/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Compressor=t()}(this,function(){"use strict";function t(t,e){var r,i=Object.keys(t);return Object.getOwnPropertySymbols&&(r=Object.getOwnPropertySymbols(t),e&&(r=r.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),i.push.apply(i,r)),i}function n(i){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?t(Object(n),!0).forEach(function(e){var t,r;t=i,r=n[e=e],(e=o(e))in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r}):Object.getOwnPropertyDescriptors?Object.defineProperties(i,Object.getOwnPropertyDescriptors(n)):t(Object(n)).forEach(function(e){Object.defineProperty(i,e,Object.getOwnPropertyDescriptor(n,e))})}return i}function a(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,o(i.key),i)}}function s(){return(s=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r,i=arguments[t];for(r in i)Object.prototype.hasOwnProperty.call(i,r)&&(e[r]=i[r])}return e}).apply(this,arguments)}function o(e){e=function(e,t){if("object"!=typeof e||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0===r)return("string"===t?String:Number)(e);if("object"!=typeof(r=r.call(e,t||"default")))return r;throw new TypeError("@@toPrimitive must return a primitive value.")}(e,"string");return"symbol"==typeof e?e:String(e)}function O(e){return 0<e&&e<1/0}var e,r,l,c,h,u,f,d,i={exports:{}},j=(e=i,"undefined"!=typeof window&&(l=(r=window).HTMLCanvasElement&&r.HTMLCanvasElement.prototype,c=r.Blob&&function(){try{return Boolean(new Blob)}catch(e){return!1}}(),h=c&&r.Uint8Array&&function(){try{return 100===new Blob([new Uint8Array(100)]).size}catch(e){return!1}}(),u=r.BlobBuilder||r.WebKitBlobBuilder||r.MozBlobBuilder||r.MSBlobBuilder,f=/^data:((.*?)(;charset=.*?)?)(;base64)?,/,d=(c||u)&&r.atob&&r.ArrayBuffer&&r.Uint8Array&&function(e){var t,r,i,n,a,o=e.match(f);if(!o)throw new Error("invalid data URI");for(t=o[2]?o[1]:"text/plain"+(o[3]||";charset=US-ASCII"),a=!!o[4],e=e.slice(o[0].length),r=(a?atob:decodeURIComponent)(e),o=new ArrayBuffer(r.length),i=new Uint8Array(o),n=0;n<r.length;n+=1)i[n]=r.charCodeAt(n);return c?new Blob([h?i:o],{type:t}):((a=new u).append(o),a.getBlob(t))},r.HTMLCanvasElement&&!l.toBlob&&(l.mozGetAsFile?l.toBlob=function(e,t,r){var i=this;setTimeout(function(){r&&l.toDataURL&&d?e(d(i.toDataURL(t,r))):e(i.mozGetAsFile("blob",t))})}:l.toDataURL&&d&&(l.msToBlob?l.toBlob=function(e,t,r){var i=this;setTimeout(function(){(t&&"image/png"!==t||r)&&l.toDataURL&&d?e(d(i.toDataURL(t,r))):e(i.msToBlob(t))})}:l.toBlob=function(e,t,r){var i=this;setTimeout(function(){e(d(i.toDataURL(t,r)))})})),e.exports?e.exports=d:r.dataURLtoBlob=d),i.exports),m={strict:!0,checkOrientation:!0,retainExif:!1,maxWidth:1/0,maxHeight:1/0,minWidth:0,minHeight:0,width:void 0,height:void 0,resize:"none",quality:.8,mimeType:"auto",convertTypes:["image/png"],convertSize:5e6,beforeDraw:null,drew:null,success:null,error:null},b="undefined"!=typeof window&&void 0!==window.document?window:{},p=Array.prototype.slice;function x(e){return Array.from?Array.from(e):p.call(e)}var g=/^image\/.+$/;function T(e){return g.test(e)}var y=String.fromCharCode;var w=b.btoa;function A(e,t){for(var r=[],i=new Uint8Array(e);0<i.length;)r.push(y.apply(null,x(i.subarray(0,8192)))),i=i.subarray(8192);return"data:".concat(t,";base64,").concat(w(r.join("")))}function v(e){var t,r,i,n,a,o,l,s=new DataView(e);try{if(255===s.getUint8(0)&&216===s.getUint8(1))for(var c=s.byteLength,h=2;h+1<c;){if(255===s.getUint8(h)&&225===s.getUint8(h+1)){r=h;break}h+=1}if(i=r&&(n=r+10,"Exif"===function(e,t,r){var i,n="";for(r+=t,i=t;i<r;i+=1)n+=y(e.getUint8(i));return n}(s,r+4,4))&&((l=18761===(a=s.getUint16(n)))||19789===a)&&42===s.getUint16(n+2,l)&&8<=(o=s.getUint32(n+4,l))?n+o:i)for(var u,f=s.getUint16(i,l),d=0;d<f;d+=1)if(u=i+12*d+2,274===s.getUint16(u,l)){u+=8,t=s.getUint16(u,l),s.setUint16(u,1,l);break}}catch(e){t=1}return t}var B=/\.\d*(?:0|9){12}\d*$/;function R(e,t){t=1<arguments.length&&void 0!==t?t:1e11;return B.test(e)?Math.round(e*t)/t:e}function E(e,t){var r,i=e.aspectRatio,n=e.height,e=e.width,t=1<arguments.length&&void 0!==t?t:"none",a=O(e),o=O(n);return a&&o?(r=n*i,("contain"===t||"none"===t)&&e<r||"cover"===t&&r<e?n=e/i:e=n*i):a?n=e/i:o&&(e=n*i),{width:e,height:n}}var U=b.ArrayBuffer,k=b.FileReader,M=b.URL||b.webkitURL,D=/\.\w+$/,L=b.Compressor;return function(){function r(e,t){if(!(this instanceof r))throw new TypeError("Cannot call a class as a function");this.file=e,this.exif=[],this.image=new Image,this.options=n(n({},m),t),this.aborted=!1,this.result=null,this.init()}var e,t,i;return e=r,i=[{key:"noConflict",value:function(){return window.Compressor=L,r}},{key:"setDefaults",value:function(e){s(m,e)}}],(t=[{key:"init",value:function(){var i,n,a,e,o=this,l=this.file,t=this.options;e=l,"undefined"!=typeof Blob&&(e instanceof Blob||"[object Blob]"===Object.prototype.toString.call(e))?T(i=l.type)?M&&k?(U||(t.checkOrientation=!1,t.retainExif=!1),n=(e="image/jpeg"===i)&&t.checkOrientation,a=e&&t.retainExif,!M||n||a?(e=new k,(this.reader=e).onload=function(e){var e=e.target.result,t={},r=1;n&&1<(r=v(e))&&s(t,function(e){var t=0,r=1,i=1;switch(e){case 2:r=-1;break;case 3:t=-180;break;case 4:i=-1;break;case 5:t=90,i=-1;break;case 6:t=90;break;case 7:t=90,r=-1;break;case 8:t=-90}return{rotate:t,scaleX:r,scaleY:i}}(r)),a&&(o.exif=function(e){for(var t=x(new Uint8Array(e)),r=t.length,i=[],n=0;n+3<r;){var a=t[n],o=t[n+1];if(255===a&&218===o)break;255===a&&216===o?n+=2:(a=n+(256*t[n+2]+t[n+3])+2,o=t.slice(n,a),i.push(o),n=a)}return i.reduce(function(e,t){return 255===t[0]&&225===t[1]?e.concat(t):e},[])}(e)),t.url=n||a?!M||1<r?A(e,i):M.createObjectURL(l):e,o.load(t)},e.onabort=function(){o.fail(new Error("Aborted to read the image with FileReader."))},e.onerror=function(){o.fail(new Error("Failed to read the image with FileReader."))},e.onloadend=function(){o.reader=null},n||a?e.readAsArrayBuffer(l):e.readAsDataURL(l)):this.load({url:M.createObjectURL(l)})):this.fail(new Error("The current browser does not support image compression.")):this.fail(new Error("The first argument must be an image File or Blob object.")):this.fail(new Error("The first argument must be a File or Blob object."))}},{key:"load",value:function(e){var t=this,r=this.file,i=this.image;i.onload=function(){t.draw(n(n({},e),{},{naturalWidth:i.naturalWidth,naturalHeight:i.naturalHeight}))},i.onabort=function(){t.fail(new Error("Aborted to load the image."))},i.onerror=function(){t.fail(new Error("Failed to load the image."))},b.navigator&&/(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(b.navigator.userAgent)&&(i.crossOrigin="anonymous"),i.alt=r.name,i.src=e.url}},{key:"draw",value:function(e){var n=this,a=e.naturalWidth,o=e.naturalHeight,t=e.rotate,t=void 0===t?0:t,r=e.scaleX,r=void 0===r?1:r,e=e.scaleY,e=void 0===e?1:e,i=this.file,l=this.image,s=this.options,c=document.createElement("canvas"),h=c.getContext("2d"),u=Math.abs(t)%180==90,f=("contain"===s.resize||"cover"===s.resize)&&O(s.width)&&O(s.height),d=Math.max(s.maxWidth,0)||1/0,m=Math.max(s.maxHeight,0)||1/0,b=Math.max(s.minWidth,0)||0,p=Math.max(s.minHeight,0)||0,g=a/o,y=s.width,w=s.height,v=(u&&(d=(v=[m,d])[0],m=v[1],b=(v=[p,b])[0],p=v[1],y=(v=[w,y])[0],w=v[1]),E({aspectRatio:g=f?y/w:g,width:d,height:m},"contain")),v=(d=v.width,m=v.height,E({aspectRatio:g,width:b,height:p},"cover")),v=(b=v.width,p=v.height,w=f?(y=(v=E({aspectRatio:g,width:y,height:w},s.resize)).width,v.height):(y=void 0===(B=(v=E({aspectRatio:g,width:y,height:w})).width)?a:B,void 0===(B=v.height)?o:B),-(y=Math.floor(R(Math.min(Math.max(y,b),d))))/2),B=-(w=Math.floor(R(Math.min(Math.max(w,p),m))))/2,b=y,d=w,p=[],m=(f&&(0,m=(g=E({aspectRatio:g,width:m=a,height:f=o},{contain:"cover",cover:"contain"}[s.resize])).width,f=g.height,p.push((a-m)/2,(o-f)/2,m,f)),p.push(v,B,b,d),u&&(y=(g=[w,y])[0],w=g[1]),c.width=y,c.height=w,T(s.mimeType)||(s.mimeType=i.type),"transparent"),U=(i.size>s.convertSize&&0<=s.convertTypes.indexOf(s.mimeType)&&(s.mimeType="image/jpeg"),"image/jpeg"===s.mimeType);h.fillStyle=m=U?"#fff":m,h.fillRect(0,0,y,w),s.beforeDraw&&s.beforeDraw.call(this,h,c),this.aborted||(h.save(),h.translate(y/2,w/2),h.rotate(t*Math.PI/180),h.scale(r,e),h.drawImage.apply(h,[l].concat(p)),h.restore(),s.drew&&s.drew.call(this,h,c),this.aborted)||(f=function(e){var i,t,r;n.aborted||(i=function(e){return n.done({naturalWidth:a,naturalHeight:o,result:e})},e&&U&&s.retainExif&&n.exif&&0<n.exif.length?(t=function(e){return i(j(A((e=e,t=n.exif,255!==(r=x(new Uint8Array(e)))[2]||224!==r[3]?e:(e=256*r[4]+r[5],t=[255,216].concat(t,r.slice(4+e)),new Uint8Array(t))),s.mimeType)));var t,r},e.arrayBuffer?e.arrayBuffer().then(t).catch(function(){n.fail(new Error("Failed to read the compressed image with Blob.arrayBuffer()."))}):(r=new k,(n.reader=r).onload=function(e){e=e.target;t(e.result)},r.onabort=function(){n.fail(new Error("Aborted to read the compressed image with FileReader."))},r.onerror=function(){n.fail(new Error("Failed to read the compressed image with FileReader."))},r.onloadend=function(){n.reader=null},r.readAsArrayBuffer(e))):i(e))},c.toBlob?c.toBlob(f,s.mimeType,s.quality):f(j(c.toDataURL(s.mimeType,s.quality))))}},{key:"done",value:function(e){var t=e.naturalWidth,r=e.naturalHeight,e=e.result,i=this.file,n=this.image,a=this.options;M&&0===n.src.indexOf("blob:")&&M.revokeObjectURL(n.src),!e||a.strict&&!a.retainExif&&e.size>i.size&&a.mimeType===i.type&&!(a.width>t||a.height>r||a.minWidth>t||a.minHeight>r||a.maxWidth<t||a.maxHeight<r)?e=i:(n=new Date,e.lastModified=n.getTime(),e.lastModifiedDate=n,e.name=i.name,e.name&&e.type!==i.type&&(e.name=e.name.replace(D,(t=T(t=e.type)?t.substr(6):"",".".concat(t="jpeg"===t?"jpg":t))))),this.result=e,a.success&&a.success.call(this,e)}},{key:"fail",value:function(e){var t=this.options;if(!t.error)throw e;t.error.call(this,e)}},{key:"abort",value:function(){this.aborted||(this.aborted=!0,this.reader?this.reader.abort():this.image.complete?this.fail(new Error("The compression process has been aborted.")):(this.image.onload=null,this.image.onabort()))}}])&&a(e.prototype,t),i&&a(e,i),Object.defineProperty(e,"prototype",{writable:!1}),r}()});
 
(function() {
    'use strict';

    angular.module('BlurAdmin.admin', [
            'ui.router',

            'BlurAdmin.admin.dashboard_admin',
            'BlurAdmin.admin.clientes',
            'BlurAdmin.admin.instaladores',
            'BlurAdmin.admin.facturacion'

        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($httpProvider) {

        $httpProvider.defaults.headers.common.Accept = 'application/json; charset=utf-8';
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

        /**
         * The workhorse; converts an object to x-www-form-urlencoded serialization.
         * @param {Object} obj
         * @return {String}*/
        var param = function(obj) {
            var query = '',
                name, value, fullSubName, subName, subValue, innerObj, i;

            for (name in obj) {
                value = obj[name];

                if (value instanceof Array) {
                    for (i = 0; i < value.length; ++i) {
                        subValue = value[i];
                        fullSubName = name + '[' + i + ']';
                        innerObj = {};
                        innerObj[fullSubName] = subValue;
                        query += param(innerObj) + '&';
                    }
                } else if (value instanceof Object) {
                    for (subName in value) {
                        subValue = value[subName];
                        fullSubName = name + '[' + subName + ']';
                        innerObj = {};
                        innerObj[fullSubName] = subValue;
                        query += param(innerObj) + '&';
                    }
                } else if (value !== undefined && value !== null)
                    query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
            }

            return query.length ? query.substr(0, query.length - 1) : query;
        };

        // Override $http service's default transformRequest
        $httpProvider.defaults.transformRequest = [function(data) {
            return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
        }];
    }

})();
 
(function () {
  'use strict';

  angular.module('BlurAdmin.auth', [])
      .config(routeConfig);

  /** @ngInject */
   function routeConfig($stateProvider) {
    $stateProvider
     .state('sign_in', {
          url: '/sign_in',
          templateUrl: 'app/auth/sign_in/signIn.html',
          title: 'Sign in',
          controller: 'SignInCtrl',
      })
   }

})();


(function () {
  'use strict';

  angular.module('BlurAdmin.consumo', [
    'ui.router',
    'BlurAdmin.consumo.dashboard_consumo',
    'BlurAdmin.consumo.dashboard_consumo.estadisticas_zona',
    'BlurAdmin.consumo.energy_dashboard',
  ])
  
  .config(routeConfig);

  /** @ngInject */
   function routeConfig($httpProvider) {

    $httpProvider.defaults.headers.common.Accept = 'application/json; charset=utf-8';
    $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
    $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

    /**
     * The workhorse; converts an object to x-www-form-urlencoded serialization.
     * @param {Object} obj
     * @return {String}*/
     var param = function(obj) {
      var query = '', name, value, fullSubName, subName, subValue, innerObj, i;
      
      for(name in obj) {
        value = obj[name];
        
        if(value instanceof Array) {
          for(i=0; i<value.length; ++i) {
            subValue = value[i];
            fullSubName = name + '[' + i + ']';
            innerObj = {};
            innerObj[fullSubName] = subValue;
            query += param(innerObj) + '&';
          }
        }
        else if(value instanceof Object) {
          for(subName in value) {
            subValue = value[subName];
            fullSubName = name + '[' + subName + ']';
            innerObj = {};
            innerObj[fullSubName] = subValue;
            query += param(innerObj) + '&';
          }
        }
        else if(value !== undefined && value !== null)
          query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
      }
      
      return query.length ? query.substr(0, query.length - 1) : query;
    };

    // Override $http service's default transformRequest
    $httpProvider.defaults.transformRequest = [function(data) {
      return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
    }];
   }

})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.help', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('help', {
          url: '/help',
          templateUrl: 'app/help/help.html',
          controller: 'helpCtrl',
          title: 'Ayuda',
          sidebarMeta: {
            icon: 'ion-help',
            order: 900,
          },
          controlAccess: ['all'],       
        });
    }
  
  })();
 
(function () {
  'use strict';

  angular.module('BlurAdmin.instalador', [
    'ui.router',
    'BlurAdmin.instalador.dashboard_instalador',
    'BlurAdmin.instalador.projects',
    'BlurAdmin.instalador.users'
  ])
  
  .config(routeConfig);

  /** @ngInject */
   function routeConfig($httpProvider) {

    $httpProvider.defaults.headers.common.Accept = 'application/json; charset=utf-8';
    $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
    $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

    /**
     * The workhorse; converts an object to x-www-form-urlencoded serialization.
     * @param {Object} obj
     * @return {String}*/
     var param = function(obj) {
      var query = '', name, value, fullSubName, subName, subValue, innerObj, i;
      
      for(name in obj) {
        value = obj[name];
        
        if(value instanceof Array) {
          for(i=0; i<value.length; ++i) {
            subValue = value[i];
            fullSubName = name + '[' + i + ']';
            innerObj = {};
            innerObj[fullSubName] = subValue;
            query += param(innerObj) + '&';
          }
        }
        else if(value instanceof Object) {
          for(subName in value) {
            subValue = value[subName];
            fullSubName = name + '[' + subName + ']';
            innerObj = {};
            innerObj[fullSubName] = subValue;
            query += param(innerObj) + '&';
          }
        }
        else if(value !== undefined && value !== null)
          query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
      }
     //console.log('estoy en instalador');
      return query.length ? query.substr(0, query.length - 1) : query;
    };

    // Override $http service's default transformRequest
    $httpProvider.defaults.transformRequest = [function(data) {
      return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
    }];

    

   }

})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.notifications', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('notifications', {
          url: '/notifications',
          templateUrl: 'app/notifications/notifications.html',
          controller: 'notificationsCtrl',
          title: 'Notificaciones',
          sidebarMeta: {
            icon: 'ion-android-notifications',
            order: 1000,
          },
          controlAccess: ['all'],       
        });
    }
  
  })();
 
(function () {
  'use strict';

  angular.module('BlurAdmin.operador', [
    'ui.router',
    'BlurAdmin.operador.dashboard_operador',
    'BlurAdmin.operador.ofertas'

  ])
 .config(routeConfig);

  /** @ngInject */
   function routeConfig($httpProvider) {

    $httpProvider.defaults.headers.common.Accept = 'application/json; charset=utf-8';
    $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
    $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

    /**
     * The workhorse; converts an object to x-www-form-urlencoded serialization.
     * @param {Object} obj
     * @return {String}*/
     var param = function(obj) {
      var query = '', name, value, fullSubName, subName, subValue, innerObj, i;
      
      for(name in obj) {
        value = obj[name];
        
        if(value instanceof Array) {
          for(i=0; i<value.length; ++i) {
            subValue = value[i];
            fullSubName = name + '[' + i + ']';
            innerObj = {};
            innerObj[fullSubName] = subValue;
            query += param(innerObj) + '&';
          }
        }
        else if(value instanceof Object) {
          for(subName in value) {
            subValue = value[subName];
            fullSubName = name + '[' + subName + ']';
            innerObj = {};
            innerObj[fullSubName] = subValue;
            query += param(innerObj) + '&';
          }
        }
        else if(value !== undefined && value !== null)
          query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
      }
      
      return query.length ? query.substr(0, query.length - 1) : query;
    };

    // Override $http service's default transformRequest
    $httpProvider.defaults.transformRequest = [function(data) {
      return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
    }];
   }

})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.profile', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('profile', {
          url: '/profile',
          templateUrl: 'app/profile/profile.html',
          controller: 'profileCtrl',
          title: 'Perfil',
          sidebarMeta: {
            icon: 'ion-person',
            order: 900,
          }, 
          controlAccess: ['all'],       
        })
        .state('profile.membershipCoupon', {
          url: '/membershipCoupon',
          templateUrl: 'app/profile/membership-coupon/membership-coupon.html',
          controller: 'membershipCouponCtrl',
          title: 'Cupón Membresía',
          controlAccess: ['all'], 
        });
    }
  
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.settings', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('settings', {
          url: '/settings',
          templateUrl: 'app/settings/settings.html',
          controller: 'settingsCtrl',
          title: 'Configuración',
          sidebarMeta: {
            icon: 'ion-gear',
            order: 1000,
          },
          controlAccess: ['all'],  
          redirectTo: 'settings.holidays', 
        })
        .state('settings.holidays', {
          url: '/holidays',
          templateUrl: 'app/settings/management-holidays/management-holidays.html',
          controller: 'holidaysCtrl',
          title: 'Gestión de Feriados',
          controlAccess: ['monitoreo', 'coordinador'],
          params: {
            step: null,
            options: null,
          }
        })
        .state('settings.devTools', {
          url: '/dev-tools',
          templateUrl: 'app/settings/dev-tools/dev-tools.html',
          controller: 'devToolsCtrl',
          title: 'Opciones de Desarrollador',
          controlAccess: ['all'], 
        })
    }
  
  })();

(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      //'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components'
  ]);

})();

 
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente', [
            'ui.router',


            'BlurAdmin.cliente.dashboard_cliente',
            //'BlurAdmin.cliente.estadisticas_c',
            'BlurAdmin.cliente.dashboard_cliente.estadisticas_zona',
            //'BlurAdmin.cliente.historial',
            'BlurAdmin.cliente.mantenimiento',
            'BlurAdmin.cliente.consumption',
            'BlurAdmin.cliente.ofertas_c',
            'BlurAdmin.cliente.smartbar',
            'BlurAdmin.cliente.alerts',
            'BlurAdmin.cliente.monitoreo',
            'BlurAdmin.cliente.monitoreo-plano',
            //'BlurAdmin.cliente.aires'



        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($httpProvider) {
        $httpProvider.defaults.headers.common.Accept = 'application/json; charset=utf-8';
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        $httpProvider.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';

        /**
         * The workhorse; converts an object to x-www-form-urlencoded serialization.
         * @param {Object} obj
         * @return {String}*/
        var param = function(obj) {
            var query = '',
                name, value, fullSubName, subName, subValue, innerObj, i;

            for (name in obj) {
                value = obj[name];

                if (value instanceof Array) {
                    for (i = 0; i < value.length; ++i) {
                        subValue = value[i];
                        fullSubName = name + '[' + i + ']';
                        innerObj = {};
                        innerObj[fullSubName] = subValue;
                        query += param(innerObj) + '&';
                    }
                } else if (value instanceof Object) {
                    for (subName in value) {
                        subValue = value[subName];
                        fullSubName = name + '[' + subName + ']';
                        innerObj = {};
                        innerObj[fullSubName] = subValue;
                        query += param(innerObj) + '&';
                    }
                } else if (value !== undefined && value !== null)
                    query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
            }

            return query.length ? query.substr(0, query.length - 1) : query;
        };

        // Override $http service's default transformRequest
        $httpProvider.defaults.transformRequest = [function(data) {
            return angular.isObject(data) && String(data) !== '[object File]' ? param(data) : data;
        }];
    }

})();
/**
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.admin.clientes', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('clientes', {
                url: '/clientes',
                templateUrl: 'app/admin/clientes/clientes.html',
                title: 'Clientes',
                controller: 'clientesCtrl',
                sidebarMeta: {
                    icon: 'ion-person-stalker',
                },
                controlAccess: ['admin'],
            });
    }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.admin.facturacion', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('facturacion', {
          url: '/facturacion_old',
          templateUrl: 'app/admin/facturacion/facturacion.html',
          abstract: true,
          title: 'Facturacion',
          sidebarMeta: {
            icon: 'ion-ios-location-outline',
            order: 300,
          },
          controlAccess: ['admin'],
        })
        .state('facturacion.generar', {
          url: '/generar',
          templateUrl: 'app/admin/facturacion/generar/generar_factura.html',
          controller: 'generar_facturaCtrl',
          title: 'Generar factura',
          sidebarMeta: {
            order: 0,
          },
          controlAccess: ['admin'],
        })
        .state('facturacion.valor_kwh', {
          url: '/valor_kwh',
          templateUrl: 'app/admin/facturacion/valor_kwh/valor_kwh.html',
          controller: 'valor_kwhCtrl',
          title: 'Valor kwh',
          sidebarMeta: {
            order: 100,
          },
          controlAccess: ['admin'],
        });
  }

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.admin.instaladores', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('instaladores', {
                url: '/instaladores',
                templateUrl: 'app/admin/instaladores/instaladores.html',
                title: 'Instaladores',
                controller: 'instaladoresCtrl',
                sidebarMeta: {
                    icon: 'ion-settings'
                },
                controlAccess: ['admin'],
            });
    }

})();
 
(function () {
  'use strict';

  angular.module('BlurAdmin.admin.maps', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('maps', {
          url: '/maps',
          templateUrl: 'app/admin/maps/maps.html',
          abstract: true,
          title: 'Maps',
          sidebarMeta: {
            icon: 'ion-ios-location-outline',
            order: 500,
          },
          controlAccess: ['admin'],  
        })
        .state('maps.gmap', {
          url: '/gmap',
          templateUrl: 'app/admin/maps/google-maps/google-maps.html',
          controller: 'GmapPageCtrl',
          title: 'Google Maps',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('maps.leaflet', {
          url: '/leaflet',
          templateUrl: 'app/admin/maps/leaflet/leaflet.html',
          controller: 'LeafletPageCtrl',
          title: 'Leaflet Maps',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('maps.bubble', {
          url: '/bubble',
          templateUrl: 'app/admin/maps/map-bubbles/map-bubbles.html',
          controller: 'MapBubblePageCtrl',
          title: 'Bubble Maps',
          sidebarMeta: {
            order: 200,
          },
        })
        .state('maps.line', {
          url: '/line',
          templateUrl: 'app/admin/maps/map-lines/map-lines.html',
          controller: 'MapLinesPageCtrl',
          title: 'Line Maps',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.changePassword', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('changePassword', {
        url: '/changePassword',
        templateUrl: 'app/auth/nueva_contrasena/nueva_contrasena.html',
        controller: 'changePasswordCtrl',
        title: 'Cambiar Contraseña',       
      });
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.recuperar', [])
      .config(routeConfig);

  /** @ngInject */
   function routeConfig($stateProvider) {
    $stateProvider
     .state('recuperar_contrasena', {
          url: '/recuperar_contrasena',
          templateUrl: 'app/auth/recuperar_contrasena/recuperar_contrasena.html',
          title: 'Recuperar contraseña',
          controller: 'recuperar_contrasenaCtrl',
      })
      .state('recuperar_contrasena.sendEmail', {
        url: '/validarCorreo',
        templateUrl: 'app/auth/recuperar_contrasena/sendEmail/sendEmail.html',
        title: 'validar correo',
        controller: 'sendEmailCtrl',
      })
      .state('recuperar_contrasena.validarCodigo', {
        url: '/validarCodigo',
        templateUrl: 'app/auth/recuperar_contrasena/validarCodigo/validarCodigo.html',
        title: 'validar codigo',
        controller: 'validarCodigoCtrl',
        params: {
          email: null,
        },
      })
      .state('recuperar_contrasena.newPassword', {
        url: '/nuevaContrasena',
        templateUrl: 'app/auth/recuperar_contrasena/newPassword/newPassword.html',
        title: 'nueva contraseña',
        controller: 'newPasswordCtrl',
        params: {
          email: null,
          token: null,
          code: null,
        },
      })
   }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.consumo.dashboard_consumo', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard_consumo', {
        url: '/dashboard_consumo',
        templateUrl: 'app/consumo/dashboard-consumo/dashboard_consumo.html',
        title: 'Control',
        controller: 'Dashboard_consumoCtrl',
        sidebarMeta: {
          icon: 'ion-android-home',
          order: 0
        },
        controlAccess: ['cliente'],
      });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.consumo.energy_dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('energy_dashboard', {
        url: '/consumo_energetico',
        templateUrl: 'app/consumo/energy-dashboard/energy-dashboard.html',
        title: 'Consumo energético',
        controller: 'EnergyDashboardCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          icon: 'ion-flash',
          order: 310
        },
        controlAccess: ['monitoreo']
      });
  }

})();

 
(function () {
  'use strict';

  angular.module('BlurAdmin.instalador.dashboard_instalador', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard_instalador', {
        url: '/dashboard_instalador',
        templateUrl: 'app/instalador/dashboard-instalador/dashboard_instalador.html',
        title: 'Dashboard',
        controller: 'Dashboard_instaladorCtrl',
        sidebarMeta: {
          icon: 'ion-android-home',
          order: 0,
        },
        controlAccess: ['instalador'],
      })
      .state('dashboard_instalador.newClient', {
        url: '/newClient',
        templateUrl: 'app/instalador/forms/project/new_project.html',
        title: 'Nuevo Cliente',
        controller: 'newClientCtrl',
        controlAccess: ['instalador'],
      })
  }

  

})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.instalador.projects', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('projects_', {
            url: '/proyectos_',
            templateUrl: 'app/instalador/projects/projects.html',
            title: 'Proyectos',
            controller: 'projectsCtrl_',
            sidebarMeta: {
              icon: 'ion-grid',
              order: 100,
            },
            controlAccess: ['instalador'],
          })
             
    }
  
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.instalador.users', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('users', {
            url: '/users',
            templateUrl: 'app/instalador/users/users.html',
            title: 'Usuarios',
            controller: 'usersCtrl',
            sidebarMeta: {
              icon: 'ion-person-stalker',
              order: 200,
            },
            controlAccess: ['instalador'],
            params: {
              cliente: null,
              newUser: null
            },
          })
          .state('users.newUser', {
            url: '/newUser',
            templateUrl: 'app/instalador/users/newUser/newUser.html',
            title: 'Nuevo Usuario',
            controller: 'newUserCtrl',
            params: {
              cliente: null,
              parm: null,
              user: null
            },
            controlAccess: ['instalador'],
        })
             
    }
  
  })();
 
(function () {
  'use strict';

  angular.module('BlurAdmin.operador.dashboard_operador', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard_op', {
          url: '/dashboard_op',
          templateUrl: 'app/operador/dashboard-operador/dashboard_operador.html',
          title: 'Dashboard',
          controller: 'Dashboard_operadorCtrl',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  }

  

})();

 
(function () {
  'use strict';

  angular.module('BlurAdmin.operador.ofertas', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ofertas', {
          url: '/ofertas',
          //templateUrl: 'app/operador/ofertas/ofertas.html',
          title: 'Ofertas',
          abstract: true,
          controller: 'ofertasCtrl',
          sidebarMeta: {
            icon: 'ion-pricetag',
            order: 200,
          },
        })
        .state('ofertas.generar', {
          url: '/generar',
          templateUrl: 'app/operador/ofertas/generar/generar.html',
          controller: 'generarCtrl',
          title: 'Generar',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('ofertas.historial', {
          url: '/historial_op',
          templateUrl: 'app/operador/ofertas/historial/historial.html',
          controller: 'historialCtrl',
          title: 'historial',
          sidebarMeta: {
            order: 0,
          },
        })
        ;
  }

  

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.operador.statistics', [])
      .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('statistics', {
          url: '/statistics',
          templateUrl: 'app/operador/statistics/statistics.html',
          title: 'Estadísticas',
          controller: 'StatisticsCtrl',
          sidebarMeta: {
            icon: 'ion-stats-bars',          },
        });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;

    Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
    Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
    Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
    Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;

    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();


 
(function () {
  'use strict';

  angular.module('BlurAdmin.admin.dashboard_admin', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard_admin', {
          url: '/dashboard_admin',
          templateUrl: 'app/admin/dashboard-admin/dashboard_admin.html',
          title: 'Dashboard',
          controller: 'Dashboard_adminCtrl',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
          controlAccess: ['admin'],
        });
  }

  

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
 
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);
})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.alerts', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('alerts', {
            url: '/alerts',
            templateUrl: 'app/cliente/alerts/alerts.html',
            title: 'Alertas',
            controller: 'alertsCtrl',
            sidebarMeta: {
              icon: 'ion-android-notifications',
              order: 700,
            },
            params: {
              id_zona: null,
            },
            order: 0,
            controlAccess: ['cliente'],
          })
          .state('newAlert', {
            url: '/newAlert',
            templateUrl: 'app/cliente/alerts/new-alert/new-alert.html',
            title: 'Gestión de Alertas',
            controller: 'newAlertCtrl',
            params: {
              editMode: false,
              alert: null,
              type: null,
              zona: null,
            },
            order: 1,
            controlAccess: ['cliente'],
          })
          .state('offlineAlert', {
            url: '/offlineAlert',
            templateUrl: 'app/cliente/alerts/offline-alert/offline-alert.html',
            title: 'Nueva alerta de Monitoreo',
            controller: 'offlineAlertCtrl',
            params: {
              editMode: false,
              alert: null,
              type: null,
              zona: null,
            },
            order: 1,
            controlAccess: ['cliente'],
          })
          .state('quickEdit', {
            url: '/quickEdit',
            templateUrl: 'app/cliente/alerts/quick-edit/quick-edit.html',
            title: 'Edición Rápida',
            controller: 'quickEditAlertCtrl',
            params: {
              alerts: null,
            },
            order: 1,
            controlAccess: ['cliente'],
          })
          .state('noAlerts', {
            url: '/no_alerts',
            templateUrl: 'app/cliente/alerts/no-alerts/no-alerts.html',
            title: '',
            controller: 'noAlertsCtrl',
            controlAccess: ['cliente'],
          })
             
    }
  
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('consumption', {
            url: '/consumo_v2',
            templateUrl: 'app/cliente/consumo_v2/consumoV2.html',
            title: 'Consumo',
            abstract: true,
            sidebarMeta: {
              icon: 'ion-stats-bars',
              order: 300,
            },
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.dashboardConsumo', {
            url: '/dashboardConsumo',
            templateUrl: 'app/cliente/consumo_v2/dashboard-consumo/dashboard-consumo.html',
            controller: 'dashboardConsumoCtrl',
            title: 'Dashboard',
            sidebarMeta: {
              order: 0,
            },
            order: 0,
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.consumoDispositivo', {
            url: '/consumoDispositivo',
            templateUrl: 'app/cliente/consumo_v2/consumo-dispositivo/consumo-dispositivo.html',
            controller: 'consumoDispositivoCtrl',
            title: 'Consumo Dispositivo',
            params: {
              dispositivo: null,
            },
            sidebarMeta: {
              order: 3,
            },
            order: 1,
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })  
          .state('consumption.puntoFacturacion', {
            url: '/puntosFacturacion',
            templateUrl: 'app/cliente/consumo_v2/puntos-facturacion/puntos-facturacion.html',
            controller: 'puntosFacturacionCtrl',
            title: 'Informes',
            sidebarMeta: {
              order: 100,
            },
            order: 0,
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.nuevoPuntoFacturacion', {
            url: '/nuevoPuntoFacturacion',
            templateUrl: 'app/cliente/consumo_v2/nuevo-punto-facturacion/nuevo-punto-facturacion.html',
            controller: 'nuevoPuntoFacturacionCtrl',
            title: 'Nueva frontera comercial',
            params: {
              punto: null,
            },
            order: 1,
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.procesoFacturacion', {
            url: '/procesoFacturacion',
            templateUrl: 'app/cliente/consumo_v2/proceso-facturacion/proceso-facturacion.html',
            controller: 'procesoFacturacionCtrl',
            title: 'Creación de informe',
            order: 1,
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.facturacion', {
            url: '/facturacion',
            templateUrl: 'app/cliente/consumo_v2/facturacion/facturacion.html',
            controller: 'facturacionCtrl',
            title: 'Facturas',
            params: {
              id: null,
              punto: null,
            },
            order: 1,
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.nuevaFactura', {
            url: '/nuevaFactura',
            templateUrl: 'app/cliente/consumo_v2/nueva-factura/nueva-factura.html',
            controller: 'nuevaFacturaCtrl',
            title: 'Cargar nueva factura',
            params: {
              factura: null,
              id_punto: null,
            },
            order: 2,
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.estadisticasFacturacion', {
            url: '/estadisticasFacturacion',
            templateUrl: 'app/cliente/consumo_v2/estadisticas-facturacion/estadisticas-facturacion.html',
            controller: 'estadisticasFacturacionCtrl',
            title: 'Estadisticas Facturación',
            params: {
              id_punto: null,
            },
            order: 2,
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.factura', {
            url: '/factura',
            templateUrl: 'app/cliente/consumo_v2/factura/factura.html',
            controller: 'facturaCtrl',
            title: 'Detalle Factura',
            params: {
              factura: null,
            },
            order: 3,
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.facturadores', {
            url: '/facturadores',
            templateUrl: 'app/cliente/consumo_v2/facturadores/facturadores.html',
            controller: 'facturadoresCtrl',
            title: 'Cuentas',
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.nuevoFacturador', {
            url: '/nuevo_facturador',
            templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-nuevo/proceso-facturacion-nuevo.html',
            controller: 'procesoFacturacionNuevoCtrl',
            title: 'Nueva cuenta',
            params: {
              facturador: null,
              edit_mode: null,
            },
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.nofacturador', {
            url: '/no_facturador',
            templateUrl: 'app/cliente/consumo_v2/components/no-facturador/no-facturador.html',
            controller: 'noFacturadorCtrl',
            title: '',
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.noPunto', {
            url: '/no_punto',
            templateUrl: 'app/cliente/consumo_v2/components/no-punto/no-punto.html',
            controller: 'noPuntoCtrl',
            title: '',
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.procesoFacturacion.ind', {
            url: '/ind',
            templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-ind/proceso-facturacion-ind.html',
            title: 'Nuevo informe',
            controller: 'procesoFacturacionIndCtrl',
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.procesoFacturacion.info', {
            url: '/info',
            templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-info/proceso-facturacion-info.html',
            title: 'Nuevo informe',
            controller: 'procesoFacturacionInfoCtrl',
            params: {
              ind: null,
              facturadores: undefined,
            },
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.procesoFacturacion.data', {
            url: '/fuenteData',
            templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-seleccion/proceso-facturacion-seleccion.html',
            title: 'Nuevo informe',
            controller: 'procesoFacturacionSeleccionCtrl',
            params: {
              ind: null,
              basic_info: null,
              edit_mode: null,
            },
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
          .state('consumption.procesoFacturacion.resultado', {
            url: '/resultado',
            templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-resultado/proceso-facturacion-resultado.html',
            title: 'Nuevo informe',
            controller: 'procesoFacturacionResultadoCtrl',
            params: {
              ind: null,
              basic_info: null,
              facturador: null,
            },
            controlAccess: ['cliente', 'monitoreo_plano_control'],
          })
                      
    }
  
  })();
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.dashboard_cliente', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('dashboard_cliente', {
          url: '/dashboard_cliente',
          templateUrl: 'app/cliente/dashboard-cliente/dashboard_cliente.html',
          title: 'Control',
          controller: 'Dashboard_clienteCtrl',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
          order: 0,
          controlAccess: ['cliente'],
          showIconAlert: true,
          redirectTo: 'dashboard_cliente.zones',
        })
        .state('dashboard_cliente.zones', {
          url: '/zones',
          templateUrl: 'app/cliente/dashboard-cliente/zones/zones.html',
          title: 'Zonas',
          controller: 'zonesCtrl',
          order: 0,
          controlAccess: ['cliente', 'monitoreo_plano_visualizacion', 'monitoreo_plano_control'],
          showIconAlert: true,
        })
        .state('dashboard_cliente.projects', {
          url: '/projects',
          templateUrl: 'app/cliente/dashboard-cliente/projects/projects.html',
          title: 'Proyectos',
          controller: 'projectsCtrl',
          order: 0,
          controlAccess: ['monitoreo', 'coordinador'],
          showIconAlert: true,
        })
        .state('dashboard_cliente.project', {
          url: '/project',
          templateUrl: 'app/cliente/dashboard-cliente/project/project.html',
          //title: 'Proyectos',
          controller: 'projectCtrl',
          order: 0,
          controlAccess: ['monitoreo', 'coordinador'],
          showIconAlert: true,
          params: {
            project: null,
          },
        })
        .state('dashboard_cliente.newProject', {
          url: '/new-project',
          templateUrl: 'app/cliente/dashboard-cliente/new-project/new-project.html',
          title: 'Nuevo Proyecto',
          controller: 'newProjectCtrl',
          order: 0,
          controlAccess: ['monitoreo', 'coordinador'],
          showIconAlert: true,
          params: {
            project: null,
          },
        })
        .state('dashboard_cliente.moveDevices', {
          url: '/move-devices',
          templateUrl: 'app/cliente/dashboard-cliente/move-devices/move-devices.html',
          title: 'Mover dispositivos',
          controller: 'moveDevicesCtrl',
          order: 0,
          controlAccess: ['monitoreo', 'coordinador'],
          showIconAlert: true,
          params: {
            devices: null,
          },
        })
        .state('dashboard_cliente.newAutomationAir', {
          url: '/newAutomationAir',
          templateUrl: 'app/cliente/dashboard-cliente/automation/air/airAutomation.html',
          title: 'Nueva Programación',
          controller: 'newAutomationAirCtrl',
          params: {
            zona: null,
            program: null,
            parm: null,
            dispositivos: null,
          },
          order: 1,
          controlAccess: ['cliente'],
          showIconAlert: true,
        })
        .state('dashboard_cliente.newAutomationLoad', {
          url: '/newAutomationLoad',
          templateUrl: 'app/cliente/dashboard-cliente/automation/load/loadAutomation.html',
          title: 'Nueva Programación Zona',
          controller: 'newAutomationLoadCtrl',
          params: {
            zona: null,
            program: null,
            parm: null,
            dispositivos: null,
          },
          order: 2,
          controlAccess: ['cliente'],
          showIconAlert: true,
        })
        .state('dashboard_cliente.schedules', {
          url: '/schedules',
          templateUrl: 'app/cliente/dashboard-cliente/schedules/schedules.html',
          title: 'Lista de programaciones',
          controller: 'schedulesCtrl',
          params: {
           zone: null,
          },
          order: 3,
          controlAccess: ['cliente'],
          showIconAlert: true,
        })
        .state('dashboard_cliente.newZone', {
          url: '/newZone',
          templateUrl: 'app/cliente/dashboard-cliente/newZone/newZone.html',
          title: 'Gestión de Zona',
          controller: 'newZoneCtrl',
          order: 4,
          params: {
            zone: null,
          },
          controlAccess: ['cliente'],
          showIconAlert: true,
        })
        .state('dashboard_cliente.newAutomation', {
          url: '/newAutomation',
          templateUrl: 'app/cliente/dashboard-cliente/automation/automation.html',
          title: 'Nueva Programación Zona',
          controller: 'automationCtrl',
          params: {
            zona: null,
            program: null,
            parm: null,
            dispositivos: null,
            type: null,
          },
          order: 2,
          controlAccess: ['cliente'],
          showIconAlert: true,
        });
  }

  

})();

 
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.historial', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('historial', {
          url: '/historial',
          templateUrl: 'app/cliente/historial/historial.html',
          title: 'Programaciones',
          controller: 'historialCtrl',
          sidebarMeta: {
            icon: 'ion-clipboard',
            order: 200,
          },
          controlAccess: ['cliente'],
        })
           
  }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('mantenimiento', {
                url: '/mantenimiento',
                templateUrl: 'app/cliente/mantenimiento/mantenimiento.html',
                title: 'Mantenimiento',
                controller: 'mantenimientoCtrl',
                sidebarMeta: {
                    icon: 'ion-wrench',
                    order: 3
                },
                order: 0,
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('mantenimiento_log', {
                url: '/maintenanceLog/{hash}',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/maintenance_log.html',
                title: 'Lista de Mantenimientos',
                controller: 'maintenance_logCtrl',
                params: {
                    device: null, 
                    control: null
                },
                order: 1,
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('mantenimiento_new', {
                url: '/newMaintenance',
                templateUrl: 'app/cliente/mantenimiento/new_maintenance/new_maintenance.html',
                title: 'Nuevo Mantenimiento',
                controller: 'newMaintenanceCtrl',
                params: {
                    device: null, 
                    totalMaintenance: null
                },
                order: 4,
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('mantenimiento_apparatusProfile', {
                url: '/apparatusProfile',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/apparatus_profile.html',
                title: 'Perfil del dispositivo',
                controller: 'apparatus_profileCtrl',
                params: {
                    device: null,
                    control: null,
                    devices: null,
                },
                order: 3,
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('mantenimiento_newApparatus', {
                url: '/newApparatus',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/new_apparatus_profile/new_apparatus_profile.html',
                title: 'Nuevo dispositivo',
                controller: 'new_apparatus_profileCtrl',
                order: 5,
                params: {
                    zone: null,
                    apparatus: null,
                    control: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('mantenimiento_detalle', {
                url: '/maintenanceDetail',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/maintenance_detail/maintenance_detail.html',
                title: 'Detalle de Mantenimiento',
                controller: 'maintenance_detailCtrl',
                params: {
                    maintenance: null, 
                    device: null,
                    control: null,
                },
                order: 2,
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('device_settings', {
                url: '/device_settings',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings/settings.html',
                title: 'Configuración',
                controller: 'device_settingsCtrl',
                order: 5,
                params: {
                    device: null,
                    control: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('device_settings_helo_s', {
                url: '/settings_helo_s',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_helo_s/settings_helo_s.html',
                title: 'Configuración',
                controller: 'settings_helo_s_Ctrl',
                order: 5,
                params: {
                    device: null,
                    control: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('device_settings_helo_th', {
                url: '/settings_helo_th',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_helo_th/settings_helo_th.html',
                title: 'Configuración',
                controller: 'settings_helo_th_Ctrl',
                order: 5,
                params: {
                    device: null,
                    control: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('device_settings_helo_t', {
                url: '/settings_helo_t',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_helo_t/settings_helo_t.html',
                title: 'Configuración',
                controller: 'settings_helo_t_Ctrl',
                order: 5,
                params: {
                    device: null,
                    control: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('device_settings_tipo_dispositivo', {
                url: '/settings_tipo_dispositivo',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_tipo_dispositivo/settings_tipo_dispositivo.html',
                title: 'Configuración',
                controller: 'settings_tipo_dispositivo_Ctrl',
                order: 5,
                params: {
                    device: null,
                    control: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('device_settings_hub', {
                url: '/settings_hub',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_hub/settings_hub.html',
                title: 'Configuración',
                controller: 'settings_hub_Ctrl',
                order: 5,
                params: {
                    device: null,
                    control: null,
                    devices: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('device_settings_hub_master', {
                url: '/settings_hub_master',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_hub_master/settings_hub_master.html',
                title: 'Configuración',
                controller: 'settings_hub_master_Ctrl',
                order: 5,
                params: {
                    device: null,
                    control: null,
                    devices: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('device_settings_virtual', {
                url: '/settings_virtual_device',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings-virtual-device/settings-virtual-device.html',
                title: 'Configuración',
                controller: 'settings_helo_virtual_Ctrl',
                order: 5,
                params: {
                    device: null,
                    control: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })
            .state('change_DB', {
                url: '/change_DB',
                templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/change_DB/change_DB.html',
                title: 'Configuración',
                controller: 'changeDBCtrl',
                order: 5,
                params: {
                    device: null,
                    control: null,
                    aire_actual: null,
                },
                controlAccess: ['cliente', 'monitoreo_plano_control'],
            })

    }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.monitoreo', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('monitoring', {
            url: '/monitoring',
            templateUrl: 'app/cliente/monitoreo/monitoreo.html',
            title: 'Monitoreo',
            abstract: true,
            sidebarMeta: {
                icon: 'ion-speedometer',
                order: 300,
            },
            controlAccess: ['monitoreo', 'tecnico', 'coordinador'],
        })
        .state('monitoring.tickets', {
            url: '/tickets',
            templateUrl: 'app/cliente/monitoreo/tickets/tickets.html',
            controller: 'ticketsCtrl',
            title: 'Tickets',
            sidebarMeta: {
                order: 0,
            },
            controlAccess: ['monitoreo', 'tecnico', 'coordinador'],
        }) 
        .state('monitoring.tecnicos', {
            url: '/tecnicos',
            templateUrl: 'app/cliente/monitoreo/tecnicos/tecnicos.html',
            controller: 'tecnicosCtrl',
            title: 'Técnicos',
            sidebarMeta: {
                order: 1,
            },
            controlAccess: ['monitoreo', 'coordinador'],
        }) 
        .state('monitoring.newTechnical', {
            url: '/new_technical',
            templateUrl: 'app/cliente/monitoreo/nuevo-tecnico/nuevo-tecnico.html',
            controller: 'newTechnicalCtrl',
            title: 'Nuevo Tecnico',
            sidebarMeta: {
                order: 2,
            },
            params: {
                tecnico: null
            },
            controlAccess: ['monitoreo', 'coordinador'],
        })
        .state('monitoring.newTicket', {
            url: '/new_ticket',
            templateUrl: 'app/cliente/monitoreo/nuevo-ticket/nuevo-ticket.html',
            controller: 'newTicketCtrl',
            title: 'Nuevo Ticket',
            sidebarMeta: {
                order: 2,
            },
            controlAccess: ['monitoreo', 'coordinador'],
        }) 
        .state('monitoring.ticket', {
            url: '/ticket',
            templateUrl: 'app/cliente/monitoreo/ticket/ticket.html',
            controller: 'ticketCtrl',
            title: 'Ticket',
            sidebarMeta: {
                order: 2,
            },
            controlAccess: ['monitoreo', 'tecnico', 'coordinador'],
            params: {
                ticket: null,
            },
        })    
    }
  
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.monitoreo-plano', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider 
          .state('monitoreoPlano', {
            url: '/monitoreo-plano',
            templateUrl: 'app/cliente/monitoreo-plano/monitoreo-plano.html',
            controller: 'monitoreoPlanoCtrl',
            title: 'Plano',
            sidebarMeta: {
              icon: 'ion-map',
              order: 800,
            },
            controlAccess: ['monitoreo', 'monitoreo_plano', 'coordinador', 'monitoreo_plano_visualizacion', 'monitoreo_plano_control'],
            params: {
              zona: null,
              planos: null,
            }
          })
    }
  
  })();
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.ofertas_c', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ofertas_c', {
          url: '/ofertas_c',
          templateUrl: 'app/cliente/ofertas/ofertas.html',
          title: 'Ofertas',
          controller: 'ofertas_cCtrl',
          sidebarMeta: {
            icon: 'ion-pricetag',
            order: 500,
          },
          controlAccess: ['cliente'],
        })
           
  }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.smartbar', [])
        .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('smartbar', {
            url: '/smartbar',
            templateUrl: 'app/cliente/smartbar/smartbar.html',
            title: 'Smartbar',
            controller: 'smartbarCtrl',
            sidebarMeta: {
              icon: 'ion-usb',
              order: 600,
            },
            params: {
              date: null,
              time: null
            },
            controlAccess: ['cliente'],
          })
          .state('smartbar.measurePoint', {
            url: '/measurePoint',
            templateUrl: "app/cliente/smartbar/measurePoint/measurePoint.html",
            title: 'measurePoint',
            controller: 'measurePointCtrl',
            controlAccess: ['cliente'],
         })
         .state('smartbar.tempPoint', {
            url: '/tempPoint',
            templateUrl: "app/cliente/smartbar/tempPoint/tempPoint.html",
            title: 'tempPoint',
            controller: 'tempPointCtrl',
            controlAccess: ['cliente'],
        });
             
    }
  
  })();
(function () {
  'use strict';

  angular.module('BlurAdmin.consumo.dashboard_consumo.estadisticas_zona', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('consumo_zona', {
        url: '/consumo_zona',
        templateUrl: 'app/consumo/dashboard-consumo/estadisticas_zona/estadisticas_zona.html',
        controller: 'consumo_zonaCtrl',
        title: 'Estadísticas de consumo por zona',
        params: {'nombre': null, 'id': null}        
      });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('estadisticas_zona', {
        url: '/estadisticas_zona',
        templateUrl: 'app/cliente/dashboard-cliente/estadisticas_zona/estadisticas_zona.html',
        controller: 'estadisticas_zonaCtrl',
        title: 'Estadísticas por zona',
        controlAccess: ['cliente', 'monitoreo_plano_visualizacion', 'monitoreo_plano_control'],
        showIconAlert: true,
        params: {'nombre': null, 'id_zona': null, 'id_device': null, 'date': null, 'time': null}        
      });
  }

})();

'use strict';

angular.module('BlurAdmin', [
        'ngDialog',
        //'ngStorage',
        'ngCookies',
        'ngAnimate',
        'ui.bootstrap',
        'ui.sortable',
        'ui.router',
        'ngTouch',
        'toastr',
        'smart-table',
        'ui.slimscroll',
        'angular-progress-button-styles',
        'ngStorage',
        'ngDialog',
        'xeditable',
        'ngJsTree',
        'ngclipboard',
        'ui.select',
        'ja.qr',
        //'ui.swiper',

        'BlurAdmin.theme',
        'BlurAdmin.admin',
        'BlurAdmin.recuperar',
        'BlurAdmin.changePassword',
        'BlurAdmin.auth',
        'BlurAdmin.cliente',
        'BlurAdmin.operador',
        'BlurAdmin.instalador',
        'BlurAdmin.consumo',
        'BlurAdmin.help',
        'BlurAdmin.profile',
        'BlurAdmin.notifications',
        'BlurAdmin.settings',
    ])
    .config(routeConfig);

function routeConfig($urlRouterProvider) { 
    $urlRouterProvider.otherwise('/sign_in');
    $urlRouterProvider.when('/dashboard_cliente', '/dashboard_cliente/zones');
}

(function () {
    'use strict';

    angular.module('BlurAdmin')
        .filter('startFrom', startFrom);

    /** @ngInject */
    function startFrom() {
        return function (input, start) {
            if (input) {
                start = +start;
                return input.slice(start);
            }
            return [];
        };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin')
        .filter('propsFilter', propsFilter);

    /** @ngInject */
    function propsFilter() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function(item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                out = items;
            }

            return out;
        };
    };
})();
(function() {
    'use strict';
    angular.module('BlurAdmin.help')
        .service('helpStrings', helpStrings);

    /** @ngInject */
    function helpStrings() {
        return {
            faqsUser: [{
                    title: "¿Qué es Helo?",
                    answer: "es una cosa que...",
                    video: "dpMm3MtjwBk"
                },
                {
                    title: "¿Cómo hacer una rutina de ahorro?",
                    answer: "es una cosa que...",
                    video: "LTRnBcvrPFE"
                },
                {
                    title: "¿Cómo programar y automatizar un dispositivo?",
                    answer: "es una cosa que...",
                    video: "QNG4zhn26yw"
                },
                {
                    title: "Ver estadísticas por zona",
                    answer: "es una cosa que...",
                    video: "CCGP_EqPZos"
                },
                {
                    title: "Control a distancia",
                    answer: "es una cosa que...",
                    video: "N6ycLGTiWS0"
                },

            ],
            faqsInstaller: [
                {
                    title: "¿Cómo se crea un cliente?",
                    answer: "es una cosa que...",
                    video: "UE0KgFs0r5k"
                },
                {
                    title: "¿Cómo se crea una zona?",
                    answer: "es una cosa que...",
                    video: "bK_hMxKj5sM"
                },
                {
                    title: "¿Cómo se crea un usuario?",
                    answer: "es una cosa que...",
                    video: "j5CgjK56eoE"
                },
                {
                    title: "¿Cómo se crea un dispositivo?",
                    answer: "es una cosa que...",
                    video: "STs5nic-7Eo"
                },
            ]
        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.help')
      .controller('helpCtrl', helpCtrl);
  
    function helpCtrl($scope, $localStorage, helpStrings) {
        
        $scope.rol = $localStorage.rol;
        $scope.ind_question;
        $scope.installer = $scope.rol == 3 ? true : false;
        $scope.questions = helpStrings.faqsUser;
        $scope.questions_installer = helpStrings.faqsInstaller;

    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.notifications')
      .controller('notificationsCtrl', notificationsCtrl);
  
    function notificationsCtrl($scope, SHAREServices, RESTServices, $localStorage) {

        $scope.loading = true;
        $scope.noInfo = false;

        $scope.notificaciones = SHAREServices.notifications;
        $scope.notificaciones = $scope.notificaciones.map(function(n){
            n.dia = n.fecha.split(" ")[0];
            n.hora = n.fecha.split(" ")[1];
            return n;
        });
        
        $scope.totalItems = $scope.notificaciones.length;
        $scope.currentPage = 1;
        $scope.itemsPerPage = 10;
        $scope.noOfPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);

        $scope.noInfo = false;
        $scope.loading = false;

        RESTServices.markNotificationsSeenV2().then(function(result) {
            if(result.code == '200') SHAREServices.badge = 0;
        });

    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.profile')
      .controller('profileCtrl', profileCtrl);
  
    function profileCtrl($scope, $rootScope, $localStorage, RESTServices, $timeout, utilities, SHAREServices) {
        
        $rootScope.flag_loading = false;
        $scope.user = $localStorage.client;

    }

})();
/*var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
s1.async=true;
s1.src='https://embed.tawk.to/58b5a8e52dfdd91cf6e9a0dd/default';
s1.charset='UTF-8';
s1.setAttribute('crossorigin','*');
s0.parentNode.insertBefore(s1,s0);
})();*/

var url_1 = "https://api.helo.v0.intelmotics.com/helo/services/"; //Production HeloV0
//var url_1 = 'http://localhost/services/'; //Testing
var url_2 = "https://api.helo.v1.intelmotics.com/services/"; //Production HeloV1
//var url_2 = "https://apitest.helo.v1.intelmotics.com/services/"; //Testing HeloV1
// The gulp build is identical for dev and prod — same bundle, deployed to a
// different S3 bucket/CloudFront alias per .github/workflows/deploy.yml —
// so there's no build-time env injection. Pick the v3 targets at runtime
// from the hostname the bundle actually got deployed to instead.
var IS_DEV_DEPLOY = ["app.dev.intelmotics.com", "dev.helo.intelmotics.com", "localhost"].indexOf(window.location.hostname) !== -1;

// Was /v2 (legacy gateway, Firebase-only authorizer). Everything that uses
// this base URL now sends the Cognito token from fetchHeloV2IdToken/
// loginCognito, which /v2's authorizer rejects outright (wrong issuer) — has
// to be the Cognito-authorizer gateway, i.e. v3. Kept the variable name to
// avoid touching every call site.
var url_helo_v2 = IS_DEV_DEPLOY
  ? "https://api.helo.com.co/v3dev"
  : "https://api.helo.com.co/v3";
// Platform API (tickets, billing): its own gateway, separate from devices (v3).
var url_helo_platform = IS_DEV_DEPLOY
  ? "https://api.helo.com.co/platformdev"
  : "https://api.helo.com.co/platform";
// loginCognito's target: was hardcoded to prod always, so a login on the dev
// deploy synced the user into the prod Cognito pool while url_helo_v2 (v3dev)
// validates against the dev pool — every dev-deployed request came back 401
// regardless of a successful login.
var url_admin_v3 = IS_DEV_DEPLOY
  ? "https://1p4dwe1c0i.execute-api.us-east-1.amazonaws.com" // dev admin-v3
  : "https://ci97lpser1.execute-api.us-east-1.amazonaws.com"; // prod admin-v3 (helo-iac#23)
var url;

// ---------------------------------------------------------------------------
// Legacy PHP endpoints (Tickets + Facturacion) now served by Go lambdas behind
// the v3 gateway. RESTServices.post_header looks the PHP path up here and, when
// found, translates the legacy POST payload ({id_usuario, ticket: "<json>", ...})
// into the REST request of the new lambda. `id_usuario` is dropped: the lambda
// derives the user from the Cognito token. Each adapter returns
// { method, path, query, body, response }; `response` (optional) reshapes the
// legacy-compatible body so controllers keep reading what PHP used to return.
// ---------------------------------------------------------------------------
function v3IsBlank(v) {
  return v === null || v === undefined || v === "";
}

// Several legacy payloads carry a JSON-encoded string ("ticket", "factura"...).
function v3Parse(v) {
  if (typeof v === "string") {
    try {
      return JSON.parse(v) || {};
    } catch (e) {
      return {};
    }
  }
  return v || {};
}

function v3Id(v) {
  var n = Number(v);
  return isNaN(n) ? 0 : n;
}

function v3Seg(v) {
  return encodeURIComponent(v === undefined || v === null ? "" : v);
}

function v3Date(v) {
  return typeof v === "string" ? v.substring(0, 10) : v;
}

// Copy `keys` from src into dst, skipping null/undefined/"" (the Go side
// decodes JSON null into its flex int types as an error, and "" as invalid).
function v3Copy(dst, src, keys, asString) {
  keys.forEach(function (k) {
    var v = src[k];
    if (v3IsBlank(v)) return;
    if (asString) {
      v = typeof v === "object" ? JSON.stringify(v) : String(v);
    }
    dst[k] = v;
  });
  return dst;
}

// PHP/MySQL returned every column as a string and the controllers compare with
// ===; Go returns real ints. Stringify the given keys in each row.
function v3Stringify(rows, keys, nullAs) {
  if (!angular.isArray(rows)) return rows;
  rows.forEach(function (r) {
    keys.forEach(function (k) {
      if (v3IsBlank(r[k])) {
        if (nullAs !== undefined && nullAs[k] !== undefined) r[k] = nullAs[k];
      } else {
        r[k] = String(r[k]);
      }
    });
  });
  return rows;
}

var V3_TICKET_KEYS = [
  "id",
  "id_zona",
  "id_tecnico",
  "id_coordinador",
  "id_creador",
];

function v3Ticket(p) {
  var t = v3Parse(p.ticket);
  var id = v3Id(t.id);
  var body = v3Copy(
    {},
    t,
    [
      "prioridad",
      "estado",
      "dispositivos",
      "texto",
      "descripcion",
      "fecha_ejecucion",
      "hora_ejecucion",
    ],
    true,
  );
  v3Copy(body, t, ["id_coordinador", "id_zona", "id_tecnico"]);
  return {
    method: id > 0 ? "PUT" : "POST",
    path: id > 0 ? "/tickets/" + id : "/tickets",
    body: body,
  };
}

// The schedule lambdas want YYYY-MM-DD; some callers send the PHP-era "yyyy/MM/dd".
function v3ScheduleDay(v) {
  return typeof v === "string" ? v.replace(/\//g, "-").substring(0, 10) : v;
}

// Body of the zone schedule lambdas. zone/schedule ids and id_usuario travel in
// the path / the token now, so they are not part of the body.
function v3ZoneSchedule(p) {
  return {
    dia: v3ScheduleDay(p.dia),
    hora_inicio: p.hora_inicio,
    hora_fin: p.hora_fin,
    frecuencia: v3Id(p.frecuencia),
  };
}

// Body of the air schedule lambdas. grupo/feriado only apply on create (an edit
// keeps the stored ones); grupo is a varchar(20) so numbers are stringified.
function v3AirSchedule(p, withExtras) {
  var body = {
    dia: v3ScheduleDay(p.dia),
    hini: p.hini,
    hfin: p.hfin,
    frecuencia: v3Id(p.frecuencia),
    comando: Math.round(v3Id(p.comando)),
    comando_post: Math.round(v3Id(p.comando_post)),
  };
  if (withExtras) {
    v3Copy(body, p, ["grupo"], true);
    if (!v3IsBlank(p.feriado)) body.feriado = v3Id(p.feriado);
  }
  return body;
}

var V3_ADAPTERS = {
  // ---- Tickets ----
  "cliente/consulta_tickets.php": function (p) {
    return {
      method: "GET",
      path: "/tickets",
      query: v3Copy({}, p, ["estado", "id_ticket", "prioridad"]),
      response: function (d) {
        v3Stringify(d.tickets, V3_TICKET_KEYS, { id_tecnico: "0" });
        return d;
      },
    };
  },
  "cliente/filtro_tickets.php": function (p) {
    return {
      method: "GET",
      path: "/tickets/search",
      query: v3Copy({}, p, [
        "estado",
        "id_zona",
        "id_tecnico",
        "fecha_ini",
        "fecha_fin",
        "prioridad",
      ]),
      response: function (d) {
        v3Stringify(d.tickets, V3_TICKET_KEYS, { id_tecnico: "0" });
        return d;
      },
    };
  },
  "cliente/edita_tickets.php": v3Ticket,
  "cliente/edita_imagen_ticket.php": function (p) {
    var i = v3Parse(p.imagen);
    var id = v3Id(i.id);
    var base = "/tickets/" + v3Seg(i.id_ticket) + "/images";
    return {
      method: id > 0 ? "PUT" : "POST",
      path: id > 0 ? base + "/" + id : base,
      body: { url: i.url },
    };
  },
  "cliente/consulta_imagenes_ticket.php": function (p) {
    return {
      method: "GET",
      path: "/tickets/" + v3Seg(p.id_ticket) + "/images",
    };
  },
  "cliente/edita_nota_ticket.php": function (p) {
    var n = v3Parse(p.nota);
    var id = v3Id(n.id);
    var base = "/tickets/" + v3Seg(n.id_ticket) + "/notes";
    return {
      method: id > 0 ? "PUT" : "POST",
      path: id > 0 ? base + "/" + id : base,
      body: { texto: n.texto },
      // The lambda echoes {id} on update too; the controller uses `res.id` to
      // tell "created" from "edited" (PHP only returned it on create).
      response: function (d) {
        if (id > 0) delete d.id;
        return d;
      },
    };
  },
  "cliente/consulta_notas_ticket.php": function (p) {
    return {
      method: "GET",
      path: "/tickets/" + v3Seg(p.id_ticket) + "/notes",
    };
  },
  "cliente/asociar_tecnicosaticket.php": function (p) {
    return {
      method: "PUT",
      path: "/tickets/" + v3Seg(p.id_ticket) + "/technicians",
      body: { orden: v3Id(p.orden), tecnicos: v3Parse(p.tecnicos) },
    };
  },
  "cliente/consulta_tecnicos_ticket.php": function (p) {
    return {
      method: "GET",
      path: "/tickets/" + v3Seg(p.id_ticket) + "/technicians",
      response: function (d) {
        v3Stringify(d.tecnicos, ["id_tecnico"]);
        return d;
      },
    };
  },
  "cliente/ver_ticket.php": function (p) {
    return {
      method: "PUT",
      path: "/tickets/" + v3Seg(p.id_ticket) + "/seen",
    };
  },

  // ---- Facturacion ----
  "cliente/consulta_factura.php": function (p) {
    var f = v3Parse(p.factura);
    return {
      method: "GET",
      path:
        "/billing-points/" +
        v3Seg(p.id_punto_facturacion || f.id_punto_facturacion) +
        "/invoice-info",
      query: { fecha_ini: v3Date(f.fecha_ini) },
    };
  },
  "cliente/edita_factura.php": function (p) {
    var f = v3Parse(p.factura);
    var id = v3Id(f.id);
    var body = v3Copy({}, f, [
      "id_punto_facturacion",
      "precio_kwh",
      "consumo_kwh",
      "valor",
    ]);
    body.dia_ini = v3Date(f.dia_ini);
    body.dia_fin = v3Date(f.dia_fin);
    return {
      method: id > 0 ? "PUT" : "POST",
      path: id > 0 ? "/invoices/" + id : "/invoices",
      body: body,
    };
  },
  "cliente/elimina_factura.php": function (p) {
    var f = v3Parse(p.factura);
    return { method: "DELETE", path: "/invoices/" + v3Seg(f.id) };
  },
  "cliente/edita_facturador.php": function (p) {
    var f = v3Parse(p.facturador);
    var id = v3Id(f.id);
    var body = v3Copy(
      {},
      f,
      ["nombre", "direccion", "telefono", "correo", "nit"],
      true,
    );
    v3Copy(body, f, ["id_ciudad"]);
    body.puntos = (f.puntos || []).map(function (pt) {
      return { id: pt.id, nombre: pt.nombre };
    });
    return {
      method: id > 0 ? "PUT" : "POST",
      path: id > 0 ? "/billers/" + id : "/billers",
      body: body,
    };
  },
  "cliente/elimina_facturador.php": function (p) {
    return { method: "DELETE", path: "/billers/" + v3Seg(p.id_facturador) };
  },
  "cliente/consulta_facturador.php": function () {
    return {
      method: "GET",
      path: "/billers",
      response: function (d) {
        v3Stringify(d.facturadores, ["ciudad_id", "estado_id", "pais_id"]);
        return d;
      },
    };
  },
  "cliente/consulta_facturas.php": function (p) {
    return {
      method: "GET",
      path: "/billing-points/" + v3Seg(p.id_punto_facturacion) + "/invoices",
    };
  },
  "cliente/consulta_historico_facturas.php": function (p) {
    return {
      method: "GET",
      path:
        "/billing-points/" + v3Seg(p.id_punto_facturacion) + "/invoice-history",
      query: {
        fecha_ini: v3Date(p.fecha_ini),
        fecha_fin: v3Date(p.fecha_fin),
        variable: p.variable,
      },
    };
  },
  "cliente/edita_punto_facturacion.php": function (p) {
    var pt = v3Parse(p.punto);
    var id = v3Id(pt.id);
    var body = v3Copy(
      {},
      pt,
      ["nombre", "prestador_servicio", "plan", "direccion", "telefono"],
      true,
    );
    v3Copy(body, pt, ["id_ciudad", "estrato"]);
    // The legacy form sends 0 for "no totalizer"; the lambda would store 0.
    if (!v3IsBlank(pt.id_totalizador) && v3Id(pt.id_totalizador) !== 0) {
      body.id_totalizador = pt.id_totalizador;
    }
    return {
      method: id > 0 ? "PUT" : "POST",
      path: id > 0 ? "/billing-points/" + id : "/billing-points",
      body: body,
    };
  },
  "cliente/elimina_punto_facturacion.php": function (p) {
    return {
      method: "DELETE",
      path: "/billing-points/" + v3Seg(p.id_punto_facturacion),
    };
  },
  "cliente/consulta_puntos_facturacion.php": function (p) {
    return {
      method: "GET",
      path: "/billing-points",
      query: v3Copy({}, p, ["pagina", "cantidad"]),
      response: function (d) {
        v3Stringify(d.puntos, [
          "estrato",
          "ciudad_id",
          "estado_id",
          "pais_id",
          "id_totalizador",
        ]);
        return d;
      },
    };
  },
  "cliente/consulta_puntos_facturacion_disponibles.php": function () {
    return { method: "GET", path: "/billing-points/available" };
  },

  // ---- Programaciones (zona y aires) ----
  "lista_programacion.php": function (p) {
    return {
      method: "GET",
      path: "/zones/" + v3Seg(p.id_zona) + "/schedules",
      response: function (d) {
        if (!angular.isArray(d.programaciones)) return d;
        v3Stringify(d.programaciones, ["id", "frecuencia", "enable"]);
        // Controllers of the admin dashboard and the history view still read the
        // PHP-era parallel arrays (data.id[i], data.hora_inicio[i]...).
        var rows = d.programaciones;
        d.id = rows.map(function (r) { return r.id; });
        d.dia = rows.map(function (r) { return r.dia; });
        d.hora_inicio = rows.map(function (r) { return r.hini; });
        d.hora_fin = rows.map(function (r) { return r.hfin; });
        d.frecuencia = rows.map(function (r) { return r.frecuencia; });
        return d;
      },
    };
  },
  "programacion_zona.php": function (p) {
    return {
      method: "POST",
      path: "/zones/" + v3Seg(p.id_zona) + "/schedules",
      body: v3ZoneSchedule(p),
    };
  },
  "edita_programacion.php": function (p) {
    return {
      method: "PUT",
      path: "/zone-schedules/" + v3Seg(p.id_programacion),
      body: v3ZoneSchedule(p),
    };
  },
  "elimina_programacion.php": function (p) {
    return {
      method: "DELETE",
      path: "/zone-schedules/" + v3Seg(p.id_programacion),
    };
  },
  "programacion_aire.php": function (p) {
    return {
      method: "POST",
      path: "/devices/" + v3Seg(p.id_dispositivo) + "/air-schedules",
      body: v3AirSchedule(p, true),
    };
  },
  "edita_programacion_aires.php": function (p) {
    return {
      method: "PUT",
      path: "/air-schedules/" + v3Seg(p.id_programacion),
      body: v3AirSchedule(p, false),
    };
  },
  "elimina_programacion_aires.php": function (p) {
    return {
      method: "DELETE",
      path: "/air-schedules/" + v3Seg(p.id_programacion),
    };
  },
  "get_programacion.php": function (p) {
    return {
      method: "GET",
      path: "/air-schedules/" + v3Seg(p.id_programacion),
    };
  },
  "cliente/habilita_programacionesxzona.php": function (p) {
    return {
      method: "PUT",
      path: "/zones/" + v3Seg(p.id_zona) + "/schedules/enabled",
      body: { estado: v3Id(p.estado) },
    };
  },
  "cliente/habilita_programacionesxcliente.php": function (p) {
    return {
      method: "PUT",
      path: "/schedules/enabled",
      body: { estado: v3Id(p.estado) },
    };
  },
};

// Legacy-code mapping shared by the alert V2 adapters. The Go routes answer
// real HTTP statuses; the controllers still expect {code: "200"|"300"|...}.
// `table` maps an HTTP status to a legacy code and `fallback` covers the rest
// (including a network error, where `status` is undefined). The response body
// `code` is never read.
function alertStatusToCode(response, table, fallback) {
  var status = response && response.status;
  if (table.hasOwnProperty(status)) {
    return table[status];
  }
  return fallback;
}

var ALERT_WRITE_CODES = { 400: "500", 401: "400", 403: "400", 404: "300" };

(function () {
  "use strict";
  angular
    .module("BlurAdmin")
    .factory(
      "RESTServices",
      function (
        $http,
        $q,
        $rootScope,
        ngDialog,
        $localStorage,
        SHAREServices,
        $filter,
      ) {
        return {
          canceler: null,
          post_pending: false,
          post: function (api, parametros) {
            url = $localStorage.server_url;
            return $http
              .post(url + api, parametros)
              .catch(function (response) {
                if (response.status != 200) {
                  $rootScope.flag_loading = false;
                  ngDialog.open({
                    template:
                      "app/cliente/dashboard-cliente/templates/mensaje.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        // controller logic
                        $scope.titleModal = "Error de red";
                        $scope.bodyModal =
                          "La red no tiene acceso a la plataforma, comunicarse con el administrador del servicio";

                        $scope.close = function () {
                          ngDialog.close();
                        };
                      },
                    ],
                  });
                }
              })
              .then(
                function (response) {
                  if (response) {
                    if (response.data != undefined) {
                      return response.data;
                    } else {
                      return $q.reject();
                    }
                  } else {
                    return $q.reject();
                  }
                },
                function (error) {
                  return $q.reject(error);
                },
              );
          },
          // Same contract as post_header, but against the v3 gateway: the
          // lambdas answer with real HTTP statuses (400/403/404...) and keep the
          // legacy body {code:"..."}, which the controllers expect to receive as
          // a resolved value, so non-2xx responses carrying a `code` resolve.
          post_header_v3: function (adapter, parametros) {
            var self = this;
            var req = adapter(parametros || {});

            function send(retryOnUnauthorized) {
              return self.fetchHeloV2IdToken(false).then(function (idToken) {
                // Created after the token fetch: it may itself go through
                // post_header and replace self.canceler / post_pending.
                var canceler = $q.defer();
                self.canceler = canceler;
                self.post_pending = true;
                return $http({
                  method: req.method,
                  url: url_helo_platform + req.path,
                  params: req.query,
                  data: req.body === undefined ? undefined : angular.toJson(req.body),
                  transformRequest: [function (d) { return d; }],
                  headers: {
                    Authorization: idToken,
                    "Content-Type": "application/json",
                  },
                  timeout: canceler.promise,
                }).catch(function (error) {
                  if (error && error.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return send(false);
                  }
                  return $q.reject(error);
                });
              });
            }

            return send(true)
              .then(function (response) {
                self.post_pending = false;
                if (response && response.data !== undefined) {
                  return req.response
                    ? req.response(response.data)
                    : response.data;
                }
                return $q.reject();
              })
              .catch(function (error) {
                self.post_pending = false;
                if (
                  error &&
                  error.status > 0 &&
                  error.status !== 401 &&
                  error.data &&
                  typeof error.data === "object" &&
                  error.data.code !== undefined
                ) {
                  return error.data;
                }
                if (
                  error &&
                  error.status != 200 &&
                  error.config &&
                  error.config.timeout &&
                  error.config.timeout.$$state.status === 0
                ) {
                  $rootScope.flag_loading = false;
                  ngDialog.open({
                    template:
                      "app/cliente/dashboard-cliente/templates/mensaje.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.titleModal = "Error de red";
                        $scope.bodyModal =
                          "La red no tiene acceso a la plataforma, comunicarse con el administrador del servicio";

                        $scope.close = function () {
                          ngDialog.close();
                        };
                      },
                    ],
                  });
                }
                return $q.reject(error);
              });
          },
          post_header: function (api, parametros, token, flag) {
            if (V3_ADAPTERS.hasOwnProperty(api)) {
              return this.post_header_v3(V3_ADAPTERS[api], parametros);
            }
            var url = $localStorage.server_url;
            var auth_header = flag == true ? "Bearer " : "Basic ";
            var self = this;

            // Crear un nuevo canceler para esta solicitud
            this.canceler = $q.defer();
            this.post_pending = true;

            return $http
              .post(url + api, parametros, {
                headers: { Authorization: auth_header + token },
                timeout: this.canceler.promise,
              })
              .then(function (response) {
                self.post_pending = false;
                if (response && response.data !== undefined) {
                  return response.data;
                } else {
                  return $q.reject();
                }
              })
              .catch(function (response) {
                self.post_pending = false;
                if (
                  response.status != 200 &&
                  response.config.timeout &&
                  response.config.timeout.$$state.status === 0
                ) {
                  $rootScope.flag_loading = false;
                  ngDialog.open({
                    template:
                      "app/cliente/dashboard-cliente/templates/mensaje.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.titleModal = "Error de red";
                        $scope.bodyModal =
                          "La red no tiene acceso a la plataforma, comunicarse con el administrador del servicio";

                        $scope.close = function () {
                          ngDialog.close();
                        };
                      },
                    ],
                  });
                }
                return $q.reject(response);
              });
          },
          cancelarSolicitudHttp: function () {
            if (this.post_pending && this.canceler) {
              this.canceler.resolve();
              this.post_pending = false;
            }
          },
          get: function (url, tag) {
            return $http
              .get(url + tag + "&filter=point")
              .then(function (response) {
                if (response.data != undefined) {
                  return response.data;
                }
              });
          },
          setPointSaeg: function (value, point_id) {
            var url =
              "https://ql47eug7ynipxlxder34mu7vlm0ftkun.lambda-url.us-east-1.on.aws/?point_id=" +
              point_id +
              "&value=" +
              value +
              "&level=7";
            return $http.get(url).then(function (response) {
              if (response.data != undefined) {
                return response.data;
              }
            });
          },
          getPointHistorySaeg: function (point_id, start, end) {
            var url =
              "https://qhud4fq47kyeviqjj5yexf2jiy0evvgm.lambda-url.us-east-1.on.aws/?point_id=" +
              point_id +
              "&start=" +
              start +
              "&end=" +
              end;
            return $http.get(url).then(function (response) {
              if (response.data != undefined) {
                return response.data;
              }
            });
          },
          server_selector: function (status) {
            switch (status) {
              case 0:
                $localStorage.server_url = url_1;
                SHAREServices.server_status = 0;
                break;
              case 1:
                $localStorage.server_url = url_1;
                SHAREServices.server_status = 1;
                break;
              case 2:
                $localStorage.server_url = url_2;
                SHAREServices.server_status = 2;
                break;
            }
            url = $localStorage.server_url;
          },
          uploadFile: function () {
            var params = {
              id_usuario: $localStorage.id_usuario,
            };
            var keys = this.post_header(
              "cliente/consulta_url_upload.php",
              params,
              SHAREServices.hash_decode_token($localStorage.token),
              true,
            ).then(function (res) {
              if (res.code == 200) {
                return res;
              }
            });
            return keys;
          },
          getURL: function (file, hash) {
            var res;
            var self = this;
            var url = $q.resolve(this.uploadFile()).then(function (response) {
              var name = file.name.replaceAll(" ", "_");
              name = self.quitarTildes(name);
              res = response;
              var headers = {
                Authorization: res.authorizationToken,
                "X-Bz-File-Name":
                  "images/" +
                  $localStorage.id_usuario +
                  "_" +
                  $filter("date")(new Date(), "yyyy_MM_dd_hh_mm_ss") +
                  "-" +
                  name,
                "Content-Type": "image/jpeg",
                "X-Bz-Content-Sha1": hash,
              };

              var url = $http({
                method: "POST",
                url: res.uploadUrl,
                data: file,
                headers: headers,
              }).then(
                function (response) {
                  if (response.data != undefined) {
                    var fileUrl =
                      "https://f000.backblazeb2.com/file/helo-files/" +
                      response.data.fileName;
                    return fileUrl;
                  } else {
                    return $q.reject(error);
                  }
                },
                function (error) {
                  return $q.reject(error);
                },
              );

              return url;
            });

            return url;
          },

          quitarTildes: function (cadena) {
            // Reemplazar tildes por vocales simples
            return cadena.replace(/[áéíóúüÁÉÍÓÚÜ]/g, function (match) {
              switch (match) {
                case "á":
                  return "a";
                case "é":
                  return "e";
                case "í":
                  return "i";
                case "ó":
                  return "o";
                case "ú":
                  return "u";
                case "ü":
                  return "u";
                case "Á":
                  return "A";
                case "É":
                  return "E";
                case "Í":
                  return "I";
                case "Ó":
                  return "O";
                case "Ú":
                  return "U";
                case "Ü":
                  return "U";
              }
            });
          },

          getCountries: function () {
            var fields = {
              id_instalador: $localStorage.id_usuario,
              id_usuario: $localStorage.id_usuario,
            };

            return this.post_header(
              "admin/lista_paises.php",
              fields,
              SHAREServices.hash_decode_token($localStorage.token),
              true,
            ).then(function (res) {
              if (res.code == "200") {
                return res.paises;
              } else {
                return [];
              }
            });
          },

          clearHeloV2IdToken: function () {
            delete $localStorage.helo_v2_id_token;
            delete $localStorage.helo_v2_uid;
          },

          verifyHeloV2: function (uid) {
            return $http
              .post(url_helo_v2 + "/verify", angular.toJson({ uid: uid }), {
                headers: { "Content-Type": "application/json" },
                transformRequest: angular.identity,
              })
              .then(function (response) {
                if (response.data && response.data.token) {
                  return response.data;
                }
                return $q.reject(response);
              });
          },

          // Llamada justo después de un login.php exitoso, con la misma
          // password que el usuario acaba de validar contra Firebase. Crea
          // el usuario en Cognito la primera vez (vía el trigger de
          // migración) y, si ya existía con una password desactualizada, el
          // propio lambda la resincroniza — nunca hace falta un paso aparte.
          // Best-effort: si falla, el login legacy ya sucedió y sigue andando.
          loginCognito: function (email, password) {
            return $http
              .post(
                url_admin_v3 + "/login",
                angular.toJson({ uid: email, password: password }),
                {
                  headers: { "Content-Type": "application/json" },
                  transformRequest: angular.identity,
                },
              )
              .then(function (response) {
                if (!response.data || !response.data.token) {
                  return $q.reject(response);
                }
                $localStorage.cognito_refresh_token =
                  response.data.refresh_token;
                $localStorage.helo_v2_id_token = response.data.token;
                return response.data;
              });
          },

          refreshCognitoToken: function () {
            var self = this;
            return $http
              .post(
                url_admin_v3 + "/login",
                angular.toJson({
                  refresh_token: $localStorage.cognito_refresh_token,
                }),
                {
                  headers: { "Content-Type": "application/json" },
                  transformRequest: angular.identity,
                },
              )
              .then(function (response) {
                if (!response.data || !response.data.token) {
                  return $q.reject(response);
                }
                $localStorage.helo_v2_id_token = response.data.token;
                return response.data.token;
              })
              .catch(function (err) {
                delete $localStorage.cognito_refresh_token;
                self.clearHeloV2IdToken();
                return $q.reject(err);
              });
          },

          fetchHeloV2IdToken: function (forceRefresh) {
            var self = this;

            if (!forceRefresh && $localStorage.helo_v2_id_token) {
              return $q.when($localStorage.helo_v2_id_token);
            }

            if ($localStorage.cognito_refresh_token) {
              return self.refreshCognitoToken();
            }

            // Legacy fallback: no hay sesión de Cognito todavía (usuario no
            // pasó por loginCognito, p.ej. sesión abierta antes de este
            // cambio) — mintear un token de Firebase a partir del UID, como
            // antes.
            var fields = {
              id_usuario: $localStorage.id_usuario,
            };

            return self
              .post_header(
                "cliente/consulta_uid.php",
                fields,
                SHAREServices.hash_decode_token($localStorage.token),
                true,
              )
              .then(function (res) {
                if (!res || res.code !== "200" || !res.uid) {
                  self.clearHeloV2IdToken();
                  return $q.reject(res);
                }

                $localStorage.helo_v2_uid = res.uid;

                return self.verifyHeloV2(res.uid).then(
                  function (data) {
                    $localStorage.helo_v2_id_token = data.token;
                    return data.token;
                  },
                  function (err) {
                    self.clearHeloV2IdToken();
                    return $q.reject(err);
                  },
                );
              });
          },

          fetchZonesListV2: function (retryOnUnauthorized) {
            var self = this;

            if (retryOnUnauthorized === undefined) {
              retryOnUnauthorized = true;
            }

            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url:
                    url_helo_v2 +
                    "/zones?format=unified&include=device_summary,owner_customer",
                  headers: {
                    Authorization: idToken,
                  },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchZonesListV2(false);
                  }
                  if (response.data !== undefined) {
                    return response.data;
                  }
                  return $q.reject(response);
                });
              })
              .catch(function (response) {
                if (
                  response &&
                  response.status === 401 &&
                  retryOnUnauthorized
                ) {
                  self.clearHeloV2IdToken();
                  return self.fetchZonesListV2(false);
                }
                return $q.reject(response);
              });
          },

          normalizeZonesV2ToLegacy: function (v2Data) {
            var zonas = [];
            var zonasExternas = [];

            var mapZone = function (z, isShared) {
              var hub = z.hub != null ? z.hub : z.h != null ? z.h : 0;
              var legacy = {
                // String: fetchProjectZonesV2 (POST /v2/projects/zones, migrated
                // from consulta_zonasxproyecto.php) also stringifies id_zona for
                // this same reason; without this, z.id === z_p.id never matches in
                // new-project.ctrl.js and the project's zones don't end up marked.
                id: String(z.id),
                nombre: z.name || z.nombre,
                // String: legacy consumers bind it to <select ng-model> whose
                // <option value="{{pais.id}}"> values are strings (newZone.html);
                // a numeric country_id never matches and the select shows blank.
                id_pais:
                  z.country_id != null
                    ? String(z.country_id)
                    : z.id_pais != null
                      ? String(z.id_pais)
                      : z.id_pais,
                h: String(hub),
              };

              if (z.device_summary) {
                legacy.iluminacion = z.device_summary.lightning || 0;
                legacy.aires = z.device_summary.airs || 0;
                legacy.medicion = z.device_summary.measurements || 0;
                legacy.temp = z.device_summary.temperature || 0;
              } else {
                legacy.iluminacion = z.lightning || 0;
                legacy.aires = z.airs || 0;
                legacy.medicion = z.measurements || 0;
                legacy.temp = z.temperature || 0;
              }

              if (isShared) {
                legacy.nombre_cliente =
                  (z.owner_customer && z.owner_customer.name) ||
                  z.customer_name ||
                  z.nombre_cliente;
                legacy.rol = z.access_role != null ? z.access_role : z.rol;
              }

              return legacy;
            };

            if (v2Data.shared_zones) {
              (v2Data.zones || []).forEach(function (z) {
                zonas.push(mapZone(z, false));
              });
              (v2Data.shared_zones || []).forEach(function (z) {
                zonasExternas.push(mapZone(z, true));
              });
            } else {
              (v2Data.zones || []).forEach(function (z) {
                if (z.ownership === "shared") {
                  zonasExternas.push(mapZone(z, true));
                } else {
                  zonas.push(mapZone(z, false));
                }
              });
            }

            var enable = v2Data.enable;
            if (enable === undefined && v2Data.meta) {
              enable = v2Data.meta.schedules_enabled ? 1 : 0;
            }

            return {
              code: zonas.length || zonasExternas.length ? "200" : "300",
              zonas: zonas.length ? zonas : undefined,
              zonas_externas: zonasExternas.length ? zonasExternas : undefined,
              enable: enable,
            };
          },

          fetchClientZones: function () {
            var self = this;
            var fields = {
              id_usuario: $localStorage.id_usuario,
            };
            var token = SHAREServices.hash_decode_token($localStorage.token);

            return self
              .fetchZonesListV2()
              .then(function (v2Data) {
                return self.normalizeZonesV2ToLegacy(v2Data);
              })
              .catch(function () {
                return self.post_header(
                  "cliente/consulta_zonas.php",
                  fields,
                  token,
                  true,
                );
              });
          },

          createDeviceMaintenanceV2: function (
            deviceId,
            body,
            retryOnUnauthorized,
          ) {
            var self = this;

            if (retryOnUnauthorized === undefined) {
              retryOnUnauthorized = true;
            }

            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "POST",
                  url: url_helo_v2 + "/devices/" + deviceId + "/maintenance",
                  data: angular.toJson(body),
                  transformRequest: angular.identity,
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: idToken,
                  },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.createDeviceMaintenanceV2(
                      deviceId,
                      body,
                      false,
                    );
                  }
                  if (response.data !== undefined) {
                    return response.data;
                  }
                  return $q.reject();
                });
              })
              .catch(function (response) {
                if (
                  response &&
                  response.status === 401 &&
                  retryOnUnauthorized
                ) {
                  self.clearHeloV2IdToken();
                  return self.createDeviceMaintenanceV2(deviceId, body, false);
                }
                if (response && response.status && response.status !== 200) {
                  $rootScope.flag_loading = false;
                  ngDialog.open({
                    template:
                      "app/cliente/dashboard-cliente/templates/mensaje.html",
                    className: "ngdialog-theme-plain",
                    controller: [
                      "$scope",
                      function ($scope) {
                        $scope.titleModal = "Error de red";
                        $scope.bodyModal =
                          "La red no tiene acceso a la plataforma, comunicarse con el administrador del servicio";

                        $scope.close = function () {
                          ngDialog.close();
                        };
                      },
                    ],
                  });
                }
                return $q.reject(response);
              });
          },

          // v2 Lambda endpoint migrations
          fetchProjectsV2: function (retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/projects",
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchProjectsV2(false);
                  }
                  // El Lambda devuelve un array plano (no { projects: [...] }).
                  var v2Projects = Array.isArray(response.data)
                    ? response.data
                    : [];
                  return {
                    code: "200",
                    proyectos: v2Projects.map(function (p) {
                      return {
                        id: String(p.id),
                        nombre: p.nombre,
                        imagen: p.imagen || "",
                        // Ids as strings: new-project compares them with === against
                        // consulta_tecnicos.php, whose ids are strings.
                        tecnicos: Array.isArray(p.tecnicos)
                          ? p.tecnicos.map(function (t) {
                              return { id: String(t.id), nombre: t.nombre, email: t.email };
                            })
                          : null,
                      };
                    }),
                  };
                });
              })
              .catch(function (error) {
                return { code: "300", proyectos: [] };
              });
          },

          fetchZoneUsersV2: function (zoneId, retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/zones/" + zoneId + "/users",
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchZoneUsersV2(zoneId, false);
                  }
                  return {
                    code: response.data.code || "200",
                    users: response.data.users || [],
                  };
                });
              })
              .catch(function (error) {
                return { code: "300", users: [] };
              });
          },

          // Zones shared with a technician (accepted, from any company). Go route
          // GET /users/{userId}/zones (roles 6 and 8 only), resolved in the legacy
          // {code, zonas_externas} shape that replaced
          // cliente/consulta_zonas_usuario_zona.php. Ids are strings. No PHP
          // fallback.
          //   200 with zones   -> {code: "200", zonas_externas}
          //   200 with []      -> {code: "300"}
          //   400/403/404      -> {code: "300"} (e.g. a caller without the role)
          //   anything else    -> {code: "500"} (401 is retried once by callHeloV2)
          fetchUserSharedZonesV2: function (userId) {
            return this.callHeloV2("GET", "/users/" + userId + "/zones")
              .then(function (res) {
                var zones = angular.isArray(res.data) ? res.data : [];
                if (zones.length === 0) {
                  return { code: "300" };
                }
                return {
                  code: "200",
                  zonas_externas: zones.map(function (z) {
                    return {
                      id: String(z.id),
                      nombre: z.name,
                      id_cliente: String(z.customer_id),
                      nombre_cliente: z.customer_name,
                      rol: String(z.role),
                    };
                  }),
                };
              })
              .catch(function (response) {
                var status = response && response.status;
                if (status === 400 || status === 403 || status === 404) {
                  return { code: "300" };
                }
                return { code: "500" };
              });
          },

          // Zones shared with the logged user that still await approval. Go route
          // GET /users/me/zones/pending, resolved in the legacy {code, zonas}
          // shape that replaced cliente/consulta_zonas_usuario.php. Ids are
          // strings. Same code mapping as fetchUserSharedZonesV2.
          fetchPendingZonesV2: function () {
            return this.callHeloV2("GET", "/users/me/zones/pending")
              .then(function (res) {
                var zones = angular.isArray(res.data) ? res.data : [];
                if (zones.length === 0) {
                  return { code: "300" };
                }
                return {
                  code: "200",
                  zonas: zones.map(function (z) {
                    return {
                      id_zona: String(z.id),
                      zona: z.name,
                      cliente: z.customer_name,
                    };
                  }),
                };
              })
              .catch(function (response) {
                var status = response && response.status;
                if (status === 400 || status === 403 || status === 404) {
                  return { code: "300" };
                }
                return { code: "500" };
              });
          },

          // Alert writes (cliente/edita_alertas.php, elimina_alertas.php,
          // habilita_alertas.php, edita_notificacionesxcliente.php migrated to
          // Go). Identity comes from the token, no id_usuario is sent. Each
          // resolves the legacy {code} shape from the HTTP status:
          //   2xx -> "200", 400 -> "500", 401/403 -> "400", 404 -> "300",
          //   anything else (5xx, network) -> "500".
          // `alertas` are the same item objects the PHP endpoint received (as
          // objects, not as a JSON string).
          saveAlertsV2: function (alertas) {
            return this.callHeloV2("POST", "/alerts", { alerts: alertas }).then(
              function () {
                return { code: "200" };
              },
              function (response) {
                return { code: alertStatusToCode(response, ALERT_WRITE_CODES, "500") };
              },
            );
          },

          // `ids` is always an array; the single-alert case is wrapped as [id].
          deleteAlertsV2: function (ids) {
            return this.callHeloV2("POST", "/alerts/delete", { ids: ids }).then(
              function () {
                return { code: "200" };
              },
              function (response) {
                return { code: alertStatusToCode(response, ALERT_WRITE_CODES, "500") };
              },
            );
          },

          // `items` is an array of {id, estado}; each item keeps its own estado.
          setAlertsStateV2: function (items) {
            return this.callHeloV2("PATCH", "/alerts/state", { alerts: items }).then(
              function () {
                return { code: "200" };
              },
              function (response) {
                return { code: alertStatusToCode(response, ALERT_WRITE_CODES, "500") };
              },
            );
          },

          // Marks every unread notification of the token customer as seen.
          markNotificationsSeenV2: function () {
            return this.callHeloV2("POST", "/notifications/seen").then(
              function () {
                return { code: "200" };
              },
              function (response) {
                return { code: alertStatusToCode(response, ALERT_WRITE_CODES, "500") };
              },
            );
          },

          // Notification history of one alert (consulta_notificaciones.php).
          //   items -> {code: "200", notificaciones: [{fecha, id_dispositivo}]}
          //   []    -> {code: "300"}
          //   400 -> "500"; 401/403/404 -> "300"; anything else -> "500"
          fetchAlertNotificationsV2: function (alertId) {
            return this.callHeloV2("GET", "/alerts/" + alertId + "/notifications").then(
              function (res) {
                var items = angular.isArray(res.data) ? res.data : [];
                if (items.length === 0) {
                  return { code: "300" };
                }
                return {
                  code: "200",
                  notificaciones: items.map(function (n) {
                    return {
                      fecha: n.date,
                      id_dispositivo: String(n.device_id),
                    };
                  }),
                };
              },
              function (response) {
                return {
                  code: alertStatusToCode(
                    response,
                    { 400: "500", 401: "300", 403: "300", 404: "300" },
                    "500",
                  ),
                };
              },
            );
          },

          // Open-alert counts per zone for the sidebar (consulta_alertasxzona.php).
          // Ids and counts are strings (the sidebar compares ids with ===). An
          // empty list omits its key.
          //   400 -> "500"; 401/403 -> "300"; anything else -> "500"
          fetchAlertsZonesSummaryV2: function () {
            function toLegacy(zones) {
              return zones.map(function (z) {
                return {
                  id: String(z.id),
                  nombre: z.name,
                  cantidad: String(z.count),
                };
              });
            }
            return this.callHeloV2("GET", "/alerts/zones/summary").then(
              function (res) {
                var data = res.data || {};
                var result = { code: "200" };
                if (angular.isArray(data.owned) && data.owned.length > 0) {
                  result.zonas = toLegacy(data.owned);
                }
                if (angular.isArray(data.shared) && data.shared.length > 0) {
                  result.zonas_externas = toLegacy(data.shared);
                }
                return result;
              },
              function (response) {
                return {
                  code: alertStatusToCode(
                    response,
                    { 400: "500", 401: "300", 403: "300" },
                    "500",
                  ),
                };
              },
            );
          },

          // Offline devices of a zone (consulta_dispositivos_offlinexzona.php).
          // last_connection stays null for a device that never connected.
          //   400/401/403/404 -> "300" (controller shows the no-devices state);
          //   anything else -> "500"
          fetchZoneOfflineDevicesV2: function (zoneId) {
            return this.callHeloV2("GET", "/zones/" + zoneId + "/devices/offline").then(
              function (res) {
                var data = res.data || {};
                var devices = angular.isArray(data.devices) ? data.devices : [];
                var result = { code: "200" };
                if (devices.length > 0) {
                  result.offline = devices.map(function (d) {
                    return {
                      id: String(d.id),
                      nombre: d.name,
                      fecha_conexion: d.last_connection,
                      fecha_server: data.server_time,
                    };
                  });
                }
                return result;
              },
              function (response) {
                return {
                  code: alertStatusToCode(
                    response,
                    { 400: "300", 401: "300", 403: "300", 404: "300" },
                    "500",
                  ),
                };
              },
            );
          },

          // Bell list of the logged customer (consulta_notificacionesxcliente.php).
          // Go route GET /customers/me/notifications; the customer comes from
          // the token. tipo and estado are strings (the controller switches on
          // them). The notificaciones key is omitted when there are no items.
          //   400/401/403 -> {code: "400"}; anything else -> {code: "500"}
          fetchNotificationsListV2: function () {
            return this.callHeloV2("GET", "/customers/me/notifications").then(
              function (res) {
                var data = res.data || {};
                var result = { code: "200", badge: data.unread_badge };
                if (angular.isArray(data.items) && data.items.length > 0) {
                  result.notificaciones = data.items.map(function (n) {
                    return {
                      tipo: String(n.type),
                      estado: String(n.status),
                      fecha: n.created_at,
                      descripcion: n.description,
                    };
                  });
                }
                return result;
              },
              function (response) {
                return {
                  code: alertStatusToCode(
                    response,
                    { 400: "400", 401: "400", 403: "400" },
                    "500",
                  ),
                };
              },
            );
          },

          // Role of the logged user (cliente/consulta_rol.php). Go route
          // GET /users/me/role in the v2 shape (NOT ?format=legacy: its rol is
          // an int with omitempty, so role 0 would be dropped and a number
          // would fail guardUser's rol === "0" and log the user out). rol is
          // always a string; cliente is present only when the user has a
          // customer.
          //   2xx            -> {code: "200", rol, cliente?, email}
          //   anything else (400/401/403, network error, 5xx, 404, or no
          //   Cognito token)
          //                  -> falls back to cliente/consulta_rol.php, which
          //                     stays live, and returns its body untouched.
          //                     400/401/403 are not definitive: a Firebase-token
          //                     session gets 401 on this Cognito-only route and
          //                     the Go 400 can be transient, so only the PHP
          //                     answer may end up logging the user out.
          fetchRoleV2: function () {
            var self = this;

            function legacyRole() {
              return self.post_header(
                "cliente/consulta_rol.php",
                { id_usuario: $localStorage.id_usuario },
                SHAREServices.hash_decode_token($localStorage.token),
                true,
              );
            }

            return self.fetchHeloV2IdToken(false).then(
              function () {
                return self.callHeloV2("GET", "/users/me/role").then(
                  function (res) {
                    var data = res.data || {};
                    var result = {
                      code: "200",
                      rol: String(data.role),
                      email: data.email,
                    };
                    if (data.customer_id) {
                      result.cliente = String(data.customer_id);
                    }
                    return result;
                  },
                  function () {
                    return legacyRole();
                  },
                );
              },
              function () {
                return legacyRole();
              },
            );
          },

          fetchZonePlansV2: function (zoneId, retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/zones/" + zoneId + "/plans",
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchZonePlansV2(zoneId, false);
                  }
                  // El Lambda devuelve un array plano (no { plans: [...] }).
                  var v2Plans = Array.isArray(response.data)
                    ? response.data
                    : [];
                  return { code: "200", planos: v2Plans };
                });
              })
              .catch(function (error) {
                return { code: "300", planos: [] };
              });
          },

          fetchDevicesByZoneV2: function (zoneId, retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/devices/zone/" + zoneId,
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchDevicesByZoneV2(zoneId, false);
                  }
                  if (angular.isArray(response.data)) {
                    return response.data;
                  }
                  return $q.reject(response);
                });
              })
              .catch(function (response) {
                if (
                  response &&
                  response.status === 401 &&
                  retryOnUnauthorized
                ) {
                  self.clearHeloV2IdToken();
                  return self.fetchDevicesByZoneV2(zoneId, false);
                }
                return $q.reject(response);
              });
          },

          // Maps one alert of the Go contract (internal/alerts/types.AlertResponse)
          // to the legacy consulta_alertas.php shape. Pure and this-free (it can be
          // passed to Array.prototype.map). Ids, tipo and the numeric columns MUST be
          // strings: alertsCtrl compares them with === against string literals.
          // null stays null (min/max/email/... are tested with === null); "" stays "".
          normalizeAlertToLegacy: function (a) {
            function s(v) {
              return v === null || v === undefined ? null : String(v);
            }
            return {
              id: String(a.id),
              nombre: a.nombre,
              dispositivos: String(a.dispositivos),
              tipo: String(a.tipo),
              min: s(a.min),
              max: s(a.max),
              t_espera: String(a.t_espera),
              t_repeticion: String(a.t_repeticion),
              correos: a.correos,
              estado: String(a.estado),
              dias: a.dias,
              h_ini: s(a.h_ini),
              h_fin: s(a.h_fin),
              offset: String(a.offset),
              email: s(a.email),
              grupo: s(a.grupo),
              control_en_off: s(a.control_en_off),
              comparacion: s(a.comparacion),
              feriado: s(a.feriado),
              ids_feriados: s(a.ids_feriados),
              control: a.control
                ? {
                    id: String(a.control.id),
                    id_dispositivo: String(a.control.id_dispositivo),
                    set_point: String(a.control.set_point),
                    tipo: s(a.control.tipo),
                  }
                : null,
              comparador: a.comparador
                ? {
                    id: String(a.comparador.id),
                    id_dispositivo: String(a.comparador.id_dispositivo),
                  }
                : null,
              notificacion: !!a.notificacion,
              activa: !!a.activa,
              fecha_notificacion: s(a.fecha_notificacion),
              offset_temp: s(a.offset_temp),
            };
          },

          // Builds the legacy {code, alertas} envelope from the Go array. An empty
          // array yields {code:'200'} with NO alertas key (legacy "no alerts" shape).
          alertsResponseToLegacy: function (arr) {
            if (!arr || arr.length === 0) {
              return { code: "200" };
            }
            return {
              code: "200",
              alertas: arr.map(this.normalizeAlertToLegacy),
            };
          },

          // Maps a failed request to the legacy envelope: 400/401/403 -> '400',
          // anything else (5xx, network, malformed body) -> '500'.
          alertsErrorToLegacy: function (resp) {
            var st = resp && resp.status;
            if (st === 400 || st === 401 || st === 403) {
              return { code: "400" };
            }
            return { code: "500" };
          },

          // GET /devices/{deviceId}/consumption?period=day|month|year&date=YYYY-MM-DD
          // (consumption chart of consumo_v2). Resolves with the raw Go body
          // {period, date, partial, estimated, total_kwh, points}; rejects on any
          // non-2xx status or a body without points (never treated as data), with a
          // single retry on 401. There is no PHP fallback.
          fetchDeviceConsumptionV2: function (deviceId, period, date, retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/devices/" + deviceId + "/consumption",
                  params: { period: period, date: date },
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchDeviceConsumptionV2(deviceId, period, date, false);
                  }
                  if (response.data && angular.isArray(response.data.points)) {
                    return response.data;
                  }
                  return $q.reject(response);
                });
              })
              .catch(function (response) {
                if (response && response.status === 401 && retryOnUnauthorized) {
                  self.clearHeloV2IdToken();
                  return self.fetchDeviceConsumptionV2(deviceId, period, date, false);
                }
                return $q.reject(response);
              });
          },

          // GET /alerts/zone/{zoneId}; resolves with the raw Go array.
          fetchZoneAlertsV3: function (zoneId, retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/alerts/zone/" + zoneId,
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchZoneAlertsV3(zoneId, false);
                  }
                  if (angular.isArray(response.data)) {
                    return response.data;
                  }
                  return $q.reject(response);
                });
              })
              .catch(function (response) {
                if (
                  response &&
                  response.status === 401 &&
                  retryOnUnauthorized
                ) {
                  self.clearHeloV2IdToken();
                  return self.fetchZoneAlertsV3(zoneId, false);
                }
                return $q.reject(response);
              });
          },

          // Zone alerts in the legacy {code, alertas} shape. Never rejects and has
          // no PHP fallback: failures map to {code:'400'|'500'}.
          fetchZoneAlerts: function (zoneId) {
            var self = this;
            return self.fetchZoneAlertsV3(zoneId).then(
              function (arr) {
                return self.alertsResponseToLegacy(arr);
              },
              function (err) {
                return self.alertsErrorToLegacy(err);
              }
            );
          },

          // Mapea un dispositivo del contrato Go (internal/zones/types.DeviceResponse)
          // al formato legacy consumido por el resto del frontend. "tipo" DEBE quedar
          // como string: AutoServices.getControlByID compara tipo con === contra
          // literales string ('0', '1', '2'...).
          normalizeDeviceV2ToLegacy: function (v2Device) {
            return {
              id: v2Device.id,
              id_dispositivo: v2Device.id,
              nombre: v2Device.name,
              tipo: String(v2Device.type),
              id_zona: v2Device.zone_id,
              ultima_conexion: v2Device.last_connection,
              ultimo_estado: v2Device.last_state,
              online: v2Device.online,
              control: v2Device.control,
              potencia: v2Device.power,
              relay: v2Device.relay,
              offset: v2Device.offset,
            };
          },

          // Dispositivos de una zona: una sola llamada al Lambda Go
          // (GET /devices/zone/{zoneId}); si falla, cae a la ruta PHP equivalente
          // (mismo alcance por zona, mismo formato de respuesta {code, dispositivos}).
          fetchDevicesByZone: function (zoneId) {
            var self = this;

            return self
              .fetchDevicesByZoneV2(zoneId)
              .then(function (v2Data) {
                return {
                  code: "200",
                  dispositivos: v2Data.map(self.normalizeDeviceV2ToLegacy),
                };
              })
              .catch(function () {
                var fields = {
                  id_usuario: $localStorage.id_usuario,
                  id_zona: zoneId,
                };
                return self.post_header(
                  "cliente/consulta_dispositivosxzona.php",
                  fields,
                  SHAREServices.hash_decode_token($localStorage.token),
                  true,
                );
              });
          },

          // Adapts a Go device (internal/zones/types.DeviceResponse) to the legacy
          // dashboard shape that consulta_estado_dispositivoxzona.php used to return,
          // so zoneTable and sidebar-zones only change their online/h_server lines.
          // Pure and `this`-free: it is passed straight to Array.prototype.map.
          // - ids and tipo are strings: sidebar-zones compares them with ===.
          // - estado is null when the server flags no_data (drives the "sin datos"
          //   filter); grouping parents (23/26) are no_data=false by design.
          // - relay/open come as strings ("" when absent); "" maps to null so the
          //   templates fall back to estado, and "0" is kept (shows "Apagado").
          // - 23/26 always get an agrupados array, like PHP, even when empty.
          normalizeDeviceV2ToDashboard: function (v2Device) {
            var tipo = String(v2Device.type);
            var hasFecha = !!v2Device.last_connection;
            var agrupados = null;
            if (angular.isArray(v2Device.grouped)) {
              agrupados = v2Device.grouped.map(function (g) {
                return { id: String(g.id), direccion: String(g.direction) };
              });
            } else if (tipo === "23" || tipo === "26") {
              agrupados = [];
            }
            return {
              fecha: hasFecha ? v2Device.last_connection : null,
              id: String(v2Device.id),
              id_aire: String(v2Device.air_id),
              estado: v2Device.no_data ? null : v2Device.last_state,
              tipo: tipo,
              id_zona: String(v2Device.zone_id),
              control: String(v2Device.control),
              potencia: String(v2Device.power),
              nombre: v2Device.name,
              online: v2Device.online ? 1 : 0,
              connection_gap: hasFecha ? v2Device.connection_gap : null,
              relay: v2Device.relay ? v2Device.relay : null,
              open: v2Device.open ? v2Device.open : null,
              agrupados: agrupados,
            };
          },

          // Dashboard device state from the Go route (GET /devices/zone/{zoneId}),
          // resolved in the legacy {code, dispositivos} envelope. No PHP fallback:
          // a fallback would hide Go errors and bring back the h_server clock drift.
          //   200 with devices -> {code: "200", dispositivos}
          //   200 with []      -> {code: "300"} (PHP did the same for an empty zone)
          //   400/403/404      -> {code: "300"} (e.g. "zone does not belong to user")
          //   anything else    -> {code: "500"} (401 is retried once by
          //                       fetchDevicesByZoneV2 before it gets here)
          fetchZoneDeviceStatus: function (zoneId) {
            var self = this;

            return self
              .fetchDevicesByZoneV2(zoneId)
              .then(function (v2Data) {
                if (v2Data.length === 0) {
                  return { code: "300" };
                }
                return {
                  code: "200",
                  dispositivos: v2Data.map(self.normalizeDeviceV2ToDashboard),
                };
              })
              .catch(function (response) {
                var status = response && response.status;
                if (status === 400 || status === 403 || status === 404) {
                  return { code: "300" };
                }
                return { code: "500" };
              });
          },

          fetchSchedulesByZoneV2: function (zoneId, retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/schedules/zone/" + zoneId,
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchSchedulesByZoneV2(zoneId, false);
                  }
                  // El Lambda responde 200 con {message: 'schedule not found'}
                  // (no un array) cuando la zona no tiene programaciones.
                  if (angular.isArray(response.data)) {
                    return response.data;
                  }
                  return [];
                });
              })
              .catch(function (response) {
                if (
                  response &&
                  response.status === 401 &&
                  retryOnUnauthorized
                ) {
                  self.clearHeloV2IdToken();
                  return self.fetchSchedulesByZoneV2(zoneId, false);
                }
                return $q.reject(response);
              });
          },

          // Mapea una programación del contrato Go
          // (internal/zones/types.ScheduleResponse) al formato legacy consumido por
          // schedulesUtil. "dia" debe quedar SOLO con la fecha: Go la devuelve como
          // "YYYY-MM-DD HH:MM:SS" completo, y formatSchedule concatena
          // dia + ' ' + hini para parsear un único timestamp UTC — pasar la cadena
          // completa duplicaría la hora y rompería el parseo. "frecuencia" y "enable"
          // deben quedar como string: schedulesUtil y schedulesListCtrl los comparan
          // con === contra literales string ('1', etc).
          normalizeScheduleV2ToLegacy: function (v2Schedule) {
            var dateOnly = (v2Schedule.date || "").split(" ")[0];
            return {
              id: v2Schedule.id,
              id_dispositivo: v2Schedule.device_id,
              dia: dateOnly,
              hini: v2Schedule.start_time,
              hfin: v2Schedule.end_time,
              frecuencia: String(v2Schedule.frequency),
              comando: v2Schedule.command,
              comando_post: v2Schedule.command_post,
              enable: String(v2Schedule.enabled),
              fecha_actualizacion: v2Schedule.updated_at,
              usuario: v2Schedule.user || null,
              // El DTO de Go ahora expone group/holiday (ver
              // openspec/changes/fix-schedules-grouping-fields en api-microservicios-helo).
              grupo: v2Schedule.group || null,
              feriado: String(
                v2Schedule.holiday != null ? v2Schedule.holiday : 0,
              ),
            };
          },

          // Programaciones de una zona: una sola llamada al Lambda Go
          // (GET /schedules/zone/{zoneId}) — sin fallback a PHP. No existe un
          // endpoint PHP equivalente por zona: lista_programacion.php consulta la
          // tabla "programacion" (no "programacion_aires") y su respuesta no trae
          // id_dispositivo, así que no se puede filtrar por dispositivo; el único
          // equivalente real (lista_programacion_aires.php) es por dispositivo, y
          // usarlo como fallback reintroduciría una llamada PHP por dispositivo.
          fetchSchedulesByZone: function (zoneId) {
            var self = this;

            return self
              .fetchSchedulesByZoneV2(zoneId)
              .then(function (v2Data) {
                return {
                  code: "200",
                  programaciones: v2Data.map(self.normalizeScheduleV2ToLegacy),
                };
              })
              .catch(function () {
                return { code: "300", programaciones: [] };
              });
          },

          fetchPlanPinsV2: function (planId, retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/plans/" + planId + "/pins",
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchPlanPinsV2(planId, false);
                  }
                  // El Lambda devuelve un array plano (no { pins: [...] }).
                  var v2Pins = Array.isArray(response.data)
                    ? response.data
                    : [];
                  return { code: "200", pines: v2Pins };
                });
              })
              .catch(function (error) {
                return { code: "300", pines: [] };
              });
          },

          fetchDeviceLimitV2: function (deviceId, retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/devices/" + deviceId + "/limit",
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchDeviceLimitV2(deviceId, false);
                  }
                  return { code: "200", limite: response.data.limit || "" };
                });
              })
              .catch(function (error) {
                return { code: "300", limite: "" };
              });
          },

          fetchDeviceConfigV2: function (deviceId, retryOnUnauthorized) {
            var self = this;
            if (retryOnUnauthorized === undefined) retryOnUnauthorized = true;
            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                return $http({
                  method: "GET",
                  url: url_helo_v2 + "/devices/" + deviceId + "/config",
                  headers: { Authorization: idToken },
                }).then(function (response) {
                  if (response.status === 401 && retryOnUnauthorized) {
                    self.clearHeloV2IdToken();
                    return self.fetchDeviceConfigV2(deviceId, false);
                  }
                  // Normalize to legacy caracteristicas format: array of {id, valor}
                  var caracteristicas = [];
                  if (response.data.characteristics) {
                    caracteristicas = response.data.characteristics.map(
                      function (c) {
                        return { id: String(c.id), valor: String(c.valor) };
                      },
                    );
                  }
                  var aire;
                  if (response.data.aire) {
                    aire = {
                      id: response.data.aire.id,
                      referencia: response.data.aire.referencia,
                    };
                  }
                  return {
                    code: "200",
                    caracteristicas: caracteristicas,
                    aire: aire,
                  };
                });
              })
              .catch(function (error) {
                return { code: "300", caracteristicas: [] };
              });
          },

          // Generic REST caller (Cognito bearer + 401 retry-once). Resolves
          // {status, data} on any 2xx response (including 204 with no body);
          // rejects {status, data} otherwise. Callers decide success/failure
          // from `status`, never a legacy body `code`. Thin per-endpoint
          // methods below build on this instead of repeating the retry/token
          // dance.
          callHeloV2: function (method, path, body, retryOnUnauthorized) {
            var self = this;

            if (retryOnUnauthorized === undefined) {
              retryOnUnauthorized = true;
            }

            return self
              .fetchHeloV2IdToken(false)
              .then(function (idToken) {
                var request = {
                  method: method,
                  url: url_helo_v2 + path,
                  headers: { Authorization: idToken },
                };
                if (body !== undefined) {
                  request.data = angular.toJson(body);
                  request.transformRequest = angular.identity;
                  request.headers["Content-Type"] = "application/json";
                }
                return $http(request).then(function (response) {
                  // $http only reaches this handler for 2xx statuses — any
                  // status (200/201/204/...) is success.
                  return { status: response.status, data: response.data };
                });
              })
              .catch(function (response) {
                if (
                  response &&
                  response.status === 401 &&
                  retryOnUnauthorized
                ) {
                  self.clearHeloV2IdToken();
                  return self.callHeloV2(method, path, body, false);
                }
                return $q.reject({
                  status: response ? response.status : undefined,
                  data: response ? response.data : undefined,
                });
              });
          },

          // migrated from cliente/edita_proyecto.php. POST /projects (201
          // {id}) creates; PUT /projects/{projectID} (204) updates. Identity
          // for the update comes only from the path — an existing project.id
          // selects PUT and the id inside the body is otherwise ignored by
          // the server. Sends "proyecto" as a nested JSON object (the Go
          // lambda unmarshals it directly), unlike the legacy PHP call which
          // sent it JSON.stringify'd.
          saveProjectV2: function (project, retryOnUnauthorized) {
            var self = this;
            if (project && project.id) {
              return self.callHeloV2(
                "PUT",
                "/projects/" + project.id,
                { proyecto: project },
                retryOnUnauthorized,
              );
            }
            return self.callHeloV2(
              "POST",
              "/projects",
              { proyecto: project },
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/elimina_proyecto.php. DELETE
          // /projects/{projectID} (204).
          deleteProjectV2: function (idProyecto, retryOnUnauthorized) {
            var self = this;
            return self.callHeloV2(
              "DELETE",
              "/projects/" + idProyecto,
              undefined,
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/consulta_zonasxproyecto.php. GET
          // /projects/{projectID}/zones (200 {zonas:[]} — an empty list is a
          // valid result, not an error; 404 means not owned).
          fetchProjectZonesV2: function (idProyecto, retryOnUnauthorized) {
            var self = this;
            return self
              .callHeloV2(
                "GET",
                "/projects/" + idProyecto + "/zones",
                undefined,
                retryOnUnauthorized,
              )
              .then(function (res) {
                var zonas = ((res.data && res.data.zonas) || []).map(
                  function (z) {
                    return {
                      // String: see normalizeZonesV2ToLegacy comment above —
                      // keeps z.id === z_p.id comparisons working in
                      // project.ctrl.js / new-project.ctrl.js against zone
                      // ids from fetchClientZones, which are also strings.
                      id: String(z.id),
                      nombre: z.nombre,
                      hub: z.hub,
                      id_pais: z.id_pais,
                      rol: z.rol,
                    };
                  },
                );
                return { zonas: zonas };
              });
          },

          // migrated from cliente/asociar_usuarioazona.php. POST
          // /zones/users (bulk, always 200 for a structurally valid request;
          // per-item outcome is in data.results[].status). zoneIds accepts a
          // single id or an array (mirrors id_zona/id_zonas).
          addZoneUserV2: function (email, rol, zoneIds, retryOnUnauthorized) {
            var self = this;
            var body = { email: email, rol: rol };
            if (angular.isArray(zoneIds)) {
              body.id_zonas = zoneIds;
            } else {
              body.id_zona = zoneIds;
            }
            return self.callHeloV2(
              "POST",
              "/zones/users",
              body,
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/elimina_usuario_zona.php. POST
          // /zones/users/revoke (bulk, same results[] shape as addZoneUserV2).
          // zoneIds accepts a single id or an array.
          revokeZoneUserV2: function (email, zoneIds, retryOnUnauthorized) {
            var self = this;
            var body = { email: email };
            if (angular.isArray(zoneIds)) {
              body.id_zonas = zoneIds;
            } else {
              body.id_zona = zoneIds;
            }
            return self.callHeloV2(
              "POST",
              "/zones/users/revoke",
              body,
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/elimina_planos.php. POST /plans/delete
          // (bulk, same results[] shape as addZoneUserV2/revokeZoneUserV2).
          // planIds accepts a single id or an array of plan ids.
          deletePlanV2: function (planIds, retryOnUnauthorized) {
            var self = this;
            var planos = (angular.isArray(planIds) ? planIds : [planIds]).map(
              function (id) {
                return { id: id };
              },
            );
            return self.callHeloV2(
              "POST",
              "/plans/delete",
              { planos: planos },
              retryOnUnauthorized,
            );
          },

          // Bulk share: N zones x M emails in one POST /zones/users. Resolves
          // the raw {status, data} of callHeloV2; per-pair outcomes are in
          // data.results[] ({id_zona, email, status, outcome?, access?,
          // message?}).
          addZoneUsersBulkV2: function (emails, rol, zoneIds, retryOnUnauthorized) {
            return this.callHeloV2(
              "POST",
              "/zones/users",
              { emails: emails, rol: rol, id_zonas: zoneIds },
              retryOnUnauthorized,
            );
          },

          // Everybody with access to an owned zone (entity users plus shares),
          // from GET /zones/{id}/access, resolved in a legacy-like shape.
          //   200 with items   -> {code: "200", users}  (rol as string)
          //   200 with []      -> {code: "300", users: []}
          //   403/404          -> {code: "300", users: []} (not the owner)
          //   anything else    -> {code: "500", users: []}
          fetchZoneAccessV2: function (zoneId, retryOnUnauthorized) {
            return this.callHeloV2(
              "GET",
              "/zones/" + zoneId + "/access",
              undefined,
              retryOnUnauthorized,
            )
              .then(function (res) {
                var items = (res.data && res.data.items) || [];
                if (items.length === 0) {
                  return { code: "300", users: [] };
                }
                return {
                  code: "200",
                  users: items.map(function (i) {
                    return {
                      email: i.email,
                      name: i.name,
                      rol: String(i.role),
                      estado: i.estado,
                      source: i.source,
                      revocable: i.revocable,
                    };
                  }),
                };
              })
              .catch(function (response) {
                var status = response && response.status;
                if (status === 403 || status === 404) {
                  return { code: "300", users: [] };
                }
                return { code: "500", users: [] };
              });
          },

          // Transactional bulk creation of zones with their devices, from
          // POST /zones/bulk (replaces N genera_zona.php + M edita_dispositivo.php).
          //   201            -> {code: "200", zonas: [{id, name, devices_created}]}
          //   409            -> {code: "409", conflicts: [existing names]}
          //   400            -> {code: "300"}
          //   anything else  -> {code: "500"}
          createZonesBulkV2: function (zones, retryOnUnauthorized) {
            return this.callHeloV2(
              "POST",
              "/zones/bulk",
              { zones: zones },
              retryOnUnauthorized,
            )
              .then(function (res) {
                return { code: "200", zonas: (res.data && res.data.zones) || [] };
              })
              .catch(function (response) {
                var status = response && response.status;
                if (status === 409) {
                  var data = response.data || {};
                  return { code: "409", conflicts: data.conflicts || [] };
                }
                if (status === 400) {
                  var message = response.data && response.data.message;
                  return message ? { code: "300", message: message } : { code: "300" };
                }
                return { code: "500" };
              });
          },

          // Device search limited to the caller's zones, from
          // GET /devices/search?q=. Resolved in the legacy {code, dispositivos}
          // shape of buscar_dispositivo.php plus `control` (can_control).
          //   200 with items -> {code: "200", dispositivos, truncated}
          //   200 with []    -> {code: "300"}
          //   400            -> {code: "300"} (query too short or too long)
          //   403            -> {code: "400"} (role not allowed to search)
          //   anything else  -> {code: "500"}
          searchDevicesV2: function (text, retryOnUnauthorized) {
            return this.callHeloV2(
              "GET",
              "/devices/search?q=" + encodeURIComponent(text),
              undefined,
              retryOnUnauthorized,
            )
              .then(function (res) {
                var items = (res.data && res.data.items) || [];
                if (items.length === 0) {
                  return { code: "300" };
                }
                return {
                  code: "200",
                  truncated: !!res.data.truncated,
                  dispositivos: items.map(function (d) {
                    return {
                      id_dispositivo: String(d.id),
                      nombre: d.name,
                      tipo_dispositivo: String(d.type),
                      id_zona: String(d.zone_id),
                      nombre_zona: d.zone_name,
                      nombre_cliente: d.customer_name,
                      control: !!d.can_control,
                    };
                  }),
                };
              })
              .catch(function (response) {
                var status = response && response.status;
                if (status === 400) {
                  return { code: "300" };
                }
                if (status === 403) {
                  return { code: "400" };
                }
                return { code: "500" };
              });
          },

          // migrated from cliente/asociar_usuarioaproyecto.php (edicion=1).
          // POST /projects/users (bulk, always 200 for a structurally valid
          // request; per-item outcome is in data.results[].status, each item
          // {id_proyecto, status, message?}). projectIds accepts a single id
          // or an array.
          addProjectUserV2: function (email, projectIds, retryOnUnauthorized) {
            var self = this;
            var body = { email: email };
            if (angular.isArray(projectIds)) {
              body.id_proyectos = projectIds;
            } else {
              body.id_proyecto = projectIds;
            }
            return self.callHeloV2(
              "POST",
              "/projects/users",
              body,
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/asociar_usuarioaproyecto.php (edicion=0).
          // POST /projects/users/revoke (same body and results[] shape as
          // addProjectUserV2).
          revokeProjectUserV2: function (email, projectIds, retryOnUnauthorized) {
            var self = this;
            var body = { email: email };
            if (angular.isArray(projectIds)) {
              body.id_proyectos = projectIds;
            } else {
              body.id_proyecto = projectIds;
            }
            return self.callHeloV2(
              "POST",
              "/projects/users/revoke",
              body,
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/edita_limite.php. PUT
          // /devices/{deviceID}/limit (204; 400 negative/invalid limit, 404
          // when the device is not accessible).
          setDeviceLimitV2: function (deviceId, limit, retryOnUnauthorized) {
            var self = this;
            return self.callHeloV2(
              "PUT",
              "/devices/" + deviceId + "/limit",
              { limit: limit },
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/edita_pines.php. POST
          // /plans/{planID}/pins (201 {id}) creates when pin.id is falsy or
          // '0'; PUT /plans/{planID}/pins/{pinID} (204) otherwise. Ids come
          // only from the path, so the body omits id/id_plano. An array
          // pin.variables is sent as a comma-joined string (column format);
          // the pin object itself is never mutated.
          savePinV2: function (planId, pin, retryOnUnauthorized) {
            var self = this;
            var body = {
              nombre: pin.nombre,
              id_dispositivo: pin.id_dispositivo,
              x: pin.x,
              y: pin.y,
              variables: angular.isArray(pin.variables)
                ? pin.variables.join(",")
                : pin.variables || "",
            };
            var isNew = !pin.id || String(pin.id) === "0";
            var path = "/plans/" + planId + "/pins";
            return self.callHeloV2(
              isNew ? "POST" : "PUT",
              isNew ? path : path + "/" + pin.id,
              body,
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/elimina_pines.php. POST /pins/delete
          // (bulk, always 200; per-item outcome in data.results[], each item
          // {id_pin, status, message?}). pines accepts pin objects ({id}) or
          // plain ids, single or array.
          deletePinsV2: function (pines, retryOnUnauthorized) {
            var self = this;
            var list = angular.isArray(pines) ? pines : [pines];
            return self.callHeloV2(
              "POST",
              "/pins/delete",
              {
                pines: list.map(function (p) {
                  return { id: angular.isObject(p) ? p.id : p };
                }),
              },
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/asociar_zonaaproyecto.php (edicion=1). POST
          // /projects/{projectID}/zones (bulk, always 200 for a structurally
          // valid request; per-item outcome is in data.results[].status, each
          // item {id_zona, status, message?}). The project id comes only from
          // the path. zoneIds accepts a single id or an array; either way it
          // is sent as id_zonas.
          addProjectZonesV2: function (projectId, zoneIds, retryOnUnauthorized) {
            var self = this;
            return self.callHeloV2(
              "POST",
              "/projects/" + projectId + "/zones",
              { id_zonas: angular.isArray(zoneIds) ? zoneIds : [zoneIds] },
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/asociar_zonaaproyecto.php (edicion=0). POST
          // /projects/{projectID}/zones/revoke (same body and results[] shape
          // as addProjectZonesV2; an item with no active link reports 404).
          removeProjectZonesV2: function (projectId, zoneIds, retryOnUnauthorized) {
            var self = this;
            return self.callHeloV2(
              "POST",
              "/projects/" + projectId + "/zones/revoke",
              { id_zonas: angular.isArray(zoneIds) ? zoneIds : [zoneIds] },
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/edita_planos.php. POST /zones/{zoneID}/plans
          // (201 {id}) creates when plano.id is falsy or '0'; PUT
          // /plans/{planID} (204, no body) otherwise. Ids come only from the
          // path, so the body carries just {nombre, url_img}; nombre is
          // optional server-side and defaults to ''. zoneId is only used on
          // create.
          savePlanV2: function (plano, zoneId, retryOnUnauthorized) {
            var self = this;
            var body = {
              nombre: plano.nombre || "",
              url_img: plano.url_img,
            };
            var isNew = !plano.id || String(plano.id) === "0";
            return self.callHeloV2(
              isNew ? "POST" : "PUT",
              isNew ? "/zones/" + zoneId + "/plans" : "/plans/" + plano.id,
              body,
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/aprueba_zonas_usuario.php. POST
          // /users/me/zones/approve (204, idempotent — also 204 when nothing
          // was pending). idZona is optional: omit/null approves all pending
          // zones for the authenticated user.
          approveZoneUsersV2: function (idZona, retryOnUnauthorized) {
            var self = this;
            return self.callHeloV2(
              "POST",
              "/users/me/zones/approve",
              { id_zona: idZona || null },
              retryOnUnauthorized,
            );
          },

          // migrated from the legacy PHP bulk device move. POST
          // /zones/{zoneID}/devices/move (200 {moved, unchanged, rejected}).
          // zoneId is the DESTINATION zone; ids are device ids (numbers or
          // numeric strings). All or nothing: 409 with
          // {code: 10409, rejected: [{id, reason}]} when any device is
          // rejected (reason: not_found | hub_device | group_split) or
          // {error: "destination_has_hub"}; 403 when the role (6/7 only) or
          // the destination zone is not allowed.
          moveZoneDevicesV2: function (zoneId, ids, retryOnUnauthorized) {
            var self = this;
            return self.callHeloV2(
              "POST",
              "/zones/" + zoneId + "/devices/move",
              { devices: ids },
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/reinicia_cambio_aire.php. PUT
          // /devices/{deviceID}/aire (204; also 204 when the update affects 0
          // rows — a successful no-op — and 404 when the device is not
          // accessible).
          resetDeviceAireV2: function (deviceId, idAire, retryOnUnauthorized) {
            var self = this;
            return self.callHeloV2(
              "PUT",
              "/devices/" + deviceId + "/aire",
              { id_aire: idAire },
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/edita_configuracion.php. PUT
          // /devices/{deviceID}/config (204/404 mapping same as aire).
          // payload is
          // { caracteristicas: [{id, valor}], tipo: <int>?, agrupados: [{id}]? } —
          // caracteristicas/agrupados must be real arrays (not JSON.stringify'd
          // strings like the legacy PHP form post used), and tipo must be a
          // number, not the stringified device type used elsewhere in the UI.
          updateDeviceConfigV2: function (
            deviceId,
            payload,
            retryOnUnauthorized,
          ) {
            var self = this;
            return self.callHeloV2(
              "PUT",
              "/devices/" + deviceId + "/config",
              payload,
              retryOnUnauthorized,
            );
          },

          // migrated from cliente/consulta_mantenimientos.php. GET
          // /devices/{deviceID}/maintenance. Resolves the raw array (an empty
          // history is [] — a success, not an error); rejects {status, data}
          // on 403/404/5xx. `chequeos` is a native array and the nullable
          // fecha_proximo/fecha_actualizacion come through as null.
          fetchDeviceMaintenancesV2: function (deviceId, retryOnUnauthorized) {
            var self = this;
            return self
              .callHeloV2(
                "GET",
                "/devices/" + deviceId + "/maintenance",
                undefined,
                retryOnUnauthorized,
              )
              .then(function (res) {
                return angular.isArray(res.data) ? res.data : [];
              });
          },

          // migrated from cliente/consulta_dispositivos_mant.php. GET
          // /zones/{zoneID}/maintenance-devices. Resolves the raw body
          // {devices: [...]} (own and shared devices together, told apart by
          // `shared`); use adaptZoneMaintenanceDevices to rebuild the legacy
          // dispositivos / dispositivos_externos lists.
          fetchZoneMaintenanceDevicesV2: function (zoneId, retryOnUnauthorized) {
            var self = this;
            return self
              .callHeloV2(
                "GET",
                "/zones/" + zoneId + "/maintenance-devices",
                undefined,
                retryOnUnauthorized,
              )
              .then(function (res) {
                return res.data;
              });
          },

          // migrated from cliente/consulta_tipo_dispositivo_mant.php. GET
          // /devices/{deviceID}/maintenance/type. Resolves {type: "<tipo>"}
          // where type is a STRING (relatedProductCtrl switches on it with
          // strict equality); rejects on 404 (no access or no active profile).
          fetchDeviceMaintenanceTypeV2: function (deviceId, retryOnUnauthorized) {
            var self = this;
            return self
              .callHeloV2(
                "GET",
                "/devices/" + deviceId + "/maintenance/type",
                undefined,
                retryOnUnauthorized,
              )
              .then(function (res) {
                return res.data;
              });
          },

          // Rebuilds the legacy consulta_dispositivos_mant.php shape from the
          // Go response: shared=false -> dispositivos, shared=true ->
          // dispositivos_externos. Pure and this-free. "tipo" and the
          // characteristic id/valor MUST be strings: the apparatus-profile
          // screens compare them with === against string literals ('2', '31').
          // null caracteristicas stay null (the legacy "no characteristics"
          // marker). The input devices are not mutated.
          adaptZoneMaintenanceDevices: function (data) {
            var devices = data && angular.isArray(data.devices) ? data.devices : [];
            var result = { dispositivos: [], dispositivos_externos: [] };
            devices.forEach(function (d) {
              var item = {};
              Object.keys(d).forEach(function (k) {
                item[k] = d[k];
              });
              if (d.tipo !== null && d.tipo !== undefined) {
                item.tipo = String(d.tipo);
              }
              if (angular.isArray(d.caracteristicas)) {
                item.caracteristicas = d.caracteristicas.map(function (c) {
                  return { id: String(c.id), valor: String(c.valor) };
                });
              }
              if (d.shared) {
                result.dispositivos_externos.push(item);
              } else {
                result.dispositivos.push(item);
              }
            });
            return result;
          },
        };
      },
    );
})();

(function () {
  "use strict";
  angular
    .module("BlurAdmin")
    .factory(
      "SHAREServices",
      function (
        $filter,
        $localStorage,
        $window,
        $rootScope,
        $cookies,
        ngDialog,
      ) {
        return {
          mesDatepicker: "",
          diaDatepicker: "",
          diaZonaDatepicker: "",
          donaInfo: [],
          desconexionxzonaxdia: [],
          potencia_Wh: "",
          flagDesconexiones: true,
          flagAhorro: true,
          flagComp_aire: true,
          flagUso_aire: true,
          flagConsumo_aire: true,
          fromconsumptionModule: false,
          flagConsumo_zona: true,
          uso_aire: [],
          consumo_aire: [],
          consumo_zona: [],
          ahorroxzonaxmes: [],
          dispositivo_selected: "",
          zona: {},
          zonas: null,
          zona_alertas: null,
          novedad_alertas: true,
          is_first_alertas: true,
          zonas_propias: [],
          zonas_compartidas: [],
          monitoringMode: null,
          hiddenZones: "0",
          comportamiento_aire: [],
          user: {
            id: "",
            token: "",
            rol: "",
            tipo: "",
          },
          control_zona: undefined,
          dateFilter: [
            {
              name: "Día",
              status: true,
              id: "day",
            },
            /*{
                    name: 'Semana',
                    status: false,
                    id: 'week'
                },*/
            {
              name: "Mes",
              status: false,
              id: "month",
            },
            /*{
                    name: 'Año',
                    status: false,
                    id: 'year'
                },*/
          ],
          maintenanceFilter: [
            {
              name: "Todo",
              status: true,
              id: "",
            },
            {
              name: "Rojo",
              status: false,
              id: "red",
            },
            {
              name: "Verde",
              status: false,
              id: "green",
            },
          ],
          format: {
            day: "yyyy-MM-dd",
            week: "yyyy-MM-dd",
            month: "yyyy-MM",
            year: "yyyy",
          },
          project: {},
          //settings_options: [],
          zone_selected_project: null,
          server_status: 0,
          cerrar_sesion: function () {
            delete $localStorage.id_cliente;
            delete $localStorage.nombre_cliente;
            delete $localStorage.login;
            delete $localStorage.rol;
            delete $localStorage.id_usuario;
            delete $localStorage.token;
            delete $localStorage.tipo;
            delete $localStorage.server_url;
            delete $localStorage.email;
            delete $localStorage.client;
            delete $localStorage.helo_v2_id_token;
            delete $localStorage.helo_v2_uid;
            delete $localStorage.cognito_refresh_token;
            delete $localStorage.marketer;
            this.zonas = null;
            this.control_zona = undefined;
            this.zona_alertas = null;
            this.user = {
              id: "",
              token: "",
              rol: "",
              tipo: "",
            };
            this.badge = 0;
            this.notifications = [];
            this.flagNotificaciones = true;
            $cookies.remove("userRol");
            $cookies.remove("monitoringMode");
            $cookies.remove("hiddenZones");
            $window.location.href = "#/sign_in";
            $rootScope.flag_loading = false;
          },
          devices: [],
          flag_editApparatus: false,
          apparatus: "",
          breadcrumbs: [],
          hash_encode: function (id) {
            var hash = "";
            for (var i = 0; i < 3; i++)
              hash += "" + Math.floor(Math.random() * Math.floor(10));
            hash += id.toString().length;
            hash += id.toString();
            for (var i = 0; i < 3; i++)
              hash += "" + Math.floor(Math.random() * Math.floor(10));
            hash = btoa(hash);
            return hash;
          },
          hash_decode: function (hash) {
            var hash_decoded = atob(hash);
            var id = "";
            for (var i = 4; i < 4 + Number(hash_decoded[3]); i++)
              id += "" + hash_decoded[i];
            return id;
          },
          hash_decode_token: function (hash) {
            if ($localStorage.token === undefined) {
              this.cerrar_sesion();
            } else {
              var hash_decoded = atob(hash);
              var id = "";
              for (var i = 5; i < 25; i++) id += "" + hash_decoded[i];
              return id;
            }
          },
          timeAgo: function (time, local, raw) {
            //time: Date to compare, local: Current date
            if (!time) return "nunca";

            if (!local) {
              local = Date.now();
            }

            if (angular.isDate(time)) {
              time = time.getTime();
            } else if (typeof time === "string") {
              time = new Date(time).getTime();
            }

            if (angular.isDate(local)) {
              local = local.getTime();
            } else if (typeof local === "string") {
              local = new Date(local).getTime();
            }

            if (typeof time !== "number" || typeof local !== "number") {
              return;
            }

            var offset = Math.abs((local - time) / 1000),
              span = [],
              MINUTE = 60,
              HOUR = 3600,
              DAY = 86400,
              WEEK = 604800,
              MONTH = 2629744,
              YEAR = 31556926,
              DECADE = 315569260;

            if (offset <= MINUTE)
              span = ["", raw ? "ahora" : "menos de un minuto"];
            else if (offset < MINUTE * 60)
              span = [Math.round(Math.abs(offset / MINUTE)), "minuto"];
            else if (offset < HOUR * 24)
              span = [Math.round(Math.abs(offset / HOUR)), "hora"];
            else if (offset < DAY * 7)
              span = [Math.round(Math.abs(offset / DAY)), "día"];
            else if (offset < WEEK * 52)
              span = [Math.round(Math.abs(offset / WEEK)), "semana"];
            else if (offset < YEAR * 10)
              span = [Math.round(Math.abs(offset / YEAR)), "año"];
            else if (offset < DECADE * 100)
              span = [Math.round(Math.abs(offset / DECADE)), "decada"];
            else span = ["", "Mucho tiempo"];

            span[1] += span[0] === 0 || span[0] > 1 ? "s" : "";
            span = span.join(" ");

            if (raw === true) {
              return span;
            }
            return time <= local ? "Hace " + span : "En " + span;
          },
          badge: 0,
          notifications: [],
          flagNotificaciones: true,
          enableSchedules: [
            {
              status: false,
              type: "user",
              id: 0,
            },
            {
              status: false,
              type: "zone",
              id: 1,
            },
          ],
          changeDate: new Date("2020-06-20 23:59:00"),
          dateToLocal: function (dia, ultimo_idx, idx, flag_h) {
            if (flag_h)
              return new Date(dia) < this.changeDate || idx == ultimo_idx
                ? $filter("date")(new Date(dia.replace(/-/g, "\/")), "HH:mm:ss")
                : $filter("date")(
                    new Date(dia.replace(" ", "T") + "Z"),
                    "HH:mm:ss",
                  );
            else
              return new Date(dia) < this.changeDate || idx == ultimo_idx
                ? new Date(dia.replace(/-/g, "\/"))
                : new Date(dia.replace(" ", "T") + "Z");
          },
          integracion: "",
          encode: function (input) {
            var keyStr =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            var output = "";
            var chr1,
              chr2,
              chr3 = "";
            var enc1,
              enc2,
              enc3,
              enc4 = "";
            var i = 0;

            do {
              chr1 = input.charCodeAt(i++);
              chr2 = input.charCodeAt(i++);
              chr3 = input.charCodeAt(i++);

              enc1 = chr1 >> 2;
              enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
              enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
              enc4 = chr3 & 63;

              if (isNaN(chr2)) {
                enc3 = enc4 = 64;
              } else if (isNaN(chr3)) {
                enc4 = 64;
              }

              output =
                output +
                keyStr.charAt(enc1) +
                keyStr.charAt(enc2) +
                keyStr.charAt(enc3) +
                keyStr.charAt(enc4);
              chr1 = chr2 = chr3 = "";
              enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);

            return output;
          },

          decode: function (input) {
            var keyStr =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            var output = "";
            var chr1,
              chr2,
              chr3 = "";
            var enc1,
              enc2,
              enc3,
              enc4 = "";
            var i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            var base64test = /[^A-Za-z0-9\+\/\=]/g;
            if (base64test.exec(input)) {
              window.alert(
                "There were invalid base64 characters in the input text.\n" +
                  "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                  "Expect errors in decoding.",
              );
            }
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

            do {
              enc1 = keyStr.indexOf(input.charAt(i++));
              enc2 = keyStr.indexOf(input.charAt(i++));
              enc3 = keyStr.indexOf(input.charAt(i++));
              enc4 = keyStr.indexOf(input.charAt(i++));

              chr1 = (enc1 << 2) | (enc2 >> 4);
              chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
              chr3 = ((enc3 & 3) << 6) | enc4;

              output = output + String.fromCharCode(chr1);

              if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
              }
              if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
              }

              chr1 = chr2 = chr3 = "";
              enc1 = enc2 = enc3 = enc4 = "";
            } while (i < input.length);

            return output;
          },

          cancelAirChange: function (ind) {
            ngDialog.open({
              template: "app/cliente/dashboard-cliente/templates/mensaje.html",
              className: "ngdialog-theme-plain",
              controller: [
                "$scope",
                function ($scope) {
                  // controller logic
                  $scope.titleModal = "Proceso Cancelado";
                  $scope.bodyModal =
                    ind === 0
                      ? "No nos hemos podido comunicar con el dispositivo, intenta de nuevo más tarde"
                      : "Has abandonado la página de configuración sin finalizar el proceso con éxito";

                  $scope.close = function () {
                    ngDialog.close();
                  };
                },
              ],
            });
          },
        };
      },
    );
})();

(function () {
  "use strict";
  angular.module("BlurAdmin").factory("utilities", function () {
    return {
      DefineType: function (type) {
        switch (type) {
          case "temp":
            return "10";
            break;
          case "hum":
            return "11";
            break;
          case "consumption":
            return "102";
            break;
          default:
            return "0";
        }
      },
      getMembershipType: function (type) {
        switch (type) {
          case "1":
            return "Free";
            break;
          case "2":
            return "Basic";
            break;
          case "3":
            return "Essential";
            break;
          case "4":
            return "Pro";
            break;
          case "5":
            return "Enterprise";
            break;
          default:
            return "";
        }
      },
      getMembershipDays: function (date) {
        var hoy = Date.now();
        var fecha_vencimiento = new Date(date.replace(" ", "T") + "Z");
        var fecha_segundos = fecha_vencimiento.getTime();
        var s = fecha_segundos - hoy;
        return Math.round(s / (1000 * 60 * 60 * 24));
      },
      guardUser: function (types, rol) {
        var state = false;
        types.forEach(function (type) {
          switch (type) {
            case "cliente":
              if (
                rol === "0" ||
                rol === "5" ||
                rol === "6" ||
                rol === "7" ||
                rol === "8" ||
                rol === "12"
              ) {
                state = true;
              }
              break;
            case "instalador":
              if (rol === "3") {
                state = true;
              }
              break;
            case "admin":
              if (rol === "2") {
                state = true;
              }
              break;
            case "monitoreo":
              if (rol === "6") {
                state = true;
              }
              break;
            case "tecnico":
              if (rol === "7") {
                state = true;
              }
              break;
            case "coordinador":
              if (rol === "8") {
                state = true;
              }
              break;
            case "coordinador_produccion":
              if (rol === "12") {
                state = true;
              }
              break;
            case "monitoreo_plano":
              if (rol === "9") {
                state = true;
              }
            case "monitoreo_plano_visualizacion":
              if (rol === "10") {
                state = true;
              }
            case "monitoreo_plano_control":
              if (rol === "11") {
                state = true;
              }
              break;
            case "all":
              state = true;
              break;
            default:
              state = false;
          }
        });
        return state;
      },
      generarIntervaloDimmer: function (min) {
        var intervalDimmer = [
          {
            id: 0,
            nombre: "Apagar",
            status: true,
          },
        ];
        while (min < 101) {
          var inter = {
            id: min,
            nombre: min + "%",
            status: true,
          };
          min = min + 10;
          intervalDimmer.push(inter);
        }
        return intervalDimmer;
      },
      generarCodigo: function (longitudCodigo) {
        var codigo = "";
        var caracteres =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < longitudCodigo; i++) {
          codigo += caracteres.charAt(
            Math.floor(Math.random() * caracteres.length),
          );
        }

        return codigo;
      },
    };
  });
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.settings')
      .controller('settingsCtrl', settingsCtrl);
  
    function settingsCtrl($scope, $state, settingsServices, $rootScope, $localStorage) {
        
        $scope.options = settingsServices.setOptions($localStorage.rol);
        $scope.options.map(function(o){ o.status = false});
        $scope.options[0].status = true;
        $state.go($scope.options[0].link);
        $scope.gotoOption = function(link, index){
            $scope.options.map(function(o){ o.status = false});
            $scope.options[index].status = true;
            $state.go(link);
            if(link === 'settings.holidays'){
                $rootScope.$broadcast('gotoAddCreateHolidays', {ind: 1} )
            }
        }

        // $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams){
        //     $timeout(function(){
        //         switch(toState.url) {
        //             case '/settings':
        //                 $state.go($scope.options[0].link);
        //                 break;
        //         }
        //     })
        // });

    }

})();
(function() {
    'use strict';
    angular.module('BlurAdmin.settings')
        .service('settingsServices', settingsServices);

    /** @ngInject */
    function settingsServices() {
        return {
            options: [
                {
                    title: 'Gestión de Días Feriados',
                    icon: 'ion-flag',
                    link: 'settings.holidays',
                    status: false,
                },
                {
                    title: 'Opciones de Desarrollador',
                    icon: 'ion-cube',
                    link: 'settings.devTools',
                    status: false,
                },
            ],

            setOptions: function(rol){
                var options = Array.from(this.options);
                if(rol === '6' || rol === '8') {
                    return options
                } else {
                    options.splice(0,1);
                    return options
                }
            }
        }
    }
})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper) {
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.admin.clientes')
        .controller('clientesCtrl', clientesCtrl);

    /** @ngInject */
    function clientesCtrl($scope, $element, baConfig, layoutPaths, $window, $localStorage, ngDialog, RESTServices, SHAREServices) {

        $scope.flag_cliente = false;
        $scope.flag_usuario = false;
        $scope.flag_error = false;
        $scope.cliente = {};
        $scope.cliente.nombre = "";
        $scope.cliente.ciudad = "";
        $scope.cliente.direccion = "";
        $scope.cliente.tel = "";

        $scope.rol = '2';

        $scope.usuario = {};
        $scope.usuario.nombre = "";
        $scope.usuario.apellido = "";
        $scope.usuario.email = "";
        $scope.usuario.contrasena = "";

        var params_ = {
            "id_usuario": $localStorage.id_usuario,
            //"token": SHAREServices.hash_decode_token($localStorage.token)
        };

        RESTServices.post_header('admin/lista_clientes.php', params_,SHAREServices.hash_decode_token($localStorage.token), true).then(function(res_) {
            if (res_.code == '200') {
                $scope.clientes = res_.clientes;
            }
            RESTServices.post_header('admin/lista_paises.php', params_, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                if (res.code == '200') {
                    $scope.paises = res.paises;
                }
            });
        });



        $scope.listar_estados = function(pais) {

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_pais": pais.id
            };
            RESTServices.post_header('admin/lista_estados.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                if (res.code == '200') {
                    $scope.estados = res.estados;
                }
            });
        }

        $scope.listar_ciudades = function(estado) {
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_estado": estado.id
            };

            RESTServices.post_header('admin/lista_ciudades.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                if (res.code == '200') {
                    $scope.ciudades = res.ciudades;
                }
            });
        }

        $scope.agregar_cliente = function() {
            ngDialog.open({
                template: 'app/admin/templates/modal_cliente.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
            });
            $scope.flag_crear_cliente = true;
            $scope.flag_cliente = false;
        }

        $scope.crear_cliente = function(cliente) {

            $scope.flag_error = false;
            if (cliente.nombre != "" && cliente.ciudad != "" && cliente.direccion != "" && cliente.tel != "") {
                cliente.referencia = Math.floor(Math.random() * (1999999999 - 1000000000 + 1) + 1000000000);

                var fields = {
                    "id_usuario": $localStorage.id_usuario,
                    //"token": SHAREServices.hash_decode_token($localStorage.token),
                    "cliente": cliente
                };

                RESTServices.post_header('admin/crear_cliente.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                    if (res.code == '200') {
                        var cliente_aux = {};
                        cliente_aux.nombre = cliente.nombre;
                        cliente_aux.ciudad = cliente.ciudad;
                        cliente_aux.id = res.id;
                        cliente_aux.usuarios = null;
                        $scope.clientes.push(cliente_aux);
                        $scope.cliente.nombre = "";
                        $scope.cliente.ciudad = "";
                        $scope.cliente.direccion = "";
                        $scope.cliente.tel = "";
                        $scope.flag_crear_cliente = false;
                        $scope.flag_cliente = true;
                    }
                });
            } else {
                $scope.flag_error = true;
            }

        }

        $scope.agregar_usuario = function(id_cliente, index) {
            $scope.rol_ = 'cliente';
            $scope.id_cliente = id_cliente;
            $scope.index_cliente = index;
            ngDialog.open({
                template: 'app/admin/templates/modal_usuario.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
            });
            $scope.flag_crear_usuario = true;
            $scope.flag_usuario = false;
        }


        $scope.crear_usuario = function(usuario) {

            $scope.flag_error = false;
            if (usuario.nombre != "" && usuario.apellido != "" && usuario.email != "" && usuario.contrasena != "") {
                var r = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var s = '';
                for (var i = 0; i < 20; i++) s += r.charAt(Math.floor(Math.random() * r.length));
                usuario.token = s;
                usuario.rol = '0';
                usuario.id_entidad = $scope.id_cliente;
                usuario.estado = '1';

                var fields = {
                    "id_usuario": $localStorage.id_usuario,
                    //"token": SHAREServices.hash_decode_token($localStorage.token),
                    "usuario": usuario
                };

                RESTServices.post_header('admin/crear_usuario.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                    if (res.code == '200') {
                        var usuario_aux = {};
                        usuario_aux.nombre = usuario.nombre;
                        usuario_aux.email = usuario.email;
                        $scope.clientes[$scope.index_cliente].usuarios.push(usuario_aux);
                        $scope.usuario.nombre = "";
                        $scope.usuario.apellido = "";
                        $scope.usuario.email = "";
                        $scope.usuario.contrasena = "";
                        $scope.flag_crear_usuario = false;
                        $scope.flag_usuario = true;
                    }
                });
            } else {
                $scope.flag_error = true;
            }

        }

        $scope.cerrar = function() {
            ngDialog.close();
        }


    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.admin.instaladores')
        .controller('instaladoresCtrl', instaladoresCtrl);

    /** @ngInject */
    function instaladoresCtrl($scope, $element, baConfig, layoutPaths, $window, $localStorage, ngDialog, RESTServices, SHAREServices) {

        $scope.rol = '2';
        $scope.flag_instalador = false;
        $scope.flag_usuario = false;
        $scope.flag_as_cliente = false;
        $scope.flag_error = false;
        $scope.instalador = {};
        $scope.instalador.nombre = "";
        $scope.instalador.ciudad = "";
        $scope.instalador.direccion = "";
        $scope.instalador.tel = "";

        $scope.usuario = {};
        $scope.usuario.nombre = "";
        $scope.usuario.apellido = "";
        $scope.usuario.email = "";
        $scope.usuario.contrasena = "";

        var params = {
            "id_usuario": $localStorage.id_usuario,
            //"token": SHAREServices.hash_decode_token($localStorage.token)
        };

        RESTServices.post_header('admin/lista_paises.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
            if (res.code == '200') {
                $scope.paises = res.paises;
            }
        });

        $scope.listar_estados = function(pais) {

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_pais": pais.id
            };

            RESTServices.post_header('admin/lista_estados.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                if (res.code == '200') {
                    $scope.estados = res.estados;
                }
            });
        }

        $scope.listar_ciudades = function(estado) {
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_estado": estado.id
            };

            RESTServices.post_header('admin/lista_ciudades.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                if (res.code == '200') {
                    $scope.ciudades = res.ciudades;
                }
            });
        }

        var params_ = {
            "id_usuario": $localStorage.id_usuario,
            //"token": SHAREServices.hash_decode_token($localStorage.token)
        };

        RESTServices.post_header('admin/lista_instaladores.php', params_,SHAREServices.hash_decode_token($localStorage.token), true).then(function(res_) {
            if (res_.code == '200') {
                $scope.instaladores = res_.instaladores;

                RESTServices.post_header('admin/lista_paises.php', params_, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                    if (res.code == '200') {
                        $scope.paises = res.paises;
                    }
                });
            }
        });

        $scope.agregar_instalador = function() {
            ngDialog.open({
                template: 'app/admin/templates/modal_instalador.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
            });
            $scope.flag_crear_instalador = true;
            $scope.flag_instalador = false;

        }

        //Crear un instalador
        $scope.crear_instalador = function(instalador) {
            $scope.flag_error = false;
            if (instalador.nombre != "" && instalador.ciudad != "" && instalador.direccion != "" && instalador.tel != "") {
                var fields = {
                    "id_usuario": $localStorage.id_usuario,
                    //"token": SHAREServices.hash_decode_token($localStorage.token),
                    "instalador": instalador
                };

                RESTServices.post_header('admin/crear_instalador.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                    if (res.code == '200') {
                        var instalador_aux = {};
                        instalador_aux.nombre = instalador.nombre;
                        instalador_aux.email = instalador.email;
                        $scope.instaladores.push(instalador);
                        $scope.instalador.nombre = "";
                        $scope.instalador.ciudad = "";
                        $scope.instalador.direccion = "";
                        $scope.instalador.tel = "";
                        $scope.flag_crear_instalador = false;
                        $scope.flag_instalador = true;
                    }
                });
            } else {
                $scope.flag_error = true;
            }

        }

        //Presenta el formulario para crear un nuevo usuario asociado a un instalador
        $scope.agregar_usuario = function(id_instalador, index) {
            $scope.rol_ = 'instalador';
            $scope.id_instalador = id_instalador;
            $scope.index_instalador = index;
            ngDialog.open({
                template: 'app/admin/templates/modal_usuario.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
            });
            $scope.flag_crear_usuario = true;
            $scope.flag_usuario = false;
        }

        // Crear usuario de un instalador
        $scope.crear_usuario = function(usuario) {
            $scope.flag_error = false;
            if (usuario.nombre != "" && usuario.apellido != "" && usuario.email != "" && usuario.contrasena != "") {
                var r = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var s = '';
                for (var i = 0; i < 20; i++) s += r.charAt(Math.floor(Math.random() * r.length));
                usuario.token = s;
                usuario.rol = '3';
                usuario.id_entidad = $scope.id_instalador;
                usuario.estado = '1';

                var fields = {
                    "id_usuario": $localStorage.id_usuario,
                   ////token: SHAREServices.hash_decode_token($localStorage.token),
                    "usuario": usuario
                };

                RESTServices.post_header('admin/crear_usuario.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                    if (res.code == '200') {
                        var usuario_aux = {};
                        usuario_aux.nombre = usuario.nombre;
                        usuario_aux.email = usuario.email;
                        usuario_aux.clientes = {};
                        if ($scope.clientes[$scope.index_cliente].usuarios == undefined) $scope.clientes[$scope.index_cliente].usuarios = {};
                        $scope.instaladores[$scope.index_instalador].usuarios.push(usuario_aux);
                        $scope.usuario.nombre = "";
                        $scope.usuario.apellido = "";
                        $scope.usuario.email = "";
                        $scope.usuario.contrasena = "";
                        $scope.flag_crear_usuario = false;
                        $scope.flag_usuario = true;
                    }
                });
            } else {
                $scope.flag_error = true;
            }

        }

        //Presenta el formulario para elegir los clientes disponibles (Los trae de un servicio REST)
        $scope.agregar_clienteainstalador = function(id_usuario, index, parent_index) {
            $scope.id_usuario = id_usuario;
            $scope.index_usuario = index;
            $scope.index_instalador = parent_index;

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token)
            }

            RESTServices.post_header('admin/lista_clientes_disponibles.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                if (res.code == '200') {
                    $scope.clientes_disponibles = res.clientes;
                }
            });

            ngDialog.open({
                template: 'app/admin/templates/modal_asociar_cliente.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
            });
            $scope.flag_asociar_cliente = true;
            $scope.flag_as_cliente = false;
        }

        // Asociar cliente a un usuario instalador
        $scope.asociar_cliente = function(cliente) {
            $scope.flag_error = false;
            if (cliente.nombre != "" && cliente.id != "") {

                var fields = {
                    "id_usuario": $localStorage.id_usuario,
                    //"token": SHAREServices.hash_decode_token($localStorage.token),
                    "id_cliente": cliente.id,
                    "id_instalador": $scope.id_usuario
                };

                RESTServices.post_header('admin/asociar_clienteainstalador.php', fields, SHAREServices.hash_decode_token($localStorage.token), true).then(function(res) {
                    if (res.code == '200') {
                        var cliente_aux = {}
                        cliente_aux.nombre = cliente.nombre;
                        cliente_aux.id = cliente.id;
                        $scope.instaladores[$scope.index_instalador].usuarios[$scope.index_usuario].clientes = $scope.instaladores[$scope.index_instalador].usuarios[$scope.index_usuario].clientes || [];
                        $scope.instaladores[$scope.index_instalador].usuarios[$scope.index_usuario].clientes.push(cliente_aux);

                        $scope.id_usuario = "";
                        $scope.flag_asociar_cliente = false;
                        $scope.flag_as_cliente = true;
                    }
                });
            } else {
                $scope.flag_error = true;
            }

        }


        $scope.cerrar = function() {
            ngDialog.close();
        }


    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.changePassword')
        .controller('changePasswordCtrl', changePasswordCtrl);

    /** @ngInject */
    function changePasswordCtrl($scope, $window, $localStorage, RESTServices, ngDialog, $state, $timeout, SHAREServices, loginUtil) {

        //Verificar que se haya iniciado sesión desde el login. Si refrescan la página redirecciona al login
        if ($localStorage.login == undefined) {
            SHAREServices.cerrar_sesion();
        } else {
            if ($localStorage.server_url != undefined) {
                if ($localStorage.server_url[17] == '0') RESTServices.server_selector(1);
                else if ($localStorage.server_url[17] == '1') RESTServices.server_selector(2);
            } else {
                RESTServices.server_selector(0);
            }
        }
        $scope.rol = $localStorage.rol;

        $scope.no_valida = false;
        $scope.confirmar = false;
        $scope.contrasena = "";
        $scope.n_contrasena = undefined;
        $scope.c_contrasena = undefined;

        $scope.verificarNueva = function(nueva, verificada) {
                if (nueva !== undefined && verificada !== undefined) {
                    if (nueva === verificada) {
                        angular.element(document.querySelector("#enviar_nueva")).removeAttr("disabled");
                    } else {
                        angular.element(document.querySelector("#enviar_nueva")).attr("disabled", "disabled");
                    }
                } else {
                    angular.element(document.querySelector("#enviar_nueva")).attr("disabled", "disabled");

                }
            }
            //$scope.proceso = true;
        $scope.cambiarContrasena = function(nueva, contrasena) {
            var field = {
                //token: SHAREServices.hash_decode_token($localStorage.token),
                contrasena: contrasena,
                nueva_contrasena: nueva
            }
            RESTServices.post_header('cambiar_contrasena.php', field,SHAREServices.hash_decode_token($localStorage.token), true).then(function(ans) {
                if (ans.code == '200') {
                    $scope.no_valida = false;
                    $scope.confirmar = true;
                    $scope.proceso_exitoso = true;
                    $timeout(function() {
                        loginUtil.setDashboard($localStorage.rol);
                    }, 2000);
                } else {
                    $scope.no_valida = true;
                    $scope.confirmar = false;
                    $scope.proceso_exitoso = false;
                }
            });

        }


    }

})();
 
(function () {
  'use strict';

  angular.module('BlurAdmin.recuperar')
    .controller('recuperar_contrasenaCtrl', recuperar_contrasenaCtrl);

  /** @ngInject */
  function recuperar_contrasenaCtrl($scope, $state) {
		
    $scope.goSignIn = function(){
      $state.go("sign_in");
    }

  }

})();

 
(function() {
    'use strict';

    angular.module('BlurAdmin.auth')
        .controller('SignInCtrl', SignInCtrl);

    /** @ngInject */
    function SignInCtrl($scope, $window, $localStorage, RESTServices, ngDialog, $state, SHAREServices, loginUtil, $rootScope) {
        

        loginUtil.selectServidor();
        $scope.today = new Date();

        $scope.showmsg = function() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/mensaje.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function($scope) {
                    // controller logic
                    $scope.titleModal = 'Acceso denegado';
                    $scope.bodyModal = 'El usuario y/o la contraseña ingresada son incorrectos';

                    $scope.close = function() {
                        ngDialog.close();
                    };
                }]
            });
        };

        $scope.msgErrorConex = function() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/mensaje.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function($scope) {
                    // controller logic
                    $scope.titleModal = 'Error';
                    $scope.bodyModal = 'No se pudo conectar al servidor, intente más tarde';

                    $scope.close = function() {
                        ngDialog.close();
                    };
                }]
            });
        };

        $scope.login = function(user) {
            $rootScope.flag_loading = true;
            loginUtil.selectServidor();
            var field = {
                "usuario": SHAREServices.encode(user.mail), //user.mail,
                "contrasena": SHAREServices.encode(user.password) //user.password
            };
            var authdata = SHAREServices.encode(user.mail + ':' + user.password);
            //RESTServices.post('login.php', field).then(function(data) {
            RESTServices.post_header('login.php', {}, authdata, false).then(function(data) {                  
                if ((data[0] != undefined) || (data.code != undefined)) {
                    if (data[0] != undefined) {
                        if (data[0].code == 200) {
                            data[0].email = user.mail;
                            loginUtil.setUserParams(data[0]);
                            loginUtil.syncCognito(user.mail, user.password);
                        }
                    } else {
                        if (SHAREServices.server_status == 0) {
                            RESTServices.server_selector(2);
                            RESTServices.post_header('login.php', {}, authdata, false).then(function(data) {
                            //RESTServices.post('login.php', field).then(function(data) {
                                if ((data != undefined) || (data.code != undefined) || (data.code != '300')) {
                                    if (data != undefined) {
                                        if (data.code == 200) {
                                            data.email = user.mail;
                                            loginUtil.setUserParams(data);
                                            loginUtil.syncCognito(user.mail, user.password);
                                        }else{
                                            loginUtil.modalResponse();
                                            $rootScope.flag_loading = false;
                                        }
                                    }else{
                                        loginUtil.modalResponse();
                                        $rootScope.flag_loading = false;
                                    }
                                
                                }else{
                                    loginUtil.modalResponse(); 
                                    $rootScope.flag_loading = false;

                                }
                            })
                        } else {
                            $rootScope.flag_loading = false;
                            loginUtil.initialUserInfo();
                            loginUtil.modalResponse();
                            //$scope.showmsg();
                        }
                    }
                } else {
                    $rootScope.flag_loading = false;
                    loginUtil.initialUserInfo();
                    loginUtil.modalResponse();
                    RESTServices.server_selector(1);
                    //$scope.msgErrorConex();
                }
            });

        }

        $scope.goRecuperar = function() {
            $state.go("recuperar_contrasena");
        };

        $scope.goSignUp = function(){
            $state.go("sign_up");
        }

    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.auth').factory('loginUtil', function($localStorage, $window, SHAREServices, ngDialog, RESTServices, $cookies, $rootScope) {
        return {
            initialUserInfo: function() {
                $localStorage.id_cliente = undefined;
                $localStorage.nombre_cliente = undefined;
                $localStorage.login = undefined;
                $localStorage.rol = undefined;
                $localStorage.id_usuario = undefined;
                $localStorage.token = undefined;
                $localStorage.tipo = undefined;
                $localStorage.server_url = undefined;
                $localStorage.client = undefined;
                $localStorage.helo_v2_id_token = undefined;
                $localStorage.helo_v2_uid = undefined;
                $localStorage.cognito_refresh_token = undefined;
                $localStorage.marketer = undefined;
            },

            setDashboard: function(rol) {
                switch (rol) {
                    case '0':
                    case '5':
                    case '6': 
                    case '7':   
                    case '8':   
                    case '10':  
                    case '11': 
                    case '12': 
                        $window.location.href = '#/dashboard_cliente/zones';
                        break;
                    case '1':
                        $window.location.href = '#/dashboard_op';
                        break;
                    case '2':
                        $window.location.href = '#/dashboard_admin';
                        break;
                    case '3':
                        $window.location.href = '#/dashboard_instalador';
                        break;
                    case '4':
                        $window.location.href = '#/dashboard_consumo';
                        break;
                    case '9':  
                        $window.location.href = '#/monitoreo-plano';
                }
            },

            setUserParams: function(response) {
                var now = new Date();
                var exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());

                var token_aux = SHAREServices.decode(response.token);

                $localStorage.id_cliente = response.id_entidad;
                $localStorage.nombre_cliente = response.nombre;
                $localStorage.login = true;
                $localStorage.rol = response.rol;
                $localStorage.id_usuario = response.id;
                //
                $localStorage.token = SHAREServices.hash_encode(token_aux);
                $localStorage.tipo = response.tipo;
                $localStorage.email = response.email;
                $localStorage.client = response;

                SHAREServices.user.id = $localStorage.id_usuario;
                SHAREServices.user.token = SHAREServices.hash_decode_token($localStorage.token);
                SHAREServices.user.tipo = $localStorage.tipo;
                SHAREServices.user.rol = $localStorage.rol;
                SHAREServices.user.image = response.image;
                SHAREServices.integracion = response.integracion;
                $cookies.put('userRol', SHAREServices.user.rol, {
                    expires: exp
                });

                if ($localStorage.id_cliente == '38') {
                    $localStorage.marketer = true;
                } else {
                    $localStorage.marketer = false;
                }

                this.setDashboard(response.rol);
            },

            // Best-effort: crea/resincroniza el usuario en Cognito con la
            // misma password que el usuario acaba de validar contra
            // login.php. Si falla (red, Cognito caído, lo que sea), el login
            // legacy ya sucedió — no bloquea ni rompe la sesión actual.
            syncCognito: function(email, password) {
                RESTServices.loginCognito(email, password).catch(function(err) {
                    console.warn('No se pudo sincronizar la sesión con Cognito', err);
                });
            },

            modalResponse: function() {
                ngDialog.open({
                    template: 'app/cliente/dashboard-cliente/templates/mensaje.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function($scope) {
                        // controller logic
                        $scope.titleModal = 'No se pudo loguear';
                        $scope.bodyModal = 'El usuario o la contraseña son incorrectos';

                        $scope.close = function() {
                            ngDialog.close();
                        };
                    }]
                });
            },

            selectServidor: function() {
                if ($localStorage.login != undefined) {
                    if ($localStorage.server_url != undefined) {
                        if ($localStorage.server_url[17] == '0') RESTServices.server_selector(1);
                        else if ($localStorage.server_url[17] == '1') RESTServices.server_selector(2);
                        if ($localStorage.login) {
                            SHAREServices.user.id = $localStorage.id_usuario;
                            SHAREServices.user.token = SHAREServices.hash_decode_token($localStorage.token);
                            SHAREServices.user.tipo = $localStorage.tipo;
                            SHAREServices.user.rol = $localStorage.rol;

                            this.setDashboard($localStorage.rol);

                        }
                    } else {
                        RESTServices.server_selector(0);
                    }
                } else {
                    RESTServices.server_selector(0);
                }
            }
        }
    })

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.consumo.dashboard_consumo')
        .controller('Dashboard_consumoCtrl', Dashboard_consumoCtrl);

    /** @ngInject */
    function Dashboard_consumoCtrl($scope, $window, RESTServices, $filter, ngDialog, $localStorage, $log, $state, SHAREServices) {
        $scope.flag1 = false;
        $scope.flag2 = false;
        $scope.flag_generar = true;
        $scope.flag_copy = false;
        $scope.flag_crear_zona = true;
        $scope.flag_zona = false;
        $scope.flag_dia_facturacion = true;
        $scope.flag_valores = false;
        $scope.dispositivo = {};
        $scope.zona = {};
        $scope.cliente = {};
        $scope.user_name = $localStorage.nombre_cliente;

        $scope.rol = '4';

        var params = {
            id_instalador: '7' //$localStorage.id_usuario
        }
        RESTServices.post_header('instalador/lista_clientesxinstalador.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
            if (res.code == '200') {
                $scope.clientes = res.clientes;
            }
        });

        //$scope.clientes

        $scope.status = {
            isopen: false
        };

        $scope.toggled = function(open) {
            $log.log('Dropdown is now: ', open);
        };

        $scope.oneAtATime = true;

        $scope.agregar_disp = function(zona_id, cliente_nombre) {
            ngDialog.open({
                template: 'app/consumo/dashboard-consumo/templates/modal_id.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
                    //controller: 'Dashboard_instaladorCtrl'
            });
            $scope.zona_id = zona_id;
            $scope.flag_generar = true;
            $scope.flag_copy = false;
            var cliente = $filter('filter')($scope.clientes, { nombre: cliente_nombre }, true)[0];
            //get the index
            $scope.index_cliente = $scope.clientes.indexOf(cliente);
            var zona = $filter('filter')($scope.clientes[$scope.index_cliente].zonas, { id: zona_id }, true)[0];
            //get the index
            $scope.index_zona = $scope.clientes[$scope.index_cliente].zonas.indexOf(zona);

        }

        $scope.dia_facturacion_modal = function(cliente) {
            ngDialog.open({
                template: 'app/consumo/dashboard-consumo/templates/modal_dia_facturacion.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
                    //controller: 'Dashboard_instaladorCtrl'
            });
            var cliente_ = $filter('filter')($scope.clientes, { id: cliente.id }, true)[0];
            //get the index
            $scope.index_cliente = $scope.clientes.indexOf(cliente_);
            $scope.cliente_id = cliente.id;
            $scope.flag_dia_facturacion = true;
            $scope.cliente.dia_facturacion = parseInt($scope.clientes[$scope.index_cliente].dia_facturacion, 10);
        }
        $scope.valor_kwh_modal = function(cliente) {
            ngDialog.open({
                template: 'app/consumo/dashboard-consumo/templates/modal_valor_kwh_mes.html',
                className: 'ngdialog-theme-plain',
                width: 500,
                scope: $scope
            });
            $scope.flag_valores = false;
            var cliente_ = $filter('filter')($scope.clientes, { id: cliente.id }, true)[0];
            //get the index
            $scope.index_cliente = $scope.clientes.indexOf(cliente_);
            $scope.cliente_id = cliente.id;
            for (var i = 0; i < 12; i++) {
                $scope.meses[i].valorkwh = "";
            }

        }
        $scope.years = ["2017"];
        $scope.meses = [{
                "nombre": "Enero",
                "valorkwh": ""
            },
            {
                "nombre": "Febrero",
                "valorkwh": ""
            },
            {
                "nombre": "Marzo",
                "valorkwh": ""
            },
            {
                "nombre": "Abril",
                "valorkwh": ""
            },
            {
                "nombre": "Mayo",
                "valorkwh": ""
            },
            {
                "nombre": "Junio",
                "valorkwh": ""
            },
            {
                "nombre": "Julio",
                "valorkwh": "",
            },
            {
                "nombre": "Agosto",
                "valorkwh": ""
            },
            {
                "nombre": "Septiembre",
                "valorkwh": ""
            },
            {
                "nombre": "Octubre",
                "valorkwh": ""
            },
            {
                "nombre": "Noviembre",
                "valorkwh": ""
            },
            {
                "nombre": "Diciembre",
                "valorkwh": ""
            }
        ];

        $scope.open_consumo = function(zona) {
            var zona = { 'nombre': zona.nombre, 'id': zona.id };
            $state.go('consumo_zona', zona);
        }


        $scope.agregar_lugar = function(cliente_id) {
            ngDialog.open({
                template: 'app/consumo/dashboard-consumo/templates/modal_lugar.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
            });
            $scope.flag_crear_zona = true;
            $scope.flag_zona = false;
            $scope.cliente_id = cliente_id;
            var cliente = $filter('filter')($scope.clientes, { id: cliente_id }, true)[0];
            //get the index
            $scope.index_cliente = $scope.clientes.indexOf(cliente);

        }

        $scope.agregar_zona = function(cliente_id) {
            ngDialog.open({
                template: 'app/consumo/dashboard-consumo/templates/modal_zona.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
            });
            $scope.flag_crear_zona = true;
            $scope.flag_zona = false;
            $scope.cliente_id = cliente_id;
            var cliente = $filter('filter')($scope.clientes, { id: cliente_id }, true)[0];
            //get the index
            $scope.index_cliente = $scope.clientes.indexOf(cliente);

        }

        $scope.copy_value = function() {
            var id_cont = angular.element(document.querySelector('#id_cont'));
            id_cont.value;

        }

        $scope.fecha_s = $filter('date')(new Date(), 'dd/MMM/yyyy');

        $scope.show = function() {
            $scope.flag1 = !$scope.flag1;
        }

        $scope.show_menu = function() {
            $scope.flag2 = !$scope.flag2;
        }

        $scope.obtener_code = function(dispositivo) {
            var params = {
                "nombre": dispositivo.nombre,
                "id_zona": $scope.zona_id,
                "potencia": dispositivo.potencia
            }
            RESTServices.post_header('instalador/genera_dispositivo.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    $scope.dispositivo.id_nuevo = ans.dispositivo.code;
                    $scope.flag_generar = false;
                    if ($scope.clientes[$scope.index_cliente].zonas[$scope.index_zona].dispositivos == null) $scope.clientes[$scope.index_cliente].zonas[$scope.index_zona].dispositivos = [];
                    $scope.clientes[$scope.index_cliente].zonas[$scope.index_zona].dispositivos.push(ans.dispositivo);
                }
            });
        }

        $scope.crear_zona = function(zona) {
            var params = {
                "nombre": zona.nombre,
                "id_cliente": $scope.cliente_id
            }
            RESTServices.post_header('instalador/genera_zona.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200' && ans.estado == true) {
                    $scope.flag_crear_zona = false;
                    $scope.flag_zona = true;
                    var zona = {
                        nombre: params.nombre,
                        dispositivos: null,
                        id: ans.id_zona
                    }
                    if ($scope.clientes[$scope.index_cliente].zonas == undefined) $scope.clientes[$scope.index_cliente].zonas = [];
                    $scope.clientes[$scope.index_cliente].zonas.push(zona);
                    $scope.zona = {};
                }
            });
        }

        $scope.agregar_dia_facturacion = function(cliente) {
            var params = {
                "dia": cliente.dia_facturacion,
                "id_cliente": $scope.cliente_id
            }
            RESTServices.post_header('instalador/genera_dia_facturacion.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    $scope.flag_dia_facturacion = false;
                    $scope.clientes[$scope.index_cliente].dia_facturacion = params.dia_facturacion;
                }
            });
        }

        $scope.addValorkwh = function(meses, year) {
            var params = {
                "year": year,
                "id_cliente": $scope.cliente_id,
                "valores": [meses[0].valorkwh, meses[1].valorkwh, meses[2].valorkwh, meses[3].valorkwh, meses[4].valorkwh, meses[5].valorkwh, meses[6].valorkwh, meses[7].valorkwh, meses[8].valorkwh, meses[9].valorkwh, meses[10].valorkwh, meses[11].valorkwh]
            }
            RESTServices.post_header('instalador/genera_valores_kwh.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    $scope.flag_valores = true;
                    for (var i = 0; i < 12; i++) {
                        $scope.meses[i].valorkwh = "";
                    }
                }
            });
        }

        $scope.obtener_valores = function(year) {
            var params = {
                "year": year,
                "id_cliente": $scope.cliente_id
            }
            RESTServices.post_header('instalador/entrega_valores_kwh.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    $scope.flag_valores = false;
                    for (var i = 0; i < 12; i++) {
                        $scope.meses[i].valorkwh = parseInt(ans.valores[i], 10);
                    }
                }
            });
        }

        $scope.copy = function() {
            $scope.flag_copy = true;
        }

        $scope.cerrar = function() {
            ngDialog.close();
            $scope.dispositivo = {};
        }


        $scope.showNotificacion = function() {
            $scope.notificacion = false;
            $location.hash('grafica_comparativa');
            $anchorScroll();
        }
        $scope.notificacion = true;
        angular.element(document.querySelector("#tawkchat-container")).css("display", "inherit");


    }

})();
(function () {
  'use strict';

  /**
   * Vertical bars = daily kWh of the selected period.
   * Faint line = previous period, aligned by day index (day 1, day 2, ...).
   * Uses amCharts 4 (loaded globally from index.html).
   */
  angular.module('BlurAdmin.consumo.energy_dashboard')
    .directive('energyDailyChart', energyDailyChart);

  /** @ngInject */
  function energyDailyChart($q) {
    return {
      restrict: 'E',
      scope: {
        serie: '=',
        anterior: '=',
        exportApi: '=?'
      },
      template: '<div class="ed-chart ed-chart-daily"></div>',
      link: function (scope, element) {
        var chart = null;

        // bridge for the PDF report: getPng() resolves with a PNG data URI or rejects
        scope.exportApi = {
          getPng: function () {
            if (!chart) { return $q.reject(new Error('chart not ready')); }
            return $q.when(chart.exporting.getImage('png')).then(function (png) {
              return png || $q.reject(new Error('empty chart image'));
            });
          }
        };

        scope.$watchGroup(['serie', 'anterior'], function () {
          if (!scope.serie) { return; }
          if (!chart) { chart = createChart(element.children()[0]); }
          chart.data = buildData(scope.serie, scope.anterior);
        });

        scope.$on('$destroy', function () {
          scope.exportApi = null;
          if (chart) { chart.dispose(); chart = null; }
        });
      }
    };

    function buildData(serie, anterior) {
      return serie.map(function (d, i) {
        var prev = anterior && anterior[i] ? anterior[i] : null;
        return {
          dia: String(i + 1),
          fecha: d.fecha,
          kwh: d.kwh,
          fecha_anterior: prev ? prev.fecha : null,
          kwh_anterior: prev ? prev.kwh : null
        };
      });
    }

    function createChart(container) {
      var chart = am4core.create(container, am4charts.XYChart);
      chart.paddingRight = 16;

      var category = chart.xAxes.push(new am4charts.CategoryAxis());
      category.dataFields.category = 'dia';
      category.renderer.grid.template.location = 0;
      category.renderer.minGridDistance = 22;
      category.title.text = 'Día del período';

      var value = chart.yAxes.push(new am4charts.ValueAxis());
      value.min = 0;
      value.title.text = 'kWh';

      var bars = chart.series.push(new am4charts.ColumnSeries());
      bars.name = 'Período seleccionado';
      bars.dataFields.categoryX = 'dia';
      bars.dataFields.valueY = 'kwh';
      bars.columns.template.fill = am4core.color('#2f80c9');
      bars.columns.template.strokeOpacity = 0;
      // One combined tooltip per day: separate tooltips for the bar and the
      // previous-period line overlap when the line crosses the bar.
      bars.columns.template.tooltipText = '{fecha}: {valueY.formatNumber("#,###.0")} kWh';
      bars.columns.template.adapter.add('tooltipText', function (text, target) {
        var ctx = target.dataItem && target.dataItem.dataContext;
        if (!ctx || ctx.kwh_anterior === null || ctx.kwh_anterior === undefined) {
          return text;
        }
        return text + '\nAnterior ({fecha_anterior}): {kwh_anterior.formatNumber("#,###.0")} kWh';
      });

      var line = chart.series.push(new am4charts.LineSeries());
      line.name = 'Período anterior';
      line.dataFields.categoryX = 'dia';
      line.dataFields.valueY = 'kwh_anterior';
      line.stroke = am4core.color('#8d99a6');
      line.strokeOpacity = 0.55;
      line.strokeWidth = 2;
      line.strokeDasharray = '4,3';
      line.tooltipText = '';

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineX.disabled = true;
      chart.legend = new am4charts.Legend();
      return chart;
    }
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.consumo.energy_dashboard')
    .controller('EnergyDashboardCtrl', EnergyDashboardCtrl);

  /** @ngInject */
  function EnergyDashboardCtrl($scope, $q, ngDialog, EnergyDashboardService, EnergyReportService) {
    var vm = this;
    var requestSeq = 0; // guards against out-of-order responses
    var dataRequest = null; // in-flight consumption request (has cancel())

    vm.dashboards = [];
    vm.periods = [];
    vm.selected = { dashboardId: null, periodId: null };
    vm.data = null;
    vm.selectedZoneId = null;
    vm.loadingDashboards = true;
    vm.loadingPeriods = false;
    vm.loadingData = false;
    vm.error = null;
    vm.dataError = null;   // consumption failed: shown with a retry action
    vm.progress = null;    // {total_days, ready_days} while the backfill runs
    vm.priceState = 'none'; // 'none' | 'mixed' | 'all' (zones with a kWh price in the loaded payload)
    vm.charts = {};        // chart bridges filled by the chart directives ({getPng})
    vm.exporting = false;  // PDF generation in progress
    vm.exportError = null; // PDF generation failed (the view stays usable)

    vm.onDashboardChange = onDashboardChange;
    vm.onPeriodChange = loadPeriodData;
    vm.selectZone = selectZone;
    vm.openCreateDashboard = openCreateDashboard;
    vm.openNewPeriod = openNewPeriod;
    vm.openEditDashboard = openEditDashboard;
    vm.openDeleteDashboard = openDeleteDashboard;
    vm.openEditPeriod = openEditPeriod;
    vm.openDeletePeriod = openDeletePeriod;
    vm.canEditDashboard = canEditDashboard;
    vm.canEditPeriod = canEditPeriod;
    vm.zoneDevices = zoneDevices;
    vm.zoneHasEstimated = zoneHasEstimated;
    vm.selectedZone = selectedZone;
    vm.periodLabel = periodLabel;
    vm.trendClass = trendClass;
    vm.retryPeriodData = loadPeriodData;
    vm.progressPct = progressPct;
    vm.canExport = canExport;
    vm.exportPdf = exportPdf;
    vm.exportZonesExcel = function () { exportExcel(EnergyReportService.downloadZonesExcel); };
    vm.exportDevicesExcel = function () { exportExcel(EnergyReportService.downloadDevicesExcel); };

    $scope.$on('$destroy', cancelDataRequest);

    init();

    function init() {
      EnergyDashboardService.listDashboards().then(function (list) {
        vm.dashboards = list;
        vm.loadingDashboards = false;
        if (list.length) {
          vm.selected.dashboardId = list[0].id;
          onDashboardChange();
        }
      }, handleError);
    }

    function onDashboardChange(preferredPeriodId) {
      cancelDataRequest();
      // invalidate in-flight callbacks (cancel only stops polling) and settle the loading flags
      var seq = ++requestSeq;
      vm.loadingData = false;
      vm.loadingPeriods = false;
      vm.dataError = null;
      vm.exportError = null;
      vm.progress = null;
      vm.data = null;
      vm.priceState = 'none';
      vm.periods = [];
      vm.selected.periodId = null;
      vm.selectedZoneId = null;
      vm.error = null;
      if (vm.selected.dashboardId === null) { return; }
      vm.loadingPeriods = true;
      EnergyDashboardService.listPeriods(vm.selected.dashboardId).then(function (periods) {
        if (seq !== requestSeq) { return; }
        vm.loadingPeriods = false;
        vm.periods = periods;
        if (periods.length) {
          // honor the preferred id only if it survived the refresh (number vs string safe)
          var preferred = preferredPeriodId ? periods.filter(function (p) {
            return String(p.id) === String(preferredPeriodId);
          })[0] : null;
          vm.selected.periodId = preferred ? preferred.id : periods[0].id;
          loadPeriodData();
        }
      }, handleError);
    }

    function loadPeriodData() {
      cancelDataRequest();
      vm.data = null;
      vm.exportError = null;
      vm.priceState = 'none';
      vm.selectedZoneId = null;
      vm.error = null;
      vm.dataError = null;
      vm.progress = null;
      if (vm.selected.periodId === null) { return; }
      vm.loadingData = true;
      var seq = ++requestSeq;
      dataRequest = EnergyDashboardService.getPeriodData(vm.selected.dashboardId, vm.selected.periodId);
      dataRequest.then(function (data) {
        if (seq !== requestSeq) { return; }
        vm.loadingData = false;
        vm.progress = null;
        vm.data = data;
        vm.priceState = priceStateOf(data);
      }, function (err) {
        if (seq !== requestSeq) { return; }
        vm.loadingData = false;
        vm.progress = null;
        vm.dataError = (err && err.message) || 'No fue posible calcular el consumo del período.';
      }, function (progress) {
        if (seq !== requestSeq) { return; }
        vm.progress = progress || null;
      });
    }

    function cancelDataRequest() {
      if (dataRequest && dataRequest.cancel) { dataRequest.cancel(); }
      dataRequest = null;
    }

    /** Percentage of device-days already cached, or null when unknown. */
    function progressPct() {
      if (!vm.progress || !vm.progress.total_days) { return null; }
      return Math.min(100, Math.round(vm.progress.ready_days / vm.progress.total_days * 100));
    }

    /**
     * Price state from zonas[].precio_kwh of the payload: 'none' (no zone priced), 'mixed' (some) or
     * 'all'. A price of 0 counts as priced; costo_total is deliberately not used.
     */
    function priceStateOf(data) {
      var zonas = (data && data.zonas) || [];
      var priced = zonas.filter(function (z) { return z.precio_kwh !== null && z.precio_kwh !== undefined; }).length;
      if (!priced) { return 'none'; }
      return priced === zonas.length ? 'all' : 'mixed';
    }

    /** The PDF needs a complete 200 payload: no loading, no error, a selected period. */
    function canExport() {
      return !!vm.data && vm.selected.periodId !== null && !vm.loadingData && !vm.dataError && !vm.error && !vm.exporting;
    }

    /** Builds and downloads an Excel sheet (zones or devices) from the loaded payload. */
    function exportExcel(downloader) {
      if (!canExport()) { return; }
      vm.exportError = null;
      var dashboard = selectedDashboard();
      downloader(vm.data, {
        dashboardName: dashboard ? dashboard.nombre : '',
        priceState: vm.priceState,
        generatedAt: new Date()
      }).catch(function () {
        vm.exportError = 'No fue posible generar el archivo de Excel. Intenta de nuevo.';
      });
    }

    /** Builds and downloads the PDF from the loaded payload. Any failure shows an error and downloads nothing. */
    function exportPdf() {
      if (!canExport()) { return; }
      vm.exporting = true;
      vm.exportError = null;
      var dashboard = vm.dashboards.filter(function (d) { return d.id === vm.selected.dashboardId; })[0];
      var charts = vm.charts;
      // both images must resolve before building the document
      $q.all({
        daily: $q.when().then(function () { return charts.daily.getPng(); }),
        zone: $q.when().then(function () { return charts.zone.getPng(); })
      }).then(function (images) {
        return EnergyReportService.download(vm.data, {
          dashboardName: dashboard ? dashboard.nombre : '',
          priceState: vm.priceState,
          generatedAt: new Date(),
          images: images
        });
      }).catch(function () {
        vm.exportError = 'No fue posible generar el reporte PDF. Intenta de nuevo.';
      }).finally(function () {
        vm.exporting = false;
      });
    }

    function selectZone(zoneId) {
      vm.selectedZoneId = vm.selectedZoneId === zoneId ? null : zoneId;
    }

    function selectedZone() {
      if (!vm.data || vm.selectedZoneId === null) { return null; }
      return vm.data.zonas.filter(function (z) { return z.zona_id === vm.selectedZoneId; })[0] || null;
    }

    /** Devices of the selected zone with their share of the zone total, sorted desc (no-data last). */
    function zoneDevices() {
      var zone = selectedZone();
      if (!zone) { return []; }
      return vm.data.dispositivos
        .filter(function (d) { return d.zona_id === zone.zona_id; })
        .map(function (d) {
          return angular.extend({}, d, {
            share_pct: d.kwh !== null && zone.kwh > 0 ? Math.round(d.kwh / zone.kwh * 1000) / 10 : null
          });
        })
        .sort(function (a, b) { return (b.kwh === null ? -1 : b.kwh) - (a.kwh === null ? -1 : a.kwh); });
    }

    /** True when the selected zone has a Helo S (tipo 5) device, whose kWh is an estimate. */
    function zoneHasEstimated() {
      var zone = selectedZone();
      if (!zone) { return false; }
      return vm.data.dispositivos.some(function (d) { return d.zona_id === zone.zona_id && d.tipo === 5; });
    }

    function openCreateDashboard() {
      ngDialog.open({
        template: 'app/consumo/energy-dashboard/create-dashboard.modal.html',
        className: 'ngdialog-theme-plain ed-dialog ed-dialog-wide',
        scope: $scope,
        controller: 'EnergyCreateDashboardModalCtrl',
        controllerAs: 'modal',
        closeByDocument: false
      }).closePromise.then(function (result) {
        var created = result.value;
        if (created && created.id) {
          vm.dashboards.push(created);
          vm.selected.dashboardId = created.id;
          onDashboardChange();
        }
      });
    }

    function openNewPeriod() {
      ngDialog.open({
        template: 'app/consumo/energy-dashboard/new-period.modal.html',
        className: 'ngdialog-theme-plain ed-dialog',
        scope: $scope,
        controller: 'EnergyNewPeriodModalCtrl',
        controllerAs: 'modal',
        closeByDocument: false,
        data: { dashboardId: vm.selected.dashboardId }
      }).closePromise.then(function (result) {
        var created = result.value;
        if (created && created.id) { onDashboardChange(created.id); }
      });
    }

    function selectedDashboard() {
      return vm.dashboards.filter(function (d) { return d.id === vm.selected.dashboardId; })[0] || null;
    }

    function selectedPeriod() {
      return vm.periods.filter(function (p) { return p.id === vm.selected.periodId; })[0] || null;
    }

    /** Edit/delete controls need a selected item and no load in flight. */
    function canEditDashboard() {
      return !!selectedDashboard() && !vm.loadingDashboards;
    }

    function canEditPeriod() {
      return !!selectedPeriod() && !vm.loadingPeriods;
    }

    function openEditDashboard() {
      var dashboard = selectedDashboard();
      if (!dashboard) { return; }
      ngDialog.open({
        template: 'app/consumo/energy-dashboard/edit-dashboard.modal.html',
        className: 'ngdialog-theme-plain ed-dialog',
        scope: $scope,
        controller: 'EnergyEditDashboardModalCtrl',
        controllerAs: 'modal',
        closeByDocument: false,
        data: { dashboard: dashboard }
      }).closePromise.then(function (result) {
        var updated = result.value;
        if (updated && updated.gone) {
          // deleted elsewhere (REQ-CFG-17): reload the list and never keep it selected
          vm.selected.dashboardId = null;
          onDashboardChange(); // clears period and data
          init();
          return;
        }
        if (updated && updated.id) {
          // rename only: update the name in place, no reload
          dashboard.nombre = updated.nombre;
          vm.dashboards.forEach(function (d) {
            if (d.id === dashboard.id) { d.nombre = updated.nombre; }
          });
        }
      });
    }

    function openDeleteDashboard() {
      var dashboard = selectedDashboard();
      if (!dashboard) { return; }
      ngDialog.open({
        template: 'app/consumo/energy-dashboard/confirm-delete.modal.html',
        className: 'ngdialog-theme-plain ed-dialog',
        scope: $scope,
        controller: 'EnergyConfirmDeleteModalCtrl',
        controllerAs: 'modal',
        closeByDocument: false,
        data: { kind: 'dashboard', dashboardId: dashboard.id, label: dashboard.nombre }
      }).closePromise.then(function (result) {
        if (!(result.value && result.value.deleted)) { return; }
        vm.dashboards = vm.dashboards.filter(function (d) { return d.id !== dashboard.id; });
        vm.selected.dashboardId = vm.dashboards.length ? vm.dashboards[0].id : null;
        onDashboardChange(); // clears period and data; with no dashboard it returns early
      });
    }

    function openEditPeriod() {
      var period = selectedPeriod();
      if (!period) { return; }
      ngDialog.open({
        template: 'app/consumo/energy-dashboard/edit-period.modal.html',
        className: 'ngdialog-theme-plain ed-dialog',
        scope: $scope,
        controller: 'EnergyEditPeriodModalCtrl',
        controllerAs: 'modal',
        closeByDocument: false,
        data: { dashboardId: vm.selected.dashboardId, period: period }
      }).closePromise.then(function (result) {
        var updated = result.value;
        if (updated && updated.gone) {
          // deleted elsewhere (REQ-CFG-17): no preferred id, the period must not stay selected
          onDashboardChange();
          return;
        }
        if (updated && updated.id) { onDashboardChange(period.id); }
      });
    }

    function openDeletePeriod() {
      var period = selectedPeriod();
      if (!period) { return; }
      ngDialog.open({
        template: 'app/consumo/energy-dashboard/confirm-delete.modal.html',
        className: 'ngdialog-theme-plain ed-dialog',
        scope: $scope,
        controller: 'EnergyConfirmDeleteModalCtrl',
        controllerAs: 'modal',
        closeByDocument: false,
        data: { kind: 'period', dashboardId: vm.selected.dashboardId, periodId: period.id, label: periodLabel(period) }
      }).closePromise.then(function (result) {
        if (!(result.value && result.value.deleted)) { return; }
        // no preferred id: the deleted periodId must never stay selected
        onDashboardChange();
      });
    }

    function periodLabel(p) {
      return p.fecha_inicio + '  →  ' + p.fecha_fin;
    }

    /** Higher consumption than the previous period is bad (up = red), lower is good (down = green). */
    function trendClass(value) {
      if (value === null || value === undefined || value === 0) { return 'ed-trend-neutral'; }
      return value > 0 ? 'ed-trend-up' : 'ed-trend-down';
    }

    function handleError(err) {
      vm.loadingDashboards = false;
      vm.loadingPeriods = false;
      vm.loadingData = false;
      vm.error = (err && err.message) || 'No fue posible cargar la información.';
    }
  }

})();

(function () {
  'use strict';

  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  angular.module('BlurAdmin.consumo.energy_dashboard')
    .filter('edKwh', function () {
      return function (value) {
        if (value === null || value === undefined) { return '—'; }
        // always one decimal so whole values read as "12,0"
        return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value);
      };
    })
    .filter('edCop', function () {
      return function (value) {
        if (value === null || value === undefined) { return '—'; }
        return new Intl.NumberFormat('es-CO', {
          style: 'currency', currency: 'COP', maximumFractionDigits: 0
        }).format(value);
      };
    })
    // kWh prices keep up to 4 decimals (edCop rounds to whole pesos)
    .filter('edPrice', function () {
      return function (value) {
        if (value === null || value === undefined) { return '—'; }
        return new Intl.NumberFormat('es-CO', {
          style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 4
        }).format(value);
      };
    })
    .filter('edPct', function () {
      return function (value) {
        if (value === null || value === undefined) { return '—'; }
        var s = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 1 }).format(Math.abs(value));
        return (value > 0 ? '+' : (value < 0 ? '-' : '')) + s + '%';
      };
    })
    // 'YYYY-MM-DD' -> '03 jul 2026' by string parsing (no Date, no timezone shifts)
    .filter('edDate', function () {
      return function (value) {
        if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) { return value || ''; }
        return value.slice(8, 10) + ' ' + MONTHS[+value.slice(5, 7) - 1] + ' ' + value.slice(0, 4);
      };
    });

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.consumo.energy_dashboard')
    .controller('EnergyCreateDashboardModalCtrl', EnergyCreateDashboardModalCtrl)
    .controller('EnergyNewPeriodModalCtrl', EnergyNewPeriodModalCtrl)
    .controller('EnergyEditPeriodModalCtrl', EnergyEditPeriodModalCtrl)
    .controller('EnergyEditDashboardModalCtrl', EnergyEditDashboardModalCtrl)
    .controller('EnergyConfirmDeleteModalCtrl', EnergyConfirmDeleteModalCtrl);

  var MAX_DASHBOARD_NAME = 100; // same limit as the API (create and rename)

  /**
   * Validates the per-zone price inputs and builds the `precios` payload.
   * Price is optional per zone. An empty input is skipped, 0 is a valid price (free) and a
   * non-empty but invalid entry is an error: an invalid number input leaves the model
   * undefined (same as empty), so the field's validity is checked instead.
   * Returns {precios} or {error}.
   */
  function collectPrices(form, zones, prices) {
    var precios = [];
    for (var i = 0; i < zones.length; i++) {
      var zone = zones[i];
      var field = form && form['price_' + zone.id];
      var price = prices[zone.id];
      if (field && field.$invalid) {
        return { error: 'El precio del kWh de la zona "' + zone.nombre + '" no es válido: ingresa un número mayor o igual a cero.' };
      }
      if (price === undefined || price === null || price === '') { continue; }
      var value = Number(price);
      if (!isFinite(value) || value < 0 || Number(value.toFixed(4)) !== value) {
        return { error: 'El precio del kWh de la zona "' + zone.nombre + '" debe ser mayor o igual a cero y tener máximo 4 decimales.' };
      }
      precios.push({ zona_id: zone.id, precio_kwh: value });
    }
    return { precios: precios };
  }

  /**
   * Copies the global price input to every zone of a period modal. The per-zone inputs stay
   * editable afterwards, so one zone can still get a different price before saving.
   */
  function applyGlobalPrice(modal) {
    modal.error = null;
    var value = modal.globalPrice;
    if (value === undefined || value === null || value === '' || !isFinite(Number(value)) || Number(value) < 0) {
      modal.error = 'Ingresa un precio global válido: un número mayor o igual a cero.';
      return;
    }
    modal.zones.forEach(function (z) { modal.prices[z.id] = Number(value); });
  }

  /** @ngInject */
  function EnergyCreateDashboardModalCtrl($scope, EnergyDashboardService) {
    var modal = this;

    modal.step = 1;
    modal.nombre = '';
    modal.zones = [];
    modal.loading = true;
    modal.saving = false;
    modal.error = null;
    // selection is explicit: nothing is pre-selected
    modal.zoneSelected = {};   // zoneId -> bool
    modal.deviceSelected = {}; // deviceId -> bool

    modal.zoneQuery = '';      // zone search box (step 1); only filters what is shown

    modal.ownZones = function () { return modal.zones.filter(function (z) { return !z.compartida; }); };
    modal.sharedZones = function () { return modal.zones.filter(function (z) { return z.compartida; }); };
    modal.visibleOwnZones = function () { return modal.ownZones().filter(matchesQuery); };
    modal.visibleSharedZones = function () { return modal.sharedZones().filter(matchesQuery); };
    modal.typeLabel = typeLabel;
    modal.chosenZones = chosenZones;
    modal.selectedCount = selectedCount;
    modal.zoneAllSelected = zoneAllSelected;
    modal.toggleZoneAll = toggleZoneAll;
    modal.visibleZonesAllSelected = visibleZonesAllSelected;
    modal.toggleVisibleZones = toggleVisibleZones;
    modal.allDevicesSelected = allDevicesSelected;
    modal.toggleAllDevices = toggleAllDevices;
    modal.goToDevices = goToDevices;
    modal.back = back;
    modal.save = save;

    EnergyDashboardService.getZonesWithDevices().then(function (zones) {
      modal.zones = zones;
      modal.loading = false;
    }, function (err) {
      modal.loading = false;
      modal.error = err.message;
    });

    /** Badge text per dispositivos.tipo; empty (no badge) for an unknown or missing tipo. */
    function typeLabel(tipo) {
      if (tipo === 5) { return 'Helo S'; }
      if (tipo === 9) { return 'Med. Avanzada'; }
      return '';
    }

    // own zones first, then the shared ones (same order as the group headings)
    function chosenZones() {
      return modal.ownZones().concat(modal.sharedZones())
        .filter(function (z) { return modal.zoneSelected[z.id]; });
    }

    function selectedCount() {
      return chosenZones().reduce(function (acc, z) {
        return acc + z.dispositivos.filter(function (d) { return modal.deviceSelected[d.id]; }).length;
      }, 0);
    }

    function zoneAllSelected(zone) {
      return zone.dispositivos.every(function (d) { return modal.deviceSelected[d.id]; });
    }

    function toggleZoneAll(zone) {
      var value = !zoneAllSelected(zone);
      zone.dispositivos.forEach(function (d) { modal.deviceSelected[d.id] = value; });
    }

    /** Case and accent insensitive match on the zone name and, for shared zones, the customer name. */
    function matchesQuery(zone) {
      var query = normalize(modal.zoneQuery);
      if (!query) { return true; }
      return normalize(zone.nombre).indexOf(query) !== -1 ||
        normalize(zone.clienteNombre).indexOf(query) !== -1;
    }

    function normalize(text) {
      return String(text || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
    }

    function visibleZones() {
      return modal.visibleOwnZones().concat(modal.visibleSharedZones());
    }

    function visibleZonesAllSelected() {
      var zones = visibleZones();
      return zones.length > 0 && zones.every(function (z) { return modal.zoneSelected[z.id]; });
    }

    /** Selects or clears only the zones that match the search, so a filtered bulk action stays scoped. */
    function toggleVisibleZones() {
      var value = !visibleZonesAllSelected();
      visibleZones().forEach(function (z) { modal.zoneSelected[z.id] = value; });
    }

    function allDevicesSelected() {
      var zones = chosenZones();
      return zones.length > 0 && zones.every(zoneAllSelected);
    }

    function toggleAllDevices() {
      var value = !allDevicesSelected();
      chosenZones().forEach(function (z) {
        z.dispositivos.forEach(function (d) { modal.deviceSelected[d.id] = value; });
      });
    }

    function goToDevices() {
      modal.error = null;
      if (!modal.nombre || !modal.nombre.trim()) { modal.error = 'Ingresa un nombre para el dashboard.'; return; }
      if (!chosenZones().length) { modal.error = 'Selecciona al menos una zona.'; return; }
      modal.step = 2;
    }

    function back() {
      modal.error = null;
      modal.step = 1;
    }

    function save() {
      modal.error = null;
      var dispositivos = [];
      chosenZones().forEach(function (z) {
        z.dispositivos.forEach(function (d) {
          if (modal.deviceSelected[d.id]) { dispositivos.push({ dispositivo_id: d.id, zona_id: z.id }); }
        });
      });
      modal.saving = true;
      EnergyDashboardService.createDashboard({ nombre: modal.nombre, dispositivos: dispositivos })
        .then(function (created) {
          $scope.closeThisDialog(created);
        }, function (err) {
          modal.saving = false;
          modal.error = err.message;
        });
    }
  }

  /** @ngInject */
  function EnergyNewPeriodModalCtrl($scope, EnergyDashboardService) {
    var modal = this;
    var dashboardId = $scope.ngDialogData.dashboardId;

    modal.maxDate = EnergyDashboardService.yesterdayString();
    modal.form = { fecha_inicio: null, fecha_fin: null }; // dates are Date objects (input[type=date])
    modal.zones = [];          // [{id, nombre}] zones of the dashboard, one optional price each
    modal.prices = {};         // zoneId -> price typed by the user (empty = no price)
    modal.globalPrice = null;  // optional price copied to every zone
    modal.loadingZones = true;
    modal.saving = false;
    modal.error = null;

    modal.save = save;
    modal.applyGlobalPrice = function () { applyGlobalPrice(modal); };

    EnergyDashboardService.getDashboardZones(dashboardId).then(function (zones) {
      modal.zones = zones;
      modal.loadingZones = false;
      if (!zones.length) {
        modal.error = 'Este dashboard no tiene zonas.';
      }
    }, function (err) {
      modal.loadingZones = false;
      modal.error = err.message;
    });

    function save() {
      modal.error = null;
      var fechaInicio = toDateString(modal.form.fecha_inicio);
      var fechaFin = toDateString(modal.form.fecha_fin);
      if (!fechaInicio || !fechaFin) { modal.error = 'Las fechas son obligatorias.'; return; }
      if (fechaFin < fechaInicio) { modal.error = 'La fecha de fin no puede ser anterior a la fecha de inicio.'; return; }
      if (fechaFin > modal.maxDate) { modal.error = 'La fecha de fin debe ser anterior a hoy: solo se permiten períodos cerrados.'; return; }

      var collected = collectPrices($scope.newPeriodForm, modal.zones, modal.prices);
      if (collected.error) { modal.error = collected.error; return; }
      var precios = collected.precios;

      modal.saving = true;
      EnergyDashboardService.createPeriod(dashboardId, {
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFin,
        precios: precios
      }).then(function (created) {
        $scope.closeThisDialog(created);
      }, function (err) {
        modal.saving = false;
        modal.error = err.message;
      });
    }

    /** Date picked in the browser (local midnight) -> 'YYYY-MM-DD' using LOCAL parts, so the day never shifts. */
    function toDateString(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) { return null; }
      var m = date.getMonth() + 1;
      var d = date.getDate();
      return date.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
    }
  }

  /** @ngInject */
  function EnergyEditPeriodModalCtrl($scope, EnergyDashboardService) {
    var modal = this;
    var dashboardId = $scope.ngDialogData.dashboardId;
    var period = $scope.ngDialogData.period;

    modal.period = period;     // dates are shown read-only
    modal.zones = [];          // [{id, nombre}] live zones of the dashboard
    modal.prices = {};         // zoneId -> price (blank = no price, 0 = free)
    modal.globalPrice = null;  // optional price copied to every zone
    modal.loadingZones = true;
    modal.saving = false;
    modal.error = null;

    modal.save = save;
    modal.applyGlobalPrice = function () { applyGlobalPrice(modal); };

    EnergyDashboardService.getDashboardZones(dashboardId).then(function (zones) {
      modal.zones = zones;
      var current = {};
      ((period && period.precios) || []).forEach(function (p) { current[p.zona_id] = p.precio_kwh; });
      zones.forEach(function (z) {
        if (current[z.id] !== undefined && current[z.id] !== null) { modal.prices[z.id] = Number(current[z.id]); }
      });
      modal.loadingZones = false;
      if (!zones.length) { modal.error = 'Este dashboard no tiene zonas.'; }
    }, function (err) {
      modal.loadingZones = false;
      modal.error = err.message;
    });

    function save() {
      modal.error = null;
      var collected = collectPrices($scope.editPeriodForm, modal.zones, modal.prices);
      if (collected.error) { modal.error = collected.error; return; }
      modal.saving = true;
      EnergyDashboardService.updatePeriodPrices(dashboardId, period.id, collected.precios)
        .then(function (updated) {
          $scope.closeThisDialog(updated || { id: period.id });
        }, function (err) {
          if (err && err.status === 404) {
            $scope.closeThisDialog({ gone: true }); // deleted elsewhere: same as the delete modal
            return;
          }
          modal.saving = false;
          modal.error = err.message;
        });
    }
  }

  /** @ngInject */
  function EnergyEditDashboardModalCtrl($scope, EnergyDashboardService) {
    var modal = this;
    var dashboard = $scope.ngDialogData.dashboard;

    modal.nombre = dashboard ? dashboard.nombre : '';
    modal.maxLength = MAX_DASHBOARD_NAME;
    modal.saving = false;
    modal.error = null;

    modal.save = save;

    function save() {
      modal.error = null;
      var nombre = modal.nombre ? modal.nombre.trim() : '';
      if (!nombre) { modal.error = 'Ingresa un nombre para el dashboard.'; return; }
      if (nombre.length > MAX_DASHBOARD_NAME) { modal.error = 'El nombre no puede superar los ' + MAX_DASHBOARD_NAME + ' caracteres.'; return; }
      modal.saving = true;
      EnergyDashboardService.updateDashboard(dashboard.id, nombre)
        .then(function (updated) {
          $scope.closeThisDialog(updated || { id: dashboard.id, nombre: nombre });
        }, function (err) {
          if (err && err.status === 404) {
            $scope.closeThisDialog({ gone: true }); // deleted elsewhere: same as the delete modal
            return;
          }
          modal.saving = false;
          modal.error = err.message;
        });
    }
  }

  /**
   * Confirm-delete modal. ngDialogData: {kind: 'dashboard'|'period', dashboardId, periodId?, label}.
   * Calls the API itself so errors stay in the modal. 204 and 404 both mean "gone":
   * the modal closes with {deleted: true} and no error is shown.
   * @ngInject
   */
  function EnergyConfirmDeleteModalCtrl($scope, EnergyDashboardService) {
    var modal = this;
    var data = $scope.ngDialogData;

    modal.kind = data.kind;
    modal.label = data.label;
    modal.deleting = false;
    modal.error = null;

    modal.confirm = confirm;

    function confirm() {
      modal.error = null;
      modal.deleting = true;
      var request = data.kind === 'dashboard'
        ? EnergyDashboardService.deleteDashboard(data.dashboardId)
        : EnergyDashboardService.deletePeriod(data.dashboardId, data.periodId);
      request.then(function () {
        $scope.closeThisDialog({ deleted: true });
      }, function (err) {
        if (err && err.status === 404) {
          $scope.closeThisDialog({ deleted: true });
          return;
        }
        modal.deleting = false;
        modal.error = err.message;
      });
    }
  }

})();

/**
 * Client-side reports of the energy dashboard: PDF (pdfmake) and Excel (SheetJS), both loaded
 * globally from index.html.
 *
 * build() is pure: payload + context in, pdfmake docDefinition out. The charts arrive as PNG data
 * URIs already resolved by the controller, so the document is only built once both images exist.
 * Values are formatted with the same filters as the view (edKwh, edCop, edPrice, edPct, edDate).
 * Avoid characters missing from the bundled Roboto font (e.g. the arrow U+2192).
 *
 * The Excel sheets keep numbers as numbers (with a cell format) so they can be summed in Excel.
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.consumo.energy_dashboard')
    .factory('EnergyReportService', EnergyReportService);

  var PAGE_MARGIN = 40;
  var IMAGE_WIDTH = 515; // A4 portrait width (595) minus both margins
  var IMAGE_MAX_HEIGHT = 680;
  var TIPO_HELO_S = 5;
  var DASH = '—';
  var LOGO_WIDTH = 60;
  var WATERMARK_SIZE = 320; // the logo is square, so width = height
  var WATERMARK_OPACITY = 0.06;
  var XLSX_KWH_FORMAT = '#,##0.0';
  var XLSX_COP_FORMAT = '#,##0';
  var XLSX_PRICE_FORMAT = '#,##0.00##';

  /** @ngInject */
  function EnergyReportService($filter, $q, consumoServices) {
    var edKwh = $filter('edKwh');
    var edCop = $filter('edCop');
    var edPrice = $filter('edPrice');
    var edPct = $filter('edPct');
    var edDate = $filter('edDate');
    // same Helo logo as the consumo_v2 dashboard report
    var logo = consumoServices.logoHeloData;

    return {
      build: build,
      fileName: fileName,
      download: download,
      zoneRows: zoneRows,
      deviceRows: deviceRows,
      downloadZonesExcel: downloadZonesExcel,
      downloadDevicesExcel: downloadDevicesExcel
    };

    /**
     * @param {Object} data consumption payload (200)
     * @param {{dashboardName: string, priceState: string, generatedAt: Date,
     *          images: {daily: string, zone: string}}} ctx
     */
    function build(data, ctx) {
      var priced = ctx.priceState !== 'none';
      var mixed = ctx.priceState === 'mixed';
      var periodo = data.periodo;
      var content = [
        // header: title, period and generation time on the left, logo on the right
        {
          columns: [
            {
              width: '*',
              stack: [
                { text: ctx.dashboardName || 'Dashboard', style: 'title' },
                { text: 'Período: ' + edDate(periodo.fecha_inicio) + ' a ' + edDate(periodo.fecha_fin), style: 'meta' },
                { text: 'Generado: ' + formatGeneratedAt(ctx.generatedAt), style: 'meta' }
              ]
            },
            { width: LOGO_WIDTH, image: logo, fit: [LOGO_WIDTH, LOGO_WIDTH] }
          ],
          columnGap: 12,
          margin: [0, 0, 0, 12]
        },

        { text: 'Resumen', style: 'section' },
        summaryTable(data.resumen, data.periodo_anterior, priced),

        { text: 'Consumo diario (kWh)', style: 'section' },
        { image: ctx.images.daily, width: IMAGE_WIDTH },

        { text: 'Consumo por zona', style: 'section' },
        { image: ctx.images.zone, fit: [IMAGE_WIDTH, IMAGE_MAX_HEIGHT], margin: [0, 0, 0, 10] },
        zoneTable(data.zonas, priced)
      ];
      if (mixed) { content.push({ text: mixedNote(), style: 'note' }); }

      content.push({ text: 'Detalle por dispositivo', style: 'section' });
      content.push(deviceTable(data, priced));
      if (mixed) { content.push({ text: mixedNote(), style: 'note' }); }
      if (data.dispositivos.some(function (d) { return d.tipo === TIPO_HELO_S; })) {
        content.push({
          text: 'Estimado: el consumo de los dispositivos Helo S se calcula a partir de la corriente medida y su potencia nominal.',
          style: 'note'
        });
      }

      return {
        pageSize: 'A4',
        pageMargins: [PAGE_MARGIN, PAGE_MARGIN, PAGE_MARGIN, PAGE_MARGIN],
        background: watermark,
        defaultStyle: { fontSize: 9 },
        content: content,
        styles: {
          title: { fontSize: 18, bold: true, margin: [0, 0, 0, 4] },
          meta: { fontSize: 10, color: '#555555' },
          section: { fontSize: 12, bold: true, margin: [0, 14, 0, 6] },
          note: { fontSize: 8, color: '#666666', italics: true, margin: [0, 4, 0, 0] },
          th: { bold: true, fillColor: '#eeeeee' }
        }
      };
    }

    /** Faded logo centered on every page, drawn behind the content. */
    function watermark(currentPage, pageSize) {
      return {
        image: logo,
        width: WATERMARK_SIZE,
        opacity: WATERMARK_OPACITY,
        absolutePosition: {
          x: (pageSize.width - WATERMARK_SIZE) / 2,
          y: (pageSize.height - WATERMARK_SIZE) / 2
        }
      };
    }

    function summaryTable(resumen, anterior, priced) {
      var rows = [
        [{ text: 'Consumo total', bold: true }, edKwh(resumen.kwh_total) + ' kWh']
      ];
      if (priced) { rows.push([{ text: 'Costo total', bold: true }, edCop(resumen.costo_total)]); }
      var variation = edPct(resumen.variacion_pct);
      if (anterior) {
        variation += '  (vs ' + edDate(anterior.fecha_inicio) + ' a ' + edDate(anterior.fecha_fin) + ')';
      }
      rows.push([{ text: 'Variación vs período anterior', bold: true }, variation]);
      return { table: { widths: [180, '*'], body: rows }, layout: 'lightHorizontalLines' };
    }

    function zoneTable(zonas, priced) {
      var header = [th('Zona'), th('kWh', 'right')];
      var widths = ['*', 70];
      if (priced) {
        header.push(th('Precio kWh', 'right'), th('Costo', 'right'));
        widths.push(80, 90);
      }
      header.push(th('Variación', 'right'));
      widths.push(60);
      var body = [header].concat(zonas.map(function (z) {
        var row = [z.nombre, right(edKwh(z.kwh))];
        if (priced) { row.push(right(edPrice(z.precio_kwh)), right(edCop(z.costo))); }
        row.push(right(edPct(z.variacion_pct)));
        return row;
      }));
      return { table: { headerRows: 1, widths: widths, body: body }, layout: 'lightHorizontalLines' };
    }

    function deviceTable(data, priced) {
      var header = [th('Dispositivo'), th('Zona'), th('Tipo'), th('kWh', 'right')];
      var widths = ['*', 110, 60, 60];
      if (priced) {
        header.push(th('Costo', 'right'));
        widths.push(80);
      }
      var zoneName = zoneNames(data);
      var body = [header].concat(sortedDevices(data).map(function (d) {
        var row = [
          d.nombre,
          zoneName[d.zona_id] || '',
          d.tipo === TIPO_HELO_S ? 'Estimado' : '',
          right(d.sin_datos ? DASH : edKwh(d.kwh))
        ];
        if (priced) { row.push(right(d.sin_datos ? DASH : edCop(d.costo))); }
        return row;
      }));
      return { table: { headerRows: 1, widths: widths, body: body }, layout: 'lightHorizontalLines' };
    }

    function zoneNames(data) {
      var names = {};
      data.zonas.forEach(function (z) { names[z.zona_id] = z.nombre; });
      return names;
    }

    /** Grouped by zone (payload order), then highest consumption first, devices without data last. */
    function sortedDevices(data) {
      var zoneOrder = {};
      data.zonas.forEach(function (z, i) { zoneOrder[z.zona_id] = i; });
      return data.dispositivos.slice().sort(function (a, b) {
        var byZone = (zoneOrder[a.zona_id] || 0) - (zoneOrder[b.zona_id] || 0);
        if (byZone) { return byZone; }
        return (b.kwh === null ? -1 : b.kwh) - (a.kwh === null ? -1 : a.kwh);
      });
    }

    function th(text, alignment) {
      return { text: text, style: 'th', alignment: alignment || 'left' };
    }

    function right(text) {
      return { text: text, alignment: 'right' };
    }

    function mixedNote() {
      return 'El costo total solo incluye las zonas con precio del kWh; las zonas sin precio se muestran con "' + DASH + '".';
    }

    /** Local date and time of the user. */
    function formatGeneratedAt(date) {
      return date.toLocaleString('es-CO', { dateStyle: 'medium', timeStyle: 'short' });
    }

    /**
     * reporte-energia-<slug>-<fecha_inicio>_<fecha_fin>.pdf (REQ-RPT-5). The Excel files add a
     * suffix and their own extension: reporte-energia-<slug>-zonas-<inicio>_<fin>.xlsx
     */
    function fileName(dashboardName, fechaInicio, fechaFin, suffix, extension) {
      var slug = String(dashboardName || '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'dashboard';
      return 'reporte-energia-' + slug + (suffix ? '-' + suffix : '') + '-' + fechaInicio + '_' + fechaFin +
        '.' + (extension || 'pdf');
    }

    function download(data, ctx) {
      var doc = build(data, ctx);
      var name = fileName(ctx.dashboardName, data.periodo.fecha_inicio, data.periodo.fecha_fin);
      // pdfmake 0.3 returns a promise: hand it back so callers see failures
      return $q.when(pdfMake.createPdf(doc).download(name));
    }

    /**
     * Rows of the zone sheet: header + one row per zone. Each cell is {v, z?}; z is the Excel
     * number format. Missing values stay empty instead of "—" so the column remains numeric.
     */
    function zoneRows(data, priced) {
      var header = ['Zona', 'Consumo (kWh)'];
      if (priced) { header.push('Precio kWh (COP)', 'Costo (COP)'); }
      header.push('Variación vs período anterior (%)');
      return [headerCells(header)].concat(data.zonas.map(function (z) {
        var row = [cell(z.nombre), cell(z.kwh, XLSX_KWH_FORMAT)];
        if (priced) { row.push(cell(z.precio_kwh, XLSX_PRICE_FORMAT), cell(z.costo, XLSX_COP_FORMAT)); }
        row.push(cell(z.variacion_pct, XLSX_KWH_FORMAT));
        return row;
      }));
    }

    /** Rows of the device sheet, in the same order as the PDF device table. */
    function deviceRows(data, priced) {
      var zoneName = zoneNames(data);
      var zoneKwh = {};
      data.zonas.forEach(function (z) { zoneKwh[z.zona_id] = z.kwh; });

      var header = ['Zona', 'Dispositivo', 'Tipo', 'Consumo (kWh)'];
      if (priced) { header.push('Costo (COP)'); }
      header.push('% de la zona');
      return [headerCells(header)].concat(sortedDevices(data).map(function (d) {
        var total = zoneKwh[d.zona_id];
        var share = !d.sin_datos && d.kwh !== null && total > 0 ? Math.round(d.kwh / total * 1000) / 10 : null;
        var row = [
          cell(zoneName[d.zona_id] || ''),
          cell(d.nombre),
          cell(d.tipo === TIPO_HELO_S ? 'Estimado' : ''),
          d.sin_datos ? cell('Sin datos') : cell(d.kwh, XLSX_KWH_FORMAT)
        ];
        if (priced) { row.push(d.sin_datos ? cell(null) : cell(d.costo, XLSX_COP_FORMAT)); }
        row.push(cell(share, XLSX_KWH_FORMAT));
        return row;
      }));
    }

    function downloadZonesExcel(data, ctx) {
      return downloadExcel(data, ctx, 'Consumo por zona', 'zonas', zoneRows(data, ctx.priceState !== 'none'));
    }

    function downloadDevicesExcel(data, ctx) {
      return downloadExcel(data, ctx, 'Consumo por dispositivo', 'dispositivos', deviceRows(data, ctx.priceState !== 'none'));
    }

    /** One sheet: dashboard name, data period and generation time on top, then the table. */
    function downloadExcel(data, ctx, sheetName, suffix, tableRows) {
      return $q.when().then(function () {
        var periodo = data.periodo;
        var rows = [
          [cell(ctx.dashboardName || 'Dashboard')],
          [cell('Período de los datos: ' + edDate(periodo.fecha_inicio) + ' a ' + edDate(periodo.fecha_fin))],
          [cell('Generado: ' + formatGeneratedAt(ctx.generatedAt))],
          []
        ].concat(tableRows);

        var ws = XLSX.utils.aoa_to_sheet(rows.map(function (r) { return r.map(function (c) { return c.v; }); }));
        rows.forEach(function (r, ri) {
          r.forEach(function (c, ci) {
            var ref = XLSX.utils.encode_cell({ r: ri, c: ci });
            if (c.z && ws[ref] && ws[ref].t === 'n') { ws[ref].z = c.z; }
          });
        });
        ws['!cols'] = tableRows[0].map(function (c, i) { return { wch: i === 0 || c.v === 'Dispositivo' ? 32 : 18 }; });

        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        XLSX.writeFile(wb, fileName(ctx.dashboardName, periodo.fecha_inicio, periodo.fecha_fin, suffix, 'xlsx'));
      });
    }

    function cell(value, format) {
      return { v: value === undefined ? null : value, z: format };
    }

    function headerCells(titles) {
      return titles.map(function (title) { return cell(title); });
    }
  }

})();

(function () {
  'use strict';

  /**
   * Horizontal bars = kWh by zone, sorted descending. Clicking a bar selects the zone.
   * Uses amCharts 4 (loaded globally from index.html).
   */
  angular.module('BlurAdmin.consumo.energy_dashboard')
    .directive('energyZoneChart', energyZoneChart);

  var BASE_COLOR = '#2f80c9';
  var SELECTED_COLOR = '#f0a02b';
  var ROW_HEIGHT = 44;

  /** @ngInject */
  function energyZoneChart($q) {
    return {
      restrict: 'E',
      scope: {
        zonas: '=',
        selectedId: '=',
        onSelect: '&',
        exportApi: '=?'
      },
      template: '<div class="ed-chart"></div>',
      link: function (scope, element) {
        var chart = null;
        var series = null;
        var box = element.children()[0];

        // bridge for the PDF report: getPng() resolves with a PNG data URI or rejects
        scope.exportApi = {
          getPng: function () {
            if (!chart) { return $q.reject(new Error('chart not ready')); }
            return $q.when(chart.exporting.getImage('png')).then(function (png) {
              return png || $q.reject(new Error('empty chart image'));
            });
          }
        };

        scope.$watch('zonas', function (zonas) {
          if (!zonas) { return; }
          box.style.height = (zonas.length * ROW_HEIGHT + 60) + 'px';
          if (!chart) { create(); }
          chart.data = zonas;
        });

        scope.$watch('selectedId', function () {
          if (series) { series.columns.each(function (c) { c.fill = colorFor(c.dataItem); }); }
        });

        scope.$on('$destroy', function () {
          scope.exportApi = null;
          if (chart) { chart.dispose(); chart = null; series = null; }
        });

        function colorFor(dataItem) {
          var selected = dataItem && dataItem.dataContext && dataItem.dataContext.zona_id === scope.selectedId;
          return am4core.color(selected ? SELECTED_COLOR : BASE_COLOR);
        }

        function create() {
          chart = am4core.create(box, am4charts.XYChart);
          chart.paddingRight = 24;

          var category = chart.yAxes.push(new am4charts.CategoryAxis());
          category.dataFields.category = 'nombre';
          category.renderer.inversed = true; // first item (largest) on top
          category.renderer.grid.template.location = 0;
          category.renderer.minGridDistance = 20;
          category.renderer.labels.template.truncate = true;
          category.renderer.labels.template.maxWidth = 180;
          category.renderer.labels.template.tooltipText = '{category}';

          var value = chart.xAxes.push(new am4charts.ValueAxis());
          value.min = 0;
          value.title.text = 'kWh';

          series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.categoryY = 'nombre';
          series.dataFields.valueX = 'kwh';
          series.columns.template.strokeOpacity = 0;
          series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
          series.columns.template.tooltipText = '{categoryY}: {valueX.formatNumber("#,###.0")} kWh';
          series.columns.template.adapter.add('fill', function (fill, target) {
            return colorFor(target.dataItem);
          });
          series.columns.template.events.on('hit', function (ev) {
            var zonaId = ev.target.dataItem.dataContext.zona_id;
            scope.$evalAsync(function () { scope.onSelect({ zonaId: zonaId }); });
          });
        }
      }
    };
  }

})();

/**
 * Energy dashboard API client (Cognito-authenticated v3 gateway, role 6 only).
 *
 * All requests go through RESTServices.callHeloV2, which sends the Cognito id
 * token from fetchHeloV2IdToken and, on a 401, drops the cached token and
 * retries ONCE. A second 401 is NOT a logout: the backend also answers 401
 * when the user lacks role 6, so it is surfaced as a regular rejection with
 * a {message} and the session is left untouched.
 *
 * Every public method rejects with {message, status?} so controllers only
 * ever read err.message.
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.consumo.energy_dashboard')
    .factory('EnergyDashboardService', EnergyDashboardService);

  /** @ngInject */
  function EnergyDashboardService($q, $timeout, RESTServices) {

    var BASE = '/energy';
    var POLL_INTERVAL_MS = 3000;
    var POLL_MAX_ATTEMPTS = 40;

    return {
      listDashboards: listDashboards,
      getZonesWithDevices: getZonesWithDevices,
      createDashboard: createDashboard,
      getDashboardZones: getDashboardZones,
      listPeriods: listPeriods,
      createPeriod: createPeriod,
      updateDashboard: updateDashboard,
      deleteDashboard: deleteDashboard,
      updatePeriodPrices: updatePeriodPrices,
      deletePeriod: deletePeriod,
      getPeriodData: getPeriodData,
      todayString: todayString,
      yesterdayString: yesterdayString
    };

    /** GET /energy/dashboards -> [{id, nombre, creado_en, dispositivos_count, zonas:[{zona_id, nombre}]}] */
    function listDashboards() {
      return call('GET', BASE + '/dashboards').then(function (res) {
        return res.data || [];
      });
    }

    /**
     * GET /energy/selectable-devices ->
     * [{id, nombre, compartida, clienteNombre, dispositivos:[{id, nombre, tipo}]}]
     * (zone/device ids normalised to id; compartida = zone shared by another customer)
     */
    function getZonesWithDevices() {
      return call('GET', BASE + '/selectable-devices').then(function (res) {
        return (res.data || []).map(function (z) {
          return {
            id: z.zona_id,
            nombre: z.nombre,
            compartida: !!z.compartida,
            clienteNombre: z.cliente_nombre || '',
            dispositivos: (z.dispositivos || []).map(function (d) {
              return { id: d.dispositivo_id, nombre: d.nombre, tipo: d.tipo };
            })
          };
        });
      });
    }

    /** POST /energy/dashboards {nombre, dispositivos:[{dispositivo_id, zona_id}]} -> 201 {id, nombre, dispositivos} */
    function createDashboard(payload) {
      var nombre = payload && payload.nombre ? String(payload.nombre).trim() : '';
      return call('POST', BASE + '/dashboards', {
        nombre: nombre,
        dispositivos: payload.dispositivos
      }).then(function (res) { return res.data; });
    }

    /**
     * Zones that need a price in a new period of the dashboard: [{id, nombre}].
     * They come from the `zonas` of the dashboard in GET /energy/dashboards
     * (fetched fresh, so a dashboard created in an earlier session works).
     * Resolves with [] when the dashboard is not in the list.
     */
    function getDashboardZones(dashboardId) {
      return listDashboards().then(function (dashboards) {
        var dashboard = dashboards.filter(function (d) {
          return String(d.id) === String(dashboardId);
        })[0];
        return ((dashboard && dashboard.zonas) || []).map(function (z) {
          return { id: z.zona_id, nombre: z.nombre };
        });
      });
    }

    /** GET /energy/dashboards/{id}/periods -> [{id, fecha_inicio, fecha_fin, creado_en, precios:[{zona_id, precio_kwh}]}] sorted by fecha_fin desc */
    function listPeriods(dashboardId) {
      return call('GET', BASE + '/dashboards/' + dashboardId + '/periods').then(function (res) {
        return (res.data || []).slice().sort(function (a, b) {
          return a.fecha_fin < b.fecha_fin ? 1 : (a.fecha_fin > b.fecha_fin ? -1 : 0);
        });
      });
    }

    /**
     * POST /energy/dashboards/{id}/periods
     * body {fecha_inicio, fecha_fin, precios:[{zona_id, precio_kwh}]} -> 201 period
     */
    function createPeriod(dashboardId, payload) {
      return call('POST', BASE + '/dashboards/' + dashboardId + '/periods', {
        fecha_inicio: payload.fecha_inicio,
        fecha_fin: payload.fecha_fin,
        precios: payload.precios
      }).then(function (res) { return res.data; });
    }

    /** PATCH /energy/dashboards/{id} {nombre} -> 200 {id, nombre} */
    function updateDashboard(dashboardId, nombre) {
      return call('PATCH', BASE + '/dashboards/' + dashboardId, {
        nombre: nombre ? String(nombre).trim() : ''
      }).then(function (res) { return res.data; });
    }

    /** DELETE /energy/dashboards/{id} -> 204 (rejects with status 404 when already deleted) */
    function deleteDashboard(dashboardId) {
      return call('DELETE', BASE + '/dashboards/' + dashboardId).then(function () { return true; });
    }

    /**
     * PATCH /energy/dashboards/{id}/periods/{pid} {precios:[{zona_id, precio_kwh}]} -> 200 period.
     * `precios` is the FULL desired set: a zone left out ends with no price. Dates are immutable.
     */
    function updatePeriodPrices(dashboardId, periodId, precios) {
      return call('PATCH', BASE + '/dashboards/' + dashboardId + '/periods/' + periodId, {
        precios: precios
      }).then(function (res) { return res.data; });
    }

    /** DELETE /energy/dashboards/{id}/periods/{pid} -> 204 (rejects with status 404 when already deleted) */
    function deletePeriod(dashboardId, periodId) {
      return call('DELETE', BASE + '/dashboards/' + dashboardId + '/periods/' + periodId).then(function () { return true; });
    }

    /**
     * Consumption of one period. Resolves with the 200 payload; notifies
     * {total_days, ready_days} while the backfill runs. The returned promise
     * has a cancel() that stops polling.
     *
     * Polling design (do not "simplify" to status-only polling): the status
     * endpoint never claims or enqueues work, so a job that is already "listo"
     * but still has gaps would report pending=true forever. Only the data
     * endpoint claims the job and enqueues the backfill. Each round therefore
     * (1) reads status to show progress and to stop on a backfill error
     * (the data endpoint would silently re-claim an errored job, hiding the
     * failure and looping), then (2) re-calls the data endpoint.
     * A backfill error rejects with {backfillError: true}; the user retries
     * by calling getPeriodData again.
     */
    function getPeriodData(dashboardId, periodId) {
      var deferred = $q.defer();
      var base = BASE + '/dashboards/' + dashboardId + '/periods/' + periodId + '/consumption';
      var timer = null;
      var attempts = 0;
      var cancelled = false;

      fetchData();

      deferred.promise.cancel = function () {
        cancelled = true;
        if (timer) { $timeout.cancel(timer); }
      };
      return deferred.promise;

      function fetchData() {
        call('GET', base).then(function (res) {
          if (cancelled) { return; }
          if (res.status === 202) {
            deferred.notify(res.data && res.data.progress);
            scheduleNext();
            return;
          }
          deferred.resolve(res.data);
        }, fail);
      }

      function scheduleNext() {
        attempts++;
        if (attempts >= POLL_MAX_ATTEMPTS) {
          fail({ message: 'El cálculo del consumo está tardando más de lo esperado. Intenta de nuevo en unos minutos.', timeout: true });
          return;
        }
        timer = $timeout(checkStatus, POLL_INTERVAL_MS);
      }

      function checkStatus() {
        call('GET', base + '/status').then(function (res) {
          if (cancelled) { return; }
          var status = res.data || {};
          if (status.error) {
            fail({ message: 'No fue posible calcular el consumo de este período.', backfillError: true });
            return;
          }
          deferred.notify(status.progress);
          fetchData();
        }, fail);
      }

      function fail(err) {
        if (cancelled) { return; }
        deferred.reject(err);
      }
    }

    // ----------------------------------------------------------------- helpers
    /** callHeloV2 + normalisation of rejections to {message, status}. */
    function call(method, path, body) {
      return RESTServices.callHeloV2(method, path, body).catch(function (err) {
        return $q.reject(toError(err));
      });
    }

    function toError(err) {
      if (err && err.message && err.status === undefined) { return err; }
      var status = err && err.status;
      var apiMessage = err && err.data && err.data.message;
      var message;
      if (status === 401) {
        message = 'No tienes acceso al dashboard de consumo energético o tu sesión expiró.';
      } else if (status === 409) {
        message = 'Ya existe un período con esas fechas en este dashboard.';
      } else if (status === 400) {
        message = 'Datos inválidos' + (apiMessage ? ': ' + apiMessage : '.');
      } else if (status === 404) {
        message = 'No se encontró el recurso solicitado.';
      } else if (status > 0) {
        message = 'Ocurrió un error en el servidor. Intenta de nuevo.';
      } else {
        message = 'No fue posible conectar con el servidor.';
      }
      return { message: message, status: status };
    }

    function localDateString(date) {
      var m = date.getMonth() + 1;
      var d = date.getDate();
      return date.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
    }

    function todayString() { return localDateString(new Date()); }

    function yesterdayString() {
      var d = new Date();
      d.setDate(d.getDate() - 1);
      return localDateString(d);
    }
  }

})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.help')
        .directive('question', question);
  
    /** @ngInject */
    function question() {
      return {
        restrict: 'E',
        controller: 'questionCtrl',
        scope: {
          question: '=question'
        },
        templateUrl: 'app/help/question/question.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.help')
        .controller('questionCtrl', questionCtrl);

    /** @ngInject */
    function questionCtrl($scope) {
        $scope.status = {
            open: false,
        };

        $scope.showContent = function(){
            $scope.status.open =  !$scope.status.open;
        }
       
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.help')
        .directive('youtube', youtube);
  
    /** @ngInject */
    function youtube(youTubeApiService) {
        return {
            restrict: "E",

            scope: {
                height:   "@",
                width:    "@",
                videoid:  "@"  
            },

            template: '<div></div>',

            link: function(scope, element) {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                
                
                var player;
                youTubeApiService.onReady(function() {
                    player = setupPlayer(scope, element);
                });

                function setupPlayer(scope, element) {
                    return new YT.Player(element.children()[0], {
                        playerVars: {
                          autoplay: 0,
                          html5: 1,
                          theme: "light",
                          modesbranding: 0,
                          color: "white",
                          iv_load_policy: 3,
                          showinfo: 1,
                          controls: 1
                        },
                        
                        height: scope.height,
                        width: scope.width,
                        videoId: scope.videoid,
                    });
                }

                scope.$watch('videoid', function(newValue, oldValue) {
                    if (newValue == oldValue) {
                        return;
                    }

                    player.cueVideoById(scope.videoid);

                });

            }
        };
    }
})();
(function() {
    'use strict';
    angular.module('BlurAdmin.help').factory('youTubeApiService', function($q, $window) {
        var deferred = $q.defer();
        var apiReady = deferred.promise;

        $window.onYouTubeIframeAPIReady = function() {
            deferred.resolve();
        }

        return {
            onReady: function(callback) {
                apiReady.then(callback);
            }
        }
    })
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.instalador.dashboard_instalador')
        .controller('Dashboard_instaladorCtrl', Dashboard_instaladorCtrl);

    /** @ngInject */
    function Dashboard_instaladorCtrl($scope, $window, RESTServices, $filter, ngDialog, $localStorage, $log, $state, SHAREServices) {
        $scope.flag1 = false;
        $scope.flag2 = false;
        $scope.flag_generar = true;
        $scope.flag_copy = false;
        $scope.flag_crear_zona = true;
        $scope.flag_zona = false;
        $scope.flag_dia_facturacion = true;
        $scope.flag_valores = false;

        $scope.flag_no_usuario = true;

        //$scope.rol = '3';
        $scope.dispositivo = {};
        $scope.zona = {};

        $scope.cliente = {};
        $scope.cliente.nombre = "";
        $scope.cliente.ciudad = "";
        $scope.cliente.direccion = "";
        $scope.cliente.tel = "";

        $scope.usuario = {};
        $scope.usuario.nombre = "";
        $scope.usuario.apellido = "";
        $scope.usuario.email = "";
        $scope.usuario.contrasena = "";


        var params = {
            "id_instalador": $localStorage.id_usuario,
           //token: SHAREServices.hash_decode_token($localStorage.token),
            "id_usuario": $localStorage.id_usuario
        }
        RESTServices.post_header('instalador/lista_clientesxinstalador.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
            if (res.code == '200') {
                $scope.clientes = res.clientes;
            } else {
                $scope.clientes = [];
            }
            RESTServices.post_header('admin/lista_paises.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.paises = res.paises;
                }
            });
        });

        $scope.status = {
            isopen: false
        };

        $scope.toggled = function(open) {
            $log.log('Dropdown is now: ', open);
        };

        $scope.oneAtATime = true;

        $scope.agregar_disp = function(zona_id, cliente_nombre) {
            ngDialog.open({
                template: 'app/instalador/dashboard-instalador/templates/modal_id.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
                    //controller: 'Dashboard_instaladorCtrl'
            });
            $scope.zona_id = zona_id;
            $scope.flag_generar = true;
            $scope.flag_copy = false;
            var cliente = $filter('filter')($scope.clientes, { nombre: cliente_nombre }, true)[0];
            //get the index
            $scope.index_cliente = $scope.clientes.indexOf(cliente);
            var zona = $filter('filter')($scope.clientes[$scope.index_cliente].zonas, { id: zona_id }, true)[0];
            //get the index
            $scope.index_zona = $scope.clientes[$scope.index_cliente].zonas.indexOf(zona);

        }

        $scope.dia_facturacion_modal = function(cliente) {
            ngDialog.open({
                template: 'app/instalador/dashboard-instalador/templates/modal_dia_facturacion.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
                    //controller: 'Dashboard_instaladorCtrl'
            });
            var cliente_ = $filter('filter')($scope.clientes, { id: cliente.id }, true)[0];
            //get the index
            $scope.index_cliente = $scope.clientes.indexOf(cliente_);
            $scope.cliente_id = cliente.id;
            $scope.flag_dia_facturacion = true;
            $scope.cliente.dia_facturacion = parseInt($scope.clientes[$scope.index_cliente].dia_facturacion, 10);
        }
        $scope.valor_kwh_modal = function(cliente) {
            ngDialog.open({
                template: 'app/instalador/dashboard-instalador/templates/modal_valor_kwh_mes.html',
                className: 'ngdialog-theme-plain',
                width: 500,
                scope: $scope
            });
            $scope.flag_valores = false;
            var cliente_ = $filter('filter')($scope.clientes, { id: cliente.id }, true)[0];
            //get the index
            $scope.index_cliente = $scope.clientes.indexOf(cliente_);
            $scope.cliente_id = cliente.id;
            for (var i = 0; i < 12; i++) {
                $scope.meses[i].valorkwh = "";
            }

        }
        $scope.years = ["2017", "2018", "2019"];
        $scope.meses = [{
                "nombre": "Enero",
                "valorkwh": ""
            },
            {
                "nombre": "Febrero",
                "valorkwh": ""
            },
            {
                "nombre": "Marzo",
                "valorkwh": ""
            },
            {
                "nombre": "Abril",
                "valorkwh": ""
            },
            {
                "nombre": "Mayo",
                "valorkwh": ""
            },
            {
                "nombre": "Junio",
                "valorkwh": ""
            },
            {
                "nombre": "Julio",
                "valorkwh": "",
            },
            {
                "nombre": "Agosto",
                "valorkwh": ""
            },
            {
                "nombre": "Septiembre",
                "valorkwh": ""
            },
            {
                "nombre": "Octubre",
                "valorkwh": ""
            },
            {
                "nombre": "Noviembre",
                "valorkwh": ""
            },
            {
                "nombre": "Diciembre",
                "valorkwh": ""
            }
        ];


        $scope.agregar_zona = function(cliente_id) {
            ngDialog.open({
                template: 'app/instalador/dashboard-instalador/templates/modal_zona.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
            });
            $scope.flag_crear_zona = true;
            $scope.flag_zona = false;
            $scope.cliente_id = cliente_id;
            var cliente = $filter('filter')($scope.clientes, { id: cliente_id }, true)[0];
            //get the index
            $scope.index_cliente = $scope.clientes.indexOf(cliente);

        }

        $scope.copy_value = function() {
            var id_cont = angular.element(document.querySelector('#id_cont'));
            id_cont.value;

        }

        $scope.show = function() {
            $scope.flag1 = !$scope.flag1;
        }

        $scope.show_menu = function() {
            $scope.flag2 = !$scope.flag2;
        }

        $scope.obtener_code = function(dispositivo) {
            var params = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "nombre": dispositivo.nombre,
                "id_zona": $scope.zona_id,
                "potencia": dispositivo.potencia
            }
            RESTServices.post_header('instalador/genera_dispositivo.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    $scope.dispositivo.id_nuevo = ans.dispositivo.code;
                    $scope.flag_generar = false;
                    if ($scope.clientes[$scope.index_cliente].zonas[$scope.index_zona].dispositivos == null) $scope.clientes[$scope.index_cliente].zonas[$scope.index_zona].dispositivos = [];
                    $scope.clientes[$scope.index_cliente].zonas[$scope.index_zona].dispositivos.push(ans.dispositivo);
                }
            });
        }

        $scope.crear_zona = function(zona) {
            var params = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "nombre": zona.nombre,
                "id_cliente": $scope.cliente_id
            }
            RESTServices.post_header('instalador/genera_zona.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200' && ans.estado == true) {
                    $scope.flag_crear_zona = false;
                    $scope.flag_zona = true;
                    var zona = {
                        nombre: params.nombre,
                        dispositivos: null,
                        id: ans.id_zona
                    }
                    if ($scope.clientes[$scope.index_cliente].zonas == undefined) $scope.clientes[$scope.index_cliente].zonas = [];
                    $scope.clientes[$scope.index_cliente].zonas.push(zona);
                    $scope.zona = {};
                }
            });
        }

        $scope.agregar_dia_facturacion = function(cliente) {
            var params = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "dia": cliente.dia_facturacion,
                "id_cliente": $scope.cliente_id
            }

            RESTServices.post_header('instalador/genera_dia_facturacion.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    $scope.flag_dia_facturacion = false;
                    $scope.clientes[$scope.index_cliente].dia_facturacion = params.dia_facturacion;
                }
            });
        }

        $scope.addValorkwh = function(meses, year) {
            var params = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "year": year,
                "id_cliente": $scope.cliente_id,
                "valores": [meses[0].valorkwh, meses[1].valorkwh, meses[2].valorkwh, meses[3].valorkwh, meses[4].valorkwh, meses[5].valorkwh, meses[6].valorkwh, meses[7].valorkwh, meses[8].valorkwh, meses[9].valorkwh, meses[10].valorkwh, meses[11].valorkwh]
            }

            RESTServices.post_header('instalador/genera_valores_kwh.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    $scope.flag_valores = true;
                    for (var i = 0; i < 12; i++) {
                        $scope.meses[i].valorkwh = "";
                    }
                }
            });
        }

        $scope.obtener_valores = function(year) {
            var params = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "year": year,
                "id_cliente": $scope.cliente_id
            }
            RESTServices.post_header('instalador/entrega_valores_kwh.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    $scope.flag_valores = false;
                    for (var i = 0; i < 12; i++) {
                        $scope.meses[i].valorkwh = parseInt(ans.valores[i], 10);
                    }
                }
            });
        }

        $scope.copy = function() {
            $scope.flag_copy = true;
        }


        $scope.listar_estados = function(pais) {

            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "id_pais": pais.id
            };

            RESTServices.post_header('admin/lista_estados.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.estados = res.estados;
                }
            });
        }

        $scope.listar_ciudades = function(estado) {
            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "id_estado": estado.id
            };

            RESTServices.post_header('admin/lista_ciudades.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.ciudades = res.ciudades;
                }
            });
        }
        /*
        $scope.agregar_cliente = function() {
            ngDialog.open({
                template: 'app/admin/templates/modal_cliente.html',
                className: 'ngdialog-theme-plain',
                width: 300,
                scope: $scope
            });
            $scope.flag_crear_cliente = true;
            $scope.flag_cliente = false;
        }*/

        $scope.crear_cliente = function(cliente) {

            $scope.flag_error = false;
            if (cliente.nombre != "" && cliente.ciudad != "" && cliente.direccion != "" && cliente.tel != "") {
                cliente.referencia = Math.floor(Math.random() * (1999999999 - 1000000000 + 1) + 1000000000);

                var fields = {
                    "id_usuario": $localStorage.id_usuario,
                   //token: SHAREServices.hash_decode_token($localStorage.token),
                    "cliente": cliente
                };

                RESTServices.post_header('admin/crear_cliente.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                    if (res.code == '200') {
                        var cliente_aux = {};
                        cliente_aux.nombre = cliente.nombre;
                        cliente_aux.ciudad = cliente.ciudad;
                        cliente_aux.id = res.id;
                        cliente_aux.usuarios = null;
                        $scope.clientes.push(cliente_aux);

                        var fields_ = {
                            "id_usuario": $localStorage.id_usuario,
                           //token: SHAREServices.hash_decode_token($localStorage.token),
                            "id_cliente": cliente_aux.id,
                            "id_instalador": $localStorage.id_usuario
                        };

                        RESTServices.post_header('admin/asociar_clienteainstalador.php', fields_, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                            if (res.code == '200') {
                                $scope.cliente.nombre = "";
                                $scope.cliente.ciudad = "";
                                $scope.cliente.direccion = "";
                                $scope.cliente.tel = "";
                                $scope.flag_crear_cliente = false;
                                $scope.flag_cliente = true;
                                //$window.location.reload();
                            }
                        });


                    }
                });
            } else {
                $scope.flag_error = true;
            }

        }

        $scope.usuarios_cliente = function(cliente, index) {
            //$scope.rol = 'cliente';
            $scope.cliente = cliente;
            $scope.index_cliente = index;
            if (cliente.usuarios != null) $scope.flag_no_usuario = false;
            else $scope.flag_no_usuario = true;

            ngDialog.open({
                template: 'app/instalador/dashboard-instalador/templates/modal_usuarios_cliente.html',
                className: 'ngdialog-theme-plain',
                width: 450,
                scope: $scope
            });
        }



        $scope.cerrar = function() {
            ngDialog.close();
            $scope.dispositivo = {};
        }


        $scope.showNotificacion = function() {
            $scope.notificacion = false;
            $location.hash('grafica_comparativa');
            $anchorScroll();
        }
        $scope.notificacion = true;
        angular.element(document.querySelector("#tawkchat-container")).css("display", "inherit");

    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.instalador.projects')
      .controller('projectsCtrl_', projectsCtrl_);
  
    function projectsCtrl_($scope, $rootScope, $localStorage, RESTServices, $timeout, utilities, SHAREServices) {
        
        $rootScope.flag_loading = false;
        //$scope.rol = '3';

    }

})();
(function() {
    'use strict';
    angular.module('BlurAdmin.instalador.projects').factory('projectsUtil', function() {
        return {
            selectClass: function(type) {
                switch (type) {
                    case 1:
                        return 'icon-light';
                        break;
                    case 2:
                        return 'icon-aires';
                        break;
                    case 3:
                        return 'icon-measurer';
                        break;
                    case 4:
                        return 'icon-temperature';
                        break;
                }
            },
        }
    })
})();
(function() {
    'use strict';
    angular.module('BlurAdmin').service('userServices', userServices);

    function userServices() {
        return {
            avatares : [
                {
                    link: 'avatar1.svg',
                    status: false,
                    id: 0
    
                },
                {
                    link: 'avatar2.svg',
                    status: false,
                    id: 1
    
                },
                {
                    link: 'avatar3.svg',
                    status: false,
                    id: 2
    
                },
                {
                    link: 'avatar4.svg',
                    status: false,
                    id: 3
    
                },
                {
                    link: 'avatar5.svg',
                    status: false,
                    id: 4
    
                },
                {
                    link: 'avatar6.svg',
                    status: false,
                    id: 5
    
                }
            ],

            setAvatar: function(id){
                return this.avatares[id];
            },

            roles: [
                {
                    text: 'Controlador',
                    value: '0',
                },
                {
                    text: 'Visualizador',
                    value: '5',
                },
                {
                    text: 'Monitoreo',
                    value: '6',
                },
                {
                    text: 'Técnico',
                    value: '7',
                },
                {
                    text: 'Coordinador',
                    value: '8',
                },
                {
                    text: 'Monitoreo Plano',
                    value: '9',
                },
                {
                    text: 'Monitoreo Plano visualización',
                    value: '10',
                },
                {
                    text: 'Monitoreo Plano control',
                    value: '11',
                },
                {
                    text: 'Coordinador producción',
                    value: '12',
                },
            ]


        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.instalador.users')
        .controller('usersCtrl', usersCtrl);

    function usersCtrl($scope, $rootScope, $stateParams, userServices, RESTServices, $localStorage, $state) {

        $rootScope.flag_loading = false;
        $scope.rol = '3';

        if ($stateParams.cliente == null) {
            $state.go('dashboard_instalador');
            /*var params = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "id_cliente": $localStorage.id_cliente ? $localStorage.id_cliente : null,
            }

            RESTServices.post('', params).then(function(res) {
                if (res.code == '200') {
                    formatUsers(res.usuarios);
                }
            })*/
        } else {
            $localStorage.id_cliente = $stateParams.cliente.id;
            $scope.cliente = $stateParams.cliente;
            formatUsers($scope.cliente.usuarios);
        }

        function formatUsers(usuarios) {
            if (usuarios !== null) {
                $scope.users = usuarios.map(function(u) {
                    return ({
                        nombre: u.nombre,
                        apellido: u.apellido,
                        email: u.email,
                        id: u.id ? u.id : null,
                        avatar: userServices.setAvatar(u.avatar),
                        rol: u.rol,
                    })
                });
            }

        }

        if ($stateParams.newUser){
            if($scope.users != undefined)$scope.users.push($stateParams.newUser);
            else{
                $scope.users=[]; 
                $scope.users.push($stateParams.newUser);
            }
        } 

        $scope.$on('userDelected', function(event, result) {
            var index = $scope.users.findIndex(function(i) { return i.id == result.data.id });
            $scope.users.splice(index, 1);
            if ($scope.users.length == 0) {
                $scope.noUsers = true;
            }
        });

        $scope.$on('editUser', function(event, result) {
            var index = $scope.users.findIndex(function(i) { return i.id == result.data.id });
            $scope.users[index] = result.data;
        });

    }

})();
/**

 */
(function() {
    'use strict';

    angular.module('BlurAdmin.operador.dashboard_operador')
        .controller('Dashboard_operadorCtrl', Dashboard_operadorCtrl);

    /** @ngInject */
    function Dashboard_operadorCtrl($scope, $window, RESTServices, $filter, ngDialog, $localStorage,  SHAREServices) {

        $scope.rol = '1';
        $scope.today = new Date();
        $scope.today_2h = $filter('date')($scope.today.setHours($scope.today.getHours() + 2), 'HH:MM');
        $scope.today = $filter('date')($scope.today, 'yyyy-MM-dd');
        $scope.flag_msg_oferta = false;
        $scope.ofertas_finalizadas = [];
        $scope.user_name = $localStorage.nombre_cliente;


        ////////////////función tabla inteligente

        $scope.OpenOferta_lanzar = true;
        $scope.OpenOferta_abiertas = false;
        $scope.OpenOferta_ejecutandose = false;
        $scope.OpenOferta_finalizadas = false;
        /*$scope.status = {
          OpenOferta_lanzar: false,
        };*/
        $scope.showPanel = function(ind) {
            switch (ind) {
                case 1:
                    $scope.OpenOferta_lanzar = !$scope.OpenOferta_lanzar;
                    break;
                case 2:
                    $scope.OpenOferta_abiertas = !$scope.OpenOferta_abiertas;
                    break;
                case 3:
                    $scope.OpenOferta_ejecutandose = !$scope.OpenOferta_ejecutandose;
                    break;
                case 4:
                    $scope.OpenOferta_finalizadas = !$scope.OpenOferta_finalizadas;
                    break;
            }

        }

        var fields = {
            id_usuario: $localStorage.id_usuario,
            //token: SHAREServices.hash_decode_token($localStorage.token)
        };

        RESTServices.post_header('comercializador/consulta_ciudades.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
            if (ans.code == '200') {
                $scope.ciudades = ans.ciudades;

                RESTServices.post_header('comercializador/consulta_ofertas.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans2) {
                    if (ans2.code == '200') {
                        $scope.ofertas = ans2.ofertas;
                        for (var i = 0; i < $scope.ofertas.length; i++) {
                            $scope.ofertas[i].dia = new Date($scope.ofertas[i].dia.replace(/-/g, '\/'));
                            $scope.ofertas[i].hini = Date.parse('1990-01-01 ' + $scope.ofertas[i].hini);
                            $scope.ofertas[i].hfin = Date.parse('1990-01-01 ' + $scope.ofertas[i].hfin);
                            $scope.ofertas[i].kw = parseInt($scope.ofertas[i].kw, 10);
                            $scope.ofertas[i].precio_kwh = parseInt($scope.ofertas[i].precio_kwh, 10);
                            var ciudad = $filter('filter')($scope.ciudades, { id: $scope.ofertas[i].id_ciudad }, true)[0];
                            $scope.ofertas[i].ciudad = ciudad.nombre;
                            $scope.ofertas[i].flag = true;
                            $scope.ofertas[i].nuevo = false;
                            if ($scope.ofertas[i].estado == 4) {
                                $scope.ofertas[i].dia = $filter('date')($scope.ofertas[i].dia, 'yyyy-MM-dd');
                                $scope.ofertas_finalizadas.push($scope.ofertas[i]);
                            }

                        }
                        $scope.totalItems = $scope.ofertas_finalizadas.length;
                    }
                });
            }
        });


        /////////////////////////////////////////////////// 

        $scope.nuevo_tamano, $scope.nuevo_valor, $scope.nueva_ciudad, $scope.hora_fin, $scope.hora_in = null;
        $scope.nuevos = [];
        ///////funciones 

        $scope.editar = function(index) {
            if ($scope.nuevos[index] == undefined) $scope.nuevos[index] = {};
            $scope.nuevos[index].kw = $scope.ofertas[index].kw;
            $scope.nuevos[index].precio_kwh = $scope.ofertas[index].precio_kwh;
            $scope.nuevos[index].ciudad = $scope.ofertas[index].ciudad;
            $scope.nuevos[index].dia = $scope.ofertas[index].dia;
            $scope.nuevos[index].hini = $scope.ofertas[index].hini;
            $scope.nuevos[index].hfin = $scope.ofertas[index].hfin;
            $scope.ofertas[index].flag = !$scope.ofertas[index].flag;
            $scope.ofertas[index].nuevo = false;
        };

        $scope.guardar = function(index, nuevos) {
            if ((nuevos.kw != undefined) && (nuevos.precio_kwh != undefined) && (nuevos.ciudad != undefined) && (nuevos.dia != undefined) && (nuevos.hini != undefined) && (nuevos.hfin != undefined)) {
                $scope.today = new Date();
                $scope.today_2h = $filter('date')($scope.today.setHours($scope.today.getHours() + 2), 'HH:MM');
                $scope.today = $filter('date')($scope.today, 'yyyy-MM-dd');
                var dia = $filter('date')(nuevos.dia, 'yyyy-MM-dd');
                var hora_in = $filter('date')(nuevos.hini, 'HH:MM');

                if (($scope.today == dia) && ($scope.today_2h > hora_in)) {
                    $scope.flag_msg_oferta = true;
                    $scope.msg = "La oferta de desconexión a lanzar debe tener como mínimo 2 horas de antelación para que los consumidores puedan aprobarla";
                } else if (nuevos.hfin < nuevos.hini) {
                    $scope.flag_msg_oferta = true;
                    $scope.msg = "La hora de inicio de la desconexión debe ser menor que la hora de finalización";
                } else {
                    if (nuevos.hini != $scope.ofertas[index].hini) {
                        if (nuevos.hini.getHours() < 10) {
                            if (nuevos.hini.getMinutes() < 10) {
                                hora_in = '0' + nuevos.hini.getHours() + ':' + '0' + nuevos.hini.getMinutes();
                            } else {
                                hora_in = '0' + nuevos.hini.getHours() + ':' + nuevos.hini.getMinutes();
                            }
                        } else {
                            if (nuevos.hini.getMinutes() < 10) {
                                hora_in = nuevos.hini.getHours() + ':' + '0' + nuevos.hini.getMinutes();
                            } else {
                                hora_in = nuevos.hini.getHours() + ':' + nuevos.hini.getMinutes();
                            }
                        }
                    } else {
                        hora_in = $filter('date')(nuevos.hini, 'shortTime');
                        if (hora_in.length == 9) {
                            hora_in = '0' + hora_in;
                        }
                        if (hora_in[6] == 'p') {
                            var hora = hora_in[0] + hora_in[1];
                            hora = parseInt(hora, 10) + 12;
                            hora = hora.toString();
                            hora_in = hora[0] + hora[1] + ":" + hora_in[3] + hora_in[4];
                        }
                    }

                    if (nuevos.hfin != $scope.ofertas[index].hfin) {
                        if (nuevos.hfin.getHours() < 10) {
                            if (nuevos.hfin.getMinutes() < 10) {
                                var hora_fin = '0' + nuevos.hfin.getHours() + ':' + '0' + nuevos.hfin.getMinutes();
                            } else {
                                var hora_fin = '0' + nuevos.hfin.getHours() + ':' + nuevos.hfin.getMinutes();
                            }
                        } else {
                            if (nuevos.hfin.getMinutes() < 10) {
                                var hora_fin = nuevos.hfin.getHours() + ':' + '0' + nuevos.hfin.getMinutes();
                            } else {
                                var hora_fin = nuevos.hfin.getHours() + ':' + nuevos.hfin.getMinutes();
                            }
                        }
                    } else {
                        var hora_fin = $filter('date')(nuevos.hfin, 'shortTime');
                        if (hora_fin.length == 9) {
                            hora_fin = '0' + hora_fin;
                        }
                        if (hora_fin[6] == 'p') {
                            var hora = hora_fin[0] + hora_fin[1];
                            hora = parseInt(hora, 10) + 12;
                            hora = hora.toString();
                            hora_fin = hora[0] + hora[1] + ":" + hora_fin[3] + hora_fin[4];
                        }
                    }

                    var ciudad = $filter('filter')($scope.ciudades, { nombre: nuevos.ciudad }, true)[0];

                    $scope.flag_msg_oferta = false;
                    if ($scope.ofertas[index].nuevo) {
                        var params = {
                            dia: dia,
                            hini: hora_in,
                            hfin: hora_fin,
                            kw: nuevos.kw,
                            precio_kwh: nuevos.precio_kwh,
                            id_ciudad: ciudad.id,
                            estado: 1,
                            id_usuario: $localStorage.id_usuario,
                            //token: SHAREServices.hash_decode_token($localStorage.token)
                        }

                        RESTServices.post_header('comercializador/genera_oferta.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                            if (ans.code == 200) {
                                $scope.flag_msg_oferta = false;
                                $scope.ofertas[index].kw = nuevos.kw;
                                $scope.ofertas[index].precio_kwh = nuevos.precio_kwh;
                                $scope.ofertas[index].ciudad = nuevos.ciudad; //ciudad.id;
                                $scope.ofertas[index].dia = nuevos.dia;
                                $scope.ofertas[index].hini = nuevos.hini;
                                $scope.ofertas[index].hfin = nuevos.hfin;
                                $scope.ofertas[index].flag = !$scope.ofertas[index].flag;
                                $scope.ofertas[index].estado = 1;
                                $scope.ofertas[index].nuevo = false;

                            } else {
                                $scope.flag_msg_oferta = true;
                                $scope.msg = "No se ha podido registrar la oferta por inconsistencias con la información suministrada";
                            }
                        });
                    } else {
                        var params = {
                            dia: dia,
                            hini: hora_in,
                            hfin: hora_fin,
                            kw: nuevos.kw,
                            precio_kwh: nuevos.precio_kwh,
                            id_ciudad: ciudad.id,
                            id_usuario: $localStorage.id_usuario,
                            //token: SHAREServices.hash_decode_token($localStorage.token),
                            id_oferta: $scope.ofertas[index].id
                        }
                        RESTServices.post_header('comercializador/edita_oferta.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                            if (ans.code == 200) {
                                $scope.flag_msg_oferta = false;
                                $scope.ofertas[index].kw = nuevos.kw;
                                $scope.ofertas[index].precio_kwh = nuevos.precio_kwh;
                                $scope.ofertas[index].ciudad = nuevos.ciudad; //ciudad.id;
                                $scope.ofertas[index].dia = nuevos.dia;
                                $scope.ofertas[index].hini = nuevos.hini;
                                $scope.ofertas[index].hfin = nuevos.hfin;
                                $scope.ofertas[index].flag = !$scope.ofertas[index].flag;
                                $scope.ofertas[index].nuevo = false;

                            } else {
                                $scope.flag_msg_oferta = true;
                                $scope.msg = "No se ha podido editar la oferta por inconsistencias con la información suministrada";
                            }
                        });
                    }
                }
            } else {
                $scope.flag_msg_oferta = true;
                if (nuevos.kw == undefined) {
                    $scope.msg = "Debes definir un tamaño en kW de la potencia que necesitas desconectar";
                } else if (nuevos.precio_kwh == undefined) {
                    $scope.msg = "Debes definir un valor del kWh que ofrecerás a tus consumidores por desconectarse";
                } else if (nuevos.ciudad == undefined) {
                    $scope.msg = "Debes definir la ciudad en la que deseas realizar las desconexiones";
                } else if (nuevos.dia == undefined) {
                    $scope.msg = "Debes definir el día en que se realizará la desconexión, como mínimo se acepta el día actual";
                } else if (nuevos.hini == undefined) {
                    $scope.msg = "Debes definir una hora inicial para la oferta de desconexión";
                } else if (nuevos.hfin == undefined) {
                    $scope.msg = "Debes definir una hora final para la oferta de desconexión";
                }
            }
        };
        $scope.cancelar = function(index) {
            //$scope.ofertas[index].flag = !$scope.ofertas[index].flag;
            $scope.ofertas.splice(index, 1);

        };

        $scope.borrar = function(index) {
            if ($scope.ofertas[index].id != undefined) {
                var params = {
                    id_oferta: $scope.ofertas[index].id,
                    id_usuario: $localStorage.id_usuario,
                    //token: SHAREServices.hash_decode_token($localStorage.token)
                }
                RESTServices.post_header('comercializador/elimina_oferta.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                    if (ans.code == 200) {
                        $scope.flag_msg_oferta = false;
                        $scope.ofertas.splice(index, 1);
                    } else {
                        $scope.flag_msg_oferta = true;
                        $scope.msg = "No se ha podido eliminar la oferta por inconsistencias con la información suministrada";
                    }
                });
            }
        }

        $scope.addOferta = function() {
            $scope.inserted = {
                kw: null,
                precio_kwh: null,
                hini: null,
                hfin: null,
                ciudad: null,
                flag: false,
                nuevo: true,
                estado: 1
            };
            $scope.ofertas.push($scope.inserted);
        };

        $scope.ismeridian = true;


        $scope.currentPage = 1;
        $scope.itemsPerPage = 5;


        $scope.fecha = function() {
            $scope.fecha_filtro = $filter('date')($scope.des_f_ini, 'yyyy-MM-dd');
            $scope.ofertas_filtradas = $filter('filter')($scope.ofertas_finalizadas, { dia: $scope.fecha_filtro }, true);
            $scope.totalItems = $scope.ofertas_filtradas.length;
        }
        $scope.open1 = function() {
            $scope.popup.opened = true;
        };

        $scope.options1 = {
            showWeeks: false
        };

        $scope.popup = {
            opened: false,
        };

        $scope.status = {
            isopen: false
        };

        $scope.refresh = function() {
            $scope.fecha_filtro = undefined;
            $scope.totalItems = $scope.ofertas_finalizadas.length;
        }


        $scope.showNotificacion = function() {
            $scope.notificacion = false;
            $location.hash('grafica_comparativa');
            $anchorScroll();
        }
        $scope.notificacion = true;
        angular.element(document.querySelector("#tawkchat-container")).css("display", "inherit");


    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.operador.ofertas')
        .controller('ofertasCtrl', ofertasCtrl);

    /** @ngInject */
    function ofertasCtrl($scope, $element, $filter, baConfig, layoutPaths, $window, $localStorage, ngDialog, SHAREServices) {

        $scope.rol = '1';

        $scope.ofertas_estado_mes_deuda = true;

        $scope.ofertas_ejecutadas = [{
                hora_in: '11:00',
                hora_fin: '12:00',
                valor_oferta: 200,
                fecha_limite: '12/06/2017',
                id: 0,
                ciudad: "Medellín",
                tamano_oferta: 20000,
                clientes_participantes: 50,
                porcentaje_alcanzado: 50,
                kwh_desconectados: 10000,
                costo: 2000000,
                clientes_desconectados: [{
                        estado: false,
                        nombre: "Hotel san fernando",
                        carga_desconectada: 600,
                        zonas_desconectadas: [{
                                nombre: "Lobby",
                                valor: 100,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "Corredor 1",
                                valor: 200,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "hab 8",
                                valor: 300,
                                estado: false,
                                dispositivos: []
                            }
                        ]
                    },
                    {
                        estado: false,
                        nombre: "CC camino real",
                        carga_desconectada: 600,
                        zonas_desconectadas: [{
                                nombre: "Primer piso",
                                valor: 100,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "Zona común Movistar",
                                valor: 200,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "Cuarto de maquinas",
                                valor: 300,
                                estado: false,
                                dispositivos: []
                            }
                        ]
                    },
                    {
                        estado: false,
                        nombre: "Tecnoparque",
                        carga_desconectada: 600,
                        zonas_desconectadas: [{
                                nombre: "Cuarto servicio",
                                valor: 100,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "recepción",
                                valor: 200,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "Lab1",
                                valor: 300,
                                estado: false,
                                dispositivos: []
                            }
                        ]
                    }

                ]

            },
            {
                hora_in: '11:00',
                hora_fin: '12:00',
                valor_oferta: 200,
                fecha_limite: '12/06/2017',
                id: 0,
                ciudad: "Bogotá",
                tamano_oferta: 20000,
                clientes_participantes: 50,
                porcentaje_alcanzado: 50,
                kwh_desconectados: 10000,
                costo: 2000000,
                clientes_desconectados: [{
                        estado: false,
                        nombre: "Hotel san fernando",
                        carga_desconectada: 600,
                        zonas_desconectadas: [{
                                nombre: "Lobby",
                                valor: 100,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "Corredor 1",
                                valor: 200,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "hab 8",
                                valor: 300,
                                estado: false,
                                dispositivos: []
                            }
                        ]
                    },
                    {
                        estado: false,
                        nombre: "CC camino real",
                        carga_desconectada: 600,
                        zonas_desconectadas: [{
                                nombre: "Primer piso",
                                valor: 100,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "Zona común Movistar",
                                valor: 200,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "Cuarto de maquinas",
                                valor: 300,
                                estado: false,
                                dispositivos: []
                            }
                        ]
                    },
                    {
                        estado: false,
                        nombre: "Tecnoparque",
                        carga_desconectada: 600,
                        zonas_desconectadas: [{
                                nombre: "Cuarto servicio",
                                valor: 100,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "recepción",
                                valor: 200,
                                estado: false,
                                dispositivos: []
                            },
                            {
                                nombre: "Lab1",
                                valor: 300,
                                estado: false,
                                dispositivos: []
                            }
                        ]
                    }

                ]

            }

        ];

        $scope.meses = [{
                nombre: "enero"
            },
            {
                nombre: "febrero"
            },
            {
                nombre: "marzo"
            },
            {
                nombre: "abril"
            },
            {
                nombre: "mayo"
            },
            {
                nombre: "junio"
            },
            {
                nombre: "julio"
            },
            {
                nombre: "agosto"
            },
            {
                nombre: "septiembre"
            },
            {
                nombre: "octubre"
            },
            {
                nombre: "noviembre"
            },
            {
                nombre: "diciembre"
            }
        ];


        $scope.showNotificacion = function() {
            $scope.notificacion = false;
            $location.hash('grafica_comparativa');
            $anchorScroll();
        }
        $scope.notificacion = true;
        angular.element(document.querySelector("#tawkchat-container")).css("display", "inherit");


        $scope.getMes = function(mes) {

        }

        $scope.enviarPago = function(mes) {
            ngDialog.open({
                template: 'app/operador/ofertas/modals/enviar_pago.html',
                className: 'ngdialog-theme-plain',
                closeByDocument: true,
                scope: $scope,
                controller: ['$scope', function($scope) {
                    // controller logic
                    $scope.mes = mes;
                    $scope.info_pago = {
                        ofertas_totales: 2,
                        carga_desconectada_total: 20000,
                        clientes_participantes: 50,
                        horas_desconectadas: 8,
                        total_kwh_desconectados: 20000,
                        total_pagar: 500000,
                    };

                    $scope.enviar = function() {
                        ngDialog.close();

                    };




                }]
            })
        };

    }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.operador.statistics')
    .controller('StatisticsCtrl', StatisticsCtrl);

  /** @ngInject */
  function StatisticsCtrl($scope,$element, baConfig, layoutPaths,$window) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  
  $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });

  }

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.profile')
      .controller('membershipCouponCtrl', membershipCouponCtrl);
  
    function membershipCouponCtrl($scope, $localStorage, RESTServices, toastr, $state,SHAREServices) {
        
        $scope.sendCoupon = function(coupon) {
            $scope.errorCoupon = false;
            $scope.errorMembership = false;
            coupon = coupon.toUpperCase();

            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "codigo_promo": coupon,
            };

            RESTServices.post_header('cliente/agrega_codigo_promo.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response !== undefined) {
                    if (response.code === '200') {
                        $state.go('dashboard_cliente');                 
                    } else if(response.code === '700') {
                        $scope.errorMembership = true;
                    } else {
                        $scope.errorCoupon = true;
                    }
                } else {
                    toastr.error('Hubo un error en la plataforma, intenta de nuevo más tarde.', 'Cupón');
                }
                
            });
        }
    }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.settings')
    .controller('devToolsCtrl', devToolsCtrl);

  function devToolsCtrl($scope, $localStorage, RESTServices, toastr, SHAREServices, $timeout) {

      $scope.uid = '';
      
      $timeout(function(){

          var fields = {
              "id_usuario": $localStorage.id_usuario,
          };

          RESTServices.post_header('cliente/consulta_uid.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
              if (response !== undefined) {
                  if (response.code === '200') {
                      $scope.uid = response.uid;                
                  }
              } else {
                  toastr.error('Hubo un error en la plataforma, intenta de nuevo más tarde.', 'u_id');
              }
          });
      })
  
  }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.settings')
      .controller('holidaysCtrl', holidaysCtrl);
  
    function holidaysCtrl($scope, $state, $localStorage, RESTServices, $timeout, SHAREServices, $stateParams) {
      
      $scope.countries = [];
      $scope.selectedComponent = $stateParams.step;
      $timeout(function(){
        var params = {
          "id_usuario": $localStorage.id_usuario,
        };

        RESTServices.post_header('cliente/consulta_paises_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
            if (data != null && data.code === '200') {
              $scope.countries = data.paises;
              $scope.selectedComponent = 1;
            } else if(data != null && data.code === '400') {
              $state.go('settings.devTools')
            }
        })
      })

      $scope.$on('gotoAddCreateHolidays', function(e, res){
        $scope.selectedComponent = res.ind;
      })

      $scope.$on('deletedCountry', function(e, res){
        var index = $scope.countries.findIndex(function(c){return c.id === res.pais.id});
        $scope.countries.splice(index, 1);
      })
      

    }

})();
/**
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.admin.dashboard_admin')
        .controller('Dashboard_adminCtrl', Dashboard_adminCtrl);

    /** @ngInject */
    function Dashboard_adminCtrl($scope, $window, RESTServices, $filter, ngDialog, $localStorage, SHAREServices) {
        $scope.flag1 = false;
        $scope.flag2 = false;
        $scope.rol = '2';

        $scope.ofertas = [{
                "carga": "400kw", //este valor debe ser una variable traida desde el servidor
                "h_inicio": "21/12/2016 - 21:00",
                "h_final": "22:00",
            },

            {
                "carga": "500kw", //este valor debe ser una variable traida desde el servidor
                "h_inicio": "8:00",
                "h_final": "10:00",
            },

            {
                "carga": "200kw", //este valor debe ser una variable traida desde el servidor
                "h_inicio": "12:00",
                "h_final": "13:00",
            }

        ];



        $scope.add_programacion = function(zona) {
            ngDialog.open({
                template: 'app/pages/dashboard/templates/add_programacion.html',
                className: 'ngdialog-theme-plain',
                closeByDocument: false,
                controller: ['$scope', function($scope) {
                    // controller logic
                    $scope.titleModal = 'Programación de apagado';
                    $scope.bodyModal = 'Aquí podrás definir los horarios de apagado para la zona seleccionada';
                    $scope.zona = zona;
                    $scope.agenda = []
                    $scope.agenda.day = undefined;
                    $scope.agenda.hini = undefined;
                    $scope.agenda.hfin = undefined;
                    $scope.agenda.frequency = undefined;

                    $scope.cerrar = function() {
                        ngDialog.close();
                    }
                    $scope.agendar = function() {
                        if (!(($scope.agenda.day == undefined) || ($scope.agenda.hini == undefined) || ($scope.agenda.hfin == undefined) || ($scope.agenda.frequency == undefined))) {
                            var field = {
                                "id_zona": $scope.zona,
                                "dia": $filter('date')($scope.agenda.day, 'yyyy/MM/dd'),
                                "hora_inicio": $filter('date')($scope.agenda.hini, 'HH:mm:ss'),
                                "hora_fin": $filter('date')($scope.agenda.hfin, 'HH:mm:ss'),
                                "frecuencia": $scope.agenda.frequency
                            };

                            //Agregar programación
                            RESTServices.post_header('programacion_zona.php', field,SHAREServices.hash_decode_token($localStorage.token), true).then(function(data) {
                                if (data.code == 200) {
                                    $scope.showmsg = function() {
                                        ngDialog.open({
                                            template: 'app/pages/dashboard/templates/mensaje.html',
                                            className: 'ngdialog-theme-plain',
                                            controller: ['$scope', function($scope) {
                                                // controller logic
                                                $scope.titleModal = 'Programación de apagado';
                                                $scope.bodyModal = 'Se ha programado el apagado de la zona correctamente';

                                                $scope.close = function() {
                                                    ngDialog.close();
                                                };
                                            }]
                                        });
                                    };
                                    $scope.showmsg();
                                    ngDialog.close();
                                } else {
                                    $scope.showmsg = function() {
                                        ngDialog.open({
                                            template: 'app/pages/dashboard/templates/mensaje.html',
                                            className: 'ngdialog-theme-plain',
                                            controller: ['$scope', function($scope) {
                                                // controller logic
                                                $scope.titleModal = 'Programación de apagado';
                                                $scope.bodyModal = 'No se ha podido registrar la programación de forma correcta';

                                                $scope.close = function() {
                                                    ngDialog.close();
                                                };
                                            }]
                                        });
                                    };
                                    $scope.showmsg();
                                    ngDialog.close();
                                }
                            });
                        } else {
                            $scope.showmsg = function() {
                                ngDialog.open({
                                    template: 'app/pages/dashboard/templates/mensaje.html',
                                    className: 'ngdialog-theme-plain',
                                    controller: ['$scope', function($scope) {
                                        // controller logic
                                        $scope.titleModal = 'Programación de apagado';
                                        $scope.bodyModal = 'Para programar el apagado de la zona debe ingresar todos los campos del formulario';

                                        $scope.close = function() {
                                            ngDialog.close();
                                        };
                                    }]
                                });
                            };
                            $scope.showmsg();
                        }
                    }
                }]
            });
        };

        //Listado de programaciones agendadas por zona
        $scope.list_programacion = function(zona) {
            ngDialog.open({
                template: 'app/pages/dashboard/templates/list_programacion.html',
                className: 'ngdialog-theme-plain',
                closeByDocument: false,
                controller: ['$scope', function($scope) {
                    $scope.titleModal = 'Lista de programación de apagados';
                    var parameters = {
                        "id_zona": zona
                    };

                    RESTServices.post_header('lista_programacion.php', parameters,SHAREServices.hash_decode_token($localStorage.token), true).then(function(data) {
                        $scope.prog_ids = data.id;
                        $scope.prog_dias = data.dia;
                        $scope.prog_hinis = data.hora_inicio;
                        $scope.prog_hfins = data.hora_fin;
                        $scope.prog_frecs = data.frecuencia;
                    });

                    $scope.cerrar = function() {
                        ngDialog.close();
                    }

                    $scope.delete_programacion = function(id) {
                        ngDialog.open({
                            template: 'app/pages/dashboard/templates/confirmacion.html',
                            className: 'ngdialog-theme-plain',
                            closeByDocument: false,
                            controller: ['$scope', function($scope) {
                                $scope.bodyModal = '¿Realmente desea eliminar la programación seleccionada?';

                                $scope.cancelar = function() {
                                    ngDialog.close();
                                }

                                $scope.aceptar = function() {
                                    var field = {
                                        "id_programacion": id
                                    };

                                    RESTServices.post_header('elimina_programacion.php', field,SHAREServices.hash_decode_token($localStorage.token), true).then(function(data) {
                                        if (data.code == 200) {
                                            $scope.showmsg = function() {
                                                ngDialog.open({
                                                    template: 'app/pages/dashboard/templates/mensaje.html',
                                                    className: 'ngdialog-theme-plain',
                                                    controller: ['$scope', function($scope) {
                                                        // controller logic
                                                        $scope.titleModal = 'Programación de apagado';
                                                        $scope.bodyModal = 'Se ha eliminado la programación correctamente';

                                                        $scope.close = function() {
                                                            ngDialog.close();
                                                        };
                                                    }]
                                                });
                                            };
                                            $scope.showmsg();
                                            ngDialog.close();
                                        }
                                    });
                                }
                            }]
                        });
                    }

                    $scope.edit_programacion = function(id, dia, hini, hfin, frecuencia) {
                        ngDialog.open({
                            template: 'app/pages/dashboard/templates/confirmacion.html',
                            className: 'ngdialog-theme-plain',
                            closeByDocument: false,
                            controller: ['$scope', function($scope) {
                                $scope.bodyModal = '¿Realmente desea editar la programación seleccionada?';

                                $scope.cancelar = function() {
                                    ngDialog.close();
                                }

                                $scope.aceptar = function() {
                                    $scope.showmsg = function() {
                                        ngDialog.open({
                                            template: 'app/pages/dashboard/templates/add_programacion.html',
                                            className: 'ngdialog-theme-plain',
                                            controller: ['$scope', function($scope) {
                                                // controller logic
                                                $scope.titleModal = 'Programación de apagado';
                                                $scope.bodyModal = 'Se ha eliminado la programación correctamente';
                                                $scope.agenda = [];
                                                $scope.agenda.day = new Date(dia);
                                                $scope.agenda.day.setTime($scope.agenda.day.getTime() + $scope.agenda.day.getTimezoneOffset() * 60 * 1000);
                                                $scope.agenda.hini = new Date(2016, 8, 31, parseInt(hini.substr(0, 2)), parseInt(hini.substr(3, 5)), parseInt(hini.substr(6, 8)));
                                                $scope.agenda.hfin = new Date(2016, 8, 31, parseInt(hfin.substr(0, 2)), parseInt(hfin.substr(3, 5)), parseInt(hfin.substr(6, 8)));
                                                $scope.agenda.frequency = frecuencia;

                                                $scope.cerrar = function() {
                                                    ngDialog.close();
                                                }

                                                $scope.agendar = function() {
                                                    if (!(($scope.agenda.day == undefined) || ($scope.agenda.hini == undefined) || ($scope.agenda.hfin == undefined) || ($scope.agenda.frequency == undefined))) {
                                                        var field = {
                                                            "id_programacion": id,
                                                            "dia": $filter('date')($scope.agenda.day, 'yyyy/MM/dd'),
                                                            "hora_inicio": $filter('date')($scope.agenda.hini, 'HH:mm:ss'),
                                                            "hora_fin": $filter('date')($scope.agenda.hfin, 'HH:mm:ss'),
                                                            "frecuencia": $scope.agenda.frequency
                                                        };

                                                        //Agregar programación
                                                        RESTServices.post_header('edita_programacion.php', field,SHAREServices.hash_decode_token($localStorage.token), true).then(function(data) {
                                                            if (data.code == 200) {
                                                                $scope.showmsg = function() {
                                                                    ngDialog.open({
                                                                        template: 'app/pages/dashboard/templates/mensaje.html',
                                                                        className: 'ngdialog-theme-plain',
                                                                        controller: ['$scope', function($scope) {
                                                                            // controller logic
                                                                            $scope.titleModal = 'Programación de apagado';
                                                                            $scope.bodyModal = 'Se ha editado la programación de la zona correctamente';

                                                                            $scope.close = function() {
                                                                                ngDialog.close();
                                                                            };
                                                                        }]
                                                                    });
                                                                };
                                                                $scope.showmsg();
                                                                ngDialog.close();
                                                            } else {
                                                                $scope.showmsg = function() {
                                                                    ngDialog.open({
                                                                        template: 'app/pages/dashboard/templates/mensaje.html',
                                                                        className: 'ngdialog-theme-plain',
                                                                        controller: ['$scope', function($scope) {
                                                                            // controller logic
                                                                            $scope.titleModal = 'Programación de apagado';
                                                                            $scope.bodyModal = 'No se ha podido editar la programación de forma correcta';

                                                                            $scope.close = function() {
                                                                                ngDialog.close();
                                                                            };
                                                                        }]
                                                                    });
                                                                };
                                                                $scope.showmsg();
                                                                ngDialog.close();
                                                            }
                                                        });
                                                    }
                                                }
                                            }]
                                        });
                                    };
                                    $scope.showmsg();
                                    ngDialog.close();
                                }
                            }]
                        });
                    }
                }]
            });
        };

        $scope.show = function() {
            $scope.flag1 = !$scope.flag1;
        }

        $scope.show_menu = function() {
            $scope.flag2 = !$scope.flag2;
        }

        $scope.showNotificacion = function() {
            $scope.notificacion = false;
            $location.hash('grafica_comparativa');
            $anchorScroll();
        }

        angular.element(document.querySelector("#tawkchat-container")).css("display", "inherit");

    }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
 
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.alerts').service('alertsServices', alertsServices);

    function alertsServices() {
        return {
            standBySegments: [
                {
                    text: "1 minuto",
                    value: '1',
                },
                {
                    text: "2 minutos",
                    value: '2',
                },
                {
                    text: "5 minutos",
                    value: '5',
                },
                {
                    text: "10 minutos",
                    value: '10',
                },
                {
                    text: "20 minutos",
                    value: '20',
                },
                {
                    text: "30 minutos",
                    value: '30',
                },
                {
                    text: "1 hora",
                    value: '60',
                },
                {
                    text: "2 horas",
                    value: '120',
                },
                {
                    text: "3 horas",
                    value: '180',
                },
                {
                    text: "6 horas",
                    value: '360',
                },
                {
                    text: "12 horas",
                    value: '720',
                },
                {
                    text: "1 día",
                    value: '1440',
                },
            ],
            repeatAlertSegments: [
                {
                    text: "1 minuto",
                    value: '1',
                },
                {
                    text: "2 minutos",
                    value: '2',
                },
                {
                    text: "5 minutos",
                    value: '5',
                },
                {
                    text: "10 minutos",
                    value: '10',
                },
                {
                    text: "20 minutos",
                    value: '20',
                },
                {
                    text: "30 minutos",
                    value: '30',
                },
                {
                    text: "1 hora",
                    value: '60',
                },
                {
                    text: "2 horas",
                    value: '120',
                },
                {
                    text: "3 horas",
                    value: '180',
                },
                {
                    text: "6 horas",
                    value: '360',
                },
                {
                    text: "12 horas",
                    value: '720',
                },
                {
                    text: "1 día",
                    value: '1440',
                },
            ],
            listaAlertas: [
                {
                    name: 'Temperatura',
                    min_name: 'Temp',
                    id: '0',
                    type: '10',
                    icon: '../../../../../assets/icons/alert_temp.svg',
                    show: true,
                    unit: '° C'
                },
                {
                    name: 'Humedad',
                    min_name: 'Hum',
                    id: '1',
                    type: '11',
                    icon: '../../../../../assets/icons/alert_humidity.svg',
                    show: true,
                    unit: '%',
                },
                // {
                //     name: 'Consumo',
                //     id: '2',
                //     type: 'consumption',
                //     icon: '',
                // },
                // {
                //     name: 'Flujo',
                //     id: '3',
                //     type: '12',
                //     icon: '',
                // },
                {
                    name: 'Presión PSI',
                    min_name: 'PSI',
                    id: '4',
                    type: '13',
                    icon: '../../../../../assets/icons/alert_pressure.svg',
                    show: true,
                    unit: 'PSI',
                },
                {
                    name: 'Presión pRack',
                    min_name: 'pRack',
                    id: '4',
                    type: '4',
                    icon: '../../../../../assets/icons/alert_pressure.svg',
                    show: true,
                    unit: 'bar',
                },
                {
                    name: 'Potencia',
                    min_name: 'Poten',
                    id: '5',
                    type: '102',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: true,
                    unit: 'w',
                },
                {
                    name: 'Potencia',
                    min_name: 'Poten',
                    id: '5',
                    type: '101',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: false,
                    unit: 'w',
                },
                {////pontencia para la fase 1 de medidor de avanzada
                    name: 'Potencia',
                    min_name: 'Poten M.A.',
                    id: '5',
                    type: '27',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: false,
                    unit: 'w',
                },
                {////pontencia para la fase 2 de medidor de avanzada
                    name: 'Potencia',
                    min_name: 'Poten M.A.',
                    id: '5',
                    type: '28',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: false,
                    unit: 'w',
                },
                {////pontencia para la fase 3 de medidor de avanzada
                    name: 'Potencia',
                    min_name: 'Poten M.A.',
                    id: '5',
                    type: '29',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: false,
                    unit: 'w',
                },
                {
                    name: 'Apertura y cierre',
                    min_name: 'Open',
                    id: '6',
                    type: '3',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: true,
                    unit: '',
                },
                {
                    name: 'Desconexión',
                    min_name: 'Offline',
                    id: '7',
                    type: '15',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: true,
                    unit: '',
                },
                {
                    name: 'Presencia',
                    min_name: 'presence',
                    id: '8',
                    type: '7',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: true,
                    unit: '',
                },
                {
                    name: 'Límite inferior',
                    min_name: 'limit',
                    id: '9',
                    type: '1',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: true,
                    unit: '',
                },
                {
                    name: 'PM 1.0',
                    min_name: 'PM 1.0',
                    id: '10',
                    type: '45',
                    icon: '',
                    show: true,
                    unit: 'PM 1.0um',
                },
                {
                    name: 'PM 2.5',
                    min_name: 'PM 2.5',
                    id: '11',
                    type: '46',
                    icon: '',
                    show: true,
                    unit: 'PM 2.5um',
                },
                {
                    name: 'PM 4.0',
                    min_name: 'PM 4.0',
                    id: '12',
                    type: '47',
                    icon: '',
                    show: true,
                    unit: 'PM 4.0um',
                },
                {
                    name: 'PM 10.0',
                    min_name: 'PM 10.0',
                    id: '13',
                    type: '48',
                    icon: '',
                    show: true,
                    unit: 'PM 10.0um',
                },
                {
                    name: 'VOC',
                    min_name: 'VOC',
                    id: '14',
                    type: '49',
                    icon: '',
                    show: true,
                    unit: 'VOC Index',
                },
                {
                    name: 'NOx',
                    min_name: 'NOx',
                    id: '15',
                    type: '50',
                    icon: '',
                    show: true,
                    unit: 'NOx Index',
                },
                {
                    name: 'Comunicación',
                    min_name: 'Comm',
                    id: '16',
                    type: '58',
                    icon: '../../../../../assets/icons/alert_comm.svg',
                    show: true,
                    unit: ''
                },
                {
                    name: 'Error',
                    min_name: 'Error',
                    id: '17',
                    type: '59',
                    icon: '../../../../../assets/icons/alert_power.svg',
                    show: true,
                    unit: ''
                },
            ],
            observationSegments: [
                {
                    text: "Personalizado",
                    value: 'custom',
                },
                {
                    text: "Feriados",
                    value: 'holidays',
                },
                {
                    text: "Siempre que no sea feriado",
                    value: 'no_holidays',
                },
            ],
            openSegments: [
                {
                    text: "Cerrado",
                    value: '1',
                },
                {
                    text: "Abierto",
                    value: '0',
                },
            ],
            presenceSegments: [
                {
                    text: "Presencia",
                    value: '1',
                },
                {
                    text: "No presencia",
                    value: '0',
                },
            ],
            comunicacionSegments: [
                {
                    text: "Sin comunicación",
                    value: '1',
                },
                {
                    text: "Error",
                    value: '2',
                },
                {
                    text: "Con comunicación",
                    value: '3',
                },
            ],
            getStandBySegments: function(){
                return this.standBySegments;
            },
            getOpenSegments: function(){
                return this.openSegments;
            },
            getPresenceSegments: function(){
                return this.presenceSegments;
            },
            getComunicacionSegments: function(){
                return this.comunicacionSegments;
            },
            getRepeatAlertSegments: function(){
                return this.repeatAlertSegments;
            },
            getObservationSegments: function(){
                return this.observationSegments;
            },
            setUnit: function(type) {
                switch(type) {
                    case 'Temperatura':
                        return 'C°';
                        break;
                    case 'Humedad':
                        return '%';
                        break;
                    case 'Presión':
                        return 'PSI';
                        break;
                    case 'Presión pRack':
                        return 'bar';
                        break;
                    case 'Potencia': 
                        return 'W';
                        break;
                    case 'PM 1.0': 
                        return 'PM 1.0um';
                        break;
                    case 'PM 2.5': 
                        return 'PM 2.5um';
                        break;
                    case 'PM 4.0': 
                        return 'PM 4.0um';
                        break;
                    case 'PM 10.0': 
                        return 'PM 10.0um';
                        break;
                    case 'VOC': 
                        return 'VOC Index';
                        break;
                    case 'NOx': 
                        return 'NOx Index';
                        break;
                }
            },
            commandControl: [
                {
                    nombre: '16',
                    id: '16'
                },
                {
                    nombre: '17',
                    id: '17'
                },
                {
                    nombre: '18',
                    id: '18'
                },
                {
                    nombre: '19',
                    id: '19'
                },
                {
                    nombre: '20',
                    id: '20'
                },
                {
                    nombre: '21',
                    id: '21'
                },
                {
                    nombre: '22',
                    id: '22'
                },
                {
                    nombre: '23',
                    id: '23'
                },
                {
                    nombre: '24',
                    id: '24'
                },
                {
                    nombre: '25',
                    id: '25'
                },
                {
                    nombre: '26',
                    id: '26'
                },
                {
                    nombre: '27',
                    id: '27'
                },
                {
                    nombre: '28',
                    id: '28'
                },
                {
                    nombre: '29',
                    id: '29'
                },
                {
                    nombre: '30',
                    id: '30'
                },
                {
                    nombre: 'Apagar',
                    id: '0'
                },
            ],

            onOffControl: [
                {
                    nombre: 'Apagar',
                    id: '0'
                },
                {
                    nombre: 'Encender',
                    id: '1'
                },
            ],
            wind_CurtainControl: [
                {
                    nombre: 'Apagar',
                    id: '0',
                    status: true,
                },
                {
                    nombre: 'Encender en baja',
                    id: '1',
                    status: true,
                },
                {
                    nombre: 'Encender en alta',
                    id: '2',
                    status: true,
                },
            ],

            
        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.alerts')
      .controller('alertsCtrl', alertsCtrl);
  
    function alertsCtrl($scope, $localStorage, alertsServices, RESTServices, $timeout, $interval, SHAREServices, $state, $filter, toastr, AutoServices, $rootScope, ngDialog) {
        
        $scope.alerts = [];
        $scope.listaAlertas = alertsServices.listaAlertas;
        $scope.loading = true;
        $scope.novelties =  false;
        $scope.zonas = [];
        $scope.index = {
            ind: ''
        }
        var timer;

        $scope.rol_id = $localStorage.rol;
        $scope.listaFiltros = ['todas', 'novedades', 'control', 'monitoreo', 'temperatura', 'humedad', 'presión PSI', 'presión pRack', 'potencia', 'apertura y cierre', 'desconexión', 'comunicación', 'error'];
        $scope.filterInd = 'Filtrar alertas'
        var alertas_all = [];
        var IMPORT_ID_HEADER = 'id (no editar)';
        var IMPORT_FIELD_LABELS = {
            min: 'Mínimo',
            max: 'Máximo',
            t_espera: 'Tiempo de espera',
            t_repeticion: 'Tiempo de repetición',
            dias: 'Días',
            h_ini: 'Hora inicial',
            h_fin: 'Hora final',
            set_point: 'Set point'
        };

        $scope.newAlert = function(type) {
            if ($scope.devices) {
                if (type.min_name === 'Offline' || type.min_name === 'Open' || type.min_name === 'limit' || type.min_name === 'Comm' || type.min_name === 'Error') {
                    $state.go('offlineAlert', {type: type, zona: $scope.zona})
                } else {
                    $state.go('newAlert', {type: type, zona: $scope.zona})
                }
            } else {
                toastr.warning('Espera mientras se cargan los dispositivos', 'Nueva Alerta')
            }
            
        }

        /////
        $timeout(function() {

            if (SHAREServices.zonas === null) {
                RESTServices.fetchClientZones().then(function(data) {
                    if (data != null) {
                        if (data.code == '200') {
                            if(data.zonas) {
                                $scope.zonas = data.zonas;
                            } 
                            if(data.zonas_externas) {
                                $scope.zonas = $scope.zonas.concat(data.zonas_externas)
                            }
                            $scope.zonas = $filter('orderBy')($scope.zonas, 'nombre');
                            $scope.zonas = $filter('filter')($scope.zonas, {h : '0'});
                            $scope.zonas = $scope.zonas.map(function(z, i) {
                                z.index = i;
                                return z;
                            })
                            SHAREServices.zonas = $scope.zonas;
                            if (SHAREServices.zona_alertas) {
                                $scope.zona = SHAREServices.zona_alertas;
                                var index = $scope.zonas.findIndex(function(z){return z.id === $scope.zona.id})
                                $scope.index.ind = index;
                                $scope.showAlerts(index);
                            } else {
                                $scope.zona = $scope.zonas[0];
                                $scope.index.ind = 0;
                                $scope.showAlerts(0);
                                SHAREServices.zona_alertas = $scope.zona;
                            }
                            getHolidays();
                            
                            
                        }else{
                            $state.go('noAlerts');
                            //console.log("error en respuesta")
                        }
                    } else {
                        $state.go('noAlerts');
                        //console.log("no hay respuesta")
                    }  
    
                });
            } else {
                $scope.zonas = SHAREServices.zonas;
                if (SHAREServices.zona_alertas) {
                    $scope.zona = SHAREServices.zona_alertas;
                    var index = $scope.zonas.findIndex(function(z){return z.id === $scope.zona.id})
                    $scope.index.ind = index;
                    $scope.showAlerts(index);
                } else {
                    $scope.zona = $scope.zonas[0];
                    $scope.index.ind = 0;
                    $scope.showAlerts(0);
                    SHAREServices.zona_alertas = $scope.zona;
                }
                getHolidays();
            }
            
        });

        $scope.showAlerts = function(ind) {
            // selector-filter passes the zone object; index 0 is falsy, so check the type
            var index = angular.isObject(ind) ? ind.index : ind;
            $scope.filterInd = 'Filtrar alertas';
            $scope.alerts = [];
            $scope.filtered = [];
            $scope.loading = true;
            var zona = $scope.zonas[index];
            $scope.zona = $scope.zonas[index];
            SHAREServices.zona_alertas = $scope.zonas[index];
            $rootScope.$broadcast('setAlertZone', {zona: SHAREServices.zona_alertas})
            RESTServices.fetchDevicesByZone(zona.id).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        SHAREServices.devices = data.dispositivos;
                        $scope.devices = SHAREServices.devices;
                        $scope.devices = $scope.devices.map(function(d){
                            // ids are compared with === against string ids coming from PHP
                            d.id = String(d.id);
                            if (d.id_dispositivo !== undefined) d.id_dispositivo = String(d.id_dispositivo); // absent on the PHP fallback
                            d.nombre_zona = zona.nombre;
                            d.id_zona = zona.id;
                            return d
                        })
                        getAlerts(zona.id);
                        getHolidays();
                    } else {
                        $scope.loading = false;
                    }
                }
            })

        }

        /////alertas
        function getAlerts(id) {
            // Go lambda behind an adapter that rebuilds the legacy {code, alertas} envelope (no PHP fallback).
            RESTServices.fetchZoneAlerts(id).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        if(data.alertas){
                            alertas_all = data.alertas;
                            var alertsByGroup = groupBySerial(data.alertas);
                            var groups = Object.keys(alertsByGroup);
                            $scope.alerts = [];
                            groups.forEach(function(g){
                                if (g === 'default') {
                                    alertsByGroup[g].forEach(function (alerta) {
                                        var item = {
                                                id : alerta.id,
                                                name : alerta.nombre,
                                                selectedDevices : $scope.devices.filter(function(d){ return d.id === alerta.dispositivos})[0],
                                                interval:{
                                                    min: alerta.min === null ? null : alerta.tipo === '1' ? Number(AutoServices.getControlByID(alerta.control.tipo, alerta.min).nombre) : Number(alerta.min),
                                                    max: alerta.max === null ? null : Number(alerta.max),
                                                    type: alerta.min === null ? 1 : alerta.max === null ? 2 : 0,
                                                    min_with_offset: alerta.min === null ? null : alerta.offset_temp ? Number(alerta.min) + parseFloat(alerta.offset_temp) : Number(alerta.min),
                                                    max_with_offset: alerta.max === null ? null : alerta.offset_temp ? Number(alerta.max) + parseFloat(alerta.offset_temp) : Number(alerta.max),
                                                },
                                                status: alerta.estado == '1' ? true : false,
                                                repeatAlert : alerta.t_repeticion,
                                                standBy : alerta.t_espera,
                                                interestedUsers: alerta.correos.split(","),
                                                notifications : [],
                                                type: alertsServices.listaAlertas.filter(function(t) { return alerta.tipo == t.type})[0],
                                                control: alerta.control !== null ? {
                                                    id: alerta.control.id,
                                                    id_dispositivo: alerta.control.id_dispositivo,
                                                    set_point: alerta.control.set_point,
                                                    tipo: alerta.control.tipo,
                                                    device_name: $scope.devices.filter(function(d){ return d.id === alerta.control.id_dispositivo}).length > 0 ? $scope.devices.filter(function(d){ return d.id === alerta.control.id_dispositivo})[0].nombre : '',
                                                    set_point_name: alerta.control.set_point === '0' ? 'Apagar' : alerta.control.set_point === '1' ? 'Encender' : alerta.control.set_point + '° C',
                                                } : null,
                                                notification: alerta.notificacion,
                                                observation: {
                                                    days: alerta.dias.split(","),
                                                    h_ini: alerta.h_ini,
                                                    h_fin: alerta.h_fin,
                                                },
                                                offset: alerta.offset,
                                                offset_temp: alerta.offset_temp,
                                                email: alerta.email,
                                                info: false,
                                                grupo:  alerta.grupo,
                                                nestedAlerts: null,
                                                fecha_notificacion: alerta.fecha_notificacion,
                                                active: alerta.activa,
                                                control_en_off: alerta.control_en_off,
                                                comparacion: alerta.comparacion,
                                                comparador: alerta.comparador !== null ? {
                                                    id: alerta.comparador.id,
                                                    id_dispositivo: alerta.comparador.id_dispositivo,
                                                    device_name: $scope.devices.filter(function(d){ return d.id === alerta.comparador.id_dispositivo}).length > 0 ? $scope.devices.filter(function(d){ return d.id === alerta.comparador.id_dispositivo})[0].nombre : '',
                                                }: null,
                                                feriado: alerta.feriado,
                                                ids_feriados: alerta.ids_feriados !== null && alerta.ids_feriados !== "" ? alerta.ids_feriados.split(",") : alerta.ids_feriados,
                                            };
                                        $scope.alerts.push(item);
         
                                    });
                                } else {
                                    var alerta = alertsByGroup[g][0];
                                    var item = {
                                        id : alerta.id,
                                        name : alerta.nombre,
                                        selectedDevices : formatDevices(alertsByGroup[g]),
                                        interval:{
                                            min: alerta.min === null ? null : Number(alerta.min),
                                            max: alerta.max === null ? null : Number(alerta.max),
                                            type: alerta.min === null ? 1 : alerta.max === null ? 2 : 0,
                                            min_with_offset: alerta.min === null ? null : alerta.offset_temp ? Number(alerta.min) + parseFloat(alerta.offset_temp) : Number(alerta.min),
                                            max_with_offset: alerta.max === null ? null : alerta.offset_temp ? Number(alerta.max) + parseFloat(alerta.offset_temp) : Number(alerta.max),
                                        },
                                        status: alerta.estado == '1' ? true : false,
                                        repeatAlert : alerta.t_repeticion,
                                        standBy : alerta.t_espera,
                                        interestedUsers: alerta.correos.split(","),
                                        notifications : [],
                                        type: alertsServices.listaAlertas.filter(function(t) { return alerta.tipo == t.type})[0],
                                        control: alerta.control !== null ? {
                                            id: alerta.control.id,
                                            id_dispositivo: alerta.control.id_dispositivo,
                                            set_point: alerta.control.set_point,
                                            tipo: alerta.control.tipo,
                                            device_name: $scope.devices.filter(function(d){ return d.id === alerta.control.id_dispositivo}).length > 0 ? $scope.devices.filter(function(d){ return d.id === alerta.control.id_dispositivo})[0].nombre : '',
                                            set_point_name: alerta.control.set_point === '0' ? 'Apagar' : alerta.control.set_point === '1' ? 'Encender' : alerta.control.set_point + '° C',
                                        } : null,
                                        notification: alerta.notificacion,
                                        observation: {
                                            days: alerta.dias.split(","),
                                            h_ini: alerta.h_ini,
                                            h_fin: alerta.h_fin,
                                        },
                                        offset: alerta.offset,
                                        offset_temp: alerta.offset_temp,
                                        email: alerta.email,
                                        info: false,
                                        grupo:  alerta.grupo,
                                        nestedAlerts: alertsByGroup[g],
                                        fecha_notificacion: alerta.fecha_notificacion,
                                        active: alerta.activa,
                                        control_en_off: alerta.control_en_off,
                                        comparacion: alerta.comparacion,
                                        comparador: alerta.comparador !== null ? {
                                            id: alerta.comparador.id,
                                            id_dispositivo: alerta.comparador.id_dispositivo,
                                            device_name: $scope.devices.filter(function(d){ return d.id === alerta.comparador.id_dispositivo}).length > 0 ? $scope.devices.filter(function(d){ return d.id === alerta.comparador.id_dispositivo})[0].nombre : '',
                                        }: null,
                                        feriado: alerta.feriado,
                                        ids_feriados: alerta.ids_feriados !== null && alerta.ids_feriados !== "" ? alerta.ids_feriados.split(",") : alerta.ids_feriados,
                                    };
                                    $scope.alerts.push(item);
                                }
                            })

                            $scope.filtered = $scope.alerts;
                            $scope.loading = false;
                        }else{
                            $scope.loading = false;
                            //$state.go('noAlerts');
                        }
                        
                    }else{
                        $scope.loading = false;
                        //$state.go('noAlerts');
                    }
                }else{
                    //console.log("no hay respuesta")
                }  
            });
        }

        $scope.filtrar = function(buscar) {
            if('') {
                $scope.filtered = $scope.alerts
            } else {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.name.toLowerCase().indexOf(buscar.toLowerCase()) > -1})
            }
        }

        $scope.showNovelty = function(ind) {
            $scope.novelties = !$scope.novelties;
            if(!ind) {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.notification === true});
            } else {
                $scope.filtered = $scope.alerts
            }
        }

        function groupBySerial(objects) {
            var result = {};
            objects.forEach(function(obj) {
                var grupo = obj.grupo;
                if (grupo !== null) {
                    if (result[grupo]) {
                        result[grupo].push(obj);
                    } else {
                        result[grupo] = [obj];
                    }
                } else {
                    if (result['default']) {
                        result['default'].push(obj);
                    } else {
                        result['default'] = [obj];
                    }
                }
                // if (result['default']) {
                //     result['default'].push(obj);
                // } else {
                //     result['default'] = [obj];
                // }
            });
            return result;
        };

        function formatDevices(devices) {
            var dis = []
            devices.forEach(function(dev){
                var item = $scope.devices.filter(function(d){ return d.id === dev.dispositivos})[0];
                dis.push(item)
            })
            return dis;
        }

        $scope.goToQuickEdit = function() {
            if(alertas_all.length > 0) {
                $state.go('quickEdit', {alerts: alertas_all});
            } else if (alertas_all.length === 0 && $scope.loading === false) {
                toastr.warning('No tienes alertas creadas', 'Edición Conjunta')
            } else {
                toastr.warning('Cargando alertas', 'Edición Conjunta')
            }

        }

        function buildInstructionsSheet() {
            var rows = [
                ['INSTRUCTIVO – Edición de alertas por Excel'],
                [''],
                ['1. Qué columnas podés editar'],
                ['min, max, t_espera, t_repeticion, set_point, dias, h_ini, h_fin.'],
                ['Dejá una celda vacía si no querés cambiar ese valor.'],
                ['Para borrar min o max explícitamente, escribí la palabra null en la celda (no la dejes vacía).'],
                [''],
                ['2. Qué NO tenés que tocar'],
                ['La columna "nombre" es solo referencia, no se usa al importar.'],
                ['La columna "id (no editar)" identifica cada alerta: no la borres, no la edites y no muevas filas entre sí.'],
                ['No cambies los encabezados (fila 1) ni el nombre de la hoja "Alertas".'],
                [''],
                ['3. Formatos esperados'],
                ['dias: números del 0 (domingo) al 6 (sábado) separados por coma. Ej: 1,2,3,4,5'],
                ['h_ini / h_fin: HH:mm o HH:mm:ss, ej 08:30 o 08:30:00'],
                ['set_point: solo aplica a alertas que ya tienen un control asociado'],
                [''],
                ['4. Sumar o restar un número a min, max y set_point de una sola vez'],
                ['Esta función corre DENTRO de Excel (macro VBA), no en la web. Se instala una sola vez:'],
                ['a) Abrí la pestaña Programador (si no la ves: Archivo > Opciones > Personalizar cinta > tildá "Programador").'],
                ['b) Programador > Visual Basic (o Alt+F11).'],
                ['c) En el panel izquierdo, buscá VBAProject (PERSONAL.XLSB). Si no existe, grabá y descartá una macro cualquiera una vez para que Excel lo cree.'],
                ['d) Clic derecho sobre PERSONAL.XLSB > Insertar > Módulo.'],
                ['e) Pegá ahí el código de la macro (lo encontrás en el manual "Manual_Editar_Alertas_Excel.docx") y guardá (Ctrl+S, aceptá mantener el formato .xlsb).'],
                ['f) Cerrá el editor. Desde ahora, en cualquier archivo de alertas: seleccioná exactamente las celdas que querés modificar (por ej. solo la columna min de dos filas, o min+max de todas) y después Programador > Macros > SumarValorAlertas > Ejecutar.'],
                ['La macro solo toca, dentro de tu selección, las celdas de min/max/set_point que ya tienen un número. Si seleccionás filas completas, actualiza esas 3 columnas en esas filas; si seleccionás solo una columna, actualiza solo esa. Te va a pedir el número a sumar (podés poner uno negativo para restar).']
            ];
            var ws = XLSX.utils.aoa_to_sheet(rows);
            ws['!cols'] = [{ wch: 110 }];
            return ws;
        }

        $scope.exportAlerts = function() {
            if (alertas_all.length === 0) {
                toastr.warning('No tienes alertas creadas', 'Exportar Alertas')
                return;
            }

            var rows = alertas_all.map(function(alerta) {
                var row = {};
                row['nombre'] = alerta.nombre;
                row['min'] = alerta.min;
                row['max'] = alerta.max;
                row['t_espera'] = alerta.t_espera;
                row['t_repeticion'] = alerta.t_repeticion;
                row['set_point'] = alerta.control ? alerta.control.set_point : '';
                row['dias'] = alerta.dias;
                row['h_ini'] = alerta.h_ini;
                row['h_fin'] = alerta.h_fin;
                row[IMPORT_ID_HEADER] = alerta.id;
                return row;
            });

            var ws = XLSX.utils.json_to_sheet(rows);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Alertas');
            XLSX.utils.book_append_sheet(wb, buildInstructionsSheet(), 'Instructivo');
            var fileName = 'alertas_' + ($scope.zona ? $scope.zona.nombre : $filter('date')(new Date(), 'ddMMyyyy')) + '.xlsx';
            XLSX.writeFile(wb, fileName);
        }

        $scope.importAlertsFile = function(event) {
            var file = event.files[0];
            if (!file) {
                return;
            }

            var reader = new FileReader();
            reader.onload = function(evt) {
                var workBook = XLSX.read(evt.target.result, { type: 'binary' });
                var sheet = workBook.Sheets[workBook.SheetNames[0]];
                var rows = XLSX.utils.sheet_to_json(sheet);
                event.value = '';
                $scope.$apply(function() {
                    processImportedRows(rows);
                });
            };
            reader.readAsBinaryString(file);
        }

        function processImportedRows(rows) {
            var validRows = [];
            var errorRows = [];
            var unchangedRows = [];

            rows.forEach(function(row, index) {
                var rowNumber = index + 2; // header is row 1 in the spreadsheet
                var rawId = row[IMPORT_ID_HEADER];
                var alerta = alertas_all.filter(function(a) { return String(a.id) === String(rawId); })[0];

                if (!alerta) {
                    errorRows.push({ row: rowNumber, id: rawId, messages: ['Alerta no encontrada (id ' + rawId + ')'] });
                    return;
                }

                var messages = [];
                var changes = [];
                var updated = angular.copy(alerta);

                var minResult = parseOptionalNumber(row['min']);
                var maxResult = parseOptionalNumber(row['max']);
                if (!minResult.valid) {
                    messages.push('min debe estar vacío o ser numérico');
                }
                if (!maxResult.valid) {
                    messages.push('max debe estar vacío o ser numérico');
                }
                if (minResult.valid && maxResult.valid) {
                    var effectiveMin = minResult.value === undefined ? (isBlank(alerta.min) ? null : Number(alerta.min)) : minResult.value;
                    var effectiveMax = maxResult.value === undefined ? (isBlank(alerta.max) ? null : Number(alerta.max)) : maxResult.value;
                    if (effectiveMin !== null && effectiveMax !== null && !(effectiveMin < effectiveMax)) {
                        messages.push('min debe ser menor que max');
                    }
                }

                var standByResult = parsePositiveNumber(row['t_espera']);
                if (!standByResult.valid) {
                    messages.push('t_espera debe estar vacío o ser un número positivo');
                }

                var repeatResult = parsePositiveNumber(row['t_repeticion']);
                if (!repeatResult.valid) {
                    messages.push('t_repeticion debe estar vacío o ser un número positivo');
                }

                var diasResult = parseDias(row['dias']);
                if (!diasResult.valid) {
                    messages.push('dias debe ser una lista de números entre 0 y 6 separados por coma');
                }

                var hIniResult = parseHora(row['h_ini']);
                if (!hIniResult.valid) {
                    messages.push('h_ini debe tener formato HH:mm o HH:mm:ss');
                }

                var hFinResult = parseHora(row['h_fin']);
                if (!hFinResult.valid) {
                    messages.push('h_fin debe tener formato HH:mm o HH:mm:ss');
                }

                var setPointRaw = row['set_point'];
                var setPointBlank = isBlank(setPointRaw);
                if (!setPointBlank && !alerta.control) {
                    messages.push('esta alerta no tiene control, no se puede setear set_point');
                }

                if (messages.length > 0) {
                    errorRows.push({ row: rowNumber, id: rawId, messages: messages });
                    return;
                }

                if (minResult.value !== undefined && numbersDiffer(minResult.value, alerta.min)) {
                    changes.push({ field: 'min', label: IMPORT_FIELD_LABELS.min, before: alerta.min, after: minResult.value });
                    updated.min = minResult.value;
                }
                if (maxResult.value !== undefined && numbersDiffer(maxResult.value, alerta.max)) {
                    changes.push({ field: 'max', label: IMPORT_FIELD_LABELS.max, before: alerta.max, after: maxResult.value });
                    updated.max = maxResult.value;
                }
                if (standByResult.value !== null && numbersDiffer(standByResult.value, alerta.t_espera)) {
                    changes.push({ field: 't_espera', label: IMPORT_FIELD_LABELS.t_espera, before: alerta.t_espera, after: standByResult.value });
                    updated.t_espera = standByResult.value;
                }
                if (repeatResult.value !== null && numbersDiffer(repeatResult.value, alerta.t_repeticion)) {
                    changes.push({ field: 't_repeticion', label: IMPORT_FIELD_LABELS.t_repeticion, before: alerta.t_repeticion, after: repeatResult.value });
                    updated.t_repeticion = repeatResult.value;
                }
                if (diasResult.value !== alerta.dias) {
                    changes.push({ field: 'dias', label: IMPORT_FIELD_LABELS.dias, before: alerta.dias, after: diasResult.value });
                    updated.dias = diasResult.value;
                }
                if (hIniResult.value !== alerta.h_ini) {
                    changes.push({ field: 'h_ini', label: IMPORT_FIELD_LABELS.h_ini, before: alerta.h_ini, after: hIniResult.value });
                    updated.h_ini = hIniResult.value;
                }
                if (hFinResult.value !== alerta.h_fin) {
                    changes.push({ field: 'h_fin', label: IMPORT_FIELD_LABELS.h_fin, before: alerta.h_fin, after: hFinResult.value });
                    updated.h_fin = hFinResult.value;
                }
                if (!setPointBlank && alerta.control && String(setPointRaw).trim() !== String(alerta.control.set_point)) {
                    changes.push({ field: 'set_point', label: IMPORT_FIELD_LABELS.set_point, before: alerta.control.set_point, after: String(setPointRaw).trim() });
                    updated.control.set_point = String(setPointRaw).trim();
                }

                if (changes.length === 0) {
                    unchangedRows.push({ row: rowNumber, id: alerta.id, nombre: alerta.nombre });
                    return;
                }

                validRows.push({ id: alerta.id, nombre: alerta.nombre, changes: changes, updated: updated });
            });

            showImportPreviewDialog(validRows, errorRows, unchangedRows);
        }

        function isBlank(value) {
            return value === undefined || value === null || String(value).trim() === '';
        }

        function numbersDiffer(parsedValue, originalValue) {
            var originalNum = isBlank(originalValue) ? null : Number(originalValue);
            if (parsedValue === null && originalNum === null) {
                return false;
            }
            if (parsedValue === null || originalNum === null) {
                return true;
            }
            return parsedValue !== originalNum;
        }

        // Blank means "no cambiar" (consistente con t_espera/t_repeticion) para no
        // borrar un límite real por un delete accidental en Excel. Para limpiar
        // explícitamente min/max a vacío hay que escribir "null" en la celda.
        function parseOptionalNumber(value) {
            if (isBlank(value)) {
                return { valid: true, value: undefined };
            }
            var str = String(value).trim().toLowerCase();
            if (str === 'null' || str === 'vacio' || str === 'vacío') {
                return { valid: true, value: null };
            }
            var num = Number(value);
            if (isNaN(num)) {
                return { valid: false, value: null };
            }
            return { valid: true, value: num };
        }

        function parsePositiveNumber(value) {
            if (isBlank(value)) {
                return { valid: true, value: null };
            }
            var num = Number(value);
            if (isNaN(num) || num <= 0) {
                return { valid: false, value: null };
            }
            return { valid: true, value: num };
        }

        function parseDias(value) {
            if (isBlank(value)) {
                return { valid: false, value: null };
            }
            var tokens = String(value).split(',').map(function(t) { return t.trim(); });
            var validTokens = tokens.every(function(t) { return /^[0-6]$/.test(t); });
            if (!validTokens) {
                return { valid: false, value: null };
            }
            return { valid: true, value: tokens.join(',') };
        }

        function pad2(n) {
            return (n < 10 ? '0' : '') + n;
        }

        // Excel silently turns a text cell like "16:01:00" into a numeric time
        // serial (fraction of a day) as soon as the user retypes it, so this
        // has to accept both the string format and that numeric form.
        function parseHora(value) {
            if (isBlank(value)) {
                return { valid: false, value: null };
            }
            if (typeof value === 'number' && isFinite(value)) {
                var fraction = value - Math.floor(value);
                var totalSeconds = Math.round(fraction * 86400);
                var hh = Math.floor(totalSeconds / 3600);
                var mm = Math.floor((totalSeconds % 3600) / 60);
                var ss = totalSeconds % 60;
                return { valid: true, value: pad2(hh) + ':' + pad2(mm) + ':' + pad2(ss) };
            }
            var str = String(value).trim();
            var match = /^([0-9]|[01][0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/.test(str);
            if (!match) {
                return { valid: false, value: null };
            }
            var parts = str.split(':');
            var normalized = pad2(Number(parts[0])) + ':' + parts[1] + ':' + (parts[2] || '00');
            return { valid: true, value: normalized };
        }

        function showImportPreviewDialog(validRows, errorRows, unchangedRows) {
            $scope.importSummary = {
                validCount: validRows.length,
                errorCount: errorRows.length,
                unchangedCount: unchangedRows.length,
                valid: validRows,
                errors: errorRows
            };

            ngDialog.open({
                template: 'app/cliente/alerts/templates/importAlertasPreview.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.cancelarImport = function() {
                        ngDialog.close();
                    };
                    $scope.confirmarImport = function() {
                        var alertasArray = validRows.map(function(v) { return v.updated; });
                        submitImportedAlerts(alertasArray);
                        ngDialog.close();
                    };
                }]
            });
        }

        function submitImportedAlerts(alertasArray) {
            if (alertasArray.length === 0) {
                return;
            }
            RESTServices.saveAlertsV2(alertasArray).then(function(data) {
                if (data.code == '200') {
                    toastr.success('Se han editado las alertas correctamente', 'Alertas');
                    getAlerts($scope.zona.id);
                } else {
                    toastr.error('Ha ocurrido un error inesperado', 'Alertas');
                }
            }).catch(function() {
                toastr.error('Ha ocurrido un error inesperado', 'Alertas');
            });
        }

        $scope.filtrarAlertas = function(type) {
            $scope.filterInd = type;
            if (type === 'todas') {
                $scope.filtered = $scope.alerts;
            } else if (type === 'control') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.control !== null })
            } else if (type === 'monitoreo') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.control === null })
            } else if (type === 'temperatura') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.type.type === '10' })
            } else if (type === 'humedad') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.type.type === '11' })
            } else if (type === 'presión PSI') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.type.type === '13' })
            } else if (type === 'presión pRack') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.type.type === '4' })
            } else if (type === 'potencia') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.type.type === '101' || a.type.type === '102' || a.type.type === '27' || a.type.type === '28' || a.type.type === '29' })
            } else if (type === 'apertura y cierre') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.type.type === '3' })
            } else if (type === 'desconexión') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.type.type === '15' })
            } else if (type === 'comunicación') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.type.type === '58' })
            } else if (type === 'error') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.type.type === '59' })
            } else if (type === 'novedades') {
                $scope.filtered = $scope.alerts.filter(function(a) { return a.notification === true});
            }
            //////calidad del aire
        }

        $scope.getFile = function(event) {
            if($scope.zona){
                var workBook = null;
                var jsonData = null;
                var dataFromExcel;
                var reader = new FileReader();
                var file = event.files[0];
                reader.onload = function(event) {
                    var data = reader.result;
                    workBook = XLSX.read(data, { type: 'binary' });
                    jsonData = workBook.SheetNames.reduce(function(initial, name) {
                        var sheet = workBook.Sheets[name];
                        initial[name] = XLSX.utils.sheet_to_json(sheet);
                        return initial;
                    }, {});
                    dataFromExcel = jsonData;
                    if(!dataFromExcel.sede){
                        return toastr.error('El archivo no tiene el formato adecuado', 'Ha ocurrido un error');
                    }
                    if (dataFromExcel.sede[0].nombre_sede !== $scope.zona.nombre){
                        return toastr.error('La zona no corresponde con el archivo', 'Ha ocurrido un error');
                    } 
                    if (dataFromExcel.control || dataFromExcel.monitoreo) {

                        $scope.flag_loading = true;
                        $scope.$apply();
                        var alertas = [];
                        var validardor = dataFromExcel.control && dataFromExcel.monitoreo ? dataFromExcel.control.concat(dataFromExcel.monitoreo) : dataFromExcel.control ? dataFromExcel.control : dataFromExcel.monitoreo;

                        validardor.forEach(function(v){
                            var keys = Object.keys(v);
                            if(keys.length >= 9){
                                alertas.push(v);
                            }
                        })
                        
                        addAlerts(alertas);
                    } else {
                        toastr.error('El archivo no tiene el formato adecuado', 'Ha ocurrido un error');
                    }
                    
                };
                reader.readAsBinaryString(file);
            } else {
                toastr.warning('Cargando Zonas', 'Info');
            }
            
        }

        function addAlerts(data) {
            var alertas = [];
            data.forEach(function(alert) {
                var item = {
                        "id": '0',
                        "nombre": setName($scope.zona, alert.dispositivo_control, alert.dispositivo_monitoreo, alert.sufijo),
                        "dispositivos": getDevice(alert.dispositivo_monitoreo)[0].id,
                        "min": setCondition(alert.dispositivo_monitoreo, alert.min),
                        "max": setCondition(alert.dispositivo_monitoreo, alert.max),
                        "t_espera": alert.tiempo_espera,
                        "t_repeticion": alert.repeticion,
                        "correos": 'soporte@helo.com.co',
                        "estado": '1',
                        "tipo": set_type(alert.tipo)[0].type,
                        "control": setControlFunction(alert.dispositivo_control, alert.accion),
                        "offset": (new Date()).getTimezoneOffset(),
                        "dias": setDays(alert.dias).join(),
                        "h_ini": convertirHora(alert.h_inicial, true),
                        "h_fin": convertirHora(alert.h_final, false),
                        "email": alert.dispositivo_control ? '0' : '1',
                        "grupo": null,
                        "control_en_off": '1',
                        "comparacion": '0',
                        "comparador": null,
                        "feriado": setFeriado(alert.ejecucion),
                        "ids_feriados": setFeriados(alert.ejecucion, alert.feriados),
                    }
                alertas.push(item);
            })

            callService(alertas);
            
        }

        function callService(alertas) {
            RESTServices.saveAlertsV2(alertas).then(function(data) {
                if (data.code == '200') {
                    $scope.flag_loading = false;
                    getAlerts($scope.zona.id);
                    toastr.success('Se ha creado las alertas correctamente', 'Alertas');  
                }else{
                    toastr.error('Ha ocurrido un error inesperado', 'Alertas')
                    $scope.flag_loading = false;
                    getAlerts($scope.zona.id);
                }
            })
        }

        function set_type(type) {
            return $scope.listaAlertas.filter(function(a){ return type === a.name})
        }

        function setControlFunction(control, accion) {
            if(control) {
                var device = getDevice(control)[0];
                console.log(device);
                //////si es un helo one 0, 1
                var tipo = device.tipo;
                if(tipo === '0' || tipo === '1'){ 
                    accion = accion === 'Apagar' ? '0' : '1';
                }
                return({
                    id: 0,
                    id_dispositivo: device.id,
                    set_point: accion,
                    tipo: device.tipo,
                })
            } else {
                return null
            }
        }

        function getDevice(device_name) {
            var device = $scope.devices.filter(function(d){ return  extraerSerial(device_name) === extraerSerial(d.nombre)});
            return device;
        }

        function extraerSerial(nombre) {
            var regex = /\b[a-zA-Z0-9]{10}\b/; // Expresión regular para encontrar un código alfanumérico de 10 caracteres
            var match = nombre.match(regex);
            return match ? match[0] : null
        }

        function setName(zona, control, monitoreo, sufijo) {
            if(control) {
                return zona.nombre + ' - ' + 'Control' + ' - ' + control  + (sufijo ? ( ' - ' + sufijo) : '');
            } else {
                return zona.nombre + ' - ' + 'Monitoreo' + ' - ' + monitoreo + (sufijo ? ( ' - ' + sufijo) : '');
            }
        }

        function setCondition(device_name, ind ) {
            if(ind){
                var device = getDevice(device_name);
                return device[0].offset ? ind - parseFloat(device[0].offset) : ind;
            } else {
                return null
            }
            
        }

        function setDays(ind) {
            var days = ind.split(',');
            days = days.map(function(f){
                return f.trim();
            })
            var ArrayDays = [];
            days.forEach(function(d){
                switch(d){
                    case 'Dom': 
                        ArrayDays.push(0);
                        break;
                    case 'Lun':
                        ArrayDays.push(1);
                        break;
                    case 'Mar':
                        ArrayDays.push(2);
                        break;
                    case 'Mie':
                        ArrayDays.push(3);
                        break;
                    case 'Jue':
                        ArrayDays.push(4);
                        break;
                    case 'Vie':
                        ArrayDays.push(5);
                        break;
                    case 'Sab': 
                        ArrayDays.push(6);
                        break;
                    case 'Diario': 
                        ArrayDays.push(0,1,2,3,4,5,6);
                        break;
                    case 'Lun - Vie': 
                        ArrayDays.push(1,2,3,4,5);
                        break;
                    case 'Fines de semana': 
                        ArrayDays.push(6,0);
                        break;
                }
            })

            return ArrayDays;
        }

        function convertirHora(decimal, ind) {
            if(decimal){
                var totalHours = decimal * 24;
                var hours = Math.floor(totalHours);
                var minutes = Math.round((totalHours - hours) * 60);
                var date = new Date();

                // Opcional: Asegurar dos dígitos en horas y minutos
                var hoursStr = hours.toString().padStart(2, '0');
                var minutesStr = minutes.toString().padStart(2, '0');

                date.setHours(hoursStr);
                date.setMinutes(minutesStr);
                date.setSeconds(0);

                return $filter('date')(date, 'HH:mm:ss')

            } else {
                if(ind) {
                    return '00:00:00'
                } else {
                    return '23:59:59'
                }
            }
            
        }

        function getHolidays() {
            var params = {
                "id_usuario": $localStorage.id_usuario,
                "id_pais": $scope.zona.id_pais,
                "year": $filter('date')(new Date(), 'yyyy'),
            };
      
            RESTServices.post_header('cliente/consulta_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code === '200') {
                    $scope.holidays = data.festivos;
                } else {
                    $scope.holidays = [];
                }
            })
        }

        function setFeriados(ejecucion, feriados) {
            var holidays = [];
            
            if(ejecucion === 'siempre' || ejecucion === 'siempre que no sea feriado' || ejecucion === undefined){
                return null
            } else {
                feriados = (feriados || '').split(',');
                feriados = feriados.map(function(f){
                    return f.trim();
                })
                $scope.holidays.forEach(function(h){
                    if(feriados.includes(h.day)){
                        holidays.push(h.id);
                    }
                })
                
                return holidays.join(',');
            }
            
        }

        function setFeriado(ejecucion) {
            switch(ejecucion){
                case 'siempre':
                    return '0';
                case 'feriado':
                    return '1';
                case 'siempre que no sea feriado':
                    return '2';
                default:
                    return '0';
            }
        }

        function dividirEnBloques(arr, tamaño) {
            var resultado = [];
            var i;

            for (i = 0; i < arr.length; i += tamaño) {
                var bloque = arr.slice(i, i + tamaño);
                resultado.push(bloque);
            }

            return resultado;
        }


    }

})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.consumption').factory('consumoV2Util', function($filter) {
        return {
            
            setYesterday: function () {
                var h = new Date();
                var s = h.getTime();
                var y = s - (1000 * 60 * 60 * 24);
                var d_i = new Date(y);
                var d_f = new Date(y);
                d_i.setHours(0);
                d_i.setMinutes(0);
                d_i.setSeconds(0);
                d_f.setHours(23);
                d_f.setMinutes(59);
                d_f.setSeconds(59);
                var d = [d_i, d_f];
                return d;
            },
    
            setMonth: function () {
                var d_i = new Date();
                var d_f = new Date();
                d_i.setDate(1);
                d_i.setHours(0);
                d_i.setMinutes(0);
                d_i.setSeconds(0);
                var d = [d_i, d_f];
                return d;
            },
    
            setYear: function () {
                var d_i = new Date();
                var d_f = new Date();
                d_i.setMonth(0);
                d_i.setDate(1);
                d_i.setHours(0);
                d_i.setMinutes(0);
                d_i.setSeconds(0);                
                var d = [d_i, d_f];
                return d;
            }, 
    
            lastday: function(y,m){
                return  new Date(y, m +1, 0).getDate();
            },

            setAllMonth: function (date) {
                var d_i = date;
                var d_i = new Date(d_i.getFullYear(), d_i.getMonth(), 1)
                var d_f = new Date(d_i.getFullYear(), d_i.getMonth(), this.lastday(d_i.getFullYear(), d_i.getMonth()))
                d_f.setHours(23);
                d_f.setMinutes(59);
                d_f.setSeconds(59);
                d_i = $filter('date')(d_i, 'yyyy-MM-dd HH:mm:ss');
                d_f = $filter('date')(d_f, 'yyyy-MM-dd HH:mm:ss');
                var d = {
                    fecha_ini: d_i,
                    fecha_fin: d_f,
                }
                return d;
            },

            setAllYear: function (date) {
                var h = new Date();
                var d_i;
                var d_f;
                if (h.getFullYear() === date.getFullYear()) {
                    d_i = date;
                    d_i.setMonth(0);
                    d_i.setDate(1);
                    d_i.setHours(0);
                    d_i.setMinutes(0);
                    d_i.setSeconds(0);
                    d_f = new Date();
                } else {
                    d_i = date;
                    d_f = new Date();
                    d_f.setYear(d_i.getFullYear());
                    d_f.setMonth(11);
                    d_f.setDate(31);
                    d_f.setHours(23);
                    d_f.setMinutes(59);
                    d_f.setSeconds(59);
                }
                d_i = $filter('date')(d_i, 'yyyy-MM-dd HH:mm:ss');
                d_f = $filter('date')(d_f, 'yyyy-MM-dd HH:mm:ss');
                var d = {
                    fecha_ini: d_i,
                    fecha_fin: d_f,
                }
                return d;
            },

            // Adapts the body of GET /devices/{id}/consumption to the legacy chart
            // rows. month -> {dia, fecha, valor}, year -> {mes, fecha, valor} (as
            // produced by formatMonth), day -> {dia, fecha: 'HH:mm', valor}. Day rows
            // keep the Bogota wall clock written in `start` (never converted to the
            // browser time zone), so the hour labels are right for any viewer.
            toLegacyConsumo: function(res, period) {
                var points = res && res.points ? res.points : [];
                return points.map(function(p) {
                    var valor = Number(p.kwh);
                    if (period === 'day') {
                        return {
                            dia: p.start.substring(0, 10) + ' ' + p.start.substring(11, 19),
                            fecha: p.start.substring(11, 16),
                            valor: valor,
                        };
                    }
                    var y = Number(p.start.substring(0, 4));
                    var m = Number(p.start.substring(5, 7)) - 1;
                    if (period === 'year') {
                        return {
                            mes: p.start.substring(0, 7) + '-01 00:00:00',
                            fecha: $filter('date')(new Date(y, m, 1), 'MMM y'),
                            valor: valor,
                        };
                    }
                    return {
                        dia: p.start.substring(0, 10) + ' 00:00:00',
                        fecha: $filter('date')(new Date(y, m, Number(p.start.substring(8, 10))), 'MMM d, y'),
                        valor: valor,
                    };
                });
            },

            // Method/day flags of a consumption body: `estimated` (derived from the
            // nominal voltage, shows "Estimado") and `partial` (day still running).
            consumoFlags: function(res) {
                return {
                    estimated: !!(res && res.estimated),
                    partial: !!(res && res.partial),
                };
            },

            formatMonth: function(data, date) {
                var h = new Date(date);
                var array = data.map(function(d, i){
                    h.setMonth(i === 0 ? h.getMonth() : h.getMonth() + 1);
                    return ({
                        mes: $filter('date')(h, 'yyyy-MM-dd HH:mm:ss'),
                        fecha: $filter('date')(h, 'MMM y'),
                        valor: d.valor,
                    })
                })
                return array;
            },

            formatIntervalMonths: function(data, date_ini, date_fin) {
                var h = new Date();
                if (date_ini.getFullYear() === date_fin.getFullYear()) {
                    h.setYear(date_ini.getFullYear());
                    h.setDate(1);
                    h.setMonth(date_ini.getMonth());
                    var array = data.map(function(d, i){
                        if (i === 0) {
                            return ({
                                mes: $filter('date')(h, 'yyyy-MM-dd HH:mm:ss'),
                                fecha: $filter('date')(h, 'MMM y'),
                                valor: d.valor,
                            })
                        } else {
                            h.setMonth(date_ini.getMonth() + i);
                            return ({
                                mes: $filter('date')(h, 'yyyy-MM-dd HH:mm:ss'),
                                fecha: $filter('date')(h, 'MMM y'),
                                valor: d.valor,
                            })
                        }
                        
                        
                    })
                    return array;
                } else {
                    h.setYear(date_ini.getFullYear());
                    h.setDate(1);
                    h.setMonth(date_ini.getMonth());
                    var array = data.map(function(d, i){
                        if (i === 0) {
                            return ({
                                mes: $filter('date')(h, 'yyyy-MM-dd HH:mm:ss'),
                                fecha: $filter('date')(h, 'MMM y'),
                                valor: d.valor,
                            })
                        } else {
                            if (h.getMonth() === 11){
                                h.setFullYear(h.getFullYear() + 1);
                                h.setMonth(0);
                                return ({
                                    mes: $filter('date')(h, 'yyyy-MM-dd HH:mm:ss'),
                                    fecha: $filter('date')(h, 'MMM y'),
                                    valor: d.valor,
                                })
                            } else {
                                h.setMonth(h.getMonth() + 1);
                                return ({
                                    mes: $filter('date')(h, 'yyyy-MM-dd HH:mm:ss'),
                                    fecha: $filter('date')(h, 'MMM y'),
                                    valor: d.valor,
                                })
                            }
                            
                        }
                    })
                    return array;
                }
               
            },

            formatDays: function(data, date) {
                var h = new Date(date);
                var array = data.map(function(d, i){
                    h.setDate(i === 0 ? h.getDate() : h.getDate() + 1);
                    return ({
                        dia: d.dia,
                        fecha: $filter('date')(h, 'MMM d, y'),
                        valor: d.valor,
                    })
                })
                return array;
            },

            sumarConsumosDia: function(data, date) {
                var fechas = [];
                data.forEach(function(d){
                    if(fechas.findIndex(function(f){return f === d.dia}) === -1){
                        fechas.push(d.dia)
                    }
                });

                var array = fechas.map(function(f) {
                    var fecha = data.filter(function(d){
                        return d.dia === f;
                    })
                    var all = fecha.map(function(c){ return Number(c.valor)});
                    var sum = all.reduce(function(previous, current) { return current += previous});
                    return ({
                        dia: f,
                        fecha: $filter('date')(new Date(f), 'MMM d, y'),
                        valor: sum,
                    })
                })
                
                return array;
            },

            sumarConsumosMes: function(data, date) {
                var fechas = [];
                data.forEach(function(d){
                    if(fechas.findIndex(function(f){return f === d.mes}) === -1){
                        fechas.push(d.mes)
                    }
                });

                var array = fechas.map(function(f) {
                    var fecha = data.filter(function(d){
                        return d.mes === f;
                    })
                    var all = fecha.map(function(c){ return Number(c.valor)});
                    var sum = all.reduce(function(previous, current) { return current += previous});
                    return ({
                        mes: f,
                        fecha: $filter('date')(new Date(f), 'MMM, y'),
                        valor: sum,
                    })
                })
                
                return array;
            },

            setPlanFacturacion: function(type) {
                switch(type) {
                    case '1':
                        return 'Residencial';
                        break;
                    case '2':
                        return 'Comercial';
                        break;
                    case '3':
                        return 'Industrial';
                        break;
                }
            },

            changeMonthtoDate: function(month) {
                var h = new Date();
                var y = h.getFullYear();
                switch(month) {
                    case 'Enero':
                        return y + '-01';
                        break;
                    case 'Febrero':
                        return y + '-02';
                        break;
                    case 'Marzo':
                        return y + '-03';
                        break;
                    case 'Abril':
                        return y + '-04';
                        break;
                    case 'Mayo':
                        return y + '-05';
                        break;
                    case 'Junio':
                        return y + '-06';
                        break;
                    case 'Julio':
                        return y + '-07';
                        break;
                    case 'Agosto':
                        return y + '-08';
                        break;
                    case 'Septiembre':
                        return y + '-09';
                        break;
                    case 'Octubre':
                        return y + '-10';
                        break;
                    case 'Noviembre':
                        return y + '-11';
                        break;
                    case 'Diciembre':
                        return y + '-12';
                        break;
                }
            },
            setDateFormat: function(type){
                switch (type) {
                    case 1:
                        return this.formato.month;
                        break;
                    case 2:
                        return this.formato.year;
                        break;
                    case 3:
                        return this.formato.day;
                        break;
                }
            },

            setDateminMode: function(type){
                switch (type) {
                    case 1:
                        return 'month';
                        break;
                    case 2:
                        return 'year';
                        break;
                    case 3:
                        return 'day';
                        break;
                }
            },

            setLabel: function(type){
                switch (type) {
                    case 1:
                        return 'Mes';
                        break;
                    case 2:
                        return 'Año';
                        break;
                    case 3:
                        return 'Día';
                        break;
                }
            },

            formato : { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' },

            filters : [
                {
                    name: 'Día',
                    type: 3,
                    status: false,
                },
                {
                    name: 'Mes',
                    type: 1,
                    status: true,
                },
                {
                    name: 'Año',
                    type: 2,
                    status: false,
                }
            ],




        }
    })
})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.consumption').service('consumoServices', consumoServices);

    function consumoServices() {
        return {
            intervalsDates: [
                {
                    value: 0,
                    nombre: 'Ayer'
                },
                {
                    value: 1,
                    nombre: 'Mes'
                },
                {
                    value: 2,
                    nombre: 'Año'
                },
                {
                    value: 3,
                    nombre: 'Personalizar'
                },
            ],

            formato : { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' },

            tabsConsumo: [
                {
                    type: 'energy',
                    status: true,
                    name: 'Energía',
                    unit: 'KWh',
                },
                {
                    type: 'power',
                    status: false,
                    name: 'Potencia',
                    unit: 'W',
                },
                
            ],

            tabsHeloE: [
                {
                    type: 'energy',
                    status: true,
                    name: 'Energía',
                    unit: 'KWh',
                },  
            ],

            tabsFacturacion: [
                {
                    type: 'value',
                    status: true,
                    name: 'Valor Factura',
                    unit: '$',
                },
                {
                    type: 'consumption',
                    status: false,
                    name: 'KWh Consumidos',
                    unit: 'KWh',
                },
                {
                    type: 'kwh',
                    status: false,
                    name: 'Valor KWh',
                    unit: '$',
                },
                
            ],

            filters : [
                {
                    name: 'Día',
                    type: 0,
                    status: false,
                    id: 'day',
                },
                {
                    name: 'Mes',
                    type: 1,
                    status: true,
                    id: 'month'
                },
            ],

            id_punto_facturacion: null,
            punto_facturacion: null,
            AllPuntos_facturacion: null,
            logoHeloData: 'data:image/jpeg;base64,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',
        
        }

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('Dashboard_clienteCtrl', Dashboard_clienteCtrl);

    /** @ngInject */
    function Dashboard_clienteCtrl($timeout, $state, $scope, $location, $rootScope, $localStorage) {
        $scope.rol = $localStorage.rol;
        var path = $location.path();
        if(path === '/dashboard_cliente/zones' || path === '/dashboard_cliente/projects'){
            $scope.showButtonsViews = true;
        }
        if(path === '/dashboard_cliente'){
            if($localStorage.rol === '6' || $localStorage.rol === '8'){
                $state.go('dashboard_cliente.projects');
                $scope.showButtonsViews = true;
            }else {
                $state.go('dashboard_cliente.zones');
                $scope.showButtonsViews = true;
            }
        }

        $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams){
            $timeout(function(){
                switch(toState.url) {
                    case '/zones':
                    case '/projects':
                        $scope.showButtonsViews = true;
                        break;
                    case '/dashboard_cliente':
                        if($localStorage.rol === '6' || $localStorage.rol === '8'){
                            $state.go('dashboard_cliente.projects');
                        }else {
                            $state.go('dashboard_cliente.zones');
                        }
                        
                        break;
                    default:
                        $scope.showButtonsViews = false;
                }
            })
        });
        
    }
})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.dashboard_cliente').service('clientServices', clientServices);

    function clientServices() {
        return {
            rango_temp : [{
                "id": "2",
                "nombre": "Apagar"
            }, {
                "id": "9",
                "nombre": "16"
            }, {
                "id": "10",
                "nombre": "17"
            }, {
                "id": "11",
                "nombre": "18"
            }, {
                "id": "12",
                "nombre": "19"
            }, {
                "id": "13",
                "nombre": "20"
            }, {
                "id": "14",
                "nombre": "21"
            }, {
                "id": "15",
                "nombre": "22"
            }, {
                "id": "16",
                "nombre": "23"
            }, {
                "id": "17",
                "nombre": "24"
            }, {
                "id": "18",
                "nombre": "25"
            }, {
                "id": "19",
                "nombre": "26"
            }, {
                "id": "20",
                "nombre": "27"
            }, {
                "id": "21",
                "nombre": "28"
            }, {
                "id": "22",
                "nombre": "29"
            }, {
                "id": "23",
                "nombre": "30"
            }]
        }
 
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .service('zoneSharingServices', zoneSharingServices);

    /** @ngInject */
    function zoneSharingServices(RESTServices, $q) {
        // Backend caps of POST /zones/users (share_input.go); checked here so the
        // user gets a specific reason instead of a generic failure.
        var MAX_ZONES = 200;
        var MAX_EMAILS = 50;
        var MAX_PAIRS = 1000;
        var MAX_EMAIL_CHARS = 45;
        var EMAIL_RE = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/;

        // usuario_zona.email is VARCHAR(45) and the API counts runes (Go), so count
        // code points (Array.from), not UTF-16 units (.length). Also used by the
        // single-share entry points (newZone, nuevo-tecnico).
        function emailTooLong(email) {
            return Array.from(String(email || '').trim()).length > MAX_EMAIL_CHARS;
        }

        // Splits free text on commas, semicolons and whitespace, trims,
        // lowercases and dedupes. The caller's own email is dropped (a user
        // cannot share a zone with themselves) and reported via ownRemoved.
        function parseEmails(text, ownEmail) {
            var result = { emails: [], invalid: [], ownRemoved: false };
            var own = String(ownEmail || '').trim().toLowerCase();
            var seen = {};
            String(text || '').split(/[\s,;]+/).forEach(function (raw) {
                var email = raw.trim().toLowerCase();
                if (email === '' || seen[email]) {
                    return;
                }
                seen[email] = true;
                if (!EMAIL_RE.test(email)) {
                    result.invalid.push(email);
                } else if (own !== '' && email === own) {
                    result.ownRemoved = true;
                } else {
                    result.emails.push(email);
                }
            });
            return result;
        }

        // Counts the per-pair results of POST /zones/users. A pair is "created"
        // or "already_has_access" only when its status is 200.
        function summarizeShareResults(results) {
            var list = angular.isArray(results) ? results : [];
            var summary = { created: 0, already: 0, failed: 0, total: list.length, failures: [], text: '' };
            list.forEach(function (r) {
                if (r.status === 200 && r.outcome === 'created') {
                    summary.created++;
                } else if (r.status === 200 && r.outcome === 'already_has_access') {
                    summary.already++;
                } else {
                    summary.failed++;
                    summary.failures.push({ id_zona: r.id_zona, email: r.email, message: r.message });
                }
            });
            var parts = [];
            if (summary.created > 0) {
                parts.push('Accesos creados: ' + summary.created + '.');
            }
            if (summary.already > 0) {
                parts.push('Ya tenían acceso: ' + summary.already + '.');
            }
            if (summary.failed > 0) {
                parts.push('Con error: ' + summary.failed + '.');
            }
            summary.text = parts.join(' ');
            return summary;
        }

        // Case-insensitive lookup in an access list (entity users included).
        function findAccess(users, email) {
            var wanted = String(email || '').trim().toLowerCase();
            return (users || []).filter(function (u) {
                return String(u.email || '').trim().toLowerCase() === wanted;
            })[0];
        }

        // Validates the input, sends ONE bulk request and resolves the summary.
        // Rejects {reason: 'no_zones' | 'no_emails' | 'invalid_emails' (+invalid)
        // | 'email_too_long' | 'too_many_zones' | 'too_many_emails'
        // | 'too_many_pairs' | 'request_failed'}; nothing is sent on validation
        // errors or when a backend cap would be exceeded (no chunking).
        function share(zoneIds, emailsText, rol, ownEmail) {
            if (!zoneIds || zoneIds.length === 0) {
                return $q.reject({ reason: 'no_zones' });
            }
            if (zoneIds.length > MAX_ZONES) {
                return $q.reject({ reason: 'too_many_zones', max: MAX_ZONES, count: zoneIds.length });
            }
            var parsed = parseEmails(emailsText, ownEmail);
            if (parsed.invalid.length > 0) {
                return $q.reject({ reason: 'invalid_emails', invalid: parsed.invalid });
            }
            if (parsed.emails.length === 0) {
                return $q.reject({ reason: 'no_emails', ownRemoved: parsed.ownRemoved });
            }
            var tooLong = parsed.emails.filter(emailTooLong);
            if (tooLong.length > 0) {
                return $q.reject({ reason: 'email_too_long', max: MAX_EMAIL_CHARS, long: tooLong });
            }
            if (parsed.emails.length > MAX_EMAILS) {
                return $q.reject({ reason: 'too_many_emails', max: MAX_EMAILS, count: parsed.emails.length });
            }
            if (zoneIds.length * parsed.emails.length > MAX_PAIRS) {
                return $q.reject({ reason: 'too_many_pairs', max: MAX_PAIRS, zones: zoneIds.length, emails: parsed.emails.length });
            }
            return RESTServices.addZoneUsersBulkV2(parsed.emails, rol, zoneIds)
                .then(function (res) {
                    var results = res && res.data && res.data.results;
                    if (!angular.isArray(results) || results.length === 0) {
                        return $q.reject({ reason: 'request_failed' });
                    }
                    return summarizeShareResults(results);
                }, function () {
                    return $q.reject({ reason: 'request_failed' });
                });
        }

        return {
            parseEmails: parseEmails,
            summarizeShareResults: summarizeShareResults,
            findAccess: findAccess,
            share: share,
            emailTooLong: emailTooLong,
            maxEmailChars: MAX_EMAIL_CHARS,
        };
    }
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.historial')
        .controller('historialCtrl', historialCtrl);

    /** @ngInject */

    function historialCtrl($scope, $element, baConfig, layoutPaths, $window, $localStorage, ngDialog, RESTServices, $filter, $state, SHAREServices, $rootScope) {
        $scope.flag1 = false;
        $scope.flag2 = false;
        $scope.rol = '0';
        $scope.v_program = false;
        $scope.flag_valid = false;

        // Owned zones only (same scope as the legacy lista_zonas2.php); zonas_externas is ignored.
        RESTServices.fetchClientZones().then(function(data) {
            if (data != null && data.code == 200) {
                $scope.tabla = {};
                $scope.tabla.zonas = data.zonas || [];
            }
        });

        $scope.fecha = function() {
            $scope.fecha_filtro = $filter('date')($scope.des_f_ini, 'yyyy-MM-dd');
            $scope.programaciones_filtradas = $filter('filter')($scope.programaciones, { dia: $scope.fecha_filtro }, true);
            $scope.totalItems = $scope.programaciones_filtradas.length;
        }
        $scope.open1 = function() {
            $scope.popup.opened = true;
        };

        $scope.options1 = {
            showWeeks: false
        };

        $scope.popup = {
            opened: false,
        };

        $scope.status = {
            isopen: false
        };

        $scope.refresh = function() {
            $scope.fecha_filtro = undefined;
            $scope.totalItems = $scope.programaciones.length;
        }

        $scope.getProgram = function(zona_id) {
            $scope.v_program = true;
            $scope.des_f_ini = undefined;
            $rootScope.flag_loading = true;

            var parameters = {
                "id_zona": zona_id
            };

            $scope.programaciones = [];

            RESTServices.post_header('lista_programacion.php', parameters, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data.code == 200) {

                    for (var i = 0; i < data.id.length; i++) {
                        var programacion = {
                            id: data.id[i],
                            dia: data.dia[i],
                            hini: data.hora_inicio[i],
                            hfin: data.hora_fin[i],
                            frec: data.frecuencia[i]
                        }
                        $scope.programaciones.push(programacion);
                    }
                }

                //Agregando programación de aires al arreglo
                var fields = {
                    //token: SHAREServices.hash_decode_token($localStorage.token),
                    id_usuario: $localStorage.id_usuario,
                    id_zona: zona_id
                }

                RESTServices.post_header('consulta_airesxzona.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                    if (ans.code == '200') {
                        var dispositivos = ans.dispositivos;
                        for (var i = 0; i < dispositivos.length; i++) {
                            var vars = {
                                //token: SHAREServices.hash_decode_token($localStorage.token),
                                id_usuario: $localStorage.id_usuario,
                                id_dispositivo: dispositivos[i].id
                            }
                            RESTServices.post_header('lista_programacion_aires.php', vars, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans2) {
                                if (ans2.code == '200') {
                                    for (var j = 0; j < ans2.programaciones.length; j++) {
                                        var aire = $filter('filter')(dispositivos, { id: ans2.programaciones[j].id_dispositivo }, true)[0];
                                        var programacion = {
                                            id: ans2.programaciones[j].id,
                                            dia: ans2.programaciones[j].dia,
                                            hini: ans2.programaciones[j].hini,
                                            hfin: ans2.programaciones[j].hfin,
                                            frec: ans2.programaciones[j].frecuencia,
                                            comando: ans2.programaciones[j].comando,
                                            comando_post: ans2.programaciones[j].comando_post,
                                            aire: aire.nombre
                                        }
                                        $scope.programaciones.push(programacion);
                                        $scope.totalItems = $scope.programaciones.length;
                                        $scope.currentPage = 1;
                                        $scope.itemsPerPage = 10;
                                    }
                                    $rootScope.flag_loading = false;
                                } else {
                                    $rootScope.flag_loading = false;
                                }
                            });

                        }
                    } else {
                        $rootScope.flag_loading = false;
                    }
                });

            });

        };

        ////////////////////////////////////////

        $scope.delete_programacion = function(programacion) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                closeByDocument: false,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Realmente desea eliminar la programación seleccionada?';

                    $scope.cancelar = function() {
                        ngDialog.close();
                    }

                    $scope.aceptar = function() {
                        var field = {
                            "id_programacion": programacion.id,
                            "id_usuario": $localStorage.id_usuario
                        };
                        RESTServices.post_header('elimina_programacion.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                            if (data.code == 200) {
                                $window.location.reload();
                                $scope.showmsg = function() {
                                    ngDialog.open({
                                        template: 'app/cliente/dashboard-cliente/templates/mensaje.html',
                                        className: 'ngdialog-theme-plain',
                                        controller: ['$scope', function($scope) {
                                            // controller logic
                                            $scope.titleModal = 'Programación de apagado';
                                            $scope.bodyModal = 'Se ha eliminado la programación correctamente';

                                            $scope.close = function() {
                                                ngDialog.close();
                                            };
                                        }]
                                    });
                                };
                                $scope.showmsg();
                                ngDialog.close();
                            }
                        });
                    }
                }]
            });
        }

        $scope.edit_programacion = function(programacion) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                closeByDocument: false,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Realmente desea editar la programación seleccionada?';

                    $scope.cancelar = function() {
                        ngDialog.close();
                    }

                    $scope.aceptar = function() {
                        $scope.showmsg = function() {
                            ngDialog.open({
                                template: 'app/cliente/dashboard-cliente/templates/add_programacion.html',
                                className: 'ngdialog-theme-plain',
                                controller: ['$scope', function($scope) {
                                    // controller logic
                                    //$scope.fecha_dia = $filter('date')(new Date(), 'yyyy-MM-dd');
                                    $scope.titleModal = 'Programación de apagado';
                                    $scope.agenda = [];
                                    $scope.agenda.day = new Date(programacion.dia);
                                    $scope.agenda.day.setTime($scope.agenda.day.getTime() + $scope.agenda.day.getTimezoneOffset() * 60 * 1000);
                                    $scope.agenda.hini = new Date(2016, 8, 31, parseInt(programacion.hini.substr(0, 2)), parseInt(programacion.hini.substr(3, 5)), parseInt(programacion.hini.substr(6, 8)));
                                    $scope.agenda.hfin = new Date(2016, 8, 31, parseInt(programacion.hfin.substr(0, 2)), parseInt(programacion.hfin.substr(3, 5)), parseInt(programacion.hfin.substr(6, 8)));
                                    $scope.agenda.frequency = programacion.frec;

                                    $scope.cerrar = function() {
                                        ngDialog.close();
                                    }

                                    $scope.agendar = function() {
                                        if (!(($scope.agenda.day == undefined) || ($scope.agenda.hini == undefined) || ($scope.agenda.hfin == undefined) || ($scope.agenda.frequency == undefined) || ($scope.agenda.hini >= $scope.agenda.hfin))) {
                                            var field = {
                                                "id_programacion": programacion.id,
                                                "dia": $filter('date')($scope.agenda.day, 'yyyy/MM/dd'),
                                                "hora_inicio": $filter('date')($scope.agenda.hini, 'HH:mm:ss'),
                                                "hora_fin": $filter('date')($scope.agenda.hfin, 'HH:mm:ss'),
                                                "frecuencia": $scope.agenda.frequency,
                                                "id_usuario": $localStorage.id_usuario
                                            };

                                            //Agregar programación
                                            RESTServices.post_header('edita_programacion.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                                                if (data.code == 200) {
                                                    $scope.flag_valid = false;
                                                    $window.location.reload();
                                                    $scope.showmsg = function() {
                                                        ngDialog.open({
                                                            template: 'app/cliente/dashboard-cliente/templates/mensaje.html',
                                                            className: 'ngdialog-theme-plain',
                                                            controller: ['$scope', function($scope) {
                                                                // controller logic
                                                                $scope.titleModal = 'Programación de apagado';
                                                                $scope.bodyModal = 'Se ha editado la programación de la zona correctamente';

                                                                $scope.close = function() {
                                                                    ngDialog.close();
                                                                };
                                                            }]
                                                        });
                                                    };
                                                    $scope.showmsg();
                                                    ngDialog.close();
                                                } else {
                                                    $scope.showmsg = function() {
                                                        ngDialog.open({
                                                            template: 'app/cliente/dashboard-cliente/templates/mensaje.html',
                                                            className: 'ngdialog-theme-plain',
                                                            controller: ['$scope', function($scope) {
                                                                // controller logic
                                                                $scope.titleModal = 'Programación de apagado';
                                                                $scope.bodyModal = 'No se ha podido editar la programación de forma correcta';

                                                                $scope.close = function() {
                                                                    ngDialog.close();
                                                                };
                                                            }]
                                                        });
                                                    };
                                                    $scope.showmsg();
                                                    ngDialog.close();
                                                }
                                            });
                                        } else {
                                            $scope.flag_valid = true;
                                            if ($scope.agenda.day == undefined) {
                                                $scope.text = "Debes agregar una fecha válida en el campo día";
                                            } else if ($scope.agenda.hini == undefined) {
                                                $scope.text = "Debes seleccionar una hora inicial";
                                            } else if (($scope.agenda.hfin == undefined) || ($scope.agenda.hini >= $scope.agenda.hfin)) {
                                                $scope.text = "Debes seleccionar una hora final válida que sea mayor a la hora inicial";
                                            } else if ($scope.agenda.frequency == undefined) {
                                                $scope.text = "Debes seleccionar una frecuencia para la programación";
                                            }
                                        }
                                    }
                                }]
                            });
                        };
                        $scope.showmsg();
                        ngDialog.close();
                    }
                }]
            });
        }


    }


})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.mantenimiento').service('maintenanceServices', maintenanceServices);

    function maintenanceServices($filter) {
        return {
            maintenanceTypes: [{
                    value: 0,
                    type: 'Mantenimiento Preventivo'
                },
                {
                    value: 1,
                    type: 'Mantenimiento Correctivo'
                }
                /*,
                                {
                                    value:2,
                                    type: 'Mantenimiento Predictivo'
                                },
                                {
                                    value:3,
                                    type: 'Mantenimiento Cero Horas u Overhaul'
                                },
                                {
                                    value:4,
                                    type: 'Mantenimiento en Uso'
                                },*/
            ],

            getMaintenanceTypes: function() {
                return this.maintenanceTypes
            },

            setCheckList: function(type) {
                var lista = $filter('filter')(this.checkList_mantenimientos, { tipo_dispositivo: type }, true);
                return lista;
            },

            selectActivityList: function(id) {
                return $filter('filter')(this.checkList_acciones, { id_lista_mantenimiento: id }, true);
            },

            selectActivity: function(id) {
                return $filter('filter')(this.checkList_acciones, { id: id }, true);
            },

            checkList_mantenimientos: [
                { 'id': '0', 'nombre': 'MANTENIMIENTO GENERAL', 'tipo_dispositivo': '0' },
                { 'id': '1', 'nombre': 'MANTENIMIENTO POR FALLA DEL CONTACTOR  ', 'tipo_dispositivo': '1', 'selected': false },
                { 'id': '2', 'nombre': 'MANTENIMIENTO POR FALLA DEL VENTILADOR  ', 'tipo_dispositivo': '1', 'selected': false },
                { 'id': '3', 'nombre': 'MANTENIMIENTO GENERAL', 'tipo_dispositivo': '1', 'selected': false },
                { 'id': '4', 'nombre': 'MANTENIMIENTO POR ACEITES Y REFRIGERANTES  ', 'tipo_dispositivo': '1', 'selected': false },
                { 'id': '5', 'nombre': 'MANTENIMIENTO POR FUGA DE GAS  ', 'tipo_dispositivo': '1', 'selected': false },
                { 'id': '6', 'nombre': 'MANTENIMIENTO POR LIMPIAR CONDENSADOR  ', 'tipo_dispositivo': '1', 'selected': false },
                { 'id': '7', 'nombre': 'MANTENIMIENTO POR CAMBIO DE COMPONETES ELECTRICOS ', 'tipo_dispositivo': '1', 'selected': false },
                { 'id': '8', 'nombre': 'MANTENIMIENTO POR CHEQUEO Y CARGA DE GAS ', 'tipo_dispositivo': '1', 'selected': false },
                { 'id': '9', 'nombre': 'MANTENIMIENTO POR SUSTITUCIÓN FILTRO DE GAS ', 'tipo_dispositivo': '1', 'selected': false },
                { 'id': '10', 'nombre': 'MANTENIMIENTO DEL SISTEMA ELECTRICO ', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '11', 'nombre': 'MANTENIMIENTO DEL SISTEMA MECÁNICO', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '12', 'nombre': 'MANTENIMIENTO POR BURBUJAS EN LA MIRILLA', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '13', 'nombre': 'MANTENIMIENTO POR COMPRESOR RUIDOSO', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '14', 'nombre': 'MANTENIMIENTO POR AIRE DEL CONDENSADOR SALE CALIENTE', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '15', 'nombre': 'MANTENIMIENTO A MOTORES', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '16', 'nombre': 'MANTENIMIENTO AL CIRCUITO REFRIGERANTE', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '17', 'nombre': 'MANTENIMIENTO A BOMBAS', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '18', 'nombre': 'MANTENIMIENTO EN LAS TUBERIAS Y CANALIZACIONES', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '19', 'nombre': 'MANTENIMIENTO POR EL COMPRESOR NO ARRANCA', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '20', 'nombre': 'MANTENIMIENTO POR PRESIÓN DE DESCARGA ALTA', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '21', 'nombre': 'MANTENIMIENTO POR  PRESIÓN DE SUCCIÓN BAJA - CONGELAMIENTO', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '22', 'nombre': 'MANTENIMIENTO POR  ALTA TEMPERATURA EN EL ÁREA ACONDICONADA', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '23', 'nombre': 'MANTENIMIENTO POR  BAJA TEMPERATURA EN EL ÁREA ACONDICIONADA', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '24', 'nombre': 'MANTENIMIENTO POR COMPRESOR VIBRA, SALTA Ó GOLPETEA', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '25', 'nombre': 'MANTENIMIENTO A LOS CONTROLES DEL MOTOR', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '26', 'nombre': 'MANTENIMIENTO A CONDENSADORES Y EVAPORADORES', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '27', 'nombre': 'MANTENIMIENTO A LOS VENTILADORES', 'tipo_dispositivo': '0', 'selected': false },
                { 'id': '28', 'nombre': 'MANTENIMIENTO SOLO A LA CABINA DE PASAJEROS', 'tipo_dispositivo': '25', 'selected': false },
                { 'id': '29', 'nombre': 'MANTENIMIENTO EN PUNTOS DE CONTROL GENERALES EN ZONA DE TRACCIÓN Y CONTROL', 'tipo_dispositivo': '25', 'selected': false },
                { 'id': '30', 'nombre': 'MANTENIMIENTO A LA CABINA Y A LA FOSA', 'tipo_dispositivo': '25', 'selected': false },
                { 'id': '31', 'nombre': 'MANTENIMIENTO EN CADA UNO DE LOS PISOS ', 'tipo_dispositivo': '25', 'selected': false },
                { 'id': '32', 'nombre': 'MANTENIMIENTO A LAS PUERTAS DE ACCESO A LOS PISOS', 'tipo_dispositivo': '25', 'selected': false },
                { 'id': '33', 'nombre': 'MANTENIMIENTO EN EL LARGO TOTAL DE LA ESCALERA', 'tipo_dispositivo': '29', 'selected': false },
                { 'id': '34', 'nombre': 'MANTENIMIENTO EN EL CABEZAL TENSOR', 'tipo_dispositivo': '29', 'selected': false },
                { 'id': '35', 'nombre': 'MANTENIMIENTO EN EL CABEZAL DE TRACCIÓN', 'tipo_dispositivo': '29', 'selected': false },
                { 'id': '36', 'nombre': 'MANTENIMIENTO DE LOS PANELES O MÓDULOS FOTOVOLTAICOS', 'tipo_dispositivo': '31', 'selected': false },
                { 'id': '37', 'nombre': 'MANTENIMIENTO DE LOS SOPORTES Y ESTRUCTURAS', 'tipo_dispositivo': '31', 'selected': false },
                { 'id': '38', 'nombre': 'MANTENIMIENTO DE CAJAS DE CONEXIÓN Y CADENAS', 'tipo_dispositivo': '31', 'selected': false },
                { 'id': '39', 'nombre': 'MANTENIMIENTO DE CABLEADO', 'tipo_dispositivo': '31', 'selected': false },
                { 'id': '40', 'nombre': 'MANTENIMIENTO DEL INVERSOR', 'tipo_dispositivo': '31', 'selected': false },
                { 'id': '41', 'nombre': 'MANTENIMIENTO DE LA PROTECCIÓN CONTRA RAYOS Y SISTEMA DE PUESTA A TIERRA', 'tipo_dispositivo': '31', 'selected': false },
                { 'id': '42', 'nombre': 'MANTENIMIENTO A EQUIPOS DE MEDICIÓN Y SISTEMAS DE MONITOREO', 'tipo_dispositivo': '31', 'selected': false },
                { 'id': '43', 'nombre': 'MANTENIMIENTO ELÉCTRICO DE LA PLANTA SOLAR', 'tipo_dispositivo': '31', 'selected': false },
                { 'id': '44', 'nombre': 'MANTENIMIENTO SISTEMA PRESIONES', 'tipo_dispositivo': '33', 'selected': false },
                { 'id': '45', 'nombre': 'MANTENIMIENTO SISTEMA HIDRÁULICO', 'tipo_dispositivo': '33', 'selected': false },
                { 'id': '46', 'nombre': 'MANTENIMIENTO SISTEMA ESTRUCTURA', 'tipo_dispositivo': '33', 'selected': false },
                { 'id': '47', 'nombre': 'MANTENIMIENTO SISTEMA ELÉCTRICO', 'tipo_dispositivo': '33', 'selected': false },  
                { 'id': '48', 'nombre': 'MANTENIMIENTO HELO AIR', 'tipo_dispositivo': '0', 'selected': false }, 
                { 'id': '49', 'nombre': 'MANTENIMIENTO HELO ONE', 'tipo_dispositivo': '3', 'selected': false }, 
                { 'id': '50', 'nombre': 'MANTENIMIENTO HELO TH', 'tipo_dispositivo': '2', 'selected': false }, 
            ],


            checkList_acciones: [
                { 'id': '0', 'id_lista_mantenimiento': '0', 'descripcion': 'Medir y verficar temperatura de zona (°C)', 'valor': '1' },
                { 'id': '1', 'id_lista_mantenimiento': '0', 'descripcion': 'Medir y verificar temperatura de entrada de la manejadora (°C)', 'valor': '1' },
                { 'id': '2', 'id_lista_mantenimiento': '0', 'descripcion': 'Medir y verficar temperatura de salida de la manejadora (°C)', 'valor': '1' },
                { 'id': '3', 'id_lista_mantenimiento': '0', 'descripcion': 'Medir y verificar los voltajes (V)', 'valor': '3' },
                { 'id': '4', 'id_lista_mantenimiento': '0', 'descripcion': 'Medir y verificar la corriente (A)', 'valor': '3' },
                { 'id': '5', 'id_lista_mantenimiento': '0', 'descripcion': 'Limpiar componentes tales como: tolvas, caracoles y filtros de aire', 'valor': '0' },
                { 'id': '6', 'id_lista_mantenimiento': '0', 'descripcion': 'Limpiar serpentines en su parte exterior con desincrustante', 'valor': '0' },
                { 'id': '7', 'id_lista_mantenimiento': '0', 'descripcion': 'Limpiar bandeja (charola) condensado de equipos', 'valor': '0' },
                { 'id': '8', 'id_lista_mantenimiento': '0', 'descripcion': 'Limpiar el cableado eléctrico del sistema en su conjunto', 'valor': '0' },
                { 'id': '9', 'id_lista_mantenimiento': '0', 'descripcion': 'Limpiar y balancear los alabes de los ventiladores', 'valor': '0' },
                { 'id': '10', 'id_lista_mantenimiento': '0', 'descripcion': 'Limpiar y engrasar la chumacera', 'valor': '0' },
                { 'id': '11', 'id_lista_mantenimiento': '0', 'descripcion': 'Limpiar finamente las turbinas', 'valor': '0' },
                { 'id': '12', 'id_lista_mantenimiento': '0', 'descripcion': 'Alinear las bandas de los equipos', 'valor': '0' },
                { 'id': '13', 'id_lista_mantenimiento': '0', 'descripcion': 'Revisar y reportar fallas por condiciones eléctricas (voltaje o corriente),  o cualquiera que afecte el funcionamiento adecuado del equipo (especificar en observaciones)', 'valor': '0' },
                { 'id': '14', 'id_lista_mantenimiento': '0', 'descripcion': 'Revisar y reportar fallas por condiciones mecánicas (presión, temperatura, ruido, vibración)  o cualquiera que afecte el funcionamiento adecuado del equipo (especificar en observaciones)', 'valor': '0' },
                { 'id': '15', 'id_lista_mantenimiento': '0', 'descripcion': 'Revisar y reportar fallas que evidencien fugas de refrigerante o cualquiera que afecte el funcionamiento adecuado del equipo (especificar en observaciones el tipo y la cantidad  de regrigerante adicionado)', 'valor': '0' },
                { 'id': '16', 'id_lista_mantenimiento': '0', 'descripcion': 'Revisar y reportar fallas que evidencien derrames de aceite o cualquiera que afecte el funcionamiento adecuado del equipo (especificar en observaciones el tipo y la cantidad  de aceite adicionado)', 'valor': '0' },
                { 'id': '17', 'id_lista_mantenimiento': '0', 'descripcion': 'Revisar y reportar las fugas de agua en bandejas y tuberías de drenaje cualquiera o que afecte el funcionamiento adecuado del equipo (especificar en observaciones)', 'valor': '0' },
                { 'id': '18', 'id_lista_mantenimiento': '0', 'descripcion': 'Revisar y reportar el correcto funcionamiento de los sistemas de enfriamiento de agua (motobomba, control de flujo, temperaturas y presiones) (especificar en observaciones)', 'valor': '0' },
                { 'id': '19', 'id_lista_mantenimiento': '0', 'descripcion': 'Revisar y reportar funcionamiento de las válvulas de expansión (especificar en observaciones)', 'valor': '0' },
                { 'id': '20', 'id_lista_mantenimiento': '0', 'descripcion': 'Revisar y reportar el correcto funcionamiento del equipo desde el panel de control o control remoto (si aplica) (especificar en observaciones)', 'valor': '0' },
                { 'id': '21', 'id_lista_mantenimiento': '0', 'descripcion': 'Revisar y reportar si se debe reparar o reemplazar algún elemento o repuesto del equipo (especificar en observaciones)', 'valor': '0' },
                { 'id': '22', 'id_lista_mantenimiento': '0', 'descripcion': 'Corregir las fallas eléctricas o mecánicas (especificar en observaciones)', 'valor': '0' },
                { 'id': '23', 'id_lista_mantenimiento': '0', 'descripcion': 'Corregir las fugas de refrigerante, agua o aceite (especificar en observaciones)', 'valor': '0' },
                { 'id': '24', 'id_lista_mantenimiento': '0', 'descripcion': 'Corregir las fallas en algún elemento o repuesto del equipo (especificar en observaciones)', 'valor': '0' },
                { 'id': '25', 'id_lista_mantenimiento': '0', 'descripcion': 'Posterior al mantenimiento preventivo de cada equipo, efectuar limpieza del área de trabajo', 'valor': '0' },
                { 'id': '26', 'id_lista_mantenimiento': '0', 'descripcion': 'Realizar cualquier otra tarea que sea necesaria para  un adecuado mantenimiento preventivo', 'valor': '0' },
                { 'id': '27', 'id_lista_mantenimiento': '1', 'descripcion': 'Instalar manómetros', 'valor': '0' },
                { 'id': '28', 'id_lista_mantenimiento': '1', 'descripcion': 'Checar con amperímetro si están quemadas las líneas del contactor y cerciorarse si no hay paso de la corriente', 'valor': '0' },
                { 'id': '29', 'id_lista_mantenimiento': '1', 'descripcion': 'Remplazar contactor', 'valor': '0' },
                { 'id': '30', 'id_lista_mantenimiento': '1', 'descripcion': 'Checar gas y aceite y cerciorarse que es la única falla', 'valor': '0' },
                { 'id': '31', 'id_lista_mantenimiento': '2', 'descripcion': 'Cerciorarse que el ventilador esta quemado.', 'valor': '0' },
                { 'id': '32', 'id_lista_mantenimiento': '2', 'descripcion': 'Desmontar el ventilador quemado.', 'valor': '0' },
                { 'id': '33', 'id_lista_mantenimiento': '2', 'descripcion': 'Remplazar el equipo.', 'valor': '0' },
                { 'id': '34', 'id_lista_mantenimiento': '2', 'descripcion': 'Checar que el equipo funcione y no sea la única falla.', 'valor': '0' },
                { 'id': '35', 'id_lista_mantenimiento': '3', 'descripcion': 'Compruebe los registros de funcionamiento de la unidad.', 'valor': '0' },
                { 'id': '36', 'id_lista_mantenimiento': '3', 'descripcion': 'Limpie todos los tamices de los sistemas de ductos. ', 'valor': '0' },
                { 'id': '37', 'id_lista_mantenimiento': '3', 'descripcion': 'Compruebe el tamaño de la gota de presión a través del filtro de aceite', 'valor': '0' },
                { 'id': '38', 'id_lista_mantenimiento': '3', 'descripcion': 'Sustituye el filtro de gas si este lo requiere. ', 'valor': '0' },
                { 'id': '39', 'id_lista_mantenimiento': '3', 'descripcion': 'Examine todos los componentes de la tubería para saber si hay salida y/o daño. ', 'valor': '0' },
                { 'id': '40', 'id_lista_mantenimiento': '3', 'descripcion': 'Limpie y repinte cualquier área que demuestre signos de corrosión.', 'valor': '0' },
                { 'id': '41', 'id_lista_mantenimiento': '3', 'descripcion': 'Examine y limpie el condensador para saber si es necesario cambiar. ', 'valor': '0' },
                { 'id': '42', 'id_lista_mantenimiento': '3', 'descripcion': 'Examine y limpie el serpentín del condensador', 'valor': '0' },
                { 'id': '43', 'id_lista_mantenimiento': '3', 'descripcion': 'Pruebe la tubería del respiradero de todas las válvulas de descarga. ', 'valor': '0' },
                { 'id': '44', 'id_lista_mantenimiento': '3', 'descripcion': 'Verifique los niveles del refrigerante', 'valor': '0' },
                { 'id': '45', 'id_lista_mantenimiento': '3', 'descripcion': 'Compruebe la temperatura y presión refrigerante del evaporador.', 'valor': '0' },
                { 'id': '46', 'id_lista_mantenimiento': '3', 'descripcion': 'Compruebe la temperatura y presión refrigerante del condensador.', 'valor': '0' },
                { 'id': '47', 'id_lista_mantenimiento': '4', 'descripcion': 'Compruebe la línea del líquido en la mirilla de cristal. ', 'valor': '0' },
                { 'id': '48', 'id_lista_mantenimiento': '4', 'descripcion': 'Realice todos los procedimientos de mantenimientos de semanales.', 'valor': '0' },
                { 'id': '49', 'id_lista_mantenimiento': '4', 'descripcion': 'Mida y registre el sistema de sobrecalentamiento. ', 'valor': '0' },
                { 'id': '50', 'id_lista_mantenimiento': '4', 'descripcion': 'Mida y registre el sistema de subenfriamiento. ', 'valor': '0' },
                { 'id': '51', 'id_lista_mantenimiento': '4', 'descripcion': 'Examine los componentes eléctricos para saber si hay deficiencia.', 'valor': '0' },
                { 'id': '52', 'id_lista_mantenimiento': '4', 'descripcion': 'Examine las líneas de fluido para saber si hay salida o daño. ', 'valor': '0' },
                { 'id': '53', 'id_lista_mantenimiento': '4', 'descripcion': 'Limpie hacia fuera cualquier tamiz en línea. ', 'valor': '0' },
                { 'id': '54', 'id_lista_mantenimiento': '4', 'descripcion': 'Limpie y repinte cualquier área que demuestre indicios de corrosión.', 'valor': '0' },
                { 'id': '55', 'id_lista_mantenimiento': '4', 'descripcion': 'Limpie los ventiladores del condensador', 'valor': '0' },
                { 'id': '56', 'id_lista_mantenimiento': '5', 'descripcion': 'Instalar manómetros y checar presión alta y baja .', 'valor': '0' },
                { 'id': '57', 'id_lista_mantenimiento': '5', 'descripcion': 'Buscar fuga y localizarla.', 'valor': '0' },
                { 'id': '58', 'id_lista_mantenimiento': '5', 'descripcion': 'Hacer un vacío (recuperar gas en su tanque recuperador)', 'valor': '0' },
                { 'id': '59', 'id_lista_mantenimiento': '5', 'descripcion': 'Soldar y Tapar fuga ', 'valor': '0' },
                { 'id': '60', 'id_lista_mantenimiento': '5', 'descripcion': 'Checar nivel de aceite', 'valor': '0' },
                { 'id': '61', 'id_lista_mantenimiento': '5', 'descripcion': 'Instalar aceite faltante', 'valor': '0' },
                { 'id': '62', 'id_lista_mantenimiento': '5', 'descripcion': 'Rellenar de gas el equipo el gas faltante', 'valor': '0' },
                { 'id': '63', 'id_lista_mantenimiento': '6', 'descripcion': 'Limpiar de tierra y polvo el condensador.', 'valor': '0' },
                { 'id': '64', 'id_lista_mantenimiento': '6', 'descripcion': 'Lavar por fuera el condensador con agua y jabón.', 'valor': '0' },
                { 'id': '65', 'id_lista_mantenimiento': '6', 'descripcion': 'Hacer un vacío (recuperar gas en su tanque recuperador)', 'valor': '0' },
                { 'id': '66', 'id_lista_mantenimiento': '7', 'descripcion': 'Checar con voltímetro las continuidades de cada línea de las piezas eléctricas.', 'valor': '0' },
                { 'id': '67', 'id_lista_mantenimiento': '7', 'descripcion': 'Si hay falta de corriente en alguna línea remplazar piezas.', 'valor': '0' },
                { 'id': '68', 'id_lista_mantenimiento': '8', 'descripcion': 'Instalar manómetros', 'valor': '0' },
                { 'id': '69', 'id_lista_mantenimiento': '8', 'descripcion': 'Checar presiones en altas y bajas presiones', 'valor': '0' },
                { 'id': '70', 'id_lista_mantenimiento': '8', 'descripcion': 'Si se requirió de relleno de gas volver a checar presión después del relleno', 'valor': '0' },
                { 'id': '71', 'id_lista_mantenimiento': '8', 'descripcion': 'Si se requirió de relleno de gas volver a checar presión después del relleno', 'valor': '0' },
                { 'id': '72', 'id_lista_mantenimiento': '8', 'descripcion': 'Dejar funcionando el equipo', 'valor': '0' },
                { 'id': '73', 'id_lista_mantenimiento': '9', 'descripcion': 'Desoldar filtro de gas.', 'valor': '0' },
                { 'id': '74', 'id_lista_mantenimiento': '9', 'descripcion': 'Desmontar filtro.', 'valor': '0' },
                { 'id': '75', 'id_lista_mantenimiento': '9', 'descripcion': 'Montar nuevo filtro.', 'valor': '0' },
                { 'id': '76', 'id_lista_mantenimiento': '9', 'descripcion': 'Soldar filtro nuevo.', 'valor': '0' },
                { 'id': '77', 'id_lista_mantenimiento': '9', 'descripcion': 'Checar que el equipo funcione normal y no presente fallas.', 'valor': '0' },
                { 'id': '78', 'id_lista_mantenimiento': '10', 'descripcion': 'Revisión de la alimentación eléctrica del tablero a la unidad, apretando bornes de llegada del conductor y salida de pastilla térmica, antes y después de dar el servicio de mantenimiento preventivo de la unidad. ', 'valor': '0' },
                { 'id': '79', 'id_lista_mantenimiento': '10', 'descripcion': 'Verificar voltaje de llegada al tablero de control, que sea de diseño de la unidad, antes y después de dar el servicio de mantenimiento preventivo de la unidad. ', 'valor': '0' },
                { 'id': '80', 'id_lista_mantenimiento': '10', 'descripcion': 'Verificar amperaje de consumo, antes y después de dar el servicio de mantenimiento preventivo de la unidad.', 'valor': '0' },
                { 'id': '81', 'id_lista_mantenimiento': '10', 'descripcion': 'Limpieza de contactores y relevadores de tablero de control, con líquido dieléctrico.', 'valor': '0' },
                { 'id': '82', 'id_lista_mantenimiento': '10', 'descripcion': 'Lubricación y limpieza del motor.', 'valor': '0' },
                { 'id': '83', 'id_lista_mantenimiento': '11', 'descripcion': 'Revisión de la alimentación eléctrica.', 'valor': '0' },
                { 'id': '84', 'id_lista_mantenimiento': '11', 'descripcion': 'Limpieza mensual de serpentines evaporadores y serpentines condensadores, con líquido a presión. ', 'valor': '0' },
                { 'id': '85', 'id_lista_mantenimiento': '11', 'descripcion': 'Limpieza de charola de condensados, para evitar se tapone la descarga de agua de condensación. ', 'valor': '0' },
                { 'id': '86', 'id_lista_mantenimiento': '11', 'descripcion': 'Limpieza de aspas de motores, condensadores y turbinas. ', 'valor': '0' },
                { 'id': '87', 'id_lista_mantenimiento': '11', 'descripcion': 'Ajuste de carga de gas refrigerante de acuerdo a diseño del equipo. ', 'valor': '0' },
                { 'id': '88', 'id_lista_mantenimiento': '11', 'descripcion': 'Limpieza de filtros de aire con la periodicidad requerida. ', 'valor': '0' },
                { 'id': '89', 'id_lista_mantenimiento': '11', 'descripcion': 'Verificación de temperatura de las áreas acondicionadas, que con un mínimo sea de 23ªC', 'valor': '0' },
                { 'id': '90', 'id_lista_mantenimiento': '11', 'descripcion': 'Verificación y en su caso corrección al ciclo de trabajo del compresor. ', 'valor': '0' },
                { 'id': '91', 'id_lista_mantenimiento': '11', 'descripcion': 'Verificación y en su caso corrección de fugas. ', 'valor': '0' },
                { 'id': '92', 'id_lista_mantenimiento': '11', 'descripcion': 'Limpieza de termostato, verificando que opere correctamente, en su paro, arranque y corte automático por temperatura. ', 'valor': '0' },
                //{'id': '93','id_lista_mantenimiento': '11','descripcion': '','valor':'0'},
                { 'id': '94', 'id_lista_mantenimiento': '11', 'descripcion': 'Verificación de las condiciones y trayectoria de los ductos del sistema de aire acondicionado. ', 'valor': '0' },
                { 'id': '95', 'id_lista_mantenimiento': '11', 'descripcion': 'Garantizar que el equipo funcione las 24 horas del día.', 'valor': '0' },
                { 'id': '96', 'id_lista_mantenimiento': '12', 'descripcion': 'Suelen aparecer cuando hay bajo nivel de gas refrigerante.', 'valor': '0' },
                { 'id': '97', 'id_lista_mantenimiento': '12', 'descripcion': 'Coloque y Evalue el manometro para medir la presión del gas refrigerante. ', 'valor': '0' },
                { 'id': '98', 'id_lista_mantenimiento': '12', 'descripcion': 'Busque y repare la fuga del gas. ', 'valor': '0' },
                { 'id': '99', 'id_lista_mantenimiento': '12', 'descripcion': 'Chequee cuanto gas no se fugo. ', 'valor': '0' },
                { 'id': '100', 'id_lista_mantenimiento': '12', 'descripcion': 'Recargue la cantidad de gas necesario.', 'valor': '0' },
                { 'id': '101', 'id_lista_mantenimiento': '12', 'descripcion': 'Chequee nuevamente la presión del gas con el manometro.', 'valor': '0' },
                { 'id': '102', 'id_lista_mantenimiento': '13', 'descripcion': 'Evalue que el sello no este escoriado. ', 'valor': '0' },
                { 'id': '103', 'id_lista_mantenimiento': '13', 'descripcion': 'Revise que el nivel de aceite no haya bajado gradualmente.', 'valor': '0' },
                { 'id': '104', 'id_lista_mantenimiento': '13', 'descripcion': 'Chequee los Fritros y las Válvulas correspondientes.', 'valor': '0' },
                { 'id': '105', 'id_lista_mantenimiento': '13', 'descripcion': 'Limpie, Repare o Cambie los Filtros de ser necesario. ', 'valor': '0' },
                { 'id': '106', 'id_lista_mantenimiento': '13', 'descripcion': 'Asegurese que las Válvulas de succión de compresor no esten rotas.', 'valor': '0' },
                { 'id': '107', 'id_lista_mantenimiento': '13', 'descripcion': 'En caso de requerirse: Repare o Cambie las Válvulas de succión.', 'valor': '0' },
                { 'id': '108', 'id_lista_mantenimiento': '14', 'descripcion': 'Cheque la ventilación del condensador y busque que tenga buena ventilación.', 'valor': '0' },
                { 'id': '109', 'id_lista_mantenimiento': '14', 'descripcion': 'Revise si el ventilador esta funcionando correctamente. ', 'valor': '0' },
                { 'id': '110', 'id_lista_mantenimiento': '14', 'descripcion': 'Evalue que el condensador no este Sucio.', 'valor': '0' },
                { 'id': '111', 'id_lista_mantenimiento': '14', 'descripcion': 'Limpie el condensador. ', 'valor': '0' },
                { 'id': '112', 'id_lista_mantenimiento': '15', 'descripcion': 'Revise los conductos de aire de motores abiertos para verificar su limpieza y detectar obstrucciones.', 'valor': '0' },
                { 'id': '113', 'id_lista_mantenimiento': '15', 'descripcion': 'Revise el estado de los rodamientos y lubríquelos.', 'valor': '0' },
                { 'id': '114', 'id_lista_mantenimiento': '15', 'descripcion': 'Tome lecturas de resistencia del aislamiento. Si las lecturas indican menos de un mega ohmio de resistencia, no encienda el motor ', 'valor': '0' },
                { 'id': '115', 'id_lista_mantenimiento': '15', 'descripcion': 'Verifique el valor de la resistencia.', 'valor': '0' },
                { 'id': '116', 'id_lista_mantenimiento': '16', 'descripcion': 'Asegúrese que el circuito está dotado de un indicador de humedad, y si registra presencia de humedad, instale nuevos núcleos de filtrado/secado en la línea líquida. Determine y corrija la fuente de la humedad.', 'valor': '0' },
                { 'id': '117', 'id_lista_mantenimiento': '16', 'descripcion': 'Revise el correcto funcionamiento de la válvula de expansión y la calibración de sobrecalentamiento para todo el rango de operación.', 'valor': '0' },
                { 'id': '118', 'id_lista_mantenimiento': '17', 'descripcion': 'Revise los rodamientos, empaques, acoples del eje, y sellos. Lubrique los rodamientos.', 'valor': '0' },
                { 'id': '119', 'id_lista_mantenimiento': '18', 'descripcion': 'Revise todos los soportes de la tubería para identificar señales de debilitamiento.', 'valor': '0' },
                { 'id': '120', 'id_lista_mantenimiento': '18', 'descripcion': 'Revise que no existan daños externos o vibración excesiva.', 'valor': '0' },
                { 'id': '121', 'id_lista_mantenimiento': '19', 'descripcion': 'Verifique que el switch principal no este abierto.', 'valor': '0' },
                { 'id': '122', 'id_lista_mantenimiento': '19', 'descripcion': 'Evalue que el contactor del Compresor no este defectuoso.', 'valor': '0' },
                { 'id': '123', 'id_lista_mantenimiento': '19', 'descripcion': 'Asegurese que no haya perdida de la alimentación eléctrica. ', 'valor': '0' },
                { 'id': '124', 'id_lista_mantenimiento': '20', 'descripcion': 'Colocar el manometro para verificar la cantidad de gas no condensable.', 'valor': '0' },
                { 'id': '125', 'id_lista_mantenimiento': '20', 'descripcion': 'Saque ó elimine el exceso de gas refrigerante.', 'valor': '0' },
                { 'id': '126', 'id_lista_mantenimiento': '20', 'descripcion': 'Purgue el gas no condensable.', 'valor': '0' },
                { 'id': '127', 'id_lista_mantenimiento': '20', 'descripcion': 'Verifique el funcionamiento de la válvula de agua. Chequee que no este inoperante o restringida. ', 'valor': '0' },
                { 'id': '128', 'id_lista_mantenimiento': '20', 'descripcion': 'Evalue que los Ventiladores de enfriamiento del condensador esten funcionando correctamente.', 'valor': '0' },
                { 'id': '129', 'id_lista_mantenimiento': '20', 'descripcion': 'Limpie o repare la válvula de agua.', 'valor': '0' },
                { 'id': '130', 'id_lista_mantenimiento': '20', 'descripcion': 'Tome la temperatura del agua de enfriamiento del condensador y verifique que no este elevada. ', 'valor': '0' },
                { 'id': '131', 'id_lista_mantenimiento': '20', 'descripcion': 'Recircule el aire caliente a traves de los ventiladores del condensador. ', 'valor': '0' },
                { 'id': '132', 'id_lista_mantenimiento': '20', 'descripcion': 'Controle la temperatura del agua.', 'valor': '0' },
                { 'id': '133', 'id_lista_mantenimiento': '20', 'descripcion': 'Compruebe la Presión del gas refrigerante. ', 'valor': '0' },
                { 'id': '134', 'id_lista_mantenimiento': '21', 'descripcion': 'Chequee que el filtro en la linea de líquido no este tapado. ', 'valor': '0' },
                { 'id': '135', 'id_lista_mantenimiento': '21', 'descripcion': 'Limpie o Cambie el Filtro. ', 'valor': '0' },
                { 'id': '136', 'id_lista_mantenimiento': '22', 'descripcion': 'Evalue que la Carga o espacio a acondiconar no sea excesivo. ', 'valor': '0' },
                { 'id': '137', 'id_lista_mantenimiento': '22', 'descripcion': 'Revise si hay excesivo aire de repuesto. ', 'valor': '0' },
                { 'id': '138', 'id_lista_mantenimiento': '22', 'descripcion': 'Registre si el aislamiento del Espacio a acondicionar es el adecuado para los BTU del aire.', 'valor': '0' },
                { 'id': '139', 'id_lista_mantenimiento': '23', 'descripcion': 'Tome en cuenta que el Termostato no este funcionando a una temperatura de control muy baja. ', 'valor': '0' },
                { 'id': '140', 'id_lista_mantenimiento': '23', 'descripcion': 'Ajustar ó reparar el Termostato', 'valor': '0' },
                { 'id': '141', 'id_lista_mantenimiento': '24', 'descripcion': 'Asegurese que los pernos de acoplamiento no esten sueltos.', 'valor': '0' },
                { 'id': '142', 'id_lista_mantenimiento': '24', 'descripcion': 'Chequee que el acople de transmisión del compresor no este flojo.', 'valor': '0' },
                { 'id': '143', 'id_lista_mantenimiento': '24', 'descripcion': 'Apriete fuertemente los Acoples.', 'valor': '0' },
                { 'id': '144', 'id_lista_mantenimiento': '24', 'descripcion': 'Revise la alineacion de las poleas.', 'valor': '0' },
                { 'id': '145', 'id_lista_mantenimiento': '24', 'descripcion': 'Ajuste los pernos de sijeción del motor o compresor flojo sobre su base. ', 'valor': '0' },
                { 'id': '146', 'id_lista_mantenimiento': '24', 'descripcion': 'Si el compresor golpetea, apague o detenga el compresor. ', 'valor': '0' },
                { 'id': '147', 'id_lista_mantenimiento': '24', 'descripcion': 'Compruebe que las partes internas del compresor esten o no rotas. ', 'valor': '0' },
                { 'id': '148', 'id_lista_mantenimiento': '24', 'descripcion': 'Repare o Reemplace el Comprsor', 'valor': '0' },
                { 'id': '149', 'id_lista_mantenimiento': '25', 'descripcion': 'Inspeccione los contactos del iniciador para detectar deterioro por corto circuito, chispas, o corrosión.', 'valor': '0' },
                { 'id': '150', 'id_lista_mantenimiento': '25', 'descripcion': 'Revise que las conexiones de los terminales estén bien apretadas.', 'valor': '0' },
                { 'id': '151', 'id_lista_mantenimiento': '25', 'descripcion': 'Examine los protectores de sobrecarga para detectar defectos y ajustarlos al nivel apropiado.', 'valor': '0' },
                { 'id': '152', 'id_lista_mantenimiento': '25', 'descripcion': 'Revise los acoples mecánicos para verificar que no están pegados o excesivamente sueltos.', 'valor': '0' },
                { 'id': '153', 'id_lista_mantenimiento': '25', 'descripcion': 'Verifique que los temporizadores operen en la secuencia correcta.', 'valor': '0' },
                { 'id': '154', 'id_lista_mantenimiento': '25', 'descripcion': 'Determine que los controles estándebidamente calibrados y en condiciones adecuadas de operación, particularmente el termostato, los interruptores de seguridad de presión de aceite y los interruptores de flujo.', 'valor': '0' },
                { 'id': '155', 'id_lista_mantenimiento': '26', 'descripcion': 'Asegúrese de haber completado una adecuada limpieza de las superficies de transferencia de calor según el tipo de unidad en uso, antes de ponerla en funcionamiento.', 'valor': '0' },
                { 'id': '156', 'id_lista_mantenimiento': '26', 'descripcion': 'Torres de enfriamiento: Verifique la tensión y solidez de los deflectores. Limpie los deflectores, el desagüe y las boquillas de rociado. Verifique que la válvula de agua suplementaria funcione correctamente.', 'valor': '0' },
                { 'id': '157', 'id_lista_mantenimiento': '27', 'descripcion': 'Revise que no haya aspas rotas, resquebrajadas, dobladas o sueltas.', 'valor': '0' },
                { 'id': '158', 'id_lista_mantenimiento': '27', 'descripcion': 'Revise los bujes, el eje del ventilador y los rodamientos.', 'valor': '0' },
                { 'id': '159', 'id_lista_mantenimiento': '27', 'descripcion': 'Revise la condición y tensión de la correa del ventilador.', 'valor': '0' },
                { 'id': '160', 'id_lista_mantenimiento': '27', 'descripcion': 'Reemplace los filtros de aire.', 'valor': '0' },
                { 'id': '161', 'id_lista_mantenimiento': '28', 'descripcion': 'Verifique alumbrado de emergencia.', 'valor': '0' },
                { 'id': '162', 'id_lista_mantenimiento': '28', 'descripcion': 'Evalue el estado y fijación del alumbrado y los accesorios internos.', 'valor': '0' },
                { 'id': '163', 'id_lista_mantenimiento': '28', 'descripcion': 'Comprobamos el funcionamiento de la botonera, alarma y comunicación bidireccional.', 'valor': '0' },
                { 'id': '164', 'id_lista_mantenimiento': '28', 'descripcion': 'Inspeccione las puertas, cierres, contactos, fotocélula o cortinas ópticas de la puerta de cabina.', 'valor': '0' },
                { 'id': '165', 'id_lista_mantenimiento': '28', 'descripcion': 'Chequee la nivelación de las cabinas.', 'valor': '0' },
                { 'id': '166', 'id_lista_mantenimiento': '28', 'descripcion': 'Limpie el techo de la cabina y comprobamos los dispositivos de seguridad.', 'valor': '0' },
                { 'id': '167', 'id_lista_mantenimiento': '28', 'descripcion': 'Verificación del sistema de sobrecarga.', 'valor': '0' },
                { 'id': '168', 'id_lista_mantenimiento': '28', 'descripcion': 'Comprobamos la comunicación con el cuarto de máquinas.', 'valor': '0' },
                { 'id': '169', 'id_lista_mantenimiento': '29', 'descripcion': 'Comprobamos el funcionamiento del interruptor diferencial.', 'valor': '0' },
                { 'id': '170', 'id_lista_mantenimiento': '29', 'descripcion': 'Revise el motor así como la ventilación forzada y los frenos con sus contactos.', 'valor': '0' },
                { 'id': '171', 'id_lista_mantenimiento': '29', 'descripcion': 'Inspeccione el reductor revisando también el nivel del aceite y controlando el juego de corona sinfín y acoplamiento.', 'valor': '0' },
                { 'id': '172', 'id_lista_mantenimiento': '29', 'descripcion': 'Verifique el estado de los canales, la adherencia de los cables en la polea de tracción y el indicador de nivel de piso.', 'valor': '0' },
                { 'id': '173', 'id_lista_mantenimiento': '29', 'descripcion': 'Limpie y lubrique  las poleas de desvío.', 'valor': '0' },
                { 'id': '174', 'id_lista_mantenimiento': '29', 'descripcion': 'Inspeccione el limitador de velocidad, engrase y limpie controlando sus contactos de seguridad.', 'valor': '0' },
                { 'id': '175', 'id_lista_mantenimiento': '29', 'descripcion': 'Controle el funcionamiento y estado de la maniobra.', 'valor': '0' },
                { 'id': '176', 'id_lista_mantenimiento': '29', 'descripcion': 'Chequee los fusibles, contactores y relés, así como los terminales y bornas de conexión.', 'valor': '0' },
                { 'id': '177', 'id_lista_mantenimiento': '29', 'descripcion': 'Limpie y verifique el estado de la cabeza del pistón.', 'valor': '0' },
                { 'id': '178', 'id_lista_mantenimiento': '29', 'descripcion': 'Revise la central hidráulica verificando los niveles de aceite, tuberías, mangueras y uniones.', 'valor': '0' },
                { 'id': '179', 'id_lista_mantenimiento': '29', 'descripcion': 'Compruebe que no existan fugas de aceite.', 'valor': '0' },
                { 'id': '180', 'id_lista_mantenimiento': '29', 'descripcion': 'Verifique las válvulas de seguridad de sobrepresión, de rotura, de emergencia antideriva, bomba manual y mangueras/tuberías.', 'valor': '0' },
                { 'id': '181', 'id_lista_mantenimiento': '29', 'descripcion': 'Evalue con el multímetro Protecciones eléctricas, sondas térmicas y termostatos.', 'valor': '0' },
                { 'id': '182', 'id_lista_mantenimiento': '30', 'descripcion': 'Chequee el estado y el correcto funcionamiento de las botoneras.', 'valor': '0' },
                { 'id': '183', 'id_lista_mantenimiento': '30', 'descripcion': 'Compruebe la iluminación del hueco.', 'valor': '0' },
                { 'id': '184', 'id_lista_mantenimiento': '30', 'descripcion': 'Verifique el estado de los cables de suspensión, sus terminales y tensión, y limitador de velocidad.', 'valor': '0' },
                { 'id': '185', 'id_lista_mantenimiento': '30', 'descripcion': 'Compruebe el funcionamiento de la botonera de revisión', 'valor': '0' },
                { 'id': '186', 'id_lista_mantenimiento': '30', 'descripcion': 'Controle y pruebe los contactos de seguridad tales como los de los cables de suspensión, de paracaídas y finales de carreras.', 'valor': '0' },
                { 'id': '187', 'id_lista_mantenimiento': '30', 'descripcion': 'Lubrique la polea diferencial', 'valor': '0' },
                { 'id': '188', 'id_lista_mantenimiento': '30', 'descripcion': 'Controle y ajuste las zapatas de la cabina ', 'valor': '0' },
                { 'id': '189', 'id_lista_mantenimiento': '30', 'descripcion': 'Inspeccione el nivel de aceite de los engrasadores automáticos de guías de cabina y contrapeso. Si es necesario rellene el aceite faltante.', 'valor': '0' },
                { 'id': '190', 'id_lista_mantenimiento': '30', 'descripcion': 'Engrase la polea tensora del cable limitador de velocidad.', 'valor': '0' },
                { 'id': '191', 'id_lista_mantenimiento': '30', 'descripcion': 'Compruebe el operador de puertas automáticas, revise el estado y tensión de correas y bandas de freno limpiándolas y lubricando los ejes.', 'valor': '0' },
                { 'id': '192', 'id_lista_mantenimiento': '30', 'descripcion': 'Inspeccione el funcionamiento del paracaídas ajustándolo si es necesario.', 'valor': '0' },
                { 'id': '193', 'id_lista_mantenimiento': '30', 'descripcion': 'Verifique la distancia entre el contrapeso y el amortiguador.', 'valor': '0' },
                { 'id': '194', 'id_lista_mantenimiento': '30', 'descripcion': 'Evalue los amortiguadores y sus seguridades.', 'valor': '0' },
                { 'id': '195', 'id_lista_mantenimiento': '30', 'descripcion': 'Compruebe el estado y desarrollo de los órganos de compensación.', 'valor': '0' },
                { 'id': '196', 'id_lista_mantenimiento': '30', 'descripcion': 'Verifique el contacto del acceso inferior al foso.', 'valor': '0' },
                { 'id': '197', 'id_lista_mantenimiento': '30', 'descripcion': 'Limpie el foso y compruebe los dispositivos de seguridad.', 'valor': '0' },
                { 'id': '198', 'id_lista_mantenimiento': '30', 'descripcion': 'Revise anclajes y fijaciones.', 'valor': '0' },
                { 'id': '199', 'id_lista_mantenimiento': '30', 'descripcion': 'Haga una revisión del contrapeso y armaduras (cabina/contrapeso).', 'valor': '0' },
                { 'id': '200', 'id_lista_mantenimiento': '30', 'descripcion': 'Finalmente efectue un revisión del cableado eléctrico.', 'valor': '0' },
                { 'id': '201', 'id_lista_mantenimiento': '31', 'descripcion': 'Chequee el estado y el correcto funcionamiento de las botoneras.', 'valor': '0' },
                { 'id': '202', 'id_lista_mantenimiento': '31', 'descripcion': 'En la señalización de plantas compruebe su estado e iluminación.', 'valor': '0' },
                { 'id': '203', 'id_lista_mantenimiento': '31', 'descripcion': 'Se comprueba que todos los componentes estén limpios y se mantengan libres de polvo y corrosión.', 'valor': '0' },
                { 'id': '204', 'id_lista_mantenimiento': '31', 'descripcion': 'Se verifican los indicadores luminosos y acústicos y sus fijaciones.', 'valor': '0' },
                { 'id': '205', 'id_lista_mantenimiento': '32', 'descripcion': 'Ajuste los enclavamientos, contactos, poleas y zapatas.', 'valor': '0' },
                { 'id': '206', 'id_lista_mantenimiento': '32', 'descripcion': 'Lubrique los rodillos y limpian las correderas.', 'valor': '0' },
                { 'id': '207', 'id_lista_mantenimiento': '32', 'descripcion': 'En las cerraduras, inspeccione el funcionamiento eléctrico y mecánico, el estado de conexiones y contactos eléctricos, así como del pestillo, accesorios y juegos. Además se limpie, lubrique y ajuste cada una de ellas.', 'valor': '0' },
                { 'id': '208', 'id_lista_mantenimiento': '32', 'descripcion': 'Verifique el enclavamiento, amortiguador, tirador, marco, cristal y la sensibilidad en semiautomáticas', 'valor': '0' },
                { 'id': '209', 'id_lista_mantenimiento': '32', 'descripcion': 'Compruebe el funcionamiento y ajuste de apertura, cierre y estado de las guías.', 'valor': '0' },
                { 'id': '210', 'id_lista_mantenimiento': '33', 'descripcion': 'Verifique y revise la Iluminación balaustrada, los zócalos y el armazón. Chequee que no exista corrosión.', 'valor': '0' },
                { 'id': '211', 'id_lista_mantenimiento': '33', 'descripcion': 'Ajuste la Iluminación Balaustrada, los cepillos de protección y deflectores.', 'valor': '0' },
                { 'id': '212', 'id_lista_mantenimiento': '33', 'descripcion': 'Inspeccione el funcionamiento del Tren de peldaños/tablillas y pasamanos.', 'valor': '0' },
                { 'id': '213', 'id_lista_mantenimiento': '33', 'descripcion': 'Lubrique y limpie las guías de los peldaños en las láminas de zócalo.', 'valor': '0' },
                { 'id': '214', 'id_lista_mantenimiento': '33', 'descripcion': 'Chequee el estado de los rodillos de peldaños.', 'valor': '0' },
                { 'id': '215', 'id_lista_mantenimiento': '33', 'descripcion': 'Efectue una limpieza de los vestigios del trabajo.', 'valor': '0' },
                { 'id': '216', 'id_lista_mantenimiento': '33', 'descripcion': 'Limpieza de los rieles de los rodillos de peldaño.', 'valor': '0' },
                { 'id': '217', 'id_lista_mantenimiento': '34', 'descripcion': 'Verifique y Controle el funcionamiento de los interruptores de llave, la parada de emergencia, las barreras infrarrojas y los equipos de vigilancia de las zonas de acceso.', 'valor': '0' },
                { 'id': '218', 'id_lista_mantenimiento': '34', 'descripcion': 'Revise los indicadores de dirección de marcha, iluminaciones de la placa porta-peines y entre peldaños, así como la pantalla digital.', 'valor': '0' },
                { 'id': '219', 'id_lista_mantenimiento': '34', 'descripcion': 'Haga una revisión de los pictogramas.', 'valor': '0' },
                { 'id': '220', 'id_lista_mantenimiento': '34', 'descripcion': 'Ajuste el control del contacto de la placa de descanso.', 'valor': '0' },
                { 'id': '221', 'id_lista_mantenimiento': '34', 'descripcion': 'Compruebe el control del funcionamiento de los intervalos de trabajo del sistema de lubricación.', 'valor': '0' },
                { 'id': '222', 'id_lista_mantenimiento': '34', 'descripcion': 'Evalue la Iluminación del espacio de máquinas, detector de humos y contactos de nivel de agua.', 'valor': '0' },
                { 'id': '223', 'id_lista_mantenimiento': '34', 'descripcion': 'Efectue una limpieza del foso de la escalera / rampa móvil.', 'valor': '0' },
                { 'id': '224', 'id_lista_mantenimiento': '34', 'descripcion': 'Chequee el estado de las cadenas de reenvío y los pasamanos. En caso de requerir: Lubríquelas.', 'valor': '0' },
                { 'id': '225', 'id_lista_mantenimiento': '34', 'descripcion': 'Verifique en que estado estan los peldaños/tablillas.', 'valor': '0' },
                { 'id': '226', 'id_lista_mantenimiento': '34', 'descripcion': 'Revise detalladamente el estado de las cadenas de peldaños/tablillas y su lubricación.', 'valor': '0' },
                { 'id': '227', 'id_lista_mantenimiento': '34', 'descripcion': 'Compruebe los contactos de tensión de las cadenas de peldaños/tablillas y las guías de los mismos.', 'valor': '0' },
                { 'id': '228', 'id_lista_mantenimiento': '34', 'descripcion': 'Haga un chequeo de la placa porta-peines y peines y sus guías laterales.', 'valor': '0' },
                { 'id': '229', 'id_lista_mantenimiento': '34', 'descripcion': 'Inspeccione el funcionamiento y ajuste de los contactos de la placa porta-peines.', 'valor': '0' },
                { 'id': '230', 'id_lista_mantenimiento': '34', 'descripcion': 'Ajuste y revise las calefacciones y radiadores de ventilación.', 'valor': '0' },
                { 'id': '231', 'id_lista_mantenimiento': '34', 'descripcion': 'Examine y ajuste el funcionamiento de los contactos del pasamanos, del zócalo y hundimiento de peldaños/tablillas.', 'valor': '0' },
                { 'id': '232', 'id_lista_mantenimiento': '34', 'descripcion': 'Cerciorese que los rieles y patines de deslizamiento, funcionen perfectamente.', 'valor': '0' },
                { 'id': '233', 'id_lista_mantenimiento': '34', 'descripcion': 'Verifique el estado y lubricación de los rodillos de cadenas y de los casquillos de peldaños junto con sus contactos de desprendimiento.', 'valor': '0' },
                { 'id': '234', 'id_lista_mantenimiento': '34', 'descripcion': 'Examine la lubricación del tren de peldaños/tablillas y del sincronismo de pasamanos con sus perfiles guía.', 'valor': '0' },
                { 'id': '235', 'id_lista_mantenimiento': '34', 'descripcion': 'Inspeccione el cuadro maniobra.', 'valor': '0' },
                { 'id': '236', 'id_lista_mantenimiento': '35', 'descripcion': 'Inpeccione el funcionamiento de los interruptores de llave y la parada de emergencia, las barreras infrarrojas y los equipos de vigilancia de las zonas de acceso.', 'valor': '0' },
                { 'id': '237', 'id_lista_mantenimiento': '35', 'descripcion': 'Revise el funcionamiento de los indicadores de marcha, iluminaciones de la placa porta-peines y entre peldaños, así como la pantalla digital de texto.', 'valor': '0' },
                { 'id': '238', 'id_lista_mantenimiento': '35', 'descripcion': 'Evalue el estado de los pictogramas.', 'valor': '0' },
                { 'id': '239', 'id_lista_mantenimiento': '35', 'descripcion': 'Efectue la Limpieza de la bandeja colectora de aceite de la cadena de tracción y de pasamanos, controlando su estado.', 'valor': '0' },
                { 'id': '240', 'id_lista_mantenimiento': '35', 'descripcion': 'Chequee el funcionamiento y ajuste el contacto de la placa de descanso, la iluminación, detectores de humos y botonera de revisión.', 'valor': '0' },
                { 'id': '241', 'id_lista_mantenimiento': '35', 'descripcion': 'Límpie del foso de la escalera y de la ventilación del motor.', 'valor': '0' },
                { 'id': '242', 'id_lista_mantenimiento': '35', 'descripcion': 'Examine el estado del ajuste de los rieles tangenciales, entrada de peldaños/ tablillas, guías, placa portapeines, peines y contactos de seguridad y sus guías laterales.', 'valor': '0' },
                { 'id': '243', 'id_lista_mantenimiento': '35', 'descripcion': 'Verifique el  funcionamiento y limpieza de los contactos de entrada de pasamanos, contactos de zócalo, hundimiento de peldaños, control de rieles y dispositivos de bloqueos mecánicos.', 'valor': '0' },
                { 'id': '244', 'id_lista_mantenimiento': '35', 'descripcion': 'Ajuste y lubrique la cadena de tracción, control de funcionamiento de sus contactos de seguridad y las varillas de todos los frenos.', 'valor': '0' },
                { 'id': '245', 'id_lista_mantenimiento': '35', 'descripcion': 'Chequee y ajuste el Freno de Servicio, cinta de freno, contactos de seguridad y evalue la perfecta  distancia de frenado.', 'valor': '0' },
                { 'id': '246', 'id_lista_mantenimiento': '35', 'descripcion': 'Inspeccione el funcvionamiento de los frenos de seguridad, y ajuste de la distancia de frenado y todos sus contactos de seguridad.', 'valor': '0' },
                { 'id': '247', 'id_lista_mantenimiento': '35', 'descripcion': 'Verifique los niveles de aceite de lubricación en reductor. Chequee que efectuen su lubricación automática con cepillos aplicadores. Sino Ajustelos.', 'valor': '0' },
                { 'id': '248', 'id_lista_mantenimiento': '35', 'descripcion': 'Revise el estado de la tensión de los pasamanos, correas de presión, ruedas de fricción, cadenas de tracción y del pasamanos. Registre y Lubriquelos.', 'valor': '0' },
                { 'id': '249', 'id_lista_mantenimiento': '35', 'descripcion': 'Inspeccione el cuadro maniobra y ventilación GFU.', 'valor': '0' },
                { 'id': '250', 'id_lista_mantenimiento': '35', 'descripcion': 'Finalmente efectue una limpieza de los perfiles de guía del pasamanos y sus arcos de reenvío.', 'valor': '0' },
                { 'id': '251', 'id_lista_mantenimiento': '36', 'descripcion': 'Inspección visual de cambios ópticos para detectar indícios de "Browning", vidrio empañado, corrosión, decoloración, hotspots, delaminación, babas de caracol o burbujas en la superficie posterior de los módulos. De ser positivo evalue el reemplazo.', 'valor': '0' },
                { 'id': '252', 'id_lista_mantenimiento': '36', 'descripcion': 'Inspección visual de daños mecánicos para detectan módulos rotos o marcos doblados. Ecalue cambio del Módulo de ser necesario.', 'valor': '0' },
                { 'id': '253', 'id_lista_mantenimiento': '36', 'descripcion': 'Chequeo de la lámina posterior para detectar arañazos y/o perforación.', 'valor': '0' },
                { 'id': '254', 'id_lista_mantenimiento': '36', 'descripcion': 'Revisión del Status de la El estado de la Capa-Elox.', 'valor': '0' },
                { 'id': '255', 'id_lista_mantenimiento': '36', 'descripcion': 'Asegurese que el radio de curvatura de los cables del módulo respeta las indicaciones del fabricante.', 'valor': '0' },
                { 'id': '256', 'id_lista_mantenimiento': '36', 'descripcion': 'Cerciorese que No hay micro-sombreado debido al polvo acumulado entre el módulo y las abrazaderas.', 'valor': '0' },
                { 'id': '257', 'id_lista_mantenimiento': '36', 'descripcion': 'Efectue la Limpieza de los módulos para que no exceden las pérdidas por suciedad.', 'valor': '0' },
                { 'id': '258', 'id_lista_mantenimiento': '36', 'descripcion': 'Revise el intersticio entre el marco y la lámina posterior y compruebe que el sellado es hermético.', 'valor': '0' },
                { 'id': '259', 'id_lista_mantenimiento': '36', 'descripcion': 'Inspeccione visualmemnte que la vegetación alrededor de los módulos no genera efectos de sombreamiento en los paneles solares.', 'valor': '0' },
                { 'id': '260', 'id_lista_mantenimiento': '36', 'descripcion': 'Retire cualquier residuo u objetos extraños detrás de los colectores y canaletas tales como plásticos, latas o cartones', 'valor': '0' },
                { 'id': '261', 'id_lista_mantenimiento': '36', 'descripcion': 'Elimine nidos de aves, reptiles o animales en general, del área del arreglo FV o de su estructura.', 'valor': '0' },
                { 'id': '262', 'id_lista_mantenimiento': '37', 'descripcion': 'Observar si se evidencian daños mecánicos o deformación de la estructura de montaje.', 'valor': '0' },
                { 'id': '263', 'id_lista_mantenimiento': '37', 'descripcion': 'Evaluar que la posición de las grapas de sujeción del módulo es correcta. Las grapas no deben producir sombreado sobre los módulos.', 'valor': '0' },
                { 'id': '264', 'id_lista_mantenimiento': '37', 'descripcion': 'Revisar si se han producido movimientos del lastre.', 'valor': '0' },
                { 'id': '265', 'id_lista_mantenimiento': '37', 'descripcion': 'Cerciorese que la fijación de los elementos roscados es correcta.', 'valor': '0' },
                { 'id': '266', 'id_lista_mantenimiento': '37', 'descripcion': 'Chequee y mida que el estado de la puesta a tierra del módulo y la estructura de montaje.', 'valor': '0' },
                { 'id': '267', 'id_lista_mantenimiento': '37', 'descripcion': 'Revise que el revestimiento protector (capa galvanizada por inmersión en caliente) de los perfiles de montaje no muestren daños.', 'valor': '0' },
                { 'id': '268', 'id_lista_mantenimiento': '37', 'descripcion': 'Observar si existren indicios de reacciones electroquímicas y/o Corrosión entre metales con diferentes potenciales de ionización.', 'valor': '0' },
                { 'id': '269', 'id_lista_mantenimiento': '37', 'descripcion': 'Inspeccione que no presenten bordes o cantos afilados en la estructural del sistema de montaje.', 'valor': '0' },
                { 'id': '270', 'id_lista_mantenimiento': '37', 'descripcion': 'Analice la dirección y fuerza del viento y verifique que el sistema soporta las tensiones mecánicas previstas.', 'valor': '0' },
                { 'id': '271', 'id_lista_mantenimiento': '37', 'descripcion': 'Asegurese que la integridad estructural del área donde esta la instalación no se ve comprometida.', 'valor': '0' },
                { 'id': '272', 'id_lista_mantenimiento': '37', 'descripcion': 'Garantice que en el área donde esta la instalación no sea estanco de aguas de residuales o de lluvia.', 'valor': '0' },
                { 'id': '273', 'id_lista_mantenimiento': '37', 'descripcion': 'Elimine nidos de aves, reptiles o animales en general, del área del arreglo FV o de su estructura.', 'valor': '0' },
                { 'id': '274', 'id_lista_mantenimiento': '38', 'descripcion': 'Chequee que no se observa decoloración, degradación, suciedad, daños mecánicos, humedad o corrosión de los equipos y las conexiones.', 'valor': '0' },
                { 'id': '275', 'id_lista_mantenimiento': '38', 'descripcion': 'Efectue una inspección visual y revisión de fusibles de cadena, monitoreo de cadenas, y protección contra sobretensiones arroja resultados positivos.', 'valor': '0' },
                { 'id': '276', 'id_lista_mantenimiento': '38', 'descripcion': 'Asegurese que No hay humedad ni rastro de insectos en el interior de las cajas.', 'valor': '0' },
                { 'id': '277', 'id_lista_mantenimiento': '38', 'descripcion': 'Inspeccione el funcionamiento de los interruptores y dispositivos de protección de CA y comrpuebe que funcionan perfectamente.', 'valor': '0' },
                { 'id': '278', 'id_lista_mantenimiento': '38', 'descripcion': 'Garantice que el estado de la ventilación de las cajas es bueno (especialmente en relación al estado de los filtros, si los hay).', 'valor': '0' },
                { 'id': '279', 'id_lista_mantenimiento': '38', 'descripcion': 'Ratifique que la entrada y salida de los cables a la caja de conexiones está ejecutada correctamente y no hay trazas de suciedad.', 'valor': '0' },
                { 'id': '280', 'id_lista_mantenimiento': '38', 'descripcion': 'Verifique los pares de apriete de las conexiones del circuito primario son correctos.', 'valor': '0' },
                { 'id': '281', 'id_lista_mantenimiento': '38', 'descripcion': 'Siempre despues de una Tormenta - Inspeccione el dispositivo de protección contra sobretensiones (SPD), para asegurarse que esta óptimo.', 'valor': '0' },
                { 'id': '282', 'id_lista_mantenimiento': '39', 'descripcion': 'Mida y Evalue que resistencia de aislamiento del cableado de baja tensión es buena.', 'valor': '0' },
                { 'id': '283', 'id_lista_mantenimiento': '39', 'descripcion': 'Reemplace el contenido de las etiquetas de cada cable que no se pueden identificar claramente.', 'valor': '0' },
                { 'id': '284', 'id_lista_mantenimiento': '39', 'descripcion': 'Verifique que el estado de los tubos de protección necesarios para proteger los cables de la carga UV y de las condiciones ambientales es bueno.', 'valor': '0' },
                { 'id': '285', 'id_lista_mantenimiento': '39', 'descripcion': 'Chequee que la fijación de los cables a las bandejas y/o a la estructura de montaje es perfecta.', 'valor': '0' },
                { 'id': '286', 'id_lista_mantenimiento': '39', 'descripcion': 'Revise el estado de las bandejas de cables prestando atención a la fijación y el envejecimiento.', 'valor': '0' },
                { 'id': '287', 'id_lista_mantenimiento': '39', 'descripcion': 'Inspeccione que el estado de los conectores del cable es optimo. Tomer en cuenta los siguientes aspectos: Estanqueidad de la conexión, Daños mecánicos, Humedad, Corrosión y Exceso de polvo.', 'valor': '0' },
                { 'id': '288', 'id_lista_mantenimiento': '39', 'descripcion': 'Garantice que el estado de las bridas de conexión del cable con respecto a la carga UV y la degradación inducida por la temperatura es bueno.', 'valor': '0' },
                { 'id': '289', 'id_lista_mantenimiento': '39', 'descripcion': 'Compruebe que el radio de curvatura de los cables es el indicado por el fabricante.', 'valor': '0' },
                { 'id': '290', 'id_lista_mantenimiento': '39', 'descripcion': 'Inspeccione el estado mecánico de los cables. Tome en cuenta que no exista: Mordedura de animales, Cables rotos, Cortes y Exceso de polvo.', 'valor': '0' },
                { 'id': '291', 'id_lista_mantenimiento': '39', 'descripcion': 'Verifique que No hay elementos sueltos en los puntos de Conexión o anclaje.', 'valor': '0' },
                { 'id': '292', 'id_lista_mantenimiento': '39', 'descripcion': 'Cerciorese que los Bluces de Inducción y el campo de potencial eléctrico entre los cables +/- es el mínimo.', 'valor': '0' },
                { 'id': '293', 'id_lista_mantenimiento': '40', 'descripcion': 'Asegurese que los mensajes de alerta se envian a los técnicos correspondientes y estos realizan su revisión periódicamente', 'valor': '0' },
                { 'id': '294', 'id_lista_mantenimiento': '40', 'descripcion': 'Inspeccione visualmente que no exista decoloración, degradación, polvo y acumulación de suciedad, daños mecánicos, humedad y corrosión de los equipos y conexiones.', 'valor': '0' },
                { 'id': '295', 'id_lista_mantenimiento': '40', 'descripcion': 'Evalue que No haya signos de humedad ni daños debido a condiciones climáticas agresivas.', 'valor': '0' },
                { 'id': '296', 'id_lista_mantenimiento': '40', 'descripcion': 'Evidencie si hay indicios de envejecimiento y/o reducción del grado IP debido a corrosión, acumulación de humedad o condensación.', 'valor': '0' },
                { 'id': '297', 'id_lista_mantenimiento': '40', 'descripcion': 'Asegurese que la funcionalidad de las Luces de Advertencia y Alarmas.', 'valor': '0' },
                { 'id': '298', 'id_lista_mantenimiento': '40', 'descripcion': 'Verifique que el par de apriete de las conexiones del circuito primario de energía es correcto.', 'valor': '0' },
                { 'id': '299', 'id_lista_mantenimiento': '40', 'descripcion': 'Observe que el estado de las marcas y etiquetas es bueno.', 'valor': '0' },
                { 'id': '300', 'id_lista_mantenimiento': '40', 'descripcion': 'Revise que funcionalidad del aire acondicionado o sistema de ventilación es óptimo.', 'valor': '0' },
                { 'id': '301', 'id_lista_mantenimiento': '40', 'descripcion': 'Evalue la conexión y el funcioonamiento del sistema de puesta a tierra.', 'valor': '0' },
                { 'id': '302', 'id_lista_mantenimiento': '40', 'descripcion': 'Mida la resistencia de aislamiento del circuito de potencia y cerciorese que da valores positivos.', 'valor': '0' },
                { 'id': '303', 'id_lista_mantenimiento': '40', 'descripcion': 'Efectue una prueba funcional de los interruptores, dispositivo de protección CA, dispositivo de corriente residual (RCD) y protección contra sobretensión, y compruebe que es satisfactoria.', 'valor': '0' },
                { 'id': '304', 'id_lista_mantenimiento': '40', 'descripcion': 'Verifique que los filtros están libres de polvo y se encuentran en buen estado.', 'valor': '0' },
                { 'id': '305', 'id_lista_mantenimiento': '40', 'descripcion': 'Revise que las conexiones de los cables son firmes y no muestran holgura.', 'valor': '0' },
                { 'id': '306', 'id_lista_mantenimiento': '40', 'descripcion': 'Chequee que el estado de los conectores es bueno y no muestra corrosión.', 'valor': '0' },
                { 'id': '307', 'id_lista_mantenimiento': '40', 'descripcion': 'Compruebe que el estado de los fusibles y seccionadores es correcto.', 'valor': '0' },
                { 'id': '308', 'id_lista_mantenimiento': '40', 'descripcion': 'Inspeccione la funcionalidad del paro de emergencia está asegurada.', 'valor': '0' },
                { 'id': '309', 'id_lista_mantenimiento': '40', 'descripcion': 'Asegurese que La funcionalidad de los contactos de la puerta es Perfecta.', 'valor': '0' },
                { 'id': '310', 'id_lista_mantenimiento': '40', 'descripcion': 'Revise que el software se actualiza/mejora periódicamente (Según datos del Fabricante).', 'valor': '0' },
                { 'id': '311', 'id_lista_mantenimiento': '40', 'descripcion': 'Verifique que La Memoria interna guarde correctamente los datos a largo plazo y la memoria de errores este disponible.', 'valor': '0' },
                { 'id': '312', 'id_lista_mantenimiento': '41', 'descripcion': 'lnspeccione que el estado de los cables en cuanto a integridad y daño mecánico es bueno.', 'valor': '0' },
                { 'id': '313', 'id_lista_mantenimiento': '41', 'descripcion': 'Chequee que las uniones atornilladas no muestren holgura.', 'valor': '0' },
                { 'id': '314', 'id_lista_mantenimiento': '41', 'descripcion': 'Revise que la continuidad del sistema de puesta a tierra está asegurada.', 'valor': '0' },
                { 'id': '315', 'id_lista_mantenimiento': '41', 'descripcion': 'Verifique que no exista corrosión en todo los elementos de sistema', 'valor': '0' },
                { 'id': '316', 'id_lista_mantenimiento': '42', 'descripcion': 'Verifique la calibración y la verificación de exactitud.', 'valor': '0' },
                { 'id': '317', 'id_lista_mantenimiento': '42', 'descripcion': 'Asegurese que la protección contra condiciones ambientales agresivas (humedad, calor, productos químicos, etc.) funciona correctamente.', 'valor': '0' },
                { 'id': '318', 'id_lista_mantenimiento': '42', 'descripcion': 'Chequee que toda la información se graba digitalmente y está disponible en cualquier momento.', 'valor': '0' },
                { 'id': '319', 'id_lista_mantenimiento': '42', 'descripcion': 'Compruebe que existe comunicación entre todos los componenetes del sistema.', 'valor': '0' },
                { 'id': '320', 'id_lista_mantenimiento': '42', 'descripcion': 'Revise que el software de los equipos de monitoreo se actualizan/mejoran periódicamente (Según datos del Fabricante).', 'valor': '0' },
                { 'id': '321', 'id_lista_mantenimiento': '42', 'descripcion': 'Efectue el cálculo de las pérdidas debido a la acumulación de polvo en zonas representativas de la planta.', 'valor': '0' },
                { 'id': '322', 'id_lista_mantenimiento': '42', 'descripcion': 'Inspeccione que el sistema de vigilancia está operativo y en buen estado.', 'valor': '0' },
                { 'id': '323', 'id_lista_mantenimiento': '42', 'descripcion': 'Evalue que los sensores están limpios y correctamente fijados.', 'valor': '0' },
                { 'id': '324', 'id_lista_mantenimiento': '43', 'descripcion': 'Realice mediciones de la tensión de circuito abierto en el 100% de los strings.', 'valor': '0' },
                { 'id': '325', 'id_lista_mantenimiento': '43', 'descripcion': 'Efectue mediciones de la corriente de cortocircuito en el 100% de los strings.', 'valor': '0' },
                { 'id': '326', 'id_lista_mantenimiento': '43', 'descripcion': 'Analice las mediciones de curva I-V en el 100% de los strings y compare con las entregadas por el fabricante.', 'valor': '0' },
                { 'id': '327', 'id_lista_mantenimiento': '43', 'descripcion': 'Gestione un análisis de infrarrojos del 100% de los módulos FV incluidos conectores.', 'valor': '0' },
                { 'id': '328', 'id_lista_mantenimiento': '43', 'descripcion': 'Gestione el análisis de infrarrojos del 100% de las cajas de combinación.', 'valor': '0' },
                { 'id': '329', 'id_lista_mantenimiento': '43', 'descripcion': 'Ejecute un análisis de electroluminiscencia en una selección de módulos FV.', 'valor': '0' },
                { 'id': '330', 'id_lista_mantenimiento': '43', 'descripcion': 'Haga un Seguimiento de la degradación del módulo en una cantidad representativa de módulos. (Las pruebas se realizarán siempre en los mismos módulos).', 'valor': '0' },
                { 'id': '331', 'id_lista_mantenimiento': '43', 'descripcion': 'Mida que la resistencia de aislamiento de corriente continua no supera los límites establecidos.', 'valor': '0' },
                { 'id': '332', 'id_lista_mantenimiento': '43', 'descripcion': 'Chequee que el sistema de puesta a tierra es fucional.', 'valor': '0'  },
                { 'id': '333', 'id_lista_mantenimiento': '44', 'descripcion': 'Revisar la funcionalidad de Válvulas.', 'valor': '0'  },
                { 'id': '334', 'id_lista_mantenimiento': '44', 'descripcion': 'Revisar funcionalidad de la Bomba.', 'valor': '0'  },
                { 'id': '335', 'id_lista_mantenimiento': '44', 'descripcion': 'Verificar los Manómetros.', 'valor': '0'  },
                { 'id': '336', 'id_lista_mantenimiento': '44', 'descripcion': 'Chequear el valor de la presión (Entre 2000 y 2500 psi).', 'valor': '0'  },
                { 'id': '337', 'id_lista_mantenimiento': '45', 'descripcion': 'Revisar Filtros.', 'valor': '0'  },
                { 'id': '338', 'id_lista_mantenimiento': '45', 'descripcion': 'Revisar Aceite.', 'valor': '0'  },
                { 'id': '339', 'id_lista_mantenimiento': '45', 'descripcion': 'Revisar Nivel de Aceite.', 'valor': '0'  },
                { 'id': '340', 'id_lista_mantenimiento': '45', 'descripcion': 'Revisar Mangueras.', 'valor': '0'  },
                { 'id': '341', 'id_lista_mantenimiento': '45', 'descripcion': 'Revisar Acoples Mangueras.', 'valor': '0'  },
                { 'id': '342', 'id_lista_mantenimiento': '45', 'descripcion': 'Revisar Fugas de Aceite.', 'valor': '0'  },
                { 'id': '343', 'id_lista_mantenimiento': '45', 'descripcion': 'Revisar Cilindro y Actuador Hidráulico.', 'valor': '0'  },
                { 'id': '344', 'id_lista_mantenimiento': '46', 'descripcion': 'Chequear Nivel, Ajuste y trabajo de las compuertas.', 'valor': '0'  },
                { 'id': '345', 'id_lista_mantenimiento': '46', 'descripcion': 'Revisar Guayas y Cadenas.', 'valor': '0'  },
                { 'id': '346', 'id_lista_mantenimiento': '46', 'descripcion': 'Inspeccionar Flanche y Pasador de Flanche.', 'valor': '0'  },
                { 'id': '347', 'id_lista_mantenimiento': '46', 'descripcion': 'Examinar estado de pintura.', 'valor': '0'  },
                { 'id': '348', 'id_lista_mantenimiento': '47', 'descripcion': 'Chequear Control Eléctrico (Botonera, Cableado).', 'valor': '0'  },
                { 'id': '349', 'id_lista_mantenimiento': '47', 'descripcion': 'Revisar Estado y Funcionalidad de Micros.', 'valor': '0'  },
                { 'id': '350', 'id_lista_mantenimiento': '47', 'descripcion': 'Inspeccionar Funcionamientos de Motor.', 'valor': '0'  },
                { 'id': '351', 'id_lista_mantenimiento': '47', 'descripcion': 'Validar Funcionamiento de la Maquina en automático.', 'valor': '0' },
                { 'id': '352', 'id_lista_mantenimiento': '48', 'descripcion': 'Verificar las conexiones eléctricas del equipo', 'valor': '0' },
                { 'id': '353', 'id_lista_mantenimiento': '48', 'descripcion': 'Verificar que exista la red Wifi a la que se conecta el equipo', 'valor': '0' },
                { 'id': '354', 'id_lista_mantenimiento': '48', 'descripcion': 'Verificar potencia de la red Wifi en ese punto', 'valor': '0' },
                { 'id': '355', 'id_lista_mantenimiento': '48', 'descripcion': 'Verificar que la red Wifi tenga acceso a internet', 'valor': '0' },
                { 'id': '356', 'id_lista_mantenimiento': '48', 'descripcion': 'Si esta linea, verificar ultima conexion sea mayor a 1.5 minutos', 'valor': '0' },
                { 'id': '357', 'id_lista_mantenimiento': '48', 'descripcion': 'Verifiar el estado físico del dispositivo (grasas, animales, polvo, agua, etc) y limpiarlo.', 'valor': '0' },
                { 'id': '358', 'id_lista_mantenimiento': '48', 'descripcion': 'Verificar la instalación del dispositivo. Idealmente debe ser lo más frontal al equipo a controlar.', 'valor': '0' },
                { 'id': '359', 'id_lista_mantenimiento': '48', 'descripcion': 'Si el dispositivo tiene cinta doble faz, cambiarla. ', 'valor': '0' },
                { 'id': '360', 'id_lista_mantenimiento': '48', 'descripcion': 'Verificar si el equipo envía comandos infrarojos (T° y set point) Con la camara del celular enfocar a la pestaña del emisor.', 'valor': '0' },
                { 'id': '361', 'id_lista_mantenimiento': '48', 'descripcion': 'Verificar si el dispositivo toma los comando enviados con el control remoto del aire.', 'valor': '0' },
                { 'id': '362', 'id_lista_mantenimiento': '48', 'descripcion': 'Desde plataforma enviar comandos y verificar si equipo lo ejecuta bien.', 'valor': '0' },
                { 'id': '363', 'id_lista_mantenimiento': '48', 'descripcion': 'Verificar si el sensor de presencia apaga el aire cuando no hay nadie en el espacio.', 'valor': '0' },
                { 'id': '364', 'id_lista_mantenimiento': '49', 'descripcion': 'Verificar las conexiones eléctricas del equipo', 'valor': '0' },
                { 'id': '365', 'id_lista_mantenimiento': '49', 'descripcion': 'Verificar que exista la red Wifi a la que se conecta el equipo', 'valor': '0' },
                { 'id': '366', 'id_lista_mantenimiento': '49', 'descripcion': 'Verificar potencia de la red Wifi en ese punto', 'valor': '0' },
                { 'id': '367', 'id_lista_mantenimiento': '49', 'descripcion': 'Verificar que la red Wifi tenga acceso a internet', 'valor': '0' },
                { 'id': '368', 'id_lista_mantenimiento': '49', 'descripcion': 'Si esta linea, verificar ultima conexion sea mayor a 1.5 minutos', 'valor': '0' },
                { 'id': '369', 'id_lista_mantenimiento': '49', 'descripcion': 'Verifiar el estado físico del dispositivo (grasas, animales, polvo, agua, etc) y limpiarlo.', 'valor': '0' },
                { 'id': '370', 'id_lista_mantenimiento': '49', 'descripcion': 'Revisar estado de la muletilla ( 0 = Manual ; 1 = Automatico). Siempre debe estar en Automatico.', 'valor': '0' },
                { 'id': '371', 'id_lista_mantenimiento': '49', 'descripcion': 'Verificar que se actualice el estado en plataforma cuando se mueve de forma manual la muletilla', 'valor': '0' },
                { 'id': '372', 'id_lista_mantenimiento': '49', 'descripcion': 'Realizar control desde plataforma y verificar que en sitio cambie de estado', 'valor': '0' },
                { 'id': '373', 'id_lista_mantenimiento': '50', 'descripcion': 'Si Helo One tiene contactor, verificar conexión.', 'valor': '0' },
                { 'id': '374', 'id_lista_mantenimiento': '50', 'descripcion': 'Verificar las conexiones eléctricas del equipo', 'valor': '0' },
                { 'id': '375', 'id_lista_mantenimiento': '50', 'descripcion': 'Verificar que exista la red Wifi a la que se conecta el equipo', 'valor': '0' },
                { 'id': '376', 'id_lista_mantenimiento': '50', 'descripcion': 'Verificar potencia de la red Wifi en ese punto', 'valor': '0' },
                { 'id': '377', 'id_lista_mantenimiento': '50', 'descripcion': 'Verificar que la red Wifi tenga acceso a internet', 'valor': '0' },
                { 'id': '378', 'id_lista_mantenimiento': '50', 'descripcion': 'Si esta linea, verificar ultima conexion sea mayor a 1.5 minutos', 'valor': '0' },
                { 'id': '379', 'id_lista_mantenimiento': '50', 'descripcion': 'Verifiar el estado físico del dispositivo (grasas, animales, polvo, agua, etc) y limpiarlo.', 'valor': '0' },
                { 'id': '380', 'id_lista_mantenimiento': '50', 'descripcion': 'Verificar que la instalación el sensor esté lo mas cercano a donde se encuentra el sensor de la nevera para tener lecturas similares entre el control de la nevera y lo que se ve en plataforma.', 'valor': '0' },
                { 'id': '381', 'id_lista_mantenimiento': '50', 'descripcion': 'Verificar que los datos que envía a la plataforma son correctos', 'valor': '0' },
                { 'id': '382', 'id_lista_mantenimiento': '50', 'descripcion': 'Limpiar el sensor y el estado de la conexión del sensor al dispositivo.', 'valor': '0' },
                { 'id': '383', 'id_lista_mantenimiento': '50', 'descripcion': 'Ponerle teflón a la rosca a la carcaza metalica del sensor (para aislar los conectores y sensor, del agua).', 'valor': '0' },
                
            ],

            deviceType: [{
                    "value": "0",
                    "nombre": "Aire acondicionado"
                },
                {
                    "value": "1",
                    "nombre": "Refrigerador"
                },
                {
                    "value": "2",
                    "nombre": "Cava"
                },
                {
                    "value": "3",
                    "nombre": "Luminaria"
                },
                {
                    "value": "4",
                    "nombre": "Transformandor"
                },
                {
                    "value": "5",
                    "nombre": "Tablero eléctrico"
                },
                {
                    "value": "6",
                    "nombre": "Computadora"
                },
                {
                    "value": "7",
                    "nombre": "TV"
                },
                {
                    "value": "8",
                    "nombre": "Compresor"
                },
                {
                    "value": "9",
                    "nombre": "Bomba"
                },
                {
                    "value": "10",
                    "nombre": "Congelador"
                },
                {
                    "value": "11",
                    "nombre": "Alarma"
                },
                {
                    "value": "12",
                    "nombre": "Máquina"
                },
                {
                    "value": "13",
                    "nombre": "Plancha de Ropa"
                },
                {
                    "value": "14",
                    "nombre": "Ducha eléctrica"
                },
                {
                    "value": "15",
                    "nombre": "Impresora"
                },
                {
                    "value": "16",
                    "nombre": "Lavadora"
                },
                {
                    "value": "17",
                    "nombre": "Estufa"
                },
                {
                    "value": "18",
                    "nombre": "Calefactor"
                },
                {
                    "value": "19",
                    "nombre": "Horno"
                },
                {
                    "value": "20",
                    "nombre": "Microondas"
                },
                {
                    "value": "21",
                    "nombre": "Campana"
                },
                {
                    "value": "22",
                    "nombre": "Secadora"
                },
                {
                    "value": "23",
                    "nombre": "Ventilador"
                },
                {
                    "value": "24",
                    "nombre": "Boiler/Termotanque"
                },
                {
                    "value": "25",
                    "nombre": "Ascensor"
                },
                {
                    "value": "26",
                    "nombre": "Teléfono"
                },
                {
                    "value": "27",
                    "nombre": "Equipo de Sonido"
                },
                {
                    "value": "28",
                    "nombre": "Licuadora"
                },
                {
                    "value": "29",
                    "nombre": "Escaleras eléctricas"
                },
                {
                    "value": "30",
                    "nombre": "Generador"
                },
                {
                    "value": "31",
                    "nombre": "Sistema fotovoltaico"
                },
                {
                    "value": "33",
                    "nombre": "Monta Carga"
                },
                {
                    "value": "34",
                    "nombre": "Caminadora Eléctrica"
                },
                {
                    "value": "35",
                    "nombre": "Escaladora Eléctrica"
                },
                {
                    "value": "36",
                    "nombre": "Elíptica"
                },
                {
                    "value": "37",
                    "nombre": "Dispensador"
                },
                {
                    "value": "38",
                    "nombre": "Aviso"
                },
                {
                    "value": "39",
                    "nombre": "SAEG"
                },
                {
                    "value": "40",
                    "nombre": "Dimmer"
                },
                {
                    "value": "41",
                    "nombre": "Helo S multicanal"
                },
                {
                    "value": "42",
                    "nombre": "Canal medidor Emporia",
                    "type": "25"
                },
                {
                    "value": "43",
                    "nombre": "Activo API",
                    "type": "30"
                },
                {
                    "value": "44",
                    "nombre": "Hub master",
                    "type": "31"
                },
                {
                    "value": "45",
                    "nombre": "Dispositivo Helo",
                },
                {
                    "value": "32",
                    "nombre": "Otro"
                },
            ],
            timeRanges: [
                {
                    text: "10 minutos",
                    value: '10',
                },
                {
                    text: "20 minutos",
                    value: '20',
                },
                {
                    text: "30 minutos",
                    value: '30',
                },
                {
                    text: "40 minutos",
                    value: '40',
                },
                {
                    text: "50 minutos",
                    value: '50',
                },
                {
                    text: "1 hora",
                    value: '60',
                },
                {
                    text: "2 horas",
                    value: '120',
                },
            ],
            lackRanges: [
                {
                    text: "20 minutos",
                    value: '80',
                },
                {
                    text: "30 minutos",
                    value: '120',
                },
                {
                    text: "40 minutos",
                    value: '160',
                },
                {
                    text: "50 minutos",
                    value: '200',
                },
                {
                    text: "1 hora",
                    value: '240',
                },
                {
                    text: "2 horas",
                    value: '480',
                },
            ],
            degreesRanges : [
                {
                    text: 'No aumentar',
                    value: '0',
                },
                {
                    text: '1',
                    value: '1',
                },
                {
                    text: '2',
                    value: '2',
                },
                {
                    text: '3',
                    value: '3',
                },
                {
                    text: '4',
                    value: '4',
                },
                {
                    text: '5',
                    value: '5',
                },
                {
                    text: '6',
                    value: '6',
                },
            ],
            ct_type : [
                {
                    text: '1 Fase',
                    value: '1',
                },
                {
                    text: '2 Fases',
                    value: '2',
                },
                {
                    text: '3 Fases',
                    value: '3',
                },
            ],
            current_ct : [
                {
                    text: '30 amperios',
                    value: '30',
                },
                {
                    text: '100 amperios',
                    value: '100',
                },
            ],
            frequency : [
                {
                    text: '50 hz',
                    value: '50',
                },
                {
                    text: '60 hz',
                    value: '60',
                },
            ],
            sampling_time : [
                {
                    text: '1 minuto',
                    value: '1',
                },
                {
                    text: '2 minutos',
                    value: '2',
                },
                {
                    text: '5 minutos',
                    value: '5',
                },
                {
                    text: '10 minutos',
                    value: '10',
                },
                {
                    text: '15 minutos',
                    value: '15',
                },
                {
                    text: '20 minutos',
                    value: '20',
                },
                {
                    text: '30 minutos',
                    value: '30',
                },
                {
                    text: '40 minutos',
                    value: '40',
                },
                {
                    text: '50 minutos',
                    value: '50',
                },
                {
                    text: '1 hora',
                    value: '60',
                },
            ],

            error_list_engine: [
                {
                    id: 0,
                    name: 'Sin registro de fallas'
                },
                {
                    id: 1,
                    name: 'Sobre corriente (oc)'
                },
                {
                    id: 2,
                    name: 'Sobrevoltaje (ov)'
                },
                {
                    id: 3,
                    name: 'Sobrecalentamiento del IGBT (OH1)'
                },
                {
                    id: 4,
                    name: 'Reservado'
                },
                {
                    id: 5,
                    name: 'Sobre carga de conducción (oL)'
                },
                {
                    id: 6,
                    name: 'Sobrecarga del motor (oL1)'
                },
                {
                    id: 7,
                    name: 'Sobre torque (oL2)'
                },
                {
                    id: 8,
                    name: 'Fallo externo (EF)'
                },
                {
                    id: 9,
                    name: 'Sobrecorriente durante la aceleración (ocA)'
                },
                {
                    id: 10,
                    name: 'Sobrecorriente durante la desaceleración (ocd)'
                },
                {
                    id: 11,
                    name: 'Sobrecorriente a velocidad constante (ocn)'
                },
                {
                    id: 12,
                    name: 'Reservado'
                },
                {
                    id: 13,
                    name: 'Baja tensión (Lv)'
                },
                {
                    id: 14,
                    name: 'Pérdida de fase de entrada (PHL)'
                },
                {
                    id: 15,
                    name: 'Reservado'
                },
                {
                    id: 16,
                    name: 'Fallo de aceleración/desaceleración automática (cFA)'
                },
                {
                    id: 17,
                    name: 'Protección por contraseña de software y parámetros (codE)'
                },
                {
                    id: 18,
                    name: 'Error de escritura de CPU (cF1.0)'
                },
                {
                    id: 19,
                    name: 'Error de lectura de CPU (cF2.0)'
                },
                {
                    id: 20,
                    name: 'Error de protección de hardware CC, OC (HPF1)'
                },
                {
                    id: 21,
                    name: 'Error de protección de hardware OV (HPF2)'
                },
                {
                    id: 22,
                    name: 'Reservado'
                },
                {
                    id: 23,
                    name: 'Error de protección de hardware OC (HPF4)'
                },
                {
                    id: 24,
                    name: 'Error de hardware de fase U (cF3.0)'
                },
                {
                    id: 25,
                    name: 'Error de hardware de fase V (cF3.1)'
                },
                {
                    id: 26,
                    name: 'Error de hardware de fase W (cF3.2)'
                },
                {
                    id: 27,
                    name: 'Error de hardware del bus de DC (cF3.3)'
                },
                {
                    id: 28,
                    name: 'Error de hardware OH1 (cF3.4)'
                },
                {
                    id: 29,
                    name: 'Reservado'
                },
                {
                    id: 30,
                    name: 'Reservado'
                },
                {
                    id: 31,
                    name: 'Reservado'
                },
                {
                    id: 32,
                    name: 'Reservado'
                },
                {
                    id: 33,
                    name: 'Reservado'
                },
                {
                    id: 34,
                    name: 'Reservado'
                },
                {
                    id: 35,
                    name: 'Reservado'
                },
                {
                    id: 36,
                    name: 'Reservado'
                },
                {
                    id: 37,
                    name: 'OPHL'
                },
            ],

            baudios_rate: [
                {
                    text: '9600',
                    value: '1',
                },
                {
                    text: '19200',
                    value: '2',
                },
                {
                    text: '115200',
                    value: '3',
                },
            ],
            paridad: [
                {
                    text: 'None',
                    value: '1',
                },
                {
                    text: 'Even',
                    value: '2',
                },
                {
                    text: 'Odd',
                    value: '3',
                },
            ],

            settings_properties: [
                {
                    id: '15',
                    name: 'frequency',
                },
                {
                    id: '64',
                    name: 'sensor',
                },
                {
                    id: '65',
                    name: 'h_fin',
                },
                {
                    id: '66',
                    name: 'h_ini',
                },
                {
                    id: '67',
                    name: 'ahorro',
                },
                {
                    id: '68',
                    name: 'comando',
                },
                {
                    id: '69',
                    name: 'grados',
                },
                {
                    id: '70',
                    name: 'ausencia',
                },
                {
                    id: '71',
                    name: 'tiempo',
                },
                {
                    id: '72',
                    name: 'ct_type',
                },
                {
                    id: '73',
                    name: 'current_ct',
                },
                {
                    id: '74',
                    name: 'sampling_time',
                },
                {
                    id: '75',
                    name: 'offset',
                },
                {
                    id: '76',
                    name: 'channel_1',
                },
                {
                    id: '77',
                    name: 'channel_2',
                },
                {
                    id: '78',
                    name: 'channel_3',
                },
                {
                    id: '80',
                    name: 'offset_t',
                },
                {
                    id: '81',
                    name: 'direction',
                },
                {
                    id: '82',
                    name: 'turning_sense',
                },
                {
                    id: '83',
                    name: 'frequency',
                },
                {
                    id: '84',
                    name: 'umbral_t_max',
                },
                {
                    id: '85',
                    name: 'umbral_t_min',
                },
                {
                    id: '86',
                    name: 'activar_umbral_t',
                },
                {
                    id: '87',
                    name: 'umbral_corriente_low',
                },
                {
                    id: '88',
                    name: 'umbral_corriente_high',
                },
                {
                    id: '89',
                    name: 'baudios_rate',
                },
                {
                    id: '90',
                    name: 'paridad',
                },
                {
                    id: '91',
                    name: 'velocidad_fan',
                },
                {
                    id: '92',
                    name: 'bloqueo',
                },
                {
                    id: '93',
                    name: 'modo_operacion',
                },
                {
                    id: '94',
                    name: 'swing',
                },
            ],

            getErrorListEngine: function(data) {
                var self = this;
                data.map(function(d){
                    d.name = self.error_list_engine.find(function(e){return e.id == d.id}).name;
                })
                return data
            },

            // Rows of the "activos" sheet -> edita_dispositivo payloads. A row whose
            // `tipo` is not a known device type is skipped and reported (row is the
            // spreadsheet row, header included; real row via sheet_to_json's
            // non-enumerable __rowNum__, since blank rows are skipped) instead of
            // throwing a TypeError.
            parseActives: function(data, zona){
                var self = this;
                var activos = [];
                var skipped = [];
                (data.activos || []).forEach(function(a, index) {
                    var type = $filter('filter')(self.deviceType, { nombre: a.tipo }, true)[0];
                    if (!type) {
                        skipped.push({ row: a && a.__rowNum__ !== undefined ? a.__rowNum__ + 1 : index + 2, nombre: a.nombre, tipo: a.tipo });
                        return;
                    }
                    activos.push({
                        id_device: '0',
                        nombre: a.nombre,
                        id_zona: zona.id,
                        caracteristicas: [
                            {
                                valor: a.marca ? a.marca : '',
                                id: 1,
                            },
                            {
                                valor: type.value,
                                id: 2,
                            }, 
                            {
                                valor: a.serial ? a.serial : '',
                                id: 3,
                            },
                            {
                                valor: a.referencia ? a.referencia : '',
                                id: 4,
                            },  
                        ]
                    });
                });
                return { activos: activos, skipped: skipped };
            },

            formatDataActives: function(data, zona){
                return this.parseActives(data, zona).activos;
            },

            // Rows of the "zonas" sheet -> POST /zones/bulk payload. The zone name
            // is "<nombre> - <ciudad>" (just <nombre> without a city); rows
            // without a name are skipped and reported.
            bulkDeviceColumns: [
                ['Helo AIR', 'helo_air'],
                ['Helo T', 'helo_t'],
                ['Helo AQ', 'helo_aq'],
                ['Helo ONE', 'helo_one'],
                ['Helo S', 'helo_s'],
                ['Helo AIR CV', 'cortina_viento'],
                ['Helo MA', 'helo_ma'],
                ['MODEM', 'modem'],
                ['REPETIDOR', 'repetidor'],
            ],

            // Also validates the backend caps and rules (api zones-bulk-create) before
            // building any device array, so a typo like 100000 cannot freeze the tab:
            // `errors` lists {row, reason} (row = real Excel row, header is row 1: taken
            // from sheet_to_json's non-enumerable __rowNum__ because blank rows are
            // skipped, falling back to index + 2) and the
            // offending zones are not built. Nothing should be sent when errors exist.
            buildBulkZones: function(rows){
                var columns = this.bulkDeviceColumns;
                var MAX_ZONES = 200;
                var MAX_DEVICES = 5000;
                var MAX_NAME_CHARS = 60;
                var zones = [];
                var skipped = [];
                var errors = [];
                var seen = {};
                var totalDevices = 0;
                var stop = false;
                (rows || []).forEach(function(z, index) {
                    if (stop) {
                        return;
                    }
                    var row = z && z.__rowNum__ !== undefined ? z.__rowNum__ + 1 : index + 2;
                    var nombre = String(z.nombre === undefined || z.nombre === null ? '' : z.nombre).trim();
                    if (nombre === '') {
                        skipped.push({ row: row, reason: 'sin nombre' });
                        return;
                    }
                    var ciudad = String(z.ciudad === undefined || z.ciudad === null ? '' : z.ciudad).trim();
                    var fullName = ciudad === '' ? nombre : nombre + ' - ' + ciudad;
                    if (zones.length >= MAX_ZONES) {
                        errors.push({ row: row, reason: 'el archivo supera el máximo de ' + MAX_ZONES + ' zonas' });
                        stop = true;
                        return;
                    }
                    if (Array.from(fullName).length > MAX_NAME_CHARS) {
                        errors.push({ row: row, reason: 'el nombre de la zona supera los ' + MAX_NAME_CHARS + ' caracteres' });
                        return;
                    }
                    var key = fullName.toLowerCase();
                    if (seen.hasOwnProperty(key)) {
                        errors.push({ row: row, reason: 'el nombre de la zona se repite (fila ' + seen[key] + ')' });
                        return;
                    }
                    seen[key] = row;

                    // Validate every count and the running total BEFORE looping.
                    var rowTotal = 0;
                    var badColumn = null;
                    columns.forEach(function(col) {
                        var raw = z[col[1]];
                        if (badColumn !== null || raw === undefined || raw === null || String(raw).trim() === '') {
                            return;
                        }
                        var n = Number(raw);
                        if (!isFinite(n) || Math.floor(n) !== n || n < 0) {
                            badColumn = col[1];
                            return;
                        }
                        rowTotal += n;
                    });
                    if (badColumn !== null) {
                        errors.push({ row: row, reason: 'la cantidad de dispositivos debe ser un número entero mayor o igual a 0 (columna ' + badColumn + ')' });
                        return;
                    }
                    if (rowTotal > MAX_DEVICES) {
                        errors.push({ row: row, reason: 'la cantidad de dispositivos supera el máximo de ' + MAX_DEVICES });
                        return;
                    }
                    if (totalDevices + rowTotal > MAX_DEVICES) {
                        errors.push({ row: row, reason: 'el total de dispositivos supera el máximo de ' + MAX_DEVICES });
                        stop = true;
                        return;
                    }
                    totalDevices += rowTotal;

                    var devices = [];
                    columns.forEach(function(col) {
                        for (var i = 1; i <= z[col[1]]; i++) {
                            devices.push({ name: col[0] + ' ' + i, brand: 'Helo', type: '45', serial: '', reference: '' });
                        }
                    });
                    var zone = { name: fullName };
                    if (z.id_pais !== undefined && z.id_pais !== null && z.id_pais !== '') {
                        zone.country_id = z.id_pais;
                    }
                    zone.devices = devices;
                    zones.push(zone);
                });
                return { zones: zones, skipped: skipped, errors: errors };
            },
            logoHeloData: 'data:image/png;base64,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',
        }

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('mantenimientoCtrl', mantenimientoCtrl);

    /** @ngInject */

    function mantenimientoCtrl($scope, RESTServices, $localStorage, $rootScope, SHAREServices, $timeout, $filter, maintenanceServices, toastr, $window) {

        $scope.loading = true;
        $scope.noInfo = false;
        $scope.devices = [];
        $scope.zonas = [];
        $scope.rol = $localStorage.rol;
        var TIME_PROMESE = 300;

        $scope.flag_loading = false;

        // Loads the zone list and, when there is a selected zone, its devices.
        // A customer with zero zones ends here with no selected zone (it must
        // still be able to upload zones from an Excel file).
        function loadZones() {
            return RESTServices.fetchClientZones().then(function(data) {
                if (data != null && data.code == '200') {
                    var selectedId = $scope.zona ? $scope.zona.id : undefined;
                    $scope.zonas = [];
                    if(data.zonas) {
                        $scope.zonas = data.zonas;
                        $scope.zonas.map(function(z){
                            z.rol = 0;
                        })
                    }
                    if(data.zonas_externas) {
                        $scope.zonas = $scope.zonas.concat(data.zonas_externas)
                    }
                    $scope.zonas = $filter('orderBy')($scope.zonas, 'nombre');
                    //$scope.zonas = $filter('filter')($scope.zonas, {h : '0'});
                    var previous = $scope.zonas.filter(function(z){ return z.id === selectedId; })[0];
                    $scope.zona = previous || $scope.zonas[0];
                    if ($scope.zona) {
                        generarListaMantenimiento($scope.zona.id, $scope.zona.rol);
                    } else {
                        $scope.loading = false;
                        $scope.noInfo = true;
                    }
                } else {
                    $scope.loading = false;
                    $scope.noInfo = true;
                }
            }).catch(function() {
                $scope.loading = false;
                $scope.noInfo = true;
            });
        }

        $timeout(function(){
            loadZones();
        });



        function generarListaMantenimiento(id, rol) {
            var control = rol == 0 ? true : false;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.devices = [];
            RESTServices.fetchZoneMaintenanceDevicesV2(id).then(function(data) {
                // Rebuild the legacy dispositivos / dispositivos_externos lists from the single devices[].
                var lists = RESTServices.adaptZoneMaintenanceDevices(data);
                $scope.devices = generarfiltroMantenimiento(lists.dispositivos.concat(lists.dispositivos_externos));
                $scope.noInfo = $scope.devices.length === 0;
                $scope.loading = false;
            }).catch(function() {
                // 403/404/502 are plain failures: never close the session here.
                $scope.devices = [];
                $scope.noInfo = true;
                $scope.loading = false;
            }).then(function() {
                $rootScope.$broadcast('devicesMaintenance', {dispositivos: $scope.devices, id_zona: id, control: control});
            });
        };

        function generarfiltroMantenimiento(dispositivos){
            var dispositivosFiltro;
            if (dispositivos) {
                dispositivosFiltro = dispositivos.map(function(d){
                    d.limit = d.limite_horas_uso
                    // null horas_uso means usage hours are unavailable: neither red nor green, never 0.
                    if (d.horas_uso === null) {
                        d.filter = 'unknown'
                        return d
                    }
                    d.filter = d.horas_uso >= d.limite_horas_uso ? 'red' : 'green'
                    d.horas_uso = d.horas_uso != undefined ? d.horas_uso : 0
                    return d
                }); 
            }
            return dispositivosFiltro;
        }

        $scope.$on('getDevicesMaintenance', function(event, result){
            generarListaMantenimiento(result.id, result.rol);
            var index = $scope.zonas.findIndex(function(z){return z.id === result.id})
            if(index > -1) {
                $scope.zona = $scope.zonas[index]
            }
        });

        // Callers run inside a digest ($evalAsync), so no $apply here.
        function startLoading() {
            $scope.flag_loading = true;
        }

        // Always reset the preloader (also outside a digest).
        function stopLoading() {
            $timeout(function() {
                $scope.flag_loading = false;
            });
        }

        // Reads the first file of the input and hands the rows of `sheet` to onRows.
        function readSheet(event, sheet, onRows) {
            var reader = new FileReader();
            var file = event.files[0];
            // The input's native onchange fires this callback outside a digest, so
            // the UI work (toasts, loading flags) goes through $evalAsync.
            reader.onload = function() {
                var rows;
                try {
                    var workBook = XLSX.read(reader.result, { type: 'binary' });
                    var jsonData = workBook.SheetNames.reduce(function(initial, name) {
                        initial[name] = XLSX.utils.sheet_to_json(workBook.Sheets[name]);
                        return initial;
                    }, {});
                    rows = jsonData[sheet];
                } catch (e) {
                    $scope.$evalAsync(function() {
                        toastr.error('No se pudo leer el archivo', 'Ha ocurrido un error');
                    });
                    return;
                }
                $scope.$evalAsync(function() {
                    if (rows) {
                        onRows(rows);
                    } else {
                        toastr.error('El archivo no tiene el formato adecuado', 'Ha ocurrido un error');
                    }
                });
            };
            reader.readAsBinaryString(file);
        }

        $scope.getFile = function(event) {
            if($scope.zona){
                readSheet(event, 'activos', function(rows) {
                    var parsed = maintenanceServices.parseActives({ activos: rows }, $scope.zona);
                    if (parsed.skipped.length > 0) {
                        toastr.warning('Filas omitidas por tipo de dispositivo desconocido: ' + parsed.skipped.map(function(s) { return s.row; }).join(', '), 'Cargar activos');
                    }
                    if (parsed.activos.length === 0) {
                        toastr.error('El archivo no tiene activos válidos', 'Ha ocurrido un error');
                        return;
                    }
                    startLoading();
                    createActives(parsed.activos).then(function() {
                        toastr.success('Activos cargados', 'Cargar activos');
                        generarListaMantenimiento($scope.zona.id, $scope.zona.rol);
                    }).catch(function() {
                        toastr.error('Ha ocurrido un error al cargar los activos', 'Cargar activos');
                    }).then(stopLoading);
                });
            } else {
                toastr.warning('Cargando Zonas', 'Info');
            }

        }

        // Sequential edita_dispositivo calls; resolves when all are done and
        // rejects on the first failure (the caller resets the preloader).
        function createActives(actives) {
            var promise = Promise.resolve();

            actives.forEach(function (a) {
                promise = promise.then(function () {
                    return addActive(a).then(function() {
                        return new Promise(function (resolve) {
                            setTimeout(resolve, TIME_PROMESE);
                        });
                    });
                });
            });

            return promise;

            function addActive(a) {
                var params = {
                    dispositivo: JSON.stringify(a),
                    id_usuario: $localStorage.id_usuario,
                };

                return RESTServices.post_header('cliente/edita_dispositivo.php',params,SHAREServices.hash_decode_token($localStorage.token),true).then(function (res) {
                    if (res.code != 200) {
                        return Promise.reject(res);
                    }
                });
            }
        }

        ////////crear zonas y dispositivos a partir de un archivo de excel
        // One transactional request (POST /zones/bulk) instead of a genera_zona
        // plus N edita_dispositivo calls per zone. No selected zone is needed.
        $scope.getZones = function(event) {
            readSheet(event, 'zonas', function(rows) {
                var built = maintenanceServices.buildBulkZones(rows);
                if (built.errors.length > 0) {
                    var shownErrors = built.errors.slice(0, 5).map(function(e) { return 'Fila ' + e.row + ': ' + e.reason; }).join('; ');
                    var moreErrors = built.errors.length > 5 ? ' (y ' + (built.errors.length - 5) + ' errores más)' : '';
                    toastr.error(shownErrors + moreErrors, 'El archivo contiene datos no válidos, no se creó ninguna zona');
                    return;
                }
                if (built.skipped.length > 0) {
                    toastr.warning('Filas omitidas: ' + built.skipped.map(function(s) { return s.row + ' (' + s.reason + ')'; }).join(', '), 'Cargar zonas');
                }
                if (built.zones.length === 0) {
                    toastr.error('El archivo no tiene zonas válidas', 'Ha ocurrido un error');
                    return;
                }
                startLoading();
                RESTServices.createZonesBulkV2(built.zones).then(function(res) {
                    if (res.code === '200') {
                        toastr.success('Zonas creadas: ' + res.zonas.length, 'Cargar zonas');
                        return loadZones();
                    }
                    if (res.code === '409') {
                        var names = res.conflicts || [];
                        var shown = names.slice(0, 5).join(', ') + (names.length > 5 ? ' y ' + (names.length - 5) + ' más' : '');
                        toastr.error('Ya existen zonas con estos nombres, no se creó ninguna: ' + shown, 'Cargar zonas');
                    } else if (res.code === '300') {
                        toastr.error(res.message ? 'El archivo contiene datos no válidos: ' + res.message : 'El archivo contiene datos no válidos', 'Cargar zonas');
                    } else {
                        toastr.error('Ha ocurrido un error al crear las zonas', 'Cargar zonas');
                    }
                }).catch(function() {
                    toastr.error('Ha ocurrido un error al crear las zonas', 'Cargar zonas');
                }).then(stopLoading);
            });
        }

        $scope.generateQRList = function() {
            console.log('generate qr');
            if ($scope.devices.length > 0) {
                var docDefinition = {
                    header: [
                        {
                            text: $scope.zona.nombre,
                        }
                    ],
                    content: [],
                    pageMargins: [10, 30, 10, 30],
                    styles: {
                        header: {
                            fontSize: 12,
                            bold: true,
                        }
                    }
                };

                var i = 0;
                while (i < $scope.devices.length) {
                    // Obtenemos los 4 dispositivos del grupo actual (pueden ser menos si es el último grupo)
                    var group = [];
                    for (var j = 0; j < 4; j++) {
                        group.push($scope.devices[i + j] || null);
                    }

                    var nameRow    = [];
                    var zoneRow    = [];
                    var qrRow      = [];
                    var logoRow    = [];
                    var spacerRow  = [];

                    for (var k = 0; k < 4; k++) {
                        var device = group[k];
                        if (device) {
                            var deviceId = device.id ? device.id : device.id_device;
                            nameRow.push({  text: $filter('limitTo')(device.nombre, 25), alignment: 'center', fontSize: 8, bold: true });
                            zoneRow.push({  text: $filter('limitTo')($scope.zona.nombre, 25), alignment: 'center', fontSize: 7 });
                            qrRow.push({    qr: 'https://helo.intelmotics.com/#/maintenanceLog/' + SHAREServices.hash_encode(deviceId), fit: 100, alignment: 'center' });
                            logoRow.push({  image: maintenanceServices.logoHeloData, width: 60, margin: [10, 5, 0, 0], alignment: 'center' });
                        } else {
                            // Celda vacía para rellenar cuando el número de dispositivos no es múltiplo de 4
                            nameRow.push({ text: '', alignment: 'center' });
                            zoneRow.push({ text: '', alignment: 'center' });
                            qrRow.push(  { text: '', alignment: 'center' });
                            logoRow.push({ text: '', alignment: 'center' });
                        }
                        spacerRow.push('\n');
                    }

                    var table = {
                        table: {
                            widths: ['25%', '25%', '25%', '25%'],
                            body: [
                                nameRow,
                                zoneRow,
                                qrRow,
                                logoRow,
                                spacerRow,
                            ]
                        },
                        layout: 'noBorders',
                    };

                    docDefinition.content.push(table);
                    i = i + 4;
                }

                pdfMake.createPdf(docDefinition).download('QRs_' + $scope.zona.nombre + '.pdf');
            } else {
                toastr.warning('No tienes dispositivos para generar los códigos QR', 'Info');
            }
        };

        

    }


})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.monitoreo').service('monitoringServices', monitoringServices);

    function monitoringServices() {
        return {
            statusOptions: [
                {
                    text: 'Abierto',
                    value: '0',
                },
                {
                    text: 'Cerrado',
                    value: '1',
                },
                {
                    text: 'En revisión',
                    value: '2',
                },
                {
                    text: 'Archivado',
                    value: '3',
                },
            ],
            priority: [
                {
                    text: 'Media',
                    value: '0',
                },
                {
                    text: 'Alta',
                    value: '1',
                },
                {
                    text: 'Baja',
                    value: '2',
                },
                {
                    text: 'Urgente',
                    value: '3',
                },
            ],
        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo-plano')
      .controller('monitoreoPlanoCtrl', monitoreoPlanoCtrl);
  
    function monitoreoPlanoCtrl($scope, $localStorage, RESTServices, $timeout, SHAREServices, $state, $filter, $rootScope) {
        $scope.planos = [];
        $scope.icon = '../../../assets/icons/icon_plano.svg';
        $scope.showConfiguracion = false;
        $scope.loading = true;
        $scope.no_informacion = false; 
        $scope.zoneSelected = {
            id: '',
        }
        $scope.step = 1;
        $scope.zonas = [];
        $scope.rol_id = $localStorage.rol;

        $timeout(function() {

            if (SHAREServices.zonas === null) {
                var params = {
                    "id_usuario": $localStorage.id_usuario,
                };
                ////query zonas
                RESTServices.fetchClientZones().then(function(data) {
                    if (data != null) {
                        if (data.code == '200') {
                            if(data.zonas) {
                                $scope.zonas = data.zonas;
                            } 
                            if(data.zonas_externas) {
                                $scope.zonas = $scope.zonas.concat(data.zonas_externas)
                            }
                            $scope.zonas = $filter('orderBy')($scope.zonas, 'nombre');
                            $scope.zonas = $filter('filter')($scope.zonas, {h : '0'});
                            $scope.zonas = $scope.zonas.map(function(z, i) {
                                z.index = i;
                                return z;
                            })
                            SHAREServices.zonas = $scope.zonas;
                            $scope.zona = $scope.zonas[0];
                            $scope.zoneSelected.id = $scope.zona.id;
                            $scope.getPlanoZona($scope.zona);
                            
                        }else{
                            $rootScope.flag_loading = false;
                            $scope.showConfiguracion = true;
                            $scope.step = 4;
                            $timeout(function(){
                                $rootScope.$broadcast('setDevicesPlane', {zona: $scope.zona, step: $scope.step});
                            })
                            $scope.loading = false; 
                        }
                    } else {
                        $scope.step = 4;
                        $timeout(function(){
                            $rootScope.$broadcast('setDevicesPlane', {zona: $scope.zona, step: $scope.step});
                        })
                        $scope.loading = false; 
                        $rootScope.flag_loading = false;
                    }  
    
                });
            } else {
                $scope.zonas = SHAREServices.zonas;
                $scope.zona = $scope.zonas[0];
                $scope.zoneSelected.id = $scope.zona.id;
                $scope.getPlanoZona($scope.zona); 
            }
            
        });


        $scope.getPlanoZona = function(item) {
            $scope.showConfiguracion = true;
            $scope.planos = [];
            ////query pines
            // v2: migrated from consulta_planosxzona.php
            RESTServices.fetchZonePlansV2(item.id).then(function(data) {
                if (data != null) {
                    if(data.planos && data.planos.length > 0) {
                        var index = $scope.zonas.findIndex(function(z){return z.id === item.id});
                        $scope.zona = $scope.zonas[index];
                        $scope.zoneSelected.id = $scope.zona.id;
                        $scope.showConfiguracion = false;
                        $scope.planos = data.planos;
                    } else {
                        var index = $scope.zonas.findIndex(function(z){return z.id === item.id});
                        $scope.zona = $scope.zonas[index];
                        $scope.zoneSelected.id = $scope.zona.id;
                        $scope.showConfiguracion = true;
                        $scope.step = 1;
                        $timeout(function(){
                            $rootScope.$broadcast('setDevicesPlane', {zona: $scope.zona, step: $scope.step});
                        })
                        
                    }
                    $rootScope.flag_loading = false;
                }
                $scope.loading = false;
                $rootScope.flag_loading = false;
            })
        }

        $scope.crearPlano = function(step) {
            $scope.showConfiguracion = true;
            $timeout(function(){
                $rootScope.$broadcast('setDevicesPlane', {zona: $scope.zona, step : step});
            })
        }

        $scope.$on('goToPlano', function(e, res) {
            $scope.getPlanoZona(res.zona)
        })

        $scope.$on('goToEditPlane', function(e, res) {
            $scope.showConfiguracion = true;
            var step = 3;
            $timeout(function(){
                $rootScope.$broadcast('editPlane', {zona: $scope.zona, step : step, plano: res.plano, pines: res.pines});
            })
        })
        
    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.ofertas_c')
        .controller('ofertas_cCtrl', ofertas_cCtrl);

    /** @ngInject */
    function ofertas_cCtrl($scope, $element, $filter, baConfig, layoutPaths, $window, $localStorage) {

        $scope.rol = '0';

        $scope.desconexiones = [{
                hora_in: '11:00',
                hora_fin: '12:00',
                valor_oferta: 200,
                fecha_limite: '12/06/2017',
                id: 0,
                carga_desconectada_total: 2500,
                zonas_desconectadas: 3,
                valor_desconexion: 500000,
                zonas: [{
                        index: 0,
                        estado: false,
                        nombre: "pasillo",
                        carga_zona: 600,
                        dispositivos: [{
                                "nombre": "dispo_1",
                                "valor": 100,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_2",
                                "valor": 200,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_3",
                                "valor": 300,
                                "estado": false
                            }
                        ]
                    },
                    {
                        index: 1,
                        estado: false,
                        nombre: "Lobby",
                        carga_zona: 1500,
                        dispositivos: [{
                                "nombre": "dispo_4",
                                "valor": 400,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_5",
                                "valor": 500,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_6",
                                "valor": 600,
                                "estado": false
                            }
                        ]
                    },
                    {
                        index: 2,
                        estado: false,
                        nombre: "hab 8",
                        carga_zona: 2400,
                        dispositivos: [{
                                "nombre": "dispo_7",
                                "valor": 700,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_8",
                                "valor": 800,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_9",
                                "valor": 900,
                                "estado": false
                            }
                        ]
                    }
                ]

            },
            {
                hora_in: '15:00',
                hora_fin: '16:00',
                valor_oferta: 200,
                fecha_limite: '13/06/2017',
                id: 1,
                carga_desconectada_total: 4500,
                zonas_desconectadas: 3,
                valor_desconexion: 900000,
                zonas: [{
                        index: 0,
                        estado: false,
                        nombre: "pasillo",
                        carga_zona: 600,
                        dispositivos: [{
                                "nombre": "dispo_1",
                                "valor": 100,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_2",
                                "valor": 200,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_3",
                                "valor": 300,
                                "estado": false
                            }
                        ]
                    },
                    {
                        index: 1,
                        estado: false,
                        nombre: "Lobby",
                        carga_zona: 1500,
                        dispositivos: [{
                                "nombre": "dispo_4",
                                "valor": 400,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_5",
                                "valor": 500,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_6",
                                "valor": 600,
                                "estado": false
                            }
                        ]
                    },
                    {
                        index: 2,
                        estado: false,
                        nombre: "hab 8",
                        carga_zona: 2400,
                        dispositivos: [{
                                "nombre": "dispo_7",
                                "valor": 700,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_8",
                                "valor": 800,
                                "estado": false
                            },
                            {
                                "nombre": "dispo_9",
                                "valor": 900,
                                "estado": false
                            }
                        ]
                    }
                ]

            },

        ];

        $scope.meses = [{
                nombre: "enero"
            },
            {
                nombre: "febrero"
            },
            {
                nombre: "marzo"
            },
            {
                nombre: "abril"
            },
            {
                nombre: "mayo"
            },
            {
                nombre: "junio"
            },
            {
                nombre: "julio"
            },
            {
                nombre: "agosto"
            },
            {
                nombre: "septiembre"
            },
            {
                nombre: "octubre"
            },
            {
                nombre: "noviembre"
            },
            {
                nombre: "diciembre"
            }
        ];

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.smartbar')
        .controller('smartbarCtrl', smartbarCtrl);

    /** @ngInject */
    function smartbarCtrl($scope, $stateParams) {
        $scope.rol = '0';

    }

})();


 
(function () {
  'use strict';

  angular.module('BlurAdmin.admin.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
      var mapCanvas = document.getElementById('google-maps');
      var mapOptions = {
        center: new google.maps.LatLng(44.5403, -78.5463),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapCanvas, mapOptions);
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

 
(function () {
  'use strict';

  angular.module('BlurAdmin.admin.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

 
(function () {
  'use strict';

  angular.module('BlurAdmin.admin.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

 
(function () {
  'use strict';

  angular.module('BlurAdmin.admin.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.recuperar')
        .directive('newPassword', newPassword);

    function newPassword() {
      return {
        restrict: 'E',
        controller: 'newPasswordCtrl',
        templateUrl: 'app/auth/recuperar_contrasena/newPassword/newPassword.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.recuperar')
        .controller('newPasswordCtrl', newPasswordCtrl);

    function newPasswordCtrl($scope, $rootScope, RESTServices, $localStorage, $state, $stateParams, toastr, SHAREServices) {
    
        $scope.NuevaContrasena = function(contrasena){
            $rootScope.flag_loading = true;
            var params ={
                email: $stateParams.email,
                code: $stateParams.code,
                //token: $stateParams.token,
                contrasena: contrasena,
            }

            RESTServices.post('cambiar_contrasena_code.php', params).then(function(ans) {
                if(ans.code==200){
                    $rootScope.flag_loading = false;
                    toastr.success('Se ha restaurado tu contraseña exitosamente', 'Cambio de contraseña exitoso');
                    deleteLocalStorage()
                    $state.go('sign_in')
                }else{
                    $rootScope.flag_loading = false;
                    toastr.error('Hubo un problema inesperado y debes repetir el proceso nuevamente', 'No se pudo restaurar la contraseña');
                    $state.go('sign_in')
                }
            });	
        }

        function deleteLocalStorage(){
            delete $localStorage.login;
            delete $localStorage.nombre_cliente;
            delete $localStorage.id_cliente;
        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.recuperar')
        .controller('validarCodigoCtrl', validarCodigoCtrl);

    function validarCodigoCtrl($scope, $rootScope, RESTServices, $state, $stateParams) {
        
        $scope.verificarCode = function(code){
            $rootScope.flag_loading = true;
            var params ={
                email: $stateParams.email,
                code: code,
            }
            RESTServices.post('valida_code.php', params).then(function(ans){
                if(ans.code==200){
                    $state.go('recuperar_contrasena.newPassword', {token: ans.token, email: $stateParams.email, code: code})
                    $rootScope.flag_loading = false;
                }else{
                    toastr.error('Por seguridad debes repetir el proceso nuevamente', 'El código no es válido');
                    $rootScope.flag_loading = false;
                    $state.go('recuperar_contrasena')  		
                }
            });
    
        }

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.recuperar')
        .directive('validarCodigo', validarCodigo);

    function validarCodigo() {
      return {
        restrict: 'E',
        controller: 'validarCodigoCtrl',
        templateUrl: 'app/auth/recuperar_contrasena/validarCodigo/validarCodigo.html'
      };
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.recuperar')
        .directive('sendEmail', sendEmail);

    function sendEmail() {
      return {
        restrict: 'E',
        controller: 'sendEmailCtrl',
        templateUrl: 'app/auth/recuperar_contrasena/sendEmail/sendEmail.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.recuperar')
        .controller('sendEmailCtrl', sendEmailCtrl);

    function sendEmailCtrl($scope, $rootScope, RESTServices, SHAREServices, loginUtil, $state, toastr) {
        
        $scope.recuperar = function(correo){  
            loginUtil.selectServidor();          
            $rootScope.flag_loading = true;

            RESTServices.post('valida_correo.php',{email: correo}).then(function(ans){
                if(ans.code == 200){
                    $state.go('recuperar_contrasena.validarCodigo', {email: correo})
                    $rootScope.flag_loading = false;	
                }else{
                    if (SHAREServices.server_status == 0) {
                        RESTServices.server_selector(2);
                        RESTServices.post('valida_correo.php',{email: correo}).then(function(ans){
                            if(ans.code==200){
                                $state.go('recuperar_contrasena.validarCodigo', {email: correo})
                                $rootScope.flag_loading = false;	
                            }else{
                                toastr.error('Intentalo nuevamente', 'Hubo un error inesperado');
                                $rootScope.flag_loading = false;		
                            }
                        })
                    }    
                }
            });
    
        }

    }
})();
/**
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.consumo.dashboard_consumo.estadisticas_zona')
        .controller('consumo_zonaCtrl', consumo_zonaCtrl);

    /** @ngInject */
    function consumo_zonaCtrl($scope, $window, RESTServices, SHAREServices, $filter, ngDialog, $localStorage, $stateParams, $state) {
        $scope.nombre_zona = $stateParams.nombre;
        $scope.id_zona = $stateParams.id;
        $scope.flagDesconexiones = false;
        $scope.tipo_app = $localStorage.tipo;
        SHAREServices.diaDatepicker = $filter('date')(new Date(), 'yyyy-MM-dd');

        $scope.rol = '4';

        RESTServices.fetchDevicesByZone($scope.id_zona).then(function(data) {
            if (data.code == '200') {
                $scope.dispositivos = data.dispositivos;
            }
        });

        $scope.consulta_desconexion = function(dispositivo) {
            $scope.dispositivo_selected = JSON.parse(dispositivo).id;
            var campos = {
                "id_zona": $scope.id_zona,
                "fecha": SHAREServices.diaDatepicker,
                "id_dispositivo": $scope.dispositivo_selected
            };
            var color = ["#112340", "#0C98F2"];
            RESTServices.post_header('consulta_estadisticaxzonaxdia.php', campos, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data.code == 200) {
                    if (data.desconexiones != undefined) {
                        $scope.flagDesconexiones = true;
                        var tiempoOff = 0;
                        SHAREServices.desconexionxzonaxdia = [];
                        for (var i = 0; i < data.desconexiones.length; i++) {
                            var desconexionxzonaxdia = {
                                "start": data.desconexiones[i].start,
                                "duration": data.desconexiones[i].duration,
                                "color": color[i],
                                "h_ini": data.desconexiones[i].h_ini,
                                "h_final": data.desconexiones[i].h_fin,
                                "labelText": "<b>[[Potencia]]</b>"
                            };
                            tiempoOff = tiempoOff + parseInt(data.desconexiones[i].duration, 10);
                            SHAREServices.desconexionxzonaxdia[i] = desconexionxzonaxdia;
                        }
                        SHAREServices.potencia_Wh = ((tiempoOff) * parseInt(data.potencia, 10)) / 60;
                        SHAREServices.flagDesconexiones = !SHAREServices.flagDesconexiones;

                        var params = {
                            "id_zona": $scope.id_zona,
                            "mes": $filter('date')(SHAREServices.diaDatepicker, 'yyyy-MM')
                        };

                        RESTServices.post_header('consulta_estadisticaxzonaxmes.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response.code == 200) {
                                SHAREServices.ahorroxzonaxmes = response.ahorro;
                                SHAREServices.flagAhorro = !SHAREServices.flagAhorro;
                            }
                        });
                    } else {
                        $scope.flagDesconexiones = false;

                        var params = {
                            "id_zona": $scope.id_zona,
                            "mes": $filter('date')(SHAREServices.diaDatepicker, 'yyyy-MM')
                        };

                        RESTServices.post_header('consulta_estadisticaxzonaxmes.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response.code == 200) {
                                SHAREServices.ahorroxzonaxmes = response.ahorro;
                                SHAREServices.flagAhorro = !SHAREServices.flagAhorro;
                            }
                        });
                    }
                }
            });
        }

        $scope.$watch(function() {
            return SHAREServices.diaDatepicker;
        }, function(newValue, oldValue) {


            var color = ["#112340", "#0C98F2"];

            var field = {
                "id_zona": $scope.id_zona,
                "fecha": newValue,
                "id_dispositivo": $scope.dispositivo_selected
            };

            RESTServices.post_header('consulta_estadisticaxzonaxdia.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data.code == 200) {
                    if (data.desconexiones != undefined) {
                        $scope.flagDesconexiones = true;
                        var tiempoOff = 0;
                        SHAREServices.desconexionxzonaxdia = [];
                        for (var i = 0; i < data.desconexiones.length; i++) {
                            var desconexionxzonaxdia = {
                                "start": data.desconexiones[i].start,
                                "duration": data.desconexiones[i].duration,
                                "color": color[i],
                                "h_ini": data.desconexiones[i].h_ini,
                                "h_final": data.desconexiones[i].h_fin,
                                "labelText": "<b>[[Potencia]]</b>"
                            };
                            tiempoOff = tiempoOff + parseInt(data.desconexiones[i].duration, 10);
                            SHAREServices.desconexionxzonaxdia[i] = desconexionxzonaxdia;
                        }
                        SHAREServices.potencia_Wh = ((tiempoOff) * parseInt(data.potencia, 10)) / 60;
                        SHAREServices.flagDesconexiones = !SHAREServices.flagDesconexiones;

                        var params = {
                            "id_zona": $scope.id_zona,
                            "mes": $filter('date')(newValue, 'yyyy-MM')
                        };
                        RESTServices.post_header('consulta_estadisticaxzonaxmes.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response.code == 200) {
                                SHAREServices.ahorroxzonaxmes = response.ahorro;
                                SHAREServices.flagAhorro = !SHAREServices.flagAhorro;
                            }
                        });
                    } else {
                        $scope.flagDesconexiones = false;

                        var params = {
                            "id_zona": $scope.id_zona,
                            "mes": $filter('date')(newValue, 'yyyy-MM')
                        };

                        RESTServices.post_header('consulta_estadisticaxzonaxmes.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response.code == 200) {
                                SHAREServices.ahorroxzonaxmes = response.ahorro;
                                SHAREServices.flagAhorro = !SHAREServices.flagAhorro;
                            }
                        });
                    }
                }
            });
        });


    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.instalador.dashboard_instalador')
        .controller('newClientCtrl', newClientCtrl);

    /** @ngInject */
    function newClientCtrl($scope, RESTServices, $localStorage, $state, toastr, $timeout,SHAREServices) {
        $scope.newClient = {};

        $timeout(function(){
            getCountrys()
        })

        $scope.integraciones = [
            {
                name: "Ninguna",
                id: "0",
            },
            {
                name: "SAEG",
                id: "1",
            },
            {
                name: "SENA",
                id: "2",
            },
        ]


        $scope.cancelar = function() {
            $state.go('dashboard_instalador');
        }

        $scope.getStates = function(pais) {

            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "id_pais": pais.id != undefined ? pais.id : null
            };
            RESTServices.post_header('admin/lista_estados.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.estados = res.estados;
                }
            });
        }

        $scope.getCitys = function(estado) {
            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "id_estado": estado != undefined ? estado.id : null
            };

            RESTServices.post_header('admin/lista_ciudades.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.ciudades = res.ciudades;
                }
            });
        }

        function getCountrys() {
            var fields = {
                "id_instalador": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "id_usuario": $localStorage.id_usuario
            };

            RESTServices.post_header('admin/lista_paises.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.paises = res.paises;
                }
            });
        }

        $scope.addClient = function(client) {
            client.ciudad = client.ciudad.id;

            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "cliente": client
            };

            RESTServices.post_header('admin/crear_cliente.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    client.id = res.id;
                    client.usuarios = null;

                    var parms = {
                        "id_usuario": $localStorage.id_usuario,
                       //token: SHAREServices.hash_decode_token($localStorage.token),
                        "id_cliente": client.id,
                        "id_instalador": $localStorage.id_usuario
                    };

                    RESTServices.post_header('admin/asociar_clienteainstalador.php', parms, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                        if (res.code == 200) {
                            $state.go('dashboard_instalador');
                            toastr.success('Se ha creado un cliente exitosamente', 'Creación de cliente');
                            $window.location.reload();
                        } else if (data.code == 400) {
                            toastr.error('Ha ocurrido un error', 'No se pudo crear el cliente');
                        } else {
                            toastr.error('Ha ocurrido un error', 'No se pudo crear el cliente');
                        }
                    });


                }
            });

        }





    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.instalador.users')
        .controller('newUserCtrl', newUserCtrl);

    /** @ngInject */
    function newUserCtrl($scope, RESTServices, $localStorage, $stateParams, $state, toastr, userServices, $rootScope,SHAREServices) {
        
        var service = $stateParams.parm == 'edit' ? 'admin/editar_usuario.php' : 'admin/crear_usuario.php';
        $scope.newUser = {};
        $scope.roles = userServices.roles;

        $scope.addUser = function(user) {

            var r = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var s = '';
            for (var i = 0; i < 20; i++) s += r.charAt(Math.floor(Math.random() * r.length));

            user.token = s;
            user.id_entidad = $stateParams.cliente.id;
            user.estado = '1';
            user.avatar = $scope.avatar;

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "usuario": user,
            };

            RESTServices.post_header(service, fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        user.avatar = userServices.setAvatar(user.avatar);
                        if($stateParams.parm == 'edit'){
                            $rootScope.$broadcast('editUser', {data: user});
                            $state.go('users');
                        }else{
                            $state.go('users', {newUser:user});
                        }
                        toastr.success('Se ha agregado un nuevo usuario correctamente', 'Nuevo Usuario')
                    }else if(data.code == '300'){
                        toastr.error('Este usuario ya se ha creado', 'Nuevo Usuario')
                    }
                    else{
                        toastr.error('No se puede conectar en este momento', 'Nuevo Usuario');   
                    }
                }else{
                    toastr.error('No se puede conectar en este momento', 'Nuevo Usuario');
                }
            });

        }

        $scope.cancelar = function(){
            $state.go('users');
        }
        
        $scope.avatares = userServices.avatares;

        $scope.getAvatar = function(avatar){
            $scope.avatares.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.avatares.findIndex(function(i) { return i.id == avatar.id });
            $scope.avatares[index].status = true;
            $scope.avatar = $scope.avatares[index].id;
        }

        

        if($stateParams.parm == 'edit'){
            $scope.getAvatar($stateParams.user.avatar);
            $scope.newUser = $stateParams.user;
            $scope.edit = true;
        }else{
            $scope.getAvatar($scope.avatares[0]);
        }

    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.instalador.users')
        .controller('userCardCtrl', userCardCtrl);

    /** @ngInject */
    function userCardCtrl($scope, ngDialog, RESTServices, toastr, $rootScope, $localStorage,SHAREServices) {
        
        $scope.deleteUser = function(user) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                closeByDocument: false,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Realmente desea borrar el usuario?';

                    $scope.cancelar = function() {
                        ngDialog.close();
                    }

                    $scope.aceptar = function() {
                        var field = {
                            id_usuario: $localStorage.id_usuario,
                           //token: SHAREServices.hash_decode_token($localStorage.token),
                            id: user.id
                        };

                        RESTServices.post_header('admin/eliminar_usuario.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                            if (data != null) {
                                if (data.code == '200') {
                                    ngDialog.close();
                                    toastr.success('Se ha eliminado el usuario correctamente', 'Eliminar usuario')
                                    $rootScope.$broadcast('userDelected', {data: user});
                                }else{
                                    toastr.error('No se puede conectar en este momento', 'Eliminar usuario');   
                                }
                            }else{
                                toastr.error('No se puede conectar en este momento', 'Eliminar usuario');
                            }
                        });                        
                    }
                }]
            });
        }



    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.instalador.users')
        .directive('userCard', userCard);
  
    /** @ngInject */
    function userCard() {
      return {
        restrict: 'E',
        controller: 'userCardCtrl',
        templateUrl: 'app/instalador/users/userCard/userCard.html',
        scope: {
            user: '=user'
        }
      };
    }
})();


(function () {
    'use strict';

    angular.module('BlurAdmin.profile')
        .controller('userInfoCtrl', userInfoCtrl);

    /** @ngInject */
    function userInfoCtrl($scope, RESTServices, $localStorage, $state, toastr,SHAREServices) {

        $scope.editPass = function() {
            $state.go('changePassword');
        }

        $scope.openEditMode = function() {
            $scope.editMode = !$scope.editMode;
        }

        $scope.editUserProfile = function(formValid, formDirty) {
            if ($scope.editMode) {
                if (formDirty) {
                    if (formValid) {
                        changeInfoUserProfile($scope.user);
                        $scope.editMode = false;
                    } 
                } else {
                    $scope.editMode = false;
                }
            } else {
                $scope.editMode = true;
            }
        }


        function changeInfoUserProfile(user) {

            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "usuario": user,
            };

            RESTServices.post_header('admin/editar_usuario.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code === '200') {
                    toastr.success('Se ha editado correctamente tu perfil', 'Perfil');
                    $localStorage.client = $scope.user;
                } else {
                    toastr.error('Hubo un error en la plataforma, intenta de nuevo más tarde.', 'Perfil');
                }
            });
        }
      

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.profile')
        .directive('userInfo', userInfo);
  
    /** @ngInject */
    function userInfo() {
      return {
        restrict: 'E',
        controller: 'userInfoCtrl',
        templateUrl: 'app/profile/components/user-info/user-info.html',
        scope: {
            user: '=user',
        },
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.profile')
        .controller('businessCardCtrl', businessCardCtrl);

    /** @ngInject */
    function businessCardCtrl($scope, RESTServices, $localStorage, toastr, $q,SHAREServices) {
        
        $scope.openEditMode = function() {
            $scope.editMode = !$scope.editMode;
        }

        $scope.editProfile = function(formValid, formDirty) {
            if ($scope.editMode) {
                if (formDirty) {
                    if (formValid) {
                        changeInfoProfile($scope.business);
                        $scope.editMode = false;
                    } 
                } else {
                    $scope.editMode = false;
                }
            } else {
                $scope.editMode = true;
            }
        }

        $scope.deleteImage =  function() {
            $scope.business.image = '';
            changeInfoProfile($scope.business);
        }

        function changeInfoProfile(client) {

            var info = {
                "nombre": client.cliente,
                "ciudad": client.id_ciudad,
                "direccion": client.direccion,
                "telefono": client.telefono,
                "image": client.image,
            }
            var params = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "cliente": JSON.stringify(info),
            };

            RESTServices.post_header('cliente/edita_cliente.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code === '200') {
                    toastr.success('Se ha editado correctamente tu información', 'Perfil');
                    $localStorage.client = $scope.business;
                } else {
                    toastr.error('Hubo un error en la plataforma, intenta de nuevo más tarde.', 'Perfil');
                }
            });
        }

        $scope.setImage = function() {
            //// agregar condicionales para la imagen
            $scope.loading = true;
            var f = document.getElementById('file').files[0],
            r = new FileReader();
            
            r.onload = function (e) {
                var hash = CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(e.target.result));
                $q.resolve(RESTServices.getURL(f,hash)).then(function(url){
                    $scope.business.image = url;
                    $scope.loading = false;
                    changeInfoProfile($scope.business);
                    $scope.$apply();
                });
            }
            r.readAsBinaryString(f);
        }

        
        $scope.getStates = function(id, fromView) {

            if (fromView) {
                $scope.business.pais = $scope.paises.filter(function(p) { return p.id === id })[0].nombre;
            }

            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "id_pais": id != undefined ? id : null
            };

            RESTServices.post_header('admin/lista_estados.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.estados = res.estados;
                }
            });
        }

        $scope.getCitys = function(id, fromView) {

            if (fromView) {
                $scope.business.estado = $scope.estados.filter(function(p) { return p.id === id })[0].nombre;
            }

            
            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "id_estado": id != undefined ? id : null
            };

            RESTServices.post_header('admin/lista_ciudades.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.ciudades = res.ciudades;
                }
            });
        }

        $scope.setCity = function(id) {
            $scope.business.ciudad = $scope.ciudades.filter(function(p) { return p.id === id })[0].nombre;
        }

        function getCountrys() {
            var fields = {
                "id_instalador": $localStorage.id_usuario,
                "id_usuario": $localStorage.id_usuario,
            };

            RESTServices.post_header('admin/lista_paises.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.paises = res.paises;
                }
            });
        }

        getCountrys();
        $scope.getStates($scope.business.id_pais);
        $scope.getCitys($scope.business.id_estado);
        

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.profile')
        .directive('businessCard', businessCard);
  
    /** @ngInject */
    function businessCard() {
      return {
        restrict: 'E',
        controller: 'businessCardCtrl',
        templateUrl: 'app/profile/components/business-card/business-card.html',
        scope: {
            business: '=business',
        },
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.settings')
        .controller('addHolidayDateCtrl', addHolidayDateCtrl);

    /** @ngInject */
    function addHolidayDateCtrl($scope, ngDialog, $rootScope, $localStorage, RESTServices, SHAREServices, $filter, toastr) {
        
        $scope.addHoliday = function() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/holiday.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
                    $scope.createHoliday = function(date) { 
                        createCountry($scope.country);
                        var index = $scope.holidays.findIndex(function(d){ return date === d });
                        if(index === -1){
                            var festivo = {
                                id: 0, 
                                id_pais: $scope.country.id,
                                day: $filter('date')(date, 'yyyy-MM-dd'),
                                year: $filter('date')(date, 'yyyy'),
                                eliminado: 0,
                            }
                            
                            var params = {
                                "id_usuario": $localStorage.id_usuario,
                                "festivo": JSON.stringify(festivo)
                            };                                  
                            
                            RESTServices.post_header('cliente/edita_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                                if (data != null) {
                                    if (data.code == '200') {
                                        var itm = {
                                            id: data.id,
                                            year: $filter('date')(date, 'yyyy'),
                                            day: $filter('date')(date, 'dd/MM/yyyy'),
                                        }
                                        $scope.holidays.push(itm);
                                        toastr.success('Feriado Agregado correctamente');
                                        ngDialog.close();                                     
                                    }else{
                                        toastr.error('Hubo un problema inesperado');
                                    }
                                }else{
                                    toastr.error('Hubo un problema inesperado'); 
                                }
                                $rootScope.flag_loading = false;
                            });
                        } else {
                            toastr.warning('Este feriado ya se encuentra agregado');  
                        }
                        ngDialog.close(); 
                    }

                    function createCountry(pais) {
                        pais.eliminado = '0';
                        var params = {
                            "id_usuario": $localStorage.id_usuario,
                            "pais": JSON.stringify(pais)
                        };                                  
                        
                        RESTServices.post_header('cliente/edita_paises_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                            if (data != null) {
                                if (data.code == '200') {

                                }
                            }
                        });     
                    }
                }]
            })
        }

        $scope.deteleHoliday = function(date) {
            
            var festivo = {
                id: date.id, 
                id_pais: $scope.country.id,
                day: date.day,
                year: date.year,
                eliminado: 1,
            };

            var params = {
                "id_usuario": $localStorage.id_usuario,
                "festivo": JSON.stringify(festivo)
            }; 

            RESTServices.post_header('cliente/edita_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        var index = $scope.holidays.findIndex(function(d){ return date === d });
                        $scope.holidays.splice(index, 1);
                        toastr.warning('Feriado borrado correctamente'); 
                    }
                }
            })
        }

        $scope.$on("$destroy", function () {
            ngDialog.close();
        });

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.settings')
        .directive('addHolidayDate', addHolidayDate);
  
    /** @ngInject */
    function addHolidayDate() {
      return {
        restrict: 'E',
        controller: 'addHolidayDateCtrl',
        templateUrl: 'app/settings/components/add-holiday-date/add-holiday-date.html',
        scope: {
            holidays: '=holidays',
            ngModel: '=ngModel',
            country: '=country',
            loading: '=loading',
        }
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.settings')
        .controller('createHolidaysCtrl', createHolidaysCtrl);

    /** @ngInject */
    function createHolidaysCtrl($scope, $localStorage, RESTServices, SHAREServices) {

        $scope.step_1 = true;
        $scope.step_2 = false;
        $scope.holidays = [];
        $scope.country = undefined;
        
        $scope.next = function(ind) {
            if(ind === 2) {
                $scope.step_1 = false;
                $scope.step_2 = true;
                RESTServices.getCountries().then(function(res){
                    $scope.paises = res;
                })
            } else {
                $scope.step_1 = true;
                $scope.step_2 = false;
            }
        }

        $scope.validatedCountry = function(pais){
            $scope.country = pais;
        }
        

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.settings')
        .directive('createHolidays', createHolidays);
  
    /** @ngInject */
    function createHolidays() {
      return {
        restrict: 'E',
        controller: 'createHolidaysCtrl',
        templateUrl: 'app/settings/components/create-holidays/create-holidays.html',
        scope: {
            countries: '=countries',
        }
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.settings')
        .controller('holidaysByCountryCtrl', holidaysByCountryCtrl);

    /** @ngInject */
    function holidaysByCountryCtrl($scope, $localStorage, RESTServices, SHAREServices, $filter, ngDialog, toastr, $rootScope) {

        
        $scope.getHoliday = function(country){
            
            var index = $scope.countries.findIndex(function(c){return c.id === country.id})
            if(!country.open){
                $scope.countries.forEach(function(c) {
                    c.open = false;
                });
                $scope.countries[index].open = true;
                $scope.loading = true;
                $scope.countries[index].holidays = [];

                var currentYear = new Date().getFullYear();
                var nextYear = currentYear + 1;
                var allyears = [];
                allyears.push(currentYear, nextYear);

                var promesas = allyears.map(function(year) {
                    var params = {
                        "id_usuario": $localStorage.id_usuario,
                        "id_pais": country.id,
                        "year": year,
                    };

                    return RESTServices.post_header('cliente/consulta_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true)
                    
                })
                
                Promise.all(promesas)
                    .then(function(data) {
                        data.forEach(function(item) {
                            if (item.code === '200') {
                                $scope.countries[index].holidays = $scope.countries[index].holidays.concat(item.festivos);
                            }else {
                                $scope.countries[index].holidays = [];
                            }
                        })
                        $scope.loading = false;
                    })
                    .catch(function(error) {
                        //console.log(error)
                    })


                // var params = {
                //     "id_usuario": $localStorage.id_usuario,
                //     "id_pais": country.id,
                //     "year": $filter('date')(new Date(), 'yyyy'),
                // };
          
                // RESTServices.post_header('cliente/consulta_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                //     if (data != null && data.code === '200') {
                //         $scope.countries[index].holidays = data.festivos;
                //     } else {
                //         $scope.countries[index].holidays = [];
                //     }
                //     $scope.loading = false;
                // })
            } else {
                $scope.countries[index].open = !$scope.countries[index].open;
            }
            
        }
        
        $scope.gotoAddCountry = function(ind) {
            $scope.$emit('gotoAddCreateHolidays', {ind: ind})
        }

        $scope.deleteCountry = function(pais) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Desea borrar este País?',
                    $scope.sumary = 'Esta acción no se puede deshacer'
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.aceptar = function() {
                        pais.eliminado = "1";
                        var params = {
                            "id_usuario": $localStorage.id_usuario,
                            "pais": JSON.stringify(pais)
                        }; 
                        RESTServices.post_header('cliente/edita_paises_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response.code == '200') {
                                ngDialog.close();
                                toastr.success('El país ha sido borrado', 'Eliminar zona');
                                $rootScope.$broadcast('deletedCountry', {pais: pais})
                            }else{
                                toastr.error('No se pude eliminar el país', 'Ha ocurrido algo inesperado');
                            }
                        });
                    }
                }]
            })
        }

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.settings')
        .directive('holidaysByCountry', holidaysByCountry);
  
    /** @ngInject */
    function holidaysByCountry() {
      return {
        restrict: 'E',
        controller: 'holidaysByCountryCtrl',
        templateUrl: 'app/settings/components/holidays-by-country/holidays-by-country.html',
        scope: {
            countries: '=countries',
        }
      };
    }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .directive('breadCrumbs', breadCrumbs);
    /** @ngInject */
    function breadCrumbs($state, SHAREServices, $stateParams, $timeout) {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/breadCrumbs/breadCrumbs.html',
        link: function($scope) {
            $timeout(function() {
                if($state.current.order == 0) SHAREServices.breadcrumbs = []
                if(SHAREServices.breadcrumbs.findIndex(function(i){return i.name == $state.current.name}) == -1){
                    var state = $state.current;
                    state.params = $stateParams;
                    SHAREServices.breadcrumbs.push(state);
                }
                $scope.breadCrumb = SHAREServices.breadcrumbs;
            })
            //////////
            $scope.validateState = function(state){
                if(state.name != $state.current.name){
                    $state.go(state.name, state.params);
                    SHAREServices.breadcrumbs.splice(state.order);
                } 
            }
        }
      };
    }
  
  })();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);
  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin')
        .directive('loadingContent', loadingContent);
  
    /** @ngInject */
    function loadingContent() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/loading/loading.html',
        scope:{
            loading: '=loading',
            noInfo: '=noInfo'
        }
      };
    }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $localStorage, $timeout, $window, RESTServices, SHAREServices, $state, ngDialog, toastr) {
    $timeout(function() {
      if(SHAREServices.flagNotificaciones){
        $scope.indNotifications = 0;
        RESTServices.fetchNotificationsListV2().then(function(result) {
            if (result != null) {
                if (result.code == '200') {
                  SHAREServices.flagNotificaciones=false;
                  $scope.indNotifications = result.badge;
                  if(result.notificaciones != undefined){
                    $scope.notifications = result.notificaciones; 
                    $scope.notifications = $scope.notifications.map(function(d){                      
                      d.tiempo = SHAREServices.timeAgo(new Date (d.fecha+'Z'),Date.now(),false);
                      d.action = setAction(d.tipo);
                      d.icon = setIcon(d.tipo);
                      return d;
                    });
                    SHAREServices.notifications = $scope.notifications;
                    
                  }
                  SHAREServices.badge = $scope.indNotifications;
                }
            }     
        });
      }else{
        $scope.indNotifications = SHAREServices.badge;
        $scope.notifications=SHAREServices.notifications;
      }
    });

    $scope.pendingZones = [];

    function setAction(type){
      switch(type){
        case '1':
          return 'goMaintenance()';
        case '2':
          return 'goAlerts()';
        case '3':
          return 'AddZoneToUser()';
      }
    };
    function setIcon(type){
      switch(type){
        case '1':
          return 'ion-settings';
        case '2':
          return 'ion-thermometer';
        case '3':
          return 'ion-forward';
      }
    };
    
    $scope.goMaintenance = function(){
      $state.go('mantenimiento')
    };

    $scope.goAlerts = function(){
      $state.go('alerts')
    };

    $scope.AddZoneToUser = function(){
      ngDialog.open({
        template: 'app/cliente/dashboard-cliente/templates/addZone.html',
        className: 'ngdialog-theme-plain',
        scope: $scope,
        controller: ['$scope', function($scope) {
            $timeout(function() {
              RESTServices.fetchPendingZonesV2().then(function(response) {
                if(response.code == '200'){
                  $scope.pendingZones = response.zonas;
                }
              });
            })
            

            $scope.cancelar = function() {
                ngDialog.close();
            };

            $scope.addZoneToMyProfile = function(itm) {
                // v2: migrated from cliente/aprueba_zonas_usuario.php. Always
                // 204 on success, including when nothing was pending.
                RESTServices.approveZoneUsersV2(itm ? itm.id_zona : null).then(function(res) {
                    if(itm){
                      $scope.validador = true;
                      var index = $scope.pendingZones.findIndex(function(u){return u.id_zona == itm.id_zona});
                      if(index >= 0){
                        $scope.pendingZones.splice(index, 1);
                      }
                      toastr.success('La zona ha sido agregada para tu gestión', 'Gestión de zonas');
                      if($scope.pendingZones.length == 0){
                        ngDialog.close();
                      }
                    }else{
                      $window.location.reload();
                      toastr.success('Las zonas han sido agregadas para tu gestión', 'Gestión de zonas');
                      ngDialog.close();
                    }
                    SHAREServices.zonas = null;
                }).catch(function() {
                    toastr.error('Ha ocurrido un error al gestionar la zona', 'Gestión de zonas');
                });
            }

        }]
      });
      
    }

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .directive('pageFooter', pageFooter);

    function pageFooter() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/pageFooter/pageFooter.html',
        controller: function($scope) {
          $scope.today = new Date();
        },
      };
    }
  
  })();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'pageTopCtrl',
    };
  };
              

})();




(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('pageTopCtrl', pageTopCtrl);

    /** @ngInject */
    function pageTopCtrl($scope, $window, $localStorage, SHAREServices, RESTServices, $state, $cookies, $rootScope, ngDialog, utilities, $timeout, statisticsServices) {

        var home = $localStorage.rol;
        $scope.id_rol = $localStorage.rol;
        $scope.monitoringMode = '0';
        $scope.hiddenZones = '0';
        $scope.active_alerts = 0;
        $scope.results = [];
        var now = new Date();
        var exp = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
        $scope.client = {};
        $scope.client.zonas = [];
        $scope.user_name = $localStorage.client ? $localStorage.client.nombre: SHAREServices.cerrar_sesion();
        $scope.nombre_cliente = $localStorage.nombre_cliente;
        $scope.class_header;
        $scope.link_dashboard;
        $scope.logo_helo = '../../../../assets/img/helo_logo.png';
        if ($localStorage.id_cliente == '38' || $localStorage.id_cliente == '47' || $localStorage.id_cliente == '82') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/logo-oe.png',
                name: 'Optim Energy'
            }
        } else if ($localStorage.id_cliente == '87') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/LOGO_SOLENIUM.png',
                name: 'Solenium'
            }
        } else if ($localStorage.id_cliente == '158') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/Logo_SolucionAIRE.png',
                name: 'Solución Aire'
            }
        } else if ($localStorage.id_cliente == '377') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/logo_realcol.png',
                name: 'RealCol'
            }
        } else if ($localStorage.id_cliente == '112') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/logo_lutus.png',
                name: 'Lutus'
            }
        } else if ($localStorage.id_cliente == '394') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/logo_santafe.png',
                name: 'Santafe Energy'
            }
        } else if ($localStorage.id_cliente == '488') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/vitacom_logo.jpg',
                name: 'Vitacom'
            }
        } else if ($localStorage.id_cliente == '489') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/ipse_logo.png',
                name: 'Vitacom'
            }
        } else if ($localStorage.id_cliente == '494') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/teana_logo.jpeg',
                name: 'Teana'
            }
        } else if ($localStorage.id_cliente == '506') {
            $scope.marketer = {
                status: true,
                img: '../../../../assets/img/epm_logo.png',
                name: 'EPM'
            }
        } else {
            $scope.marketer = {
                status: false,
                img: '',
                name: ''
            }
        }

        $scope.openModalSearch = function() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/search.html',
                className: 'ngdialog-theme-plain modal-search',
                appendClassName: 'modal-search',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.loading = false;
                    $scope.first_search = true;
                    // Scoped search (GET /devices/search): only devices of the user's own
                    // zones and of zones shared with them. The backend needs 2+ characters.
                    $scope.search = function(text) {
                        var query = typeof text === 'string' ? text.trim() : '';
                        if(query.length >= 2){
                            $scope.loading = true;
                            RESTServices.searchDevicesV2(query).then(function(response) {
                                if (response.code === '200') {
                                    $scope.results = response.dispositivos.map(function(r){
                                        r.icon = statisticsServices.setIcon(r.tipo_dispositivo)
                                        return r
                                    })
                                } else {
                                    $scope.results = []; 
                                }
                            }).catch(function() {
                                $scope.results = [];
                            }).then(function() {
                                $scope.loading = false;
                                $scope.first_search = false;
                            });
                        } else {
                            $scope.results = [];
                        }
                        
                    }
                    // Same state params as the other callers: `control` comes from
                    // can_control (owned zone or a share with role control) and
                    // `devices` is null (the hub master screens guard against it).
                    $scope.goToDeviceProfile = function(device){
                        var objetDevice = {
                            id: String(device.id_dispositivo),
                            tipo: String(device.tipo_dispositivo),
                        }
                        if (device.id_zona !== undefined && device.id_zona !== null) {
                            objetDevice.id_zona = String(device.id_zona);
                        }
                        $state.go('mantenimiento_apparatusProfile', { device: objetDevice, control: device.control === true, devices: null });
                    }
                    $scope.cerrar = function() {
                        ngDialog.close();  
                    };
                    
                    
                }]
            })
        }
        

        /////
        /// if ($cookies.get('userRol') === '0') $scope.control = true;


        function setClassHeader(home) {
            switch (home) {
                case '0':
                case '5':
                case '6':
                case '7':
                case '8':
                case '10':
                case '11':
                case '12':
                    $scope.class_header = 'header_color_cliente';
                    $scope.link_dashboard = '#/dashboard_cliente/zones'
                    break;
                case '1':
                    $scope.class_header = 'header_color_op';
                    $scope.link_dashboard = '#/dashboard_op'
                    break;
                case '2':
                    $scope.class_header = 'header_color_admin';
                    $scope.link_dashboard = '#/dashboard_admin'
                    break;
                case '3':
                    $scope.class_header = 'header_color_cliente';
                    $scope.link_dashboard = '#/dashboard_instalador'
                    break;
                case '4':
                    $scope.class_header = 'header_color_instalador';
                    $scope.link_dashboard = '#/dashboard_consumo'
                    break;
                case '9':
                    $scope.class_header = 'header_color_cliente';
                    $scope.link_dashboard = '#/monitoreo-plano'
                    break;
            }

        }
        setClassHeader(home);

        $timeout(function(){
            if($state.current.showIconAlert) {
                $scope.showSideBarAlertsIcon = true;
            }
            if($localStorage.token === undefined) {
                SHAREServices.cerrar_sesion();
            } else {
                RESTServices.fetchRoleV2().then(function(response) {
                    if (response.code === '200') {
                        var state = utilities.guardUser($state.current.controlAccess, response.rol)
                        if (state === false) {
                            SHAREServices.cerrar_sesion();
                        } else {
                            if (response.rol === '0') $scope.control = true;
                            if ($localStorage.server_url != undefined) {
                                if ($localStorage.server_url[17] == '0') RESTServices.server_selector(1);
                                else if ($localStorage.server_url[17] == '1') RESTServices.server_selector(2);
                            } else {
                                RESTServices.server_selector(0);
                            }
                            if(response.rol === '6' || response.rol === '7' || response.rol === '8' || response.rol === '12') {
                                $scope.accessHiddenZones = true;
                                validateShowHiddenZones();
                            }
                        }
                    } else {
                        SHAREServices.cerrar_sesion();
                    }
                    
                })
                .catch(function(){
                    SHAREServices.cerrar_sesion();
                });
            }
            validateMonitoring();
            
        });

        //////Membresía
        function consultaMembresia() {

            var fields = {
                "id_usuario": $localStorage.id_usuario,
            };
            RESTServices.post_header('cliente/consulta_usuario_membresia.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code === '200') {
                    if (response.membresia.visto === '0') {
                        showModalMembership();
                    }
                    $scope.membershipType = utilities.getMembershipType(response.membresia.tipo_membresia);
                    $scope.daysMembership = utilities.getMembershipDays(response.membresia.f_fin);              
                } else {
                    $scope.membershipType = utilities.getMembershipType('1');
                }
            });
        }

        function showModalMembership() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/membership.html',
                className: 'modal-membership',
                scope: $scope,
                closeByDocument: false,
                controller: ['$scope', function($scope) {
                    $scope.cerrar = function() {
                        ngDialog.close();
                        vistaMembership();
                    };
                }]
            })
        }

        function vistaMembership() {
            var fields = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
            };
            RESTServices.post_header('cliente/edita_vista_membresia.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code === '200') {
                   //console.log('Inicia periodo de mebresia');
                    /// Inicia periodo de mebresia             
                }
            });
        }

        consultaMembresia();

        $scope.cerrar_sesion = function() {
            SHAREServices.cerrar_sesion();
        }
        $scope.showNotificacion = function() {
            $scope.notificacion = false;
            $location.hash('grafica_comparativa');
            $anchorScroll();
        }
        $scope.showSideBarAlerts = function() {
            $scope.$broadcast('openSideBarAlerts')
        }
        $scope.notificacion = true;
        //angular.element(document.querySelector("#tawkchat-container")).css("display", "inherit");

        $scope.goCambiarContrasena = function() {
            $state.go('changePassword');
        };
        $scope.goToHelp = function() {
            $state.go("help");
        };
        $scope.goProfile = function() {
            $state.go("profile");
        };
        $scope.goMembershipCoupon = function() {
            $state.go("profile.membershipCoupon");
        }
        $scope.goToGeneralSettings = function() {
            var name = $state.current.name.split('.')[0]
            if(name === 'settings') {
                $state.go($state.current, {}, { reload: true })
            } else {
                $state.go("settings");
            }
        }

        $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams){
            $window.scrollTo(0, 0);
        });

        if ($state.current.title === 'Ayuda'){
            var ele = document.querySelector('#freshworks-container');
            if(ele) ele.style.display = 'block';
        } else {
            var ele = document.querySelector('#freshworks-container');
            if(ele) ele.style.display = 'none';
        }

        $scope.activeMonitoringMode = function() {
            $scope.monitoringMode = $scope.monitoringMode === '0' ? '1' : '0';
            SHAREServices.monitoringMode = $scope.monitoringMode;
            $cookies.put('monitoringMode', $scope.monitoringMode, {
                expires: exp
            });
            $window.location.reload();
        }

        function validateMonitoring() {
            var allCookies = $cookies.getAll();
            if (allCookies.monitoringMode) {
                $scope.monitoringMode = $cookies.get('monitoringMode');
                SHAREServices.monitoringMode = $scope.monitoringMode;
            } else {
                SHAREServices.monitoringMode = $scope.monitoringMode;
            }
        }

        $scope.showHiddenZones = function() {
            $scope.hiddenZones = $scope.hiddenZones === '0' ? '1' : '0';
            SHAREServices.hiddenZones = $scope.hiddenZones;
            $cookies.put('hiddenZones', $scope.hiddenZones, {
                expires: exp
            });
            $window.location.reload();
        }

        function validateShowHiddenZones() {
            var allCookies = $cookies.getAll();
            if (allCookies.hiddenZones) {
                $scope.hiddenZones = $cookies.get('hiddenZones');
                SHAREServices.hiddenZones = $scope.hiddenZones;
            } else {
                SHAREServices.hiddenZones = $scope.hiddenZones;
            }
        }
        $scope.$on('setSideBarAlertsInd', function(event, result) {
            if(result.ind >= 100){
                $scope.active_alerts = '99+';
            } else {
                $scope.active_alerts = result.ind
            }
            
        });

        $scope.$on("$destroy", function () {
            ngDialog.close();
        });


    }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .controller('selectableListCtrl', selectableListCtrl);
  
    /** @ngInject */
    function selectableListCtrl($scope, $filter) {
        var allItems = [];
        var indFilter = true;
        var first = true;
        $scope.selectAll = function(flag) {
            if(flag) {
                $scope.items.map(function(i){i.status = true})
                $scope.ngModel = $scope.items;
            } else {
                $scope.items.map(function(i){i.status = false})
                $scope.ngModel = [];
            }
            $scope.validateList();
        }

        $scope.$watch(function() {
            return $scope.items;
        }, function() {
            if(first) {
                if($scope.items.length > 0) {
                    allItems = $scope.items;
                    first = false;
                } 
            }
            
        });

        $scope.addToList = function(){
            $scope.ngModel = [];
            var itemsSelected = allItems.filter(function(i){return i.status === true});
            $scope.ngModel = itemsSelected; 
            $scope.validateList();  
        }

        $scope.validateList = function() {
            if($scope.activeValidation){
                var index = $scope.items.findIndex(function(i){return i.status === true});
                if(index >= 0) {
                    $scope.validation = true;
                } else {
                    $scope.validation = false;
                }
            }
        }

        $scope.search = function(buscar) {
            if (indFilter){
                allItems = Array.from($scope.items)
            }
            if(buscar === '') {
                $scope.items = Array.from(allItems);
            } else {
                $scope.items = $filter('filter')(allItems, buscar);
                $scope.items = $filter('orderBy')($scope.items, $scope.label);
            }
            indFilter = false;
        }
    }
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .directive('selectableList', selectableList);
  
    /** @ngInject */
    function selectableList() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/selectable-list/selectable-list.html',
        controller: 'selectableListCtrl',
        scope: {
            items: '=items',
            ngModel: '=ngModel',
            label: '=label',
            loading: '=loading',
            activeValidation: '=activeValidation',
            validation: '=validation',
        },
      };
    };
                
  
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .directive('selectedField', selectedField);
    /** @ngInject */
    function selectedField() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/selectedField/selectedField.html',
        scope: {
            ngModel: '=ngModel',
            lista: '=lista',
        },
        link: function(scope) {
            
            scope.lista = [];
            //scope.ngModel = [];
            
            scope.addItemToMatches = function(ev, newItem){
                var keyCode = ev.which || ev.keyCode;
                if(keyCode === 13){
                    if(validarCorreo(newItem)){
                        scope.ngModel.push(newItem);
                        scope.newItem = ''; 
                    }
                }else if(keyCode === 188){
                    var value = newItem.substr(0, newItem.length -1)
                    if(validarCorreo(value)){
                        scope.ngModel.push(value);
                        scope.newItem = '';
                    }
                }
                
            }
            scope.addItemToMatchesBlur = function(newItem){
                if(newItem != undefined){
                    if(newItem !== ''){
                        if(validarCorreo(newItem)){
                            scope.ngModel.push(newItem);
                            scope.newItem = '';
                            scope.showListaOptiones = false; 
                        }else{
                            scope.showListaOptiones = false;
                        }
                    }else{
                        scope.emailInvalido = false;
                        //scope.showListaOptiones = false;
                    }
                }else{
                    //scope.showListaOptiones = false;
                }
                
            }

            scope.addItem = function(itm){
                if(emailYaExiste(itm)){
                    return
                }else{
                    scope.ngModel.push(itm)
                    var index = scope.lista.findIndex(function(i){return i === itm})
                    scope.lista.splice(index, 1);
                    scope.showListaOptiones = false;
                    scope.newItem = '';
                    scope.emailInvalido = false;
                }
                
            }

            function emailYaExiste(itm){
                var index = Array.isArray(scope.ngModel)? scope.ngModel.findIndex(function(u){return u === itm}): -1;
                if(index >= 0){
                    scope.emailYaExiste = true;
                    return true
                }else{
                    scope.emailYaExiste = false;
                    return false
                }
            }

            function validarCorreo(itm){
                var filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if(filter.test(itm)){
                    if(emailYaExiste(itm)){
                        return
                    }else{
                        scope.emailInvalido = false;
                        return true;
                    }
                } else {
                    scope.emailInvalido = true;
                    return false;
                }
            }

            scope.deteleUser = function(itm){
                var index = scope.ngModel.findIndex(function(u){return u === itm});
                scope.ngModel.splice(index, 1);
                if (scope.lista.length > 0) {
                    scope.lista.push(itm);
                }
                    

                
            }

        }
      };
    }
  
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .controller('selectorFilterCtrl', selectorFilterCtrl);
  
    /** @ngInject */
    function selectorFilterCtrl($scope, $filter) {
        var allItems = [];
        var first = true;
        $scope.open = false;
        $scope.filteredItems = [];

        $scope.$watch('items', function(newVal) {
            if (newVal && newVal.length > 0) {
                allItems = angular.copy(newVal);
                $scope.filteredItems = angular.copy(newVal);
                if (first) {
                    if (!$scope.selectedItem) {
                        $scope.selectedItem = $scope.filteredItems[0];
                    }
                    first = false;
                }
            }
        });

        $scope.search = function(buscar) {
            if (buscar === '') {
                $scope.filteredItems = angular.copy(allItems);
            } else {
                $scope.filteredItems = $filter('filter')(allItems, buscar);
                $scope.filteredItems = $filter('orderBy')($scope.filteredItems, $scope.label);
            }
        };
        
        $scope.selectZone = function(item) {
            $scope.selectedItem = item;
            $scope.selected({ ind: item });
            $scope.open = false;
            $scope.filteredItems = allItems;
        }

    }
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .directive('selectorFilter', selectorFilter);
  
    /** @ngInject */
    function selectorFilter() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/selector-filter/selector-filter.html',
        controller: 'selectorFilterCtrl',
        scope: {
            items: '=items',
            selected: '&',
            selectedItem: '=selectedItem'
        },
      };
    };
                
  
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .directive('selectedList', selectedList);
    /** @ngInject */
    function selectedList() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/seletedList/selectedList.html',
        scope: {
            ngModel: '=ngModel',
            lista: '=lista',
            selected: '&selected'
        },
        link: function(scope) {
            scope.addItem = function(itm){
                var value = JSON.parse(itm)
                scope.ngModel.push(value)
                var index = scope.lista.findIndex(function(i){return i.nombre === value.nombre})
                scope.lista.splice(index, 1);
                scope.showListaOptiones = false;
                scope.newItem = '';
            }
            scope.deteleItem = function(itm){
              var index = scope.ngModel.findIndex(function(u){return u === itm});
              scope.ngModel.splice(index, 1);
              scope.lista.push(itm);
          }

        }
      };
    }
  
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .controller('sidebarAlertsCtrl', sidebarAlertsCtrl);
  
    /** @ngInject */
    function sidebarAlertsCtrl($scope, $filter, $state, toastr, $timeout, $interval, SHAREServices, $localStorage, RESTServices, $rootScope) {

        $scope.open_not = false;
        $scope.notificationsAlerts = [];
        $scope.notfiltered = [];
        $scope.trigger = true;
        $scope.rol = $localStorage.rol;
        $scope.loading = true;

        var timer;
        var TIME = 300000;

        $timeout(function(){
            getNotAlerts();
            iniciarTimer();
        });

        $scope.openSideBar = function() {
            $scope.open_not = !$scope.open_not;
        }

        $scope.gotoAlerts = function(not) {
            SHAREServices.zona_alertas = not;
            $state.go('alerts');
        }

        $scope.notTrigger = function() {
            $scope.trigger = !$scope.trigger;
            if($scope.trigger) {
                iniciarTimer()
            } else {
                cancelarTimer()
            }
        }

        $scope.filtrarNot = function(buscar) {
            if(buscar === '') {
                $scope.notfiltered = Array.from($scope.notificationsAlerts);
            } else {
                $scope.notfiltered = $filter('filter')($scope.notificationsAlerts, { nombre : buscar });
            }
        }

        function getNotAlerts() {
            
            RESTServices.fetchAlertsZonesSummaryV2().then(function(response) {
                if (response != null) {
                    var cantidad = 0;
                    var notificaciones = [];
                    if(response.zonas) {
                        notificaciones = notificaciones.concat(response.zonas) 
                    }
                    if(response.zonas_externas) {
                        notificaciones = notificaciones.concat(response.zonas_externas) 
                    }

                    $scope.notificationsAlerts = validarAlertas(notificaciones, $scope.notificationsAlerts);
                    $scope.notificationsAlerts = addClass($scope.notificationsAlerts)
                    $scope.notfiltered = Array.from($scope.notificationsAlerts);
                    $scope.notfiltered.forEach(function(not){
                        cantidad = cantidad + parseInt(not.cantidad);
                    })
                    $scope.loading = false;
                    $rootScope.$broadcast('setSideBarAlertsInd', {ind: cantidad})
                    if(SHAREServices.novedad_alertas) {
                        SHAREServices.is_first_alertas = false;
                        toastr.warning('Se han registrado novedades en las zonas de monitoreo', 'Nueva alerta')
                    }
                }
            })
        }

        function iniciarTimer() {
            timer = $interval(function() {
                getNotAlerts()
            }, TIME);
        };

        function cancelarTimer() {
            $interval.cancel(timer);
            timer = undefined;
        }

        $scope.shortName = function(value) {
            var nit = '';
            if (value) {
                var items = value.split(' ');
                if (items.length > 1) {
                    if (items[1].substring(0,1) == '-') {
                        nit =  items[0].substring(0,1) + items[2].substring(0,1);
                    } else {
                        nit = items[0].substring(0,1) + items[1].substring(0,1);
                    }
                } else {
                    nit = items[0].substring(0,1)
                }
            }
            return nit
        }

        function addClass(data) {
            data.map(function(n){
                if(parseInt(n.cantidad) > 10 && parseInt(n.cantidad) <= 20) {
                    n.class = 'not-ind-mid';
                } else if(parseInt(n.cantidad) > 20) {
                    n.class = 'not-ind-high';
                } else {
                    n.class = 'not-ind-low';
                }
                return n;
            })

            return data
        }

        function validarAlertas(nuevoArray, viejoArray) {
            var arrayValidado = [];
            nuevoArray.forEach(function(item){
                var index = viejoArray.findIndex(function(v) {return v.id === item.id});
                if(index > -1) {
                    if(parseInt(viejoArray[index].cantidad) < parseInt(item.cantidad)){
                        viejoArray[index].cantidad = item.cantidad;
                        SHAREServices.novedad_alertas = true;
                    }
                } else {
                    arrayValidado.unshift(item);
                    SHAREServices.novedad_alertas = true;
                }
                if(SHAREServices.is_first_alertas) {
                    SHAREServices.novedad_alertas = true;
                } else {
                    SHAREServices.novedad_alertas = false;
                }
                
            })

            arrayValidado = viejoArray.concat(arrayValidado);
            return arrayValidado;
        }

        $scope.$on('$destroy', function() {
            $interval.cancel(timer);
            timer = undefined;
        });
       
        $scope.$on('openSideBarAlerts', function() {
            $scope.openSideBar();
        });


    }
  })();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .directive('sidebarAlerts', sidebarAlerts);
  
    /** @ngInject */
    function sidebarAlerts() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/sidebar-alerts/sidebar-alerts.html',
        controller: 'sidebarAlertsCtrl',
      };
    };
                
  
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState =  $scope.menuItems.length > 0 ? $scope.menuItems[0].stateRef : '';

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];

        this.addStaticItem = function() {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        /** @ngInject */
        this.$get = function($state, layoutSizes, $localStorage) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();

                this.getMenuItems = function() {
                    var states = defineMenuItemStates();
                    var menuItems = states.filter(function(item) {
                        return item.level == 0;
                    });

                    menuItems.forEach(function(item) {
                        var children = states.filter(function(child) {
                            return child.level == 1 && child.name.indexOf(item.name) === 0;
                        });

                        item.subMenu = children.length ? children : null;

                    })

                    return menuItems.concat(staticMenuItems);
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function(isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function() {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function() {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function(item) {

                        var result = [];
                        _iterateSubItems(item);
                        return result;

                        function _iterateSubItems(currentItem) {
                            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
                                subItem.stateRef && result.push(subItem.stateRef);
                                _iterateSubItems(subItem);
                            });
                        }
                    }
                    //Función que pinta los Items del Menú principal///////

                function defineMenuItemStates() {
                    return $state.get()
                        .filter(function(s) {
                            /*return s.sidebarMeta;*/
                            switch ($localStorage.rol) {
                                case '0': //Cliente
                                case '5': //Cliente
                                case '12': //coordinador producción
                                    if (s.url == '/dashboard_cliente' || s.url == '/mantenimiento' || s.url == '/consumo_v2' || s.url == '/dashboardConsumo' || s.url == '/puntosFacturacion' || s.url == '/alerts' || s.url == '/help') {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                case '1': //Operador
                                    if (s.url == '/dashboard_op' || s.url == '/ofertas' || s.url == '/generar' || s.url == '/historial_op') {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                case '2': //Administrador
                                    if (s.url == '/dashboard_admin' || s.url == '/instaladores' || s.url == '/clientes' || s.url == '/operador' || s.url == '/zona' || s.url == '/dispositivo' || s.url == '/facturacion' || s.url == '/estadisticas' || s.url == '/generar' || s.url == '/valor_kwh') {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                case '3': //Instalador
                                    //if (s.url == '/proyectos' || s.url == '/help') {
                                    if (s.url == '/dashboard_instalador' || s.url == '/help') {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                case '4': //Consumo
                                    if (s.url == '/dashboard_consumo' || s.url == '/consumo_zona') {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                case '6': //Monitoreo
                                case '8': //coordinador
                                    if (s.url == '/dashboard_cliente' || s.url == '/mantenimiento' || s.url == '/consumo_v2' || s.url == '/dashboardConsumo' || s.url == '/puntosFacturacion' || s.url == '/alerts' || s.url == '/help' || s.url == '/monitoring' || s.url == '/tickets' || s.url == '/tecnicos' || s.url == '/monitoreo-plano') {
                                        return s.sidebarMeta;
                                    };
                                    // Energy dashboard is only available for monitoreo (rol 6)
                                    if (s.url == '/consumo_energetico' && $localStorage.rol === '6') {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                case '7': //Técnico
                                    if (s.url == '/dashboard_cliente' || s.url == '/mantenimiento' || s.url == '/consumo_v2' || s.url == '/dashboardConsumo' || s.url == '/puntosFacturacion' || s.url == '/alerts' || s.url == '/help' || s.url == '/monitoring' || s.url == '/tickets' ) {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                case '9': //monitoreo plano
                                    if (s.url == '/monitoreo-plano') {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                case '10': //monitoreo plano visualización
                                    if (s.url == '/dashboard_cliente' || s.url == '/monitoreo-plano') {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                case '11': //monitoreo plano control
                                    if (s.url == '/dashboard_cliente' || s.url == '/mantenimiento' || s.url == '/consumo_v2' || s.url == '/dashboardConsumo' || s.url == '/puntosFacturacion'  || s.url == '/help' || s.url == '/monitoreo-plano') {
                                        return s.sidebarMeta;
                                    };
                                    break;
                                
                            }

                        })
                        .map(function(s) {
                            /*var meta = s.sidebarMeta;
                                  return {
                                    name: s.name,
                                    title: s.title,
                                    level: (s.name.match(/\./g) || []).length,
                                    order: meta.order,
                                    icon: meta.icon,
                                    stateRef: s.name,
                                  }*/
                            switch ($localStorage.rol) {
                                case '0':
                                case '5': //Cliente
                                case '12': //coordinador producción
                                    if (s.url == '/dashboard_cliente' || s.url == '/estadisticas_c' || s.url == '/historial' || s.url == '/mantenimiento' || s.url == '/consumo_v2' || s.url == '/dashboardConsumo' || s.url == '/puntosFacturacion' || s.url == '/ofertas_c' || s.url == '/alerts' || s.url == '/help') {
                                    //if (s.url == '/dashboard_cliente' || s.url == '/estadisticas_c' || s.url == '/historial' || s.url == '/mantenimiento' || s.url == '/consumo' || s.url == '/ofertas_c' || s.url == '/alerts' || s.url == '/help') {

                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                                case '1': //Operador
                                    if (s.url == '/dashboard_op' || s.url == '/ofertas' || s.url == '/generar' || s.url == '/historial_op') {
                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                                case '2': //Administrador
                                    if (s.url == '/dashboard_admin' || s.url == '/instaladores' || s.url == '/clientes' || s.url == '/operador' || s.url == '/zona' || s.url == '/dispositivo' || s.url == '/facturacion' || s.url == '/estadisticas' || s.url == '/generar' || s.url == '/valor_kwh') {
                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                                case '3': //Instalador
                                    //if (s.url == '/proyectos' || s.url == '/help') {
                                    if (s.url == '/dashboard_instalador' || s.url == '/help') {
                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                                case '4': //Consumo
                                    if (s.url == '/dashboard_consumo' || s.url == '/consumo_zona') {
                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                                case '6': //Monitoreo
                                case '8': //Coordinador
                                    if (s.url == '/dashboard_cliente' || s.url == '/estadisticas_c' || s.url == '/historial' || s.url == '/mantenimiento' || s.url == '/consumo_v2' || s.url == '/dashboardConsumo' || s.url == '/puntosFacturacion' || s.url == '/ofertas_c' || s.url == '/alerts' || s.url == '/help' || s.url == '/monitoring' || s.url == '/tickets' || s.url == '/tecnicos' || s.url == '/informes' || s.url == '/monitoreo-plano' || (s.url == '/consumo_energetico' && $localStorage.rol === '6')) {
                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                                case '7': //Técnico
                                    if (s.url == '/dashboard_cliente' || s.url == '/estadisticas_c' || s.url == '/historial' || s.url == '/mantenimiento' || s.url == '/consumo_v2' || s.url == '/dashboardConsumo' || s.url == '/puntosFacturacion' || s.url == '/ofertas_c' || s.url == '/alerts' || s.url == '/help' || s.url == '/monitoring' || s.url == '/tickets' ) {
                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                                case '9': //Monitoreo plano
                                    if (s.url == '/monitoreo-plano' ) {
                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                                case '10': //Monitoreo plano visualización
                                    if (s.url == '/dashboard_cliente' || s.url == '/monitoreo-plano' ) {
                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                                case '11': //Monitoreo plano control
                                    if (s.url == '/dashboard_cliente' || s.url == '/mantenimiento' || s.url == '/consumo_v2' || s.url == '/dashboardConsumo' || s.url == '/puntosFacturacion'  || s.url == '/help' || s.url == '/monitoreo-plano' ) {
                                        var meta = s.sidebarMeta;
                                        return {
                                            name: s.name,
                                            title: s.title,
                                            level: (s.name.match(/\./g) || []).length,
                                            order: meta.order,
                                            icon: meta.icon,
                                            stateRef: s.name,
                                        };
                                    }
                                    break;
                            }

                        })
                        .sort(function(a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        };

    }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('baSidebarToggleMenu', baSidebarToggleMenu)
        .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
        .directive('baSidebarTogglingItem', baSidebarTogglingItem)
        .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
        .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
        .directive('baUiSrefToggler', baUiSrefToggler);

    /** @ngInject */
    function baSidebarToggleMenu(baSidebarService) {
        return {
            restrict: 'A',
            link: function(scope, elem) {
                elem.on('click', function($evt) {
                    $evt.originalEvent.$sidebarEventProcessed = true;
                    //$evt.$sidebarEventProcessed = true;
                    scope.$apply(function() {
                        baSidebarService.toggleMenuCollapsed();
                    });
                });
            }
        };
    }

    /** @ngInject */
    function baSidebarCollapseMenu(baSidebarService) {
        return {
            restrict: 'A',
            link: function(scope, elem) {
                elem.on('click', function($evt) {
                    $evt.originalEvent.$sidebarEventProcessed = true;
                    //$evt.$sidebarEventProcessed = true;
                    if (!baSidebarService.isMenuCollapsed()) {
                        scope.$apply(function() {
                            baSidebarService.setMenuCollapsed(true);
                        });
                    }
                });
            }
        };
    }

    /** @ngInject */
    function baSidebarTogglingItem() {
        return {
            restrict: 'A',
            controller: 'BaSidebarTogglingItemCtrl'
        };
    }

    /** @ngInject */
    function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
        var vm = this;
        var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
        if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
            vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
            vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

            var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

            vm.$expand = function() {
                vm.$$expandSubmenu();
                $element.addClass('ba-sidebar-item-expanded');
            };

            vm.$collapse = function() {
                vm.$$collapseSubmenu();
                $element.removeClass('ba-sidebar-item-expanded');
            };

            vm.$toggle = function() {
                $element.hasClass('ba-sidebar-item-expanded') ?
                    vm.$collapse() :
                    vm.$expand();
            };

            if (_isState($state.current)) {
                $element.addClass('ba-sidebar-item-expanded');
            }

            $scope.$on('$stateChangeStart', function(event, toState) {
                if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
                    vm.$collapse();
                    $element.removeClass('ba-sidebar-item-expanded');
                }
            });

            $scope.$on('$stateChangeSuccess', function(event, toState) {
                if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
                    vm.$expand();
                    $element.addClass('ba-sidebar-item-expanded');
                }
            });
        }

        function _isState(state) {
            return state && subItemsStateRefs.some(function(subItemState) {
                return state.name.indexOf(subItemState) == 0;
            });
        }
    }

    /** @ngInject */
    function baUiSrefTogglingSubmenu($state) {
        return {
            restrict: 'A',
            require: '^baSidebarTogglingItem',
            link: function(scope, el, attrs, baSidebarTogglingItem) {
                baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
                baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
            }
        };
    }

    /** @ngInject */
    function baUiSrefToggler(baSidebarService) {
        return {
            restrict: 'A',
            require: '^baSidebarTogglingItem',
            link: function(scope, el, attrs, baSidebarTogglingItem) {
                el.on('click', function() {
                    if (baSidebarService.isMenuCollapsed()) {
                        // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
                        // This should not affect mobiles, because on mobiles sidebar should be hidden at all
                        scope.$apply(function() {
                            baSidebarService.setMenuCollapsed(false);
                        });
                        baSidebarTogglingItem.$expand();
                    } else {
                        baSidebarTogglingItem.$toggle();
                    }
                });
            }
        };
    }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.alerts')
        .directive('alert', alert);
  
    /** @ngInject */
    function alert() {
      return {
        restrict: 'E',
        controller: 'alertCtrl',
        scope: {
          alert: '=alert'
        },
        templateUrl: 'app/cliente/alerts/alert/alert.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.alerts')
        .controller('alertCtrl', alertCtrl);

    /** @ngInject */
    function alertCtrl($scope, RESTServices, $localStorage, ngDialog, $rootScope, SHAREServices, $state) {

        $scope.devices = SHAREServices.devices;
        $scope.oneAtATime = true;
        $scope.status = {
            open: false,
        };

        $scope.itemsPerPage = 5;
        $scope.currentPage = 1;
        
        $scope.showNotifications = function(alert){
            $scope.status.open = !$scope.status.open;

            if($scope.status.open){
                RESTServices.fetchAlertNotificationsV2(alert.id).then(function(data) {
                    if (data != null) {
                        if (data.code == '200') {
                            var notifications = data.notificaciones.map(function(not) {
                                return ({
                                    date: SHAREServices.dateToLocal(not.fecha,2,1,false), 
                                    time: SHAREServices.dateToLocal(not.fecha,2,1,true),
                                    device: $scope.devices.find(function(device){
                                        return device.id == not.id_dispositivo
                                    })
                                })
                            })
                            alert.notifications = notifications;
                        }else{
                            //console.log("error en respuesta")
                        }
                    }else{
                        //console.log("no hay respuesta")
                    }  
                })
            }
            
        }

        $scope.activeAlert = function(alert){
            var items = [{ id: alert.id, estado: alert.status == false ? '1' : '0' }];
            RESTServices.setAlertsStateV2(items).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        $scope.alert.status = !$scope.alert.status; 
                    }else{
                       //console.log("error en respuesta")
                    }
                }else{
                   //console.log("no hay respuesta")
                }  

            });
        }

        $scope.deleteAlert = function(alert){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = "¿Deseas borrar esta alerta?";
                    
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
                    $scope.aceptar = function() {                                    
                        RESTServices.deleteAlertsV2([alert.id]).then(function(data) {
                            if (data != null) {
                                if (data.code == '200') {
                                    $rootScope.$broadcast('AlertDelected', {data: alert});
                                    ngDialog.close();                                     
                                }else{
                                   //console.log("error en respuesta")
                                }
                            }else{
                               //console.log("no hay respuesta")
                            }  
            
                        });
                    }
                }]
            })
        }

        $scope.editAlert = function(alert){
            $state.go('alerts.newAlert', {editMode: true, alert: alert})
            //$rootScope.$broadcast('editAlert', {data: alert});
        }


    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.alerts')
        .directive('newAlert', newAlert);
  
    /** @ngInject */
    function newAlert($rootScope) {
      return {
        restrict: 'E',
        controller: 'newAlertCtrl',
        templateUrl: 'app/cliente/alerts/new-alert/new-alert.html',
      };
    }
})();
(function () {
  "use strict";

  angular
    .module("BlurAdmin.cliente.alerts")
    .controller("newAlertCtrl", newAlertCtrl);

  /** @ngInject */
  function newAlertCtrl(
    $scope,
    $rootScope,
    $localStorage,
    RESTServices,
    utilities,
    SHAREServices,
    $stateParams,
    alertsServices,
    toastr,
    $state,
    ngDialog,
    AutoServices,
    $window,
    $filter,
  ) {
    var noDevisesMsg;
    var zone_before = "";
    $scope.zones = [];
    $scope.zone = {
      name: "",
      id_pais: null,
    };
    var id_pais = null;
    $scope.intermittence = 0;
    $scope.intermittenceDays = [0, 1, 2, 3, 4, 5, 6];

    //$scope.devices = SHAREServices.devices;
    $scope.$on("$viewContentLoaded", function () {
      noDevisesMsg = document.querySelector("#no_devices_message");
      if (SHAREServices.devices.length > 0) {
        noDevisesMsg.style.display = "none";
      } else {
        noDevisesMsg.style.display = "block";
      }
      $scope.zone.name = $stateParams.zona.nombre;
      $scope.zone.id_pais = $stateParams.zona.id_pais;
      id_pais = $scope.zone.id_pais;
      if ($scope.editMode === false) {
        $scope.devicesInZone($scope.zone.name);
      }
    });

    $scope.interestDevices = [];
    $scope.alertsDetails = [];
    $scope.open = false;
    $scope.editMode = $stateParams.editMode;
    $scope.alertType = $stateParams.type;
    $scope.options = {
      open: false,
    };
    if ($stateParams.type) {
      $scope.openSegments =
        $stateParams.type.type === "7"
          ? alertsServices.getPresenceSegments()
          : alertsServices.getOpenSegments();
    }
    $scope.standBySegments = alertsServices.getStandBySegments();
    $scope.repeatAlertSegments = alertsServices.getRepeatAlertSegments();
    $scope.observation = alertsServices.getObservationSegments();
    if ($scope.alertType)
      $scope.unit = alertsServices.setUnit($scope.alertType.name);
    $scope.emailsDisponibles = [];
    $scope.setPointsSegmentsControl = [];
    $scope.newAlert = {
      id: null,
      name: null,
      type: null,
      interval: {},
      selectedDevices: null,
      interestedUsers: [],
      repeatAlert: null,
      standBy: null,
      status: true,
      alerts: [],
      observation: {
        type: "",
        days: [0, 1, 2, 3, 4, 5, 6],
      },
      email: true,
      control_en_off: true,
      comparacion: false,
      comparador: {
        id: 0,
        id_dispositivo: null,
      },
      feriado: "0", ////0 se ejecuta siempre sin importar si es festivo //// 1 solo ejecuta cuando es festivo //// 2 solo cuando no es festivo
      ids_feriados: [],
    };
    $scope.controlFunction = [];
    $scope.set_point = [];
    $scope.id_dispositivo;
    if ($stateParams.zona) {
      $scope.zone.name = $stateParams.zona.nombre;
      $scope.zone.id_pais = $stateParams.zona.id_pais;
      id_pais = $scope.zone.id_pais;
      //$scope.devicesInZone($scope.zone.name);
    }

    function setComparador(ind, comparador) {
      if (ind.id_comparison) {
        return {
          id: comparador.id,
          id_dispositivo: ind.id_comparison,
        };
      } else {
        return null;
      }
    }

    $scope.addAlert = function (newAlert) {
      function setControlFunction(index) {
        if ($scope.controlFunction.length > 0) {
          return {
            id: $scope.controlFunction[index].id
              ? $scope.controlFunction[index].id
              : 0,
            id_dispositivo: $scope.controlFunction[index].id_dispositivo,
            set_point: $scope.controlFunction[index].set_point,
            tipo: $scope.controlFunction[index].tipo,
          };
        } else {
          return null;
        }
      }
      if (newAlert.observation.days.length === 0)
        newAlert.observation.days = [0, 1, 2, 3, 4, 5, 6];

      var alertas = [];
      newAlert.alerts.forEach(function (alert, i) {
        var item;
        if (
          alert.selectedDevices.tipo === "9" &&
          $scope.alertType.name === "Potencia" &&
          $scope.editMode === false
        ) {
          for (var j = 0; j < 3; j++) {
            item = {
              id: newAlert.id ? newAlert.id : "0",
              nombre: alert.name,
              dispositivos: alert.selectedDevices.id,
              min:
                newAlert.interval.type == 0 || newAlert.interval.type == 2
                  ? alert.selectedDevices.offset
                    ? newAlert.interval.min -
                      parseFloat(alert.selectedDevices.offset)
                    : newAlert.interval.min
                  : null,
              max:
                newAlert.interval.type == 0 || newAlert.interval.type == 1
                  ? alert.selectedDevices.offset
                    ? newAlert.interval.max -
                      parseFloat(alert.selectedDevices.offset)
                    : newAlert.interval.max
                  : null,
              t_espera: newAlert.standBy,
              t_repeticion: newAlert.repeatAlert,
              correos: alert.interestedUsers.join(),
              estado: newAlert.status == true ? "1" : "0",
              tipo: 27 + j,
              control:
                setControlFunction(i) === null
                  ? null
                  : setControlFunction(i).id_dispositivo
                    ? setControlFunction(i)
                    : null,
              offset: new Date().getTimezoneOffset(),
              dias: $scope.newAlert.observation.days.join(),
              h_ini: newAlert.observation.h_ini
                ? $filter("date")(newAlert.observation.h_ini, "HH:mm:ss")
                : "00:00:00",
              h_fin: newAlert.observation.h_fin
                ? $filter("date")(newAlert.observation.h_fin, "HH:mm:ss")
                : "23:59:59",
              email: newAlert.email === true ? "1" : "0",
              grupo: null,
              control_en_off: newAlert.control_en_off === true ? "1" : "0",
              comparacion: newAlert.comparacion === true ? "1" : "0",
              comparador: setComparador(alert, newAlert.comparador),
              feriado: newAlert.feriado,
              ids_feriados: setHolidays($scope.holidays),
            };
            alertas.push(item);
          }
        } else {
          item = {
            id: newAlert.id ? newAlert.id : "0",
            nombre: alert.name,
            dispositivos: alert.selectedDevices.id,
            min:
              newAlert.interval.type == 0 || newAlert.interval.type == 2
                ? alert.selectedDevices.offset
                  ? newAlert.interval.min -
                    parseFloat(alert.selectedDevices.offset)
                  : newAlert.interval.min
                : null,
            max:
              newAlert.interval.type == 0 || newAlert.interval.type == 1
                ? alert.selectedDevices.offset
                  ? newAlert.interval.max -
                    parseFloat(alert.selectedDevices.offset)
                  : newAlert.interval.max
                : null,
            t_espera: newAlert.standBy,
            t_repeticion: newAlert.repeatAlert,
            correos: alert.interestedUsers.join(),
            estado: newAlert.status == true ? "1" : "0",
            tipo: $scope.alertType.type,
            control:
              setControlFunction(i) === null
                ? null
                : setControlFunction(i).id_dispositivo
                  ? setControlFunction(i)
                  : null,
            offset: new Date().getTimezoneOffset(),
            dias: $scope.newAlert.observation.days.join(),
            h_ini: newAlert.observation.h_ini
              ? $filter("date")(newAlert.observation.h_ini, "HH:mm:ss")
              : "00:00:00",
            h_fin: newAlert.observation.h_fin
              ? $filter("date")(newAlert.observation.h_fin, "HH:mm:ss")
              : "23:59:59",
            email: newAlert.email === true ? "1" : "0",
            grupo: null,
            control_en_off: newAlert.control_en_off === true ? "1" : "0",
            comparacion: newAlert.comparacion === true ? "1" : "0",
            comparador: setComparador(alert, newAlert.comparador),
            feriado: newAlert.feriado,
            ids_feriados: setHolidays($scope.holidays),
          };
          alertas.push(item);
        }
      });
      RESTServices.saveAlertsV2(alertas).then(function (data) {
        if (data.code == "200") {
          $state.go("alerts");
          if ($scope.editMode) {
            toastr.success("Se ha editado la alerta correctamente", "Alertas");
          } else {
            toastr.success("Se ha creado la alerta correctamente", "Alertas");
          }
        } else {
          $state.go("alerts");
          toastr.error("Ha ocurrido un error inesperado", "Alertas");
        }
      });
    };

    function setHolidays(holidays) {
      var ids = [];
      if (holidays) {
        var selected = holidays.filter(function (h) {
          return h.status === true;
        });
        if (selected.length > 0) {
          selected.forEach(function (s) {
            ids.push(s.id);
          });
        }
      }
      return ids.length > 0 ? ids.join() : null;
    }

    $scope.setComparisonInterval = function (ind) {
      if (ind === true) {
        $scope.newAlert.interval.type = 1;
      } else {
        $scope.newAlert.interval.type = 0;
      }
    };

    $scope.devicesInZone = function (zone) {
      if (
        $scope.editMode === false &&
        $scope.zone.name !== "" &&
        $scope.newAlert.alerts.length > 0
      ) {
        ngDialog.open({
          template: "app/cliente/dashboard-cliente/templates/confirmacion.html",
          className: "ngdialog-theme-plain modal-add-device",
          scope: $scope,
          controller: [
            "$scope",
            function ($scope) {
              $scope.bodyModal = "¿Deseas cambiar de zona?";
              $scope.sumary = "Esta acción borrará las alertas ya creadas";
              $scope.cancelar = function () {
                ngDialog.close();
                $scope.zone.name = zone_before;
              };
              $scope.aceptar = function () {
                ngDialog.close();
                $scope.newAlert.alerts = [];
                $scope.devices = [];
                $scope.alertsDetails.splice(0, $scope.alertsDetails.length);
                $scope.devices = SHAREServices.devices.filter(function (d) {
                  return d.nombre_zona === zone;
                });
                $scope.devicesControl = $scope.devices.filter(function (d) {
                  return (
                    d.tipo == "0" ||
                    d.tipo == "1" ||
                    d.tipo == "2" ||
                    d.tipo == "3" ||
                    d.tipo == "4" ||
                    d.tipo == "33"
                  );
                });
                $rootScope.$broadcast("setDevices", {
                  devices: $scope.devices,
                });
              };
            },
          ],
        });
      } else {
        $scope.devices = [];
        $scope.devices = SHAREServices.devices.filter(function (d) {
          return d.nombre_zona === zone;
        });
        $scope.devicesControl = $scope.devices.filter(function (d) {
          return (
            d.tipo == "0" ||
            d.tipo == "1" ||
            d.tipo == "2" ||
            d.tipo == "3" ||
            d.tipo == "4" ||
            d.tipo == "29" ||
            d.tipo == "32" ||
            d.tipo == "33"
          );
        });

        zone_before = $scope.zone.name;
      }
    };

    $scope.filterDevices = function (type) {
      switch (type) {
        case "10": //temperatura
          $scope.interestDevices = $scope.devices.filter(function (device) {
            return (
              device.tipo == "6" ||
              device.tipo == "12" ||
              device.tipo == "13" ||
              device.tipo == "15" ||
              device.tipo == "28" ||
              device.tipo == "30" ||
              device.tipo == "4" ||
              device.tipo == "32" ||
              device.tipo == "33"
            );
          });
          break;
        case "11": //humedad
          $scope.interestDevices = $scope.devices.filter(function (device) {
            return (
              device.tipo == "6" || device.tipo == "28" || device.tipo == "30"
            );
          });
          break;
        case "12": //flujo
        case "13": //presión
          $scope.interestDevices = $scope.devices.filter(function (device) {
            return device.tipo == "12" || device.tipo == "18";
          });
          break;
        case "4": //presión pRack
          $scope.interestDevices = $scope.devices.filter(function (device) {
            return device.tipo == "14";
          });
          break;
        case "27": //potencia fase 1
        case "28": //potencia fase 2
        case "29": //potencia fase 3
        case "102": //potencia
        case "101": //potencia
          $scope.interestDevices = $scope.devices.filter(function (device) {
            return (
              device.tipo == "0" ||
              device.tipo == "2" ||
              device.tipo == "3" ||
              device.tipo == "5" ||
              device.tipo == "9" ||
              device.tipo == "13"
            );
          });
          break;
        case "3": //apertura y cierre
          $scope.interestDevices = $scope.devices.filter(function (device) {
            return (
              device.tipo == "0" || device.tipo == "1" || device.tipo == "20"
            );
          });
          break;
        case "15": //offiline
          $scope.interestDevices = $scope.devices;
          break;
        case "7": //presencia
          $scope.interestDevices = $scope.devices.filter(function (device) {
            return device.tipo == "21";
          });
          break;
        case "45": //Calidad del aire
        case "46": //Calidad del aire
        case "47": //Calidad del aire
        case "48": //Calidad del aire
        case "49": //Calidad del aire
        case "50": //Calidad del aire
          $scope.interestDevices = $scope.devices.filter(function (device) {
            return device.tipo == "28";
          });
          break;
      }
    };

    $scope.openAccordion = function (i) {
      $scope.alertsDetails[i].open = !$scope.alertsDetails[i].open;
    };
    if ($scope.editMode) {
      $scope.newAlert = $stateParams.alert;
      $scope.alertType = $stateParams.alert.type;
      $scope.alertsDetails = [
        {
          name: $scope.newAlert.name,
          selectedDevices: $scope.newAlert.selectedDevices,
          interestedUsers: $scope.newAlert.interestedUsers,
          id_device: $scope.newAlert.selectedDevices.id,
          id_comparison: $scope.newAlert.comparador
            ? $scope.newAlert.comparador.id_dispositivo
            : null,
          name_comparison: $scope.newAlert.comparador
            ? $scope.newAlert.comparador.device_name
            : null,
        },
      ];
      $scope.newAlert.interval.min =
        $scope.newAlert.interval.min === null
          ? null
          : $scope.newAlert.offset_temp
            ? $scope.newAlert.interval.min +
              parseFloat($scope.newAlert.offset_temp)
            : $scope.newAlert.interval.min;
      $scope.newAlert.interval.max =
        $scope.newAlert.interval.max === null
          ? null
          : $scope.newAlert.offset_temp
            ? $scope.newAlert.interval.max +
              parseFloat($scope.newAlert.offset_temp)
            : $scope.newAlert.interval.max;
      $scope.controlFunction = [];
      if ($scope.newAlert.control) {
        $scope.controlFunction.push($scope.newAlert.control);
        switch ($scope.controlFunction[0].tipo) {
          case "0":
          case "1":
            $scope.setPointsSegmentsControl = alertsServices.onOffControl;
            break;
          case "2":
          case "3":
          case "4":
          case "32":
          case "33":
            $scope.setPointsSegmentsControl = alertsServices.commandControl;
            break;
          case "29":
            $scope.setPointsSegmentsControl =
              alertsServices.wind_CurtainControl;
            break;
        }
      }
      $scope.id_dispositivo =
        $scope.newAlert.control == null
          ? null
          : $scope.newAlert.control.id_dispositivo;
      $scope.newAlert.alerts = [];
      $scope.intermittence = 1;
      if ($stateParams.alert.feriado === "1") {
        $scope.newAlert.observation.type = "holidays";
      } else if ($stateParams.alert.feriado === "2") {
        $scope.newAlert.observation.type = "no_holidays";
      } else {
        $scope.newAlert.observation.type = "custom";
        $scope.intermittenceDays = setIntermittenceDays(
          $stateParams.alert.observation.days,
        );
      }
      //$scope.newAlert.observation.type = 'custom';
      $scope.newAlert.alerts.push($scope.alertsDetails[0]);
      //$scope.intermittenceDays = setIntermittenceDays($stateParams.alert.observation.days);
      $scope.newAlert.observation.h_ini = new Date(
        "2021-07-12" + " " + $scope.newAlert.observation.h_ini,
      );
      $scope.newAlert.observation.h_fin = new Date(
        "2021-07-12" + " " + $scope.newAlert.observation.h_fin,
      );
      //$scope.zone.name = $scope.newAlert.selectedDevices.nombre_zona;
      $scope.devicesInZone($scope.zone.name);
      $scope.newAlert.email = $scope.newAlert.email === "1" ? true : false;
      $scope.newAlert.control_en_off =
        $scope.newAlert.control_en_off === "1" ? true : false;
      $scope.newAlert.comparacion =
        $scope.newAlert.comparacion === "1" ? true : false;
      $scope.openSegments =
        $stateParams.alert.type.type === "7"
          ? alertsServices.getPresenceSegments()
          : alertsServices.getOpenSegments();
      $scope.open =
        $scope.newAlert.interval.min == "1" &&
        $scope.newAlert.interval.max == null
          ? "0"
          : $scope.newAlert.interval.max == "0" &&
              $scope.newAlert.interval.min == null
            ? "1"
            : "";
      if ($stateParams.alert.feriado === "1") {
        getHolidays($scope.editMode, $stateParams.alert.ids_feriados);
      }
    }

    function setIntermittenceDays(days) {
      var d = [false, false, false, false, false, false, false];
      days.forEach(function (v) {
        d[v] = true;
      });
      return d;
    }

    $scope.cancelar = function () {
      $state.go("alerts");
    };

    $scope.showOptions = function () {
      $scope.options.open = !$scope.options.open;
    };

    $scope.addDevices = function (alert, editMode, index) {
      if ($scope.zone === undefined) {
        toastr.warning("Primero debes escoger una zona", "Recuerda");
      } else {
        ngDialog.open({
          template:
            "app/cliente/alerts/templates/agregarDispositivosAlertas.html",
          className: "ngdialog-theme-plain modal-add-device",
          scope: $scope,
          controller: [
            "$scope",
            function ($scope) {
              $scope.filterDevices($scope.alertType.type);
              if (editMode) {
                $scope.addDevice = Object.assign({}, alert);
                $scope.interestDevicesComparison = Array.from(
                  $scope.interestDevices,
                );
              } else {
                $scope.addDevice = {
                  name: null,
                  selectedDevices: null,
                  interestedUsers: [],
                  id_device: null,
                  open: false,
                  id_comparison: null,
                  name_comparison: null,
                };
              }

              $scope.set_type = function (id) {
                var d = $scope.interestDevices.filter(function (i) {
                  return i.id === id;
                })[0];
                $scope.interestDevicesComparison =
                  $scope.interestDevices.filter(function (i) {
                    return i.id !== id;
                  });

                if ($scope.alertType.name === "Potencia") {
                  if (d.tipo === "3") {
                    $scope.alertType.type = "101";
                  } else {
                    $scope.alertType.type = "102";
                  }
                }
              };

              $scope.getUsersAvailables = function (devices) {
                var promesas = devices.map(function (d) {
                  return RESTServices.fetchZoneUsersV2(d.id_zona);
                });

                Promise.all(promesas)
                  .then(function (data) {
                    //console.log(data)
                    data.forEach(function (itm) {
                      if (itm.code === "200") {
                        itm.users.forEach(function (u) {
                          $scope.emailsDisponibles.push(u.email);
                        });
                      }
                    });
                  })
                  .catch(function (error) {
                    //console.log(error)
                  });
              };
              $scope.cancelar = function () {
                ngDialog.close();
              };

              $scope.validateName = function (name) {
                var index = $scope.alertsDetails.findIndex(function (a) {
                  return a.name === name;
                });
                if (index === -1) {
                  $scope.invalidName = false;
                } else {
                  $scope.invalidName = true;
                }
              };

              $scope.aceptar = function () {
                var d = $scope.interestDevices.filter(function (i) {
                  return i.id === $scope.addDevice.id_device;
                })[0];
                if ($scope.addDevice.id_comparison) {
                  $scope.addDevice.name_comparison =
                    $scope.interestDevices.filter(function (i) {
                      return i.id === $scope.addDevice.id_comparison;
                    })[0].nombre;
                }
                $scope.addDevice.selectedDevices = d;
                if (editMode) {
                  $scope.alertsDetails[index] = $scope.addDevice;
                  $scope.newAlert.alerts[index] = $scope.addDevice;
                } else {
                  $scope.alertsDetails.push($scope.addDevice);
                  $scope.newAlert.alerts.push($scope.addDevice);
                }
                ngDialog.close();
              };
            },
          ],
        });
      }
    };
    $scope.deleteAlert = function (index) {
      $scope.alertsDetails.splice(index, 1);
      $scope.newAlert.alerts.splice(index, 1);
    };
    $scope.selectSetPoint = function (id, index) {
      var device = $scope.devicesControl.filter(function (d) {
        return d.id == id;
      })[0];
      $scope.devicesControl.filter(function (d) {
        return d.id != id;
      });
      $scope.controlFunction[index].tipo = device.tipo;
      if (
        $scope.controlFunction.findIndex(function (d) {
          return d.id_dispositivo === id;
        }) === -1
      ) {
        $scope.controlFunction[index].deviceControlError = false;
        $scope.controlFunction[index].id_dispositivo = id;
        switch (device.tipo) {
          case "0":
          case "1":
            $scope.setPointsSegmentsControl = alertsServices.onOffControl;
            break;
          case "2":
          case "3":
          case "4":
          case "32":
          case "33":
            $scope.setPointsSegmentsControl = alertsServices.commandControl;
            break;
          case "29":
            $scope.setPointsSegmentsControl =
              alertsServices.wind_CurtainControl;
            break;
        }
      } else {
        $scope.controlFunction[index].deviceControlError = true;
      }
      validateDeviceControlError();
    };
    function validateDeviceControlError() {
      if (
        $scope.controlFunction.find(function (c) {
          return c.deviceControlError === true;
        })
      ) {
        $scope.deviceControlError = true;
      } else {
        $scope.deviceControlError = false;
      }
    }

    $scope.setObservationDays = function (type, days) {
      switch (type) {
        case "custom":
        case "no_holidays":
          if (type === "custom") {
            $scope.newAlert.feriado = "0";
          } else {
            $scope.newAlert.feriado = "2";
          }

          days = days.map(function (o, i) {
            if (o === true) {
              return i;
            } else {
              return false;
            }
          });
          $scope.newAlert.observation.days = days.filter(function (o) {
            return o !== false;
          });
          break;
        case "holidays":
          $scope.newAlert.feriado = "1";
          getHolidays($scope.editMode);
          break;
      }
    };
    function getHolidays(ind, feriados) {
      var currentYear = new Date().getFullYear();
      var nextYear = currentYear + 1;
      var allyears = [];
      allyears.push(currentYear, nextYear);

      var promesas = allyears.map(function (year) {
        var params = {
          id_usuario: $localStorage.id_usuario,
          id_pais: id_pais,
          year: year,
        };

        return RESTServices.post_header(
          "cliente/consulta_festivos.php",
          params,
          SHAREServices.hash_decode_token($localStorage.token),
          true,
        );
      });

      Promise.all(promesas)
        .then(function (data) {
          var allHolidays = [];
          data.forEach(function (item) {
            if (item.code === "200") {
              allHolidays = allHolidays.concat(item.festivos);
            } else {
              allHolidays = [];
            }
          });
          $scope.holidays = allHolidays;
          if (ind) {
            $scope.holidays.map(function (h) {
              if (feriados.includes(h.id)) {
                h.status = true;
              }
            });
          } else {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            $scope.holidays = allHolidays.filter(function (f) {
              var date = new Date(f.day);
              date.setHours(0, 0, 0, 0); // También ajustamos la hora de la fecha del arreglo
              return date >= today;
            });
            $scope.holidays.map(function (h) {
              h.status = true;
            });
            $scope.holidays.sort(function (a, b) {
              if (a.day > b.day) {
                return 1;
              }
              if (a.day < b.day) {
                return -1;
              }
              return 0;
            });
            $scope.$apply();
          }
        })
        .catch(function (error) {
          //console.log(error)
        });
    }

    $scope.enableMail = function (status) {
      //console.log(status)
    };

    $scope.$on("$destroy", function () {
      ngDialog.close();
    });

    $scope.$on("setDevices", function (event, result) {
      $scope.controlFunction = [];
      $scope.setControlFunction = [];
      $scope.devices = result.devices;
      $scope.devicesControl = $scope.devices.filter(function (d) {
        return (
          d.tipo == "0" ||
          d.tipo == "1" ||
          d.tipo == "2" ||
          d.tipo == "3" ||
          d.tipo == "4" ||
          d.tipo == "29" ||
          d.tipo == "32" ||
          d.tipo == "33"
        );
      });
    });

    $scope.setOpening = function (ind) {
      //cero es abierto
      //uno es cerrado
      $scope.newAlert.interval.type = 0;
      if (ind == "0") {
        $scope.newAlert.interval.min = 1;
        $scope.newAlert.interval.max = null;
      } else {
        $scope.newAlert.interval.min = null;
        $scope.newAlert.interval.max = 0;
      }
    };
  }
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.alerts')
        .controller('offlineAlertCtrl', offlineAlertCtrl)
        
    /** @ngInject */
    function offlineAlertCtrl($scope, $localStorage, RESTServices, SHAREServices, $stateParams, alertsServices, toastr, $state, $filter, AutoServices) {
        
        $scope.loading = false;
        $scope.noInfo = false;
        $scope.validatedList = false;
        $scope.select_all = false;
        $scope.newAlert = {
            id: null,
            name: null,
            type: null,
            interval: {},
            selectedDevices: null,
            interestedUsers: [],
            repeatAlert: null,
            standBy: null,
            status: true,
            alerts: [],
            observation: {
                type: '',
                days: [0,1,2,3,4,5,6],
            },
            limit: null,
        };
        var observation_days = [0,1,2,3,4,5,6];
        $scope.standBySegments = alertsServices.getStandBySegments();
        $scope.repeatAlertSegments = alertsServices.getRepeatAlertSegments();
        $scope.openSegments = alertsServices.getOpenSegments();
        $scope.comunicacionSegments = alertsServices.getComunicacionSegments();
        $scope.setPointsSegmentsControl = alertsServices.commandControl;
        $scope.filtered = [];
        $scope.controlFunction = [];
        $scope.devicesControl = [];


        if($stateParams.zona === null) {
            $state.go('alerts');
        } else {
            $scope.zona = $stateParams.zona;
        }
        
        
        if ($stateParams.editMode) {
            $scope.edit_mode = true;
            var selectedDevices = $stateParams.alert.selectedDevices;
            $scope.newAlert = $stateParams.alert;
            if ($stateParams.alert.type.min_name === 'limit'){
                $scope.newAlert.limit = $stateParams.alert.interval.min.toString();
                selectedDevices.status = true;
                $scope.filtered.push(selectedDevices);
            } else {
                $scope.devices = SHAREServices.devices.filter(function(d){return d.tipo !== '11'});
                selectedDevices.map(function(i){i.status = true});
                $scope.devices.forEach(function(d) {
                    var index = selectedDevices.findIndex(function(i) { return i.id === d.id})
                    if(index === -1) {
                        d.status = false;
                        selectedDevices.push(d)
                    }
                });
                $scope.filtered = Array.from(selectedDevices);  
            }
            $scope.validatedList = true;
            $scope.alertType = $stateParams.alert.type;
            if ($scope.alertType.min_name === 'Comm') {
                $scope.newAlert.comunicacionEstado = $stateParams.alert.interval.min !== null ? $stateParams.alert.interval.min.toString() : null;
            }
            if ($scope.alertType.min_name === 'Open' && $stateParams.alert.control) {
                $scope.devicesControl = SHAREServices.devices.filter(function(d){
                    return d.tipo == "0" || d.tipo == "1" || d.tipo == "2" || d.tipo == "3" || d.tipo == "4";
                });
                $scope.controlFunction = [{
                    id: $stateParams.alert.control.id,
                    id_dispositivo: $stateParams.alert.control.id_dispositivo,
                    set_point: $stateParams.alert.control.set_point,
                    tipo: $stateParams.alert.control.tipo,
                }];
            }
            
        } else {
            $scope.zona = $stateParams.zona;
            $scope.alertType = $stateParams.type;
            if (!$scope.alertType) {
                $state.go('alerts');
                return;
            }
            if ($scope.alertType.min_name === 'Open') {
                $scope.devices = SHAREServices.devices.filter(function(d){return d.tipo == "0" || d.tipo == "1" || d.tipo == "20"});
                $scope.devicesControl = SHAREServices.devices.filter(function(d){
                    return d.tipo == "0" || d.tipo == "1" || d.tipo == "2" || d.tipo == "3" || d.tipo == "4";
                });
                $scope.controlFunction = [{}];
            } else if($scope.alertType.min_name === 'limit') {
                $scope.devices = SHAREServices.devices.filter(function(d){return d.tipo == "2" || d.tipo == "3" || d.tipo == "4"});
                $scope.newAlert.interestedUsers.push($localStorage.email)
            } else if ($scope.alertType.min_name === 'Comm') {
                $scope.devices = SHAREServices.devices.filter(function(d){return d.tipo == "33"});
            } else if ($scope.alertType.min_name === 'Error') {
                $scope.devices = SHAREServices.devices.filter(function(d){return d.tipo == "32"});
            } else {
                $scope.devices = SHAREServices.devices.filter(function(d){return d.tipo !== '11'});
            }
            $scope.devices.map(function(i){i.status = false});
            $scope.filtered = Array.from($scope.devices);
            if ($scope.devices.length === 0) $scope.noInfo = true;
        }
        
        
        
        $scope.selectAll = function(flag) {
            if(flag) {
                $scope.devices.map(function(i){i.status = true})
            } else {
                $scope.devices.map(function(i){i.status = false})
            }
            $scope.validateList();
        }

        $scope.search = function(buscar) {
            if (buscar === '') {
                $scope.filtered = Array.from($scope.devices);
            } else {
                $scope.filtered = $filter('filter')($scope.devices, buscar );
                $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            }
        }

        $scope.validateList = function(){
            var index = $scope.devices.findIndex(function(i){return i.status === true});
            if(index >= 0) {
                $scope.validatedList = true;
            } else {
                $scope.validatedList = false;
            }
            
        }

        $scope.crear = function(newAlert) {
            $scope.loading = true;
            var selected;
            selected = $scope.devices.filter(function(i){return i.status === true});
            var alertas = [];
            var codigo = generarCodigo();
            if ($scope.edit_mode && $stateParams.alert.type.min_name !== 'limit') {
                var noDevices = compararArreglosPorId(selected, $stateParams.alert.selectedDevices);
                var noAlerts = alertasNoSeleccionadas(noDevices, $stateParams.alert.nestedAlerts);
                if (noAlerts.length > 0){
                    deleteAlerts(noAlerts);
                }
            }
            selected.forEach(function(device, index) {
                if ($scope.alertType.min_name === 'Offline') {
                    var item = {
                        "id": newAlert.id ? getIdAlert(device.id, $stateParams.alert.nestedAlerts) : '0',
                        //"nombre": $scope.zona.nombre + ' - ' + 'DESCONEXIÓN' + ' ' + device.nombre,
                        "nombre": newAlert.name,
                        "dispositivos": device.id,
                        "min": 1,
                        "max": null,
                        "t_espera": newAlert.standBy,
                        "t_repeticion": newAlert.repeatAlert,
                        "correos": newAlert.interestedUsers.join(),
                        "estado": '1',
                        "tipo": '15',
                        "control": null,
                        "offset": (new Date()).getTimezoneOffset(),
                        "dias": observation_days.join(),
                        "h_ini": '00:00:00',
                        "h_fin": '23:59:59',
                        "email": '1',
                        "grupo": newAlert.grupo ? newAlert.grupo : codigo,
                    }
                    alertas.push(item);
                } else if($scope.alertType.min_name === 'Open') {
                    var controlData = null;
                    if ($scope.controlFunction.length > 0 && $scope.controlFunction[index] && $scope.controlFunction[index].id_dispositivo) {
                        controlData = {
                            "id": $scope.controlFunction[index].id || 0,
                            "id_dispositivo": $scope.controlFunction[index].id_dispositivo,
                            "set_point": $scope.controlFunction[index].set_point,
                            "tipo": $scope.controlFunction[index].tipo,
                        };
                    }
                    var item = {
                        "id": newAlert.id ? newAlert.id : '0',
                        "nombre": $scope.zona.nombre + ' - ' + 'MONITOREO MULETILLA' + ' ' + device.nombre,
                        "dispositivos": device.id,
                        "min": newAlert.interval.type == 0 || newAlert.interval.type == 2 ? newAlert.interval.min : null,
                        "max": newAlert.interval.type == 0 || newAlert.interval.type == 1 ? newAlert.interval.max : null,
                        "t_espera": newAlert.standBy,
                        "t_repeticion": newAlert.repeatAlert,
                        "correos": newAlert.interestedUsers.join(),
                        "estado": '1',
                        "tipo": '3',
                        "control": controlData,
                        "offset": (new Date()).getTimezoneOffset(),
                        "dias": observation_days.join(),
                        "h_ini": '00:00:00',
                        "h_fin": '23:59:59',
                        "email": '1',
                        "grupo": null,
                    }
                    alertas.push(item);
                } else if ($scope.alertType.min_name === 'Comm') {
                    var item = {
                        "id": newAlert.id ? getIdAlert(device.id, $stateParams.alert.nestedAlerts) : '0',
                        "nombre": $scope.zona.nombre + ' - ' + 'COMUNICACIÓN' + ' ' + device.nombre,
                        "dispositivos": device.id,
                        "min": parseInt(newAlert.comunicacionEstado, 10),
                        "max": null,
                        "t_espera": newAlert.standBy,
                        "t_repeticion": newAlert.repeatAlert,
                        "correos": newAlert.interestedUsers.join(),
                        "estado": '1',
                        "tipo": '58',
                        "control": null,
                        "offset": (new Date()).getTimezoneOffset(),
                        "dias": observation_days.join(),
                        "h_ini": '00:00:00',
                        "h_fin": '23:59:59',
                        "email": '1',
                        "grupo": newAlert.grupo ? newAlert.grupo : codigo,
                    }
                    alertas.push(item);
                } else if ($scope.alertType.min_name === 'Error') {
                    var item = {
                        "id": newAlert.id ? getIdAlert(device.id, $stateParams.alert.nestedAlerts) : '0',
                        "nombre": $scope.zona.nombre + ' - ' + 'ERROR' + ' ' + device.nombre,
                        "dispositivos": device.id,
                        "min": null,
                        "max": 0,
                        "t_espera": newAlert.standBy,
                        "t_repeticion": newAlert.repeatAlert,
                        "correos": newAlert.interestedUsers.join(),
                        "estado": '1',
                        "tipo": '59',
                        "control": null,
                        "offset": (new Date()).getTimezoneOffset(),
                        "dias": observation_days.join(),
                        "h_ini": '00:00:00',
                        "h_fin": '23:59:59',
                        "email": '1',
                        "grupo": newAlert.grupo ? newAlert.grupo : codigo,
                    }
                    alertas.push(item);
                } else if ($scope.alertType.min_name === 'limit') {
                    var item = {
                        "id": newAlert.id ? newAlert.id : '0',
                        "nombre": 'LIMITE DE SETPOINT INFERIOR' + ' ' + device.nombre,
                        "dispositivos": device.id,
                        "min": AutoServices.getControl(device.tipo, newAlert.limit).id,
                        "max": null,
                        "t_espera": "1",
                        "t_repeticion": "1",
                        "correos": newAlert.interestedUsers.join(),
                        "estado": '1',
                        "tipo": '1',
                        "control": {
                            "id": newAlert.control ? newAlert.control.id : 0,
                            "id_dispositivo": device.id,
                            "set_point": newAlert.limit,
                            "tipo": device.tipo,
                        },
                        "offset": (new Date()).getTimezoneOffset(),
                        "dias": observation_days.join(),
                        "h_ini": '00:00:00',
                        "h_fin": '23:59:59',
                        "email": '0',
                        "grupo": null,
                    }
                    alertas.push(item);
                }
                
            })
            RESTServices.saveAlertsV2(alertas).then(function(data) {
                if (data.code == '200') {
                    $scope.loading = false;
                    $state.go('alerts');
                    toastr.success( $scope.edit_mode ? 'Se ha editado la alerta correctamente' : 'Se ha creado la alerta correctamente', 'Alertas')                    
                }else{
                    $scope.loading = false;
                    $state.go('alerts');
                    toastr.error('Ha ocurrido un error inesperado', 'Alertas')
                }
            })
           
        }

        $scope.back = function() {
            $state.go('alerts')
        }

        function generarCodigo() {
            var codigo = "";
            var caracteres = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            var longitudCodigo = 20;
            
            for (var i = 0; i < longitudCodigo; i++) {
              codigo += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
            }
            
            return codigo;
        }

        $scope.setOpening = function(ind) {
            //cero es abierto
            //uno es cerrado
            $scope.newAlert.interval.type = 0;
            if(ind == '0') {
                $scope.newAlert.interval.min = 1;
                $scope.newAlert.interval.max = null;
            } else {
                $scope.newAlert.interval.min = null;
                $scope.newAlert.interval.max = 0;
            }
        }

        $scope.selectSetPoint = function(id, index) {
            var device = $scope.devicesControl.filter(function(d){ return d.id == id; })[0];
            $scope.controlFunction[index].tipo = device.tipo;
            $scope.controlFunction[index].deviceControlError = false;
            $scope.controlFunction[index].id_dispositivo = id;
            switch (device.tipo) {
                case "0":
                case "1":
                    $scope.setPointsSegmentsControl = alertsServices.onOffControl;
                    break;
                case "2":
                case "3":
                case "4":
                    $scope.setPointsSegmentsControl = alertsServices.commandControl;
                    break;
            }
        }

        function compararArreglosPorId(nuevo, original) {
            var idsNuevo = nuevo.map(function(obj) { return obj.id});
            var dispositivosNoEncontrados = original.filter(function(obj) {return !idsNuevo.includes(obj.id)} );
            return dispositivosNoEncontrados;
        }

        function alertasNoSeleccionadas(devices, alertas) {
            var idsDevices = devices.map(function(obj) { return obj.id});
            var alertasNoSeleccionadas = alertas.filter(function(obj) {return idsDevices.includes(obj.dispositivos)} );
            return alertasNoSeleccionadas;
        }

        function getIdAlert(id_device, alertas) {
            var id_alerta = '0';
            var alerta = alertas.filter(function(alert) {return alert.dispositivos === id_device});
            if (alerta.length > 0){
                id_alerta = alerta[0].id; 
            } 
            return id_alerta;
        }

        function deleteAlerts(alerts) {
            var ids = alerts.map(function(a) {
                return a.id;
            })

            RESTServices.deleteAlertsV2(ids).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                                                             
                    }else{
                        toastr.error('Hubo un problema inesperado');
                    }
                }else{
                    toastr.error('Hubo un problema inesperado'); 
                } 
            });
        }

    };

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.alerts')
        .directive('offlineAlert', offlineAlert);
  
    /** @ngInject */
    function offlineAlert($rootScope) {
      return {
        restrict: 'E',
        controller: 'offlineAlertCtrl',
        templateUrl: 'app/cliente/alerts/offline-alert/offline-alert.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.alerts')
        .controller('quickEditAlertCtrl', quickEditAlertCtrl)
        
    /** @ngInject */
    function quickEditAlertCtrl($scope, $localStorage, RESTServices, SHAREServices, $stateParams, alertsServices, toastr, $state, $filter, ngDialog ) {
        
        $scope.loading = false;
        $scope.noInfo = false;
        $scope.validatedList = false;
        var useOpening = false;
        var usedSetPoint = false;
        var usedSetControl = false;
        var noItem = [
            {
                text: "",
                value: '',
            }
        ] 
        $scope.select_ind = 'Seleccionar por';
        $scope.listaOrden = ['todos', 'control', 'control sin apertura y cierre', 'monitoreo', 'monitoreo sin apertura y cierre', 'temperatura', 'presión PSI', 'presión pRack', 'potencia', 'humedad', 'apertura y cierre', 'presencia', 'comunicación', 'ninguno'];
        $scope.newAlert = {
            id: null,
            name: null,
            type: null,
            interval: {
                type: 0, 
                min: null, 
                max: null
            },
            selectedDevices: null,
            interestedUsers: [],
            removeUsers: [],
            open: '',
            repeatAlert: null,
            standBy: null,
            status: 3,
            alerts: [],
            observation: {
                type: '',
                days: [],
            },
            email: 2,
            control_en_off: 2,
            setPoint_control: null,
            control_type: 0,
            feriado: 0, ////0 se ejecuta siempre sin importar si es festivo //// 1 solo ejecuta cuando es festivo //// 2 solo cuando no es festivo
            ids_feriados: null,
        };
        $scope.standBySegments = alertsServices.getStandBySegments();
        $scope.standBySegments = $scope.standBySegments.concat(noItem);
        $scope.repeatAlertSegments = alertsServices.getRepeatAlertSegments();
        $scope.repeatAlertSegments = $scope.repeatAlertSegments.concat(noItem);
        $scope.openSegments = alertsServices.getOpenSegments();
        $scope.openSegments = $scope.openSegments.concat(noItem);
        $scope.observation = alertsServices.getObservationSegments();
        $scope.observation = $scope.observation.concat(noItem);
        $scope.intermittenceDays = [0,1,2,3,4,5,6];
        $scope.mensaje = "";
        $scope.setPoint_controls = [];
        
        if($stateParams.alerts === null) {
            $state.go('alerts');
        } else {
            $scope.alerts = $stateParams.alerts.filter(function(a) {return a.grupo === null});
            $scope.alerts = $scope.alerts.map(function(alert){
                alert.max_with_offset = alert.max === null ? null : alert.offset_temp ? parseFloat(alert.max) + parseFloat(alert.offset_temp) : parseFloat(alert.max);
                alert.min_with_offset = alert.min === null ? null : alert.offset_temp ? parseFloat(alert.min) + parseFloat(alert.offset_temp) : parseFloat(alert.min);
                return alert;
            })
            $scope.filtered = Array.from($scope.alerts);
        }

        $scope.selectAll = function(type) {
            $scope.select_ind = type;
            if (type === 'todos') {
                $scope.alerts.map(function(i){i.status = true})
            } else if (type === 'control') {
                $scope.alerts.map(function(i){i.status = false});
                $scope.alerts.map(function(a) {
                    if(a.control !== null) {
                        a.status = true
                    }
                })
            } else if (type === 'control sin apertura y cierre') {
                $scope.alerts.map(function(i){i.status = false});
                $scope.alerts.map(function(a) {
                    if(a.control !== null && a.tipo !== '3') {
                        a.status = true
                    }
                })
            } else if (type === 'monitoreo') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.control === null) {
                        a.status = true
                    }
                })
            } else if (type === 'monitoreo sin apertura y cierre') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.control === null && a.tipo !== '3') {
                        a.status = true
                    }
                })
            } else if (type === 'temperatura') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.tipo === '10') {
                        a.status = true
                    }
                })
            } else if (type === 'humedad') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.tipo === '11') {
                        a.status = true
                    }
                })
            } else if (type === 'presión PSI') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.tipo === '13') {
                        a.status = true
                    }
                })
            } else if (type === 'presión pRack') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.tipo === '4') {
                        a.status = true
                    }
                })
            } else if (type === 'potencia') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.tipo === '101' || a.tipo === '102' || a.tipo === '27' || a.tipo === '28' || a.tipo === '29') {
                        a.status = true
                    }
                })
            } else if (type === 'apertura y cierre') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.tipo === '3') {
                        a.status = true
                    }
                })
            } else if (type === 'presencia') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.tipo === '7') {
                        a.status = true
                    }
                })    
            } else if (type === 'comunicación') {
                $scope.alerts.map(function(i){i.status = false})
                $scope.alerts.map(function(a) {
                    if(a.tipo === '58') {
                        a.status = true
                    }
                })
            } else if (type === 'ninguno') {
                $scope.alerts.map(function(i){i.status = false})
            }
            
            $scope.validateList();
        }

        $scope.search = function(buscar) {
            if (buscar === '') {
                $scope.filtered = Array.from($scope.alerts);
            } else {
                $scope.filtered = $filter('filter')($scope.alerts, buscar );
                $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            }
        }

        $scope.validateList = function(){
            var index = $scope.alerts.findIndex(function(i){return i.status === true});
            if(index >= 0) {
                $scope.validatedList = true;
            } else {
                $scope.validatedList = false;
            }
            
        }

        $scope.editar = function(newAlert) {
            var selected = $scope.alerts.filter(function(i){return i.status === true});
            var alertas = [];
            if(newAlert.status === '2') {
                showDelectDialog(selected);
            } else {
                if (validarAlertas(selected)) {
                    if (newAlert.open !== '') {
                        $scope.setOpening(newAlert.open)
                    }
                    $scope.loading = true;
                    selected.forEach(function(alert) {
                        if(alert.control){
                            alert.control.set_point = $scope.newAlert.setPoint_control ? $scope.newAlert.setPoint_control : alert.control.set_point;
                        }
                        var item = {
                            "id": alert.id,
                            "nombre": $scope.newAlert.sufijo ? alert.nombre + ' - ' + $scope.newAlert.sufijo : alert.nombre,
                            "dispositivos": alert.dispositivos,
                            "min": calcularMin(alert, $scope.newAlert),
                            "max": calcularMax(alert, $scope.newAlert),
                            "t_espera": newAlert.standBy !== null ? (newAlert.standBy !== '' ? newAlert.standBy : alert.t_espera) : alert.t_espera,
                            "t_repeticion": newAlert.repeatAlert !== null ? (newAlert.repeatAlert !== '' ?  newAlert.repeatAlert : alert.t_repeticion) : alert.t_repeticion,
                            "correos": addMails(alert.correos, newAlert.interestedUsers, newAlert.removeUsers),
                            "estado": newAlert.status === 3 ? alert.estado : newAlert.status,
                            "tipo": alert.tipo,
                            "control": alert.control,
                            "offset": alert.offset,
                            "dias": $scope.newAlert.observation.days.length > 0 ? $scope.newAlert.observation.days.join() : alert.dias,
                            "h_ini": newAlert.observation.h_ini ? $filter('date')(newAlert.observation.h_ini, 'HH:mm:ss') : alert.h_ini,
                            "h_fin": newAlert.observation.h_fin ? $filter('date')(newAlert.observation.h_fin, 'HH:mm:ss') : alert.h_fin,
                            "email": newAlert.email === 2 ? alert.email : newAlert.email,
                            "grupo": alert.grupo,
                            "control_en_off": newAlert.control_en_off === 2 ? alert.control_en_off : newAlert.control_en_off,
                            "comparacion": alert.comparacion,
                            "comparador": alert.comparador,
                            "feriado": alert.feriado,
                            "ids_feriados": alert.ids_feriados,
                        }
                        alertas.push(item);
                        
                    })
                    RESTServices.saveAlertsV2(alertas).then(function(data) {
                        if (data.code == '200') {
                            $scope.loading = false;
                            $state.go('alerts');
                            toastr.success('Se han editado las alertas correctamente', 'Alertas')
                        }else{
                            $scope.loading = false;
                            $state.go('alerts');
                            toastr.error('Ha ocurrido un error inesperado', 'Alertas')
                        }
                    })
                } else {
                    showInfoDialog();
                    $scope.loading = false;
                    return false
                }
            }             
        }

        $scope.back = function() {
            $state.go('alerts')
        }
        function calcularMin(alert, newAlert) {
            if (newAlert.interval.type === "0" || newAlert.interval.type === "2") {
                if (newAlert.open !== '') {
                    return newAlert.interval.min;
                }
                if (newAlert.interval.min !== null) {
                    return alert.offset_temp
                        ? newAlert.interval.min - parseFloat(alert.offset_temp)
                        : newAlert.interval.min;
                }
            }
            return alert.min;
        }
        
        function calcularMax(alert, newAlert) {
            if (newAlert.interval.type === "0" || newAlert.interval.type === "1") {
                if (newAlert.open !== '') {
                    return newAlert.interval.max;
                }
                if (newAlert.interval.max !== null) {
                    return alert.offset_temp
                        ? newAlert.interval.max - parseFloat(alert.offset_temp)
                        : newAlert.interval.max;
                }
            }
            return alert.max;
        }

        function addMails(mails, interestedUsers, removeUsers) {
            var correos = mails.split(",");
            if (interestedUsers.length > 0) {
                var correosNuevos = compararArreglos(interestedUsers, correos);
                correos = correos.concat(correosNuevos)
            }
            if (removeUsers.length > 0) {
                removeUsers.forEach(function(user) {
                    var index = correos.findIndex(function(c) {return c === user})
                    if (index > -1) {
                        correos.splice(index, 1);
                    }
                }) 
            }

            return correos.join();
        }

        function compararArreglos(original, nuevos) {
            var correosNoEncontrados = original.filter(function(obj) {return !nuevos.includes(obj)} );
            return correosNoEncontrados;
        }

        $scope.setOpening = function(ind) {
            //cero es abierto
            //uno es cerrado
            if(ind !== ''){
                $scope.newAlert.interval.type = 0;
                useOpening = true;
                if(ind == '0') {
                    $scope.newAlert.interval.min = 1;
                    $scope.newAlert.interval.max = null;
                } else {
                    $scope.newAlert.interval.min = null;
                    $scope.newAlert.interval.max = 0;
                }
            } else {
                useOpening = false;
            }
        }

        function validarAlertas(alerts) {
            if (useOpening) {
                var index = alerts.findIndex(function(alert) {
                    return alert.tipo !== '3';
                });
                if (index >= 0) {
                    $scope.mensaje = "Vas a editar el indicador de apertura y cierre y has seleccionado alertas que no corresponden con ese tipo.";
                    return false;
                }
                if (usedSetPoint) {
                    $scope.mensaje = "No se puede editar simultáneamente las opciones de operación y de apertura y cierre.";
                    return false;
                }
                return true;
            }
        
            if (usedSetPoint) {
                var index = alerts.findIndex(function(alert) {
                    return alert.tipo === '3';
                });
                if (index >= 0) {
                    $scope.mensaje = "Las opciones de operación no se pueden aplicar a las alertas de apertura y cierre. Debes excluir estas alertas para continuar.";
                    return false;
                }
                return true;
            }

            if(usedSetControl) {
                var validControlTypes = {
                    '1': function(alert) {
                        return ['0', '1'].includes(alert.control.tipo);
                    },
                    '2': function(alert) {
                        return ['2', '3', '4'].includes(alert.control.tipo);
                    },
                    '3': function(alert) {
                        return alert.control.tipo === '29';
                    }
                };
        
                var isValid = alerts.every(function(alert) {
                    if(alert.control) {
                        if (validControlTypes[$scope.newAlert.control_type](alert)) {
                            return true;
                        }
                    }
                    $scope.mensaje = "Este tipo de control no se puede aplicar a estas alertas";
                    return false;
                });
        
                return isValid;
            }
        
            return true;
        }
        
        $scope.validarSetPoint = function(ind1, ind2) {
            if(ind1 !== null || ind2 !== null){
                usedSetPoint = true;
            } else {
                usedSetPoint = false;
            }  
        }

        function showInfoDialog() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/mensaje.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.titleModal = "No puedes realizar estos cambios";
                    $scope.bodyModal = $scope.mensaje;
                    $scope.close = function() {
                        ngDialog.close();
                    };
                }]
            })
        }

        function deleteAlerts(alerts) {
            $scope.loading = true;
            var ids = alerts.map(function(a) {
                return a.id;
            })

            RESTServices.deleteAlertsV2(ids).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        toastr.success('Alerta Borrada');
                        $state.go('alerts');  
                        $scope.loading = false;                         
                    }else{
                        toastr.error('Hubo un problema inesperado'); 
                    }
                }else{
                    toastr.error('Hubo un problema inesperado'); 
                }
            });
        }

        function showDelectDialog(alerts) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = "¿Deseas borrar este conjunto de alertas?";

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
                    $scope.aceptar = function() {  
                        deleteAlerts(alerts);
                        ngDialog.close();
                    }
                }]
            })
        }

        $scope.$on("$destroy", function () {
            ngDialog.close();
        });

        $scope.setObservationDays = function(type, days) {
            switch(type){
                case '':
                    $scope.newAlert.observation.days = [];
                    break;
                case 'dayly':
                    $scope.newAlert.observation.days = [0,1,2,3,4,5,6];
                    break;
                case 'weekly':
                    $scope.newAlert.observation.days = [1,2,3,4,5];
                    break;
                case 'weekendly':
                    $scope.newAlert.observation.days = [6,0];
                    break;
                case 'custom':
                    days = days.map(function(o, i){
                        if(o === true) {
                            return i;
                        } else {
                            return false;
                        }
                    });
                    $scope.newAlert.observation.days = days.filter(function(o){ return o !== false})
                    break;
            }
        }

        $scope.duplicar = function(newAlert) {
            var selected = $scope.alerts.filter(function(i){return i.status === true});
            var alertas = [];
            if(newAlert.status === '2') {
                showDelectDialog(selected);
            } else {
                if (validarAlertas(selected)) {
                    if (newAlert.open !== '') {
                        $scope.setOpening(newAlert.open)
                    }
                    $scope.loading = true;
                    selected.forEach(function(alert) {
                        if(alert.control){
                            alert.control.id = '0';
                            alert.control.set_point = $scope.newAlert.setPoint_control ? $scope.newAlert.setPoint_control : alert.control.set_point;
                        }
                        var item = {
                            "id": '0',
                            "nombre": $scope.newAlert.sufijo ? alert.nombre + ' - ' + $scope.newAlert.sufijo : alert.nombre,
                            "dispositivos": alert.dispositivos,
                            "min": calcularMin(alert, $scope.newAlert),
                            "max": calcularMax(alert, $scope.newAlert),
                            "t_espera": newAlert.standBy !== null ? (newAlert.standBy !== '' ? newAlert.standBy : alert.t_espera) : alert.t_espera,
                            "t_repeticion": newAlert.repeatAlert !== null ? (newAlert.repeatAlert !== '' ?  newAlert.repeatAlert : alert.t_repeticion) : alert.t_repeticion,
                            "correos": addMails(alert.correos, newAlert.interestedUsers, newAlert.removeUsers),
                            "estado": newAlert.status === 3 ? alert.estado : newAlert.status,
                            "tipo": alert.tipo,
                            "control": alert.control,
                            "offset": alert.offset,
                            "dias": $scope.newAlert.observation.days.length > 0 ? $scope.newAlert.observation.days.join() : alert.dias,
                            "h_ini": newAlert.observation.h_ini ? $filter('date')(newAlert.observation.h_ini, 'HH:mm:ss') : alert.h_ini,
                            "h_fin": newAlert.observation.h_fin ? $filter('date')(newAlert.observation.h_fin, 'HH:mm:ss') : alert.h_fin,
                            "email": newAlert.email === 2 ? alert.email : newAlert.email,
                            "grupo": alert.grupo,
                            "control_en_off": newAlert.control_en_off === 2 ? alert.control_en_off : newAlert.control_en_off,
                            "comparacion": alert.comparacion,
                            "comparador": alert.comparador,
                            "feriado": alert.feriado,
                            "ids_feriados": alert.ids_feriados,
                        }
                        alertas.push(item);
                        
                    })
                    RESTServices.saveAlertsV2(alertas).then(function(data) {
                        if (data.code == '200') {
                            $scope.loading = false;
                            $state.go('alerts');
                            toastr.success('Se han editado las alertas correctamente', 'Alertas')
                        }else{
                            $scope.loading = false;
                            $state.go('alerts');
                            toastr.error('Ha ocurrido un error inesperado', 'Alertas')
                        }
                    })
                } else {
                    showInfoDialog();
                    $scope.loading = false;
                    return false
                }
            }             
        }

        $scope.changeSetPointControl = function(ind){
            switch (ind) {
                case "0":
                    $scope.newAlert.setPoint_control = null; 
                    $scope.setPoint_controls = [];
                    usedSetControl = false;
                    break;
                case "1":
                    $scope.setPoint_controls = alertsServices.onOffControl; 
                    usedSetControl = true;
                    break;
                case "2":
                    $scope.setPoint_controls = alertsServices.commandControl;
                    usedSetControl = true;
                    break;
                case "3":
                    $scope.setPoint_controls = alertsServices.wind_CurtainControl;
                    usedSetControl = true;
                    break;
            }
        }
        

        



    };

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.alerts')
        .directive('quickEditAlert', quickEditAlert);
  
    /** @ngInject */
    function quickEditAlert($rootScope) {
      return {
        restrict: 'E',
        controller: 'quickEditAlertCtrl',
        templateUrl: 'app/cliente/alerts/quick-edit/quick-edit.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('consumoDispositivoCtrl', consumoDispositivoCtrl);

    /** @ngInject */

    function consumoDispositivoCtrl($scope, $stateParams, consumoServices, RESTServices, $filter, $localStorage, $timeout, SHAREServices, $state) {
        $scope.tabs = $stateParams.dispositivo.tipo === '16' ? consumoServices.tabsHeloE : consumoServices.tabsConsumo;
        $scope.active = 'energy';
        $scope.unit = 'KWh';
        $scope.$on('tabConsumo', function(event, result){
            $scope.active = result.data.type;
            $scope.unit = result.data.unit;
        });
        
    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('dashboardConsumoCtrl', dashboardConsumoCtrl);

    /** @ngInject */

    function dashboardConsumoCtrl($scope, RESTServices, $filter, $localStorage, $timeout, SHAREServices, $state, consumoServices, $rootScope) {
        delete $localStorage.id_zona;
        $scope.consumo_total = [];
        $scope.zonas = [];


        $timeout(function(){
            var params = {
                "id_usuario": $localStorage.id_usuario,
            };
            ////query zonas
            RESTServices.fetchClientZones().then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        if(data.zonas) {
                            $scope.zonas = data.zonas;
                        } 
                        if(data.zonas_externas) {
                            $scope.zonas = $scope.zonas.concat(data.zonas_externas)
                        }
                        $scope.zonas = $filter('orderBy')($scope.zonas, 'nombre');
                        $scope.zonas = $filter('filter')($scope.zonas, {h : '0'});
                        $rootScope.$broadcast('devicesConsumption', {zonas: $scope.zonas});
                    }
                }
            })
        });

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('estadisticasFacturacionCtrl', estadisticasFacturacionCtrl);

    /** @ngInject */

    function estadisticasFacturacionCtrl($scope, consumoServices, RESTServices, $filter, $localStorage, $timeout, SHAREServices, $state) {
        
        $scope.tabs = consumoServices.tabsFacturacion;
        //$scope.active = 'value';
        // $scope.$on('tabConsumo', function(event, result){
        //     $scope.active = result.data.type;
        // });
    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('facturaCtrl', facturaCtrl);

    /** @ngInject */

    function facturaCtrl($scope, consumoServices, RESTServices, $filter, $localStorage, $timeout, SHAREServices, $state, $stateParams, $window) {
        
        $scope.noInfo = false;
        $scope.loading = false;
        if ($stateParams.factura) {
            $scope.factura = $stateParams.factura;
        } else {
            $state.go('consumption.puntoFacturacion');
        }
        
        var chart;

        function getInfoFactura() {
            //chart.data = [];
            var factura = {
                id: $stateParams.factura.id,
                id_punto_facturacion: $stateParams.factura.id_punto_facturacion,
                fecha_ini: $stateParams.factura.dia_ini,
            };

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_punto_facturacion": $stateParams.factura.id_punto_facturacion,
                "factura": JSON.stringify(factura),
            };

            RESTServices.post_header('cliente/consulta_factura.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.punto != undefined) {
                        $scope.factura = Object.assign($scope.factura, response.punto);
                    } 
                    if (response.historico != undefined) {
                        response.historico.map(function(h){
                            h.mes = new Date(h.mes);
                            h.fecha = $filter('date')(h.mes, 'MMM y');
                        });
                        createGraphic();
                        chart.data = response.historico;
                        successfulResponse();
                    } else {
                        //createGraphic();
                        noInfo();
                    }
                }

            })
        };

        getInfoFactura();

        function createGraphic() {

            am4core.useTheme(am4themes_animated);
            am4core.options.autoDispose = true;

            // Create chart instance
            chart = am4core.create("grafica_consumos", am4charts.XYChart);

            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "month",
                "count": 1
            };

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 30;

            // Create series
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.dateX = "mes";
            series.dataFields.valueY = "consumo_kwh";
            

            series.name = "Histórico Consumo";
            series.columns.template.tooltipHTML = "Fecha: <strong>{fecha}</strong><br>Valor KWh: <strong>{precio_kwh}</strong><br>Consumo: <strong>{consumo_kwh} KWh</strong><br>Valor: <strong>${valor}</strong>";
            series.columns.template.fillOpacity = .8;
            series.columns.template.events.on("hit", function(ev) {
                $scope.clickedInd = ev.target.dataItem.dataContext;
                $scope.$apply();
            }, this);

            var columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;
        }

        $scope.imprimir = function() {
            $window.print();
        };

        function noInfo() {
            //chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
        }


    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('facturacionCtrl', facturacionCtrl);

    /** @ngInject */

    function facturacionCtrl($scope, RESTServices, $filter, $localStorage, $timeout, SHAREServices, $state, $stateParams, consumoServices) {

        //$scope.facturas = [];
        if ($stateParams.id || $stateParams.punto || consumoServices.id_punto_facturacion || consumoServices.punto_facturacion) {
            consumoServices.id_punto_facturacion = $stateParams.id ? $stateParams.id : consumoServices.id_punto_facturacion;
            consumoServices.punto_facturacion = $stateParams.punto ? $stateParams.punto : consumoServices.punto_facturacion;
        } else {
            $state.go('consumption.puntoFacturacion');
        }
        consumoServices.id_punto_facturacion = $stateParams.id ? $stateParams.id : consumoServices.id_punto_facturacion;
        consumoServices.punto_facturacion = $stateParams.punto ? $stateParams.punto : consumoServices.punto_facturacion;
        $scope.puntos = consumoServices.AllPuntos_facturacion;
        $scope.gotoNuevaFactura = function() {
            $state.go('consumption.nuevaFactura', {id_punto: $stateParams.id ? $stateParams.id : consumoServices.id_punto_facturacion});
        }
        $scope.gotoDatosPuntoFacturacion = function() {
            $state.go('consumption.nuevoPuntoFacturacion', {punto: $stateParams.punto ? $stateParams.punto : consumoServices.punto_facturacion});
        }
        $scope.gotoEstadisticas = function() {
            $state.go('consumption.estadisticasFacturacion', {id_punto: $stateParams.id ? $stateParams.id : consumoServices.id_punto_facturacion});
        }

        function getFacturacion() {
            $scope.facturas = [];
            var ele = document.querySelector('#no_factura');
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_punto_facturacion": $stateParams.id ? $stateParams.id : consumoServices.id_punto_facturacion,
            };
            RESTServices.post_header('cliente/consulta_facturas.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.facturas) {
                        ele.style.display = 'none';
                        response.facturas.map(function(f){
                            var d_i = new Date(f.dia_ini);
                            var t_i = d_i.getTime();
                            var d_f = new Date(f.dia_fin);
                            var t_f = d_f.getTime();
                            var period = t_f - t_i;
                            var days = Math.ceil(period / (1000 * 60 * 60 * 24));
                            f.dias_facturados = days;
                            f.id_punto_facturacion = $stateParams.id ? $stateParams.id : consumoServices.id_punto_facturacion;
                        })
                        $scope.facturas = $filter('orderBy')(response.facturas, '-dia_fin');
                        $scope.ultima_factura = $scope.facturas[0].valor;
                        $scope.costo_actual_kwh = $scope.facturas[0].precio_kwh;
                        $scope.ultimo_consumo = $scope.facturas[0].consumo_kwh;
                    } else {
                        ele.style.display = 'block';
                    }
                } else {
                    ele.style.display = 'block';
                }

            })
        };

        getFacturacion();

        $scope.$on('deleteBill', function(event, result){
            var index = $scope.facturas.findIndex(function(f){ return f.id === result.factura.id});
            $scope.facturas.splice(index, 1);
        });

        $scope.gotoPunto = function(punto) {
            $stateParams.punto = punto;
            $stateParams.id = punto.id;
            $scope.nombre_punto = punto.nombre;
            getFacturacion();
        }

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('facturadoresCtrl', facturadoresCtrl);

    /** @ngInject */

    function facturadoresCtrl($scope, $stateParams, $localStorage, RESTServices, SHAREServices, $timeout, $state) {
        
        $timeout(function(){
            $scope.loading = true;
            $scope.control = $localStorage.rol == 0 || $localStorage.rol == 6 || $localStorage.rol == 8  ? true : false;
            var params = {
                "id_usuario": $localStorage.id_usuario,
            }
            RESTServices.post_header('cliente/consulta_facturador.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.facturadores) {
                        $scope.facturadores = response.facturadores;
                        $scope.loading = false;
                    } else {
                        $state.go('consumption.nofacturador')
                    }
                    
                } else {
                    $state.go('consumption.nofacturador')
                }

            })
        })

        $scope.gotoNuevoFacturador = function() {
            $state.go('consumption.nuevoFacturador');
        }

        $scope.gotoProcesoFacturacion = function() {
            $state.go('consumption.procesoFacturacion');
        }

        $scope.$on('deleteFacturador', function(event, result) {
            var index = $scope.facturadores.findIndex(function(i){return i.id == result.facturador.id});
            $scope.facturadores.splice(index, 1);
            if ($scope.facturadores.length == 0) {
                $state.go('consumption.nofacturador')
            }
        });

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('nuevaFacturaCtrl', nuevaFacturaCtrl);

    /** @ngInject */

    function nuevaFacturaCtrl($scope, RESTServices, $localStorage, $state, toastr, $stateParams, $filter, consumoServices,SHAREServices) {
        $scope.date = {};

        if($stateParams.factura) {
            $scope.editMode = true;
            $scope.nuevaFactura = $stateParams.factura;
            var divisor_1 = $scope.nuevaFactura.dia_ini.split('-');
            var divisor_2 = $scope.nuevaFactura.dia_fin.split('-');
            //$scope.nuevaFactura.dia_ini = $scope.nuevaFactura.dia_ini + ' ' + '00:00:00';
            $scope.date.fecha_ini = new Date(divisor_1[0], divisor_1[1] - 1, divisor_1[2]);
            $scope.date.fecha_final = new Date(divisor_2[0], divisor_2[1] - 1, divisor_2[2]);
            // $scope.date.fecha_ini = new Date('2021', '03', '29');
            // $scope.date.fecha_final = new Date('2021', '04', '15');
            // $scope.date.fecha_ini = new Date($scope.nuevaFactura.dia_ini.replace(/-/g, '\/')+'Z');
            // $scope.date.fecha_final = new Date($scope.nuevaFactura.dia_fin.replace(/-/g, '\/')+'Z');
        }

        $scope.open = function(itm) {
            $scope.popup[itm] = true;
        }

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.popup = {
            opened_1: false,
            opened_2: false
        };
        $scope.crearFactura = function(factura) {
            factura.id = $scope.editMode ? factura.id : 0;
            factura.id_punto_facturacion = factura.id_punto_facturacion ? factura.id_punto_facturacion : $stateParams.id_punto ? $stateParams.id_punto : consumoServices.id_punto_facturacion;
            factura.dia_ini = $filter('date')($scope.date.fecha_ini, 'yyyy-MM-dd');
            factura.dia_fin = $filter('date')($scope.date.fecha_final, 'yyyy-MM-dd');

            var fields = {
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_usuario": $localStorage.id_usuario,
                "factura": JSON.stringify(factura),
            };

            RESTServices.post_header('cliente/edita_factura.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code === '200') {
                    $state.go('consumption.facturacion');
                    toastr.success('Se ha creado una nueva factura', 'Bien Hecho');
                } else {
                    toastr.error('En este momento no tienes comunicación con la plataforma', 'Ha ocurrido un error');
                }
            });
        }
        $scope.cancelar = function(){
            $state.go('consumption.facturacion');
        }
    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('nuevoPuntoFacturacionCtrl', nuevoPuntoFacturacionCtrl);

    /** @ngInject */

    function nuevoPuntoFacturacionCtrl($scope, RESTServices, $localStorage, $state, toastr, $stateParams,SHAREServices) {

        $scope.planConsumo = [{name:'Residencial', id: '1'}, {name:'Comercial', id:'2'}, {name:'Industrial', id:'3'}];
        $scope.estratos = ['1', '2', '3', '4', '5', '6'];
        $scope.devices = [];
        $scope.getStates = function(id) {

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "id_pais": id != undefined ? id : null
            };

            RESTServices.post_header('admin/lista_estados.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.estados = res.estados;
                }
            });
        }

        $scope.getCitys = function(id) {
            
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "id_estado": id != undefined ? id : null
            };
            RESTServices.post_header('admin/lista_ciudades.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.ciudades = res.ciudades;
                }
            });
        }

        function getCountrys() {
            var fields = {
                "id_instalador": $localStorage.id_usuario,
                "id_usuario": $localStorage.id_usuario,
            };

            RESTServices.post_header('admin/lista_paises.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.paises = res.paises;
                }
            });
        }

        if($stateParams.punto) {
            $scope.nuevoPunto = Object.assign($stateParams.punto);
            $scope.nuevoPunto.pais = $scope.nuevoPunto.pais_id;
            $scope.nuevoPunto.estado = $scope.nuevoPunto.estado_id;
            $scope.nuevoPunto.ciudad = $scope.nuevoPunto.ciudad_id;
            getCountrys();
            getDevices();
            $scope.getStates($scope.nuevoPunto.pais);
            $scope.getCitys($scope.nuevoPunto.estado);
            $scope.editMode = true;
            $scope.nuevoPunto.plan = $scope.planConsumo.filter(function(p){ return p.name === $stateParams.punto.plan})[0].id
        } else {
            getCountrys();
            getDevices();
        }

        $scope.crearPuntoFacturacion = function(punto) {
            punto.id = $scope.editMode ? punto.id : 0;
            punto.id_ciudad = punto.ciudad;
            punto.id_totalizador = punto.id_totalizador ? punto.id_totalizador : 0;
            delete punto.ciudad;
            delete punto.pais;
            delete punto.estado;

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "punto": JSON.stringify(punto),
            };

            RESTServices.post_header('cliente/edita_punto_facturacion.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code === '200') {
                    $state.go('consumption.facturacion');
                    toastr.success($scope.editMode ? 'Se ha editar la frontera comercial' : 'Se ha creado una nueva frontera comercial', 'Bien Hecho');
                } else {
                    toastr.error('En este momento no tienes comunicación con la plataforma', 'Ha ocurrido un error');
                }
            });
        }

        function getDevices() {
            var params = {
                "id_usuario": $localStorage.id_usuario,
            };
            RESTServices.post_header('cliente/consulta_dispositivos_totalizador_disponibles.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        $scope.devices = data.dispositivos;
                        if ($stateParams.punto) {
                            var device = {
                                id: $scope.nuevoPunto.id_totalizador,
                                nombre: $scope.nuevoPunto.nombre_totalizador,
                            }
                            $scope.devices.push(device);
                        }
                    } else{
                        if ($stateParams.punto) {
                            var device = {
                                id: $scope.nuevoPunto.id_totalizador,
                                nombre: $scope.nuevoPunto.nombre_totalizador,
                            }
                            $scope.devices.push(device);
                        }
                    }
                } else {
                    //console.log("no hay respuesta")
                }  

            });

            
        }

        $scope.cancelar = function(){
            $state.go('consumption.puntoFacturacion');
        }
    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('procesoFacturacionCtrl', procesoFacturacionCtrl);

    /** @ngInject */

    function procesoFacturacionCtrl($scope) {
        
    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('puntosFacturacionCtrl', puntosFacturacionCtrl);

    /** @ngInject */

    function puntosFacturacionCtrl($scope, RESTServices, consumoServices, $filter, consumoV2Util, $localStorage, $timeout, SHAREServices, $state) {
        
        $scope.loading = true;
        $scope.currentPage = 1;
        $scope.itemsPerPage = 40;
        $scope.puntos = [];
        $scope.filtered = [];
        var paginasSolicitadas = [];
        $scope.control = $localStorage.rol == 0 || $localStorage.rol == 6 || $localStorage.rol == 8  ? true : false;
        $scope.getPoints = function(){
            var item = paginasSolicitadas.findIndex(function(i) {return i === $scope.currentPage})
            if (item === -1) {
                $scope.loading = true;
                paginasSolicitadas.push($scope.currentPage);
                var fields = {
                    id_usuario: $localStorage.id_usuario,
                    pagina: $scope.currentPage,
                    cantidad: $scope.itemsPerPage,
                };
                RESTServices.post_header('cliente/consulta_puntos_facturacion.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                    if (response.code == '200') {
                        if (response.puntos) {
                            $scope.totalItems = response.cantidad_total;
                            response.puntos.map(function(p) {
                                p.plan = consumoV2Util.setPlanFacturacion(p.plan);
                            });
                            $scope.puntos = $scope.puntos.concat(response.puntos);
                            $scope.filtered = $scope.puntos;
                            consumoServices.AllPuntos_facturacion = $scope.puntos;
                            var allFacturacion = response.puntos.map(function(c){ return Number(c.ultima_factura)});
                            $scope.totalFacturacion = allFacturacion.reduce(function(previous, current) { return current += previous});
                            $scope.loading = false;
                        } else {
                            $state.go('consumption.noPunto');
                        }
                        
                    } else {
                        $state.go('consumption.noPunto');
                    }
    
                })
            }

            
            
        }
 
        $timeout(function(){
            $scope.getPoints();
        })
        
        $scope.gotoNuevoPuntoFacturacion = function() {
            $state.go('consumption.nuevoPuntoFacturacion');
        }

        $scope.gotoFacturadores = function() {
            $state.go('consumption.facturadores');
        }

        $scope.$on('deletePoint', function(event, result){
            var index = $scope.puntos.findIndex(function(p){ return p.id === result.punto.id});
            $scope.puntos.splice(index, 1);
        });

        $scope.consultaTotalFacturacion = function(e){
            var fecha = consumoV2Util.changeMonthtoDate(e);
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "fecha": fecha,
            };

            RESTServices.post_header('cliente/consulta_total_mes_cliente.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {

                if (response.code == '200') {
                    if (response.valor) {
                        $scope.totalFacturacion = response.valor;
                    } else {
                        $scope.totalFacturacion = null;
                    }
                }
            })
        }

    }


})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.dashboard_cliente').service('AutoServices', AutoServices);

    /** @ngInject */
    function AutoServices($filter, utilities) {
        return {

            serverDelay: 7,

            format: {
                day: 'yyyy-MM-dd',
                week: 'yyyy-MM-dd',
                month: 'yyyy-MM',
                year: 'yyyy'
            },

            frequencyProgram: [{
                    text: 'Única',
                    value: '1'
                },
                {
                    text: 'Diaria',
                    value: '2'
                },
                {
                    text: 'Semanal',
                    value: '3'
                },
                {
                    text: 'Mensual',
                    value: '4'
                },
            ],

            frequency: [
                {
                    text: 'Única',
                    value: '1'
                },
                {
                    text: 'Diaria',
                    value: '2'
                },
                {
                    text: 'Lunes - Viernes',
                    value: '3'
                },
                {
                    text: 'Fines de semana',
                    value: '4'
                },
                {
                    text: 'Personalizar',
                    value: '5'
                },
                {
                    text: 'Feriado',
                    value: '6'
                },
            ],
            tipos_feriados: [
                {
                    text: 'Siempre',
                    value: '0'
                },
                {
                    text: 'Solo en día feriado',
                    value: '1'
                },
                {
                    text: 'Siempre que no sea feriado',
                    value: '2'
                },
            ],
            intermittenceDays: [
                {
                    text: 'Dom',
                    value: 0,
                    status: false,
                }, 
                {
                    text: 'Lun',
                    value: 1,
                    status: false,
                },
                {
                    text: 'Mar',
                    value: 2,
                    status: false,
                },
                {
                    text: 'Mie',
                    value: 3,
                    status: false,
                },
                {
                    text: 'Jue',
                    value: 4,
                    status: false,
                },
                {
                    text: 'Vie',
                    value: 5,
                    status: false,
                },
                {
                    text: 'Sab',
                    value: 6,
                    status: false,
                },
                 
            ],

            getIntermittenceDays: function() {
                var days = Array.from(this.intermittenceDays);
                days.map(function(d){
                    d.status = false;
                    return d;
                })
                return days;
            },

            automations: [
                {
                    name: 'Aire acondicionado',
                    ind: '0',
                },
                {
                    name: 'On/Off',
                    ind: '1',
                },
                {
                    name: 'Dimmer',
                    ind: '2',
                },
                {
                    name: 'Presión',
                    ind: '3',
                },
                {
                    name: 'Variador Velocidad',
                    ind: '4',
                },
                {
                    name: 'Refrigeración',
                    ind: '5',
                },
                {
                    name: 'Cortina de viento',
                    ind: '6',
                },
            ],
            commandControl: [
                {
                    nombre: '16',
                    id: '9',
                    status: true,
                },
                {
                    nombre: '17',
                    id: '10',
                    status: true,
                },
                {
                    nombre: '18',
                    id: '11',
                    status: true,
                },
                {
                    nombre: '19',
                    id: '12',
                    status: true,
                },
                {
                    nombre: '20',
                    id: '13',
                    status: true,
                },
                {
                    nombre: '21',
                    id: '14',
                    status: true,
                },
                {
                    nombre: '22',
                    id: '15',
                    status: true,
                },
                {
                    nombre: '23',
                    id: '16',
                    status: true,
                },
                {
                    nombre: '24',
                    id: '17',
                    status: true,
                },
                {
                    nombre: '25',
                    id: '18',
                    status: true,
                },
                {
                    nombre: '26',
                    id: '19',
                    status: true,
                },
                {
                    nombre: '27',
                    id: '20',
                    status: true,
                },
                {
                    nombre: '28',
                    id: '21',
                    status: true,
                },
                {
                    nombre: '29',
                    id: '22',
                    status: true,
                },
                {
                    nombre: '30',
                    id: '23',
                    status: true,
                },
                {
                    nombre: 'Apagar',
                    id: '2',
                    status: true,
                },
                {
                    nombre: '23',
                    id: '1',
                    status: false,
                },
            ],

            commandControl_17: [
                {
                    nombre: '17',
                    id: '10',
                    status: true,
                },
                {
                    nombre: '18',
                    id: '11',
                    status: true,
                },
                {
                    nombre: '19',
                    id: '12',
                    status: true,
                },
                {
                    nombre: '20',
                    id: '13',
                    status: true,
                },
                {
                    nombre: '21',
                    id: '14',
                    status: true,
                },
                {
                    nombre: '22',
                    id: '15',
                    status: true,
                },
                {
                    nombre: '23',
                    id: '16',
                    status: true,
                },
                {
                    nombre: '24',
                    id: '17',
                    status: true,
                },
                {
                    nombre: '25',
                    id: '18',
                    status: true,
                },
                {
                    nombre: '26',
                    id: '19',
                    status: true,
                },
                {
                    nombre: '27',
                    id: '20',
                    status: true,
                },
                {
                    nombre: '28',
                    id: '21',
                    status: true,
                },
                {
                    nombre: '29',
                    id: '22',
                    status: true,
                },
                {
                    nombre: '30',
                    id: '23',
                    status: true,
                },
                {
                    nombre: 'Apagar',
                    id: '2',
                    status: true,
                },
                {
                    nombre: '23',
                    id: '1',
                    status: false,
                },
            ],

            commandControl_18: [
                {
                    nombre: '18',
                    id: '11',
                    status: true,
                },
                {
                    nombre: '19',
                    id: '12',
                    status: true,
                },
                {
                    nombre: '20',
                    id: '13',
                    status: true,
                },
                {
                    nombre: '21',
                    id: '14',
                    status: true,
                },
                {
                    nombre: '22',
                    id: '15',
                    status: true,
                },
                {
                    nombre: '23',
                    id: '16',
                    status: true,
                },
                {
                    nombre: '24',
                    id: '17',
                    status: true,
                },
                {
                    nombre: '25',
                    id: '18',
                    status: true,
                },
                {
                    nombre: '26',
                    id: '19',
                    status: true,
                },
                {
                    nombre: '27',
                    id: '20',
                    status: true,
                },
                {
                    nombre: '28',
                    id: '21',
                    status: true,
                },
                {
                    nombre: '29',
                    id: '22',
                    status: true,
                },
                {
                    nombre: '30',
                    id: '23',
                    status: true,
                },
                {
                    nombre: 'Apagar',
                    id: '2',
                    status: true,
                },
                {
                    nombre: '23',
                    id: '1',
                    status: false,
                },
            ],

            modos_termostato: [
                {
                    text: 'Calentar',
                    value: '0',
                    icon: 'icon-aires',
                    status: true,
                    index: 0,
                },
                {
                    text: 'Enfriar',
                    value: '1',
                    icon: 'icon-measurer',
                    status: false,
                    index: 1,
                },
                {
                    text: 'Ventilar',
                    value: '2',
                    icon: 'icon-light',
                    status: false,
                    index: 2,
                },
                {
                    text: 'Sin configurar',
                    value: '4',
                    icon: 'icon-light',
                    status: false,
                    index: 1,
                },
            ],

            velocidad_ventilador: [
                {
                    text: 'Auto',
                    value: '0', 
                    icon: 'icon-aires',
                    status: true,
                    index: 0,
                },
                {
                    text: 'Alta',
                    value: '3',
                    icon: 'icon-measurer',
                    status: false,
                    index: 1,
                },
                {
                    text: 'Media',
                    value: '2', 
                    icon: 'icon-light',
                    status: false,
                    index: 2,
                },
                {
                    text: 'Baja',
                    value: '1', 
                    icon: 'icon-temperature',
                    status: false,
                    index: 3,
                },
                {
                    text: 'Sin configurar',
                    value: '4',
                    icon: 'icon-light',
                    status: false,
                    index: 1,
                },
            ],

            block_termostato : [
                {
                    text: 'Bloquear',
                    value: '1',
                    icon: 'icon-temperature',
                    status: true,
                    index: 0,
                },
                {
                    text: 'Desbloquear',
                    value: '0',
                    icon: 'icon-light',
                    status: false,
                    index: 1,
                },
                {
                    text: 'Sin configurar',
                    value: '4',
                    icon: 'icon-light',
                    status: false,
                    index: 1,
                },
            ],

            selectComandsControl: function(id) {
                switch(id) {
                    case '119':
                    case '120':
                    case '121':
                    case '122':
                    case '123':
                    case '129':
                    case '131':
                    case '133':
                    case '134':
                    case '135':
                    case '137':
                    case '138':
                    case '139':
                    case '140':
                    case '141':
                    case '142':
                    case '143':
                        return this.commandControl;
                    case '124':
                    case '132':
                    case '136':
                    case '144':
                        return this.commandControl_17;
                    case '125':
                    case '126':
                        return this.commandControl_18;
                    default:
                        return this.commandControl_17;
                }
            },

            getCommandsControl: function() {
                var commands = [];
                commands = JSON.parse(JSON.stringify(this.commandControl))
                return commands;
            },

            onOffControl: [
                {
                    nombre: 'Apagar',
                    id: '0',
                    status: true,
                },
                {
                    nombre: 'Encender',
                    id: '1',
                    status: true,
                },
            ],

            wind_CurtainControl: [
                {
                    nombre: 'Apagar',
                    id: '0',
                    status: true,
                },
                {
                    nombre: 'Encender en baja',
                    id: '1',
                    status: true,
                },
                {
                    nombre: 'Encender en alta',
                    id: '2',
                    status: true,
                },
            ],

            mxproControl: [
                {
                    "id":"-200", 
                    "nombre": "-20",
                    status: true,
                }, 
                { 
                    "id":"-190", 
                    "nombre": "-19",
                    status: true,
                }, 
                { 
                    "id":"-180", 
                    "nombre": "-18",
                    status: true,
                }, 
                { 
                    "id":"-170", 
                    "nombre": "-17",
                    status: true,
                }, 
                { 
                    "id":"-160", 
                    "nombre": "-16",
                    status: true,
                }, 
                { 
                    "id":"-150", 
                    "nombre": "-15",
                    status: true,
                }, 
                { 
                    "id":"-140", 
                    "nombre": "-14",
                    status: true,
                }, 
                { 
                    "id":"-130", 
                    "nombre": "-13",
                    status: true,
                }, 
                { 
                    "id":"-120", 
                    "nombre": "-12",
                    status: true,
                }, 
                { 
                    "id":"-110", 
                    "nombre": "-11",
                    status: true,
                }, 
                { 
                    "id":"-100", 
                    "nombre": "-10",
                    status: true,
                }, 
                { 
                    "id":"-90", 
                    "nombre": "-9",
                    status: true,
                }, 
                { 
                    "id":"-80",
                    "nombre": "-8",
                    status: true,
                }, 
                { 
                    "id":"-70", 
                    "nombre": "-7",
                    status: true,
                }, 
                { 
                    "id":"-60", 
                    "nombre": "-6",
                    status: true,
                }, 
                {
                    "id":"-50", 
                    "nombre": "-5",
                    status: true,
                }, 
                { 
                    "id":"-40", 
                    "nombre": "-4",
                    status: true,
                }, 
                { 
                    "id":"-30", 
                    "nombre": "-3",
                    status: true,
                }, 
                { 
                    "id":"-20", 
                    "nombre": "-2",
                    status: true,
                }, 
                { 
                    "id":"-10", 
                    "nombre": "-1",
                    status: true,
                }, 
                {  
                    "id":"0", 
                    "nombre": "0",
                    status: true,
                }, 
                { 
                    "id":"10", 
                    "nombre": "1",
                    status: true,
                }, 
                { 
                    "id":"20", 
                    "nombre": "2",
                    status: true,
                }, 
                { 
                    "id":"30", 
                    "nombre": "3",
                    status: true,
                }, 
                { 
                    "id":"40", 
                    "nombre": "4",
                    status: true,
                }, 
                { 
                    "id":"50", 
                    "nombre": "5",
                    status: true,
                }, 
                { 
                    "id":"60", 
                    "nombre": "6",
                    status: true,
                }, 
                { 
                    "id":"70", 
                    "nombre": "7",
                    status: true,
                }, 
                { 
                    "id":"80", 
                    "nombre": "8",
                    status: true,
                }, 
                { 
                    "id":"90", 
                    "nombre": "9",
                    status: true,
                }, 
                { 
                    "id":"100", 
                    "nombre": "10",
                    status: true,
                }, 
                { 
                    "id":"110", 
                    "nombre": "11",
                    status: true,
                }, 
                { 
                    "id":"120", 
                    "nombre": "12",
                    status: true,
                }, 
                { 
                    "id":"130", 
                    "nombre": "13",
                    status: true,
                }, 
                { 
                    "id":"140", 
                    "nombre": "14",
                    status: true,
                }, 
                { 
                    "id":"150", 
                    "nombre": "15",
                    status: true,
                }, 
                { 
                    "id":"160", 
                    "nombre": "16",
                    status: true,
                }, 
                { 
                    "id":"170", 
                    "nombre": "17",
                    status: true,
                }, 
                { 
                    "id":"180", 
                    "nombre": "18",
                    status: true,
                }, 
                { 
                    "id":"190", 
                    "nombre": "19",
                    status: true,
                }, 
                { 
                    "id":"200", 
                    "nombre": "20",
                    status: true,
                }, 
                { 
                    "id":"210", 
                    "nombre": "21",
                    status: true,
                }, 
                { 
                    "id":"220", 
                    "nombre": "22",
                    status: true,
                }, 
                { 
                    "id":"230", 
                    "nombre": "23",
                    status: true,
                }, 
                { 
                    "id":"240", 
                    "nombre": "24",
                    status: true,
                }, 
                { 
                    "id":"250", 
                    "nombre": "25",
                    status: true,
                }
            ],


            getControl: function(tipo, ind) {
                if(tipo == 2 || tipo == 3 || tipo == 4 || tipo == 8 || tipo == 32) {
                    var itm = this.commandControl.find(function(c){
                        return c.nombre == ind
                    })
                    return itm
                }else if(tipo == 0 || tipo == 1){
                    var itm2 = this.onOffControl.find(function(c){
                        return c.nombre == ind
                    })
                    return itm2
                }
                else if(tipo == 15){
                    var itm3 = this.mxproControl.find(function(c){
                        return c.nombre == ind
                    })
                    var itm4 = {
                        nombre: itm3.nombre,
                        id: parseInt(itm3.id)/10,
                        value: itm3.id
                    }
                    return itm4
                }
                else if(tipo == 17){
                    var comands = utilities.generarIntervaloDimmer(50);
                    var itm3 = comands.find(function(c){
                        return c.nombre == ind
                    })
                    return itm3
                }
                else if(tipo == 27){
                    var comands = utilities.generarIntervaloDimmer(10);
                    var itm5 = comands.find(function(c){
                        return c.nombre == ind
                    })
                    return itm5
                }
                else if(tipo == 29){
                    var itm6 = this.wind_CurtainControl.find(function(c){
                        return c.nombre == ind
                    })
                    return itm6
                }
            },

            getControlByID: function(tipo, id) {
                var itm;
                switch (tipo) {
                    case '0':
                    case '1':
                        itm = this.onOffControl.find(function(c){
                            return c.id == id
                        })
                        return itm
                    case '2':
                    case '3':
                    case '4':
                    case '32': // BMS (ex-DMS) — mismo set de setpoints que Helo T/Tracer
                    case '33':
                        itm = this.commandControl.find(function(c){
                            return c.id == id
                        })
                        return itm
                    case '14':
                        return ({
                            nombre: id/10,
                            id: id
                        })
                    case '15':
                        itm = this.mxproControl.find(function(c){
                            return c.id == id
                        })
                        return itm
                    case '17':
                        var comands = utilities.generarIntervaloDimmer(50);
                        itm = comands.find(function(c){
                            return c.id == id
                        })
                        return itm
                    case '27':
                        var comands = utilities.generarIntervaloDimmer(10);
                        itm = comands.find(function(c){
                            return c.id == id
                        })
                        return itm
                    case '29':
                        itm = this.wind_CurtainControl.find(function(c){
                            return c.id == id
                        })
                        return itm
                }
            },

            getFrequency: function(ind) {
                var itm = this.frequencyProgram.find(function(f){
                    return f.text == ind
                })
                return itm
            },

            setDays: function(array) {
                var days = [];
                var self = this;
                array.forEach(function(d){
                    var itm = self.intermittenceDays.find(function(i){
                        return d === i.text;
                    })
                    days.push(itm.value);
                })
                return days
            },

            formatResponse: function(d) {
                return ({
                    //air: d.dispositivo.nombre,
                    air: d.aire,
                    date: new Date(d.dia + ' ' + '00:00:00'),
                    hinit: this.formatHour(d.hini, d.dia + ' ' + '00:00:00'),
                    hend: this.formatHour(d.hfin, d.dia + ' ' + '00:00:00'),
                    //freq: this.frequencyProgram.filter(function(c) { return c.text == d.frecuencia})[0].value,
                    freq: this.frequencyProgram.filter(function(c) { return c.value == d.frec})[0].value,
                    //setpoint: this.commandControl.filter(function(c) { return c.nombre == d.action })[0].id,
                    //finalsetpoint: this.commandControl.filter(function(c) { return c.id == d.postAction })[0].id,
                    setpoint: this.commandControl.filter(function(c) { return c.nombre == d.comando })[0].id,
                    finalsetpoint: this.commandControl.filter(function(c) { return c.id == d.comando_post })[0].id,
                    id: d.id
                })
            },

            formatResponseLoad: function(d) {
                return ({
                    date: new Date(d.dia + ' ' + '00:00:00'),
                    hinit: this.formatHour(d.hini, d.dia + ' ' + '00:00:00'),
                    hend: this.formatHour(d.hfin, d.dia + ' ' + '00:00:00'),
                    //freq: this.frequencyProgram.filter(function(c) { return c.text == d.frecuencia})[0].value,
                    freq: this.frequencyProgram.filter(function(c) { return c.value == d.frec})[0].value,
                    id: d.id
                })
            },

            formatHour: function(h, d) {
                var t = h.split(":");
                var n = new Date(d);
                n.setHours(t[0]);
                n.setMinutes(t[1]);
                n.setMilliseconds(t[2]);
                return n;
            },
            validateChangeDayInUTC: function(dayInit, dayEnd){

                if($filter('date')(dayInit, 'yyyy-MM-dd') == dayInit.toISOString().substring(0,10)){
                    if($filter('date')(dayEnd, 'yyyy-MM-dd') == dayEnd.toISOString().substring(0,10)){
                        return 1; //Day in local and UTC format is same
                    }else if($filter('date')(dayEnd, 'yyyy-MM-dd') < dayEnd.toISOString().substring(0,10)){
                        return 3; //Day in local and UTC format is different for dayEnd
                    }
                }else if($filter('date')(dayInit, 'yyyy-MM-dd') > dayInit.toISOString().substring(0,10)){
                    if($filter('date')(dayEnd, 'yyyy-MM-dd') > dayEnd.toISOString().substring(0,10)){
                        return 4; //Day in local is major that UTC format for dayInit and dayEnd
                    }else return 2; //Day in local and UTC format is different for dayInit                  
                }else return 5; //Day in local is minor that UTC format for dayInit and dayEnd        
            }

        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('automationCtrl', automationCtrl);

    /** @ngInject */
    function automationCtrl($scope, RESTServices, $localStorage, $stateParams, $state, $filter, toastr, AutoServices,SHAREServices, $rootScope, utilities, $timeout) {
        
        
        $scope.frequency = AutoServices.frequency;
        $scope.tipos_feriados = AutoServices.tipos_feriados.filter(function(f){return f.value !== '1'})
        $scope.intermittenceDays = AutoServices.getIntermittenceDays();
        $scope.loading = false;
        $scope.validatedList = false;
        $scope.validatedDays = false;
        $scope.editMode = false;
        $scope.newAutomation = {
            hinit: null,
            hend: null,
            freq: '',
            repeat: '',
            date: null,
            setpoint: '',
            finalsetpoint: '',
            setPoint_rack: '',
            finalsetpoint_rack: '',
            devices: [],
            days: [],
            feriado: 0, ////0 se ejecuta siempre sin importar si es festivo //// 1 solo ejecuta cuando es festivo //// 2 solo cuando no es festivo
        };
        $scope.device = {};
        var id_pais;
        
        if($stateParams.zona) {
            id_pais = $stateParams.zona.id_pais;
            $scope.type = $stateParams.type ? $stateParams.type : $stateParams.program.tipo;
            $stateParams.dispositivos.map(function(d){d.status = false});
            switch($scope.type.ind){
                case '0':
                    $scope.setpoints = AutoServices.getCommandsControl();
                    $scope.dispositivos = $stateParams.dispositivos.filter(function(d){
                        return d.tipo == '2' || d.tipo == '3' || d.tipo == '4' || d.tipo == '32';
                    })
                    break;
                case '1':
                    $scope.setpoints = AutoServices.onOffControl;
                    $scope.dispositivos = $stateParams.dispositivos.filter(function(d){
                        return d.tipo == '0' || d.tipo == '1';
                    })
                    break;
                case '2':
                    $scope.setpoints = utilities.generarIntervaloDimmer(50);
                    $scope.dispositivos = $stateParams.dispositivos.filter(function(d){
                        return d.tipo == '17';
                    })
                    break;
                case '3':
                    $scope.dispositivos = $stateParams.dispositivos.filter(function(d){
                        return d.tipo == '14' 
                    })
                    break;
                case '4':
                    $scope.setpoints = utilities.generarIntervaloDimmer(10);
                    $scope.dispositivos = $stateParams.dispositivos.filter(function(d){
                        return d.tipo == '27';
                    })
                    break;
                case '5':
                    $scope.setpoints = AutoServices.mxproControl;
                    $scope.dispositivos = $stateParams.dispositivos.filter(function(d){
                        return d.tipo == '15';
                    })
                    break;
                case '6':
                        $scope.setpoints = AutoServices.wind_CurtainControl;
                        $scope.dispositivos = $stateParams.dispositivos.filter(function(d){
                            return d.tipo == '29';
                        })
                        break;
                default:
                    $scope.dispositivos = [];
            }
        } else {
            $state.go('dashboard_cliente')
        };
        
        /////control datepicker
        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            minDate: new Date()
        };
        $scope.open = function() {
            $scope.popup.opened = true;
        };
        $scope.popup = {
            opened: false
        };
        $scope.DateFormat = AutoServices.format.day;
        
        $scope.setRepeat = function(ind, date) {
            switch(ind){
                case '1':
                    var day = new Date(date).getDay();
                    $scope.newAutomation.days.push(day);
                    setExecutiveTypes(ind);
                    break;
                case '2':
                    var day = new Date().getDay();
                    $scope.newAutomation.days.push(day);
                    setExecutiveTypes(ind);
                    break;
                case '3':
                    $scope.newAutomation.days = [1,2,3,4,5];
                    setExecutiveTypes(ind);
                    break;
                case '4':
                    $scope.newAutomation.days = [0,6];
                    setExecutiveTypes(ind);
                    break;
                case '5':
                    $scope.newAutomation.days = [];
                    setExecutiveTypes(ind);
                    break;
                case '6':
                    $scope.newAutomation.feriado = '1';
                    getHolidays();
                    setExecutiveTypes(ind);
                    break;
                case '7':
                    $scope.newAutomation.feriado = '2';
                    //getHolidays();
                    setExecutiveTypes(ind);
                    break;
            }
            $scope.validarDias(false)
        }

        function setExecutiveTypes(ind) {
            switch(ind) {
                case '6':
                    var items = AutoServices.tipos_feriados.filter(function(f){return f.value !== '0'})
                    $scope.tipos_feriados = items;
                    break;
                default:
                    var items = AutoServices.tipos_feriados.filter(function(f){return f.value !== '1'})
                    $scope.tipos_feriados = items;
                    break;
            }
        }

        $scope.selectAll = function(ind) {
            if(ind){
                $scope.holidays.map(function(h){
                    h.status = true;
                })
            } else {
                $scope.holidays.map(function(h){
                    h.status = false;
                })
            } 
        }

        // $scope.setHolidaysType = function(ind) {
        //     if(ind === '1') {
        //         getHolidays()
        //     }
        // }

        function getHolidays() {
            var currentYear = new Date().getFullYear();
            var nextYear = currentYear + 1;
            var allyears = [];
            allyears.push(currentYear, nextYear);

            var promesas = allyears.map(function(year) {
                var params = {
                    "id_usuario": $localStorage.id_usuario,
                    "id_pais": id_pais,
                    "year": year,
                };

                return RESTServices.post_header('cliente/consulta_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true)
                
            })
                
            Promise.all(promesas)
                .then(function(data) {
                    var allHolidays = []
                    data.forEach(function(item) {
                        if (item.code === '200') {
                            allHolidays = allHolidays.concat(item.festivos);
                        } else {
                            allHolidays = [];
                        }
                    })
                    if(allHolidays.length > 0){
                        var today = new Date();
                        today.setHours(0, 0, 0, 0);
                        $scope.holidays = allHolidays.filter(function(f){
                            var date = new Date(f.day);
                            date.setHours(0, 0, 0, 0); // También ajustamos la hora de la fecha del arreglo
                            return date >= today;
                        });
                        $scope.holidays.map(function(h){
                            h.status = true;
                        })
                        $scope.holidays.sort(function (a, b) {
                            if (a.day > b.day) {
                                return 1;
                            }
                            if (a.day < b.day) {
                                return -1;
                            }
                            return 0;
                        });
                    } else {
                        $scope.holidays = [];
                    }

                    $scope.$apply();
                    $scope.validarDias(true)
                    

                })
                .catch(function(error) {
                    //console.log(error)
                })
        }

        $scope.setDays = function(value, status) {
            if(status) {
                $scope.newAutomation.days.push(value)
            } else {
                var index = $scope.newAutomation.days.findIndex(function(d){return d === value});
                $scope.newAutomation.days.splice(index, 1);
            }
            
            $scope.validarDias(false)
        }

        $scope.validarDias = function(is_holidays){
            if(is_holidays && $scope.holidays){
                var selected = $scope.holidays.filter(function(h){return h.status === true});
                if(selected.length > 0) {
                    $scope.validatedDays = true;
                } else {
                    $scope.validatedDays = false;
                }
            } else {
                var length = $scope.newAutomation.days.length;
                if(length > 0) {
                    $scope.validatedDays = true;
                } else {
                    $scope.validatedDays = false;
                }
            }
            
        }

        if($stateParams.parm == 'edit'){
            $scope.editMode = true;
            $scope.device = $stateParams.program.dispositivo;
            var fecha_dia = $filter('date')(new Date(), 'yyyy-MM-dd');
            $scope.newAutomation = {
                date: new Date(),
                hinit: new Date(fecha_dia + ' ' + $stateParams.program.hini),
                hend: new Date(fecha_dia + ' ' + $stateParams.program.hfin),
                freq: '3',
                repeat: '5',
                setpoint: $scope.device.tipo == 14 ? null : AutoServices.getControl($scope.device.tipo, $stateParams.program.action).id,
                finalsetpoint: $scope.device.tipo == 14 ? null : AutoServices.getControl($scope.device.tipo, $stateParams.program.postAction).id,
                setPoint_rack: $scope.device.tipo == 14 ? parseInt($stateParams.program.action) : null,
                finalsetpoint_rack: $scope.device.tipo == 14 ? parseInt($stateParams.program.postAction) : null,
                devices: [$scope.device],
                days: AutoServices.setDays($stateParams.program.actionDays),
                feriado: $stateParams.program.feriado,
            }
            $scope.newAutomation.date.setHours(0);
            $scope.newAutomation.date.setMinutes(0);
            $scope.newAutomation.date.setSeconds(0);

            $scope.newAutomation.days.forEach(function(i){
                $scope.intermittenceDays[i].status = true;
            });
            $scope.validatedDays = true;
            $scope.validatedList = true;
        }
        
        // ////////////////////////
        $scope.validateSchedual = function(progm) {
            $rootScope.flag_loading = true; 
            if($scope.editMode) {
                deleteSchedule(progm)
            } else {
                newPrograming(progm)
            }
        }

        function validarUTC(promg) {
            promg.hinit = $filter('date')(promg.date.getFullYear()+'-'+(promg.date.getMonth()+1)+'-'+promg.date.getDate()+' '+promg.hinit.getHours()+':'+promg.hinit.getMinutes()+':'+promg.hinit.getSeconds(), 'yyyy-MM-dd HH:mm:ss');
            promg.hend = $filter('date')(promg.date.getFullYear()+'-'+(promg.date.getMonth()+1)+'-'+promg.date.getDate()+' '+promg.hend.getHours()+':'+promg.hend.getMinutes()+':'+promg.hend.getSeconds(), 'yyyy-MM-dd HH:mm:ss');
            promg.hinit = new Date(promg.hinit);
            promg.hend = new Date(promg.hend);

            var state = AutoServices.validateChangeDayInUTC(promg.hinit,promg.hend);
            return state === 1 || state === 4 || state === 5 ? true : false
        }

        function getWeekDates(date, daysOfWeek, isUTC) {
            var utc = isUTC ? 1 : 0;
            var inputDate = new Date(date);
            var dayOfWeek = inputDate.getDay(); // 0 (Sunday) to 6 (Saturday)
            
            // Calculate the date of the Monday of the week containing the input date
            var diffToMonday = (dayOfWeek + 6) % 7; // This gives 0 for Monday, 6 for Sunday, etc.
            var monday = new Date(inputDate);
            monday.setDate(inputDate.getDate() - diffToMonday);
            
            // Generate the array of dates based on the specified daysOfWeek
            var weekDates = [];
            for (var i = 0; i < 7; i++) {
                if (daysOfWeek.includes((i + 1) % 7)) {
                    var weekDate = new Date(monday);
                    weekDate.setDate(monday.getDate() + i + utc);
                    weekDate.setHours(0);
                    weekDate.setMinutes(0);
                    weekDate.setSeconds(0);
                    weekDates.push(new Date(weekDate)); // Create a new Date object for each day to avoid mutation issues
                }
            }
            
            return weekDates;
        }

        function differenceInDays(date1, date2) {
            var date1Obj = new Date(date1);
            var date2Obj = new Date(date2);
          
            // Obtenemos la diferencia en milisegundos
            var differenceInTime = date2Obj - date1Obj;
          
            // Convertimos la diferencia de milisegundos a días
            var differenceInDays = differenceInTime / (1000 * 3600 * 24);
          
            return Math.abs(differenceInDays) >= 1 ? true : false;
        }

        function generateHolidays() {
            var items = [];
            var selected = $scope.holidays.filter(function(h){return h.status === true});
            if(selected.length > 0) {
                selected.forEach(function(s){
                    var date = s.day.split('-').map(Number);
                    var itm = new Date(date[0], date[1] - 1, date[2]);
                    itm.setHours(0);
                    itm.setMinutes(0);
                    itm.setSeconds(0);
                    items.push(itm);
                });
            }
            return items;
        }

        // /////////////
        function newPrograming(promg){
            var programaciones = [];
            var days = [];

            if(promg.date === null) {
                promg.date = new Date();
                promg.date.setHours(0);
                promg.date.setMinutes(0);
                promg.date.setSeconds(0);
            }

            if(validarUTC(promg)) {
                if(promg.feriado === '1'){
                    days = generateHolidays()
                } else {
                    days = getWeekDates(promg.date, promg.days, differenceInDays(promg.date.toISOString().substring(0,10), promg.hinit.toISOString().substring(0,10)));
                }
                promg.devices.forEach(function(device){
                    var codigo = utilities.generarCodigo(20);
                    days.forEach(function(day) {
                        var field = {
                            "id_dispositivo": device.id ? device.id : device.id_dispositivo,
                            "dia": day.toISOString().substring(0,10),
                            "hini": promg.hinit.toISOString().substring(11,19),
                            "hfin": promg.hend.toISOString().substring(11,19),
                            "frecuencia": getFrecuencia(promg.repeat),
                            "comando": device.tipo == 14 ? promg.setPoint_rack*10 : promg.setpoint,
                            "comando_post": device.tipo == 14 ? promg.finalsetpoint_rack*10 : promg.finalsetpoint,
                            "id_usuario": $localStorage.id_usuario,
                            "id_programacion": promg.id ? promg.id : null,
                            "grupo": codigo,
                            "feriado": promg.feriado
                        };

                        programaciones.push(field)
                    })
                })

                

            } else {
                ///partir programación
                if(promg.feriado === '1'){
                    days = generateHolidays()
                } else {
                    days = getWeekDates(promg.date, promg.days, false);
                }
                
                var createField = function(device, day, hini, hfin, comando, comando_post, userId, programId, frecuencia, codigo, feriado) {
                    return {
                        "id_dispositivo": device.id ? device.id : device.id_dispositivo,
                        "dia": day.toISOString().substring(0, 10),
                        "hini": hini,
                        "hfin": hfin,
                        "frecuencia": frecuencia,
                        "comando": comando,
                        "comando_post": comando_post,
                        "id_usuario": userId,
                        "id_programacion": programId,
                        "grupo": codigo,
                        "feriado": feriado,
                    };
                };
                
                promg.devices.forEach(function(device) {
                    var codigo = utilities.generarCodigo(20);
                    days.forEach(function(day) {
                        var userId = $localStorage.id_usuario;
                        var programId = promg.id ? promg.id : null;
                        var frecuencia = getFrecuencia(promg.repeat);
                        var comando = device.tipo == 14 ? promg.setPoint_rack * 10 : promg.setpoint;
                        var comandoPostInitial = comando;
                        var comandoPostFinal = device.tipo == 14 ? promg.finalsetpoint_rack * 10 : promg.finalsetpoint;
                
                        var field = createField(device, day, promg.hinit.toISOString().substring(11, 19), '23:59:59', comando, comandoPostInitial, userId, programId, frecuencia, codigo, promg.feriado);
                        programaciones.push(field);
                
                        var nextDay = new Date(day);
                        nextDay.setDate(nextDay.getDate() + 1);
                
                        var field_2 = createField(device, nextDay, '00:00:00', promg.hend.toISOString().substring(11, 19), comando, comandoPostFinal, userId, programId, frecuencia, codigo, promg.feriado);
                        programaciones.push(field_2);
                    });
                });
                
            }
            editSchedule(programaciones)

        }

        var getFrecuencia = function(ind) {
            switch(ind){
                case '1':
                    return ind;
                case '2': 
                    return ind;
                case '3':
                case '4':
                case '5':
                    return '3';
                case '6':
                case '7':
                    return '1';
            }
        }

        $scope.cancelar = function(){
            $state.go('dashboard_cliente.schedules', {zone: $stateParams.zona});
        }
        // ///////////
        
        

        function editSchedule(programaciones) {
            var promise = Promise.resolve();
            programaciones.forEach(function(a){
                promise = promise.then(function () {
                    // Espera la respuesta: la lambda tarda más de 400 ms y la lista se recargaba antes de que terminara.
                    return Schedule(a);
                });
            })
  
            promise.then(function(){
                $state.go('dashboard_cliente.schedules', {zone: $stateParams.zona});
                $rootScope.flag_loading = false;
                toastr.success('Se ha programado el aire correctamente', 'Programación de aire');

            })
  
            function Schedule(params) {
                return RESTServices.post_header('programacion_aire.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                    if(res.code == 200) {
                        
                    }
                    if (res.code == 400){
                        toastr.error('La programación se cruza con al menos una programación previamente agendada.', 'No se pudo programar el aire');
                    }
                }).catch(function () {})
            }
          
        }

        function deleteSchedule(schedule){
            var prog = $stateParams.program;
            var promesas = [];
            var promesas = prog.id_nestedProg.map(function(id){
                var field = {
                    "id_programacion": id,
                    "id_usuario": $localStorage.id_usuario,
                };
                return RESTServices.post_header('elimina_programacion_aires.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
            });

            Promise.all(promesas)
                .then(function(data){
                    $timeout(function(){
                        newPrograming(schedule)
                    },1000)
                    
                })
        }

        
    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope, $filter, $http, RESTServices, SHAREServices) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['yyyy-MM-dd'];

        $scope.options = {
            showWeeks: false
        };

        $scope.options2 = {
            showWeeks: false,
            minMode: 'month',
            maxDate: new Date()
        };

        function open() {
            $scope.opened = true;
        }

        $scope.fecha_ahorro = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
        }

        $scope.fecha_ahorro_total = function() {
            SHAREServices.mesDatepicker = $filter('date')($scope.dt, 'yyyy-MM');
        }

    }
})();
(function() {
    'use strict';
    angular.module('BlurAdmin').service('statisticsServices', statisticsServices);

    function statisticsServices() {
        return {
            setTab: function(parm){
                switch(parm){
                    case '0':
                    case '1':
                        return [
                            // {
                            //     type: 'behavior',
                            //     status: true,
                            //     name: 'Comportamiento'
                            // },
                            {
                                type: 'relay',
                                status: true,
                                name: 'Conmutación',
                                id: '2',
                            },
                            {
                                type: 'consumption',
                                status: false,
                                name: 'Potencia',
                                id: '101',
                            },
                            {
                                type: 'opening',
                                status: false,
                                name: 'Apertura',
                                id: '3',
                            }
                        ]
                    case '2':
                    case '3':
                        return [
                            {
                                type: 'behavior',
                                status: true,
                                name: 'Comportamiento',
                                id: '1',
                            },
                            // {
                            //     type: 'use',
                            //     status: false,
                            //     name: 'Uso'
                            // },
                            {
                                type: 'consumption',
                                status: false,
                                name: 'Potencia',
                                id: '101',
                            },
                            {
                                type: 'presence',
                                status: false,
                                name: 'Presencia',
                                id: '7',
                            }
                        ]
                    case '4':
                        return [
                            {
                                type: 'behavior',
                                status: true,
                                name: 'Comportamiento',
                                id: '1',
                            },
                            {
                                type: 'temp',
                                status: false,
                                name: 'Temperatura',
                                id: '10',
                            },
                            {
                                type: 'fan',
                                status: false,
                                name: 'Ventilador',
                                id: '',
                            },  
                            {
                                type: 'lock',
                                status: false,
                                name: 'Bloqueo',
                                id: '',
                            },
                            {
                                type: 'mode',
                                status: false,
                                name: 'Modo',
                                id: '',
                            },  
                        ]
                    case '5':
                        return [
                            {
                                type: 'consumption',
                                status: true,
                                name: 'Potencia',
                                id: '101',
                            }
                            ]
                    case '6':
                    case '30': 
                        return [
                            {
                                type: 'temp',
                                status: true,
                                name: 'Temperatura',
                                id: '10',
                            },
                            {
                                type: 'humidity',
                                status: false,
                                name: 'Humedad',
                                id: '11',
                            }
                        ]
                    case '12':
                        return [
                            {
                                type: 'fpt',
                                status: true,
                                name: 'Flujo / Presión / Temperatura',
                                id: '',
                            },
                            {
                                type: 'scfm_kw',
                                status: false,
                                name: 'SCFM/kW',
                                id: '12',
                            },
                        ]
                    case '13':
                        return [
                            {
                                type: 'temp_hum_consumption',
                                status: true,
                                name: 'Humedad / Temperatura / Potencia',
                                id: '',
                            },
                        ]
                    case '14':
                        return [
                            {
                                type: 'pressure',
                                status: true,
                                name: 'Presion',
                                id: '4',
                            }
                        ]
                    case '15':
                        return [
                            {
                                type: 'mpx',
                                status: true,
                                name: 'Temperatura',
                                id: '10',
                            }
                        ]
                    case '16':////Helo E
                        return [
                            {
                                type: 'consumptionEnergy',
                                status: true,
                                name: 'Energía',
                                id: '8',
                            }
                        ]
                    case '17': //Dimmer
                        return [
                            {
                                type: 'dimmer',
                                status: true,
                                name: 'Dimerizado',
                                id: '9',
                            },
                            {
                                type: 'consumption',
                                status: false,
                                name: 'Potencia',
                                id: '101',
                            },
                        ]
                    case '18': //Helo presión
                        return [
                            {
                                type: 'pressurePSI',
                                status: true,
                                name: 'Presión',
                                id: '13',
                            }
                        ]
                    case '19': //Helo flujo
                        return [
                            {
                                type: 'Tin',
                                status: true,
                                name: 'Temp entrada',
                                id: '18',
                            },
                            {
                                type: 'Tout',
                                status: false,
                                name: 'Temp salida',
                                id: '19',
                            },
                            {
                                type: 'DeltaT',
                                status: false,
                                name: 'Delta de temp',
                                id: '20',
                            },
                            // {
                            //     type: 'cop',
                            //     status: false,
                            //     name: 'COP'
                            // },
                            {
                                type: 'energyTerm',
                                status: false,
                                name: 'Energía Térmica',
                                id: '17',
                            },
                            {
                                type: 'flowM3h',
                                status: false,
                                name: 'Flujo',
                                id: '16',
                            },
                        ]
                    case '20': //Helo apertura
                        return [
                            {
                                type: 'opening',
                                status: true,
                                name: 'Apertura y cierre',
                                id: '3',
                            },
                        ]
                    case '21': //Helo presencia
                        return [
                            {
                                type: 'presence',
                                status: true,
                                name: 'Presencia',
                                id: '7',
                            },
                        ]
                    case '22': //Helo s con voltaje
                        return [
                            {
                                type: 'energy_plus',
                                status: true,
                                name: 'Helo S plus',
                                id: '',
                            },
                        ]
                    case '23': //Helo s multicanal
                        return [
                            {
                                type: 'consumo_mc',
                                status: true,
                                name: 'Helo S MultiChannel',
                                id: '',
                            },
                        ]
                    case '25': //Emporia
                        return [
                            {
                                type: 'emporiaEnergy',
                                status: true,
                                name: 'Energía Activa',
                                id: '44',
                            },
                        ]
                    case '27': //variador de velocidad
                        return [
                            {
                                type: 'frec_set',
                                status: true,
                                name: 'Frecuencia',
                                id: '53',
                            },
                            {
                                type: 'voltageVariator',
                                status: false,
                                name: 'Voltaje de salida',
                                id: '52',
                            },
                            {
                                type: 'currentVariator',
                                status: false,
                                name: 'Corriente de salida',
                                id: '51',
                            },
                            {
                                type: 'temp',
                                status: false,
                                name: 'Temperatura',
                                id: '10',
                            },
                            
                        ]
                    case '28': //Sensor calidad del aire
                        return [
                            {
                                type: 'temp',
                                status: true,
                                name: 'Temperatura',
                                id: '10',
                            },
                            {
                                type: 'humidity',
                                status: false,
                                name: 'Humedad',
                                id: '11',
                            },
                            {
                                type: 'pm1p0',
                                status: false,
                                name: 'PM 1.0 ug/m3',
                                id: '45',
                            },
                            {
                                type: 'pm2p5',
                                status: false,
                                name: 'PM 2.5 ug/m3',
                                id: '46',
                            },
                            {
                                type: 'pm4p0',
                                status: false,
                                name: 'PM 4.0 ug/m3',
                                id: '47',
                            },
                            {
                                type: 'pm10p0',
                                status: false,
                                name: 'PM 10.0 ug/m3',
                                id: '48',
                            },
                            {
                                type: 'voc',
                                status: false,
                                name: 'VoC',
                                id: '49',
                            },
                            {
                                type: 'nox',
                                status: false,
                                name: 'Óxido nítrico',
                                id: '50',
                            }
                        ]
                    case '29': //Cortina de viento
                        return [
                            {
                                type: 'curtain',
                                status: true,
                                name: 'Comportamiento',
                                id: '54',
                            },
                            {
                                type: 'consumption',
                                status: false,
                                name: 'Potencia',
                                id: '101',
                            },
                            {
                                type: 'presence',
                                status: false,
                                name: 'Presencia',
                                id: '7',
                            }
                        ]
                    case '33':
                        return [
                            {
                                type: 'behavior',
                                status: true,
                                name: 'Comportamiento',
                                id: '1',
                            },
                            {
                                type: 'temp',
                                status: false,
                                name: 'Temperatura',
                                id: '10',
                            },
                            {
                                type: 'comms',
                                status: false,
                                name: 'Comunicación',
                                id: '58',
                            },
                        ]
                    case '32': // DMS
                        return [
                            { type: 'behavior',  status: true,  name: 'Comportamiento', id: '1' },
                            { type: 'temp',      status: false, name: 'Temperatura',    id: '10' },
                            { type: 'fan',       status: false, name: 'Ventilador',     id: '55' },
                            { type: 'mode',      status: false, name: 'Modo',           id: '57' },
                            { type: 'error',     status: false, name: 'Error',          id: '59' },
                        ]
                    default:
                        return null;
                }
            },
            setGraph: function(parm){
                switch(parm){
                    case 'relay':
                    case 'opening':
                        return ({
                            title: parm === 'relay' ? 'Gráfica de Conmutación': 'Gráfica de Apertura',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_comportamiento_aire/grafica_comportamiento_aire.html'
                        })
                    case 'temp':
                    case 'Tin':
                    case 'Tout':
                    case 'DeltaT':
                        return ({
                            title: 'Gráfica de Temperatura',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_comportamiento_aire/grafica_comportamiento_aire.html',
                            indicadores: ['Promedio', 'Máximo', 'Mínimo', 'Umbral Superior', 'Umbral Inferior'],
                            unit: 'C°',
                        })
                    case 'presence':
                        return ({
                            title: 'Gráfica Sensor Presencia',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_comportamiento_aire/grafica_comportamiento_aire.html'
                        })
                    case 'fan':
                    case 'lock':
                    case 'mode':
                        return ({
                            title: 'Gráfica Comportamiento termostato',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_comportamiento_aire/grafica_comportamiento_aire.html'
                        })   
                    case 'consumption':
                    case 'voltageVariator':
                    case 'currentVariator':
                    case 'flowM3h':
                    case 'energyTerm':
                        return ({
                            title: parm === 'consumption' ? 'Gráfica de Potencia': parm === 'flowM3h' ? 'Gráfica de Flujo' : parm === 'energyTerm' ? 'Gráfica de Energía Térmica' : parm === 'voltageVariator' ?  'Gráfica de voltaje de Salida': 'Gráfica de corriente de salida',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_consumo/grafica_consumo.html'
                        })
                    case 'use':
                        return ({
                            title: 'Gráfica de Uso',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_uso_aire/grafica_uso_aire.html'
                        })
                        
                    case 'behavior':
                    case 'curtain':
                    case 'comms':
                        return ({
                            title: parm === 'comms' ? 'Gráfica de Comunicación' : 'Gráfica de Comportamiento',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_comportamiento_aire/grafica_comportamiento_aire.html'
                        })
                        
                    case 'humidity':
                    case 'pressurePSI':
                        return ({
                            title: parm === 'humidity' ? 'Gráfica de Humedad' : 'Gráfica de Presión',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_humedad/grafica_humedad.html'
                        })
                    case 'pressure':
                        return ({
                            title: 'Gráfica de Presión',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_presion/grafica_presion.html'
                        })

                    case 'mpx':
                    case 'frec_set':
                        return ({
                            title: parm === 'mpx' ? 'Gráfica de Temperatura' : 'Gráfica de Frecuencia',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_mpx/grafica_mpx.html'
                        })
                        
                    case 'energy':
                        return ({
                            title: 'Gráfica de Energía',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_energia/grafica_energia.html'
                        })
                        
                    case 'temp_dist':
                        return ({
                            title: 'Gráfica de Temperatura vs Distancia',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_temp_dist/grafica_temp_dist.html'
                        })
                        
                    case 'fpt':
                        return ({
                            title: 'Flujo / Presión / Temperatura',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_fpt/grafica_fpt.html'
                        })
                        
                    case 'scfm_kw':
                        return ({
                            title: 'SCFM/kW',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_scfm_kw/grafica_scfm_kw.html'
                        })           
                    case 'commutation':
                        return ({
                            title: 'Gráfica de Conmutación',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_conmutacion/grafica_conmutacion.html'
                        })
                    case 'consumptionEnergy':
                    case 'emporiaEnergy':
                        return ({
                            title: 'Gráfica de Energía',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_energia_helo_e/grafica_energia_helo_e.html'
                        })
                    case 'temp_hum_consumption':
                        return ({
                            title: 'Gráfica de Humedad / Temperatura / Potencia',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_temp_humedad_potencia/grafica_temp_humedad_potencia.html'
                        })
                    case 'saeg':
                        return ({
                            title: 'Variables Saeg',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/graficas_saeg/graficas_saeg.html'
                        })
                    case 'dimmer':
                        return ({
                            title: 'Gráfica de Dimerizado',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_dimmer/grafica_dimmer.html'
                        })
                    case 'cop':
                        return ({
                            title: 'Gráfica de COP (Factor de eficiencia enegética)',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_consumo/grafica_consumo.html'
                        })
                    case 'energy_plus':
                        return ({
                            title: 'Gráfica de energía',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_helo_s_plus/grafica_helo_s_plus.html'
                        })
                    case 'consumo_mc':
                        return ({
                            title: 'Gráfica de Consumo',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_consumo_helo_mc/grafica_consumo_helo_mc.html'
                        })
                    case 'pm1p0':
                    case 'pm2p5':
                    case 'pm4p0':
                    case 'pm10p0':
                    case 'voc':
                    case 'nox':
                        return ({
                            title: parm === 'pm1p0' || parm === 'pm2p5' || parm === 'pm4p0' || parm === 'pm10p0' ? 'Gráfica de Material particulado' : parm === 'voc' ? 'Gráfica de VoC' : 'Gráfica de Óxido nítrico',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_sensores/grafica_sensores.html'
                        })
                    case 'error':
                        return ({
                            title: 'Gráfica de Error',
                            url: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_error/grafica_error.html'
                        })
                    default:
                        return null;
                }
            },
            setIcon: function(type) {
                switch (type) {
                    case '0':
                    case '1':
                        return 'assets/icons/icon_light.png';
                    case '2':
                    case '3':
                    case '4':
                    case '29':
                        return 'assets/icons/icon_aire.png';
                    case '5':
                    case '9':
                    case '16':
                    case '22':
                    case '23':
                    case '25':
                        return 'assets/icons/medidor.png';
                    case '6':
                    case '8':
                    case '30':
                        return 'assets/icons/thermometer.png';
                        
                    case '13':
                        return 'assets/icons/temp_alert.png';
                    case '14':
                    case '18': //Presion
                        return 'assets/icons/pressure-gauge.png';
                    case '15': 
                        return 'assets/icons/valve.png';
                    case '17': //Dimmer
                        return 'assets/icons/dimmer.png';
                    case '20': //Dimmer
                        return 'assets/icons/apertura.png';
                    case '27': //variador de velocidad
                        return 'assets/icons/icon_engine.png';
                    case '28': //sensor
                        return 'assets/icons/icon_sensor.png';
                    case '32': // DMS
                        return [ true, 'ion-ios-gear' ]
                    default:
                        return 'assets/icons/icon_default.png';
                }
            },
            optionsEnergyTabs: [
                {
                    type: 'activeEnergy',
                    status: false,
                    name: 'Energía Activa'
                },
                {
                    type: 'reactiveEnergy',
                    status: false,
                    name: 'Energía Reactiva'
                },
                {
                    type: 'power',
                    status: false,
                    name: 'Potencia'
                },
                {
                    type: 'current',
                    status: false,
                    name: 'Corriente'

                },
                {
                    type: 'voltage',
                    status: true,
                    name: 'Voltaje'
                },
                {
                    type: 'frequency',
                    status: false,
                    name: 'Frecuencia'
                },
                {
                    type: 'powerFactor',
                    status: false,
                    name: 'Factor de Potencia'
                },
                {
                    type: 'thdV',
                    status: false,
                    name: 'THD Voltaje'
                },
                {
                    type: 'thdC',
                    status: false,
                    name: 'THD Corriente'
                }
            ],
            optionsHeloSPlusTabs: [
                {
                    type: 'power',
                    status: false,
                    name: 'Potencia'
                },
                {
                    type: 'current',
                    status: false,
                    name: 'Corriente'

                },
                {
                    type: 'voltage',
                    status: true,
                    name: 'Voltaje'
                },
                {
                    type: 'powerFactor',
                    status: false,
                    name: 'Factor de Potencia'
                },
            ],
            graphType: undefined,

            setUnit: function(parm) {
                switch(parm){
                    case 'opening':
                    case 'relay':
                    case 'presence':
                    case 'comms':
                    case 'fan':
                    case 'mode':
                    case 'error':
                        return 'Estado';
                    case 'temp':
                    case 'Tin':
                    case 'Tout':
                    case 'DeltaT':
                        return 'Temp °C';
                    case 'flowM3h':
                        return 'Gpm';
                    case 'consumption':
                        return 'W';
                    case 'energyTerm':
                        return 'GJ/h';
                    case 'voltageVariator':
                        return 'V';
                    case 'currentVariator':
                        return 'C';
                    case 'use':
                        return 'Horas';
                    case 'behavior':
                        return 'SetPoint'
                    case 'humidity':
                        return 'Humedad %';
                    case 'pressurePSI':
                        return 'Presión PSI';
                    case 'mpx':
                        return'Temperatura °C';
                    case 'frec_set':
                        return 'Frecuencia Hz';
                    case 'pm1p0':
                        return 'PM 1.0ug/m3';
                    case 'pm2p5':
                        return 'PM 2.5ug/m3';
                    case 'pm4p0':
                        return 'PM 4.0ug/m3';
                    case 'pm10p0':
                        return 'PM 10.0ug/m3';
                    case 'voc': 
                        return 'VOC Index';
                    case 'nox':
                        return 'NOx Index'
                    default:
                        return '';
                }
            },

            setIndicadoresGrafica: function(type) {
                switch (type) {
                    case 'temp':
                    case 'Tin':
                    case 'Tout':
                    case 'DeltaT':
                        return {
                            inds: ['Promedio', 'Máximo', 'Mínimo', 'Umbral Superior', 'Umbral Inferior'],
                            unit: 'C°',
                            initial_value: '--',
                        }
                    case 'humidity':
                        return {
                            inds: ['Promedio', 'Máximo', 'Mínimo'],
                            unit: '%',
                            initial_value: '--',
                        }
                    case 'pressure':
                        return {
                            inds: ['Promedio', 'Máximo', 'Mínimo'],
                            unit: 'Bar',
                            initial_value: '--',
                        }
                    default:
                        return {};
                }
            },

            variables: [
                {
                    type: 'temp',
                    status: true,
                    name: 'Temperatura',
                    id: '10',
                    nitname: 'Temp',
                    unidad: '°C',
                },
                {
                    type: 'humidity',
                    status: false,
                    name: 'Humedad',
                    id: '11',
                    nitname: 'Hum',
                    unidad: '%',
                },
                {
                    type: 'pm1p0',
                    status: false,
                    name: 'PM 1.0 ug/m3',
                    id: '45',
                    nitname: 'PM 1.0',
                    unidad: 'ug/m3',
                },
                {
                    type: 'pm2p5',
                    status: false,
                    name: 'PM 2.5 ug/m3',
                    id: '46',
                    nitname: 'PM 2.5',
                    unidad: 'ug/m3',
                },
                {
                    type: 'pm4p0',
                    status: false,
                    name: 'PM 4.0 ug/m3',
                    id: '47',
                    nitname: 'Pm 4.0',
                    unidad: 'ug/m3',
                },
                {
                    type: 'pm10p0',
                    status: false,
                    name: 'PM 10.0 ug/m3',
                    id: '48',
                    nitname: 'Pm 10.0',
                    unidad: 'ug/m3',
                },
                {
                    type: 'voc',
                    status: false,
                    name: 'VoC',
                    id: '49',
                    nitname: 'VoC',
                    unidad: '',
                },
                {
                    type: 'nox',
                    status: false,
                    name: 'Óxido nítrico',
                    id: '50',
                    nitname: 'NoX',
                    unidad: '',
                },
                {
                    type: 'behavior',
                    status: false,
                    name: 'Setpoint',
                    id: '1',
                    nitname: 'SepPoint',
                    unidad: '°C',
                },
                {
                    type: 'error',
                    name: 'Error',
                    id: '59',
                    status: true,
                },
                
            ],

            getVaribleByID: function(id){
                var variables = Array.from(this.variables);

                var variable = variables.filter(function(variable){
                    return variable.id === id;
                })

                return variable;

            }


        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('estadisticas_zonaCtrl', estadisticas_zonaCtrl);

    /** @ngInject */
    function estadisticas_zonaCtrl($scope, RESTServices, SHAREServices, $filter, $localStorage, $stateParams, $rootScope, statisticsServices, $timeout) {

        $scope.nombre_zona = $stateParams.nombre ? $stateParams.nombre : $localStorage.nombre_zona;
        $scope.id_zona = $stateParams.id_zona ? $stateParams.id_zona : $localStorage.id_zona;
        $scope.showDevices = false;
        
        $scope.evento = 'updateDevice';
        $scope.noData = true;
        SHAREServices.zona = {
            nombre: $stateParams.nombre,
            id: $stateParams.id_zona
        }
        if($stateParams.id_zona){
            $localStorage.id_zona = $stateParams.id_zona;
            $localStorage.nombre_zona = $stateParams.nombre;
        }

        SHAREServices.diaDatepicker = $filter('date')(new Date(), 'yyyy-MM-dd');

        $scope.$watch(function() {
            return SHAREServices.flagConsumo_aire;
        }, function() {
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
        });

        RESTServices.fetchDevicesByZone($scope.id_zona).then(function(res) {
            if (res.code == '200') {
                $scope.dispositivos = res.dispositivos;
                $scope.dispositivos.map(function(d) {
                    d.image = statisticsServices.setIcon(d.tipo);
                    d.status = false;
                    d.id = d.id_dispositivo ? d.id_dispositivo : d.id;
                    d.agrupados = d.agrupados ? d.agrupados : null;
                    d.canales = [];
                    return d;
                });
                $scope.dispositivos = $filter('orderBy')($scope.dispositivos, 'nombre');
                $scope.dispositivos.map(function(d){
                    if (d.agrupados) {
                        d.agrupados.forEach(function(a){
                            var item = $scope.dispositivos.find(function(i){
                                return i.id === a.id;
                            })
                            d.canales.push(item);
                            var index = $scope.dispositivos.findIndex(function(j){ return j.id === item.id});
                            $scope.dispositivos.splice(index, 1);
                        })
                    }
                })
                if($stateParams.id_device){
                    var index = $scope.dispositivos.findIndex(function(device){return device.id === $stateParams.id_device})
                    $scope.dispositivos[index].status = true;
                }else {
                    $scope.dispositivos[0].status = true;
                }
                
                SHAREServices.dispositivo_selected = $stateParams.id_device ? $scope.dispositivos.filter(function(d) { return d.id === $stateParams.id_device})[0] : $scope.dispositivos[0];
                $scope.device = SHAREServices.dispositivo_selected;
                SHAREServices.zona.id = $stateParams.id_zona ? $stateParams.id_zona : $scope.dispositivos[0].id_zona;
                var dispositivo = $stateParams.id_device ? $scope.dispositivos.filter(function(d) { return d.id === $stateParams.id_device})[0] : $scope.dispositivos[0];
                $rootScope.$broadcast('updateDevice', {data: dispositivo, dispositivos: $scope.dispositivos});   

                            
            }
        });
        
        $scope.$on('noGraph', function(e, res){
            if(!res.ind) {
                $scope.noData = false;
            }
        })

        $scope.$on('updateDevice', function(e, res){
            if(res.data){
                $scope.device = res.data;
            }
        })

        $scope.subMenu = [
            {
                id: 0,
                name: 'Dispositivos',
                icon: '../../../../assets/icons/devices.svg',
                status: false,
            },
        ];

        $scope.selectSubMenu = function(ind) {
            $scope.subMenu.map(function(s){ s.status = false})
            $scope.showDevices = !$scope.showDevices;
            $scope.showZones = false;
            $scope.subMenu[0].status = $scope.showDevices;
            
        }

        $scope.$on('closeComponent', function(e, res) {
            $timeout(function() {
                $scope.subMenu.map(function(s){ s.status = false})
                $scope.showDevices = false;
            },500)
            
        })

    }


})();
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.dashboard_cliente')
      .directive('graficaComparativaAhorro', graficaComparativaAhorro);

  /** @ngInject */
  function graficaComparativaAhorro() {
    return {
      restrict: 'E',
      controller: 'graficaComparativaAhorroCtrl',
      templateUrl: 'app/cliente/dashboard-cliente/graficaComparativaAhorro/graficaComparativaAhorro.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.dashboard_cliente')
      .controller('graficaComparativaAhorroCtrl', graficaComparativaAhorroCtrl);

  /** @ngInject */
  function graficaComparativaAhorroCtrl($scope, SHAREServices) {

    $scope.verGrafica = true;
    //$scope.verGraficaBars = false;
    $scope.loading = false;
    $scope.noInfo = false;
    $scope.errorFecha1 = false;
    $scope.errorFecha2 = false;
    $scope.fechaB = {};
    $scope.fechaB.dt = new Date();
    $scope.fechaD_1 = {};
    $scope.fechaD_1.dt = new Date();
    var dt = new Date();
    var m = dt.setMonth($scope.fechaD_1.dt.getMonth() - 1);
    $scope.fechaD_2 = {};
    $scope.fechaD_2.dt = new Date(m);
    var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
    $scope.DateFormatB = formato.year;
    $scope.DateFormatD = formato.month;

    ///////control datepicker grafica donut
    $scope.open = open;
    $scope.open_2 = open_2;

    $scope.options = {
        showWeeks: false,
        minMode: 'month',
        maxDate: new Date()
    };

    $scope.popup = {
        opened: false
    };

    function open() {
        $scope.popup.opened = true;
    }
    $scope.popup_2 = {
        opened: false
    };

    function open_2() {
        $scope.popup_2.opened = true;
    }

    ///////control datepicker grafica bars
    $scope.open2 = open2;

    $scope.options2 = {
        showWeeks: false,
        minMode: 'year',
        maxDate: new Date()
    };

    $scope.popup2 = {
        opened: false
    };

    function open2() {
        $scope.popup2.opened = true;
    }





    $scope.graficaAhorro = function(parm){
      if(parm == 0){
        $scope.verGrafica = !$scope.verGrafica;
        //$scope.verGraficaBars = false;
      }
      if(parm == 1){
        $scope.verGrafica = !$scope.verGrafica;
        //$scope.verGraficaDonut = false;
        //$scope.verGraficaBars = true;
      }
    }

    $scope.consultaAhorro = function(fecha1, fecha2){
      if(fecha1 == undefined || fecha1 == null){
        $scope.errorFecha1 = true;
      }else if(fecha2 == undefined || fecha2 == null){
        $scope.errorFecha2 = true;
      }else{
        $scope.errorFecha1 = false;
        $scope.errorFecha2 = false;
      }
 
    }


    ///////CONSTRUCTOR GRAFICA
    ////Grafica donut

    var chart = AmCharts.makeChart( "graficaDonut", {
      "type": "pie",
      "theme": "light",
      "growSlices": true,
      "dataProvider": [{
        "category": "enero",
        "value": 10
      }, {
        "category": "Diciembre",
        "value": 8
      }],
      "valueField": "value",
      "titleField": "category",
      "labelRadiusField": "labelRadius",
      "labelRadius": 5,
      "alphaField": "alpha",
      "startDuration": 0,
      "radius": "30%",
      "innerRadius": "40%",
      "labelText": "[[title]]",
      "legend":{
        "position":"bottom",
        "marginRight":0,
        "marginTop":0,
        "autoMargins":false
      },
      "colors":[
        "#0C98F2",
        "#AF4848"
      ]

    });

    var chart2 = AmCharts.makeChart( "graficaBarras", {
      "type": "serial",
      "theme": "light",
      "dataProvider": [ {
        "country": "USA",
        "visits": 2025
      }, {
        "country": "China",
        "visits": 1882
      }, {
        "country": "Japan",
        "visits": 1809
      }, {
        "country": "Germany",
        "visits": 1322
      }, {
        "country": "UK",
        "visits": 1122
      }, {
        "country": "France",
        "visits": 1114
      }, {
        "country": "India",
        "visits": 984
      }, {
        "country": "Spain",
        "visits": 711
      }, {
        "country": "Netherlands",
        "visits": 665
      }, {
        "country": "Russia",
        "visits": 580
      }, {
        "country": "South Korea",
        "visits": 443
      }, {
        "country": "Canada",
        "visits": 441
      }, {
        "country": "Brazil",
        "visits": 395
      } ],
      "valueAxes": [ {
        "gridColor": "#FFFFFF",
        "gridAlpha": 0.2,
        "dashLength": 0
      } ],
      "gridAboveGraphs": true,
      "startDuration": 1,
      "graphs": [ {
        "balloonText": "[[category]]: <b>[[value]]</b>",
        "fillAlphas": 0.8,
        "lineAlpha": 0.2,
        "type": "column",
        "valueField": "visits"
      } ],
      "chartCursor": {
        "categoryBalloonEnabled": false,
        "cursorAlpha": 0,
        "zoomable": false
      },
      "categoryField": "country",
      "categoryAxis": {
        "gridPosition": "start",
        "gridAlpha": 0,
        "tickPosition": "start",
        "tickLength": 20
      },
      "export": {
        "enabled": true
      },
      "colors":["#EA4747"]

    } );


















   /* $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;

    $scope.$watch(function(){
       return SHAREServices.donaInfo;
    }, function(newValue, oldValue){
        if(newValue[0]!= undefined){
            $scope.value1 = newValue[0].value1;
            $scope.value2 = newValue[0].value2;
            $scope.label1 = newValue[0].label1;
            $scope.label2 = newValue[0].label2;
            
            /*$scope.doughnutData = [
              {
                value: $scope.value1,
                color: "#25684B",
                highlight: "#25684B",
                label: $scope.label1,
                percentage: 87,
                order: 1,
              }, {
                value: $scope.value2,
                color: "#53ECAA",
                highlight: "#53ECAA",
                label: $scope.label2,
                percentage: 22,
                order: 2,
              }
            ];

            var ctx = document.getElementById('chart-area').getContext('2d');
            if(window.myDoughnut != undefined){
                window.myDoughnut.destroy();
            }
            window.myDoughnut = new Chart(ctx).Doughnut($scope.doughnutData, {
              segmentShowStroke: false,
              percentageInnerCutout : 64,
              responsive: true
            });
        }
    });*/


  }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('moveDevicesCtrl', moveDevicesCtrl);

    /** @ngInject */

    function moveDevicesCtrl($scope, $stateParams, RESTServices, $filter, $localStorage, $timeout, SHAREServices, $state, toastr) {
        
        $scope.zonas = [];
        $scope.filtered = [];
        $scope.loading = true;
        $scope.validatedList = false;
        $scope.disabled = false;
        $scope.move = {
            id_zona: '',
            devices: [],
        }
        if($localStorage.rol !== '7' && $localStorage.rol !== '6'){
            $state.go('dashboard_cliente')
        }
        if($stateParams.devices === null) {
            $state.go('dashboard_cliente.projects');    
        }

        $scope.devices = $stateParams.devices;

        //////////////////

        // Rejection reasons returned by POST /zones/{zoneID}/devices/move (409).
        var REJECTION_REASONS = {
            not_found: 'no existe o no tienes acceso',
            hub_device: 'es un hub y no se puede mover',
            group_split: 'pertenece a un grupo; muévelo junto con todo el grupo'
        };

        function deviceName(id) {
            var found = ($scope.devices || []).filter(function(d) {
                return String(d.id_device ? d.id_device : d.id) === String(id) || String(d.id) === String(id);
            })[0];
            return found && found.nombre ? found.nombre : 'Dispositivo ' + id;
        }

        function moveErrorMessage(err) {
            var status = err && err.status;
            var data = (err && err.data) || {};
            if (status === 403) {
                return 'No tienes permisos para mover dispositivos a esta zona.';
            }
            if (status === 409 && data.error === 'destination_has_hub') {
                return 'La zona destino ya tiene un hub; no se puede mover dispositivos a ella.';
            }
            if (status === 409 && data.rejected && data.rejected.length) {
                var lines = data.rejected.map(function(r) {
                    return deviceName(r.id) + ': ' + (REJECTION_REASONS[r.reason] || r.reason);
                });
                return 'No se movió ningún dispositivo. ' + lines.join('; ') + '.';
            }
            return 'No se pudieron mover los dispositivos. Inténtalo de nuevo.';
        }

        $scope.moveDevices = function() {
            $scope.disabled = true;
            var ids = $scope.move.devices.map(function(d) {
                return d.id_device ? d.id_device : d.id;
            });

            RESTServices.moveZoneDevicesV2($scope.move.id_zona, ids).then(function() {
                toastr.success('Dispositivos movidos correctamente');
                $state.go('dashboard_cliente.projects');
            }).catch(function(err) {
                $scope.disabled = false;
                toastr.error(moveErrorMessage(err));
            });
        }

        // The destination select must not offer the zone the devices already live in.
        function withoutCurrentZone(zonas) {
            var current = SHAREServices.zona && SHAREServices.zona.id;
            if (current === undefined || current === null || current === '') {
                return zonas;
            }
            return zonas.filter(function(z) {
                return String(z.id) !== String(current);
            });
        }

        $scope.cancelar = function() {
            $state.go('dashboard_cliente.projects');
        }

        $timeout(function() {

            $scope.devices.map(function(f){ 
                f.status = false;
                return f;
            })

            if (SHAREServices.zonas === null) {
                var params = {
                    "id_usuario": $localStorage.id_usuario,
                };
                ////query zonas
                RESTServices.fetchClientZones().then(function(data) {
                    if (data != null && data.code == '200') {
                        if(data.zonas) {
                            $scope.zonas = data.zonas;
                        } 
                        if(data.zonas_externas) {
                            $scope.zonas = $scope.zonas.concat(data.zonas_externas)
                        }
                        $scope.zonas = $filter('orderBy')($scope.zonas, 'nombre');
                        $scope.zonas = $filter('filter')($scope.zonas, {h : '0'});
                        $scope.zonas = $scope.zonas.map(function(z, i) {
                            z.index = i;
                            z.status = false;
                            return z;
                        })
                        
                        SHAREServices.zonas = $scope.zonas;
                        $scope.zonas = withoutCurrentZone($scope.zonas);
                        $scope.loading = false; 
                    }else{
                        $scope.noInfo = true;
                    }
                });
            } else {
                $scope.zonas = SHAREServices.zonas; 
                $scope.zonas = $scope.zonas.map(function(z, i) {
                    z.index = i;
                    z.status = false;
                    return z;
                });
                $scope.zonas = withoutCurrentZone($scope.zonas);
                $scope.loading = false;
                
            } 
           

            
        });

        

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('newProjectCtrl', newProjectCtrl);

    /** @ngInject */

    function newProjectCtrl($scope, $stateParams, $q, RESTServices, $filter, $localStorage, $timeout, SHAREServices, $state, toastr) {
        
        $scope.zonas = [];
        $scope.filtered = [];
        $scope.loading = true;
        $scope.loading_t = true;
        $scope.noInfo = false;
        $scope.edit_mode = false;
        $scope.validatedList = false;
        $scope.disabled = false;
        $scope.project = {
            imagen: '',
            nombre: '',
            zonas: [],
            tecnicos: [],
            id: 0,
        }
        if($localStorage.rol !== '7' && $localStorage.rol !== '6'){
            $state.go('dashboard_cliente')
        }

        $scope.file;
        var selected_zones_original = [];
        var selected_users_original = [];
        var zonas = [];

        $scope.validatedList_2 = false;
        //////////////////

        $scope.addProject = function() {
            $scope.disabled = true;
            if($scope.project.imagen === '' || validarURL($scope.project.imagen)){
                createProject($scope.project.imagen);
            } else {
                uploadImage($scope.file);
            }
        }

        function createProject(imagen) {

            var project = {
                nombre: $scope.project.nombre,
                imagen: imagen,
                id: $scope.project.id,
            }

            // v2: migrated from cliente/edita_proyecto.php
            RESTServices.saveProjectV2(project).then(function(res) {
                var newId = res.data && res.data.id;
                if (newId) {
                    addZones(newId);
                    addUsers($scope.project.tecnicos, newId);
                } else {
                    addZones($scope.project.id);
                    addUsers($scope.project.tecnicos, $scope.project.id);
                }
            }).catch(function() {
                toastr.error('No se puede conectar en este momento', 'Nuevo Proyecto');
                $scope.disabled = false;
            });
        }

        function uploadImage(file) {
            ////////comprimir la imagen
            new Compressor(file, {
                quality: 0.2,
                success: function(result) {
                    var imagen = new File([result], result.name, { type: result.type });
                    getURL(imagen)
                } 
            });
            ////subir la imagen al servidor multimedia (Backblaze) para obterner la URL
            function getURL(imagen) {
                var r = new FileReader();
                r.onload = function (e) {
                    var hash = CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(e.target.result));
                    $q.resolve(RESTServices.getURL(imagen,hash)).then(function(url){
                        /////crear el proyecto junto con la imagen
                        createProject(url)
                    })
                    .catch(function(e){
                        toastr.error('Hubo un problema inesperado con el servidor');
                        $timeout(function () {
                            document.getElementById('file').value = '';
                        });  
                    });
                }
                r.readAsBinaryString(imagen);
            }

        }

        function addZones(id_proyecto) {
            if(arrayIgual($scope.project.zonas, selected_zones_original) || $scope.project.zonas.length === 0) {
                toastr.success('Proyecto Editado con éxito', 'Proyectos');
                $state.go('dashboard_cliente.projects');
                $scope.disabled = false;
                return;
            } else {
                var zones_to_unlink = compararArreglosPorId($scope.project.zonas, selected_zones_original);
                var zones_to_link = compararArreglosPorId(selected_zones_original, $scope.project.zonas);
                if(zones_to_unlink.length > 0) {
                    callService(0, zones_to_unlink)
                }
                if(zones_to_link.length > 0) {
                    callService(1, zones_to_link);
                }
                
            }

            function callService(ind, zonas) {
                var zoneIds = zonas.map(function(s){return s.id});

                // ind: 1 = link, 0 = unlink
                var request = ind === 1
                    ? RESTServices.addProjectZonesV2(id_proyecto, zoneIds)
                    : RESTServices.removeProjectZonesV2(id_proyecto, zoneIds);

                request.then(function(res) {
                    // The envelope is 2xx; each zone carries its own status in results[].
                    var results = (res && res.data && res.data.results) || [];
                    var allOk = results.length > 0 && results.every(function(item){ return item.status === 200; });
                    if (allOk) {
                        toastr.success('Proyecto creado con éxito', 'Nuevo proyecto');
                        $state.go('dashboard_cliente.projects');
                    }else{
                        toastr.error('Ha ocurrido un error al agregar el proyecto', 'Proyectos');
                    }
                }).catch(function() {
                    toastr.error('Ha ocurrido un error al agregar el proyecto', 'Proyectos');
                });
            }
        }

        function addUsers(users, id_proyecto) {
            if(users !== null) {
                if(arrayIgual(users, selected_users_original)) {
                    return;
                } else {
                    var users_to_unlink = compararArreglosPorId(users, selected_users_original);
                    var users_to_link = compararArreglosPorId(selected_users_original, users);
                    if(users_to_unlink.length > 0) {
                        callServicsUsers(0, users_to_unlink)
                    }
                    if(users_to_link.length > 0) {
                        callServicsUsers(1, users_to_link);
                    }
                    
                }

                function callServicsUsers(ind, users) {
                    if(users.length > 0) {
                        var promesas = users.map(function(u){
                            // ind: 1 = share, 0 = revoke
                            return ind === 1
                                ? RESTServices.addProjectUserV2(u.email, id_proyecto)
                                : RESTServices.revokeProjectUserV2(u.email, id_proyecto);
                        })

                        $q.all(promesas).then(function(res){
                            // Each response carries per-project results[]; success only if every item is 200.
                            var allOk = res.every(function(r){
                                var results = (r && r.data && r.data.results) || [];
                                return results.length > 0 && results.every(function(item){ return item.status === 200; });
                            });
                            if(allOk){
                                toastr.success('Usuarios agregados con éxito', 'Nuevo proyecto');
                            }else {
                                toastr.error('Ha ocurrido un error al agregar usuarios al proyecto', 'Proyectos');
                            }
                        }).catch(function(){
                            toastr.error('Ha ocurrido un error al agregar usuarios al proyecto', 'Proyectos');
                        });
                    }
                } 
            }
        }

        $scope.cancelar = function() {
            $state.go('dashboard_cliente.projects');
        }
       

        function compararArreglosPorId(nuevo, original) {
            var idsNuevo = nuevo.map(function(obj) { return obj.id});
            var objetosNoEncontrados = original.filter(function(obj) {return !idsNuevo.includes(obj.id)} );
            return objetosNoEncontrados;
        }

        function arrayIgual(array1, array2) {
            var idsArray1 = array1.map(function(obj) { return obj.id});
            var idsArray2 = array2.map(function(obj) { return obj.id});
            return JSON.stringify(idsArray1.sort()) == JSON.stringify(idsArray2.sort())
        }

        function validarURL(imagen) {
            var regex = new RegExp("^(http|https)://([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}(/[a-zA-Z0-9-_.~!*'();:@&=+$,%#]+)*$");
            return regex.test(imagen);
        }

        $timeout(function() {

            if($stateParams.project) {
                $scope.edit_mode = true;
                $scope.project = $stateParams.project;
                if($scope.project.tecnicos){
                    selected_users_original = $scope.project.tecnicos;
                }
                
            }

            if (SHAREServices.zonas === null) {
                var params = {
                    "id_usuario": $localStorage.id_usuario,
                };
                ////query zonas
                RESTServices.fetchClientZones().then(function(data) {
                    if (data != null && data.code == '200') {
                        if(data.zonas) {
                            zonas = data.zonas;
                        } 
                        if(data.zonas_externas) {
                            zonas = zonas.concat(data.zonas_externas)
                        }
                        zonas = $filter('orderBy')(zonas, 'nombre');
                        zonas = $filter('filter')(zonas, {h : '0'});
                        zonas = zonas.map(function(z, i) {
                            z.index = i;
                            z.status = false;
                            return z;
                        })
                        
                        $scope.zonas = zonas;
                        SHAREServices.zonas = $scope.zonas;
                        if($scope.edit_mode) {
                            $scope.validatedList = true;
                            getProjectzones($scope.project.id)
                        }else {
                            $scope.loading = false;
                        } 
                    }else{
                        $scope.noInfo = true;
                    }
                });
            } else {
                zonas = SHAREServices.zonas; 
                zonas = zonas.map(function(z, i) {
                    z.index = i;
                    z.status = false;
                    return z;
                });

                $scope.zonas = zonas;

                if($scope.edit_mode) {
                    $scope.validatedList = true;
                    getProjectzones($scope.project.id)
                }else {
                    $scope.loading = false;
                }  
                
            } 
            var params = {
                "id_usuario": $localStorage.id_usuario,
                "id_monitoreo": 0,
            };

            RESTServices.post_header('cliente/consulta_tecnicos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code == '200') {
                    $scope.tecnicos = data.tecnicos;
                    $scope.loading_t = false;
                    if($scope.edit_mode && $scope.project.tecnicos){
                        $scope.project.tecnicos.forEach(function(z_p) {
                            var index = $scope.tecnicos.findIndex(function(z){
                                return z.id === z_p.id
                            })
                            if(index >= 0) {
                                $scope.tecnicos[index].status = true;
                            }
                        })
                    }
                    
                }  

            }); 
        });

        $scope.getFile = function() {
            $scope.file = document.getElementById('file').files[0];
            var reader = new FileReader();
            reader.onload = function (e) {
                $scope.project.imagen = e.target.result;
                $scope.$apply();
            };
            reader.readAsDataURL($scope.file);
        }

        function getProjectzones(id) {
            $scope.loading = true;
            // v2: migrated from cliente/consulta_zonasxproyecto.php
            RESTServices.fetchProjectZonesV2(id).then(function(data) {
                var zonas = data.zonas || [];
                selected_zones_original = zonas;
                $scope.project.zonas = zonas;
                zonas.forEach(function(z_p) {
                    var index = $scope.zonas.findIndex(function(z){
                        return z.id === z_p.id
                    })
                    if(index >= 0) {
                        $scope.zonas[index].status = true;
                    }
                })
                $scope.zonas.sort(function(a, b) {
                    // Colocar primero los objetos con status true
                    if (a.status && !b.status) {
                      return -1; // a debe ir antes que b
                    } else if (!a.status && b.status) {
                      return 1; // b debe ir antes que a
                    } else {
                      return 0; // no se cambia el orden
                    }
                });
                $scope.loading = false;
            }).catch(function() {
                $scope.loading = false;
            })
        }

    }


})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('newZoneCtrl', newZoneCtrl);

    /** @ngInject */
    function newZoneCtrl($scope, RESTServices, $localStorage, $stateParams, $state, toastr, ngDialog, $rootScope,SHAREServices, zoneSharingServices) {
        
        var zoneScope = $scope;
        $scope.newZone = {};
        $scope.users = [];

        // Everybody with access to the zone: entity users (source 'entity') and
        // shares (source 'shared', estado 2 = pending). Replaces the shares-only
        // list so entity users are no longer invisible (and can be deduped).
        $scope.loadAccess = function() {
            return RESTServices.fetchZoneAccessV2($stateParams.zone.id).then(function(res) {
                if (res.code == 200) {
                    $scope.users = res.users;
                } else if (res.code == 300) {
                    $scope.users = [];
                }
            });
        };

        // Entity users always have control (they are not limited by usuario_zona.rol);
        // only a share is view-only (rol 5).
        $scope.accessLabel = function(user) {
            if (user.source === 'entity') {
                return 'Control';
            }
            return user.rol == 0 ? 'Control' : 'Visualización';
        };

        // Only a share can be revoked from here; entity users cannot.
        $scope.canRevoke = function(user) {
            return user.revocable === true;
        };

        function sameEmail(a, b) {
            return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
        }

        if($stateParams.zone != null){
            RESTServices.getCountries().then(function(res){
                $scope.paises = res;
            })
            $scope.newZone.nombre = $stateParams.zone.nombre;
            $scope.newZone.pais = $stateParams.zone.id_pais;
            $scope.loadAccess();

        }
        
        $scope.deteleUser = function(user){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Desea borrar usuario?',

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.aceptar = function() {
                        // v2: migrated from cliente/elimina_usuario_zona.php
                        // (bulk endpoint; single zone here, so results[0].status
                        // decides success).
                        RESTServices.revokeZoneUserV2(user.email, $stateParams.zone.id).then(function(res) {
                            var results = (res.data && res.data.results) || [];
                            var ok = results.length > 0 && results[0].status === 200;
                            if (ok) {
                                ngDialog.close();
                                zoneScope.loadAccess();
                                toastr.success('El usuario ha sido borrado', 'Gestión de usuarios');
                            } else {
                                toastr.error('Ha ocurrido un error al eliminar el usuario', 'Gestión de usuarios');
                            }
                        }).catch(function() {
                            toastr.error('Ha ocurrido un error al eliminar el usuario', 'Gestión de usuarios');
                        });
                    }

                }]
            });
        }

        $scope.nuevoUser = function(){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/newUser.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.addUser = function(user) {

                        var existing = zoneScope.users.filter(function(u){return sameEmail(u.email, user.email)});
                        if(existing.length > 0){
                            ngDialog.close();
                            toastr.error('Usuario ya ha sido agregado', 'Gestión de usuarios');
                        }else if(sameEmail($localStorage.email, user.email)){
                            ngDialog.close();
                            toastr.error('No puedes agregar tu propio email a una zona', 'Gestión de usuarios');
                        }else if(zoneSharingServices.emailTooLong(user.email)){
                            ngDialog.close();
                            toastr.error('El correo es demasiado largo (máximo ' + zoneSharingServices.maxEmailChars + ' caracteres): ' + user.email, 'Gestión de usuarios');
                        }else{
                            ngDialog.close();
                            var rol = user.rol == 'control' ? 0 : 5;

                            // Bulk endpoint with one email and one zone: results[0]
                            // carries the outcome (created | already_has_access).
                            RESTServices.addZoneUsersBulkV2([user.email], rol, [$stateParams.zone.id]).then(function(res) {
                                var results = (res.data && res.data.results) || [];
                                var ok = results.length > 0 && results[0].status === 200;
                                if (ok) {
                                    if (results[0].outcome === 'already_has_access') {
                                        toastr.info('El usuario ya tiene acceso a esta zona', 'Gestión de usuarios');
                                    } else {
                                        toastr.success('Usuario agregado', 'Gestión de usuarios');
                                    }
                                    zoneScope.loadAccess();
                                }else{
                                    toastr.error('Ha ocurrido un error al agregar el usuario', 'Gestión de usuarios');
                                }
                            }).catch(function() {
                                toastr.error('Ha ocurrido un error al agregar el usuario', 'Gestión de usuarios');
                            });
                        }
                        
                        
                    }

                }]
            });
        }

        $scope.editZone = function(zone){
            var params = {
                id_usuario: $localStorage.id_usuario,
                id_zona: $stateParams.zone.id,
                nombre: zone.nombre,
                id_pais: zone.pais,
            };
            RESTServices.post_header('instalador/edita_zona.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == 200) {
                    $rootScope.$broadcast('ZoneEdited', {nuevo: zone, viejo: $stateParams.zone});
                    SHAREServices.zonas = null;
                    toastr.success('Se ha editado la zona correctamente', 'Gestión de zonas');
                    $state.go('dashboard_cliente');
                }else{
                    toastr.error('No se pudo editar la zona', 'Ha ocurrido un error');
                }
            });
        }


        $scope.cancelar = function(){
            $state.go('dashboard_cliente');
        }


    }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.dashboard_cliente')
      .controller('oferta_operadorCtrl', oferta_operadorCtrl);

  /** @ngInject */
  function oferta_operadorCtrl($scope, RESTServices, $localStorage, $filter, ngDialog) {
  	$scope.oneAtATime = true;

  ////Agreglo con las ofertas de desconexión generado por el comercializador
  	$scope.ofertas = [
	    {
	      hora_in: '11:00',
	      hora_fin: '12:00',
	      valor_oferta: 200,
	      total_oferta: 0,
        fecha_limite:'12/06/2017',
        id: 0,
        potencia_total_zonas:4500,
        carga_progressbar:0,
        porcentaje_carga:0,
        zonas: [
                { 
                  index:0,
                  estado:false,
                  nombre:"pasillo",
                  carga_zona:0,
                  dispositivos:[
                      {
                        "nombre":"dispo_1",
                        "valor": 100,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_2",
                        "valor": 200,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_3",
                        "valor": 300,
                        "estado":false
                      }
                    ]
                },
                {
                  index:1,
                  estado:false,
                  nombre:"Lobby",
                  carga_zona:0,
                  dispositivos:[
                      {
                        "nombre":"dispo_4",
                        "valor": 400,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_5",
                        "valor": 500,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_6",
                        "valor": 600,
                        "estado":false
                      }
                    ]
                },
                {
                  index:2,
                  estado:false,
                  nombre:"hab 8",
                  carga_zona:0,
                  dispositivos:[
                      {
                        "nombre":"dispo_7",
                        "valor": 700,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_8",
                        "valor": 800,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_9",
                        "valor": 900,
                        "estado":false
                      }
                    ]
                }
              ]
        
      },
	    {
        hora_in: '11:00',
        hora_fin: '12:00',
        valor_oferta: 200,
        total_oferta: 0,
        fecha_limite:'13/06/2017',
        id: 1,
        potencia_total_zonas:4500,
        carga_progressbar:0,
        porcentaje_carga:0,
        zonas: [
                {
                  index:0,
                  estado:false,
                  nombre:"pasillo",
                  carga_zona:0,
                  dispositivos:[
                      {
                        "nombre":"dispo_1",
                        "valor": 100,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_2",
                        "valor": 200,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_3",
                        "valor": 300,
                        "estado":false
                      }
                    ]
                },
                {
                  index:1,
                  estado:false,
                  nombre:"Lobby",
                  carga_zona:0,
                  dispositivos:[
                      {
                        "nombre":"dispo_4",
                        "valor": 400,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_5",
                        "valor": 500,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_6",
                        "valor": 600,
                        "estado":false
                      }
                    ]
                },
                {
                  index:2,
                  estado:false,
                  nombre:"hab 8",
                  carga_zona:0,
                  dispositivos:[
                      {
                        "nombre":"dispo_7",
                        "valor": 700,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_8",
                        "valor": 800,
                        "estado":false
                      },
                      {
                        "nombre":"dispo_9",
                        "valor": 900,
                        "estado":false
                      }
                    ]
                }
              ]
        
      },

	  ];

////Función que me despliega los dispositivos disponibles en cada zona
    $scope.showDis = function(index, p1){
  		var zona = angular.element(document.querySelector("#flag_dis_o"+index+p1));
  		var flecha = angular.element(document.querySelector("#flecha_o"+index+p1));
		
			if(zona.hasClass("display_none")){
				zona.removeClass("display_none");
				zona.addClass("display_block");
				flecha.removeClass("ion-ios-arrow-up");
				flecha.addClass("ion-ios-arrow-down");
			}else{
				zona.addClass("display_none");
				zona.removeClass("display_block");
				flecha.addClass("ion-ios-arrow-up");
				flecha.removeClass("ion-ios-arrow-down");	
			}
	  };

  ////Función que controla la carga desde el checkbox de la zona
    $scope.enviar_carga = function(zona, p1){

      var ind_valor = angular.element(document.querySelector("#ind-valor-"+p1));

      if(zona.estado && $scope.ofertas[p1].carga_progressbar>=0 ){
        var x=0; 
        var i;
          for (i = 0; i < zona.dispositivos.length; i++) {
                if(zona.dispositivos[i].estado==false){ 
                  x = x + zona.dispositivos[i].valor;
                  $scope.ofertas[p1].zonas[zona.index].dispositivos[i].estado=true;
                }
          }
          $scope.ofertas[p1].carga_progressbar=$scope.ofertas[p1].carga_progressbar + x;
          $scope.ofertas[p1].porcentaje_carga = ($scope.ofertas[p1].carga_progressbar*100)/$scope.ofertas[p1].potencia_total_zonas; 
          $scope.ofertas[p1].total_oferta=$scope.ofertas[p1].carga_progressbar*$scope.ofertas[p1].valor_oferta;

          ///Cambio de colores del indicador del dinero
          if($scope.ofertas[p1].porcentaje_carga < 20){
            ind_valor.css("background-color", "gray");
          }else if ($scope.ofertas[p1].porcentaje_carga < 40) {
            ind_valor.css("background-color", "#DDD");
          }else if ($scope.ofertas[p1].porcentaje_carga < 75) {
            ind_valor.css("background-color", "#C6B261");
          }else {
            ind_valor.css("background-color", "#0CE889");
          }

      }else{
        var x=0; 
        var i;
        if($scope.ofertas[p1].carga_progressbar>=0){
          for (i = 0; i < zona.dispositivos.length; i++) { 
                  x = x + zona.dispositivos[i].valor;
                  $scope.ofertas[p1].zonas[zona.index].dispositivos[i].estado=false;
          }
   
          $scope.ofertas[p1].carga_progressbar=$scope.ofertas[p1].carga_progressbar - x;
          $scope.ofertas[p1].porcentaje_carga = ($scope.ofertas[p1].carga_progressbar*100)/$scope.ofertas[p1].potencia_total_zonas; 
          $scope.ofertas[p1].total_oferta=$scope.ofertas[p1].carga_progressbar*$scope.ofertas[p1].valor_oferta;
        
        ///Cambio de colores del indicador del dinero
          if($scope.ofertas[p1].porcentaje_carga < 20){
            ind_valor.css("background-color", "gray");
          }else if ($scope.ofertas[p1].porcentaje_carga < 40) {
            ind_valor.css("background-color", "#DDD");
          }else if ($scope.ofertas[p1].porcentaje_carga < 75) {
            ind_valor.css("background-color", "#C6B261");
          }else {
            ind_valor.css("background-color", "#0CE889");
          }
        }
      } 
    };

  ///Función que controla la carga desde el checkbox del dispositivo
    $scope.enviar_carga_disp = function(zona, p1, posicion){
      var ind_valor = angular.element(document.querySelector("#ind-valor-"+p1));

      if($scope.ofertas[p1].zonas[zona.index].dispositivos[posicion].estado){
        $scope.ofertas[p1].carga_progressbar = $scope.ofertas[p1].carga_progressbar + zona.dispositivos[posicion].valor;
        $scope.ofertas[p1].porcentaje_carga = ($scope.ofertas[p1].carga_progressbar*100)/$scope.ofertas[p1].potencia_total_zonas; 
        $scope.ofertas[p1].total_oferta=$scope.ofertas[p1].carga_progressbar*$scope.ofertas[p1].valor_oferta;

        ///Cambio de colores del indicador del dinero
        if($scope.ofertas[p1].porcentaje_carga < 20){
          ind_valor.css("background-color", "gray");
        }else if ($scope.ofertas[p1].porcentaje_carga < 40) {
          ind_valor.css("background-color", "#DDD");
        }else if ($scope.ofertas[p1].porcentaje_carga < 75) {
          ind_valor.css("background-color", "#C6B261");
        }else {
          ind_valor.css("background-color", "#0CE889");
        }
      }else{
        $scope.ofertas[p1].zonas[zona.index].estado=false;
        $scope.ofertas[p1].carga_progressbar = $scope.ofertas[p1].carga_progressbar - zona.dispositivos[posicion].valor;
        $scope.ofertas[p1].porcentaje_carga = ($scope.ofertas[p1].carga_progressbar*100)/$scope.ofertas[p1].potencia_total_zonas; 
        $scope.ofertas[p1].total_oferta=$scope.ofertas[p1].carga_progressbar*$scope.ofertas[p1].valor_oferta;

        ///Cambio de colores del indicador del dinero
          if($scope.ofertas[p1].porcentaje_carga < 20){
            ind_valor.css("background-color", "gray");
          }else if ($scope.ofertas[p1].porcentaje_carga < 40) {
            ind_valor.css("background-color", "#DDD");
          }else if ($scope.ofertas[p1].porcentaje_carga < 75) {
            ind_valor.css("background-color", "#C6B261");
          }else {
            ind_valor.css("background-color", "#0CE889");
          }
      }
      /////Cuando todas las cargas de los dispositivos esten seleccionados selecciona el checkbox de la zona
      var i;
      var contador=0;
      for (i = 0; i < zona.dispositivos.length; i++) { 
        if($scope.ofertas[p1].zonas[zona.index].dispositivos[i].estado){
          contador = contador+1;
        }
      }
      if(contador==zona.dispositivos.length){
        $scope.ofertas[p1].zonas[zona.index].estado=true;
      }
    };
  
  ///Función enviar Desconexion  
    $scope.enviar_desconexion=function(oferta, p1){

      //Valida si se ha enviado alguna desconexión
      if(oferta.carga_progressbar==0){
        ngDialog.open({                  
              template: 'app/cliente/dashboard-cliente/oferta_operador/modals/error_no_desconexion.html',
              className: 'ngdialog-theme-plain',
              closeByDocument: true,
              controller: ['$scope',  function($scope) {

                /// controller logic
                $scope.titleModal = 'Espera un momento';
                $scope.cerrar = function(){
                  ngDialog.close();
                }

            }]
        })
      ////Si hay alguna desconexión se crea un modal con la info que será enviada a la oferta  
      }else{
        ngDialog.open({                  
              template: 'app/cliente/dashboard-cliente/oferta_operador/modals/validar_desconexion.html',
              className: 'ngdialog-theme-plain',
              closeByDocument: true,
              scope:$scope, 
              controller: ['$scope',  function($scope) {

                /// Lógica del controlador
                $scope.titleModal = 'Validar Desconexión';
                $scope.desconexion = oferta;
                ///Genera la carga aportada por cada zona a la desconexión
                var i;
                var x;
                for (x = 0; x < $scope.ofertas[p1].zonas.length; x++) {
                    for (i = 0; i < $scope.ofertas[p1].zonas[x].dispositivos.length; i++) {
                      if($scope.ofertas[p1].zonas[x].dispositivos[i].estado){
                        $scope.ofertas[p1].zonas[x].carga_zona = $scope.ofertas[p1].zonas[x].carga_zona + $scope.ofertas[p1].zonas[x].dispositivos[i].valor;                        
                      }
                    }  
                }
                

                $scope.enviar_des = function(){
                  ngDialog.close();
                  $scope.ofertas.splice(p1, 1)
                }
                ///Reinicia la carga de cada zona para que sea confirmada por el usuario
                $scope.editar = function(){
                  ngDialog.close();
                  for (x = 0; x < $scope.ofertas[p1].zonas.length; x++) {
                    $scope.ofertas[p1].zonas[x].carga_zona=0;
                  }
                }

              }]
        })
      }
      ///////////


    }

  }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('projectCtrl', projectCtrl);

    /** @ngInject */
    function projectCtrl($timeout, $state, $stateParams, $scope, SHAREServices, $localStorage, RESTServices, $rootScope, $filter, statisticsServices) {
        
        $scope.project = $stateParams.project;
        $scope.icon = '../../../assets/icons/proyects.png';
        $scope.showInds = false;
        $scope.backToProjects = function() {
            $state.go('dashboard_cliente.projects')
        };
        if($localStorage.rol !== '7' && $localStorage.rol !== '6'){
            $state.go('dashboard_cliente/zones')
        }
        $scope.noData = true;
        $scope.showDevices = false;
        $scope.showZones = false;

        $scope.zonas = [];
        $scope.zoneSelected;

        $scope.subMenu = [
            {
                id: 0,
                name: 'Zonas',
                icon: '../../../../assets/icons/zones.svg',
                status: false,
            },
            {
                id: 1,
                name: 'Dispositivos',
                icon: '../../../../assets/icons/devices.svg',
                status: false,
            },
        ];

        $scope.selectSubMenu = function(ind) {
            $scope.subMenu.map(function(s){ s.status = false})
            if(ind.id === 0){
                $scope.showZones = !$scope.showZones;
                $scope.showDevices = false;
                $scope.subMenu[ind.id].status = $scope.showZones;
            } else {
                $scope.showDevices = !$scope.showDevices;
                $scope.showZones = false;
                $scope.subMenu[ind.id].status = $scope.showDevices;
            }
        }

        $scope.$on('closeComponent', function(e, res) {
            $timeout(function() {
                $scope.subMenu.map(function(s){ s.status = false})
                $scope.showDevices = false;
                $scope.showZones = false;
            },500)
            
        })

        $timeout(function() {
            if(!$scope.project){
                $scope.project = SHAREServices.project;
            }
            if(SHAREServices.project.id !== $scope.project.id){
                SHAREServices.zone_selected_project = null
            }
            SHAREServices.project = $scope.project
            $scope.loading = true;
            ////query zonas
            // v2: migrated from cliente/consulta_zonasxproyecto.php
            RESTServices.fetchProjectZonesV2($scope.project.id).then(function(data) {
                if (data.zonas && data.zonas.length) {
                    $scope.zonas = data.zonas;
                    $scope.zonas = $scope.zonas.map(function(z) {
                        z.rol = z.rol ? z.rol : 0,
                        z.index = i;
                        z.status = false;
                        return z;
                    })
                    $scope.zonas = $filter('orderBy')($scope.zonas, 'nombre');
                    $scope.zonas = $filter('filter')($scope.zonas, {hub : '0'});
                    $scope.loading = false;
                    $scope.zoneSelected = SHAREServices.zone_selected_project ? SHAREServices.zone_selected_project : $scope.zonas[0];
                    SHAREServices.zones_project = $scope.zonas;
                    $rootScope.$broadcast('setZones', {zones: $scope.zonas, zoneSelected: $scope.zoneSelected});
                }else{
                    $rootScope.$broadcast('setZones', {zones: null});
                    $scope.loading = false;
                    $scope.noInfo = true;
                }
            }).catch(function() {
                // 404 (not owned) or any other error: same "no zones" UX as an
                // empty result.
                $rootScope.$broadcast('setZones', {zones: null});
                $scope.loading = false;
                $scope.noInfo = true;
            });
            
            
                         
        });

        $scope.$on('noGraph', function(e, res){
            if(!res.ind) {
                $scope.noData = false;
            }
        })

        $scope.$on('setZoneName', function(e, res){
            $scope.zoneSelected = res.zona;
        })

        $scope.$on('setDeviceName', function(e, res){
            $scope.deviceSelected = res.device;
        })

        $scope.$on('updateGraph', function(e, res){
            $rootScope.$broadcast('resetIndGraph')
            console.log(res.data)
            $scope.indicadoresGrafica = statisticsServices.setIndicadoresGrafica(res.data)
            if($scope.indicadoresGrafica.inds && $scope.indicadoresGrafica.inds.length > 0){
                $scope.showInds = true;
            } else {
                $scope.showInds = false;
            }
        });

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('projectsCtrl', projectsCtrl);

    /** @ngInject */

    function projectsCtrl($scope, $rootScope, RESTServices, SHAREServices, $filter, $localStorage, $timeout, $state) {
        
        $scope.loading = true;
        $scope.noInfo = false;
        $scope.rol = $localStorage.rol

        if($localStorage.rol !== '7' && $localStorage.rol !== '6' && $localStorage.rol !== '8'){
            $state.go('dashboard_cliente')
        }
        
        $timeout(function(){
            // v2: migrated from consulta_proyectos.php
            RESTServices.fetchProjectsV2().then(function(data) {
                if (data.code == 200) {
                    $scope.loading = false;
                    $scope.projects = data.proyectos;
                    animarProyectCard();
                    $rootScope.flag_loading = false;
                } else {
                    $scope.loading = false;
                    $scope.noInfo = true;
                    $rootScope.flag_loading = false;
                }
            })
        })

        function animarProyectCard() {
            var projects = document.querySelectorAll('.project-card');
            projects.forEach(function(project, index) {
                project.style.animationDelay = (index * 0.1) + 's' ;
            });
        }

        $scope.$on('projectDelected', function(e, res){
            var index = $scope.projects.findIndex(function(p){return p.id === res.data.id})
            $scope.projects.splice(index, 1);
            if($scope.projects.length === 0){
                $scope.noInfo = true;
            }
        });

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('schedulesCtrl', schedulesCtrl);

    /** @ngInject */
    function schedulesCtrl($scope, RESTServices, $localStorage, $stateParams, $state, toastr, AutoServices, $timeout, $rootScope, schedulesUtil, SHAREServices, ngDialog, $filter) {

        if($localStorage.rol !== '10' && $localStorage.rol !== '11'){
            if($stateParams.zone){
                $localStorage.id_zona = $stateParams.zone.id;
                $localStorage.nombre_zona = $stateParams.zone.nombre;
                SHAREServices.control_zona = $stateParams.zone.rol;
            } else {
                $state.go('dashboard_cliente');
                return;
            }
        } else {
            toastr.warning('No tienes permiso para entrar a esta función');
            $state.go('dashboard_cliente');
            return;
        }


        $scope.schedules = [];
        $scope.dispositivos = [];
        $scope.evento = 'getSheduales';
        $scope.loading = true;
        var allSchedules = []; // cache de schedules para no repetir llamadas
        $scope.automations = AutoServices.automations;
        $scope.listaFiltros = ['Todas', 'Diaria', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'];
        $scope.filterInd = $scope.listaFiltros[0];
        $scope.$on('getSheduales', function(event, result){
           var device = result.data;
           $scope.device = device;
           $scope.loading = true;
           ////cancelar peticiones en cola
           RESTServices.cancelarSolicitudHttp();
           if (allSchedules.length > 0) {
               filterSchedulesByDevice(device);
           } else {
               getSchedules(device);
           }
        });

        $timeout(function() {
            $scope.loading = true;
            $scope.zone = $stateParams.zone;
            $scope.control = $scope.zone ? ($scope.zone.rol == 0 ? true : false) : SHAREServices.control_zona == 0 ? true : false;
            getDevices();
        });

        function getDevices() {
            RESTServices.fetchDevicesByZone($localStorage.id_zona).then(function(res) {
                if (res.code == '200') {
                    $scope.dispositivos = res.dispositivos;
                    $scope.dispositivos = $filter('orderBy')($scope.dispositivos, 'nombre');
                    if($scope.dispositivos.length > 0){
                        $scope.dispositivos[0].status = true;
                        getSchedules($scope.dispositivos[0])
                    } else {
                        $scope.loading = false;
                    }

                }
            })
        }


        function getSchedules(device){
            $scope.loading = true;

            RESTServices.fetchSchedulesByZone($localStorage.id_zona).then(function(res){
                if(res.code === '200' && res.programaciones){
                    allSchedules = res.programaciones;
                    filterSchedulesByDevice(device);
                } else {
                    $scope.loading = false;
                }
            })
        }

        function filterSchedulesByDevice(device) {
            $scope.schedules = [];
            $scope.filtered = [];
            var programaciones = [];

            var filtered = allSchedules.filter(function(s) {
                return Number(s.id_dispositivo) === Number(device.id);
            });
            filtered.sort(function (a, b) {
                if (a.dia > b.dia) return 1;
                if (a.dia < b.dia) return -1;
                return 0;
            });
            programaciones = schedulesUtil.organizeSchedules(filtered);
            programaciones.forEach(function(p) {
                var dev = $scope.dispositivos.find(function(dis){
                    var disId = Number(dis.id || dis.id_dispositivo);
                    return disId === Number(p.id_dispositivo);
                })
                if (dev) {
                    $scope.schedules.push(schedulesUtil.formatSchedule(p, dev));
                }
            })
            $scope.schedules = schedulesUtil.groupSchedules($scope.schedules);
            $scope.filtered = $scope.schedules;
            if ($scope.schedules.length > 0) {
                SHAREServices.enableSchedules[1].status = $scope.schedules[0].enable == 1 ? true : false;
            }
            $rootScope.$broadcast('enableSchedules', {data: SHAREServices.enableSchedules[1].status, type: 'zone', id: 1});
            $scope.totalItems = $scope.filtered.length;
            $scope.currentPage = 1;
            $scope.itemsPerPage = 12;
            $scope.noOfPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);
            $scope.loading = false;
        }

        // Refrescar schedules (después de crear/eliminar)
        $scope.$on('getSchedules', function(e, result){
            allSchedules = [];
            getSchedules($scope.dispositivos[0])
        })

        $scope.filtrarSchedules = function(ind) {
            $rootScope.$broadcast('filtrarSchedules', {filter:ind});
            $scope.filterInd = ind;
        }

        $scope.filtrar = function(buscar) {
            if(buscar === '') {
                $scope.filtered = Array.from($scope.schedules);
            } else {
                $scope.filtered = $scope.schedules.filter(function(s){
                    return s.dispositivo.nombre.toLowerCase().includes(buscar.toLowerCase());
                })
            }
            $scope.totalItems = $scope.filtered.length;
            $scope.noOfPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);
            $scope.currentPage = 1;
        }

        ////////////////

        $scope.gotoNewSchedule = function(type) {
            $state.go('dashboard_cliente.newAutomation', { zona: $stateParams.zone, dispositivos: $scope.dispositivos, type: type });
        }

        $scope.openDeleteDialog = function() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Quieres eliminar todas las programaciones de este dispositivo?';
                    $scope.sumary = 'Esta acción no se puede deshacer';

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.aceptar = function(){
                        var progm = [];
                        $scope.schedules.forEach(function(s){
                            s.id_nestedProg.forEach(function(id){
                                var field = {
                                    "id_programacion": id,
                                    "id_usuario": $localStorage.id_usuario,
                                };
                                progm.push(field);
                            })
                        });

                        scheduleServices(progm);
                    }
                }]
            });
        };

        $scope.deleteAllSchedule = function() {
            $scope.openDeleteDialog(null, true);
        }


        function scheduleServices(programaciones) {
            $rootScope.flag_loading = true;
            ngDialog.close();
            var promise = Promise.resolve();
            programaciones.forEach(function(a){
                promise = promise.then(function () {
                    // Espera la respuesta: la lambda tarda más de 400 ms y la lista se recargaba antes de que terminara.
                    return Schedule(a);
                });
            })

            promise.then(function(){
                $rootScope.flag_loading = false;
                getSchedules($scope.device);
                toastr.success('Se han eliminado correctamente todas las programaciones', 'Programación de aire');
            })

            function Schedule(params) {
                return RESTServices.post_header('elimina_programacion_aires.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                    if(res.code == 200) {

                    }
                }).catch(function () {})
            }

        }

        $scope.$on('activeAllSchedules', function(event, result){
            $scope.schedules.map(function(s){
                s.enable = result.status ? '1' : '0';
            })
        });

        $scope.subMenu = [
            {
                id: 0,
                name: 'Dispositivos',
                icon: '../../../../assets/icons/devices.svg',
                status: false,
            },
        ];

        $scope.selectSubMenu = function(ind) {
            $scope.subMenu.map(function(s){ s.status = false})
            $scope.showDevices = !$scope.showDevices;
            $scope.showZones = false;
            $scope.subMenu[0].status = $scope.showDevices;

        }

        $scope.$on('closeComponent', function(e, res) {
            $timeout(function() {
                $scope.subMenu.map(function(s){ s.status = false})
                $scope.showDevices = false;
            },500)

        })


    }
})();

(function() {
    'use strict';
    angular.module('BlurAdmin').factory('schedulesUtil', function($filter, SHAREServices, AutoServices) {
        return {
            setFrequency : function(f){
                switch (f) {
                    case '1':
                        return 'Única';
                        break;
                    case '2':
                        return 'Diaria';
                        break;
                    case '3':
                        return 'Semanal';
                        break;
                    case '4':
                        return 'Mensual';
                        break;
                    case '5':
                        return 'Feriado';
                        break;
                }
            },
            setStatus : function(hini, hfin, dia, frec){
                var today = new Date();

                switch (frec) {
                    case '1':
                        if(today.getTime() < dia.getTime()){
                            return 'En espera';
                            break;
                        }else if(today.getTime() == dia.getTime()){
                            if(today.getTime() < hini.getTime()){
                                return 'En espera';
                                break;
                            }else if(today.getTime() > hfin.getTime()){
                                return 'Ejecutado';
                                break;
                            }else if(today.getTime() > hini.getTime() && today.getTime() < hfin.getTime()){
                                return 'Ejecutando';
                                break;
                            }
                        }else if(today.getTime() > dia.getTime()){
                            return 'Ejecutado';
                            break;
                        }
                    case '2':
                        if(today.getTime() < hini.getTime()){
                            return 'En espera';
                            break;
                        }else if(today.getTime() > hfin.getTime()){
                            return 'Ejecutado';
                            break;
                        }else if(today.getTime() > hini.getTime() && today.getTime() < hfin.getTime()){
                            return 'Ejecutando';
                            break;
                        }
                    case '3':
                        if($filter('date')(today, 'EEEE') < $filter('date')(dia, 'EEEE')){
                            return 'En espera';
                            break;
                        }else if($filter('date')(today, 'EEEE') == $filter('date')(dia, 'EEEE')){
                            if(today.getTime() < hini.getTime()){
                                return 'En espera';
                                break;
                            }else if(today.getTime() > hfin.getTime()){
                                return 'Ejecutado';
                                break;
                            }else if(today.getTime() > hini.getTime() && today.getTime() < hfin.getTime()){
                                return 'Ejecutando';
                                break;
                            }
                        }else if($filter('date')(today, 'EEEE') > $filter('date')(dia, 'EEEE')){
                            return 'Ejecutado';
                            break;
                        }
                    case '4':
                        if($filter('date')(today, 'd') < $filter('date')(dia, 'd')){
                            return 'En espera';
                            break;
                        }else if($filter('date')(today, 'd') == $filter('date')(dia, 'd')){
                            if(today.getTime() < hini.getTime()){
                                return 'En espera';
                                break;
                            }else if(today.getTime() > hfin.getTime()){
                                return 'Ejecutado';
                                break;
                            }else if(today.getTime() > hini.getTime() && today.getTime() < hfin.getTime()){
                                return 'Ejecutando';
                                break;
                            }
                        }else if($filter('date')(today, 'd') > $filter('date')(dia, 'd')){
                            return 'Ejecutado';
                            break;
                        }
                }
            },

            formatSchedule: function(res, d, type){
                //var fecha_dia = $filter('date')(new Date(), 'yyyy-MM-dd');
                var hini_aux = res.dia + ' ' + res.hini;
                var hfin_aux = res.dia_utc ? res.dia_utc + ' ' + res.hfin : res.dia + ' ' + res.hfin;
                var dia_aux = new Date(res.dia + 'T' + res.hini + 'Z');
                
                hini_aux = new Date(hini_aux.replace(' ', 'T') + 'Z');
                hfin_aux = new Date(hfin_aux.replace(' ', 'T') + 'Z');
                
                
                return ({
                    id: res.id,
                    id_couple: res.id_couple ? res.id_couple : null,
                    id_nestedProg: res.id_nestedProg ? res.id_nestedProg : [],
                    dia: dia_aux, 
                    hini: $filter('date')(hini_aux, 'HH:mm'),
                    hfin: $filter('date')(hfin_aux, 'HH:mm'), 
                    action : AutoServices.getControlByID(d.tipo, res.comando).nombre,
                    postAction: AutoServices.getControlByID(d.tipo, res.comando_post).nombre,
                    estado : this.setStatus(hini_aux, hfin_aux, dia_aux, res.frecuencia),
                    actionDate: this.setActionDate(res.frecuencia, dia_aux, res.feriado),
                    frecuencia: this.setFrequency(res.frecuencia),
                    dispositivo: d,
                    tipo: this.setType(d.tipo),
                    enable: res.enable,
                    grupo: res.grupo,
                    feriado: res.feriado,
                })
                
            }, 

            setType: function(tipo) {
                switch(tipo) {
                    case '0':
                    case '1':
                        return AutoServices.automations[1];
                    case '2':
                    case '3':
                    case '4':
                        return AutoServices.automations[0];
                    case '14':
                        return AutoServices.automations[3];
                    case '15':
                        return AutoServices.automations[5];
                    case '27':
                        return AutoServices.automations[4];
                    case '29':
                        return AutoServices.automations[6];
                    case '17':
                        return AutoServices.automations[2];
                }
            },

            setActionDate: function(f, date, feriado){
                if(feriado === '0'){
                    switch (f) {
                        case '1':
                            return $filter('date')(date , 'MMM d, y');
                        case '2':
                            return 'Diaria';
                            break;
                        case '3':
                            var day = $filter('date')(date , 'EEEE').substring(0,3);
                            return this.capitalizeFirstLetter(day);
                            break;
                        case '4':
                            return 'Todos los' + ' ' + $filter('date')(date , 'd');
                            break;
                    }
                } else {
                    switch (f) {
                        case '1':
                            return 'Feriado';
                    }
                }
                
            },

            capitalizeFirstLetter: function(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }, 
            transformToLocal: function(dia,hini,hfin){
                var response = [];
                var fecha_ini = new Date (dia + ' ' + hini+'Z');
                var fecha_fin = new Date (dia + ' ' + hfin+'Z');
                response.dia = fecha_ini;
                response.dia_f = fecha_fin;
                response.hini = (fecha_ini.getHours()<10? ('0'+fecha_ini.getHours()):(fecha_ini.getHours()))+':'+(fecha_ini.getMinutes()<10? ('0'+fecha_ini.getMinutes()):(fecha_ini.getMinutes()))+':'+(fecha_ini.getSeconds()<10? ('0'+fecha_ini.getSeconds()):(fecha_ini.getSeconds()));
                response.hfin = (fecha_fin.getHours()<10? ('0'+fecha_fin.getHours()):(fecha_fin.getHours()))+':'+(fecha_fin.getMinutes()<10? ('0'+fecha_fin.getMinutes()):(fecha_fin.getMinutes()))+':'+(fecha_fin.getSeconds()<10? ('0'+fecha_fin.getSeconds()):(fecha_fin.getSeconds()));
                return response;
            },

            organizeSchedules: function(data) {

                var schedules = [];
                var ids = [];
                
                data.forEach(function(s, i) {
                    if(s.comando == s.comando_post && s.hfin == "23:59:59") {
                        var schedule = [];
                        schedule.push(s);
                        ids.push(s.id);
                        var couple = data.find(function(d){
                            var nextDay = new Date(s.dia).getTime() + 86400000;
                            return d.hini === "00:00:00" && new Date(d.dia).getTime() === nextDay && Number(d.id_dispositivo) === Number(s.id_dispositivo); 
                        })
                        if (!couple) {
                            schedules.push(s);
                            return;
                        }
                        schedule.push(couple); 
                        ids.push(couple.id);
                        schedule.sort(function(a,b) {
                            if (a.hini === "23:59:59") {
                                return 1;
                            } else if(b.hini === "23:59:59") {
                                return 1;
                            }
                        })
                        var newSchedule = {
                            comando: schedule[0].comando,
                            comando_post: schedule[1].comando_post,
                            dia: schedule[0].dia,
                            dia_utc: schedule[1].dia,
                            enable: schedule[0].enable,
                            fecha_actualizacion: schedule[0].fecha_actualizacion,
                            frecuencia: schedule[0].frecuencia,
                            hfin: schedule[1].hfin,
                            hini: schedule[0].hini,
                            id: schedule[0].id,
                            id_nestedProg: [],
                            id_couple: [schedule[0].id,schedule[1].id],
                            id_dispositivo: schedule[1].id_dispositivo,
                            usuario: schedule[0].usuario,
                            grupo: schedule[0].grupo,
                            feriado: schedule[0].feriado,
                        }
        
                        schedules.push(newSchedule);
                    } 
                });
                /////Agregar las otras programaciones que no están partidas
                var otras = Array.from(data);
                if(ids.length > 0) {
                    ids.forEach(function(id) {
                        var index = otras.findIndex(function(f){ return f.id === id});
                        otras.splice(index, 1)
                    });
                    otras = otras.map(function(o){
                        o.id_couple = [];
                        o.id_couple.push(o.id);
                        o.id_nestedProg = [];
                        return o;
                    })
                    schedules = schedules.concat(otras);
                } else {
                    otras = otras.map(function(o){
                        o.id_couple = [];
                        o.id_couple.push(o.id);
                        o.id_nestedProg = [];
                        return o;
                    })
                    schedules = schedules.concat(otras);
                }
                
                return schedules;
                
                
            },

            groupBySerial: function(objects) {
                var result = {};
                objects.forEach(function(obj) {
                    var grupo = obj.grupo;
                    if (grupo !== null) {
                        if (result[grupo]) {
                            result[grupo].push(obj);
                        } else {
                            result[grupo] = [obj];
                        }
                    } else {
                        if (result['default']) {
                            result['default'].push(obj);
                        } else {
                            result['default'] = [obj];
                        }
                    }
                });
                return result;
            },

            groupSchedules: function(programaciones) {
                var progByGroup = this.groupBySerial(programaciones);
                var grupos = Object.keys(progByGroup);
                var agrupadas = [];

                grupos.forEach(function(g){
                    if(g === 'default') {
                        progByGroup[g].forEach(function(p){
                            p.id_nestedProg = p.id_nestedProg.concat(p.id_couple);
                            p.actionDays = [p.actionDate];
                            agrupadas.push(p);
                        })
                    } else {
                        var item = progByGroup[g][0];
                        item.actionDays = [];

                        if(item.feriado === '1'){
                            progByGroup[g].forEach(function(p, i){
                                item.id_nestedProg = item.id_nestedProg.concat(p.id_couple);
                                item.actionDays.push(p.dia);
                            })
                            agrupadas.push(item);
                        } else {
                            progByGroup[g].forEach(function(p, i){
                                item.id_nestedProg = item.id_nestedProg.concat(p.id_couple);
                                var daysOfWeek = [
                                    'Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'
                                ];
                                var dayOfWeek = p.dia.getDay();
                                item.actionDays.push(daysOfWeek[dayOfWeek]);
                            })
                            agrupadas.push(item);
                        }
                    }
                })

                return agrupadas;
            },
            
        }
    })
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('zonesCtrl', zonesCtrl);

    /** @ngInject */

    function zonesCtrl($scope, $rootScope, RESTServices, SHAREServices, $filter, $localStorage, $timeout, toastr, ngDialog, zoneSharingServices) {
        
        //$scope.noZones = true;
        $scope.rol = $localStorage.rol;
        $scope.loading = true;
        $scope.noInfo = false;
        $scope.getReady = false;

        if ($localStorage.marketer) {
            $scope.is_cliente = true;
        } else {
            $scope.is_cliente = false;
        }

        $timeout(function() {

            RESTServices.fetchClientZones().then(function(data) {
                    if (data.code == 200 || data.code == '200') {
                    var hasOwn = data.zonas && data.zonas.length;
                    var hasShared = data.zonas_externas && data.zonas_externas.length;
                    $scope.noZones = !hasOwn && !hasShared;

                    if (hasOwn) {
                        $scope.noZones = false;
                        $scope.client = {};
                        $scope.client.zonas = $filter('orderBy')(data.zonas, 'nombre');
                        if(SHAREServices.hiddenZones === '0'){
                            $scope.client.zonas = $scope.client.zonas.filter(function(z) {return z.h == '0'});
                        }
                        $scope.client.zonas = $scope.client.zonas.map(function(e){
                            e.rol = 0;
                            return e;
                        });
                        SHAREServices.zonas_propias = $scope.client.zonas;
                        $scope.getReady = true;
                    } else {
                        $scope.client = $scope.client || {};
                        $scope.client.zonas = [];
                    }

                    if (data.enable !== undefined) {
                        $rootScope.$broadcast('enableSchedules', {data: data.enable, type: 'user', id: 0});
                        SHAREServices.enableSchedules[0].status = data.enable;
                    }

                    if(hasShared){
                        $scope.noZones = false;
                        var clientsNames = []
                        data.zonas_externas.map(function(d){
                            if(clientsNames.findIndex(function(z){return z == d.nombre_cliente}) == -1){
                                clientsNames.push(d.nombre_cliente)
                            }
                        })
                        $scope.shareClients = clientsNames.map(function(d){
                            var zonas = $filter('filter')(data.zonas_externas, {nombre_cliente : d});
                            return ({
                                nombre: d,
                                zonas : zonas
                            })
                        });
                        SHAREServices.zonas_compartidas = $scope.shareClients;
                    }
                    $scope.loading = false;
                    $scope.noInfo = false;
                    $rootScope.flag_loading = false;
    
                    
                }else{
                    $rootScope.flag_loading = false;
                    $scope.noZones = true;
                    $scope.loading = false;
                    $scope.noInfo = true;
                }
            });
        })
        

        $scope.$on('callDashboard', function(event, result) {
           
            if($scope.client.zonas.length == 0){
                $scope.noZones = true;
            }
            
        });

        $scope.$on('ZoneCreated', function(event, result) {
            $scope.noZones = false;
            $scope.client.zonas.push(result.data);
            generarPaginado();
            $rootScope.flag_loading = false;
            toastr.success('Zona creada exitosamente', 'Nueva zona');
        });

        // Opened from the "Compartir zonas" button in control-buttons-top. Bulk share is rol 6 only.
        $scope.$on('openShareZones', function() {
            if ($localStorage.rol !== '6' || !$scope.getReady) {
                return;
            }
            if (!$scope.client || !$scope.client.zonas || $scope.client.zonas.length === 0) {
                toastr.warning('No tienes zonas propias para compartir', 'Compartir zonas');
                return;
            }
            $scope.openShareZones();
        });

        // Bulk share: pick N OWNED zones and M emails, one request, per-pair summary.
        $scope.openShareZones = function() {
            var zonesScope = $scope;
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/shareZones.html',
                className: 'ngdialog-theme-plain modal-share-zones',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.zones = zonesScope.client.zonas;
                    $scope.selected = {};
                    $scope.form = { emails: '', rol: 'control' };
                    $scope.summary = null;
                    $scope.sending = false;

                    function selectedIds() {
                        return Object.keys($scope.selected).filter(function(id) { return $scope.selected[id]; });
                    }

                    $scope.selectedCount = function() {
                        return selectedIds().length;
                    };

                    $scope.selectAll = function() {
                        $scope.selected = {};
                        $scope.zones.forEach(function(z) { $scope.selected[z.id] = true; });
                    };

                    $scope.clearSelection = function() {
                        $scope.selected = {};
                    };

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.share = function() {
                        var ids = selectedIds();
                        if (ids.length === 0) {
                            toastr.warning('Selecciona al menos una zona', 'Compartir zonas');
                            return;
                        }
                        var rol = $scope.form.rol == 'control' ? 0 : 5;
                        $scope.sending = true;
                        $scope.summary = null;
                        zoneSharingServices.share(ids, $scope.form.emails, rol, $localStorage.email).then(function(summary) {
                            $scope.summary = summary;
                            if (summary.failed > 0) {
                                toastr.warning(summary.text, 'Compartir zonas');
                            } else {
                                toastr.success(summary.text, 'Compartir zonas');
                            }
                        }).catch(function(err) {
                            var reason = err && err.reason;
                            if (reason === 'invalid_emails') {
                                toastr.error('Correos no válidos: ' + err.invalid.join(', '), 'Compartir zonas');
                            } else if (reason === 'no_emails') {
                                toastr.error(err.ownRemoved ? 'No puedes compartir una zona contigo mismo' : 'Ingresa al menos un correo', 'Compartir zonas');
                            } else if (reason === 'email_too_long') {
                                toastr.error('Correos demasiado largos (máximo ' + err.max + ' caracteres): ' + err.long.join(', '), 'Compartir zonas');
                            } else if (reason === 'too_many_zones') {
                                toastr.error('Puedes compartir máximo ' + err.max + ' zonas a la vez (seleccionaste ' + err.count + ')', 'Compartir zonas');
                            } else if (reason === 'too_many_emails') {
                                toastr.error('Puedes compartir con máximo ' + err.max + ' correos a la vez (ingresaste ' + err.count + ')', 'Compartir zonas');
                            } else if (reason === 'too_many_pairs') {
                                toastr.error('Máximo ' + err.max + ' combinaciones de zona y correo por envío (' + err.zones + ' zonas x ' + err.emails + ' correos); reduce la selección', 'Compartir zonas');
                            } else if (reason === 'no_zones') {
                                toastr.warning('Selecciona al menos una zona', 'Compartir zonas');
                            } else {
                                toastr.error('Ha ocurrido un error al compartir las zonas', 'Compartir zonas');
                            }
                        }).then(function() {
                            $scope.sending = false;
                        });
                    };
                }]
            });
        };

        function generarPaginado(){
            $scope.client.zonas = $filter('orderBy')($scope.client.zonas, 'nombre');
            $scope.totalItems = $scope.client.zonas.length;
            $scope.currentPage = 1;
            $scope.itemsPerPage = 6;
        };

    }


})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('maintenance_logCtrl', maintenance_logCtrl);

    /** @ngInject */
    function maintenance_logCtrl($scope, $rootScope, RESTServices, SHAREServices, ngDialog, $localStorage, $window, $stateParams, $timeout, $state, $filter, toastr) {

        $scope.loading = true;
        $scope.noInfo = false;
        $scope.moreDescripcion = false;
        $scope.dispositivo = $stateParams.device;
        $scope.control = $stateParams.control;
        if($stateParams.device == null){
            if($stateParams.hash != "") {
                $scope.dispositivo = {};
                $scope.dispositivo.id = SHAREServices.hash_decode($stateParams.hash);
                getMaintenance($scope.dispositivo);
                getInfoDevice($scope.dispositivo.id);
                
            }else $state.go('mantenimiento');
        }else{
            getMaintenance($scope.dispositivo);
            $rootScope.$broadcast('setDevice', {device: $scope.dispositivo})
        }

        function getMaintenance(device){
            $scope.link = 'https://helo.intelmotics.com/#/maintenanceLog/' + SHAREServices.hash_encode(device.id ? device.id : device.id_device);

            RESTServices.fetchDeviceMaintenancesV2(device.id ? device.id : device.id_device).then(function(list) {
                if (!list || list.length === 0) {
                    // An empty history is a valid result (not an error).
                    $scope.noInfo = true;
                    $scope.loading = false;
                    return;
                }
                $scope.ListMantenimiento = list.map(function(d){
                    // fecha_actualizacion / fecha_proximo are null when never set.
                    d.fecha_actualizacion = d.fecha_actualizacion ? d.fecha_actualizacion.replace(/-/g, '\/') : null; // soporte safari e IE
                    d.fecha = new Date(d.fecha.replace(' ', 'T')+'Z'); // To Local
                    d.fecha_proximo = d.fecha_proximo ? new Date(d.fecha_proximo.replace(/-/g, '\/')) : null;
                    return d
                });
                $scope.totalItems = $scope.ListMantenimiento.length;
                $scope.currentPage = 1;
                $scope.itemsPerPage = 12;
                $scope.noOfPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);

                $scope.loading = false;
                $scope.noInfo = false;
            }).catch(function() {
                // 403/404/5xx are plain failures: never close the session here.
                $scope.noInfo = true;
                $scope.loading = false;
                toastr.error('No se pudo cargar el historial de mantenimientos', 'Ha ocurrido un error');
            });
        }

        ////////////
        $scope.imprimirListM = function() {
            $scope.itemsPerPage = $scope.ListMantenimiento != undefined ? $scope.ListMantenimiento.length : 1;
            $scope.moreDescripcion = true;
            $scope.printerView = true;
            $timeout(function() {
                $window.print();
                $scope.itemsPerPage = 6;
                $scope.moreDescripcion = false;
                $scope.printerView = false;
            }, 1);
        }

        $scope.filtrar = function(buscar) {
            $scope.filtered = $filter('filter')($scope.tabla.zonas, { nombre: buscar });
            $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            $scope.totalItems = $scope.filtered.length;
            $scope.noOfPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);
            $scope.currentPage = 1;
        }
        
        function getInfoDevice(id){
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "id_dispositivo": id,
            };

            RESTServices.post_header('cliente/consulta_dispositivo.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code === "200") {
                    $scope.dispositivo = res.dispositivo;
                    $rootScope.$broadcast('setDevice', {device:$scope.dispositivo})
                }
            });
        };

        $scope.showQRcode = function(){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/descargar_qr.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.link = $scope.link;
                    $timeout(function(){
                        var qrLink = document.getElementById('qr').querySelectorAll("img")[0].src;
                        var canvas = document.getElementById('qrHelo');  
                        var context = canvas.getContext('2d');  
                        var imageObj1 = new Image();  
                        imageObj1.src = qrLink;  
                        imageObj1.onload = function() {    
                            context.drawImage(imageObj1, 0, 0);  
                        };
                        var imageObj2 = new Image();  
                        imageObj2.src = '../../../../../assets/img/logo_helo.png';
                        imageObj2.onload = function() {    
                            context.drawImage(imageObj2, 45, 220, 120, 80);  
                        };
                    }, 200)
                    
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.downloadQR = function() {
                        var link = document.createElement('a');
                        link.download = $scope.dispositivo.nombre + '_QR' + '.jpeg';
                        link.href = document.getElementById('qrHelo').toDataURL()
                        link.click();
                        ngDialog.close();
                    }

                }]
            });
        }

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('newMaintenanceCtrl', newMaintenanceCtrl);

    /** @ngInject */
    function newMaintenanceCtrl($scope, RESTServices, $q, $rootScope, $localStorage, $stateParams, $state, $filter, toastr, maintenanceServices, ngDialog, SHAREServices, $timeout) {

        if ($stateParams.device === null) $state.go('mantenimiento');

        var dispositivo = $stateParams.device;
        $scope.maintenanceTypes = maintenanceServices.getMaintenanceTypes();
        if (dispositivo.caracteristicas) {
            if (dispositivo.caracteristicas.find(function(d) { return d.id === '2'})) {
                var tipo = dispositivo.caracteristicas.find(function(d) { return d.id === '2'}).valor;
                $scope.checkLists = maintenanceServices.setCheckList(tipo ? tipo : '#');
            }
        } else {
            $scope.checkLists = maintenanceServices.setCheckList(dispositivo.tipo ? dispositivo.tipo : '#');
        }


        $scope.actionList = [];
        $scope.newMantenimiento = {};
        $scope.newMantenimiento.fecha = new Date();
        $scope.newMantenimiento.hora = new Date();
        $scope.formats = ['yyyy-MM-dd'];
        $scope.mstep = 1;
        $scope.images = [];

        $scope.flag_check_list = true;

        $scope.open = function(ind) {
            $scope.popup[ind].opened = true;
        };
        // var d = new Date();
        // var dt = $filter('date')(d.getTime() - 8 * 24 * 60 * 60 * 1000, 'yyyy-MM-dd');


        $scope.options_1 = {
            showWeeks: false,
            initDate: new Date(),
            maxDate: new Date(),
            // minDate: new Date(dt)
        };

        $scope.options_2 = {
            showWeeks: false,
            initDate: new Date(),
            // minDate: new Date()
        };


        $scope.popup = [{
                opened: false,

            },
            {
                opened: false,

            },
        ]

        $scope.cancelar = function() {
            $state.go('mantenimiento_log', { device: dispositivo });
        };

        $scope.$on('checkListModel', function(event, result) {
            if ($scope.newMantenimiento.chequeos == undefined) $scope.newMantenimiento.chequeos = [];
            var index = $scope.newMantenimiento.chequeos.findIndex(function(i) { return i.id_chequeo == result.key });
            if (index != -1) $scope.newMantenimiento.chequeos[index] = result.data;
            else $scope.newMantenimiento.chequeos.push(result.data);
        });

        $scope.nuevoMantenimiento = function(nuevo) {
            $rootScope.flag_loading = true;
            //var mantenimiento = {};
            nuevo.lista_chequeo = !$scope.flag_check_list;
            nuevo.tipo = Number(nuevo.tipo);
            nuevo.fecha = $filter('date')(nuevo.fecha, 'yyyy-MM-dd');
            nuevo.hora = $filter('date')(nuevo.hora, 'HH:mm:ss');
            nuevo.fecha = new Date(nuevo.fecha + " " + nuevo.hora);
            nuevo.fecha = nuevo.fecha.toISOString().substring(0, 10) + " " + nuevo.fecha.toISOString().substring(11, 19); //To UTC
            nuevo.horas_uso = dispositivo.horas_uso ? dispositivo.horas_uso : 0;
            nuevo.fecha_proximo = $filter('date')(nuevo.fecha_proximo, 'yyyy-MM-dd');
            nuevo.id_dispositivo = dispositivo.id_device == undefined ? dispositivo.id : dispositivo.id_device;
            nuevo.repuestos = nuevo.repuestos ? nuevo.repuestos.join() : null;
            nuevo.consecutivo = "C" + nuevo.id_dispositivo + "-" + ($stateParams.totalMaintenance + 1)
            nuevo.imagenes = $scope.images;
            if (!nuevo.lista_chequeo || nuevo.chequeos.length === 0) {
                nuevo.lista_chequeo = false;
                nuevo.chequeos = null; // Ej: chequeos = [{id_chequeo:0, chequeo: 1, valor:"20"},{id_chequeo:3, chequeo:1, valor: "120,120"} ]
            } 

            if ($scope.images.length > 0) {
                getFile(nuevo)
            } else {
                agregarMantenimiento(nuevo)
            }

            
        }

        function normalizeChequeosForV2(chequeos) {
            if (!chequeos || !chequeos.length) {
                return null;
            }

            return chequeos.map(function(item) {
                return {
                    id_chequeo: parseInt(item.id_chequeo, 10),
                    chequeo: item.chequeo != null ? String(item.chequeo) : '',
                    valor: item.valor
                };
            });
        }

        function buildMaintenancePayload(nuevo) {
            var payload = {
                fecha: nuevo.fecha,
                tipo: nuevo.tipo,
                descripcion: nuevo.descripcion,
                horas_uso: nuevo.horas_uso,
                responsable: nuevo.responsable,
                estado_actual: nuevo.estado_actual,
                estado_final: nuevo.estado_final,
                telefono: nuevo.telefono,
                repuestos: nuevo.repuestos,
                fecha_proximo: nuevo.fecha_proximo,
                lista_chequeo: nuevo.lista_chequeo,
                consecutivo: nuevo.consecutivo,
                id_dispositivo: parseInt(nuevo.id_dispositivo, 10)
            };

            if (nuevo.lista_chequeo && nuevo.chequeos && nuevo.chequeos.length) {
                payload.chequeos = normalizeChequeosForV2(nuevo.chequeos);
            }

            return payload;
        }

        function onMaintenanceCreateError(nuevo) {
            $state.go('mantenimiento_log', { device: dispositivo });
            $rootScope.flag_loading = false;
            if ($scope.checkLists) {
                $scope.checkLists.map(function(c) {
                    c.selected = false;
                });
            }
            toastr.error('No se puede conectar en este momento', 'Nuevo mantenimiento');
            $scope.newMantenimiento = nuevo;
        }

        function onMaintenanceCreateSuccess(nuevo, imageUrls, maintenanceId) {
            $state.go('mantenimiento_log', { device: dispositivo });
            $rootScope.flag_loading = false;
            if ($scope.checkLists) {
                $scope.checkLists.map(function(c) {
                    c.selected = false;
                });
            }
            if (imageUrls.length > 0) {
                linkImages(maintenanceId, imageUrls);
            }
            toastr.success('Se ha agregado un nuevo mantenimiento correctamente', 'Nuevo mantenimiento');
        }

        function agregarMantenimiento(nuevo) {
            var deviceId = dispositivo.id_device == undefined ? dispositivo.id : dispositivo.id_device;
            var imageUrls = (nuevo.imagenes && nuevo.imagenes.length > 0) ? nuevo.imagenes.slice() : [];
            var body = {
                id_usuario: parseInt($localStorage.id_usuario, 10),
                id_dispositivo: parseInt(deviceId, 10),
                mantenimiento: buildMaintenancePayload(nuevo)
            };

            RESTServices.createDeviceMaintenanceV2(deviceId, body).then(function(data) {
                if (data != null && data.message === 'success' && data.id) {
                    onMaintenanceCreateSuccess(nuevo, imageUrls, data.id);
                } else {
                    onMaintenanceCreateError(nuevo);
                }
            }).catch(function() {
                onMaintenanceCreateError(nuevo);
            });
        }

        $scope.selectCheckList = function(id) {
            $scope.flag_check_list = false;
            var index = $scope.checkLists.findIndex(function(i) { return i.id == id });

            if ($scope.checkLists[index].selected) {
                deteleChecklist(index, $scope.checkLists[index].id)
            } else {
                $scope.checkLists[index].selected = true;
                var item = {
                    name: $scope.checkLists[index].nombre,
                    id_lista: $scope.checkLists[index].id,
                    items: maintenanceServices.selectActivityList(id).map(function(list) {
                        return ({
                            valor_: '',
                            descripcion: list.descripcion,
                            id: list.id,
                            valor: list.valor,
                            id_lista_mantenimiento: list.id_lista_mantenimiento,
                            name: 'checkList_' + list.id,
                            model: 'newMantenimiento.checkList_' + list.id
                        });
                    })
                }
                $scope.actionList.push(item);
            }
        }

        function deteleChecklist(i, id) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Desea borrar lista de chequeo?';

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.aceptar = function() {
                        $scope.checkLists[i].selected = false;
                        var index = $scope.actionList.findIndex(function(i) { return i.id_lista == id });
                        $scope.actionList.splice(index, 1);
                        $scope.newMantenimiento.chequeos = $scope.newMantenimiento.chequeos.filter(function(itm) {
                            return itm.id_lista_mantenimiento !== id;
                        });
                        ngDialog.close();
                    }

                }]
            });
        }

        $scope.addImage = function() {
            var imagenes = [];
            var files = document.getElementById('file').files;
            var length = files.length;
            var contador = 0;
            files.forEach(function(f) {
                var r = new FileReader();
                r.onload = function (e) {
                    contador += 1;
                    var image = {
                        name: f.name,
                        url: e.target.result,
                        file: f
                    }
                    imagenes.push(image);
                    if(contador === length) {
                        renderImagenes(imagenes)
                    }
                }
                r.readAsDataURL(f);
            })

            function renderImagenes(imagenes) {
                $timeout(function(){
                    $scope.images = $scope.images.concat(imagenes)
                })
            }
            
        }

        

        function getFile(mantenimiento) {
             
            // comprimir imágenes
            var imagenes = [];
            var counter_2 = 0;
            var files = $scope.images.map(function(i){return i.file});
            var length = files.length;
            files.forEach(function(file) {
                new Compressor(file, {
                    quality: 0.2,
                    success: function(result) {
                        counter_2 += 1;
                        var file = new File([result], result.name, { type: result.type });
                        imagenes.push(file); 
                        if(counter_2 === length){
                            getURLs(imagenes, mantenimiento)
                        }
                    } 
                });
            })
        }

        function getURLs(imagenes, mantenimiento) {
            var urls = [];
            var length = imagenes.length;
            var counter = 0;
            imagenes.forEach(function(f) {
                var r = new FileReader();
                r.onload = function (e) {
                    var hash = CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(e.target.result));
                    $q.resolve(RESTServices.getURL(f,hash)).then(function(url){
                        counter += 1;
                        urls.push(url);
                        if(counter === length){
                            mantenimiento.imagenes = urls;
                            agregarMantenimiento(mantenimiento)
                        }
                    })
                    .catch(function(e){
                        console.log(e);
                        toastr.error('Hubo un problema inesperado con el servidor');  
                    });
                }
                r.readAsBinaryString(f);
            })
        }

        function linkImages(id, imagenes) {
            var promesas = imagenes.map(function(url) {
                var item = {
                    id: 0,
                    url: url,
                    id_contenedor: id,
                    id_creador: $localStorage.id_usuario,
                }
                var params = {
                    id_usuario: $localStorage.id_usuario,
                    tipo: 2,
                    imagen: JSON.stringify(item)
                }
                return RESTServices.post_header('cliente/edita_imagen.php', params, SHAREServices.hash_decode_token($localStorage.token),true)
            })

            Promise.all(promesas)
                .then(function(data) {
                    if(data[0].code === '200'){
                        toastr.success('Imagenes agregadas correctamente', 'Nuevo mantenimiento');
                    }
                    
                })
                .catch(function(error) {
                
                })
        }

        $scope.deteleImage = function(item) {
            var index = $scope.images.findIndex(function(i){return i.url === item.url})
            $scope.images.splice(index, 1)
        }

        $scope.showImage = function(index) {
            ngDialog.open({
                template: 'app/cliente/monitoreo/modales/slider-ticket.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.asunto = 'Mantenimiento'
                    $scope.images = $scope.images;
                    $scope.active = index;
                }]
            });
        }

    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo')
        .controller('newTechnicalCtrl', newTechnicalCtrl);

    /** @ngInject */

    function newTechnicalCtrl($scope, RESTServices, toastr, $localStorage, SHAREServices, $state, $timeout,$filter, $stateParams, zoneSharingServices) {
        
        $scope.zonas = [];
        $scope.filtered = [];
        $scope.loading = true;
        $scope.noInfo = false;
        $scope.edit_mode = false;
        $scope.validatedList = false;
        $scope.disabled = false;
        var selected_zones_original = [];

        // The share API rejects emails over the usuario_zona.email limit; check it
        // before creating the technician so nothing is half-done.
        function emailTooLongToast(tecnico) {
            if (!zoneSharingServices.emailTooLong(tecnico.email)) {
                return false;
            }
            toastr.error('El correo es demasiado largo (máximo ' + zoneSharingServices.maxEmailChars + ' caracteres): ' + tecnico.email, 'Gestión de usuarios');
            return true;
        }

        $scope.crearTecnico = function(tecnico) {
            if (willShareZones() && emailTooLongToast(tecnico)) {
                return;
            }
            $scope.disabled = true;
            if ($scope.edit_mode === false) {
                var r = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var s = '';
                for (var i = 0; i < 20; i++) s += r.charAt(Math.floor(Math.random() * r.length));

                tecnico.token = s;
                tecnico.id_entidad = $localStorage.id_cliente; /////ID de cliente que almacena todos los técnicos
                tecnico.estado = '1';
                tecnico.id = 0;
            }

            tecnico.avatar = 'avatar1.svg';
            tecnico.rol = 7;
            
            
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "tecnico": tecnico,
                "id_tecnico": tecnico.id,
                "asociar": $scope.edit_mode ? 0 : 1,
            };

            RESTServices.post_header('cliente/edita_tecnico.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null ) {
                    if (data.code == '200') {
                        deteleZones(tecnico);
                        addZones(tecnico);
                    }else if(data.code == '300'){
                        toastr.error('Este usuario ya se ha creado', 'Nuevo Usuario')
                    }
                    else{
                        toastr.error('No se puede conectar en este momento', 'Nuevo Usuario');   
                    }
                    $scope.disabled = false;
                }else{
                    toastr.error('No se puede conectar en este momento', 'Nuevo Usuario');
                }
            });

        }

        $scope.cancelar = function() {
            $state.go('monitoring.tecnicos');
        }

        $scope.selectAll = function(flag) {
            if(flag) {
                $scope.zonas.map(function(i){if(!i.readOnly){i.status = true}})
            } else {
                $scope.zonas.map(function(i){if(!i.readOnly){i.status = false}})
            }
            $scope.validateList();
        }

        $scope.validateList = function(){
            var index = $scope.zonas.findIndex(function(i){return i.status === true && !i.readOnly});
            if(index >= 0) {
                $scope.validatedList = true;
            } else {
                $scope.validatedList = false;
            }
        }

        $scope.search = function(buscar) {
            if (buscar === '') {
                $scope.filtered = $scope.zonas;
            } else {
                $scope.filtered = $filter('filter')($scope.zonas, buscar );
                $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            }
        }

        // Zones shared with the technician by another company are shown read-only: they are
        // never part of the selection sent to addZoneUserV2 / revokeZoneUserV2.
        function editableSelectedZones() {
            return $scope.zonas.filter(function(d){return d.status === true && !d.readOnly});
        }

        // True when addZones will call the share API: zones selected and the
        // selection differs from the original one (always in create mode).
        function willShareZones() {
            var selected_zones = editableSelectedZones();
            return !(arrayIgual(selected_zones, selected_zones_original) || selected_zones.length === 0);
        }

        function addZones(tecnico) {
            var selected_zones = editableSelectedZones();
            if(!willShareZones()) {
                toastr.success('Técnico Editado', 'Gestión de usuarios');
                $state.go('monitoring.tecnicos');
                return;
            } else {
                if (emailTooLongToast(tecnico)) {
                    return;
                }
                var zoneIds = selected_zones.map(function(s){return s.id});

                // v2: migrated from cliente/asociar_usuarioazona.php (bulk;
                // every zone in results[] must succeed for this to count as a
                // full success).
                RESTServices.addZoneUserV2(tecnico.email, 0, zoneIds).then(function(res) {
                    var results = (res.data && res.data.results) || [];
                    var ok = results.length > 0 && results.every(function(r) { return r.status === 200; });
                    if (ok) {
                        toastr.success('Técnico Creado', 'Gestión de usuarios');
                        $state.go('monitoring.tecnicos');
                    }else{
                        toastr.error('Ha ocurrido un error al agregar el técnico', 'Gestión de usuarios');
                    }
                }).catch(function() {
                    toastr.error('Ha ocurrido un error al agregar el técnico', 'Gestión de usuarios');
                });
            }
            
        }

        function deteleZones(tecnico){
            var selected_zones = editableSelectedZones();
            var zones_to_unlink = compararArreglosPorId(selected_zones, selected_zones_original);
            if(zones_to_unlink.length > 0){
                var zoneIds = zones_to_unlink.map(function(s){return s.id});

                // v2: migrated from cliente/elimina_usuario_zona.php (bulk;
                // every zone in results[] must succeed for this to count as a
                // full success).
                RESTServices.revokeZoneUserV2(tecnico.email, zoneIds).then(function(res) {
                    var results = (res.data && res.data.results) || [];
                    var ok = results.length > 0 && results.every(function(r) { return r.status === 200; });
                    if (ok) {
                        $state.go('monitoring.tecnicos');
                    }else{
                        toastr.error('Ha ocurrido un error al agregar el técnico', 'Gestión de usuarios');
                    }
                }).catch(function() {
                    toastr.error('Ha ocurrido un error al agregar el técnico', 'Gestión de usuarios');
                });
            }
            
        }

        function compararArreglosPorId(nuevo, original) {
            var idsNuevo = nuevo.map(function(obj) { return obj.id});
            var objetosNoEncontrados = original.filter(function(obj) {return !idsNuevo.includes(obj.id)} );
            return objetosNoEncontrados;
        }

        function arrayIgual(array1, array2) {
            var idsArray1 = array1.map(function(obj) { return obj.id});
            var idsArray2 = array2.map(function(obj) { return obj.id});
            return JSON.stringify(idsArray1.sort()) == JSON.stringify(idsArray2.sort())
        }

        $timeout(function() {

            if (SHAREServices.zonas === null) {
                var params = {
                    "id_usuario": $localStorage.id_usuario,
                };
                ////query zonas
                RESTServices.fetchClientZones().then(function(data) {
                    if (data != null && data.code == '200') {
                        if(data.zonas) {
                            $scope.zonas = data.zonas;
                        } 
                        if(data.zonas_externas) {
                            // Zones shared WITH the caller's company belong to another company:
                            // they can never be added to or revoked from a technician.
                            data.zonas_externas.forEach(function(z){z.foreign = true});
                            $scope.zonas = $scope.zonas.concat(data.zonas_externas)
                        }
                        $scope.zonas = $filter('orderBy')($scope.zonas, 'nombre');
                        $scope.zonas = $filter('filter')($scope.zonas, {h : '0'});
                        $scope.zonas = $scope.zonas.map(function(z, i) {
                            z.index = i;
                            z.status = false;
                            z.readOnly = !!z.foreign;
                            return z;
                        })
                        $scope.filtered = Array.from($scope.zonas);
                        // Copy so zones pushed by getShareZones never leak into the shared cache.
                        SHAREServices.zonas = Array.from($scope.zonas);
                        $scope.loading = false;

                        if($stateParams.tecnico) {
                            $scope.edit_mode = true;
                            $scope.tecnico = $stateParams.tecnico;
                            $scope.validatedList = true;
                            getShareZones();
                        } 
                    }else{
                        $scope.noInfo = true;
                    }
                });
            } else {
                // Copy so zones pushed by getShareZones never leak into the shared cache.
                $scope.zonas = SHAREServices.zonas.map(function(z, i) {
                    z.index = i;
                    z.status = false;
                    z.readOnly = !!z.foreign;
                    return z;
                });
                $scope.filtered = Array.from($scope.zonas);
                $scope.loading = false;

                if($stateParams.tecnico) {
                    $scope.tecnico = $stateParams.tecnico;
                    $scope.edit_mode = true;
                    $scope.validatedList = true;
                    getShareZones();
                } 
                
            }

            function getShareZones() {
                $scope.loading = true;
                RESTServices.fetchUserSharedZonesV2($stateParams.tecnico.id).then(function(data) {
                    if (data != null && data.code == '200') {
                        selected_zones_original = [];
                        data.zonas_externas.forEach(function(z_e) {
                            // Only the owning company can revoke a zone (backend ZoneOwnedByCustomer),
                            // so zones owned by any other company are visible but read-only and never
                            // part of selected_zones_original.
                            var readOnly = z_e.id_cliente !== String($localStorage.id_cliente);
                            var index = $scope.zonas.findIndex(function(z) {
                                return z_e.id === z.id;
                            });
                            if (index >= 0) {
                                $scope.zonas[index].status = true;
                                $scope.zonas[index].readOnly = readOnly;
                            } else {
                                z_e.status = true;
                                z_e.readOnly = readOnly;
                                $scope.zonas.push(z_e);
                            }
                            if (!readOnly) {
                                selected_zones_original.push(z_e);
                            }
                        });
                        $scope.zonas.sort(function(a, b) {
                            // Colocar primero los objetos con status true
                            if (a.status && !b.status) {
                              return -1; // a debe ir antes que b
                            } else if (!a.status && b.status) {
                              return 1; // b debe ir antes que a
                            } else {
                              return 0; // no se cambia el orden
                            }
                        });
                        $scope.filtered = Array.from($scope.zonas);
                    } 
                    $scope.loading = false;
                })
            } 
        });

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo')
        .controller('newTicketCtrl', newTicketCtrl);

    /** @ngInject */

    function newTicketCtrl($scope, monitoringServices, RESTServices, $filter, $localStorage, $timeout, SHAREServices, $state, toastr, AutoServices) {
        
        $scope.statusOptions = monitoringServices.statusOptions;
        $scope.priority = monitoringServices.priority;
        $scope.zonas = [];
        $scope.tecnicos = [];
        $scope.loading = false;
        $scope.noInfo = false;
        $scope.disabled = false;
        $scope.loading_z = false;
        $scope.maxCaracteres = 600;
        $scope.caracteresRestantes = $scope.maxCaracteres;
        $scope.validDescription = true;

        /////control datepicker
        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            minDate: new Date()
        };
        $scope.open = function() {
            $scope.popup.opened = true;
        };
        $scope.popup = {
            opened: false
        };
        $scope.DateFormat = AutoServices.format.day;

        $timeout(function() {
            $scope.loading_z = true;
            if (SHAREServices.zonas === null) {
                var params = {
                    "id_usuario": $localStorage.id_usuario,
                };
                ////query zonas
                RESTServices.fetchClientZones().then(function(data) {
                    if (data != null && data.code == '200') {
                        if(data.zonas) {
                            $scope.zonas = data.zonas;
                        } 
                        if(data.zonas_externas) {
                            $scope.zonas = $scope.zonas.concat(data.zonas_externas)
                        }
                        $scope.zonas = $filter('orderBy')($scope.zonas, 'nombre');
                        $scope.zonas = $filter('filter')($scope.zonas, {h : '0'});
                        $scope.zonas = $scope.zonas.map(function(z, i) {
                            z.index = i;
                            return z;
                        })
                        SHAREServices.zonas = $scope.zonas;
                        $scope.loading_z = false;
                    }else{
                        //$state.go('noAlerts');
                        //console.log("error en respuesta")
                    }
                    
    
                });
            } else {
                $scope.zonas = SHAREServices.zonas;  
            }

            var params = {
                "id_usuario": $localStorage.id_usuario,
                "id_monitoreo": 0,
            };
            ////query técnicos
            RESTServices.post_header('cliente/consulta_tecnicos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code == '200') {
                    $scope.tecnicos = data.tecnicos;
                }
            });

            var params = {
                "id_usuario": $localStorage.id_usuario,
            };
            ////query coordinadores
            RESTServices.post_header('cliente/consulta_coordinadores.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code == '200') {
                    $scope.coordinadores = data.tecnicos;
                }
            });
            
        });

        $scope.getDevices = function(id) {
            $scope.loading = true;
            RESTServices.fetchDevicesByZone(id).then(function(res) {
                if (res.code == '200') {
                    $scope.dispositivos = res.dispositivos;
                    $scope.dispositivos.map(function(d) {
                        d.id = String(d.id); // ticket stores device ids as strings
                        d.status = false;
                        return d;
                    });
                    $scope.filtered = Array.from($scope.dispositivos);
                    $scope.loading = false;
                    $scope.noInfo = false;
                } else {
                    $scope.loading = false;
                    $scope.noInfo = true;
                }
            }); 
        }

        $scope.selectAll = function(flag) {
            if(flag) {
                $scope.dispositivos.map(function(i){i.status = true})
            } else {
                $scope.dispositivos.map(function(i){i.status = false})
            }
        }

        $scope.search = function(buscar) {
            if (buscar === '') {
                $scope.filtered = $scope.dispositivos;
            } else {
                $scope.filtered = $filter('filter')($scope.dispositivos, buscar );
                $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            }
        }

        $scope.crearTicket = function(data) {
            $scope.disabled = true;
            var selected_devices = $scope.dispositivos.filter(function(d){return d.status === true})
            var ticket = {
                estado: data.estado,
                id_zona: data.id_zona,
                //id_tecnico: data.id_tecnico,
                id_tecnico: 0,
                dispositivos: JSON.stringify(selected_devices.map(function(s){return s.id})),
                texto: data.asunto,
                id: 0,
                id_creador: $localStorage.id_usuario,
                descripcion: data.description,
                prioridad: data.prioridad,
                id_coordinador: data.id_coordinador,
                fecha_ejecucion: $filter('date')(data.fecha_ejecucion, 'yyyy-MM-dd'),
                hora_ejecucion: $filter('date')(data.hora_ejecucion, 'HH:mm:ss'),
            }
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "ticket": JSON.stringify(ticket)
            };

            RESTServices.post_header('cliente/edita_tickets.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res != null && res.code == '200') {
                    agregarTecnico(res.id, data.tecnicos)
                } else{
                    toastr.error('Hubo un problema inesperado');
                    $scope.disabled = false;
                }
            }); 
        }

        function agregarTecnico(id_ticket, data) {
            var tecnicos = data.map(function(t){
                return ({
                    id: t.id,
                })
            })
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "id_ticket": id_ticket,
                "orden": 1,
                "tecnicos": JSON.stringify(tecnicos),
                
            };

            RESTServices.post_header('cliente/asociar_tecnicosaticket.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res != null && res.code == '200') {
                    toastr.success('Ticket creado con éxito');
                    $state.go('monitoring.tickets')
                } else{
                    toastr.error('Hubo un problema inesperado');
                    $scope.disabled = false;
                }
            });
        }

        $scope.cancelar = function() {
            $state.go('monitoring.tickets');
        }

        $scope.actualizarContador = function(texto) {
            $scope.caracteresRestantes = $scope.maxCaracteres - texto.length;
            if($scope.caracteresRestantes <= 0) {
                $scope.validDescription = false;
            } else{
                $scope.validDescription = true;
            }
        }

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo')
        .controller('tecnicosCtrl', tecnicosCtrl);

    /** @ngInject */

    function tecnicosCtrl($scope, RESTServices, $localStorage, $timeout, SHAREServices, $state) {
        
        $scope.tecnicos = [];
        $scope.loading = true;

        $scope.goToNewTechnical = function() {
            $state.go('monitoring.newTechnical')
        }

        $timeout(function() {

            var params = {
                "id_usuario": $localStorage.id_usuario,
                "id_monitoreo": 0,
            };

            RESTServices.post_header('cliente/consulta_tecnicos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code == '200') {
                    $scope.tecnicos = data.tecnicos;
                    $scope.loading = false;
                } else {
                    $scope.loading = false; 
                } 

            }); 
        });

        $scope.$on('technicalDeleted', function(event, result) {
            var index = $scope.tecnicos.findIndex(function(i) { return i.id == result.data.id });
            $scope.tecnicos.splice(index, 1);
        });

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo')
        .controller('ticketCtrl', ticketCtrl);

    /** @ngInject */

    function ticketCtrl($scope, monitoringServices, RESTServices, $filter, $localStorage, $q, $timeout, SHAREServices, $state, ngDialog, toastr, $stateParams) {
        
        $scope.statusOptions = monitoringServices.statusOptions;
        $scope.id_usuario = $localStorage.id_usuario;
        $scope.loading = false;
        $scope.loading_image = false;
        $scope.noInfo = false;
        $scope.newNote = false;
        $scope.notas = [];
        $scope.images = [];
        var user_name = $localStorage.nombre_cliente;
        $scope.maxCaracteres = 1200;
        $scope.caracteresRestantes1 = $scope.maxCaracteres;
        $scope.caracteresRestantes2 = $scope.maxCaracteres;
        $scope.validNote_create = true;
        $scope.validNote_edit= true;

        $timeout(function() {
            $scope.ticket = $stateParams.ticket;
            $scope.ticket.fecha_creacion = changeToLocal($scope.ticket.fecha_creacion);
            $scope.note = {
                texto: '',
                id: '0',
                id_creador: $localStorage.id_usuario,
                fecha: null,
                id_ticket: $scope.ticket.id,
            }
            var params = {
                "id_usuario": $localStorage.id_usuario,
                "id_ticket": $scope.ticket.id,
            };

            RESTServices.post_header('cliente/consulta_notas_ticket.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code == '200') {
                    data.notas = data.notas.map(function(d){
                        d.fecha_local = changeToLocal(d.fecha);
                        d.edit = false;
                        d.id = d.id_nota;
                        d.id_ticket = $scope.ticket.id;
                        return d;
                    })
                    $scope.notas = data.notas 
                }else{

                }
            });

            var params = {
                "id_usuario": $localStorage.id_usuario,
                "id_ticket": $scope.ticket.id,
            };

            RESTServices.post_header('cliente/consulta_imagenes_ticket.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code == '200') {
                    data.imagenes = data.imagenes.map(function(i){
                        i.name = getName(i.url);
                        return i;
                    })
                    $scope.images = data.imagenes 
                }else{

                }
            });

            RESTServices.fetchDevicesByZone($scope.ticket.id_zona).then(function(res) {
                if (res.code == '200') {
                    $scope.ticket.dispositivos = JSON.parse($scope.ticket.dispositivos);
                    $scope.ticket.equipos = $scope.ticket.dispositivos.map(function(d){
                        return res.dispositivos.find(function(device) { return String(device.id) === String(d) })  
                    })              
                }
            });
            
            
            if($scope.ticket.visto === '0'){
                var fields = {
                    "id_ticket": $scope.ticket.id,
                    "id_usuario": $localStorage.id_usuario,
                };
        
                RESTServices.post_header('cliente/ver_ticket.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                    if (res.code == '200') {
    
                    }
                }); 
            }

            if($scope.ticket.id_tecnico === '0'){
                consultaTecnicos($scope.ticket.id)
            } 
            

            
            
            

        });

        function consultaTecnicos(id_ticket) {
            var params = {
                    "id_usuario": $localStorage.id_usuario,
                    "id_ticket": id_ticket,
            }
            RESTServices.post_header('cliente/consulta_tecnicos_ticket.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code == '200') {
                    $scope.tecnicos = data.tecnicos;
                }  

            });
        }

        $scope.volver = function() {
            $state.go('monitoring.tickets');
        }

        $scope.showNewNote = function() {
            $scope.newNote = !$scope.newNote;
            if(!$scope.newNote){
                $scope.note = {
                    texto: '',
                    id: '0',
                    id_creador: $localStorage.id_usuario,
                    fecha: null,
                    id_ticket: $scope.ticket.id,
                }  
            }
        }

        $scope.addNote = function(data) {
            $scope.newNote = false;
            var date = new Date();
            var note = data;

            var field = {
                "id_usuario": $localStorage.id_usuario,
                "nota": JSON.stringify(note),
            };

            RESTServices.post_header('cliente/edita_nota_ticket.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
            .then(function(response) {
                if (response != null && response.code == '200') {
                    note.fecha_local = $filter('date')(date, 'MMM dd, yyyy HH:mm');
                    ///////para editar la nota
                    
                    if(response.id){
                        note.nombre_creador = user_name;
                        note.id = response.id;
                        $scope.notas.push(note);
                        $scope.note = {
                            texto: '',
                            id: '0',
                            id_creador: $localStorage.id_usuario,
                            fecha: null,
                            id_ticket: $scope.ticket.id,
                        } 
                        $scope.caracteresRestantes2 = $scope.maxCaracteres;
                    } else {
                        var index = $scope.notas.findIndex(function(n) { return n.id === note.id});
                        if(index >= 0) $scope.notas[index].texto = note.texto;
                    }
                    
                    toastr.success('Estado del tickect cambiado con éxito');
                } else{
                    toastr.error('Hubo un problema inesperado');
                }
            })

            

        }

        $scope.setStatus = function(status) {

            var ticket = Object.assign($scope.ticket);
            ticket.estado = status;
            
            var field = {
                "id_usuario": $localStorage.id_usuario,
                "ticket": JSON.stringify(ticket)
            };

            RESTServices.post_header('cliente/edita_tickets.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
            .then(function(response) {
                if (response != null && response.code == '200') {
                    $scope.ticket.estado = status;
                    toastr.success('Estado del ticket cambiado con éxito');
                } else{
                    toastr.error('Hubo un problema inesperado');
                }
            })
        }

        $scope.getFile = function() {
            $timeout(function () {
                $scope.loading_image = true;
            });  
            // comprimir imágenes
            var imagenes = [];
            var counter_2 = 0;
            var files = document.getElementById('file').files;
            var length = files.length;
            files.forEach(function(file) {
                new Compressor(file, {
                    quality: 0.2,
                    success: function(result) {
                        counter_2 += 1;
                        var file = new File([result], result.name, { type: result.type });
                        imagenes.push(file); 
                        if(counter_2 === length){
                            getURLs(imagenes)
                        }
                    } 
                });
            })
        }

        function getURLs(imagenes) {
            var urls = [];
            var length = imagenes.length;
            var counter = 0;
            imagenes.forEach(function(f) {
                var r = new FileReader();
                r.onload = function (e) {
                    var hash = CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(e.target.result));
                    $q.resolve(RESTServices.getURL(f,hash)).then(function(url){
                        counter += 1;
                        urls.push(url);
                        if(counter === length){
                            setImages(urls)
                        }
                    })
                    .catch(function(e){
                        console.log(e);
                        toastr.error('Hubo un problema inesperado con el servidor');
                        $timeout(function () {
                            $scope.loading_image = false;
                            document.getElementById('file').value = '';
                        });  
                    });
                }
                r.readAsBinaryString(f);
            })
        }

        function setImages(item) {
            $timeout(function () {

                var promesas = item.map(function(i) {
                    var imagen = {
                        url: i,
                        id_ticket: $scope.ticket.id,
                        id_creador: $localStorage.id_usuario,
                    }

                    var field = {
                        "id_usuario": $localStorage.id_usuario,
                        "imagen": JSON.stringify(imagen),
                    };

                    return RESTServices.post_header('cliente/edita_imagen_ticket.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
                })
                var param = item;
                Promise.all(promesas)
                .then(function(response) {
                    if (response[0] != null && response[0].code == '200') {
                        param.forEach(function(p){
                            var imagen = {
                                name: getName(p),
                                url: p,
                            }
                            $scope.images.push(imagen)
                        })
                        document.getElementById('file').value = '';
                        $scope.loading_image = false;
                        toastr.success('Imágenes agregadas con éxito');
                    } else{
                        toastr.error('Hubo un problema inesperado');
                        $scope.loading_image = false;
                    }
                })
                                
            });   
        }

        $scope.deteleImage = function(item) {

        }

        $scope.showImage = function(index) {
            ngDialog.open({
                template: 'app/cliente/monitoreo/modales/slider-ticket.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.asunto = $scope.ticket.texto;
                    $scope.images = $scope.images;
                    $scope.active = index;
                }]
            });
        }

        $scope.setPriority = function(ind) {
            switch (ind) {
                case '0':
                    return 'Media';
                case '1':
                    return 'Alta';
                case '2':
                    return 'Baja';
                case '3':
                    return 'Urgente';
                default:
                    return '';
            }
        }

        function getName(allName) {
            var name = allName.split('-')[2];
            return name;
        }


        function changeToLocal(dia) {
            return new Date(dia.replace(' ', 'T') + 'Z');
        };

        $scope.actualizarContador = function(texto, event) {

            if(event === 'new') {
                $scope.caracteresRestantes2 = $scope.maxCaracteres - texto.length;
            } else {
                $scope.caracteresRestantes1 = $scope.maxCaracteres - texto.length;
            }
            
            if($scope.caracteresRestantes1 <= 0) {
                $scope.validNote_edit = false;
            } else{
                $scope.validNote_edit = true
            }
            if($scope.caracteresRestantes2 <= 0) {
                $scope.validNote_create = false;
            } else{
                $scope.validNote_create = true;
            }
        }

        $scope.contarCaracteres = function(texto){
            $scope.caracteresRestantes1 = texto.length
        }

        $scope.addTecnico = function() {
            ngDialog.open({
                template: 'app/cliente/monitoreo/modales/add_tecnico.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                controller: ['$scope', function($scope) {
                     $scope.validatedList = false; 
                    var params = {
                        "id_usuario": $localStorage.id_usuario,
                        "id_monitoreo": 0,
                    };
                    ////query técnicos
                    RESTServices.post_header('cliente/consulta_tecnicos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                        if (data != null && data.code == '200') {
                            var ids_tecnicos = $scope.tecnicos.map(function(t){return t.id_tecnico})
                            $scope.alltecnicos = data.tecnicos;
                            $scope.alltecnicos.map(function(t){
                                if(ids_tecnicos.includes(t.id)){
                                    t.status = true;
                                }
                            }) 
                            $scope.alltecnicos.map(function(t){
                                if(t.status){
                                   $scope.validatedList = true; 
                                   return; 
                                }
                            })
                            
                            $scope.tecnicos_original = $scope.alltecnicos.filter(function(t){
                                return t.status;
                            })

            
                        }
                    });
                    $scope.agregar = function() {
                        var newArrayTecnicos = $scope.alltecnicos.filter(function(t){
                            return t.status;
                        })
                        var users_to_unlink = compararArreglosPorId(newArrayTecnicos, $scope.tecnicos_original);
                        var users_to_link = compararArreglosPorId($scope.tecnicos_original, newArrayTecnicos);
                        if(users_to_unlink.length > 0) {
                            asociarTecnicos(0, users_to_unlink, newArrayTecnicos)
                        }
                        if(users_to_link.length > 0) {
                            asociarTecnicos(1, users_to_link, newArrayTecnicos);
                        }
                        ngDialog.close(); 
                    }

                    $scope.cancelar = function(){
                        ngDialog.close();
                    }
                }]
            });
        }


        $scope.addVisita = function() {
            ngDialog.open({
                template: 'app/cliente/monitoreo/modales/add_visita.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    var today = new Date('2025-01-07' + ' ' + $scope.ticket.hora_ejecucion);
                    var date = $scope.ticket.fecha_ejecucion + " 00:00:00"
                    $scope.visita = {
                        fecha: new Date(date),
                        hora: today,
                    };
                    
                    $scope.agregar = function(visita) {
                        ngDialog.close();
                        var nuevoTicket = Object.assign($scope.ticket)
                        nuevoTicket.fecha_ejecucion = $filter('date')(visita.fecha, 'yyyy-MM-dd'),
                        nuevoTicket.hora_ejecucion = $filter('date')(visita.hora, 'HH:mm:ss'),
                        nuevoTicket.dispositivos = JSON.stringify(nuevoTicket.dispositivos);
                        editarTicket(nuevoTicket);
                    }

                    $scope.cancelar = function(){
                        ngDialog.close();
                    }
                }]
            });
        }

        function editarTicket(ticket) {
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "ticket": JSON.stringify(ticket)
            };

            RESTServices.post_header('cliente/edita_tickets.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res != null && res.code == '200') {
                    toastr.success('Campo editado correctamente');
                } else{
                    toastr.error('Hubo un problema inesperado');
                }
            });  
        }

        function asociarTecnicos(ind, data, newArrayTecnicos){

            var tecnicos = data.map(function(t){
                return ({
                    id: t.id,
                })
            })
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "id_ticket": $scope.ticket.id,
                "orden": ind,
                "tecnicos": JSON.stringify(tecnicos),
            };

            RESTServices.post_header('cliente/asociar_tecnicosaticket.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res != null && res.code == '200') {
                    toastr.success('Ticket creado con éxito');
                    $scope.tecnicos = newArrayTecnicos.map(function(t){
                            return({
                                id_tecnico: t.id,
                                nombre_tecnico: t.nombre + ' ' + t.apellido,
                                email_tecnico: t.email
                            })
                        })
                } else{
                    toastr.error('Hubo un problema inesperado');
                }
            });
        }

        function compararArreglosPorId(nuevo, original) {
            var idsNuevo = nuevo.map(function(obj) { return obj.id});
            var objetosNoEncontrados = original.filter(function(obj) {return !idsNuevo.includes(obj.id)} );
            return objetosNoEncontrados;
        }

    }


})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.alerts')
        .controller('noAlertsCtrl', noAlertsCtrl);

    /** @ngInject */

    function noAlertsCtrl($scope, $state, alertsServices) {
        
        $scope.listaAlertas = alertsServices.listaAlertas;

        $scope.newAlert = function(type) {
            $state.go('newAlert', {type: type})
        }
       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.alerts')
        .directive('noAlerts', noAlerts);
  
    /** @ngInject */
    function noAlerts() {
      return {
        restrict: 'E',
        controller: 'noAlertsCtrl',
        templateUrl: 'app/cliente/alerts/no-alerts/no-alerts.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo')
        .controller('ticketsCtrl', ticketsCtrl);

    /** @ngInject */

    function ticketsCtrl($scope, RESTServices, $localStorage, $timeout, SHAREServices, $state, monitoringServices) {
        
        $scope.tickets = [];
        $scope.loading = true;
        $scope.noInfo = false;
        $scope.statusOptions = Array.from(monitoringServices.statusOptions);
        $scope.priority = Array.from(monitoringServices.priority);
        var todos = {
            text: 'Todos',
            value: null,
        };
        $scope.statusOptions.push(todos);
        $scope.priority.push(todos);

        $timeout(function() {
            $scope.getTickets()
        });

        $scope.goToNewTicket = function() {
            $state.go('monitoring.newTicket')
        }

        $scope.getTickets = function(key, value, data) {
            var service = '';
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.tickets = [];
            var params = {}
            if(data) {
                params = data;
                service = 'cliente/filtro_tickets.php'
            } else {
                params = {
                    "estado": null,
                    "prioridad": null, 
                    "id_ticket": null,
                }
                params[key] = value;
                service = 'cliente/consulta_tickets.php';
            }
            params.id_usuario = $localStorage.id_usuario;

            RESTServices.post_header(service, params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code == '200') {
                    $scope.tickets = data.tickets;
                    $scope.loading = false;
                } else {
                    $scope.loading = false;
                    $scope.noInfo = true;
                }  

            });
        }

        $scope.$on('setFilters', function(e, result){
            $scope.getTickets(null, null, result.data)
        })

        $scope.$on('deletedTicket', function(e, result){
            var index = $scope.tickets.findIndex(function(t){return t.id === result.ticket.id})
            $scope.tickets.splice(index, 1);
        })

    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.smartbar')
      .controller('measurePointCtrl', measurePointCtrl);
  
    
    function measurePointCtrl($scope) {
        $scope.msg = "Measure Point";
    }
  
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.smartbar')
      .controller('tempPointCtrl', tempPointCtrl);
  
   
    function tempPointCtrl($scope) {
        $scope.msg = "Temp Point";
    }
  
})();
/**
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.consumo.dashboard_consumo.estadisticas_zona')
      .controller('grafica_consumo_cCtrl', grafica_consumo_cCtrl);

  /** @ngInject */
  function grafica_consumo_cCtrl($scope, baConfig, $element, layoutPaths, SHAREServices) {
    /*var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    $scope.$watch(function(){
       return SHAREServices.flagAhorro;
    }, function(newValue, oldValue){    
      if(SHAREServices.ahorroxzonaxmes[0] != undefined){*/

      $scope.filtro_mes = true;
      $scope.filtro_year = false;


      $scope.filtrar = function(parm){
        if(parm == "m"){
          $scope.filtro_mes = true;
          $scope.filtro_year = false;
          chart.dataProvider = $scope.datos_mes;
          chart.validateData();
        }
        if(parm == "a"){
          $scope.filtro_mes = false;
          $scope.filtro_year = true;
          chart.dataProvider = $scope.datos_year;
          chart.validateData();
        }
      }

        $scope.datos_mes = [ {
            "date": "2012-07-27",
            "value": 13
          }, {
            "date": "2012-07-28",
            "value": 11
          }, {
            "date": "2012-07-29",
            "value": 15
          }, {
            "date": "2012-07-30",
            "value": 16
          }, {
            "date": "2012-07-31",
            "value": 18
          }, {
            "date": "2012-08-01",
            "value": 13
          }, {
            "date": "2012-08-02",
            "value": 22
          }, {
            "date": "2012-08-03",
            "value": 23
          }, {
            "date": "2012-08-04",
            "value": 20
          }, {
            "date": "2012-08-05",
            "value": 17
          }, {
            "date": "2012-08-06",
            "value": 16
          }, {
            "date": "2012-08-07",
            "value": 18
          }, {
            "date": "2012-08-08",
            "value": 21
          }, {
            "date": "2012-08-09",
            "value": 26
          }, {
            "date": "2012-08-10",
            "value": 24
          }, {
            "date": "2012-08-11",
            "value": 29
          }, {
            "date": "2012-08-12",
            "value": 32
          }, {
            "date": "2012-08-13",
            "value": 18
          }, {
            "date": "2012-08-14",
            "value": 24
          }, {
            "date": "2012-08-15",
            "value": 22
          }, {
            "date": "2012-08-16",
            "value": 18
          }, {
            "date": "2012-08-17",
            "value": 19
          }, {
            "date": "2012-08-18",
            "value": 14
          }, {
            "date": "2012-08-19",
            "value": 15
          }, {
            "date": "2012-08-20",
            "value": 12
          }, {
            "date": "2012-08-21",
            "value": 8
          }, {
            "date": "2012-08-22",
            "value": 9
          }, {
            "date": "2012-08-23",
            "value": 8
          }, {
            "date": "2012-08-24",
            "value": 7
          }, {
            "date": "2012-08-25",
            "value": 5
          }, {
            "date": "2012-08-26",
            "value": 11
          }, {
            "date": "2012-08-27",
            "value": 13
          }, {
            "date": "2012-08-28",
            "value": 18
          }, {
            "date": "2012-08-29",
            "value": 20
          }, {
            "date": "2012-08-30",
            "value": 29
          }, {
            "date": "2012-08-31",
            "value": 33
          }, {
            "date": "2012-09-01",
            "value": 42
          }, {
            "date": "2012-09-02",
            "value": 35
          }, {
            "date": "2012-09-03",
            "value": 31
          }, {
            "date": "2012-09-04",
            "value": 47
          }, {
            "date": "2012-09-05",
            "value": 52
          }, {
            "date": "2012-09-06",
            "value": 46
          }, {
            "date": "2012-09-07",
            "value": 41
          }, {
            "date": "2012-09-08",
            "value": 43
          }, {
            "date": "2012-09-09",
            "value": 40
          }, {
            "date": "2012-09-10",
            "value": 39
          }, {
            "date": "2012-09-11",
            "value": 34
          }, {
            "date": "2012-09-12",
            "value": 29
          }, {
            "date": "2012-09-13",
            "value": 34
          }, {
            "date": "2012-09-14",
            "value": 37
          }, {
            "date": "2012-09-15",
            "value": 42
          }, {
            "date": "2012-09-16",
            "value": 49
          }, {
            "date": "2012-09-17",
            "value": 46
          }, {
            "date": "2012-09-18",
            "value": 47
          }, {
            "date": "2012-09-19",
            "value": 55
          }, {
            "date": "2012-09-20",
            "value": 59
          }, {
            "date": "2012-09-21",
            "value": 58
          }, {
            "date": "2012-09-22",
            "value": 57
          }, {
            "date": "2012-09-23",
            "value": 61
          }, {
            "date": "2012-09-24",
            "value": 59
          }, {
            "date": "2012-09-25",
            "value": 67
          }, {
            "date": "2012-09-26",
            "value": 65
          }, {
            "date": "2012-09-27",
            "value": 61
          }, {
            "date": "2012-09-28",
            "value": 66
          }, {
            "date": "2012-09-29",
            "value": 69
          }, {
            "date": "2012-09-30",
            "value": 71
          }, {
            "date": "2012-10-01",
            "value": 67
          }, {
            "date": "2012-10-02",
            "value": 63
          }, {
            "date": "2012-10-03",
            "value": 46
          }, {
            "date": "2012-10-04",
            "value": 32
          }, {
            "date": "2012-10-05",
            "value": 21
          }, {
            "date": "2012-10-06",
            "value": 18
          }, {
            "date": "2012-10-07",
            "value": 21
          }, {
            "date": "2012-10-08",
            "value": 28
          }, {
            "date": "2012-10-09",
            "value": 27
          }, {
            "date": "2012-10-10",
            "value": 36
          }, {
            "date": "2012-10-11",
            "value": 33
          }, {
            "date": "2012-10-12",
            "value": 31
          }, {
            "date": "2012-10-13",
            "value": 30
          }, {
            "date": "2012-10-14",
            "value": 34
          }, {
            "date": "2012-10-15",
            "value": 38
          }, {
            "date": "2012-10-16",
            "value": 37
          }, {
            "date": "2012-10-17",
            "value": 44
          }, {
            "date": "2012-10-18",
            "value": 49
          }, {
            "date": "2012-10-19",
            "value": 53
          }, {
            "date": "2012-10-20",
            "value": 57
          }, {
            "date": "2012-10-21",
            "value": 60
          }, {
            "date": "2012-10-22",
            "value": 61
          }, {
            "date": "2012-10-23",
            "value": 69
          }, {
            "date": "2012-10-24",
            "value": 67
          }, {
            "date": "2012-10-25",
            "value": 72
          }, {
            "date": "2012-10-26",
            "value": 77
          }, {
            "date": "2012-10-27",
            "value": 75
          }, {
            "date": "2012-10-28",
            "value": 70
          }, {
            "date": "2012-10-29",
            "value": 72
          }, {
            "date": "2012-10-30",
            "value": 70
          }, {
            "date": "2012-10-31",
            "value": 72
          }, {
            "date": "2012-11-01",
            "value": 73
          }, {
            "date": "2012-11-02",
            "value": 67
          }, {
            "date": "2012-11-03",
            "value": 68
          }, {
            "date": "2012-11-04",
            "value": 65
          }, {
            "date": "2012-11-05",
            "value": 71
          }, {
            "date": "2012-11-06",
            "value": 75
          }, {
            "date": "2012-11-07",
            "value": 74
          }, {
            "date": "2012-11-08",
            "value": 71
          }, {
            "date": "2012-11-09",
            "value": 76
          }, {
            "date": "2012-11-10",
            "value": 77
          }, {
            "date": "2012-11-11",
            "value": 81
          }, {
            "date": "2012-11-12",
            "value": 83
          }, {
            "date": "2012-11-13",
            "value": 80
          }, {
            "date": "2012-11-14",
            "value": 81
          }, {
            "date": "2012-11-15",
            "value": 87
          }, {
            "date": "2012-11-16",
            "value": 82
          }, {
            "date": "2012-11-17",
            "value": 86
          }, {
            "date": "2012-11-18",
            "value": 80
          }, {
            "date": "2012-11-19",
            "value": 87
          }, {
            "date": "2012-11-20",
            "value": 83
          }, {
            "date": "2012-11-21",
            "value": 85
          }, {
            "date": "2012-11-22",
            "value": 84
          }, {
            "date": "2012-11-23",
            "value": 82
          }, {
            "date": "2012-11-24",
            "value": 73
          }, {
            "date": "2012-11-25",
            "value": 71
          }, {
            "date": "2012-11-26",
            "value": 75
          }, {
            "date": "2012-11-27",
            "value": 79
          }, {
            "date": "2012-11-28",
            "value": 70
          }, {
            "date": "2012-11-29",
            "value": 73
          }, {
            "date": "2012-11-30",
            "value": 61
          }, {
            "date": "2012-12-01",
            "value": 62
          }, {
            "date": "2012-12-02",
            "value": 66
          }, {
            "date": "2012-12-03",
            "value": 65
          }, {
            "date": "2012-12-04",
            "value": 73
          }, {
            "date": "2012-12-05",
            "value": 79
          }, {
            "date": "2012-12-06",
            "value": 78
          }, {
            "date": "2012-12-07",
            "value": 78
          }, {
            "date": "2012-12-08",
            "value": 78
          }, {
            "date": "2012-12-09",
            "value": 74
          }, {
            "date": "2012-12-10",
            "value": 73
          }, {
            "date": "2012-12-11",
            "value": 75
          }, {
            "date": "2012-12-12",
            "value": 70
          }, {
            "date": "2012-12-13",
            "value": 77
          }, {
            "date": "2012-12-14",
            "value": 67
          }, {
            "date": "2012-12-15",
            "value": 62
          }, {
            "date": "2012-12-16",
            "value": 64
          }, {
            "date": "2012-12-17",
            "value": 61
          }, {
            "date": "2012-12-18",
            "value": 59
          }, {
            "date": "2012-12-19",
            "value": 53
          }, {
            "date": "2012-12-20",
            "value": 54
          }, {
            "date": "2012-12-21",
            "value": 56
          }, {
            "date": "2012-12-22",
            "value": 59
          }, {
            "date": "2012-12-23",
            "value": 58
          }, {
            "date": "2012-12-24",
            "value": 55
          }, {
            "date": "2012-12-25",
            "value": 52
          }, {
            "date": "2012-12-26",
            "value": 54
          }, {
            "date": "2012-12-27",
            "value": 50
          }, {
            "date": "2012-12-28",
            "value": 50
          }, {
            "date": "2012-12-29",
            "value": 51
          }, {
            "date": "2012-12-30",
            "value": 52
          }, {
            "date": "2012-12-31",
            "value": 58
          }, {
            "date": "2013-01-01",
            "value": 60
          }, {
            "date": "2013-01-02",
            "value": 67
          }, {
            "date": "2013-01-03",
            "value": 64
          }, {
            "date": "2013-01-04",
            "value": 66
          }, {
            "date": "2013-01-05",
            "value": 60
          }, {
            "date": "2013-01-06",
            "value": 63
          }, {
            "date": "2013-01-07",
            "value": 61
          }, {
            "date": "2013-01-08",
            "value": 60
          }, {
            "date": "2013-01-09",
            "value": 65
          }, {
            "date": "2013-01-10",
            "value": 75
          }, {
            "date": "2013-01-11",
            "value": 77
          }, {
            "date": "2013-01-12",
            "value": 78
          }, {
            "date": "2013-01-13",
            "value": 70
          }, {
            "date": "2013-01-14",
            "value": 70
          }, {
            "date": "2013-01-15",
            "value": 73
          }, {
            "date": "2013-01-16",
            "value": 71
          }, {
            "date": "2013-01-17",
            "value": 74
          }, {
            "date": "2013-01-18",
            "value": 78
          }, {
            "date": "2013-01-19",
            "value": 85
          }, {
            "date": "2013-01-20",
            "value": 82
          }, {
            "date": "2013-01-21",
            "value": 83
          }, {
            "date": "2013-01-22",
            "value": 88
          }, {
            "date": "2013-01-23",
            "value": 85
          }, {
            "date": "2013-01-24",
            "value": 85
          }, {
            "date": "2013-01-25",
            "value": 80
          }, {
            "date": "2013-01-26",
            "value": 87
          }, {
            "date": "2013-01-27",
            "value": 84
          }, {
            "date": "2013-01-28",
            "value": 83
          }, {
            "date": "2013-01-29",
            "value": 84
          }, {
            "date": "2013-01-30",
            "value": 81
          }, {
            "date": "2013-02-01",
            "value": 60
          }, {
            "date": "2013-02-02",
            "value": 67
          }, {
            "date": "2013-02-03",
            "value": 64
          }, {
            "date": "2013-02-04",
            "value": 66
          }, {
            "date": "2013-02-05",
            "value": 60
          }, {
            "date": "2013-02-06",
            "value": 63
          }, {
            "date": "2013-02-07",
            "value": 61
          }, {
            "date": "2013-02-08",
            "value": 60
          }, {
            "date": "2013-02-09",
            "value": 65
          }, {
            "date": "2013-02-10",
            "value": 75
          }, {
            "date": "2013-02-11",
            "value": 77
          }, {
            "date": "2013-02-12",
            "value": 78
          }, {
            "date": "2013-02-13",
            "value": 70
          }, {
            "date": "2013-02-14",
            "value": 70
          }, {
            "date": "2013-02-15",
            "value": 73
          }, {
            "date": "2013-02-16",
            "value": 71
          }, {
            "date": "2013-02-17",
            "value": 74
          }, {
            "date": "2013-02-18",
            "value": 78
          }, {
            "date": "2013-02-19",
            "value": 85
          }, {
            "date": "2013-02-20",
            "value": 82
          }, {
            "date": "2013-02-21",
            "value": 83
          }, {
            "date": "2013-02-22",
            "value": 88
          }, {
            "date": "2013-02-23",
            "value": 85
          }, {
            "date": "2013-02-24",
            "value": 85
          }, {
            "date": "2013-02-25",
            "value": 80
          }, {
            "date": "2013-02-26",
            "value": 87
          }, {
            "date": "2013-02-27",
            "value": 84
          }, {
            "date": "2013-02-28",
            "value": 83
          }, {
            "date": "2013-02-29",
            "value": 84
          }, {
            "date": "2013-02-30",
            "value": 81
          }  ];

          $scope.datos_year = [{
            "date": "2012-09-26",
            "value": 65
          }, {
            "date": "2012-09-27",
            "value": 61
          }, {
            "date": "2012-09-28",
            "value": 66
          }, {
            "date": "2012-10-05",
            "value": 21
          }, {
            "date": "2012-10-06",
            "value": 18
          }, {
            "date": "2012-10-07",
            "value": 21
          }, {
            "date": "2012-10-08",
            "value": 28
          }, {
            "date": "2012-10-09",
            "value": 27
          }, {
            "date": "2012-10-10",
            "value": 36
          }, {
            "date": "2012-10-11",
            "value": 33
          }, {
            "date": "2012-10-12",
            "value": 31
          }, {
            "date": "2012-10-13",
            "value": 30
          }, {
            "date": "2012-10-14",
            "value": 34
          }, {
            "date": "2012-10-15",
            "value": 38
          }, {
            "date": "2012-10-16",
            "value": 37
          }, {
            "date": "2012-10-17",
            "value": 44
          }, {
            "date": "2012-10-18",
            "value": 49
          }, {
            "date": "2012-10-19",
            "value": 53
          }, {
            "date": "2012-10-20",
            "value": 57
          }, {
            "date": "2012-10-21",
            "value": 60
          }, {
            "date": "2012-10-22",
            "value": 61
          }, {
            "date": "2012-10-23",
            "value": 69
          }, {
            "date": "2012-10-24",
            "value": 67
          }, {
            "date": "2012-10-25",
            "value": 72
          }, {
            "date": "2012-10-26",
            "value": 77
          }, {
            "date": "2012-10-27",
            "value": 75
          }, {
            "date": "2012-10-28",
            "value": 70
          }, {
            "date": "2012-10-29",
            "value": 72
          }, {
            "date": "2012-10-30",
            "value": 70
          }, {
            "date": "2012-10-31",
            "value": 72
          }, {
            "date": "2012-11-01",
            "value": 73
          }, {
            "date": "2012-11-02",
            "value": 67
          }, {
            "date": "2012-11-03",
            "value": 68
          }, {
            "date": "2012-11-04",
            "value": 65
          }, {
            "date": "2012-11-05",
            "value": 71
          }, {
            "date": "2012-11-06",
            "value": 75
          }, {
            "date": "2012-11-07",
            "value": 74
          }, {
            "date": "2012-11-08",
            "value": 71
          }, {
            "date": "2012-11-09",
            "value": 76
          }, {
            "date": "2012-11-10",
            "value": 77
          }, {
            "date": "2012-11-11",
            "value": 81
          }, {
            "date": "2012-11-12",
            "value": 83
          }, {
            "date": "2012-11-13",
            "value": 80
          }, {
            "date": "2012-11-14",
            "value": 81
          }, {
            "date": "2012-11-15",
            "value": 87
          }, {
            "date": "2012-11-16",
            "value": 82
          }, {
            "date": "2012-11-17",
            "value": 86
          }, {
            "date": "2012-11-18",
            "value": 80
          }, {
            "date": "2012-11-19",
            "value": 87
          }, {
            "date": "2012-11-20",
            "value": 83
          }, {
            "date": "2012-11-21",
            "value": 85
          }, {
            "date": "2012-11-22",
            "value": 84
          }, {
            "date": "2012-11-23",
            "value": 82
          }, {
            "date": "2012-11-24",
            "value": 73
          }, {
            "date": "2012-11-25",
            "value": 71
          }, {
            "date": "2012-11-26",
            "value": 75
          }, {
            "date": "2012-11-27",
            "value": 79
          }, {
            "date": "2012-11-28",
            "value": 70
          }, {
            "date": "2012-11-29",
            "value": 73
          }, {
            "date": "2012-11-30",
            "value": 61
          }, {
            "date": "2012-12-01",
            "value": 62
          }, {
            "date": "2012-12-02",
            "value": 66
          }, {
            "date": "2012-12-03",
            "value": 65
          }, {
            "date": "2012-12-04",
            "value": 73
          }, {
            "date": "2012-12-05",
            "value": 79
          }, {
            "date": "2012-12-06",
            "value": 78
          }, {
            "date": "2012-12-07",
            "value": 78
          }, {
            "date": "2012-12-08",
            "value": 78
          }, {
            "date": "2012-12-09",
            "value": 74
          }, {
            "date": "2012-12-10",
            "value": 73
          }, {
            "date": "2012-12-11",
            "value": 75
          }, {
            "date": "2012-12-12",
            "value": 70
          }, {
            "date": "2012-12-13",
            "value": 77
          }, {
            "date": "2012-12-14",
            "value": 67
          }, {
            "date": "2012-12-15",
            "value": 62
          }, {
            "date": "2012-12-16",
            "value": 64
          }, {
            "date": "2012-12-17",
            "value": 61
          }, {
            "date": "2012-12-18",
            "value": 59
          }, {
            "date": "2012-12-19",
            "value": 53
          }, {
            "date": "2012-12-20",
            "value": 54
          }, {
            "date": "2012-12-21",
            "value": 56
          }, {
            "date": "2012-12-22",
            "value": 59
          }, {
            "date": "2012-12-23",
            "value": 58
          }, {
            "date": "2012-12-24",
            "value": 55
          }, {
            "date": "2012-12-25",
            "value": 52
          }, {
            "date": "2012-12-26",
            "value": 54
          }, {
            "date": "2012-12-27",
            "value": 50
          }, {
            "date": "2012-12-28",
            "value": 50
          }, {
            "date": "2012-12-29",
            "value": 51
          }, {
            "date": "2012-12-30",
            "value": 52
          }, {
            "date": "2012-12-31",
            "value": 58
          }, {
            "date": "2013-01-01",
            "value": 60
          }, {
            "date": "2013-01-02",
            "value": 67
          }, {
            "date": "2013-01-03",
            "value": 64
          }, {
            "date": "2013-01-04",
            "value": 66
          }, {
            "date": "2013-01-05",
            "value": 60
          }, {
            "date": "2013-01-06",
            "value": 63
          }, {
            "date": "2013-01-07",
            "value": 61
          }, {
            "date": "2013-01-08",
            "value": 60
          }, {
            "date": "2013-01-09",
            "value": 65
          }, {
            "date": "2013-01-10",
            "value": 75
          }, {
            "date": "2013-01-11",
            "value": 77
          }, {
            "date": "2013-01-12",
            "value": 78
          }, {
            "date": "2013-01-13",
            "value": 70
          }, {
            "date": "2013-01-14",
            "value": 70
          }, {
            "date": "2013-01-15",
            "value": 73
          }, {
            "date": "2013-01-16",
            "value": 71
          }, {
            "date": "2013-01-17",
            "value": 74
          }, {
            "date": "2013-01-18",
            "value": 78
          }, {
            "date": "2013-01-19",
            "value": 85
          }, {
            "date": "2013-01-20",
            "value": 82
          }, {
            "date": "2013-01-21",
            "value": 83
          }, {
            "date": "2013-01-22",
            "value": 88
          }, {
            "date": "2013-01-23",
            "value": 85
          }, {
            "date": "2013-01-24",
            "value": 85
          }, {
            "date": "2013-01-25",
            "value": 80
          }, {
            "date": "2013-01-26",
            "value": 87
          }, {
            "date": "2013-01-27",
            "value": 84
          }, {
            "date": "2013-02-06",
            "value": 63
          }, {
            "date": "2013-02-07",
            "value": 61
          }, {
            "date": "2013-02-08",
            "value": 60
          }, {
            "date": "2013-02-09",
            "value": 65
          }, {
            "date": "2013-02-10",
            "value": 75
          }, {
            "date": "2013-02-11",
            "value": 77
          }, {
            "date": "2013-02-12",
            "value": 78
          }, {
            "date": "2013-02-13",
            "value": 70
          }, {
            "date": "2013-02-14",
            "value": 70
          }, {
            "date": "2013-02-15",
            "value": 73
          }, {
            "date": "2013-02-16",
            "value": 71
          }, {
            "date": "2013-02-17",
            "value": 74
          }, {
            "date": "2013-02-18",
            "value": 78
          }, {
            "date": "2013-02-19",
            "value": 85
          }, {
            "date": "2013-02-20",
            "value": 82
          }, {
            "date": "2013-02-21",
            "value": 83
          }, {
            "date": "2013-02-22",
            "value": 88
          }, {
            "date": "2013-02-23",
            "value": 85
          }, {
            "date": "2013-02-24",
            "value": 85
          }, {
            "date": "2013-02-25",
            "value": 80
          }, {
            "date": "2013-02-26",
            "value": 87
          }, {
            "date": "2013-02-27",
            "value": 84
          }, {
            "date": "2013-02-28",
            "value": 83
          }, {
            "date": "2013-02-29",
            "value": 84
          }, {
            "date": "2013-02-30",
            "value": 81
          }  ];


        var chart = AmCharts.makeChart( "grafica_consumo_c", {
          "type": "serial",
          "marginRight": 40,
          "marginLeft": 40,
          "autoMarginOffset": 20,
          "dataDateFormat": "YYYY-MM-DD",
          "valueAxes": [ {
            "id": "v1",
            "axisAlpha": 0,
            "position": "left",
            "ignoreAxisWidth": true
          } ],
          "balloon": {
            "borderThickness": 1,
            "shadowAlpha": 0
          },
          "graphs": [ {
            "id": "g1",
            "balloon": {
              "drop": true,
              "adjustBorderColor": false,
              "color": "#ffffff",
              "type": "smoothedLine"
            },
            "fillAlphas": 0.2,
            "bullet": "round",
            "bulletBorderAlpha": 1,
            "bulletColor": "#FFFFFF",
            "bulletSize": 5,
            "hideBulletsCount": 50,
            "lineThickness": 2,
            "title": "red line",
            "useLineColorForBulletBorder": true,
            "valueField": "value",
            "balloonText": "<span style='font-size:18px;'>[[value]]</span>"
          } ],
          "chartCursor": {
            "valueLineEnabled": true,
            "valueLineBalloonEnabled": true,
            "cursorAlpha": 0,
            "zoomable": false,
            "valueZoomable": true,
            "valueLineAlpha": 0.5
          },
          "valueScrollbar": {
            "autoGridCount": true,
            "color": "#000000",
            "scrollbarHeight": 50
          },
          "categoryField": "date",
          "categoryAxis": {
            "parseDates": true,
            "dashLength": 1,
            "minorGridEnabled": true
          },
          "export": {
            "enabled": true
          },
          "dataProvider": $scope.datos_mes
        } );
      //}
    //});
  } 

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.instalador.projects')
      .controller('projectCtrl_', projectCtrl_);
  
    function projectCtrl_($scope, $rootScope, $localStorage, RESTServices, projectsUtil) {
        
        $scope.edit = false;
        
        $scope.project = {
          name: 'Mi casa',
          id: 123560,
          zones: [
              {
                name:'Sala',
                id: 123456,
                devices: [
                    {
                      name: 'consumo',
                      id: 123456,
                      type: 1
                    },
                    {
                      name: 'aire',
                      id: 11111,
                      type: 2
                    }
                ]
              },
              {
                name:'cocina',
                id: 456789,
                devices: [
                    {
                      name: 'consumo',
                      id: 74582,
                      type: 1
                    },
                    {
                      name: 'temperatura',
                      id: 44111,
                      type: 3
                    }
                ]
              }
          ]
        };

        ////////////////
        var dv = [];
        $scope.project.zones.map(function(z){ 
          z.devices.map(function(d){
            d.class = projectsUtil.selectClass(d.type);
            dv.push(d)
          })
        })

        $scope.devices = dv;

        /////////////////

        $scope.editName = function(){

        }




    }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.instalador.projects')
        .directive('project', project);
  
    /** @ngInject */
    function project() {
      return {
        restrict: 'E',
        controller: 'projectCtrl_',
        scope: {
          //project: '=project'
        },
        templateUrl: 'app/instalador/projects/directives/project/project.html'
      };
    }
})();
/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.alerts')
        .controller('alertCardCtrl', alertCardCtrl);

    /** @ngInject */
    function alertCardCtrl($scope, RESTServices, $localStorage, ngDialog, $rootScope, SHAREServices, $state, toastr, $filter) {

        $scope.indAlerts = 2;
        $scope.status = {
            open: false,
        };

        $scope.itemsPerPage = 5;
        $scope.currentPage = 1;

        $scope.showNotifications = function(alert){
            $scope.status.open = !$scope.status.open;

            if($scope.status.open){
                RESTServices.fetchAlertNotificationsV2(alert.id).then(function(data) {
                    if (data != null) {
                        if (data.code == '200') {
                            var notifications = data.notificaciones.map(function(not) {
                                return ({
                                    date: SHAREServices.dateToLocal(not.fecha,2,1,false), 
                                    time: SHAREServices.dateToLocal(not.fecha,2,1,true),
                                    device: $scope.alert.selectedDevices,
                                    // device: $scope.alert.selectedDevices.find(function(device){
                                    //     return device.id == not.id_dispositivo
                                    // })
                                })
                            })
                            $scope.alert.notifications = $filter('orderBy')(notifications, ['-date','-time']);
                        }
                    }else{
                       //console.log("no hay respuesta")
                    }  
                })
            }
            
        }

        $scope.activeAlert = function(alert){
            var items = [{ id: alert.id, estado: alert.status == false ? '1' : '0' }];
            RESTServices.setAlertsStateV2(items).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        $scope.alert.status = !$scope.alert.status;
                        toastr.success($scope.alert.status ? 'Alerta activada' : 'Alerta Desactivada');
                    }else{
                        toastr.error('Hubo un problema inesperado');
                    }
                }else{
                    toastr.error('Hubo un problema inesperado');
                }  

            });
        }

        $scope.deleteAlert = function(alert){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = "¿Deseas borrar esta alerta?";
                    
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
                    $scope.aceptar = function() {                                    
                        RESTServices.deleteAlertsV2([alert.id]).then(function(data) {
                            if (data != null) {
                                if (data.code == '200') {
                                    $rootScope.$broadcast('AlertDelected', {data: alert});
                                    toastr.success('Alerta Borrada');
                                    ngDialog.close();                                     
                                }else{
                                    toastr.error('Hubo un problema inesperado');
                                   
                                }
                            }else{
                                toastr.error('Hubo un problema inesperado'); 
                            }  
            
                        });
                    }
                }]
            })
        }

        $scope.editAlert = function(alert){
            $state.go('newAlert', {editMode: true, alert: alert});
        }



    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.alerts')
        .directive('alertCard', alertCard);
  
    /** @ngInject */
    function alertCard() {
      return {
        restrict: 'E',
        controller: 'alertCardCtrl',
        scope: {
          alert: '=alert'
        },
        templateUrl: 'app/cliente/alerts/components/alert-card/alert-card.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.alerts')
        .controller('offlineDevicesCtrl', offlineDevicesCtrl);

    /** @ngInject */
    function offlineDevicesCtrl($scope, RESTServices, $localStorage, ngDialog, SHAREServices, $state, toastr, $filter, $rootScope) {


        $scope.itemsPerPage = 5;
        $scope.currentPage = 1;
        $scope.offlineDevices = [];
        $scope.loading = true;

        $scope.$on('setAlertZone', function(e, result){
            if(result.zona) {
                getOfflineDevices(result.zona)
            }
        })

        function getOfflineDevices(zona) {
            $scope.offlineDevices = [];
            $scope.loading = true;
            RESTServices.fetchZoneOfflineDevicesV2(zona.id).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        $scope.loading = false;
                        if(data.offline){
                            $scope.offlineDevices = $scope.offlineDevices.concat(data.offline);
                            $scope.offlineDevices = calcularUltimaConexion($scope.offlineDevices);
                        }
                    } else {
                        $scope.loading = false;
                    }
                }else{
                    $scope.loading = false;
                }  
            })
        }

        function calcularUltimaConexion(data) {
            data.forEach(function (device) {
                if(device.fecha_conexion) {
                    // Convertir fecha de conexión a formato local y formatearla
                    device.date = SHAREServices.dateToLocal(device.fecha_conexion, 2, 1, false);
                    device.date = $filter('date')(device.date, 'MMM d, y h:mm:ss a');
            
                    // Reemplazar guiones en las fechas para soporte en Safari
                    var h_s = device.fecha_server.replace(/-/g, '/');
                    var h_d = device.fecha_conexion.replace(/-/g, '/');
                    
                    // Convertir fechas a milisegundos
                    var h_server = new Date(h_s).getTime();
                    var h_device = new Date(h_d).getTime();
                    
                    // Calcular la diferencia entre las fechas
                    var df = h_server - h_device;
                    var index = 0;
                    var ind;
            
                    // Si la fecha de dispositivo es válida, calcular la última conexión
                    if (h_device !== 0) {
                        while (checkDigits(df)) {
                            ind = df / div(index);
                            index++;
                            device.ultima_conexion = ind;
                            df = ind;
                        }
                    }
            
                    // Función para verificar si el número tiene más de un dígito y es positivo
                    function checkDigits(number) {
                        var ind_ = Math.trunc(number);
                        var length = ind_.toString().length;
                        return (length > 1) && (ind_ > 0);
                    }
            
                    // Función para obtener el divisor según el índice y establecer la unidad de tiempo
                    function div(ind) {
                        switch (ind) {
                            case 0:
                                device.ind = 'Segundos';
                                return 1000;
                            case 1:
                                device.ind = 'Minutos';
                                return 60;
                            case 2:
                                device.ind = 'Horas';
                                return 60;
                            case 3:
                                device.ind = 'Días';
                                return 24;
                            case 4:
                                device.ind = 'Meses';
                                return 30;
                            case 5:
                                device.ind = 'Años';
                                return 12;
                            default:
                                return 1;
                        }
                    }
                }
                
        
                return device;
            });
        
            return data;
        }


    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.alerts')
        .directive('offlineDevices', offlineDevices);
  
    /** @ngInject */
    function offlineDevices() {
      return {
        restrict: 'E',
        controller: 'offlineDevicesCtrl',
        scope: {
          zone: '=zone',
        },
        templateUrl: 'app/cliente/alerts/components/offline-devices/offline-devices.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.alerts')
        .controller('tableAlertsCtrl', tableAlertsCtrl);

    /** @ngInject */
    function tableAlertsCtrl($scope, RESTServices, $localStorage, ngDialog, SHAREServices, $state, toastr, $filter, $rootScope) {

        $scope.status = {
            open: false,
        };

        $scope.itemsPerPage = 5;
        $scope.currentPage = 1;

        $scope.showNotifications = function(alert, index){
                RESTServices.fetchAlertNotificationsV2(alert.id).then(function(data) {
                    if (data != null) {
                        if (data.code == '200') {
                            data.notificaciones.sort(function (a, b) {
                                if (a.fecha > b.fecha) {
                                    return 1;
                                }
                                if (a.fecha < b.fecha) {
                                    return -1;
                                }
                                return 0;
                            });
                            var notifications = data.notificaciones.map(function(not) {
                                return ({
                                    date: SHAREServices.dateToLocal(not.fecha,2,1,false), 
                                    time: SHAREServices.dateToLocal(not.fecha,2,1,true),
                                    device: $scope.alerts[index].selectedDevices,
                                })
                            })
                            $scope.alerts[index].notifications = $filter('orderBy')(notifications, ['-date','-time']);
                        }
                    }else{
                       //console.log("no hay respuesta")
                    }  
                })
            
            
        }

        $scope.activeAlert = function(alert, index){
            var items;
            if (alert.type.type !== '15') {
                items = [{ id: alert.id, estado: alert.status == false ? '1' : '0' }];
            } else {
                items = alert.nestedAlerts.map(function(a) {
                    return ({
                        "id": a.id,
                        "estado": a.status == false ? '1':'0'
                    })
                })
            }

            RESTServices.setAlertsStateV2(items).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        $scope.alerts[index].status = !$scope.alerts[index].status;
                        toastr.success($scope.alerts[index].status ? 'Alerta activada' : 'Alerta Desactivada');
                    }else{
                        toastr.error('Hubo un problema inesperado');
                    }
                }else{
                    toastr.error('Hubo un problema inesperado');
                }  

            });
        }

        $scope.deleteAlert = function(alert){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = "¿Deseas borrar esta alerta?";
                    
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
                    $scope.aceptar = function() { 
                        $rootScope.flag_loading = true; 
                        var ids;
                        if (alert.type.type !== '15') {
                            ids = [alert.id];
                        } else {
                            ids = alert.nestedAlerts.map(function(a) {
                                return a.id;
                            })
                        }

                        RESTServices.deleteAlertsV2(ids).then(function(data) {
                            if (data != null) {
                                if (data.code == '200') {
                                    alertDelected(alert);
                                    toastr.success('Alerta Borrada');
                                    ngDialog.close();                                     
                                }else{
                                    toastr.error('Hubo un problema inesperado');
                                   
                                }
                            }else{
                                toastr.error('Hubo un problema inesperado'); 
                            }
                            $rootScope.flag_loading = false;
                        });
                    }
                }]
            })
        }

        $scope.editAlert = function(alert){
            if (alert.type.min_name === 'Offline' || alert.type.min_name === 'limit' || alert.type.min_name === 'Comm') {
                $state.go('offlineAlert', {editMode: true, alert: alert, zona: $scope.zone})
            } else {
                $state.go('newAlert', {editMode: true, alert: alert, zona: $scope.zone})
            }
        }

        $scope.open = function(alert, index) {
            $scope.alerts[index].info = !$scope.alerts[index].info;
            if($scope.alerts[index].feriado === '1'){
                getHolidays($scope.alerts[index].ids_feriados, $scope.zone, index);
            }
        }

        $scope.setDay = function(day) {
            switch(day){
                case '1':
                    return 'Lun,';
                case '2':
                    return 'Mar,';
                case '3':
                    return 'Mie,';
                case '4':
                    return 'Jue,';
                case '5':
                    return 'Vie,';
                case '6':
                    return 'Sab,';
                case '0':
                    return 'Dom,';
            }
        }

        $scope.setRepeat = function(ind) {
            switch(ind){
                case '1':
                    return '1 minuto';
                case '2':
                    return '2 minutos';
                case '5':
                    return '5 minutos';
                case '10':
                    return '10 minutos';
                case '20':
                    return '20 minutos';
                case '30':
                    return '30 minutos';
                case '60':
                    return '1 hora';
                case '120':
                    return '2 horas';
                case '360':
                    return '6 horas';
                case '720':
                    return '12 horas';
                case '1440':
                    return '1 día';
            }
        }

        function alertDelected(alert) {
            var index = $scope.alerts.findIndex(function(i){return i.id == alert.id});
            $scope.alerts.splice(index, 1);
            if ($scope.alerts.length == 0) {
                $state.go('noAlerts');
            }
        };

        function getHolidays(feriados, zone, index) {
            var params = {
                "id_usuario": $localStorage.id_usuario,
                "id_pais": zone.id_pais,
                "year": $filter('date')(new Date(), 'yyyy'),
            };
      
            RESTServices.post_header('cliente/consulta_festivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code === '200') {
                    var holidays = data.festivos;
                    holidays.map(function(h){
                        if(feriados.includes(h.id)){
                            h.status = true;
                        }
                    })

                    $scope.alerts[index].holidays = holidays.filter(function(h){ return h.status})

                    
                } 
            })
        }

        // $scope.ShowMonitoring = function(alert) {
        //     SHAREServices.dispositivo_selected = alert.selectedDevices;
        //     SHAREServices.diaDatepicker = $filter('date')(new Date(alert.fecha_notificacion ? alert.fecha_notificacion : new Date()), 'yyyy-MM-dd');
        //     $scope.$broadcast('updateDevice', {data: alert.selectedDevices, dispositivos: SHAREServices.devices}); 
        // }



    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.alerts')
        .directive('tableAlerts', tableAlerts);
  
    /** @ngInject */
    function tableAlerts() {
      return {
        restrict: 'E',
        controller: 'tableAlertsCtrl',
        scope: {
          alerts: '=alerts',
          zone: '=zone',
        },
        templateUrl: 'app/cliente/alerts/components/table-alerts/table-alerts.html'
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('consumptionDevicesCtrl', consumptionDevicesCtrl);

    /** @ngInject */

    function consumptionDevicesCtrl($localStorage, $scope, consumoV2Util, RESTServices, $filter, $state, SHAREServices) {
        $scope.id;
        $scope.listaOrden = ['Mayor consumo', 'Menor consumo', 'Primero Helo S', 'Primero Helo Air', 'Primero Helo One', 'Primero Helo Avanzada'];
        var date = {};
        var params = {}
        
        $scope.$on('devicesConsumption', function(event, result){
            $scope.zones = result.zonas;
            $scope.zona = $scope.zones[0];
            $scope.id = $scope.zona.id;
            date.fecha_ini = $filter('date')(consumoV2Util.setYesterday()[0], 'yyyy-MM-dd HH:mm:ss');
            date.fecha_final = $filter('date')(consumoV2Util.setYesterday()[1], 'yyyy-MM-dd HH:mm:ss');
            params = {tipo: 1, date: date}
            $scope.getConsumption($scope.zona.id, params);
        });

        $scope.getConsumption = function(id, data) {
            $scope.devices = [];
            $scope.devicesFiltered = [];
            $scope.loading = true;
            $scope.noInfo = false;
            if(data) {
                params.tipo = data.tipo;
                params.date = data.date;
            }

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "fecha_ini": data !== undefined ? data.date.fecha_ini : params.date.fecha_ini,
                "fecha_fin": data !== undefined ? data.date.fecha_final : params.date.fecha_final,
                "tipo": data !== undefined ? params.tipo : 1,
                "id_zona": id !== false ? id : $scope.id,
            };

            RESTServices.post_header('cliente/consulta_consumos.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.dispositivos != undefined) {
                        $scope.devices = response.dispositivos;
                    } 
                    if (response.dispositivos_externos != undefined) {
                        $scope.devices = $scope.devices.concat(response.dispositivos_externos)
                    } 
                    if ($scope.devices.length > 0) {
                        $scope.devicesFiltered = $scope.devices;
                        $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, '-consumo');
                        $scope.loading = false;
                        $scope.noInfo = false;
                    } else {
                        $scope.loading = false;
                        $scope.noInfo = true;
                    }
                    
                } else {
                    $scope.noInfo = true;
                    $scope.loading = false;
                }

            })
        };

        $scope.goConsumptionGraphics = function(device) {
            if (device.tipo == '9') {
                var fields = {
                    "id_usuario": $localStorage.id_usuario,
                    "id_dispositivo": device.id,
                };
                RESTServices.post_header('cliente/consulta_dispositivo.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                    if (res.code === "200") {
                        var data = {'nombre': device.nombre, 'id_device': device.id, 'id_zona': res.dispositivo.id_zona }
                        $state.go('estadisticas_zona', data);
                    }
                });   
            } else {
                $state.go('consumption.consumoDispositivo', {dispositivo: device});
            }
        }

        $scope.filterOrderBy = function(e) {
            switch(e) {
                case 'Mayor consumo':
                    $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, '-consumo');
                    break;
                case 'Menor consumo':
                    $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, 'consumo');
                    break;
                case 'Primero Helo S':
                    var filtered = $scope.devicesFiltered.filter(function(d) {
                        return d.tipo === '5';
                    });
                    filtered = $filter('orderBy')(filtered, '-consumo');
                    var otros = $scope.devicesFiltered.filter(function(d) {
                        return d.tipo !== '5';
                    });
                    var todos = filtered.concat(otros);
                    $scope.devicesFiltered = todos;
                    break;
                case 'Primero Helo Air':
                    var filtered = $scope.devicesFiltered.filter(function(d) {
                        return d.tipo === '3';
                    });
                    filtered = $filter('orderBy')(filtered, '-consumo');
                    var otros = $scope.devicesFiltered.filter(function(d) {
                        return d.tipo !== '3';
                    });
                    var todos = filtered.concat(otros);
                    $scope.devicesFiltered = todos;
                    break;
                case 'Primero Helo One':
                    var filtered = $scope.devicesFiltered.filter(function(d) {
                        return d.tipo === '0';
                    });
                    filtered = $filter('orderBy')(filtered, '-consumo');
                    var otros = $scope.devicesFiltered.filter(function(d) {
                        return d.tipo !== '0';
                    });
                    var todos = filtered.concat(otros);
                    $scope.devicesFiltered = todos;
                    break;
                case 'Primero Helo Avanzada':
                    var filtered = $scope.devicesFiltered.filter(function(d) {
                        return d.tipo === '9';
                    });
                    filtered = $filter('orderBy')(filtered, '-consumo');
                    var otros = $scope.devicesFiltered.filter(function(d) {
                        return d.tipo !== '9';
                    });
                    var todos = filtered.concat(otros);
                    $scope.devicesFiltered = todos;
                    break;
            }
        }

        $scope.search = function(ind) {
            $scope.nombreCliente = 'Todos';
            $scope.nombreZona = 'Zonas';
            $scope.filters = [];
            $scope.devicesFiltered = $scope.devices;
            $scope.devicesFiltered = $filter('filter')($scope.devicesFiltered, {nombre:ind});
            if(ind = '') $scope.devicesFiltered = $scope.devices;
        }

    }




})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('consumptionDevices', consumptionDevices);
  
    /** @ngInject */
    function consumptionDevices() {
      return {
        restrict: 'E',
        controller: 'consumptionDevicesCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/consumption-devices/consumption-devices.html',
        scope: {
            noInfo: "=noInfo",
            loading: "=loading",
            zones: "=zones",
        }
    };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('consumptionPieChartCtrl', consumptionPieChartCtrl);

    /** @ngInject */

    function consumptionPieChartCtrl($scope, $localStorage, RESTServices, $filter, SHAREServices, consumoV2Util) {
        
        $scope.loading_ = true;
        $scope.noInfo_ = false;
        $scope.id;
        var date = {};
        var chart;
        var params = {};

        $scope.$on('devicesConsumption', function(event, result){
            $scope.zones = result.zonas;
            $scope.zona = $scope.zones[0];
            $scope.id = $scope.zona.id;
            date.fecha_ini = $filter('date')(consumoV2Util.setYesterday()[0], 'yyyy-MM-dd HH:mm:ss');
            date.fecha_final = $filter('date')(consumoV2Util.setYesterday()[1], 'yyyy-MM-dd HH:mm:ss');
            params = {tipo: 1, date: date}
            createGraphic();
            $scope.getConsumption_($scope.zona.id, params);
        });

        function createGraphic() {
            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end

            // Create chart instance
            chart = am4core.create("chartdiv", am4charts.PieChart);

            // Add and configure Series
            var pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "consumo";
            pieSeries.dataFields.category = "nombre";

            // Let's cut a hole in our Pie chart the size of 30% the radius
            chart.innerRadius = am4core.percent(30);

            // Put a thick white border around each Slice
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;
            pieSeries.slices.template
            // change the cursor on hover to make it apparent the object can be interacted with
            .cursorOverStyle = [
                {
                "property": "cursor",
                "value": "pointer"
                }
            ];

            pieSeries.alignLabels = false;
            pieSeries.labels.template.bent = true;
            pieSeries.labels.template.radius = 3;
            pieSeries.labels.template.padding(0,0,0,0);

            pieSeries.ticks.template.disabled = true;
            pieSeries.labels.template.disabled = true;

            // Create a base filter effect (as if it's not there) for the hover to return to
            var shadow = pieSeries.slices.template.filters.push(new am4core.DropShadowFilter);
            shadow.opacity = 0;

            // Create hover state
            var hoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

            // Slightly shift the shadow and make it more prominent on hover
            var hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter);
            hoverShadow.opacity = 0.7;
            hoverShadow.blur = 5;

            // Add a legend
            chart.legend = new am4charts.Legend();

            var legendContainer = am4core.create("legenddiv", am4core.Container);
            legendContainer.width = am4core.percent(100);
            legendContainer.height = am4core.percent(100);
            chart.legend.parent = legendContainer;
            //chart.legend.scrollable = true;

            //// cambiar el largo de contenedor de la leyenda dinamicamente
            chart.events.on("datavalidated", resizeLegend);
            chart.events.on("maxsizechanged", resizeLegend);

            chart.legend.events.on("datavalidated", resizeLegend);
            chart.legend.events.on("maxsizechanged", resizeLegend);

            function resizeLegend(ev) {
                document.getElementById("legenddiv").style.height = chart.legend.contentHeight + "px";
            }

        }
        
        $scope.$on("$destroy", function () {
            chart.dispose();
        });
        $scope.getConsumption_ = function(id, data) {
            $scope.devices = [];
            $scope.loading_ = true;
            $scope.noInfo_ = false;

            if(data) {
                params.tipo = data.tipo;
                params.date = data.date;
            }

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "fecha_ini": data !== undefined ? data.date.fecha_ini : params.date.fecha_ini,
                "fecha_fin": data !== undefined ? data.date.fecha_final : params.date.fecha_final,
                "tipo": data !== undefined ? params.tipo : 1,
                "id_zona": id !== false ? id : $scope.id,
            };

            RESTServices.post_header('cliente/consulta_consumos.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.dispositivos != undefined) {
                        $scope.devices = response.dispositivos;
                    } 
                    if (response.dispositivos_externos != undefined) {
                        $scope.devices = $scope.devices.concat(response.dispositivos_externos)
                    } 
                    if ($scope.devices.length > 0) {
                        chart.data = $scope.devices;
                        $scope.loading_ = false;
                        $scope.noInfo_ = false;
                    } else {
                        $scope.loading_ = false;
                        $scope.noInfo_ = true;
                    }
                    chart.data = $filter('orderBy')($scope.devices, '-consumo');
                } else {
                    $scope.noInfo_ = true;
                    $scope.loading_ = false;
                }

            })
        };
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('consumptionPieChart', consumptionPieChart);
  
    /** @ngInject */
    function consumptionPieChart() {
      return {
        restrict: 'E',
        controller: 'consumptionPieChartCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/consumption-pie-chart/consumption-pie-chart.html',
        scope: {
            noInfo: "=noInfo",
            loading: "=loading",
            zones: "=zones",
        }
    };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('datePickerConsumptionCtrl', datePickerConsumptionCtrl);

    /** @ngInject */

    function datePickerConsumptionCtrl($scope, consumoServices, $filter, consumoV2Util) {
        
        var tipo = '1';
        $scope.date = {};
        $scope.selectedIntervalDates = 0,
        $scope.intervalsDates = consumoServices.intervalsDates;
        $scope.selectedIntervalDates = "0",
        $scope.filtersDates = [
            {
                name: 'Día',
                type: 1,
                status: true,
                id: 'day',
            },
            {
                name: 'Mes',
                type: 2,
                status: false,
                id: 'month'
            },
        ];
        $scope.DateFormat = consumoServices.formato.month;

        $scope.open = function(itm) {
            $scope.popup[itm] = true;
        }

        $scope.options = {
            showWeeks: false,
            minMode: 'month',
            maxDate: new Date()
        };

        $scope.popup = {
            opened_1: false,
            opened_2: false
        };

        $scope.setIntelval = function(e) {
            if (e === '3') {
                $scope.customInterval = true;
                $scope.options.minMode = 'day';
                $scope.DateFormat = consumoServices.formato.day;
            } else {
                $scope.customInterval = false;
                var date = {};
                switch(e) {
                    case '0':
                        date.fecha_ini = $filter('date')(consumoV2Util.setYesterday()[0], 'yyyy-MM-dd HH:mm:ss');
                        date.fecha_final = $filter('date')(consumoV2Util.setYesterday()[1], 'yyyy-MM-dd HH:mm:ss');
                        $scope.selectedDate(false, {tipo: 1, date: date})
                        break;
                    case '1':
                        date.fecha_ini = $filter('date')(consumoV2Util.setMonth()[0], 'yyyy-MM-dd HH:mm:ss');
                        date.fecha_final = $filter('date')(consumoV2Util.setMonth()[1], 'yyyy-MM-dd HH:mm:ss');
                        $scope.selectedDate(false, {tipo: 1, date: date})
                        break;
                    case '2':
                        date.fecha_ini = $filter('date')(consumoV2Util.setYear()[0], 'yyyy-MM-dd HH:mm:ss');
                        date.fecha_final = $filter('date')(consumoV2Util.setYear()[1], 'yyyy-MM-dd HH:mm:ss');
                        $scope.selectedDate(false, {tipo: 1, date: date})
                        break;
                }
            }
        }
        $scope.changeInterval = function(type) {
            if (type === 1) {
                $scope.options.minMode = 'day';
                $scope.DateFormat = consumoServices.formato.day;
            } else {
                $scope.options.minMode = 'month';
                $scope.DateFormat = consumoServices.formato.month;
            }
            $scope.date = {};
            $scope.filtersDates.map(function(f) {f.status = false});
            var index = $scope.filtersDates.findIndex(function(f) { return f.type === type})
            $scope.filtersDates[index].status = true;
            tipo = $scope.filtersDates[index].type;
        }

        $scope.consultaConsumos = function(date) {
            if (date.fecha_ini && date.fecha_final) {
                if (date.fecha_final > date.fecha_ini) {
                    var lasDay = consumoV2Util.lastday(date.fecha_final.getFullYear(), date.fecha_final.getMonth())
                    var fechas = {};
                    fechas.fecha_ini = $filter('date')(date.fecha_ini, 'yyyy-MM-dd HH:mm:ss');
                    fechas.fecha_final = $filter('date')(date.fecha_final.setDate(lasDay), 'yyyy-MM-dd HH:mm:ss');
                    $scope.selectedDate(false, {tipo: tipo, date: fechas})
                } else {
                    $scope.errorInterval = true;
                }
            }
        }

       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('datePickerConsumption', datePickerConsumption);
  
    /** @ngInject */
    function datePickerConsumption() {
      return {
        restrict: 'E',
        controller: 'datePickerConsumptionCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/datePickerConsumption/datePickerConsumption.html',
        scope: {
          'selectedDate': '=',
        }
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('energyGraphicCtrl', energyGraphicCtrl);

    /** @ngInject */

    function energyGraphicCtrl($scope, consumoServices, consumoV2Util, $rootScope, $localStorage, RESTServices, $stateParams, $filter,SHAREServices) {

        $scope.DateFilter = [
            {
                name: 'Mes',
                type: 1,
                status: true,
                id: 'month'
            },
            {
                name: 'Año',
                type: 2,
                status: false,
                id: 'year',
            },
        ];

        // Dia (hourly bars) is only available for the Helo S (tipo 5): the API answers
        // 422 for any other device type.
        if ($stateParams.dispositivo.tipo === '5') {
            $scope.DateFilter.unshift({
                name: 'Día',
                type: 3,
                status: false,
                id: 'day',
            });
        }

        $scope.nombreDispositivo = $stateParams.dispositivo.nombre;
        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'month',
            maxDate: new Date()
        };

        $scope.DateFormat = consumoServices.formato.month;

        // The server derives the range from a period and one date, so the picked day is
        // all that is sent: any date of the month for Mes, any date of the year for Ano.
        $scope.update_date = function() {
            $scope.getEnergyTotal($scope.options.minMode, $filter('date')($scope.dt, 'yyyy-MM-dd'));
        }
        //$scope.dt = $filter('date')(new Date(), 'yyyy-MM-dd');
        $scope.dt = new Date();

        
        
        
        $scope.loading = false;
        $scope.noInfo = false;
        // estimated: consumption derived from the nominal voltage (shows "Estimado").
        // partial: the day is still running (Dia of today).
        $scope.estimated = false;
        $scope.partial = false;
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
            $scope.estimated = false;
            $scope.partial = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
        }

        $scope.setFilter = function(param){
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == param.id });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = param.id;
            $scope.DateFormat = consumoServices.formato[param.id];
            $scope.dt = new Date();
            $scope.update_date();
            //$scope.getEnergyTotal(date, param.type); 
        }

        var TIME_UNIT = { day: 'hour', month: 'day', year: 'month' };

        $scope.getEnergyTotal = function(period, date) {
            $rootScope.$broadcast('indDataConsumtion', {data: null});
            $scope.loading = true;
            $scope.noInfo = false;

            RESTServices.fetchDeviceConsumptionV2($stateParams.dispositivo.id, period, date).then(function(response) {
                var data = consumoV2Util.toLegacyConsumo(response, period);
                if (data.length === 0) {
                    noInfo();
                    return;
                }
                var flags = consumoV2Util.consumoFlags(response);
                dateAxis.baseInterval.timeUnit = TIME_UNIT[period];
                series.dataFields.dateX = period === 'year' ? 'mes' : 'dia';
                chart.data = data;
                $scope.estimated = flags.estimated;
                $scope.partial = flags.partial;
                $rootScope.$broadcast('indDataConsumtion', {data: data.map(function(d){return d.valor})});
                successfulResponse();
            }, function() {
                noInfo();
            });
        }
        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        // Create chart instance
        var chart = am4core.create("grafica_energia", am4charts.XYChart);
        // Rows carry 'yyyy-MM-dd HH:mm:ss'; the amCharts default ('yyyy-MM-dd') drops
        // the hour, which stacks the 24 Dia bars on the same instant.
        chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm:ss";

        // Create axes
        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.baseInterval = {
            "timeUnit": "day",
            "count": 1
        };

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.minWidth = 35;
        valueAxis.min = 0;

        // Create series
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.dateX = "dia";
        series.dataFields.valueY = "valor";

        series.name = "Energía";
        series.columns.template.tooltipHTML = "{fecha} : <strong>{valueY} KWh</strong>";
        series.columns.template.fillOpacity = .8;

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 2;
        columnTemplate.strokeOpacity = 1;

        // Initial load: the current month.
        $scope.getEnergyTotal('month', $filter('date')(new Date(), 'yyyy-MM-dd'));

        // add exporting button
        chart.exporting.menu = new am4core.ExportMenu();
        am4core.options.minPolylineStep = 5;
        am4core.options.onlyShowOnViewport = true;
        am4core.options.queue = true;

        $scope.$on("$destroy", function () {
            chart.dispose();
        });
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('energyGraphic', energyGraphic);
  
    /** @ngInject */
    function energyGraphic() {
      return {
        restrict: 'E',
        controller: 'energyGraphicCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/energy-graphic/energy-graphic.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('indActivePowerCtrl', indActivePowerCtrl);

    /** @ngInject */

    function indActivePowerCtrl($scope, $stateParams, $localStorage, RESTServices, toastr, $rootScope,SHAREServices) {
        
        $scope.editar_limite = false;
        
        (function getActivePower() {
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_dispositivo": $stateParams.dispositivo.id,
            };
            RESTServices.post_header('cliente/consulta_factor_potencia.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res != null) {
                    if (res.code === '200') {
                        $scope.activePower = Number(res.factor);
                    }
                }
            });
        })();

        $scope.setActivePower = function(newValue){
            if (newValue !== undefined && $scope.activePower !== newValue){
                var fields = {
                    "id_usuario": $localStorage.id_usuario,
                    //"token": SHAREServices.hash_decode_token($localStorage.token),
                    "id_dispositivo": $stateParams.dispositivo.id,
                    "factor": newValue,
                };

                RESTServices.post_header('cliente/edita_factor_potencia.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                    if (res != null) {
                        if (res.code === '200') {
                            // $rootScope.$broadcast('', {dispositivos: ''});
                            toastr.success('Valor editado correctamente', 'Potencia activa');
                            $scope.activePower = newValue;
                            $scope.editar_limite = false;
                        }
                    } else {
                        toastr.error('No se ha podido comunicar con la plataforma', 'Intenta más tarde');
                    }
                });
            } else {
                $scope.editar_limite = !$scope.editar_limite;
            }
            
        }

        $scope.editMode = function() {
            $scope.editar_limite = !$scope.editar_limite;
        }

        $scope.content = 'app/cliente/consumo_v2/components/ind-active-power/content.html';

       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('indActivePower', indActivePower);
  
    /** @ngInject */
    function indActivePower() {
      return {
        restrict: 'E',
        controller: 'indActivePowerCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/ind-active-power/ind-active-power.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('indDataCtrl', indDataCtrl);

    /** @ngInject */

    function indDataCtrl($scope, consumoServices, $rootScope) {
        
        $scope.ind = $scope.initial;
        
        $scope.$on('resetIndGraph', function(e, res){
            $scope.ind = "--"
        })

        $scope.$on('indDataConsumtion', function(event, result){
            if (result.data) {
                switch($scope.indTitle) {
                    case 'Máximo':
                        $scope.ind = calcularMaximo(result.data);               
                        break;
                    case 'Mínimo':
                        $scope.ind = calcularMinimo(result.data);  
                        break;
                    case 'Promedio':
                        $scope.ind = calcularPromedio(result.data); 
                        break;
                    case 'Umbral Superior':
                        $scope.ind = calcularUmbralSuperior(result.data); 
                        break;
                    case 'Umbral Inferior':
                        $scope.ind = calcularUmbralInferior(result.data); 
                        break;
                }
            } else {
                $scope.ind = '--';
            }
            
        });

        function calcularMaximo(data) {
            return Math.max.apply(null, data);
        };

        function calcularMinimo(data) {
            return Math.min.apply(null, data);
        }; 

        function calcularPromedio(data) {
            var sum = data.reduce(function(previous, current) { return current += previous});
            var avg = sum / data.length;
            return avg.toFixed(1);
        };

        function calcularUmbralSuperior(arr) {
            var frequency = {};

            for (var i = 0; i < arr.length; i++) {
                var num = arr[i];
                frequency[num] = (frequency[num] || 0) + 1;
            }

            // Convertir el objeto frequency en un arreglo de pares [num, count]
            var frequencyArray = Object.keys(frequency).map(function(key) {
                return [parseInt(key, 10), frequency[key]];
            });

            // Ordenar el arreglo por la frecuencia de mayor a menor
            frequencyArray.sort(function(a, b) {
                return b[1] - a[1];
            });
            var firstNum;
            var secondNum;
            if(frequencyArray[0]) {
                firstNum = frequencyArray[0][0];
            }
            if(frequencyArray[1]) {
                secondNum = frequencyArray[1][0];
            }

            if(!isNaN(Math.max(firstNum, secondNum))){
                return Math.max(firstNum, secondNum)
            } else {
                return '--';
            }
            
        }

        function calcularUmbralInferior(arr) {
            var frequency = {};

            for (var i = 0; i < arr.length; i++) {
                var num = arr[i];
                frequency[num] = (frequency[num] || 0) + 1;
            }

            // Convertir el objeto frequency en un arreglo de pares [num, count]
            var frequencyArray = Object.keys(frequency).map(function(key) {
                return [parseInt(key, 10), frequency[key]];
            });

            // Ordenar el arreglo por la frecuencia de mayor a menor
            frequencyArray.sort(function(a, b) {
                return b[1] - a[1];
            });

            var firstNum;
            var secondNum;
            if(frequencyArray[0]) {
                firstNum = frequencyArray[0][0];
            }
            if(frequencyArray[1]) {
                secondNum = frequencyArray[1][0];
            }

            if(!isNaN(Math.min(firstNum, secondNum))) {
                return Math.min(firstNum, secondNum);
            }else {
                return '--';
            }

            
        }
       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('indData', indData);
  
    /** @ngInject */
    function indData() {
      return {
        restrict: 'E',
        controller: 'indDataCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/ind-data/ind-data.html',
        scope: {
          indTitle: '=indTitle',
          unit: '=unit',
          initial: '=initial',
        }
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('indTotalizadorCtrl', indTotalizadorCtrl);

    /** @ngInject */

    function indTotalizadorCtrl($scope, consumoServices, $rootScope) {
        $scope.meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('indTotalizador', indTotalizador);
  
    /** @ngInject */
    function indTotalizador() {
      return {
        restrict: 'E',
        controller: 'indTotalizadorCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/ind-totalizador/ind-totalizador.html',
        scope: {
          indTitle: '=indTitle',
          unit: '=unit',
          ind: '=ind',
          hasSelect: '=hasSelect',
          selected: '=selected',
        },
        link: function(scope) {
          scope.changeInterlval = function(itm) {
              scope.selected(itm);
          }
        }
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('invoiceValueGraphicCtrl', invoiceValueGraphicCtrl);

    /** @ngInject */

    function invoiceValueGraphicCtrl($scope, $localStorage, RESTServices, SHAREServices, $rootScope, $stateParams, $filter, consumoServices) {
        
        $scope.dt = new Date();
        var chart;
        
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
        }

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = consumptionServices.format[itm];
        };

        function setParameters(itm) {
            return {
                "device_id": $stateParams.dispositivo.id,
                "user_id": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "data": $filter('date')($scope.dt, consumoServices.formato.day),
                "time": itm,
                "type": "consumption",
                "offset": (new Date()).getTimezoneOffset()
            };
        };
        
        $scope.consultarHistoricoValoresFactura = function(parm) {
            
            
            //loading(parm);
            var field = setParameters(parm);

            RESTServices.post_header('', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        //createGraphic();
                        //chart.data = consumptionUtil.addLastHour(response.data, $filter('date')($scope.dt, consumoServices.formato.day), parm);
                        //var allValues = response.data.map(function(d){return Number(d.estado)})
                        //$rootScope.$broadcast('indDataConsumtion', {data: allValues});
                        successfulResponse();
                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });

        }

        //$scope.consultarHistoricoValoresFactura();

        
        function createGraphic() {
            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end

            // Create chart instance
            chart = am4core.create("grafica_valor_factura", am4charts.XYChart);

            // Add data
            chart.data = generateChartData();

            // Create axes
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.minGridDistance = 50;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

            // Create series
            var series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = "visits";
            series.dataFields.dateX = "date";
            series.strokeWidth = 2;
            series.minBulletDistance = 10;
            series.tooltipText = "{valueY}";
            series.tooltip.pointerOrientation = "vertical";
            series.tooltip.background.cornerRadius = 20;
            series.tooltip.background.fillOpacity = 0.5;
            series.tooltip.label.padding(12,12,12,12)

            // Add scrollbar
            chart.scrollbarX = new am4charts.XYChartScrollbar();
            chart.scrollbarX.series.push(series);

            // Add cursor
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.snapToSeries = series;

            function generateChartData() {
                var chartData = [];
                var firstDate = new Date();
                firstDate.setDate(firstDate.getDate() - 1000);
                var visits = 1200;
                for (var i = 0; i < 500; i++) {
                    // we create date objects here. In your data, you can have date strings
                    // and then set format of your dates using chart.dataDateFormat property,
                    // however when possible, use date objects, as this will speed up chart rendering.
                    var newDate = new Date(firstDate);
                    newDate.setDate(newDate.getDate() + i);
                    
                    visits += Math.round((Math.random()<0.5?1:-1)*Math.random()*10);

                    chartData.push({
                        date: newDate,
                        visits: visits
                    });
                }
                return chartData;
            }
        }

        createGraphic();

        $scope.$on("$destroy", function () {
            chart.dispose();
        });
       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('invoiceValueGraphic', invoiceValueGraphic);
  
    /** @ngInject */
    function invoiceValueGraphic() {
      return {
        restrict: 'E',
        controller: 'invoiceValueGraphicCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/invoice-value-graphic/invoice-value-graphic.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('kwhConsumedGraphicCtrl', kwhConsumedGraphicCtrl);

    /** @ngInject */

    function kwhConsumedGraphicCtrl($scope, consumoServices, consumoV2Util, SHAREServices, $localStorage, RESTServices, $stateParams, $filter) {
        var chart;
        var type = 1;
        $scope.name_graphic = 'Valor Factura';
        $scope.unit = '$';
        ///////control datepicker
        $scope.date = {};
        $scope.DateFormat = consumoServices.formato.month;

        $scope.open = function(itm) {
            $scope.popup[itm] = true;
        }

        $scope.options = {
            showWeeks: false,
            minMode: 'month',
            maxDate: new Date()
        };

        $scope.popup = {
            opened_1: false,
            opened_2: false
        };

        $scope.update_date = function(date) {
            if (date.fecha_ini && date.fecha_final) {
                if (date.fecha_final > date.fecha_ini) {
                    date.fecha_ini = $filter('date')(date.fecha_ini, 'yyyy-MM-dd');
                    date.fecha_final = $filter('date')(date.fecha_final, 'yyyy-MM-dd');
                    $scope.getData(date, type)
                } else {
                    $scope.errorInterval = true;
                }
            }
        }
        
        $scope.loading = false;
        $scope.noInfo = false;
        function noInfo() {
            if (chart) {
                chart.data = [];
            }
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
        }

        $scope.getData = function(date, type) {
            $scope.loading = true;
            $scope.noInfo = false;
            var field = {
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "id_punto_facturacion": $stateParams.id_punto ? $stateParams.id_punto : consumoServices.id_punto_facturacion,
                "fecha_ini": date.fecha_ini,
                "fecha_fin": date.fecha_final,
                "variable": type,
            }

            RESTServices.post_header('cliente/consulta_historico_facturas.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.historico != undefined) {
                        createGraphic();
                        chart.data = consumoV2Util.formatMonth(response.historico, new Date('2021','01','01'));
                        successfulResponse();
                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });
        }
        var date = {}
        date.fecha_ini = $filter('date')(consumoV2Util.setYear()[0], 'yyyy-MM-dd');
        date.fecha_final = $filter('date')(consumoV2Util.setYear()[1], 'yyyy-MM-dd');
        $scope.getData(date, 1);

        function createGraphic() {
            am4core.useTheme(am4themes_animated);
            am4core.options.autoDispose = true;
            // Themes end

            // Create chart instance
            chart = am4core.create("grafica_kwh_consumidos", am4charts.XYChart);

            // Create axes
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "month",
                "count": 1
            };

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            // Create series
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.dateX = "mes";
            series.dataFields.valueY = "valor";

            series.name = "histórico";
            series.columns.template.tooltipHTML = "{fecha} : <strong>{valueY} "+$scope.unit+"</strong>";
            series.columns.template.fillOpacity = .8;

            var columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;
        }

        $scope.$on('tabConsumo', function(event, result){
            //chart.dispose();
            if(result.data.type === 'value') {
                $scope.name_graphic = 'Valor Factura';
                $scope.unit = '$';
                type = 1;
                $scope.getData(date, type);
            } else if(result.data.type === 'consumption') {
                $scope.name_graphic = 'KWh consumidos';
                $scope.unit = 'KWh';
                type = 2;
                $scope.getData(date, type);
            } else {
                $scope.name_graphic = 'Valor KWh';
                $scope.unit = '$';
                type = 3;
                $scope.getData(date, type);
            }
        });

        // $scope.$on("$destroy", function () {
        //     chart.dispose();
        // });
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('kwhConsumedGraphic', kwhConsumedGraphic);
  
    /** @ngInject */
    function kwhConsumedGraphic() {
      return {
        restrict: 'E',
        controller: 'kwhConsumedGraphicCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/kwh-consumed-graphic/kwh-consumed-graphic.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('noFacturaCtrl', noFacturaCtrl);

    /** @ngInject */

    function noFacturaCtrl($scope, $state, $stateParams) {
        
        $scope.gotoNuevaFactura = function() {
            $state.go('consumption.nuevaFactura', {id_punto: $stateParams.id});
        }
       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('noFactura', noFactura);
  
    /** @ngInject */
    function noFactura() {
      return {
        restrict: 'E',
        controller: 'noFacturaCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/no-factura/no-factura.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('noFacturadorCtrl', noFacturadorCtrl);

    /** @ngInject */

    function noFacturadorCtrl($scope, $state) {
        
        $scope.gotoNuevoFacturador = function() {
            $state.go('consumption.nuevoFacturador');
        }
       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('noFacturador', noFacturador);
  
    /** @ngInject */
    function noFacturador() {
      return {
        restrict: 'E',
        controller: 'noFacturadorCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/no-facturador/no-facturador.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('noPuntoCtrl', noPuntoCtrl);

    /** @ngInject */

    function noPuntoCtrl($scope, $state) {
        
        $scope.gotoNuevoPunto = function() {
            $state.go('consumption.nuevoPuntoFacturacion');
        }
       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('noPunto', noPunto);
  
    /** @ngInject */
    function noPunto() {
      return {
        restrict: 'E',
        controller: 'noPuntoCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/no-punto/no-punto.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('powerGraphicCtrl', powerGraphicCtrl);

    /** @ngInject */

    function powerGraphicCtrl($scope, $localStorage, RESTServices, SHAREServices, consumptionUtil, $rootScope, $stateParams, $filter, consumoServices) {
        $scope.DateFilter = [
            {
                name: 'Día',
                type: 0,
                status: false,
                id: 'day',
            },
            {
                name: 'Mes',
                type: 1,
                status: true,
                id: 'month'
            },
        ];
        //$scope.DateFilter = $scope.DateFilter.concat(consumoServices.filters);
        $scope.nombreDispositivo = $stateParams.dispositivo.nombre;
        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'month',
            maxDate: new Date(),
        };

        $scope.DateFormat = consumoServices.formato.month;

        $scope.update_date = function() {
            $scope.consultarPotencia($scope.options.minMode);
        }
        $scope.dt = $filter('date')(new Date(), 'yyyy-MM');
        
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
        }

        function loading(itm) {
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.DateFormat = consumoServices.formato[itm];
        };

        function setParameters(itm) {
            return {
                "device_id": $stateParams.dispositivo.id,
                "user_id": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "data": $filter('date')($scope.dt, consumoServices.formato.day),
                "time": itm,
                "type": "consumption",
                "offset": (new Date()).getTimezoneOffset()
            };
        };

        $scope.setFilter = function(param){
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == param });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = param;
            $scope.DateFormat = consumoServices.formato[param];
            $scope.consultarPotencia(param); 
        }
        
        $scope.consultarPotencia = function(parm) {
            $rootScope.$broadcast('indDataConsumtion', {data: null});
            
            loading(parm);
            var field = setParameters(parm);
            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        var array = response.data.map(function(d,ind){
                            return ({
                                tiempo: SHAREServices.dateToLocal(d.tiempo,response.data.length,ind,false),
                                estado: d.estado,
                                tipo: d.tipo,
                            })
                        })
                        chart.data = array;
                        //chart.data = consumptionUtil.addLastHour(response.data, $filter('date')($scope.dt, consumoServices.formato.day), parm);
                        var allValues = response.data.map(function(d){return Number(d.estado)})
                        $rootScope.$broadcast('indDataConsumtion', {data: allValues});
                        successfulResponse();
                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });

        }

        $scope.consultarPotencia('month');
        
        
        am4core.useTheme(am4themes_animated); 
        var chart = am4core.create("grafica_potencia", am4charts.XYChart);
        chart.paddingRight = 20;


        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.baseInterval = {
            "timeUnit": "second",
            "count": 1
        };
        
        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.minWidth = 35;

        var series = chart.series.push(new am4charts.StepLineSeries());
        series.dataFields.dateX = "tiempo";
        series.dataFields.valueY = "estado";
        series.strokeWidth = 3;

        series.tooltipText = "Watts: {valueY.value}";
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = dateAxis;
        chart.cursor.fullWidthLineX = true;
        chart.cursor.lineX.strokeWidth = 0;
        chart.cursor.lineX.fill = chart.colors.getIndex(2);
        chart.cursor.lineX.fillOpacity = 0.1;

        var scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        chart.scrollbarX = scrollbarX;

        //chart.exporting.menu = new am4core.ExportMenu();
        am4core.options.minPolylineStep = 5;
        am4core.options.onlyShowOnViewport = true;
        am4core.options.queue = true;

        // $scope.$on("$destroy", function () {
        //     chart.dispose();
        // });
       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('powerGraphic', powerGraphic);
  
    /** @ngInject */
    function powerGraphic() {
      return {
        restrict: 'E',
        controller: 'powerGraphicCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/power-graphic/power-graphic.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('procesoFacturacionInfoCtrl', procesoFacturacionInfoCtrl);

    /** @ngInject */

    function procesoFacturacionInfoCtrl($scope, $state, $stateParams, $timeout, $localStorage, RESTServices,SHAREServices) {
        
        $scope.nuevoProcesoFacturacion = {};

        $timeout(function(){
            var params = {
                "id_usuario": $localStorage.id_usuario,
            }
            RESTServices.post_header('cliente/consulta_facturador.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.facturadores) {
                        $scope.facturadores = response.facturadores;
                    } else {
                        $state.go('consumption.nofacturador')
                    }
                    
                } else {
                    $state.go('consumption.nofacturador')
                }

            })
        })
        
        $scope.open = function(itm) {
            $scope.popup[itm] = true;
        }

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.popup = {
            opened_1: false,
            opened_2: false
        };
        $scope.next = function(proceso) {
            proceso.days = calculateDays(proceso.fecha_ini, proceso.fecha_final)
            var facturador = $scope.facturadores.filter(function(f){
                return f.id == $scope.nuevoProcesoFacturacion.facturador;
            })
            $state.go('consumption.procesoFacturacion.resultado', {ind: $stateParams.ind, basic_info: proceso, facturador: facturador[0]})
        }
        $scope.cancelar = function(){
            $state.go('consumption.facturacion');
        }


        function calculateDays(ini, end) {
            var t1 = ini.getTime();
            var t2 = end.getTime();
            var time = Math.round((t2 - t1) / (1000 * 60 * 60 * 24))
            return time + 1;
        }
        
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('procesoFacturacionInfo', procesoFacturacionInfo);
  
    /** @ngInject */
    function procesoFacturacionInfo() {
      return {
        restrict: 'E',
        controller: 'procesoFacturacionInfoCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-info/proceso-facturacion-info.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('procesoFacturacionIndCtrl', procesoFacturacionIndCtrl);

    /** @ngInject */

    function procesoFacturacionIndCtrl($scope, $state) {
        
        $scope.ind = {};
        
        $scope.inds = [
            {
              name: 'Puntos de facturación',
              status: false,
              disabled: true,
              ind: 0,
            },
            {
              name: 'Medidores en zona',
              status: false,
              disabled: false,
              ind: 1, 
            },
        ];

        $scope.statusChange = function(ind) {
            $scope.inds.map(function(g) { g.status = false});
            $scope.inds[ind].status = true;
        };

        $scope.next = function(id) {
            $state.go('consumption.procesoFacturacion.info', {ind: id})
        }


    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('procesoFacturacionInd', procesoFacturacionInd);
  
    /** @ngInject */
    function procesoFacturacionInd() {
      return {
        restrict: 'E',
        controller: 'procesoFacturacionIndCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-ind/proceso-facturacion-ind.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('procesoFacturacionResultadoCtrl', procesoFacturacionResultadoCtrl);

    /** @ngInject */

    function procesoFacturacionResultadoCtrl($scope, $state, $stateParams, $localStorage, RESTServices, $filter, $window, $timeout, SHAREServices) {
        
        var itemsPerPage = 30;

        $scope.loading = true;

        $scope.radicado = {
            fecha_informe: new Date(),
            fecha_inicio: $stateParams.basic_info.fecha_ini,
            fecha_fin: $stateParams.basic_info.fecha_final,
            dias_facturados: $stateParams.basic_info.days,
            valor_kwh: $stateParams.basic_info.valor_kwh,
            consumo_kwh: $stateParams.basic_info.consumo_kwh,
        }

        if($stateParams.basic_info === null) {
            $state.go('consumption.procesoFacturacion.info');
        } else {
            var params = {
                id_usuario: $localStorage.id_usuario,
                id_facturador: $stateParams.basic_info.facturador,
                fecha_ini: $filter('date')($stateParams.basic_info.fecha_ini, 'yyyy-MM-dd'),
                fecha_fin: $filter('date')($stateParams.basic_info.fecha_final, 'yyyy-MM-dd'),
            }

            RESTServices.post_header('cliente/consulta_consumos_facturador.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if(response.code === '200') {
                    $scope.puntos = response.consumos;
                    $scope.puntos = $filter('orderBy')($scope.puntos, 'nombre');
                    $scope.totalItems = $scope.puntos.length;
                    $scope.currentPage = 1;
                    $scope.itemsPerPage = itemsPerPage;
                    $scope.noOfPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);
                    if ($scope.radicado.consumo_kwh) {
                        $scope.puntos = $scope.puntos.map(function(p) {
                            p.kwh = $scope.radicado.consumo_kwh;
                            return p;
                        })
                    }

                    $scope.puntos = $scope.puntos.map(function(p) {
                        p.codigo = extraerCodigo(p.nombre);
                        return p; 
                    })

                    $scope.loading = false;
                }
            })

            $scope.cliente = $stateParams.facturador;
        }
        function esNumero(valor) {
            return !isNaN(parseFloat(valor)) && isFinite(valor);
        }

        $scope.exportExcel = function() {
            var data = Array.from($scope.puntos);
            data = data.map(function(d) {
                return ({
                    punto: d.nombre,
                    codigo: extraerCodigo(d.nombre),
                    consumo: d.kwh === null || d.kwh === undefined ? 0 : parseInt(d.kwh),
                    dias_facturados: $scope.radicado.dias_facturados,
                    valor_kwh: $scope.radicado.valor_kwh ? $scope.radicado.valor_kwh : 0,
                    total: $scope.radicado.valor_kwh ? $scope.radicado.valor_kwh * d.kwh : 0,
                })
            })
            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.json_to_sheet(data);

            XLSX.utils.book_append_sheet(wb, ws, 'Data');
            XLSX.writeFile(wb, 'Consumo_' + $stateParams.facturador.nombre + '_' + 'del_' + $filter('date')($stateParams.basic_info.fecha_ini, 'dd_MM_yyyy') + '_al_' + $filter('date')($stateParams.basic_info.fecha_final, 'dd_MM_yyyy') + '.xlsx');
        }

        function extraerCodigo(cadena) {
            var indice = cadena.lastIndexOf('-');
            var codigo = '';
            var s;
            if (indice !== -1) {
              s = cadena.slice(indice + 1);
              var f = s.slice(0, 3);
              if (esNumero(f)) codigo = s;
            }
            return codigo;
          }

        $scope.imprimir = function() {
            $scope.itemsPerPage = $scope.totalItems;
            $timeout(function() {
                $window.print();
                $scope.itemsPerPage = itemsPerPage;
            }, 1);
        }

    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('procesoFacturacionResultado', procesoFacturacionResultado);
  
    /** @ngInject */
    function procesoFacturacionResultado() {
      return {
        restrict: 'E',
        controller: 'procesoFacturacionResultadoCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-resultado/proceso-facturacion-resultado.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('procesoFacturacionNuevoCtrl', procesoFacturacionNuevoCtrl);

    /** @ngInject */

    function procesoFacturacionNuevoCtrl($scope, $state, $timeout, RESTServices, $localStorage, $stateParams,SHAREServices) {
        
        $scope.nuevoFacturador = {},
        $scope.editMode = false;
        $scope.loading_state = false;
        $scope.loading_city = false;

        function getCountrys() {
            var fields = {
                "id_instalador": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_usuario": $localStorage.id_usuario,
            };

            RESTServices.post_header('admin/lista_paises.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.paises = res.paises;
                }
            });
        }

        $scope.getStates = function(id) {
            $scope.loading_state = true;
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_pais": id != undefined ? id : null
            };

            RESTServices.post_header('admin/lista_estados.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.estados = res.estados;
                } 
                $scope.loading_state = false;
            });
        }

        $scope.getCitys = function(id) {
            $scope.loading_city = true;
            
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                //"token": SHAREServices.hash_decode_token($localStorage.token),
                "id_estado": id != undefined ? id : null
            };

            RESTServices.post_header('admin/lista_ciudades.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    $scope.ciudades = res.ciudades;
                }
                $scope.loading_city = false;
            });
        }

        $timeout(function() {
            if($stateParams.facturador) {
                $scope.editMode = $stateParams.edit_mode;
                $scope.nuevoFacturador = Object.assign($stateParams.facturador);
                getCountrys();
                $scope.getStates($scope.nuevoFacturador.pais_id);
                $scope.getCitys($scope.nuevoFacturador.estado_id);
            } else {
               getCountrys();
            }
            
        })

        $scope.cancelar = function() {
            $state.go('consumption.facturadores');
        }
        $scope.next = function(info) {
            $state.go('consumption.procesoFacturacion.data', {basic_info: info, edit_mode: $scope.editMode});
        }

    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('procesoFacturacionNuevo', procesoFacturacionNuevo);
  
    /** @ngInject */
    function procesoFacturacionNuevo() {
      return {
        restrict: 'E',
        controller: 'procesoFacturacionNuevoCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-nuevo/proceso-facturacion-nuevo.html',
      };
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('selectedFilter', selectedFilter);
    /** @ngInject */
    function selectedFilter() {
      return {
        restrict: 'E',
        templateUrl: 'app/cliente/consumo_v2/components/selectedFilter/selectedFilter.html',
        scope: {
            nombre: '=nombre',
            lista: '=lista',
            selected: '=selected'
        },
        link: function(scope) {
            scope.selectedItem = function(itm) {
                scope.openList = false;
                //scope.nombre = itm;
                scope.selected(itm);
            }
            // scope.$on('updateSelectZone', function(event, result){
            //   scope.nombre = result.itm;
            // });
            
            
        }
      };
    }
  
  })();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('procesoFacturacionSeleccionCtrl', procesoFacturacionSeleccionCtrl);

    /** @ngInject */

    function procesoFacturacionSeleccionCtrl($scope, $state, $stateParams, RESTServices, $filter, $localStorage, $timeout, toastr, SHAREServices) {

        $scope.loading = false;
        $scope.noInfo = false;
        $scope.validatedList = false;
        if($stateParams.basic_info.puntos){
            $scope.items = $stateParams.basic_info.puntos;
        }else {
            $scope.items = [];
        }
        
        $timeout(function(){
            if($stateParams.basic_info === null) {
                $state.go('consumption.puntosFacturacion');
            } else if($stateParams.edit_mode) {
                $scope.edit_mode = $stateParams.edit_mode;
                $scope.loading = true;
                $scope.noInfo = false;
                if($scope.items !== null) {
                    $scope.items.map(function(i) { 
                        i.status = true
                    });
                }
                

                var params = {
                    "id_usuario": $localStorage.id_usuario,
                }
                RESTServices.post_header('cliente/consulta_puntos_facturacion_disponibles.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                    if (response.code == '200') {
                        if(response.puntos) {

                            response.puntos.map(function(i) { i.status = false});
                            if ($scope.items !== undefined) {
                                $scope.items = $scope.items.concat(response.puntos)
                            } else {
                                $scope.items = response.puntos;
                            }
                            
                        } 
                        $scope.filtered = Array.from($scope.items);
                        $scope.validateList();
                        $scope.loading = false;
                        //$scope.$apply();
                    } else {
                        $scope.loading = false;
                        if($scope.item === null) {
                            $scope.noInfo = true;
                        } else {
                            $scope.noInfo = false;
                        }
                        $scope.filtered = Array.from($scope.items);
                        $scope.validateList();
                        //$scope.$apply();
                        
                    }
                })
            } else {
                $scope.loading = true;
                $scope.noInfo = false;
                var params = {
                    "id_usuario": $localStorage.id_usuario,
                    //"token": SHAREServices.hash_decode_token($localStorage.token),
                }
                RESTServices.post_header('cliente/consulta_puntos_facturacion_disponibles.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                    if (response.code == '200') {
                        if(response.puntos) {
                            $scope.items = response.puntos;
                        } 
                        $scope.items.map(function(i) { i.status = false});
                        $scope.filtered = Array.from($scope.items);
                        $scope.loading = false;
                    } else {
                        $scope.loading = false;
                        $scope.noInfo = true;
                    }
                })
            }
        });

        $scope.selectAll = function(flag) {
            if(flag) {
                $scope.items.map(function(i){i.status = true})
            } else {
                $scope.items.map(function(i){i.status = false})
            }
            $scope.validateList();
        }

        $scope.search = function(buscar) {
            if (buscar === '') {
                $scope.filtered = $scope.items;
            } else {
                $scope.filtered = $filter('filter')($scope.items, buscar );
                $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            }
        }

        $scope.validateList = function(){
            var index = $scope.items.findIndex(function(i){return i.status === true});
            if(index >= 0) {
                $scope.validatedList = true;
            } else {
                $scope.validatedList = false;
            }
            
        }

        $scope.crear = function() {
            var selected = $scope.items.filter(function(i){return i.status === true});
            var ids_puntos = [];
            selected.forEach(function(s){
                var item = {
                    id: s.id,
                    nombre: s.nombre
                }
                ids_puntos.push(item);
            })

            var facturador = $stateParams.basic_info
            facturador.id_cliente = $localStorage.id_cliente;
            facturador.id = $stateParams.edit_mode ? $stateParams.basic_info.id : 0;
            facturador.puntos = ids_puntos;
            facturador.id_ciudad = facturador.ciudad_id;
            delete facturador.pais_id;
            delete facturador.estado_id;
            delete facturador.ciudad_id;

            var params = {
                id_usuario: $localStorage.id_usuario,
                token: SHAREServices.hash_decode_token($localStorage.token),
                facturador: JSON.stringify(facturador),
            }

            RESTServices.post_header('cliente/edita_facturador.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    $state.go('consumption.facturadores');
                    toastr.success('Tu facturador se ha creado correctamente', '¡Bien hecho!')
                } else {
                    toastr.error('Se ha producido un error', 'Intanta más tarde')
                }
            })
        }

        $scope.back = function() {
            $state.go('consumption.nuevoFacturador', {facturador: $stateParams.basic_info, edit_mode: $scope.edit_mode})
        }



    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('procesoFacturacionSeleccion', procesoFacturacionSeleccion);
  
    /** @ngInject */
    function procesoFacturacionSeleccion() {
      return {
        restrict: 'E',
        controller: 'procesoFacturacionSeleccionCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/proceso-facturacion-seleccion/proceso-facturacion-seleccion.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('tableConsumptionCtrl', tableConsumptionCtrl);

    /** @ngInject */

    function tableConsumptionCtrl($scope, ngDialog, $localStorage, RESTServices, $state, toastr, $rootScope,SHAREServices) {
        
        $scope.gotoFacturacion = function(punto) {
            $state.go('consumption.facturacion', {id: punto.id, punto: punto});
        }

        $scope.editarPunto = function(punto) {
            $state.go('consumption.nuevoPuntoFacturacion', {punto: punto});
        }

        $scope.borrarPunto = function(punto) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = "¿Deseas borrar este punto de facturación?";
                    $scope.sumary = "Se borrarán también todas las facturas asociadas a este punto de facturación. Esta acción no se puede deshacer"
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
                    $scope.aceptar = function() {                                    
                        var params = {
                            "id_usuario": $localStorage.id_usuario,
                            //"token": SHAREServices.hash_decode_token($localStorage.token),
                            "id_punto_facturacion": punto.id,
                            
                        };
                        RESTServices.post_header('cliente/elimina_punto_facturacion.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response != null) {
                                if (response.code == '200') {
                                    $rootScope.$broadcast('deletePoint', {punto: punto}); 
                                    toastr.success('Se ha eliminado el punto de facturación', 'Bien Hecho');
                                    ngDialog.close();   
                                                    
                                }
                            }else{
                                toastr.error('Se ha podido conectar con el servidor', 'Intentar más tarde');
                                ngDialog.close();
                            }  
            
                        });
                    }
                }]
            })
        }


    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('tableConsumption', tableConsumption);
  
    /** @ngInject */
    function tableConsumption() {
        return {
            restrict: 'E',
            controller: 'tableConsumptionCtrl',
            templateUrl: 'app/cliente/consumo_v2/components/table-consumption/table-consumption.html',
            scope: {
                punto: '=punto',
                control: '=control',
            }
        };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('tableBillingCtrl', tableBillingCtrl);

    /** @ngInject */

    function tableBillingCtrl($scope, consumoServices, ngDialog, $localStorage, toastr, $rootScope, RESTServices, SHAREServices, $state, $stateParams) {
        
        $scope.gotoFactura = function(factura) {
            $state.go('consumption.factura', {factura: factura});
        }
        $scope.editBill = function(factura) {
            $state.go('consumption.nuevaFactura', {factura: factura, id_punto: $stateParams.id ? $stateParams.id : consumoServices.id_punto_facturacion});
        }

        $scope.deleteBill = function(factura) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = "¿Deseas borrar esta factura?";
                    $scope.sumary = "Esta acción no se puede deshacer"
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
                    $scope.aceptar = function() {  
                        var ft = {
                            "id_punto_facturacion": $stateParams.id ? $stateParams.id : consumoServices.id_punto_facturacion,
                            "id": factura.id,
                        }                                  
                        var params = {
                            "id_usuario": $localStorage.id_usuario,
                            //"token": SHAREServices.hash_decode_token($localStorage.token),
                            "factura": JSON.stringify(ft),
                            
                        };
                        RESTServices.post_header('cliente/elimina_factura.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response != null) {
                                if (response.code == '200') {
                                    $rootScope.$broadcast('deleteBill', {factura: factura}); 
                                    toastr.success('Se ha eliminado la factura', 'Bien Hecho');
                                    ngDialog.close();   
                                                    
                                }
                            }else{
                                toastr.error('Se ha podido conectar con el servidor', 'Intentar más tarde');
                                ngDialog.close();
                            }  
            
                        });
                    }
                }]
            })
        }

    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('tableBilling', tableBilling);
  
    /** @ngInject */
    function tableBilling() {
        return {
            restrict: 'E',
            controller: 'tableBillingCtrl',
            templateUrl: 'app/cliente/consumo_v2/components/table-billing/table-billing.html',
            scope: {
                facturas: '=facturas',
            }
        };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('tabsConsumoCtrl', tabsConsumoCtrl);

    /** @ngInject */

    function tabsConsumoCtrl($scope, consumoServices, $rootScope) {
        
        //$scope.tabs = consumoServices.tabs;
        //$rootScope.$broadcast('selectGraph', {data: $scope.tabs[0].type});
        
        $scope.tabGrafica = function(parm){
            $scope.tabs.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.tabs.findIndex(function(i) { return i.type == parm.type });
            $scope.tabs[index].status = true;
            $rootScope.$broadcast('tabConsumo', {data: parm});
        }

        $scope.$on("$destroy", function () {
            $scope.tabs.map(function(obj) {
                obj.status = false;
            });
            $scope.tabs[0].status = true;
        });
       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('tabsConsumo', tabsConsumo);
  
    /** @ngInject */
    function tabsConsumo() {
      return {
        restrict: 'E',
        controller: 'tabsConsumoCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/tabs-consumo/tabs-consumo.html',
        scope: {
          tabs: "=tabs"
        }
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('tableFacturadoresCtrl', tableFacturadoresCtrl);

    /** @ngInject */

    function tableFacturadoresCtrl($scope, ngDialog, $localStorage, RESTServices, $state, toastr, $rootScope,SHAREServices) {

        $scope.editarFacturador = function(facturador) {
            $state.go('consumption.nuevoFacturador', {facturador: facturador, edit_mode: true});
        }

        $scope.borrarFacturador = function(facturador) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = "¿Deseas borrar este facturador?";
                    $scope.sumary = "Se borrará también toda la información asociada. Esta acción no se puede deshacer"
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
                    $scope.aceptar = function() {                                    
                        var params = {
                            "id_usuario": $localStorage.id_usuario,
                            //"token": SHAREServices.hash_decode_token($localStorage.token),
                            "id_facturador": facturador.id,
                        };
                        RESTServices.post_header('cliente/elimina_facturador.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response != null) {
                                if (response.code == '200') {
                                    $rootScope.$broadcast('deleteFacturador', {facturador: facturador}); 
                                    toastr.success('Se ha eliminado el facturador', 'Bien Hecho');
                                    ngDialog.close();               
                                }
                            }else{
                                toastr.error('Se ha podido conectar con el servidor', 'Intentar más tarde');
                                ngDialog.close();
                            }  
            
                        });
                    }
                }]
            })
        }


    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('tableFacturadores', tableFacturadores);
  
    /** @ngInject */
    function tableFacturadores() {
        return {
            restrict: 'E',
            controller: 'tableFacturadoresCtrl',
            templateUrl: 'app/cliente/consumo_v2/components/table-facturadores/table-facturadores.html',
            scope: {
                facturadores: '=facturadores',
                control: '=control',
            }
        };
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('totalConsumption', totalConsumption);
  
    /** @ngInject */
    function totalConsumption() {
      return {
        restrict: 'E',
        templateUrl: 'app/cliente/consumo_v2/components/totalConsumption/totalConsumtion.html',
        scope: {
            consumption: '=consumption',
            label: '=label',
            allConsumption: '=allConsumption',
            clients: '=clients',
            zones: '=zones',
        },
        link: function(scope) {
            scope.setClient = function(e) {
                
                if (e){
                    if (e === 'Todos' && scope.allConsumption != undefined) {
                        var all = scope.allConsumption.map(function(c){ return Number(c.consumo)});
                        scope.consumo = Math.ceil(all.reduce(function(previous, current) { return current += previous})) 
                    } else {
                        scope.consumo = scope.allConsumption.filter(function(c){ return c.cliente === e})[0].consumo; 
                    }
                }
            };
            scope.setZone = function(e) {
                //console.log(scope.allConsumption);
                // if (e){
                //     if (e === 'Todos' && scope.allConsumption != undefined) {
                //         var all = scope.allConsumption.map(function(c){ return Number(c.consumo)});
                //         scope.consumo = Math.ceil(all.reduce(function(previous, current) { return current += previous})) 
                //     } else {
                //         scope.consumo = scope.allConsumption.filter(function(c){ return c.cliente === e})[0].consumo; 
                //     }
                // }
            }
            scope.$on('devicesConsumption', function(event, result){
                scope.setClient('Todos');
            });
            
        }
    };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('totalConsumptionChartCtrl', totalConsumptionChartCtrl);

    /** @ngInject */

    function totalConsumptionChartCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, consumoV2Util, $rootScope) {
        
        var chart;
        $scope.consumos;
        //$scope.clickedInd;
        var type;
        $scope.id;
        var date = {};
        var params = {};

        $scope.$on('devicesConsumption', function(event, result){
            $scope.zones = result.zonas;
            $scope.zona = $scope.zones[0];
            $scope.id = $scope.zona.id;
            date.fecha_ini = $filter('date')(consumoV2Util.setYesterday()[0], 'yyyy-MM-dd HH:mm:ss');
            date.fecha_final = $filter('date')(consumoV2Util.setYesterday()[1], 'yyyy-MM-dd HH:mm:ss');
            params = {tipo: 1, date: date};
            //createGraphic(1);
            $scope.getConsumoTotal($scope.zona.id, params);
        });

        $scope.getConsumoTotal = function(id, data) {
            $scope.consumos = [];
            type = data !== undefined ? data.tipo : 1;
            if(data) {
                params.tipo = data.tipo;
                params.date = data.date;
            }

            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "fecha_ini": data !== undefined ? data.date.fecha_ini : params.date.fecha_ini,
                "fecha_fin": data !== undefined ? data.date.fecha_final : params.date.fecha_final,
                "tipo": data !== undefined ? params.tipo : 1,
                "id_zona": id !== false ? id : $scope.id,
            };

            RESTServices.post_header('cliente/consulta_consumosxrango.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.consumo != undefined) {  
                        $scope.consumos = response.consumo;
                        var ind = params.tipo === 1 ? 'MMMM d, y' : 'MMMM, y';
                        $scope.consumos = $scope.consumos.map(function(c){
                            c.fecha = $filter('date')(new Date(params.tipo === 1 ? c.dia: c.mes), ind);
                            return c;
                        })                        
                    } 
                    createGraphic(params.tipo);
                    chart.data = $scope.consumos;
                    
                    successfulResponse();

                } else {
                    noInfo();
                }
            });
        }

        function createGraphic(tipo) {
            am4core.useTheme(am4themes_animated);
            am4core.options.autoDispose = true;
            // Themes end

            // Create chart instance
            chart = am4core.create("totalConsumption", am4charts.XYChart);

            // Create axes
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": tipo == 1 ? "day" : "month",
                "count": 1
            };

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 30;
            valueAxis.min = 0;

            // Create series
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.dateX = tipo == 1 ? "dia" : "mes";
            series.dataFields.valueY = "valor";

            series.name = "Energía";
            series.columns.template.tooltipHTML = "{fecha} : <strong>{valueY} KWh</strong>";
            series.columns.template.fillOpacity = .8;
            // series.columns.template.events.on("hit", function(ev) {
            //     $scope.clickedInd = ev.target.dataItem.dataContext;
            //     //$scope.$apply();
            // }, this);

            var columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;
        }

        function noInfo() {
            chart.data = [];
            $scope.noInfo_ = true;
            $scope.loading_ = false;
        }

        function successfulResponse() {
            $scope.loading_ = false;
            $scope.noInfo_ = false;
        }
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('totalConsumptionChart', totalConsumptionChart);
  
    /** @ngInject */
    function totalConsumptionChart() {
      return {
        restrict: 'E',
        controller: 'totalConsumptionChartCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/total-consumption-chart/total-consumption-chart.html',
        scope: {
            noInfo: "=noInfo",
            loading: "=loading",
            zones: "=zones",
        }
    };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('newAutomationAirCtrl', newAutomationAirCtrl);

    /** @ngInject */
    function newAutomationAirCtrl($scope, RESTServices, $localStorage, $stateParams, $state, $filter, toastr, AutoServices,SHAREServices, $rootScope, utilities) {
        $scope.newAutomationAir = {};
        $scope.frequency = AutoServices.frequencyProgram;
        $scope.setpoints = AutoServices.getCommandsControl();

        ///////control datepicker
        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            minDate: new Date()
        };
        $scope.open = function() {
            $scope.popup.opened = true;
        };
        $scope.popup = {
            opened: false
        };
        $scope.DateFormat = AutoServices.format.day;
        
        /////////////

        if($stateParams.zona) {
            var zona = $stateParams.zona;
        } else {
            $state.go('dashboard_cliente')
        };
        $scope.dispositivos = $stateParams.dispositivos;
        $scope.dispositivos = $stateParams.dispositivos.filter(function(d){
            return d.tipo == '0' || d.tipo == '1' || d.tipo == '2' || d.tipo == '3' || d.tipo == '4' || d.tipo == '14' || d.tipo == '15' || d.tipo == '17' || d.tipo == '27' || d.tipo == '29' || d.tipo == '32';
        })

        /////////////////////
        if($stateParams.parm == 'edit'){
            $scope.editMode = true;
            var fecha_dia = $filter('date')(new Date(), 'yyyy-MM-dd');
            $scope.disp = $stateParams.program.dispositivo;
            if($scope.disp.tipo == '2' || $scope.disp.tipo == '3' || $scope.disp.tipo == '4' || $scope.disp.tipo == '32') {
                $scope.setpoints = AutoServices.getCommandsControl();
            } else if($scope.disp.tipo == '15') {
                $scope.setpoints = AutoServices.mxproControl;
            } else if ($scope.disp.tipo == '17') {
                //$scope.setpoints = utilities.generarIntervaloDimmer($scope.disp.min);
                $scope.setpoints = utilities.generarIntervaloDimmer(50);
            } else if ($scope.disp.tipo == '27') {
                $scope.setpoints = utilities.generarIntervaloDimmer(10);
            } else if ($scope.disp.tipo == '29') {
                $scope.setpoints = AutoServices.wind_CurtainControl;
            } else {
                $scope.setpoints = AutoServices.onOffControl;
            }
            $scope.newAutomationAir = {
                air: $stateParams.program.dispositivo,
                date: $stateParams.program.dia,
                hinit: new Date(fecha_dia + ' ' + $stateParams.program.hini),
                hend: new Date(fecha_dia + ' ' + $stateParams.program.hfin),
                freq: AutoServices.getFrequency($stateParams.program.frecuencia).value,
                setpoint: $scope.disp.tipo == 14 ? null : AutoServices.getControl($scope.disp.tipo, $stateParams.program.action).id,
                finalsetpoint: $scope.disp.tipo == 14 ? null : AutoServices.getControl($scope.disp.tipo, $stateParams.program.postAction).id,
                setPoint_rack: $scope.disp.tipo == 14 ? parseInt($stateParams.program.action) : null,
                finalsetpoint_rack: $scope.disp.tipo == 14 ? parseInt($stateParams.program.postAction) : null,
            }
           //console.log($scope.newAutomationAir);
        } else {
            $scope.editMode = false;
        }
        
        ///////////////////

        $scope.consultaComandos = function(disp) {
            $scope.disp = disp;
            if(disp.tipo == '2' || disp.tipo == '3' || disp.tipo == '4' || disp.tipo == '32') {
                $scope.setpoints = AutoServices.getCommandsControl();
            } else if(disp.tipo == '0' || disp.tipo == '1') {
                $scope.setpoints = AutoServices.onOffControl;
            } else if(disp.tipo == '15') {
                $scope.setpoints = AutoServices.mxproControl;
            } else if (disp.tipo == '17') {
                $scope.setpoints = utilities.generarIntervaloDimmer(50);
            } else if (disp.tipo == '27') {
                $scope.setpoints = utilities.generarIntervaloDimmer(10);
            } else if (disp.tipo == '29') {
                $scope.setpoints = AutoServices.wind_CurtainControl;
            }           
        }

        ////////////////////////
        $scope.validateSchedual = function(progm) {
            if($scope.editMode) {
                deleteSchedule(progm)
            } else {
                newPrograming(progm)
            }
        }

        /////////////
        function newPrograming(promg){


            /*///////Para cuadrar desfase con la hora del servidor de 7 minutos
            promg.hinit.setMinutes(promg.hinit.getMinutes() - AutoServices.serverDelay);
            promg.hend.setMinutes(promg.hend.getMinutes() - AutoServices.serverDelay);
            ////////////////*/
            promg.hinit = $filter('date')(promg.date.getFullYear()+'-'+(promg.date.getMonth()+1)+'-'+promg.date.getDate()+' '+promg.hinit.getHours()+':'+promg.hinit.getMinutes()+':'+promg.hinit.getSeconds(), 'yyyy-MM-dd HH:mm:ss');
            promg.hend = $filter('date')(promg.date.getFullYear()+'-'+(promg.date.getMonth()+1)+'-'+promg.date.getDate()+' '+promg.hend.getHours()+':'+promg.hend.getMinutes()+':'+promg.hend.getSeconds(), 'yyyy-MM-dd HH:mm:ss');
            promg.hinit = new Date(promg.hinit);
            promg.hend = new Date(promg.hend);

            var state = AutoServices.validateChangeDayInUTC(promg.hinit,promg.hend);

            switch (state){
                case 1: //Day in local and UTC format is same
                case 4: //Day in local is major that UTC format for dayInit and dayEnd
                case 5: //Day in local is minor that UTC format for dayInit and dayEnd  
                    var field = {
                        "id_dispositivo": promg.air.id ? promg.air.id : $scope.program.id_dispositivo,
                        "dia": promg.hinit.toISOString().substring(0,10),
                        "hini": promg.hinit.toISOString().substring(11,19),
                        "hfin": promg.hend.toISOString().substring(11,19),
                        "frecuencia": promg.freq,
                        "comando": promg.air.tipo == 14 ? promg.setPoint_rack*10 : promg.setpoint,
                        "comando_post": promg.air.tipo == 14 ? promg.finalsetpoint_rack*10 : promg.finalsetpoint,
                        "id_usuario": $localStorage.id_usuario,
                        "id_programacion": promg.id ? promg.id : null,
                    };

                    editSchedule(field);

                break;

                case 2: //Day in local and UTC format is different for dayInit
                case 3: //Day in local and UTC format is different for dayEnd
                    var field = {
                        "id_dispositivo": promg.air.id ? promg.air.id : $scope.program.id_dispositivo,
                        "dia": promg.hinit.toISOString().substring(0,10),
                        "hini": promg.hinit.toISOString().substring(11,19),
                        "hfin": '23:59:59',
                        "frecuencia": promg.freq,
                        "comando": promg.air.tipo == 14 ? promg.setPoint_rack*10 : promg.setpoint,
                        "comando_post": promg.air.tipo == 14 ? promg.finalsetpoint_rack*10 : promg.setpoint,
                        "id_usuario": $localStorage.id_usuario,
                        "id_programacion": promg.id ? promg.id : null,
                    };

                    editSchedule(field);

                    field = {
                        "id_dispositivo": promg.air.id ? promg.air.id : $scope.program.id_dispositivo,
                        "dia": promg.hend.toISOString().substring(0,10),
                        "hini": '00:00:00',
                        "hfin": promg.hend.toISOString().substring(11,19),
                        "frecuencia": promg.freq,
                        "comando": promg.air.tipo == 14 ? promg.setPoint_rack*10 : promg.setpoint,
                        "comando_post": promg.air.tipo == 14 ? promg.finalsetpoint_rack*10 : promg.finalsetpoint,
                        "id_usuario": $localStorage.id_usuario,
                        "id_programacion": promg.id ? promg.id : null,
                    };

                    editSchedule(field);

                break;

            }

        }

        $scope.cancelar = function(){
            $state.go('dashboard_cliente');
        }
        ///////////
        ////////esta función es para setear la misma hora en el datatimer y poder comparalos 
        $scope.setMili = function(parm){
            if(parm === 'ini'){
                $scope.newAutomationAir.hinit.setMilliseconds('00');
            }else{
                $scope.newAutomationAir.hend.setMilliseconds('00');
            }
        }

        function editSchedule(field) {  
            $rootScope.flag_loading = true;               
            //Agregar programación de aires
            RESTServices.post_header('programacion_aire.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data.code == 200) {
                    $state.go('dashboard_cliente.schedules', {zone: $stateParams.zona});
                    $rootScope.flag_loading = false;
                    toastr.success('Se ha programado el aire correctamente', 'Programación de aire');
                }else if (data.code == 400){
                    $rootScope.flag_loading = false;
                    toastr.error('La programación se cruza con al menos una programación previamente agendada.', 'No se pudo programar el aire');
                }else{
                    $rootScope.flag_loading = false;
                    toastr.error('No se ha podido registrar la programación de forma correcta', 'No se pudo programar el aire');
                }
            })
        }

        function deleteSchedule(schedule){
            var prog = $stateParams.program;
            var promesas = prog.id_nestedProg.map(function(id){
                var field = {
                    "id_programacion": id,
                    "id_usuario": $localStorage.id_usuario,
                };
                return RESTServices.post_header('elimina_programacion_aires.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
            });

            Promise.all(promesas)
                .then(function(data){
                    newPrograming(schedule)
                })
        }
        
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.consumption')
        .controller('valueKwhGraphicCtrl', valueKwhGraphicCtrl);

    /** @ngInject */

    function valueKwhGraphicCtrl($scope, $localStorage, RESTServices, SHAREServices, $rootScope, $stateParams, $filter, consumoServices) {
        
        $scope.dt = new Date();
        var chart;
        
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
        }

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = consumptionServices.format[itm];
        };

        function setParameters(itm) {
            return {
                "device_id": $stateParams.dispositivo.id,
                "user_id": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "data": $filter('date')($scope.dt, consumoServices.formato.day),
                "time": itm,
                "type": "consumption",
                "offset": (new Date()).getTimezoneOffset()
            };
        };
        
        $scope.consultarHistoricoValoresFactura = function(parm) {
            
            
            //loading(parm);
            var field = setParameters(parm);
            RESTServices.post_header('', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        //createGraphic();
                        //chart.data = consumptionUtil.addLastHour(response.data, $filter('date')($scope.dt, consumoServices.formato.day), parm);
                        //var allValues = response.data.map(function(d){return Number(d.estado)})
                        //$rootScope.$broadcast('indDataConsumtion', {data: allValues});
                        successfulResponse();
                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });

        }

        //$scope.consultarHistoricoValoresFactura();

        
        function createGraphic() {
            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end

            // Create chart instance
            chart = am4core.create("grafica_valor_factura", am4charts.XYChart);

            // Add data
            chart.data = generateChartData();

            // Create axes
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.minGridDistance = 50;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

            // Create series
            var series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = "visits";
            series.dataFields.dateX = "date";
            series.strokeWidth = 2;
            series.minBulletDistance = 10;
            series.tooltipText = "{valueY}";
            series.tooltip.pointerOrientation = "vertical";
            series.tooltip.background.cornerRadius = 20;
            series.tooltip.background.fillOpacity = 0.5;
            series.tooltip.label.padding(12,12,12,12)

            // Add scrollbar
            chart.scrollbarX = new am4charts.XYChartScrollbar();
            chart.scrollbarX.series.push(series);

            // Add cursor
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.snapToSeries = series;

            function generateChartData() {
                var chartData = [];
                var firstDate = new Date();
                firstDate.setDate(firstDate.getDate() - 1000);
                var visits = 1200;
                for (var i = 0; i < 500; i++) {
                    // we create date objects here. In your data, you can have date strings
                    // and then set format of your dates using chart.dataDateFormat property,
                    // however when possible, use date objects, as this will speed up chart rendering.
                    var newDate = new Date(firstDate);
                    newDate.setDate(newDate.getDate() + i);
                    
                    visits += Math.round((Math.random()<0.5?1:-1)*Math.random()*10);

                    chartData.push({
                        date: newDate,
                        visits: visits
                    });
                }
                return chartData;
            }
        }

        createGraphic();

        $scope.$on("$destroy", function () {
            chart.dispose();
        });
       
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.consumption')
        .directive('valueKwhGraphic', valueKwhGraphic);
  
    /** @ngInject */
    function valueKwhGraphic() {
      return {
        restrict: 'E',
        controller: 'valueKwhGraphicCtrl',
        templateUrl: 'app/cliente/consumo_v2/components/value-kwh-graphic/value-kwh-graphic.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('controlButtonsTopCtrl', controlButtonsTopCtrl);

    /** @ngInject */
    function controlButtonsTopCtrl($state, $scope, ngDialog, $rootScope, $localStorage, RESTServices, SHAREServices, $timeout, $location) {

        var indList = ['Nueva Zona', 'Nuevo proyecto'];
        $scope.name_ind = indList[0];
        $scope.indRol = $localStorage.rol

        $timeout(function(){
            var path = $location.path();
            $scope.buttonsSwitch.map(function(b){
                b.status = false;
                return b
            })
            if(path === '/dashboard_cliente/zones') {
                $scope.buttonsSwitch[0].status = true;
                $scope.name_ind = indList[0];
            } else {
                $scope.buttonsSwitch[1].status = true;
                $scope.name_ind = indList[1];
            }
        },200)
       
        $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams){
            $timeout(function(){
                switch(toState.url) {
                    case '/zones':
                        $scope.buttonsSwitch.map(function(b){
                            b.status = false;
                            return b
                        })
                        $scope.buttonsSwitch[0].status = true;
                        $scope.name_ind = indList[0];
                        break; 
                    case '/projects':
                        $scope.buttonsSwitch.map(function(b){
                            b.status = false;
                            return b
                        })
                        $scope.buttonsSwitch[1].status = true;
                        $scope.name_ind = indList[1];
                        break; 
                }
            })
        });
        
        $scope.buttonsSwitch = [
            {
                name:'Zonas',
                state: 'dashboard_cliente.zones',
                clases: 'switch-view left',
                icon: '../../../../assets/icons/list.png',
                status: true,
                index: 0
            },
            {
                name:'Proyectos',
                state: 'dashboard_cliente.projects',
                clases: 'switch-view right',
                icon: '../../../../assets/icons/proyects.png',
                status: false,
                index: 1
            },
        ]
        
        $scope.switchView = function(button){
            $state.go(button.state);
            $scope.buttonsSwitch.map(function(b){ return b.status = false})
            $scope.buttonsSwitch[button.index].status = true;
            $scope.name_ind = indList[button.index];
        }

        $scope.goToNewContent = function() {
            var activebutton = $scope.buttonsSwitch.find(function(b){return b.status === true});
            switch (activebutton.index) {
                case 0:
                    createZone();
                    break;
                case 1:
                    $state.go('dashboard_cliente.newProject');
                    break;
            }
        }

        // The share dialog needs the owned zones, which live in zonesCtrl (a sibling view).
        $scope.openShareZones = function() {
            $rootScope.$broadcast('openShareZones');
        }

        function createZone() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/newZone.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    RESTServices.getCountries().then(function(res){
                        $scope.paises = res;
                    })

                    $scope.newZone = function(nombre, pais) {
                        $rootScope.flag_loading = true;
                        var params = {
                            id_usuario: $localStorage.id_usuario,
                            nombre: nombre,
                            id_pais: pais
                        };

                        RESTServices.post_header('/instalador/genera_zona.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                            if (res.code == 200) {
                                var zona = { nombre: nombre, id: res.id_zona, aires: 0, h: 0, medicion: 0, iluminacion: 0, temp: 0, id_pais: pais };
                                SHAREServices.zonas = null;
                                $rootScope.$broadcast('ZoneCreated', {data: zona});
                                ngDialog.close();
                                $rootScope.flag_loading = false;
                            }
                        });
                    }

                }]
            });
        }


    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('controlButtonsTop', controlButtonsTop);
  
    /** @ngInject */
    function controlButtonsTop() {
      return {
        restrict: 'E',
        controller: 'controlButtonsTopCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/control-buttons-top/control-buttons-top.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('newAutomationLoadCtrl', newAutomationLoadCtrl);

    /** @ngInject */
    function newAutomationLoadCtrl($scope, $filter, RESTServices, $localStorage, $stateParams, $state, toastr, AutoServices,SHAREServices) {

        $scope.frequency = AutoServices.frequencyProgram;
        $scope.newAutomationLoad = {};
        ///////control datepicker
        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            minDate: new Date()
        };
        $scope.open = function() {
            $scope.popup.opened = true;
        };
        $scope.popup = {
            opened: false
        };
        $scope.DateFormat = AutoServices.format.day;

        /////////////

        var zoneId = $stateParams.zona ? $stateParams.zona.id : null;

        var service = $stateParams.parm == 'edit' ? 'edita_programacion.php' : 'programacion_zona.php';

        if ($stateParams.parm == 'edit') {
            $scope.newAutomationLoad = AutoServices.formatResponseLoad($stateParams.program);
        }

        //////////
        ////////esta función es para setear la misma hora en el datatimer y poder comparalos 
        $scope.setMili = function(parm) {
            if (parm === 'ini') {
                $scope.newAutomationLoad.hinit.setMilliseconds('00');
            } else {
                $scope.newAutomationLoad.hend.setMilliseconds('00');
            }
        }


        ////////////////////////
        $scope.newPrograming = function(promg) {

            /*///////Para cuadrar desfase con la hora del servidor de 7 minutos
            promg.hinit.setMinutes(promg.hinit.getMinutes() - AutoServices.serverDelay);
            promg.hend.setMinutes(promg.hend.getMinutes() - AutoServices.serverDelay);
            ////////////////
            */
            promg.hinit = $filter('date')(promg.date.getFullYear() + '-' + (promg.date.getMonth() + 1) + '-' + promg.date.getDate() + ' ' + promg.hinit.getHours() + ':' + promg.hinit.getMinutes() + ':' + promg.hinit.getSeconds(), 'yyyy-MM-dd HH:mm:ss');
            promg.hend = $filter('date')(promg.date.getFullYear() + '-' + (promg.date.getMonth() + 1) + '-' + promg.date.getDate() + ' ' + promg.hend.getHours() + ':' + promg.hend.getMinutes() + ':' + promg.hend.getSeconds(), 'yyyy-MM-dd HH:mm:ss');
            promg.hinit = new Date(promg.hinit);
            promg.hend = new Date(promg.hend);

            var state = AutoServices.validateChangeDayInUTC(promg.hinit, promg.hend);
            switch (state) {
                case 1: //Day in local and UTC format is same
                case 4: //Day in local is major that UTC format for dayInit and dayEnd
                case 5: //Day in local is minor that UTC format for dayInit and dayEnd  
                    var field = {
                        "id_zona": zoneId ? zoneId : null,
                        "dia": promg.hinit.toISOString().substring(0, 10),
                        "hora_inicio": promg.hinit.toISOString().substring(11, 19),
                        "hora_fin": promg.hend.toISOString().substring(11, 19),
                        "frecuencia": promg.freq,
                        "id_usuario": $localStorage.id_usuario,
                        "id_programacion": promg.id ? promg.id : null,
                       //token: SHAREServices.hash_decode_token($localStorage.token)
                    };

                    editSchedule(field);

                    break;

                case 2: //Day in local and UTC format is different for dayInit
                case 3: //Day in local and UTC format is different for dayEnd
                    var field = {
                        "id_zona": zoneId ? zoneId : null,
                        "dia": promg.hinit.toISOString().substring(0, 10),
                        "hora_inicio": promg.hinit.toISOString().substring(11, 19),
                        "hora_fin": '23:59:59',
                        "frecuencia": promg.freq,
                        "id_usuario": $localStorage.id_usuario,
                        "id_programacion": promg.id ? promg.id : null,
                       //token: SHAREServices.hash_decode_token($localStorage.token)
                    };

                    editSchedule(field);

                    field = {
                        "id_zona": zoneId ? zoneId : null,
                        "dia": promg.hend.toISOString().substring(0, 10),
                        "hora_inicio": '00:00:00',
                        "hora_fin": promg.hend.toISOString().substring(11, 19),
                        "frecuencia": promg.freq,
                        "id_usuario": $localStorage.id_usuario,
                        "id_programacion": promg.id ? promg.id : null,
                       //token: SHAREServices.hash_decode_token($localStorage.token)
                    };

                    editSchedule(field);

                    break;

            }

        }

        $scope.cancelar = function() {
            $state.go('dashboard_cliente');
        }

        function editSchedule(field) {
            //Agregar programación
            RESTServices.post_header(service, field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data.code == 200) {
                    $state.go('dashboard_cliente');
                    toastr.success('Se ha programado la zona correctamente', 'Programación de zona');
                } else if (data.code == 400) {
                    toastr.error('La programación se cruza con al menos una programación previamente agendada.', 'No se pudo programar la zona');
                } else {
                    toastr.error('No se ha podido registrar la programación de forma correcta', 'No se pudo programar la zona');
                }
            })
        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('controlDevicesListCtrl', controlDevicesListCtrl);

    /** @ngInject */
    function controlDevicesListCtrl($scope, SHAREServices,$rootScope, $filter, ngDialog, $state, $localStorage, RESTServices, ApparatusForms, toastr) {
        
        var allDevices = [];
        var indFilter = true;
        $scope.loading = true;
        $scope.disabled = false;
        $scope.devices = [];

        $scope.filters = [
            {
                label: 'Todos',
                ind: 'all',
                status: true,
                number: null
            },
            {
                label: 'Offline',
                ind: 'offline',
                status: false,
                number: null
            },
            {
                label: 'Online',
                ind: 'online',
                status: false,
                number: null
            },
            {
                label: 'Activos',
                ind: 'assets',
                status: false,
                number: null
            },
        ];

        $scope.filtrarDevice = function(buscar) {
            if (indFilter){
                allDevices = Array.from($scope.devices);
            }
            $scope.filters.map(function(f) {f.status = false} );
            $scope.filters[0].status = true;
            if(buscar === '') {
                $scope.devices = Array.from(allDevices);
            } else {
                $scope.devices = $filter('filter')(allDevices, { nombre : buscar });
            }
            indFilter = false;
        }

        $scope.filterDevices = function(ind) {
            if (indFilter){
                allDevices = Array.from($scope.devices);
            }
            var index = $scope.filters.findIndex(function(f) {return f.ind === ind});
            $scope.filters.map(function(f) {f.status = false} );
            $scope.filters[index].status = true;
            if(ind === 'all') {
                $scope.devices = Array.from(allDevices);
            } else if(ind === 'offline') {
                $scope.devices = allDevices.filter(function(d) { return d.online == 0 && d.tipo !== '11'});
            } else if(ind === 'online') {
                $scope.devices = allDevices.filter(function(d) { return d.online == 1 && d.tipo !== '11'});
            }
            else if(ind === 'assets') {
                $scope.devices = allDevices.filter(function(d) { return d.tipo === '11'});
            }
            indFilter = false;
        }

        $scope.$on('loading', function(e, res){
            $scope.devices = [];
            $scope.loading = res.ind;
        });

        $scope.$on('updateDevice', function(event, result) {
            
            if(result.dispositivos) {
                $scope.devices = result.dispositivos;
                $scope.rawdevices = Array.from(result.rawdevices);
                devicesCounter($scope.devices);
                allDevices = [];
                indFilter = true;
            }
            
            if ($scope.devices) {
                $scope.devices.map(function(obj) {
                    obj.status = false;
                    if(obj.canales.length > 0){
                        obj.canales.map(function(c){
                            c.status = false
                        })
                    }
                });
                var index = $scope.devices.findIndex(function(i) { return i.id == result.data.id });
                if (index > -1) {
                    $scope.devices[index].status = true;
                }
                if(result.data.agrupador){
                    var index_2 = $scope.devices.findIndex(function(i) { return i.id == result.data.agrupador.id });
                    if (index_2 > -1) {
                        $scope.devices[index_2].canales.map(function(obj) {
                            obj.status = false;
                        });
                        var index_3 = $scope.devices[index_2].canales.findIndex(function(i) { return i.id == result.data.id });
                        if (index_3 > -1) {
                            $scope.devices[index_2].canales[index_3].status = true;
                        }
                    }
                }

            }
            
            $scope.loading = false;
            
        })

        function devicesCounter(devices) {
            var dispositivos;
            var all_devices = [];
            devices.forEach(function(d){
                if(d.canales.length > 0){
                    all_devices = all_devices.concat(d.canales);
                }
            })
            devices = devices.concat(all_devices);
            $scope.filters.forEach(function(filter){{
                if(filter.ind === 'all') {
                    dispositivos = devices.filter(function(d) { return d.tipo !== '11' && d.tipo !== '26'});
                    $scope.filters[0].number = dispositivos.length;
                } else if(filter.ind === 'offline') {
                    dispositivos = devices.filter(function(d) { return d.online == 0 && d.tipo !== '11' && d.tipo !== '26'});
                    $scope.filters[1].number = dispositivos.length;
                } else if(filter.ind === 'online') {
                    dispositivos = devices.filter(function(d) { return d.online == 1 && d.tipo !== '11' && d.tipo !== '26'});
                    $scope.filters[2].number = dispositivos.length;
                }
                else if(filter.ind === 'assets') {
                    dispositivos = devices.filter(function(d) { return d.tipo === '11'});
                    $scope.filters[3].number = dispositivos.length;
                }
            }})
        }

        SHAREServices.diaDatepicker = $filter('date')(new Date(), 'yyyy-MM-dd');

        $scope.goToNewDevice = function(zone) {
            $state.go('mantenimiento_newApparatus', {zone:zone})
        }
        $scope.goSchedules = function(zone) {
            $state.go('dashboard_cliente.schedules', { zone: zone })
        }

        $scope.goToMoveDevices = function() {
            $state.go('dashboard_cliente.moveDevices', { devices: $scope.devices })
        }

        $scope.createSystem = function() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/newSystem.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.devices_ = [];
                    var devices_ = Array.from($scope.devices).filter(function(d){return d.tipo !== '26'});
                    $scope.devices_ = $scope.devices_.concat(devices_)
                    $scope.system = {
                        devices: []
                    }
                    var selected_devices_original = [];

                    $scope.devices_.map(function(f){ 
                        f.status = false;
                        return f;
                    })
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    function compararArreglosPorId(nuevo, original) {
                        var idsNuevo = nuevo.map(function(obj) { return obj.id});
                        var objetosNoEncontrados = original.filter(function(obj) {return !idsNuevo.includes(obj.id)} );
                        return objetosNoEncontrados;
                    }
            
                    function arrayIgual(array1, array2) {
                        var idsArray1 = array1.map(function(obj) { return obj.id});
                        var idsArray2 = array2.map(function(obj) { return obj.id});
                        return JSON.stringify(idsArray1.sort()) == JSON.stringify(idsArray2.sort())
                    }

                    $scope.addSystem = function(nombre) {
                        $scope.disabled = true;
                        var agrupador = {
                            "id_device":  '0',
                            "nombre": nombre,
                            "id_zona": SHAREServices.zona.id,
                            "caracteristicas": ApparatusForms.defaultCharacteristicsSystem,
                            "tipo": '26',
                        }
        
                        var params = {
                            dispositivo: JSON.stringify(agrupador),
                            id_usuario: $localStorage.id_usuario,
                        };
        
                        RESTServices.post_header('cliente/edita_dispositivo.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res){
                            if(res.code == '200'){
                                var id_agrupador = res.dispositivo.id;
                                if(arrayIgual($scope.system.devices, selected_devices_original)) {
                                    toastr.success('Sistema editado con éxito', 'Sistema');
                                    ngDialog.close();
                                    return;
                                } else { 
                                    var id_dispositivos = $scope.system.devices.map(function(d){
                                        return ({
                                            id : d.id
                                        })
                                    })
                                    var parms = {
                                        "id_agrupador": id_agrupador,
                                        "dispositivos": JSON.stringify(id_dispositivos),
                                        "id_usuario": $localStorage.id_usuario,
                                        "asociar": 1,
                                    };
        
                                    RESTServices.post_header('cliente/asociar_dispositivos_agrupador.php', parms, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                                        if(response.code === '200'){
                                            toastr.success('Se ha creado/editado el dispositivo correctamente', 'Nuevo sistema');
                                            ngDialog.close();
                                            $rootScope.$broadcast('resetDevices', {zona: $scope.zone});
                                        } else if(response.code === '400') {
                                            toastr.error('No tienes permisos para realizar esta acción', 'Nuevo sistema');
                                        } else {
                                            toastr.error('Algo ha fallado, intenta nuevamente más tarde', 'Nuevo sistema');
                                        }
                                    })
                                }
                                
                            }
                        })    
                        
                    }

                }]
            });
        }
            
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('controlDevicesList', controlDevicesList);
  
    /** @ngInject */
    function controlDevicesList() {
      return {
        restrict: 'E',
        controller: 'controlDevicesListCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/control-devices-list/control-devices-list.html',
        scope: {
            devices: '=devices',
            zone: '=zone',
            control: '=control',
            integracion: '=integracion',
            serverHour: '=serverHour',
        },
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('controlDeviceCtrl', controlDeviceCtrl);

    /** @ngInject */
    function controlDeviceCtrl($scope, SHAREServices, $rootScope, $localStorage, RESTServices, toastr, $state) {
        
        $scope.delectedGroup =  function(device, control) {
            if(device.tipo === '26' && control) {
                console.log(device);

                var params = {
                    id_usuario: $localStorage.id_usuario,
                    id_dispositivo: device.id
                }

                RESTServices.post_header('cliente/elimina_dispositivos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                    if (data.code == 200) {
                        toastr.success('Se ha eliminado el grupo', 'Agrupador');
                        $rootScope.$broadcast('resetDevices', {zona: $scope.zona});
                    } else {
                        toastr.error('Algo ha fallado, intenta nuevamente más tarde', 'Agrupador');
                    }
                })

            }
        }

        $scope.goApparatusProfile = function(device, control) {
            $state.go('mantenimiento_apparatusProfile', { device: device, control: control, devices: $scope.devices });
        }
            
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('controlDevice', controlDevice);
  
    /** @ngInject */
    function controlDevice() {
      return {
        restrict: 'E',
        controller: 'controlDeviceCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/control-device/control-device.html',
        scope: {
            device: '=device',
            devices: '=devices',
            control: '=control',
            serverHour: '=serverHour',
            zona: '=zona',
        },
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('deviceCtrl', deviceCtrl);

    /** @ngInject */
    function deviceCtrl($scope, $rootScope, SHAREServices, $timeout,maintenanceServices, AutoServices, $filter, utilities, $localStorage, RESTServices, toastr, $state, ngDialog) {
        
        var variable;
        $scope.variable_name = {name:''}
        $scope.errors = [];
        $scope.loading_errors = true;
        var debounceTimer = null;

        $timeout(function() {
            if ($scope.device.tipo == '2' || $scope.device.tipo == '3') {
                var id = $scope.device.estado && $scope.device.estado.id !== undefined ? $scope.device.estado.id : $scope.device.estado;
                $scope.device.estado = $filter('filter')(AutoServices.getCommandsControl(), { id : id}, true)[0];
                $scope.setpoints = AutoServices.selectComandsControl($scope.device.id_aire);
                
            } else if ($scope.device.tipo == '4' || $scope.device.tipo == '32' || $scope.device.tipo == '33') {
                // device.estado es la lectura real de temperatura (ultimo_estado_variable tipo=10),
                // no un id de comando: no pasarla por el filtro de getCommandsControl, o una lectura
                // valida que coincida con un id (9-23) se muestra con el nombre de un comando no
                // relacionado (ver device.html).
                $scope.setpoints = AutoServices.getCommandsControl();
                if($scope.device.tipo == '33'){
                    var index = $scope.setpoints.findIndex(function(s){return s.id === '2'})
                    if(index){
                       $scope.setpoints.splice(index, 1);
                    }
                }
                $scope.velocidad_ventilador = AutoServices.velocidad_ventilador;
                $scope.modos_termostato = AutoServices.modos_termostato;
                $scope.block_termostato = AutoServices.block_termostato;
                
            } else if ($scope.device.tipo == '15') {
                $scope.setpoints = AutoServices.mxproControl;
            } else if ($scope.device.tag) {
                if ($scope.device.variables.length > 0) {
                    $scope.showStatus($scope.device.variables[0].navName);
                    $scope.variable_name.name = $scope.device.variables[0].navName
                }
                
            } else if ($scope.device.tipo == '17') {
                //$scope.intervalDimmer = generarIntervaloDimmer($scope.device.min);
                $scope.intervalDimmer = utilities.generarIntervaloDimmer(50);
            } else if ($scope.device.tipo == '27') {
                $scope.intervalEngine = utilities.generarIntervaloDimmer(10);
            } else if ($scope.device.tipo == '29') {
                $scope.setpoints = AutoServices.wind_CurtainControl;
            } 
            

            /////calcular última conexión
            if ($scope.device.tipo !== '11' && !$scope.device.tag && $scope.device.fecha !== null) {
                var h_l = SHAREServices.dateToLocal($scope.device.fecha,2,1,false)
                $scope.fecha_conexion = $filter('date')(h_l, 'MMM d, y h:mm:ss a');
                // connection_gap (ms) is computed by the server clock, not by the browser.
                var df = $scope.device.connection_gap;
                var ind;
                var index = 0;
                if ($scope.device.connection_gap != null) {
                    while (checkDigits(df)) {
                        ind = df / div(index);
                        index = index + 1;
                        $scope.last_conexion = ind;
                        df = ind;
                    }
                } else {
                    $scope.last_conexion = '--';
                    $scope.ind = '';
                }
                
                function checkDigits(number) {
                    var ind_ = Math.trunc(number);
                    var length =  ind_.toString().length;
                    return (length > 1) && (ind_ > 0);   
                }
                function div(ind) {
                    switch(ind) {
                        case 0 :
                            $scope.ind = 'Segundos';
                            return 1000;
                        case 1 :
                            $scope.ind = 'Minutos';
                            return 60;
                        case 2 :
                            $scope.ind = 'Horas';
                            return 60;
                        case 3: 
                            $scope.ind = 'Días';
                            return 24;
                        case 4:
                            $scope.ind = 'Meses';
                            return 30;
                        case 5:
                            $scope.ind = 'Años';
                            return 12;
                    }
                }
            } else {
                $scope.last_conexion = '--';
                $scope.ind = '';
            }
            

        });
        
        $scope.getData = function(device) {
            SHAREServices.dispositivo_selected = device;
            SHAREServices.zona.id = device.id_zona;
            $scope.$emit('updateGhaphicData', {data: device});
            $scope.$emit('closeComponent');
            $rootScope.$broadcast('setDeviceName', {device: device});
        }

        $scope.turnDevice = function(device) {

            var params = {
                id_dispositivo: device.id,
                id_usuario: $localStorage.id_usuario,
                comando: device.relay ? device.relay: device.estado,
            }

            RESTServices.post_header('control_manual.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    if(device.relay==null) device.estado = device.estado === '0' ? '1' : '0';
                    else device.relay = device.relay === '0' ? '1' : '0';
                    toastr.success('Se ha ejecutado el comando correctamente', 'Control')
                } else {
                    toastr.error('No se ha ejecutado el comando', 'Control')
                }
            });
        }

        $scope.setAir = function(setPoint, device) {
            if (device.tipo != 14)setPoint = JSON.parse(setPoint);
            if(device.tipo == 15) setPoint.nombre = parseInt(setPoint.nombre)*10;
            //if (device.tipo === "14") var rack = parseInt(setPoint)*10;
            var params = {
                id_dispositivo: device.id,
                id_usuario: $localStorage.id_usuario,
                comando: device.tipo !== "14" ? setPoint.nombre : device.tipo === "14" ? setPoint*10 : null,
                //tipo: 1,
            }

            RESTServices.post_header('control_manual_aire.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    toastr.success('Se ha ejecutado el comando correctamente', 'Control');
                    // Solo tipo 2/3 guardan el comando actual como objeto en device.estado;
                    // para el resto (ej. 4/32/33) device.estado es la lectura de sensor, no
                    // el objeto de comando, y asignarle .nombre rompe en modo estricto.
                    if (device.tipo === '2' || device.tipo === '3') {
                        $scope.device.estado.nombre = setPoint.nombre;
                    }
                } else {
                    toastr.error('No se ha ejecutado el comando', 'Control');
                }
            })
        };

        $scope.showStatus = function(name) {
            variable = $scope.device.variables.find(function(d){ return d.navName === name});
            $scope.device.estado = variable.curVal;
            if(variable.writable) {
                $scope.control_saeg = true;
            }else {
                $scope.control_saeg = false;
            }
        }

        $scope.controlSaeg = function(value) {

            RESTServices.setPointSaeg(value, variable.id).then(function(response) {
                if (response.http_status_code == '200') {
                    toastr.success('Se ha ejecutado el comando correctamente', 'Control');
                    $scope.device.estado = value;
                } else {
                    toastr.error('No se ha ejecutado el comando', 'Control');
                }
            })
        }

        $scope.setControlByPercent = function(percent, device) {
            var params = {
                id_dispositivo: device.id,
                id_usuario: $localStorage.id_usuario,
                comando: percent,
            }

            RESTServices.post_header('control_manual_aire.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    toastr.success('Se ha ejecutado el comando correctamente', 'Control');
                    $scope.device.estado = percent;
                } else {
                    toastr.error('No se ha ejecutado el comando', 'Control');
                }
            })
        };

        $scope.goApparatusProfile = function(device, control) {
            $state.go('mantenimiento_apparatusProfile', { device: device, control: control, devices: $scope.devices });
        }

        $scope.showStatus = function(name) {
            variable = $scope.device.variables.find(function(d){ return d.navName === name});
            $scope.device.estado = variable.curVal;
            if(variable.writable) {
                $scope.control_saeg = true;
            }else {
                $scope.control_saeg = false;
            }
        }

        $scope.controlSaeg = function(value) {

            RESTServices.setPointSaeg(value, variable.id).then(function(response) {
                if (response.http_status_code == '200') {
                    toastr.success('Se ha ejecutado el comando correctamente', 'Control');
                    $scope.device.estado = value;
                } else {
                    toastr.error('No se ha ejecutado el comando', 'Control');
                }
            })
        }

        $scope.showErrors = function(device) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/errors_logs.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {

                    var params = {
                        id_usuario: $localStorage.id_usuario,
                        id_dispositivo: device.id,
                    }
        
                    RESTServices.post_header('cliente/consulta_errores.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                        if (response.code == '200') {
                            $scope.loading_errors = false;
                            $scope.errors = maintenanceServices.getErrorListEngine(response.errores);
                            $scope.errors = $scope.errors.map(function(e){
                                e.fecha = new Date(e.fecha.replace(' ', 'T')+'Z');
                                return e;
                            })
                        } else {
                            $scope.loading_errors = false;
                        }
                    })

                    $scope.close = function() {
                        ngDialog.close();
                    };
                }]
            });
        }

        $scope.$on("$destroy", function () {
            ngDialog.close();
        });

            
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('device', device);
  
    /** @ngInject */
    function device() {
      return {
        restrict: 'E',
        controller: 'deviceCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/device/device.html',
        scope: {
            device: '=device',
            control: '=control',
            serverHour: '=serverHour',
        },
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('devicesListCtrl', devicesListCtrl);

    /** @ngInject */
    function devicesListCtrl($scope, $rootScope, SHAREServices, $filter, $timeout) {
        $scope.list = true;
        var myDivs;
        var first = true;
        $scope.$on('updateDevice', function(event, result) {
            if (SHAREServices.dispositivo_selected.tipo !== '12') {
                $scope.list = true;
            } else {
                $scope.list = false;
            } 
            $timeout(function(){
                if(first){
                    myDivs = document.querySelectorAll('.myDivs');
                    scrollToAnchor();
                    first = false;
                }
                
            })
        })
        $scope.$on('setDevice_s', function(e, result){
            console.log(result);
        });
        
        var allDevices = [];
        var indFilter = true;
        
        $scope.getData = function(device) {
            $rootScope.$broadcast('closeComponent');
            $scope.devices.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.devices.findIndex(function(i) { return i.id == device.id });
            $scope.devices[index].status = true;
            SHAREServices.dispositivo_selected = device;
            SHAREServices.zona.id = device.id_zona;
            $rootScope.$broadcast($scope.broadcast, {data: device, dispositivos: $scope.devices});
        }

        $scope.filtrarDevice = function(buscar) {
            if (indFilter){
                allDevices = Array.from($scope.devices)
            }
            if(buscar === '') {
                $scope.devices = Array.from(allDevices);
            } else {
                $scope.devices = $filter('filter')(allDevices, { nombre : buscar });
            }
            indFilter = false;
        }

        function scrollToAnchor() {
            var div;
            var cont = document.getElementsByClassName('cont-devices')[0];
            if (myDivs) {
                for (var i = 0; i < myDivs.length; i++) {
                    var element = myDivs[i];
                    var id = element.getAttribute('id');
                    if (id === SHAREServices.dispositivo_selected.id) {
                        div = element;
                        break
                    }
                }
                if (div) {
                    cont.scrollTop = div.offsetTop - 250;
                }
            }   
        }

            
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('devicesList', devicesList);
  
    /** @ngInject */
    function devicesList() {
      return {
        restrict: 'E',
        controller: 'devicesListCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/devices-list/devices-list.html',
        scope: {
            devices: '=devices',
            broadcast: "=broadcast",
        },
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('noGraphCtrl', noGraphCtrl);

    /** @ngInject */
    function noGraphCtrl($state, $scope, ngDialog, $rootScope, $localStorage, RESTServices, SHAREServices) {

        


    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('noGraph', noGraph);
  
    /** @ngInject */
    function noGraph() {
      return {
        restrict: 'E',
        controller: 'noGraphCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/no-graph/no-graph.html',
      };
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('infoCliente', infoCliente);
  
    /** @ngInject */
    function infoCliente() {
      return {
        restrict: 'E',
        controller: 'infoClienteCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/infoCliente/infoCliente.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('infoClienteCtrl', infoClienteCtrl);

    /** @ngInject */
    function infoClienteCtrl($scope, $localStorage) {
        $scope.default_img = '../../../../assets/img/cliente_default.png';
        $scope.user = {
            name: $localStorage.nombre_cliente,
            img: '../../../../assets/img/logo_las_americas.jpg',
            rol: $localStorage.rol,
            id: $localStorage.id_usuario,
        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('pauseSchedulesCtrl', pauseSchedulesCtrl);

    /** @ngInject */
    function pauseSchedulesCtrl($scope, $localStorage, ngDialog, toastr, RESTServices, $filter, $timeout, SHAREServices, $rootScope, $state) {

        $scope.pauseSchedules = {
            status : $state.current.name == 'dashboard_cliente' ? SHAREServices.enableSchedules[0].status : SHAREServices.enableSchedules[1].status,
            id : $state.current.name == 'dashboard_cliente' ? SHAREServices.enableSchedules[0].id : SHAREServices.enableSchedules[1].id,
        }
        $scope.$on('enableSchedules', function(event, result) {
            $scope.pauseSchedules.status = result.data;
            $scope.pauseSchedules.id = result.id;
        });

        $scope.activeSchedules = function(zone){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = $scope.pauseSchedules.status == true ? '¿Quieres pausar todas las programaciones en esta zona?' : '¿Quieres activar todas las programaciones en esta zona?';

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.aceptar = function(){
                        var service = zone != undefined ? 'cliente/habilita_programacionesxzona.php' : 'cliente/habilita_programacionesxcliente.php';
            
                        var params  = {
                            id_zona: zone != undefined ? zone.id : null,
                            id_usuario: $localStorage.id_usuario,
                            estado: $scope.pauseSchedules.status == true ? 0 : 1,
                        };
                        RESTServices.post_header(service, params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response.code == 200) {
                                $scope.pauseSchedules.status = !$scope.pauseSchedules.status;
                                SHAREServices.enableSchedules[$scope.pauseSchedules.id].status = $scope.pauseSchedules.status;
                                toastr.success($scope.pauseSchedules.status == true ? 'Se han activado todas la programaciones' : 'Se han pausado todas la programaciones', 'Pausar Programaciones');
                                $rootScope.$broadcast('activeAllSchedules', {status:$scope.pauseSchedules.status});         
                            }else{
                                toastr.error('Ha ocurrido un error', 'Pausar Programaciones');
                            }
                            ngDialog.close();
                        })
                    }
                }]
            })
        }
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('pauseSchedules', pauseSchedules);
  
    /** @ngInject */
    function pauseSchedules($timeout, SHAREServices) {
      return {
        restrict: 'E',
        controller: 'pauseSchedulesCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/pauseSchedules/pauseSchedules.html'
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('noZonesCtrl', noZonesCtrl);

    /** @ngInject */
    function noZonesCtrl($scope, $localStorage, $rootScope, RESTServices, $state, toastr, ngDialog, $filter, SHAREServices, $window) {
        
        
        $scope.addZone = function() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/newZone.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.newZone = function(nueva) {
                        $rootScope.flag_loading = true;
                        var params = {
                            id_usuario: $localStorage.id_usuario,
                            //token: SHAREServices.hash_decode_token($localStorage.token),
                            nombre: nueva.nombre
                        };

                        RESTServices.post_header('/instalador/genera_zona.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {

                            if (res.code == 200) {
                                var zona = { nombre: nueva.nombre, id: res.id_zona, aires: 0, h: 0, medicion: 0, iluminacion: 0, temp: 0 };
                                $rootScope.$broadcast('ZoneCreated', {data: zona});
                                ngDialog.close();
                                $window.location.reload();
                                // $rootScope.flag_loading = false;
                            }
                        });
                    }

                }]
            });
        }

        
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('noZones', noZones);
  
    /** @ngInject */
    function noZones() {
      return {
        restrict: 'E',
        controller: 'noZonesCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/noZones/noZones.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('projectCardCtrl', projectCardCtrl);

    /** @ngInject */
    function projectCardCtrl($scope, $rootScope, SHAREServices, ngDialog, $timeout, AutoServices, $filter, utilities, $localStorage, RESTServices, toastr, $state) {
       
        $scope.goToProject = function(project) {
            $state.go('dashboard_cliente.project', {project: project})
        }

        $scope.goToEditarProject = function(project) {
            $state.go('dashboard_cliente.newProject', {project: project})
        }

        $scope.deletedProject = function(project) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Desea borrar este proyecto?',

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.aceptar = function() {
                        $rootScope.flag_loading = true;
                        // v2: migrated from cliente/elimina_proyecto.php
                        RESTServices.deleteProjectV2(project.id).then(function(response) {
                            ngDialog.close();
                            $rootScope.flag_loading = false;
                            $rootScope.$broadcast('projectDelected', {data: project});
                            toastr.success('El proyecto ha sido borrado', 'Eliminar proyecto');
                        }).catch(function() {
                            $rootScope.flag_loading = false;
                            toastr.error('No se pude eliminar el proyecto', 'Ha ocurrido algo inesperado');
                        });
                    }
                }]
            })
        }
        

            
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('projectCard', projectCard);
  
    /** @ngInject */
    function projectCard() {
      return {
        restrict: 'E',
        controller: 'projectCardCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/project-card/project-card.html',
        scope: {
            project: '=project',
            rol: '=rol',
        },
      };
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('relatedProduct', relatedProduct);
  
    /** @ngInject */
    function relatedProduct() {
      return {
        restrict: 'E',
        controller: 'relatedProductCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/relatedProduct/relatedProduct.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente').filter('trustAsResourceUrl', ['$sce', function($sce) {
        return function(val) {
            return $sce.trustAsResourceUrl(val);
        };
    }])
    .controller('relatedProductCtrl', relatedProductCtrl);

    /** @ngInject */
    function relatedProductCtrl($scope, $filter, $localStorage, RESTServices, SHAREServices, $rootScope) {

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '11') {
                $rootScope.flag_loading = true;
                $scope.related = true;
                RESTServices.fetchDeviceMaintenanceTypeV2(SHAREServices.dispositivo_selected.id).then(function(res) {
                    // res.type is a string ("3"): the switch below compares with strict equality.
                    SHAREServices.dispositivo_selected.type = res.type;
                    setIframe();
                }).catch(function() {
                    // 404 (no access / no active profile) or a failure: do not leave the loader stuck.
                    $rootScope.flag_loading = false;
                });
            }
        });

        function setIframe() {
            switch (SHAREServices.dispositivo_selected.type){
                case '3':
                case '6': 
                case '7': 
                case '13': 
                case '14': 
                case '15': 
                case '23': 
                case '26': 
                case '27': 
                case '28': 
                case '29':
                    $scope.relatedProduct = $filter('filter')(products, { 'id': 0 }, true)[0]; 
                break;
                case '0':
                    $scope.relatedProduct = $filter('filter')(products, { 'id': 1 }, true)[0]; 
                break;
                case '1':
                case '8': 
                case '9': 
                case '12': 
                case '16': 
                case '19': 
                case '20': 
                case '21': 
                case '22': 
                    $scope.relatedProduct = $filter('filter')(products, { 'id': 2 }, true)[0]; 
                break;
                case '18':
                    $scope.relatedProduct = $filter('filter')(products, { 'id': 3 }, true)[0]; 
                break;
                case '2':
                    $scope.relatedProduct = $filter('filter')(products, { 'id': 4 }, true)[0]; 
                break;
                case '4':
                case '5': 
                case '25': 
                case '24': 
                case '30': 
                case '31': 
                case '32': 
                    $scope.relatedProduct = $filter('filter')(products, { 'id': 5 }, true)[0]; 
                break;
            }
            $rootScope.flag_loading = false;
        };


        var products = [
            { 
                id: 0,
                name: 'Helo One',
                url: 'https://intelmotics.com/helo-one/',
                types: '3,6,7,13,14,15,23,26,27,28,29'
            },
            { 
                id: 1,
                name: 'Helo Air+',
                url: 'https://intelmotics.com/helo-air-plus/',
                types: '0'
            },
            { 
                id: 2,
                name: 'Helo S',
                url: 'https://intelmotics.com/helo-s/',
                types: '1,8,9,12,16,19,20,21,22'
            },
            { 
                id: 3,
                name: 'Helo T',
                url: 'https://intelmotics.com/helo-t/',
                types: '18'
            },
            { 
                id: 4,
                name: 'Helo TH',
                url: 'https://intelmotics.com/helo-th/',
                types: '2'
            },
            { 
                id: 5,
                name: 'Helo Medición Avanzada',
                url: 'https://intelmotics.com/helo-medicion-avanzada/',
                types: '4,5,25,24,30,31,32'
            }
        ]
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('sidebarZonesCtrl', sidebarZonesCtrl);

    /** @ngInject */
    function sidebarZonesCtrl($state, $scope, $window, ngDialog, $rootScope, $localStorage, RESTServices, SHAREServices, $filter, $stateParams, $timeout) {

        $scope.zones = [];
        $scope.zone;
        $scope.showContent = false;
        $scope.idPosition = 0;
        var nav = document.getElementById('nav');
        var myDivs;
        var idZoneSelected;
        $scope.loading = true;
        $scope.search_zone = {
            ind: '',
        }


        /////////
        $scope.$on('setZones', function(e, res) {
            if(res.zones){
                $scope.zones = res.zones;
                $scope.Zonesfiltered = Array.from($scope.zones);
                $scope.zone = res.zoneSelected;
                $scope.zone.status = true;
                idZoneSelected = $scope.zone.id;
                var index = $scope.zones.findIndex(function(z) { return z.id === idZoneSelected});
                $scope.zones[index].status = true;
                $scope.loading = false;
                scrollToAnchor();
                if(RESTServices.post_pending === false){
                    updateStateDevice($scope.zone);
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        updateStateDevice($scope.zone);
                    },100) 
                }
                //updateStateDevice($scope.zone);
            } else {
                $scope.$broadcast('loading', {ind: false});
            }
            
        })

        $scope.$on('resetDevices', function(e, res) {
            if(RESTServices.post_pending === false){
                    updateStateDevice(res.zona);
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        updateStateDevice(res.zona);
                    },100) 
                }
            //updateStateDevice(res.zona);
        })


        $scope.setHover = function(e) {
            if(e === 0) {
                nav.classList.add('hover');
                $scope.showContent = true;
                $timeout(function(){
                    myDivs = document.querySelectorAll('.myDivs');
                    scrollToAnchor();
                })
            } else {
                if($window.innerWidth <= 1024) {
                    
                } else {
                    nav.classList.remove('hover');
                    $scope.showContent = false;
                }
            }
        }

        function checkIfMobile() {
            if ($window.innerWidth <= 1024) {
                $scope.setHover(0)
            } else {
                $scope.setHover(1)
            }
        }
        
        $window.addEventListener('resize', checkIfMobile);
        
        checkIfMobile();

        $scope.shortName = function(value) {
            var nit = '';
            if (value) {
              var items = value.split(' ');
              if (items.length > 1) {
                if (items[1].substring(0,1) == '-') {
                  nit =  items[0].substring(0,1) + items[2].substring(0,1);
                } else {
                  nit = items[0].substring(0,1) + items[1].substring(0,1);
                }
              } else {
                nit = items[0].substring(0,1)
              }
            }
            return nit
        }

        $scope.filtrarZone = function(buscar) {
            if(buscar === '') {
                $scope.Zonesfiltered = Array.from($scope.zones);
            } else {
                $scope.Zonesfiltered = $filter('filter')($scope.zones, { nombre : buscar });
            }
        }


        $scope.selectedZone = function(zone) {
            var index = $scope.zones.findIndex(function(z) { return z.id === zone.id});
            if(RESTServices.post_pending === false){
                    updateStateDevice(zone);
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        updateStateDevice(zone);
                    },100) 
                }
            //updateStateDevice(zone);
            idZoneSelected = zone.id;
            $scope.zones.map(function(z) { z.status = false});
            SHAREServices.zone_selected_project = $scope.zones[index];
            $scope.zones[index].status = true;
            $scope.idPosition = index;
            $rootScope.$broadcast('setZoneName', {zona: zone});
            $rootScope.$broadcast('closeComponent');
        }

        function updateStateDevice(zona) {
            $scope.$broadcast('loading', {ind: true});
            $scope.devices = [];
            $scope.control = zona.rol == 0 ? true : false;
            var params = {
                id_zona: zona.id,
                id_usuario: $localStorage.id_usuario,
            }

            // Tag clients keep the PHP tag flow; everyone else reads device state from the Go route.
            var request = $localStorage.client.integracion === '1'
                ? RESTServices.post_header('cliente/consulta_dispositivos_tag.php', params, SHAREServices.hash_decode_token($localStorage.token),true)
                : RESTServices.fetchZoneDeviceStatus(zona.id);

            request.then(function(response) {
                if (response != null) {
                    if (response.code == '200') {
                        if ($localStorage.client.integracion === '1') {
                            var dispositivos = response.dispositivos.map(function(d){
                                return ({
                                    nombre: d.nombre,
                                    tag: d.tag,
                                    variables:[],
                                    id: d.id_dispositivo,
                                })
                            })
                            var promesas = response.dispositivos.map(function(d) {
                                var url = 'https://ahhlcn2eporzzf6pbu4tbsb35i0iddhq.lambda-url.us-east-1.on.aws/?tag='
                                return RESTServices.get(url, d.tag)
                            })

                            Promise.all(promesas)
                                .then(function(res) {
                                    res.forEach(function(itm){
                                        if (itm.points.rows.length > 0) {
                                            var index = itm.points.rows[0].equipRef.indexOf(' ');
                                            var device = itm.points.rows[0].equipRef.slice(index + 1)
                                    
                                            dispositivos.forEach(function(d){
                                                if(d.nombre === device) {
                                                    var dv = {
                                                        nombre : d.nombre,
                                                        tag: d.tag,
                                                        id: d.id,
                                                        variables: itm.points.rows
                                                    }
                                                    $scope.devices.push(dv);
                                                } else {
                                                    var dv = {
                                                        nombre : d.nombre,
                                                        tag: d.tag,
                                                        id: d.id,
                                                        variables: []
                                                    }
                                                    $scope.devices.push(dv);
                                                }
                                            })
                                        } 
                                        
                                        
                                    })

                                    RESTServices.fetchZoneDeviceStatus(zona.id).then(function(response) {
                                        if (response != null) {
                                            if (response.code == '200') {
                                                var dis = response.dispositivos;
                                                dis = dis.map(function(d) {
                                                    return ({
                                                        fecha: d.fecha,
                                                        id: d.id,
                                                        id_aire: d.id_aire,
                                                        estado: d.estado,
                                                        tipo: d.tipo,
                                                        id_zona: d.id_zona,
                                                        control: d.control,
                                                        potencia: d.potencia,
                                                        nombre: d.nombre,
                                                        relay: d.relay ? d.relay  : null,
                                                        online: d.online,
                                                        connection_gap: d.connection_gap,
                                                        agrupados: d.agrupados ? d.agrupados : null,
                                                        canales: [], 
                                                        open: true,
                                                        muletilla: d.open,
                                                        status: false,
                                                    })
                                                });

                                                var devicesArray = Array.from($scope.devices);

                                                devicesArray.forEach(function(device) {
                                                    if (device.agrupados) {
                                                        device.agrupados.forEach(function(agrupado) {
                                                            var foundDeviceIndex = $scope.devices.findIndex(function(item) {
                                                                return item.id === agrupado.id;
                                                            });

                                                            if (foundDeviceIndex !== -1) {
                                                                var foundDevice = $scope.devices[foundDeviceIndex];
                                                                foundDevice.agrupador = device;
                                                                device.canales.push(foundDevice);
                                                                $scope.devices.splice(foundDeviceIndex, 1);
                                                            }
                                                        });
                                                    }
                                                });

                                                $scope.devices = $scope.devices.concat(dis);
                                                $scope.filtered = $filter('orderBy')($scope.devices, 'nombre');
                                                $rootScope.$broadcast('setDeviceName', {device: $scope.filtered[0].tipo !== '26' ? $scope.filtered[0] : $scope.filtered[0].canales[0]});
                                                $rootScope.flag_loading = false;

                                                var all = []
                                                $scope.devices.forEach(function(c){ 
                                                    if(c.tipo === "5" && c.estado !== '--') {
                                                        all.push(Number(c.estado)) 
                                                    }
                                                });
                                                $scope.suma = Math.ceil(all.reduce(function(previous, current) { return current += previous})) 
                                                console.log($scope.suma);
                                            }
                                        }
                                    })
                                    
                                })
                            

                        } else {
                            $scope.devices = response.dispositivos;
                            $scope.devices = $scope.devices.map(function(d) {
                                return ({
                                    fecha: d.fecha,
                                    id: d.id,
                                    id_aire: d.id_aire,
                                    estado: d.tipo ==='9' ? '--' : d.estado,
                                    tipo: d.tipo,
                                    id_zona: d.id_zona,
                                    control: d.control,
                                    potencia: d.potencia,
                                    nombre: d.nombre,
                                    relay: d.relay ? d.relay  : null,
                                    online: d.online,
                                    connection_gap: d.connection_gap,
                                    agrupados: d.agrupados ? d.agrupados : null,
                                    canales: [],
                                    open: true,
                                    muletilla: d.open,
                                    status: false,
                                })
                            });

                            var devicesArray = Array.from($scope.devices);
                            $scope.rawdevices = Array.from($scope.devices);
                            devicesArray.forEach(function(device) {
                                if (device.agrupados) {
                                    device.agrupados.forEach(function(agrupado) {
                                        var foundDeviceIndex = $scope.devices.findIndex(function(item) {
                                            return item.id === agrupado.id;
                                        });

                                        if (foundDeviceIndex !== -1) {
                                            var foundDevice = $scope.devices[foundDeviceIndex];
                                            foundDevice.agrupador = device;
                                            device.canales.push(foundDevice);
                                            $scope.devices.splice(foundDeviceIndex, 1);
                                        }
                                    });
                                }
                            });
                            $scope.filtered = $filter('orderBy')($scope.devices, 'nombre');
                            $rootScope.$broadcast('setDeviceName', {device: $scope.filtered[0].tipo !== '26' ? $scope.filtered[0] : $scope.filtered[0].canales[0]});
                            $rootScope.flag_loading = false;
                            formatMonitoringMode(zona);
                            
                        }
                    } else {
                        //console.log("error");
                        $rootScope.flag_loading = false;
                        $scope.$broadcast('loading', {ind: false});
                    }
                    
                } else {
                    //console.log("error");
                    $rootScope.flag_loading = false;
                    $scope.$broadcast('loading', {ind: false});
                }
            })
        }
        function formatMonitoringMode(zona) {
            $scope.filtered.map(function(d) {
                d.status = false;
                d.id = d.id_dispositivo ? d.id_dispositivo : d.id;
                return d;
            });
            if($scope.filtered[0].tipo !== '26') {
                $scope.filtered[0].status = true;
            } else if($scope.filtered[0].tipo === '26') {
                $scope.filtered[0].canales[0].status = true;
            }
            
            SHAREServices.dispositivo_selected = $stateParams.id_device ? $scope.filtered.filter(function(d) { return d.id === $stateParams.id_device})[0] : $scope.filtered[0];
            SHAREServices.zona.id = zona.id
            var dispositivo = $stateParams.id_device ? $scope.filtered.filter(function(d) { return d.id === $stateParams.id_device})[0] : $scope.filtered[0];
            $scope.$broadcast('updateDevice', {data: dispositivo.tipo !== '26' ? dispositivo : dispositivo.canales[0], dispositivos: $scope.filtered, rawdevices:$scope.rawdevices});
            
        }

        $scope.$on('updateGhaphicData', function(event, result) {
            $scope.$broadcast('updateDevice', {data: result.data});
        })

        function scrollToAnchor() {
            var div;
            var cont = document.getElementsByClassName('cont-zones')[0];
            if (myDivs) {
                for (var i = 0; i < myDivs.length; i++) {
                    var element = myDivs[i];
                    var id = element.getAttribute('id');
                    if (id === idZoneSelected) {
                        div = element;
                        break
                    }
                }
                if (div) {
                    cont.scrollTop = div.offsetTop - 250;
                }
            }   
        }

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('sidebarZones', sidebarZones);
  
    /** @ngInject */
    function sidebarZones() {
      return {
        restrict: 'E',
        controller: 'sidebarZonesCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/sidebar-zones/sidebar-zones.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('schedulesListCtrl', schedulesListCtrl);

    /** @ngInject */
    function schedulesListCtrl($scope, $rootScope, SHAREServices, $filter, $state, ngDialog, RESTServices, toastr, $localStorage) {
        
        var first = true;
        var allSchedule = [];
        
        
        ////////////////
        $scope.editSchedule = function(prog) {
            if(prog.frecuencia === 'Única' || prog.frecuencia === 'Diaria' || prog.frecuencia === 'Mensual') {
                $state.go('dashboard_cliente.newAutomationAir', { program: prog, parm: 'edit', zona: $scope.zone, dispositivos: $scope.devices });
            } else {
                $state.go('dashboard_cliente.newAutomation', { program: prog, parm: 'edit', zona: $scope.zone, dispositivos: $scope.devices  });
            }
        }
        
        $scope.openDeleteDialog = function(prog) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal ='¿Quieres eliminar esta programación?';
                    $scope.sumary = 'Esta acción no se puede deshacer';
        
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
        
                    $scope.aceptar = function(){
                        var progm = []; 
                        prog.id_nestedProg.forEach(function(id){
                            var field = {
                                "id_programacion": id,
                                "id_usuario": $localStorage.id_usuario,
                            };
                            progm.push(field);
                        });
                        
                        scheduleServices(progm);
                    }
                }]
            });
        };
        
        $scope.deleteSchedule = function(prog) {
            $scope.openDeleteDialog(prog, false);
        }
        

        function scheduleServices(programaciones) {
            $rootScope.flag_loading = true; 
            ngDialog.close();
            var promise = Promise.resolve();
            programaciones.forEach(function(a){
                promise = promise.then(function () {
                    // Espera la respuesta: la lambda tarda más de 400 ms y la lista se recargaba antes de que terminara.
                    return Schedule(a);
                });
            })
  
            promise.then(function(){
                $rootScope.flag_loading = false;
                $rootScope.$broadcast('getSchedules', {});
                toastr.success('Se han eliminado correctamente todas las programaciones', 'Programación de aire'); 
            })
  
            function Schedule(params) {
                return RESTServices.post_header('elimina_programacion_aires.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                    if(res.code == 200) {
                        
                    }
                }).catch(function () {})
            }
          
        }

        $scope.activeSchedule = function(schedule) {
            var promesas = schedule.id_nestedProg.map(function(id){
                var field = {
                    "id": id,
                    "id_usuario": $localStorage.id_usuario,
                    "estado": schedule.enable === '1' ? '0' : '1',
                    "id_dispositivo": schedule.dispositivo.id,
                };
                return RESTServices.post_header('cliente/habilita_programacionesxid.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
            })

            Promise.all(promesas)
                .then(function(data){
                    var index = $scope.schedules.findIndex(function(i){return i.id === schedule.id})
                    $scope.schedules[index].enable = schedule.enable === '1' ? '0' : '1';
                    toastr.success($scope.schedules[index].enable === '1' ? 'Programación activada' : 'Programación Desactivada');
                })
                .catch(function(error){
                    toastr.error('Hubo un problema inesperado');
                })
        }

        $scope.convertString = function(array) {
            var strings = array.toString();
            return strings;
        }

        $scope.showHolidays = function(holidays) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/holidays_list.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.holidays = holidays;
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
        
                }]
            });
        }

        $scope.$on('filtrarSchedules', function(event, result){
            if(first) {
                if($scope.schedules.length > 0) {
                    allSchedule = $scope.schedules;
                    first = false;
                }
                filtrar(result.filter) 
            } else {
                filtrar(result.filter)
            }

            function filtrar(ind){
                switch(ind) {
                    case 'Todas': 
                        $scope.schedules = allSchedule;
                        break;
                    case 'Diaria': 
                        $scope.schedules = allSchedule.filter(function(s){
                            return s.frecuencia === 'Diaria'
                        })
                        break;
                    case 'Lun': 
                        $scope.schedules = allSchedule.filter(function(s){
                            return s.actionDays.includes('Lun')                       
                        })
                        break;
                    case 'Mar': 
                        $scope.schedules = allSchedule.filter(function(s){
                            return s.actionDays.includes('Mar')                       
                        })
                        break;
                    case 'Mie': 
                        $scope.schedules = allSchedule.filter(function(s){
                            return s.actionDays.includes('Mie')                       
                        })
                        break;
                    case 'Jue': 
                        $scope.schedules = allSchedule.filter(function(s){
                            return s.actionDays.includes('Jue')                       
                        })
                        break;
                    case 'Vie': 
                        $scope.schedules = allSchedule.filter(function(s){
                            return s.actionDays.includes('Vie')                       
                        })
                        break;
                    case 'Sab': 
                        $scope.schedules = allSchedule.filter(function(s){
                            return s.actionDays.includes('Sab')                       
                        })
                        break;
                    case 'Dom': 
                        $scope.schedules = allSchedule.filter(function(s){
                            return s.actionDays.includes('Dom')                       
                        })
                        break;
                }
            }
        }); 


            
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('schedulesList', schedulesList);
  
    /** @ngInject */
    function schedulesList() {
      return {
        restrict: 'E',
        controller: 'schedulesListCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/schedules-list/schedules-list.html',
        scope: {
          schedules: '=schedules',
          control: '=control',
          zone: '=zone',
          devices: '=devices',
        },
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('zoneCardCtrl', zoneCardCtrl);

    /** @ngInject */
    function zoneCardCtrl($scope, $localStorage, $rootScope, RESTServices, ngDialog, $filter,SHAREServices) {
        
        $scope.currentPage = 1;
        $scope.itemsPerPage = 6;
        $scope.totalItems = $scope.client.zonas.length;

        $scope.filtrar = function(buscar) {
            $scope.filtered = $filter('filter')($scope.client.zonas, { nombre: buscar });
            $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            $scope.totalItems = $scope.filtered.length;
            $scope.noOfPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);
            $scope.currentPage = 1;
        }

        /////Eventos

        $scope.$on('ZoneDelected', function(event, result) {
            var index = $scope.client.zonas.findIndex(function(z){return z.id == result.data.id});
            $scope.client.zonas.splice(index, 1);
            generarPaginado();
            if($scope.client.zonas.length == 0){
                $rootScope.$broadcast('callDashboard');
            }
        });

        $scope.$on('ZoneEdited', function(event, result) {
            var index = $scope.client.zonas.findIndex(function(z){return z.nombre == result.viejo.nombre});
            $scope.client.zonas[index].nombre = result.nuevo.nombre;
        });

        function generarPaginado(){
            $scope.client.zonas = $filter('orderBy')($scope.client.zonas, 'nombre');
            $scope.totalItems = $scope.client.zonas.length;
            $scope.currentPage = 1;
            $scope.itemsPerPage = 6;
        };
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('zoneCard', zoneCard);
  
    /** @ngInject */
    function zoneCard($filter) {
      return {
        restrict: 'E',
        controller: 'zoneCardCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/zoneCard/zoneCard.html',
        scope: {
            client: '=client',
            owner: '=owner',
            loading: '=loading',
            noInfo: '=noInfo'
        }
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('zoneTableCtrl', zoneTableCtrl);

    /** @ngInject */
    function zoneTableCtrl($scope, $localStorage, $rootScope, RESTServices, $state, toastr, ngDialog, $filter, SHAREServices, $stateParams, $interval, statisticsServices) {
        $scope.status = {
            open: false,
        };
        $scope.showInds = true;
        $scope.monitoringMode = SHAREServices.monitoringMode;
        $scope.showIndFilterDevices = false;
        if($localStorage.client.integracion){
            $scope.integracion = $localStorage.client.integracion;
        } else {
            $scope.integracion = '0';
        }
        
        var timer;

        $scope.indFilterActives = [
            {
                name: 'Todos',
                id: 0,
                status: true,
            },
            {
                name: 'Dispositivos',
                id: 1,
                status: false,
            },
            {
                name: 'Activos',
                id: 2,
                status: false,
            },
        ]

        $scope.showDis = function(zona, flag) {
            $rootScope.flag_loading = true;
            $scope.status.open = !$scope.status.open;
            $scope.zona = zona;
            if (!flag) {
                //iniciarTimer();
                updateStateDevice(zona)  
            } else {
                //cancelarTimer()
                $rootScope.flag_loading = false;  
            } 
        }

        

        $scope.goSchedules = function(zone) {
            $state.go('dashboard_cliente.schedules', { zone: zone })
        }

        $scope.goStatistics = function(zona) {
            var zona = { 'nombre': zona.nombre, 'id_zona': zona.id };
            $state.go('estadisticas_zona', zona);
        }
        $scope.deleteZone = function(zone) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Desea borrar esta zona?',

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.aceptar = function() {
                        $rootScope.flag_loading = true;
                        var params = {
                            id_zona: zone.id,
                            id_usuario: $localStorage.id_usuario,
                            //token: SHAREServices.hash_decode_token($localStorage.token)
                        }
                        RESTServices.post_header('instalador/elimina_zona.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response.code == '200') {
                                ngDialog.close();
                                $rootScope.flag_loading = false;
                                $rootScope.$broadcast('ZoneDelected', {data: zone});
                                toastr.success('La zona ha sido borrada', 'Eliminar zona');
                            }else{
                                toastr.error('No se pude eliminar la zona', 'Ha ocurrido algo inesperado');
                            }
                        });
                    }
                }]
            })
            
        }
        $scope.filtrarDevice = function(buscar) {
            if(buscar === '') {
                $scope.filtered = $scope.devices;
                $scope.indFilterActives.map(function(d){
                    d.status = false;
                });
                $scope.indFilterActives[0].status = true;
            } else {
                $scope.filtered = $filter('filter')($scope.devices, { nombre : buscar });
            }
        }

        $scope.filterActives = function(param) {
            $scope.filtered = $scope.devices;
            $scope.indFilterActives.map(function(d){
                d.status = false;
            });
            $scope.indFilterActives[param].status = true;
            if (param === 0) {
                $scope.filtered = $filter('orderBy')($scope.devices, 'nombre');
            } else if(param === 1) {
                $scope.filtered = $scope.filtered.filter(function(d) {
                    return d.estado !== null;
                });
                $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            } else if (param === 2) {
                $scope.filtered = $filter('filter')($scope.devices, { estado : null });
                $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            }
        }

        $scope.exportExcel = function() {
            var data = Array.from($scope.filtered);
            data = data.map(function(d) {
                return ({
                    zona: $scope.zone.nombre,
                    dispositivo: d.nombre,
                    serial: extraerSerial(d.nombre),
                    fecha: d.fecha,
                    online: d.online,
                    id: $localStorage.rol === '6' || $localStorage.rol === '7' || $localStorage.rol === '8' ? d.id : '',
                    //"conexión últimas 24 horas": isWithin24Hours(d.fecha)
                })        
            })
            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.json_to_sheet(data);

            XLSX.utils.book_append_sheet(wb, ws, 'Data');
            XLSX.writeFile(wb, $scope.zone.nombre + '.xlsx');
        }

        function extraerSerial(nombre) {
            var regex = /\b[a-zA-Z0-9]{10}\b/; // Expresión regular para encontrar un código alfanumérico de 10 caracteres
            var match = nombre.match(regex);
            return match ? match[0] : null
        }

        

        // function isWithin24Hours(dateString) {
        //     // Convertimos la cadena de fecha de entrada en un objeto Date
        //     var inputDate = new Date(dateString);
        //     // Obtenemos la fecha actual
        //     var currentDate = new Date();
        
        //     // // Verificamos si la fecha ingresada es válida
        //     // if (isNaN(inputDate.getTime())) {
        //     //     throw new Error("La fecha ingresada no es válida.");
        //     // }
        
        //     // Calculamos la diferencia en milisegundos entre las dos fechas
        //     var differenceInMilliseconds = currentDate - inputDate;
        
        //     // Convertimos la diferencia a horas
        //     var differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);
        
        //     // Devolvemos 1 si está dentro de las 24 horas, de lo contrario 0
        //     return differenceInHours < 24 ? 1 : 0;
        // }

        function formatMonitoringMode() {
            $scope.filtered.map(function(d) {
                d.status = false;
                d.id = d.id_dispositivo ? d.id_dispositivo : d.id;
                return d;
            });
            SHAREServices.dispositivo_selected = $stateParams.id_device ? $scope.filtered.filter(function(d) { return d.id === $stateParams.id_device})[0] : $scope.filtered[0];
            SHAREServices.zona.id = $stateParams.id_zona ? $stateParams.id_zona : $scope.filtered[0].id_zona;
            var dispositivo = $stateParams.id_device ? $scope.filtered.filter(function(d) { return d.id === $stateParams.id_device})[0] : $scope.filtered[0];
            $scope.$broadcast('updateDevice', {data: dispositivo, dispositivos: $scope.filtered});
            //setInds(dispositivo);
            
        }

        $scope.$on('updateGhaphicData', function(event, result) {
            $scope.$broadcast('updateDevice', {data: result.data});
            //setInds(result.data);
        })

        // function setInds(device){
        //     $rootScope.$broadcast('resetIndGraph')
        //     $scope.indicadoresGrafica = statisticsServices.setIndicadoresGrafica(device)
        //     if($scope.indicadoresGrafica.inds && $scope.indicadoresGrafica.inds.length > 0){
        //         $scope.showInds = true;
        //     } else {
        //         $scope.showInds = false;
        //     }
        // };

        // $scope.$on('setInds', function(e, res){
        //     $rootScope.$broadcast('resetIndGraph')
        //     $scope.indicadoresGrafica = statisticsServices.setIndicadoresGrafica(res.type)
        //     if($scope.indicadoresGrafica.inds && $scope.indicadoresGrafica.inds.length > 0){
        //         $scope.showInds = true;
        //     } else {
        //         $scope.showInds = false;
        //     }
        // });

        

        function iniciarTimer() {
            // CÓDIGO PARA SIMULAR TIEMPO REAL
            timer = $interval(function() {
                updateStateDevice($scope.zona)
           }, 30000);
        };

        function cancelarTimer() {
            $interval.cancel(timer);
            timer = undefined;
        }
       
        $scope.$on('$destroy', function() {
            $interval.cancel(timer);
            timer = undefined;
        });

        function updateStateDevice(zona) {
            $scope.devices = [];
            $scope.control = zona.rol == 0 ? true : false;
                var params = {
                    id_zona: zona.id,
                    id_usuario: $localStorage.id_usuario,
                }

                // Tag clients keep the PHP tag flow; everyone else reads device state from the Go route.
                var request = $localStorage.client.integracion === '1'
                    ? RESTServices.post_header('cliente/consulta_dispositivos_tag.php', params, SHAREServices.hash_decode_token($localStorage.token),true)
                    : RESTServices.fetchZoneDeviceStatus(zona.id);

                request.then(function(response) {
                    if (response != null) {
                        if (response.code == '200') {
                            if ($localStorage.client.integracion === '1') {
                                var dispositivos = response.dispositivos.map(function(d){
                                    return ({
                                        nombre: d.nombre,
                                        tag: d.tag,
                                        variables:[],
                                        id: d.id_dispositivo,
                                    })
                                })

                                var promesas = response.dispositivos.map(function(d) {
                                    var url = 'https://ahhlcn2eporzzf6pbu4tbsb35i0iddhq.lambda-url.us-east-1.on.aws/?tag='
                                    return RESTServices.get(url, d.tag)
                                })

                                Promise.all(promesas)
                                    .then(function(res) {
                                        res.forEach(function(itm){
                                            if (itm.points.rows.length > 0) {
                                                var index = itm.points.rows[0].equipRef.indexOf(' ');
                                                var device = itm.points.rows[0].equipRef.slice(index + 1)
                                        
                                                dispositivos.forEach(function(d){
                                                    if(d.nombre === device) {
                                                        var dv = {
                                                            nombre : d.nombre,
                                                            tag: d.tag,
                                                            id: d.id,
                                                            variables: itm.points.rows
                                                        }
                                                        $scope.devices.push(dv);
                                                    } else {
                                                        var dv = {
                                                            nombre : d.nombre,
                                                            tag: d.tag,
                                                            id: d.id,
                                                            variables: []
                                                        }
                                                        $scope.devices.push(dv);
                                                    }
                                                })
                                            } 
                                            
                                            
                                        })

                                        RESTServices.fetchZoneDeviceStatus(zona.id).then(function(response) {
                                            if (response != null) {
                                                if (response.code == '200') {
                                                    var dis = response.dispositivos;
                                                    dis = dis.map(function(d) {
                                                        return ({
                                                            fecha: d.fecha,
                                                            id: d.id,
                                                            id_aire: d.id_aire,
                                                            estado: d.estado,
                                                            tipo: d.tipo,
                                                            id_zona: d.id_zona,
                                                            control: d.control,
                                                            potencia: d.potencia,
                                                            nombre: d.nombre,
                                                            relay: d.relay ? d.relay  : null,
                                                            online: d.online,
                                                            connection_gap: d.connection_gap,
                                                            agrupados: d.agrupados ? d.agrupados : null,
                                                            canales: [], 
                                                            open: false,
                                                            muletilla: d.open,
                                                            status: false,
                                                        })
                                                    });

                                                    var devicesArray = Array.from($scope.devices);

                                                    devicesArray.forEach(function(device) {
                                                        if (device.agrupados) {
                                                            device.agrupados.forEach(function(agrupado) {
                                                                var foundDeviceIndex = $scope.devices.findIndex(function(item) {
                                                                    return item.id === agrupado.id;
                                                                });
                        
                                                                if (foundDeviceIndex !== -1) {
                                                                    var foundDevice = $scope.devices[foundDeviceIndex];
                                                                    foundDevice.agrupador = device;
                                                                    device.canales.push(foundDevice);
                                                                    $scope.devices.splice(foundDeviceIndex, 1);
                                                                }
                                                            });
                                                        }
                                                    });

                                                    $scope.devices = $scope.devices.concat(dis);
                                                    $scope.filtered = $filter('orderBy')($scope.devices, 'nombre');
                                                    for (var i = 0; i < $scope.devices.length; i++ ) {
                                                        if ($scope.devices[i].estado === null) {
                                                            $scope.showIndFilterDevices = true;
                                                            break;
                                                        }
                                                    }
                                                    $rootScope.flag_loading = false;

                                                    var all = []
                                                    $scope.devices.forEach(function(c){ 
                                                        if(c.tipo === "5" && c.estado !== '--') {
                                                            all.push(Number(c.estado)) 
                                                        }
                                                    });
                                                    $scope.suma = Math.ceil(all.reduce(function(previous, current) { return current += previous})) 
                                                    console.log($scope.suma);
                                                }
                                            }
                                        })
                                        
                                    })
                                

                            } else {
                                $scope.devices = response.dispositivos;
                                $scope.devices = $scope.devices.map(function(d) {
                                    return ({
                                        fecha: d.fecha,
                                        id: d.id,
                                        id_aire: d.id_aire,
                                        estado: d.tipo ==='9' ? '--' : d.estado,
                                        tipo: d.tipo,
                                        id_zona: d.id_zona,
                                        control: d.control,
                                        potencia: d.potencia,
                                        nombre: d.nombre,
                                        relay: d.relay ? d.relay  : null,
                                        online: d.online,
                                        connection_gap: d.connection_gap,
                                        agrupados: d.agrupados ? d.agrupados : null,
                                        canales: [],
                                        open: false,
                                        muletilla: d.open,
                                        status: false,
                                    })
                                });

                                var devicesArray = Array.from($scope.devices);

                                devicesArray.forEach(function(device) {
                                    if (device.agrupados && device.tipo === '23') {
                                        device.agrupados.forEach(function(agrupado) {
                                            var foundDeviceIndex = $scope.devices.findIndex(function(item) {
                                                return item.id === agrupado.id;
                                            });

                                            if (foundDeviceIndex !== -1) {
                                                var foundDevice = $scope.devices[foundDeviceIndex];
                                                foundDevice.agrupador = device;
                                                device.canales.push(foundDevice);
                                                $scope.devices.splice(foundDeviceIndex, 1);
                                            }
                                        });
                                    } else if(device.agrupados && device.tipo === '26'){
                                        var foundDeviceIndex = $scope.devices.findIndex(function(item) {
                                            return item.id === device.id;
                                        });
                                        $scope.devices.splice(foundDeviceIndex, 1);
                                    }
                                });

                                $scope.filtered = $filter('orderBy')($scope.devices, 'nombre');
                                for (var i = 0; i < $scope.devices.length; i++ ) {
                                    if ($scope.devices[i].estado === null) {
                                        $scope.showIndFilterDevices = true;
                                        break;
                                    }
                                }
                                $rootScope.flag_loading = false;
                                if ($scope.monitoringMode === '1') formatMonitoringMode();
                                
                            }
                        } else {
                           //console.log("error");
                            $rootScope.flag_loading = false;
                            $scope.$broadcast('loading', {ind: false});
                        }
                        
                    } else {
                       //console.log("error");
                        $rootScope.flag_loading = false;
                    }
                })
        }

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('zoneTable', zoneTable);
  
    /** @ngInject */
    function zoneTable() {
      return {
        restrict: 'E',
        controller: 'zoneTableCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/zoneTable/zoneTable.html',
        scope: {
            zone: '=zone',
            owner: '=owner'
          },
      };
    }
})();
 
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
      .controller('grafica_ahorro_cCtrl', grafica_ahorro_cCtrl);

  /** @ngInject */
  function grafica_ahorro_cCtrl($scope, baConfig, $element, layoutPaths, SHAREServices) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    $scope.$watch(function(){
       return SHAREServices.flagAhorro;
    }, function(newValue, oldValue){    
      if(SHAREServices.ahorroxzonaxmes[0] != undefined){
        var lineChart = AmCharts.makeChart(id, {
          type: 'serial',
          theme: 'blur',
          color: layoutColors.defaultText,
          marginTop: 0,
          marginRight: 15,
          dataProvider: SHAREServices.ahorroxzonaxmes,
          valueAxes: [
            {
              axisAlpha: 0,
              position: 'left',
              gridAlpha: 0.5,
              gridColor: layoutColors.border,
            }
          ],
          graphs: [
            {
              id: 'g1',
              balloonText: '[[potencia_wh]]',
              bullet: 'round',
              bulletSize: 8,
              lineColor: layoutColors.danger,
              lineThickness: 1,
              negativeLineColor: layoutColors.warning,
              type: 'smoothedLine',
              valueField: 'potencia_wh'
            }
          ],
          chartScrollbar: {
            graph: 'g1',
            gridAlpha: 0,
            color: layoutColors.defaultText,
            scrollbarHeight: 55,
            backgroundAlpha: 0,
            selectedBackgroundAlpha: 0.05,
            selectedBackgroundColor: layoutColors.defaultText,
            graphFillAlpha: 0,
            autoGridCount: true,
            selectedGraphFillAlpha: 0,
            graphLineAlpha: 0.2,
            selectedGraphLineColor: layoutColors.defaultText,
            selectedGraphLineAlpha: 1
          },
          chartCursor: {
            categoryBalloonDateFormat: 'DD-MMMM-YYYY',
            cursorAlpha: 0,
            valueLineEnabled: true,
            valueLineBalloonEnabled: true,
            valueLineAlpha: 0.5,
            fullWidth: true
          },
          dataDateFormat: 'YYYY-MM-DD',
          categoryField: 'dia',
          categoryAxis: {
            minPeriod: 'DD',
            parseDates: true,
            minorGridAlpha: 0.1,
            minorGridEnabled: true,
            gridAlpha: 0.5,
            gridColor: layoutColors.border,
          },
          export: {
            enabled: true
          },
          creditsPosition: 'bottom-right',
          pathToImages: layoutPaths.images.amChart
        });

        lineChart.addListener('rendered', zoomChart);
        if (lineChart.zoomChart) {
          lineChart.zoomChart();
        }

        function zoomChart() {
          lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
        }

        lineChart.monthNames = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ];

        lineChart.shortMonthNames = [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Sept',
          'Oct',
          'Nov',
          'Dic'];        
      }
    });
  } 

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_comportamiento_aireCtrl', grafica_comportamiento_aireCtrl);

    /** @ngInject */
    function grafica_comportamiento_aireCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, statisticsServices, $timeout, utilities, consumptionUtil, consumoV2Util, $rootScope, energyUtil) {

        $scope.noInfo = false;
        $scope.loading = false;
        $scope.ind_unit = statisticsServices.setUnit(statisticsServices.graphType);
        var chart;
        $scope.rol = $localStorage.rol;
        $scope.graphType = statisticsServices.graphType;

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.indicador = utilities.generarCodigo(20);

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFilter = SHAREServices.dateFilter;

        var colors = [
            '#337ab7',
            '#0ce789'
        ];

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
        $scope.DateFormat = formato.day;


        $scope.update_date = function(time) {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            consulta_comp(time ? time : $scope.time);
        }

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = formato[itm];
        };

        /////////////
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = statisticsServices.graphType + " - " + SHAREServices.dispositivo_selected.nombre;
        }

        $scope.$on('updateGraph', function(event, result) {
            $scope.graphType = result.data;
            if(result.data === 'opening' || result.data === 'relay' || result.data === 'temp' || result.data === 'behavior' || result.data === 'presence' || result.data === 'Tin' || result.data === 'Tout' || result.data === 'DeltaT' || result.data === 'curtain' || result.data === 'fan' || result.data === 'lock' || result.data === 'mode' || result.data === 'comms' || result.data === 'error'){
                createGraphic();
                if(RESTServices.post_pending === false){
                    consulta_comp('day')
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        consulta_comp('day')
                    },100)
                    
                }  
            }
        })

        function consulta_comp(time) {
            if(chart !== undefined) {
                chart.data = []
            }
            $scope.time = time;
            $scope.tipo = SHAREServices.dispositivo_selected.tipo;
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
            $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            $scope.ind_unit = statisticsServices.setUnit(statisticsServices.graphType)
            loading(time);
            var field = {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": time,
                "type": statisticsServices.graphType,
                "offset": (new Date()).getTimezoneOffset()
            };

            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        response.data.sort(function (a, b) {
                            if (a.tiempo > b.tiempo) {
                                return 1;
                            }
                            if (a.tiempo < b.tiempo) {
                                return -1;
                            }
                            return 0;
                        });
                        response.data = addLastHour(response.data, SHAREServices.diaDatepicker, time);
                        response.data = response.data.map(function(d,ind){
                            return ({
                                tiempo : SHAREServices.dateToLocal(d.tiempo,response.data.length-1,ind,false),
                                fecha: $filter('date')(new Date(SHAREServices.dateToLocal(d.tiempo,response.data.length-1,ind,false)), 'MMM d, y'),
                                lineColor : d.tipo == '0' ? colors[0] : colors[1],
                                action : d.tipo == '0' ? 'Usuario' : 'Helo',
                                estado : d.estado,
                                tipo : d.tipo,
                                ind: statisticsServices.graphType === 'opening' ? (d.estado === '1' ? 'Cerrado' : 'Abierto') : d.estado,
                                hora: SHAREServices.dateToLocal(d.tiempo,response.data.length-1,ind,true),
                            })
                        })
                        response.data = energyUtil.filterDate(response.data, SHAREServices.diaDatepicker, time);
                        // se agrega el primer valor en la gráfica para que abarque todo el día
                        if(time === 'day') {
                            if(response.data[0].hora !== '00:00:00'){
                                var t = new Date(response.data[0].tiempo);
                                t.setHours('00');
                                t.setMinutes('00');
                                t.setSeconds('00');
                                var itm = {
                                    tiempo : t,
                                    fecha: $filter('date')(t, 'MMM d, y'),
                                    lineColor : colors[0],
                                    action : 'Usuario',
                                    estado : '0',
                                    tipo : response.data[0].tipo,
                                    hora: '00:00:00'
                                }
                                response.data.unshift(itm);
                            }
                        }
                        
                        if(statisticsServices.graphType === 'Tin' || statisticsServices.graphType === 'Tout' || statisticsServices.graphType === 'DeltaT') {
                            response.data = response.data.map(function(d){
                                d.estado = (d.estado) / 10;
                                return d
                            })
                        }
                        if(statisticsServices.graphType === 'temp' && SHAREServices.dispositivo_selected.tipo === '32') { //DMS: temperatura viene multiplicada por 100
                            response.data = response.data.map(function(d){
                                d.estado = (d.estado) / 100;
                                return d
                            })
                        }
                        if(SHAREServices.dispositivo_selected.tipo === '28' || SHAREServices.dispositivo_selected.tipo === '30') {
                            response.data = response.data.map(function(d){
                                d.estado = (d.estado) / 100;
                                return d
                            })
                        }
                        //$rootScope.$broadcast('setInds', {type:statisticsServices.graphType})
                        if(statisticsServices.graphType === 'temp') {
                            if(SHAREServices.dispositivo_selected.tipo !== '4'){
                                // v2: migrated from consulta_configuracion.php
                                RESTServices.fetchDeviceConfigV2(SHAREServices.dispositivo_selected.id).then(function(res) {
                                    if(res.code === '200') {
                                        var offset;
                                        var index = res.caracteristicas.findIndex(function(c){return c.id === '80'})
                                        if(index >= 0){
                                            offset = parseFloat(res.caracteristicas[index].valor);
                                            response.data = response.data.map(function(d){
                                                d.estado = parseFloat(d.estado) + offset;
                                                return d
                                            })
                                            
                                        }
                                        var all = response.data.map(function(c){ return Number(c.estado)});
                                        $rootScope.$broadcast('indDataConsumtion', {data: all});
    
                                        var index_umbral = res.caracteristicas.findIndex(function(c){return c.id === '86'});
                                        if(index_umbral >= 0){
                                            if(res.caracteristicas[index_umbral].valor === '1'){
                                                var limite_superior = res.caracteristicas.find(function(c){return c.id === '84'}).valor;
                                                var limite_inferior = res.caracteristicas.find(function(c){return c.id === '85'}).valor;
                                                if(limite_superior && limite_superior !== '') addSeries(limite_superior, 'limite_superior');
                                                if(limite_inferior && limite_inferior !== '') addSeries(limite_inferior, 'limite_inferior');
                                                var objetLimite_superior = [
                                                    {
                                                        tiempo: response.data[0].tiempo,
                                                        limite_superior: limite_superior,
                                                    },
                                                    {
                                                        tiempo: response.data[response.data.length - 1].tiempo,
                                                        limite_superior: limite_superior,
                                                    }
                                                ]
                                                var objetLimite_inferior = [
                                                    {
                                                        tiempo: response.data[0].tiempo,
                                                        limite_inferior: limite_inferior,
                                                    },
                                                    {
                                                        tiempo: response.data[response.data.length - 1].tiempo,
                                                        limite_inferior: limite_inferior,
                                                    }
                                                ]
                                            }
                                        }
                                        
                                        response.data = response.data.concat(objetLimite_superior, objetLimite_inferior)
                                        chart.data = response.data;
                                        successfulResponse();
                                        
                                        
                                    } else {
                                        var all = response.data.map(function(c){ return Number(c.estado)});
                                        $rootScope.$broadcast('indDataConsumtion', {data: all});
                                        chart.data = response.data;
                                        successfulResponse();
                                    }
                                })
                            } else {
                                var all = response.data.map(function(c){ return Number(c.estado)});
                                $rootScope.$broadcast('indDataConsumtion', {data: all});
                                chart.data = response.data;
                                successfulResponse();
                            }
                              
                        } else {
                            chart.data = response.data;
                            successfulResponse();
                        }                         

                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });
        }

        // $scope.$on('updateDevice', function(event, result) {
        //     if (result.data.tipo === '0' || result.data.tipo === '1' || result.data.tipo === '2' || result.data.tipo === '3' || result.data.tipo === '4' || result.data.tipo === '6' || result.data.tipo === '19' || result.data.tipo === '20' || result.data.tipo === '21') consulta_comp('day');
        // })

        $timeout(function(){
            createGraphic();
            consulta_comp('day');
        }, 100);

       

        function createGraphic() {
            am4core.useTheme(am4themes_animated); 
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
            am4core.options.autoDispose = true;
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            chart.paddingRight = 20;

            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            };

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;
            if($scope.graphType === 'fan' || $scope.graphType === 'lock' || $scope.graphType === 'mode' || $scope.graphType === 'comms' || $scope.graphType === 'error') {
                if($scope.graphType === 'comms'){
                    valueAxis.min = 0.5;
                    valueAxis.max = 3.5;
                    valueAxis.strictMinMax = true;
                }
                valueAxis.renderer.labels.template.adapter.add("text", function(label, target) {
                    if($scope.graphType === 'fan'){
                        console.log(label);
                        if (label === "1" || label === "1.0" || label === "1.00" || label === "1.002") {
                            return "Bajo";
                        } else if (label === "2" || label === "2.0" || label === "2.00" || label === "2.002") {
                            return "Medio";
                        } else if (label === "3" || label === "3.0" || label === "3.00" || label === "3.002") {
                            return "Alto";
                        } else if (label === "0" || label === "0.0" || label === "0.00" || label === "0.002") {
                            return "Auto";
                        }
                        // Por defecto devuelve el número original
                        return '';
                    }

                    if($scope.graphType === 'lock'){
                        console.log(label);
                        if (label === "1" || label === "1.0" || label === "1.00" || label === "1.002") {
                            return "Lock";
                        } else if (label === "0" || label === "0.0" || label === "0.00" || label === "0.002") {
                            return "Unlock";
                        }
                        // Por defecto devuelve el número original
                        return " ";
                    }
                    if($scope.graphType === 'mode'){
                        console.log(label);
                        if (label === "1" || label === "1.0" || label === "1.00" || label === "1.002") {
                            return "Enfriar";
                        } else if (label === "2" || label === "2.0" || label === "2.00" || label === "2.002") {
                            return "Ventilar";
                        } else if (label === "0" || label === "0.0" || label === "0.00" || label === "0.002") {
                            return "Calentar";
                        }
                        // Por defecto devuelve el número original
                        return " ";
                    }
                    if($scope.graphType === 'comms'){
                        console.log(label);
                        if (label === "1" || label === "1.0" || label === "1.00" || label === "1.002") {
                            return "Sin comunicación";
                        } else if (label === "2" || label === "2.0" || label === "2.00" || label === "2.002") {
                            return "Error";
                        } else if (label === "3" || label === "3.0" || label === "3.00" || label === "3.002") {
                            return "Con comunicación";
                        }
                        // Por defecto devuelve el número original
                        return " ";
                    }
                    if($scope.graphType === 'error'){
                        if (label === "0" || label === "0.0" || label === "0.00") {
                            return "Sin error";
                        }
                        // Any other value means error
                        return "Con error";
                    }
                    
                });
            }
            

            var series = chart.series.push(new am4charts.StepLineSeries());
            var label = "Estado: <strong>{estado}</strong><br> Acción: <strong>{action}</strong>";
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";
            series.strokeWidth = 3;
            series.propertyFields.stroke = "lineColor";
            series.tooltipHTML = "Fecha: <strong>{fecha}</strong><br>Hora: <strong>{hora}</strong><br> "+label;
            // Make bullets grow on hover
            var bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.strokeWidth = 2;
            bullet.circle.radius = 3;
            bullet.circle.fill = am4core.color("#fff");
            
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.fullWidthLineX = true;
            chart.cursor.lineX.strokeWidth = 0;
            chart.cursor.lineX.fill = chart.colors.getIndex(2);
            chart.cursor.lineX.fillOpacity = 0.1;

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            chart.scrollbarX = scrollbarX;

            chart.exporting.menu = new am4core.ExportMenu();

            
        }

        function addSeries(value, name) {
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.labels.template.disabled = false;
            dateAxis.cursorTooltipEnabled = true;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = name;
            series.strokeWidth = 3;
           // series.tooltipHTML = "Umbral superior: <strong>{fecha}</strong><br>Hora: <strong>{hora}</strong><br> "+label;
            //series.tooltipText = name + ": {name}" ;
            series.name = name;
            series.stroke = am4core.color("#E8A220");
        }

        $scope.$on("$destroy", function () {
            chart.dispose();
            RESTServices.cancelarSolicitudHttp();
        });

        function addLastHour(array, date, parm) {
            var setParam = consumptionUtil.setTiempo(parm, date, array);
            var i = array.length; 
            if (parm === 'day') {
                if (date == $filter('date')(new Date(), 'yyyy-MM-dd')) {
                    var aux = {
                        tiempo: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                        estado: array[i - 1].estado,
                        tipo: array[i - 1].tipo
                    };
                } else {
                    var aux = {
                        tiempo: date + ' 23:59:59',
                        estado: array[i - 1].estado,
                        tipo: array[i - 1].tipo
                    };
                }
                array.push(aux);

            } else if (parm === 'month') {
                var current_month = new Date().getMonth();
                var month = new Date(date + ' ' + '00:00:00').getMonth();
                if (current_month !== month) {
                    var year = date.substring(0,4);
                    var last_date = consumoV2Util.lastday(year, month)
                    var aux = {
                        tiempo: year + '-' + (month + 1) + '-' + last_date + ' 23:59:00',
                        estado: array[i - 1].estado,
                        tipo: array[i - 1].tipo,
                    };
                    array.push(aux);
                } else {
                    var i = array.length;
                    var aux = {
                        tiempo: setParam,
                        estado: array[i - 1].estado,
                        tipo: array[i - 1].tipo,
                    };
                    array.push(aux);
                }
            }
            
            return array; 
        }

    }

        

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_commutationCtrl', grafica_commutationCtrl);

    /** @ngInject */
    function grafica_commutationCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, $rootScope, utilities) {

        $scope.noInfo = false;
        $scope.loading = false;

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;
        $scope.indicador = utilities.generarCodigo(20);

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFilter = SHAREServices.dateFilter;

        var colors = [
            '#337ab7',
            '#0ce789'
        ];

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
        $scope.DateFormat = formato.day;


        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            consulta_comp();
        }

        /////////////
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = "conmutación" + " - " + SHAREServices.dispositivo_selected.nombre;
        }

        function consulta_comp() {
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.tipo = SHAREServices.dispositivo_selected.tipo;
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
            $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            var field = {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "data": SHAREServices.diaDatepicker,
                "time": "day",
                "type": "relay",
                "offset": (new Date()).getTimezoneOffset()
            };
            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        
                        response.data.sort(function (a, b) {
                            if (a.tiempo > b.tiempo) {
                                return 1;
                            }
                            if (a.tiempo < b.tiempo) {
                                return -1;
                            }
                            return 0;
                        });
                        var index = response.data.length;
                        if (SHAREServices.diaDatepicker == $filter('date')(new Date(), 'yyyy-MM-dd')) {
                            var aux = {
                                //tiempo: $filter('date')(new Date(), 'HH:mm:ss'),
                                tiempo: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                                estado: response.data[index - 1].estado,
                                tipo: response.data[index - 1].tipo
                            };
                        } else {
                            var aux = {
                                //tiempo: '23:59:59',
                                tiempo: SHAREServices.diaDatepicker+' 23:59:59',
                                estado: response.data[index - 1].estado,
                                tipo: response.data[index - 1].tipo
                            };
                        }
                        response.data.push(aux);
                        response.data = response.data.map(function(d,ind){
                            return ({
                                tiempo : SHAREServices.dateToLocal(d.tiempo,response.data.length-1,ind,false),
                                lineColor : d.tipo == '0' ? colors[0] : colors[1],
                                action : d.tipo == '0' ? 'Usuario' : 'Helo',
                                estado : d.estado,
                                tipo : d.tipo,
                                hora: SHAREServices.dateToLocal(d.tiempo,response.data.length-1,ind,true)
                            })
                        })

                        SHAREServices.comportamiento_aire = response.data;
                        chart.data = SHAREServices.comportamiento_aire;
                        successfulResponse();
                        

                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });
        }

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '0' || result.data.tipo === '1') consulta_comp();
        })

        am4core.useTheme(am4themes_animated); 
        var chart = am4core.create($scope.indicador, am4charts.XYChart);
        chart.paddingRight = 20;
        am4core.options.autoDispose = true;

        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.baseInterval = {
            "timeUnit": "second",
            "count": 1
        };

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.minWidth = 35;

        var series = chart.series.push(new am4charts.StepLineSeries());
        series.dataFields.dateX = "tiempo";
        series.dataFields.valueY = "estado";
        series.strokeWidth = 3;
        series.propertyFields.stroke = "lineColor";
        series.tooltipHTML = "Hora: <strong>{hora}</strong><br> Temp: <strong>{valueY.value}</strong><br> Acción: <strong>{action}</strong>"
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = dateAxis;
        chart.cursor.fullWidthLineX = true;
        chart.cursor.lineX.strokeWidth = 0;
        chart.cursor.lineX.fill = chart.colors.getIndex(2);
        chart.cursor.lineX.fillOpacity = 0.1;

        var scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        chart.scrollbarX = scrollbarX;

        //chart.exporting.menu = new am4core.ExportMenu();
        am4core.options.minPolylineStep = 5;
        am4core.options.onlyShowOnViewport = true;
        am4core.options.queue = true;



        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        consulta_comp();

    }

        

})();
(function() {
    'use strict';
    angular.module('BlurAdmin').factory('consumptionUtil', function(consumptionServices, $filter,SHAREServices) {
       
        return {

            getMonday: function(date) {
                var day = date.getDay() || 7;
                if (day !== 1)
                    date.setHours(-24 * (day - 1));
                return date;
            },
            
            setTiempo: function(parm, date, data) {
                var index = data.length;
                switch (parm) {
                    case 'day':
                        if (date < $filter('date')(new Date(), 'yyyy-MM-dd')) {
                            return date + ' ' + '23:59:59';
                        } else {
                            return $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                        }
                        break;
                    case 'week':
                        var lunes = this.getMonday(new Date($filter('date')(date, 'yyyy/MM/dd')));
                        if ($filter('date')(lunes, 'yyyy-MM-dd') < $filter('date')(this.getMonday(new Date()), 'yyyy-MM-dd')) {
                            return $filter('date')(lunes.setDate(lunes.getDate() + 6), 'yyyy-MM-dd') + ' 23:59:59';
                        } else {
                            return $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                        }
                        break;
                    case 'month':
                        if (date.substring(0, 5) + data[index - 1].tiempo.substring(0, 2) < $filter('date')(new Date(), 'yyyy-MM')) {
                            return  $filter('date')(new Date(date.substring(0, 4), parseInt(data[index - 1].tiempo.substring(0, 2)), 0), 'yyyy-MM-dd') + ' 23:59:59';      
                        } else {
                            return $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                        }
                        break;
                    case 'year':
                        if (date.substring(0, 4) < $filter('date')(new Date(), 'yyyy')) {
                            return data[index - 1].tiempo.substring(0, 5) + '12-31 23:59:59';
                        } else {
                            return $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                        }
                        break;
                }
            },

            addLastHour: function(array, date, parm) {
                var setParam = this.setTiempo(parm, date, array); 
                array = array.map(function(d,ind){
                    return ({
                        tiempo: SHAREServices.dateToLocal(d.tiempo,array.length,ind,false),
                        estado: d.estado,
                        tipo: d.tipo,
                    })
                })
                /////
                if(parm === 'month') {
                    var current_month = new Date().getMonth();
                    var month = new Date(date + ' ' + '00:00:00').getMonth();
                    if (current_month !== month) {
                        var i = array.length;
                        var d = new Date(date);
                        var last_date = $filter('date')(new Date(d.getFullYear(), d.getMonth() + 1, new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate(), 23, 59,0), 'yyyy-MM-dd') 
                        var aux = {
                            tiempo: new Date(last_date.replace(/-/g, '/')),
                            estado: array[i - 1].estado,
                            tipo: array[i - 1].tipo,
                        };
                        array.push(aux);
                    } else {
                        var i = array.length;
                        var aux = {
                            tiempo: new Date(setParam.replace(/-/g, '/')),
                            estado: array[i - 1].estado,
                            tipo: array[i - 1].tipo,
                        };
                        array.push(aux);
                    }
                } else {
                    var i = array.length;
                    var aux = {
                        tiempo: new Date(setParam.replace(/-/g, '/')),
                        estado: array[i - 1].estado,
                        tipo: array[i - 1].tipo,
                    };
                    array.push(aux);
                }
                return array; 
            },

            changeToLocal: function(array, date, parm) {
                var setParam = this.setTiempo(parm, date, array); 
                array = array.map(function(d,ind){
                    return ({
                        tiempo: SHAREServices.dateToLocal(d.tiempo,array.length,ind,false),
                        estado: d.estado,
                        tipo: d.tipo,
                    })
                })
                return array; 
            }

        }
    })
})();
(function() {
    'use strict';
    angular.module('BlurAdmin').service('consumptionServices', consumptionServices);

    function consumptionServices() {
        return {
            
            chart: AmCharts.makeChart("grafica_consumo", {
                "type": "serial",
                "autoMarginOffset": 25,
                "startDuration": 1,
                "mouseWheelZoomEnabled": true,
                "colors": [
                    "#337ab7"
                ],
                "valueAxes": [{
                    "axisAlpha": 0,
                    "position": "left"
                }],
                "graphs": [{
                    "id": "g1",
                    "balloonText": "[[category]]<br><b>[[value]] W</b>",
                    "type": "step",
                    "lineThickness": 2,
                    "bullet": "square",
                    "bulletAlpha": 0,
                    "bulletSize": 4,
                    "bulletBorderAlpha": 0,
                    "valueField": "estado"
                }],
                "chartScrollbar": {
                    "graph": "g1",
                    "oppositeAxis": false,
                    "offset": 30,
                    "scrollbarHeight": 40,
                    "backgroundAlpha": 0,
                    "selectedBackgroundAlpha": 0,
                    "selectedBackgroundColor": "#888888",
                    "graphFillAlpha": 0,
                    "graphLineAlpha": 0,
                    "selectedGraphFillAlpha": 0,
                    "selectedGraphLineAlpha": 1,
                    "autoGridCount": true,
                    "color": "#AAAAAA"
                },
                "chartCursor": {
                    "fullWidth": true,
                    "categoryBalloonDateFormat": "JJ:NN",
                    "cursorAlpha": 0,
                    "graphBulletAlpha": 1,
                    "valueZoomable": true
                },
                "zoomControl": {
                    "zoomControlEnabled": true,
                    "panControlEnabled": true
                },
                "dataDateFormat": "JJ:NN",
                "categoryField": "tiempo",
                "categoryAxis": {
                    "minPeriod": "ss",
                    "parseDates": true,
                    "gridAlpha": 0
                },
                "export": {
                    "enabled": true
                },
                "options":{
                    "minPolylineStep" : 5
                }
            }),

            format: {
                day: 'yyyy-MM-dd',
                week: 'yyyy-MM-dd',
                month: 'yyyy-MM',
                year: 'yyyy'
            },

            dataProvider: [],
            day: '',
            year: '',

           

        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_consumoCtrl', grafica_consumoCtrl);

    /** @ngInject */
    function grafica_consumoCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, consumptionServices, consumptionUtil, energyUtil, $timeout, utilities, statisticsServices) {
        
        $scope.parm = "day";
        $scope.noInfo = false;
        $scope.loading = true;
        var chart;
        $scope.type_graph = "consumption";
        $scope.indicador = utilities.generarCodigo(20);

        $scope.DateFilter = SHAREServices.dateFilter;

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFormat = consumptionServices.format.day;

        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.filtrar($scope.parm);
        }
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        /////////////////////////

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = consumptionServices.format[itm];
        };

        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = statisticsServices.graphType + " - " + SHAREServices.dispositivo_selected.nombre;

        }

        function setParameters(parm) {
            return {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": parm,
                "type": statisticsServices.graphType,
                "offset": (new Date()).getTimezoneOffset()
            };
        }

        $scope.filtrar = function(parm) {
            if(chart !== undefined) {
                chart.data = [];
            }
            $scope.parm = parm;
            $scope.tipo = SHAREServices.dispositivo_selected.tipo;
            $scope.ind_unit = statisticsServices.setUnit(statisticsServices.graphType)
            consumptionServices.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            consumptionServices.day = SHAREServices.diaDatepicker.substring(0, 11);
            loading(parm);
            var field = setParameters(parm);

            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        response.data.sort(function (a, b) {
                            if (a.tiempo > b.tiempo) {
                                return 1;
                            }
                            if (a.tiempo < b.tiempo) {
                                return -1;
                            }
                            // a must be equal to b
                            return 0;
                        });
                        chart.data = consumptionUtil.addLastHour(response.data, SHAREServices.diaDatepicker, parm);
                        chart.data.map(function(dt){
                            dt.tiempoFormato = $filter('date')(dt.tiempo, 'MMM d, y');
                            dt.horaFormato = $filter('date')(dt.tiempo, 'h:mm a');
                            return dt
                        })
                        if(statisticsServices.graphType === 'energyTerm') {
                            chart.data.map(function(dt){
                                dt.estado = (dt.estado) / 100;
                                return dt
                            })
                        }
                        successfulResponse();
                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });

        }

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '5' || result.data.tipo === '19' || result.data.tipo === '27' ) {
                if(RESTServices.post_pending === false){
                    $scope.filtrar($scope.parm);
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        $scope.filtrar($scope.parm);
                    }, 100)
                    
                } 
                
            } 
        })

        $scope.$on('updateGraph', function(event, result) {
            if(result.data === 'flowM3h' || result.data === 'consumption' || result.data === 'energyTerm' || result.data === 'voltageVariator' || result.data === 'currentVariator'){
                if(RESTServices.post_pending === false){
                    $scope.filtrar($scope.parm);
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        $scope.filtrar($scope.parm);
                    }, 100)
                    
                }
                
            }
        })


        $scope.$on("$destroy", function () {
            chart.dispose();
            RESTServices.cancelarSolicitudHttp();
        });

        function createGraphic (tipo) {
            am4core.useTheme(am4themes_animated); 
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
            am4core.options.autoDispose = true;
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            
            chart.paddingRight = 20;
            
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            };
            
            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";
            series.strokeWidth = 3;
            series.tooltipText = $scope.ind_unit + ': {valueY.value}'
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.fullWidthLineX = true;
            chart.cursor.lineX.strokeWidth = 0;
            chart.cursor.lineX.fill = chart.colors.getIndex(2);
            chart.cursor.lineX.fillOpacity = 0.1;

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            chart.scrollbarX = scrollbarX;

            //chart.exporting.menu = new am4core.ExportMenu();
            
        }

        $timeout(function(){
            $scope.tipo = SHAREServices.dispositivo_selected.tipo;
            $scope.ind_unit = statisticsServices.setUnit(statisticsServices.graphType)
            createGraphic(statisticsServices.graphType)
            $scope.filtrar($scope.parm);
        });

    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_consumo_helo_mcCtrl', grafica_consumo_helo_mcCtrl);

    /** @ngInject */
    function grafica_consumo_helo_mcCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, consumptionServices, consumptionUtil, energyUtil, $timeout, utilities, statisticsServices) {
        
        $scope.parm = "day";
        $scope.noInfo = false;
        $scope.loading = false;
        var chart;
        $scope.type_graph = "consumption";
        $scope.indicador = utilities.generarCodigo(20);

        $scope.DateFilter = SHAREServices.dateFilter;
        var allData = [];

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };
        var colors = ['#AF4848', '#217AEB', '#0ce789']

        $scope.DateFormat = consumptionServices.format.day;

        $scope.update_date = function() {
            allData = [];
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.filtrar($scope.parm, true);
        }
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        /////////////////////////

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = consumptionServices.format[itm];
        };

        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = $scope.type_graph + " - " + SHAREServices.dispositivo_selected.nombre;
            //$scope.$apply();
        }

        function setParameters(parm, device_id) {
            
            return {
                "device_id": device_id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": parm,
                "type": 'consumption',
                "offset": (new Date()).getTimezoneOffset()
            };
        }

        $scope.filtrar = function(parm, allDataMode, canal) {
            if(chart !== undefined) {
                chart.data = [];
            }
            $scope.parm = parm;
            $scope.tipo = SHAREServices.dispositivo_selected.tipo;
            $scope.variable = statisticsServices.graphType;
            consumptionServices.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            consumptionServices.day = SHAREServices.diaDatepicker.substring(0, 11);
            loading(parm);

            if(allDataMode){
                getAllData(parm);
            } else {
                var field = setParameters(parm, canal.id);
                RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                    if (response.code == '200') {
                        if (response.data != undefined) {
                            response.data.sort(function (a, b) {
                                if (a.tiempo > b.tiempo) {
                                    return 1;
                                }
                                if (a.tiempo < b.tiempo) {
                                    return -1;
                                }
                                return 0;
                            });
                            response.data = consumptionUtil.addLastHour(response.data, SHAREServices.diaDatepicker, parm);
                            response.data.map(function(dt){
                                dt.tiempo = dt.tiempo;
                                dt.tiempoFormato = $filter('date')(dt.tiempo, 'MMM d, y');
                                dt.horaFormato = $filter('date')(dt.tiempo, 'h:mm a');
                                dt['estado' + canal.index] = dt.estado; 
                                delete dt.estado;
                                return dt
                            })

                            createSeries(canal.index, canal.nombre, response.data);
                            successfulResponse();
                        } else {
                            noInfo();
                        }

                    } else {
                        noInfo();
                    }
                });
            }
            
        }

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '23' ) {
                allData = [];
                if(chart.series) {
                    chart.series.clear();
                }
                $scope.filtrar($scope.parm, false, result.data.canales[0]);
                $scope.canales = result.data.canales;
                if($scope.canales.length > 0 ){
                    $scope.canales.map(function(c, i){
                        c.estado = i === 0 ? true : false;
                        c.index = i + 1;
                        return c;
                    })
                }
                
            }
        })

        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        function createGraphic (tipo) {
            am4core.useTheme(am4themes_animated); 
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
            am4core.options.autoDispose = true;
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            
            chart.paddingRight = 20;
            
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            };
            
            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.fullWidthLineX = true;
            chart.cursor.lineX.strokeWidth = 0;
            chart.cursor.lineX.fill = chart.colors.getIndex(2);
            chart.cursor.lineX.fillOpacity = 0.1;

            var scrollbarX = new am4core.Scrollbar();
            chart.scrollbarX = scrollbarX;

            ////configuración exportación
            //chart.exporting.menu = new am4core.ExportMenu();
            chart.exporting.adapter.add("data", function(data, target) {
                // Assemble data from series
                var data = [];
                chart.series.each(function(series) {
                  for(var i = 0; i < series.data.length; i++) {
                    series.data[i].name = series.name;
                    data.push(series.data[i]);
                  }
                });
                return { data: data };
            });
            
        }

        $timeout(function(){
            $scope.tipo = SHAREServices.dispositivo_selected.tipo;
            $scope.variable = statisticsServices.graphType;
            createGraphic();
            $scope.canales = SHAREServices.dispositivo_selected.canales.length > 0 ? SHAREServices.dispositivo_selected.canales : [];
            if($scope.canales.length > 0 ){
                $scope.canales.map(function(c, i){
                    c.estado = i === 0 ? true : false;
                    c.index = i + 1;
                    return c;
                })
            }
            $scope.filtrar($scope.parm, false, $scope.canales[0]);
        });

        $scope.setChannel = function(canal, estado){
            if(estado) {
                $scope.filtrar($scope.parm, false, canal);
            } else {
                chart.data = organizeData(allData, canal.index, [], true)
            } 
        }
        
        function createSeries(canal, name, data) {
            var series = chart.series.push(new am4charts.StepLineSeries());
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado" + canal;
            series.strokeWidth = 3;
            series.tooltipText = name + ": {valueY.value} W" ;
            series.name = name;
            series.stroke = am4core.color(colors[canal - 1]);
            chart.data = organizeData(allData, canal, data, false);
        }

        function organizeData(data_total, canal, data_canal, ind) {

            var mc_data = [];
            var dataTotalMap = new Map();

            function createDataObject(tiempo, estado1, estado2, estado3) {
                return {
                    tiempo: tiempo,
                    estado1: estado1 !== undefined ? estado1 : null,
                    estado2: estado2 !== undefined ? estado2 : null,
                    estado3: estado3 !== undefined ? estado3 : null,
                }
            };
            function addToDataTotalMap(data) {
                data.forEach(function(d) {
                    var time = $filter('date')(d.tiempo, 'yyyy-MM-dd HH:mm:ss');
                    if (dataTotalMap.has(time)) {
                        var existing = dataTotalMap.get(time);
                        dataTotalMap.set(time, createDataObject(
                            time,
                            d.estado1 !== undefined ? d.estado1 : existing.estado1,
                            d.estado2 !== undefined ? d.estado2 : existing.estado2,
                            d.estado3 !== undefined ? d.estado3 : existing.estado3
                        ));
                    } else {
                        dataTotalMap.set(time, createDataObject(time, d.estado1, d.estado2, d.estado3));
                    }
                });
            }

            
            // si ind es true se elimina ese canal del arreglo
            if(ind){
                mc_data = data_total.map(function(d){
                    d['estado' + canal] = null;
                    return d;
                })
                chart.series.removeIndex(canal - 1);
            } else {

                // Agregar datos de cada fase al mapa
                addToDataTotalMap(data_total);
                addToDataTotalMap(data_canal);

                mc_data = Array.from(dataTotalMap.values());
                mc_data.sort(function (a, b) {
                    if (a.tiempo > b.tiempo) {
                        return 1;
                    }
                    if (a.tiempo < b.tiempo) {
                        return -1;
                    }
                    return 0;
                });
                mc_data = mc_data.map(function(d, i, arr) {
                    d.tiempo = new Date(d.tiempo);
                    if (i > 0) {
                        d.estado1 = d.estado1 !== null ? d.estado1 : arr[i - 1].estado1;
                        d.estado2 = d.estado2 !== null ? d.estado2 : arr[i - 1].estado2;
                        d.estado3 = d.estado3 !== null ? d.estado3 : arr[i - 1].estado3;
                    }
                    return d;
                });
            }
        
            // Verificar si todas las propiedades del primer objeto son null
            if (countNullProperties(mc_data[0]) === 3) {
                mc_data = [];
                chart = []; 
                createGraphic(); 
            }
        
            allData = mc_data;
            return mc_data;
        }

        function countNullProperties(obj) {
            var count = 0;
            for (var key in obj) {
                if (obj[key] === null) {
                    count++;
                }
            }
            return count;
        }

        function getAllData(parm) {
            var promesas = []
            $scope.canales.forEach(function(c){
                if(c.estado){
                    var field = setParameters(parm, c.id);
                    promesas.push(RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true))
                } 
            })

            Promise.all(promesas).then(function(response){
                var data;
                response.map(function(res, i){
                    res.data = consumptionUtil.addLastHour(res.data, SHAREServices.diaDatepicker, parm);
                    res.data.map(function(dt){
                        dt.tiempo = dt.tiempo;
                        dt.tiempoFormato = $filter('date')(dt.tiempo, 'MMM d, y');
                        dt.horaFormato = $filter('date')(dt.tiempo, 'h:mm a');
                        dt['estado' + (i + 1)] = dt.estado; 
                        delete dt.estado;
                        return dt
                    })
                    data = organizeData(allData, (i + 1), res.data, false);            
                })

                chart.data = data;
                $scope.loading = false;
                $scope.noInfo = false;
                $scope.$apply();
            })
        }


    }

})();
/**
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
      .controller('grafica_consumo_zonaCtrl', grafica_consumo_zonaCtrl);

  /** @ngInject */
  function grafica_consumo_zonaCtrl($scope, $element, SHAREServices, $localStorage, RESTServices, $filter) {
    
    $scope.parm = "d";
    $scope.noInfo = false;
    $scope.loading = false;
    ///////control datepicker
    function open() {
      $scope.opened = true;
    }
    
    $scope.open = open;
    $scope.opened = false;

    $scope.options = {
        showWeeks: false,
        minMode: 'day',
        maxDate: new Date()            
    };

    var formato = {day:'yyyy-MM-dd', week:'yyyy-MM-dd', month:'yyyy-MM', year: 'yyyy'};
    $scope.DateFormat = formato.day;

    
    $scope.update_date = function(){
      SHAREServices.diaDatepicker = $filter('date')($scope.dt,'yyyy-MM-dd');
    }
    $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

    $scope.$watch(function(){
      return SHAREServices.diaDatepicker;
    },function(){    
      $scope.filtrar($scope.parm);
    }); 
        

    $scope.filtro_dia = true;
    $scope.filtro_semana = false;
    $scope.filtro_mes = false;
    $scope.filtro_year = false;

    $scope.filtrar = function(parm){
      $scope.parm = parm;
      if(parm == "d"){
        $scope.filtro_dia = true;
        $scope.filtro_semana = false;
        $scope.filtro_mes = false;
        $scope.filtro_year = false;
        $scope.options.minMode = 'day';
        $scope.dt = "";
        $scope.DateFormat = formato.day;
        var field = {
              "zone_id": SHAREServices.zona.id,
              "user_id": $localStorage.id_usuario,
             //token: SHAREServices.hash_decode_token($localStorage.token),
              "data": SHAREServices.diaDatepicker,
              "time": "day",
              "type": "consumption"
          };

        RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data2) {
          if(data2.code=='200'){
            SHAREServices.consumo_zona = data2.data;  
            SHAREServices.flagConsumo_zona = !SHAREServices.flagConsumo_zona;            
            chart.chartCursor.categoryBalloonDateFormat = "JJ:NN:SS";
            chart.dataDateFormat = "JJ:NN:SS";
            chart.dataProvider = SHAREServices.consumo_zona;
            chart.validateData();
            chart.animateAgain();
          }
        });

      }else if(parm == "s"){
        $scope.filtro_dia = false;
        $scope.filtro_semana = true;
        $scope.filtro_mes = false;
        $scope.filtro_year = false;
        $scope.options.minMode = 'day';
        $scope.dt = "";
        $scope.DateFormat = formato.week;
        var field = {              
              "zone_id": SHAREServices.zona.id,
              "user_id": $localStorage.id_usuario,
             //token: SHAREServices.hash_decode_token($localStorage.token),
              "data": SHAREServices.diaDatepicker,
              "time": "week",
              "type": "consumption"
          };

        RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data2) {
          if(data2.code=='200'){
            SHAREServices.consumo_zona = data2.data;  
            SHAREServices.flagConsumo_zona = !SHAREServices.flagConsumo_zona;            
            chart.chartCursor.categoryBalloonDateFormat = "MM-DD JJ:NN:SS";
            chart.dataDateFormat = "MM-DD JJ:NN:SS"; 
            chart.dataProvider = SHAREServices.consumo_zona;
            chart.validateData();
            chart.animateAgain(); 
          }
        });
      }else if(parm == "m"){
        $scope.filtro_dia = false;
        $scope.filtro_semana = false;
        $scope.filtro_mes = true;
        $scope.filtro_year = false;
        $scope.options.minMode = 'month';
        $scope.dt = "";
        $scope.DateFormat = formato.month;
        var field = {          
          "zone_id": SHAREServices.zona.id,
          "user_id": $localStorage.id_usuario,
         //token: SHAREServices.hash_decode_token($localStorage.token),
          "data": SHAREServices.diaDatepicker,
          "time": "month",
          "type": "consumption"
        };

        RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data2) {
          if(data2.code=='200'){
            SHAREServices.consumo_zona = data2.data;  
            SHAREServices.flagConsumo_zona = !SHAREServices.flagConsumo_zona;            
            chart.chartCursor.categoryBalloonDateFormat = "MM-DD JJ:NN:SS";
            chart.dataDateFormat = "MM-DD JJ:NN:SS";
            chart.dataProvider = SHAREServices.consumo_zona;
            chart.validateData();
            chart.animateAgain();
          }
        });
      }else if(parm == "a"){
        $scope.filtro_dia = false;
        $scope.filtro_semana = false;
        $scope.filtro_mes = false;        
        $scope.filtro_year = true;
        $scope.options.minMode = 'year';
        $scope.dt = "";
        $scope.DateFormat = formato.year;
        var field = {              
          "zone_id": SHAREServices.zona.id,
          "user_id": $localStorage.id_usuario,
         //token: SHAREServices.hash_decode_token($localStorage.token),
          "data": SHAREServices.diaDatepicker,
          "time": "year",
          "type": "consumption"
        };

        RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data2) {
          if(data2.code=='200'){
            SHAREServices.consumo_zona = data2.data;  
            SHAREServices.flagConsumo_zona = !SHAREServices.flagConsumo_zona;            
            chart.chartCursor.categoryBalloonDateFormat = "MM-DD JJ:NN:SS";
            chart.dataDateFormat = "MM-DD JJ:NN:SS";            
            chart.dataProvider = SHAREServices.consumo_zona;
            chart.validateData();
            chart.animateAgain();
          }
        });
      }
    }


    $scope.$watch(function(){
      return SHAREServices.flagConsumo_zona;
    },function(){    
      $scope.fecha_consulta = SHAREServices.diaDatepicker;
    }); 
         
    
    var chart = AmCharts.makeChart("grafica_consumo_zona", {
      "type": "serial",
      "theme": "light",
      "colors": [
       "#00BFDB"
      ],
      "dataProvider": $scope.datos_semana,
      "valueAxes": [ {
        "gridColor": "#FFFFFF",
        "gridAlpha": 0.2,
        "dashLength": 0
      } ],
      "gridAboveGraphs": true,
      "startDuration": 1,
      "graphs": [ {
        "balloonText": "<b>[[value]] kWh</b>",
        "fillAlphas": 0.8,
        "lineAlpha": 0.2,
        "type": "column",
        "valueField": "value"
      } ],
      "chartCursor": {
        "categoryBalloonEnabled": false,
        "cursorAlpha": 0,
        "zoomable": false
      },
      "dataDateFormat": "JJ",
      "categoryField": "time",
      "categoryAxis": {
        "gridPosition": "start",
        "gridAlpha": 0,
        "tickPosition": "start",
        "tickLength": 20
      },
      "export": {
        "enabled": true
      }
             
    })
  } 

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
    .controller('grafica_desconexiones_cCtrl', grafica_desconexiones_cCtrl);

  /** @ngInject */
  function grafica_desconexiones_cCtrl($element, $scope, SHAREServices) {
    var id = $element[0].getAttribute('id');

    $scope.$watch(function(){
       return SHAREServices.flagDesconexiones;
    }, function(newValue, oldValue){
      if(SHAREServices.desconexionxzonaxdia[0] != undefined){
        $scope.ahorro = SHAREServices.potencia_Wh; 

        var data = [
          {
            name: "Lunes",
            fromDate: "2018-01-01 08:00",
            toDate: "2018-01-01 10:00",
            color: colorSet.getIndex(0).brighten(0)
          },
          {
            name: "Martes",
            fromDate: "2018-01-01 12:00",
            toDate: "2018-01-01 15:00",
            color: colorSet.getIndex(0).brighten(0.4)
          },
          {
            name: "Miércoles",
            fromDate: "2018-01-01 15:30",
            toDate: "2018-01-01 21:30",
            color: colorSet.getIndex(0).brighten(0.8)
          },
        
          {
            name: "Jueves",
            fromDate: "2018-01-01 09:00",
            toDate: "2018-01-01 12:00",
            color: colorSet.getIndex(2).brighten(0)
          },
          {
            name: "Viernes",
            fromDate: "2018-01-01 13:00",
            toDate: "2018-01-01 17:00",
            color: colorSet.getIndex(2).brighten(0.4)
          },
        
          {
            name: "Sábado",
            fromDate: "2018-01-01 11:00",
            toDate: "2018-01-01 16:00",
            color: colorSet.getIndex(4).brighten(0)
          },
          {
            name: "Domingo",
            fromDate: "2018-01-01 16:00",
            toDate: "2018-01-01 19:00",
            color: colorSet.getIndex(4).brighten(0.4)
          }
        ];

        var chart = AmCharts.makeChart( id, {
          "type": "gantt",
          "theme": "light",
          "marginRight": 70,
          "period": "mm",
          "dataDateFormat":"DD-MM-YYYY",
          "balloonDateFormat": "JJ:NN",
          "columnWidth": 0.5,
          "valueAxis": {
            "type": "date",
            "minimum": 0,
            "maximum": 1440
          },
          "brightnessStep": 10,
          "graph": {
            "fillAlphas": 1,
            "balloonText": "Inicio: [[h_ini]] - Final:[[h_final]]"
          },
          "rotate": true,
          "categoryField": "fecha",
          "segmentsField": "segments",
          "colorField": "color",
          //"startDate": SHAREServices.diaDatepicker,
          "startDate": data,
          "startField": "start",
          "endField": "end",
          "durationField": "duration",
          "dataProvider": [{
            "fecha": data.name,
            "segments": data.fromDate,
            //"fecha": SHAREServices.diaDatepicker,
            //"segments": SHAREServices.desconexionxzonaxdia
          }],              
          "valueScrollbar": {
            "enabled": true
          },
          "chartCursor": {
            "cursorColor":"#55bb76",
            "valueBalloonsEnabled": false,
            "cursorAlpha": 0,
            "valueLineAlpha":0.5,
            "valueLineBalloonEnabled": true,
            "valueLineEnabled": true,
            "zoomable":false,
            "valueZoomable":true
          },
          "export": {
            "enabled": true
          },
          "creditsPosition": "bottom-right",
          "pathToImages": "layoutPaths.images.amChart"
        });                
      }
    });         
  }

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_dimmerCtrl', grafica_dimmerCtrl);

    /** @ngInject */
    function grafica_dimmerCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, consumptionServices, consumptionUtil, energyUtil, utilities, $timeout) {
        
        $scope.parm = "day";
        $scope.noInfo = false;
        $scope.loading = false;
        $scope.type_graph = "dimmer";
        var chart;

        $scope.DateFilter = SHAREServices.dateFilter;
        $scope.indicador = utilities.generarCodigo(20);

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFormat = consumptionServices.format.day;

        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.filtrar($scope.parm);
        }
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        /////////////////////////

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = consumptionServices.format[itm];
        };

        function setParameters(itm) {
            return {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": itm,
                "type": "dimmer",
                "offset": (new Date()).getTimezoneOffset()
            };
        };

        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = "dimmer" + " - " + SHAREServices.dispositivo_selected.nombre;
            
        }

        $scope.filtrar = function(parm) {
            $scope.parm = parm;
            consumptionServices.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            consumptionServices.day = SHAREServices.diaDatepicker.substring(0, 11);
            loading(parm);
            var field = setParameters(parm);

            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        chart.data = consumptionUtil.addLastHour(response.data, SHAREServices.diaDatepicker, parm);
                        chart.data.map(function(dt){
                            dt.tiempoFormato = $filter('date')(dt.tiempo, 'MMM d, y');
                            dt.horaFormato = $filter('date')(dt.tiempo, 'h:mm a');
                            return dt
                        })
                        
                        SHAREServices.consumo_aire = chart.data;
                        SHAREServices.flagConsumo_aire = !SHAREServices.flagConsumo_aire;
                        successfulResponse();
                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });

        }

        // $scope.$watch(function() {
        //     return SHAREServices.diaDatepicker;
        // }, function() {
        //     if (SHAREServices.dispositivo_selected.id != undefined) {
        //         $scope.filtrar($scope.parm);
        //     }
        // });


        // $scope.$watch(function() {
        //     return SHAREServices.dispositivo_selected.id;
        // }, function() {
        //     $scope.filtrar($scope.parm);
        // });

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '17') $scope.filtrar($scope.parm);
        })

        $timeout(function(){
            createGraphic()
            $scope.filtrar($scope.parm);
        });

        function createGraphic() {
            am4core.useTheme(am4themes_animated); 
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            chart.paddingRight = 20;
            am4core.options.autoDispose = true;

            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            };
            
            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";
            series.strokeWidth = 3;

            series.tooltipText = "Dimerizado: {valueY.value} %";
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.fullWidthLineX = true;
            chart.cursor.lineX.strokeWidth = 0;
            chart.cursor.lineX.fill = chart.colors.getIndex(2);
            chart.cursor.lineX.fillOpacity = 0.1;

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            chart.scrollbarX = scrollbarX;

            //chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
        }

        $scope.$on("$destroy", function () {
            chart.dispose();
        });



    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_energiaCtrl', grafica_energiaCtrl);

    /** @ngInject */
    function grafica_energiaCtrl($scope, $rootScope, SHAREServices, $localStorage, RESTServices, $filter, energyUtil, energyServices, toastr, $timeout, utilities) {

        var initial = {
            type: 'power',
            status: false,
            name: 'Potencia'
        }

        var factor_m;

        var all_formatted_data = [];
        $scope.indicador = utilities.generarCodigo(20);
        var chart;

        $scope.parm = "day";
        $scope.type_graph = "activeEnergy";
        $scope.noInfo = false;
        $scope.loading = false;
        $scope.interval = 0;
        var h = new Date();
        $scope.intelvalLimite = Math.ceil(h.getDate() / 4);
        $scope.DateFilter = SHAREServices.dateFilter;
        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFormat = energyServices.format.day;

        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.interval = 0;
            var lastday = new Date($scope.dt.getFullYear(), $scope.dt.getMonth() +1, 0).getDate();
            $scope.intelvalLimite = Math.ceil(lastday / 4);
            if(RESTServices.post_pending === false){
                $scope.filtrar($scope.parm, factor_m);
            }else {
                RESTServices.cancelarSolicitudHttp();
                $timeout(function(){
                    $scope.filtrar($scope.parm, factor_m);
                }, 100)  
            }
            //$scope.filtrar($scope.parm, factor_m);
        }
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
        

        ////////
        $scope.$on('energyGraphics', function(event, result) {
            $scope.interval = 0;
            $scope.graph_name = result.data.name;
            $scope.unit = energyUtil.unit(result.data.type);
            $scope.type_graph = result.data.type;
            factor_m = result.factor;
            if(RESTServices.post_pending === false){
                $scope.filtrar($scope.parm, result.factor);
            }else {
                RESTServices.cancelarSolicitudHttp();
                $timeout(function(){
                    $scope.filtrar($scope.parm, result.factor);
                }, 100)  
            }
            //$scope.filtrar($scope.parm, result.factor);
        });

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = energyServices.format[itm];
            if(itm === 'month' ){
                $scope.interval += 1;
            } else {
                $scope.interval = 0;
            }
        };

        function setParameters(itm, day) {
            return {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": day,
                "time": itm,
                "type": $scope.type_graph,
                "offset": (new Date()).getTimezoneOffset(),
                "interval": $scope.type_graph === 'power' &&  itm === 'month' ? $scope.interval : null,
            };
        };

        function noInfo() {
            if (chart.export.config) {
                //chart.export.config.enabled = false;
                chart.export.config.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
            } else {
                //chart.export.enabled = false;
                chart.export.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
            }
            chart.dataProvider = [];
            chart.validateData();
            chart.validateNow();
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            chart.validateData();
            chart.validateNow();
            $scope.loading = false;
            $scope.noInfo = false;

        }

        $scope.filtrar = function(parm) {
            energyServices.DataFase1 = [], energyServices.DataFase2 = [], energyServices.DataFase3 = [];
            energyServices.dataProvider = [];
            $scope.parm = parm;
            energyServices.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            energyServices.day = SHAREServices.diaDatepicker.substring(0, 11);
            loading(parm);
            var field = setParameters(parm, SHAREServices.diaDatepicker);
            var allData;
            energyServices.div = energyUtil.divider($scope.type_graph);
            if($scope.type_graph!='activeEnergy' && $scope.type_graph!='reactiveEnergy'){
                RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                    if (response.code == '200') {
                        if (response.data != undefined) {
                            switch ($scope.type_graph) {
                                case 'voltage':
                                case 'current':
                                case 'power':
                                case 'powerFactor':
                                case 'thdC':
                                case 'thdV':
                                    var validateNoData = response.data.filter(function(obj) { return obj == null });
                                    if (validateNoData.length == 3) {
                                        noInfo();
                                        return;
                                    }  
                                    response.data = energyUtil.sortData(response.data, parm, SHAREServices.diaDatepicker, $scope.type_graph);                                  
                                    energyServices.DataFase1 = response.data[0];
                                    energyServices.DataFase2 = response.data[1];
                                    energyServices.DataFase3 = response.data[2];

                                    if($scope.type_graph === 'power' && parm === 'month' && $scope.associatedFlow){ // se debe condicionar esto a solo los medidores de avanzada usados en medidores de flujo porque de lo contrario no serviria para los de avanzada actuales en otras aplicaciones
                                        energyServices.dataProvider = energyServices.DataFase1.map(function(d, i){
                                            return ({
                                                tiempo: SHAREServices.dateToLocal(d.tiempo, energyServices.DataFase1.length-1, i, false),//d.tiempo,
                                                value1: energyServices.DataFase1[i].estado,
                                                value2: energyServices.DataFase2[i].estado,
                                                value3: energyServices.DataFase3[i].estado,
                                            })
                                        });
                                    } else{
                                        
                                        energyUtil.organiceData2();
                                        if(parm !== 'month'){
                                            var lastItem = energyUtil.createLastHour(energyServices.dataProvider[energyServices.dataProvider.length - 1], $scope.type_graph,  parm, SHAREServices.diaDatepicker)
                                            energyServices.dataProvider.push(lastItem);
                                        }
                                        if(parm === 'month' && $scope.type_graph === 'voltage'){
                                            var lastItem = energyUtil.createLastHour(energyServices.dataProvider[energyServices.dataProvider.length - 1], $scope.type_graph,  parm, SHAREServices.diaDatepicker)
                                            energyServices.dataProvider.push(lastItem);
                                        }
                                        
                                        if($scope.type_graph === 'current'){
                                            energyServices.dataProvider = energyUtil.formatDataCurrency(energyServices.dataProvider);
                                        }
                                    } 
                                    
                                    break;
                                case 'frequency':
                                    var frequencydata = energyUtil.formatDataFrequency(response.data);
                                    var lastItem = energyUtil.createLastHour(frequencydata[frequencydata.length - 1], $scope.type_graph, parm, SHAREServices.diaDatepicker)
                                    frequencydata.push(lastItem);
                                    chart.chartScrollbar.graphType = 'step';
                                    energyServices.dataProvider = frequencydata;
                                break;

                            }
                            if ($scope.type_graph === 'power' && parm === 'month' && $scope.interval <= $scope.intelvalLimite){
                                if ($scope.interval === 1) {
                                    chart.dataProvider = [];
                                }
                                allData = energyUtil.formatingDate(energyServices.dataProvider);
                                allData = $scope.type_graph === 'power' || $scope.type_graph === 'current' ? energyUtil.applyFactor(allData, factor_m) : allData;

                                chart.dataProvider = chart.dataProvider.concat(allData);
                                all_formatted_data = Array.from(chart.dataProvider);
                                chart.graphs = energyUtil.graph($scope.type_graph, parm);
                                chart.chartCursor.categoryBalloonDateFormat = energyUtil.graphDataFormat(parm);
                                chart.dataDateFormat = energyUtil.graphDataFormat(parm);
                                chart.categoryAxis.minPeriod = energyUtil.graphMinPeriod(parm);
                                if (chart.export.config) {
                                    chart.export.config.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                } else {
                                    chart.export.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                }

                            } else {  
                                chart.dataProvider = energyUtil.formatingDate(energyServices.dataProvider);
                                all_formatted_data = Array.from(chart.dataProvider);
                                chart.dataProvider = $scope.type_graph === 'power' || $scope.type_graph === 'current' ? energyUtil.applyFactor(chart.dataProvider, factor_m) : chart.dataProvider;
                                chart.graphs = energyUtil.graph($scope.type_graph, parm);
                                chart.chartCursor.categoryBalloonDateFormat = energyUtil.graphDataFormat(parm);
                                chart.dataDateFormat = energyUtil.graphDataFormat(parm);
                                chart.categoryAxis.minPeriod = energyUtil.graphMinPeriod(parm);
                                if (chart.export.config) {
                                    chart.export.config.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                } else {
                                    chart.export.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                }

                            }
                            successfulResponse();
                        } else {
                            noInfo();
                        }

                    } else {
                        noInfo();
                    }
                });
            }else{
                if(parm=='day'){
                    var offset = (new Date()).getTimezoneOffset();
                    if(offset < 0){
                        var day_init = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
                        day_init.setDate(day_init.getDate() - 1);
                        day_init = $filter('date')(day_init, 'yyyy-MM-dd');
                        var day_end = SHAREServices.diaDatepicker;
                    }else{
                        var day_init = SHAREServices.diaDatepicker;
                        var day_end = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
                        day_end.setDate(day_end.getDate() + 1);
                        day_end = $filter('date')(day_end, 'yyyy-MM-dd');
                    }
                    var field = setParameters(parm,day_init);
                    RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                        if (response.code == '200') {
                            if (response.data != undefined) {
                                response.data = energyUtil.sortData(response.data, parm, SHAREServices.diaDatepicker, $scope.type_graph);
                                
                                chart.chartScrollbar.graphType = 'column';
                                energyServices.dataProvider = response.data;
    
                                field = setParameters(parm,day_end);
                                RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response2) {
                                    if (response2.code == '200') {
                                        if (response2.data != undefined) {
                                            response2.data = energyUtil.sortData(response2.data, parm, SHAREServices.diaDatepicker, $scope.type_graph);
                                            
                                            chart.chartScrollbar.graphType = 'column';
                                            energyServices.dataProvider = energyServices.dataProvider.concat(response2.data);
                                            var div = energyServices.dataProvider[0].time ? 60 : 15;
                                            if (!energyServices.dataProvider[0].time) energyServices.dataProvider = energyUtil.addDataFiveteen(energyServices.dataProvider);
                                            chart.dataProvider = energyUtil.changeToLocal(energyServices.dataProvider, div, 'day');
                                            chart.dataProvider = energyUtil.filterDate(chart.dataProvider, SHAREServices.diaDatepicker, parm);
                                            all_formatted_data = Array.from(chart.dataProvider);
                                            chart.graphs = energyUtil.graph($scope.type_graph, parm);
                                            chart.chartCursor.categoryBalloonDateFormat = energyUtil.graphDataFormat(parm);
                                            chart.dataDateFormat = energyUtil.graphDataFormat(parm);
                                            chart.categoryAxis.minPeriod = energyUtil.graphMinPeriod(parm);
                                            if (chart.export.config) {
                                                chart.export.config.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                            } else {
                                                chart.export.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                            }
                                            successfulResponse();
                                            
                                        } 
                                        else {
                                            chart.chartScrollbar.graphType = 'column';
                                            var div = energyServices.dataProvider[0].time ? 60 : 15;
                                            if (!energyServices.dataProvider[0].time) energyServices.dataProvider = energyUtil.addDataFiveteen(energyServices.dataProvider);
                                            chart.dataProvider = energyUtil.changeToLocal(energyServices.dataProvider, div, 'day');
                                            chart.dataProvider = energyUtil.filterDate(chart.dataProvider, SHAREServices.diaDatepicker, parm);
                                            all_formatted_data = Array.from(chart.dataProvider);
                                            chart.graphs = energyUtil.graph($scope.type_graph, parm);
                                            chart.chartCursor.categoryBalloonDateFormat = energyUtil.graphDataFormat(parm);
                                            chart.dataDateFormat = energyUtil.graphDataFormat(parm);
                                            chart.categoryAxis.minPeriod = energyUtil.graphMinPeriod(parm);
                                            if (chart.export.config) {
                                                chart.export.config.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                            } else {
                                                chart.export.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                            }
                                            successfulResponse();
                                        }
                                    }
                                });
                            }else {
                                noInfo();
                            }
                        } else {
                            noInfo();
                        }
                    }); 
                }else{ //Por revisar
                    field = setParameters(parm,SHAREServices.diaDatepicker);
                    RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response2) {
                        if (response2.code == '200') {
                            if (response2.data != undefined) {
                                response2.data = energyUtil.sortData(response2.data, parm, SHAREServices.diaDatepicker, $scope.type_graph);
                                chart.chartScrollbar.graphType = 'column';
                                energyServices.dataProvider = response2.data;
                                var div = energyServices.dataProvider[0].time ? 60 : 15;
                                if (!energyServices.dataProvider[0].time) energyServices.dataProvider = energyUtil.addDataFiveteen(energyServices.dataProvider);
                                chart.dataProvider = energyUtil.changeToLocal(energyServices.dataProvider, div, 'month');
                                chart.dataProvider = energyUtil.filterDate(chart.dataProvider, SHAREServices.diaDatepicker, parm);
                                all_formatted_data = Array.from(chart.dataProvider);
                                chart.graphs = energyUtil.graph($scope.type_graph, parm);
                                chart.chartCursor.categoryBalloonDateFormat = energyUtil.graphDataFormat(parm);
                                chart.dataDateFormat = energyUtil.graphDataFormat(parm);
                                chart.categoryAxis.minPeriod = energyUtil.graphMinPeriod(parm);
                                if (chart.export.config) {
                                    chart.export.config.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                } else {
                                    chart.export.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
                                }
                                successfulResponse();
                                 
                            }else {
                                noInfo();
                            }
                        }else {
                            noInfo();
                        }
                    });
                }
                  
                     
                    
            }

        }

        //$rootScope.$broadcast('energyGraphics', { data: initial });

       
        // consultar Medidores Flujo
        $timeout(function() {
            var field = {
                "id_dispositivo": SHAREServices.dispositivo_selected.id,
                "id_usuario": $localStorage.id_usuario,
            };
            RESTServices.post_header('cliente/consulta_asociadoaflujo.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    $scope.associatedFlow = true;
                }   
            })
            chart = AmCharts.makeChart($scope.indicador, {
                "type": "serial",
                "theme": "light",
                "colors": [
                    "#A47DFD",
                    "#FFA622",
                    "#07CCB6"
                ],
                "dataProvider": '',
                "categoryField": "tiempo",
                "valueAxes": [{
                    "gridColor": "#FFFFFF",
                    "gridAlpha": 0.2,
                    "dashLength": 0,
                    "axisAlpha": 0.1,
                    "tickLength": 0,
                    //"baseValue": 0,
                    //"minimum": 0,
                    //"strictMinMax": true,
                }],
                "gridAboveGraphs": false,
                "startDuration": 1,
                "graphs": [],
                "chartCursor": {
                    "categoryBalloonEnabled": false,
                    "categoryBalloonDateFormat": 'MMM DD',
                    "cursorAlpha": 0,
                    "zoomable": true
                },
                "chartScrollbar": {
                    "graph": "grafica_1",
                    "oppositeAxis": false,
                    "offset": 30,
                    "scrollbarHeight": 40,
                    "backgroundAlpha": 0,
                    "selectedBackgroundAlpha": 0.1,
                    "selectedBackgroundColor": "#888888",
                    "graphFillAlpha": 0,
                    "graphLineAlpha": 0.5,
                    "selectedGraphFillAlpha": 0,
                    "selectedGraphLineAlpha": 1,
                    "autoGridCount": true,
                    "color": "#AAAAAA"
                },
                "dataDateFormat": 'MMM DD',
                "categoryAxis": {
                    "gridPosition": "start",
                    "gridAlpha": 0,
                    "tickPosition": "start",
                    "tickLength": 20,
                    "axisAlpha": 0.1,
                    "parseDates": true
    
                },
                "export": {
                    "enabled": true,
                    "fileName": "Helo",
                },
                "legend": {
                    "useGraphSettings": true
                },
                "zoomControl": {
                    "zoomControlEnabled": true,
                    "panControlEnabled": true
                },
    
            });
    
    
    
    
    
    
            
           // var chart = energyServices.chart;
            chart.legend.clickMarker = energyUtil.handleLegendClick;
            chart.legend.clickLabel = energyUtil.handleLegendClick;
            // if (chart.export.config) {
            //     chart.export.config.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
            // } else {
            //     chart.export.fileName = $scope.graph_name + ' - ' + SHAREServices.dispositivo_selected.nombre;
            // }

        });


        $scope.$on('energyFactor', function(event, result) {
            var new_factor = {
                id:'62',
                valor: result.factor,
            }
            result.device.caracteristicas.push(new_factor);

            var dispositivo = {
                "id_device": result.device.id_device,
                "nombre": result.device.nombre,
                "id_zona": result.device.id_zona,
                "caracteristicas": result.device.caracteristicas
            }
            var params = {
                dispositivo: JSON.stringify(dispositivo),
                id_usuario: $localStorage.id_usuario,
                //token: SHAREServices.hash_decode_token($localStorage.token)
            };
            RESTServices.post_header('cliente/edita_dispositivo.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                $scope.loading = true;
                if (data != null) {
                    if (data.code == '200') {
                        chart.dataProvider = energyUtil.applyFactor(all_formatted_data, result.factor);
                        chart.validateData();
                        $scope.loading = false;
                        toastr.success('Se ha cambiado el factor exitosamente', 'Factor multiplicador');
                    } else {
                        toastr.error('No se puede conectar en este momento', 'Error');
                    }
                } else {
                    toastr.error('No se puede conectar en este momento', 'Error');
                }
            });
        });

        $scope.$on("$destroy", function () {
            chart.clear();
            RESTServices.cancelarSolicitudHttp();
        });

        

    }

})();
(function() {
    'use strict';
    angular.module('BlurAdmin').factory('energyUtil', function(energyServices, SHAREServices, $filter) {
        return {
            unit: function(type) {
                switch (type) {
                    case 'voltage':
                        return 'V';
                        break;
                    case 'current':
                        return 'A';
                        break;
                    case 'power':
                        return 'W';
                        break;
                    case 'activeEnergy':
                        return 'KWh';
                        break;
                    case 'reactiveEnergy':
                        return 'KVArh';
                        break;
                    case 'frequency':
                        return 'Hz';
                        break;
                    case 'powerFactor':
                    case 'thd':
                        return '%';
                        break;
                }
            },

            divider: function(type) {
                switch (type) {
                    case 'frequency':
                    case 'activeEnergy':
                    case 'reactiveEnergy':
                        return 100;
                    case 'current':
                        return 1000;
                    default:
                        return 1;
                }
            },

            graph: function(type, param) {
                switch (type) {
                    case 'voltage':
                    case 'current':
                    case 'power':
                    case 'powerFactor':
                    case 'thdC':
                    case 'thdV':
                        var fase1 = {},
                            fase2 = {},
                            fase3 = {};

                        if (param == "day") fase1.balloonText = '<strong>Fecha:</strong> [[horaFormato]] <br> <strong>Fase 1: </strong> [[value]]';
                        else fase1.balloonText = '<strong>Fecha:</strong> [[tiempoFormato]] <br> <strong>Fase 1: </strong> [[value]]';
                        fase1.id = 'grafica_1';
                        fase1.title = 'Fase 1';
                        fase1.type = 'step';
                        fase1.valueField = 'value1';
                        fase1.fillAlphas = 0;
                        fase1.lineAlpha = 1;
                        fase1.lineThickness = 3;

                        if (param == "day") fase2.balloonText = '<strong>Fecha: </strong>[[horaFormato]] <br> <strong>Fase 2:</strong>[[value]]';
                        else fase2.balloonText = '<strong>Fecha: </strong>[[tiempoFormato]] <br> <strong>Fase 2: </strong> [[value]]';
                        fase2.id = 'grafica_2';
                        fase2.title = 'Fase 2';
                        fase2.type = 'step';
                        fase2.valueField = 'value2';
                        fase2.fillAlphas = 0;
                        fase2.lineAlpha = 1;
                        fase2.lineThickness = 3;

                        if (param == "day") fase3.balloonText = '<strong>Fecha:</strong> [[horaFormato]] <br> <strong>Fase 3:</strong> [[value]]';
                        else fase3.balloonText = '<strong>Fecha:</strong> [[tiempoFormato]] <br> <strong>Fase 3: </strong> [[value]]';
                        fase3.id = 'grafica_3';
                        fase3.title = 'Fase 3';
                        fase3.type = 'step';
                        fase3.valueField = 'value3';
                        fase3.fillAlphas = 0;
                        fase3.lineAlpha = 1;
                        fase3.lineThickness = 3;

                        var parmGraph = [
                            fase1, fase2, fase3
                        ];

                        return parmGraph;
                        break;

                    case 'activeEnergy':
                    case 'reactiveEnergy':
                    case 'frequency':
                        var graphs = {};

                        if (param == "day") graphs.balloonText = '<strong>Fecha:</strong> [[horaFormato]] <br> <strong>Valor:</strong> [[estado]]';
                        else graphs.balloonText = '<strong>Fecha:</strong> [[tiempoFormato]] [[horaFormato]]<br> <strong>Valor:</strong> [[value]]';
                        graphs.id = 'grafica_1';
                        graphs.title = 'Valor';
                        graphs.type = type == 'activeEnergy' || type == 'reactiveEnergy' ? 'column' : 'step';
                        graphs.valueField = 'estado';
                        graphs.fillAlphas = 0;
                        graphs.lineAlpha = 1;
                        graphs.lineThickness = 3;

                        var parmGraph = [
                            graphs
                        ];

                        return parmGraph;
                        break;
                }
            },

            graphDataFormat: function(type) {
                return 'YYYY-MM-DD JJ:NN:SS';
                /*switch (type) {
                    case 'day':
                        return 'YYYY-MM-DD JJ:NN:SS';
                        break;
                    case 'week':
                        return 'YYYY-MM-DD JJ:NN:SS';
                        break;
                    case 'month':
                        return 'YYYY-MM-DD JJ:NN:SS';
                        break;
                    case 'year':
                        return 'YYYY-MM-DD JJ:NN:SS';
                        break;
                }*/
            },
            graphMinPeriod: function(type) {
                switch (type) {
                    case 'day':
                        return 'ss';
                        break;
                    case 'week':
                        return 'ss';
                        break;
                    case 'month':
                        return 'ss';
                        break;
                    case 'year':
                        return 'ss';
                        break;
                }
            },

            getMonday: function(date) {
                var day = date.getDay() || 7;
                if (day !== 1)
                    date.setHours(-24 * (day - 1));
                return date;
            },

            manageData2: function(data, fase) {
                data.map(function(dt, i){
                    dt.tiempo = SHAREServices.dateToLocal(dt.tiempo,data.length,i,false);
                    dt.tiempo = $filter('date')(dt.tiempo, 'yyyy-MM-dd HH:mm:ss');
                    dt['value' + fase] = dt.estado; 
                    delete dt.estado;
                    return dt
                })

                return data;
            },



            organiceData2: function(){

                var mc_data = [];
                energyServices.dataProvider = [];
                var dataTotalMap = new Map();

                // Llamada a manageData2 para cada fase
                energyServices.DataFase1 = this.manageData2(energyServices.DataFase1, 1);
                energyServices.DataFase2 = this.manageData2(energyServices.DataFase2, 2);
                energyServices.DataFase3 = this.manageData2(energyServices.DataFase3, 3);

                energyServices.DataFase1.sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });
                energyServices.DataFase2.sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });
                energyServices.DataFase3.sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });

                // Función para crear objetos de datos
                function createDataObject(tiempo, value1, value2, value3) {
                    return {
                        tiempo: tiempo,
                        value1: value1 !== undefined ? value1 : null,
                        value2: value2 !== undefined ? value2 : null,
                        value3: value3 !== undefined ? value3 : null,
                    };
                }

                // Función para agregar datos al mapa
                function addToDataTotalMap(data) {
                    data.forEach(function(d) {
                        if (dataTotalMap.has(d.tiempo)) {
                            var existing = dataTotalMap.get(d.tiempo);
                            dataTotalMap.set(d.tiempo, createDataObject(
                                d.tiempo,
                                d.value1 !== undefined ? d.value1 : existing.value1,
                                d.value2 !== undefined ? d.value2 : existing.value2,
                                d.value3 !== undefined ? d.value3 : existing.value3
                            ));
                        } else {
                            dataTotalMap.set(d.tiempo, createDataObject(d.tiempo, d.value1, d.value2, d.value3));
                        }
                    });
                }

                // Agregar datos de cada fase al mapa
                addToDataTotalMap(energyServices.DataFase1);
                addToDataTotalMap(energyServices.DataFase2);
                addToDataTotalMap(energyServices.DataFase3);

                // Convertir el mapa a un array y asignarlo a dataProvider
                mc_data = Array.from(dataTotalMap.values());
                // Ordenar los datos por tiempo
                mc_data.sort(function (a, b) {
                    if (a.tiempo > b.tiempo) {
                        return 1;
                    }
                    if (a.tiempo < b.tiempo) {
                        return -1;
                    }
                    return 0;
                });
                mc_data = mc_data.map(function(d, i, arr) {
                    if (i > 0) {
                        d.value1 = d.value1 !== null ? d.value1 : arr[i - 1].value1;
                        d.value2 = d.value2 !== null ? d.value2 : arr[i - 1].value2;
                        d.value3 = d.value3 !== null ? d.value3 : arr[i - 1].value3;
                    }
                    return d;
                });

                energyServices.dataProvider = mc_data;
                //return energyServices.dataProvider;
            },

            organiceData: function() {
                this.manageData(1, 2);
                this.manageData(2, 1);
                this.manageData(3, 1);
                this.manageData(1, 3);
                this.manageData(3, 2);

                energyServices.DataFase1.sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });
                energyServices.DataFase2.sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });
                energyServices.DataFase3.sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });
                energyServices.dataProvider = [];
                for (var i = 0; i < energyServices.DataFase1.length; i++) {
                    energyServices.dataProvider[i] = {};
                    energyServices.dataProvider[i].tiempo = energyServices.DataFase1[i].tiempo;
                    energyServices.dataProvider[i].value1 = energyServices.DataFase1[i].estado;
                    energyServices.dataProvider[i].value2 = energyServices.DataFase2[i].estado;
                    energyServices.dataProvider[i].value3 = energyServices.DataFase3[i].estado;
                }
            },

            manageData: function(in1, in2) {
                var array1 = [];
                var array2 = [];
                switch (in1) {
                    case 1:
                        array1 = energyServices.DataFase1;
                        if (in2 == 2) array2 = energyServices.DataFase2;
                        else array2 = energyServices.DataFase3;
                        break;
                    case 2:
                        array1 = energyServices.DataFase2;
                        if (in2 == 1) array2 = energyServices.DataFase1;
                        else array2 = energyServices.DataFase3;
                        break;
                    case 3:
                        array1 = energyServices.DataFase3;
                        if (in2 == 2) array2 = energyServices.DataFase2;
                        else array2 = energyServices.DataFase1;
                        break;
                }
                array1.forEach(function(element) {
                    if (!Object.keys(array2).some(function(k) { return ((new Date(array2[k].tiempo)).getTime() === (new Date(element.tiempo)).getTime())})) {
                        var data_aux = array2.filter(function(x) { return ((new Date(x.tiempo)).getTime() < (new Date(element.tiempo)).getTime())});                       
                        var index = data_aux.length === 0 ? -1 : (data_aux.length - 1) ;
                        data_aux = index == -1 ? {"tiempo": element.tiempo, "estado":0} : data_aux[index];
                        switch (in2) {
                            case 1:
                                energyServices.DataFase1[energyServices.DataFase1.length] = {};
                                energyServices.DataFase1[energyServices.DataFase1.length - 1].tiempo = element.tiempo;
                                energyServices.DataFase1[energyServices.DataFase1.length - 1].estado = data_aux.estado;
                                break;
                            case 2:
                                energyServices.DataFase2[energyServices.DataFase2.length] = {};
                                energyServices.DataFase2[energyServices.DataFase2.length - 1].tiempo = element.tiempo;
                                energyServices.DataFase2[energyServices.DataFase2.length - 1].estado = data_aux.estado;
                                break;
                            case 3:
                                energyServices.DataFase3[energyServices.DataFase3.length] = {};
                                energyServices.DataFase3[energyServices.DataFase3.length - 1].tiempo = element.tiempo;
                                energyServices.DataFase3[energyServices.DataFase3.length - 1].estado = data_aux.estado;
                                break;
                        }
                    }

                });


            },

            setTiempo: function(parm, date, type, last) {
                //var index = data.length;
                switch (parm) {
                    case 'day':
                        if (last) {
                            if (date < $filter('date')(new Date(), 'yyyy-MM-dd')) {
                                return date + ' 23:59:59';
                            } else {
                                return $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                            }
                        } else {
                            return date + ' 00:00:00';
                        }
                        break;
                    case 'week':
                        var lunes = this.getMonday(new Date($filter('date')(date, 'yyyy/MM/dd')));
                        if (last) {
                            if ($filter('date')(lunes, 'yyyy-MM-dd') < $filter('date')(this.getMonday(new Date()), 'yyyy-MM-dd')) {
                                return $filter('date')(lunes.setDate(lunes.getDate() + 6), 'MM-dd') + ' 23:59:59';
                            } else {
                                return $filter('date')(new Date(), 'MM-dd HH:mm:ss');
                            }
                        } else {
                            return ($filter('date')(lunes, 'MM-dd') + ' 00:00:00');
                        }
                        break;
                    case 'month':
                        if (last) {
                            if (type === 'activeEnergy' && type === 'reactiveEnergy' && type === 'frequency') {
                                if (date.substring(0, 7) < $filter('date')(new Date(), 'yyyy-MM')) {
                                    return $filter('date')(new Date(date.substring(0, 4), parseInt(date.substring(5, 7)), 0), 'yyyy-MM-dd') + ' 23:59:59';
                                } else {
                                    return $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                                }
                            } else {
                                    return $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                            }
                        } else {
                            return (date.substring(0, 7) + '-01 00:00:00');
                        }
                        break;
                    case 'year':
                        if (last) {
                            if (date.substring(0, 4) < $filter('date')(new Date(), 'yyyy')) {
                                return '12-31 23:59:59';
                            } else {
                                return $filter('date')(new Date(), 'MM-dd HH:mm:ss');
                            }
                        } else {
                            return '01-01 00:00:00';
                        }
                        break;
                }
            },

            sortData: function(response, parm, date, type) {
                if (Array.isArray(response[0]) || Array.isArray(response[1]) || Array.isArray(response[2])) {
                    var tiempo_aux = this.setTiempo(parm, date, type, false);
                    response = response.map(function(d,ind) {
                        if (d == null) {
                            return ([{
                                tiempo: tiempo_aux,
                                estado: '0'
                            }])
                        } else {
                            return d;
                        }
                    })
                    return response
                } else {
                    return response;
                }
            },

            ordenarPorFecha: function(arr) {
                arr.sort(function(a, b) {
                    var dateA = new Date(a.tiempo);
                    var dateB = new Date(b.tiempo);
                    return dateA - dateB;
                });
                return arr;
            },

            addLastHour: function(array, date, parm, type) {
                var all_f = [];
                if (Array.isArray(array[0]) || Array.isArray(array[1]) || Array.isArray(array[2])) {
                    var a_1 = this.ordenarPorFecha(Array.from(array[0]));
                    var a_2 = this.ordenarPorFecha(Array.from(array[1]));
                    var a_3 = this.ordenarPorFecha(Array.from(array[2]));
                    all_f.push(a_1, a_2, a_3);
                }
                var setParam = this.setTiempo(parm, date, type, true);
                switch (type) {
                    case 'voltage':
                    case 'current':
                    case 'power':
                    case 'powerFactor':
                    case 'thdC':
                    case 'thdV':
                        var withHour = all_f.map(function(obj, index) {
                            if (parm == 'month') {
                                var i = obj.length;
                                //if (date.substring(0, 5) + obj[i - 1].tiempo.substring(0, 2) < $filter('date')(new Date(), 'yyyy-MM')) {
                                if (date.substring(0, 5) + obj[i - 1].tiempo.substring(5, 7) < $filter('date')(new Date(), 'yyyy-MM')) {

                                    var auxMonth = {
                                        tiempo: $filter('date')(new Date(date.substring(0, 4), parseInt(obj[i - 1].tiempo.substring(5, 7)), 0), 'yyyy-MM-dd') + ' 23:59:59',
                                        estado: obj[i - 1].estado,
                                        tipo: obj[i - 1].tipo,
                                    }
                                } else {
                                    var auxMonth = {
                                        tiempo: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                                        estado: obj[i - 1].estado,
                                        tipo: obj[i - 1].tipo
                                    }
                                }
                                array[index].push(auxMonth);
                                array[index] = array[index].map(function(d) {
                                    return ({
                                        tiempo: d.tiempo,
                                        estado: d.estado / energyServices.div
                                    })
                                })
                                return array[index];

                            }
                            var i = obj.length;
                            var aux = {
                                tiempo: setParam,
                                estado: obj[i - 1].estado,
                                tipo: obj[i - 1].tipo,
                            };

                            array[index].push(aux);
                            array[index] = array[index].map(function(d) {
                                //d.tiempo = SHAREServices.dateToLocal(d.tiempo, all_f.length-1, index, false);
                                //d.tiempo = $filter('date')(d.tiempo, 'yyyy-MM-dd HH:mm:ss');
                                return ({
                                    tiempo: d.tiempo,
                                    estado: d.estado / energyServices.div
                                })
                            })
                            return array[index];

                        })

                        return withHour;

                        break;
                    case 'activeEnergy':
                    case 'reactiveEnergy':
                        /*switch (parm) {
                            case 'day':
                                setParam = setParam;
                                break;
                            case 'week':
                                setParam = date + ' ' + setParam;
                                break;
                            case 'month':
                                setParam = setParam;
                                break;
                            case 'year':
                                setParam = date + ' ' + setParam;
                                break;
                        }*/

                    case 'frequency':
                        var i = array.length;
                        array = this.ordenarPorFecha(array);
                        var aux = {
                            tiempo: setParam,
                            estado: array[i - 1].estado,
                            tipo: array[i - 1].tipo,
                        };
                        array.push(aux);
                        if (type != 'frequency' && parm != 'day') array.pop();
                        array = array.map(function(d) {
                            if (type == 'frequency') {
                                return ({
                                    tiempo: d.tiempo,
                                    estado: d.estado / energyServices.div
                                })
                            } else {
                                return ({
                                    tiempo: d.tiempo.substring(0, 14) + '00:00',
                                    estado: d.estado / energyServices.div
                                })
                            }

                        })
                        return array;
                }
            },

            createLastHour: function(lastItem, type, parm, date) {
                var setParam = this.setTiempo(parm, date, type, true);
                switch (type) {
                    case 'voltage':
                    case 'current':
                    case 'power':
                    case 'powerFactor':
                    case 'thdC':
                    case 'thdV':
                        return ({
                            //horaFormato: $filter('date')(new Date(setParam), 'h:mm a'),
                            tiempo: setParam,
                            //tiempoFormato: $filter('date')(new Date(setParam), 'MMM d, y'),
                            value1: lastItem.value1,
                            value2: lastItem.value2,
                            value3: lastItem.value3,
                        })
                    break;
                    case 'frequency':
                        return ({
                            tiempo: setParam,
                            estado: lastItem.estado,
                        })
                    break;
                }
            },

            formatDataFrequency: function(data){
                var all_data = data.map(function(d){
                    return ({
                        tiempo: d.tiempo,
                        estado: d.estado / energyServices.div
                    })
                })
                return all_data;
            },
            formatDataCurrency: function(data){
                var all_data = data.map(function(d){
                    return ({
                            horaFormato: d.horaFormato,
                            tiempo: d.tiempo,
                            tiempoFormato: d.tiempoFormato,
                            value1: d.value1 / energyServices.div,
                            value2: d.value2 / energyServices.div,
                            value3: d.value3 / energyServices.div,
                    })
                })
                return all_data;
            },

            formatingDate: function(date) {
                var d;
                var ftdate = date.map(function(dt) {
                    d = new Date(dt.tiempo.replace(/-/g, '\/'));
                    dt.tiempoFormato = $filter('date')(d, 'MMM d, y');
                    dt.horaFormato = $filter('date')(d, 'h:mm a');
                    return dt
                });

                return ftdate;
            },

            formatingDate2: function(date) {
                var d;
                var ftdate = date.map(function(dt) {
                    d = new Date(dt.tiempo.replace(/-/g, '\/'));
                    dt.tiempoFormato = $filter('date')(d, 'MMM d, y');
                    dt.horaFormato = $filter('date')(d, 'h:mm a');
                    dt.tiempo = d;
                    return dt
                });

                return ftdate;
            },

            changeToLocal: function(array, ind, category) {
                var m = ind === 60 ? '00': 'mm'
                var d;
                var ftdate = array.map(function(dt) {
                    if (category === 'day') d = new Date(dt.tiempo.replace(' ', 'T')+'Z');
                    else d = new Date(dt.tiempo);
                    dt.tiempoFormato = $filter('date')(d, 'MMM d, y');
                    dt.horaFormato = $filter('date')(d, 'h:' + m + ' ' + 'a');
                    dt.tiempo = $filter('date')(d, 'yyyy-MM-dd HH:mm:ss');
                    dt.estado = dt.estado / energyServices.div;
                    dt.year = $filter('date')(d, 'yyyy');
                    dt.month = $filter('date')(d, 'MM');
                    dt.day = $filter('date')(d, 'dd');
                    dt.time = $filter('date')(d, 'HH:mm');
                    return dt
                });



                return ftdate;
            },

            handleLegendClick: function(graph) {
                var chart = graph.chart;
                var index = chart.graphs.findIndex(function(i) { return i.id == graph.id });
                if (chart.graphs[index].hidden) {
                    chart.showGraph(chart.graphs[index]);
                } else {
                    chart.hideGraph(chart.graphs[index]);
                }
            },

            applyFactor: function(data, factor) {
                if (factor === 1 ) {
                    return data
                } else {
                    var new_data = data.map(function(d) {
                        return ({
                            value1: d.value1 * factor,
                            value2: d.value2 * factor,
                            value3: d.value3 * factor,
                            tiempo: d.tiempo,
                            horaFormato: d.horaFormato,
                            tiempoFormato: d.tiempoFormato,
                        })
                    })
                    return new_data;
                }
            },

            addDataFiveteen: function(data) {
                var formated = [];

                //NUEVA SOLUCION CAMBIANDO MARCA TEMPORAL
                data.forEach(function(d, index, array) {
                    if(d.estado === 0 && index>0) {
                        if(parseInt((Date.parse(d.tiempo)-Date.parse(formated[formated.length-1].tiempo))/(1000*60*15)) > 1){
                            var last_time = Date.parse(formated[formated.length-1].tiempo);
                            var values = parseInt((Date.parse(d.tiempo)-last_time)/(1000*60*15));
                            for(var i = 0; i < values; i++) {
                                var tiempo_aux = $filter('date')((new Date(last_time+1000*60*15*(i + 1))), 'yyyy-MM-dd HH:mm:ss');
                                var n = {
                                    estado: 0, 
                                    tiempo: tiempo_aux,
                                    tipo: d.tipo
                                }
                                formated.push(n); 
                            }
                        }else{
                            formated.push(d);
                            for(var i = 0; i < 3; i++) {
                                var tiempo_aux = $filter('date')((new Date(Date.parse(d.tiempo)+1000*60*15*(i + 1))), 'yyyy-MM-dd HH:mm:ss');
                                var n = {
                                    estado: 0,
                                    tiempo: tiempo_aux,
                                    tipo: d.tipo
                                }
                                formated.push(n); 
                            }
                        }
                        
                    }else if((index>0) && parseInt((Date.parse(d.tiempo)-Date.parse(formated[formated.length-1].tiempo))/(1000*60*15)) > 1){ //Validando si se tienen lecturas espaciadas en intervalos mayores a 15min
                        var last_time = Date.parse(formated[formated.length-1].tiempo);
                        var values = parseInt((Date.parse(d.tiempo)-last_time)/(1000*60*15));
                     
                        
                        for(var i = 0; i < values; i++) {
                            var tiempo_aux = $filter('date')((new Date(last_time+1000*60*15*(i + 1))), 'yyyy-MM-dd HH:mm:ss');
                            var n = {
                                estado: (i==values-1) ? d.estado : 0, // Ajustando visualizacion de energia analizando comportamiento
                                tiempo: tiempo_aux,
                                tipo: d.tipo
                            }
                            formated.push(n); 
                        }
                        
                        
                    }else{
                        if(formated.length>1){
                            var tiempo_aux = $filter('date')((new Date(Date.parse(formated[formated.length-1].tiempo)+1000*60*15)), 'yyyy-MM-dd HH:mm:ss');              
                            var n = {
                                    estado: d.estado, // Ajustando visualizacion de energia analizando comportamiento
                                    tiempo: tiempo_aux,
                                    tipo: d.tipo
                                }
                            formated.push(n);
                        }else{
                            var tiempo_aux = $filter('date')(new Date(d.tiempo), 'yyyy-MM-dd HH');
                                var n = {
                                    estado: d.estado,
                                    tiempo: tiempo_aux + ':00:00',
                                    tipo: d.tipo
                                }
                                formated.push(n);
                        }
                        
                    }
                })
                return this.deleteDuplicates(formated);
                //return formated;

            },

            deleteDuplicates: function(data){
                var array = Array.from(data);
                array.forEach(function(d, index){
                    if (index + 1 < array.length) {
                        var t_1 = new Date(d.tiempo);
                        var t_2 = new Date(array[index + 1].tiempo);
                        t_1 = t_1.getTime();
                        t_2 = t_2.getTime();
                        if(t_1 === t_2) {
                            if(array[index + 1].estado === 0){
                                array.splice(index + 1, 1);
                            }
                        }  
                    } 
                })
                return this.filterPeaks(array);
            },

            filterPeaks: function(data){
                var array = Array.from(data);
                array.forEach(function(d, index){
                    if (index + 2 < array.length) {
                        var v_1 = d.estado;
                        var v_2 = array[index + 1].estado;
                        var v_3 = array[index + 2].estado;
                        if((v_1 === 0) && (v_2 > 0)){
                            if(v_3 > 0){
                                if( ((v_2-v_3)/v_2) >0.8 ){
                                    array[index + 1].estado = v_3*1.2;
                                }else array[index + 1].estado = v_2/2;
                            }else{
                                if(index + 3 < array.length){
                                    v_3 = array[index + 3].estado;
                                    if(v_3>0){
                                        if( ((v_2-v_3)/v_2) >0.8 ){
                                            array[index + 1].estado = v_3*1.2;
                                        }
                                    }else{
                                        if(index + 4 < array.length){
                                            v_3 = array[index + 4].estado;
                                            if(v_3>0){
                                                if( (((v_2-v_3)/v_2) >0.8) ){
                                                    array[index + 1].estado = v_3*1.2;
                                                }
                                            }else if(v_2>5000 && ((index+40) < array.length)){
                                                for (i=0;i<40;i++){
                                                    var factor = 1;
                                                    switch(i%8){
                                                        case 0:
                                                            factor = 1.2;
                                                            break;
                                                        case 1:
                                                            factor = 1.05;
                                                            break;
                                                        case 2:
                                                            factor = 0.8;
                                                            break;
                                                        case 3:
                                                            factor = 0.95;
                                                            break;
                                                        case 4:
                                                            factor = 0.75;
                                                            break;
                                                        case 5:
                                                            factor = 1.15;
                                                            break;
                                                        case 6:
                                                            factor = 0.9;
                                                            break;
                                                        case 7:
                                                            factor = 1.25;
                                                            break;
                                                    }
                                                    array[index+i+1].estado = (v_2/40)*factor;
                                                }
                                            }
                                        } 
                                    }   
                                }         
                            }    
                        }  
                    } 
                })
                return array;
            },

            filterDate: function(data, date, ind) {
                var filtered = [];
                if (ind === 'day') {
                    var ref = new Date(date + ' ' + '00:00:00').getDate();
                } else {
                    var ref = new Date(date + ' ' + '00:00:00').getMonth();
                }
                data.forEach(function(d){
                    var comp = ind === 'day' ? new Date(d.tiempo).getDate() : new Date(d.tiempo).getMonth()
                    if(comp === ref) {
                        filtered.push(d)
                    }
                })
                return filtered;
            }




        }
    })
})();
(function() {
    'use strict';
    angular.module('BlurAdmin').service('energyServices', energyServices);

    function energyServices() {
        return {
            chart: AmCharts.makeChart('grafica_energia', {
                "type": "serial",
                "theme": "light",
                "colors": [
                    "#A47DFD",
                    "#FFA622",
                    "#07CCB6"
                ],
                "dataProvider": '',
                "categoryField": "tiempo",
                "valueAxes": [{
                    "gridColor": "#FFFFFF",
                    "gridAlpha": 0.2,
                    "dashLength": 0,
                    "axisAlpha": 0.1,
                    "tickLength": 0,
                    //"baseValue": 0,
                    //"minimum": 0,
                    //"strictMinMax": true,
                }],
                "gridAboveGraphs": false,
                "startDuration": 1,
                "graphs": [],
                "chartCursor": {
                    "categoryBalloonEnabled": false,
                    "categoryBalloonDateFormat": 'MMM DD',
                    "cursorAlpha": 0,
                    "zoomable": true
                },
                "chartScrollbar": {
                    "graph": "grafica_1",
                    "oppositeAxis": false,
                    "offset": 30,
                    "scrollbarHeight": 40,
                    "backgroundAlpha": 0,
                    "selectedBackgroundAlpha": 0.1,
                    "selectedBackgroundColor": "#888888",
                    "graphFillAlpha": 0,
                    "graphLineAlpha": 0.5,
                    "selectedGraphFillAlpha": 0,
                    "selectedGraphLineAlpha": 1,
                    "autoGridCount": true,
                    "color": "#AAAAAA"
                },
                "dataDateFormat": 'MMM DD',
                "categoryAxis": {
                    "gridPosition": "start",
                    "gridAlpha": 0,
                    "tickPosition": "start",
                    "tickLength": 20,
                    "axisAlpha": 0.1,
                    "parseDates": true

                },
                "export": {
                    "enabled": true,
                    "fileName": "Helo",
                },
                "legend": {
                    "useGraphSettings": true
                },
                "zoomControl": {
                    "zoomControlEnabled": true,
                    "panControlEnabled": true
                },

            }),

            format: {
                day: 'yyyy-MM-dd',
                week: 'yyyy-MM-dd',
                month: 'yyyy-MM',
                year: 'yyyy'
            },

            DataFase1: [],
            DataFase2: [],
            DataFase3: [],
            dataProvider: [],
            div: 1,
            day: '',
            year: '',
            id: null,
            multiplying_factor: [
                {
                    name: 'Por defecto',
                    factor: 1,
                },
                {
                    name: '200/5A',
                    factor: 40,
                },
                {
                    name: '250/5A',
                    factor: 50,
                },
                {
                    name: '300/5A',
                    factor: 60,
                },
                {
                    name: '400/5A',
                    factor: 80,
                },
                {
                    name: '500/5A',
                    factor: 100,
                },
                {
                    name: '700/5A',
                    factor: 140,
                },
            ],
            fechas: [
                '2023-10-27',
                '2023-10-28',
                '2023-10-29',
                '2023-10-30',
                '2023-10-31',
                '2023-11-01',
                '2023-11-02',
                '2023-11-03',
                '2023-11-04',
                '2023-11-05',
                '2023-11-06',
                '2023-11-07',
                '2023-11-08',
                '2023-11-09',
                '2023-11-10',
                '2023-11-11',
                '2023-11-12',
                '2023-11-13',
                '2023-11-14',
                '2023-11-15',
                '2023-11-16',
                '2023-11-17',
                '2023-11-18',
                '2023-11-19',
                '2023-11-20',
                '2023-11-21',
                '2023-11-22',
                '2023-11-23',
                '2023-11-24',
                '2023-11-25',
                '2023-11-26',
                '2023-11-27',
                '2023-11-28',
                '2023-11-29',
                '2023-11-30',
                '2023-12-01',
                '2023-12-02',
                '2023-12-03',
                '2023-12-04',
                '2023-12-05',
                '2023-12-06',
                '2023-12-07',
                '2023-12-08',
                '2023-12-09',
                '2023-12-10',
                '2023-12-11',
                '2023-12-12',
                '2023-12-13',
                '2023-12-14',
                '2023-12-15',
                '2023-12-16',
                '2023-12-17',
                '2023-12-18',
                '2023-12-19',
                '2023-12-20',
                '2023-12-21',
                '2023-12-22',
                '2023-12-23',
                '2023-12-24',
                '2023-12-25',
                '2023-12-26',
                '2023-12-27',
                '2023-12-28',
                '2023-12-29',
                '2023-12-30',
                '2023-12-31',
                '2024-01-01',
                '2024-01-02',
                '2024-01-03',
                '2024-01-04',
                '2024-01-05',
                '2024-01-06',
                '2024-01-07',
                '2024-01-08',
                '2024-01-09',
                '2024-01-10',
                '2024-01-11',
                '2024-01-12',
                '2024-01-13',
                '2024-01-14',
                '2024-01-15',
                '2024-01-16',
                '2024-01-17',
                '2024-01-19',
                '2024-01-20',
                '2024-01-21',
                '2024-01-22',
                '2024-01-23',
                '2024-01-24',
                '2024-01-25',
                '2024-01-26',
                '2024-01-27',
                '2024-01-28',
                '2024-01-29',
            ]


        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_energia_helo_e_Ctrl', grafica_energia_helo_e_Ctrl);

    /** @ngInject */

    function grafica_energia_helo_e_Ctrl($scope, consumptionServices, consumptionUtil, $rootScope, $localStorage, RESTServices, $stateParams, $filter,SHAREServices, utilities, $timeout, statisticsServices) {

        $scope.parm = "day";
        $scope.noInfo = false;
        $scope.loading = false;
        $scope.type_graph = "consumptionEnergy";

        $scope.DateFilter = SHAREServices.dateFilter;
        $scope.indicador = utilities.generarCodigo(20);
        var chart;

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFormat = consumptionServices.format.day;

        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.filtrar($scope.parm);
        }
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        /////////////////////////

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = consumptionServices.format[itm];
        };

        function setParameters(itm) {
            return {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": itm,
                "type": statisticsServices.graphType,
                "offset": (new Date()).getTimezoneOffset()
            };
        };

        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = "energy" + " - " + SHAREServices.dispositivo_selected.nombre;
            
        }

        $scope.filtrar = function(parm) {
            $scope.parm = parm;
            consumptionServices.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            consumptionServices.day = SHAREServices.diaDatepicker.substring(0, 11);
            loading(parm);
            var field = setParameters(parm);

            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        response.data.sort(function (a, b) {
                            if (a.tiempo > b.tiempo) {
                                return 1;
                            }
                            if (a.tiempo < b.tiempo) {
                                return -1;
                            }
                            // a must be equal to b
                            return 0;
                        });
                        if(statisticsServices.graphType === 'emporiaEnergy') response.data = formatData(response.data);
                        chart.data = consumptionUtil.changeToLocal(response.data, SHAREServices.diaDatepicker, parm);
                        chart.data.map(function(dt){
                            dt.tiempoFormato = $filter('date')(dt.tiempo, 'MMM d, y');
                            dt.horaFormato = $filter('date')(dt.tiempo, 'h:mm a');
                            return dt
                        })
                        
                        SHAREServices.consumo_aire = chart.data;
                        SHAREServices.flagConsumo_aire = !SHAREServices.flagConsumo_aire;
                        successfulResponse();
                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });

        }

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '16' || result.data.tipo === '25') $scope.filtrar($scope.parm);
        })

        $timeout(function(){
            createGraphic(statisticsServices.graphType)
            $scope.filtrar($scope.parm);
        });

        function createGraphic(tipo) {
            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end

            // Create chart instance
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            am4core.options.autoDispose = true;
            // Create axes
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": tipo === 'emporiaEnergy' ? 'hour' : 'minute',
                "count": 1
            };

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;
            valueAxis.min = 0;

            // Create series
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";

            series.name = "Energía";
            series.columns.template.tooltipHTML = "{horaFormato} : <strong>{valueY} Wh</strong>";
            series.columns.template.fillOpacity = .8;

            var columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            chart.scrollbarX = scrollbarX;

            // add exporting button
            chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
        }


        function formatData(data) {
            var all = [];
            all = data.map(function(d){
                d.estado =  d.estado / 10;
                return d;
            })

            return all;
        }
        

        $scope.$on("$destroy", function () {
            chart.dispose();
        });
    }


})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('ErrorCtrl', function($scope, $stateParams, $localStorage, SHAREServices, RESTServices, statisticsServices) {
            
            $scope.indicador = 'error_panel_' + statisticsServices.graphType;
            $scope.noInfo = true;
            $scope.status = 'ok';
            $scope.errorCode = 0;
            $scope.loading = false;

            function loading(){
                $scope.loading = true;
                $scope.noInfo = false;
                $scope.status = 'ok';
            }

            function noInfo(){
                $scope.noInfo = true;
                $scope.loading = false;
                $scope.status = 'ok';
            }

            function consulta_comp(){
                loading();

                var token = SHAREServices.hash_decode_token($localStorage.token);

                // Latest comportamiento data for tipo=59 (error)
                var params = {
                    device_id: SHAREServices.dispositivo_selected.id,
                    user_id: $localStorage.id_usuario,
                    data: SHAREServices.diaDatepicker,
                    time: 'day',
                    type: 'error',
                    offset: new Date().getTimezoneOffset(),
                };

                RESTServices.post_header('cliente/graficas_comportamiento.php', params, token, true).then(function(response){
                    if(response.code === '200' && response.data && response.data.length > 0){
                        // The backend does not return rows in chronological order
                        var lastData = response.data.reduce(function(latest, d){
                            return d.tiempo > latest.tiempo ? d : latest;
                        });
                        var estado = parseFloat(lastData.estado);

                        $scope.loading = false;
                        if(estado === 0){
                            $scope.status = 'ok';
                            $scope.errorCode = 0;
                        } else {
                            $scope.status = 'error';
                            $scope.errorCode = Math.round(estado);
                        }
                    } else {
                        noInfo();
                    }
                }).catch(function(){
                    noInfo();
                });
            }

            function createGraphic(){
                // Panel renderizado via HTML, no se necesita gráfica
            }

            function iniciales(){
                consulta_comp();
            }

            // Inicializar
            if(SHAREServices.dispositivo_selected){
                iniciales();
            } else {
                noInfo();
            }

            $scope.$on('updateDevice', function(event, result){
                if(result.data === 'error') {
                    iniciales();
                }
            });

            $scope.$on('selectGraph', function(event, result){
                if(result.data === 'error') {
                    iniciales();
                }
            });

            $scope.$on('consultaDia', function(event, result){
                if(result.data === 'error') {
                    consulta_comp();
                }
            });
        });
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_fptCtrl', grafica_fptCtrl);

    /** @ngInject */
    function grafica_fptCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, $timeout, $rootScope, utilities) {


        $scope.noInfo = false;
        $scope.loading = false;
        $scope.interval = 0;
        var chart;
        $scope.indicador = utilities.generarCodigo(20);
        var h = new Date();
        $scope.intelvalLimite = Math.ceil(h.getDate() / 4);

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFilter = [
            {
                name: 'Día',
                status: true,
                id: 'day',
            },
            {
                name: 'Mes',
                status: false,
                id: 'month',
            }
        ];
        
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.DateFormat = formato.day;


        $scope.update_date = function() {
            $scope.interval = 0;
            var lastday = new Date($scope.dt.getFullYear(), $scope.dt.getMonth() +1, 0).getDate();
            $scope.intelvalLimite = Math.ceil(lastday / 4);
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.consulta_comp($scope.options.minMode);
            $scope.DateFormat = $scope.options.minMode === 'day' ? formato.day : formato.month;
        }

        /////////////
        function noInfo(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm;
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm;
            $scope.loading = false;
            $scope.noInfo = false;
            $rootScope.$broadcast('iniciarTimer');
            chart.exporting.filePrefix = "flow" + " - " + SHAREServices.dispositivo_selected.nombre;

        }

        $scope.consulta_comp = function(time) {
            $rootScope.$broadcast('cancelarTimer');
            if(time === 'month' ){
                $scope.interval += 1;
            } else {
                $scope.interval = 0;
            }
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
            $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            var field = {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": time,
                "type": "flow",
                "offset": (new Date()).getTimezoneOffset(),
                "interval": time === 'month' ? $scope.interval : null,
            };
            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        if (response.data[0] !== null) {
                            var lengths = [response.data[0].length, response.data[1].length, response.data[2].length];
                            var min = calcularMinimo(lengths);
                            var index = lengths.findIndex(function(i){return i === min});
                            
                            var formatData = response.data[index].map(function(d, ind){
                                return ({
                                    tiempo: new Date(d.tiempo),
                                    flujo: (( ((response.data[1][ind].estado) > 70000) || (response.data[1][ind].estado == 0) ?  (ind == 0 ? 0 : response.data[1][ind-1].estado > 70000 ? 0 : response.data[1][ind-1].estado) : response.data[1][ind].estado) / 100),
                                    presion: (( ((response.data[2][ind].estado > 70000) || (response.data[2][ind].estado == 0) ) ?  (ind == 0 ? 0 : response.data[2][ind-1].estado > 70000 ? 0 : response.data[2][ind-1].estado) : response.data[2][ind].estado) / 100),
                                    temperatura: (( ((response.data[0][ind].estado > 70000) || (response.data[0][ind].estado < 400) ) ? (ind == 0 ? 2300 : ( (response.data[0][ind-1].estado > 70000) || (response.data[0][ind-1].estado < 400)) ? 2300 : response.data[0][ind-1].estado) : response.data[0][ind].estado) / 100) //2300 : response.data[0][ind].estado) / 100)
                                })
                            })
                            
                            if (time === 'month' && $scope.interval <= $scope.intelvalLimite){
                                if ($scope.interval === 1) {
                                    chart.data = [];
                                }
                                chart.data = chart.data.concat(formatData);
                            } else {
                                chart.data = [];
                                chart.data = formatData;
                            }
                            successfulResponse(time);
                        } else {
                            noInfo(time);
                        }

                    } else {
                        noInfo(time);
                    }

                } else {
                    noInfo(time);
                }
            });
        }

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '12')  $scope.consulta_comp('day');
        })

        $timeout(function(){
            createChart();
            $scope.consulta_comp('day');
        });

        function createChart() {
            am4core.useTheme(am4themes_animated); 
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            chart.paddingRight = 20;
            am4core.options.autoDispose = true;
            // Create axes
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.minGridDistance = 50;

            // Create series
            function createAxisAndSeries(field, name, opposite, bullet) {
                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                if(chart.yAxes.indexOf(valueAxis) != 0){
                    valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
                }
                
                var series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.valueY = field;
                series.dataFields.dateX = "tiempo";
                series.strokeWidth = 2;
                series.yAxis = valueAxis;
                series.name = name;
                series.tooltipText = field === 'flujo' ? "{name}: [bold]{valueY} SCFM[/]" : field === 'presion' ? "{name}: [bold]{valueY} PSI[/]" : "{name}: [bold]{valueY} °C[/]";
                series.tensionX = 0.8;
                series.showOnInit = true;
                series.stroke = field === 'flujo' ? am4core.color("#217aeb") : field === 'presion' ? am4core.color("#0ce789") : am4core.color("#af4848");
                series.fill = series.stroke;
                series.smoothing = "monotoneX";
                
                var interfaceColors = new am4core.InterfaceColorSet();
                
                valueAxis.renderer.line.strokeOpacity = 1;
                valueAxis.renderer.line.strokeWidth = 2;
                valueAxis.renderer.line.stroke = series.stroke;
                valueAxis.renderer.labels.template.fill = series.stroke;
                valueAxis.renderer.opposite = opposite;
            }

            createAxisAndSeries("flujo", "Flujo", false, "circle");
            createAxisAndSeries("presion", "Presión", true, "triangle");
            createAxisAndSeries("temperatura", "Temperatura", true, "rectangle");

            // Add legend
            chart.legend = new am4charts.Legend();

            // Add cursor
            chart.cursor = new am4charts.XYCursor();

            // add scrollbarX
            chart.scrollbarX = new am4core.Scrollbar();

            // add exporting button
            //chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
        }



        $scope.$on("$destroy", function () {
            chart.dispose();
            $rootScope.$broadcast('cancelarTimer');
        });

        function calcularMinimo(data) {
            return Math.min.apply(null, data);
        }; 

    }

        

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_helo_s_plus_Ctrl', grafica_helo_s_plus_Ctrl);

    /** @ngInject */
    function grafica_helo_s_plus_Ctrl($scope, SHAREServices, $localStorage, RESTServices, $filter, consumptionServices, consumptionUtil, energyUtil, $timeout, utilities, statisticsServices, energyServices) {
        
        $scope.parm = "day";
        $scope.noInfo = false;
        $scope.loading = true;
        var chart;
        var type_graph = "power";
        $scope.indicador = utilities.generarCodigo(20);
        $scope.graph_name = "Potencia";
        $scope.unit = "W";

        $scope.DateFilter = SHAREServices.dateFilter;

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFormat = consumptionServices.format.day;

        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.filtrar($scope.parm);
        }
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        /////////////////////////

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = consumptionServices.format[itm];
        };

        function noInfo() {
            if(chart !== undefined) {
                chart.data = [];
            }
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = "power" + " - " + SHAREServices.dispositivo_selected.nombre;
        }

        function setParameters(parm) {
            return {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": parm,
                "type": type_graph,
                "offset": (new Date()).getTimezoneOffset()
            };
        }

        $scope.filtrar = function(parm) {
            if(chart !== undefined) {
                chart.data = [];
            }
            $scope.parm = parm;
            $scope.tipo = SHAREServices.dispositivo_selected.tipo;
            $scope.variable = statisticsServices.graphType;
            consumptionServices.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            consumptionServices.day = SHAREServices.diaDatepicker.substring(0, 11);
            loading(parm);
            var field = setParameters(parm);

            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        var validateNoData = response.data.filter(function(obj) { return obj == null });
                        if (validateNoData.length == 3) {
                            noInfo();
                            return;
                        }
                        response.data = energyUtil.sortData(response.data, parm, SHAREServices.diaDatepicker, type_graph);
                        response.data = $scope.type_graph === 'power' && parm === 'month' ? response.data : energyUtil.addLastHour(response.data, SHAREServices.diaDatepicker, parm, type_graph);                                    
                        
                        energyServices.DataFase1 = response.data[0];
                        energyServices.DataFase2 = response.data[1];
                        energyServices.DataFase3 = response.data[2];
                        energyUtil.organiceData2(); 
                        createGraphic()
                        chart.data = energyUtil.formatingDate2(energyServices.dataProvider);
                        successfulResponse();
                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });

        }

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '22' ) $scope.filtrar($scope.parm);
        })


        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        function createGraphic () {
            am4core.useTheme(am4themes_animated); 
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
            am4core.options.autoDispose = true;
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            
            chart.paddingRight = 20;
            
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            };
            
            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "value1";
            series.strokeWidth = 3;
            series.tooltipText = "{valueY.value}" + ' ' + $scope.unit;
            series.name = "Línea 1";
            series.stroke = am4core.color("#A47DFD");

            var series2 = chart.series.push(new am4charts.StepLineSeries());
            series2.dataFields.dateX = "tiempo";
            series2.dataFields.valueY = "value2";
            series2.strokeWidth = 3;
            series2.tooltipText = "{valueY.value}" + ' ' + $scope.unit;
            series2.name = "Línea 2";
            series2.stroke = am4core.color("#FFA622");

            var series3 = chart.series.push(new am4charts.StepLineSeries());
            series3.dataFields.dateX = "tiempo";
            series3.dataFields.valueY = "value3";
            series3.strokeWidth = 3;
            series3.tooltipText = "{valueY.value}" + ' ' + $scope.unit;
            series3.name = "Línea 3";
            series3.stroke = am4core.color("#07CCB6");

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.fullWidthLineX = true;
            chart.cursor.lineX.strokeWidth = 0;
            chart.cursor.lineX.fill = chart.colors.getIndex(2);
            chart.cursor.lineX.fillOpacity = 0.1;

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            chart.scrollbarX = scrollbarX;

            //chart.exporting.menu = new am4core.ExportMenu();

            // Add legend
            chart.legend = new am4charts.Legend();
            
        }

        $timeout(function(){
            $scope.tipo = SHAREServices.dispositivo_selected.tipo;
            $scope.variable = statisticsServices.graphType;
            $scope.filtrar($scope.parm);
        });

        $scope.$on('energyGraphics2', function(event, result) {
            $scope.graph_name = result.data.name;
            $scope.unit = energyUtil.unit(result.data.type);
            type_graph = result.data.type;
            $scope.filtrar($scope.parm);
        });

    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
    .controller('grafica_mpxCtrl', grafica_mpxCtrl);

    /** @ngInject */
    function grafica_mpxCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, utilities, $timeout, statisticsServices) {


        $scope.noInfo = false;
        $scope.loading = false;
        $scope.ind_unit = statisticsServices.setUnit(statisticsServices.graphType);

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;
        $scope.indicador = utilities.generarCodigo(20);
        var chart;
        var types = [
            ['temp', 'settemp'],
            ['frequency', 'setfrequency'],
        ];
        var valores = [
            ['Temperatura', 'Setpoint Temperatura'],
            ['Frecuencia', 'Setpoint Frecuencia'],
        ]

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFilter = SHAREServices.dateFilter;
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.DateFormat = formato.day;


        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.consulta_comp();
        }

        /////////////
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
            $scope.$apply();
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            var ind = statisticsServices.graphType === 'mpx' ? 'temp_setPoint' : 'frec_setPoint';
            chart.exporting.filePrefix = ind + " - " + SHAREServices.dispositivo_selected.nombre;
            $scope.$apply();
        }

        $scope.consulta_comp = function() {
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
            $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            getData('day');
        }

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '15' || result.data.tipo === '27') {
                //variables = result.data.tipo === '15' ? types[0] : types[1];
                if(RESTServices.post_pending === false){
                    $scope.consulta_comp('day');
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        $scope.consulta_comp('day');
                    }, 100)  
                }   
            }
        })


        $timeout(function(){
            var variables = statisticsServices.graphType === 'mpx' ? valores[0] : valores[1];
            createGraphic(variables);
            $scope.consulta_comp();
        });

        function createGraphic(variables){
            am4core.useTheme(am4themes_animated); 

            chart = am4core.create($scope.indicador, am4charts.XYChart);
            chart.paddingRight = 20;
            am4core.options.autoDispose = true;
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.cursorTooltipEnabled = false;

            var dateAxis2 = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis2.renderer.labels.template.disabled = true;
            dateAxis2.cursorTooltipEnabled = false;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.labels.template.fill = am4core.color("#1F71E7");
            valueAxis.renderer.minWidth = 60;

            // var valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
            // valueAxis2.tooltip.disabled = true;
            // valueAxis2.renderer.labels.template.fill = am4core.color("#E8A220");
            // valueAxis2.renderer.minWidth = 60;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.name = variables[0];
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";
            series.tooltipHTML = variables[0] === 'Temperatura' ? "Temperatura: {valueY.value} C <br> Hora: {hora}" : "Frecuencia: {valueY.value} Hz <br> Hora: {hora}" ;
            series.fill = am4core.color("#1F71E7");
            series.stroke = am4core.color("#1F71E7");
            series.strokeWidth = 3;

            var series2 = chart.series.push(new am4charts.StepLineSeries());
            series2.name = variables[1];
            series2.dataFields.dateX = "tiempo2";
            series2.dataFields.valueY = "estado2";
            //series2.yAxis = valueAxis2;
            series2.xAxis = dateAxis2;
            series2.tooltipHTML = variables[0] === 'Temperatura' ? "Temperatura: {valueY.value} C <br> Hora: {hora}" : "Frecuencia: {valueY.value} Hz <br> Hora: {hora}" ;
            series2.fill = am4core.color("#E8A220");
            series2.stroke = am4core.color("#E8A220");
            series2.strokeWidth = 3;

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;

            // Legenda
            chart.legend = new am4charts.Legend();

            // add exporting button
            //chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;

            //valueAxis2.renderer.grid.template.strokeOpacity = 0.07;
            dateAxis2.renderer.grid.template.strokeOpacity = 0.07;
            dateAxis.renderer.grid.template.strokeOpacity = 0.07;
            valueAxis.renderer.grid.template.strokeOpacity = 0.07;
        }

        

        function getData(time) {
            var variables = statisticsServices.graphType === 'mpx' ? types[0] : types[1];
            var allData = [];
            var data_1 = [];
            var data_2 = [];
            var promesas = variables.map(function(d) {
                var field = {
                    "device_id": SHAREServices.dispositivo_selected.id,
                    "user_id": $localStorage.id_usuario,
                    "data": SHAREServices.diaDatepicker,
                    "time": time,
                    "type": d,
                    "offset": (new Date()).getTimezoneOffset()
                };

                return RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
            })

            Promise.all(promesas)
                .then(function(res) {
                    if (res[0].code === '200' || res[1].code === '200') {
                        if(res[0].data) {
                            data_1 = res[0].data;
                            data_1 = organizarData(data_1);
                            data_1 = addLastHour(data_1);
                            data_1  = formatData(res[0].data, 'tiempo', 'estado', true);
                            
                        }
                        if(res[1].data) {
                            data_2 = res[1].data;
                            data_2 = organizarData(data_2);
                            data_2 = addLastHour(data_2);
                            data_2 = formatData(data_2, 'tiempo2', 'estado2', true);
                            
                        }
                        allData = data_1.concat(data_2);
                        chart.data = allData;
                        successfulResponse();
                    } else {
                        noInfo();
                    }
                    
                })
                .catch(function(error){
                    noInfo();
                })

            
        }

        function formatData(itm, nombre, valor, flat) {
            itm = itm.map(function(d, ind){
                var aux = {};
                aux[nombre] = flat ? SHAREServices.dateToLocal(d.tiempo,itm.length-1,ind,false) : d.tiempo;
                aux[valor] = d.estado/10; //Escalando a unidad real;
                var date = flat ? new Date(SHAREServices.dateToLocal(d.tiempo,itm.length-1,ind,false)): new Date(d.tiempo); 
                aux.hora = $filter('date')(date, 'HH:mm:ss');
                return aux;
            })
            return itm;
        }

        function addLastHour(data) {
            var index = data.length;
            var aux = {};
            if (SHAREServices.diaDatepicker == $filter('date')(new Date(), 'yyyy-MM-dd')) {
                aux.tiempo = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                aux.estado = data[index - 1].estado;
            } else {
                aux.tiempo = SHAREServices.diaDatepicker + ' 23:59:59';
                aux.estado = data[index - 1].estado;
            }
            data.push(aux);
            return data;
        }

        function organizarData(data) {
            data.sort(function (a, b) {
                if (a.tiempo > b.tiempo) {
                    return 1;
                }
                if (a.tiempo < b.tiempo) {
                    return -1;
                }
                return 0;
            });
            return data;
        }


        $scope.$on("$destroy", function () {
            chart.dispose();
            RESTServices.cancelarSolicitudHttp();
        });

    }

        

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_humedadCtrl', grafica_humedadCtrl);

    /** @ngInject */
    function grafica_humedadCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, statisticsServices, utilities, $timeout, $rootScope) {


        $scope.noInfo = false;
        $scope.loading = false;
        $scope.ind_unit = statisticsServices.setUnit(statisticsServices.graphType);
        $scope.DateFilter = SHAREServices.dateFilter;
        $scope.rol = $localStorage.rol;
        $scope.graphType = statisticsServices.graphType;

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        var chart;
        $scope.indicador = utilities.generarCodigo(20);

        $scope.DateFilter = SHAREServices.dateFilter;
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.DateFormat = formato.day;


        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.consulta_comp($scope.time);
        }

        /////////////
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = statisticsServices.graphType + " - " + SHAREServices.dispositivo_selected.nombre;

        }
        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = formato[itm];
        };

        $scope.consulta_comp = function(time) {
            $scope.time = time;
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
            $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            loading(time);
            var field = {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": time,
                "type": statisticsServices.graphType,
                "offset": (new Date()).getTimezoneOffset()
            };
            
            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        response.data.sort(function (a, b) {
                            if (a.tiempo > b.tiempo) {
                                return 1;
                            }
                            if (a.tiempo < b.tiempo) {
                                return -1;
                            }
                            return 0;
                        });
                        
                        var index = response.data.length;
                        if (SHAREServices.diaDatepicker == $filter('date')(new Date(), 'yyyy-MM-dd')) {
                            var aux = {
                                tiempo: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                                estado: response.data[index - 1].estado,
                                tipo: response.data[index - 1].tipo
                            };
                        } else {
                            var aux = {
                                tiempo: SHAREServices.diaDatepicker+' 23:59:59',
                                estado: response.data[index - 1].estado,
                                tipo: response.data[index - 1].tipo
                            };
                        }
                        response.data.push(aux);

                        var diaDatepicker = SHAREServices.diaDatepicker.substring(5, 11);
                        response.data = response.data.map(function(d,ind){
                            return ({ 
                                tiempo : SHAREServices.dateToLocal(d.tiempo,response.data.length-1,ind,false),
                                estado : d.estado,
                                tipo : d.tipo,
                                hora: SHAREServices.dateToLocal(d.tiempo,response.data.length-1,ind,true)
                            })
                        })
                        if(SHAREServices.dispositivo_selected.tipo === '28' || SHAREServices.dispositivo_selected.tipo === '30') {
                            response.data = response.data.map(function(d){
                                d.estado = (d.estado) / 100;
                                return d
                            })
                        }
                        var all = response.data.map(function(c){ return Number(c.estado)});
                        $rootScope.$broadcast('indDataConsumtion', {data: all})
                        SHAREServices.comportamiento_aire = response.data;
                        chart.data = SHAREServices.comportamiento_aire;
                        successfulResponse();

                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });
        }


        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '6' || result.data.tipo === '18') {
                if(statisticsServices.graphType !== 'temp'){
                    if(RESTServices.post_pending === false){
                        $scope.consulta_comp('day');
                    }else {
                        RESTServices.cancelarSolicitudHttp();
                        $timeout(function(){
                            $scope.consulta_comp('day');
                        },100)
                        
                    } 
                }
                 
            } 
        })

        $timeout(function(){
            createGraphic()
            $scope.consulta_comp('day');
        });

        function createGraphic(){
            am4core.useTheme(am4themes_animated); 
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            chart.paddingRight = 20;
            am4core.options.autoDispose = true;
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            };

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";
            series.strokeWidth = 3;
            series.tooltipHTML = "Hora: <strong>{hora}</strong><br>" + $scope.ind_unit + ": <strong>{valueY.value}</strong>"
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.fullWidthLineX = true;
            chart.cursor.lineX.strokeWidth = 0;
            chart.cursor.lineX.fill = chart.colors.getIndex(2);
            chart.cursor.lineX.fillOpacity = 0.1;

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            chart.scrollbarX = scrollbarX;

            chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
        }

        



        $scope.$on("$destroy", function () {
            chart.dispose();
            RESTServices.cancelarSolicitudHttp();
        });

    }

        

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
    .controller('grafica_presionCtrl', grafica_presionCtrl);

    /** @ngInject */
    function grafica_presionCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, utilities, $timeout) {


        $scope.noInfo = false;
        $scope.loading = false;

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };
        var chart;
        $scope.indicador = utilities.generarCodigo(20);
        $scope.DateFilter = SHAREServices.dateFilter;
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.DateFormat = formato.day;


        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.consulta_comp();
        }

        /////////////
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = "pressure_setPressure" + " - " + SHAREServices.dispositivo_selected.nombre;
            $scope.$apply();
        }

        $scope.consulta_comp = function() {
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
            $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            getData('day');
        }

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '14') $scope.consulta_comp();
        })

        function createGraphic() {
            am4core.useTheme(am4themes_animated); 

            chart = am4core.create($scope.indicador, am4charts.XYChart);
            chart.paddingRight = 20;
            am4core.options.autoDispose = true;
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;

            var dateAxis2 = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis2.renderer.labels.template.disabled = true;


            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.labels.template.fill = am4core.color("#1F71E7");
            valueAxis.renderer.minWidth = 60;

            var valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis2.tooltip.disabled = true;
            valueAxis2.renderer.labels.template.fill = am4core.color("#E8A220");
            valueAxis2.renderer.minWidth = 60;
        // valueAxis2.syncWithAxis = valueAxis;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.name = "Presión";
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";
            series.tooltipText = "Presion: {valueY.value} Bar";
            series.fill = am4core.color("#1F71E7");
            series.stroke = am4core.color("#1F71E7");
            series.strokeWidth = 3;

            var series2 = chart.series.push(new am4charts.StepLineSeries());
            series2.name = "Set Point Presión";
            series2.dataFields.dateX = "tiempo2";
            series2.dataFields.valueY = "estado2";
            series2.yAxis = valueAxis2;
            series2.xAxis = dateAxis2;
            series2.tooltipText = "Setpoint Presion: {valueY.value} Bar";
            series2.fill = am4core.color("#E8A220");
            series2.stroke = am4core.color("#E8A220");
            series2.strokeWidth = 3;

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;

            // Legenda
            chart.legend = new am4charts.Legend();

            // add exporting button
            //chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;

            valueAxis2.renderer.grid.template.strokeOpacity = 0.07;
            dateAxis2.renderer.grid.template.strokeOpacity = 0.07;
            dateAxis.renderer.grid.template.strokeOpacity = 0.07;
            valueAxis.renderer.grid.template.strokeOpacity = 0.07;
        }

        $timeout(function(){
            createGraphic()
            $scope.consulta_comp();
        });

        

        function getData(time) {
            var type = ['pressure', 'setpressure'];
            var allData = [];
            var promesas = type.map(function(d) {
                var field = {
                    "device_id": SHAREServices.dispositivo_selected.id,
                    "user_id": $localStorage.id_usuario,
                    "data": SHAREServices.diaDatepicker,
                    "time": time,
                    "type": d,
                    "offset": (new Date()).getTimezoneOffset()
                };

                return RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
            })

            Promise.all(promesas)
                .then(function(res) {
                    if (res[0].code === '200' && res[1].code === '200') {
                        res[0].data = addLastHour(res[0].data);
                        res[1].data = addLastHour(res[1].data);
                        res[0].data = formatData(res[0].data, 'tiempo', 'estado', true);
                        res[1].data = formatData(res[1].data, 'tiempo2', 'estado2', true);
                        allData = res[0].data.concat(res[1].data);
                        chart.data = allData;
                        successfulResponse();
                    } else {
                        noInfo();
                    }
                    
                })
                .catch(function(error){
                   //console.log(error)
                    noInfo();
                })

            
        }

        function formatData(itm, nombre, valor, flat) {
            itm = itm.map(function(d, ind){
                var aux = {};
                aux[nombre] = flat ? SHAREServices.dateToLocal(d.tiempo,itm.length-1,ind,false) : d.tiempo;
                aux[valor] = d.estado == '0'?(ind == 0 ? d.estado : itm[ind-1].estado/10): d.estado/10; //Escalando a unidad real;
                return aux;
            })
            return itm;
        }

        function addLastHour(data) {
            var index = data.length;
            var aux = {};
            if (SHAREServices.diaDatepicker == $filter('date')(new Date(), 'yyyy-MM-dd')) {
                aux.tiempo = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                aux.estado = data[index - 1].estado;
            } else {
                aux.tiempo = SHAREServices.diaDatepicker + ' 23:59:59';
                aux.estado = data[index - 1].estado;
            }
            data.push(aux);
            return data;
        }


        $scope.$on("$destroy", function () {
            chart.dispose();
        });

    }

        

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_scfm_kwCtrl', grafica_scfm_kwCtrl);

    /** @ngInject */
    function grafica_scfm_kwCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, ngDialog, toastr, $window, scfm_kwUtil, scfm_kwServices, $rootScope) {

        $scope.settings = true;
        $scope.noInfo = false;
        $scope.loading = false;
        var chart;
        $scope.dv = SHAREServices.dispositivo_selected;
        $scope.medidores = [];
        $scope.interval = 0;
        var h = new Date();
        $scope.intelvalLimite = Math.ceil(h.getDate() / 4);

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFilter = scfm_kwServices.dateFilter;
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.DateFormat = formato.day;

        $scope.update_date = function() {
            $scope.interval = 0;
            var lastday = new Date($scope.dt.getFullYear(), $scope.dt.getMonth() +1, 0).getDate();
            $scope.intelvalLimite = Math.ceil(lastday / 4);
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            scfm_kwServices.DataFases = {};
            scfm_kwServices.dataProvider=[];
            $scope.DateFormat = $scope.options.minMode === 'day' ? formato.day : formato.month;
            $scope.consulta_comp($scope.options.minMode);
        }

        /////////////
        function noInfo(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm;
            $scope.loading = false;
            $scope.noInfo = false;
            $rootScope.$broadcast('iniciarTimer');
        }

        $scope.consulta_comp = function(time, interval) {
            $rootScope.$broadcast('cancelarTimer');
            if(time === 'month' ){
                $scope.interval += 1;
            }
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
            $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            var field = {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
                "data": SHAREServices.diaDatepicker,
                "time": time,
                "type": "SCFM_KW",
                "offset": (new Date()).getTimezoneOffset(),
                "interval": time === 'month' ? $scope.interval : null,
            };

            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        
                        scfm_kwUtil.organiceData(response.data,time);

                        var formatData = scfm_kwServices.dataProvider.map(function(d){
                            return ({
                                tiempo: new Date(d.tiempo),
                                estado: d.estado,
                                hora: $filter('date')(new Date(d.tiempo), 'HH:mm:ss'),
                            })
                        });
                        if (time === 'month' && $scope.interval <= $scope.intelvalLimite){
                            if ($scope.interval === 1) {
                                chart.data = [];
                            }
                            chart.data = chart.data.concat(formatData);
                        } else {
                            chart.data = [];
                            chart.data = formatData;
                        }
                        
                        successfulResponse(time);

                    } else {
                        noInfo(time);
                    }

                } else {
                    noInfo(time);
                }
            });
        }
        function settingsReady() {
            var field = {
                "id_agrupador": SHAREServices.dispositivo_selected.id,
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token),
            };

            RESTServices.post_header('cliente/consulta_medidores_energia_flujo.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    response.dispositivos.forEach(function(disp){
                        if (disp.estado === '1') {
                            $scope.settings = false;
                            $scope.medidores.push(disp);
                        }
                    })
                    if ($scope.settings === false) {
                        $scope.consulta_comp('day');
                    }
                }    
            })
        }

        $scope.$on('addMeasurers', function(event, result) {
            $scope.medidores = result.data;
            $scope.settings = false;
            createChart();
            $scope.consulta_comp('day');
        });

        $scope.$watch(function() {
            return SHAREServices.dispositivo_selected.id;
        }, function() {
            createChart();
            settingsReady();
        });

        function createChart() {
            am4core.useTheme(am4themes_animated); 
            chart = am4core.create("grafica_scfm_kw", am4charts.XYChart);
            chart.paddingRight = 20;
            am4core.options.autoDispose = true;
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            };

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";
            series.strokeWidth = 3;
            series.tooltipHTML = "Hora: <strong>{hora}</strong><br> Valor: <strong>{valueY.value}</strong>"
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.fullWidthLineX = true;
            chart.cursor.lineX.strokeWidth = 0;
            chart.cursor.lineX.fill = chart.colors.getIndex(2);
            chart.cursor.lineX.fillOpacity = 0.1;

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            chart.scrollbarX = scrollbarX;

            //chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
        }
        



        $scope.$on("$destroy", function () {
            chart.dispose();
            $rootScope.$broadcast('cancelarTimer');
        });

        $scope.deteleMeasure = function(measurer){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Desea desasociar ese medidor?',

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.aceptar = function() {
                        var parms = {
                            "id_agrupador": $scope.dv.id,
                            "id_medidor": measurer.id,
                            "id_usuario": $localStorage.id_usuario,
                           //token: SHAREServices.hash_decode_token($localStorage.token),
                            "asociar": 0,
                        };
                        RESTServices.post_header('cliente/asociar_dispositivos_agrupador.php', parms, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                            if (response.code == '200') {
                                var index = $scope.medidores.findIndex(function(med){return med.id === measurer.id});
                                $scope.medidores.splice(index, 1);
                                ngDialog.close();
                                toastr.success('El medidor ha sido desasociado', 'Gestión de Medidores');
                                if ($scope.medidores.length === 0) {
                                    $scope.settings = true;
                                    $window.location.reload();
                                }
                            }    
                        })
                    }

                }]
            });
            
        }

    }

        

})();
(function() {
    'use strict';
    angular.module('BlurAdmin').factory('scfm_kwUtil', function(scfm_kwServices, SHAREServices, $filter) {
        return {
            organiceData: function(data,time) {
                var bufferAux = {};
                var flag = false;
                for(var i=0;i<data.length;i++){
                    if(data[i]!= null){
                        flag = true;
                    }else{
                        if(i==(data.length-1))flag=false;
                        else{
                            //Agrega el valor inicial a cada arreglo
                            var timeInit = this.setTiempo(time, SHAREServices.diaDatepicker, 'power', false);
                            data[i] = [{
                                tiempo: timeInit,
                                estado: '0',
                                var: scfm_kwServices.getVariable(i, data.length-1)
                            }]
                        }
                    }
                }

                for(var i = 0; i < data.length; i++ ){
                    var scale = i === (data.length -1) ? 300 : 240; //SCFM se escala con 300 ya que se toman datos en prom cada 12seg y Power con 240 ya que se toman datos en prom cada 15seg
                    var divider = i === (data.length -1) ? 100 : 1000; //SCFM se divide sobre 100 para escala real y Power sobre 1000 para pasar a KW
                    scfm_kwServices.DataFases[i] = this.average(data[i], scale, divider);
                }

                // Acumulando potencias en scfm_kwServices.dataProvider
                for (var i = 0; i < scfm_kwServices.DataFases[0].length; i++) {
                    var acumPot = 0;
                    for (var j = 0; j < (data.length-1); j++) {
                        acumPot = acumPot + scfm_kwServices.DataFases[j][i].estado ;
                    }
                    bufferAux[i] = {};
                    bufferAux[i].tiempo = scfm_kwServices.DataFases[0][i].tiempo;
                    bufferAux[i].estado = acumPot;
                    /*scfm_kwServices.dataProvider[i] = {};
                    scfm_kwServices.dataProvider[i].tiempo = scfm_kwServices.DataFases[0][i].tiempo;
                    scfm_kwServices.dataProvider[i].estado = acumPot;
                    */
                    
                }

                //scfm_kwServices.DataFases[0]= scfm_kwServices.dataProvider;

               //console.log('DataFases', scfm_kwServices.DataFases);
               //console.log('dataProvider', bufferAux);   
                
                for (var i = 0; i < scfm_kwServices.DataFases[data.length-1].length; i++) {
                    var scfm_kw = (parseInt(scfm_kwServices.DataFases[data.length-1][i].estado) == 0 ? 0 : ( bufferAux[i].estado == 0 ? 0 : (scfm_kwServices.DataFases[data.length-1][i].estado)/(bufferAux[i].estado) )); 
                    scfm_kwServices.dataProvider[i] = {};
                    scfm_kwServices.dataProvider[i].tiempo = scfm_kwServices.DataFases[data.length-1][i].tiempo;
                    scfm_kwServices.dataProvider[i].estado = scfm_kw > 7 ? 7 : scfm_kw;   //SolucionAire solicita que se descarten datos por encima de 7 en este indicador                
                }

                //scfm_kwServices.DataFases[0]= scfm_kwServices.dataProvider;
                //Organizando datos temporales de potencia acumulada con SCFM
                /*this.manageData(0, data.length-1);
                this.manageData(data.length-1, 0);

                scfm_kwServices.DataFases[0].sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });
                scfm_kwServices.DataFases[data.length-1].sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });

                for (var i = 0; i < scfm_kwServices.DataFases[0].length; i++) {
                    var scfm_kw = parseInt(scfm_kwServices.DataFases[data.length-1][i].estado) == 0 ? 0 : ( parseInt(scfm_kwServices.DataFases[0][i].estado) == 0 ? 0 : (parseInt(scfm_kwServices.DataFases[data.length-1][i].estado)/100)/(parseInt(scfm_kwServices.DataFases[0][i].estado)/1000) ) ; //Se divide potencia para que quede en Kw y SCFM por 100 para obtener escala real
                    scfm_kwServices.dataProvider[i].estado = scfm_kw > 7 ? ( i == 0 ? 7 : scfm_kwServices.dataProvider[i-1].estado) : scfm_kw;   //SolucionAire solicita que se descarten datos por encima de 7 en este indicador                
                }*/

                /*if(flag){ //Alguna de las fases tiene info
                    if(data.length==4){
                        this.manageData(0, 1);
                        this.manageData(1, 2);
                        this.manageData(2, 0);
                        this.manageData(2, 1);
                    }else if(data.length==7){
                        this.manageData(0, 1);
                        this.manageData(1, 2);
                        this.manageData(2, 3);
                        this.manageData(3, 4);
                        this.manageData(4, 5);
                        this.manageData(5, 0);
                        this.manageData(5, 1);
                        this.manageData(5, 2);
                        this.manageData(5, 3);
                        this.manageData(5, 4);
                    }
                    //Organizando arreglos para que contengan misma cantidad de datos y escala temporal
                    for(var i=0;i< (data.length-1);i++){
                        scfm_kwServices.DataFases[i].sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });
                    }
                    // Acumulando potencias en scfm_kwServices.dataProvider
                    for (var i = 0; i < scfm_kwServices.DataFases[0].length; i++) {
                        var acumPot = 0;
                        for (var j = 0; j < (data.length-1); j++) {
                            var inter = scfm_kwServices.DataFases[j][i] ? scfm_kwServices.DataFases[j][i].estado : scfm_kwServices.DataFases[j - 1][i].estado;
                            acumPot = acumPot + parseInt(inter);
                        }
                        scfm_kwServices.dataProvider[i] = {};
                        scfm_kwServices.dataProvider[i].tiempo = scfm_kwServices.DataFases[0][i].tiempo;
                        scfm_kwServices.dataProvider[i].estado = acumPot;
                        
                    }
                    var lastTime = this.setTiempo(time, SHAREServices.diaDatepicker,'power', true);
                    scfm_kwServices.dataProvider[scfm_kwServices.dataProvider.length] = {
                        tiempo: lastTime,
                        estado: scfm_kwServices.dataProvider[scfm_kwServices.dataProvider.length-1].estado
                    };
                    scfm_kwServices.DataFases[0]= scfm_kwServices.dataProvider;

                    //Organizando datos temporales de potencia acumulada con SCFM
                    this.manageData(0, data.length-1);
                    this.manageData(data.length-1, 0);

                    scfm_kwServices.DataFases[0].sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });
                    scfm_kwServices.DataFases[data.length-1].sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });

                    for (var i = 0; i < scfm_kwServices.DataFases[0].length; i++) {
                        var scfm_kw = parseInt(scfm_kwServices.DataFases[data.length-1][i].estado) == 0 ? 0 : ( parseInt(scfm_kwServices.DataFases[0][i].estado) == 0 ? 0 : (parseInt(scfm_kwServices.DataFases[data.length-1][i].estado)/100)/(parseInt(scfm_kwServices.DataFases[0][i].estado)/1000) ) ; //Se divide potencia para que quede en Kw y SCFM por 100 para obtener escala real
                        scfm_kwServices.dataProvider[i].estado = scfm_kw > 7 ? ( i == 0 ? 7 : scfm_kwServices.dataProvider[i-1].estado) : scfm_kw;   //SolucionAire solicita que se descarten datos por encima de 7 en este indicador                
                    }

                    //Calculando el promedio de cada 300 datos
                    //console.log(scfm_kwServices.dataProvider);
                    var averageArray = [];
                    var auxDataProvider = [];
                    while (scfm_kwServices.dataProvider.length > 0) {
                        var aux = scfm_kwServices.dataProvider.splice(0,300);
                        averageArray = aux.map(this.getEstado);
                        //Se obtiene objeto con promedio de los 300 datos y la marca de tiempo del último dato del arreglo
                        var object = {
                            estado: averageArray.reduce(this.accumulator,0) / averageArray.length,
                            tiempo: aux[aux.length-1].tiempo
                        }
                        //Se agrega a arreglo auxiliar
                        auxDataProvider.push(object);
                    }
                    //Se pasa a dataProvider que se usa para graficar
                    scfm_kwServices.dataProvider = auxDataProvider;
                    //console.log(auxDataProvider);

                }else{ //Potencia nulas o sin datos de sensor de flujo

                }*/
            },

            manageData: function(in1, in2) {
                var array1 = scfm_kwServices.DataFases[in1];
                var array2 = scfm_kwServices.DataFases[in2];
                
                array1.forEach(function(element) {
                    if (!Object.keys(array2).some(function(k) { return (array2[k].tiempo == element.tiempo); })) {
                        var data_aux = array2.filter(function(x) { return (x.tiempo < element.tiempo); });
                        if(data_aux.length>0){
                            data_aux.sort(function(c, b) { return c.tiempo.localeCompare(b.tiempo) });
                            var index = data_aux.length - 1;
                            data_aux = data_aux[index];
                            scfm_kwServices.DataFases[in2][scfm_kwServices.DataFases[in2].length - 1] = {};
                            scfm_kwServices.DataFases[in2][scfm_kwServices.DataFases[in2].length - 1].tiempo = element.tiempo;
                            scfm_kwServices.DataFases[in2][scfm_kwServices.DataFases[in2].length - 1].estado = data_aux.estado; 
                            scfm_kwServices.DataFases[in2][scfm_kwServices.DataFases[in2].length - 1].tipo = '0';
                            scfm_kwServices.DataFases[in2][scfm_kwServices.DataFases[in2].length - 1].var = scfm_kwServices.getVariable(in2, scfm_kwServices.DataFases.length-1);
                        }
                                                     
                    }

                });

            },

            getEstado: function(item) {
                return item.estado/scfm_kwServices.divider;
            },

            getTiempo: function(item) {
                return item.tiempo;
            },

            accumulator: function(runningTotal, estado) {
                return runningTotal + estado;
            },

            setTiempo: function(parm, date, type, last) {
                switch (parm) {
                    case 'day':
                        if (last) {
                            if (date < $filter('date')(new Date(), 'yyyy-MM-dd')) {
                                return date+' 23:59:59';
                            } else {
                                return $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                            }
                        } else {
                            return date+' 00:00:00';
                        }
                        break;
                    case 'week':
                        var lunes = this.getMonday(new Date($filter('date')(date, 'yyyy/MM/dd')));
                        if (last) {
                            if ($filter('date')(lunes, 'yyyy-MM-dd') < $filter('date')(this.getMonday(new Date()), 'yyyy-MM-dd')) {
                                return $filter('date')(lunes.setDate(lunes.getDate() + 6), 'MM-dd') + ' 23:59:59';
                            } else {
                                return $filter('date')(new Date(), 'MM-dd HH:mm:ss');
                            }
                        } else {
                            return ($filter('date')(lunes, 'MM-dd') + ' 00:00:00');
                        }
                        break;
                    case 'month':
                        if (last) {
                            if (type == 'activeEnergy' || type == 'reactiveEnergy' || type == 'frequency') {
                                if (date.substring(0, 7) < $filter('date')(new Date(), 'yyyy-MM')) {
                                    return $filter('date')(new Date(date.substring(0, 4), parseInt(date.substring(5, 7)), 0), 'yyyy-MM-dd') + ' 23:59:59';
                                } else {
                                    return $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                                }
                            }
                        } else {
                            return (date.substring(0, 7) + '-01 00:00:00');
                        }
                        break;
                    case 'year':
                        if (last) {
                            if (date.substring(0, 4) < $filter('date')(new Date(), 'yyyy')) {
                                return '12-31 23:59:59';
                            } else {
                                return $filter('date')(new Date(), 'MM-dd HH:mm:ss');
                            }
                        } else {
                            return '01-01 00:00:00';
                        }
                        break;
                }
            },
            average: function(data, scale, divider) {
                var averageArray = [];
                var auxDataProvider = [];
                while (data.length > 0) {
                    var aux = data.splice(0, scale);
                    scfm_kwServices.divider = divider; 
                    averageArray = aux.map(this.getEstado);
                    //Se obtiene objeto con promedio de los x(scale) datos y la marca de tiempo del último dato del arreglo
                    var object = {
                        estado: averageArray.reduce(this.accumulator,0) / averageArray.length,
                        tiempo: aux[aux.length-1].tiempo
                    }
                    //Se agrega a arreglo auxiliar
                    auxDataProvider.push(object);
                }
                return auxDataProvider;
            }
        }
    })
})();
(function() {
    'use strict';
    angular.module('BlurAdmin').service('scfm_kwServices', scfm_kwServices);

    function scfm_kwServices() {
        return {
            divider: 1,
            DataFases: {},
            dataProvider: [],
            getVariable: function(i,max) {
                if(i<2){
                    if(i==1) return 28;
                    else return 27;
                }else if(i<max){
                    return (i%2 == 0 ? 29 : (i%3 ==0 ? 27 : 28));
                }else return 12;
            },
            dateFilter: [
                {
                    name: 'Día',
                    status: true,
                    id: 'day',
                },
                {
                    name: 'Mes',
                    status: false,
                    id: 'month',
                },
            ]

        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_sensoresCtrl', grafica_sensoresCtrl);

    /** @ngInject */
    function grafica_sensoresCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, statisticsServices, utilities, $timeout) {


        $scope.noInfo = false;
        $scope.loading = false;
        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        var chart;
        $scope.indicador = utilities.generarCodigo(20);

        $scope.DateFilter = SHAREServices.dateFilter;
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.DateFormat = formato.day;


        $scope.update_date = function(time) {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.consulta_comp(time ? time : $scope.time);
        }

        /////////////
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = statisticsServices.graphType + " - " + SHAREServices.dispositivo_selected.nombre;

        }
        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            //$scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = formato[itm];
        };

        $scope.$on('updateGraph', function(event, result) {
            if(result.data === 'pm1p0' || result.data === 'pm2p5' || result.data === 'pm4p0' || result.data === 'pm10p0' || result.data === 'voc' || result.data === 'nox'){
                $scope.ind_unit = statisticsServices.setUnit(statisticsServices.graphType);
                if(RESTServices.post_pending === false){
                    $scope.consulta_comp('day')
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        $scope.consulta_comp('day')
                    },100)
                    
                }  
            }
        })

        $scope.consulta_comp = function(time) {
            if(chart !== undefined) {
                chart.data = []
            }
            $scope.time = time;
            $scope.tipo = SHAREServices.dispositivo_selected.tipo;
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
            $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            $scope.graphType = statisticsServices.graphType;
            loading(time)
            var field = {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": time,
                "type": statisticsServices.graphType,
                "offset": (new Date()).getTimezoneOffset()
            };
            
            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        response.data.sort(function (a, b) {
                            if (a.tiempo > b.tiempo) {
                                return 1;
                            }
                            if (a.tiempo < b.tiempo) {
                                return -1;
                            }
                            return 0;
                        });
                        
                        var index = response.data.length;
                        if (SHAREServices.diaDatepicker == $filter('date')(new Date(), 'yyyy-MM-dd')) {
                            var aux = {
                                tiempo: $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                                estado: response.data[index - 1].estado,
                                tipo: response.data[index - 1].tipo
                            };
                        } else {
                            var aux = {
                                tiempo: SHAREServices.diaDatepicker+' 23:59:59',
                                estado: response.data[index - 1].estado,
                                tipo: response.data[index - 1].tipo
                            };
                        }
                        response.data.push(aux);

                        //var diaDatepicker = SHAREServices.diaDatepicker.substring(5, 11);
                        response.data = response.data.map(function(d,ind){
                            return ({ 
                                tiempo : SHAREServices.dateToLocal(d.tiempo,response.data.length-1,ind,false),
                                estado : d.estado / 10,
                                tipo : d.tipo,
                                hora: SHAREServices.dateToLocal(d.tiempo,response.data.length-1,ind,true),
                                unit: statisticsServices.setUnit(statisticsServices.graphType),
                            })
                        })
                        SHAREServices.comportamiento_aire = response.data;
                        chart.data = SHAREServices.comportamiento_aire;
                        successfulResponse();

                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });
        }


        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '28') {
                $scope.ind_unit = statisticsServices.setUnit(statisticsServices.graphType);
                if(RESTServices.post_pending === false){
                    $scope.consulta_comp('day');
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        $scope.consulta_comp('day');
                    },100)
                    
                }  
            } 
        })

        $timeout(function(){
            createGraphic()
            $scope.consulta_comp('day');
        });

        function createGraphic(){
            am4core.useTheme(am4themes_animated); 
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            chart.paddingRight = 20;
            am4core.options.autoDispose = true;
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            };

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            // var series = chart.series.push(new am4charts.StepLineSeries());
            // series.dataFields.dateX = "tiempo";
            // series.dataFields.valueY = "estado";
            // series.strokeWidth = 3;
            // series.tooltipHTML = "Hora: <strong>{hora}</strong><br>" + $scope.ind_unit + ": <strong>{valueY.value}</strong>"
            // chart.cursor = new am4charts.XYCursor();
            // chart.cursor.xAxis = dateAxis;
            // chart.cursor.fullWidthLineX = true;
            // chart.cursor.lineX.strokeWidth = 0;
            // chart.cursor.lineX.fill = chart.colors.getIndex(2);
            // chart.cursor.lineX.fillOpacity = 0.1;

            // var scrollbarX = new am4charts.XYChartScrollbar();
            // scrollbarX.series.push(series);
            // chart.scrollbarX = scrollbarX;

        
            var series = chart.series.push(new am4charts.LineSeries());
            series.dataFields.valueY = "estado";
            series.dataFields.dateX = "tiempo";
            series.strokeWidth = 3;
            series.minBulletDistance = 10;
            //series.tooltipText = "{valueY}";
            series.tooltipHTML = "Hora: <strong>{hora}</strong><br>" + "{unit}: <strong>{valueY.value}</strong>"

            series.tooltip.pointerOrientation = "vertical";
            series.tooltip.background.cornerRadius = 20;
            series.tooltip.background.fillOpacity = 0.5;
            series.tooltip.label.padding(12,12,12,12)

            // Add scrollbar
            chart.scrollbarX = new am4charts.XYChartScrollbar();
            chart.scrollbarX.series.push(series);

            // Add cursor
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.snapToSeries = series;

            chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
        }

        



        $scope.$on("$destroy", function () {
            chart.dispose();
            RESTServices.cancelarSolicitudHttp();
        });

    }

        

})();
(function() {
    'use strict';
    angular.module('BlurAdmin').service('tempDistServices', tempDistServices);

    function tempDistServices() {
        return {
            chart: AmCharts.makeChart("grafica_temp_dist", {
                "type": "serial",
                "theme": "none",
                "marginRight": 40,
                "marginLeft": 40,
                "autoMarginOffset": 20,
                "colors": ["#0C98F2"],
                "valueAxes": [{
                    "id": "v1",
                    "axisAlpha": 0,
                    "position": "left",
                    "ignoreAxisWidth": true,
                    "minimum": 0,
                }],
                "balloon": {
                    "borderThickness": 1,
                    "shadowAlpha": 0
                },
                "graphs": [{
                    "id": "g1",
                    "balloon": {
                        "drop": true,
                        "adjustBorderColor": false,
                        "color": "#ffffff"
                    },
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": "#FFFFFF",
                    "bulletSize": 5,
                    "hideBulletsCount": 50,
                    "lineThickness": 2,
                    "useLineColorForBulletBorder": true,
                    "valueField": "t",
                    "balloonText": "<span style='font-size:18px;'>[[t]]</span>"
                }],
                "chartCursor": {
                    "pan": true,
                    "valueLineEnabled": true,
                    "valueLineBalloonEnabled": true,
                    "cursorAlpha": 1,
                    "cursorColor": "#258cbb",
                    "limitToGraph": "g1",
                    "valueLineAlpha": 0.2,
                    "valueZoomable": true
                },
                "categoryField": "d",
                "categoryAxis": {
                    "dashLength": 1,
                    "minorGridEnabled": true
                },
                "export": {
                    "enabled": true
                },
            }),




        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_temp_distCtrl', grafica_temp_distCtrl);

    /** @ngInject */
    function grafica_temp_distCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, $rootScope, tempDistServices) {

        var chart = tempDistServices.chart;

        $scope.noInfo = false;
        $scope.loading = false;

        function QueryTempDistan() {
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.fecha_consulta = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

            var field = {
                "id_zona": SHAREServices.zona.id,
                "id_usuario": $localStorage.id_usuario,
               //token: SHAREServices.hash_decode_token($localStorage.token)
            };
            
            RESTServices.post_header('cliente/asociar_dispositivos_agrupador.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        chart.dataProvider = response.data;
                        reloadChart();
                        $scope.noInfo = false;
                    } else {
                        chart.dataProvider = [];
                        reloadChart();
                        $scope.noInfo = true;
                    }
                } else {
                    chart.dataProvider = [];
                    reloadChart();
                    $scope.noInfo = true;
                }
            });


        }

        function reloadChart() {
            chart.validateData();
            chart.write("grafica_temp_dist");
            chart.animateAgain();
            $scope.loading = false;
        };

        chart.addListener("clickGraphItem", handleClick);

        function handleClick(event) {
            $rootScope.$broadcast('tempPoint', { data: event.index });
        }

        QueryTempDistan();

    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_thpCtrl', grafica_thpCtrl);

    /** @ngInject */
    function grafica_thpCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, consumptionUtil, utilities) {


        $scope.noInfo = false;
        $scope.loading = false;

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFilter = SHAREServices.dateFilter;
        var chart;
        $scope.indicador = utilities.generarCodigo(20);
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.DateFormat = formato.day;


        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.consulta_comp();
        }

        /////////////
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = "humedity_temp_consumption" + " - " + SHAREServices.dispositivo_selected.nombre;
            $scope.$apply();
        }

        $scope.consulta_comp = function() {
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.fecha_consulta = SHAREServices.diaDatepicker;
            $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            getData('day');
        }

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '13') $scope.consulta_comp();
        })

        $timeout(function(){
            createGraphic()
            $scope.consulta_comp();
        });

        function createGraphic() {
            am4core.useTheme(am4themes_animated); 

            chart = am4core.create($scope.indicador, am4charts.XYChart);
            chart.paddingRight = 20;
            am4core.options.autoDispose = true;
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;

            var dateAxis2 = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis2.renderer.labels.template.disabled = true;

            var dateAxis3 = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis3.renderer.labels.template.disabled = true;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.labels.template.fill = am4core.color("#1F71E7");
            valueAxis.renderer.minWidth = 60;

            var valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis2.tooltip.disabled = true;
            valueAxis2.renderer.labels.template.fill = am4core.color("#E8A220");
            valueAxis2.renderer.minWidth = 60;
        // valueAxis2.syncWithAxis = valueAxis;

            var valueAxis3 = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis3.tooltip.disabled = true;
            valueAxis3.renderer.labels.template.fill = am4core.color("#F1D314");
            valueAxis3.renderer.minWidth = 60;
            //valueAxis3.syncWithAxis = valueAxis;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.name = "Humedad";
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";
            series.tooltipText = "Humedad: {valueY.value} %";
            series.fill = am4core.color("#1F71E7");
            series.stroke = am4core.color("#1F71E7");
            series.strokeWidth = 3;

            var series2 = chart.series.push(new am4charts.StepLineSeries());
            series2.name = "Temperatura";
            series2.dataFields.dateX = "tiempo2";
            series2.dataFields.valueY = "estado2";
            series2.yAxis = valueAxis2;
            series2.xAxis = dateAxis2;
            series2.tooltipText = "Temp: {valueY.value} C°";
            series2.fill = am4core.color("#E8A220");
            series2.stroke = am4core.color("#E8A220");
            series2.strokeWidth = 3;

            var series3 = chart.series.push(new am4charts.StepLineSeries());
            series3.name = "Potencia";
            series3.dataFields.dateX = "tiempo3";
            series3.dataFields.valueY = "estado3";
            series3.yAxis = valueAxis3;
            series3.xAxis = dateAxis3;
            series3.tooltipText = "Potencia: {valueY.value} W";
            series3.fill = am4core.color("#F1D314");
            series3.stroke = am4core.color("#F1D314");
            series3.strokeWidth = 3;

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis3;

            // Legenda
            chart.legend = new am4charts.Legend();

            // add exporting button
            //chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;

            valueAxis2.renderer.grid.template.strokeOpacity = 0.07;
            dateAxis2.renderer.grid.template.strokeOpacity = 0.07;
            dateAxis.renderer.grid.template.strokeOpacity = 0.07;
            valueAxis.renderer.grid.template.strokeOpacity = 0.07;
            dateAxis3.renderer.grid.template.strokeOpacity = 0.07;
            valueAxis3.renderer.grid.template.strokeOpacity = 0.07;
        }

        

        function getData(time) {
            var type = ['humidity', 'temp', 'consumption'];
            var allData = [];
            var promesas = type.map(function(d) {
                var field = {
                    "device_id": SHAREServices.dispositivo_selected.id,
                    "user_id": $localStorage.id_usuario,
                   //token: SHAREServices.hash_decode_token($localStorage.token),
                    "data": SHAREServices.diaDatepicker,
                    "time": time,
                    "type": d,
                    "offset": (new Date()).getTimezoneOffset()
                };
                return RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
            })

            Promise.all(promesas)
                .then(function(res) {
                    if (res[0].code === '200' && res[1].code === '200' && res[2].code === '200') {
                        res[0].data = addLastHour(res[0].data);
                        res[1].data = addLastHour(res[1].data);
                        res[2].data = consumptionUtil.addLastHour(res[2].data, SHAREServices.diaDatepicker, 'day');
                        res[0].data = formatData(res[0].data, 'tiempo', 'estado', true);
                        res[1].data = formatData(res[1].data, 'tiempo2', 'estado2', true);
                        res[2].data = formatData(res[2].data, 'tiempo3', 'estado3', false);
                        allData = res[0].data.concat(res[1].data, res[2].data);
                        chart.data = allData;
                        successfulResponse();
                    } else {
                        noInfo();
                    }
                    
                })
                .catch(function(error){
                   //console.log(error)
                    noInfo();
                })

            
        }

        function formatData(itm, nombre, valor, flat) {
            itm = itm.map(function(d, ind){
                var aux = {};
                aux[nombre] = flat ? SHAREServices.dateToLocal(d.tiempo,itm.length-1,ind,false) : d.tiempo;
                aux[valor] = d.estado;
                return aux;
            })
            return itm;
        }

        function addLastHour(data) {
            var index = data.length;
            var aux = {};
            if (SHAREServices.diaDatepicker == $filter('date')(new Date(), 'yyyy-MM-dd')) {
                aux.tiempo = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                aux.estado = data[index - 1].estado;
            } else {
                aux.tiempo = SHAREServices.diaDatepicker + ' 23:59:59';
                aux.estado = data[index - 1].estado;
            }
            data.push(aux);
            return data;
        }


        $scope.$on("$destroy", function () {
            chart.dispose();
        });

    }

        

})();
(function() {
    'use strict';
    angular.module('BlurAdmin').factory('useUtil', function(consumptionServices, SHAREServices, $filter) {
        return {

            formatResponse: function(data, parm) {
                switch (parm) {
                    case 'day':
                        data = data.map(function(d) {
                            var date = new Date((consumptionServices.year + '-' + SHAREServices.diaDatepicker.substring(5, 11)).replace(/-/g, '\/') + ' ' + d.time + ':00:00');
                            return ({
                                time: date,
                                value: Number(d.value < 0 ? 60: d.value),
                                date: $filter('date')(date, 'HH:mm'),
                                ind: 'min'
                            })
                        });
                        return data;
                        break;
                    case 'week':
                        this.sortWeek(SHAREServices.diaDatepicker, data);
                        /*data = data.map(function(d){
                                return ({
                                    time : d.time,
                                    value : Number(d.value)
                                })
                            });
                            return data;*/
                        break;
                    case 'month':
                        data = data.map(function(d) {
                            var date = new Date(consumptionServices.year + '-' + SHAREServices.diaDatepicker.substring(5, 7) + '-' + d.time + ' ' + '00:00:00');
                            return ({
                                time: new Date(consumptionServices.year + '-' + SHAREServices.diaDatepicker.substring(5, 7) + '-' + d.time + ' ' + '00:00:00'),
                                value: Number(d.value),
                                date: $filter('date')(date, 'MMM d, y'),
                                ind: 'horas'
                            })
                        });
                        return data;
                        break;
                    case 'year':
                        data = data.map(function(d) {
                            return ({
                                time: new Date(consumptionServices.year, d.time),
                                value: Number(d.value)
                            })
                        });
                        return data;
                        break;
                }
            },

            baseInterval: function(parm) {
                switch (parm) {
                    case 'day':
                        return {
                            "timeUnit": "hour",
                            "count": 1
                        };
                        break;
                    case 'week':
                    case 'month':
                        return {
                            "timeUnit": "day",
                            "count": 1
                        };
                        break;
                    case 'year':
                        return {
                            "timeUnit": "month",
                            "count": 1
                        };
                        break;
                }
            },

            sortWeek: function(date, data) {
                //const f = new Date(date + " " + "00:00:00");
                var f = new Date(date + " " + "00:00:00");
                var weekday = new Array(7);
                var lengthWeek = data.length;
                weekday[0] = "Sunday";
                weekday[1] = "Monday";
                weekday[2] = "Tuesday";
                weekday[3] = "Wednesday";
                weekday[4] = "Thursday";
                weekday[5] = "Friday";
                weekday[6] = "Saturday";

                var d = weekday[f.getDay()];
                var ind = data.findIndex(function(i) { return i.time == d })
                var down = data.slice(ind);
                var up = data.slice(0, ind);


                var weekdown = [];
                var fa = f;

                for (var i = 0; i < down.length; i++) {
                    var fh = fa;
                    var day = fh.setDate(fa.getDate() + i);
                    var aux = {
                        time: day,
                        value: down[i].value
                    }
                    weekdown.push(aux);
                    fh = undefined;
                    day = undefined;
                }

                /*var weekdown = down.map(function(i, index){
                    var fh = new Date();
                    return ({
                        time: new Date (fh.setDate(f.getDate() + index)),
                        value: i.value
                    })
                });
 
                var weekup = up.map(function(i, index){
                    var fh2 = new Date();
                    return ({
                        time: new Date (fh2.setDate(f.getDate() - (index + 1))),
                        value: i.value
                    })
                });*/

                var week = weekup.concat(weekdown);



            }




        }
    })
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('grafica_uso_aireCtrl', grafica_uso_aireCtrl);

    /** @ngInject */
    function grafica_uso_aireCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, consumptionServices, useUtil, $timeout, utilities) {


        $scope.parm = "day";
        $scope.noInfo = false;
        $scope.loading = false;
        $scope.type_graph = "use";

        $scope.DateFilter = SHAREServices.dateFilter;

        ///////control datepicker
        function open() {
            $scope.opened = true;
        }

        $scope.open = open;
        $scope.opened = false;
        var chart;
        $scope.indicador = utilities.generarCodigo(20);

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.DateFormat = consumptionServices.format.day;

        $scope.update_date = function() {
            SHAREServices.diaDatepicker = $filter('date')($scope.dt, 'yyyy-MM-dd');
            $scope.filtrar($scope.parm);
        }
        $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));

        /////////////////////////

        function loading(itm) {
            $scope.DateFilter.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.DateFilter.findIndex(function(i) { return i.id == itm });
            $scope.DateFilter[index].status = true;
            $scope.options.minMode = itm == 'week' ? 'day' : itm;
            $scope.indTime = itm == 'day' ? 'Minutos' : 'Horas';
            $scope.loading = true;
            $scope.noInfo = false;
            $scope.dt = new Date($filter('date')(SHAREServices.diaDatepicker, 'yyyy/MM/dd'));
            $scope.fecha_consulta = $scope.dt;
            $scope.DateFormat = consumptionServices.format[itm];
        };

        function setParameters(itm,offset) {
            return {
                "device_id": SHAREServices.dispositivo_selected.id,
                "user_id": $localStorage.id_usuario,
                "data": SHAREServices.diaDatepicker,
                "time": itm,
                "type": "use",
                "offset": offset
            };
        };

        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
        }

        $scope.filtrar = function(parm) {
            $scope.parm = parm;
            consumptionServices.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
            consumptionServices.day = SHAREServices.diaDatepicker.substring(0, 11);
            loading(parm);
            var d = new Date();
            var n = d.getTimezoneOffset();
            var field = setParameters(parm,n);

            RESTServices.post_header('cliente/graficas_comportamiento.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    if (response.data != undefined) {
                        response.data = useUtil.formatResponse(response.data, parm);
                        chart.data = response.data;
                        SHAREServices.uso_aire = response.data;
                        SHAREServices.flagUso_aire = !SHAREServices.flagUso_aire;
                        successfulResponse();
                    } else {
                        noInfo();
                    }

                } else {
                    noInfo();
                }
            });

        }

        $timeout(function(){
            createGraphic()
            $scope.filtrar($scope.parm)
        });

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '2' || result.data.tipo === '3' || result.data.tipo === '4' ) {
                if(RESTServices.post_pending === false){
                    $scope.filtrar($scope.parm);
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        $scope.filtrar($scope.parm);
                    },100)
                    
                }
                
            }
        })

        function createGraphic() {
            am4core.useTheme(am4themes_animated);
            // Themes end

            // Create chart instance
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            am4core.options.autoDispose = true;
            // Create axes
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;
            valueAxis.min = 0;

            // Create series
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.dateX = "time";
            series.dataFields.valueY = "value";

            series.name = "Uso";
            series.columns.template.tooltipHTML = "Fecha: <strong>{date}</strong><br>Uso: <strong>{valueY.value} {ind}</strong>";
            series.columns.template.fillOpacity = .8;

            var columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            chart.scrollbarX = scrollbarX;

            // add exporting button
            //chart.exporting.menu = new am4core.ExportMenu();
            chart.exporting.filePrefix = "use" + " - " + SHAREServices.dispositivo_selected.nombre;
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
        }
        


        

        
        $scope.$on("$destroy", function () {
            chart.dispose();
            RESTServices.cancelarSolicitudHttp();
        });

        
        // $scope.$watch(function() {
        //     return SHAREServices.flagUso_aire;
        // }, function() {
        //     $scope.fecha_consulta = SHAREServices.diaDatepicker;
        //     if ($scope.parm == "day")  series.columns.template.tooltipText = "[bold]{valueY.value}[/] min"; 
        //     else series.columns.template.tooltipText = "[bold]{valueY.value}[/] h";
        //     chart.data = SHAREServices.uso_aire;
            
        // });

        // $scope.$watch(function() {
        //     return SHAREServices.diaDatepicker;
        // }, function() {
        //     $scope.filtrar($scope.parm);
        // });


    }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('graficas_saegCtrl', graficas_saegCtrl);

    /** @ngInject */
    function graficas_saegCtrl($scope, SHAREServices, $localStorage, RESTServices, $filter, $timeout, utilities) {


        $scope.noInfo = false;
        $scope.loading = false;

        $scope.date = {
            fecha_ini: new Date(),
            fecha_final: new Date(),
        };

        $scope.open = function(itm) {
            $scope.popup[itm] = true;
        }

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.popup = {
            opened_1: false,
            opened_2: false
        };

        var formato = { day: 'yyyy-MM-dd', week: 'yyyy-MM-dd', month: 'yyyy-MM', year: 'yyyy' };
        $scope.DateFormat = formato.day;
        var chart;
        $scope.indicador = utilities.generarCodigo(20);

        $scope.update_date = function() {
            var start = $scope.date.fecha_ini;
            var end = $scope.date.fecha_final;
            consulta_comp($scope.point, start, end);
        }

        /////////////
        function noInfo() {
            chart.data = [];
            $scope.noInfo = true;
            $scope.loading = false;
        }

        function successfulResponse() {
            $scope.loading = false;
            $scope.noInfo = false;
            chart.exporting.filePrefix = $scope.variable + " - " + SHAREServices.dispositivo_selected.nombre;
        }

        function consulta_comp(point, start, end) {
            if(point) {
                $scope.loading = true;
                $scope.noInfo = false;
                $scope.variable = point.navName;
                $scope.unit = point.unit;
                $scope.year = $filter('date')(SHAREServices.diaDatepicker, 'yyyy');
                start = $filter('date')(start, 'yyyy-MM-dd');
                end = $filter('date')(end, 'yyyy-MM-dd');

                RESTServices.getPointHistorySaeg(point.id, start, end)
                    .then(function(response) {
                        var data = response.rows.map(function(r){
                            var index = r.ts.indexOf(' ');
                            return({
                                tiempo: new Date(r.ts.slice(0, index)),
                                estado: r.val.slice(0, 4),
                                hora: $filter('date')(new Date(r.ts.slice(0, index)), 'HH:mm'),
                                fecha: $filter('date')(new Date(r.ts.slice(0, index)), 'mediumDate')
                            })
                        })
                        SHAREServices.comportamiento_aire = data;
                        chart.data = SHAREServices.comportamiento_aire;
                        series.tooltipHTML = "Hora: <strong>{hora}</strong><br> " + $scope.variable + ": <strong>{valueY.value} " + $scope.unit + "</strong><br> Fecha: <strong>{fecha}</strong>"
                        successfulResponse();
                    })
                    .catch(function(error){
                        noInfo();
                    });
            }else {
                noInfo();
                $scope.variable = '';
                $scope.unit = '';
            }
            
        }

        $timeout(function(){
            createGraphic()
            //consulta_comp()
        });

        // $scope.$watch(function() {
        //     return SHAREServices.dispositivo_selected.id;
        // }, function() {
        //     consulta_comp();
        // });

        function createGraphic() {
            am4core.useTheme(am4themes_animated); 
            chart = am4core.create($scope.indicador, am4charts.XYChart);
            chart.paddingRight = 20;
            am4core.options.autoDispose = true;
            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;
            dateAxis.baseInterval = {
                "timeUnit": "second",
                "count": 1
            };

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            var series = chart.series.push(new am4charts.StepLineSeries());
            series.dataFields.dateX = "tiempo";
            series.dataFields.valueY = "estado";
            series.strokeWidth = 3;
            series.tooltipHTML = "Hora: <strong>{hora}</strong><br> " + $scope.variable + ": <strong>{valueY.value} " + $scope.unit + "</strong><br> Fecha: <strong>{fecha}</strong>"
            chart.cursor = new am4charts.XYCursor();
            chart.cursor.xAxis = dateAxis;
            chart.cursor.fullWidthLineX = true;
            chart.cursor.lineX.strokeWidth = 0;
            chart.cursor.lineX.fill = chart.colors.getIndex(2);
            chart.cursor.lineX.fillOpacity = 0.1;

            var scrollbarX = new am4charts.XYChartScrollbar();
            scrollbarX.series.push(series);
            chart.scrollbarX = scrollbarX;

            //chart.exporting.menu = new am4core.ExportMenu();
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
        }

        



        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        $scope.$on('saegVarible', function(event, result) {
            $scope.point = result.data;
            consulta_comp(result.data, $scope.date.fecha_ini, $scope.date.fecha_final);
        })

    }

        

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('maintenanceCardCtrl', maintenanceCardCtrl);

    /** @ngInject */
    function maintenanceCardCtrl($scope, $filter, $state, $timeout, $window, $rootScope) {
        $scope.id;
        $scope.listaOrden = ['Todos','Mayor a menor', 'Menor a mayor','Necesitan mantenimiento', 'No requieren mantenimiento'];
        $scope.print = false;
        var control;

        $scope.$on('devicesMaintenance', function(event, result){
            $scope.id = result.id_zona;
            control = result.control;
            $scope.devices = result.dispositivos;
            $scope.devicesFiltered = $scope.devices;
            $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, '-horas_uso');
        });

        $scope.get_maintenances = function(id) {
            $scope.devicesFiltered = [];
            var rol = $scope.zones.filter(function(z){return z.id === id})[0].rol;
            $rootScope.$broadcast('getDevicesMaintenance', {id: id, rol: rol});
        }
        
        $scope.filterOrderBy = function(e) {
            switch(e) {
                case 'Todos':
                    $scope.devicesFiltered = $scope.devices;
                    break;
                case 'Mayor a menor':
                    $scope.devicesFiltered = $scope.devices;
                    $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, '-horas_uso');
                    break;
                case 'Menor a mayor':
                    $scope.devicesFiltered = $scope.devices;
                    $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, 'horas_uso');
                    break;
                case 'Necesitan mantenimiento':
                    $scope.devicesFiltered = $scope.devices;
                    $scope.devicesFiltered = $filter('filter')($scope.devicesFiltered, {filter: 'red'});
                    $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, '-horas_uso');
                    break;
                case 'No requieren mantenimiento':
                    $scope.devicesFiltered = $scope.devices;
                    $scope.devicesFiltered = $filter('filter')($scope.devicesFiltered, {filter: 'green'});
                    $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, '-horas_uso');
                    break;
                
            }
        }

        $scope.goMantenimientoLog = function(device) {
            $state.go('mantenimiento_log', {device:device, control: control});
        }
        $scope.search = function(ind) {
            $scope.devicesFiltered = $scope.devices;
            $scope.devicesFiltered = $filter('filter')($scope.devicesFiltered, {nombre:ind});
            if(ind = '') $scope.devicesFiltered = $scope.devices;
        }

        $scope.imprimirTodos = function() {
            $scope.print = true;
            $scope.devicesFiltered = $scope.devices;
            $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, '-horas_uso');
            $timeout(function() {
                $window.print();
                $scope.devicesFiltered = $scope.devices;
                $scope.print = false;
            }, 1);
        }

        $scope.imprimirM = function() {
            $scope.print = true;
            $scope.devicesFiltered = $scope.devices;
            $scope.devicesFiltered = $filter('filter')($scope.devicesFiltered, {filter: 'red'});
            $scope.devicesFiltered = $filter('orderBy')($scope.devicesFiltered, '-horas_uso');
            $timeout(function() {
                $window.print();
                $scope.devicesFiltered = $scope.devices;
                $scope.print = false;
            }, 1);
        }

        
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('maintenanceCard', maintenanceCard);
  
    /** @ngInject */
    function maintenanceCard() {
      return {
        restrict: 'E',
        controller: 'maintenanceCardCtrl',
        templateUrl: 'app/cliente/mantenimiento/components/maintenanceCard/maintenanceCard.html',
        scope: {
          devices: "=devices",
          clients: "=clients",
          noInfo: "=noInfo",
          loading: "=loading",
          zones: "=zones",
        }
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('filterMaintenanceCtrl', filterMaintenanceCtrl);

    /** @ngInject */
    function filterMaintenanceCtrl($scope, $timeout, $filter, RESTServices, $localStorage, $rootScope, SHAREServices) {
        
        $scope.filtrar = function(parm) {
            $scope.categoryFilter = parm;
            var filtered = $scope.client.dispositivos.filter(function(d){
                return d.filter == parm;
            });
           
            if(parm == ''){
                filtered = $scope.client.dispositivos;
            }
            $scope.totalItems = filtered.length;
            $scope.currentPage = 1;
        }

        


    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('filterMaintenance', filterMaintenance);
  
    /** @ngInject */
    function filterMaintenance() {
      return {
        restrict: 'E',
        controller: 'filterMaintenanceCtrl',
        templateUrl: 'app/cliente/mantenimiento/components/filterMaintenance/filterMaintenance.html',
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('solicitarMantenimientoCtrl', solicitarMantenimientoCtrl);

    /** @ngInject */
    function solicitarMantenimientoCtrl($scope, RESTServices, $localStorage, toastr, ngDialog, $stateParams, SHAREServices, $state) {
        
        $scope.solicitarMantenimiento = function(){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/solicitarMantenimiento.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    if($stateParams.device.email_encargado) {
                        if ($stateParams.device.email_encargado === "") {
                            $scope.noEncargado = true;
                        } else {
                            $scope.infoDevice = $stateParams.device;
                            $scope.infoDevice.email_encargado = Array.isArray($scope.infoDevice.email_encargado) ? $scope.infoDevice.email_encargado : $scope.infoDevice.email_encargado === "" ? $scope.infoDevice.email_encargado : $scope.infoDevice.email_encargado.split(",");
                            $scope.noEncargado = false;
                        }

                    } else {
                        if ($stateParams.device.caracteristicas) {
                            $scope.infoDevice = $stateParams.device;
                            var email = $scope.infoDevice.caracteristicas.find(function(c){ return c.id == '6'}).valor;
                            if (email !== "") {
                                $scope.infoDevice.email_encargado = Array.isArray(email) ? email : email === "" ? email: email.split(",");
                                $scope.noEncargado = false;
                            } else {
                                $scope.noEncargado = true;
                            }
                            
                        } else {
                            $scope.noEncargado = true;
                        }
                    }
                    
                    

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.aceptar = function() {
                        var params = {
                                id_usuario: $localStorage.id_usuario,
                                nombre_dispositivo: $scope.infoDevice.nombre,
                                nombre_zona: $scope.infoDevice.nombre_zona,
                                nombre_cliente: $localStorage.nombre_cliente,
                                email_encargado: $scope.infoDevice.email_encargado, 
                                id_dispositivo: $scope.infoDevice.id_device,
                                hash: SHAREServices.hash_encode($scope.infoDevice.id_device),
                            };
                            RESTServices.post_header('cliente/solicita_mantenimiento.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                                if (res.code == 200) {
                                    ngDialog.close();
                                    createTicket($scope.infoDevice);
                                    toastr.success('Solicitud enviada con exito', 'Mantenimiento');
                                } else {
                                    ngDialog.close();
                                    toastr.error('No se ha podido enviar la solicitud. Intenta de nuevo más tarde', 'Mantenimiento');
                                }
                            });
                        
                    }

                    $scope.goApparatusProfile = function() {
                        ngDialog.close();
                        $state.go('mantenimiento_apparatusProfile', {device: $scope.infoDevice})
                    }

                    function istecnicoHelo(email) {
                        var dominio = email.split('@')[1];
                        return dominio === 'intelmotics.com' || 'helo.com.co' ? true : false;
                    }

                    function createTicket(data) {
                        var selected_devices = [];
                        selected_devices.push(data.id_device);
                        var ticket = {
                            estado: '0',
                            id_zona: data.id_zona,
                            id_tecnico: data.id_tecnico ? data.id_tecnico : '464',
                            dispositivos: JSON.stringify(selected_devices),
                            texto: 'Solicitud de nuevo mantenimiento',
                            id: 0,
                            id_creador: $localStorage.id_usuario,
                            descripcion: 'El cliente ' +  $localStorage.nombre_cliente + ' ha solicitado un mantenimiento en el equipo ' + data.nombre + ' ubicado en la zona ' + data.nombre_zona,
                        }
                        var fields = {
                            "id_usuario": $localStorage.id_usuario,
                            "ticket": JSON.stringify(ticket)
                        };

                        RESTServices.post_header('cliente/edita_tickets.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                            if (res != null && res.code == '200') {
                                ngDialog.close();
                                toastr.success('Solicitud enviada con exito', 'Mantenimiento');
                            } else{
                                ngDialog.close();
                                toastr.error('No se ha podido enviar la solicitud. Intenta de nuevo más tarde', 'Mantenimiento');
                            }
                        });
                    }

                }]
            });
        } 

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('solicitarMantenimiento', solicitarMantenimiento);
  
    /** @ngInject */
    function solicitarMantenimiento() {
      return {
        restrict: 'E',
        controller: 'solicitarMantenimientoCtrl',
        templateUrl: 'app/cliente/mantenimiento/components/solicitarMantenimiento/solicitarMantenimiento.html',
        scope: {
            device: '=device',
        },
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('maintenanceTabsCtrl', maintenanceTabsCtrl);

    /** @ngInject */
    function maintenanceTabsCtrl($scope, $timeout, $filter, RESTServices, $localStorage, $rootScope, SHAREServices) {
        
        $scope.tabActive = 0;
        $scope.currentPage = 1;
        $scope.itemsPerPage = 6;
        $scope.filterActivo = false;

        $scope.tabs = [
            {
                id: 0,
                name: 'Mis dispositivos',
                status: true,
            },
            {
                id: 1,
                name: 'Dispositivos compartidos',
                status: false,
            }
        ];

        $scope.clientes = ['universidad', 'mi casa', 'oficina', 'otro lugar']
        
        $scope.selectTab = function(itm){
            $scope.tabs.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.tabs.findIndex(function(i) { return i.id == itm.id });
            $scope.tabs[index].status = true;
            $scope.tabActive = itm.id;
        }

        $scope.selectClient = function(client, e){
            var zonesNames = [];
            $scope.filteredZones = [];
            client.dispositivos.forEach(function(d) {
                if(zonesNames.findIndex(function(z){return z == d.nombre_zona}) == -1){
                    zonesNames.push(d.nombre_zona)
                }
            })

            zonesNames.map(function(d){
                var dispositivos = $filter('filter')(client.dispositivos, {nombre_zona : d});
                var zona = {
                    nombre: d,
                    dispositivos : dispositivos
                }
                $scope.filteredZones.push(zona)
            });

            if(e.target.classList.contains('cont-client-active')){
                e.target.classList.remove('cont-client-active')
            }else{
                e.target.classList.add('cont-client-active')
            }

            
        }

        $scope.filtrar3 = function(buscar) {
            $scope.filterActivo = true;
            $scope.filtered = $filter('filter')($scope.client.dispositivos, { nombre: buscar });
            $scope.filtered = $filter('orderBy')($scope.filtered, 'nombre');
            $scope.totalItems = $scope.filtered.length;
            $scope.noOfPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);
            $scope.currentPage = 1;
        }

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('maintenanceTabs', maintenanceTabs);
  
    /** @ngInject */
    function maintenanceTabs() {
      return {
        restrict: 'E',
        controller: 'maintenanceTabsCtrl',
        templateUrl: 'app/cliente/mantenimiento/components/maintenanceTabs/maintenanceTabs.html',
        scope: {
            zones: '=zones',
            clients: '=clients'
        },
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('maintenance_limitCtrl', maintenance_limitCtrl);

    /** @ngInject */
    function maintenance_limitCtrl($scope, RESTServices, $localStorage,  $stateParams, SHAREServices, toastr) {
        $scope.limite;
        $scope.editar_limite = false;
        $scope.nuevo_limite = {
            valor: 0
        };
        
        // v2: migrated from consulta_limite.php
        RESTServices.fetchDeviceLimitV2($stateParams.device.id_device ? $stateParams.device.id_device : $stateParams.device.id).then(function(data) {
                if (data != null) {
                if (data.code == '200') {
                    $scope.limite = Number(data.limite);
                    //$rootScope.$broadcast('updateLimitMaintenance', { data: data.limite });
                }
            }
        });    
        
        $scope.abrirEditar = function() {
            $scope.editar_limite = !$scope.editar_limite;
            $scope.nuevo_limite.valor = $scope.limite;
        }
        $scope.cerrarEditar = function() {
            $scope.editar_limite = false;
        }

        $scope.guardarNuevoLimite = function() {
            if ($scope.nuevo_limite.valor == null) {
                $scope.nuevo_limite.valor = 0;
            }

            var deviceId = $stateParams.device.id_device ? $stateParams.device.id_device : $stateParams.device.id;
            var nuevoLimite = parseInt($scope.nuevo_limite.valor, 10) || 0;

            RESTServices.setDeviceLimitV2(deviceId, nuevoLimite).then(function() {
                $scope.limite = nuevoLimite;
                $scope.editar_limite = false;
                $scope.nuevo_limite.valor = 0;
                //$rootScope.$broadcast('updateLimitMaintenance', { data: $scope.limite});
            }).catch(function() {
                toastr.error('No se pudo cambiar el límite', 'Límite mantenimiento');
            });
        }



    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('maintenanceLimit', maintenanceLimit);
  
    /** @ngInject */
    function maintenanceLimit() {
      return {
        restrict: 'E',
        controller: 'maintenance_limitCtrl',
        templateUrl: 'app/cliente/mantenimiento/directives/maintenance_limit/maintenance_limit.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('apparatus_profileCtrl', apparatus_profileCtrl);

    /** @ngInject */
    function apparatus_profileCtrl( $scope, $stateParams, $timeout, maintenanceServices, $filter, toastr, SHAREServices, $state, $localStorage, RESTServices, ApparatusForms, ngDialog) {
        if($stateParams.device == null) {
            $state.go('mantenimiento');
        } else {

            $scope.type = $stateParams.device.tipo;
            $scope.control_d = $stateParams.control;
            $scope.link = 'https://helo.intelmotics.com/#/maintenanceLog/' + SHAREServices.hash_encode($stateParams.device.id ? $stateParams.device.id : $stateParams.device.id_device);
            getInfoDevice($stateParams.device.id ? $stateParams.device.id : $stateParams.device.id_device);
        }

        $scope.type;
        $scope.device = $stateParams.device;
        $scope.images = [];
        $scope.rol_ind = $localStorage.rol;

        $scope.tabs = [
            {
                name: 'General',
                selected: true,
                index: 0,
            },
            {
                name: 'Caraterísticas',
                selected: false,
                index: 1,
            },
            {
                name: 'Encargado',
                selected: false,
                index: 2,
            },
            {
                name: 'Galería',
                selected: false,
                index: 3,
            },
        ]

        $scope.indtab = 0;

        $scope.selectTab = function(ind) {
            $scope.indtab = ind;
            $scope.tabs.map(function(t){t.selected = false})
            $scope.tabs[ind].selected = true
        }

        $scope.liberarEquipo = function(device){
            if(device.registro){
                ngDialog.open({
                    template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                    className: 'ngdialog-theme-plain',
                    scope: $scope,
                    closeByDocument: true,
                    controller: ['$scope', function($scope) {
                        $scope.bodyModal = "¿Deseas desvincular este equipo del dispositivo Helo?";
                        
                        $scope.cancelar = function() {
                            ngDialog.close();
                        };
                        $scope.aceptar = function() {  
                            if($scope.rol_ind === '12'){
                                var params = {
                                    "id_usuario": $localStorage.id_usuario,
                                    "id_dispositivo": device.id ? device.id : device.id_device,
                                };
        
                                RESTServices.post_header('cliente/liberar_dispositivo.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                                    if (data != null) {
                                        if (data.code == '200') {
                                            toastr.success('El dispositivo ha sido liberado con éxito');
                                            getInfoDevice($stateParams.device.id ? $stateParams.device.id : $stateParams.device.id_device);
                                            ngDialog.close();                                     
                                        }else{
                                            toastr.error('Hubo un problema inesperado');
                                            ngDialog.close(); 
                                        }
                                    }else{
                                        toastr.error('Hubo un problema inesperado');
                                        ngDialog.close();  
                                    }  
                                });
                            }
                            
                        }
                    }]
                })
            } else {
                toastr.warning('El dispositivo ya está liberado');
            }
            
        }
        

        $scope.copy = function(){
            var text = document.getElementById("textToCopy").innerText;
            navigator.clipboard.writeText(text).then(function() {
                toastr.success('Código copiado correctamente');
            }).catch(function(error) {
                toastr.error('Código copiado correctamente');
            });
            
        }

        function getInfoDevice(id) {
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "id_dispositivo": id,
            };

            RESTServices.post_header('cliente/consulta_dispositivo.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code === "200") {
                    $scope.apparatusProfile = res.dispositivo;
                    getDeviceImages(id);
                    if ($scope.apparatusProfile.caracteristicas){
                        var type;
                        var todos = [];
                        if ($scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '2'})) {
                            type = $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '2'}).valor;
                        }
                        var caracteristicas = ApparatusForms.selectform(type);
                        if (caracteristicas) {
                            $scope.deviceCaracteristicas = [];
                            caracteristicas.forEach(function(c) {
                                c.caracteristicas.forEach(function(itm) {
                                    todos.push(itm);
                                });
                            });

                            todos.forEach(function(c) {
                                var caracteristica = $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id == c.id});
                                if (caracteristica) {
                                    var valor = caracteristica.valor;
                                    var itm = {
                                        id: c.id,
                                        titulo: c.titulo,
                                        nombre: c.nombre,
                                        unidad: c.unidad,
                                        options: c.options ? c.options : null,
                                        valor: valor,
                                    }
                                    $scope.deviceCaracteristicas.push(itm);

                                }
                            });
                        }
                        
                        
                        if (type){
                            $scope.apparatusProfile.tipo_ = $filter('filter')(maintenanceServices.deviceType, { value: type}, true)[0];
                        }
                        $scope.apparatusProfile.marca = $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '1'}) ? $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '1'}).valor : '';
                        $scope.apparatusProfile.serie = $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '3'}) ? $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '3'}).valor : '';
                        $scope.apparatusProfile.referencia = $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '4'}) ? $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '4'}).valor : '';
                        $scope.apparatusProfile.nombre_encargado = $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '5'}) ? $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '5'}).valor : '';
                        if ($scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '6'})) {
                            var emalis = $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '6'}).valor;
                            $scope.apparatusProfile.email_encargado = Array.isArray(emalis) ? emalis : emalis === "" ? emalis : emalis.split(",");
                        } else {
                            $scope.apparatusProfile.email_encargado = '';
                        }
                        $scope.apparatusProfile.tel_encargado = $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '7'}) ? $scope.apparatusProfile.caracteristicas.find(function(d) { return d.id === '7'}).valor : '';
                        
                    } else {
                        $scope.apparatusProfile.tipo_ = $filter('filter')(maintenanceServices.deviceType, { value: $scope.apparatusProfile.tipo_}, true)[0];
                        if ($scope.apparatusProfile.email_encargado) {
                            $scope.apparatusProfile.email_encargado = Array.isArray($scope.apparatusProfile.email_encargado) ? $scope.apparatusProfile.email_encargado : $scope.apparatusProfile.email_encargado === "" ? $scope.apparatusProfile.email_encargado : $scope.apparatusProfile.email_encargado.split(",");
                        }
                    }
                }
            });
        };

        function getDeviceImages(id) {
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "id_contenedor": id,
                "tipo": 3
            };

            RESTServices.post_header('cliente/consulta_imagenes.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code === "200") {
                    $scope.images = res.imagenes;
                    $scope.apparatusProfile.imagenes = res.imagenes;
                }
            })    
        }
        

        $scope.goEdit = function(device) {
            $state.go('mantenimiento_newApparatus', {apparatus:device, control: $stateParams.control})
        }

        $scope.goSettings = function(device) {
            var type= device.tipo;
            switch(type) {
                case '2':
                case '3':
                case '29':
                case '21':
                    $state.go('device_settings', {device:device, control: $stateParams.control})
                    break;
                case '4':
                    $state.go('device_settings_helo_t', {device:device, control: $stateParams.control})
                    break;
                case '5':
                case '16':
                case '22':
                case '23':
                    $state.go('device_settings_helo_s', {device:$stateParams.device, control: $stateParams.control})
                    break;
                case '6':
                case '28':
                    $state.go('device_settings_helo_th', {device: device, control: $stateParams.control})
                    break;
                case '14':
                case '15':
                case '27':
                case '31':
                    if(device.tipo !== '31'){
                        $state.go('device_settings_hub', {device: device, control: $stateParams.control, devices: $stateParams.devices})
                    } else {
                        if(device.registro){
                            $state.go('device_settings_hub', {device: device, control: $stateParams.control, devices: $stateParams.devices})
                        } else {
                            toastr.warning('Debes agregar primero dispositivos al hub master', 'Configuración')
                        }
                    }
                    break;
                case '30':
                    $state.go('device_settings_virtual', {device:device, control: $stateParams.control})
                    break;
                case '32':
                    $state.go('device_settings_tipo_dispositivo', {device:device, control: $stateParams.control})
                    break;
            }
            
        }
        $scope.goAddDevicesHub = function(device) {
            $state.go('device_settings_hub_master', {device: device, control: $stateParams.control, devices: $stateParams.devices})
        }

        $scope.showImage = function(index) {
            ngDialog.open({
                template: 'app/cliente/monitoreo/modales/slider-ticket.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.asunto = $scope.apparatusProfile.nombre;
                    $scope.images = $scope.images;
                    $scope.active = index;
                }]
            });
        }

    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('maintenance_detailCtrl', maintenance_detailCtrl);

    /** @ngInject */
    function maintenance_detailCtrl($scope, $window, $localStorage, RESTServices, $stateParams, $timeout, maintenanceServices, SHAREServices, $state, ngDialog) {
        
        $scope.profile = $localStorage.client;
        
        if($stateParams.maintenance == null){
            $state.go('mantenimiento');
            return;
        }

        $scope.maintenance = $stateParams.maintenance;
        $scope.device = $stateParams.device;
        $scope.printerView = true;
        $scope.listasDeChequeo = [];

        $timeout(function(){
            
            var fields = {
                "id_usuario": $localStorage.id_usuario,
                "id_contenedor": $scope.maintenance.id_mantenimiento,
                "tipo": 2
            };

            RESTServices.post_header('cliente/consulta_imagenes.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code === "200") {
                    $scope.maintenance.imagenes = res.imagenes;
                }
            })
        })

        /////////formateo de datos
        if($scope.maintenance.repuestos) {
            $scope.maintenance.repuestos = $scope.maintenance.repuestos.split(',');
        }
        // fecha_actualizacion / fecha_proximo are null when never set: keep null instead of an Invalid Date.
        $scope.maintenance.fecha_actualizacion = $scope.maintenance.fecha_actualizacion ? new Date($scope.maintenance.fecha_actualizacion) : null;
        $scope.maintenance.fecha = new Date($scope.maintenance.fecha); 

        $scope.maintenance.fecha_proximo = $scope.maintenance.fecha_proximo ? new Date($scope.maintenance.fecha_proximo) : null;

        // chequeos is a native array (the API no longer returns a JSON-encoded string).
        if(Array.isArray($scope.maintenance.chequeos) && $scope.maintenance.chequeos.length){
            
            // Todas las listas de chequeo disponibles, sin filtrar por tipo de dispositivo
            var listasDeChequeoDisponibles = maintenanceServices.checkList_mantenimientos;
            
            // id_chequeo arrives as a number while the activity catalog uses string ids
            // (and selectActivity compares strictly); unknown ids are skipped, not fatal.
            var listaDeChequeoDelMantinimiento = $scope.maintenance.chequeos.map(function(c){
                var actividad = maintenanceServices.selectActivity(String(c.id_chequeo))[0];
                if (!actividad) {
                    return null;
                }
                c.valor = String(c.valor || '').split(',');
                return({
                    id: String(c.id_chequeo),
                    id_lista_mantenimiento: actividad.id_lista_mantenimiento,
                    description: actividad.descripcion,
                    chequeo: c.chequeo == 0 ? 'No' : c.chequeo == 1 ? 'Sí' : 'NA',
                    valores: c.valor.reduce(function(acc, cur, i) {
                        acc[i] = cur;
                        return acc;
                    }, {})
                })
            }).filter(Boolean)

            listasDeChequeoDisponibles.forEach(function(itm){
                var lista = listaDeChequeoDelMantinimiento.filter(function(ls){
                    return ls.id_lista_mantenimiento === itm.id
                })
                if(lista.length > 0){
                    var list = {
                        nombre: itm.nombre,
                        lista: lista
                    }
                    $scope.listasDeChequeo.push(list)
                } 
            })
        }

        $scope.showImage = function(index) {
            ngDialog.open({
                template: 'app/cliente/monitoreo/modales/slider-ticket.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.asunto = 'Mantemimiento ' + $scope.maintenance.consecutivo;
                    $scope.images = $scope.maintenance.imagenes;
                    $scope.active = index;
                }]
            });
        }
        


        /////////
        $scope.imprimir = function() {
            $scope.printerView = false;
            $timeout(function() {
                $window.print();
                $scope.printerView = true;
            }, 1);
        }
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('actionListCtrl', actionListCtrl);

    /** @ngInject */
    function actionListCtrl($scope, $rootScope) {
        
        

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('actionList', actionList);
  
    /** @ngInject */
    function actionList() {
      return {
        restrict: 'E',
        controller: 'actionListCtrl',
        templateUrl: 'app/cliente/mantenimiento/new_maintenance/actionList/actionList.html',
        scope:{
            list: '=list'
        }
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('checkListCtrl', checkListCtrl);

    /** @ngInject */
    function checkListCtrl($scope, $rootScope) {
        
        $scope.chequeos_aux = [];
        $scope.value_aux = 1;

        $scope.setCheck = function(state, key, id_lista){
            if($scope.chequeos_aux[key]==undefined)$scope.chequeos_aux[key] = {id_chequeo: key, chequeo: state, valor: null, id_lista_mantenimiento: id_lista};
            else $scope.chequeos_aux[key].chequeo = state;
            $rootScope.$broadcast('checkListModel', {data: $scope.chequeos_aux[key], key: key});
        }

        $scope.setValue = function(state, key, value, id_lista){
            if($scope.chequeos_aux[key]==undefined)$scope.chequeos_aux[key]={id_chequeo: key, chequeo: null, valor: null, id_lista_mantenimiento: id_lista};
            if($scope.chequeos_aux[key].valor==null)$scope.chequeos_aux[key].valor=state;
            else{
              if($scope.value_aux == value){
                  if($scope.chequeos_aux[key].valor.split(',').length == 1)$scope.chequeos_aux[key].valor = state;
                  else {
                    $scope.chequeos_aux[key].valor=$scope.chequeos_aux[key].valor.replace(/,[^,]+$/, ","+state);
                  }   
              }else {
                $scope.chequeos_aux[key].valor = $scope.chequeos_aux[key].valor+","+state;
                $scope.value_aux = value;
              }
            } 
            $rootScope.$broadcast('checkListModel', {data: $scope.chequeos_aux[key], key: key});
        }
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('checkList', checkList);
  
    /** @ngInject */
    function checkList() {
      return {
        restrict: 'E',
        controller: 'checkListCtrl',
        templateUrl: 'app/cliente/mantenimiento/new_maintenance/checkList/checkList.html',
        scope:{
            item: '=item',
            par: '=par'
        }
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo')
        .controller('advancedFiltersCtrl', advancedFiltersCtrl);

    /** @ngInject */
    function advancedFiltersCtrl($scope, RESTServices, $localStorage, monitoringServices, $timeout, SHAREServices, $filter, $rootScope, consumoServices) {

        $scope.statusOptions = monitoringServices.statusOptions;
        $scope.priority = monitoringServices.priority;
        $scope.loading_t = true;
        $scope.params = {
            estado: null,
            prioridad: null,
            id_zona:null,
            id_tecnico:null,
            fecha_ini: null,
            fecha_fin: null,
        }

        $scope.date = {};

        $scope.DateFormat = consumoServices.formato.day;
        
        $scope.open = function(itm) {
            $scope.popup[itm] = true;
        }

        $scope.options = {
            showWeeks: false,
            minMode: 'day',
            maxDate: new Date()
        };

        $scope.popup = {
            opened_1: false,
            opened_2: false
        };

        $timeout(function() {

            if (SHAREServices.zonas === null) {
                $scope.loading = true;
                var params = {
                    "id_usuario": $localStorage.id_usuario,
                };
                ////query zonas
                RESTServices.fetchClientZones().then(function(data) {
                    if (data != null && data.code == '200') {
                        if(data.zonas) {
                            $scope.zonas = data.zonas;
                        } 
                        if(data.zonas_externas) {
                            $scope.zonas = $scope.zonas.concat(data.zonas_externas)
                        }
                        $scope.zonas = $filter('orderBy')($scope.zonas, 'nombre');
                        $scope.zonas = $filter('filter')($scope.zonas, {h : '0'});
                        $scope.zonas = $scope.zonas.map(function(z, i) {
                            z.index = i;
                            return z;
                        })
                        SHAREServices.zonas = $scope.zonas;
                        $scope.loading = false;
                    }else{
                        $scope.loading = false;
                        $scope.noInfo = true;
                    }
                });
            } else {
                $scope.zonas = SHAREServices.zonas; 
            }

            var params = {
                "id_usuario": $localStorage.id_usuario,
                "id_monitoreo": 0,
            };

            RESTServices.post_header('cliente/consulta_tecnicos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null && data.code == '200') {
                    $scope.tecnicos = data.tecnicos;
                    $scope.loading_t = false;
                }  

            }); 



             
        });

        $scope.setFilters = function() {
            $scope.error_fecha_2 = false;
            $scope.error_fecha_1 = false;
            console.log($scope.params);
            if ($scope.date.fecha_ini && $scope.date.fecha_fin) {
                if ($scope.date.fecha_fin > $scope.date.fecha_ini) {
                    $scope.params.fecha_ini = $filter('date')($scope.date.fecha_ini, 'yyyy-MM-dd HH:mm:ss');
                    $scope.params.fecha_fin = $filter('date')($scope.date.fecha_fin, 'yyyy-MM-dd HH:mm:ss');
                    $rootScope.$broadcast('setFilters', {data: $scope.params})
                } else {
                    $scope.error_fecha_2 = true;
                }
            } else {
                if($scope.date.fecha_ini || $scope.date.fecha_fin) {
                    $scope.error_fecha_1 = true;
                    return;
                } 
                $rootScope.$broadcast('setFilters', {data: $scope.params})
            }
        } 

        $scope.resetFilters = function() {
            $scope.params = {
                estado: null,
                id_zona: null,
                prioridad: null,
                id_tecnico: null,
                fecha_ini: null,
                fecha_fin: null,
            }
            $scope.date = {};
            $rootScope.$broadcast('setFilters', {data: null})
        }

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.monitoreo')
        .directive('advancedFilters', advancedFilters);
  
    /** @ngInject */
    function advancedFilters() {
      return {
        restrict: 'E',
        controller: 'advancedFiltersCtrl',
        templateUrl: 'app/cliente/monitoreo/components/advanced-filters/advanced-filters.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo')
        .controller('tableTecnicosCtrl', tableTecnicosCtrl);

    /** @ngInject */
    function tableTecnicosCtrl($scope, RESTServices, $localStorage, ngDialog, SHAREServices, $state, toastr, $rootScope) {

        $scope.loading = false;
        $scope.ind = false;
        
        $scope.editarTecnico = function(tecnico){
            $state.go('monitoring.newTechnical', {tecnico: tecnico})
        }

        $scope.showZonas = function(tecnico) {
            $scope.loading = true;
            ngDialog.open({
                template: 'app/cliente/monitoreo/modales/zonas-compartidas.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.tecnico = tecnico;
                    RESTServices.fetchUserSharedZonesV2(tecnico.id).then(function(data) {
                        if (data != null && data.code == '200') {
                            $scope.zonas = data.zonas_externas;
                        }else {
                            $scope.ind = true;
                        } 
                        $scope.loading = false;
                    })
                }]
            });
        }

        $scope.borrarTecnico = function(tecnico) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                closeByDocument: false,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = '¿Realmente desea borrar este técnico?';

                    $scope.cancelar = function() {
                        ngDialog.close();
                    }

                    $scope.aceptar = function() {
                        var field = {
                            id_usuario: $localStorage.id_usuario,
                            id: tecnico.id
                        };

                        RESTServices.post_header('admin/eliminar_usuario.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                            if (data != null) {
                                if (data.code == '200') {
                                    ngDialog.close();
                                    toastr.success('Se ha eliminado el técnico correctamente', 'Eliminar técnico')
                                    $rootScope.$broadcast('technicalDeleted', {data: tecnico});
                                }else{
                                    toastr.error('No se puede conectar en este momento', 'Eliminar técnico');   
                                }
                            }else{
                                toastr.error('No se puede conectar en este momento', 'Eliminar técnico');
                            }
                        });                        
                    }
                }]
            });
        }

        

        $scope.$on("$destroy", function () {
            ngDialog.close();
        });
        

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.monitoreo')
        .directive('tableTecnicos', tableTecnicos);
  
    /** @ngInject */
    function tableTecnicos() {
      return {
        restrict: 'E',
        controller: 'tableTecnicosCtrl',
        scope: {
            tecnicos: '=tecnicos',
        },
        templateUrl: 'app/cliente/monitoreo/components/table-tecnicos/table-tecnicos.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo')
        .controller('tableTicketsCtrl', tableTicketsCtrl);

    /** @ngInject */
    function tableTicketsCtrl($scope, RESTServices, $localStorage, monitoringServices, SHAREServices, $state, toastr, $filter, $rootScope, ngDialog) {


        $scope.statusOptions = monitoringServices.statusOptions;

        $scope.setStatus = function(status, data) {

            var ticket = data;
            ticket.estado = status;
            
            var field = {
                "id_usuario": $localStorage.id_usuario,
                "ticket": JSON.stringify(ticket)
            };

            RESTServices.post_header('cliente/edita_tickets.php', field, SHAREServices.hash_decode_token($localStorage.token),true)
            .then(function(response) {
                if (response != null && response.code == '200') {
                    if(status === '3'){
                        $rootScope.$broadcast('deletedTicket', {ticket: ticket});
                    }else {
                        toastr.success('Estado del ticket cambiado con éxito');
                    }
                } else{
                    toastr.error('Hubo un problema inesperado');
                }
            })
        }

        

        $scope.gotoTicket = function(ticket) {
            $state.go('monitoring.ticket', {ticket: ticket})
        }

        $scope.changeToLocal = function(dia) {
            var date = new Date(dia.replace(' ', 'T') + 'Z');
            return $filter('date')(date, 'MMM d, y - HH:mm')
        };

        $scope.setPriority = function(ind) {
            switch (ind) {
                case '0':
                    return 'Media';
                case '1':
                    return 'Alta';
                case '2':
                    return 'Baja';
                case '3':
                    return 'Urgente';
                default:
                    return '';
            }
        }

        $scope.get_tecnicos = function(id_ticket) {
            ngDialog.open({
                template: 'app/cliente/monitoreo/modales/tecnicos_asociados.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.loading = true;
                    $scope.noInfo = false;

                    var params = {
                        "id_usuario": $localStorage.id_usuario,
                        "id_ticket": id_ticket,
                    }
                    RESTServices.post_header('cliente/consulta_tecnicos_ticket.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                        if (data != null && data.code == '200') {
                            $scope.tecnicos = data.tecnicos;
                            $scope.loading = false;
                            $scope.noInfo = false;
                        } else {
                            $scope.loading = false;
                            $scope.noInfo = true;
                        }  

                    });

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
        
                }]
            });
            
        }

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.monitoreo')
        .directive('tableTickets', tableTickets);
  
    /** @ngInject */
    function tableTickets() {
      return {
        restrict: 'E',
        controller: 'tableTicketsCtrl',
        scope: {
            tickets: '=tickets',
        },
        templateUrl: 'app/cliente/monitoreo/components/table-tickets/table-tickets.html'
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo-plano')
      .controller('configuracionPlanoCtrl', configuracionPlanoCtrl);
  
    function configuracionPlanoCtrl($scope, $stateParams, $localStorage, RESTServices, $timeout, SHAREServices, $state, $filter, toastr, statisticsServices, $rootScope, $q) {
       
        $scope.file;
        var allPines = [];
        var CALIDAD_IMAGEN = 1;
        $scope.edit_mode = false;

        $scope.plano = {
            id: '0',
            nombre: '',
            id_zona: '',
            url_img:'',
        }

        $scope.pin = {
            x: '',
            y: '',
            id: '0',
            nombre: '',
            variables: [],
            id_dispositivo: '',
            id_plano: '',
            index: null,
        }

        $scope.pines = [];

        $scope.$on('setDevicesPlane', function(e, res) {
            $scope.plano.id_zona = res.zona ? res.zona.id : '';
            $scope.step = res.step;
            if(res.zona) {
                getDevices(res.zona.id);
            }
            
        });

        $scope.$on('editPlane', function(e, res) {
            $scope.edit_mode = true;
            $scope.step = res.step;
            getDevices(res.zona.id);
            $scope.plano.id = res.plano.id;
            $scope.plano.nombre = res.plano.nombre;
            $scope.plano.id_zona = res.zona.id;
            $scope.plano.url_img = res.plano.url;
            $scope.pines = res.pines;
            $scope.pines.map(function(pin, i){
                pin.id_plano =  $scope.plano.id;
                pin.close= true;
                if(Array.isArray(pin.variables)){
                    pin.variables = pin.variables.map(function(v){return v.tipo});
                } else {
                    pin.variables = pin.variables.split(",");
                }
                pin.index = i;
            })
            allPines = Array.from($scope.pines);
            $timeout(function(){
                $scope.pines.forEach(function(pin){
                    var id_pin = "pin-" + pin.index;
                    var pin_ind = document.getElementById(id_pin);
                    pin_ind.style.top = pin.y + "%";
                    pin_ind.style.left = pin.x + "%";
                })
            })
        });

        $scope.next = function(ind) {
            $scope.step = ind;
        }

        $scope.openPin = function(pin) {
            if(pin.close){
                $scope.pin = {
                    x: '',
                    y: '',
                    id: '0',
                    nombre: '',
                    variables: [],
                    id_dispositivo: '',
                    index: null,
                }
                $scope.pin = pin;
                $scope.pin.close = !pin.close;
                var menu = document.getElementById('menu-variables');
                menu.style.display = "flex";
                menu.style.top = pin.y + "%";
                menu.style.left = pin.x + "%";
                menu.classList.remove('zoomOut');
                menu.classList.add('zoomIn'); 
                if(pin.id_dispositivo !== '') {
                    $scope.selectedDevices = $scope.devices.filter(function(d){return d.id === pin.id_dispositivo})
                    $scope.selectedDevices.forEach(function(device){
                        device.open = false;
                        device.variables.forEach(function(variable){
                            var index = $scope.pin.variables.findIndex(function(v){return v === variable.id});
                            if(index >= 0) {
                                variable.status = true;
                            }
                        })
                    })
                    validarPin()
                } 
            } else {
                $scope.pin.close = !pin.close;
                cerrarPin()
            }
             
        }
        $scope.removeFile = function() {
            $scope.file = undefined;  // Limpia el modelo
            document.getElementById('file').value = ""; // Restablece el input file
        };

        $scope.getFile = function() {
            $scope.file = document.getElementById('file').files[0];
            var reader = new FileReader();
            reader.onload = function (e) {
                $scope.plano.url_img = e.target.result;
                $scope.$apply();
            };
            reader.readAsDataURL($scope.file);
        }

        $scope.createPin = function(event) {
            $scope.pinValido = false;
            var menu = document.getElementById('menu-variables');
            $scope.pin = {
                x: '',
                y: '',
                id: '0',
                nombre: '',
                variables: [],
                id_dispositivo: '',
            }

            var coordenadas = getCoordenadas(event);
            $scope.pin.x = coordenadas[0]; 
            $scope.pin.y = coordenadas[1]; 

            menu.style.display = "flex";
            menu.style.top = $scope.pin.y + "%";
            menu.style.left = $scope.pin.x + "%";
            menu.classList.remove('zoomOut');
            menu.classList.add('zoomIn');  
            if($scope.pin.id_dispositivo === '') {
                var ids = $scope.pines.map(function(pin){return pin.id_dispositivo})
                $scope.selectedDevices = $scope.devices.filter(function(d) {return !ids.includes(d.id)} );
                $scope.selectedDevices.forEach(function(device){
                    device.open = false;
                    if(device.variables){
                        device.variables.forEach(function(variable){
                            variable.status = false;
                        })
                    } 
                })
                validarPin()
            } 
              

        }

        $scope.addPin = function(pin) {
            if(pin.id === '0'){
                pin.index = $scope.pines.length;
                pin.close = true;
                $scope.pines.push(pin);
                var index = $scope.pines.length - 1;
                var id_pin = "pin-" + index;

                $scope.selectedDevices.shift();

                $timeout(function(){
                    var pin_ind = document.getElementById(id_pin);
                    pin_ind.style.top = pin.y + "%";
                    pin_ind.style.left = pin.x + "%";
                })
            } else {
                var index = $scope.pines.findIndex(function(p){return p.id === pin.id});
                $scope.pines[index] = pin;
            }
            cerrarPin();
        }

        $scope.cancelar = function(pin) {
            if(pin.index !== undefined) {
                $scope.pines.splice(pin.index, 1);
                cerrarPin();
            } else {
                cerrarPin();
            }
        }

        $scope.cancelarPlano = function() {
            $rootScope.$broadcast('goToPlano', {zona: $scope.zona, step: 1});
        }

        function getCoordenadas(event) {
            var coordenadas = [];
            var imgRect = event.target.getBoundingClientRect();
            
            var x = event.clientX - imgRect.left; // Coordenada X relativa a la imagen
            var y = event.clientY - imgRect.top;  // Coordenada Y relativa a la imagen

            // Calcular el porcentaje
            var porcentajeX = Math.floor((x / imgRect.width) * 100);
            var porcentajeY = Math.floor((y / imgRect.height) * 100);

            coordenadas.push(porcentajeX, porcentajeY);

            return coordenadas;

        }

        function getDevices(id_zona) {
            if(id_zona) {
                RESTServices.fetchDevicesByZone(id_zona).then(function(res) {
                    if (res.code == '200') {
                        $scope.devices = res.dispositivos;
                        $scope.devices = $scope.devices.filter(function(device){
                            return device.tipo == "2" || device.tipo == "3" || device.tipo == "6" || device.tipo == "12" || device.tipo == "13" || device.tipo == "15" || device.tipo == "28";
                        })
                        $scope.devices.map(function(d){
                            d.id = String(d.id); // pins store ids as strings and are compared with ===
                            d.variables = statisticsServices.setTab(d.tipo);
                            if(d.variables){
                                d.variables.map(function(v){
                                    v.status = false;
                                    return v;
                                })  
                            }
                            d.open = false;
                            return d;
                        });
                        devices = $scope.devices; 
                        $scope.selectedDevices = Array.from($scope.devices);     
                    }
                });
            } 
        }

        function cerrarPin(){
            var menu = document.getElementById('menu-variables');
            menu.classList.remove('zoomIn');
            menu.classList.add('zoomOut');
            $timeout(function(){
                menu.style.display = "none";
            },500)
        }

        $scope.setVariables = function(id, status, device) {
            if(status) {
                $scope.pin.variables.push(id)
                $scope.pin.id_dispositivo = device.id
            } else {
                var index = $scope.pin.variables.findIndex(function(d){return d === id});
                $scope.pin.variables.splice(index, 1);
            }
            
            validarPin()
        }

        function validarPin() {
            var length = $scope.pin.variables.length;
            if(length > 0) {
                $scope.pinValido = true;
            } else {
                $scope.pinValido = false;
                $scope.pin.id_dispositivo = '';
            }
        }

        

        $scope.addPlane = function() {
            $rootScope.flag_loading = true;

            if(validarURL($scope.plano.url_img)){
                guardarPlano($scope.plano.url_img);
            } else {
                uploadImage($scope.file);
            }
        }

        function validarURL(imagen) {
            var regex = new RegExp("^(http|https)://([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,4}(/[a-zA-Z0-9-_.~!*'();:@&=+$,%#]+)*$");
            return regex.test(imagen);
        }

        function uploadImage(file) {
            ////////comprimir la imagen
            new Compressor(file, {
                quality: CALIDAD_IMAGEN,
                success: function(result) {
                    var imagen = new File([result], result.name, { type: result.type });
                    getURL(imagen)
                } 
            });
            ////subir la imagen al servidor multimedia (Backblaze) para obterner la URL
            function getURL(imagen) {
                var r = new FileReader();
                r.onload = function (e) {
                    var hash = CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(e.target.result));
                    $q.resolve(RESTServices.getURL(imagen,hash)).then(function(url){
                        /////crear el plano junto con la imagen
                        guardarPlano(url)
                    })
                    .catch(function(e){
                        toastr.error('Hubo un problema inesperado con el servidor');
                        $timeout(function () {
                            document.getElementById('file').value = '';
                        });  
                    });
                }
                r.readAsBinaryString(imagen);
            }

        }

        function guardarPlano(url) {
            var plano = $scope.plano;
            plano.url_img = url;

            RESTServices.savePlanV2(plano, plano.id_zona || $scope.zona.id).then(function(res) {
                // 201 {id} on create; the 204 on edit has no body, so keep the id from the scope.
                var planId = (res && res.data && res.data.id) ? res.data.id : $scope.plano.id;
                // Keep the new id so that retrying after a pin failure edits this plan, not a duplicate.
                $scope.plano.id = String(planId);
                var pins_to_deleted = getRemovedObjects(allPines, $scope.pines);
                if(pins_to_deleted.length > 0){
                    deletePins(pins_to_deleted )
                }
                guardarPines(planId, $scope.pines);
            }).catch(function() {
                // Pins are neither saved nor deleted when the plan itself could not be saved.
                toastr.error('Ha ocurrido un error al guardar el plano', 'Creación de planos');
                $rootScope.flag_loading = false;
            })
        }


        function getRemovedObjects(originalArray, modifiedArray) {
            // Crear un conjunto de ids del arreglo modificado para buscar eficientemente
            var modifiedIds = new Set(modifiedArray.map(function(item) { return item.id}));
        
            // Filtrar los objetos que no están en el conjunto de ids del arreglo modificado
            return originalArray.filter(function(item) { return !modifiedIds.has(item.id)});
        }

        function guardarPines(id, pines) {
            var promesas = pines.map(function(pin){
                return RESTServices.savePinV2(id, pin).then(function(res) {
                    // New pins get their id from the 201 {id} response.
                    if (res && res.data && res.data.id) {
                        pin.id = String(res.data.id);
                    }
                    return res;
                });
            })

            $q.all(promesas)
                .then(function(response) {
                    toastr.success('Plano creado con correctamente', 'Creación de planos');
                    $rootScope.$broadcast('goToPlano', {zona: $scope.zona});
                })
                .catch(function() {
                    toastr.error('Ha ocurrido un error al guardar los pines del plano', 'Creación de planos');
                });
        }

        function deletePins(pines) {
            RESTServices.deletePinsV2(pines).then(function(response) {
                var results = (response && response.data && response.data.results) || [];
                var failed = results.some(function(item) { return item.status !== 200; });
                if (failed) {
                    toastr.warning('Algunos pines no pudieron eliminarse', 'Creación de planos');
                }
            }).catch(function() {
                toastr.warning('Algunos pines no pudieron eliminarse', 'Creación de planos');
            });
        }
        
    }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.monitoreo-plano')
        .directive('configuracionPlano', configuracionPlano);
  
    /** @ngInject */
    function configuracionPlano() {
      return {
        restrict: 'E',
        controller: 'configuracionPlanoCtrl',
        templateUrl: 'app/cliente/monitoreo-plano/components/configuracion-plano/configuracion-plano.html',
        scope: {
          zona: '=zona',
          step: '=step',
        },
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.monitoreo-plano')
      .controller('planoCtrl', planoCtrl);
  
    function planoCtrl($scope, $localStorage, ngDialog, RESTServices, $timeout, SHAREServices, $state, toastr, $rootScope, statisticsServices, $interval, $window, AutoServices) {
      
      $scope.loading = true;
      var timer;
      var TIME = 10000;
      $scope.pines = [];
      var allPines = [];
      $scope.deviceFilter = [
        {
          name: 'Monitoreo',
          status: true,
          id: 0,
        },
        {
          name: 'Control',
          status: false,
          id: 1
        },
        {
          name: 'Todos',
          status: false,
          id: 2
        },
      ],
      
      $timeout(function(){
        if($scope.planos.length > 0 ) {
          $scope.planos.map(function(plano, index) {
            plano.index = index;
            plano.activo = false;
            return plano;
          });
          $scope.plano = $scope.planos[0];
          $scope.plano.activo = true;
          getPines($scope.plano.id);
          iniciarTimer();
        }
      })

      function iniciarTimer() {
        timer = $interval(function() {
          if($scope.pines.length > 0){
            getPinState($scope.pines)
          }
        }, TIME);
      };

      function cancelarTimer() {
          $interval.cancel(timer);
          timer = undefined;
      }

      $window.addEventListener('visibilitychange', handleVisibilityChange);

      function handleVisibilityChange() {
        if (document.visibilityState === 'visible') {
          if($state.current.name === 'monitoreoPlano'){
            if($scope.pines.length > 0){
              getPinState($scope.pines);
              iniciarTimer();
            }
          }
          
          
        } else if (document.visibilityState === 'hidden') {
          cancelarTimer();
        }
      };

      $scope.openPin = function(pin) {
        // Position comes from ng-style in the template; pin.index points into
        // allPines, not into the filtered list, so toggle the pin itself.
        pin.close = !pin.close;
      }

      function getPinState(pines){
        var promesas = pines.map(function(pin){
          var params = {
            "id_usuario": $localStorage.id_usuario,
            "id_pin": pin.id,
          };
          return RESTServices.post_header('cliente/consulta_estado_pin.php', params, SHAREServices.hash_decode_token($localStorage.token),true)
        })

        Promise.all(promesas)
          .then(function(res){
            res.forEach(function(itm, i) {
              if (itm.code === '200') {
                var variables = itm.variables;
                if(variables){
                  variables.map(function(v){
                    var inds = statisticsServices.getVaribleByID(v.tipo)[0];
                    var nombre = inds.nitname;
                    v.nombre = nombre;
                    v.valor = setPinValue(v.tipo, v.valor, pines[i].tipo_dispositivo);
                    v.unidad = inds.unidad;
                    return v;
                  })
                  // pines is the list the requests were built from; $scope.pines may
                  // have been replaced by a filter change while they were in flight.
                  pines[i].variables = variables;
                }
                $scope.loading = false;
              } else {
                $scope.loading = false;
              }
            })
            $scope.$apply();
          })
      }

      function setPinValue(type, value, device_type) {
        if(type === '1'){
          return AutoServices.getControlByID(device_type,value)
        } else {
          return ({
            id: '',
            nombre: value / 100,
            status: false,
          })
        }
      }

      function getPines(id) {
        $scope.pines = [];
        ////query pines
        // v2: migrated from consulta_pinesxplano.php
        RESTServices.fetchPlanPinsV2(id).then(function(data) {
            if (data != null) {
                if(data.pines) {
                    $scope.pines = data.pines;
                    $scope.pines.map(function(pin, i){
                      pin.index = i;
                      pin.close = true;
                      pin.types = setPinTypes(pin.variables);
                    })
                    allPines = Array.from($scope.pines);
                    $timeout(function(){
                      $scope.changeFilter(0);
                      getPinState($scope.pines);
                    })
                } else {
                   toastr.error('no hay pines disponibles', 'Pines') 
                   $scope.loading = false;
                }
            }
        })
      }

      function setPinTypes(variables) {
        variables = variables.split(',')
        var ind = [];
        variables.forEach(function(type){
          if(type === '1'){
            if(!ind.includes(1)){
              ind.push(1)
            } 
          } else {
            if(!ind.includes(0)){
              ind.push(0)
            } 
          }
        })
        return ind;
      }

      $scope.prev = function() {
        var actual = $scope.planos.findIndex(function(plano){ return plano.activo === true });
        var prev = actual === 0 ? $scope.planos.length - 1 : actual - 1;
        $scope.planos.map(function(plano) {
          plano.activo = false;
          return plano;
        });
        $scope.planos[prev].activo = true;
        $scope.plano =  $scope.planos[prev];
        getPines($scope.plano.id);
      }

      $scope.next = function() {
        var actual = $scope.planos.findIndex(function(plano){ return plano.activo === true });
        var next = actual ===  $scope.planos.length - 1 ? 0 : actual + 1;
        $scope.planos.map(function(plano) {
          plano.activo = false;
          return plano;
        });
        $scope.planos[next].activo = true;
        $scope.plano =  $scope.planos[next];
        getPines($scope.plano.id);
      }

      $scope.editarPlano = function(plano) {
        $window.removeEventListener('visibilitychange', handleVisibilityChange);
        cancelarTimer();
        $rootScope.$broadcast('goToEditPlane', {plano: plano, pines: allPines})
      }

      $scope.borrarPlano = function(plano, all) {
        ngDialog.open({
            template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
            className: 'ngdialog-theme-plain',
            scope: $scope,
            controller: ['$scope', function($scope) {
                $scope.bodyModal = all ? '¿Desea borrar todos los planos?' : '¿Desea borrar este plano?',

                $scope.cancelar = function() {
                    ngDialog.close();
                };

                $scope.aceptar = function() {
                    $rootScope.flag_loading = true;
                    var ids = [];
                    $scope.planos.forEach(function(plano){
                      ids.push(plano.id)
                    })
                    // v2: migrated from cliente/elimina_planos.php (bulk; every
                    // plan in results[] must succeed for this to count as a
                    // full success).
                    var planIds = all ? ids : [plano.id];
                    RESTServices.deletePlanV2(planIds).then(function(response) {
                        var results = (response.data && response.data.results) || [];
                        var ok = results.length > 0 && results.every(function(r) { return r.status === 200; });
                        if (ok) {
                            ngDialog.close();
                            $rootScope.flag_loading = false;
                            cancelarTimer();
                            $rootScope.$broadcast('goToPlano', {zona:$scope.zona})
                            toastr.success('El plano ha sido borrado', 'Eliminar plano');
                        }else{
                            $rootScope.flag_loading = false;
                            toastr.error('No se pude eliminar el plano', 'Ha ocurrido algo inesperado');
                        }
                    }).catch(function() {
                        $rootScope.flag_loading = false;
                        toastr.error('No se pude eliminar el plano', 'Ha ocurrido algo inesperado');
                    });
                }
            }]
        })
      }

      $scope.changeFilter = function(id){
        $scope.deviceFilter.map(function(obj) {
          obj.status = false;
        });
        var index = $scope.deviceFilter.findIndex(function(i) { return i.id === id });
        $scope.deviceFilter[index].status = true;
        // Pins are positioned by ng-style in the template, so the DOM is not touched here.
        if(id === 2){
          $scope.pines = Array.from(allPines);
        } else {
          $scope.pines = allPines.filter(function(p) {
            return p.types.some(function(type) {return type == id});
          });
        }
      }

      $scope.$on('$destroy', function() {
        $interval.cancel(timer);
        timer = undefined;
        $window.removeEventListener('visibilitychange', handleVisibilityChange);
      });
        
    }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.monitoreo-plano')
        .directive('plano', plano);
  
    /** @ngInject */
    function plano() {
      return {
        restrict: 'E',
        controller: 'planoCtrl',
        templateUrl: 'app/cliente/monitoreo-plano/components/plano/plano.html',
        scope: {
          planos: '=planos',
          zona: '=zona',
          rol: '=rol',
        }
      };
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.smartbar')
        .directive('consumption', consumption);
  
    /** @ngInject */
    function consumption() {
      return {
        restrict: 'E',
        controller: 'consumptionCtrl',
        templateUrl: 'app/cliente/smartbar/directives/consumption/consumption.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.smartbar')
        .controller('consumptionCtrl', consumptionCtrl);

    /** @ngInject */
    function consumptionCtrl($scope) {

        $scope.intervalsConsump = ['Hoy', 'semana', 'mes', 'año'];
        $scope.consumption = {
                                value : 2425,
                                comparative : {
                                    value : 5.4,
                                    state : 'down'
                                }
        };

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.smartbar')
        .directive('graficTempVsDist', graficTempVsDist);
  
    /** @ngInject */
    function graficTempVsDist() {
      return {
        restrict: 'E',
        controller: 'graficTempVsDistCtrl',
        templateUrl: 'app/cliente/smartbar/directives/graficTempVsDist/graficTempVsDist.html'
      };
    }
  })();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.smartbar')
        .controller('graficTempVsDistCtrl', graficTempVsDistCtrl);

    /** @ngInject */
    function graficTempVsDistCtrl($scope) {
        $scope.intervalsGrafTemDis = ['Hoy', 'semana', 'mes', 'año'];
        $scope.noInfo = false;
        $scope.loading = false;
        var tempVsDistDataRaw = [{
                'PointId': 1,
                'dist': 1,
                'temp': 20
            },
            {
                'PointId': 2,
                'dist': 2,
                'temp': 23,
            },
            {
                'PointId': 3,
                'dist': 3,
                'temp': 23,
            },
            {
                'PointId': 4,
                'dist': 4,
                'temp': 30,
            },
            {
                'PointId': 5,
                'dist': 5,
                'temp': 20,
            },
            {
                'PointId': 6,
                'dist': 6,
                'temp': 24,
            },
            {
                'PointId': 7,
                'dist': 7,
                'temp': 48,
            },
            {
                'PointId': 8,
                'dist': 8,
                'temp': 24,
            },
            {
                'PointId': 9,
                'dist': 9,
                'temp': 29,
            },
            {
                'PointId': 10,
                'dist': 10,
                'temp': 40,
            },
            {
                'PointId': 11,
                'dist': 11,
                'temp': 20,
            },
            {
                'PointId': 12,
                'dist': 12,
                'temp': 32,
            },
            {
                'PointId': 13,
                'dist': 13,
                'temp': 31,
            },
            {
                'PointId': 14,
                'dist': 14,
                'temp': 45,
            },
            {
                'PointId': 15,
                'dist': 15,
                'temp': 30,
            },
            {
                'PointId': 16,
                'dist': 16,
                'temp': 25,
            },
            {
                'PointId': 17,
                'dist': 17,
                'temp': 39,
            },
            {
                'PointId': 18,
                'dist': 18,
                'temp': 35,
            },
            {
                'PointId': 19,
                'dist': 19,
                'temp': 42,
            },
            {
                'PointId': 20,
                'dist': 20,
                'temp': 25,
            },

        ];

        var tempVsDistData = tempVsDistDataRaw.map(function(t) {
            if (t.temp > 40) {
                t.color = '#AF4848'
            } else if (t.temp > 30 && t.temp <= 40) {
                t.color = '#FFA622'
            } else {
                t.color = '#A47DFD'
            }
            return t;
        });

        var chart = AmCharts.makeChart("grafica_tempVsDist", {
            "type": "serial",
            "theme": "light",
            "colors": [
                "#00BFDB"
            ],
            "dataProvider": tempVsDistData,
            "valueAxes": [{
                "gridColor": "#FFFFFF",
                "gridAlpha": 0.2,
                "dashLength": 0,
                "axisAlpha": 0.1,
                "tickLength": 0
            }],
            "gridAboveGraphs": false,
            "startDuration": 1,
            "graphs": [{
                "balloonText": "[[category]]: <b>[[value]]</b>",
                "fillColorsField": "color",
                "fillAlphas": 0.8,
                "lineAlpha": 0.2,
                "type": "column",
                "valueField": "temp",
            }],
            "chartCursor": {
                "categoryBalloonEnabled": false,
                "cursorAlpha": 0,
                "zoomable": false
            },
            "categoryField": "dist",
            "categoryAxis": {
                "gridPosition": "start",
                "gridAlpha": 0,
                "tickPosition": "start",
                "tickLength": 0,
                "axisAlpha": 0.1,
            },
            "export": {
                "enabled": true
            }

        })

        chart.addListener("clickGraphItem", handleClick);

        function handleClick(event) {
           //console.log(event.item.dataContext)
        }


    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.smartbar')
        .directive('losses', losses);
  
    /** @ngInject */
    function losses() {
      return {
        restrict: 'E',
        controller: 'lossesCtrl',
        templateUrl: 'app/cliente/smartbar/directives/losses/losses.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.smartbar')
        .controller('lossesCtrl', lossesCtrl);

    /** @ngInject */
    function lossesCtrl($scope) {
        
        $scope.intervalsLosses = ['Hoy', 'semana', 'mes', 'año'];
        $scope.loss = {
                        value : 24,
                        comparative : {
                            value : 12.4,
                            state : 'up'
                        }
        };



    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.smartbar')
        .directive('meters', meters);
  
    /** @ngInject */
    function meters() {
      return {
        restrict: 'E',
        controller: 'metersCtrl',
        templateUrl: 'app/cliente/smartbar/directives/meters/meters.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.smartbar')
        .controller('metersCtrl', metersCtrl);

    /** @ngInject */
    function metersCtrl($scope) {

        $scope.intervalsMeters = ['Hoy', 'semana', 'mes', 'año'];
        $scope.meters = [
                {
                    name:'M-424',
                    consumption: 750, ////en kwh
                    comparative:{
                                    value:2.1,
                                    state: 'up'
                    }
                },
                {
                    name:'M-750',
                    consumption: 420, ////en kwh
                    comparative:{
                                    value:3.1,
                                    state: 'down'
                    }
                },
                {
                    name:'M-211',
                    consumption: 332, ////en kwh
                    comparative:{
                                    value:1.9,
                                    state: 'up'
                    }
                },
                {
                    name:'M-358',
                    consumption: 710, ////en kwh
                    comparative:{
                                    value:8.1,
                                    state: 'down'
                    }
                },
                {
                    name:'M-665',
                    consumption: 120, ////en kwh
                    comparative:{
                                    value:0,
                                    state: 'stable'
                    }
                },
                {
                    name:'M-924',
                    consumption: 750, ////en kwh
                    comparative:{
                                    value:5.1,
                                    state: 'up'
                    }
                }

        ];
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.smartbar')
        .directive('rateLosses', rateLosses);
  
    /** @ngInject */
    function rateLosses() {
      return {
        restrict: 'E',
        controller: 'rateLossesCtrl',
        templateUrl: 'app/cliente/smartbar/directives/rateLosses/rateLosses.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.smartbar')
        .controller('rateLossesCtrl', rateLossesCtrl);

    /** @ngInject */
    function rateLossesCtrl($scope) {
        $scope.intervalsRateLosses = ['Hoy', 'semana', 'mes', 'año'];
        $scope.noInfo = false;
        $scope.loading = false;
        var rateLossesDataRaw = [
                                    {
                                        'period':'Mon',
                                        'input':2240,
                                        'output':2001
                                    },
                                    {
                                        'period':'Tue',
                                        'input':2150,
                                        'output':2101
                                    },
                                    {
                                        'period':'Wes',
                                        'input':2310,
                                        'output':2045
                                    },
                                    {
                                        'period':'Thu',
                                        'input':2014,
                                        'output':2001
                                    },
                                    {
                                        'period':'Fri',
                                        'input':2222,
                                        'output':2005
                                    },
                                   

        ];

        var format = 'MMM DD';

        var rateLossesData = rateLossesDataRaw;
  
        var chart = AmCharts.makeChart("grafica_rateLosses", {
            "type": "serial",
            "theme": "light",
            "colors": [
                "#A47DFD",
                "#FFA622"
            ],
            "dataProvider": rateLossesData,
            "valueAxes": [ {
                "gridColor": "#FFFFFF",
                "gridAlpha": 0.2,
                "dashLength": 0,
                "axisAlpha": 0.1,
                "tickLength": 0
              } ],
              "gridAboveGraphs": false,
              "startDuration": 1,
              "graphs": [
                    {
                        "balloonText": "Entrada:[[value]]",
                        "fillAlphas": 0.8,
                        "id": "AmGraph-1",
                        "lineAlpha": 0.2,
                        "title": "Entrada",
                        "type": "column",
                        "valueField": "input"
                    },
                    {
                        "balloonText": "Salida:[[value]]",
                        "fillAlphas": 0.8,
                        "id": "AmGraph-2",
                        "lineAlpha": 0.2,
                        "title": "Salida",
                        "type": "column",
                        "valueField": "output"
                    }
                ],
              "chartCursor": {
                "categoryBalloonEnabled": false,
                "categoryBalloonDateFormat": format,
                "cursorAlpha": 0,
                "zoomable": false
              },
              "categoryField": "period",
              "dataDateFormat": format,
              "categoryAxis": {
                "gridPosition": "start",
                "gridAlpha": 0,
                "tickPosition": "start",
                "tickLength": 0,
                "axisAlpha": 0.1,
              },
              "export": {
                "enabled": true
              },
              "legend": {
                "useGraphSettings": true
              },

        })

        chart.addListener("clickGraphItem", handleClick);

        function handleClick(event){
           //console.log(event.item.dataContext)
        }

    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.smartbar')
        .directive('tempPoints', tempPoints);
  
    /** @ngInject */
    function tempPoints() {
      return {
        restrict: 'E',
        controller: 'tempPointsCtrl',
        templateUrl: 'app/cliente/smartbar/directives/tempPoints/tempPoints.html'
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.smartbar')
        .controller('tempPointsCtrl', tempPointsCtrl);

    /** @ngInject */
    function tempPointsCtrl($scope) {


        $scope.points = [
            {
                name:'01-20',
                temperature: 20, ////en kwh
                comparative:{
                                value:2,
                                state: 'up'
                }
            },
            {
                name:'02-10',
                temperature: 24, ////en kwh
                comparative:{
                                value:3,
                                state: 'down'
                }
            },
            {
                name:'03-40',
                temperature: 33, ////en kwh
                comparative:{
                                value:1,
                                state: 'up'
                }
            },
            {
                name:'04-50',
                temperature: 27, ////en kwh
                comparative:{
                                value:8,
                                state: 'down'
                }
            },
            {
                name:'05-10',
                temperature: 38, ////en kwh
                comparative:{
                                value:0,
                                state: 'stable'
                }
            },
            {
                name:'06-70',
                temperature: 30, ////en kwh
                comparative:{
                                value:5,
                                state: 'up'
                }
            }

    ];


    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .controller('deviceControlCtrl', deviceControlCtrl);

    /** @ngInject */
    function deviceControlCtrl($scope, $localStorage, SHAREServices, RESTServices, AutoServices, $timeout, $filter, toastr, $state, utilities) {

        var variable;
        $scope.variable_name = {name:''}


        $timeout(function() {
            
            if ($scope.device.tipo == '2' || $scope.device.tipo == '3') {
                $scope.device.estado = $filter('filter')(AutoServices.getCommandsControl(), { id: $scope.device.estado }, true)[0];
                $scope.setpoints = AutoServices.selectComandsControl($scope.device.id_aire);
                console.log("tipo:", $scope.device.tipo, "estado:", $scope.device.estado);
            } else if ($scope.device.tipo == '4' || $scope.device.tipo == '32' || $scope.device.tipo == '33') {
                // device.estado es la lectura real de temperatura (ultimo_estado_variable tipo=10),
                // no un id de comando: no pasarla por el filtro de getCommandsControl, o una lectura
                // valida que coincida con un id (9-23) se muestra con el nombre de un comando no
                // relacionado (ver deviceControl.html).
                $scope.setpoints = AutoServices.getCommandsControl();
                if($scope.device.tipo == '33'){
                    var index = $scope.setpoints.findIndex(function(s){return s.id === '2'})
                    if(index){
                       $scope.setpoints.splice(index, 1);
                    }
                }
            } else if ($scope.device.tipo == '15') {
                $scope.setpoints = AutoServices.mxproControl;
            } else if ($scope.device.tag) {
                if ($scope.device.variables.length > 0) {
                    $scope.showStatus($scope.device.variables[0].navName);
                    $scope.variable_name.name = $scope.device.variables[0].navName
                }
                
            } else if ($scope.device.tipo == '17') {
                //$scope.intervalDimmer = generarIntervaloDimmer($scope.device.min);
                $scope.intervalDimmer = utilities.generarIntervaloDimmer(50);
            } else if ($scope.device.tipo == '27') {
                $scope.intervalEngine = utilities.generarIntervaloDimmer(10);
            } else if ($scope.device.tipo == '29') {
                $scope.setpoints = AutoServices.wind_CurtainControl;
            } 


            ////Verifica si el dispositivo está online
            // if ($scope.device.h_server){
            //     var delay = new Date($scope.device.h_server.replace(/-/g, '\/'));
            //     delay.setMinutes(delay.getMinutes() - 10);
            //     delay = $filter('date')(delay, 'yyyy-MM-dd HH:mm');

            //     if (delay > $scope.device.fecha) $scope.device.online = 0;
            //     else $scope.device.online = 1;
            // }
            

            /////calcular última conexión
            if ($scope.device.tipo !== '11' && !$scope.device.tag && $scope.device.fecha !== null) {
                var h_l = SHAREServices.dateToLocal($scope.device.fecha,2,1,false)
                $scope.fecha_conexion = $filter('date')(h_l, 'MMM d, y h:mm:ss a');
                // connection_gap (ms) is computed by the server clock, not by the browser.
                var df = $scope.device.connection_gap;
                var ind;
                var index = 0;
                if ($scope.device.connection_gap != null) {
                    while (checkDigits(df)) {
                        ind = df / div(index);
                        index = index + 1;
                        $scope.last_conexion = ind;
                        df = ind;
                    }
                } else {
                    $scope.last_conexion = '--';
                    $scope.ind = '';
                }
                
                function checkDigits(number) {
                    var ind_ = Math.trunc(number);
                    var length =  ind_.toString().length;
                    return (length > 1) && (ind_ > 0);   
                }
                function div(ind) {
                    switch(ind) {
                        case 0 :
                            $scope.ind = 'Segundos';
                            return 1000;
                        case 1 :
                            $scope.ind = 'Minutos';
                            return 60;
                        case 2 :
                            $scope.ind = 'Horas';
                            return 60;
                        case 3: 
                            $scope.ind = 'Días';
                            return 24;
                        case 4:
                            $scope.ind = 'Meses';
                            return 30;
                        case 5:
                            $scope.ind = 'Años';
                            return 12;
                    }
                }
            } else {
                $scope.last_conexion = '--';
                $scope.ind = '';
            }
            

        });


        $scope.turnDevice = function(device) {

            var params = {
                id_dispositivo: device.id,
                id_usuario: $localStorage.id_usuario,
                comando: device.relay ? device.relay: device.estado,
            }

            RESTServices.post_header('control_manual.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(ans) {
                if (ans.code == '200') {
                    if(device.relay==null) device.estado = device.estado === '0' ? '1' : '0';
                    else device.relay = device.relay === '0' ? '1' : '0';
                    toastr.success('Se ha ejecutado el comando correctamente', 'Control')
                } else {
                    toastr.error('No se ha ejecutado el comando', 'Control')
                }
            });
        }

        $scope.setAir = function(setPoint, device) {
            if (device.tipo != 14)setPoint = JSON.parse(setPoint);
            if(device.tipo == 15) setPoint.nombre = parseInt(setPoint.nombre)*10;
            //if (device.tipo === "14") var rack = parseInt(setPoint)*10;
            var params = {
                id_dispositivo: device.id,
                id_usuario: $localStorage.id_usuario,
                comando: device.tipo !== "14" && device.tipo !== "29" ? setPoint.nombre : device.tipo === "14" ? setPoint*10 : device.tipo === "29" ? setPoint.id : null,
                //tipo: 1,
            }

            RESTServices.post_header('control_manual_aire.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    toastr.success('Se ha ejecutado el comando correctamente', 'Control');
                    // Solo tipo 2/3 guardan el comando actual como objeto en device.estado;
                    // para el resto (ej. 4/32/33) device.estado es la lectura de sensor, no
                    // el objeto de comando, y asignarle .nombre rompe en modo estricto.
                    if (device.tipo === '2' || device.tipo === '3') {
                        $scope.device.estado.nombre = setPoint.nombre;
                    }
                } else {
                    toastr.error('No se ha ejecutado el comando', 'Control');
                }
            })
        };

        $scope.setControlByPercent = function(percent, device) {
            var params = {
                id_dispositivo: device.id,
                id_usuario: $localStorage.id_usuario,
                comando: percent,
                //tipo: 9,
            }

            RESTServices.post_header('control_manual_aire.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if (response.code == '200') {
                    toastr.success('Se ha ejecutado el comando correctamente', 'Control');
                    $scope.device.estado = percent;
                } else {
                    toastr.error('No se ha ejecutado el comando', 'Control');
                }
            })
        };

        $scope.goNewAutomation = function(device) {
            if (device.tipo == '2' || device.tipo == '3' || device.tipo == '4') {
                $state.go('dashboard_cliente.newAutomationAir', { zona: $scope.zone });
            } else {
                $state.go('dashboard_cliente.newAutomationLoad', { zona: $scope.zone });
            }
        }

        $scope.goApparatusProfile = function(device, control) {
            $state.go('mantenimiento_apparatusProfile', { device: device, control: control, devices: $scope.devices });
        }

        $scope.showStatus = function(name) {
            variable = $scope.device.variables.find(function(d){ return d.navName === name});
            $scope.device.estado = variable.curVal;
            if(variable.writable) {
                $scope.control_saeg = true;
            }else {
                $scope.control_saeg = false;
            }
        }

        $scope.controlSaeg = function(value) {

            RESTServices.setPointSaeg(value, variable.id).then(function(response) {
                if (response.http_status_code == '200') {
                    toastr.success('Se ha ejecutado el comando correctamente', 'Control');
                    $scope.device.estado = value;
                } else {
                    toastr.error('No se ha ejecutado el comando', 'Control');
                }
            })
        }


    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente')
        .directive('deviceControl', deviceControl);
  
    /** @ngInject */
    function deviceControl() {
      return {
        restrict: 'E',
        controller: 'deviceControlCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/directives/zoneTable/deviceControl/deviceControl.html',
        scope: {
          device: '=device',
          devices: '=devices',
          zone: '=zone',
          control: '=control',
          integracion: '=integracion',
          serverHour: '=serverHour',
        },
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('deviceInfoCtrl', deviceInfoCtrl);

    /** @ngInject */
    function deviceInfoCtrl($scope, $rootScope, SHAREServices) {
        
        $scope.$on('updateDevice', function(event, result) {
            if (SHAREServices.dispositivo_selected.tipo !== '12') $scope.info = true;
            $scope.device = result.data;
        });
        
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .directive('deviceInfo', deviceInfo);
  
    /** @ngInject */
    function deviceInfo() {
      return {
        restrict: 'E',
        controller: 'deviceInfoCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/estadisticas_zona/components/device-info/device-info.html',
      };
    }
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('indVariableCtrl', indVariableCtrl)

    /** @ngInject */
    function indVariableCtrl($scope, $localStorage, RESTServices, $interval,SHAREServices) {

        var device;
        var timer;

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '12') {
                $scope.flow = true;
                device = result.data;
                $scope.updateData();
                iniciarTimer();
            }    
        });
        
        $scope.updateData = function() {
            if(device){
                var field = {
                    "id_dispositivo": device ? device.id: null,
                    "id_usuario": $localStorage.id_usuario,
                    //"token": SHAREServices.hash_decode_token($localStorage.token),
                    "tipo": $scope.indType,
                    "offset": (new Date()).getTimezoneOffset()
                };

                RESTServices.post_header('cliente/consulta_ultimo_estado.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                    if (response.code == '200') {
                       $scope.variable = response;
                       $scope.variable.estado = parseInt($scope.variable.estado) / 100;
                       $scope.variable.fecha = new Date($scope.variable.fecha);
                    }    
                })
            }
            
        }

        function iniciarTimer() {
             // CÓDIGO PARA SIMULAR TIEMPO REAL
             timer = $interval(function() {
                $scope.updateData();
            }, 15000);
        };

        function cancelarTimer() {
            $interval.cancel(timer);
            timer = undefined;
        }
        $scope.$on('iniciarTimer', function() {
            iniciarTimer();
        });
        $scope.$on('cancelarTimer', function() {
            cancelarTimer();
        });

        $scope.$on('$destroy', function() {
            $interval.cancel(timer);
            timer = undefined;
        });


    };

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .directive('indVariable', indVariable);
  
    /** @ngInject */
    function indVariable() {
      return {
        restrict: 'E',
        controller: 'indVariableCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/estadisticas_zona/components/ind-variable/ind-variable.html',
        scope: {
          indTitle: '=indTitle',
          unit: '=unit',
          indType: '=indType'
        }
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('tabsCtrl', tabsCtrl);

    /** @ngInject */
    function tabsCtrl($scope, $rootScope, statisticsServices) {
        
        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo !== '9' && result.data.tipo !== '11' && result.data.tipo !== '8' && result.data.tipo !== '22' && result.data.tipo !== '26' && !result.data.tag) {
                $scope.tabs = statisticsServices.setTab(result.data.tipo);
                $scope.energy = false;
                $scope.saeg = false;
                $scope.helo_s_plus = false;
                statisticsServices.graphType = $scope.tabs[0].type;
                $scope.$broadcast('noGraph', {ind : false})
                $scope.$broadcast('selectGraph', {data: $scope.tabs[0].type, dispositivos: result.dispositivos});
            } else if (result.data.tipo === '8') {
                $scope.$broadcast('noGraph', {ind : false})
                $scope.$broadcast('selectGraph', {data: 'temp_dist', dispositivos: result.dispositivos});
                statisticsServices.graphType = $scope.tabs[0].type;
            } else if(result.data.tipo == '11' || result.data.tipo == '26' || result.data.tipo == '31') {
                $scope.$broadcast('noGraph', {ind : true})
            } else {
                $scope.tabs = undefined;
            }
        });

        $scope.tabGrafica = function(parm){
            $scope.tabs.map(function(obj) {
                obj.status = false;
            });
            var index = $scope.tabs.findIndex(function(i) { return i.type == parm });
            $scope.tabs[index].status = true;
            statisticsServices.graphType = parm;
            $scope.$broadcast('selectGraph', {data: parm});
        }
        
    }

})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .directive('tabs', tabs);
  
    /** @ngInject */
    function tabs() {
      return {
        restrict: 'E',
        controller: 'tabsCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/estadisticas_zona/components/tabs/tabs.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('tabsEnergyCtrl', tabsEnergyCtrl);

    /** @ngInject */
    function tabsEnergyCtrl($scope, $rootScope, RESTServices, $localStorage, statisticsServices, SHAREServices, energyServices, $timeout, $q) {

        var dispositivo = {};
        var initial = {
            type: 'activeEnergy',
            status: false,
            name: 'Energía activa'
        }

        $scope.optionTab = {value: {}};

        
        
        function consultaDispositivo(id_dispositivo) {
            $timeout(function(){

                if(RESTServices.post_pending === false){
                    callServices(id_dispositivo)
                }else {
                    RESTServices.cancelarSolicitudHttp();
                    $timeout(function(){
                        callServices(id_dispositivo)
                    }, 100)  
                }

                function callServices(id_dispositivo) {
                    var fields = {
                        "id_usuario": $localStorage.id_usuario,
                        "id_dispositivo": id_dispositivo,
                    };
        
                    RESTServices.post_header('cliente/consulta_dispositivo.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                        if (res.code === "200") {
                            dispositivo = res.dispositivo;
                            var index =  res.dispositivo.caracteristicas ? res.dispositivo.caracteristicas.findIndex(function(c){ return c.id === '62'}) : -1;
                            if(index >= 0){
                                $scope.factor = {
                                    name: energyServices.multiplying_factor.filter(function(f) { return f.factor == res.dispositivo.caracteristicas[index].valor})[0].name,
                                    ind: parseInt(res.dispositivo.caracteristicas[index].valor),
                                }
                            }else {
                                $scope.factor = {
                                    name: 'Por defecto',
                                    ind: 1,
                                }
                            }
                            $scope.$broadcast('energyGraphics', { data: initial, factor: $scope.factor.ind });
        
                        }
                    });
                }

                
            }, 500)
            
        };

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tipo === '9') {
                $scope.energy = true;
                $scope.$broadcast('noGraph', {ind : false})
                $scope.optionEnergy = statisticsServices.optionsEnergyTabs;
                $scope.optionTab.value = $scope.optionEnergy[0];
                $scope.factors = energyServices.multiplying_factor;
                $scope.energyType = 'activeEnergy';
                consultaDispositivo(result.data.id);
                $scope.$broadcast('selectGraph', {data: 'energy'});
            }else {
                $scope.energy = false;
            }
        });

        $scope.tabEnergy_ = function(parm) {
            $scope.nameGrafica = parm.name;
            $scope.energyType = parm.type;
            $scope.$broadcast('energyGraphics', { data: parm, factor: $scope.factor.ind });
        }

        $scope.setFactor = function(parm) {
            $scope.$broadcast('energyFactor', { factor: parm, device: dispositivo});
        }
        
    }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .directive('tabsEnergy', tabsEnergy);
  
    /** @ngInject */
    function tabsEnergy() {
      return {
        restrict: 'E',
        controller: 'tabsEnergyCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/estadisticas_zona/components/tabs-energy/tabs-energy.html',
      };
    }
})();
(function() {
  'use strict';

  angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
      .controller('tabsHeloEnergyPlusCtrl', tabsHeloEnergyPlusCtrl);

  /** @ngInject */
  function tabsHeloEnergyPlusCtrl($scope, $rootScope, RESTServices, $localStorage, statisticsServices, SHAREServices, energyServices, $timeout, $q) {

      $scope.optionTab = {value: {}};

      $scope.$on('updateDevice', function(event, result) {
          if (result.data.tipo === '22') {
              $scope.helo_s_plus = true;
              $scope.optionEnergy = statisticsServices.optionsHeloSPlusTabs;
              $scope.optionTab.value = $scope.optionEnergy[0];
              $scope.energyType = 'power';
              $scope.$broadcast('noGraph', {ind : false})
              $scope.$broadcast('selectGraph', {data: 'energy_plus'});
          } else {
              $scope.helo_s_plus = false;
          }
      });

      $scope.tabEnergy = function(parm) {
          $scope.nameGrafica = parm.name;
          $scope.energyType = parm.type;
          $scope.$broadcast('energyGraphics2', { data: parm });
      }
      
  }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .directive('tabsHeloEnergyPlus', tabsHeloEnergyPlus);
  
    /** @ngInject */
    function tabsHeloEnergyPlus() {
      return {
        restrict: 'E',
        controller: 'tabsHeloEnergyPlusCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/estadisticas_zona/components/tabs-helo-s-plus/tabs-helo-s-plus.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('tabsSaegCtrl', tabsSaegCtrl);

    /** @ngInject */
    function tabsSaegCtrl($scope, $rootScope, RESTServices, $localStorage, statisticsServices, SHAREServices, energyServices, $timeout, $q) {

        $scope.optionTab = {value: {}};
        $scope.optionSaeg = {value: {}};
        
        function consultaVariables(data) {
            var url = 'https://ahhlcn2eporzzf6pbu4tbsb35i0iddhq.lambda-url.us-east-1.on.aws/?tag='
            RESTServices.get(url, data.tag).then(function(res){
                $scope.optionSaeg = res.points.rows;
                $scope.optionTab.value = res.points.rows[0];
                $rootScope.$broadcast('saegVarible', { data: res.points.rows[0], device: data });
            })
            
        };

        $scope.$on('updateDevice', function(event, result) {
            if (result.data.tag) {
                $scope.saeg = true;
                consultaVariables(result.data);
                $scope.$broadcast('noGraph', {ind : false})
                $rootScope.$broadcast('selectGraph', {data: 'saeg'});
            }else {
                $scope.saeg = false;
            }
        });

        $scope.tabSaeg = function(parm) {
            $scope.nameGrafica = parm.name;
            $scope.energyType = parm.type;
            $rootScope.$broadcast('saegVarible', { data: parm });
        }

        
        
    }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .directive('tabsSaeg', tabsSaeg);
  
    /** @ngInject */
    function tabsSaeg() {
      return {
        restrict: 'E',
        controller: 'tabsSaegCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/estadisticas_zona/components/tabs-saeg/tabs-saeg.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('contentGraphCtrl', contentGraphCtrl);

    /** @ngInject */
    function contentGraphCtrl($scope, $rootScope, statisticsServices, SHAREServices) {

        var dispositivos;
        $scope.data = {};

        $scope.$on('tempPoint', function(event, result) {
            $scope.$apply(function() {
                $scope.graph = statisticsServices.setGraph('temp');
                SHAREServices.dispositivo_selected = dispositivos[result.data];
            });
        });

        $scope.$on('selectGraph', function(event, result) {
            dispositivos = result.dispositivos;
            $scope.graph = statisticsServices.setGraph(result.data);
            $scope.$broadcast('updateGraph', {data: result.data, graph: $scope.graph});
        });
        
    }
})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .directive('contentGraph', contentGraph);
  
    /** @ngInject */
    function contentGraph() {
      return {
        restrict: 'E',
        controller: 'contentGraphCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/estadisticas_zona/components/content-graph/content-graph.html',
      };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('maintenanceTablesCtrl', maintenanceTablesCtrl);

    /** @ngInject */
    function maintenanceTablesCtrl($scope,  $state, $timeout, $filter, RESTServices, $localStorage, $rootScope, SHAREServices) {
        
        
        $scope.goMaintenanceLog = function(device){
            $state.go('mantenimiento_log', {device:device})
        }


    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('maintenanceTables', maintenanceTables);
  
    /** @ngInject */
    function maintenanceTables() {
      return {
        restrict: 'E',
        controller: 'maintenanceTablesCtrl',
        templateUrl: 'app/cliente/mantenimiento/components/maintenanceTabs/maintenanceTables/maintenanceTables.html',
        scope: {
            zone: '=zone',
        },
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('changeDBCtrl', changeDBCtrl);

    /** @ngInject */
    function changeDBCtrl($scope, RESTServices, $timeout,$interval, $filter, $localStorage, $state, toastr, maintenanceServices, SHAREServices, $stateParams, AutoServices, ngDialog) {

        $scope.step = 'select';
        $scope.aires_db = [];
        $scope.aire_db = undefined;
        $scope.paso = undefined;
        var interval = undefined;
        var max_attemps = 40;
        var attemps = 1;
        var user_action = false;

        $timeout(function(){
            if ($stateParams.device) {
                var params = {
                    id_usuario: $localStorage.id_usuario,
                }
                RESTServices.post_header('cliente/consulta_aires.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                    if(res.code === '200') {
                        $scope.aires_db = res.aires;
                    } else {
                        toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                    }
                })
            } else {
                $state.go('dashboard_cliente');
            } 
        })

        $scope.stepConfiguration = function(aire, step) {
            $scope.step = 'loading';
            $scope.paso = step;
            $scope.aire_db = aire !== undefined ? aire: $scope.aire_db;
            var params = {
                id_usuario: $localStorage.id_usuario,
                id_dispositivo: $stateParams.device.id_device,
                id_aire: $scope.aire_db.id,
                paso: step
            }
            RESTServices.post_header('cliente/edita_aire_dispositivo.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if(res.code === '200') {
                    startInterval()
                } else {
                    toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                }
            }) 
        }

        function startInterval() {
            interval = $interval(function() {
                var params = {
                    id_usuario: $localStorage.id_usuario,
                    id_dispositivo: $stateParams.device.id_device,
                }
                RESTServices.post_header('cliente/consulta_estado_editar_aire.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                    if(res.code === '200') {
                        if(res.registro === '1'){
                            console.log('comandos descargados')
                            $interval.cancel(interval);
                            
                            if ($scope.paso == 6) {
                                $scope.step = 'test_info';
                            } else  if($scope.paso == 7) {
                                $scope.step = 'test_1_2';
                            } else  if($scope.paso == 8) {
                                $scope.step = 'test_2_2';
                            }else  if($scope.paso == 9) {
                                $scope.step = 'success';
                            }
                        } else {
                            if(attemps < max_attemps) {
                                attemps += 1
                            } else {
                                $interval.cancel(interval);
                                console.log('proceso cancelado')
                                $scope.goToSettings();
                            }
                        }
                    } else {
                        console.log('en espera')
                    }
                })
            }, 15000)
        };

        

        $scope.next = function(step) {
            $scope.step = step;
        }

        $scope.goToSettings = function() {
            user_action = true;
            if ($scope.step !== 'success') {
                // v2: migrated from cliente/reinicia_cambio_aire.php
                RESTServices.resetDeviceAireV2($stateParams.device.id_device, $stateParams.aire_actual.id).then(function(res) {
                    console.log('se cancela el proceso')
                    $state.go('device_settings', {device: $stateParams.device});
                    SHAREServices.cancelAirChange(0);
                }).catch(function() {
                    toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                })
            } else {
                $state.go('device_settings', {device: $stateParams.device});
            }
        }
        
        $scope.$on("$destroy", function () {
            if (!user_action) {
                if ($scope.step !== 'success') {
                    // v2: migrated from cliente/reinicia_cambio_aire.php
                    RESTServices.resetDeviceAireV2($stateParams.device.id_device, $stateParams.aire_actual.id).then(function(res) {
                        console.log('se cancela el proceso')
                        SHAREServices.cancelAirChange(1);
                    }).catch(function() {
                        toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                    })
                }
            }  
        });

        

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('new_apparatus_profileCtrl', new_apparatus_profileCtrl);

    /** @ngInject */
    function new_apparatus_profileCtrl($scope, RESTServices, $filter, $localStorage, $state, toastr, maintenanceServices, $timeout, ngDialog, SHAREServices, $stateParams, ApparatusForms, $rootScope, $q) {
        $rootScope.flag_loading = false;
        $scope.deviceType = maintenanceServices.deviceType;
        $scope.flag_disabled = false;
        $scope.nuevoAparato = {
            email_encargado: [], 
            caracteristicas: [],
        };
        $scope.zones = [];
        $scope.is_saeg = false;
        $scope.images = [];
                
        $timeout(function() {

            if($stateParams.apparatus){
                $scope.nuevoAparato = $stateParams.apparatus;
                $scope.nuevoAparato.tipo_ = $stateParams.apparatus.tipo_ ? $stateParams.apparatus.tipo_.value : '';
                if($scope.nuevoAparato.tipo_ === '39') {
                    $scope.is_saeg = true;
                    $scope.tag = $scope.nuevoAparato.caracteristicas.filter(function(c){return c.id === '63'})[0].valor;
                }
                $scope.editMode = true;
                $scope.flag_disabled = false;
                if($scope.nuevoAparato.imagenes){
                    $scope.images = $scope.nuevoAparato.imagenes.map(function(i){
                        i.name = getName(i.url)
                        return i
                    });
                }
                $scope.is_control = $stateParams.control;
                if ($scope.nuevoAparato.caracteristicas) {
                   
                    if ($scope.nuevoAparato.caracteristicas.find(function(d) { return d.id === '2'})) {
                        var type = $scope.nuevoAparato.caracteristicas.find(function(d) { return d.id === '2'}).valor;
                        var caracteristicas = ApparatusForms.selectform(type);
                        if (caracteristicas) {
                            $scope.deviceCaracteristicas = [];
                            caracteristicas.forEach(function(c) {
                                c.caracteristicas.forEach(function(itm) {
                                    var caracteristica = $scope.nuevoAparato.caracteristicas.find(function(d) { return d.id == itm.id});
                                    if (caracteristica) {
                                        itm.valor = caracteristica.valor;
                                    }
                                });
                            });

                            $scope.deviceCaracteristicas = caracteristicas;
                        }
                        
                    }
                    
                } else {
                    var type = $scope.nuevoAparato.tipo_;
                    var caracteristicas = ApparatusForms.selectform(type);
                    $scope.deviceCaracteristicas = ApparatusForms.organizeCharacteristics(caracteristicas, $scope.nuevoAparato);
                    $scope.nuevoAparato.caracteristicas = ApparatusForms.setCharacteristics(caracteristicas, $scope.nuevoAparato);
                }
                if ($scope.nuevoAparato.email_encargado) {
                    $scope.nuevoAparato.email_encargado = Array.isArray($stateParams.apparatus.email_encargado) ? $stateParams.apparatus.email_encargado : $stateParams.apparatus.email_encargado === "" ? [] : $scope.nuevoAparato.email_encargado.split(',');
                } else {
                    $scope.nuevoAparato.email_encargado = [];
                }
                
            }

            var fields = {
                id_usuario: $localStorage.id_usuario,
            };
            RESTServices.fetchClientZones().then(function(res) {
                if (res.code == 200) {
                    $scope.zones = res.zonas ? res.zonas : [];
                    if(res.zonas_externas != undefined){
                        res.zonas_externas.forEach(function(d){
                            $scope.zones.push(d)
                        });
                        
                    }
                    $scope.zones = $filter('orderBy')($scope.zones, 'nombre');
                    if(SHAREServices.hiddenZones === '0'){
                        $scope.zones = $scope.zones.filter(function(z) {return z.h == '0'});
                    }
                    if($stateParams.zone != null){
                        $scope.nuevoAparato.id_zona = $filter('filter')($scope.zones, { id: $stateParams.zone.id }, true)[0].id;
                        $stateParams.control = $filter('filter')($scope.zones, { id: $stateParams.zone.id }, true)[0].control == '0' ? false : true ;
                    }
                    if($stateParams.apparatus != null){
                        $scope.nuevoAparato.id_zona = $filter('filter')($scope.zones, { id: $stateParams.apparatus.id_zona }, true)[0].id;
                    }
                }
            });
        });

        $scope.addZone = function() {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/newZone.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {

                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.newZone = function(nueva) {
                        var params = {
                            id_usuario: $localStorage.id_usuario,
                            nombre: nueva.nombre
                        };
                        RESTServices.post_header('instalador/genera_zona.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                            if (res.code == 200) {
                                var zona = { nombre: nueva.nombre, id: res.id_zona };
                                $scope.zones.push(zona);
                                toastr.success('Zona creada exitosamente', 'Nueva zona');
                                ngDialog.close();
                            }
                        });
                    }

                }]
            });
        }
        
        $scope.setcharacteristics = function(valor, id) {
            var index = $scope.nuevoAparato.caracteristicas.findIndex(function(c){ return c.id === id });
            if (index !== -1) {
                $scope.nuevoAparato.caracteristicas[index].valor = valor;
            } else {
                var caracteristica = {
                    valor: valor,
                    id: id
                }
                $scope.nuevoAparato.caracteristicas.push(caracteristica);
            }; 
        }

        $scope.cancelar = function() {
            $state.go('mantenimiento_apparatusProfile', {device: $stateParams.apparatus, control: $stateParams.control});
        };

        function getName(allName) {
            var name = allName.split('-')[2];
            return name;
        }

        $scope.addNewApparatus = function(nuevo) {
            validateEmail();
            $scope.flag_disabled = true;
            $rootScope.flag_loading = true;
            nuevo.imagenes = $scope.images;

            if(nuevo.tipo_ === '41') {
                ///crear el agrupador
                var agrupador = {
                    "id_device":  '0',
                    "nombre": nuevo.nombre,
                    "id_zona": nuevo.id_zona ? nuevo.id_zona : null,
                    "caracteristicas": nuevo.caracteristicas,
                    "tipo": '23',
                }

                var params = {
                    dispositivo: JSON.stringify(agrupador),
                    id_usuario: $localStorage.id_usuario,
                };

                RESTServices.post_header('cliente/edita_dispositivo.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res){
                    if(res.code == '200'){
                        var id_agrupador = res.dispositivo.id;
                        var devices = [];
                        for (var i = 0; i < 3; i++) {
                            var device = {
                                "id_device":  '0',
                                "nombre": 'canal #' + (i+1) ,
                                "id_zona": nuevo.id_zona ? nuevo.id_zona : null,
                                "caracteristicas": nuevo.caracteristicas,
                            }

                            devices.push(device);
                        }

                        var devicesRequests = [];
                        var promise = Promise.resolve();
                        devices.forEach(function(a){
                            promise = promise.then(function () {
                                addDevices(a);
                                return new Promise(function (resolve) {
                                    setTimeout(resolve, 500);
                                });
                            });
                        })

                        function addDevices(a) {
                            var params = {
                                dispositivo: JSON.stringify(a),
                                id_usuario: $localStorage.id_usuario,
                            };
                            RESTServices.post_header('cliente/edita_dispositivo.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                                if(res.code == 200) {
                                    devicesRequests.push(res.dispositivo);
                                }
                            }) 
                        }

                        promise.then(function(){
                            ///asociar dispositivos al agrupador
                            var id_dispositivos = devicesRequests.map(function(d){
                                return ({
                                    id : d.id
                                })
                            })
                            var parms = {
                                "id_agrupador": id_agrupador,
                                "dispositivos": JSON.stringify(id_dispositivos),
                                "id_usuario": $localStorage.id_usuario,
                                "asociar": 1,
                            };

                            RESTServices.post_header('cliente/asociar_dispositivos_agrupador.php', parms, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                                if(response.code === '200'){
                                    ///Agregar caracteristicas
                                    var payload = {
                                        caracteristicas: ApparatusForms.getDefaultCharacteristics,
                                        agrupados: id_dispositivos,
                                        tipo: 23,
                                    };
                                    // v2: migrated from cliente/edita_configuracion.php
                                    RESTServices.updateDeviceConfigV2(id_agrupador, payload).then(function(res){
                                        $scope.flag_disabled = false;
                                        $rootScope.flag_loading = false;
                                        toastr.success('Se ha creado/editado el dispositivo correctamente', 'Nuevo Dispositivo');
                                        $state.go('dashboard_cliente');
                                    }).catch(function(){
                                        $scope.flag_disabled = false;
                                        $rootScope.flag_loading = false;
                                        toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                                    })

                                    
                                }
                            })
                        })

                    }
                })

                /////
                
            } else {
                var images = $scope.images.filter(function(image){return !image.hasOwnProperty('id_imagen')})
                if (images.length > 0) {
                    getFile(nuevo, images)
                } else {
                    agregarDispositivo(nuevo);
                }
                
            }

            
        }

        function agregarDispositivo(nuevo) {
            
            var dispositivo = {
                "id_device": $scope.editMode ? (nuevo.id_device ? nuevo.id_device : nuevo.id) : '0' ,
                "nombre": nuevo.nombre,
                "id_zona": nuevo.id_zona ? nuevo.id_zona : null,
                "caracteristicas": nuevo.caracteristicas,
                "tipo": setType(nuevo.tipo_),
            }

            var params = {
                dispositivo: JSON.stringify(dispositivo),
                id_usuario: $localStorage.id_usuario,
            };

            RESTServices.post_header('cliente/edita_dispositivo.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(data) {
                if (data != null) {
                    if (data.code == '200') {
                        toastr.success('Se ha creado/editado el dispositivo correctamente', 'Nuevo Dispositivo');
                        var device = $scope.editMode ? $stateParams.apparatus : data.dispositivo;
                        $state.go('mantenimiento_apparatusProfile', {device: device, control: $stateParams.control});
                        var images = nuevo.imagenes.filter(function(i){
                            return i.id_imagen === undefined;
                        })
                        if(images.length > 0){
                            var id = $scope.editMode ? (nuevo.id_device ? nuevo.id_device : nuevo.id) : (data.dispositivo.id ? data.dispositivo.id : data.dispositivo.id_device);
                            linkImages(id, nuevo.imagenes)
                        }
                    } else {
                        toastr.error('No se puede conectar en este momento', 'Nuevo Dispositivo');
                    }
                } else {
                    toastr.error('No se puede conectar en este momento', 'Nuevo Dispositivo');
                }
            });
        }

        function setType(ind){
            var obj =  $scope.deviceType.find(function(d){
                return d.value === ind
            })

            return obj.type ? obj.type : null;
        }

        $scope.getUsersAvailables = function(id){
            // v2: migrated from consulta_usuarios_zona.php
            RESTServices.fetchZoneUsersV2(id).then(function(res) {
                if (res.code == 200) {
                    $scope.emailsDisponibles = res.users.map(function(u){
                        return u.email;
                    });
                }
            })
        };

        $scope.selectForm = function(type) {
            $scope.nuevoAparato.caracteristicas = [];
            $scope.nuevoAparato.marca = '';
            $scope.apparatusCharacteristics = ApparatusForms.selectform(type);
            if ($scope.editMode){
                $scope.deviceCaracteristicas = ApparatusForms.selectform(type); 
            }
            var index = $scope.nuevoAparato.caracteristicas.findIndex(function(c){ return c.id === 2 });
            if (index !== -1) {
                $scope.nuevoAparato.caracteristicas[index].valor = type;
            } else {
                var caracteristica = {
                    valor: type,
                    id: 2
                }
                $scope.nuevoAparato.caracteristicas.push(caracteristica);
            };

            if (type === '39') {
                if($localStorage.client.integracion === '1') {
                    $scope.is_saeg = true;
                    $scope.tag = ApparatusForms.generateRandomCode(20);
                    var code = {
                        valor: $scope.tag,
                        id: 63,
                    }
                    $scope.nuevoAparato.caracteristicas.push(code);
                } else {
                    $scope.is_saeg = false;
                    toastr.error('No tienes permisos para realizar esta acción');
                    $scope.nuevoAparato.tipo_ = '';
                }
                
            }
        }

        function validateEmail() {

            var email = $scope.nuevoAparato.caracteristicas.find(function(d) { return d.id == '6'});
            if (email) {
                var index = $scope.nuevoAparato.caracteristicas.findIndex(function(c){ return c.id == '6'})
                $scope.nuevoAparato.caracteristicas[index].valor = $scope.nuevoAparato.email_encargado.join();
            } else {
                var formatEmails = $scope.nuevoAparato.email_encargado.join();
                var emails = {
                    valor: formatEmails,
                    id: 6
                }
                $scope.nuevoAparato.caracteristicas.push(emails);
            }
            
        }

        $scope.copy = function(){
            toastr.success('Código copiado correctamente');
        }

        $scope.addImage = function() {
            var imagenes = [];
            var files = document.getElementById('file').files;
            var length = files.length;
            var contador = 0;
            files.forEach(function(f) {
                var r = new FileReader();
                r.onload = function (e) {
                    contador += 1;
                    var image = {
                        name: f.name,
                        url: e.target.result,
                        file: f
                    }
                    imagenes.push(image);
                    if(contador === length) {
                        renderImagenes(imagenes)
                    }
                }
                r.readAsDataURL(f);
            })

            function renderImagenes(imagenes) {
                $timeout(function(){
                    $scope.images = $scope.images.concat(imagenes)
                })
            }
            
        }

        

        function getFile(device, images) {
             
            // comprimir imágenes
            var imagenes = [];
            var counter_2 = 0;
            var files = images.map(function(i){return i.file});
            var length = files.length;
            files.forEach(function(file) {
                new Compressor(file, {
                    quality: 0.2,
                    success: function(result) {
                        counter_2 += 1;
                        var file = new File([result], result.name, { type: result.type });
                        imagenes.push(file); 
                        if(counter_2 === length){
                            getURLs(imagenes, device)
                        }
                    } 
                });
            })
        }

        function getURLs(imagenes, device) {
            var urls = [];
            var length = imagenes.length;
            var counter = 0;
            imagenes.forEach(function(f) {
                var r = new FileReader();
                r.onload = function (e) {
                    var hash = CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(e.target.result));
                    $q.resolve(RESTServices.getURL(f,hash)).then(function(url){
                        counter += 1;
                        urls.push(url);
                        if(counter === length){
                            device.imagenes = urls;
                            agregarDispositivo(device)
                        }
                    })
                    .catch(function(e){
                        console.log(e);
                        toastr.error('Hubo un problema inesperado con el servidor');  
                    });
                }
                r.readAsBinaryString(f);
            })
        }

        function linkImages(id, imagenes) {
            var promesas = imagenes.map(function(url) {
                var item = {
                    id: 0,
                    url: url,
                    id_contenedor: id,
                    id_creador: $localStorage.id_usuario,
                }
                var params = {
                    id_usuario: $localStorage.id_usuario,
                    tipo: 3,
                    imagen: JSON.stringify(item)
                }
                return RESTServices.post_header('cliente/edita_imagen.php', params, SHAREServices.hash_decode_token($localStorage.token),true)
            })

            Promise.all(promesas)
                .then(function(data) {
                    if(data[0].code === '200'){
                        toastr.success('Imagenes agregadas correctamente', 'Nuevo mantenimiento');
                    }
                    
                })
                .catch(function(error) {
                
                })
        }

        $scope.deteleImage = function(item) {
            var index = $scope.images.findIndex(function(i){return i.url === item.url})
            $scope.images.splice(index, 1)
        }

        $scope.showImage = function(index) {
            ngDialog.open({
                template: 'app/cliente/monitoreo/modales/slider-ticket.html',
                className: 'ngdialog-theme-plain modal-add-device',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.asunto = 'Mantenimiento'
                    $scope.images = $scope.images;
                    $scope.active = index;
                }]
            });
        }
        
    }
})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.mantenimiento').factory('ApparatusForms', function(apparatusProfileServices) {
        return {
            selectform: function(type) {
                return apparatusProfileServices.apparatusCharacteristics[type];
            },
            organizeCharacteristics: function(caracteristicas, dispositivo) {
                if (caracteristicas) {
                    caracteristicas.forEach(function(c) {
                        c.caracteristicas.forEach(function(itm) {
                            if (dispositivo[itm.nombre]) {
                                itm.valor = dispositivo[itm.nombre]
                            }
                        });
                    });
    
                    return caracteristicas;
                    
                }
                
            },
            setCharacteristics: function(caracteristicas, dispositivo) {
                var todos = [];
                if (caracteristicas) {
                    caracteristicas.forEach(function(c) {
                        c.caracteristicas.forEach(function(itm) {
                            if (dispositivo[itm.nombre]) {
                                var param = {
                                    id: itm.id,
                                    valor: dispositivo[itm.nombre]
                                }
                                todos.push(param);
                            }
                        });
                    });
                }
                
                this.otrasCaracteristicas.forEach(function(o){
                    if(dispositivo[o.nombre]) {
                        var param = {
                            id: o.id,
                            valor: dispositivo[o.nombre]
                        }
                        todos.push(param);
                    }
                })
                
                return todos;
                
            },
            otrasCaracteristicas : [
                {
                    id: 1,
                    nombre: 'marca'
                },
                {
                    id: 2,
                    nombre: 'tipo'
                },
                {
                    id: 3,
                    nombre: 'serie'
                },
                {
                    id: 4,
                    nombre: 'referencia'
                },
                {
                    id: 5,
                    nombre: 'nombre_encargado'
                },
                // {
                //     id: 6,
                //     nombre: 'email_encargado'
                // },
                {
                    id: 7,
                    nombre: 'tel_encargado'
                },
                {
                    id: 8,
                    nombre: 'comentario'
                },
            ],
            generateRandomCode: function(length) {
                var characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var result = ' ';
                var charactersLength = characters.length;
                for ( var i = 0; i < length; i++ ) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            },
            getDefaultCharacteristics: [
                {
                    id: 73,
                    valor: '100',
                },
                {
                    id: 74,
                    valor: '1',
                },
                {
                    id: 75,
                    valor: 0,
                },
                {
                    id: 76,
                    valor: 1,
                },
                {
                    id: 77,
                    valor: 1,
                },
                {
                    id: 78,
                    valor: 1,
                },
            ],
            defaultCharacteristicsSystem: [
                {
                    id: 0,
                    valor: '32',
                },
                {
                    id: 1,
                    valor: 'Helo',
                },
                
                {
                    id: 6,
                    valor: '',
                }
            ]
        }
    })
})();
(function() {
    'use strict';
    angular.module('BlurAdmin.cliente.mantenimiento').service('apparatusProfileServices', apparatusProfileServices);

    function apparatusProfileServices() {
        return {
          apparatusCharacteristics: {
            // Aire acondicionado
            '0': [
              {
                tipoDato: "Datos Eléctricos",
                caracteristicas: [
                  {
                    id: 14,
                    titulo: "Voltaje de alimentación",
                    nombre: "voltaje",
                    unidad: "V",
                    options: [120, 208, 240, 220, 277, 440, 480],
                  },
                  {
                    id: 26,
                    titulo: "Corriente Especificada",
                    nombre: "corriente_especificada",
                    unidad: "A",
                  },
                  {
                    id: 27,
                    titulo: "Corriente Máxima de operación",
                    nombre: "corriente_máxima",
                    unidad: "A",
                  },
                  {
                    id: 15,
                    titulo: "Frecuencia de la Red",
                    nombre: "frecuencia",
                    unidad: "Hz",
                    options: [50, 60],
                  },
                  {
                    id: 9,
                    titulo: "Potencia Nominal",
                    nombre: "potencia_nominal",
                    unidad: "Kw",
                  },
                  {
                    id: 28,
                    titulo: "Número de fases",
                    nombre: "fases",
                    unidad: "NA",
                    options: [1, 2, 3],
                  },
                ],
              },
              {
                tipoDato: "Datos de Refrigeración",
                caracteristicas: [
                  {
                    id: 23,
                    titulo: "Tipo de refrigerante",
                    nombre: "refrigerante",
                    unidad: "NA",
                    options: ['R134A', 'R22', 'R290', 'R404A', 'R507', 'R600A', 'R744'],
                  },
                  {
                    id: 29,
                    titulo: "Cantidad de Refrigerante Instalado",
                    nombre: "cantidad_refrigerante",
                    unidad: "Kg",
                  },
                  {
                    id: 19,
                    titulo: "Capacidad de Enfriamiento",
                    nombre: "frio_btu",
                    unidad: "btu",
                  },
                  {
                    id: 30,
                    titulo: "Consumo de energía",
                    nombre: "consumo_energia",
                    unidad: "kw/h",
                  },
                  {
                    id: 31,
                    titulo: "Potencia del compresor",
                    nombre: "potencia_compresor",
                    unidad: "HP",
                  },
                ]
              },
              {
                tipoDato: "Datos Mecánicos",
                caracteristicas: [
                  {
                    id: 22,
                    titulo: "Dimensiones del equipo",
                    nombre: "dimensiones_m3",
                    unidad: "m",
                  },
                  {
                    id: 32,
                    titulo: "Tipo de aire Acondicionado",
                    nombre: "tipo_aire",
                    unidad: "NA",
                    options: ['A/A Split Cassette', 'A/A Split Muro', 'A/A Split Piso techo', 'A/A De ventana', 'A/A Portatil', 'A/A Split Compacto'],
                  },
                  {
                    id: 33,
                    titulo: "Volumen o capacidad",
                    nombre: "volumen",
                    unidad: "Lt",
                  },
                  {
                    id: 18,
                    titulo: "Peso",
                    nombre: "peso",
                    unidad: "kg",
                  },
                  {
                    id: 34,
                    titulo: "Vida util",
                    nombre: "vida_util",
                    unidad: "Años",
                  },
                ]
              },
            ],
            //Refrigeración
            '1': [
              {
                tipoDato: "Datos Eléctricos",
                caracteristicas: [
                  {
                    id: 14,
                    titulo: "Voltaje de alimentación",
                    nombre: "voltaje",
                    unidad: "V",
                    options: [120, 208, 240, 220, 277, 440, 480],
                  },
                  {
                    id: 26,
                    titulo: "Corriente Especificada",
                    nombre: "corriente_especificada",
                    unidad: "A",
                  },
                  {
                    id: 15,
                    titulo: "Frecuencia de la Red",
                    nombre: "frecuencia",
                    unidad: "Hz",
                    options: [50, 60],
                  },
                  {
                    id: 9,
                    titulo: "Potencia Nominal",
                    nombre: "potencia_nominal",
                    unidad: "Kw",
                  },
                  {
                    id: 28,
                    titulo: "Número de fases",
                    nombre: "fases",
                    unidad: "NA",
                    options: [1, 2, 3],
                  },
                ],
              },
              {
                tipoDato: "Datos de Refrigeración",
                caracteristicas: [
                  {
                    id: 23,
                    titulo: "Tipo de refrigerante",
                    nombre: "refrigerante",
                    unidad: "NA",
                    options: ['R134A', 'R22', 'R290', 'R404A', 'R507', 'R600A', 'R744'],
                  },
                  {
                    id: 29,
                    titulo: "Cantidad de Refrigerante Instalado",
                    nombre: "cantidad_refrigerante",
                    unidad: "Kg",
                  },
                  {
                    id: 30,
                    titulo: "Consumo de energía",
                    nombre: "consumo_energia",
                    unidad: "kw/h",
                  },
                  {
                    id: 35,
                    titulo: "Temperatura de Operación",
                    nombre: "temperatura_operacion",
                    unidad: "C°",
                  },
                ]
              },
              {
                tipoDato: "Datos Mecánicos",
                caracteristicas: [
                  {
                    id: 22,
                    titulo: "Dimensiones del equipo",
                    nombre: "dimensiones_m3",
                    unidad: "m",
                  },
                  {
                    id: 36,
                    titulo: "Orientación del gabinete",
                    nombre: "orientacion",
                    unidad: "NA",
                    options: ['horizontal', 'vertical', 'mixto'],
                  },
                  {
                    id: 33,
                    titulo: "Volumen o capacidad",
                    nombre: "volumen",
                    unidad: "Lt",
                  },
                  {
                    id: 18,
                    titulo: "Peso",
                    nombre: "peso",
                    unidad: "kg",
                  },
                  {
                    id: 34,
                    titulo: "Vida util",
                    nombre: "vida_util",
                    unidad: "Años",
                  },
                ]
              },
            ],
            //Ascensores
            '25': [
              {
                tipoDato: "Datos Eléctricos",
                caracteristicas: [
                  {
                    id: 14,
                    titulo: "Voltaje de alimentación",
                    nombre: "voltaje",
                    unidad: "V",
                    options: [120, 208, 240, 220, 277, 440, 480],
                  },
                  {
                    id: 26,
                    titulo: "Corriente Especificada",
                    nombre: "corriente_especificada",
                    unidad: "A",
                  },
                  {
                    id: 15,
                    titulo: "Frecuencia de la Red",
                    nombre: "frecuencia",
                    unidad: "Hz",
                    options: [50, 60],
                  },
                  {
                    id: 9,
                    titulo: "Potencia Nominal",
                    nombre: "potencia_nominal",
                    unidad: "Kw",
                  },
                  {
                    id: 28,
                    titulo: "Número de fases",
                    nombre: "fases",
                    unidad: "NA",
                    options: [1, 2, 3],
                  },
                ],
              },
              {
                tipoDato: "Datos Mecánicos",
                caracteristicas: [
                  {
                    id: 22,
                    titulo: "Dimensiones del equipo",
                    nombre: "dimensiones_m3",
                    unidad: "m",
                  },
                  {
                    id: 37,
                    titulo: "Cantidad de personas",
                    nombre: "cantidad_personas",
                    unidad: "NA",
                    options: [4, 6, 8, 10, 12, 15],
                  },
                  {
                    id: 25,
                    titulo: "Velocidad",
                    nombre: "velocidad",
                    unidad: "m/s",
                  },
                  {
                    id: 38,
                    titulo: "Altura util de la cabina",
                    nombre: "altura_util",
                    unidad: "m",
                  },
                  {
                    id: 39,
                    titulo: "Carga util",
                    nombre: "carga_util",
                    unidad: "kg",
                  },
                ]
              },
            ],
            //Escaleras Eléctricas
            '29': [
              {
                tipoDato: "Datos Eléctricos",
                caracteristicas: [
                  {
                    id: 14,
                    titulo: "Voltaje de alimentación del motor",
                    nombre: "voltaje",
                    unidad: "V",
                    options: [120, 208, 240, 220, 277, 440, 480],
                  },
                  {
                    id: 26,
                    titulo: "Corriente Especificada",
                    nombre: "corriente_especificada",
                    unidad: "A",
                  },
                  {
                    id: 15,
                    titulo: "Frecuencia de la Red",
                    nombre: "frecuencia",
                    unidad: "Hz",
                    options: [50, 60],
                  },
                  {
                    id: 9,
                    titulo: "Potencia Nominal",
                    nombre: "potencia_nominal",
                    unidad: "Kw",
                  },
                  {
                    id: 28,
                    titulo: "Número de fases",
                    nombre: "fases",
                    unidad: "NA",
                    options: [1, 2, 3],
                  },
                ],
              },
              {
                tipoDato: "Datos Mecánicos",
                caracteristicas: [
                  {
                    id: 40,
                    titulo: "Disposición de la escalera",
                    nombre: "disposicion_escalera",
                    unidad: "NA",
                    options: ['En tijera', 'En paralelo', 'Cruzada con Balalustradas Alineadas', 'Servicio a dos niveles', 'Servicio a tres niveles', 'Baterías para 3 o más niveles'],
                  },
                  {
                    id: 25,
                    titulo: "Velocidad nomial de funcionamiento",
                    nombre: "Velocidad",
                    unidad: "m/s",
                  },
                  {
                    id: 41,
                    titulo: "Ambiente de Ubicación",
                    nombre: "ubicacion",
                    unidad: "NA",
                    options: ['Interior', 'Interperie'],
                  },
                  {
                    id: 42,
                    titulo: "Sector comercial",
                    nombre: "sector",
                    unidad: "NA",
                    options: ['Grandes almacenes', 'Centros comerciales', 'Hoteles', 'Edificios de oficinas', 'Otra'],
                  },
                  {
                    id: 43,
                    titulo: "Revestimiento en Peldaños",
                    nombre: "revestimiento_peldanos",
                    unidad: "NA",
                    options: ['Acabado Natural', 'Pintado en negro o gris', 'Lijado', 'Sin tratamiento de lijado'],
                  },
                  {
                    id: 44,
                    titulo: "Anchura de los Peldaños",
                    nombre: "anchura_peldanos",
                    unidad: "m",
                    options: [600, 800, 1000],
                  },
                  {
                    id: 45,
                    titulo: "Inclinación de la escalera",
                    nombre: "inclinacion",
                    unidad: "°",
                    options: [3, 30, 35],
                  },
                  {
                    id: 46,
                    titulo: "Inclinación de la andenes",
                    nombre: "inclinacion_andenes",
                    unidad: "°",
                    options: ['0 a 6', '10 a 12'],
                  },
                  {
                    id: 47,
                    titulo: "Revestimiento Exterior Lateral",
                    nombre: "revestimiento_exterior_lateral",
                    unidad: "NA",
                    options: ['Acero inoxidable', 'Chepa pintada', 'Espejo', 'Metales pétreos'],
                  },
                ]
              },
            ],
            //SAEG
            '39': [
              {
                tipoDato: "Integración",
                caracteristicas: [
                  {
                    id: 63,
                    titulo: "TAG Integración",
                    nombre: "tag_saeg",
                  }
                ]
              }
            ],
            ///Emporia
            '42': [
              {
                tipoDato: "Integración",
                caracteristicas: [
                  {
                    id: 79,
                    titulo: "TAG Integración",
                    nombre: "tag_emporia",
                  }
                ]
              }
            ],
            //Sistema fotovoltáicos
            // '31': [
            //   {
            //     tipoDato: "Datos del sistema",
            //     caracteristicas: [
            //       {
            //         id: 48,
            //         titulo: "Tipo de Instalación",
            //         nombre: "tipo_instalacion",
            //         unidad: "NA",
            //         options: ['Off grid', 'On grid'],
            //       },
            //       {
            //         id: 49,
            //         titulo: "Zona de instalación",
            //         nombre: "zona_instalacion",
            //         unidad: "NA",
            //         options: ['A nivel del suelo', 'En el techo', 'En pedestal o poste'],
            //       },
            //       {
            //         id: 50,
            //         titulo: "Tensión del sistema",
            //         nombre: "tension",
            //         unidad: "Vdc",
            //         options: [12, 24, 48],
            //       },
            //       {
            //         id: 51,
            //         titulo: "Energía Teórica Diaria",
            //         nombre: "energia_teorica_diaria",
            //         unidad: "Wh/Día",
            //       },
            //       {
            //         id: 52,
            //         titulo: "Energía Real Diaria",
            //         nombre: "energia_real_diaria",
            //         unidad: "Wh/Día",
            //       },
            //       {
            //         id: 53,
            //         titulo: "Performance Ratio ó Coeficiente de Rendimiento",
            //         nombre: "rendimiento",
            //         unidad: "%",
            //       },
            //       {
            //         id: 54,
            //         titulo: "Material de Soportes y Rieles",
            //         nombre: "soportes",
            //         unidad: "NA",
            //         options: ['Hierro', 'Aluminio', 'Galvanizado', 'Acero', 'Acero inoxidable'],
            //       },
            //       {
            //         id: 55,
            //         titulo: "Ángulo de inclinacion de los Soportes",
            //         nombre: "angulo_inclinacion",
            //         unidad: "°",
            //         options: [0, 15, 30,],
            //       },
            //     ],
            //   },
            //   {
            //     tipoDato: "Datos del Panel solar",
            //     caracteristicas: [
            //       {
            //         id: 56,
            //         titulo: "Total páneles",
            //         nombre: "total_paneles",
            //         unidad: "NA",
            //       },
            //       {
            //         id: 57,
            //         titulo: "Número de páneles en serie",
            //         nombre: "paneles_serie",
            //         unidad: "NA",
            //       },
            //       {
            //         id: 58,
            //         titulo: "Número de páneles en paralelo",
            //         nombre: "paneles_paralelo",
            //         unidad: "NA",
            //       },
            //       {
            //         id: 59,
            //         titulo: "Tipo de celda solar",
            //         nombre: "tipo_celda",
            //         unidad: "NA",
            //         options: ['Silicio Monocristalino', 'Silicio policristalino'],
            //       },
            //       {
            //         id: 9,
            //         titulo: "Potencia Máxima en STC (Pmax)",
            //         nombre: "potencia_nominal",
            //         unidad: "Wp",
            //       },
            //       {
            //         id: 60,
            //         titulo: "Voltaje de circuito abierto (Voc)",
            //         nombre: "voltaje_circuito_abierto",
            //         unidad: "m",
            //         options: [600, 800, 1000],
            //       },
            //       {
            //         id: 45,
            //         titulo: "Inclinación de la escalera",
            //         nombre: "inclinacion",
            //         unidad: "°",
            //         options: [3, 30, 35],
            //       },
            //       {
            //         id: 46,
            //         titulo: "Inclinación de la andenes",
            //         nombre: "inclinacion_andenes",
            //         unidad: "°",
            //         options: ['0 a 6', '10 a 12'],
            //       },
            //       {
            //         id: 47,
            //         titulo: "Revestimiento Exterior Lateral",
            //         nombre: "revestimiento_exterior_lateral",
            //         unidad: "NA",
            //         options: ['Acero inoxidable', 'Chepa pintada', 'Espejo', 'Metales pétreos'],
            //       },
            //     ]
            //   },
            // ],

            // DMS
            '32': [
              {
                tipoDato: "Configuración",
                caracteristicas: [
                  {
                    id: 84,
                    titulo: "Límite Máximo Temperatura",
                    nombre: "limite_max_temp",
                    unidad: "C°",
                  },
                  {
                    id: 85,
                    titulo: "Límite Mínimo Temperatura",
                    nombre: "limite_min_temp",
                    unidad: "C°",
                  },
                  {
                    id: 93,
                    titulo: "Modo de Operación",
                    nombre: "modo_operacion",
                    unidad: "NA",
                    options: [
                      { value: '0', text: 'Calefacción' },
                      { value: '1', text: 'Enfriar' },
                      { value: '2', text: 'Ventilación' },
                      { value: '4', text: 'Sin configurar' },
                    ],
                  },
                  {
                    id: 91,
                    titulo: "Velocidad Ventilador",
                    nombre: "estado_fan",
                    unidad: "NA",
                    options: [
                      { value: '0', text: 'Auto' },
                      { value: '1', text: 'Bajo' },
                      { value: '2', text: 'Medio' },
                      { value: '3', text: 'Alto' },
                      { value: '4', text: 'Sin configurar' },
                    ],
                  },
                  {
                    id: 94,
                    titulo: "Swing",
                    nombre: "swing",
                    unidad: "NA",
                    options: [
                      { value: '0', text: 'Desactivado' },
                      { value: '1', text: 'Activado' },
                      { value: '2', text: 'Sin configurar' },
                    ],
                  },
                ]
              },
            ],

          },
        }

    }
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('device_settingsCtrl', device_settingsCtrl);

    /** @ngInject */
    function device_settingsCtrl($scope, RESTServices, $timeout, $filter, $localStorage, $state, toastr, maintenanceServices, SHAREServices, $stateParams, AutoServices, ngDialog, $rootScope) {
        $rootScope.flag_loading = true;
        var caracteristicas = [];
        $scope.disabled = false;
        $scope.settings = {
            sensor: null,
            h_ini: undefined,
            h_fin: undefined,
            comando: undefined,
            ausencia: undefined,
            ahorro: null,
            grados: undefined,
            tiempo: undefined,
            umbral_corriente_low: null,
            umbral_corriente_high: null,
        };
        if($stateParams.device){
            $scope.device = $stateParams.device;
            $scope.device.id_device = parseFloat($scope.device.id_device)
        } else {
            $state.go('dashboard_cliente')
        }
        
        $scope.timeRanges = maintenanceServices.timeRanges;
        $scope.degreesRanges = maintenanceServices.degreesRanges;
        $scope.lackRanges = maintenanceServices.lackRanges;
        $scope.commands_bd = {
            id: undefined,
            referencia: undefined,
        };
        

        $timeout(function(){

            if($stateParams.device) {
                $scope.commandControl = $scope.device.tipo === '29' ? AutoServices.wind_CurtainControl : AutoServices.commandControl;
                // v2: migrated from consulta_configuracion.php
                RESTServices.fetchDeviceConfigV2($stateParams.device.id_device).then(function(res) {
                    if(res.code === '200') {
                        res.caracteristicas.forEach(function(c){
                            var property = maintenanceServices.settings_properties.find(function(s){return s.id === c.id})
                            if (property) {
                                $scope.settings[property.name] = c.valor;
                            }
                        })

                        var h_ini = new Date();
                        var h_fin = new Date();
                        h_ini.setHours($scope.settings.h_ini);
                        h_fin.setHours($scope.settings.h_fin);
                        h_ini.setMinutes('00');
                        h_ini.setSeconds('00');
                        h_ini.setMilliseconds('00');
                        h_fin.setMinutes('00');
                        h_fin.setSeconds('00');
                        h_fin.setMilliseconds('00');
                        
                        h_ini = $filter('date')(h_ini, 'yyyy-MM-dd HH:mm:ss');
                        h_fin = $filter('date')(h_fin, 'yyyy-MM-dd HH:mm:ss');
                        h_ini = new Date(h_ini.replace(' ', 'T')+'Z');
                        h_fin = new Date(h_fin.replace(' ', 'T')+'Z');

                        $scope.settings.sensor = $scope.settings.sensor ? ($scope.settings.sensor === '1' ? true : false) : null;
                        $scope.settings.ahorro = $scope.settings.ahorro ? ($scope.settings.ahorro === '1' ? true : false) : null;
                        $scope.settings.h_ini = h_ini;
                        $scope.settings.h_fin = h_fin;

                        if ($stateParams.device.tipo === '29') {
                            $scope.settings.umbral_corriente_low = parseInt($scope.settings.umbral_corriente_low);
                            $scope.settings.umbral_corriente_high = parseInt($scope.settings.umbral_corriente_high);
                        }

                        if(res.aire) {
                            $scope.commands_bd = res.aire;
                        }
                        res.caracteristicas.forEach(function(s){
                            $scope.setcharacteristics(s.valor, s.id)
                        })
                        $rootScope.flag_loading = false;
                    } else {
                        toastr.error('Esta opción no está disponible para este dispositivo', 'Algo ha fallado');
                        $state.go('dashboard_cliente');
                    }
                })
            } else {
                $state.go('dashboard_cliente');
            }
            

        })
        
        $scope.editarConfiguracion = function() {
            $scope.disabled = true;
            var payload = {
                caracteristicas: caracteristicas,
            };

            // v2: migrated from cliente/edita_configuracion.php
            RESTServices.updateDeviceConfigV2($stateParams.device.id_device, payload).then(function(res) {
                toastr.success('Se ha cambiado la configuración', 'Éxito');
                $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
            }).catch(function() {
                toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                $scope.disabled = false;
            })
        }

        $scope.setcharacteristics = function(valor, id, nuevo) {
            var index = caracteristicas.findIndex(function(c){ return c.id == id });
            if (index !== -1) {
                if ((id == 65 || id == 66) && nuevo) {
                    var isoString = valor.toISOString();
                    var utcHours = isoString.slice(11, 13);
                    caracteristicas[index].valor = utcHours;
                } else {
                    caracteristicas[index].valor = valor === true ? '1' : valor === false ? '0' : valor;
                }
            } else {
                var caracteristica = {
                    valor: valor === true ? '1' : valor === false ? '0' : valor,
                    id: id
                }
                caracteristicas.push(caracteristica);
            }; 
        }

        $scope.cancelar = function() {
            $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
        }

        function formatDate() {
            var d = new Date(dt.tiempo.replace(' ', 'T')+'Z');
            return d;
        }

        $scope.goToChangeBD = function(){
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/confirmacion.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                closeByDocument: true,
                controller: ['$scope', function($scope) {
                    $scope.bodyModal = "Este proceso cambia los comandos de operación del Helo Air ¿Desea continuar?";
                    
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };
                    $scope.aceptar = function() {  
                        $state.go('change_DB',{device: $stateParams.device, aire_actual: $scope.commands_bd});                                
                        ngDialog.close();
                    }
                }]
            })
        }

        $scope.$on("$destroy", function () {
            ngDialog.close();
        });

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('settings_helo_virtual_Ctrl', settings_helo_virtual_Ctrl);

    /** @ngInject */
    function settings_helo_virtual_Ctrl($scope, RESTServices, $timeout, $localStorage, $state, toastr, maintenanceServices, SHAREServices, $stateParams, $rootScope) {
        $rootScope.flag_loading = true;
        $scope.disabled = false;
        
        $timeout(function(){
            $scope.settings = {
                id: '0',
                id_dispositivo: $stateParams.device.id_device,
                tipo: $stateParams.device.tipo,
                latitud: null,
                longitud: null,
                id_origen: null,
                estado: '1',
            };
            $scope.device = $stateParams.device;

            if($stateParams.device) {
                getInfoDevice($stateParams.device.id_device);
                getApiArray();
            } else {
                $state.go('dashboard_cliente');
            }

        })

        function getInfoDevice(id_device){

            var params = {
                id_usuario: $localStorage.id_usuario,
                id_dispositivo: id_device,
            }
            RESTServices.post_header('cliente/consulta_dispositivo_virtual.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if(res.code === '200') {
                    res.dispositivo.latitud = parseFloat(res.dispositivo.latitud);
                    res.dispositivo.longitud = parseFloat(res.dispositivo.longitud)
                    $scope.settings = res.dispositivo;
                    
                } else {
                    
                }
                $rootScope.flag_loading = false;
            })
        }

        function getApiArray() {
            var params = {
                id_usuario: $localStorage.id_usuario,
            }
            RESTServices.post_header('cliente/consulta_origenes_datos.php', params, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if(res.code === '200') {
                    $scope.apis = res.origen_datos;
                } else {
                    
                }
                $rootScope.flag_loading = false;
            })
        }
        
        $scope.editarConfiguracion = function(device) {
            $scope.disabled = true;
            device.tipo = $stateParams.device.tipo;
            device.estado = '1';
            device.latitud = device.latitud.toString();
            device.longitud = device.longitud.toString();
            var fields = {
                id_usuario: $localStorage.id_usuario,
                dispositivo_virtual: JSON.stringify(device),
            };

            RESTServices.post_header('cliente/edita_dispositivo_virtual.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if(res.code === '200'){
                    toastr.success('Se ha cambiado la configuración', 'Éxito');
                    $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
                }else {
                    toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                    $scope.disabled = false;
                }
            })
        }

        $scope.cancelar = function() {
            $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
        }

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('settings_helo_s_Ctrl', settings_helo_s_Ctrl);

    /** @ngInject */
    function settings_helo_s_Ctrl($scope, RESTServices, $timeout, $localStorage, $state, toastr, maintenanceServices, SHAREServices, $stateParams, $rootScope) {
        $rootScope.flag_loading = true;
        var caracteristicas = [];
        $scope.disabled = false;
        $scope.settings = {
            ct_type: null,
            current_ct: null,
            sampling_time: null,
            offset: null,
            channel_1: null,
            channel_2: null,
            channel_3: null,
            frequency: null,
        };

        $scope.ct_type = maintenanceServices.ct_type;
        $scope.frequency = maintenanceServices.frequency;
        $scope.current_ct = maintenanceServices.current_ct;
        $scope.sampling_time = maintenanceServices.sampling_time;
        $scope.device = $stateParams.device;

        $timeout(function(){

            if($stateParams.device) {
                // v2: migrated from consulta_configuracion.php
                RESTServices.fetchDeviceConfigV2($stateParams.device.id).then(function(res) {
                    if(res.code === '200') {

                        res.caracteristicas.forEach(function(c){
                            var property = maintenanceServices.settings_properties.find(function(s){return s.id === c.id})
                            if (property) {
                                $scope.settings[property.name] = c.valor;
                            }
                        })

                        if ($scope.settings.offset) {
                            $scope.settings.offset = parseInt($scope.settings.offset)
                        }

                        if ($scope.settings.frequency) {
                            $scope.settings.frequency = parseInt($scope.settings.frequency)
                        }

                        if ($stateParams.device.tipo === '23') {
                            $scope.settings.channel_1 = $scope.settings.channel_1 ? ($scope.settings.channel_1 === '1' ? true : false) : null;
                            $scope.settings.channel_2 = $scope.settings.channel_2 ? ($scope.settings.channel_2 === '1' ? true : false) : null;
                            $scope.settings.channel_3 = $scope.settings.channel_3 ? ($scope.settings.channel_3 === '1' ? true : false) : null;
                        }
                        
                        res.caracteristicas.forEach(function(s){
                            $scope.setcharacteristics(s.valor, s.id)
                        })
                        $rootScope.flag_loading = false;
                    } else {
                        toastr.error('Esta opción no está disponible para este dispositivo', 'Algo ha fallado');
                        $state.go('dashboard_cliente');
                    }
                })
            } else {
                $state.go('dashboard_cliente');
            }
            

        })
        
        $scope.editarConfiguracion = function() {
            $scope.disabled = true;
            // tipo must be a number for the Go lambda (int, not the stringified
            // device type used elsewhere in the UI).
            var payload = {
                caracteristicas: organiceArray(caracteristicas),
                tipo: parseInt($stateParams.device.tipo, 10),
            };
            if ($stateParams.device.tipo === '23') {
                payload.agrupados = organiceArray($stateParams.device.agrupados);
            }

            // v2: migrated from cliente/edita_configuracion.php
            RESTServices.updateDeviceConfigV2($stateParams.device.id, payload).then(function(res) {
                toastr.success('Se ha cambiado la configuración', 'Éxito');
                $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
            }).catch(function() {
                toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                $scope.disabled = false;
            })
        }

        $scope.setcharacteristics = function(valor, id) {
            var index = caracteristicas.findIndex(function(c){ return c.id == id });
            if (index !== -1) {
                caracteristicas[index].valor = valor === true ? '1' : valor === false ? '0' : valor;
            } else {
                var caracteristica = {
                    valor: valor === true ? '1' : valor === false ? '0' : valor,
                    id: id
                }
                caracteristicas.push(caracteristica);
            }; 
        }

        $scope.cancelar = function() {
            $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
        }

        function organiceArray(ids) {
            ids.sort(function (a, b) {
                if (a.id > b.id) {
                    return 1;
                }
                if (a.id < b.id) {
                    return -1;
                }
                return 0;
            });
            // v2: updateDeviceConfigV2 sends real JSON (not a stringified body),
            // so return the sorted array itself instead of JSON.stringify(ids).
            return ids;
        }

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('settings_helo_t_Ctrl', settings_helo_t_Ctrl);

    /** @ngInject */
    function settings_helo_t_Ctrl($scope, RESTServices, $timeout, $filter, $localStorage, $state, toastr, maintenanceServices, SHAREServices, $stateParams, AutoServices, ngDialog, $rootScope) {
        $rootScope.flag_loading = true;
        var caracteristicas = [];
        $scope.disabled = false;
        $scope.settings = {
            modo_operacion: undefined,
            velocidad_fan: undefined,
            bloqueo: undefined,
        };
        if($stateParams.device){
            $scope.device = $stateParams.device;
            $scope.device.id_device = parseFloat($scope.device.id_device)
        } else {
            $state.go('dashboard_cliente')
        }
        
        $scope.velocidad_ventilador = AutoServices.velocidad_ventilador;
        $scope.modos_termostato = AutoServices.modos_termostato;
        $scope.block_termostato = AutoServices.block_termostato;

        
        $timeout(function(){

            if($stateParams.device) {
       
                // v2: migrated from consulta_configuracion.php
                RESTServices.fetchDeviceConfigV2($stateParams.device.id_device).then(function(res) {
                    if(res.code === '200') {
                        
                        res.caracteristicas.forEach(function(c){
                            var property = maintenanceServices.settings_properties.find(function(s){return s.id === c.id})
                            if (property) {
                                $scope.settings[property.name] = c.valor;
                            }
                        })
                            
                        res.caracteristicas.forEach(function(s){
                            $scope.setcharacteristics(s.valor, s.id)
                        })
                        $rootScope.flag_loading = false;
                    } else {
                        toastr.error('Esta opción no está disponible para este dispositivo', 'Algo ha fallado');
                        $state.go('dashboard_cliente');
                    }
                    
                })
            } else {
                $state.go('dashboard_cliente');
            }
            

        })
        
        $scope.editarConfiguracion = function() {
            $scope.disabled = true;
            var payload = {
                caracteristicas: caracteristicas,
            };

            // v2: migrated from cliente/edita_configuracion.php
            RESTServices.updateDeviceConfigV2($stateParams.device.id_device, payload).then(function(res) {
                toastr.success('Se ha cambiado la configuración', 'Éxito');
                $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
            }).catch(function() {
                toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                $scope.disabled = false;
            })
        }

        $scope.setcharacteristics = function(valor, id) {
            var index = caracteristicas.findIndex(function(c){ return c.id == id });
            if (index !== -1) {
                caracteristicas[index].valor = valor === true ? '1' : valor === false ? '0' : valor;
            } else {
                var caracteristica = {
                    valor: valor === true ? '1' : valor === false ? '0' : valor,
                    id: id
                }
                caracteristicas.push(caracteristica);
            };
        }

        $scope.cancelar = function() {
            $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
        }

    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('settings_helo_th_Ctrl', settings_helo_th_Ctrl);

    /** @ngInject */
    function settings_helo_th_Ctrl($scope, RESTServices, $timeout, $localStorage, $state, toastr, maintenanceServices, SHAREServices, $stateParams, $rootScope) {
        
        $rootScope.flag_loading = true;
        var caracteristicas = [];
        $scope.disabled = false;
        $scope.settings = {
            offset_t: 0,
            activar_umbral_t: false,
            umbral_t_max: null,
            umbral_t_min: null,
        };

        $timeout(function(){

            if($stateParams.device) {
                // v2: migrated from consulta_configuracion.php
                RESTServices.fetchDeviceConfigV2($stateParams.device.id ? $stateParams.device.id : $stateParams.device.id_device).then(function(res) {
                    if(res.code === '200') {

                        res.caracteristicas.forEach(function(c){
                            var property = maintenanceServices.settings_properties.find(function(s){return s.id === c.id})
                            if (property) {
                                $scope.settings[property.name] = parseFloat(c.valor);
                            }
                        })
                        if ($scope.settings.activar_umbral_t) {
                            $scope.settings.activar_umbral_t = $scope.settings.activar_umbral_t === 1 ? true : false;
                        }
                       
                            
                        res.caracteristicas.forEach(function(s){
                            $scope.setcharacteristics(s.valor, s.id)
                        })
                        
                    } else {
                    }
                    $rootScope.flag_loading = false;
                })
            } else {
                $state.go('dashboard_cliente');
            }
            

        })
        
        $scope.editarConfiguracion = function() {
            $scope.disabled = true;
            var index = caracteristicas.findIndex(function(c){ return c.id == 86})
            if(index === -1){
                $scope.setcharacteristics('0', 86)
                $scope.setcharacteristics(null, 84)
                $scope.setcharacteristics(null, 85)
            } else {
                if(caracteristicas[index].valor === '0') {
                    var index_2 = caracteristicas.findIndex(function(c){ return c.id == 84})
                    caracteristicas[index_2].valor = null;
                    var index_3 = caracteristicas.findIndex(function(c){ return c.id == 85})
                    caracteristicas[index_3].valor = null;
                }
            }
            
            var deviceId = $stateParams.device.id ? $stateParams.device.id : $stateParams.device.id_device;
            var payload = {
                caracteristicas: caracteristicas,
            };

            // v2: migrated from cliente/edita_configuracion.php
            RESTServices.updateDeviceConfigV2(deviceId, payload).then(function(res) {
                toastr.success('Se ha cambiado la configuración', 'Éxito');
                $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
            }).catch(function() {
                toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                $scope.disabled = false;
            })
        }

        $scope.setcharacteristics = function(valor, id) {
            var index = caracteristicas.findIndex(function(c){ return c.id == id });
            if (index !== -1) {
                caracteristicas[index].valor = valor === true ? '1' : valor === false ? '0' : valor;
            } else {
                var caracteristica = {
                    valor: valor === true ? '1' : valor === false ? '0' : valor,
                    id: id
                }
                caracteristicas.push(caracteristica);
            };
            if( id === 86 && !valor) {
                $scope.settings.umbral_t_max = null;
                $scope.settings.umbral_t_min = null;
            }
        }

        $scope.cancelar = function() {
            $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
        }


    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('settings_hub_Ctrl', settings_hub_Ctrl);

    /** @ngInject */
    function settings_hub_Ctrl($scope, RESTServices, $timeout, $localStorage, $state, toastr, SHAREServices, $stateParams, $rootScope, maintenanceServices, $filter) {
        
        $rootScope.flag_loading = true;
        var caracteristicas = [];
        $scope.disabled = false;
        $scope.settings = {
            direction: null,
            turning_sense: null,
            frequency: null,
            baudios_rate: null,
            paridad: null,
        };
        $scope.device = $stateParams.device;
        $scope.baudios_rate = maintenanceServices.baudios_rate;
        $scope.paridad = maintenanceServices.paridad;
        $scope.loading = true;

        $timeout(function(){

            if($stateParams.device) {
                // v2: migrated from consulta_configuracion.php
                RESTServices.fetchDeviceConfigV2($stateParams.device.id ? $stateParams.device.id : $stateParams.device.id_device).then(function(res) {
                    if(res.code === '200') {

                        res.caracteristicas.forEach(function(c){
                            var property = maintenanceServices.settings_properties.find(function(s){return s.id === c.id})
                            if (property) {
                                $scope.settings[property.name] = c.valor;
                            }
                        })

                        if ($scope.settings.direction) {
                            $scope.settings.direction = parseInt($scope.settings.direction)
                        }

                        if ($scope.settings.frequency) {
                            $scope.settings.frequency = parseInt($scope.settings.frequency)
                        }

                        res.caracteristicas.forEach(function(s){
                            $scope.setcharacteristics(s.valor, s.id)
                        })
                        
                    }
                    $rootScope.flag_loading = false;
                })
            } else {
                $state.go('dashboard_cliente');
            }
            

        })
        
        $scope.editarConfiguracion = function() {
            $scope.disabled = true;
            var deviceId = $stateParams.device.id ? $stateParams.device.id : $stateParams.device.id_device;
            var payload = {
                caracteristicas: caracteristicas,
            };

            // v2: migrated from cliente/edita_configuracion.php
            RESTServices.updateDeviceConfigV2(deviceId, payload).then(function(res) {
                toastr.success('Se ha cambiado la configuración', 'Éxito');
                $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
            }).catch(function() {
                toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                $scope.disabled = false;
            })
        }

        $scope.setcharacteristics = function(valor, id) {
            var index = caracteristicas.findIndex(function(c){ return c.id == id });
            if (index !== -1) {
                caracteristicas[index].valor = valor === true ? '1' : valor === false ? '0' : valor;
            } else {
                var caracteristica = {
                    valor: valor === true ? '1' : valor === false ? '0' : valor,
                    id: id
                }
                caracteristicas.push(caracteristica);
            }; 
        }

        $scope.cancelar = function() {
            $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
        }


    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('settings_hub_master_Ctrl', settings_hub_master_Ctrl);

    /** @ngInject */
    function settings_hub_master_Ctrl($scope, RESTServices, $timeout, $localStorage, $state, toastr, SHAREServices, $stateParams, $rootScope, maintenanceServices, $filter) {
        
        $rootScope.flag_loading = true;
        $scope.disabled = false;
        $scope.settings = {
            selectedDevices: [],
        };
        $scope.device = $stateParams.device;
        $scope.devices = [];
        $scope.loading = true;
        var selected_devices_original = [];
        var indFilter = true;
        var allItems = [];

        $timeout(function(){

            if($stateParams.devices && $stateParams.device.tipo === '31'){
                var devices = $stateParams.devices.filter(function(d){return d.tipo !== '26' && d.tipo !== '31'});
                organizeDevices($stateParams.device, devices)
            } else {
                if($stateParams.device){
                    getDevices($stateParams.device.id_zona)
                }   
            }

            if($stateParams.device) {
            } else {
                $state.go('dashboard_cliente');
            }
            

        })
                

        $scope.cancelar = function() {
            $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
        }

        function getDevices(id_zona) {
        
            RESTServices.fetchDevicesByZone(id_zona).then(function(res) {
                if (res.code == '200') {
                    var devices = res.dispositivos.filter(function(d){return d.tipo !== '26' && d.tipo !== '31' && d.tipo !== '11'});
                    organizeDevices($stateParams.device, devices)
                }
            });  
        }

        function organizeDevices(device, arrayDevices) {
            arrayDevices.map(function(f){ 
                f.id = String(f.id); // compared with === against ids from consulta_dispositivos_master.php
                f.status = false;
                f.direccion = null;
                return f;
            })

            var fields = {
                "id_dispositivo": device.id_device,
                "id_usuario": $localStorage.id_usuario,
            };

            RESTServices.post_header('cliente/consulta_dispositivos_master.php', fields, SHAREServices.hash_decode_token($localStorage.token),true).then(function(res) {
                if (res.code == '200') {
                    res.dispositivos.forEach(function(item){
                        var index = arrayDevices.findIndex(function(d){return d.id === item.id})
                        if(index >= 0) {
                            arrayDevices[index].status = true;
                            arrayDevices[index].direccion = parseInt(item.direccion);
                            selected_devices_original.push(arrayDevices[index]);
                            $scope.settings.selectedDevices.push(arrayDevices[index])
                        }
                    })
                    $scope.devices = arrayDevices;

                } else {
                    $scope.devices = arrayDevices;
                }
                
                $scope.validateList(); 
                $scope.devices = $filter('orderBy')($scope.devices, 'nombre');
                $scope.devices = $filter('orderBy')($scope.devices, 'direccion');
                $scope.loading = false;
                $rootScope.flag_loading = false;
            });

        }
        $scope.editarConfiguracion = function() {
            validateDevices();
        }

        function validateDevices() {
            if(arrayIgual($scope.settings.selectedDevices, selected_devices_original)) {
                $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control});
            } else { 
                var devices_to_unlink = compararArreglosPorId($scope.settings.selectedDevices, selected_devices_original);
                var devices_to_link = compararArreglosPorId(selected_devices_original, $scope.settings.selectedDevices);
                if(devices_to_unlink.length > 0) {
                    callService(0, devices_to_unlink)
                    callService(1, $scope.settings.selectedDevices)
                }
                if(devices_to_link.length > 0) {
                    callService(1, devices_to_link);
                }
            }
        }
        function callService(ind, devices){

            var id_dispositivos = devices.map(function(d, i){
                return ({
                    id : d.id,
                    direccion: d.direccion, 
                })
            })
            var parms = {
                "id_agrupador": $scope.device.id_device,
                "dispositivos": JSON.stringify(id_dispositivos),
                "id_usuario": $localStorage.id_usuario,
                "asociar": ind,
                "tipo": "31",
            };

            RESTServices.post_header('cliente/asociar_dispositivos_agrupador.php', parms, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                if(response.code === '200'){
                    toastr.success('Se ha agregado los equipos correctamente', 'Éxito');
                    $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
                } else {
                    toastr.error('Algo ha fallado, intenta nuevamente más tarde', 'configuración');
                    $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
                }
            })
        }

        function compararArreglosPorId(nuevo, original) {
            var idsNuevo = nuevo.map(function(obj) { return obj.id});
            var objetosNoEncontrados = original.filter(function(obj) {return !idsNuevo.includes(obj.id)} );
            return objetosNoEncontrados;
        }

        function arrayIgual(array1, array2) {
            var idsArray1 = array1.map(function(obj) { return obj.id});
            var idsArray2 = array2.map(function(obj) { return obj.id});
            var direcciones1 = array1.map(function(obj) { return obj.direccion});
            var direcciones2 = array2.map(function(obj) { return obj.direccion});
            var validador1 = JSON.stringify(idsArray1.sort()) == JSON.stringify(idsArray2.sort());
            var validador2 = JSON.stringify(direcciones1.sort()) == JSON.stringify(direcciones2.sort());
            return validador1 || validador2;
        }

        function asignarMaximo(devices){
            var direcciones = [];
            var maximo = null;
            devices.forEach(function(d){
                if(d.direccion) {
                    direcciones.push(d.direccion)
                }
            })

            // Convertimos los strings a números
            var numerosConvertidos = [];
            for (var i = 0; i < direcciones.length; i++) {
                numerosConvertidos.push(Number(direcciones[i]));
            }

            // Usamos Math.max.apply para encontrar el máximo
            if(numerosConvertidos.length > 0){
                maximo = Math.max.apply(null, numerosConvertidos); 
            }
            
            return maximo === null ? 0 : maximo;
        }

        $scope.selectAll = function(flag) {
            if(flag) {
                var contador = 0;
                $scope.devices.map(function(i){
                    i.status = true;
                    i.direccion = contador + 1;
                    contador +=1;
                });

                $scope.settings.selectedDevices = $scope.devices;
            } else {
                $scope.devices.map(function(i){
                    i.status = false;
                    i.direccion = null;
                })
                $scope.settings.selectedDevices = [];
            }
            $scope.validateList();
        }

        $scope.addToList = function(itm, status){
            if(status){
                $scope.settings.selectedDevices = []
                var itemsSelected = $scope.devices.filter(function(i){return i.status === true});
                var maximo = asignarMaximo(itemsSelected);
                itemsSelected.map(function(item){
                    if(!item.direccion){
                        item.direccion = maximo + 1;
                    }
                })
                $scope.settings.selectedDevices = itemsSelected; 
                $scope.validateList(); 
            } else {
                
                
                var index = $scope.devices.findIndex(function(i){return itm.id === i.id});
                $scope.devices[index].direccion = null;
                var indexs = [];
                var contador = 0;
                $scope.devices.forEach(function(device, i){
                    if(device.direccion){
                        indexs.push(i);
                    }
                })
                indexs.sort(function(a, b) {
                    return a - b;
                });
                
                indexs.forEach(function(i){
                    $scope.devices[i].direccion = contador + 1;
                    contador += 1;
                })
                $scope.settings.selectedDevices = []
                var itemsSelected = $scope.devices.filter(function(i){return i.status === true});
                $scope.settings.selectedDevices = itemsSelected; 
                $scope.validateList(); 
            }
             
        }

        $scope.validateList = function() {
            if($scope.settings.selectedDevices.length > 0) {
                $scope.validation = true;
            } else {
                $scope.validation = false;
            }
        }

        $scope.search = function(buscar) {
            if (indFilter){
                allItems = Array.from($scope.devices)
            }
            if(buscar === '') {
                $scope.devices = Array.from(allItems);
            } else {
                $scope.devices = $filter('filter')(allItems, buscar);
                $scope.devices = $filter('orderBy')($scope.devices, 'nombre');
            }
            indFilter = false;
        }


    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('settings_tipo_dispositivo_Ctrl', settings_tipo_dispositivo_Ctrl);

    /** @ngInject */
    function settings_tipo_dispositivo_Ctrl($scope, RESTServices, $timeout, $filter, $localStorage, $state, toastr, maintenanceServices, SHAREServices, $stateParams, ngDialog, $rootScope) {
        $rootScope.flag_loading = true;
        var caracteristicas = [];
        $scope.disabled = false;
        $scope.settings = {
            umbral_t_min: undefined,
            umbral_t_max: undefined,
            modo_operacion: undefined,
            velocidad_fan: undefined,
            swing: undefined,
        };
        $scope.modos_operacion = [
            { value: '0', text: 'Calefacción' },
            { value: '1', text: 'Enfriar' },
            { value: '2', text: 'Ventilación' },
            { value: '4', text: 'Sin configurar' },
        ];
        $scope.velocidades_fan = [
            { value: '0', text: 'Auto' },
            { value: '1', text: 'Bajo' },
            { value: '2', text: 'Medio' },
            { value: '3', text: 'Alto' },
            { value: '4', text: 'Sin configurar' },
        ];
        $scope.swing_options = [
            { value: '0', text: 'Desactivado' },
            { value: '1', text: 'Activado' },
            { value: '2', text: 'Sin configurar' },
        ];
        if($stateParams.device){
            $scope.device = $stateParams.device;
            $scope.device.id_device = parseFloat($scope.device.id_device)
        } else {
            $state.go('dashboard_cliente')
        }

        $timeout(function(){

            if($stateParams.device) {

                // v2: migrated from consulta_configuracion.php
                RESTServices.fetchDeviceConfigV2($stateParams.device.id_device).then(function(res) {
                    if(res.code === '200') {

                        res.caracteristicas.forEach(function(c){
                            var property = maintenanceServices.settings_properties.find(function(s){return s.id === c.id})
                            if (property) {
                                var esNumerico = property.name === 'umbral_t_min' || property.name === 'umbral_t_max';
                                $scope.settings[property.name] = esNumerico ? parseFloat(c.valor) : c.valor;
                            }
                        })

                        res.caracteristicas.forEach(function(s){
                            $scope.setcharacteristics(s.valor, s.id)
                        })
                        $rootScope.flag_loading = false;
                    } else {
                        toastr.error('Esta opción no está disponible para este dispositivo', 'Algo ha fallado');
                        $state.go('dashboard_cliente');
                    }

                })
            } else {
                $state.go('dashboard_cliente');
            }


        })

        $scope.editarConfiguracion = function() {
            $scope.disabled = true;
            var payload = {
                caracteristicas: caracteristicas,
            };

            // v2: migrated from cliente/edita_configuracion.php
            RESTServices.updateDeviceConfigV2($stateParams.device.id_device, payload).then(function(res) {
                toastr.success('Se ha cambiado la configuración', 'Éxito');
                $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
            }).catch(function() {
                toastr.error('Intenta de nuevo más tarde', 'Algo ha fallado');
                $scope.disabled = false;
            })
        }

        $scope.invalidTempRange = function() {
            if ($scope.settings.umbral_t_min === undefined || $scope.settings.umbral_t_min === null || $scope.settings.umbral_t_max === undefined || $scope.settings.umbral_t_max === null) {
                return false;
            }
            return Number($scope.settings.umbral_t_max) < Number($scope.settings.umbral_t_min);
        }

        $scope.setcharacteristics = function(valor, id) {
            var index = caracteristicas.findIndex(function(c){ return c.id == id });
            if (index !== -1) {
                caracteristicas[index].valor = valor === true ? '1' : valor === false ? '0' : valor;
            } else {
                var caracteristica = {
                    valor: valor === true ? '1' : valor === false ? '0' : valor,
                    id: id
                }
                caracteristicas.push(caracteristica);
            };
        }

        $scope.cancelar = function() {
            $state.go('mantenimiento_apparatusProfile', {device:$stateParams.device, control: $stateParams.control})
        }

    }
})();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('airInfo', airInfo);
  
    /** @ngInject */
    function airInfo() {
        return {
            restrict: 'E',
            //controller: 'airInfoCtrl',
            templateUrl: 'app/cliente/mantenimiento/maintenance_log/components/airInfo/airInfo.html',
            scope: {
                dispositivo: '=dispositivo',
                control: '=control'
            }
        }
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('indMaintenance', indMaintenance);
  
    /** @ngInject */
    function indMaintenance() {
        return {
            restrict: 'E',
            //controller: 'indMaintenanceCtrl',
            templateUrl: 'app/cliente/mantenimiento/maintenance_log/components/indMaintenance/indMaintenance.html',
            scope: {
                dispositivo: '=dispositivo'
            }
        }
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('indicadorUsoPieChartCtrl', indicadorUsoPieChartCtrl);

    /** @ngInject */

    function indicadorUsoPieChartCtrl($scope, $localStorage, RESTServices, SHAREServices, ngDialog, toastr) {
        
        $scope.loading_ = true;
        $scope.noInfo_ = false;
        var chart;
        var timeInd = [];

        if($scope.dispositivo) {
            timeInd = [
                {
                    "value": $scope.dispositivo.horas_uso,
                    "category": "Horas de uso",
                    "full": $scope.dispositivo.limite_horas_uso
                },
            ];
            createGraphic();
            chart.data = timeInd;
            $scope.loading_ = false;
            $scope.noInfo_ = false;
        }


        $scope.$on('setDevice', function(event, result){
            timeInd = [
                {
                    "value": result.device.horas_uso,
                    "category": "Horas de uso",
                    "full": result.device.limite_horas_uso
                },
            ];
            createGraphic();
            chart.data = timeInd;
            $scope.loading_ = false;
            $scope.noInfo_ = false;
        });

        function createGraphic() {
            // Themes begin
            am4core.useTheme(am4themes_animated);
            am4core.options.minPolylineStep = 5;
            am4core.options.onlyShowOnViewport = true;
            am4core.options.queue = true;
            am4core.options.autoDispose = true;
            // Themes end

            // Create chart instance
            chart = am4core.create("chartdiv", am4charts.RadarChart);

            // Make chart not full circle
            chart.startAngle = -90;
            chart.endAngle = 270;
            chart.innerRadius = am4core.percent(20);

            // Set number format
            chart.numberFormatter.numberFormat = "#.#";

            // Create axes
            var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "category";
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.grid.template.strokeOpacity = 0;
            categoryAxis.renderer.labels.template.horizontalCenter = "right";
            categoryAxis.renderer.labels.template.fontWeight = 500;
            categoryAxis.renderer.labels.template.adapter.add("fill", function(fill, target) {
                return (target.dataItem.index >= 0) ? chart.colors.getIndex(target.dataItem.index) : fill;
            });
            categoryAxis.renderer.minGridDistance = 0;

            var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
            valueAxis.renderer.grid.template.strokeOpacity = 0;
            valueAxis.min = 0;
            valueAxis.max = "full";
            valueAxis.strictMinMax = true;

            // Create series
            var series1 = chart.series.push(new am4charts.RadarColumnSeries());
            series1.dataFields.valueX = "full";
            series1.dataFields.categoryY = "category";
            series1.clustered = false;
            series1.columns.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
            series1.columns.template.fillOpacity = 0.08;
            series1.columns.template.cornerRadiusTopLeft = 10;
            series1.columns.template.strokeWidth = 0;
            series1.columns.template.radarColumn.cornerRadius = 10;

            var series2 = chart.series.push(new am4charts.RadarColumnSeries());
            series2.dataFields.valueX = "value";
            series2.dataFields.categoryY = "category";
            series2.clustered = false;
            series2.columns.template.strokeWidth = 0;
            series2.columns.template.tooltipText = "{category}: [bold]{value}[/]";
            series2.columns.template.radarColumn.cornerRadius = 10;

            series2.columns.template.adapter.add("fill", function(fill, target) {
                return chart.colors.getIndex(target.dataItem.index);
            });

            // Add cursor
            chart.cursor = new am4charts.RadarCursor();

        }
        
        $scope.$on("$destroy", function () {
            chart.dispose();
        });

        $scope.editarLimite = function(limite) {
            ngDialog.open({
                template: 'app/cliente/dashboard-cliente/templates/limite_mantenimiento.html',
                className: 'ngdialog-theme-plain',
                scope: $scope,
                controller: ['$scope', function($scope) {
                    $scope.limite = parseInt(limite);
                    
                    $scope.cancelar = function() {
                        ngDialog.close();
                    };

                    $scope.setLimit = function() {
                        var deviceId = $scope.dispositivo.id_device ? $scope.dispositivo.id_device : $scope.dispositivo.device.id;
                        var nuevoLimite = parseInt($scope.limite, 10) || 0;

                        RESTServices.setDeviceLimitV2(deviceId, nuevoLimite).then(function() {
                            toastr.success('Límite cambiado con éxito', 'Límite mantenimiento');
                            $scope.dispositivo.limite_horas_uso = nuevoLimite;
                            var data = [
                                {
                                    "value": $scope.dispositivo.horas_uso,
                                    "category": "Horas de uso",
                                    "full": $scope.dispositivo.limite_horas_uso
                                },
                            ];
                            chart.data = data;
                            chart.validateData();
                            ngDialog.close();
                        }).catch(function(err) {
                            if (err && (err.status === 404 || err.status === 403)) {
                                toastr.error('No tienes permiso para editar el límite', 'Límite mantenimiento');
                            } else {
                                toastr.error('Error de conexión al cambiar el límite', 'Límite mantenimiento');
                            }
                            ngDialog.close();
                        });
                        
                    }

                }]
            });            
        }
        
    }


})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('indicadorUsoPieChart', indicadorUsoPieChart);
  
    /** @ngInject */
    function indicadorUsoPieChart() {
        return {
            restrict: 'E',
            controller: 'indicadorUsoPieChartCtrl',
            templateUrl: 'app/cliente/mantenimiento/maintenance_log/components/indicador-uso-pie-chart/indicador-uso-pie-chart.html',
            scope: {
                dispositivo: '=dispositivo'
            }
        }
    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .directive('settingScfmKw', settingScfmKw);
  
    /** @ngInject */
    function settingScfmKw() {
      return {
        restrict: 'E',
        controller: 'settingScfmKwCtrl',
        templateUrl: 'app/cliente/dashboard-cliente/estadisticas_zona/grafica_scfm_kw/components/settingScfmKw/settingScfmKw.html',
      };
    }
})();
(function() {
    'use strict';

    angular.module('BlurAdmin.cliente.dashboard_cliente.estadisticas_zona')
        .controller('settingScfmKwCtrl', settingScfmKwCtrl)

    /** @ngInject */
    function settingScfmKwCtrl($scope, $localStorage, RESTServices, toastr, $rootScope, SHAREServices) {

        $scope.medidores = [];

        var field = {
            "id_agrupador": SHAREServices.dispositivo_selected.id,
            "id_usuario": $localStorage.id_usuario,
           //token: SHAREServices.hash_decode_token($localStorage.token),
        };

        RESTServices.post_header('cliente/consulta_medidores_energia_flujo.php', field, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
            if (response.code == '200') {
               $scope.lista = response.dispositivos;
            }    
        })

        $scope.addMeasurer = function(measurers){

            measurers.forEach(function(measurer){
                var parms = {
                    "id_agrupador": SHAREServices.dispositivo_selected.id,
                    "id_medidor": measurer.id,
                    "id_usuario": $localStorage.id_usuario,
                   //token: SHAREServices.hash_decode_token($localStorage.token),
                    "asociar": 1,
                };
                RESTServices.post_header('cliente/asociar_dispositivos_agrupador.php', parms, SHAREServices.hash_decode_token($localStorage.token),true).then(function(response) {
                    if (response.code == '200') {
                        // $scope.medidores.push(measurer);
                    }    
                })
            })

            if ($scope.medidores.length > 0) {
                $rootScope.$broadcast('addMeasurers', {data: $scope.medidores});
                toastr.success('El medidor ha sido asociado', 'Gestión de Medidores');
            }

            
        }


    };

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.cliente.mantenimiento')
      .controller('editableFieldCtrl', editableFieldCtrl);

  /** @ngInject */
  function editableFieldCtrl($scope, RESTServices, $localStorage, $rootScope, SHAREServices) {
  
    $scope.editMode = false;
    $scope.edit = {};
    $scope.edit.value = $scope.fieldValue;

    $scope.handleModeChange = function() {
      $scope.editMode = !$scope.editMode;
    };

    $scope.update = function(){
      //$scope.onUpdate({value: $scope.fieldValue});
      $rootScope.$broadcast('updatevalue', { data: $scope.edit.value, prop: $scope.prop});
      $scope.editMode = !$scope.editMode;
    }
  }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('editableField', editableField);
  
    /** @ngInject */
    function editableField() {
      return {
        restrict: 'E',
        controller: 'editableFieldCtrl',
        templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/components/editableField/editableField.html',
        scope: {
            fieldValue: '=fieldValue',
            fieldType: '=fieldType',
            prop: '=prop',
            edited: '='
        }
    };
    }
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.cliente.mantenimiento')
        .controller('defaultFormCtrl', defaultFormCtrl);

    /** @ngInject */
    function defaultFormCtrl($scope, RESTServices, $localStorage,  $stateParams) {
        



    }
})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.cliente.mantenimiento')
        .directive('defaultForm', defaultForm);
  
    /** @ngInject */
    function defaultForm() {
      return {
        restrict: 'E',
        controller: 'defaultFormCtrl',
        templateUrl: 'app/cliente/mantenimiento/maintenance_log/apparatus_profile/components/defaultForm/defaultForm.html'
      };
    }
})();
angular.module("BlurAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/notifications/notifications.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row notifications\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Historial de Notificaciones\" ba-panel-class=\"\"><div class=\"grid-container grid-container-header\"><p class=\"grid-item\">Fecha</p><p class=\"grid-item\">Hora</p><p class=\"grid-item\">Descripción</p></div><div class=\"grid-container grid-container-body\" ng-repeat=\"notification in notificaciones | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><p data-label=\"Fecha:\" class=\"grid-item\">{{notification.dia }}</p><p data-label=\"Hora:\" class=\"grid-item\">{{notification.hora}}</p><p data-label=\"Descripción:\" class=\"grid-item\">{{notification.descripcion}}</p></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content><div class=\"centrar centrar-c\"><uib-pagination total-items=\"totalItems\" direction-links=\"false\" ng-model=\"currentPage\" boundary-link-numbers=\"true\" rotate=\"false\" class=\"pagination-sm\" items-per-page=\"itemsPerPage\" max-size=\"noOfPages\"></uib-pagination></div><div ng-if=\"notificaciones.length == 0\" class=\"info-no-schedule centrar centrar-c\"><p>No tienes notificaciones</p></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/profile/profile.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><ui-view><div class=\"row\"><user-info user=\"user\"></user-info><business-card business=\"user\"></business-card></div></ui-view></div></div></div><page-footer></page-footer>");
$templateCache.put("app/settings/settings.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\"><div class=\"panel cont-settings-menu\"><h3>Configuraciones</h3><div class=\"cont-option centrar centrar-justificar-inicio cursor\" ng-class=\"{\'option-selected\' : option.status}\" ng-repeat=\"option in options\" ng-click=\"gotoOption(option.link, $index)\"><span class=\"{{option.icon}}\"></span><p>{{option.title}}</p></div></div></div><div class=\"col-lg-8 col-md-8 col-sm-6 col-xs-12\"><div class=\"panel cont-setting\"><ui-view></ui-view></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/help/help.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"panel panel-primary bootstrap-panel animated zoomIn panel-help\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Preguntas sobre el uso de la plataforma</p></div></div><div class=\"\"><question ng-repeat=\"question in questions track by $index\" question=\"question\"></question></div></div><div class=\"panel panel-primary bootstrap-panel animated zoomIn panel-help\" zoom-in=\"\" ng-if=\"installer\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Preguntas sobre el funcionamiento de los dispositivos</p></div></div><div class=\"\"><question ng-repeat=\"question in questions_installer track by $index\" question=\"question\"></question></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/admin/clientes/clientes.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><p>Fecha: {{fecha_s}}</p><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel panel-primary bootstrap-panel h_ind_ahorro animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><div class=\"h_icon\"><span class=\"ion-location\"></span></div><p>Panel de clientes</p></div></div><div class=\"panel-body\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default collapse-acordion\" ng-repeat=\"cliente in clientes\"><uib-accordion-heading><p>{{cliente.nombre}}</p><span class=\"ion-chevron-right\" aria-hidden=\"true\" ng-click=\"mostrar_zonas($index)\"></span></uib-accordion-heading><table class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 tabla-disp\"><thead><tr><th>Usuario</th><th>Email</th></tr></thead><tbody><tr ng-repeat=\"usuario in cliente.usuarios | orderBy: \'usuario.nombre\'\"><td class=\"cursor\">{{usuario.nombre}}</td><td class=\"cursor\">{{usuario.email}}</td></tr></tbody></table><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_usuario(cliente.id, $index)\">Agregar nuevo usuario</button></div></uib-accordion><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_cliente()\">Agregar nuevo cliente</button></div></div></div></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2016.</div></footer>");
$templateCache.put("app/admin/dashboard-admin/dashboard_admin.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><h1>Helo Admin</h1></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2016.</div></footer>");
$templateCache.put("app/admin/facturacion/facturacion.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ui-view=\"\"></div></div></div>");
$templateCache.put("app/admin/instaladores/instaladores.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><p>Fecha: {{fecha_s}}</p><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel panel-primary bootstrap-panel h_ind_ahorro animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><div class=\"h_icon\"><span class=\"ion-location\"></span></div><p>Panel de Instaladores</p></div></div><div class=\"panel-body\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default collapse-acordion\" ng-repeat=\"instalador in instaladores\" ng-init=\"outerIndex=$index\"><uib-accordion-heading><p>{{instalador.nombre}}</p><span class=\"ion-chevron-right\" aria-hidden=\"true\" ng-click=\"mostrar_zonas($index)\"></span></uib-accordion-heading><div uib-accordion-group=\"\" class=\"panel-default collapse-acordion\" ng-repeat=\"usuario in instalador.usuarios\" ng-init=\"innerIndex=$index\"><uib-accordion-heading><p><b>Nombre:</b> {{usuario.nombre}} <b>Email:</b> {{usuario.email}}</p><span class=\"ion-chevron-right\" aria-hidden=\"true\" ng-click=\"mostrar_zonas($index)\"></span></uib-accordion-heading><table class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 tabla-disp\"><thead><tr><th>Clientes</th></tr></thead><tbody><tr ng-repeat=\"cliente in usuario.clientes | orderBy: \'cliente.nombre\'\"><td class=\"cursor\">{{cliente.nombre}}</td></tr></tbody></table><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_clienteainstalador(usuario.id,innerIndex,outerIndex)\">Asociar nuevo cliente</button></div><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_usuario(instalador.id, $index)\">Agregar nuevo usuario instalador</button></div></uib-accordion><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_instalador()\">Agregar nuevo instalador</button></div></div></div></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2016.</div></footer>");
$templateCache.put("app/admin/maps/maps.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ui-view=\"\"></div></div></div>");
$templateCache.put("app/admin/templates/modal_asociar_cliente.html","<h3 class=\"centrar-texto\">Asociar cliente</h3><div class=\"modal_id centrar centrar-columna\"><p ng-hide=\"flag_as_cliente\">Cliente</p><select class=\"select-places\" ng-hide=\"flag_as_cliente\" ng-init=\"cliente = clientes_disponibles[0]\" ng-options=\"value as value.nombre for (key,value) in clientes_disponibles\" ng-model=\"cliente\"></select><button ng-hide=\"flag_as_cliente\" class=\"btn btn-default boton_agregar\" ng-click=\"asociar_cliente(cliente)\" ng-if=\"flag_asociar_cliente\" style=\"margin-top:10px;\">Asociar cliente</button><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-show=\"flag_as_cliente\">Se ha asociado el cliente exitosamente</p><p style=\"color:rgb(232, 45, 12); text-align:center; margin-top:10px;\" ng-show=\"flag_error\">Debes diligenciar la totalidad de los campos correctamente</p><div><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\" ng-hide=\"flag_asociar_cliente\">Cerrar</button></div></div>");
$templateCache.put("app/admin/templates/modal_cliente.html","<h3 class=\"centrar-texto\">Agregar nuevo cliente</h3><div class=\"modal_id centrar centrar-columna form-mantenimiento\"><p ng-hide=\"flag_cliente\">Nombre</p><input ng-hide=\"flag_cliente\" type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"cliente.nombre\"><p ng-if=\"!flag_cliente\">País</p><select class=\"select-places\" ng-if=\"!flag_cliente\" ng-init=\"result1 = paises[46].nombre\" ng-change=\"listar_estados(result1)\" ng-options=\"value as value.nombre for (key,value) in paises\" ng-model=\"result1\"><p ng-if=\"!flag_cliente\">Estado / Departamento</p></select><select class=\"select-places\" ng-if=\"!flag_cliente\" ng-change=\"listar_ciudades(result2)\" ng-options=\"value as value.nombre for (key,value) in estados\" ng-model=\"result2\"><p ng-hide=\"flag_cliente\">Ciudad</p></select><select class=\"select-places\" ng-if=\"!flag_cliente\" ng-options=\"value.id as value.nombre for (key,value) in ciudades\" ng-model=\"cliente.ciudad\"></select><select class=\"select-places\" ng-hide=\"flag_cliente\" ng-options=\"value.id as value.nombre for (key,value) in ciudades\" ng-model=\"cliente.ciudad\"><p ng-hide=\"flag_cliente\">Dirección</p></select><input ng-hide=\"flag_cliente\" type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"cliente.direccion\"><p ng-hide=\"flag_cliente\">Teléfono</p><input ng-hide=\"flag_cliente\" type=\"number\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"cliente.tel\"> <button ng-hide=\"flag_cliente\" class=\"btn btn-default boton_agregar\" ng-click=\"crear_cliente(cliente)\" ng-if=\"flag_crear_cliente\" style=\"margin-top:10px;\">Crear cliente</button><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-show=\"flag_cliente\">Se ha creado el cliente exitosamente</p><p style=\"color:rgb(232, 45, 12); text-align:center; margin-top:10px;\" ng-show=\"flag_error\">Debes diligenciar la totalidad de los campos correctamente</p><div><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\" ng-hide=\"flag_crear_cliente\">Cerrar</button></div></div>");
$templateCache.put("app/admin/templates/modal_instalador.html","<h3 class=\"centrar-texto\">Agregar nuevo instalador</h3><div class=\"modal_id centrar centrar-columna\"><p ng-hide=\"flag_instalador\">Nombre</p><input ng-hide=\"flag_instalador\" type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"instalador.nombre\"><p ng-hide=\"flag_instalador\">País</p><select class=\"select-places\" ng-hide=\"flag_instalador\" ng-init=\"result1 = paises[46].nombre\" ng-change=\"listar_estados(result1)\" ng-options=\"value as value.nombre for (key,value) in paises\" ng-model=\"result1\"><p ng-hide=\"flag_instalador\">Estado</p></select><select class=\"select-places\" ng-hide=\"flag_instalador\" ng-change=\"listar_ciudades(result2)\" ng-options=\"value as value.nombre for (key,value) in estados\" ng-model=\"result2\"><p ng-hide=\"flag_instalador\">Ciudad</p></select><select class=\"select-places\" ng-hide=\"flag_instalador\" ng-options=\"value.id as value.nombre for (key,value) in ciudades\" ng-model=\"instalador.ciudad\"><p ng-hide=\"flag_instalador\">Dirección</p></select><input ng-hide=\"flag_instalador\" type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"instalador.direccion\"><p ng-hide=\"flag_instalador\">Teléfono</p><input ng-hide=\"flag_instalador\" type=\"number\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"instalador.tel\"> <button ng-hide=\"flag_instalador\" class=\"btn btn-default boton_agregar\" ng-click=\"crear_instalador(instalador)\" ng-if=\"flag_crear_instalador\" style=\"margin-top:10px;\">Crear instalador</button><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-show=\"flag_instalador\">Se ha creado el instalador exitosamente</p><p style=\"color:rgb(232, 45, 12); text-align:center; margin-top:10px;\" ng-show=\"flag_error\">Debes diligenciar la totalidad de los campos correctamente</p><div><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\" ng-hide=\"flag_crear_instalador\">Cerrar</button></div></div>");
$templateCache.put("app/admin/templates/modal_usuario.html","<h3 class=\"centrar-texto\">Agregar nuevo usuario de {{rol_}}</h3><div class=\"modal_id centrar centrar-columna\"><p ng-hide=\"flag_usuario\">Nombre</p><input ng-hide=\"flag_usuario\" type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"usuario.nombre\"><p ng-hide=\"flag_usuario\">Apellido</p><input ng-hide=\"flag_usuario\" type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"usuario.apellido\"><p ng-hide=\"flag_usuario\">email</p><input ng-hide=\"flag_usuario\" type=\"email\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"usuario.email\"><p ng-hide=\"flag_usuario\">contraseña</p><input ng-hide=\"flag_usuario\" type=\"password\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"usuario.contrasena\"> <button ng-hide=\"flag_usuario\" class=\"btn btn-default boton_agregar\" ng-click=\"crear_usuario(usuario)\" ng-if=\"flag_crear_usuario\" style=\"margin-top:10px;\">Crear usuario</button><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-show=\"flag_usuario\">Se ha creado el usuario exitosamente</p><p style=\"color:rgb(232, 45, 12); text-align:center; margin-top:10px;\" ng-show=\"flag_error\">Debes diligenciar la totalidad de los campos correctamente</p><div><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\" ng-hide=\"flag_crear_usuario\">Cerrar</button></div></div>");
$templateCache.put("app/auth/nueva_contrasena/nueva_contrasena.html","<ba-sidebar></ba-sidebar><page-top></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"col-lg-6 col-md-8 col-sm-10 col-xs-12 z4 centrar centrar-c\" ng-hide=\"confirmar\"><div class=\"panel panel-primary bootstrap-panel animated zoomIn width-100\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Cambiar contraseña</p></div></div><div class=\"panel-body row padding-3\"><label class=\"margin-top\">Contraseña actual</label> <input type=\"password\" ng-model=\"contrasena\" class=\"form-control\" required=\"\"> <label class=\"margin-top\">Nueva contraseña</label><div class=\"centrar centrar-align-start\"><input type=\"password\" ng-model=\"n_contrasena\" class=\"form-control\" ng-change=\"verificarNueva(n_contrasena, c_contrasena)\" required=\"\"> <span class=\"ind-password\"></span></div><label class=\"margin-top\">Confirmar contraseña</label><div class=\"centrar centrar-align-start\"><input type=\"password\" ng-model=\"c_contrasena\" class=\"form-control\" ng-change=\"verificarNueva(n_contrasena, c_contrasena)\" required=\"\"> <span class=\"ind-password\" ng-class=\"{\'ion-happy-outline verde\': n_contrasena == c_contrasena && n_contrasena != undefined && c_contrasena != undefined , \'ion-sad-outline rojo\': n_contrasena != c_contrasena }\"></span></div><button class=\"btn margin-top btn-enviar\" id=\"enviar_nueva\" disabled=\"\" ng-click=\"cambiarContrasena(n_contrasena, contrasena )\">Enviar</button><p ng-show=\"no_valida\" class=\"margin-top\">La contraseña no es válida</p></div></div></div><div class=\"col-lg-6 col-md-8 col-sm-10 col-xs-12 z4 centrar centrar-c\" ng-show=\"confirmar\"><div class=\"panel panel-primary bootstrap-panel animated zoomIn width-100\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Cambiar contraseña</p></div></div><div class=\"panel-body row padding-3\"><div class=\"centrar centrar-c centrar-columna\" ng-if=\"proceso_exitoso\"><span class=\"ion-happy-outline verde ind-icon\"></span><p class=\"margin-top\">la contraseña ha sido cambiada con éxito</p></div><div class=\"centrar centrar-c centrar-columna\" ng-if=\"error\"><span class=\"ion-sad-outline rojo ind-icon\"></span><p class=\"margin-top\">Lo sentimos, ha habido un conexión con el servidor, intenta de nuevo más tarder</p></div></div></div></div></div></div><page-footer></page-footer></div>");
$templateCache.put("app/auth/recuperar_contrasena/recuperar_contrasena.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><div class=\"signIn centrar centrar-c\"><section class=\"form\"><div class=\"cont-logo centrar centrar-c\"><div class=\"logo\"><img src=\"../../../assets/img/logo_helo.svg\" alt=\"\"></div></div><ui-view><send-email></send-email></ui-view><h3>volver a <strong class=\"cursor\" ng-click=\"goSignIn()\">Iniciar sesión</strong></h3></section></div>");
$templateCache.put("app/auth/sign_in/signIn.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><div class=\"signIn centrar centrar-c\"><section class=\"form\"><div class=\"cont-logo centrar centrar-c\"><div class=\"logo\"><img src=\"../../../assets/img/logo_helo.svg\" alt=\"\"></div></div><div class=\"centrar centrar-c centrar-columna cont-login\"><h2>Iniciar sesión</h2><form name=\"LoginForm\" class=\"centrar centrar-columna centrar-align-start\"><label for=\"correo\">correo</label> <input type=\"email\" name=\"correo\" ng-model=\"user.mail\" required=\"\"><div class=\"centrar width-100p\"><label for=\"contraseña\">contraseña</label><p ng-init=\"show = false\" ng-click=\"show = !show\" class=\"cursor\"><span ng-class=\"{\'ion-eye\' : !show, \'ion-eye-disabled\' : show }\"></span>{{!show ? \'Mostrar\': \'Ocultar\'}}</p></div><input type=\"{{show ? \'text\' : \'password\'}}\" name=\"contraseña\" ng-model=\"user.password\" required=\"\"><p ng-click=\"goRecuperar()\" class=\"cursor\">¿Olvidó la contraseña?</p><button ng-click=\"login(user)\" ng-disabled=\"!LoginForm.$valid\" ng-class=\"{\'disabled\': !LoginForm.$valid}\">Entrar</button></form><p>© {{today | date : \'yyyy\'}} Intelmotics, el diseño de marca son propiedad de Intelmotics. Todos los derechos reservados.</p></div></section><section class=\"insight\"><div class=\"bg\"><img src=\"../../../assets/img/bg_login.jpg\" alt=\"\"></div><a href=\"https://helo.com.co/\" target=\"_blank\" title=\"Visítanos en Helo.com.co\"><div class=\"logo-intel\"><p>helo.com.co</p></div></a></section></div>");
$templateCache.put("app/cliente/alerts/alerts.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"transform\" id=\"locationTop\"><h1>{{zona.nombre}}</h1></div><div class=\"dinamic_content centrar centrar-columna centrar-align-start\"><div class=\"width-100p\"><div class=\"row centrar centrar-flex-flow centrar-justificar-inicio\"><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-12 margin-top-10\" ng-if=\"rol_id === \'6\' || rol_id === \'7\' || rol_id === \'8\'\"><div style=\"margin: 0;\" class=\"margin-left btn-upload\"><label class=\"cursor centrar centrar-c\" for=\"file\"><span class=\"ion-upload\"></span><p>Cargar Alertas</p></label> <input type=\"file\" id=\"file\" name=\"file\" ng-model=\"data\" onchange=\"angular.element(this).scope().getFile(this)\" accept=\".xls, .xlsx, .xlsm\"></div></div><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-12 margin-top-10\"><div class=\"dropdown filter-menu\"><div class=\"btn-add-alert centrar centrar-c cursor dropdown-toggle\" data-toggle=\"dropdown\"><p><span class=\"ion-plus-round\"></span></p></div><ul class=\"dropdown-menu\"><li ng-repeat=\"item in listaAlertas\" ng-if=\"item.show\" class=\"cursor\" ng-click=\"newAlert(item)\">{{item.name | limitTo: 20}}{{item.name.length > 20 ? \'...\': \' \'}}</li></ul></div></div><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-12 margin-top-10\"><div class=\"centrar btn-novelty centrar-c cursor\" ng-class=\"{\'btn-novelty-active\': novelties}\" ng-click=\"showNovelty(novelties)\"><p><span class=\"ion-android-notifications\"></span></p></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12 margin-top-10\"><selector-filter selected=\"showAlerts(ind)\" items=\"zonas\" selected-item=\"zona\"></selector-filter></div><div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-12 margin-top-10\"><div class=\"dropdown filter-menu\"><div class=\"btn-add-alert centrar centrar-c cursor dropdown-toggle\" data-toggle=\"dropdown\"><p style=\"text-align: center;\">{{filterInd | limitTo: 15}}{{item.length > 15 ? \'...\': \'\'}}</p></div><ul class=\"dropdown-menu\"><li ng-repeat=\"item in listaFiltros\" class=\"cursor\" ng-click=\"filtrarAlertas(item)\">{{item | limitTo: 20}}{{item.length > 20 ? \'...\': \'\'}}</li></ul></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12 margin-top-10\"><div class=\"search-box centrar\"><input ng-model=\"buscar\" placeholder=\"Buscar alerta por nombre\" class=\"input-sm form-control search-input\" ng-keyup=\"filtrar(buscar)\" type=\"search\"> <button type=\"submit\"><i class=\"ion-search\"></i></button></div></div><div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-12 margin-top-10\"><button style=\"width: 100%; margin-bottom: 0;\" class=\"btn-add-activo centrar centrar-c\" ng-click=\"goToQuickEdit()\">Edición Conjunta</button></div><div class=\"col-lg-1 col-md-1 col-sm-2 col-xs-6 margin-top-10\"><div class=\"centrar btn-novelty centrar-c cursor\" ng-click=\"exportAlerts()\" title=\"Exportar alertas a Excel\"><p><span class=\"ion-android-download\"></span></p></div></div><div class=\"col-lg-1 col-md-1 col-sm-2 col-xs-6 margin-top-10\"><div style=\"margin: 0;\" class=\"margin-left btn-upload\"><label class=\"cursor centrar centrar-c\" for=\"importAlertsFile\" title=\"Importar alertas editadas desde Excel\"><span class=\"ion-android-upload\"></span></label> <input type=\"file\" id=\"importAlertsFile\" name=\"importAlertsFile\" ng-model=\"importData\" onchange=\"angular.element(this).scope().importAlertsFile(this)\" accept=\".xlsx\"></div></div></div><div class=\"row centrar centrar-align-end centrar-flex-flow-reverse\"><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12 centrar centrar-columna\"><table-alerts class=\"width-100p\" alerts=\"filtered\" zone=\"zona\"></table-alerts><loading-content loading=\"loading\"></loading-content><p class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top\" ng-if=\"loading === false && filtered.length === 0\">No se encontraron Alertas</p></div><offline-devices class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"></offline-devices></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/consumo_v2/consumoV2.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><ui-view></ui-view></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/dashboard-cliente/dashboard_cliente.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\" ng-class=\"{\'margin-right-30\': (rol === \'6\' || rol === \'8\')}\"><content-top></content-top><div class=\"dinamic_content\"><control-buttons-top ng-if=\"showButtonsViews\"></control-buttons-top><ui-view></ui-view></div></div></div><sidebar-alerts ng-if=\"rol === \'6\' || rol === \'8\'\"></sidebar-alerts><page-footer></page-footer>");
$templateCache.put("app/cliente/historial/historial.html","<ba-sidebar></ba-sidebar><page-top></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"centrar centrar-justificar-inicio padding-2\"><div class=\"padding-2 d_program transform\"><h4>Zona</h4><select class=\"form-control\" ng-model=\"zona_id\" ng-change=\"getProgram(zona_id)\"><option ng-repeat=\"zona in tabla.zonas | orderBy:\'nombre\'\" ng-value=\"{{zona.id}}\">{{zona.nombre}}</option></select></div><div class=\"padding-2 transform z5\"><h4>Fecha</h4><p class=\"input-group d_program\"><input type=\"text\" class=\"form-control\" id=\"des_f_ini\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"des_f_ini\" is-open=\"popup.opened\" datepicker-options=\"options1\" ng-required=\"true\" close-text=\"Cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"fecha()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div><span class=\"btn btn-default ion-refresh\" ng-click=\"refresh()\" style=\"margin-top: 30px;\"></span></div></div><div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 z4\"><div class=\"panel panel-primary bootstrap-panel animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Lista de programaciones</p></div></div><div class=\"panel-body row\"><div ng-hide=\"v_program\" class=\"centrar centrar-c centrar-columna\"><span class=\"ion-flash ind-icon\"></span><p>Escoge una zona para iniciar la búsqueda</p></div><table class=\"tabla_programacion\" ng-show=\"v_program\"><thead><tr><th>Día</th><th>Hora inicio</th><th>Hora fin</th><th>Frecuencia</th><th>Acción</th><th></th></tr></thead><tbody><tr ng-repeat=\"programacion in programaciones | filter: (fecha_filtro == undefined ? \'\' : {dia: fecha_filtro} ) | orderBy:\'dia\'\" ng-if=\"$index < currentPage*itemsPerPage && $index >= (currentPage-1)*itemsPerPage\"><td>{{programacion.dia}}</td><td>{{programacion.hini}}</td><td>{{programacion.hfin}}</td><td ng-if=\"programacion.frec==1\">Única</td><td ng-if=\"programacion.frec==2\">Diaria</td><td ng-if=\"programacion.frec==3\">Semanal</td><td ng-if=\"programacion.frec==4\">Mensual</td><td ng-if=\"programacion.comando!=undefined && programacion.comando!=\'Apagar\'\">{{programacion.comando}}°</td><td ng-if=\"(programacion.comando==undefined )|| (programacion.comando!=undefined && programacion.comando==\'Apagar\')\">Apagar</td><td><div class=\"dropdown prog_opciones\"><span class=\"ion-more boton-opciones dropdown-toggle\" data-toggle=\"dropdown\"></span><ul class=\"dropdown-menu opcion\"><li ng-click=\"edit_programacion(programacion)\">Editar</li><li ng-click=\"delete_programacion(programacion)\">Borrar</li></ul></div></td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center ind_pag\" style=\"text-align: center !important;\"><ul uib-pagination=\"\" direction-links=\"false\" total-items=\"totalItems\" ng-model=\"currentPage\" max-size=\"4\" boundary-links=\"false\" force-ellipses=\"true\"></ul></td></tr></tfoot></table></div></div></div></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2016.</div></footer></div>");
$templateCache.put("app/cliente/mantenimiento/mantenimiento.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ui-view><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><bread-crumbs></bread-crumbs><div class=\"dinamic_content\"><div class=\"centrar centrar-justificar-inicio\"><div class=\"width-fit-content\"><a ui-sref=\"mantenimiento_newApparatus\"><button class=\"btn-add-activo centrar centrar-c\" title=\"Crear dispositivo\">Nuevo activo</button></a></div><div class=\"margin-left btn-upload\"><label class=\"cursor centrar centrar-c\" for=\"file\"><span class=\"ion-upload\"></span><p>Cargar Activos</p></label> <input type=\"file\" id=\"file\" name=\"file\" ng-model=\"data\" onchange=\"angular.element(this).scope().getFile(this)\" accept=\".xls, .xlsx, .xlsm\"></div><div class=\"margin-left btn-upload\" ng-if=\"rol === \'6\' || rol === \'7\' || rol === \'8\'\"><label class=\"cursor centrar centrar-c\" for=\"file2\"><span class=\"ion-upload\"></span><p>Cargar zonas</p></label> <input type=\"file\" id=\"file2\" name=\"file2\" ng-model=\"data2\" onchange=\"angular.element(this).scope().getZones(this)\" accept=\".xls, .xlsx, .xlsm\"></div><div title=\"Generar QRs\" class=\"cursor centrar centrar-c btn-icon\" ng-click=\"generateQRList()\"><span class=\"fa fa-qrcode\"></span></div></div><div class=\"row\"><maintenance-card loading=\"loading\" no-info=\"noInfo\" devices=\"devices\" zones=\"zonas\"></maintenance-card></div></div></div></div><page-footer></page-footer></ui-view>");
$templateCache.put("app/cliente/monitoreo/monitoreo.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><ui-view></ui-view></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/monitoreo-plano/monitoreo-plano.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><div class=\"dinamic_content\"><div class=\"centrar plano configuracion-plano\" style=\"margin: 20px 0;\"><div class=\"centrar\"><div ng-if=\"rol_id === \'6\' || rol_id === \'7\' || rol_id === \'8\'\" class=\"centrar form-mantenimiento\" style=\"width: auto; margin-right: 20px;\"><button class=\"centrar centrar-c\" title=\"Agregar\" ng-click=\"crearPlano(2)\"><span class=\"ion-plus-round\"></span></button></div><div class=\"centrar title\"><img class=\"icon-plano cursor\" ng-src=\"{{icon}}\" alt=\"\"><h3>{{zona.nombre | limitTo: 30}}{{zona.nombre.length > 30 ? \'...\' : \'\'}}</h3></div></div><selector-filter ng-if=\"zonas.length > 0\" style=\"width: 30%;\" selected=\"getPlanoZona(ind)\" items=\"zonas\" selected-item=\"zona\"></selector-filter></div><configuracion-plano ng-if=\"showConfiguracion\" zona=\"zona\" step=\"step\" current=\"setStep(event)\"></configuracion-plano><plano ng-if=\"!showConfiguracion\" planos=\"planos\" zona=\"zona\" rol=\"rol_id\"></plano><loading-content loading=\"loading\"></loading-content></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/ofertas/ofertas.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"panel panel-primary bootstrap-panel h_ind_oferta animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header_oferta\"><div class=\"h_titulo\"><div class=\"h_icon\"><span class=\"ion-pricetag\"></span></div><p class=\"color-blanco\">Ofertas</p></div></div><div class=\"panel-body\"><div class=\"width-150 margin-bottom-10\"><select class=\"form-control\"><option ng-repeat=\"mes in meses\" value=\"{{mes.nombre}}\">{{mes.nombre}}</option></select></div><table class=\"table-bordered table-condensed width-100 tabla_helo tabla_responsive\"><thead><th data-label=\"Oferta\">Ofertas</th><th data-label=\"Día\">Día</th><th data-label=\"Intervalo de tiempo\">Intervalo de tiempo</th><th data-label=\"valor kWh\">Valor KWh</th><th data-label=\"Zonas desconectadas\">Zonas desconectadas</th><th data-label=\"KWh desconectados\">KWh desconectados</th><th data-label=\"Pago\">Pago</th></thead><tbody><tr ng-repeat=\"desconexion in desconexiones\"><td data-label=\"Oferta\">{{desconexion.id}}</td><td data-label=\"Día\">{{desconexion.fecha_limite}}</td><td data-label=\"Intervalo de tiempo\">{{desconexion.hora_in}} - {{desconexion.hora_fin}}</td><td data-label=\"valor kWh\">${{desconexion.valor_oferta}}</td><td data-label=\"Zonas desconectadas\">{{desconexion.zonas_desconectadas}}</td><td data-label=\"KWh desconectados\">{{desconexion.carga_desconectada_total}}</td><td data-label=\"Pago\">${{desconexion.valor_desconexion | number}}</td></tr></tbody></table></div></div></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2017.</div></footer>");
$templateCache.put("app/cliente/smartbar/smartbar.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"centrar centrar-align-start centrar-flex-flow\"><div class=\"centrar centrar-columna col-lg-6 col-md-6 col-sm-12 col-xs-12\"><losses class=\"width-100p\"></losses><consumption class=\"width-100p\"></consumption></div><meters class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"></meters><temp-points class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"></temp-points><grafic-temp-vs-dist class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"></grafic-temp-vs-dist><rate-losses class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"></rate-losses></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/consumo/dashboard-consumo/dashboard_consumo.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><h2>Históricos de consumo de potencia</h2><p>Fecha: {{fecha_s}}</p><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel panel-primary bootstrap-panel h_ind_ahorro animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><div class=\"h_icon\"><span class=\"ion-location\"></span></div><p>Panel de lugares monitoreados</p></div></div><div class=\"panel-body\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default collapse-acordion\" ng-repeat=\"cliente in clientes\"><uib-accordion-heading><p>{{cliente.nombre}}</p><span class=\"ion-chevron-right\" aria-hidden=\"true\" ng-click=\"mostrar_zonas($index)\"></span></uib-accordion-heading><table class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 tabla-disp\"><thead><tr><th>Zona monitoreada</th><th></th></tr></thead><tbody><tr ng-repeat=\"zona in cliente.zonas | orderBy: \'zona.nombre\'\"><td ng-click=\"open_consumo(zona.id)\" class=\"cursor\">{{zona.nombre}}</td><td><button class=\"btn btn-default boton_agregar\" style=\"margin-bottom:1em;\" ng-click=\"agregar_disp(zona.id, cliente.nombre)\">Vincular sensor</button></td></tr></tbody></table><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_zona(zona.id)\">Agregar nueva zona</button></div></uib-accordion><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_lugar(cliente.id)\">Agregar nuevo lugar</button></div></div></div></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2016.</div></footer>");
$templateCache.put("app/consumo/energy-dashboard/confirm-delete.modal.html","<div class=\"ed-modal\"><h3>{{modal.kind === \'dashboard\' ? \'Eliminar dashboard\' : \'Eliminar período\'}}</h3><form name=\"confirmDeleteForm\" novalidate=\"\" ng-submit=\"modal.confirm()\"><div class=\"ed-modal-fixed\"><p ng-if=\"modal.kind === \'dashboard\'\">Vas a eliminar el dashboard <strong>{{modal.label}}</strong>. También se eliminarán sus períodos, los precios del kWh y los datos de cálculo (backfill) asociados.</p><p ng-if=\"modal.kind === \'period\'\">Vas a eliminar el período <strong>{{modal.label}}</strong>. También se eliminarán sus precios del kWh y los datos de cálculo (backfill) asociados.</p><p class=\"ed-muted\">Las lecturas de consumo de los dispositivos no se eliminan. Esta acción no se puede deshacer.</p></div><div class=\"ed-modal-scroll\"></div><div class=\"ed-modal-fixed\"><div class=\"alert alert-danger\" ng-if=\"modal.error\">{{modal.error}}</div><div class=\"ed-modal-actions\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"closeThisDialog()\" ng-disabled=\"modal.deleting\">Cancelar</button> <button type=\"submit\" class=\"btn btn-danger\" ng-disabled=\"modal.deleting\">{{modal.deleting ? \'Eliminando…\' : \'Eliminar\'}}</button></div></div></form></div>");
$templateCache.put("app/consumo/energy-dashboard/create-dashboard.modal.html","<div class=\"ed-modal\"><h3>Nuevo dashboard</h3><div ng-if=\"modal.loading\" class=\"ed-loading-inline\"><span class=\"ion-load-c load-rotate\"></span> Cargando zonas…</div><form ng-if=\"!modal.loading\" name=\"createDashboardForm\" novalidate=\"\" ng-submit=\"$event.preventDefault()\"><div class=\"ed-modal-step\" ng-show=\"modal.step === 1\"><div class=\"ed-modal-fixed\"><div class=\"form-group\"><label for=\"ed-dash-name\">Nombre</label> <input id=\"ed-dash-name\" type=\"text\" class=\"form-control\" maxlength=\"80\" ng-model=\"modal.nombre\" placeholder=\"Ej. Consumo sedes principales\"></div><div class=\"ed-zone-block-head\"><p class=\"ed-modal-label\">Zonas (sucursales) a incluir</p><button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"modal.toggleVisibleZones()\" ng-disabled=\"!modal.visibleOwnZones().length && !modal.visibleSharedZones().length\">{{modal.visibleZonesAllSelected() ? \'Quitar todas\' : \'Seleccionar todas\'}}</button></div><input type=\"search\" class=\"form-control ed-zone-search\" ng-model=\"modal.zoneQuery\" placeholder=\"Buscar zona…\" aria-label=\"Buscar zona\"></div><div class=\"ed-modal-scroll\"><div class=\"checkbox\" ng-repeat=\"z in modal.visibleOwnZones()\"><label><input type=\"checkbox\" ng-model=\"modal.zoneSelected[z.id]\"> {{z.nombre}} <span class=\"ed-muted\">({{z.dispositivos.length}} dispositivos)</span></label></div><p class=\"ed-muted\" ng-if=\"!modal.visibleOwnZones().length && !modal.visibleSharedZones().length\">No hay zonas que coincidan con la búsqueda.</p><div ng-if=\"modal.visibleSharedZones().length\"><p class=\"ed-modal-label\">Compartidas</p><div class=\"checkbox\" ng-repeat=\"z in modal.visibleSharedZones()\"><label><input type=\"checkbox\" ng-model=\"modal.zoneSelected[z.id]\"> {{z.nombre}}<span ng-if=\"z.clienteNombre\">· {{z.clienteNombre}}</span> <span class=\"ed-muted\">({{z.dispositivos.length}} dispositivos)</span></label></div></div></div></div><div class=\"ed-modal-step\" ng-show=\"modal.step === 2\"><div class=\"ed-modal-fixed\"><div class=\"ed-zone-block-head\"><p class=\"ed-modal-label\">Dispositivos por zona</p><button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"modal.toggleAllDevices()\">{{modal.allDevicesSelected() ? \'Quitar todos\' : \'Seleccionar todos\'}}</button></div></div><div class=\"ed-modal-scroll\"><div class=\"ed-zone-block\" ng-repeat=\"z in modal.chosenZones()\"><div class=\"ed-zone-block-head\"><strong>{{z.nombre}}</strong> <button type=\"button\" class=\"btn btn-link btn-xs\" ng-click=\"modal.toggleZoneAll(z)\">{{modal.zoneAllSelected(z) ? \'Quitar todos\' : \'Seleccionar todos\'}}</button></div><div class=\"ed-device-list\"><div class=\"checkbox\" ng-repeat=\"d in z.dispositivos\"><label><input type=\"checkbox\" ng-model=\"modal.deviceSelected[d.id]\"> {{d.nombre}} <span class=\"label label-default\" ng-if=\"modal.typeLabel(d.tipo)\">{{modal.typeLabel(d.tipo)}}</span></label></div></div></div></div><div class=\"ed-modal-fixed\"><p class=\"ed-muted\">{{modal.selectedCount()}} dispositivos seleccionados</p></div></div><div class=\"ed-modal-fixed\"><div class=\"alert alert-danger\" ng-if=\"modal.error\">{{modal.error}}</div><div class=\"ed-modal-actions\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"closeThisDialog()\">Cancelar</button> <button type=\"button\" class=\"btn btn-default\" ng-if=\"modal.step === 2\" ng-click=\"modal.back()\">Atrás</button> <button type=\"button\" class=\"btn btn-primary\" ng-if=\"modal.step === 1\" ng-click=\"modal.goToDevices()\">Continuar</button> <button type=\"button\" class=\"btn btn-primary\" ng-if=\"modal.step === 2\" ng-disabled=\"modal.saving || !modal.selectedCount()\" ng-click=\"modal.save()\">{{modal.saving ? \'Guardando…\' : \'Crear dashboard\'}}</button></div></div></form></div>");
$templateCache.put("app/consumo/energy-dashboard/edit-dashboard.modal.html","<div class=\"ed-modal\"><h3>Editar dashboard</h3><form name=\"editDashboardForm\" novalidate=\"\" ng-submit=\"modal.save()\"><div class=\"ed-modal-fixed\"><div class=\"form-group\"><label for=\"ed-edit-dash-name\">Nombre</label> <input id=\"ed-edit-dash-name\" type=\"text\" class=\"form-control\" maxlength=\"{{modal.maxLength}}\" ng-model=\"modal.nombre\" placeholder=\"Ej. Consumo sedes principales\"></div><p class=\"ed-muted\">Solo se puede cambiar el nombre. Las zonas y los dispositivos del dashboard no se modifican.</p></div><div class=\"ed-modal-scroll\"></div><div class=\"ed-modal-fixed\"><div class=\"alert alert-danger\" ng-if=\"modal.error\">{{modal.error}}</div><div class=\"ed-modal-actions\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"closeThisDialog()\">Cancelar</button> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"modal.saving\">{{modal.saving ? \'Guardando…\' : \'Guardar cambios\'}}</button></div></div></form></div>");
$templateCache.put("app/consumo/energy-dashboard/edit-period.modal.html","<div class=\"ed-modal\"><h3>Editar precios del período</h3><form name=\"editPeriodForm\" novalidate=\"\" ng-submit=\"modal.save()\"><div class=\"ed-modal-fixed\"><p class=\"ed-muted\">Las fechas del período no se pueden modificar.</p><div class=\"form-group\"><label for=\"ed-edit-period-start\">Fecha de inicio</label> <input id=\"ed-edit-period-start\" type=\"text\" class=\"form-control\" ng-value=\"modal.period.fecha_inicio | edDate\" readonly=\"\"></div><div class=\"form-group\"><label for=\"ed-edit-period-end\">Fecha de fin</label> <input id=\"ed-edit-period-end\" type=\"text\" class=\"form-control\" ng-value=\"modal.period.fecha_fin | edDate\" readonly=\"\"></div><p class=\"ed-modal-label\">Precio del kWh (COP) por zona (opcional)</p><p class=\"ed-muted\">Deja vacío si no quieres calcular el costo de una zona. Un precio de 0 es válido.</p><label for=\"ed-edit-period-global-price\">Precio global</label><div class=\"ed-global-price\"><input id=\"ed-edit-period-global-price\" type=\"number\" min=\"0\" step=\"0.0001\" class=\"form-control\" ng-model=\"modal.globalPrice\" placeholder=\"Mismo precio para todas las zonas\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"modal.applyGlobalPrice()\" ng-disabled=\"modal.loadingZones || !modal.zones.length\">Aplicar a todas</button></div></div><div class=\"ed-modal-scroll\"><div class=\"ed-muted\" ng-if=\"modal.loadingZones\"><span class=\"ion-load-c load-rotate\"></span> Cargando zonas…</div><div class=\"form-group\" ng-repeat=\"z in modal.zones\"><label for=\"ed-edit-period-price-{{z.id}}\">{{z.nombre}}</label> <input id=\"ed-edit-period-price-{{z.id}}\" name=\"price_{{z.id}}\" type=\"number\" min=\"0\" step=\"0.0001\" class=\"form-control\" ng-model=\"modal.prices[z.id]\" placeholder=\"Ej. 620.50\"></div></div><div class=\"ed-modal-fixed\"><div class=\"alert alert-danger\" ng-if=\"modal.error\">{{modal.error}}</div><div class=\"ed-modal-actions\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"closeThisDialog()\">Cancelar</button> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"modal.saving || modal.loadingZones || !modal.zones.length\">{{modal.saving ? \'Guardando…\' : \'Guardar cambios\'}}</button></div></div></form></div>");
$templateCache.put("app/consumo/energy-dashboard/energy-dashboard.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content ed-page\"><h2>Dashboard de consumo energético</h2><div class=\"ed-header\"><div class=\"ed-field\"><label for=\"ed-dashboard\">Dashboard</label><div class=\"ed-field-row\"><select id=\"ed-dashboard\" class=\"form-control\" ng-model=\"vm.selected.dashboardId\" ng-change=\"vm.onDashboardChange()\" ng-options=\"d.id as d.nombre for d in vm.dashboards\" ng-disabled=\"!vm.dashboards.length\"></select><button type=\"button\" class=\"btn btn-default ed-icon-btn\" title=\"Editar dashboard\" aria-label=\"Editar dashboard\" ng-click=\"vm.openEditDashboard()\" ng-disabled=\"!vm.canEditDashboard()\"><span class=\"ion-edit\"></span></button> <button type=\"button\" class=\"btn btn-default ed-icon-btn\" title=\"Eliminar dashboard\" aria-label=\"Eliminar dashboard\" ng-click=\"vm.openDeleteDashboard()\" ng-disabled=\"!vm.canEditDashboard()\"><span class=\"ion-trash-a\"></span></button></div></div><div class=\"ed-field\"><label for=\"ed-period\">Período histórico</label><div class=\"ed-field-row\"><select id=\"ed-period\" class=\"form-control\" ng-model=\"vm.selected.periodId\" ng-change=\"vm.onPeriodChange()\" ng-options=\"p.id as vm.periodLabel(p) for p in vm.periods\" ng-disabled=\"!vm.periods.length\"></select><button type=\"button\" class=\"btn btn-default ed-icon-btn\" title=\"Editar precios del período\" aria-label=\"Editar precios del período\" ng-click=\"vm.openEditPeriod()\" ng-disabled=\"!vm.canEditPeriod()\"><span class=\"ion-edit\"></span></button> <button type=\"button\" class=\"btn btn-default ed-icon-btn\" title=\"Eliminar período\" aria-label=\"Eliminar período\" ng-click=\"vm.openDeletePeriod()\" ng-disabled=\"!vm.canEditPeriod()\"><span class=\"ion-trash-a\"></span></button></div></div><div class=\"ed-actions\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.openCreateDashboard()\">Nuevo dashboard</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openNewPeriod()\" ng-disabled=\"vm.selected.dashboardId === null\">Nuevo período</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.exportPdf()\" ng-disabled=\"!vm.canExport()\"><span class=\"ion-load-c load-rotate\" ng-if=\"vm.exporting\"></span> {{vm.exporting ? \'Generando PDF…\' : \'Descargar PDF\'}}</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.exportZonesExcel()\" ng-disabled=\"!vm.canExport()\">Excel por zona</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.exportDevicesExcel()\" ng-disabled=\"!vm.canExport()\">Excel por dispositivo</button></div></div><div class=\"alert alert-danger\" ng-if=\"vm.error\">{{vm.error}}</div><div class=\"alert alert-danger\" ng-if=\"vm.exportError\">{{vm.exportError}}</div><div class=\"ed-empty\" ng-if=\"!vm.loadingDashboards && !vm.dashboards.length && !vm.error\"><span class=\"ion-flash\"></span><h3>Aún no tienes dashboards de consumo</h3><p>Crea tu primer dashboard eligiendo las zonas y los dispositivos que quieres analizar.</p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.openCreateDashboard()\">Nuevo dashboard</button></div><div class=\"ed-empty\" ng-if=\"vm.dashboards.length && !vm.loadingPeriods && !vm.periods.length && !vm.error\"><span class=\"ion-calendar\"></span><h3>Este dashboard aún no tiene períodos</h3><p>Define un período cerrado (fechas y, opcionalmente, el precio del kWh por zona) para ver su consumo.</p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.openNewPeriod()\">Nuevo período</button></div><div class=\"ed-loading\" ng-if=\"vm.loadingData || vm.loadingPeriods || vm.loadingDashboards\"><span class=\"ion-load-c load-rotate\"></span><p ng-if=\"vm.loadingData\">Calculando consumo del período, la primera consulta puede tardar… <span ng-if=\"vm.progressPct() !== null\">({{vm.progressPct()}}%)</span></p><p ng-if=\"!vm.loadingData\">Cargando…</p><div class=\"ed-skeleton-row\"><div class=\"ed-skeleton\"></div><div class=\"ed-skeleton\"></div><div class=\"ed-skeleton\"></div></div></div><div class=\"alert alert-danger\" ng-if=\"vm.dataError && !vm.loadingData\"><p>{{vm.dataError}}</p><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.retryPeriodData()\">Reintentar</button></div><div ng-if=\"vm.data && !vm.loadingData\"><p class=\"ed-period-info\">Período: <strong>{{vm.data.periodo.fecha_inicio | edDate}}</strong> a <strong>{{vm.data.periodo.fecha_fin | edDate}}</strong></p><div class=\"row\"><div class=\"col-md-4 col-sm-6 col-xs-12\"><div class=\"ed-card\"><span class=\"ed-card-label\">Consumo total</span> <span class=\"ed-card-value\">{{vm.data.resumen.kwh_total | edKwh}} <small>kWh</small></span></div></div><div class=\"col-md-4 col-sm-6 col-xs-12\" ng-if=\"vm.priceState !== \'none\'\"><div class=\"ed-card\"><span class=\"ed-card-label\">Costo total</span> <span class=\"ed-card-value\">{{vm.data.resumen.costo_total | edCop}}</span></div></div><div class=\"col-sm-12 col-xs-12\" ng-class=\"vm.priceState !== \'none\' ? \'col-md-4\' : \'col-md-8\'\"><div class=\"ed-card\"><span class=\"ed-card-label\">Variación vs período anterior</span> <span class=\"ed-card-value\" ng-class=\"vm.trendClass(vm.data.resumen.variacion_pct)\"><span ng-if=\"vm.data.resumen.variacion_pct > 0\" class=\"ion-arrow-up-b\"></span> <span ng-if=\"vm.data.resumen.variacion_pct < 0\" class=\"ion-arrow-down-b\"></span> {{vm.data.resumen.variacion_pct | edPct}}</span> <span class=\"ed-card-hint\" ng-if=\"vm.data.periodo_anterior\">{{vm.data.periodo_anterior.fecha_inicio | edDate}} a {{vm.data.periodo_anterior.fecha_fin | edDate}}</span> <span class=\"ed-card-hint\" ng-if=\"!vm.data.periodo_anterior\">Sin período anterior para comparar</span></div></div></div><div class=\"panel panel-default ed-panel\"><div class=\"panel-heading\">Consumo diario (kWh)</div><div class=\"panel-body\"><energy-daily-chart serie=\"vm.data.serie_diaria\" anterior=\"vm.data.serie_anterior\" export-api=\"vm.charts.daily\"></energy-daily-chart><p class=\"ed-note\" ng-if=\"vm.data.serie_anterior\">La línea punteada muestra el período anterior alineado por número de día.</p></div></div><div class=\"panel panel-default ed-panel\"><div class=\"panel-heading\">Consumo por zona</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><energy-zone-chart zonas=\"vm.data.zonas\" selected-id=\"vm.selectedZoneId\" on-select=\"vm.selectZone(zonaId)\" export-api=\"vm.charts.zone\"></energy-zone-chart></div><div class=\"col-md-6 col-xs-12\"><div class=\"table-responsive\"><table class=\"table table-hover ed-table\"><thead><tr><th>Zona</th><th class=\"text-right\">kWh</th><th class=\"text-right\" ng-if=\"vm.priceState !== \'none\'\">Precio kWh</th><th class=\"text-right\" ng-if=\"vm.priceState !== \'none\'\">Costo</th><th class=\"text-right\">Variación</th></tr></thead><tbody><tr ng-repeat=\"z in vm.data.zonas\" class=\"ed-row-click\" ng-class=\"{\'ed-row-active\': z.zona_id === vm.selectedZoneId}\" ng-click=\"vm.selectZone(z.zona_id)\"><td>{{z.nombre}}</td><td class=\"text-right\">{{z.kwh | edKwh}}</td><td class=\"text-right\" ng-if=\"vm.priceState !== \'none\'\">{{z.precio_kwh | edPrice}}</td><td class=\"text-right\" ng-if=\"vm.priceState !== \'none\'\">{{z.costo | edCop}}</td><td class=\"text-right\" ng-class=\"vm.trendClass(z.variacion_pct)\">{{z.variacion_pct | edPct}}</td></tr></tbody></table></div><p class=\"ed-note\" ng-if=\"vm.priceState === \'mixed\'\">El costo total solo incluye las zonas con precio del kWh; las zonas sin precio se muestran con «—».</p><p class=\"ed-note\">Haz clic en una zona para ver el detalle por dispositivo.</p></div></div></div></div><div class=\"panel panel-default ed-panel\" ng-if=\"vm.selectedZone()\"><div class=\"panel-heading\">Detalle por dispositivo: {{vm.selectedZone().nombre}}</div><div class=\"panel-body\"><div class=\"table-responsive\"><table class=\"table ed-table\"><thead><tr><th>Dispositivo</th><th class=\"text-right\">kWh</th><th class=\"text-right\" ng-if=\"vm.priceState !== \'none\'\">Costo</th><th class=\"text-right\">% de la zona</th></tr></thead><tbody><tr ng-repeat=\"d in vm.zoneDevices()\"><td>{{d.nombre}} <span class=\"label label-info\" ng-if=\"d.tipo === 5\" title=\"Consumo estimado a partir de la corriente medida y la potencia nominal del dispositivo\">Estimado</span></td><td class=\"text-right\"><span ng-if=\"!d.sin_datos\">{{d.kwh | edKwh}}</span> <span ng-if=\"d.sin_datos\" class=\"label label-default\">Sin datos</span></td><td class=\"text-right\" ng-if=\"vm.priceState !== \'none\'\">{{d.costo | edCop}}</td><td class=\"text-right\">{{d.share_pct === null ? \'—\' : (d.share_pct | edKwh) + \'%\'}}</td></tr></tbody></table></div><p class=\"ed-note\" ng-if=\"vm.zoneHasEstimated()\">Estimado: el consumo de los dispositivos Helo S se calcula a partir de la corriente medida y su potencia nominal.</p></div></div></div></div></div></div>");
$templateCache.put("app/consumo/energy-dashboard/new-period.modal.html","<div class=\"ed-modal\"><h3>Nuevo período</h3><form name=\"newPeriodForm\" novalidate=\"\" ng-submit=\"modal.save()\"><div class=\"ed-modal-fixed\"><p class=\"ed-muted\">Solo se permiten períodos cerrados: la fecha de fin debe ser anterior a hoy.</p><div class=\"form-group\"><label for=\"ed-period-start\">Fecha de inicio</label> <input id=\"ed-period-start\" type=\"date\" class=\"form-control\" ng-model=\"modal.form.fecha_inicio\"></div><div class=\"form-group\"><label for=\"ed-period-end\">Fecha de fin</label> <input id=\"ed-period-end\" type=\"date\" class=\"form-control\" max=\"{{modal.maxDate}}\" ng-model=\"modal.form.fecha_fin\"></div><p class=\"ed-modal-label\">Precio del kWh (COP) por zona (opcional)</p><p class=\"ed-muted\">Deja vacío si no quieres calcular el costo de una zona. Un precio de 0 es válido.</p><label for=\"ed-period-global-price\">Precio global</label><div class=\"ed-global-price\"><input id=\"ed-period-global-price\" type=\"number\" min=\"0\" step=\"0.0001\" class=\"form-control\" ng-model=\"modal.globalPrice\" placeholder=\"Mismo precio para todas las zonas\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"modal.applyGlobalPrice()\" ng-disabled=\"modal.loadingZones || !modal.zones.length\">Aplicar a todas</button></div></div><div class=\"ed-modal-scroll\"><div class=\"ed-muted\" ng-if=\"modal.loadingZones\"><span class=\"ion-load-c load-rotate\"></span> Cargando zonas…</div><div class=\"form-group\" ng-repeat=\"z in modal.zones\"><label for=\"ed-period-price-{{z.id}}\">{{z.nombre}}</label> <input id=\"ed-period-price-{{z.id}}\" name=\"price_{{z.id}}\" type=\"number\" min=\"0\" step=\"0.0001\" class=\"form-control\" ng-model=\"modal.prices[z.id]\" placeholder=\"Ej. 620.50\"></div></div><div class=\"ed-modal-fixed\"><div class=\"alert alert-danger\" ng-if=\"modal.error\">{{modal.error}}</div><div class=\"ed-modal-actions\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"closeThisDialog()\">Cancelar</button> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"modal.saving || modal.loadingZones || !modal.zones.length\">{{modal.saving ? \'Guardando…\' : \'Crear período\'}}</button></div></div></form></div>");
$templateCache.put("app/instalador/dashboard-instalador/dashboard_instalador.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><ui-view><h2>Clientes</h2><a ui-sref=\"dashboard_instalador.newClient\" class=\"btn btn-default boton_agregar\" style=\"margin-bottom: 1em;\">Agregar cliente</a><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel panel-primary bootstrap-panel h_ind_ahorro animated zoomIn\" zoom-in=\"\" ng-repeat=\"cliente in clientes\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><div class=\"h_icon\"><span class=\"ion-location\"></span></div><p>{{cliente.nombre}}</p></div><div class=\"al-user-profile h-100\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><span class=\"fa fa-gear center-icon-instalador\"></span></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><i class=\"dropdown-arr\"></i></li><li><a ng-click=\"dia_facturacion_modal(cliente)\" class=\"signout\"><i class=\"fa fa-calendar-check-o\"></i>Día inicial de facturación</a></li><li><a ng-click=\"valor_kwh_modal(cliente)\" class=\"signout\"><i class=\"fa fa-money\"></i>Valor kWh mensual</a></li><li><a ui-sref=\"users({cliente:cliente})\"><i class=\"fa fa-users\"></i>Usuarios cliente</a></li></ul></div></div><div class=\"panel-body\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default collapse-acordion\" ng-repeat=\"zona in cliente.zonas\"><uib-accordion-heading><p>{{zona.nombre}}</p><span class=\"ion-chevron-right\" aria-hidden=\"true\" ng-click=\"mostrar_zonas($index)\"></span></uib-accordion-heading><table class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 tabla-disp\"><thead><tr><th>Código</th><th>Nombre</th><th>Tipo</th><th>Voltaje(Vrms) o distancia(m)</th></tr></thead><tbody><tr ng-repeat=\"dispositivo in zona.dispositivos\"><td>{{dispositivo.code}}</td><td>{{dispositivo.nombre}}</td><td>{{dispositivo.tipo}}</td><td>{{dispositivo.potencia}}</td></tr></tbody></table><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_disp(zona.id, cliente.nombre)\">Agregar dispositivo</button></div></uib-accordion><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_zona(cliente.id)\">Agregar zona</button></div></div></div></ui-view></div></div></div><page-footer></page-footer>");
$templateCache.put("app/instalador/projects/projects.html","<ba-sidebar></ba-sidebar><page-top></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"></div><div class=\"centrar centrar-flex-flow centrar-align-start width-100\"><project class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"></project></div></div></div><page-footer></page-footer>");
$templateCache.put("app/instalador/users/users.html","<ba-sidebar></ba-sidebar><page-top></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"></div><ui-view><a ui-sref=\"users.newUser({cliente:cliente})\"><button class=\"btn-add-card centrar centrar-c\" title=\"Crear nuevo usuario\">+</button></a><div class=\"centrar-flex-flow width-100\"><user-card class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12\" ng-repeat=\"user in users track by $index\" user=\"user\"></user-card></div></ui-view></div></div><page-footer></page-footer>");
$templateCache.put("app/operador/dashboard-operador/dashboard_operador.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"operador-panel\"><div class=\"panel panel-primary bootstrap-panel animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header color-1 cursor\"><div class=\"h_titulo centrar width-100p\" ng-click=\"showPanel(1)\"><div class=\"centrar\"><div class=\"h_icon\"><span class=\"ion-pricetag\"></span></div><p>Ofertas de desconexión próximas a lanzar</p></div><div><span class=\"flecha_op\" ng-class=\"{\'ion-ios-arrow-down\': OpenOferta_lanzar, \'ion-ios-arrow-up\': !OpenOferta_lanzar}\"></span></div></div></div><div class=\"panel-body\" ng-show=\"OpenOferta_lanzar\"><table class=\"table-bordered table-condensed width-100 tabla_helo tabla_responsive\"><thead><th data-label=\"Tamaño oferta kW\" class=\"width-80\">Tamaño oferta kW</th><th data-label=\"Valor por kWh\" class=\"width-80\">Valor por kWh</th><th data-label=\"Día\" colspan=\"1\">Día</th><th data-label=\"Hora de inicio\" colspan=\"1\">Hora de inicio</th><th data-label=\"Hora de finalización\" colspan=\"1\">Hora de finalización</th><th data-label=\"Hora de finalización\">Ciudad</th><th>Porcentaje de logro actual</th></thead><tbody><tr ng-repeat=\"oferta in ofertas | orderBy:\'dia\'\" class=\"editable-row\" ng-if=\"oferta.estado == 1\"><td data-label=\"Tamaño oferta kW\"><span ng-show=\"oferta.flag\">{{ oferta.kw || \'No definido\' }}</span> <input ng-hide=\"oferta.flag\" type=\"number\" class=\"form-control\" ng-model=\"nuevos[$index].kw\"></td><td data-label=\"Valor por kWh\"><span ng-show=\"oferta.flag\">{{ oferta.precio_kwh || \'No definido\' }}</span> <input ng-hide=\"oferta.flag\" type=\"number\" class=\"form-control\" ng-model=\"nuevos[$index].precio_kwh\"></td><td data-label=\"Día\"><span ng-show=\"oferta.flag\">{{ oferta.dia | date: format:\'yyyy-MM-dd\' || \'No definido\' }}</span> <input type=\"date\" ng-model=\"nuevos[$index].dia\" min=\"{{today}}\" ng-hide=\"oferta.flag\"></td></tr></tbody></table></div><td data-label=\"Hora de inicio\"><span ng-show=\"oferta.flag\">{{ oferta.hini | date:\'shortTime\' || \'No definido\' }}</span><div uib-timepicker=\"\" ng-model=\"nuevos[$index].hini\" show-meridian=\"ismeridian\" ng-hide=\"oferta.flag\"></div></td><td data-label=\"Hora de finalización\"><span ng-show=\"oferta.flag\">{{ oferta.hfin | date:\'shortTime\' || \'No definido\' }}</span><div uib-timepicker=\"\" ng-model=\"nuevos[$index].hfin\" min=\"nuevos[$index].hini\" show-meridian=\"ismeridian\" ng-hide=\"oferta.flag\"></div></td><td class=\"select-td\" data-label=\"ciudad\"><span ng-show=\"oferta.flag\">{{oferta.ciudad}}</span><select class=\"form-control\" ng-model=\"nuevos[$index].ciudad\" ng-hide=\"oferta.flag\" ng-init=\"oferta.ciudad\"><option ng-repeat=\"ciudad in ciudades\">{{ciudad.nombre || \'No definido\'}}</option></select></td><td data-label=\"acciones\"><div ng-show=\"oferta.flag\" class=\"centrar centrar-columna\"><button class=\"btn btn-default margin-top-10\" ng-click=\"editar($index)\">Editar</button> <button ng-click=\"borrar($index)\" class=\"btn btn-danger margin-top-10\">Borrar</button></div><div ng-hide=\"oferta.flag\" class=\"centrar centrar-columna\"><button ng-click=\"guardar($index, nuevos[$index])\" class=\"btn btn-primary margin-top-10\">Guardar</button> <button ng-click=\"cancelar($index)\" class=\"btn btn-default margin-top-10\">Cancelar</button></div></td><p ng-show=\"flag_msg_oferta\">{{msg}}</p><button class=\"btn btn-primary margin-top-10\" ng-click=\"addOferta(index)\">Agregar Oferta</button></div></div></div><div class=\"operador-panel\"><div class=\"panel panel-primary bootstrap-panel animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header color-2 cursor\"><div class=\"h_titulo centrar width-100p\" ng-click=\"showPanel(2)\"><div class=\"centrar\"><div class=\"h_icon\"><span class=\"ion-pricetag\"></span></div><p>Ofertas abiertas</p></div><div><span class=\"flecha_op\" ng-class=\"{\'ion-ios-arrow-down\': OpenOferta_abiertas, \'ion-ios-arrow-up\': !OpenOferta_abiertas}\"></span></div></div></div><div class=\"panel-body\" ng-show=\"OpenOferta_abiertas\"><table class=\"table-bordered table-condensed width-100 tabla_helo tabla_responsive\"><thead><th data-label=\"Tamaño oferta kW\" class=\"width-80\">Tamaño oferta kW</th><th data-label=\"Valor por kWh\" class=\"width-80\">Valor por kWh</th><th data-label=\"Día\" colspan=\"1\">Día</th><th data-label=\"Hora de inicio\" colspan=\"1\">Hora de inicio</th><th data-label=\"Hora de finalización\" colspan=\"1\">Hora de finalización</th><th data-label=\"Ciudad\">Ciudad</th><th data-label=\"Porcentaje de logro actual\">Porcentaje de logro actual</th><tr ng-repeat=\"oferta in ofertas\" class=\"editable-row\" ng-if=\"oferta.estado == 2\"><td><span>{{ oferta.kw || \'No definido\' }}</span></td><td><span>{{ oferta.precio_kwh || \'No definido\' }}</span></td><td><span>{{ oferta.dia | date: format:\'yyyy-MM-dd\' || \'No definido\' }}</span></td><td><span>{{ oferta.hini | date:\'shortTime\' || \'No definido\' }}</span></td><td><span>{{ oferta.hfin | date:\'shortTime\' || \'No definido\' }}</span></td><td class=\"select-td\"><span>{{oferta.ciudad}}</span></td><td class=\"select-td\"><span>100</span></td></tr></thead></table></div></div></div><div class=\"operador-panel\"><div class=\"panel panel-primary bootstrap-panel animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header color-3 cursor\"><div class=\"h_titulo centrar width-100p\" ng-click=\"showPanel(3)\"><div class=\"centrar\"><div class=\"h_icon\"><span class=\"ion-pricetag\"></span></div><p>Ofertas ejecutandose</p></div><div><span class=\"flecha_op\" ng-class=\"{\'ion-ios-arrow-down\': OpenOferta_ejecutandose, \'ion-ios-arrow-up\': !OpenOferta_ejecutandose}\"></span></div></div></div><div class=\"panel-body\" ng-show=\"OpenOferta_ejecutandose\"><table class=\"table-bordered table-condensed tabla-operador col-lg-12 col-md-12 col-sm-12 col-xs-12\"><tr class=\"tabla-titulos\"><td class=\"width-80\">Tamaño oferta kW</td><td class=\"width-80\">Valor por kWh</td><td colspan=\"1\">Día</td><td colspan=\"1\">Hora de inicio</td><td colspan=\"1\">Hora de finalización</td><td>Ciudad</td><td>Porcentaje alcanzado</td></tr><tr ng-repeat=\"oferta in ofertas\" class=\"editable-row\" ng-if=\"oferta.estado == 3\"><td><span>{{ oferta.kw || \'No definido\' }}</span></td><td><span>{{ oferta.precio_kwh || \'No definido\' }}</span></td><td><span>{{ oferta.dia | date: format:\'yyyy-MM-dd\' || \'No definido\' }}</span></td><td><span>{{ oferta.hini | date:\'shortTime\' || \'No definido\' }}</span></td><td><span>{{ oferta.hfin | date:\'shortTime\' || \'No definido\' }}</span></td><td class=\"select-td\"><span>{{oferta.ciudad}}</span></td><td class=\"select-td\"><span>100</span></td></tr></table></div></div></div><div class=\"operador-panel\"><div class=\"panel panel-primary bootstrap-panel animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header color-4 cursor\"><div class=\"h_titulo centrar width-100p\" ng-click=\"showPanel(4)\"><div class=\"centrar\"><div class=\"h_icon\"><span class=\"ion-pricetag\"></span></div><p>Ofertas finalizadas</p></div><span class=\"flecha_op\" ng-class=\"{\'ion-ios-arrow-down\': OpenOferta_finalizadas, \'ion-ios-arrow-up\': !OpenOferta_finalizadas}\"></span></div></div><div class=\"panel-body\" ng-show=\"OpenOferta_finalizadas\"><div class=\"centrar centrar-justificar-inicio\"><div class=\"padding-2 transform z5\"><h4>Fecha</h4><p class=\"input-group d_program\"><input type=\"text\" class=\"form-control\" id=\"des_f_ini\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"des_f_ini\" is-open=\"popup.opened\" datepicker-options=\"options1\" ng-required=\"true\" close-text=\"Cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"fecha()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open1()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div><span class=\"btn btn-default ion-refresh\" ng-click=\"refresh()\" style=\"margin-top: 30px;\"></span></div></div><table class=\"table-bordered table-condensed tabla_helo width-100 tabla_responsive\"><thead><th>Tamaño oferta kW</th><th>Valor por kWh</th><th>Día</th><th>Hora de inicio</th><th>Hora de finalización</th><th>Ciudad</th><th>Porcentaje alcanzado</th></thead><tbody><tr ng-repeat=\"oferta in ofertas_finalizadas | filter: (fecha_filtro == undefined ? \'\' : {dia: fecha_filtro})\" class=\"editable-row\" ng-if=\"$index < currentPage*itemsPerPage && $index >= (currentPage-1)*itemsPerPage\"><td data-label=\"Tamaño oferta kW\"><span>{{ oferta.kw || \'No definido\' }}</span></td><td data-label=\"Valor por KWh\"><span>{{ oferta.precio_kwh || \'No definido\' }}</span></td><td data-label=\"Día\"><span>{{ oferta.dia | date: format:\'yyyy-MM-dd\' || \'No definido\' }}</span></td><td data-label=\"Hora de inicio\"><span>{{ oferta.hini | date:\'shortTime\' || \'No definido\' }}</span></td><td data-label=\"Hora de finalización\"><span>{{ oferta.hfin | date:\'shortTime\' || \'No definido\' }}</span></td><td data-label=\"ciudad\"><span>{{oferta.ciudad}}</span></td><td data-label=\"Porcentaje alcanzado\"><span>100</span></td></tr></tbody></table><div class=\"text-center ind_pag\" style=\"text-align: center !important;\"><ul uib-pagination=\"\" direction-links=\"false\" total-items=\"totalItems\" ng-model=\"currentPage\" items-per-page=\"itemsPerPage\" boundary-links=\"false\" force-ellipses=\"true\"></ul></div></div></div></div></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2016.</div></footer>");
$templateCache.put("app/operador/ofertas/ofertas.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"panel panel-primary bootstrap-panel h_ind_oferta animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header_oferta\"><div class=\"h_titulo\"><div class=\"h_icon\"><span class=\"ion-pricetag\"></span></div><p class=\"color-blanco\">Ofertas</p></div></div><div class=\"panel-body\"><div class=\"centrar\"><div class=\"width-150 margin-bottom-10\"><select class=\"form-control\" ng-model=\"mes_oferta\"><option ng-repeat=\"mes in meses\" ng-selected=\"mes_oferta=mes.nombre\">{{mes.nombre}}</option></select></div><div class=\"centrar centrar-justificar-final\"><button class=\"btn btn-default btn-pagar color-3\" ng-show=\"ofertas_estado_mes_deuda\" ng-click=\"enviarPago(mes_oferta)\">Pagar</button><p ng-hide=\"ofertas_estado_mes_deuda\">Ofertas pagadas</p></div></div><table class=\"table-bordered table-condensed width-100 tabla_responsive tabla_helo\"><thead><th data-label=\"Oferta\">Ofertas</th><th data-label=\"Día\">Día</th><th data-label=\"Intervalo de tiempo\">Intervalo de tiempo</th><th data-label=\"valor kWh\">Valor KWh</th><th data-label=\"Tamaño de la oferta\">Tamaño de la oferta</th><th data-label=\"Ciudad\">Ciudad</th><th data-label=\"% de logro\">% de logro</th><th data-label=\"Clientes participantes\">Clientes participantes</th><th data-label=\"KWh desconectados\">KWh desconectados</th><th data-label=\"Costo\">Costo</th></thead><tbody><tr ng-repeat=\"oferta in ofertas_ejecutadas\"><td data-label=\"Oferta\">{{oferta.id}}</td><td data-label=\"Día\">{{oferta.fecha_limite}}</td><td data-label=\"Intervalo de tiempo\">{{oferta.hora_in}} - {{oferta.hora_fin}}</td><td data-label=\"valor kWh\">${{oferta.valor_oferta | number}}</td><td data-label=\"Tamaño de la oferta\">{{oferta.tamano_oferta | number}}</td><td data-label=\"Ciudad\">{{oferta.ciudad}}</td><td data-label=\"% de logro\">{{oferta.porcentaje_alcanzado}}</td><td data-label=\"Clientes participantes\">{{oferta.clientes_participantes}}</td><td data-label=\"KWh desconectados\">{{oferta.kwh_desconectados | number}}</td><td data-label=\"Costo\">{{oferta.costo | number}}</td></tr></tbody></table></div></div></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2017.</div></footer>");
$templateCache.put("app/operador/statistics/statistics.html","<ba-sidebar></ba-sidebar><page-top></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Combined bullet/column and line graphs with multiple value axes\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/operador/charts/amCharts/combinedChart/combinedChart.html\'\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Line Chart\" ba-panel-class=\"with-scroll\"><div line-chart=\"\" line-data=\"lineData\" line-xkey=\"y\" line-ykeys=\'[\"a\", \"b\"]\' line-labels=\'[\"Serie A\", \"Serie B\"]\' line-colors=\"colors\"></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div ba-panel=\"\" ba-panel-title=\"Donut\" ba-panel-class=\"with-scroll\"><div donut-chart=\"\" donut-data=\"donutData\" donut-colors=\"colors\" donut-formatter=\'\"currency\"\'></div></div></div><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-title=\"Bar Chart\" ba-panel-class=\"with-scroll\"><div bar-chart=\"\" bar-data=\"barData\" bar-x=\"y\" bar-y=\'[\"a\", \"b\"]\' bar-labels=\'[\"Series A\", \"Series B\"]\' bar-colors=\"colors\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Area Chart\" ba-panel-class=\"with-scroll\"><div area-chart=\"\" area-data=\"areaData\" area-xkey=\"y\" area-ykeys=\'[\"a\", \"b\"]\' %=\"\" area-labels=\'[\"Serie A\", \"Serie B\"]\' line-colors=\"colors\"></div></div></div></div></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2016.</div></footer>");
$templateCache.put("app/profile/membership-coupon/membership-coupon.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn\"><div class=\"panel-body membership-coupon\"><form name=\"couponForm\" class=\"centrar centrar-columna centrar-align-start membership-coupon-info\"><h3>¡tengo un cupón de Membresía!</h3><p>En Helo nos gusta que nuestros usuarios prueben todas las funcionalidades de nuestra plataforma, por eso te vas a encontrar regularmente con cupones que puedes usar para subir de nivel y adquirir una de nuestras membresías por tiempo limitado. Aquí es el lugar donde lo puedes redimir y sacarle el máximo provecho a la Plataforma Helo.</p><input type=\"text\" ng-model=\"coupon\" placeholder=\"Cupón\" required=\"\"> <button class=\"btn-add-activo centrar centrar-c\" ng-disabled=\"!couponForm.$valid\" title=\"Enviar Cupón\" ng-click=\"sendCoupon(coupon)\">Enviar</button><p ng-if=\"errorCoupon\">El código que ingresaste no es válido</p><p ng-if=\"errorMembership\">No puedes usar este código porque ya tienes una membresía activa</p></form><div class=\"centrar membership-coupon-img\"><img src=\"../../../assets/img/membership_coupon.png\" alt=\"\"></div></div></div></div></div>");
$templateCache.put("app/settings/dev-tools/dev-tools.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel\"><div class=\"panel-body dev-tools\"><h1 class=\"title\">¿Cómo obtener el Token de autorización?</h1><p>Este endpoint permite obtener un token de autorización que será utilizado para acceder a recursos protegidos en la API de Helo.</p><p class=\"sub-title\"><strong>URL del Endpoint</strong></p><div class=\"centrar dev-toots-note\"><p><a href=\"https://api.helo.com.co/v2/verify\" class=\"q-markdown--link q-markdown--link-external\" target=\"_blank\" rel=\"noopener noreferrer\">https://api.helo.com.co/v2/verify</a></p></div><p class=\"sub-title\"><strong>Método de solicitud</strong></p><div class=\"centrar dev-toots-note\"><p>POST</p></div><p class=\"sub-title\"><strong>Headers</strong></p><div class=\"centrar dev-toots-note\"><p>Content-Type: application/json</p></div><p class=\"sub-title\"><strong>Parámetros de la solicitud</strong></p><p>La solicitud debe incluir un objeto JSON en el cuerpo (data) con la siguiente estructura:</p><div class=\"q-markdown--line-numbers-wrapper\"><div class=\"q-markdown--code-wrapper\"><pre>\n                            <code class=\"language-json\">\n                            {\n                                \"uid\": \"{{uid}}\"\n                            }\n                            </code>\n                        </pre></div></div><p class=\"sub-title\"><strong>Tu uid (user id)</strong></p><p>Este código es único por usuario y no debe ser compartido con terceros</p><div class=\"centrar dev-toots-note\"><p>{{uid}}</p></div><p class=\"sub-title\"><strong>Respuesta</strong></p><p>Si la solicitud es exitosa, el servidor responderá con un objeto JSON que contiene el token de autorización:</p><div class=\"q-markdown--line-numbers-wrapper\"><div class=\"q-markdown--code-wrapper\"><pre>\n                            <code class=\"language-json\">\n                                {\n                                    \"token\": \"eyJhbGciOiJSUzI1NiIsImtpZCI6ImIyZGZmNzhhMGJkZDVhMDIyMTIwNjM0OTlkNzdlZjRkZWVkMWY2NWIiLCJ0eXAiOiJKV1QifQ.eyJoZWxvX2IyYiI6dHJ1ZSwibXlzcWxfdWlkIjo0MywiaXNzIjoiaHR0cHM6Ly9zZWN1cmV0b2tlbi5nb29nbGUuY29tL2hlbG8tYXBpLTRjZGIzIiwiYXVkIjoiaGVsby1hcGktNGNkYjMiLCJhdXRoX3RpbWUiOjE2OTA0MjUyNzIsInVzZXJfaWQiOiJnVGlSN2lkUUhSWER2SjFZcUREZUNPajdEWmsxIiwic3ViIjoiZ1RpUjdpZFFIUlhEdkoxWXFERGVDT2o3RFprMSIsImlhdCI6MTY5MDQyNTI3MiwiZXhwIjoxNjkwNDI4ODcyLCJlbWFpbCI6InVzZXJheDFAaW50ZWxtb3RpY3MuY29tIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJmaXJlYmFzZSI6eyJpZGVudGl0aWVzIjp7ImVtYWlsIjpbInVzZXJheDFAaW50ZWxtb3RpY3MuY29tIl19LCJzaWduX2luX3Byb3ZpZGVyIjoiY3VzdG9tIn19.D0NxrNkVyRF-JBq5elb5HNmlmA33MVXKTr9qC1yameUn2KEWnBU6eL8YR0y0GngsXYCMOESi9xeG9nCMkzoB2AVlT1d2yZQLr_2G-nG3GUOJ3mJXfxpQggjJnTR-IMo0J9kKmsCsB1MzmjTV6Kl0yzU8GvmW8qn8QpEx-KODdml5R-nyHmXzzELd0x5yXCWPfemjJJE63HcEmqTftIdJY28IyGoqot2vW3_4ErMpCBj9H18jl9dPfPmVSDbaiYGns4WTxLX912XW44b4dN6UBYAYOOVKdDJo64oPxSX3IAhr11MfZbtTebno5S3rZwgEhq_K7xkmBkvYLuhs8TGozQ\"\n                                }\n                            </code>\n                        </pre></div></div><p class=\"sub-title\"><strong>Códigos de estado de respuesta</strong></p><ul><li>200 OK: La solicitud se procesó correctamente, y el token de autorización se proporciona en la respuesta.</li><li>400 Bad Request: La solicitud no es válida o falta algún parámetro requerido.</li><li>500 Internal Server Error: Se produjo un error en el servidor al procesar la solicitud.</li></ul><p class=\"sub-title\"><strong>Información adicional</strong></p><ul><li>El token de autorización es una cadena larga y cifrada que debe ser incluida en las solicitudes a otros endpoints para acceder a recursos protegidos en la API de Helo.</li><li>Es importante almacenar y gestionar adecuadamente el token de autorización, ya que otorga acceso a información sensible y protegida.</li></ul><p>Recuerda que esta documentación es un resumen de cómo utilizar el endpoint para obtener el token de autorización en la API de Helo. Si hay más funcionalidades o detalles específicos sobre la autenticación y el uso del token, es recomendable agregarlos a la documentación en función de las necesidades y requerimientos del servicio.</p><p class=\"sub-title\"><strong>CURL</strong></p><div class=\"q-markdown--line-numbers-wrapper\"><div class=\"q-markdown--code-wrapper\"><pre>\n                            <code class=\"language-bash\">\n                                curl --location --request POST \'https://api.helo.com.co/v2/verify\' \\\n                                --header \'Content-Type: application/json\' \\\n                                --data \'{\n                                    \"uid\": \"{{uid}}\"\n                                }\'\n                            </code>\n                        </pre></div></div></div></div></div></div>");
$templateCache.put("app/settings/management-holidays/management-holidays.html","<div class=\"managemente-holidays centrar\"><create-holidays class=\"width-100p\" ng-if=\"selectedComponent === 0\" countries=\"countries\"></create-holidays><holidays-by-country class=\"width-100p\" ng-if=\"selectedComponent === 1\" countries=\"countries\"></holidays-by-country></div>");
$templateCache.put("app/help/question/question.html","<div class=\"question\"><div class=\"centrar cursor question-header\" ng-click=\"showContent()\"><h3>{{question.title}}</h3><div class=\"centrar centrar-justificar-final cursor\"><i class=\"centrar centrar-c arrow-question\" ng-class=\"{\'ion-chevron-up\': status.open, \'ion-chevron-down\': !status.open}\"></i></div></div><div ng-if=\"status.open\" class=\"centrar centrar-c question-content\"><youtube width=\"640\" height=\"390\" videoid=\"{{question.video}}\"></youtube></div></div>");
$templateCache.put("app/admin/facturacion/generar/generar_factura.html","");
$templateCache.put("app/admin/maps/google-maps/google-maps.html","<div ba-panel=\"\" ba-panel-title=\"Google Maps\" class=\"viewport100\"><div id=\"google-maps\"></div></div>");
$templateCache.put("app/admin/maps/leaflet/leaflet.html","<div ba-panel=\"\" ba-panel-title=\"Leaflet\" class=\"viewport100\"><div id=\"leaflet-map\"></div></div>");
$templateCache.put("app/admin/maps/map-bubbles/map-bubbles.html","<div ba-panel=\"\" ba-panel-title=\"Map with Bubbles\" class=\"viewport100\"><div id=\"map-bubbles\"></div></div>");
$templateCache.put("app/admin/maps/map-lines/map-lines.html","<div ba-panel=\"\" ba-panel-title=\"Line Map\" class=\"viewport100\"><div id=\"map-lines\"></div></div>");
$templateCache.put("app/auth/recuperar_contrasena/newPassword/newPassword.html","<div class=\"centrar centrar-c centrar-columna cont-login\"><form class=\"centrar centrar-columna centrar-align-start\" name=\"newPasswordForm\"><label>Nueva contraseña*</label> <input type=\"password\" ng-model=\"nuevaContrasena\" required=\"\"><div class=\"centrar width-100p\"><label>Confirmar contraseña*</label><p ng-init=\"show = false\" ng-click=\"show = !show\" class=\"cursor\"><span ng-class=\"{\'ion-eye\' : !show, \'ion-eye-disabled\' : show }\"></span> {{!show ? \'Mostrar\': \'Ocultar\'}}</p></div><input type=\"{{show ? \'text\' : \'password\'}}\" ng-model=\"validarContrasena\" name=\"validarContrasena\" required=\"\"><p ng-if=\"newPasswordForm.validarContrasena.$dirty\"><strong>{{nuevaContrasena === validarContrasena ? \'La contraseña coincide\' : \'La contraseña no coincide\'}}</strong></p><button id=\"enviar_password\" ng-click=\"NuevaContrasena(validarContrasena)\" ng-disabled=\"!newPasswordForm.$valid || nuevaContrasena !== validarContrasena\" ng-class=\"{\'disabled\': (!newPasswordForm.$valid || nuevaContrasena !== validarContrasena)}\">Reiniciar contraseña</button></form></div>");
$templateCache.put("app/auth/recuperar_contrasena/sendEmail/sendEmail.html","<div class=\"centrar centrar-c centrar-columna cont-login\"><h2 class=\"centrar centrar-c\">¿Olvidó la contraseña?</h2><p>No te preocupes, vamos a ayudate. Escribe a continuación tu correo electrónico</p><form class=\"centrar centrar-columna\" name=\"mailForm\"><input type=\"email\" ng-model=\"correo\" placeholder=\"correo\" required=\"\"> <button ng-click=\"recuperar(correo)\" ng-disabled=\"!mailForm.$valid\" ng-class=\"{\'disabled\': !mailForm.$valid}\">Recuperar</button></form></div>");
$templateCache.put("app/auth/recuperar_contrasena/validarCodigo/validarCodigo.html","<div class=\"centrar centrar-c centrar-columna cont-login\"><h2 class=\"centrar centrar-c\">¡Un paso más!</h2><p>Hemos enviado a tu correo electrónico un código de verificación, por favor escríbelo a continuación</p><form class=\"centrar centrar-columna\" name=\"codeForm\"><input type=\"text\" ng-model=\"code_v\" placeholder=\"Inserta código\" required=\"\"> <button ng-click=\"verificarCode(code_v)\" ng-disabled=\"!codeForm.$valid\" ng-class=\"{\'disabled\': !codeForm.$valid}\">Enviar</button></form></div>");
$templateCache.put("app/cliente/alerts/alert/alert.html","<div class=\"cont-alert-card animated zoomIn\"><div class=\"alert-card-heading centrar centrar-columna\"><div class=\"centrar centrar-align-start width-100p\"><div class=\"centrar\"><div class=\"centrar alert-card-type\"><span ng-class=\"{\'icon-alert-temp\': alert.type == \'temp\', \'icon-alert-losses\': alert.type == \'losses\', \'icon-alert-consumption\': alert.type == \'consumption\'}\"></span></div><div class=\"centrar centrar-columna centrar-align-start alert-card-info\"><h3>{{alert.name}}</h3><p class=\"alert-card-info-type\">{{alert.type}}</p><div ng-switch=\"alert.type\" class=\"centrar alert-card-info-interval\"><div class=\"centrar centrar-flex-flow\"><p>Intervalo:</p><p><span>{{alert.interval.min}}</span> - <span>{{alert.interval.max}}</span> <span ng-switch-when=\"temp\">C</span><span ng-switch-when=\"losses\">%</span><span ng-switch-when=\"consumption\">KWH</span></p></div></div></div></div><div class=\"centrar alert-card-actions\"><div class=\"centrar cursor\" ng-click=\"activeAlert(alert)\"><div class=\"centrar centrar-c alert-card-status\"><span ng-class=\"{\'alert-card-status-on ion-toggle-filled\': alert.status == true, \'alert-card-status-off ion-toggle\': alert.status == false }\"></span></div></div><div class=\"dropdown\"><div class=\"dropdown-toggle alert-card-btn-options cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-c\"></span></div><ul class=\"dropdown-menu alert-card-options\"><li class=\"cursor\" ng-click=\"editAlert(alert)\">Editar</li><li class=\"cursor\" ng-click=\"deleteAlert(alert)\">Borrar</li></ul></div></div></div><div class=\"centrar centrar-justificar-final width-100p alert-card-arrow cursor\"><i ng-click=\"showNotifications(alert)\" ng-class=\"{\'ion-chevron-up\': status.open, \'ion-chevron-down\': !status.open}\"></i></div></div><div class=\"alert-card-body\" ng-if=\"status.open\"><div class=\"centrar notification-title\">Notificaciones</div><div class=\"cont-notificacion centrar cursor\" ng-repeat=\"notification in alert.notifications.slice(((currentPage-1)*itemsPerPage), ((currentPage)*itemsPerPage))\" ui-sref=\"estadisticas_zona({nombre: notification.nombre, id_zona:notification.device.id_zona, id_device:notification.device.id, date: notification.date, time: notification.time})\"><div data-label=\"Dispositivo\">{{notification.device.nombre}}</div><div data-label=\"Fecha\">{{notification.date | date : format : timezone}}</div><div data-label=\"Hora\">{{notification.time}}</div></div><div class=\"centrar centrar-c\" ng-show=\"alert.notifications.length > 0\"><ul uib-pagination=\"\" total-items=\"alert.notifications.length\" ng-model=\"currentPage\" max-size=\"5\" class=\"pagination-sm\" boundary-link-numbers=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" items-per-page=\"itemsPerPage\"></ul></div><div class=\"centrar margin-20\" ng-hide=\"alert.notifications.length > 0\"><p class=\"\">No hay notificaciones para mostrar</p></div></div></div>");
$templateCache.put("app/cliente/alerts/new-alert/new-alert.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" id=\"no_devices_message\" style=\"display: none;\"><div class=\"centrar centrar-justificar-inicio no-devices-message\"><div class=\"centrar centra-c\"><i class=\"ion-close-circled\"></i></div><p>No puedes crear una alerta porque no tienes ningun dispositivo Helo. Volver al <a ui-sref=\"dashboard_cliente\"><strong class=\"cursor\">Inicio.</strong></a></p></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"{{editMode ? \'Editar alerta de \' : \'Nueva alerta de \'}}{{alertType.name}}\" ba-panel-class=\"\"><div class=\"centrar centrar-columna centrar-align-start new-alert-form\"><p>Los campos marcados con * son obligatorios</p><form name=\"newAlertForm\" class=\"centrar centrar-columna centrar-align-start width-100p\"><label style=\"font-weight:500\" for=\"zones\">ZONA*</label> <input type=\"text\" name=\"\" ng-value=\"zone.name\" id=\"\" disabled=\"true\"><h4 class=\"margin-top\">ESTABLECER OBSERVACIÓN</h4><div ng-if=\"alertType.name === \'Potencia\'\" class=\"centrar centrar-justificar-inicio info-message width-100p\"><div class=\"centrar centra-c\"><i class=\"ion-information-circled\"></i></div><p>Los valores de los intervalos de potencia se deben tomar con base en la carga que se está midiendo. Estos valores están en Watts</p></div><div class=\"centrar centrar-justificar-inicio centrar-flex-flow margin-top-10 width-100p\"><input ng-model=\"newAlert.comparacion\" ng-change=\"setComparisonInterval(newAlert.comparacion)\" type=\"checkbox\"><p style=\"margin: 10px;\" class=\"\">Activar comparación con otro sensor</p></div><div ng-if=\"alertType.min_name === \'Open\' || alertType.min_name === \'presence\'\" class=\"centrar centrar-columna centrar-align-start width-100p\"><label for=\"open\">Indicador*</label><select ng-model=\"open\" ng-options=\"i.value as i.text for i in openSegments\" id=\"open\" name=\"open\" ng-change=\"setOpening(open)\" required=\"\"></select></div><div ng-if=\"alertType.min_name !== \'Open\' && alertType.min_name !== \'Offline\' && alertType.min_name !== \'presence\'\"><h5 class=\"margin-top\">INTERVALO</h5></div><div ng-if=\"alertType.min_name !== \'Open\' && alertType.min_name !== \'Offline\' && alertType.min_name !== \'presence\'\" class=\"centrar centrar-flex-flow\" ng-init=\"editMode ? newAlert.interval.type : newAlert.interval.type = 0\"><div ng-if=\"!newAlert.comparacion\" class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Rango</label> <input type=\"radio\" name=\"interval\" ng-model=\"newAlert.interval.type\" value=\"0\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Mayor que</label> <input type=\"radio\" ng-model=\"newAlert.interval.type\" value=\"1\" name=\"interval\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Menor que</label> <input type=\"radio\" ng-model=\"newAlert.interval.type\" value=\"2\" name=\"interval\"></div></div><div ng-if=\"alertType.min_name !== \'Open\' && alertType.min_name !== \'Offline\' && alertType.min_name !== \'presence\'\" class=\"centrar width-100p\"><div class=\"centrar centrar-columna centrar-align-start width-45p\" ng-if=\"newAlert.interval.type == 0 || newAlert.interval.type == 2\"><label for=\"min\">{{newAlert.comparacion ? \'Valor de diferencia en\' : \'Min\'}} {{unit}}</label> <input type=\"number\" name=\"min\" ng-model=\"newAlert.interval.min\" required=\"\" min=\"\" ng-class=\"{\'input-invalid\': newAlertForm.min.$touched && newAlertForm.min.$invalid}\"> <small class=\"ind-requerido\" ng-show=\"newAlert.interval.type == 0 && (newAlert.interval.min > newAlert.interval.max)\">Debes ingresar un número menor al ingresado en el campo Max</small></div><div class=\"centrar centrar-columna centrar-align-start width-45p\" ng-if=\"newAlert.interval.type == 0 || newAlert.interval.type == 1\"><label for=\"max\">{{newAlert.comparacion ? \'Valor de diferencia en\' : \'Max\'}} {{unit}}</label> <input type=\"number\" name=\"max\" ng-model=\"newAlert.interval.max\" required=\"\" min=\"\" ng-class=\"{\'input-invalid\': newAlertForm.max.$touched && newAlertForm.max.$invalid}\"> <small ng-show=\"newAlert.interval.type == 0 && (newAlert.interval.max < newAlert.interval.min)\" class=\"ind-requerido\">El número debe ser mayor al ingresado en el campo Min</small></div></div><label for=\"segments\">Tiempo de espera*</label><select ng-model=\"newAlert.standBy\" ng-options=\"i.value as i.text for i in standBySegments\" id=\"segments\" name=\"standBy\" ng-class=\"{\'input-invalid\': newAlertForm.standBy.$touched && newAlertForm.standBy.$invalid}\" required=\"\"></select><label for=\"repeatAlert\">Repetir alerta cada*</label><select ng-model=\"newAlert.repeatAlert\" ng-options=\"i.value as i.text for i in repeatAlertSegments\" id=\"repeatAlert\" name=\"repeatAlert\" ng-class=\"{\'input-invalid\': newAlertForm.repeatAlert.$touched && newAlertForm.repeatAlert.$invalid}\" required=\"\"></select><div class=\"cont-devices width-100p\"><div class=\"centrar cont-add-alert\" ng-click=\"addDevices()\"><p class=\"btn-add-schedule-zone centrar centrar-c cursor\"><span class=\"ion-plus-round\"></span></p><h4>AGREGAR MONITOREOS*</h4></div><div class=\"panel panel-default\" ng-repeat=\"alert in alertsDetails track by $index\"><div class=\"centrar panel-heading centrar-espaciado-entre\"><p class=\"margin-0 cursor\" ng-click=\"openAccordion($index)\">{{alert.name}}</p><div class=\"centrar\"><i class=\"ion-edit cursor\" ng-click=\"addDevices(alert, true, $index)\"></i> <i class=\"ion-trash-a cursor\" ng-click=\"deleteAlert($index)\"></i> <i class=\"cursor\" ng-class=\"{\'ion-chevron-up\': status.open, \'ion-chevron-down\': !status.open}\" ng-click=\"openAccordion($index)\"></i></div></div><div ng-if=\"alert.open\" class=\"alert-detail panel-body\"><p class=\"name\">Nombre de la alerta</p><h4>{{alert.name}}</h4><p class=\"margin-0\">Dispositivos a monitorear</p><div class=\"centrar centrar-justificar-inicio margin-bottom-10\"><p class=\"ind-filter\">{{alert.selectedDevices.nombre | limitTo: 35}}{{alert.selectedDevices.nombre.length > 35 ? \'...\': \' \'}}</p></div><p class=\"margin-0\" ng-if=\"alert.id_comparison\">Dispositivo a comparar</p><div ng-if=\"alert.id_comparison\" class=\"centrar centrar-justificar-inicio margin-bottom-10\"><p class=\"ind-filter\">{{alert.name_comparison | limitTo: 35}}{{alert.name_comparison.length > 35 ? \'...\': \' \'}}</p></div><p class=\"margin-0\">Correos interesados</p><div class=\"centrar centrar-justificar-inicio centrar-flex-flow margin-bottom-10\"><p class=\"ind-filter\" ng-repeat=\"email in alert.interestedUsers\">{{email | limitTo: 35}}{{email.length > 35 ? \'...\': \' \'}}</p></div></div></div></div><div class=\"cont-options width-100p\"><p class=\"cursor\" ng-click=\"showOptions()\"><strong><span ng-class=\"{\'ion-chevron-up\': options.open, \'ion-chevron-down\': !options.open}\"></span> Configuración adicional (opcional)</strong></p><div class=\"centrar centrar-columna centrar-align-start\" ng-show=\"options.open\"><h4 class=\"margin-top\">INTERMITENCIA</h4><div class=\"centrar\"><label class=\"without-margin\" for=\"intermittence\">No</label> <input type=\"radio\" name=\"intermittence\" ng-model=\"intermittence\" value=\"0\"> <label class=\"without-margin\" for=\"intermittence\">Sí</label> <input type=\"radio\" ng-model=\"intermittence\" value=\"1\" name=\"intermittence\"></div><div ng-if=\"intermittence == 1\" class=\"width-100p\"><label for=\"observation\">Días de observación</label><select ng-model=\"newAlert.observation.type\" ng-options=\"i.value as i.text for i in observation\" id=\"observation\" name=\"observation\" ng-class=\"{\'input-invalid\': newAlertForm.observation.$touched && newAlertForm.observation.$invalid}\" ng-change=\"setObservationDays(newAlert.observation.type, intermittenceDays)\"></select><div class=\"cont-custom-days\" ng-if=\"newAlert.observation.type === \'custom\' || newAlert.observation.type === \'no_holidays\'\"><h5>Selecciona los días a monitorear</h5><div class=\"centrar centrar-flex-flow centrar-justificar-inicio\"><div class=\"centrar centrar-justificar-inicio margin-top-10\"><p class=\"margin-0\">Lunes</p><input style=\"margin: 0 20px 0 5px;\" ng-model=\"intermittenceDays[1]\" type=\"checkbox\" ng-change=\"setObservationDays(newAlert.observation.type, intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-top-10\"><p class=\"margin-0\">Martes</p><input style=\"margin: 0 20px 0 5px;\" ng-model=\"intermittenceDays[2]\" type=\"checkbox\" ng-change=\"setObservationDays(newAlert.observation.type, intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-top-10\"><p class=\"margin-0\">Miércoles</p><input style=\"margin: 0 20px 0 5px;\" ng-model=\"intermittenceDays[3]\" type=\"checkbox\" ng-change=\"setObservationDays(newAlert.observation.type, intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-top-10\"><p class=\"margin-0\">Jueves</p><input style=\"margin: 0 20px 0 5px;\" ng-model=\"intermittenceDays[4]\" type=\"checkbox\" ng-change=\"setObservationDays(newAlert.observation.type, intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-top-10\"><p class=\"margin-0\">Viernes</p><input style=\"margin: 0 20px 0 5px;\" ng-model=\"intermittenceDays[5]\" type=\"checkbox\" ng-change=\"setObservationDays(newAlert.observation.type, intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-top-10\"><p class=\"margin-0\">Sábado</p><input style=\"margin: 0 20px 0 5px;\" ng-model=\"intermittenceDays[6]\" type=\"checkbox\" ng-change=\"setObservationDays(newAlert.observation.type, intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-top-10\"><p class=\"margin-0\">Domingo</p><input style=\"margin: 0 20px 0 5px;\" ng-model=\"intermittenceDays[0]\" type=\"checkbox\" ng-change=\"setObservationDays(newAlert.observation.type, intermittenceDays)\"></div></div></div><div ng-if=\"newAlert.observation.type === \'holidays\'\" class=\"centrar centrar-columna centrar-align-start cont-holidays width-100p\"><div class=\"centrar width-100p margin-top\" ng-init=\"select_all = true\"><p class=\"width-100p\">Lista de feriados disponibles</p><div class=\"centrar centrar-justificar-final width-100p\"><p>Seleccionar todo</p><input style=\"margin: 0 0 0 20px;\" type=\"checkbox\" ng-model=\"select_all\" ng-change=\"selectAll(select_all)\"></div></div><div class=\"centrar centrar-flex-flow centrar-justificar-inicio margin-top margin-bottom-20\"><div ng-repeat=\"holiday in holidays track by $index\" class=\"centrar centrar-justificar-inicio holiday\"><input style=\"margin-right: 10px;\" ng-model=\"holiday.status\" type=\"checkbox\"><p>{{holiday.day | date : \'dd/MM/yyyy\'}}</p></div></div></div><div class=\"centrar width-100p\"><div class=\"centrar centrar-columna centrar-align-start width-45p\"><label for=\"h_ini\">Hora inicial</label> <input type=\"time\" name=\"h_ini\" ng-model=\"newAlert.observation.h_ini\" ng-class=\"\"> <small class=\"ind-requerido\" ng-show=\"\">Debes ingresar una hora menor al ingresado en hora final</small></div><div class=\"centrar centrar-columna centrar-align-start width-45p\"><label for=\"max\">Hora final</label> <input type=\"time\" name=\"h_fin\" ng-model=\"newAlert.observation.h_fin\" min=\"{{newAlert.observation.h_ini}}\" ng-class=\"\"> <small ng-show=\"\" class=\"ind-requerido\">La hora final debe ser mayor al inicial</small></div></div></div><h4 class=\"margin-top\">FUNCIÓN DE CONTROL</h4><div class=\"width-100p\"><p class=\"info-message\" ng-if=\"newAlert.alerts.length === 0\">Debes agregar primero una alerta para usar esta función.</p><p class=\"info-message\" ng-if=\"devicesControl.length === 0 && newAlert.alerts.length > 0\">No tienes ningún dispositivo de control en esta zona</p><uib-accordion ng-if=\"devicesControl.length > 0\" ng-repeat=\"alert in newAlert.alerts track by $index\"><uib-accordion-group class=\"panel-default\" is-open=\"status.open\"><uib-accordion-heading><div class=\"centrar centrar-espaciado-entre\"><p class=\"margin-0\">PARA {{alert.name}}</p><i ng-class=\"{\'ion-chevron-up\': status.open, \'ion-chevron-down\': !status.open}\"></i></div></uib-accordion-heading><div class=\"centrar centrar-columna centrar-align-start width-100p\" ng-init=\"controlFunction[$index][\'alert_name\'] = alert.name\"><label>Agregar dispositivo de control</label><select ng-model=\"id_dispositivo\" ng-options=\"i.id as i.nombre for i in devicesControl\" ng-init=\"controlFunction[$index][\'segments\'] = true\" name=\"setPoints\" ng-class=\"{\'input-invalid\': newAlertForm.standBy.$touched && newAlertForm.standBy.$invalid}\" ng-change=\"selectSetPoint(id_dispositivo, $index)\"></select><small ng-if=\"controlFunction[$index].deviceControlError\">Ya estás usando este dispositivo de control, debes elegir uno diferente</small> <label>Acción a ejecutar</label><select ng-model=\"controlFunction[$index][\'set_point\']\" ng-options=\"i.id as i.nombre for i in setPointsSegmentsControl\" name=\"setPoints\" ng-class=\"{\'input-invalid\': newAlertForm.standBy.$touched && newAlertForm.standBy.$invalid}\" ng-change=\"show()\"></select></div></uib-accordion-group></uib-accordion><div class=\"centrar centrar-justificar-inicio margin-top-10\"><p style=\"margin: 10px;\" class=\"\">Habilitar envío de correos</p><input ng-model=\"newAlert.email\" type=\"checkbox\"></div><div class=\"centrar centrar-justificar-inicio margin-top-10\"><p style=\"margin: 10px;\" class=\"\">Activar el control cuando el equipo esté apagado</p><input ng-model=\"newAlert.control_en_off\" type=\"checkbox\"></div></div></div></div></form><div class=\"centrar centrar-c\"><button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cancelar()\">Cancelar</button> <button type=\"button\" class=\"margin-10\" ng-disabled=\"!newAlertForm.$valid || newAlert.alerts.length === 0 || deviceControlError\" ng-click=\"addAlert(newAlert)\">{{editMode ? \'Editar\' : \'Crear\'}}</button></div></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/alerts/no-alerts/no-alerts.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"no-factura\"><div class=\"centrar centrar-columna centrar-align-start no-factura-info\"><h3>¡Que nunca se te escape nada con nuestro módulo de Alertas!</h3><p>Monitorea tus procesos y genera notificaciones personalizadas para cada una de tus variables significativas.</p><div class=\"dropdown filter-menu\"><div class=\"btn-add-alert centrar centrar-c cursor dropdown-toggle\" data-toggle=\"dropdown\"><p><span class=\"ion-plus-round\"></span> Nueva Alerta</p></div><ul class=\"dropdown-menu\"><li ng-repeat=\"item in listaAlertas\" ng-if=\"item.show\" class=\"cursor\" ng-click=\"newAlert(item)\">{{item.name | limitTo: 20}}{{item.name.length > 20 ? \'...\': \' \'}}</li></ul></div></div><div class=\"centrar no-factura-img\"><img src=\"../../../assets/img/no_alerts.svg\" alt=\"\"></div></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/alerts/offline-alert/offline-alert.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn proceso-facturacion-seleccion\"><div class=\"panel-heading centrar centrar-columna\"><h3 class=\"margin-0\">ALERTA DE {{alertType.min_name === \'Open\' ? \'APERTURA Y CIERRE\' : alertType.min_name === \'limit\' ? \'LÍMITE INFERIOR\' : alertType.min_name === \'Comm\' ? \'COMUNICACIÓN\' : alertType.min_name === \'Error\' ? \'ERROR DMS\' : \'DESCONEXIÓN\'}} PARA <span style=\"text-transform: uppercase;\">{{zona.nombre}}</span></h3></div><div class=\"centrar centrar-align-start centrar-columna centrar-justificar-inicio panel-body\"><form name=\"newAlertForm\" class=\"centrar centrar-columna centrar-align-start width-100p new-alert-form margin-bottom-20\"><div ng-if=\"alertType.min_name === \'Offline\'\" class=\"centrar centrar-columna centrar-align-start width-100p\"><label for=\"segments\">Nombre alerta</label> <input type=\"text\" ng-model=\"newAlert.name\" id=\"name\" name=\"name\" required=\"\"></div><div ng-if=\"alertType.min_name === \'Open\'\" class=\"centrar centrar-columna centrar-align-start width-100p\"><label for=\"open\">Indicador*</label><select ng-model=\"open\" ng-options=\"i.value as i.text for i in openSegments\" id=\"open\" name=\"open\" ng-change=\"setOpening(open)\" required=\"\"></select></div><div ng-if=\"alertType.min_name === \'limit\'\" class=\"centrar centrar-columna centrar-align-start width-100p\"><label for=\"open\">Límite Inferior*</label><select ng-model=\"newAlert.limit\" ng-options=\"i.id as i.nombre for i in setPointsSegmentsControl\" id=\"limit\" name=\"limit\" required=\"\"></select></div><div ng-if=\"alertType.min_name === \'Comm\'\" class=\"centrar centrar-columna centrar-align-start width-100p\"><label for=\"comunicacion\">Estado a monitorear*</label><select ng-model=\"newAlert.comunicacionEstado\" ng-options=\"i.value as i.text for i in comunicacionSegments\" id=\"comunicacion\" name=\"comunicacion\" required=\"\"></select></div><div ng-if=\"alertType.min_name !== \'limit\'\" class=\"centrar centrar-columna centrar-align-start width-100p\"><label for=\"segments\">Tiempo de espera*</label><select ng-model=\"newAlert.standBy\" ng-options=\"i.value as i.text for i in standBySegments\" id=\"segments\" name=\"standBy\" ng-class=\"{\'input-invalid\': newAlertForm.standBy.$touched && newAlertForm.standBy.$invalid}\" required=\"\"></select><label for=\"repeatAlert\">Repetir alerta cada*</label><select ng-model=\"newAlert.repeatAlert\" ng-options=\"i.value as i.text for i in repeatAlertSegments\" id=\"repeatAlert\" name=\"repeatAlert\" ng-class=\"{\'input-invalid\': newAlertForm.repeatAlert.$touched && newAlertForm.repeatAlert.$invalid}\" required=\"\"></select><label>Correos para notificar* (Enter para agregar)</label><selected-field ng-model=\"newAlert.interestedUsers\" lista=\"[]\" class=\"width-100p\"></selected-field><small ng-if=\"newAlert.interestedUsers.$touched && newAlert.interestedUsers.$invalid\">Debes ingresar al menos un correo electrónico</small></div></form><div class=\"centrar centrar-columna width-100p margin-bottom-10\"><h4>Selecciona las dispositivos que desea {{alertType.min_name === \'Open\' || alertType.min_name === \'Offline\' ? \'monitorear\' : \'configurar\'}}</h4><div class=\"centrar centrar-columna width-100p\"><div class=\"centrar centrar-justificar-inicio width-100p panel-selected\"><div class=\"has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"search\"> <i class=\"ion-search form-control-feedback\"></i></div><div class=\"centrar\" style=\"margin-left: 20px;\"><p class=\"margin-0\">Seleccionar todo</p><input style=\"margin: 0 0 0 20px;\" type=\"checkbox\" ng-model=\"select_all\" ng-change=\"selectAll(select_all)\"></div></div><div class=\"centrar centrar-columna centrar-justificar-inicio width-100p cont-select\"><div ng-repeat=\"itm in filtered track by $index\" class=\"centrar width-100p itm-select\"><p>{{itm.nombre}}</p><input ng-model=\"itm.status\" ng-disabled=\"edit_mode && alertType.min_name === \'limit\'\" ng-change=\"validateList()\" type=\"checkbox\"></div><p class=\"padding-modal\" ng-if=\"noInfo\">No tienes dispositivos para realizar este monitoreo</p><loading-content ng-if=\"loading\" style=\"position: absolute; width: 100%; min-height: 330px;\" loading=\"loading\"></loading-content></div></div></div><div ng-if=\"alertType.min_name === \'Open\'\" class=\"width-100p margin-top-20\"><h4 class=\"margin-top\">FUNCIÓN DE CONTROL</h4><div class=\"width-100p\"><p class=\"info-message\" ng-if=\"devicesControl.length === 0\">No tienes ningún dispositivo de control en esta zona</p><uib-accordion ng-if=\"devicesControl.length > 0\"><uib-accordion-group class=\"panel-default\" is-open=\"status.open\"><uib-accordion-heading><div class=\"centrar centrar-espaciado-entre\"><p class=\"margin-0\">PARA ALERTA</p><i ng-class=\"{\'ion-chevron-up\': status.open, \'ion-chevron-down\': !status.open}\"></i></div></uib-accordion-heading><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label>Agregar dispositivo de control</label><select ng-model=\"id_dispositivo\" ng-options=\"i.id as i.nombre for i in devicesControl\" name=\"setPoints\" class=\"form-control input-sm\" ng-class=\"{\'input-invalid\': newAlertForm.standBy.$touched && newAlertForm.standBy.$invalid}\" ng-change=\"selectSetPoint(id_dispositivo, 0)\"></select><label class=\"margin-top-10\">Acción a ejecutar</label><select ng-model=\"controlFunction[0].set_point\" ng-options=\"i.id as i.nombre for i in setPointsSegmentsControl\" name=\"action\" class=\"form-control input-sm\" ng-class=\"{\'input-invalid\': newAlertForm.standBy.$touched && newAlertForm.standBy.$invalid}\"></select></div></uib-accordion-group></uib-accordion></div></div></div><div class=\"centrar centrar-justificar-final\"><button class=\"button-info\" ng-click=\"back()\">Cancelar</button> <button class=\"button-confirm margin-20\" ng-disabled=\"!validatedList || !newAlertForm.$valid || newAlert.interestedUsers.length === 0 || loading\" ng-click=\"crear(newAlert)\">{{edit_mode ? \'Editar\' : \'Crear\'}}</button></div></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/alerts/quick-edit/quick-edit.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn proceso-facturacion-seleccion\"><div class=\"panel-heading centrar centrar-columna\"><h3 class=\"margin-0\">EDICIÓN CONJUNTA</h3></div><div class=\"centrar centrar-align-start centrar-columna centrar-justificar-inicio panel-body\"><div class=\"centrar centrar-justificar-inicio info-message width-100p\"><div class=\"centrar centra-c\"><i class=\"ion-information-circled\"></i></div><p style=\"margin-left: 20px;\">Este formulario cambia de forma masiva los parametros de las alertas independientemente del tipo. No es necesario llenar todos los campos, solo los que se desean cambiar.</p></div><form name=\"newAlertForm\" class=\"width-100p\"><uib-tabset class=\"width-100p new-alert-form margin-bottom-20\"><uib-tab index=\"1\" class=\"centrar centrar-columna centrar-align-start\" heading=\"Operación\"><h5 class=\"margin-top\">INTERVALO</h5><div class=\"centrar centrar-flex-flow centrar-justificar-inicio\"><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Rango</label> <input type=\"radio\" name=\"interval\" ng-model=\"newAlert.interval.type\" value=\"0\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Mayor que</label> <input type=\"radio\" ng-model=\"newAlert.interval.type\" value=\"1\" name=\"interval\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Menor que</label> <input type=\"radio\" ng-model=\"newAlert.interval.type\" value=\"2\" name=\"interval\"></div></div><div class=\"centrar width-100p\"><div class=\"centrar centrar-columna centrar-align-start width-45p\" ng-if=\"newAlert.interval.type == 0 || newAlert.interval.type == 2\"><label for=\"min\">Min</label> <input re=\"\" type=\"number\" name=\"min\" ng-model=\"newAlert.interval.min\" min=\"\" ng-class=\"{\'input-invalid\': newAlertForm.min.$touched && newAlertForm.min.$invalid}\" ng-change=\"validarSetPoint(newAlert.interval.min, newAlert.interval.max)\"> <small class=\"ind-requerido\" ng-show=\"newAlert.interval.type == 0 && (newAlert.interval.min > newAlert.interval.max)\">Debes ingresar un número menor al ingresado en el campo Max</small></div><div class=\"centrar centrar-columna centrar-align-start width-45p\" ng-if=\"newAlert.interval.type == 0 || newAlert.interval.type == 1\"><label for=\"max\">Max</label> <input type=\"number\" name=\"max\" ng-model=\"newAlert.interval.max\" min=\"\" ng-class=\"{\'input-invalid\': newAlertForm.max.$touched && newAlertForm.max.$invalid}\" ng-change=\"validarSetPoint(newAlert.interval.min, newAlert.interval.max)\"> <small ng-show=\"newAlert.interval.type == 0 && (newAlert.interval.max < newAlert.interval.min)\" class=\"ind-requerido\">El número debe ser mayor al ingresado en el campo Min</small></div></div></uib-tab><uib-tab index=\"2\" class=\"centrar centrar-columna centrar-align-start\" heading=\"Monitoreo\"><label for=\"segments\">Tiempo de espera</label><select ng-model=\"newAlert.standBy\" ng-options=\"i.value as i.text for i in standBySegments\" id=\"segments\" name=\"standBy\" ng-class=\"{\'input-invalid\': newAlertForm.standBy.$touched && newAlertForm.standBy.$invalid}\"></select><label for=\"repeatAlert\">Repetir alerta cada</label><select ng-model=\"newAlert.repeatAlert\" ng-options=\"i.value as i.text for i in repeatAlertSegments\" id=\"repeatAlert\" name=\"repeatAlert\" ng-class=\"{\'input-invalid\': newAlertForm.repeatAlert.$touched && newAlertForm.repeatAlert.$invalid}\"></select></uib-tab><uib-tab index=\"3\" class=\"centrar centrar-columna centrar-align-start\" heading=\"Correos\"><label><strong>Agregar</strong> a lista de correos a notificar (Enter para agregar)</label><selected-field ng-model=\"newAlert.interestedUsers\" lista=\"[]\" class=\"width-100p mail-selected\"></selected-field><label><strong>Retirar</strong> de lista de correos a notificar (Enter para agregar)</label><selected-field ng-model=\"newAlert.removeUsers\" lista=\"[]\" class=\"width-100p mail-selected\"></selected-field><label><strong>Envío de correos</strong></label><div class=\"centrar centrar-flex-flow centrar-justificar-inicio\"><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">No cambiar</label> <input type=\"radio\" ng-model=\"newAlert.email\" value=\"2\" name=\"email\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"email\">Desactivar</label> <input type=\"radio\" name=\"email\" ng-model=\"newAlert.email\" value=\"0\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"email\">Activar</label> <input type=\"radio\" ng-model=\"newAlert.email\" value=\"1\" name=\"email\"></div></div></uib-tab><uib-tab index=\"4\" heading=\"Apertura y cierre\"><div class=\"centrar centrar-columna centrar-align-start width-100p\"><p><strong>Importante:</strong> Esta opción es restrictiva. No se puede editar al mismo tiempo la apertura y cierre y las opciones de opertación. Solo una la vez.</p><label for=\"open\">Indicador</label><select ng-model=\"newAlert.open\" ng-options=\"i.value as i.text for i in openSegments\" id=\"open\" name=\"open\" ng-change=\"setOpening(newAlert.open)\"></select></div></uib-tab><uib-tab index=\"5\" heading=\"Intermitencia\"><label for=\"observation\">Días de observación</label><select ng-model=\"newAlert.observation.type\" ng-options=\"i.value as i.text for i in observation\" id=\"observation\" name=\"observation\" ng-class=\"{\'input-invalid\': newAlertForm.observation.$touched && newAlertForm.observation.$invalid}\" ng-change=\"setObservationDays(newAlert.observation.type, intermittenceDays)\"></select><div class=\"cont-custom-days\" ng-if=\"newAlert.observation.type === \'custom\'\"><h5>Selecciona los días a monitorear</h5><div class=\"centrar centrar-flex-flow centrar-justificar-inicio\"><div class=\"centrar centrar-justificar-inicio margin-10\"><p class=\"margin-0\">Lun</p><input style=\"margin-left: 5px;\" ng-model=\"intermittenceDays[1]\" type=\"checkbox\" ng-change=\"setObservationDays(\'custom\', intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-10\"><p class=\"margin-0\">Mar</p><input style=\"margin-left: 5px;\" ng-model=\"intermittenceDays[2]\" type=\"checkbox\" ng-change=\"setObservationDays(\'custom\', intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-10\"><p class=\"margin-0\">Mié</p><input style=\"margin-left: 5px;\" ng-model=\"intermittenceDays[3]\" type=\"checkbox\" ng-change=\"setObservationDays(\'custom\', intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-10\"><p class=\"margin-0\">Jue</p><input style=\"margin-left: 5px;\" ng-model=\"intermittenceDays[4]\" type=\"checkbox\" ng-change=\"setObservationDays(\'custom\', intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-10\"><p class=\"margin-0\">Vie</p><input style=\"margin-left: 5px;\" ng-model=\"intermittenceDays[5]\" type=\"checkbox\" ng-change=\"setObservationDays(\'custom\', intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-10\"><p class=\"margin-0\">Sáb</p><input style=\"margin-left: 5px;\" ng-model=\"intermittenceDays[6]\" type=\"checkbox\" ng-change=\"setObservationDays(\'custom\', intermittenceDays)\"></div><div class=\"centrar centrar-justificar-inicio margin-10\"><p class=\"margin-0\">Dom</p><input style=\"margin-left: 5px;\" ng-model=\"intermittenceDays[0]\" type=\"checkbox\" ng-change=\"setObservationDays(\'custom\', intermittenceDays)\"></div></div></div><div class=\"centrar width-100p\"><div class=\"centrar centrar-columna centrar-align-start width-45p\"><label for=\"h_ini\">Hora inicial</label> <input type=\"time\" name=\"h_ini\" ng-model=\"newAlert.observation.h_ini\" ng-class=\"\"> <small class=\"ind-requerido\" ng-show=\"\">Debes ingresar una hora menor al ingresado en hora final</small></div><div class=\"centrar centrar-columna centrar-align-start width-45p\"><label for=\"max\">Hora final</label> <input type=\"time\" name=\"h_fin\" ng-model=\"newAlert.observation.h_fin\" min=\"{{newAlert.observation.h_ini}}\" ng-class=\"\"> <small ng-show=\"\" class=\"ind-requerido\">La hora final debe ser mayor al inicial</small></div></div></uib-tab><uib-tab index=\"6\" heading=\"Estado\"><div class=\"centrar centrar-flex-flow centrar-justificar-inicio\" ng-init=\"newAlert.status = 3\"><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">No cambiar</label> <input type=\"radio\" ng-model=\"newAlert.status\" value=\"3\" name=\"status\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Desactivar</label> <input type=\"radio\" name=\"status\" ng-model=\"newAlert.status\" value=\"0\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Activar</label> <input type=\"radio\" ng-model=\"newAlert.status\" value=\"1\" name=\"status\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Borrar</label> <input type=\"radio\" ng-model=\"newAlert.status\" value=\"2\" name=\"status\"></div></div></uib-tab><uib-tab index=\"7\" class=\"centrar centrar-columna centrar-align-start\" heading=\"Control\"><h4 class=\"margin-top\">Tipo de control</h4><div class=\"centrar centrar-flex-flow centrar-justificar-inicio\"><div class=\"centrar\"><label class=\"without-margin\" for=\"control_type\">Ninguno</label> <input type=\"radio\" name=\"control_type\" ng-model=\"newAlert.control_type\" value=\"0\" ng-change=\"changeSetPointControl(newAlert.control_type)\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"control_type\">On/off</label> <input type=\"radio\" name=\"control_type\" ng-model=\"newAlert.control_type\" value=\"1\" ng-change=\"changeSetPointControl(newAlert.control_type)\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"control_type\">Aire acondicionando</label> <input type=\"radio\" ng-model=\"newAlert.control_type\" value=\"2\" name=\"control_type\" ng-change=\"changeSetPointControl(newAlert.control_type)\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"control_type\">Cortina de viento</label> <input type=\"radio\" ng-model=\"newAlert.control_type\" value=\"3\" name=\"control_type\" ng-change=\"changeSetPointControl(newAlert.control_type)\"></div></div><div ng-if=\"setPoint_controls.length > 0\"><label for=\"segments\">Acción de control</label><select ng-model=\"newAlert.setPoint_control\" ng-options=\"i.id as i.nombre for i in setPoint_controls\" id=\"setPoint_control\" name=\"setPoint_control\" ng-class=\"{\'input-invalid\': newAlertForm.setPoint_control.$touched && newAlertForm.setPoint_control.$invalid}\"></select></div><h4 class=\"margin-top\">Control cuando el equipo está apagado</h4><div class=\"centrar centrar-flex-flow centrar-justificar-inicio\"><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">No cambiar</label> <input type=\"radio\" ng-model=\"newAlert.control_en_off\" value=\"2\" name=\"control_en_off\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"email\">Desactivar</label> <input type=\"radio\" name=\"control_en_off\" ng-model=\"newAlert.control_en_off\" value=\"0\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"email\">Activar</label> <input type=\"radio\" ng-model=\"newAlert.control_en_off\" value=\"1\" name=\"control_en_off\"></div></div></uib-tab><uib-tab index=\"8\" class=\"centrar centrar-columna centrar-align-start\" heading=\"Nombre\"><div class=\"centrar centrar-columna centrar-align-start\"><label class=\"without-margin\" for=\"sufijo\">Agregar indicador al final del nombre</label> <input type=\"text\" ng-model=\"newAlert.sufijo\" name=\"sufijo\"></div></uib-tab></uib-tabset></form><div class=\"centrar centrar-columna width-100p\"><h4>Selecciona las alertas a editar</h4><div class=\"centrar centrar-columna width-100p\"><div class=\"centrar centrar-justificar-inicio width-100p panel-selected\"><div class=\"has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"search\"> <i class=\"ion-search form-control-feedback\"></i></div><selected-filter style=\"margin-left: 20px;\" nombre=\"select_ind\" lista=\"listaOrden\" selected=\"selectAll\"></selected-filter></div><div class=\"centrar centrar-columna centrar-justificar-inicio width-100p cont-select\"><div ng-repeat=\"itm in filtered track by $index\" class=\"centrar width-100p itm-select\"><p>{{itm.nombre}} {{itm.min_with_offset ? \'| min: \' + itm.min_with_offset : \'\'}} {{itm.max_with_offset ? \'| max: \' + itm.max_with_offset : \'\'}}</p><input ng-model=\"itm.status\" ng-change=\"validateList()\" type=\"checkbox\"></div><p class=\"padding-modal\" ng-if=\"noInfo\">No tienes ninguna alerta</p><loading-content ng-if=\"loading\" style=\"position: absolute; width: 100%; min-height: 330px;\" loading=\"loading\"></loading-content></div></div></div></div><div class=\"centrar centrar-justificar-final\"><button class=\"button-info\" ng-click=\"back()\">Cancelar</button> <button class=\"button-confirm margin-20\" ng-disabled=\"!newAlertForm.$valid || !validatedList || loading\" ng-click=\"duplicar(newAlert)\">Duplicar</button> <button class=\"button-confirm\" style=\"margin: 20px 20px 20px 0;\" ng-disabled=\"!newAlertForm.$valid || !validatedList || loading\" ng-click=\"editar(newAlert)\">Editar</button></div></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/alerts/templates/agregarDispositivosAlertas.html","<div class=\"modal-message modal-success new-alert-form\"><div class=\"modal-title\">AGREGAR MONITOREO</div><div class=\"centrar centrar-justificar-inicio no-devices-message\" ng-if=\"interestDevices.length === 0 || addDevice.selectedDevices.length === 0\"><div class=\"centrar centra-c\"><i class=\"ion-close-circled\"></i></div><p>No tienes ningún sensor en esta zona para realizar este tipo de monitoreo</p></div><div class=\"modal-body centrar centrar-columna centrar-align-start\"><form name=\"addDeviceForm\" class=\"centrar centrar-columna centrar-align-start width-100p\"><label for=\"name\">Nombre de la alerta*</label> <input type=\"text\" name=\"name\" ng-model=\"addDevice.name\" required=\"\" ng-class=\"{\'input-invalid\': addDeviceForm.name.$touched && addDeviceForm.name.$invalid }\" ng-change=\"validateName(addDevice.name)\"> <small ng-if=\"(addDeviceForm.name.$touched && addDeviceForm.name.$invalid) || invalidName\">{{invalidName ? \'Te sugerimos usar nombres diferentes para cada alerta\' : \'El nombre es requerido\'}}</small> <label>Dispositivo a monitorear*</label><select ng-model=\"addDevice.id_device\" ng-change=\"set_type(addDevice.id_device)\"><option ng-repeat=\"itm in interestDevices\" value=\"{{itm.id}}\">{{itm.nombre}}</option></select><label ng-if=\"newAlert.comparacion\">Dispositivo a comparar*</label><select ng-if=\"newAlert.comparacion\" ng-model=\"addDevice.id_comparison\"><option ng-repeat=\"itm in interestDevicesComparison\" value=\"{{itm.id}}\">{{itm.nombre}}</option></select><small ng-if=\"addDeviceForm.selectedDevices.$touched && addDeviceForm.selectedDevices.$invalid\">Debes ingresar al menos un dispositivo de la lista</small> <label>Correos para notificar* (Enter para agregar)</label><selected-field ng-model=\"addDevice.interestedUsers\" lista=\"[]\" class=\"width-100p\"></selected-field><small ng-if=\"addDeviceForm.interestedUsers.$touched && addDeviceForm.interestedUsers.$invalid\">Debes ingresar al menos un correo electrónico</small></form></div><div class=\"centrar centrar-c\"><button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cancelar()\">Cancelar</button> <button type=\"button\" class=\"margin-10\" ng-disabled=\"!addDeviceForm.$valid || addDevice.selectedDevices.length === 0 || addDevice.interestedUsers.length === 0\" ng-click=\"aceptar()\">Agregar</button></div></div>");
$templateCache.put("app/cliente/alerts/templates/importAlertasPreview.html","<div class=\"modal-message modal-success\"><div class=\"modal-title\">Revisión de importación</div><div class=\"modal-body centrar centrar-c\"><p class=\"margin-0\">{{importSummary.validCount}} alertas se van a actualizar, {{importSummary.errorCount}} filas con errores serán ignoradas, {{importSummary.unchangedCount}} sin cambios</p></div><div class=\"modal-body centrar centrar-columna centrar-align-start\" ng-if=\"importSummary.valid.length > 0\" style=\"max-height: 260px; overflow-y: auto; width: 100%;\"><div ng-repeat=\"item in importSummary.valid\" style=\"width: 100%; margin-bottom: 10px;\"><p class=\"margin-0\"><strong>{{item.nombre}}</strong> (id {{item.id}})</p><p class=\"margin-0\" ng-repeat=\"change in item.changes\">{{change.label}}: {{change.before}} &rarr; {{change.after}}</p></div></div><div class=\"modal-body centrar centrar-columna centrar-align-start\" ng-if=\"importSummary.errors.length > 0\" style=\"max-height: 200px; overflow-y: auto; width: 100%;\"><p class=\"margin-0\"><strong>Filas con errores</strong></p><div ng-repeat=\"err in importSummary.errors\" style=\"width: 100%;\"><p class=\"margin-0\">Fila {{err.row}} (id {{err.id}}): {{err.messages.join(\', \')}}</p></div></div><div class=\"modal-body centrar centrar-c\"><button type=\"button\" class=\"btn btn-primary margin-10\" ng-disabled=\"importSummary.validCount === 0\" ng-click=\"confirmarImport()\">Confirmar</button> <button type=\"button\" class=\"btn btn-cancel margin-10\" ng-click=\"cancelarImport()\">Cancelar</button></div></div>");
$templateCache.put("app/cliente/consumo_v2/consumo-dispositivo/consumo-dispositivo.html","<bread-crumbs></bread-crumbs><div class=\"row\"><ind-data ind-title=\"\'Máximo\'\" unit=\"unit\"></ind-data><ind-data ind-title=\"\'Mínimo\'\" unit=\"unit\"></ind-data><ind-data ind-title=\"\'Promedio\'\" unit=\"unit\"></ind-data><ind-active-power></ind-active-power></div><div class=\"row\"><tabs-consumo tabs=\"tabs\" selected=\"setGraphic()\"></tabs-consumo></div><div class=\"row\"><power-graphic ng-if=\"active === \'power\'\"></power-graphic><energy-graphic ng-if=\"active === \'energy\'\"></energy-graphic></div>");
$templateCache.put("app/cliente/consumo_v2/dashboard-consumo/dashboard-consumo.html","<bread-crumbs></bread-crumbs><div class=\"row\"><consumption-devices loading=\"loading\" no-info=\"noInfo\" zones=\"zonas\"></consumption-devices><consumption-pie-chart loading=\"loading\" no-info=\"noInfo\" zones=\"zonas\"></consumption-pie-chart></div><div class=\"row\"><total-consumption-chart loading=\"loading\" no-info=\"noInfo\" zones=\"zonas\"></total-consumption-chart></div>");
$templateCache.put("app/cliente/consumo_v2/estadisticas-facturacion/estadisticas-facturacion.html","<bread-crumbs></bread-crumbs><div class=\"row\"><tabs-consumo tabs=\"tabs\" selected=\"setGraphic()\"></tabs-consumo></div><div class=\"row\"><kwh-consumed-graphic></kwh-consumed-graphic></div>");
$templateCache.put("app/cliente/consumo_v2/factura/factura.html","<bread-crumbs></bread-crumbs><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"centrar panel centrar-columna factura animated zoomIn\"><div class=\"centrar basic-info width-100p centrar-align-start\"><div class=\"centrar centrar-align-start centrar-columna\"><h3>INFORMACIÓN BÁSICA</h3><p><strong>Prestador del servicio:</strong> {{factura.prestador_servicio}}</p><p><strong>Plan de consumo:</strong> {{factura.plan}}</p><p><strong>Estrato:</strong> {{factura.estrato}}</p><p><strong>Dirección:</strong> {{factura.direccion}} {{factura.ciudad}}. {{factura.estado}} - {{factura.pais}}</p><p><strong>Teléfono:</strong> {{factura.telefono}}</p><p><strong>Periodo de facturación:</strong> {{factura.dia_ini}} - {{factura.dia_fin}}</p></div><div class=\"logo-helo\"><img src=\"../../../../assets/img/helo_logo_bg_a.jpg\" alt=\"\"></div></div><div class=\"centrar detail-info centrar-align-end width-100p\"><div class=\"centrar centrar-columna grafica-consumos centrar-align-start\"><h3>últimos consumos</h3><div class=\"centrar centrar-columna width-100p\" style=\"position: relative;\"><div class=\"centrar width-100p\"><p class=\"margin-0\">KWh</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"grafica_consumos\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:100px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:100px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div></div></div><div class=\"valores-info\"><div class=\"centrar centrar-columna centrar-align-start\"><h3>{{factura.consumo_kwh}} KWh</h3><p>Consumo</p></div><div class=\"centrar centrar-columna centrar-align-start\"><h3>{{factura.dias_facturados}}</h3><p>Días facturados</p></div><div class=\"centrar centrar-columna centrar-align-start\"><h3>{{factura.precio_kwh | currency}}</h3><p>Valor KWh</p></div><div class=\"centrar centrar-columna centrar-align-start ind-valor-factura\"><h3>{{factura.valor | currency}}</h3><p>Valor factura</p></div></div></div><div class=\"centrar width-100p margin-top\"><button class=\"btn-add-activo centrar centrar-c\" title=\"Imprimir\" ng-click=\"imprimir()\"><span class=\"ion-printer\"></span> Imprimir</button></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/facturacion/facturacion.html","<no-factura id=\"no_factura\" style=\"display: none;\"></no-factura><div ng-if=\"facturas.length > 0\"><bread-crumbs></bread-crumbs><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-12\"><div class=\"dropdown filter-menu margin-bottom-20\"><button class=\"dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">{{nombre_punto ? nombre_punto : \'Fronteras comerciales\'}} <span class=\"ion-chevron-down\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"punto in puntos\" class=\"cursor\" ng-click=\"gotoPunto(punto)\">{{punto.nombre | limitTo: 20}}{{punto.nombre.length > 20 ? \'...\': \' \'}}</li></ul></div></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\"><div class=\"btn-add-activo centrar centrar-c cursor\" ng-click=\"gotoNuevaFactura()\"><p><span class=\"ion-plus-round\"></span> Cargar nueva factura</p></div></div><div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\"><div class=\"btn-add-activo centrar centrar-c cursor\" ng-click=\"gotoDatosPuntoFacturacion()\"><p><span class=\"ion-clipboard\"></span> Datos frontera comercial</p></div></div><div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\"><div class=\"btn-add-activo centrar centrar-c cursor\" ng-click=\"gotoEstadisticas()\"><p><span class=\"ion-stats-bars\"></span> Estadísticas</p></div></div></div><div class=\"row\"><ind-totalizador ind-title=\"\'Última factura\'\" ind=\"ultima_factura\" unit=\"\'$\'\"></ind-totalizador><ind-totalizador ind-title=\"\'Costo actual del KWh\'\" ind=\"costo_actual_kwh\" unit=\"\'$\'\"></ind-totalizador><ind-totalizador ind-title=\"\'Último Consumo\'\" ind=\"ultimo_consumo\" unit=\"\'KWh\'\"></ind-totalizador></div><div class=\"row\"><table-billing facturas=\"facturas\"></table-billing></div></div>");
$templateCache.put("app/cliente/consumo_v2/facturadores/facturadores.html","<div><bread-crumbs></bread-crumbs><div class=\"row\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-12\"><button class=\"btn-add-activo centrar centrar-c\" title=\"Nuevo punto de facturación\" ng-click=\"gotoNuevoFacturador()\">Nueva cuenta</button></div><div class=\"col-lg-2 col-md-3 col-sm-4 col-xs-12\"><button class=\"btn-add-activo centrar centrar-c\" title=\"Proceso de facturación\" ng-click=\"gotoProcesoFacturacion()\">Informe de consumo</button></div></div><div class=\"row\"><table-facturadores facturadores=\"facturadores\" control=\"control\"></table-facturadores><loading-content loading=\"loading\"></loading-content></div></div>");
$templateCache.put("app/cliente/consumo_v2/nueva-factura/nueva-factura.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn nueva-factura\"><div class=\"panel-heading centrar centrar-columna\"><h3>Cargar nueva factura</h3></div><div class=\"panel-body centrar centrar-justificar-inicio\"><form name=\"nuevaFacturaForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><p>Todos los campos marcado con * son obligatorios</p><label>Días facturados*</label><div class=\"centrar centrar-flex-flow\"><div class=\"margin-10\"><p>Primer día facturado</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_ini\" is-open=\"popup.opened_1\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"consultaConsumos(date)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"margin-10\"><p>Último día facturado</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_final\" is-open=\"popup.opened_2\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"consultaConsumos(date)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><label>Valor KWh*</label> <input type=\"text\" ng-model=\"nuevaFactura.precio_kwh\" name=\"precio_kwh\" required=\"\"> <label>KWh Consumidos*</label> <input type=\"text\" ng-model=\"nuevaFactura.consumo_kwh\" name=\"consumokwh\" required=\"\"> <label>Valor factura*</label> <input type=\"text\" ng-model=\"nuevaFactura.valor\" name=\"valor\" required=\"\"><div ng-if=\"nuevaFactura.indMasInfo === \'true\'\"><p class=\"margin-top\">Información complementaria de Facturación</p><label>Valor Generacion</label> <input type=\"text\" ng-model=\"nuevaFactura.valor_generacion\" name=\"valor_generacion\"> <label>Valor Transporte</label> <input type=\"text\" ng-model=\"nuevaFactura.valor_transporte\" name=\"valor_transporte\"> <label>Valor Distribución</label> <input type=\"text\" ng-model=\"nuevaFactura.valor_distribucion\" name=\"valor_distribucion\"></div><div class=\"centrar\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"!nuevaFacturaForm.$valid\" ng-class=\"{\'btn-add-active\': nuevaFacturaForm.$valid, \'btn-add-active-disabled\': !nuevaFacturaForm.$valid}\" title=\"Crear factura\" ng-click=\"crearFactura(nuevaFactura)\">{{editMode ? \'Editar factura\' : \'Agregar factura\'}}</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form><div class=\"centrar factura-img\"><img src=\"../../../assets/img/facturas.png\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/nuevo-punto-facturacion/nuevo-punto-facturacion.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn\"><div class=\"panel-heading centrar centrar-columna\"><h3>Información básica</h3></div><div class=\"panel-body\"><form name=\"nuevoPuntoForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><p>Todos los campos marcado con * son obligatorios</p><div class=\"width-100p inputs-grid-group\"><label class=\"input-grid-item\">Nombre*</label> <input type=\"text\" class=\"input-grid-item\" ng-model=\"nuevoPunto.nombre\" name=\"nombre\" required=\"\"></div><div class=\"width-100p inputs-grid-group\"><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label>Prestador del servicio*</label> <input type=\"text\" ng-model=\"nuevoPunto.prestador_servicio\" name=\"prestador\" required=\"\"></div><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label>Plan de consumo*</label><select ng-model=\"nuevoPunto.plan\" name=\"Plan\" required=\"\"><option value=\"{{plan.id}}\" ng-repeat=\"plan in planConsumo\">{{plan.name}}</option></select></div></div><div class=\"width-100p inputs-grid-group\"><label class=\"input-grid-item\">Estrato*</label><select class=\"input-grid-item\" ng-model=\"nuevoPunto.estrato\" name=\"estrato\" required=\"\"><option value=\"{{estrato}}\" ng-repeat=\"estrato in estratos\">{{estrato}}</option></select></div><div class=\"width-100p inputs-grid-group\"><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label>País*</label><select ng-model=\"nuevoPunto.pais\" id=\"pais\" name=\"pais\" ng-class=\"{\'input-invalid\': nuevoPunto.pais.$touched && nuevoPunto.pais.$invalid}\" required=\"\" ng-change=\"getStates(nuevoPunto.pais)\"><option value=\"{{pais.id}}\" ng-repeat=\"pais in paises\">{{pais.nombre}}</option></select></div><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label>Estado / Departamento*</label><select ng-model=\"nuevoPunto.estado\" id=\"estado\" name=\"estado\" ng-class=\"{\'input-invalid\': nuevoPunto.estado.$touched && nuevoPunto.estado.$invalid}\" required=\"\" ng-change=\"getCitys(nuevoPunto.estado)\"><option value=\"{{estado.id}}\" ng-repeat=\"estado in estados\">{{estado.nombre}}</option></select></div></div><div class=\"width-100p inputs-grid-group\"><label class=\"input-grid-item\">Ciudad*</label><select class=\"input-grid-item\" ng-model=\"nuevoPunto.ciudad\" id=\"ciudad\" name=\"ciudad\" ng-class=\"{\'input-invalid\': nuevoPunto.ciudad.$touched && nuevoPunto.ciudad.$invalid}\" required=\"\"><option value=\"{{ciudad.id}}\" ng-repeat=\"ciudad in ciudades\">{{ciudad.nombre}}</option></select></div><div class=\"width-100p inputs-grid-group\"><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label>Dirección*</label> <input type=\"text\" ng-model=\"nuevoPunto.direccion\" required=\"\"></div><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label>Teléfono*</label> <input type=\"tel\" ng-model=\"nuevoPunto.telefono\" required=\"\" ng-class=\"{\'input-invalid\': nuevoPunto.tel.$touched && nuevoPunto.tel.$invalid}\"></div></div><div class=\"width-100p inputs-grid-group\"><label class=\"input-grid-item\">Dispositivo Helo totalizador (opcional)</label><select class=\"input-grid-item\" name=\"device\" id=\"device\" ng-model=\"nuevoPunto.id_totalizador\"><option value=\"{{device.id}}\" ng-repeat=\"device in devices\">{{device.nombre}}</option></select></div><div class=\"centrar\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"!nuevoPuntoForm.$valid\" ng-class=\"{\'btn-add-active\': nuevoPuntoForm.$valid, \'btn-add-active-disabled\': !nuevoPuntoForm.$valid}\" title=\"Crear frontera comercial\" ng-click=\"crearPuntoFacturacion(nuevoPunto)\">{{editMode ? \'Editar\' : \'Agregar\'}}</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/proceso-facturacion/proceso-facturacion.html","<ui-view><proceso-facturacion-info></proceso-facturacion-info></ui-view>");
$templateCache.put("app/cliente/consumo_v2/puntos-facturacion/puntos-facturacion.html","<div><bread-crumbs></bread-crumbs><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\"><button class=\"btn-add-activo centrar centrar-c\" title=\"Nuevo punto de facturación\" ng-click=\"gotoNuevoPuntoFacturacion()\">Agregar frontera comercial</button></div><div class=\"col-lg-3 col-md-3 col-sm-4 col-xs-12\"><button class=\"btn-add-activo centrar centrar-c\" title=\"Facturadores\" ng-click=\"gotoFacturadores()\">Cuentas</button></div></div><div class=\"row\"><div class=\"padding-col\"><div></div><div class=\"tabla-consumo tabla-consumo-header\"><p class=\"tabla-consumo-header-item\">Nombre</p><p class=\"tabla-consumo-header-item\">Ciudad</p><p class=\"tabla-consumo-header-item\">Proveedor del servicio</p><p class=\"tabla-consumo-header-item\">Valor última fáctura</p><p class=\"tabla-consumo-header-item\">Facturas</p></div></div><table-consumption ng-repeat=\"punto in filtered = puntos | filter:buscar | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\" punto=\"punto\" control=\"control\"></table-consumption><loading-content loading=\"loading\"></loading-content></div><div class=\"centrar centrar-c\"><uib-pagination style=\"box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.25);\" total-items=\"totalItems\" boundary-links=\"false\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-model=\"currentPage\" boundary-link-numbers=\"false\" rotate=\"false\" class=\"pagination-sm\" items-per-page=\"itemsPerPage\" max-size=\"0\" num-pages=\"noOfPages\" ng-change=\"getPoints(currentPage)\"></uib-pagination></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/automation/automation.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nueva Programación {{type.name}}\" ba-panel-class=\"\"><div class=\"centrar centrar-columna centrar-align-start\"><div class=\"width-100p\" id=\"no_devices_message\" ng-if=\"dispositivos.length === 0\"><div class=\"centrar centrar-justificar-inicio no-devices-message\"><div class=\"centrar centra-c\"><i class=\"ion-close-circled\"></i></div><p>En esta zona no tienes dispositivos para crear este tipo de programación. Volver <strong ng-click=\"cancelar()\" class=\"cursor\">atrás.</strong></p></div></div><form name=\"automationForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><div ng-if=\"editMode\" class=\"width-100p\"><label>Dispositivo</label> <input type=\"text\" value=\"{{device.nombre}}\" disabled=\"true\"></div><div class=\"centrar width-100p\"><div class=\"centrar centrar-columna centrar-align-start width-45p\"><label for=\"h_ini\">Hora inicial</label> <input type=\"time\" name=\"h_ini\" ng-model=\"newAutomation.hinit\" ng-class=\"\" required=\"\"> <small class=\"ind-requerido\" ng-show=\"!automationForm.h_ini.$valid\">Debes ingresar una hora menor a la ingresada en hora final</small></div><div class=\"centrar centrar-columna centrar-align-start width-45p\"><label for=\"max\">Hora final</label> <input type=\"time\" name=\"h_fin\" ng-model=\"newAutomation.hend\" min=\"{{newAutomation.hinit}}\" ng-class=\"\" required=\"\"> <small ng-show=\"!automationForm.h_fin.$valid\" class=\"ind-requerido\">La hora final debe ser mayor al inicial</small></div></div><label>Frecuencia</label><ui-select ng-model=\"newAutomation.repeat\" theme=\"bootstrap\" search-enabled=\"false\" id=\"frequency\" name=\"frequency\" class=\"freq-select\" ng-change=\"setRepeat(newAutomation.repeat)\" ng-class=\"{\'input-invalid\': automationForm.repeat.$touched && automationForm.repeat.$invalid}\" required=\"\"><ui-select-match placeholder=\"Seleccionar frecuencia\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"i.value as i in frequency\">{{i.text}}</ui-select-choices></ui-select><div ng-if=\"newAutomation.repeat === \'1\'\"><label>Fecha</label><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"newAutomation.date\" is-open=\"popup.opened\" close-text=\"cerrar\" current-text=\"Hoy\" ng-change=\"setRepeat(\'1\', newAutomation.date)\" clear-text=\"Limpiar\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div ng-if=\"newAutomation.repeat === \'5\'\"><label>Seleccionar días</label><div class=\"centrar centrar-flex-flow centrar-justificar-inicio\"><div class=\"centrar centrar-justificar-inicio margin-top-10\" ng-repeat=\"day in intermittenceDays\"><p class=\"margin-0\">{{day.text}}</p><input style=\"margin: 0 20px 0 5px;\" ng-model=\"day.status\" type=\"checkbox\" ng-change=\"setDays(day.value, day.status)\"></div></div></div><div ng-if=\"newAutomation.repeat !== \'6\'\" class=\"width-100p\"><label>Tipo de ejecución</label><ui-select ng-model=\"newAutomation.feriado\" id=\"holidaysTypes\" name=\"holidaysTypes\" ng-change=\"setHolidaysType(newAutomation.feriado)\" required=\"\" theme=\"bootstrap\" search-enabled=\"false\" class=\"freq-select\"><ui-select-match placeholder=\"Seleccionar\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"i.value as i in tipos_feriados\">{{i.text}}</ui-select-choices></ui-select></div><div ng-if=\"newAutomation.repeat === \'6\'\" class=\"centrar centrar-columna centrar-align-start cont-holidays width-100p\"><div class=\"centrar width-100p margin-top\" ng-init=\"select_all = true\"><p>Lista de feriados disponibles</p><div class=\"centrar centrar-justificar-inicio\"><p>Seleccionar todo</p><input style=\"margin: 0 0 0 20px;\" type=\"checkbox\" ng-model=\"select_all\" ng-change=\"selectAll(select_all)\"></div></div><div class=\"centrar centrar-flex-flow centrar-justificar-inicio margin-top margin-bottom-20\"><div ng-repeat=\"holiday in holidays track by $index\" class=\"centrar centrar-justificar-inicio holiday\"><input style=\"margin-right: 10px;\" ng-model=\"holiday.status\" type=\"checkbox\" ng-change=\"validarDias(newAutomation.repeat)\"><p>{{holiday.day | date : \'dd/MM/yyyy\'}}</p></div></div></div><label>Tipo de control</label><ui-select ng-if=\"type.ind !== \'3\'\" name=\"\" id=\"\" ng-model=\"newAutomation.setpoint\" ng-class=\"{\'input-invalid\': automationForm.setpoint.$touched && automationForm.setpoint.$invalid}\" required=\"\" theme=\"bootstrap\" search-enabled=\"false\" class=\"freq-select\"><ui-select-match placeholder=\"Seleccionar\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"item.id as item in setpoints | filter: {status: true}\">{{item.nombre}}</ui-select-choices></ui-select><input ng-if=\"type.ind === \'3\'\" type=\"number\" min=\"0\" max=\"10\" step=\"0.1\" ng-model=\"newAutomation.setPoint_rack\" id=\"setpoint\" ng-value=\"{{newAutomationAir.setPoint_rack}}\" name=\"setpoint\" ng-class=\"{\'input-invalid\': automationForm.setpoint.$touched && automationForm.setpoint.$invalid}\" required=\"\"> <label>Estado al finalizar la programación</label><ui-select ng-if=\"type.ind !== \'3\'\" id=\"finalsetpoint\" name=\"finalsetpoint\" ng-model=\"newAutomation.finalsetpoint\" ng-class=\"{\'input-invalid\': automationForm.finalsetpoint.$touched && automationForm.finalsetpoint.$invalid}\" required=\"\" theme=\"bootstrap\" search-enabled=\"false\" class=\"freq-select\"><ui-select-match placeholder=\"Seleccionar\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"item.id as item in setpoints | filter: {status: true}\">{{item.nombre}}</ui-select-choices></ui-select><input ng-if=\"type.ind === \'3\'\" type=\"number\" min=\"0\" max=\"10\" step=\"0.1\" ng-model=\"newAutomation.finalsetpoint_rack\" id=\"finalsetpoint\" ng-value=\"{{newAutomation.finalsetpoint_rack}}\" name=\"finalsetpoint\" ng-class=\"{\'input-invalid\': automationForm.finalsetpoint.$touched && automationForm.finalsetpoint.$invalid}\" required=\"\"> <label ng-show=\"!editMode\" for=\"\">Dispositivos a programar</label><selectable-list ng-show=\"!editMode\" ng-model=\"newAutomation.devices\" items=\"dispositivos\" label=\"\'nombre\'\" class=\"width-100p\" active-validation=\"true\" validation=\"validatedList\" loading=\"loading\"></selectable-list><div class=\"centrar centrar-align-self-end\"><button style=\"margin-left: 0;margin-right: 10px;width: 150px;\" class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button> <button style=\"width: 150px;\" class=\"centrar centrar-c margin-top\" ng-disabled=\"!validatedList || !automationForm.$valid || !validatedDays\" ng-class=\"{\'btn-add-active\': validatedList && automationForm.$valid && validatedDays, \'btn-add-active-disabled\': !validatedList || !automationForm.$valid || !validatedDays}\" title=\"Ajustar\" ng-click=\"validateSchedual(newAutomation)\">{{editMode ? \'Editar\' : \'Crear\'}}</button></div></form></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/estadisticas_zona.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\" ng-class=\"{\'margin-right-30\': rol === \'6\'}\"><content-top></content-top><div class=\"dinamic_content estadisticas-zona\"><div class=\"transform title\" id=\"locationTop\"><h1 class=\"ind-link\">{{nombre_zona | limitTo: 30}}{{nombre_zona.length > 30 ? \'...\' : \'\'}} | {{device.nombre | limitTo: 30}}{{device.nombre.length > 30 ? \'...\' : \'\'}}</h1></div><div class=\"ind-mobile centrar centrar-columna centrar-align-start\"><h5><span style=\"font-weight: bold;\">Zona:</span> {{nombre_zona | limitTo: 30}}{{nombre_zona.length > 30 ? \'...\' : \'\'}}</h5><h5><span style=\"font-weight: bold;\">Dispositivo:</span> {{device.nombre | limitTo: 30}}{{device.nombre.length > 30 ? \'...\' : \'\'}}</h5></div><div class=\"row\"><div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\"><div class=\"\"><ind-variable ind-title=\"\'Flujo\'\" unit=\"\'SCFM\'\" ind-type=\"12\"></ind-variable><ind-variable ind-title=\"\'Presión\'\" unit=\"\'PSI\'\" ind-type=\"13\"></ind-variable><ind-variable ind-title=\"\'Temperatura\'\" unit=\"\'C°\'\" ind-type=\"10\"></ind-variable><ind-variable ind-title=\"\'Presión\'\" unit=\"\'Bar\'\" ind-type=\"4\"></ind-variable></div><tabs></tabs><tabs-energy></tabs-energy><tabs-saeg></tabs-saeg><tabs-helo-energy-plus></tabs-helo-energy-plus><div class=\"row\"><content-graph></content-graph><no-graph ng-if=\"noData\"></no-graph></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><devices-list class=\"cont-devices-list-alternartive\" devices=\"dispositivos\" broadcast=\"evento\" ng-class=\"{\'show-component\': showDevices}\"></devices-list></div></div><div class=\"centrar centrar-espaciado sub-menu\"><div class=\"centrar centrar-columna\" ng-class=\"{\'sub-menu-selected\': item.status}\" ng-repeat=\"item in subMenu\"><div class=\"icon\"><img ng-src=\"{{item.icon}}\" ng-click=\"selectSubMenu(item)\" alt=\"\"></div><p>{{item.name}}</p></div></div></div></div></div><sidebar-alerts ng-if=\"rol === \'6\'\"></sidebar-alerts><page-footer></page-footer>");
$templateCache.put("app/cliente/dashboard-cliente/graficaComparativaAhorro/graficaComparativaAhorro.html","<div class=\"centrar\"><div class=\"centrar centrar-justificar-inicio\" ng-show=\"verGrafica\"><div class=\"centrar\"><p class=\"margin-0\">GRÁFICA DE AHORRO(%) COMPARATIVO MES</p></div><div uib-dropdown=\"\"><a uib-dropdown-toggle=\"\"><span class=\"ion-help-circled cursor ind-ayuda\"></span></a><ul class=\"dropdown-menu ind-ayuda-cont\" uib-dropdown-menu=\"\"><li>Selecciona en la parte de abajo los meses en los cuales quieras comparar el ahorro</li></ul></div></div><div class=\"centrar centrar-justificar-inicio\" ng-hide=\"verGrafica\"><div class=\"centrar\"><p class=\"margin-0\">GRÁFICA DE AHORRO(%) ANUAL</p></div><div uib-dropdown=\"\"><a uib-dropdown-toggle=\"\"><span class=\"ion-help-circled cursor ind-ayuda\"></span></a><ul class=\"dropdown-menu ind-ayuda-cont\" uib-dropdown-menu=\"\"><li>Selecciona en la parte de abajo el año</li></ul></div></div><div class=\"centrar cont-filtros centrar-justificar-final\"><div ng-click=\"graficaAhorro(0)\" class=\"filtro cursor\" ng-class=\"{\'filtro-activo\':verGrafica == true}\"><span class=\"ion-pie-graph\"></span></div><div ng-click=\"graficaAhorro(1)\" class=\"filtro cursor\" ng-class=\"{\'filtro-activo\':verGrafica == false}\"><span class=\"ion-stats-bars\"></span></div></div></div><div ng-show=\"verGrafica\"><div class=\"centrar centrar-c centrar-align-start cont-grafica-comparativa-donut centrar-columna\"><div class=\"centrar centrar-c width-100p\"><div id=\"graficaDonut\" class=\"width-100p\" style=\"height: 350px; margin-bottom:40px\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div></div><div class=\"centrar\"><div class=\"centrar centrar-columna centrar-align-start\"><div class=\"padding-0-10 centrar\"><p class=\"margin-0\">Mes 1</p><div uib-dropdown=\"\"><a uib-dropdown-toggle=\"\"><span class=\"ion-help-circled cursor ind-ayuda\"></span></a><ul class=\"dropdown-menu ind-ayuda-cont\" uib-dropdown-menu=\"\"><li>Escoge un mes para comparar</li></ul></div></div><div class=\"centrar cont-date padding-0-10\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormatD}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"fechaD_1.dt\" is-open=\"popup.opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"consultaAhorro(fechaD_1.dt, fechaD_2.dt)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div uib-dropdown=\"\" ng-if=\"errorFecha1\"><a uib-dropdown-toggle=\"\"><span class=\"ion-alert-circled cursor ind-info\"></span></a><ul class=\"dropdown-menu ind-ayuda-cont\" uib-dropdown-menu=\"\"><li>Selecciona un mes válido</li></ul></div></div></div><div class=\"centrar centrar-columna centrar-align-start\"><div class=\"padding-0-10 centrar\"><p class=\"margin-0\">Mes 2</p><div uib-dropdown=\"\"><a uib-dropdown-toggle=\"\"><span class=\"ion-help-circled cursor ind-ayuda\"></span></a><ul class=\"dropdown-menu ind-ayuda-cont\" uib-dropdown-menu=\"\"><li>Escoge un mes con el que quieres comparar el mes 1</li></ul></div></div><div class=\"centrar cont-date padding-0-10\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormatD}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"fechaD_2.dt\" is-open=\"popup_2.opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"consultaAhorro(fechaD_1.dt, fechaD_2.dt)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open_2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div uib-dropdown=\"\" ng-if=\"errorFecha2\"><a uib-dropdown-toggle=\"\"><span class=\"ion-alert-circled cursor ind-info\"></span></a><ul class=\"dropdown-menu ind-ayuda-cont\" uib-dropdown-menu=\"\"><li>Selecciona un mes válido</li></ul></div></div></div></div></div></div><div ng-hide=\"verGrafica\"><div class=\"centrar width-100p\"><p class=\"margin-0\">Ahorro(%)</p></div><div id=\"graficaBarras\" class=\"width-100p\" style=\"height: 400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Mes</p></div><div class=\"centrar cont-date padding-0-10\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormatB}}\" datepicker-mode=\"options2.minMode\" datepicker-options=\"options2\" ng-model=\"fechaB.dt\" is-open=\"popup2.opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open2()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/move-devices/move-devices.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Mover dispositivos\" ba-panel-class=\"\"><div class=\"centrar new-alert-form\"><form name=\"moveDevicesForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label for=\"\">Zona</label><select ng-model=\"move.id_zona\" name=\"zona\" required=\"\"><option value=\"{{zone.id}}\" ng-repeat=\"zone in zonas\">{{zone.nombre}}</option></select><label for=\"\">Dispositivos a mover</label><selectable-list ng-model=\"move.devices\" items=\"devices\" label=\"\'nombre\'\" class=\"width-100p\" active-validation=\"true\" validation=\"validatedList\" loading=\"loading\"></selectable-list><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button> <button class=\"centrar centrar-c margin-top\" ng-disabled=\"!validatedList || !moveDevicesForm.$valid || disabled\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Mover\" ng-click=\"moveDevices()\">Mover</button></div></form></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/new-project/new-project.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nuevo proyecto\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 ticket\"><p>Imagen del proyecto (opcional)</p><div class=\"cont-img\"><img ng-src=\"{{project.imagen}}\" alt=\"\"></div><div class=\"centrar centrar-columna cont-upload\"><label class=\"cursor centrar\" for=\"file\"><span class=\"ion-android-upload\"></span><p>Subir imagen</p></label> <input ng-model=\"file\" type=\"file\" id=\"file\" name=\"file\" ng-change=\"getFile()\" onchange=\"angular.element(this).scope().getFile()\" accept=\".jpg, .jpeg, .png\"></div></div><div class=\"centrar col-lg-7 col-md-7 col-sm-12 col-xs-12\"><form name=\"projectForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label for=\"nombre\">Nombre del proyecto</label> <input type=\"text\" ng-model=\"project.nombre\" name=\"nombre\" required=\"\"> <label for=\"\">Agregar Zonas</label><selectable-list ng-model=\"project.zonas\" items=\"zonas\" label=\"\'nombre\'\" class=\"width-100p\" active-validation=\"true\" validation=\"validatedList\" loading=\"loading\"></selectable-list><label for=\"\">Agregar técnicos (opcional)</label><selectable-list ng-model=\"project.tecnicos\" items=\"tecnicos\" label=\"\'email\'\" class=\"width-100p\" active-validation=\"true\" validation=\"validatedList_2\" loading=\"loading_t\"></selectable-list><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button> <button class=\"centrar centrar-c margin-top\" ng-disabled=\"!validatedList || !projectForm.$valid || disabled\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"addProject(project)\">{{edit_mode ? \'Editar\' : \'Crear\'}}</button></div></form></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/newZone/newZone.html","<div class=\"row new-zone\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Editar Zona\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start\"><form name=\"newZoneForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label>Nombre*</label> <input type=\"text\" class=\"form-control\" ng-model=\"newZone.nombre\" required=\"\"> <label>País*</label><ui-select ng-model=\"newZone.pais\" theme=\"bootstrap\" id=\"pais\" name=\"pais\" class=\"country-select\" required=\"\"><ui-select-match placeholder=\"Buscar país\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"pais.id as pais in paises | filter: {nombre: $select.search}\">{{pais.nombre}}</ui-select-choices></ui-select><label>Usuarios</label><div class=\"centrar centrar-c centrar-flex-flow centrar-justificar-inicio\"><div class=\"centrar user-zone\" ng-repeat=\"user in users\"><div class=\"centrar centrar-c\" ng-if=\"user.estado == 2\"><p tooltip-placement=\"top\" class=\"ind-status\" uib-tooltip=\"Esperando que el usuario acepte invitación\"><span class=\"ion-information-circled\"></span></p></div><div class=\"info-user\"><h3>{{user.email}}</h3><p>/{{accessLabel(user)}} <span class=\"label\" ng-class=\"user.source == \'entity\' ? \'label-primary\' : \'label-info\'\">{{user.source == \'entity\' ? \'Entidad\' : \'Compartido\'}}</span></p></div><div class=\"button-close cursor\" ng-if=\"canRevoke(user)\" ng-click=\"deteleUser(user)\"><span class=\"ion-close-round\"></span></div></div></div><div class=\"button-add centrar centrar-c cursor\" title=\"Agregar Usuario\" ng-click=\"nuevoUser()\"><span class=\"ion-plus-round\"></span></div><div class=\"centrar\"><input type=\"submit\" ng-disabled=\"!newZoneForm.$valid\" value=\"Guardar\" class=\"cursor margin-right-10\" ng-class=\"{\'btn-guardar\': newZoneForm.$valid}\" ng-click=\"editZone(newZone)\"> <input type=\"button\" value=\"Cancelar\" class=\"btn-cerrar cursor margin-right-10\" ng-click=\"cancelar()\"></div></form></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/oferta_operador/oferta_operador.html","<div ng-controller=\"oferta_operadorCtrl\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default collapse-acordion\" ng-repeat=\"oferta in ofertas\"><uib-accordion-heading><div class=\"centrar centrar-columna\"><p class=\"acordion_p\">Fecha de desconexión</p><p>{{oferta.fecha_limite}}</p></div><div class=\"horario centrar centrar-columna\" ng-init=\"posicion_acordion = $index\"><p>Horario</p><p>{{oferta.hora_in}} - {{oferta.hora_fin}}</p></div><div class=\"centrar centrar-columna\"><p class=\"acordion_p\">Valor por KWh</p><p class=\"h_oferta\"><span class=\"\">&#36;</span>{{oferta.valor_oferta | number}}</p></div></uib-accordion-heading><div class=\"centrar margin-10-20\"><div class=\"centrar centrar-columna centrar-align-start padding-right-20\"><div class=\"centrar centrar-columna centrar-align-start margin-bottom\"><p class=\"margin-0\">Fecha de vencimiento</p><h2>{{oferta.fecha_limite}}</h2></div><div class=\"centrar centrar-columna centrar-align-start margin-bottom\"><p class=\"margin-0\">Hora</p><h2>{{oferta.hora_in}} - {{oferta.hora_fin}}</h2></div><div class=\"centrar centrar-columna centrar-align-start\"><p class=\"margin-0\">Valor por KWh:</p><p class=\"margin-0 centrar centrar-c ind-valor ind-valor-verde\">${{oferta.valor_oferta}}</p></div></div><div><div><p class=\"margin-0\">Aporte a la desconexión</p><div class=\"width-100\"><uib-progressbar value=\"oferta.porcentaje_carga\"></uib-progressbar><span class=\"centrar centrar-c label-progressbar\">{{oferta.porcentaje_carga | number:0}}%</span></div></div><div><p class=\"margin-0\">Pago por la desconexión</p><div class=\"centrar\"><p id=\"ind-valor-{{posicion_acordion}}\" class=\"ind-valor centrar centrar-c\">${{oferta.total_oferta | number}}</p><div uib-dropdown=\"\" ng-if=\"oferta.porcentaje_carga < 100 && oferta.porcentaje_carga > 10\"><a uib-dropdown-toggle=\"\"><span class=\"ion-information-circled cursor ind-info\"></span></a><ul class=\"dropdown-menu ind-info-cont\" uib-dropdown-menu=\"\"><li>Aún puedes agregar más desconexiones a la oferta y recibir más dinero</li></ul></div></div></div></div></div><div class=\"form-group has-feedback\"><input ng-model=\"buscar\" placeholder=\"Buscar Zonas\" class=\"input-sm form-control search-input\" type=\"text\"> <i class=\"ion-search form-control-feedback\"></i></div><div><div class=\"centrar centrar-justificar-final\"><h5 class=\"alinear-texto-derecha\">Desconectar</h5></div><table class=\"table\" ng-repeat=\"zona in oferta.zonas | filter:buscar\"><thead ng-init=\"dispositivos = zona.dispositivos\"><tr><td ng-click=\"showDis($index, posicion_acordion)\">{{zona.nombre}}</td><td><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" value=\"aceptar\" ng-model=\"zona.estado\" ng-change=\"enviar_carga(zona, posicion_acordion)\"> <span></span></label></td><td><span id=\"flecha_o{{$index}}{{posicion_acordion}}\" class=\"ion-ios-arrow-up flecha margin-flecha\" ng-click=\"showDis($index, posicion_acordion)\"></span></td></tr></thead><tbody id=\"flag_dis_o{{$index}}{{posicion_acordion}}\" class=\"display_none cont-dispositivos\"><tr ng-repeat=\"dispositivo in zona.dispositivos\" class=\"centrar width-130p\"><td style=\"width: 40px;padding: 0 !important;\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" value=\"aceptar\" id=\"check_dispo{{posicion_acordion}}{{zona.index}}{{$index}}\" ng-model=\"dispositivo.estado\" ng-change=\"enviar_carga_disp(zona, posicion_acordion, $index)\"> <span></span></label></td><td style=\"padding: 0 !important;\">{{dispositivo.nombre}}</td><td class=\"centrar centrar-justificar-final\" style=\"width: 76px;padding: 0 !important; color: #0C98F2 !important;\">{{dispositivo.valor}}W</td></tr></tbody><tfoot></tfoot></table><button class=\"btn btn-default boton_aceptar\" ng-click=\"enviar_desconexion(oferta, posicion_acordion)\">Aceptar</button></div></div></uib-accordion></div>");
$templateCache.put("app/cliente/dashboard-cliente/project/project.html","<div class=\"project\"><div class=\"centrar centrar-columna centrar-align-start title\"><div class=\"centrar\"><img class=\"icon-project cursor\" ng-click=\"backToProjects()\" ng-src=\"{{icon}}\" alt=\"\"><h3>{{project.nombre | limitTo: 30}}{{project.nombre.length > 30 ? \'...\' : \'\'}} <span>| {{zoneSelected.nombre | limitTo: 30}}{{zoneSelected.nombre.length > 30 ? \'...\' : \'\'}}</span></h3></div><div class=\"ind-mobile centrar centrar-columna centrar-align-start\"><h5><span style=\"font-weight: bold;\">Zona:</span> {{zoneSelected.nombre | limitTo: 30}}{{zoneSelected.nombre.length > 30 ? \'...\' : \'\'}}</h5><h5><span style=\"font-weight: bold;\">Dispositivo:</span> {{deviceSelected.nombre | limitTo: 30}}{{deviceSelected.nombre.length > 30 ? \'...\' : \'\'}}</h5></div></div><div class=\"centrar centrar-align-start margin-top\"><sidebar-zones ng-class=\"{\'show-component\': showZones}\"></sidebar-zones><div class=\"grid-monitoring-item width-100p central-panel\"><tabs></tabs><tabs-energy></tabs-energy><tabs-saeg></tabs-saeg><tabs-helo-energy-plus></tabs-helo-energy-plus><div class=\"row\" ng-if=\"showInds\"><ind-data ng-repeat=\"ind in indicadoresGrafica.inds\" ind-title=\"ind\" unit=\"indicadoresGrafica.unit\" initial=\"indicadoresGrafica.initial_value\"></ind-data></div><div class=\"row\"><content-graph></content-graph></div><no-graph ng-if=\"noData\"></no-graph></div><div class=\"grid-monitoring-item\"><control-devices-list class=\"cont-devices-list animated\" ng-class=\"{\'show-component\': showDevices}\" rawdevices=\"devices\" devices=\"filtered\" zone=\"zoneSelected\" server-hour=\"serverHour\" control=\"control\"></control-devices-list></div></div><div class=\"centrar centrar-espaciado sub-menu\"><div class=\"centrar centrar-columna\" ng-class=\"{\'sub-menu-selected\': item.status}\" ng-repeat=\"item in subMenu\"><div class=\"icon\"><img ng-src=\"{{item.icon}}\" ng-click=\"selectSubMenu(item)\" alt=\"\"></div><p>{{item.name}}</p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/projects/projects.html","<div class=\"row centrar centrar-flex-flow centrar-justificar-inicio centrar-align-start\"><div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-12 margin-top\" ng-repeat=\"project in projects\"><project-card project=\"project\" rol=\"rol\"></project-card></div></div><div class=\"centrar centrar-c\"><loading-content loading=\"loading\"></loading-content><p class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top\" ng-if=\"loading === false && noInfo === true\">No se encontraron proyectos</p></div>");
$templateCache.put("app/cliente/dashboard-cliente/schedules/schedules.html","<div><h3>{{zone.nombre}}</h3></div><div class=\"row\"><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-12 margin-bottom-10\" ng-if=\"control\"><div class=\"dropdown filter-menu\"><div class=\"btn-add-alert centrar centrar-c cursor dropdown-toggle\" data-toggle=\"dropdown\"><p><span class=\"ion-plus-round\"></span></p></div><ul class=\"dropdown-menu\"><li ng-repeat=\"item in automations\" class=\"cursor\" ng-click=\"gotoNewSchedule(item)\">{{item.name | limitTo: 20}}{{item.name.length > 20 ? \'...\': \' \'}}</li></ul></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12 margin-bottom-10\" ng-if=\"control\"><pause-schedules></pause-schedules></div><div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-12 margin-bottom-10\"><div class=\"dropdown filter-menu\"><div class=\"btn-add-alert centrar centrar-c cursor dropdown-toggle\" data-toggle=\"dropdown\"><p style=\"text-align: center;\">{{filterInd | limitTo: 15}}{{filterInd.length > 15 ? \'...\': \'\'}}</p></div><ul class=\"dropdown-menu\"><li ng-repeat=\"item in listaFiltros\" class=\"cursor\" ng-click=\"filtrarSchedules(item)\">{{item | limitTo: 20}}{{item.length > 20 ? \'...\': \'\'}}</li></ul></div></div><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-12 margin-bottom-10\" ng-if=\"control\"><div ng-click=\"deleteAllSchedule()\" class=\"btn-add-alert centrar centrar-c cursor\"><p><span style=\"font-size: 20px;\" class=\"ion-trash-a\"></span></p></div></div></div><div class=\"row estadisticas-zona\"><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><devices-list class=\"cont-devices-list-alternartive\" devices=\"dispositivos\" broadcast=\"evento\" ng-class=\"{\'show-component\': showDevices}\"></devices-list></div><div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\"><schedules-list schedules=\"filtered\" devices=\"dispositivos\" zone=\"zone\" control=\"control\"></schedules-list></div><div class=\"centrar centrar-espaciado sub-menu\"><div class=\"centrar centrar-columna\" ng-class=\"{\'sub-menu-selected\': item.status}\" ng-repeat=\"item in subMenu\"><div class=\"icon\"><img ng-src=\"{{item.icon}}\" ng-click=\"selectSubMenu(item)\" alt=\"\"></div><p>{{item.name}}</p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/addZone.html","<div class=\"modal-message modal-success modal-add-zone\"><div class=\"modal-title\">AGREGAR ZONA</div><div class=\"modal-body centrar centrar-columna\" ng-if=\"pendingZones.length > 0\"><div ng-repeat=\"itm in pendingZones\" class=\"centrar width-100p cont-zone\"><div class=\"centrar centrar-columna centrar-align-start\"><h3 class=\"margin-0\">{{itm.zona}}</h3><p class=\"margin-0\">{{itm.cliente}}</p></div><div><button ng-click=\"addZoneToMyProfile(itm)\" ng-class=\"{\'button-success\' : validador}\">{{validador ? \'Agregada\': \'Agregar\'}}</button></div></div></div><div ng-if=\"pendingZones.length > 0\"><button ng-click=\"addZoneToMyProfile()\" class=\"button-success\">Agregar todos</button></div><div ng-if=\"pendingZones.length == 0\" class=\"centrar centrar-c centrar-columna margin-top\"><p>No tienes zonas para agregar en este momento</p><div><button ng-click=\"cancelar()\" class=\"button-success\">Cerrar</button></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/add_programacion.html","<div class=\"modal-message modal-success\"><div class=\"modal-title\"><h3>{{titleModal}}</h3></div><div class=\"modal-body\"><form><div class=\"form-group\"><label for=\"input01\">Día</label> <input type=\"date\" class=\"form-control\" id=\"input01\" ng-model=\"agenda.day\" ng-hide=\"flag_add\" required=\"\"> <input type=\"date\" class=\"form-control\" id=\"input01\" ng-model=\"agenda.day\" ng-show=\"flag_add\" min=\"{{fecha_dia}}\" required=\"\"></div><div class=\"form-group\"><label for=\"input02\">Hora inicial</label> <input type=\"time\" class=\"form-control\" id=\"input02\" ng-model=\"agenda.hini\" required=\"\"></div><div class=\"form-group\"><label for=\"input03\">Hora final</label> <input type=\"time\" class=\"form-control\" id=\"input03\" ng-model=\"agenda.hfin\" required=\"\"></div><div class=\"form-group\"><label for=\"input04\">Frecuencia</label><select class=\"form-control selectpicker\" id=\"input04\" selectpicker=\"\" title=\"Frecuencia de ocurrencia\" ng-model=\"agenda.frequency\" required=\"\"><option value=\"1\">Única</option><option value=\"2\">Diaria</option><option value=\"3\">Semanal</option><option value=\"4\">Mensual</option></select></div></form><p ng-show=\"flag_valid\">{{text}}</p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"agendar()\">Aceptar</button> <button type=\"button\" class=\"btn btn-cancel\" ng-click=\"cerrar()\">Cancelar</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/add_programacion_aires.html","<div class=\"modal-message modal-success\"><div class=\"modal-title\"><h3>{{titleModal}}</h3></div><div class=\"modal-body\"><form><div class=\"form-group\"><div class=\"form-group\"><div><label>Aire a controlar</label><select class=\"form-control\" ng-model=\"agenda.dispositivo\" ng-change=\"consultaComandos(agenda.dispositivo)\" ng-show=\"flag_add\"><option ng-repeat=\"aire in aires\" value=\"{{aire}}\">{{aire.nombre}}</option></select><div class=\"form-control\" ng-hide=\"flag_add\">{{aire.nombre}}</div></div></div><div class=\"form-group\"><label for=\"input01\">Día</label> <input type=\"date\" class=\"form-control\" id=\"input01\" ng-model=\"agenda.day\" ng-hide=\"flag_add\" required=\"\"> <input type=\"date\" class=\"form-control\" id=\"input01\" ng-model=\"agenda.day\" ng-show=\"flag_add\" min=\"{{fecha_dia}}\" required=\"\"></div><div class=\"form-group\"><label for=\"input02\">Hora inicial</label> <input type=\"time\" class=\"form-control\" id=\"input02\" ng-model=\"agenda.hini\" required=\"\"></div><div class=\"form-group\"><label for=\"input03\">Hora final</label> <input type=\"time\" class=\"form-control\" id=\"input03\" ng-model=\"agenda.hfin\" required=\"\"></div><div class=\"form-group\"><label for=\"input04\">Frecuencia</label><select class=\"form-control selectpicker\" id=\"input04\" selectpicker=\"\" title=\"Frecuencia de ocurrencia\" ng-model=\"agenda.frequency\" required=\"\"><option value=\"1\">Única</option><option value=\"2\">Diaria</option><option value=\"3\">Semanal</option><option value=\"4\">Mensual</option></select></div><label for=\"input01\">Tipo de control</label><select class=\"form-control\" ng-model=\"agenda.comando\"><option ng-repeat=\"comando in comandos\" value=\"{{comando.id}}\" ng-if=\"comando.nombre != \'Encender\'\">{{comando.nombre}}</option></select><label for=\"input01\">Estado al finalizar la desconexión</label><select class=\"form-control\" ng-model=\"agenda.comando_post\"><option ng-repeat=\"comando in comandos\" value=\"{{comando.id}}\" ng-if=\"comando.nombre != \'Encender\'\">{{comando.nombre}}</option></select></div></form><p ng-show=\"flag_valid\">{{text}}</p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"agendar(agenda.dispositivo)\">Aceptar</button> <button type=\"button\" class=\"btn btn-cancel\" ng-click=\"cerrar()\">Cancelar</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/confirmacion.html","<div class=\"modal-message modal-success\"><div class=\"modal-title\">{{bodyModal}}</div><div ng-if=\"sumary\" class=\"modal-body centrar centrar-c\"><p class=\"margin-0\">{{sumary}}</p></div><div class=\"modal-body centrar centrar-c\"><button type=\"button\" class=\"btn btn-primary margin-10\" ng-click=\"aceptar()\">Aceptar</button> <button type=\"button\" class=\"btn btn-cancel margin-10\" ng-click=\"cancelar()\">Cancelar</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/descargar_qr.html","<div class=\"modal-message modal-success modal-solicitud-mantenimiento\"><div class=\"modal-title\">QR del Dispositivo</div><div class=\"modal-body centrar centrar-columna\"><div id=\"qr\" class=\"qr centrar centrar-columna\"><qr style=\"display: none;\" type-number=\"8\" correction-level=\"\'M\'\" size=\"200\" input-mode=\"\" text=\"link\" image=\"true\"></qr><canvas id=\"qrHelo\" width=\"200\" height=\"330\"></canvas></div></div><div class=\"centrar centrar-c\"><button type=\"button\" class=\"margin-10\" ng-click=\"downloadQR()\">Descargar</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/errors_logs.html","<div class=\"modal-message modal-success new-alert-form\"><div class=\"modal-title\"><h4>Errores Variador de Velocidad</h4></div><div class=\"modal-body centrar centrar-columna centrar-align-start\"><div class=\"grid-errors-log errors-log-header width-100p\"><h4>Estado</h4><h4>Error</h4><h4>Fecha</h4></div><div class=\"cont-errors-log\"><div class=\"grid-errors-log errors-log-body width-100p\" ng-repeat=\"error in errors\"><div class=\"ind-error centrar centrar-c\" ng-class=\"{\'error-on\' : error.estado === \'1\'}\"><p>{{error.estado === \'1\' ? \'ON\' : \'OFF\'}}</p></div><p>{{error.name}}</p><p>{{error.fecha | date : \'medium\'}}</p></div></div><div class=\"width-100p centrar centrar-c\"><loading-content loading=\"loading_errors\"></loading-content></div><p style=\"text-align: center; width: 100%; margin-top: 20px;\" ng-if=\"errors.length === 0\">No hay errores para mostrar</p><div class=\"centrar centrar-c width-100p\"><button type=\"button\" class=\"margin-10\" ng-click=\"close()\">Cerrar</button></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/holiday.html","<div class=\"modal-message modal-success modal-new-user form-mantenimiento\"><div class=\"modal-title\" style=\"font-weight: bold; font-size: 20px; color: #000;\">Nuevo Feriado</div><div class=\"modal-body centrar centrar-c\"><form name=\"newHolidayForm\" class=\"centrar centrar-columna centrar-align-start new-alert-form width-100p\"><label for=\"holiday\">Fecha</label> <input type=\"date\" ng-model=\"date\" name=\"holiday\" required=\"\" id=\"holiday\"><div class=\"centrar centrar-c width-100p\"><button type=\"button\" ng-disabled=\"!newHolidayForm.$valid\" ng-click=\"createHoliday(date)\">Agregar</button> <button type=\"button\" style=\"margin-left: 20px;\" class=\"button-cancel\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/holidays_list.html","<div class=\"modal-message modal-success new-alert-form\"><div class=\"modal-title\"><h4>Lista de Feriados donde aplica la programación</h4></div><div class=\"modal-body centrar centrar-columna centrar-align-start ticket\"><div class=\"centrar centrar-align-start centrar-flex-flow cont-zonas-compartidas\"><div class=\"device\" ng-repeat=\"holiday in holidays\">{{holiday | date : \'dd/MM/yyyy\'}}</div></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/limite_mantenimiento.html","<div class=\"modal-message modal-success modal-solicitud-mantenimiento\"><div class=\"modal-title\">Nuevo límite de Mantenimiento</div><div class=\"modal-body centrar centrar-columna centrar-align-start\"><form class=\"form-mantenimiento\"><label for=\"nombre\">Límite</label> <input style=\"font-size: 20px; height: 40px;\" type=\"number\" min=\"0\" max=\"1000\" step=\"1\" ng-model=\"limite\" name=\"limite\"></form></div><div class=\"centrar centrar-c\"><button type=\"button\" class=\"margin-10\" ng-click=\"setLimit(limite)\">Guardar</button> <button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cancelar()\">Cancelar</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/list_programacion.html","<div class=\"h-programacion\"><div class=\"modal-title\"><h3>{{titleModal }}</h3><h5>{{fecha_dia | date : \"dd/MM/yyyy\"}}</h5></div><ul><li class=\"programacion e_pasados\" id=\"programacion\" ng-repeat=\"programacion in programaciones | orderBy:\'hini\'\" ng-if=\"( ((programacion.hfin<hora_dia)&&(programacion.dia == fecha_dia)&&(programacion.frec==1)) || ((programacion.hfin<hora_dia)&&(fecha_dia >= programacion.dia)&&(programacion.frec==2)) || ((programacion.hfin<hora_dia)&&((fecha_dia | date:\'EEEE\')==(programacion.dia | date:\'EEEE\'))&&(programacion.frec==3)&&(fecha_dia>=programacion.dia)) || ((programacion.hfin<hora_dia)&&((fecha_dia | date:\'d\')==(programacion.dia | date:\'d\'))&&(programacion.frec==4)&&(fecha_dia>=programacion.dia)))\"><div class=\"prog_dias\"><div class=\"prog_dias-ind\"><span ng-class=\"{\'icon-light-2\':programacion.comando==undefined, \'icon-aires-2\':programacion.comando!=undefined}\"></span></div><div class=\"prog_dias-estado\">Ejecutado</div></div><div class=\"h_horas\" ng-if=\"programacion.comando!=undefined\"><div ng-if=\"programacion.comando!=\'Apagar\'\" class=\"centrar centrar-columna centrar-align-start\"><p>Temp</p><p><span class=\"temp\">{{programacion.comando}}°</span></p></div><div ng-if=\"programacion.comando==\'Apagar\'\" class=\"centrar centrar-columna centrar-align-start\"><p>Estado</p><p><span>{{programacion.comando}}</span></p></div></div><div class=\"prog_horas\"><div class=\"h_horas\"><p><span>{{programacion.hini | limitTo:5 }}</span> - <span>{{programacion.hfin | limitTo:5 }}</span></p></div><div class=\"h_frecuencia\"><div><span class=\"ion-clock boton-frecuencia\"></span></div><p ng-if=\"programacion.frec==1\">Única</p><p ng-if=\"programacion.frec==2\">Diaria</p><p ng-if=\"programacion.frec==3\">Semanal</p><p ng-if=\"programacion.frec==4\">Mensual</p></div><div class=\"h_frecuencia\" ng-if=\"programacion.comando!=undefined\"><p>{{programacion.aire}}</p></div></div><div class=\"dropdown prog_opciones\"><span class=\"ion-more boton-opciones dropdown-toggle\" data-toggle=\"dropdown\"></span><ul class=\"dropdown-menu opcion\"><li ng-init=\"tipo = programacion.comando ? \'air\':\'load\'\" ng-click=\"edit_programing(programacion, tipo)\" ng-hide=\"programacion.comando.indexOf(\'subir\') === 0\">Editar</li><li ng-click=\"delete_programacion(programacion)\">Borrar</li></ul></div></li><li class=\"programacion e_ejecutandose\" id=\"programacion\" ng-repeat=\"programacion in programaciones | orderBy:\'hini\'\" ng-if=\"( ((programacion.hini<= hora_dia)&&(programacion.hfin>= hora_dia)&&(programacion.dia == fecha_dia)&&(programacion.frec==1)) || ((programacion.hini<= hora_dia)&&(programacion.hfin>= hora_dia)&&(fecha_dia >= programacion.dia)&&(programacion.frec==2)) || ((programacion.hini<= hora_dia)&&(programacion.hfin>= hora_dia)&&((fecha_dia | date:\'EEEE\')==( programacion.dia| date:\'EEEE\'))&&(programacion.frec==3)&&(fecha_dia>= programacion.dia)) || ((programacion.hini<= hora_dia)&&(programacion.hfin>= hora_dia)&&((fecha_dia | date:\'d\')==( programacion.dia| date:\'d\'))&&(programacion.frec==4)&&(fecha_dia>= programacion.dia)) )\"><div class=\"prog_dias\"><div class=\"prog_dias-ind\"><span ng-class=\"{\'icon-light-2\':programacion.comando==undefined, \'icon-aires-2\':programacion.comando!=undefined}\"></span></div><div class=\"prog_dias-estado\">Ejecutándose</div></div><div class=\"h_horas\" ng-if=\"programacion.comando!=undefined\"><div ng-if=\"programacion.comando!=\'Apagar\'\" class=\"centrar centrar-columna centrar-align-start\"><p>Temp</p><p><span class=\"temp\">{{programacion.comando}}°</span></p></div><div ng-if=\"programacion.comando==\'Apagar\'\" class=\"centrar centrar-columna centrar-align-start\"><p>Estado</p><p><span>{{programacion.comando}}</span></p></div></div><div class=\"prog_horas\"><div class=\"h_horas\"><p><span>{{programacion.hini | limitTo:5 }}</span> - <span>{{programacion.hfin | limitTo:5 }}</span></p></div><div class=\"h_frecuencia\"><div><span class=\"ion-clock boton-frecuencia\"></span></div><p ng-if=\"programacion.frec==1\">Única</p><p ng-if=\"programacion.frec==2\">Diaria</p><p ng-if=\"programacion.frec==3\">Semanal</p><p ng-if=\"programacion.frec==4\">Mensual</p></div><div class=\"h_frecuencia\" ng-if=\"programacion.comando!=undefined\"><p>{{programacion.aire}}</p></div></div><div class=\"dropdown prog_opciones\"><span class=\"ion-more boton-opciones dropdown-toggle\" data-toggle=\"dropdown\"></span><ul class=\"dropdown-menu opcion\"><li ng-init=\"tipo = programacion.comando ? \'air\':\'load\'\" ng-click=\"edit_programing(programacion, tipo)\" ng-hide=\"programacion.comando.indexOf(\'subir\') === 0\">Editar</li><li ng-click=\"delete_programacion(programacion)\">Borrar</li></ul></div></li><li class=\"programacion e_espera\" id=\"programacion\" ng-repeat=\"programacion in programaciones | orderBy:\'hini\'\" ng-if=\"( ((programacion.hini>hora_dia)&&( programacion.dia == fecha_dia)&&(programacion.frec==1)) || ((programacion.hini>hora_dia)&&(fecha_dia >= programacion.dia)&&(programacion.frec==2)) || ((programacion.hini>hora_dia)&&((fecha_dia | date:\'EEEE\')==( programacion.dia| date:\'EEEE\'))&&(programacion.frec==3)&&(fecha_dia>= programacion.dia)) || ((programacion.hini>hora_dia)&&((fecha_dia | date:\'d\')==( programacion.dia| date:\'d\'))&&(programacion.frec==4)&&(fecha_dia>= programacion.dia)) )\"><div class=\"prog_dias\"><div class=\"prog_dias-ind\"><span ng-class=\"{\'icon-light-2\':programacion.comando==undefined, \'icon-aires-2\':programacion.comando!=undefined}\"></span></div><div class=\"prog_dias-estado\">En espera</div></div><div class=\"h_horas\" ng-if=\"programacion.comando!=undefined\"><div ng-if=\"programacion.comando!=\'Apagar\'\" class=\"centrar centrar-columna centrar-align-start\"><p>Temp</p><p><span class=\"temp\">{{programacion.comando}}°</span></p></div><div ng-if=\"programacion.comando==\'Apagar\'\" class=\"centrar centrar-columna centrar-align-start\"><p>Estado</p><p><span>{{programacion.comando}}</span></p></div></div><div class=\"prog_horas\"><div class=\"h_horas\"><p><span>{{programacion.hini | limitTo:5 }}</span> - <span>{{programacion.hfin | limitTo:5 }}</span></p></div><div class=\"h_frecuencia\"><div><span class=\"ion-clock boton-frecuencia\"></span></div><p ng-if=\"programacion.frec==1\">Única</p><p ng-if=\"programacion.frec==2\">Diaria</p><p ng-if=\"programacion.frec==3\">Semanal</p><p ng-if=\"programacion.frec==4\">Mensual</p></div><div class=\"h_frecuencia\" ng-if=\"programacion.comando!=undefined\"><p>{{programacion.aire}}</p></div></div><div class=\"dropdown prog_opciones\"><span class=\"ion-more boton-opciones dropdown-toggle\" data-toggle=\"dropdown\"></span><ul class=\"dropdown-menu opcion\"><li ng-init=\"tipo = programacion.comando ? \'air\':\'load\'\" ng-click=\"edit_programing(programacion, tipo)\" ng-hide=\"programacion.comando.indexOf(\'subir\') === 0\">Editar</li><li ng-click=\"delete_programacion(programacion)\">Borrar</li></ul></div></li><li class=\"no-sessions\">No se tienen programaciones para este día.</li></ul><div class=\"h_boton_cerrar\"><button type=\"button\" class=\"btn btn-cancel\" ng-click=\"cerrar()\">Cerrar</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/membership.html","<div class=\"modal-message modal-success modal-membership\"><div class=\"modal-title\">BIENVENIDO</div><div class=\"modal-body centrar centrar-c centrar-columna\"><div class=\"centrar centrar-c img-membership\"><img src=\"../../../../assets/img/membresia_helo_6_meses.jpg\" alt=\"\"></div></div><div class=\"centrar centrar-c\"><button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cerrar()\">Empezar</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/mensaje.html","<div class=\"modal-message modal-success\"><div class=\"modal-title\"><h3>{{titleModal}}</h3></div><div class=\"modal-body\"><p>{{bodyModal}}</p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"close()\" ng-hide=\"flag_error_form\">OK</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/newSystem.html","<div class=\"modal-message modal-success form-mantenimiento\"><div class=\"modal-title\"><h3>Nuevo sistema</h3></div><div class=\"modal-body centrar centrar-columna centrar-align-start new-alert-form\"><form name=\"formNewSystem\" class=\"width-100p\"><label for=\"nombre\">Nombre</label> <input type=\"text\" ng-model=\"nombre\" name=\"nombre\" required=\"\"> <label for=\"\">Agregar equipos</label><selectable-list ng-model=\"system.devices\" items=\"devices_\" label=\"\'nombre\'\" class=\"width-100p\" active-validation=\"true\" validation=\"validatedList\"></selectable-list><div class=\"centrar centrar-c\"><button type=\"button\" class=\"margin-10\" ng-disabled=\"!formNewSystem.$valid || !validatedList || disabled\" ng-click=\"addSystem(nombre)\">Crear</button> <button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/newUser.html","<div class=\"modal-message modal-success modal-new-user\"><div class=\"modal-title\">NUEVO USUARIO</div><div class=\"modal-body centrar centrar-c\"><form name=\"newUserForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label for=\"email\">Correo</label> <input type=\"email\" ng-model=\"newUser.email\" name=\"email\" required=\"\"> <label for=\"rol\">Rol</label><select name=\"rol\" ng-model=\"newUser.rol\" required=\"\"><option value=\"control\">Control</option><option value=\"visualizacion\">Visualización</option></select><button ng-disabled=\"!newUserForm.$valid\" ng-class=\"{\'disabled\': !newUserForm.$valid}\" ng-click=\"addUser(newUser)\">Agregar</button></form></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/newZone.html","<div class=\"modal-message modal-success modal-solicitud-mantenimiento form-mantenimiento\"><div class=\"modal-title\">Agregar nueva zona</div><div class=\"modal-body centrar centrar-columna centrar-align-start\"><form name=\"formNewZone\" class=\"width-100p\"><label for=\"nombre\">Nombre*</label> <input type=\"text\" ng-model=\"nombre\" name=\"nombre\"> <label>País*</label><select ng-model=\"pais\" id=\"pais\" name=\"pais\" required=\"\"><option value=\"{{pais.id}}\" ng-repeat=\"pais in paises\">{{pais.nombre}}</option></select><div class=\"centrar centrar-c\"><button type=\"button\" class=\"margin-10\" ng-disabled=\"nombre === \'\' || nombre === undefined || pais === undefined\" ng-click=\"newZone(nombre, pais)\">Crear</button> <button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/search.html","<div class=\"centrar centrar-c centrar-columna\"><div class=\"modal-title\"><h3>Buscar dispositivo</h3></div><div class=\"modal-body centrar centrar-columna centrar-c\"><form class=\"width-100p\"><div class=\"cont-search-input centrar centrar-c\"><input ng-model=\"buscar\" placeholder=\"Buscar dispositivo\" ng-model-options=\"{ debounce: 800 }\" ng-change=\"search(buscar)\" class=\"input-sm form-control search-input\" type=\"search\"> <button type=\"submit\" ng-click=\"search(buscar)\"><i class=\"ion-search\"></i></button></div><div class=\"search-results\" ng-if=\"results.length > 0\"><div class=\"centrar result centrar-justificar-inicio\" ng-repeat=\"result in results\"><div class=\"device-icon\"><img ng-src=\"{{result.icon}}\" alt=\"\"></div><div class=\"centrar centrar-columna centrar-align-start cont-result-info\"><h4 class=\"cursor\" ng-click=\"goToDeviceProfile(result)\">{{result.nombre}}</h4><p>Zona: {{result.nombre_zona}}</p><p style=\"font-style: italic;\">Perfil: {{result.nombre_cliente}}</p></div></div></div><div class=\"centrar-c centrar margin-top\" ng-if=\"results.length === 0 && loading === false && first_search === false\"><p>No se encontraron resultados</p></div><loading-content loading=\"loading\"></loading-content></form><div ng-if=\"results.length === 0 && loading === false && first_search === true\" class=\"search-ind\"><img ng-src=\"{{\'assets/img/search_ind.svg\'}}\" alt=\"\"></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/shareZones.html","<div class=\"modal-message modal-success share-zones-modal\"><div class=\"modal-title\">COMPARTIR ZONAS</div><div class=\"modal-body\"><form name=\"shareZonesForm\" class=\"form-mantenimiento\"><div class=\"share-zones-grid\"><div class=\"share-zones-col\"><label>Zonas ({{selectedCount()}} seleccionadas)</label><div class=\"share-zones-actions\"><button type=\"button\" class=\"btn-cerrar cursor\" ng-click=\"selectAll()\">Seleccionar todas</button> <button type=\"button\" class=\"btn-cerrar cursor\" ng-click=\"clearSelection()\">Limpiar</button></div><input type=\"text\" class=\"form-control\" ng-model=\"zoneFilter\" placeholder=\"Buscar zonas\"><div class=\"share-zones-list\"><div class=\"checkbox\" ng-repeat=\"zone in zones | filter: {nombre: zoneFilter}\"><label><input type=\"checkbox\" ng-model=\"selected[zone.id]\"> {{zone.nombre}}</label></div></div></div><div class=\"share-zones-col\"><label for=\"emails\">Correos (separados por coma, espacio o salto de línea)</label> <textarea name=\"emails\" ng-model=\"form.emails\" rows=\"6\" class=\"form-control\" required=\"\"></textarea> <label for=\"rol\">Rol</label><select name=\"rol\" ng-model=\"form.rol\" class=\"form-control\" required=\"\"><option value=\"control\">Control</option><option value=\"visualizacion\">Visualización</option></select></div></div><div class=\"share-summary\" ng-if=\"summary\"><p>{{summary.text}}</p><ul ng-if=\"summary.failures.length > 0\"><li ng-repeat=\"f in summary.failures\">{{f.email}} (zona {{f.id_zona}}){{f.message ? \': \' + f.message : \'\'}}</li></ul></div><div class=\"share-zones-footer\"><button type=\"button\" class=\"btn-cerrar cursor\" ng-click=\"cancelar()\">Cerrar</button> <button type=\"button\" class=\"btn-share\" ng-disabled=\"sending || selectedCount() === 0 || !shareZonesForm.$valid\" ng-class=\"{\'disabled\': sending || selectedCount() === 0 || !shareZonesForm.$valid}\" ng-click=\"share()\">Compartir</button></div><loading-content loading=\"sending\"></loading-content></form></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/templates/solicitarMantenimiento.html","<div class=\"modal-message modal-success modal-solicitud-mantenimiento\"><div class=\"modal-title\">Solicitud de Mantenimiento</div><div class=\"modal-body centrar centrar-columna centrar-align-start\" ng-if=\"!noEncargado\"><p>Dispositivo a solicitar mantenimiento</p><h3>{{infoDevice.nombre}}</h3><p>Zona a la que pertenece</p><h3>{{infoDevice.nombre_zona}}</h3><p>Persona(s) que recibirán la solicitud</p><h3 class=\"email\" ng-repeat=\"email in infoDevice.email_encargado\">{{email}}</h3></div><div ng-if=\"noEncargado\" class=\"centrar centrar-columna centrar-align-start padding\"><p>No puedes realizar esta acción porque a este dispositivo no se le ha asignado un encargado. Ve al <strong class=\"cursor\" ng-click=\"goApparatusProfile()\">perfil del dispositivo</strong> para agregarlo.</p></div><div class=\"centrar centrar-c\"><button type=\"button\" class=\"margin-10\" ng-click=\"aceptar()\" ng-if=\"!noEncargado\">Solicitar</button> <button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cancelar()\">Cancelar</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/zones/zones.html","<div class=\"row\" ng-if=\"!noZones\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><zone-card ng-if=\"getReady\" client=\"client\" owner=\"true\" loading=\"loading\" no-info=\"noInfo\"></zone-card></div></div><no-zones ng-if=\"noZones && (rol !== \'7\' && rol !== \'10\' && rol !== \'11\')\"></no-zones><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"shareClients\"><div class=\"ind-divisor-zonas\"><h3>ZONAS COMPARTIDAS</h3></div><zone-card client=\"shareClient\" ng-repeat=\"shareClient in shareClients\" owner=\"false\" loading=\"loading\" no-info=\"noInfo\"></zone-card></div></div><loading-content loading=\"loading\"></loading-content>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/maintenance_log.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><bread-crumbs></bread-crumbs><div class=\"dinamic_content\"><div><h2>Lista de Mantenimientos | {{dispositivo.nombre}}</h2></div><div class=\"row margin-top margin-bottom-20\"><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-3\"><div><button class=\"btn-add-activo centrar centrar-c\" ui-sref=\"mantenimiento_new({device:dispositivo, totalMaintenance: ListMantenimiento.length})\" title=\"Nuevo Mantenimiento\"><p><span class=\"ion-plus-round\"></span></p></button></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-9\"><div class=\"search-box centrar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"filtrar(buscar)\" type=\"search\"> <button type=\"submit\"><i class=\"ion-search\"></i></button></div></div><div class=\"col-lg-3 col-md-3 col-sm-12\"><solicitar-mantenimiento device=\"dispositivo\"></solicitar-mantenimiento></div><div class=\"col-lg-3 col-md-3 col-sm-12\"><div class=\"maintenance-id-card\"><p>Id de Mantenimiento: {{dispositivo.id_device || dispositivo.id}}</p></div></div><div class=\"col-lg-2 col-md-2 col-sm-12 centrar centrar-justificar-final\"><button class=\"centrar centrar-c cont-btn-printer cursor\" ng-click=\"imprimirListM()\" title=\"Imprimir lista\"><span class=\"ion-printer btn-printer\"></span></button> <button class=\"centrar centrar-c cont-btn-printer cursor\" ui-sref=\"mantenimiento_apparatusProfile({device:dispositivo, control: control})\" title=\"Editar perfil\"><span class=\"ion-clipboard\"></span></button> <button class=\"centrar centrar-c cont-btn-printer cursor\" ng-click=\"showQRcode()\" title=\"Ver QR\"><span style=\"font-size: 18px;\" class=\"fa fa-qrcode\"></span></button></div></div><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-12\"><indicador-uso-pie-chart dispositivo=\"dispositivo\"></indicador-uso-pie-chart></div><div class=\"col-lg-9 col-md-9 col-sm-12\"><div class=\"width-100 list-maintenance-log\"><div class=\"grid-container grid-container-header\"><p class=\"grid-item\"></p><p class=\"grid-item\">Fecha</p><p class=\"grid-item\">Tipo</p><p class=\"grid-item\">Horas Uso</p><p class=\"grid-item\">Reaizado por</p><p class=\"grid-item\">Próx. mantenimiento</p></div><div class=\"cont-table\"><div class=\"grid-container grid-container-body\" ng-repeat=\"item in filtered = ListMantenimiento | filter:buscar | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage | orderBy:\'nombre\'\"><p data-label=\"Ver detalle\" ui-sref=\"mantenimiento_detalle({maintenance:item, device: dispositivo, control: control})\" class=\"grid-item cursor\"><span class=\"ion-clipboard\"></span></p><p data-label=\"Fecha\" class=\"grid-item\">{{item.fecha | date:\'dd/MM/yy\'}}</p><p data-label=\"Tipo\" class=\"grid-item\">{{item.tipo == 0 ? \'Preventivo\': \'Correctivo\'}}</p><p data-label=\"Horas Uso\" class=\"grid-item\">{{item.horas_uso}}</p><p data-label=\"Realizado por\" class=\"grid-item\">{{item.responsable}}</p><p data-label=\"Próx. mantenimiento\" class=\"grid-item\">{{item.fecha_proximo == undefined ? \'--\' : item.fecha_proximo | date:\'dd/MM/yy\'}}</p></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content><div class=\"centrar centrar-c\"><uib-pagination total-items=\"totalItems\" boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-model=\"currentPage\" boundary-link-numbers=\"true\" rotate=\"false\" class=\"pagination-sm\" items-per-page=\"itemsPerPage\" max-size=\"5\" num-pages=\"noOfPages\"></uib-pagination></div></div></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/new_maintenance/new_maintenance.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nuevo mantenimiento\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start\"><form name=\"nuevoMantenimientoForm\" class=\"centrar ticket centrar-columna centrar-align-start form-mantenimiento\"><label>Fecha mantenimiento*</label><p class=\"input-group fecha-mantenimiento\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"newMantenimiento.fecha\" is-open=\"popup[0].opened\" datepicker-mode=\"\'day\'\" datepicker-options=\"options_1\" ng-required=\"true\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"\" name=\"fecha\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(0)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><label>Hora mantenimiento*</label><div uib-timepicker=\"\" ng-model=\"newMantenimiento.hora\" id=\"hora\" name=\"hora\" minute-step=\"mstep\" show-meridian=\"false\" ng-required=\"true\"></div><label>Tipo de mantenimiento*</label><select ng-model=\"newMantenimiento.tipo\" name=\"tipo\" required=\"\"><option ng-repeat=\"maintenanceType in maintenanceTypes\" value=\"{{maintenanceType.value}}\">{{maintenanceType.type}}</option></select><label>Realizado por*</label> <input type=\"text\" ng-model=\"newMantenimiento.responsable\" name=\"responsable\" required=\"\"> <label>Télefono de contacto*</label> <input type=\"cel\" ng-model=\"newMantenimiento.telefono\" name=\"teléfono responsable\" required=\"\"> <label>Descripción estado inicial*</label> <textarea ng-model=\"newMantenimiento.estado_actual\" name=\"descripcion inicial\" ng-maxlength=\"200\" rows=\"10\" cols=\"40\" required=\"\"></textarea> <label>Descripción estado final*</label> <textarea ng-model=\"newMantenimiento.estado_final\" name=\"descripcion final\" ng-maxlength=\"200\" rows=\"10\" cols=\"40\" required=\"\"></textarea> <label>Descripción del procedimiento realizado*</label> <textarea ng-model=\"newMantenimiento.descripcion\" name=\"descripcion procedimiento\" ng-maxlength=\"200\" rows=\"10\" cols=\"40\" required=\"\"></textarea> <label>Fecha próximo mantenimiento*</label><p class=\"input-group fecha-mantenimiento\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"newMantenimiento.fecha_proximo\" is-open=\"popup[1].opened\" datepicker-mode=\"\'day\'\" datepicker-options=\"options_2\" ng-required=\"true\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"\" name=\"fecha\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><label>Repuestos utilizados (opcional) - Presiona Enter para agregar</label><ui-select multiple=\"\" tagging=\"\" tagging-label=\"false\" ng-model=\"newMantenimiento.repuestos\" theme=\"bootstrap\" title=\"Repuestos interesados\" class=\"multi-select\" name=\"Repuestos interesados\"><ui-select-match placeholder=\"ingresa el respuesto y luego enter\">{{$item}}</ui-select-match><ui-select-choices repeat=\"item in newMantenimiento.repuestos | filter:$select.search\">{{item}}</ui-select-choices></ui-select><label class=\"margin-top\">Imágenes adjuntas</label><div class=\"centrar centrar-c centrar-flex-flow centrar-justificar-inicio new-zone\"><div ng-click=\"showImage($index)\" class=\"centrar cursor user-zone\" ng-repeat=\"image in images track by $index\"><div class=\"info-user\"><h3>{{image.name | limitTo : 20}}</h3></div><div class=\"button-close cursor\" ng-click=\"deteleImage(image)\"><span class=\"ion-close-round\"></span></div></div></div><div class=\"centrar centrar-columna cont-upload\"><label class=\"cursor centrar\" for=\"file\"><span class=\"ion-android-upload\"></span><p>Subir imagen</p></label> <input ng-model=\"file\" type=\"file\" id=\"file\" name=\"file\" ng-change=\"addImage()\" onchange=\"angular.element(this).scope().addImage()\" multiple=\"\" accept=\".jpg, .jpeg, .png\"></div><div class=\"width-100p check-list margin-top\" ng-if=\"checkLists.length > 0\"><h3>Agregar Lista de Chequeo</h3><div class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><div class=\"button-add centrar centrar-c cursor\" title=\"Agregar Lista de chequeo\"><span class=\"ion-plus-round\"></span></div></div><ul class=\"dropdown-menu\"><div class=\"cursor centrar\" ng-repeat=\"checkList in checkLists\" ng-click=\"selectCheckList(checkList.id)\"><p>{{checkList.nombre}}</p><span ng-if=\"checkList.selected\" class=\"ion-checkmark-round\"></span></div></ul></div></div><action-list class=\"action-list width-100p\" ng-repeat=\"list in actionList\" list=\"list\"></action-list><div><input type=\"submit\" value=\"Agregar\" class=\"cursor\" ng-disabled=\"!nuevoMantenimientoForm.$valid\" ng-class=\"{\'btn-guardar\': nuevoMantenimientoForm.$valid}\" ng-click=\"nuevoMantenimiento(newMantenimiento)\"> <input type=\"button\" value=\"Cerrar\" class=\"btn-cerrar cursor\" ng-click=\"cancelar()\"></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/monitoreo/modales/add_tecnico.html","<div class=\"modal-message modal-success new-alert-form\"><div class=\"modal-title\"><h4>Asignar técnicos</h4></div><div class=\"modal-body centrar centrar-columna centrar-align-start ticket\"><selectable-list ng-model=\"ticket.tecnicos\" items=\"alltecnicos\" label=\"\'nombre\'\" class=\"width-100p\" active-validation=\"true\" validation=\"validatedList\" loading=\"loading\"></selectable-list><div class=\"centrar centrar-c width-100p\"><button type=\"button\" class=\"margin-10\" ng-click=\"agregar()\" ng-disabled=\"!validatedList\">Asignar</button> <button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cancelar()\">Cancelar</button></div></div></div>");
$templateCache.put("app/cliente/monitoreo/modales/add_visita.html","<div class=\"modal-message modal-success new-alert-form\"><div class=\"modal-title\"><h4>Asignar visita</h4></div><div class=\"modal-body centrar centrar-columna centrar-align-start ticket\"><form name=\"asignarVisitaform\"><label>Fecha de visita</label> <input type=\"date\" name=\"visita\" ng-model=\"visita.fecha\" ng-class=\"\" required=\"\"> <label for=\"h_ini\">Hora visita</label> <input type=\"time\" name=\"h_ini\" step=\"60\" ng-model=\"visita.hora\" ng-class=\"\" required=\"\"></form></div><div class=\"centrar centrar-c\"><button type=\"button\" class=\"margin-10\" ng-click=\"agregar(visita)\" ng-disabled=\"!asignarVisitaform.$valid\">Asignar</button> <button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cancelar()\">Cancelar</button></div></div>");
$templateCache.put("app/cliente/monitoreo/modales/slider-ticket.html","<div class=\"modal-message modal-success new-alert-form\"><div class=\"modal-title\"><h4>{{asunto}}</h4></div><div class=\"modal-body centrar centrar-columna centrar-align-start\"><div uib-carousel=\"\" active=\"active\" interval=\"0\" no-wrap=\"noWrapSlides\"><div style=\"width: 100%;\" uib-slide=\"\" ng-repeat=\"image in images track by $index\" index=\"$index\"><img style=\"width: 100%;\" ng-src=\"{{image.url}}\"></div></div></div></div>");
$templateCache.put("app/cliente/monitoreo/modales/tecnicos_asociados.html","<div class=\"modal-message modal-success new-alert-form\"><div class=\"modal-title\"><h4>Técnicos Asignados</h4></div><div class=\"modal-body centrar centrar-columna centrar-align-start ticket\"><div class=\"centrar centrar-align-start centrar-flex-flow cont-zonas-compartidas\"><div class=\"device\" ng-repeat=\"tecnico in tecnicos\">{{tecnico.nombre_tecnico}}</div></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div></div>");
$templateCache.put("app/cliente/monitoreo/modales/zonas-compartidas.html","<div class=\"modal-message modal-success new-alert-form\"><div class=\"modal-title\"><h4>Zonas compartidas</h4></div><div class=\"modal-body centrar centrar-columna centrar-align-start ticket\"><p><strong>Técnico:</strong> {{tecnico.nombre}} {{tecnico.apellido}}</p><div class=\"centrar centrar-align-start centrar-flex-flow cont-zonas-compartidas\"><div class=\"device\" ng-repeat=\"zona in zonas\">{{zona.nombre}}</div></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content><p ng-if=\"ind\">El técnico no ha aceptado las zonas</p></div></div>");
$templateCache.put("app/cliente/monitoreo/nuevo-tecnico/nuevo-tecnico.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nuevo técnico\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><form name=\"tecnicoForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label>Nombre</label> <input type=\"text\" ng-model=\"tecnico.nombre\" name=\"name\" required=\"\"> <label>Apellido</label> <input type=\"text\" ng-model=\"tecnico.apellido\" name=\"name\" required=\"\"> <label>Correo</label> <input type=\"email\" ng-disabled=\"edit_mode\" ng-model=\"tecnico.email\" name=\"email\" required=\"\"> <label ng-if=\"!edit_mode\">Contraseña</label> <input ng-if=\"!edit_mode\" type=\"text\" ng-model=\"tecnico.contrasena\" name=\"password\" required=\"\"> <label for=\"\">Zonas a gestionar</label><div class=\"centrar centrar-columna width-100p\"><div class=\"centrar centrar-justificar-inicio width-100p panel-selected\"><div class=\"has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"search\"> <i class=\"ion-search form-control-feedback\"></i></div><div class=\"centrar\" style=\"margin-left: 20px;\"><p class=\"margin-0\">Seleccionar todo</p><input style=\"margin: 0 0 0 20px;\" type=\"checkbox\" ng-model=\"select_all\" ng-change=\"selectAll(select_all)\"></div></div><div class=\"centrar centrar-columna centrar-justificar-inicio width-100p cont-select\"><div ng-if=\"loading === false || filtered.length > 0\" ng-repeat=\"itm in filtered track by $index\" class=\"centrar width-100p itm-select\"><p>{{itm.nombre}}</p><small ng-if=\"itm.readOnly\">Compartida por otra empresa</small> <input ng-model=\"itm.status\" ng-change=\"validateList()\" ng-disabled=\"itm.readOnly\" type=\"checkbox\"></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div></div><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"!validatedList || !tecnicoForm.$valid || disabled\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"crearTecnico(tecnico)\">{{edit_mode ? \'Editar\' : \'Crear\'}}</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div>");
$templateCache.put("app/cliente/monitoreo/nuevo-ticket/nuevo-ticket.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nuevo ticket\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start\"><form name=\"ticketForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label for=\"asunto\">Asunto</label> <input ng-model=\"ticket.asunto\" name=\"asunto\" type=\"text\" required=\"\"> <label for=\"zona\">Zona <span class=\"ion-load-c load-rotate padding-0-10\" ng-if=\"loading_z\"></span></label><select ng-model=\"ticket.id_zona\" name=\"zona\" ng-change=\"getDevices(ticket.id_zona)\" required=\"\"><option value=\"{{zona.id}}\" ng-repeat=\"zona in zonas\">{{zona.nombre}}</option></select><label for=\"status\">Estado</label><select ng-model=\"ticket.estado\" ng-options=\"i.value as i.text for i in statusOptions\" id=\"status\" name=\"status\" required=\"\"></select><label for=\"status\">Prioridad</label><select ng-model=\"ticket.prioridad\" ng-options=\"i.value as i.text for i in priority\" id=\"status\" name=\"status\" required=\"\"></select><label for=\"description\">Descripción <span>{{caracteresRestantes}}/{{maxCaracteres}}</span></label> <textarea ng-model=\"ticket.description\" name=\"description\" id=\"\" cols=\"30\" rows=\"10\" required=\"\" ng-change=\"actualizarContador(ticket.description)\"></textarea> <small ng-if=\"!validDescription\">Superaste el límite de caracteres permitidos</small> <label for=\"\">Equipos a revisar</label><div class=\"centrar centrar-columna width-100p\"><div class=\"centrar centrar-justificar-inicio width-100p panel-selected\"><div class=\"has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"search\"> <i class=\"ion-search form-control-feedback\"></i></div><div class=\"centrar\" style=\"margin-left: 20px;\"><p class=\"margin-0\">Seleccionar todo</p><input style=\"margin: 0 0 0 20px;\" type=\"checkbox\" ng-model=\"select_all\" ng-change=\"selectAll(select_all)\"></div></div><div class=\"centrar centrar-columna centrar-justificar-inicio width-100p cont-select\"><div ng-repeat=\"itm in filtered track by $index\" class=\"centrar width-100p itm-select\"><p>{{itm.nombre}}</p><input ng-model=\"itm.status\" type=\"checkbox\"></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div></div><label for=\"tecnico\">Asignar técnicos</label><selectable-list ng-model=\"ticket.tecnicos\" items=\"tecnicos\" label=\"\'nombre\'\" class=\"width-100p\" active-validation=\"true\" validation=\"validatedList\" loading=\"loading\"></selectable-list><label>Fecha de ejecución</label><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"ticket.fecha_ejecucion\" is-open=\"popup.opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><label for=\"h_ini\">Hora de ejecución</label> <input type=\"time\" name=\"h_ini\" ng-model=\"ticket.hora_ejecucion\" ng-class=\"\"> <label for=\"tecnico\">Asignar Coordinador</label><select ng-model=\"ticket.id_coordinador\" name=\"Coordinador\"><option value=\"{{coordinador.id}}\" ng-repeat=\"coordinador in coordinadores\">{{coordinador.nombre}} {{coordinador.apellido}} - {{coordinador.email}}</option></select><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"!ticketForm.$valid || disabled || !validDescription\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"crearTicket(ticket)\">Crear</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div>");
$templateCache.put("app/cliente/monitoreo/tecnicos/tecnicos.html","<div class=\"row\"><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-12 margin-top-10\"><div ng-click=\"goToNewTechnical()\" class=\"btn-add-alert centrar centrar-c cursor\"><p><span class=\"ion-plus-round\"></span></p></div></div></div><div class=\"row\"><div class=\"centrar centrar-c centrar-columna width-100\"><table-tecnicos class=\"width-100p\" tecnicos=\"tecnicos\"></table-tecnicos><loading-content loading=\"loading\"></loading-content><p class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top\" ng-if=\"loading === false && tecnicos.length === 0\">No se encontraron técnicos</p></div></div>");
$templateCache.put("app/cliente/monitoreo/ticket/ticket.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Información ticket\" ba-panel-class=\"\"><div class=\"centrar centrar-columna centrar-align-start ticket\"><div class=\"centrar centrar-align-start width-100p\"><div><h2>{{ticket.texto}}</h2><p class=\"margin-0\"><strong>Número de servicio:</strong> {{ticket.id}}</p><p class=\"margin-0\"><strong>Zona:</strong> {{ticket.zona}}</p><p class=\"margin-0\"><strong>Creado por:</strong> {{ticket.nombre_creador}} - {{ticket.fecha_creacion | date : \'MMM d, y - HH:mm\'}}</p><p class=\"margin-0\" ng-if=\"ticket.id_tecnico === \'0\'\"><strong>Técnicos asignados:</strong> <span ng-repeat=\"tecnico in tecnicos track by $index\">{{tecnico.nombre_tecnico}}{{ $index < (tecnicos.length - 1) ? \', \': \'\'}}</span><span class=\"ion-plus-circled cursor\" style=\"color: #217AEB; font-size: 20px;\" ng-click=\"addTecnico()\"></span></p><p class=\"margin-0\" ng-if=\"ticket.id_tecnico !== \'0\'\"><strong>Técnico asignado:</strong> {{ticket.nombre_tecnico}}</p><p class=\"margin-0\"><strong>Coordinador asignado:</strong> {{ticket.nombre_coordinador}}</p><p class=\"margin-0\"><strong>Visita asignada:</strong> {{ticket.fecha_ejecucion}} - {{ticket.hora_ejecucion}} <span class=\"ion-plus-circled cursor\" style=\"color: #217AEB; font-size: 20px;\" ng-click=\"addVisita()\"></span></p></div><div class=\"centrar centrar-columna centrar-align-end\"><div class=\"centrar margin-bottom-10\"><div class=\"ind-prioridad\" ng-class=\"setPriority(ticket.prioridad)\"></div><p style=\"font-weight: 700; color: #666666; margin: 0;\">{{setPriority(ticket.prioridad)}}</p></div><select class=\"select\" ng-model=\"ticket.estado\" ng-options=\"i.value as i.text for i in statusOptions\" id=\"status\" name=\"status\" ng-change=\"setStatus(ticket.estado)\"></select></div></div><div class=\"centrar centrar-columna centrar-align-start margin-top\"><h4>Descripción</h4><p>{{ticket.descripcion}}</p></div><div><h4>Equipos</h4><div class=\"centrar centrar-align-start centrar-flex-flow\"><div class=\"device\" ng-repeat=\"device in ticket.equipos\">{{device.nombre}}</div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-class=\"\"><div class=\"centrar centrar-columna centrar-align-start ticket form-mantenimiento\"><h3>Notas</h3><div class=\"nota centrar centrar-justificar-inicio width-100p\" ng-repeat=\"nota in notas\"><div class=\"circulo\"></div><div ng-if=\"!nota.edit\"><p class=\"text\">{{nota.texto}} <span ng-if=\"nota.id_creador === id_usuario\" class=\"ion-android-create cursor edit-nota\" ng-click=\"nota.edit = true; contarCaracteres(nota.texto)\"></span></p><p class=\"ref\"><span class=\"ion-clock\"></span>{{nota.fecha_local | date : \'MMM d, y - HH:mm\'}} por {{nota.nombre_creador}}</p></div><div class=\"width-100p\" ng-if=\"nota.edit\"><h4>Editar nota <span>{{caracteresRestantes1}}/{{maxCaracteres}}</span></h4><textarea ng-change=\"actualizarContador(nota.texto, \'edit\')\" ng-model=\"nota.texto\" class=\"width-100p\" name=\"\" id=\"\" cols=\"30\" rows=\"10\"></textarea><div class=\"centrar centrar-justificar-inicio\"><button class=\"centrar centrar-c btn-cancelar\" style=\"margin: 10px 10px 0 0;\" title=\"cancelar\" ng-click=\"nota.edit = false;\">cancelar</button> <button class=\"centrar centrar-c btn-add-active\" style=\"margin: 10px 10px 0 0;\" ng-disabled=\"!validNote_edit\" title=\"Editar\" ng-click=\"addNote(nota); nota.edit = false;\" ng-class=\"{\'btn-add-active-disabled\':!validNote_edit}\">Editar</button></div></div></div><div class=\"centrar centrar-columna width-100p\" ng-if=\"newNote === true\"><h4>Nueva nota <span>{{caracteresRestantes2}}/{{maxCaracteres}}</span></h4><textarea ng-change=\"actualizarContador(note.texto, \'new\')\" ng-model=\"note.texto\" class=\"width-100p\" name=\"\" id=\"\" cols=\"30\" rows=\"10\"></textarea><div class=\"centrar centrar-justificar-final form-mantenimiento\"><button class=\"centrar margin-right-10 centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"showNewNote()\">Cancelar</button> <button class=\"centrar centrar-c margin-top btn-add-active\" title=\"Agregar\" ng-disabled=\"!validNote_create\" ng-click=\"addNote(note)\" ng-class=\"{\'btn-add-active-disabled\':!validNote_create}\">Agregar</button></div></div><div class=\"form-mantenimiento\" ng-if=\"newNote === false\"><button class=\"btn-add-active\" ng-click=\"showNewNote()\">Agregar Nota</button></div><p ng-if=\"loading_image === true\" class=\"margin-0 load-rotate\"><span style=\"font-size: 1.5em;\" class=\"ion-load-c load-rotate padding-0-10\"></span></p><h4 class=\"margin-top\">Imágenes adjuntas</h4><div class=\"centrar centrar-c centrar-flex-flow centrar-justificar-inicio new-zone\"><div ng-click=\"showImage($index)\" class=\"centrar cursor user-zone\" ng-repeat=\"image in images track by $index\"><div class=\"info-user\"><h3>{{image.name}}</h3></div><div class=\"button-close cursor\" ng-click=\"deteleImage(image)\"><span class=\"ion-close-round\"></span></div></div></div><div class=\"centrar centrar-columna cont-upload\"><label class=\"cursor centrar\" for=\"file\"><span class=\"ion-android-upload\"></span><p>Subir imagen</p></label> <input ng-model=\"file\" type=\"file\" id=\"file\" name=\"file\" ng-change=\"getFile()\" onchange=\"angular.element(this).scope().getFile()\" multiple=\"\" accept=\".jpg, .jpeg, .png\"></div></div></div></div>");
$templateCache.put("app/cliente/monitoreo/tickets/tickets.html","<div class=\"row\"><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-12 margin-top-10\"><div ng-click=\"goToNewTicket()\" class=\"btn-add-alert centrar centrar-c cursor\"><p><span class=\"ion-plus-round\"></span></p></div></div><div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-12 margin-top-10\"><div class=\"dropdown filter-menu\"><div class=\"btn-add-alert centrar centrar-c cursor dropdown-toggle\" data-toggle=\"dropdown\"><p>Estado</p></div><ul class=\"dropdown-menu\"><li ng-repeat=\"item in statusOptions\" class=\"cursor\" ng-click=\"getTickets(\'estado\', item.value)\">{{item.text}}</li></ul></div></div><div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-12 margin-top-10\"><div class=\"dropdown filter-menu\"><div class=\"btn-add-alert centrar centrar-c cursor dropdown-toggle\" data-toggle=\"dropdown\"><p>Prioridad</p></div><ul class=\"dropdown-menu\"><li ng-repeat=\"item in priority\" class=\"cursor\" ng-click=\"getTickets(\'prioridad\', item.value)\">{{item.text}}</li></ul></div></div><div class=\"col-lg-3 col-md-3 col-sm-3 col-xs-12 margin-top-10\"><div class=\"search-box centrar\"><input ng-model=\"buscar\" placeholder=\"# de servicio\" ng-model-options=\"{ debounce: 800 }\" class=\"input-sm form-control search-input\" ng-change=\"getTickets( \'id_ticket\' , buscar)\" type=\"search\"> <button type=\"submit\"><i class=\"ion-search\"></i></button></div></div><div ng-init=\"showFilters = false\" class=\"col-lg-1 col-md-1 col-sm-1 col-xs-12 margin-top-10\"><button ng-class=\"{\'btn-clicked\': showFilters}\" style=\"width: 100%; margin-bottom: 0;\" class=\"btn-add-activo centrar centrar-c\" ng-click=\"showFilters = !showFilters\"><span class=\"ion-android-options\"></span></button></div></div><div ng-if=\"showFilters\" class=\"row\"><advanced-filters></advanced-filters></div><div class=\"row\"><div class=\"centrar centrar-c centrar-columna width-100\"><table-tickets class=\"width-100p\" tickets=\"tickets\"></table-tickets><loading-content loading=\"loading\" noinfo=\"no\"></loading-content><p class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top\" ng-if=\"loading === false && noInfo === true\">No se encontraron tickets</p></div></div>");
$templateCache.put("app/cliente/smartbar/measurePoint/measurePoint.html","<p>{{msg}}</p>");
$templateCache.put("app/cliente/smartbar/tempPoint/tempPoint.html","<p>{{msg}}</p>");
$templateCache.put("app/consumo/dashboard-consumo/estadisticas_zona/estadisticas_zona.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"transform\"><h1>Zona {{nombre_zona}}</h1></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 centrar\"><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12 button-datepicker2\" ng-controller=\"datepickerpopupCtrl\"><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" ng-required=\"true\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" alt-input-formats=\"altInputFormats\" show-button-bar=\"false\" ng-change=\"fecha_ahorro()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12\" style=\"width:200px; margin-bottom:15px;\"><select class=\"form-control\" ng-model=\"dispositivo\" ng-hide=\"oferta.flag\" ng-init=\"dispositivos[0]\" ng-change=\"consulta_desconexion(dispositivo)\"><option ng-repeat=\"dispositivo in dispositivos\" value=\"{{dispositivo}}\">{{dispositivo.nombre || \'No definido\'}}</option></select></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Grafica consumo\" ba-panel-class=\"with-scroll\" ng-hide=\"tipo_app==1\"><div ng-include=\"\'app/consumo/dashboard-consumo/estadisticas_zona/grafica_consumo/grafica_consumo_c.html\'\"></div></div></div></div></div><footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Medellín por <a href=\"http://intelmotics.com/\" target=\"_blank\">Ⓒ Intelmotics.</a> 2016.</div></footer>");
$templateCache.put("app/consumo/dashboard-consumo/templates/modal_id.html","<h3 style=\"text-align:center\">Vincular dispositivo</h3><div class=\"modal_id\"><div><p>Voltaje</p><input type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"dispositivo.voltaje\"></div><div class=\"margin-top\"><p>Code del sensor</p><div class=\"modal_dis\"><input type=\"text\" id=\"id_cont\" readonly=\"\" class=\"nombre_disp\" ng-model=\"dispositivo.code\"></div></div><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\">Vincular sensor</button></div>");
$templateCache.put("app/consumo/dashboard-consumo/templates/modal_lugar.html","<h3 class=\"centrar-texto\">Agregar nuevo lugar</h3><div class=\"modal_id centrar centrar-columna\"><p ng-hide=\"flag_zona\">Nombre</p><input ng-hide=\"flag_zona\" type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"cliente.nombre\"> <button ng-hide=\"flag_zona\" class=\"btn btn-default boton_agregar\" ng-click=\"crear_cliente(cliente)\" ng-if=\"flag_crear_zona\" style=\"margin-top:10px;\">Crear lugar</button><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-show=\"flag_zona\">Se ha creado el lugar exitosamente</p><div><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\" ng-hide=\"flag_crear_zona\">Cerrar</button></div></div>");
$templateCache.put("app/consumo/dashboard-consumo/templates/modal_zona.html","<h3 class=\"centrar-texto\">Agregar nueva zona</h3><div class=\"modal_id centrar centrar-columna\"><p ng-hide=\"flag_zona\">Nombre</p><input ng-hide=\"flag_zona\" type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"zona.nombre\"> <button ng-hide=\"flag_zona\" class=\"btn btn-default boton_agregar\" ng-click=\"crear_zona(zona)\" ng-if=\"flag_crear_zona\" style=\"margin-top:10px;\">Crear zona</button><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-show=\"flag_zona\">Se ha creado la zona exitosamente</p><div><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\" ng-hide=\"flag_crear_zona\">Cerrar</button></div></div>");
$templateCache.put("app/instalador/dashboard-instalador/templates/modal_dia_facturacion.html","<h3 class=\"centrar-texto\">Ingresa el día inicial de facturación</h3><form name=\"formulario\" class=\"modal_id centrar centrar-columna\"><p>Día de facturación</p><input type=\"number\" autofocus=\"\" required=\"\" min=\"1\" max=\"31\" ng-model=\"cliente.dia_facturacion\"><div role=\"alert\"><span class=\"error\" ng-hide=\"formulario.$valid\">El día ingresado no es válido</span></div><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_dia_facturacion(cliente)\" ng-show=\"flag_dia_facturacion&&formulario.$valid\" style=\"margin-top:10px;\">Agregar día de facturación</button><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-hide=\"flag_dia_facturacion\">Se ha agregado el día de facturación exitosamente</p><div style=\"display: flex; justify-content:center; margin-top:10px;\"><button ng-click=\"cerrar()\" ng-hide=\"flag_dia_facturacion\">Cerrar</button></div></form>");
$templateCache.put("app/instalador/dashboard-instalador/templates/modal_id.html","<h3 style=\"text-align:center\">Agregar nuevo dispositivo</h3><div class=\"modal_id\"><div><p>Nombre</p><input type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"dispositivo.nombre\"><p>Voltaje (Vrms) o distancia (m)</p><input type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"dispositivo.potencia\"></div><button ng-click=\"obtener_code(dispositivo)\" class=\"btn btn-default boton_agregar\" ng-if=\"flag_generar\">Generar</button><div class=\"margin-top\"><p>Code</p><div class=\"modal_dis\"><input type=\"text\" id=\"id_cont\" readonly=\"\" class=\"nombre_disp\" ng-model=\"dispositivo.id_nuevo\"> <span class=\"glyphicon glyphicon-copy\" ngclipboard=\"\" data-clipboard-target=\"#id_cont\" ng-click=\"copy()\"></span></div></div><p style=\"color:#0CE889; text-align:center;\" ng-show=\"flag_copy\">Se ha copiado el código exitosamente</p><div style=\"display: flex; justify-content: center; margin-top:10px;\"><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\" ng-hide=\"flag_generar\">Cerrar</button></div></div>");
$templateCache.put("app/instalador/dashboard-instalador/templates/modal_usuarios_cliente.html","<h3 class=\"centrar-texto\">Usuarios de cliente</h3><div class=\"modal_id centrar centrar-columna\"><table class=\"tabla-disp\"><thead><tr><th>Usuario</th><th>Email</th></tr></thead><tbody><tr ng-repeat=\"usuario in cliente.usuarios | orderBy: \'usuario.nombre\'\"><td class=\"cursor\">{{usuario.nombre}}</td><td class=\"cursor\">{{usuario.email}}</td></tr></tbody></table><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-show=\"flag_no_usuario\">Aún no se tienen usuarios para este cliente</p><button class=\"btn btn-default boton_agregar\" ng-click=\"agregar_usuario()\" style=\"margin-top:10px;\">Agregar usuario</button><div><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\">Cerrar</button></div></div>");
$templateCache.put("app/instalador/dashboard-instalador/templates/modal_valor_kwh_mes.html","<div><div><h4>Valor Kwh mensual</h4></div><div class=\"centrar centrar-columna ind-mes\"><p>Seleccione un año</p><select ng-model=\"year_facturacion\" ng-change=\"obtener_valores(year_facturacion)\"><option ng-repeat=\"year in years\">{{year}}</option></select></div><div class=\"margin-top\"><p>Ingrese el valor del Kwh por mes</p></div><div class=\"row\"><div ng-repeat=\"mes in meses\" class=\"ind-mes col-lg-4 col-md-4 col-sm-6 col-xs-6\"><p>{{mes.nombre}}</p><input ng-model=\"meses[$index].valorkwh\" type=\"number\" min=\"0\"></div></div><div class=\"centrar centrar-c margin-top\" ng-hide=\"flag_valores\"><button class=\"btn btn-default boton_agregar\" ng-click=\"addValorkwh(meses, year_facturacion)\">Actualizar</button></div><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-show=\"flag_valores\">Se han actualizado los valores de kwh mensuales correctamente</p><div class=\"centrar centrar-c margin-top\"><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\" ng-show=\"flag_valores\">Cerrar</button></div></div>");
$templateCache.put("app/instalador/dashboard-instalador/templates/modal_zona.html","<h3 class=\"centrar-texto\">Agregar nueva zona</h3><div class=\"modal_id centrar centrar-columna\"><p ng-hide=\"flag_zona\">Nombre</p><input ng-hide=\"flag_zona\" type=\"text\" autofocus=\"\" required=\"\" class=\"nombre_disp\" ng-model=\"zona.nombre\"> <button ng-hide=\"flag_zona\" class=\"btn btn-default boton_agregar\" ng-click=\"crear_zona(zona)\" ng-if=\"flag_crear_zona\" style=\"margin-top:10px;\">Crear zona</button><p style=\"color:#0CE889; text-align:center; margin-top:10px;\" ng-show=\"flag_zona\">Se ha creado la zona exitosamente</p><div><button ng-click=\"cerrar()\" class=\"btn btn-default boton_agregar\" ng-hide=\"flag_crear_zona\">Cerrar</button></div></div>");
$templateCache.put("app/instalador/forms/project/new_project.html","<div class=\"row\"><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nuevo Cliente\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start\"><form name=\"newClientForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label>Nombre</label> <input type=\"text\" ng-model=\"newClient.nombre\" autofocus=\"\" required=\"\" ng-class=\"{\'input-invalid\': newClient.nombre.$touched && newClient.nombre.$invalid}\"> <label>País</label><select ng-model=\"newClient.pais\" ng-options=\"value as value.nombre for (key,value) in paises\" id=\"pais\" name=\"pais\" ng-class=\"{\'input-invalid\': newClient.pais.$touched && newClient.pais.$invalid}\" required=\"\" ng-change=\"getStates(newClient.pais)\"></select><label>Estado / Departamento</label><select ng-model=\"newClient.estado\" ng-options=\"value as value.nombre for (key,value) in estados\" id=\"estado\" name=\"estado\" ng-class=\"{\'input-invalid\': newClient.estado.$touched && newClient.estado.$invalid}\" required=\"\" ng-change=\"getCitys(newClient.estado)\"></select><label>Ciudad</label><select ng-model=\"newClient.ciudad\" ng-options=\"value as value.nombre for (key,value) in ciudades\" id=\"ciudad\" name=\"ciudad\" ng-class=\"{\'input-invalid\': newClient.ciudad.$touched && newClient.ciudad.$invalid}\" required=\"\"></select><label>Dirección</label> <input type=\"text\" ng-model=\"newClient.direccion\" required=\"\"> <label>Teléfono</label> <input type=\"tel\" ng-model=\"newClient.tel\" required=\"\" ng-class=\"{\'input-invalid\': newClient.tel.$touched && newClient.tel.$invalid}\"><div class=\"centrar centrar-justificar-inicio width-100p\"><label>¿Este cliente es de Integración?</label> <input style=\"height: 20px; width: 20px; margin: 10px 0 0 10px;\" type=\"checkbox\" ng-model=\"with_api\" name=\"integracion\" id=\"integracion\"></div><div ng-if=\"with_api\" class=\"width-100p\"><label>Tipo de integración</label><select ng-model=\"newClient.integracion\" name=\"\" id=\"\"><option ng-repeat=\"integracion in integraciones\" value=\"{{integracion.id}}\">{{integracion.name}}</option></select></div><div class=\"centrar\"><input type=\"submit\" ng-disabled=\"!newClientForm.$valid\" value=\"Agregar\" class=\"cursor margin-right-10\" ng-class=\"{\'btn-guardar\':newClientForm.$valid}\" ng-click=\"addClient(newClient)\"> <input type=\"button\" value=\"Cancelar\" class=\"btn-cerrar cursor margin-right-10\" ng-click=\"cancelar()\"></div></form></div></div></div>");
$templateCache.put("app/instalador/users/newUser/newUser.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nuevo usuario\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start\"><form name=\"newUserForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label>Nombre</label> <input type=\"text\" ng-model=\"newUser.nombre\" name=\"name\" required=\"\"> <label>Apellido</label> <input type=\"text\" ng-model=\"newUser.apellido\" name=\"name\" required=\"\"> <label>Correo</label> <input type=\"email\" ng-model=\"newUser.email\" name=\"email\" required=\"\"><div ng-if=\"!edit\" class=\"width-100p\"><label>Contraseña</label> <input type=\"text\" ng-model=\"newUser.contrasena\" name=\"password\" required=\"\"></div><label>Rol</label><select ng-model=\"newUser.rol\" ng-options=\"i.value as i.text for i in roles\" id=\"roles\" name=\"roles\" required=\"\"></select><label for=\"\">Seleccionar Avatar</label><div class=\"avatar centrar centrar-flex-flow width-100\"><div ng-repeat=\"avatar in avatares\"><div class=\"cont-avatar cursor\" ng-click=\"getAvatar(avatar)\"><img ng-src=\"../../../assets/img/app/avatares/{{avatar.link}}\" alt=\"\"></div><label class=\"container-checkbox\"><input type=\"checkbox\" ng-model=\"avatar.status\" ng-change=\"getAvatar(avatar)\"> <span class=\"checkmark\"></span></label></div></div><div><input type=\"submit\" value=\"{{edit ? \'Editar\' : \'Agregar\'}}\" class=\"cursor\" ng-disabled=\"!newUserForm.$valid\" ng-class=\"{\'btn-guardar\': newUserForm.$valid}\" ng-click=\"addUser(newUser)\"> <input type=\"button\" value=\"Cancelar\" class=\"btn-cerrar cursor\" ng-click=\"cancelar()\"></div></form></div></div></div>");
$templateCache.put("app/instalador/users/userCard/userCard.html","<div class=\"panel panel-primary bootstrap-panel animated zoomIn panel-user centrar-c centrar-columna\"><div class=\"centrar centrar-columna\"><div class=\"dropdown\"><div class=\"dropdown-toggle alert-card-btn-options cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-c\"></span></div><ul class=\"dropdown-menu alert-card-options\"><a ui-sref=\"users.newUser({user: user, parm:\'edit\'})\"><li class=\"cursor\">Editar</li></a><li class=\"cursor\" ng-click=\"deleteUser(user)\">Borrar</li></ul></div><div class=\"avatar\"><img ng-src=\"../../../assets/img/app/avatares/{{user.avatar.link}}\" alt=\"\"></div></div><div class=\"centrar centrar-columna user-info\"><h2>{{user.nombre}} {{user.apellido}}</h2><p>{{user.email}}</p><p>{{user.rol == \'0\' ? \'Controlador\': \'Visualizador\' }}</p></div></div>");
$templateCache.put("app/admin/facturacion/valor_kwh/valor_kwh.html","");
$templateCache.put("app/operador/ofertas/generar/generar.html","");
$templateCache.put("app/operador/ofertas/historial/historial.html","");
$templateCache.put("app/operador/ofertas/modals/enviar_pago.html","<div class=\"modal-message modal-success\"><div class=\"modal-title\"><h3>Pago Ofertas mes de {{mes}}</h3></div><div class=\"modal-body\"><div><table class=\"tabla_pagar width-100\"><tr><td>Ofertas totales</td><td>{{info_pago.ofertas_totales}}</td></tr><tr><td>Carga desconectada Total</td><td>{{info_pago.carga_desconectada_total}}</td></tr><tr><td>Horas desconectadas</td><td>{{info_pago.horas_desconectadas}}</td></tr><tr><td>Numero de clientes participantes</td><td>{{info_pago.clientes_participantes}}</td></tr><tr><td>Total KWh desconectados</td><td>{{info_pago.total_kwh_desconectados}}</td></tr><tr><td>Total a pagar</td><td>{{info_pago.total_pagar}}</td></tr></table></div><div class=\"centrar centrar-justificar-final padding-2\"><form method=\"post\" action=\"https://sandbox.gateway.payulatam.com/ppp-web-gateway/\"><input name=\"merchantId\" type=\"hidden\" value=\"508029\"> <input name=\"accountId\" type=\"hidden\" value=\"512321\"> <input name=\"description\" type=\"hidden\" value=\"Test PAYU\"> <input name=\"referenceCode\" type=\"hidden\" value=\"0000000000\"> <input name=\"amount\" type=\"hidden\" value=\"3\"> <input name=\"tax\" type=\"hidden\" value=\"0\"> <input name=\"taxReturnBase\" type=\"hidden\" value=\"0\"> <input name=\"currency\" type=\"hidden\" value=\"COP\"> <input name=\"signature\" type=\"hidden\" value=\"857ec5667d6220ed36fd0233167ec0ea\"> <input name=\"test\" type=\"hidden\" value=\"1\"> <input name=\"buyerEmail\" type=\"hidden\" value=\"juan.giraldo@intelmotics.com\"> <input name=\"responseUrl\" type=\"hidden\" value=\"http://www.test.com/response\"> <input name=\"confirmationUrl\" type=\"hidden\" value=\"http://www.test.com/confirmation\"> <input name=\"Submit\" class=\"btn btn-default\" type=\"submit\" value=\"Pagar\" ng-click=\"enviar()\"></form></div></div></div>");
$templateCache.put("app/profile/components/business-card/business-card.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn user-info\"><div class=\"panel-heading clearfix centrar\"><h3 class=\"panel-title\">Información Empresa</h3></div><div class=\"panel-body centrar centrar-flex-flow width-100p\"><div class=\"centrar centrar-c centrar-columna width-100p\"><div ng-if=\"loading\"><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div><div ng-if=\"!loading\" class=\"centrar centrar-c centrar-columna width-100p\"><div class=\"user-image\" ng-if=\"business.image !== \'\'\"><img ng-src=\"{{business.image}}\" alt=\"\"></div><div ng-if=\"!business.image || business.image === \'\'\" class=\"image-default centrar centrar-c\"><p class=\"margin-0\">{{business.cliente.substring(0,1)}}</p></div><div class=\"centrar\"><p class=\"cursor btn-edit-image\" ng-click=\"deleteImage()\">Borrar</p><div><label for=\"file\" class=\"cursor btn-edit-image\">Cambiar</label> <input id=\"file\" type=\"file\" ng-model=\"image\" name=\"file\" ng-change=\"setImage(image)\" onchange=\"angular.element(this).scope().setImage()\"></div></div></div></div><div class=\"centrar centrar-columna width-100p\"><form name=\"infoClientForm\" class=\"centrar centrar-columna centrar-align-start cont-info width-100p\"><div class=\"centrar centrar-align-self-end btn-edit\" ng-if=\"!editMode\"><p class=\"cursor\" ng-click=\"openEditMode()\"><span class=\"ion-edit\"></span> Editar</p></div><div ng-if=\"!editMode\"><h4>{{business.cliente}}</h4><p>Nombre Empresa</p><h4>{{business.direccion}}</h4><p>Dirección</p><h4>{{business.ciudad}} - {{business.pais}}</h4><p>Ciudad - País</p><h4>{{business.telefono}}</h4><p>Teléfono</p></div><div ng-if=\"editMode\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label for=\"name\">Nombre</label> <input type=\"text\" name=\"nombre\" ng-model=\"business.cliente\" required=\"\"> <label for=\"direccion\">Dirección</label> <input type=\"text\" name=\"direccion\" ng-model=\"business.direccion\" required=\"\"> <label for=\"pais\">País</label><select ng-model=\"business.id_pais\" id=\"pais\" name=\"pais\" required=\"\" ng-change=\"getStates(business.id_pais, true)\"><option ng-repeat=\"pais in paises\" value=\"{{pais.id}}\">{{pais.nombre}}</option></select><label for=\"estado\">Estado / Departamento</label><select ng-model=\"business.id_estado\" id=\"estado\" name=\"estado\" required=\"\" ng-change=\"getCitys(business.id_estado, true)\"><option ng-repeat=\"estado in estados\" value=\"{{estado.id}}\">{{estado.nombre}}</option></select><label for=\"cuidad\">Ciudad</label><select ng-model=\"business.id_ciudad\" id=\"ciudad\" name=\"ciudad\" required=\"\" ng-change=\"setCity(business.id_ciudad)\"><option ng-repeat=\"ciudad in ciudades\" value=\"{{ciudad.id}}\">{{ciudad.nombre}}</option></select><label for=\"telefono\">Teléfono</label> <input type=\"tel\" name=\"telefono\" ng-model=\"business.telefono\" required=\"\"><div class=\"centrar\"><button ng-click=\"editProfile(infoClientForm.$valid, infoClientForm.$dirty)\" class=\"btn-save\">Guardar</button> <button class=\"btn-cancel\" ng-click=\"openEditMode()\">Cancelar</button></div></div></form></div></div></div></div>");
$templateCache.put("app/profile/components/user-info/user-info.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn user-info\"><div class=\"panel-heading clearfix centrar\"><h3 class=\"panel-title\">Información Usuario</h3></div><div class=\"panel-body centrar centrar-flex-flow width-100p\"><div class=\"centrar centrar-c width-100p\"><div class=\"image-default centrar centrar-c\"><p class=\"margin-0\">{{user.nombre.substring(0,1)}}{{user.apellido.substring(0,1)}}</p></div></div><div class=\"centrar centrar-columna width-100p\"><form name=\"infoUserForm\" class=\"centrar centrar-columna centrar-align-start cont-info width-100p\"><div class=\"centrar centrar-align-self-end btn-edit\" ng-if=\"!editMode\"><p class=\"cursor\" ng-click=\"openEditMode()\"><span class=\"ion-edit\"></span> Editar</p></div><div ng-if=\"!editMode\"><h4>{{user.nombre}} {{user.apellido}}</h4><p>Nombre</p><h4>{{user.email}}</h4><p>Correo</p></div><div ng-if=\"editMode\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label for=\"name\">Nombre</label> <input type=\"text\" name=\"nombre\" ng-model=\"user.nombre\" required=\"\"> <label for=\"apellido\">Apellido</label> <input type=\"text\" name=\"apellido\" ng-model=\"user.apellido\" required=\"\"><div class=\"centrar\"><label for=\"correo\">Correo</label><div uib-dropdown=\"\"><a uib-dropdown-toggle=\"\"><span class=\"ion-android-alert cursor icon-ind\"></span></a><ul class=\"dropdown-menu padding-2\" uib-dropdown-menu=\"\"><li>No puedes cambiar tu correo</li></ul></div></div><input type=\"email\" name=\"correo\" ng-model=\"user.email\" disabled=\"\" required=\"\"><div class=\"centrar\"><button ng-click=\"editUserProfile(infoUserForm.$valid, infoUserForm.$dirty)\" class=\"btn-save\">Guardar</button> <button class=\"btn-cancel\" ng-click=\"openEditMode()\">Cancelar</button></div></div></form><div class=\"centrar centrar-columna centrar-align-start cont-pass width-100p\"><div class=\"centrar centrar-align-self-end btn-edit\"><p class=\"cursor\" ng-click=\"editPass()\"><span class=\"ion-edit\"></span> Cambiar</p></div><h4>***********</h4><p>Contraseña</p></div></div></div></div></div>");
$templateCache.put("app/settings/components/add-holiday-date/add-holiday-date.html","<div class=\"centrar holidays-step-2\"><h4>Lista de feriados</h4><button type=\"button\" class=\"btn-add-activo btn-add-holiday centrar centrar-c\" ng-click=\"addHoliday()\"><span class=\"ion-plus-round\"></span></button></div><div class=\"centrar centrar-flex-flow centrar-justificar-inicio margin-top margin-bottom-20\"><div class=\"centrar holiday\" ng-repeat=\"holiday in holidays\"><p class=\"centrar centrar-c\">{{holiday.day | date : \'dd/MM/yyyy\'}}</p><div class=\"button-delete cursor centrar centrar-c\" ng-click=\"deteleHoliday(holiday)\"><span class=\"ion-close-round\"></span></div></div><div class=\"centrar centrar-c width-100p centrar-columna\"><loading-content loading=\"loading\"></loading-content><p ng-if=\"holidays.length === 0 && loading === false\">No se ha agregado ninguna fecha todavía</p></div></div>");
$templateCache.put("app/settings/components/holidays-by-country/holidays-by-country.html","<div class=\"holidays-by-country\"><div class=\"centrar\"><h3 style=\"margin: 20px 0 30px 0;\">Gestión de Días Feriados</h3></div><div class=\"centrar\"><h4>Países</h4><button type=\"button\" style=\"width: 200px;\" class=\"btn-add-activo centrar centrar-c\" ng-click=\"gotoAddCountry(0)\">Agregar País</button></div><div class=\"centrar centrar-columna\" ng-if=\"countries.length > 0\"><div class=\"centrar centrar-columna width-100p\" ng-repeat=\"country in countries\"><div class=\"centrar width-100p cont-country-holiday cursor\"><p ng-click=\"getHoliday(country)\" ng-class=\"{\'bold\' : country.open}\">{{country.nombre}}</p><div class=\"centrar\"><span class=\"cursor\" ng-click=\"getHoliday(country)\" ng-class=\"{\'ion-chevron-down\' : !country.open, \'ion-chevron-up\' : country.open}\"></span><div class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-c\"></span></div><ul class=\"dropdown-menu\"><li class=\"cursor\" ng-click=\"deleteCountry(country)\">Borrar</li></ul></div></div></div><div class=\"width-100p\" style=\"padding: 0 20px;\" ng-if=\"country.open\"><add-holiday-date loading=\"loading\" country=\"country\" holidays=\"country.holidays\"></add-holiday-date></div></div></div></div>");
$templateCache.put("app/settings/components/create-holidays/create-holidays.html","<div ng-if=\"step_1\" class=\"centrar centrar-columna holidays-step-1\"><div class=\"centrar centrar-align-start centrar-columna\"><h3 style=\"margin: 20px 0 30px 0;\">Gestión de Días Feriados</h3><p>En este módulo puedes configurar los días festivos específicos de cada país. Estos serán considerados automáticamente al generar programaciones y establecer alertas dentro de la plataforma, optimizando la gestión de eventos y tareas.</p><button type=\"button\" class=\"btn-add-activo centrar centrar-c\" ng-click=\"next(2)\">Agregar País</button></div><div class=\"insight-holidays\"><img src=\"../../../assets/img/holidays.svg\" alt=\"\"></div></div><div ng-if=\"step_2\" class=\"holidays-step-2 form-mantenimiento\"><h3>Gestión de Días Feriados</h3><label>País</label><select ng-model=\"pais\" ng-options=\"value as value.nombre for (key,value) in paises\" id=\"pais\" name=\"pais\" ng-class=\"\" ng-change=\"validatedCountry(pais)\"></select><add-holiday-date ng-if=\"pais\" country=\"pais\" holidays=\"holidays\"></add-holiday-date></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::subSubitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\">{{ ::subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-disabled=\"$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span> previous</button></li><li class=\"next\"><button ng-disabled=\"$baWizardController.isLastTab()\" ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">next <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>");
$templateCache.put("app/theme/components/breadCrumbs/breadCrumbs.html","<div class=\"content-top clearfix\"><ul class=\"breadcrumb al-breadcrumb transform cont-breadcrumb\"><li class=\"cursor\" ng-repeat=\"ind in breadCrumb | orderBy:\'order\'\" ng-click=\"validateState(ind)\">{{ ind.title }}</li></ul></div>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ activePageTitle }}</h1><ul class=\"breadcrumb al-breadcrumb transform\"><li ng-if=\"home == \'0\'\"><a href=\"#/dashboard_cliente\">Home</a></li><li ng-if=\"home == \'1\'\"><a href=\"#/dashboard_op\">Home</a></li><li ng-if=\"home == \'2\'\"><a href=\"#/dashboard_admin\">Home</a></li><li ng-if=\"home == \'3\'\"><a href=\"#/dashboard_instalador\">Home</a></li><li ng-if=\"home == \'4\'\"><a href=\"#/dashboard_consumo\">Home</a></li></ul></div>");
$templateCache.put("app/theme/components/loading/loading.html","<div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><div class=\"cont-msg\"><div class=\"msg-icon\"><img src=\"../../../../assets/icons/icon_messages.svg\" alt=\"\"></div><div class=\"centrar centrar-c notification-ind\"><span>{{indNotifications}}</span></div></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Mensajes</strong></div><div class=\"msg-list\"><a ng-repeat=\"msg in notifications | orderBy:\'-fecha\' | limitTo: \'5\'\" class=\"cursor\"><div class=\"msg-area centrar\" ng-click=\"{{msg.action}}\"><div class=\"centrar centrar-c ind-icon share\" ng-class=\"{\'maintenance\' : msg.tipo == 1, \'temp\' : msg.tipo == 2,\'share\' : msg.tipo == 3}\"><span class=\"{{msg.icon}}\"></span></div><div><p>{{ msg.descripcion }}</p><span>{{ msg.tiempo }}</span></div></div></a><div class=\"msg-area padding-2\" ng-if=\"notifications.length == 0\"><div>No tienes mensajes actualmente</div></div></div><a ui-sref=\"notifications\"><div class=\"msg-area msg-footer\"><p>Ver todos</p></div></a></div></li></ul>");
$templateCache.put("app/theme/components/pageFooter/pageFooter.html","<footer class=\"al-footer clearfix\"><div class=\"al-footer-right\">Creado con <i class=\"ion-heart\"></i> en Colombia por <a href=\"https://helo.com.co/\" target=\"_blank\">Ⓒ Helo.</a> {{today | date : \'yyyy\'}}</div></footer>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix {{class_header}}\" scroll-position=\"scrolled\" max-height=\"50\"><div><a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a> <a href=\"{{link_dashboard}}\" class=\"al-logo clearfix\"><div class=\"cont-logo-left\"><img ng-src=\"{{marketer.status ? marketer.img : logo_helo}}\"></div></a></div><div class=\"user-profile clearfix centrar centrar-justificar-final\"><div class=\"centrar centrar-columna centrar-align-start cont-logo-helo\" ng-if=\"marketer.status\"><p class=\"power-by\">Powered by</p><div class=\"cont-logo-right\"><img ng-src=\"{{marketer.status ? logo_helo: \' \'}}\" alt=\"\"></div></div><div class=\"icon-search cursor\" ng-if=\"id_rol === \'6\' || id_rol === \'8\' || id_rol === \'12\'\" ng-click=\"openModalSearch()\"><img src=\"../../../../assets/icons/icon_search.svg\" alt=\"\"></div><msg-center></msg-center><div class=\"icon-alert-not\" ng-if=\"showSideBarAlertsIcon\" ng-click=\"showSideBarAlerts()\"><img src=\"../../../../assets/icons/alert.svg\" alt=\"\"><div ng-if=\"active_alerts > 0\" class=\"centrar centrar-c notification-ind\"><span>{{active_alerts}}</span></div></div><div uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><div class=\"icon-perfil\"><img src=\"../../../../assets/icons/icon_profile.svg\" alt=\"\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu menu-perfil\"><i class=\"dropdown-arr\"></i><div class=\"cont-ind-perfil\"><p class=\"nombre\">¡Hola {{user_name | limitTo: 20}}{{user_name.length > 20 ? \'...\': \'\'}}!</p><p class=\"membresia\" ng-if=\"membershipType\">Plan {{membershipType}}</p><p class=\"dias\" ng-if=\"daysMembership\">Tienes {{daysMembership}} {{daysMembership !== 1 ? \'días\' : \'día\'}} de tu plan</p></div><div class=\"msg-list\"><div class=\"cont-item-dropdown-menu\"><div><div ng-click=\"goProfile()\">Ver perfil</div></div></div><div class=\"cont-item-dropdown-menu\"><div><div ng-click=\"goMembershipCoupon()\">Tengo un Cupón Helo</div></div></div><div class=\"cont-item-dropdown-menu\"><div><div class=\"centrar\" ng-click=\"activeMonitoringMode()\">Activar modo monitoreo <span class=\"btn-monitoring\" ng-class=\"{\'ion-toggle-filled btn-monitoring-on\' : monitoringMode === \'1\', \'ion-toggle\' : monitoringMode === \'0\'}\"></span></div></div></div><div ng-if=\"accessHiddenZones\" class=\"cont-item-dropdown-menu\"><div><div class=\"centrar\" ng-click=\"showHiddenZones()\">Mostrar Zonas ocultas <span class=\"btn-monitoring\" ng-class=\"{\'ion-toggle-filled btn-monitoring-on\' : hiddenZones === \'1\', \'ion-toggle\' : hiddenZones === \'0\'}\"></span></div></div></div><div class=\"cont-item-dropdown-menu\"><div><div ng-click=\"goToGeneralSettings()\">Configuraciones</div></div></div><div class=\"cont-item-dropdown-menu\"><div><div ng-click=\"cerrar_sesion()\">Cerrar sesión</div></div></div></div></div></div></div></div>");
$templateCache.put("app/theme/components/selectable-list/selectable-list.html","<div class=\"centrar centrar-columna width-100p\"><div class=\"centrar centrar-justificar-inicio width-100p panel-selected\"><div class=\"has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"search\"> <i class=\"ion-search form-control-feedback\"></i></div><div class=\"centrar\" style=\"margin-left: 20px;\"><p class=\"margin-0\">Seleccionar todo</p><input style=\"margin: 0 0 0 20px;\" type=\"checkbox\" ng-model=\"select_all\" ng-change=\"selectAll(select_all)\"></div></div><div class=\"centrar centrar-columna centrar-justificar-inicio width-100p cont-select\" style=\"max-height: 400px;\"><div ng-if=\"loading === false || items.length > 0\" ng-repeat=\"itm in items track by $index\" class=\"centrar centrar-justificar-inicio width-100p itm-select\"><input style=\"margin-right: 10px;\" ng-model=\"itm.status\" ng-change=\"addToList()\" type=\"checkbox\"><p>{{itm[label]}}</p></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div></div>");
$templateCache.put("app/theme/components/selectedField/selectedField.html","<div class=\"centrar centrar-columna\"><div class=\"centrar centrar-justificar-inicio width-100p centrar-flex-flow\"><div ng-repeat=\"itmMatch in ngModel track by $index\" class=\"centrar matchElement\"><div class=\"info-user\"><p>{{itmMatch}}</p></div><div class=\"button-close cursor\" ng-click=\"deteleUser(itmMatch)\"><span class=\"ion-close-round\"></span></div></div></div><input type=\"text\" ng-model=\"newItem\" ng-keyup=\"addItemToMatches($event, newItem)\" ng-blur=\"addItemToMatchesBlur(newItem)\" ng-focus=\"showListaOptiones = true\"><div ng-show=\"showListaOptiones\" class=\"width-100p\"><div ng-if=\"lista.length != 0\" class=\"centrar centrar-columna centrar-align-start lista-optiones width-100p\"><p><strong>Sugerencias</strong></p><div class=\"cursor width-100p\" ng-repeat=\"itm in lista | filter:newItem\" ng-click=\"addItem(itm)\">{{ itm }}</div></div></div><div ng-if=\"emailInvalido\"><p>Ingresa un correo válido</p></div><div ng-if=\"emailYaExiste\"><p>El correo ya ha sido agregado</p></div></div>");
$templateCache.put("app/theme/components/selector-filter/selector-filter.html","<div class=\"centrar centrar-columna centrar-c centrar-align-start selector-filter\"><div class=\"centrar width-100p cursor\" ng-click=\"open = !open\"><p style=\"margin: 0px; padding: 15px;\">{{selectedItem.nombre}}</p><span style=\"margin-right: 10px;\" class=\"ion-chevron-down\"></span></div><div ng-if=\"open\" class=\"list-cont\"><div class=\"has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"search\"> <i class=\"ion-search form-control-feedback\"></i></div><div class=\"list-filter\"><p ng-click=\"selectZone(item)\" class=\"cursor\" ng-repeat=\"item in filteredItems\">{{item.nombre}}</p></div></div></div>");
$templateCache.put("app/theme/components/seletedList/selectedList.html","<div class=\"centrar centrar-columna\"><div class=\"centrar centrar-justificar-inicio width-100p centrar-flex-flow\"><div ng-repeat=\"itmMatch in ngModel track by $index\" class=\"centrar matchElement\"><div class=\"info-user\"><p>{{itmMatch.nombre}}</p></div><div class=\"button-close cursor\" ng-click=\"deteleItem(itmMatch)\"><span class=\"ion-close-round\"></span></div></div></div><select ng-model=\"newItem\" ng-change=\"addItem(newItem); selected()\"><option ng-repeat=\"itm in lista\" value=\"{{itm}}\">{{itm.nombre}}</option></select></div>");
$templateCache.put("app/theme/components/sidebar-alerts/sidebar-alerts.html","<div class=\"sidebar-alerts\" ng-if=\"rol === \'6\' || rol === \'8\'\" ng-class=\"{\'openedSidebar\': open_not}\"><div class=\"centrar centrar-align-start centrar-c centrar-columna centrar-justificar-inicio cont-sidebar-alerts width-100p\"><div class=\"title centrar width-100p\"><div class=\"centrar centrar-justificar-inicio\"><div class=\"icon-alert-not\"><img src=\"../../../../assets/icons/alert.svg\" alt=\"\"></div><p>Alertas</p></div><div class=\"centrar centrar-c trigger cursor\" ng-class=\"{\'trigger-off\': !trigger}\" ng-click=\"notTrigger()\"><span ng-class=\"{\'ion-android-notifications\': trigger, \'ion-android-notifications-off\': !trigger}\"></span></div></div><div class=\"show-bottom cursor centrar centrar-c\" ng-click=\"openSideBar()\"><span ng-class=\"{\'ion-chevron-left\': open_not , \'ion-chevron-right\': !open_not }\"></span></div><div class=\"width-100p\"><div class=\"search-not width-100p\"><input type=\"search\" class=\"search-zone width-100p\" ng-model=\"search_ind\" placeholder=\"Buscar alerta\" ng-keyup=\"filtrarNot(search_ind)\"></div><div class=\"sidebar-cont-alerts-open centrar centrar-columna centrar-align-start\"><div class=\"not-alert centrar width-100p cursor animated fadeInUp\" ng-repeat=\"not in notfiltered\" ng-click=\"gotoAlerts(not)\"><h3>{{not.nombre | limitTo: 20}}{{not.nombre.length > 20 ? \'...\' : \'\'}}</h3><div class=\"not-ind centrar centrar-c\" ng-class=\"not.class\"><p>{{not.cantidad}}</p></div></div></div><loading-content ng-if=\"open_not\" loading=\"loading\"></loading-content><div ng-if=\"notificationsAlerts.length === 0 && loading === false && open_not\"><p style=\"padding: 10px; text-align: center;\">No hay alertas generadas</p></div><div class=\"sidebar-cont-alerts-close centrar centrar-c centrar-columna\"><div class=\"not-alert-short centrar centrar-c animated zoomIn\" ng-class=\"not.class\" ng-repeat=\"not in notfiltered | limitTo : 14 : 0\"><p>{{shortName(not.nombre)}}</p></div><div ng-if=\"notfiltered.length > 14\" class=\"centrar centrar-columna preview-more\"><p class=\"ind-more-1\"></p><p class=\"ind-more-2\"></p><p class=\"ind-more-3\"></p></div></div></div></div></div>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/consumption-devices/consumption-devices.html","<div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><p class=\"titulo\">Consumo por Dispositivo</p><div class=\"panel panel-primary bootstrap-panel zoomIn panel-smart-bar\"><div class=\"panel-heading holder_header centrar centrar-columna\"><div class=\"centrar width-100p\"><div class=\"h_titulo\"><select class=\"select-maintenance-zone\" ng-model=\"id\" ng-change=\"getConsumption(id)\" ng-options=\"zona.id as zona.nombre for zona in zones\" id=\"zonas\" name=\"zonas\"></select><div class=\"has-feedback cont-buscar width-100p\"><input ng-model=\"buscar\" placeholder=\"Buscar dispositivo\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"text\"> <i class=\"ion-search form-control-feedback\"></i></div></div><div><selected-filter nombre=\"\'Ordenar por\'\" lista=\"listaOrden\" selected=\"filterOrderBy\"></selected-filter></div></div><div class=\"centrar centrar-align-self-start\"><p class=\"ind-filter\" ng-repeat=\"filter in filters\">{{filter | limitTo: 15}}{{filter.length > 15 ? \'...\': \' \'}}</p></div></div><div class=\"panel-body cont-sm-card-with-scroll\"><div class=\"cont-sm-card-with-scroll\"><div class=\"cont-sm-card-list\"><div class=\"centrar sm-card-list-item cursor\" ng-repeat=\"device in devicesFiltered\" ng-click=\"goConsumptionGraphics(device)\"><div class=\"centrar centrar-columna centrar-align-start sm-card-list-item-ind\"><p>{{device.nombre}}</p><p class=\"sub-ind\">Zona: {{device.nombre_zona}}</p></div><div class=\"centrar centrar-columna sm-card-list-item-comp\"><p>{{device.consumo}}</p><p class=\"itm-unit\">KWH</p></div></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div></div><div class=\"cont-date-picker\"><date-picker-consumption class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" selected-date=\"getConsumption\"></date-picker-consumption></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/consumption-pie-chart/consumption-pie-chart.html","<div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><p class=\"titulo\">Gráfica de consumo por dispositivo</p><div class=\"panel panel-primary bootstrap-panel animated zoomIn panel-smart-bar\"><div class=\"panel-heading holder_header centrar centrar-columna\"><div class=\"centrar width-100p\"><div class=\"h_titulo\"><select class=\"select-maintenance-zone\" ng-model=\"id\" ng-change=\"getConsumption_(id)\" ng-options=\"zona.id as zona.nombre for zona in zones\" id=\"zonas\" name=\"zonas\"></select></div></div></div><div class=\"panel-body\"><div class=\"cont-sm-card-list\"><div id=\"chartdiv\" class=\"cont-pie-chart\"></div><div id=\"legendwrapper\"><div id=\"legenddiv\" class=\"cont-legend-chart\"></div></div><loading-content loading=\"loading_\" no-info=\"noInfo_\"></loading-content></div><div class=\"margin-top\"><date-picker-consumption selected-date=\"getConsumption_\"></date-picker-consumption></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/datePickerConsumption/datePickerConsumption.html","<div class=\"panel-smart-bar date-picker-consumption\"><div class=\"centrar centrar-columna centrar-align-start date-header\"><select ng-model=\"selectedIntervalDates\" ng-change=\"setIntelval(selectedIntervalDates)\"><option ng-repeat=\"option in intervalsDates\" value=\"{{option.value}}\">{{option.nombre}}</option></select></div><div class=\"centrar centrar-columna centrar-align-start\" style=\"margin-bottom: 20px;\" ng-if=\"customInterval\"><div class=\"centrar margin-top-10 cont-type-interval\"><p class=\"custom-title\" style=\"margin: 0;\">Intervalo</p><div class=\"centrar\" style=\"margin-left: 10px;\"><div ng-click=\"changeInterval(filter.type)\" class=\"filtro-s cursor\" ng-class=\"{\'filtro-activo\':filter.status == true}\" ng-repeat=\"filter in filtersDates\"><p>{{filter.name}}</p></div></div></div><div class=\"centrar width-100p margin-top\"><div class=\"width-100p\" style=\"margin-right: 20px;\"><p class=\"custom-title\">Fecha inicial</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_ini\" is-open=\"popup.opened_1\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"consultaConsumos(date)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"width-100p\"><p class=\"custom-title\">Fecha Final</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_final\" is-open=\"popup.opened_2\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"consultaConsumos(date)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/energy-graphic/energy-graphic.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Gráfica Energía - {{nombreDispositivo}} <span class=\"label label-info\" ng-if=\"estimated\" title=\"Consumo estimado a partir de la corriente medida y la potencia nominal del dispositivo\">Estimado</span> <span class=\"label label-warning\" ng-if=\"partial\" title=\"El día aún no termina: solo se muestran las horas transcurridas\">Día en curso</span></h3></div><div class=\"panel-body centrar centrar-columna\"><div class=\"centrar width-100p\"><p class=\"margin-0\">KWh</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"grafica_energia\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"setFilter(filter)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/ind-active-power/content.html","<p>En sistemas monofasicos: Ese número se obtiene así: V*FP</p><p>V: voltaje. FP: Factor de potencia</p>");
$templateCache.put("app/cliente/consumo_v2/components/ind-active-power/ind-active-power.html","<div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-12\"><div class=\"panel animated zoomIn\"><div class=\"panel-heading clearfix centrar\"><h3 class=\"panel-title\">Factor multiplicador</h3><p><button uib-popover-template=\"content\" popover-title=\"\'¿Como calcular la potencia activa?\'\" type=\"button\" class=\"btn btn-default\">Info</button></p></div><div class=\"panel-body\"><div class=\"centrar centrar-c\"><div class=\"centrar centrar-align-start\" ng-if=\"!editar_limite\"><p class=\"margin-0 consolidado-dato consolidado-dato-limite\">{{activePower}}</p><p class=\"margin-0 consolidado-unidad\">V</p><div class=\"centrar\"><span class=\"ion-edit icon-editar cursor\" ng-click=\"editMode()\"></span></div></div><div ng-if=\"editar_limite\"><input type=\"number\" ng-model=\"newActivePower\" ng-value=\"activePower\" class=\"editar-limite-mantenimiento\"><div class=\"centrar centrar-c\"><div class=\"centrar centrar-c btn-editar btn-guardar cursor\" ng-click=\"setActivePower(newActivePower)\"><p class=\"margin-0\">Guardar</p></div><div class=\"centrar centrar-c btn-editar btn-cerrar cursor\" ng-click=\"editMode()\"><p class=\"margin-0\">Cerrar</p></div></div></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/ind-data/ind-data.html","<div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-6\" style=\"padding: 0 !important; margin-left: 15px;\"><div class=\"ind-data panel centrar centrar-columna centrar-align-start\"><h3>{{indTitle}}</h3><div class=\"centrar\"><h2>{{ind}} {{unit}}</h2></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/ind-totalizador/ind-totalizador.html","<div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\"><div class=\"panel animated zoomIn\"><div class=\"panel-body ind-totalizador\"><div class=\"centrar margin-bottom-20\"><h3>{{indTitle}}</h3><selected-filter nombre=\"\'Mes\'\" lista=\"meses\" selected=\"changeInterlval\" ng-if=\"hasSelect\"></selected-filter></div><div class=\"centrar centrar-align-start centrar-columna\"><div class=\"centrar\"><h2>{{ind | currency: unit}} {{ind === null ? \'--\' : \'\'}}</h2></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/invoice-value-graphic/invoice-value-graphic.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Gráfica Valor Factura</h3></div><div class=\"panel-body centrar centrar-columna\"><div class=\"centrar width-100p\"><p class=\"margin-0\">$</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"grafica_valor_factura\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/kwh-consumed-graphic/kwh-consumed-graphic.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Gráfica {{name_graphic}}</h3></div><div class=\"panel-body centrar centrar-columna\"><div class=\"centrar width-100p\"><p class=\"margin-0\">{{unit}}</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"grafica_kwh_consumidos\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"margin-10\"><p class=\"custom-title\">Fecha inicial</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_ini\" is-open=\"popup.opened_1\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date(date)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"margin-10\"><p class=\"custom-title\">Fecha Final</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_final\" is-open=\"popup.opened_2\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date(date)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/no-factura/no-factura.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"no-factura\"><div class=\"centrar centrar-columna centrar-align-start no-factura-info\"><h3>¡Todo en un solo lugar con Helo!</h3><p>Empieza a gestionar tus facturas de manera sencilla y de forma centralizada. Controla tus gastos y lleva la trazabilidad de tus pagos. Da clic en el botón para agregar una factura.</p><button class=\"btn-add-activo centrar centrar-c\" title=\"Nueva Factura\" ng-click=\"gotoNuevaFactura()\">Agregar Factura</button> <a class=\"ind-skip\" ui-sref=\"consumption.puntoFacturacion\">Hacerlo más tarde</a></div><div class=\"centrar no-factura-img\"><img src=\"../../../assets/img/facturas.png\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/no-facturador/no-facturador.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"no-factura\"><div class=\"centrar centrar-columna centrar-align-start no-factura-info\"><h3>¡Factura tus Consumos con Helo!</h3><p>Lleva un mejor control de tus activos generando informes de consumo para cada una de tus zonas en la plataforma.</p><button class=\"btn-add-activo centrar centrar-c\" title=\"Nuevo facturador\" ng-click=\"gotoNuevoFacturador()\">Agregar Facturador</button></div><div class=\"centrar no-factura-img\"><img src=\"../../../assets/img/punto.svg\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/no-punto/no-punto.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"no-factura\"><div class=\"centrar centrar-columna centrar-align-start no-factura-info\"><h3>¡Bienvenido al Módulo de Consumo Helo!</h3><p>Este módulo está diseñado para hacer más fácil la gestión de tus facturas. Lo primero que debes hacer es crear un punto de facturación que agrupará todas tus factura. Da clic en el botón de abajo para comenzar.</p><button class=\"btn-add-activo centrar centrar-c\" title=\"Nuevo punto de facturación\" ng-click=\"gotoNuevoPunto()\">Agregar Punto de Facturación</button></div><div class=\"centrar no-factura-img\"><img src=\"../../../assets/img/punto.svg\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/power-graphic/power-graphic.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Gráfica Potencia - {{nombreDispositivo}}</h3></div><div class=\"panel-body centrar centrar-columna\"><div class=\"centrar width-100p\"><p class=\"margin-0\">W</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"grafica_potencia\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"setFilter(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/proceso-facturacion-ind/proceso-facturacion-ind.html","<div class=\"grill\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn centrar centrar-columna centrar-align-start\"><h4>Selecciona la fuente de los datos de consumo</h4><div class=\"centrar centrar-flex-flow cont-grill\"><div ng-repeat=\"itm in inds\" ng-class=\"{\'grill-selected\': itm.status}\" class=\"grill-selector centrar centrar-align-start centrar-columna\"><p>{{itm.name}}</p><input class=\"centrar-align-self-end\" ng-value=\"itm.ind\" ng-model=\"ind.id\" type=\"radio\" ng-disabled=\"itm.disabled\" ng-change=\"statusChange(itm.ind)\"></div></div><div class=\"centrar centrar-align-self-end\"><button ng-disabled=\"!ind.id\" ng-click=\"next(ind.id)\">Continuar <i class=\"ion-arrow-right-c\"></i></button></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/proceso-facturacion-info/proceso-facturacion-info.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn nueva-factura\"><div class=\"panel-heading centrar centrar-columna\"><h3 class=\"margin-0\">Información Básica</h3></div><div class=\"panel-body centrar centrar-justificar-inicio centrar-align-start\"><form name=\"nuevoProcesoFacturacionForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><p>Todos los campos marcado con * son obligatorios</p><label class=\"input-grid-item\">Selecciona una cuenta*</label><select class=\"input-grid-item\" ng-model=\"nuevoProcesoFacturacion.facturador\" name=\"facturador\" required=\"\"><option ng-repeat=\"facturador in facturadores\" value=\"{{facturador.id}}\">{{facturador.nombre}}</option></select><label>Rango de tiempo*</label><div class=\"centrar centrar-flex-flow\"><div class=\"width-100p\"><p>Fecha inicial</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"nuevoProcesoFacturacion.fecha_ini\" is-open=\"popup.opened_1\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"consultaConsumos(date)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"width-100p margin-top\"><p>Fecha final</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"nuevoProcesoFacturacion.fecha_final\" is-open=\"popup.opened_2\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"consultaConsumos(date)\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><label class=\"input-grid-item\">¿Cómo vas a calcular el informe?*</label><select class=\"input-grid-item\" ng-model=\"nuevoProcesoFacturacion.ind\" name=\"mas info\" required=\"\"><option value=\"0\">Valor fijo</option><option value=\"1\">Datos del medidor Helo</option></select><label>Valor KWh (opcional)</label> <input type=\"number\" min=\"0\" ng-model=\"nuevoProcesoFacturacion.valor_kwh\" name=\"valor_kwh\"><div ng-if=\"nuevoProcesoFacturacion.ind === \'0\'\"><label>KWh Consumidos por cliente*</label> <input type=\"number\" min=\"0\" ng-model=\"nuevoProcesoFacturacion.consumo_kwh\" name=\"consumokwh\" required=\"\"></div></form><div class=\"centrar factura-img\"><img src=\"../../../assets/img/facturas.png\" alt=\"\"></div></div><div class=\"centrar centrar-justificar-final\"><button class=\"button-confirm margin-20\" ng-disabled=\"!nuevoProcesoFacturacionForm.$valid\" ng-click=\"next(nuevoProcesoFacturacion)\">Generar</button></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/proceso-facturacion-nuevo/proceso-facturacion-nuevo.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn nueva-factura proceso-facturacion-seleccion\"><div class=\"panel-heading centrar centrar-columna\"><h3 class=\"margin-0\">{{editMode ? \'Editar \' : \'\'}}Información Básica</h3></div><div class=\"panel-body centrar centrar-justificar-inicio centrar-align-start\"><form name=\"nuevoFacturadorForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><p>Todos los campos marcado con * son obligatorios</p><label>Nombre*</label> <input type=\"text\" ng-model=\"nuevoFacturador.nombre\" name=\"nombre\" required=\"\"> <label>Nit*</label> <input type=\"text\" ng-model=\"nuevoFacturador.nit\" name=\"nit\" required=\"\"> <label>Correo*</label> <input type=\"email\" ng-model=\"nuevoFacturador.correo\" name=\"email\" required=\"\"> <label>Teléfono*</label> <input type=\"tel\" ng-model=\"nuevoFacturador.telefono\" name=\"tel\" required=\"\"><div class=\"width-100p inputs-grid-group\"><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label>País*</label><div class=\"centrar width-100p\"><select ng-model=\"nuevoFacturador.pais_id\" id=\"pais\" name=\"pais\" ng-class=\"{\'input-invalid\': nuevoFacturador.pais.$touched && nuevoFacturador.pais.$invalid}\" required=\"\" ng-change=\"getStates(nuevoFacturador.pais_id)\"><option value=\"{{pais.id}}\" ng-repeat=\"pais in paises\">{{pais.nombre}}</option></select></div></div><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label>Estado / Departamento* <span class=\"ion-load-c load-rotate padding-0-10\" ng-if=\"loading_state\"></span></label><div class=\"centrar width-100p\"><select ng-model=\"nuevoFacturador.estado_id\" id=\"estado\" name=\"estado\" ng-class=\"{\'input-invalid\': nuevoFacturador.estado.$touched && nuevoFacturador.estado.$invalid}\" required=\"\" ng-change=\"getCitys(nuevoFacturador.estado_id)\"><option value=\"{{estado.id}}\" ng-repeat=\"estado in estados\">{{estado.nombre}}</option></select></div></div></div><div class=\"centrar centrar-columna centrar-align-start width-100p inputs-grid-group\"><label class=\"input-grid-item\">Ciudad* <span class=\"ion-load-c load-rotate padding-0-10\" ng-if=\"loading_city\"></span></label><div class=\"centrar width-100p\"><select class=\"input-grid-item\" ng-model=\"nuevoFacturador.ciudad_id\" id=\"ciudad\" name=\"ciudad\" ng-class=\"{\'input-invalid\': nuevoFacturador.ciudad.$touched && nuevoFacturador.ciudad.$invalid}\" required=\"\"><option value=\"{{ciudad.id}}\" ng-repeat=\"ciudad in ciudades\">{{ciudad.nombre}}</option></select></div></div><label>Dirección*</label> <input type=\"text\" ng-model=\"nuevoFacturador.direccion\" required=\"\"></form><div class=\"centrar factura-img\"><img src=\"../../../assets/img/facturas.png\" alt=\"\"></div></div><div class=\"centrar centrar-justificar-final\"><button class=\"button-info\" ng-click=\"cancelar()\">Cancelar</button> <button class=\"button-confirm margin-20\" ng-disabled=\"!nuevoFacturadorForm.$valid\" ng-click=\"next(nuevoFacturador)\">Continuar <i class=\"ion-arrow-right-c\"></i></button></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/proceso-facturacion-resultado/proceso-facturacion-resultado.html","<div class=\"row\"><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-12\"><div class=\"dropdown filter-menu\"><div class=\"btn-highlighted centrar centrar-c cursor dropdown-toggle\" data-toggle=\"dropdown\"><p><span class=\"ion-archive\"></span> Descargar</p></div><ul class=\"dropdown-menu\"><li class=\"cursor ng-binding ng-scope\" ng-click=\"imprimir()\">Imprimir / PDF</li><li class=\"cursor ng-binding ng-scope\" ng-click=\"exportExcel()\">Excel</li></ul></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn proceso-facturacion-tabla\"><div class=\"panel-body margin-20 centrar centrar-columna\"><div class=\"centrar width-100p\"><div class=\"logo-helo\"><img src=\"../../../../assets/img/helo_logo_bg_a.jpg\" alt=\"\"></div><div class=\"centrar centrar-c centrar-columna info-radicado\"><h3>Informe de Servicios</h3><p><b>Fecha informe:</b> {{radicado.fecha_informe | date: \'dd/MM/yyyy\'}}</p><p><b>Periodo informe:</b> {{radicado.fecha_inicio | date:\'dd/MM/yyyy\'}} - {{radicado.fecha_fin | date:\'dd/MM/yyyy\'}}</p><p><b>Días de consumo:</b> {{radicado.dias_facturados}}</p></div></div><div class=\"centrar width-100p centrar-justificar-inicio info-cliente\"><div class=\"centrar centrar-columna\"><h5>Cliente: {{cliente.nombre}}</h5><h5>NIT: {{cliente.nit}}</h5><h5>Dirección: {{cliente.direccion}}</h5></div><div style=\"margin-left: 20px;\" class=\"centrar centrar-columna\"><h5>Correo: {{cliente.correo}}</h5><h5>Ciudad: {{cliente.ciudad}}</h5><h5>Télefono: {{cliente.telefono}}</h5></div></div><div class=\"centrar centrar-columna width-100p info-consumo\"><div ng-class=\"radicado.valor_kwh ? \'tabla-resumen-5\' : \'tabla-resumen-3\'\" class=\"tabla-resumen-header width-100p\"><p style=\"justify-self: flex-start;\" class=\"tabla-resumen-header-item\">Punto</p><p class=\"tabla-resumen-header-item\">Código</p><p class=\"tabla-resumen-header-item\">Consumo</p><p class=\"tabla-resumen-header-item\">Días de consumo</p><p ng-if=\"radicado.valor_kwh\" class=\"tabla-resumen-header-item\">Vr. KWh</p><p ng-if=\"radicado.valor_kwh\" class=\"tabla-resumen-header-item\">Vr. Total</p></div><div ng-class=\"radicado.valor_kwh ? \'tabla-resumen-5\' : \'tabla-resumen-3\'\" class=\"width-100p\" ng-repeat=\"punto in puntos | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><p style=\"text-align: start;\" class=\"tabla-resumen-item\">{{punto.nombre | limitTo: 35}}{{punto.nombre.length > 35 ? \'...\' : \'\'}}</p><p class=\"tabla-resumen-item\">{{punto.codigo}}</p><p class=\"tabla-resumen-item\">{{punto.kwh ? punto.kwh : 0}} KWh</p><p class=\"tabla-resumen-item\">{{radicado.dias_facturados}}</p><p ng-if=\"radicado.valor_kwh\" class=\"tabla-resumen-item\">{{radicado.valor_kwh | currency}}</p><p ng-if=\"radicado.valor_kwh\" class=\"tabla-resumen-item\">{{radicado.valor_kwh * punto.kwh | currency}}</p></div></div><loading-content loading=\"loading\"></loading-content><div ng-show=\"totalItems > itemsPerPage\" class=\"centrar centrar-c pag\"><uib-pagination total-items=\"totalItems\" direction-links=\"false\" ng-model=\"currentPage\" boundary-link-numbers=\"true\" rotate=\"false\" class=\"pagination-sm\" items-per-page=\"itemsPerPage\" max-size=\"noOfPages\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/proceso-facturacion-seleccion/proceso-facturacion-seleccion.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn proceso-facturacion-seleccion\"><div class=\"panel-heading centrar centrar-columna\"><h3 class=\"margin-0\">Fuente de los datos de consumo</h3></div><div class=\"centrar centrar-align-start centrar-columna centrar-justificar-inicio panel-body\"><div class=\"centrar centrar-columna width-100p\"><h4>Selecciona las fronteras comerciales que deseas incluir en esta cuenta</h4><div class=\"centrar centrar-columna width-100p\"><div class=\"centrar centrar-justificar-inicio width-100p panel-selected\"><div class=\"has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"search\"> <i class=\"ion-search form-control-feedback\"></i></div><div class=\"centrar\" style=\"margin-left: 20px;\"><p class=\"margin-0\">Seleccionar todo</p><input style=\"margin: 0 0 0 20px;\" type=\"checkbox\" ng-model=\"select_all\" ng-change=\"selectAll(select_all)\"></div></div><div class=\"centrar centrar-columna centrar-justificar-inicio width-100p cont-select\"><div ng-repeat=\"itm in filtered track by $index\" class=\"centrar width-100p itm-select\"><p>{{itm.nombre}}</p><input ng-model=\"itm.status\" ng-change=\"validateList()\" type=\"checkbox\"></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div></div></div><div></div></div><div class=\"centrar centrar-justificar-final\"><button class=\"button-info\" ng-click=\"back()\"><i class=\"ion-arrow-left-c\"></i> Volver</button> <button class=\"button-confirm margin-20\" ng-disabled=\"!validatedList\" ng-click=\"crear()\">{{edit_mode ? \'Editar\' : \'Crear\'}}</button></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/selectedFilter/selectedFilter.html","<div class=\"dropdown filter-menu\"><button class=\"dropdown-toggle\" type=\"button\" data-toggle=\"dropdown\">{{nombre | limitTo: 11}}{{nombre.length > 11 ? \'...\': \'\'}} <span class=\"ion-chevron-down\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"item in lista\" class=\"cursor\" ng-click=\"selectedItem(item)\">{{item | limitTo: 20}}{{item.length > 20 ? \'...\': \' \'}}</li></ul></div>");
$templateCache.put("app/cliente/consumo_v2/components/table-billing/table-billing.html","<div class=\"padding-col\"><div></div><div class=\"tabla-consumo tabla-consumo-header\"><p class=\"tabla-consumo-header-item\">Valor KWh</p><p class=\"tabla-consumo-header-item\">kWh consumidos</p><p class=\"tabla-consumo-header-item\">Días facturados</p><p class=\"tabla-consumo-header-item\">Intervalo de consumo</p><p class=\"tabla-consumo-header-item\">Valor</p></div><div class=\"tabla-consumo\" ng-repeat=\"factura in facturas\"><p data-label=\"Valor\" ng-click=\"gotoFactura(factura)\" class=\"cursor tabla-consumo-item\">{{factura.precio_kwh | currency}}</p><p data-label=\"kWh\" class=\"tabla-consumo-item\">{{factura.consumo_kwh}}</p><p data-label=\"Días\" class=\"tabla-consumo-item\">{{factura.dias_facturados}}</p><p data-label=\"Intervalo\" class=\"tabla-consumo-item\">{{factura.dia_ini | date}} - {{factura.dia_fin | date}}</p><p data-label=\"Valor\" class=\"tabla-consumo-item\">{{factura.valor | currency}}</p><div class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-justificar-final\"></span></div><ul class=\"dropdown-menu\"><li class=\"cursor\" ng-click=\"editBill(factura)\">Editar</li><li class=\"cursor\" ng-click=\"deleteBill(factura)\">Borrar</li></ul></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/table-consumption/table-consumption.html","<div class=\"padding-col\"><div class=\"tabla-consumo\"><p data-label=\"Nombre\" ng-click=\"gotoFacturacion(punto)\" class=\"tabla-consumo-item cursor\">{{punto.nombre}}</p><p data-label=\"Ciudad\" class=\"tabla-consumo-item\">{{punto.ciudad | limitTo: 20}}{{punto.ciudad.length > 20 ? \'...\' : \'\'}}</p><p data-label=\"Proveedor\" class=\"tabla-consumo-item\">{{punto.prestador_servicio | limitTo: 20}}{{punto.prestador.length > 20 ? \'...\' : \'\'}}</p><p data-label=\"Valor\" class=\"tabla-consumo-item\">{{punto.ultima_factura | currency}} {{!punto.ultima_factura ? \'--\' : \'\'}}</p><p data-label=\"Facturas\" class=\"tabla-consumo-item ind-link cursor\" ng-click=\"gotoFacturacion(punto)\">ver facturas</p><div class=\"dropdown\" ng-if=\"control\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-justificar-final\"></span></div><ul class=\"dropdown-menu\"><li class=\"cursor\" ng-if=\"control\" ng-click=\"editarPunto(punto)\">Editar</li><li class=\"cursor\" ng-if=\"control\" ng-click=\"borrarPunto(punto)\">Borrar</li></ul></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/table-facturadores/table-facturadores.html","<div class=\"padding-col\"><div></div><div class=\"tabla-consumo tabla-consumo-header\"><p class=\"tabla-consumo-header-item\">Nombre</p><p class=\"tabla-consumo-header-item\">Nit</p><p class=\"tabla-consumo-header-item\">Teléfono</p><p class=\"tabla-consumo-header-item\">Ciudad</p><p class=\"tabla-consumo-header-item\">País</p></div><div class=\"tabla-consumo\" ng-repeat=\"facturador in facturadores\"><p data-label=\"Nombre\" class=\"tabla-consumo-item\">{{facturador.nombre | limitTo: 20}}{{facturador.nombre.length > 20 ? \'...\' : \'\'}}</p><p data-label=\"Nit\" class=\"tabla-consumo-item\">{{facturador.nit}}</p><p data-label=\"Teléfono\" class=\"tabla-consumo-item\">{{facturador.telefono}}</p><p data-label=\"Ciudad\" class=\"tabla-consumo-item\">{{facturador.ciudad}}</p><p data-label=\"País\" class=\"tabla-consumo-item\">{{facturador.pais}}</p><div class=\"dropdown\" ng-if=\"control\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-justificar-final\"></span></div><ul class=\"dropdown-menu\"><li class=\"cursor\" ng-if=\"control\" ng-click=\"editarFacturador(facturador)\">Editar</li><li class=\"cursor\" ng-if=\"control\" ng-click=\"borrarFacturador(facturador)\">Borrar</li></ul></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/tabs-consumo/tabs-consumo.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"centrar panel cont-tab-graficas animated zoomIn\" ng-if=\"tabs\"><div class=\"centrar centrar-c tab-grafica cursor\" ng-repeat=\"tab in tabs\" ng-class=\"{\'tab-grafica-activo\':tab.status == true}\" ng-click=\"tabGrafica(tab)\"><p>{{tab.name}}</p></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/total-consumption-chart/total-consumption-chart.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><p class=\"titulo\">Histórico de consumo total</p><div class=\"panel panel-primary bootstrap-panel animated zoomIn panel-smart-bar\"><div class=\"panel-heading holder_header centrar centrar-columna\"><div class=\"centrar width-100p\"><div class=\"h_titulo\"><select class=\"select-maintenance-zone\" ng-model=\"id\" ng-change=\"getConsumoTotal(id)\" ng-options=\"zona.id as zona.nombre for zona in zones\" id=\"zonas\" name=\"zonas\"></select></div></div><div class=\"centrar centrar-align-self-start\"><p class=\"ind-filter\" ng-repeat=\"filter in filters\">{{filter | limitTo: 15}}{{filter.length > 15 ? \'...\': \' \'}}</p></div></div><div class=\"panel-body\"><div class=\"centrar width-100p\"><p class=\"margin-0\">KWh</p></div><div class=\"cont-total-consumption-chart\"><div id=\"totalConsumption\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading_\" style=\"position:absolute; top:200px; width: 100%;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo_\" style=\"position:absolute; top:200px; width: 100%;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div></div><div class=\"centrar centrar-c width-100p\"><p class=\"margin-0\">Tiempo</p></div><div class=\"margin-top\"><date-picker-consumption selected-date=\"getConsumoTotal\"></date-picker-consumption></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/totalConsumption/totalConsumtion.html","<div ng-if=\"consumption\" class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Consumo total {{label}} seleccionado\" ba-panel-class=\"\"><div class=\"centrar centrar-c\"><div class=\"centrar centrar-align-start\"><p class=\"margin-0 consolidado-dato\">{{consumption}}</p><p class=\"margin-0 consolidado-unidad\">KWH</p></div></div></div><div ng-if=\"allConsumption\" class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\"><div class=\"panel animated zoomIn\" style=\"z-index: 1;\"><div class=\"panel-body ind-totalizador\"><div class=\"centrar margin-bottom-20\"><h3>Consumo total</h3><selected-filter nombre=\"\'Cliente\'\" lista=\"clients\" selected=\"setClient\"></selected-filter></div><div class=\"centrar centrar-align-start centrar-columna\"><div class=\"centrar\"><h2>{{consumo}} <sup>KWh</sup></h2></div></div></div></div></div>");
$templateCache.put("app/cliente/consumo_v2/components/value-kwh-graphic/value-kwh-graphic.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Gráfica Valor Kwh</h3></div><div class=\"panel-body centrar centrar-columna\"><div class=\"centrar width-100p\"><p class=\"margin-0\">$</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"grafica_valor_factura\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/automation/air/airAutomation.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nueva Programación\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start\"><form name=\"newAutomationAirForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label>Equipo a controlar</label><ui-select ng-model=\"newAutomationAir.air\" id=\"air\" name=\"air\" ng-class=\"{\'input-invalid\': newAutomationAirForm.air.$touched && newAutomationAirForm.air.$invalid}\" required=\"\" ng-change=\"consultaComandos(newAutomationAir.air)\" ng-hide=\"editMode\" theme=\"bootstrap\" class=\"freq-select\"><ui-select-match placeholder=\"Buscar equipo\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"air in dispositivos | filter: {nombre: $select.search}\">{{air.nombre}}</ui-select-choices></ui-select><div class=\"form-control\" ng-show=\"editMode\">{{newAutomationAir.air.nombre}}</div><label>Día inicial</label><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"newAutomationAir.date\" is-open=\"popup.opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><label>Hora inicial</label><div uib-timepicker=\"\" ng-model=\"newAutomationAir.hinit\" id=\"hinit\" name=\"hinit\" show-meridian=\"false\" ng-change=\"setMili(\'ini\')\"></div><div class=\"centrar\"><label>Hora final</label><div uib-dropdown=\"\" ng-if=\"newAutomationAir.hinit >= newAutomationAir.hend\"><a uib-dropdown-toggle=\"\"><span class=\"ion-android-alert cursor icon-alert\"></span></a><ul class=\"dropdown-menu padding-2\" uib-dropdown-menu=\"\"><li>Verifica que la hora final sea mayor a la hora inicial</li></ul></div></div><div uib-timepicker=\"\" ng-model=\"newAutomationAir.hend\" id=\"hend\" name=\"hend\" show-meridian=\"false\" ng-change=\"setMili(\'end\')\"></div><label>Frecuencia</label><ui-select ng-model=\"newAutomationAir.freq\" theme=\"bootstrap\" search-enabled=\"false\" id=\"frequency\" name=\"frequency\" class=\"freq-select\" ng-class=\"{\'input-invalid\': newAutomationAirForm.frequency.$touched && newAutomationAirForm.frequency.$invalid}\" required=\"\"><ui-select-match placeholder=\"Seleccionar frecuencia\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"i.value as i in frequency\">{{i.text}}</ui-select-choices></ui-select><label>Tipo de control</label><ui-select ng-if=\"disp.tipo !== \'14\'\" name=\"\" id=\"\" ng-model=\"newAutomationAir.setpoint\" ng-class=\"{\'input-invalid\': newAutomationAirForm.setpoint.$touched && newAutomationAirForm.setpoint.$invalid}\" required=\"\" theme=\"bootstrap\" search-enabled=\"false\" class=\"freq-select\"><ui-select-match placeholder=\"Seleccionar\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"item.id as item in setpoints | filter: {status: true}\">{{item.nombre}}</ui-select-choices></ui-select><input ng-if=\"disp.tipo === \'14\'\" type=\"number\" min=\"0\" max=\"10\" step=\"0.1\" ng-model=\"newAutomationAir.setPoint_rack\" id=\"setpoint\" ng-value=\"{{newAutomationAir.setPoint_rack}}\" name=\"setpoint\" ng-class=\"{\'input-invalid\': newAutomationAirForm.setpoint.$touched && newAutomationAirForm.setpoint.$invalid}\" required=\"\"> <label>Estado al finalizar la programación</label><ui-select ng-if=\"disp.tipo !== \'14\'\" id=\"finalsetpoint\" name=\"finalsetpoint\" ng-model=\"newAutomationAir.finalsetpoint\" ng-class=\"{\'input-invalid\': newAutomationAirForm.finalsetpoint.$touched && newAutomationAirForm.finalsetpoint.$invalid}\" required=\"\" theme=\"bootstrap\" search-enabled=\"false\" class=\"freq-select\"><ui-select-match placeholder=\"Seleccionar\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"item.id as item in setpoints | filter: {status: true}\">{{item.nombre}}</ui-select-choices></ui-select><input ng-if=\"disp.tipo === \'14\'\" type=\"number\" min=\"0\" max=\"10\" step=\"0.1\" ng-model=\"newAutomationAir.finalsetpoint_rack\" id=\"finalsetpoint\" ng-value=\"{{newAutomationAir.finalsetpoint_rack}}\" name=\"finalsetpoint\" ng-class=\"{\'input-invalid\': newAutomationAirForm.finalsetpoint.$touched && newAutomationAirForm.finalsetpoint.$invalid}\" required=\"\"><div class=\"centrar\"><input type=\"submit\" ng-disabled=\"!newAutomationAirForm.$valid || newAutomationAir.hinit >= newAutomationAir.hend\" value=\"{{editMode ? \'Editar\' : \'Agregar\'}}\" class=\"cursor margin-right-10\" ng-class=\"{\'btn-guardar\':newAutomationAirForm.$valid && newAutomationAir.hinit < newAutomationAir.hend}\" ng-click=\"validateSchedual(newAutomationAir)\"> <input type=\"button\" value=\"Cancelar\" class=\"btn-cerrar cursor margin-right-10\" ng-click=\"cancelar()\"></div></form></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/automation/load/loadAutomation.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nueva Programación\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start\"><form name=\"newAutomationLoadForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label>Día inicial</label><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"newAutomationLoad.date\" is-open=\"popup.opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><label>Hora inicial</label><div uib-timepicker=\"\" ng-model=\"newAutomationLoad.hinit\" id=\"hinit\" name=\"hinit\" show-meridian=\"false\" ng-change=\"setMili(\'ini\')\"></div><div class=\"centrar\"><label>Hora final</label><div uib-dropdown=\"\" ng-if=\"newAutomationLoad.hinit >= newAutomationLoad.hend\"><a uib-dropdown-toggle=\"\"><span class=\"ion-android-alert cursor icon-alert\"></span></a><ul class=\"dropdown-menu padding-2\" uib-dropdown-menu=\"\"><li>Verifica que la hora final sea mayor a la hora inicial</li></ul></div></div><div uib-timepicker=\"\" ng-model=\"newAutomationLoad.hend\" id=\"hend\" name=\"hend\" show-meridian=\"false\" ng-change=\"setMili(\'end\')\"></div><label>Frecuencia</label><ui-select ng-model=\"newAutomationLoad.freq\" theme=\"bootstrap\" search-enabled=\"false\" id=\"frequency\" name=\"frequency\" class=\"freq-select\" ng-class=\"{\'input-invalid\': newAutomationLoadForm.frequency.$touched && newAutomationLoadForm.frequency.$invalid}\" required=\"\"><ui-select-match placeholder=\"Seleccionar frecuencia\">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat=\"i.value as i in frequency\">{{i.text}}</ui-select-choices></ui-select><div class=\"centrar\"><input type=\"submit\" ng-disabled=\"!newAutomationLoadForm.$valid || newAutomationLoad.hinit >= newAutomationLoad.hend\" value=\"Agregar\" class=\"cursor margin-right-10\" ng-class=\"{\'btn-guardar\':newAutomationLoadForm.$valid && newAutomationLoad.hinit < newAutomationLoad.hend}\" ng-click=\"newPrograming(newAutomationLoad)\"> <input type=\"button\" value=\"Cancelar\" class=\"btn-cerrar cursor margin-right-10\" ng-click=\"cancelar()\"></div></form></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/control-buttons-top/control-buttons-top.html","<div class=\"margin-bottom-20\" style=\"display: grid; grid-template-columns: 50% 50%; margin-top: 20px;\"><div class=\"centrar centrar-justificar-inicio\"><div ng-click=\"goToNewContent()\" ng-if=\"indRol !== \'7\' && indRol !== \'10\' && indRol !== \'11\'\" class=\"btn-add-alert centrar centrar-c cursor padding-0-10\"><p><span class=\"ion-plus-round\"></span> {{name_ind}}</p></div><div ng-click=\"openShareZones()\" ng-if=\"buttonsSwitch[0].status && indRol === \'6\'\" class=\"btn-add-alert centrar centrar-c cursor padding-0-10 margin-left-10\"><p><span class=\"ion-person-add\"></span> Compartir zonas</p></div></div><div ng-if=\"indRol === \'6\' || indRol === \'7\' || indRol === \'8\'\" class=\"cont-switch-view centrar centrar-justificar-final\"><button ng-class=\"{\'active\' : button.status}\" class=\"{{button.clases}}\" ng-repeat=\"button in buttonsSwitch\" name=\"button.name\" type=\"button\" ng-click=\"switchView(button)\"><img ng-src=\"{{button.icon}}\" alt=\"\"></button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/control-device/control-device.html","<div ng-if=\"(device.tipo !== \'11\' && device.tipo !== \'26\' && device.tipo !== \'31\')\"><device device=\"device\" server-hour=\"serverHour\" control=\"control\"></device></div><div class=\"centrar device\" ng-if=\"device.tipo === \'11\' || device.tipo === \'31\'\"><div class=\"centrar width-100p\"><div class=\"indicador-assets cursor\"><h4>{{device.nombre}}</h4></div><div class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-c\"></span></div><ul class=\"dropdown-menu\"><a ng-click=\"goApparatusProfile(device, control)\"><li class=\"cursor\">Perfil</li></a></ul></div></div></div><div ng-if=\"device.tipo === \'26\'\"><div class=\"centrar centrar-columna cont-agrupador\"><div class=\"centrar centrar-espaciado-inicio cursor agrupador width-100p\"><div class=\"centrar centrar-justificar-inicio\" ng-click=\"device.open = !device.open\"><img src=\"../../../../../assets/icons/agrupador.png\" alt=\"\"><h4>{{device.nombre | limitTo: 20}}{{device.nombre.length > 20 ? \'...\' : \'\'}}</h4></div><div class=\"centrar\"><span class=\"cursor\" ng-click=\"device.open = !device.open\" ng-class=\"{\'ion-chevron-up\': device.open, \'ion-chevron-down\': !device.open}\"></span><div class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span ng-class=\"{\'color-white\':device.status === true}\" class=\"ion-android-more-vertical centrar centrar-c\"></span></div><ul class=\"dropdown-menu\"><a ng-click=\"delectedGroup(device, control)\"><li class=\"cursor\">Borrar</li></a></ul></div></div></div><div class=\"agrupador-cont\" ng-show=\"device.open\"><device ng-if=\"(canal.tipo !== \'11\' && canal.tipo !== \'26\')\" ng-repeat=\"canal in device.canales\" device=\"canal\" server-hour=\"serverHour\" control=\"control\"></device><div ng-repeat=\"canal in device.canales\" class=\"centrar device centrar-espaciado-entre\" ng-if=\"canal.tipo === \'11\'\"><div class=\"centrar centrar-espaciado-inicio\"><div class=\"indicador-assets cursor\" ng-click=\"goApparatusProfile(canal, control)\"><h4>{{canal.nombre}}</h4></div></div></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/control-devices-list/control-devices-list.html","<div class=\"control-devices-list\"><div class=\"cont-title centrar centrar-espaciado-entre\"><div class=\"centrar\"><div class=\"icon-d\"><img src=\"../../../../assets/icons/devices.svg\" alt=\"\"></div><p>Dispositivos</p></div><div class=\"centrar\"><div class=\"icon centrar centrar-c cursor\" title=\"ver programaciones\" style=\"margin-right: 5px;\" ng-click=\"goSchedules(zone)\"><span style=\"font-size: 1.2em;\" class=\"ion-calendar\"></span></div><div class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><div class=\"icon\"><span style=\"font-size: 1.4em;\" class=\"ion-plus-round centrar centrar-c\"></span></div></div><ul class=\"dropdown-menu\"><li ng-click=\"goToNewDevice(zone)\" class=\"cursor\">Nuevo dispositivo</li><li ng-click=\"createSystem()\" class=\"cursor\">Nuevo sistema</li><li ng-click=\"goToMoveDevices()\" class=\"cursor\">Mover dispositivos</li></ul></div></div></div><div class=\"margin-bottom-10 width-100p\"><input type=\"search\" class=\"search-device width-100p\" ng-model=\"search_device\" placeholder=\"Buscar dispositivo\" ng-keyup=\"filtrarDevice(search_device)\"></div><div class=\"centrar cont-chips centrar-justificar-inicio centrar-flex-flow\"><div class=\"chip cursor centrar\" ng-repeat=\"chip in filters\" ng-class=\"{\'active\': chip.status}\" ng-click=\"filterDevices(chip.ind)\"><p class=\"centrar\">{{chip.label}} <span class=\"chip-number\" ng-class=\"{\'chip-number-active\': chip.status}\">{{chip.number}}</span></p></div></div><div class=\"cont-devices\"><control-device device=\"device\" devices=\"rawdevices\" zona=\"zone\" server-hour=\"serverHour\" control=\"control\" ng-repeat=\"device in devices\"></control-device><loading-content loading=\"loading\"></loading-content><p class=\"centrar centrar-c margin-top\" ng-if=\"loading === false && devices.length === 0\">No hay dispositivos para mostrar</p></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/device/device.html","<div class=\"centrar device centrar-espaciado-entre\" ng-class=\"{\'select-dispositivo\':device.status === true}\"><div class=\"centrar centrar-espaciado-inicio cursor\" ng-click=\"getData(device)\"><div class=\"ind-online\" ng-class=\"{\'online\' : device.online}\"></div><div class=\"indicador-info\"><div ng-if=\"device.online\"><h4 ng-if=\"(device.tipo == \'0\' || device.tipo == \'1\')\">{{device.relay == \'0\' ? \'Apagado\' : \'Encendido\'}}</h4><h4 ng-if=\"(device.tipo == \'5\' || device.tipo == \'7\' || device.tipo == \'9\')\">{{device.estado | number : 2}} {{device.tipo == \'5\' ? \'W\': \'\'}}</h4><h4 ng-if=\"(device.tipo == \'2\' || device.tipo == \'3\' || device.tipo == \'8\')\">{{device.estado.nombre ?(device.estado.nombre != \'Apagar\' ? device.estado.nombre : \'Apagado\') : \'--\'}} {{device.tipo == \'2\' || device.tipo == \'3\' ? (device.estado.nombre != \'Apagar\' ? \'&#8451\' : \'\'): \'\'}}</h4><h4 ng-if=\"device.tipo == \'6\' || device.tipo == \'13\' || device.tipo == \'15\' || device.tipo == \'4\' || device.tipo == \'33\'\">{{device.estado ? (device.tipo == \'14\' || device.tipo == \'15\' ? device.estado/10 : device.estado): \'--\'}} &#8451</h4><h4 ng-if=\"device.tipo == \'14\'\">{{device.estado ? device.estado/10 : \'--\'}} Bar</h4><h4 ng-if=\"(device.tipo == \'10\' || device.tipo == \'11\')\">--</h4><h4 ng-if=\"(device.tipo == \'12\')\">{{device.estado ? (device.estado / 100) : \'--\'}} m3n</h4><h4 ng-if=\"(device.tipo == \'16\')\">{{device.estado ? device.estado : \'--\'}} Wh</h4><h4 ng-if=\"(device.tipo == \'18\')\">{{device.estado ? device.estado : \'--\'}} PSI</h4><h4 ng-if=\"(device.tipo == \'19\')\">{{device.estado ? device.estado : \'--\'}} Gpm</h4><h4 ng-if=\"(device.tipo == \'21\')\">{{device.estado == \'0\' ? \'No Presen\' : \'Presencia\'}}</h4><h4 ng-if=\"(device.tipo == \'22\')\">--</h4><h4 ng-if=\"(device.tipo == \'27\')\">{{device.estado ? device.estado : \'--\'}} Hz</h4><h4 ng-if=\"(device.tipo == \'28\' || device.tipo == \'30\' || device.tipo == \'32\')\">{{device.estado ? device.estado / 100 : \'--\'}} °C</h4><h4 ng-if=\"(device.tipo == \'29\')\">{{device.estado ? (device.estado === \'0\' ? \'Apagado\' : \'Encendido\') : \'--\'}}</h4></div><div ng-if=\"!device.online\"><h4>--</h4></div><p class=\"name\">{{device.nombre}}</p><p class=\"conexion\" tooltip-placement=\"top\" uib-tooltip=\"{{fecha_conexion}}\">Última conexión: {{last_conexion | number: 1}} {{ind}}</p><p ng-if=\"(device.tipo == \'0\' || device.tipo == \'1\')\" class=\"conexion\">Muletilla: {{device.muletilla === \'1\' ? \'Automático\' : \'Manual\' }}</p></div></div><div class=\"centrar\"><div class=\"centrar centrar-espaciado-entre\"><div class=\"cont-control\"><div ng-if=\"device.online && control\"><select ng-if=\"setpoints\" ng-change=\"setAir(temp, device)\" ng-model=\"temp\"><option ng-if=\"setpoint.status\" ng-repeat=\"setpoint in setpoints\" value=\"{{setpoint}}\">{{setpoint.nombre}}</option></select><div ng-if=\"(device.tipo == \'14\')\"><input type=\"number\" min=\"0\" ng-model=\"comandoRack\" max=\"10\" step=\"0.1\" ng-value=\"{{parseInt(device.estado)/10}}\" ng-change=\"setAir(comandoRack, device)\"></div><div ng-if=\"(device.tipo == \'0\' || device.tipo == \'1\')\"><span ng-class=\"{\'ion-toggle-filled btn_on\': (device.relay? device.relay : device.estado) ==\'1\', \'ion-toggle btn_off\': (device.relay? device.relay : device.estado) ==\'0\'}\" ng-click=\"turnDevice(device)\"></span></div><div ng-if=\"device.tag && control_saeg\"><input type=\"number\" min=\"0\" ng-model=\"comand_saeg\" ng-model-options=\"{ debounce: 800 }\" max=\"100\" step=\"1\" ng-change=\"controlSaeg(comand_saeg)\"></div><div ng-if=\"device.tipo == \'17\'\"><select ng-model=\"comandoDimmer\" ng-options=\"i.id as i.nombre for i in intervalDimmer\" id=\"intervalDimmer\" name=\"intervalDimmer\" ng-change=\"setControlByPercent(comandoDimmer, device)\"></select></div><div ng-if=\"device.tipo == \'27\'\"><select ng-model=\"comandoVariador\" ng-options=\"i.id as i.nombre for i in intervalEngine\" id=\"intervalEngine\" name=\"intervalEngine\" ng-change=\"setControlByPercent(comandoVariador, device)\"></select></div></div></div></div><div class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span ng-class=\"{\'color-white\':device.status === true}\" class=\"ion-android-more-vertical centrar centrar-c\"></span></div><ul class=\"dropdown-menu\"><a ng-click=\"goApparatusProfile(device, control)\"><li class=\"cursor\">Perfil</li></a> <a ng-if=\"device.tipo == \'27\'\" ng-click=\"showErrors(device)\"><li class=\"cursor\">Ver Errores</li></a></ul></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/devices-list/devices-list.html","<div class=\"control-devices-list\" ng-if=\"list\"><div class=\"cont-title centrar centrar-espaciado-entre\"><div class=\"centrar\"><div class=\"icon-d\"><img src=\"../../../../assets/icons/devices.svg\" alt=\"\"></div><p>Dispositivos</p></div></div><div class=\"margin-bottom-10 width-100p\"><input type=\"search\" class=\"search-device width-100p\" ng-model=\"search_device\" placeholder=\"Buscar dispositivo\" ng-keyup=\"filtrarDevice(search_device)\"></div><div class=\"cont-devices\"><div style=\"padding: 10px 0;\" class=\"centrar centrar-justificar-inicio cursor cont-dispositivo\" ng-click=\"getData(device)\" ng-repeat=\"device in devices\" ng-if=\"devices\" ng-class=\"{\'select-dispositivo\':device.status === true}\"><div id=\"{{device.id}}\" class=\"margin-left-10 myDivs\"><p class=\"margin-0\">{{device.nombre}}</p></div></div><div ng-if=\"!devices\" class=\"centrar centrar-c\"><p>No hay dispositivo disponibles</p></div><loading-content loading=\"loading\"></loading-content></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/infoCliente/infoCliente.html","<div class=\"panel panel-primary bootstrap-panel animated zoomIn\" zoom-in=\"\"><div class=\"panel-body\"><div class=\"centrar centrar-c centrar-columna\"><h3 class=\"centrar centrar-c\">{{user.name}}</h3><div class=\"user-img\"><img ng-src=\"{{user.img != \'\' ? user.img: default_img}}\"></div><p>Dashboard de Control</p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/no-graph/no-graph.html","<div class=\"panel width-100p centrar centrar-c\" style=\"height: 690px;\"><p style=\"font-size: 20px;\">No hay información para mostrar</p></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/noZones/noZones.html","<div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel panel-primary bootstrap-panel h_ind_zonas animated zoomIn\" zoom-in=\"\"><div class=\"panel-body cont-no-zonas centrar centrar-c centrar-columna\"><div class=\"centrar centrar-c ind-icon\"><span class=\"ion-speedometer\"></span></div><h2>¡Crea tu primera zona en Helo!</h2><div class=\"button-add centrar centrar-c cursor\" title=\"Agregar Zona\" ng-click=\"addZone()\"><span class=\"ion-plus-round\"></span></div></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/pauseSchedules/pauseSchedules.html","<div class=\"centrar centrar-c pause-schedules\"><p class=\"centrar cursor\" ng-click=\"activeSchedules(zone)\">{{pauseSchedules.status == true ? \'Pausar todas en la zona\' : \'Activar todas en la zona\'}} <i class=\"ind-status\" ng-class=\"pauseSchedules.status == true ? \'ion-toggle-filled schedules-on\': \'ion-toggle\'\"></i></p></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/project-card/project-card.html","<div class=\"project-card animated zoomIn\"><div class=\"centrar\" style=\"position: relative;\"><div class=\"cont-img cursor\" ng-click=\"goToProject(project)\"><img ng-src=\"{{project.imagen === \'\' ? \'../../../../../assets/img/project_default.png\': project.imagen}}\" alt=\"cover proyecto\" title=\"cover proyecto\"></div><div ng-if=\"rol === \'6\'\" class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-c\"></span></div><ul class=\"dropdown-menu\"><li ng-click=\"goToEditarProject(project)\" class=\"cursor\">Editar</li><li ng-click=\"deletedProject(project)\" class=\"cursor\">Borrar</li></ul></div></div><div class=\"centrar centrar-justificar-inicio info\"><div class=\"cont-icon-list\"><img src=\"../../../../../assets/icons/list.png\" alt=\"\"></div><div class=\"centrar centrar-align-start centrar-columna\" style=\"margin-left: 10px;\"><h4 class=\"cursor\" ng-click=\"goToProject(project)\">{{project.nombre | limitTo: 18}}{{project.nombre.length > 18 ? \'...\' : \'\'}}</h4></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/relatedProduct/relatedProduct.html","<div class=\"panel panel-primary bootstrap-panel animated zoomIn\" zoom-in=\"\" ng-if=\"related\"><iframe ng-src=\"{{relatedProduct.url | trustAsResourceUrl}}\" width=\"100%\" height=\"800\"></iframe></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/schedules-list/schedules-list.html","<div class=\"schedules\"><div class=\"grid-container grid-container-header\"><p></p><p class=\"grid-item\">Frecuencia</p><p class=\"grid-item\">Acción inicial</p><p class=\"grid-item\">Acción final</p><p class=\"grid-item\">Intervalo</p><p class=\"grid-item\" ng-if=\"control\"></p></div><div class=\"cont-grid\"><div class=\"grid-container grid-container-body\" ng-repeat=\"schedule in schedules | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"><p class=\"grid-item cursor\"><i ng-click=\"activeSchedule(schedule)\" class=\"ind-status\" ng-class=\"schedule.enable === \'1\' ? \'ion-toggle-filled ind-status-on\': \'ion-toggle\'\"></i></p><p data-label=\"Frecuencia:\" class=\"grid-item\">{{schedule.frecuencia === \'Semanal\' ? convertString(schedule.actionDays) : schedule.frecuencia === \'Diaria\' ? schedule.frecuencia : schedule.actionDate}}<span style=\"margin-left: 7px; font-size: 16px;\" ng-if=\"schedule.actionDate === \'Feriado\'\" class=\"ion-eye cursor\" ng-click=\"showHolidays(schedule.actionDays)\"></span></p><p data-label=\"Acción inicial:\" class=\"grid-item\">{{schedule.action}}</p><p data-label=\"Acción final:\" class=\"grid-item\">{{schedule.postAction}}</p><p data-label=\"Intervalo:\" class=\"grid-item\">{{schedule.hini | limitTo:5 }} - {{schedule.hfin | limitTo:5}}</p><div data-label=\"Administrar:\" class=\"grid-item dropdown prog_opciones centrar centrar-c\" ng-if=\"control\"><span class=\"ion-more boton-opciones dropdown-toggle\" data-toggle=\"dropdown\"></span><ul class=\"dropdown-menu opcion\"><li ng-click=\"editSchedule(schedule)\" ng-hide=\"schedule.action.indexOf(\'subir\') === 0\">Editar</li><li ng-click=\"deleteSchedule(schedule)\">Borrar</li></ul></div></div><div class=\"centrar centrar-c\"><uib-pagination total-items=\"totalItems\" boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-model=\"currentPage\" boundary-link-numbers=\"true\" rotate=\"false\" class=\"pagination-sm\" items-per-page=\"itemsPerPage\" max-size=\"5\" num-pages=\"noOfPages\"></uib-pagination></div><loading-content loading=\"loading\"></loading-content><div ng-if=\"schedules.length == 0 && !loading\" class=\"info-no-schedule margin-top centrar centrar-c\"><p>No hay programaciones para mostrar</p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/sidebar-zones/sidebar-zones.html","<div class=\"sidebar-zones\" id=\"nav\" ng-mouseenter=\"setHover(0)\" ng-mouseleave=\"setHover(1)\"><div class=\"centrar centrar-c centrar-columna width-100p\"><div class=\"ind centrar centrar-justificar-inicio\"><div class=\"icon-zones\"><img src=\"../../../../assets/icons/zones.svg\" alt=\"\"></div><p style=\"margin-bottom: 0;\">Zonas</p></div><div class=\"zone-list width-100p\"><div ng-if=\"showContent\"><div class=\"margin-bottom-10 width-100p\"><input type=\"search\" class=\"search-zone width-100p\" ng-model=\"search_zone.ind\" placeholder=\"Buscar zona\" ng-keyup=\"filtrarZone(search_zone.ind)\"></div><div class=\"cont-zones\" ng-if=\"zones.length > 0\"><div ng-repeat=\"zone in Zonesfiltered\"><div id=\"{{zone.id}}\" class=\"cont-zone myDivs centrar centrar-espaciado-entre\" ng-class=\"{\'active\': zone.status}\"><div class=\"centrar\"><div class=\"centrar cursor centrar-align-left centrar-columna zone\" ng-click=\"selectedZone(zone)\"><h4>{{zone.nombre}}</h4></div></div><div class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span ng-class=\"{\'color-white\':zone.status === true}\" class=\"ion-android-more-vertical centrar centrar-c\"></span></div><ul class=\"dropdown-menu\"><a ui-sref=\"dashboard_cliente.newZone({zone:zone})\"><li class=\"cursor\">Gestionar</li></a></ul></div></div></div></div><loading-content loading=\"loading\"></loading-content><div ng-if=\"zones.length === 0 && loading === false\"><p style=\"padding: 10px; text-align: center;\">No tienes zonas disponibles</p></div></div><div ng-if=\"!showContent\" class=\"centrar centrar-c\"><div class=\"cont-preview\" ng-if=\"zones.length > 0\"><div ng-repeat=\"zone in zones | limitTo:(zones.length < 12 ? zones.length : 12) : (idPosition < 12 ? 0 : idPosition - 11)\" class=\"centrar centrar-c preview-zone\" ng-class=\"{\'active\': zone.status}\"><p>{{shortName(zone.nombre)}}</p></div><div ng-if=\"zones.length > 12 && idPosition !== (zones.length - 1)\" class=\"centrar centrar-columna preview-more\"><p class=\"ind-more-1\"></p><p class=\"ind-more-2\"></p><p class=\"ind-more-3\"></p></div></div></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/zoneCard/zoneCard.html","<div class=\"panel panel-primary bootstrap-panel h_ind_zonas animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading holder_header_zonas centrar\"><div class=\"h_titulo\"><p>{{client.nombre ? client.nombre : \'MIS ZONAS\'}}</p></div></div><div class=\"panel-body cont-zonas\"><div class=\"cont-search centrar\"><input ng-model=\"buscar\" placeholder=\"Buscar Zonas\" class=\"input-sm form-control search-input\" ng-keyup=\"filtrar(buscar)\" type=\"text\"> <button type=\"submit\"><i class=\"ion-search\"></i></button></div><div><zone-table ng-repeat=\"zona in filtered = client.zonas | filter:buscar | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\" zone=\"zona\" owner=\"owner\"></zone-table><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content><div class=\"centrar centrar-c\"><uib-pagination total-items=\"totalItems\" boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-model=\"currentPage\" boundary-link-numbers=\"true\" rotate=\"false\" class=\"pagination-sm\" items-per-page=\"itemsPerPage\" max-size=\"5\" num-pages=\"noOfPages\"></uib-pagination></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/zoneTable/zoneTable.html","<div class=\"cont-zonas-header\"><div class=\"centrar zona-title\" ng-class=\"{\'border-bottom\': status.open && monitoringMode === \'1\'}\"><p ng-click=\"showDis(zone,status.open)\" class=\"cursor margin-0\" ng-class=\"{\'bold\': status.open}\">{{zone.nombre}}</p><div class=\"centrar\"><div class=\"centrar centrar-justificar-final margin-10\"><button class=\"btn-add-schedule-zone color-middle-dark-blue centrar centrar-c\" ng-click=\"goStatistics(zone)\" title=\"Ver Estadísticas\"><span class=\"ion-stats-bars\"></span></button> <button class=\"btn-add-schedule-zone color-dark-blue centrar centrar-c\" ng-click=\"goSchedules(zone)\" title=\"Ver Programaciones\"><span class=\"ion-calendar\"></span></button></div><div class=\"dropdown\" ng-if=\"owner\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-c\"></span></div><ul class=\"dropdown-menu\"><a ui-sref=\"dashboard_cliente.newZone({zone:zone})\"><li class=\"cursor\">Gestionar</li></a></ul></div></div></div><div ng-if=\"status.open && monitoringMode === \'0\'\" class=\"cont-device device-control centrar centrar-columna\"><div ng-if=\"showIndFilterDevices\" class=\"centrar centrar-justificar-inicio margin-bottom-10 width-100p\"><p class=\"cursor ind-filter-device\" ng-class=\"{\'ind-filter-device-active\': ind.status}\" ng-repeat=\"ind in indFilterActives\" ng-click=\"filterActives(ind.id)\">{{ind.name}}</p></div><div class=\"margin-bottom-10 width-100p\"><input type=\"search\" class=\"search-device width-100p\" ng-model=\"search_device\" placeholder=\"Buscar dispositivo\" ng-keyup=\"filtrarDevice(search_device)\"></div><p ng-click=\"exportExcel()\">exportar</p><div class=\"grid-container grid-title width-100p\"><p class=\"grid-item\">Dispositivo</p><p class=\"grid-item\">Conexión Plataforma</p><p class=\"grid-item\">{{integracion === \'1\' ? \'Variables\': \'Última conexión\'}}</p><p class=\"grid-item\">Estado</p><p class=\"grid-item\">Control</p></div><device-control ng-repeat=\"device in filtered\" device=\"device\" devices=\"filtered\" integracion=\"integracion\" zone=\"zone\" server-hour=\"serverHour\" control=\"control\" class=\"device-control width-100p\"></device-control><a ui-sref=\"mantenimiento_newApparatus({zone:zone, control: control})\" class=\"centrar-align-self-start\"><div class=\"button-add centrar centrar-c cursor\" ng-class=\"\" title=\"Agregar dispositivo\"><span class=\"ion-plus-round\"></span></div></a></div><div class=\"monitoring\" ng-if=\"status.open && monitoringMode === \'1\'\"><div class=\"grid-monitoring\"><div class=\"grid-monitoring-item\"><tabs></tabs><tabs-energy></tabs-energy><tabs-saeg></tabs-saeg><tabs-helo-energy-plus></tabs-helo-energy-plus><div class=\"row\" ng-if=\"showInds\"><ind-data ng-repeat=\"ind in indicadoresGrafica.inds\" ind-title=\"ind\" unit=\"indicadoresGrafica.unit\" initial=\"indicadoresGrafica.initial_value\"></ind-data></div><div class=\"row\"><content-graph></content-graph></div></div><div class=\"grid-monitoring-item\"><control-devices-list devices=\"filtered\" zone=\"zone\" server-hour=\"serverHour\" control=\"control\"></control-devices-list></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_ahorro/grafica_ahorro_c.html","<div id=\"grafica_ahorro_c\" class=\"grafica_ahorro_c\" ng-controller=\"grafica_ahorro_cCtrl\"></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_comportamiento_aire/grafica_comportamiento_aire.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"grafica_comportamiento_aireCtrl\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">{{ind_unit}}</p></div><div id=\"{{indicador}}\" style=\"width:100%; height:400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar centrar-align-self-start\"><div class=\"centrar\"><div class=\"ind-legend legend-color-1\"></div><p>Usuario</p></div><div class=\"centrar\"><div class=\"ind-legend legend-color-2\"></div><p>Helo</p></div></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\" ng-if=\"(graphType === \'behavior\') || (graphType === \'temp\' && (rol === \'6\' || rol === \'8\'))\"><div ng-click=\"update_date(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_conmutacion/grafica_conmutacion.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"grafica_commutationCtrl\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">Valor</p></div><div id=\"{{indicador}}\" style=\"width:100%; height:400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"consulta_comp(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div><div ng-if=\"DateFilter[1].status\" class=\"centrar ind-diferido\"><button class=\"centrar\" ng-click=\"consulta_comp(\'month\', interval)\" ng-disabled=\"loading || interval === intelvalLimite\"><span class=\"ion-android-arrow-dropdown-circle\"></span></button><p>({{interval}}/{{intelvalLimite}})</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_consumo/grafica_consumo.html","<div class=\"centrar centrar-columna\" ng-controller=\"grafica_consumoCtrl\"><div class=\"centrar width-100p\"><p class=\"margin-0\">{{ind_unit}}</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"{{indicador}}\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_consumo_helo_mc/grafica_consumo_helo_mc.html","<div class=\"centrar centrar-columna\" ng-controller=\"grafica_consumo_helo_mcCtrl\"><div class=\"centrar width-100p\"><p class=\"margin-0\">W</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"{{indicador}}\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar centrar-columna centrar-align-start width-100p margin-top-10\"><h3>Canales</h3><div class=\"centrar centrar-align-start\"><div class=\"centrar\" style=\"margin-right: 10px;\" ng-repeat=\"canal in canales\"><p class=\"margin-0\">{{canal.nombre}}</p><input style=\"margin: 0 0 0 10px;\" type=\"checkbox\" ng-model=\"canal.estado\" name=\"\" id=\"\" ng-change=\"setChannel(canal, canal.estado)\"></div></div></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(filter.id, true)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_consumo_zona/grafica_consumo_zona.html","<div ng-controller=\"grafica_consumo_zonaCtrl\" class=\"centrar centrar-columna\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM dd, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">KWh</p></div><div id=\"grafica_consumo_zona\" style=\"width: 100%; height: 400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(\'d\')\" class=\"filtro cursor\" ng-class=\"{\'filtro-activo\':filtro_dia == true}\"><p>Día</p></div><div ng-click=\"filtrar(\'s\')\" class=\"filtro cursor\" ng-class=\"{\'filtro-activo\':filtro_semana == true}\"><p>Semana</p></div><div ng-click=\"filtrar(\'m\')\" class=\"filtro cursor\" ng-class=\"{\'filtro-activo\':filtro_mes == true}\"><p>Mes</p></div><div ng-click=\"filtrar(\'a\')\" class=\"filtro cursor\" ng-class=\"{\'filtro-activo\':filtro_year == true}\"><p>Año</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_desconexiones/grafica_desconexiones_c.html","<div class=\"h_grafica_desconexiones_c\"><div id=\"grafica_desconexiones_c\" class=\"grafica_desconexiones_c\" ng-controller=\"grafica_desconexiones_cCtrl\"></div><div class=\"h_bola\"><div class=\"bola_ahorro_dia\" ng-controller=\"grafica_desconexiones_cCtrl\"><p id=\"ahorro_dia\">{{ahorro | number:0}}</p><p>Wh</p></div><div class=\"ahorro_ind\"><p>Ahorro del día</p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_dimmer/grafica_dimmer.html","<div ng-controller=\"grafica_dimmerCtrl\" class=\"centrar centrar-columna\"><div class=\"centrar width-100p\"><p class=\"margin-0\">%</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"{{indicador}}\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_energia/grafica_energia.html","<div ng-controller=\"grafica_energiaCtrl\" class=\"centrar centrar-columna\"><div class=\"centrar centrar-c width-100p\"><p class=\"ind-variable\">{{graph_name}}</p></div><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM dd, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">{{unit}}</p></div><div id=\"{{indicador}}\" style=\"width: 100%; height: 400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div><div ng-if=\"DateFilter[1].status && type_graph === \'power\'\" class=\"centrar ind-diferido\"><button class=\"centrar\" ng-click=\"filtrar(\'month\')\" ng-disabled=\"loading || interval === intelvalLimite\"><span class=\"ion-android-arrow-dropdown-circle\"></span></button><p>({{interval}}/{{intelvalLimite}})</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_energia_helo_e/grafica_energia_helo_e.html","<div ng-controller=\"grafica_energia_helo_e_Ctrl\" class=\"centrar centrar-columna\"><div class=\"centrar width-100p\"><p class=\"margin-0\">Wh</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"{{indicador}}\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_error/grafica_error.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"ErrorCtrl\"><div ng-if=\"noInfo\" class=\"centrar centrar-c cont-noInfo\"><h2>No hay información para mostrar</h2></div><div ng-if=\"!noInfo\" class=\"centrar centrar-columna centrar-c width-100p\" style=\"min-height:400px;\"><div ng-if=\"status === \'ok\'\" class=\"centrar centrar-columna centrar-c width-100p\" style=\"min-height:400px;\"><div class=\"status-panel status-ok\"><i class=\"ion-checkmark-circled status-icon\" style=\"font-size:64px; color:#4CAF50;\"></i><h2 class=\"status-title\" style=\"color:#4CAF50;\">Sin error</h2><p class=\"status-text\">Todo funcionando correctamente</p></div></div><div ng-if=\"status === \'error\'\" class=\"centrar centrar-columna centrar-c width-100p\" style=\"min-height:400px;\"><div class=\"status-panel status-error\" style=\"background:#fff3f3; border:2px solid #f44336; border-radius:8px; padding:30px; text-align:center;\"><i class=\"ion-close-circled status-icon\" style=\"font-size:64px; color:#f44336;\"></i><h2 class=\"status-title\" style=\"color:#f44336; margin-top:15px;\">Con error</h2><p class=\"status-text\" style=\"font-size:18px;\">Código de error: <strong style=\"font-size:28px;\">{{errorCode}}</strong></p><p class=\"status-subtext\" style=\"color:#999;\">Contacte a soporte técnico si el error persiste</p></div></div></div><div class=\"width-100p\" style=\"margin-top:30px;\"><div ng-include=\"\'app/cliente/dashboard-cliente/estadisticas_zona/grafica_comportamiento_aire/grafica_comportamiento_aire.html\'\"></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_fpt/grafica_fpt.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"grafica_fptCtrl\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">Valor</p></div><div id=\"graficaFpt\" style=\"width:100%; height:400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"consulta_comp(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div><div ng-if=\"DateFilter[1].status\" class=\"centrar ind-diferido\"><button class=\"centrar\" ng-click=\"consulta_comp(\'month\', interval)\" ng-disabled=\"loading || interval === intelvalLimite\"><span class=\"ion-android-arrow-dropdown-circle\"></span></button><p>({{interval}}/{{intelvalLimite}})</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_helo_s_plus/grafica_helo_s_plus.html","<div class=\"centrar centrar-columna\" ng-controller=\"grafica_helo_s_plus_Ctrl\"><div class=\"centrar centrar-c width-100p\"><p class=\"ind-variable\">{{graph_name}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">{{unit}}</p></div><div class=\"width-100p\"><div class=\"width-100p\" style=\"height: 400px;\" id=\"{{indicador}}\"></div></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_humedad/grafica_humedad.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"grafica_humedadCtrl\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">{{ind_unit}}</p></div><div id=\"{{indicador}}\" style=\"width:100%; height:400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\" ng-if=\"(graphType === \'humidity\' && (rol === \'6\' || rol === \'8\'))\"><div ng-click=\"consulta_comp(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_mpx/grafica_mpx.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"grafica_mpxCtrl\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">{{ind_unit}}</p></div><div id=\"{{indicador}}\" style=\"width:100%; height:500px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_presion/grafica_presion.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"grafica_presionCtrl\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">Presión Bar</p></div><div id=\"{{indicador}}\" style=\"width:100%; height:500px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_scfm_kw/grafica_scfm_kw.html","<div ng-controller=\"grafica_scfm_kwCtrl\"><div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-hide=\"settings\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">SCFM/KW</p></div><div class=\"centrar centrar-justificar-inicio width-100p centrar-flex-flow margin-10\"><div ng-repeat=\"itmMatch in medidores\" class=\"centrar matchElement\"><div class=\"info-user\"><p>{{itmMatch.nombre}}</p></div><div class=\"button-close cursor\" ng-click=\"deteleMeasure(itmMatch)\"><span class=\"ion-close-round\"></span></div></div></div><div id=\"grafica_scfm_kw\" style=\"width:100%; height:400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"consulta_comp(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div><div ng-if=\"DateFilter[1].status\" class=\"centrar ind-diferido\"><button class=\"centrar\" ng-click=\"consulta_comp(\'month\', interval)\" ng-disabled=\"loading || interval === intelvalLimite\"><span class=\"ion-android-arrow-dropdown-circle\"></span></button><p>({{interval}}/{{intelvalLimite}})</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><setting-scfm-kw ng-show=\"settings\"></setting-scfm-kw></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_sensores/grafica_sensores.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"grafica_sensoresCtrl\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">{{ind_unit}}</p></div><div id=\"{{indicador}}\" style=\"width:100%; height:400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_temp_dist/grafica_temp_dist.html","<div ng-controller=\"grafica_temp_distCtrl\" class=\"centrar centrar-columna\"><div style=\"width:100%;\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">Temperatura °C</p></div><div id=\"grafica_temp_dist\" style=\"width:100%; height:350px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Distancia (m)</p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_temp_humedad_potencia/grafica_temp_humedad_potencia.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"grafica_thpCtrl\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">Humedad / Temperatura / Potencia</p></div><div id=\"{{indicador}}\" style=\"width:100%; height:500px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_uso_aire/grafica_uso_aire.html","<div class=\"grafica_uso_aire centrar centrar-columna\" ng-controller=\"grafica_uso_aireCtrl\"><div class=\"centrar centrar-justificar-inicio width-100p\"><p>{{fecha_consulta | date : \'MMMM d, y\'}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">{{indTime}}</p></div><div id=\"{{indicador}}\" style=\"width:100%; height:350px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar width-100p filtros-cont\"><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in DateFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div><div class=\"margin-top\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\" ng-change=\"update_date()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/graficas_saeg/graficas_saeg.html","<div class=\"grafica_comportamiento_aire centrar centrar-columna\" ng-controller=\"graficas_saegCtrl\"><div class=\"centrar centrar-c width-100p\"><p class=\"ind-variable\">{{variable}}</p></div><div class=\"centrar width-100p\"><p class=\"margin-0\">{{unit}}</p></div><div id=\"{{indicador}}\" style=\"width:100%; height:400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div><div class=\"centrar centrar-justificar-inicio centrar-align-end width-100p filtros-cont margin-10\"><div class=\"margin-10\"><p class=\"custom-title\">Fecha inicial</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_ini\" is-open=\"popup.opened_1\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"margin-10\"><p class=\"custom-title\">Fecha Final</p><div class=\"centrar cont-date\"><p class=\"input-group margin-0 width-200\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_final\" is-open=\"popup.opened_2\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"centrar centrar-aling-self-end\"><button style=\"padding: 15px; height: 34px; margin-bottom: 10px;\" class=\"btn-add-activo centrar centrar-c\" ng-click=\"update_date()\">Consultar</button></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/oferta_operador/modals/error_no_desconexion.html","<div class=\"modal-message modal-success\"><div class=\"modal-title\"><h3>{{titleModal}}</h3></div><div class=\"modal-body\"><div><p>No has agregado ninguna desconexión a esta oferta. Verifica nuevamente y vuelve a internarlo.</p></div><button type=\"button\" class=\"btn btn-default\" ng-click=\"cerrar()\">Aceptar</button></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/oferta_operador/modals/validar_desconexion.html","<div class=\"modal-message modal-success\"><div class=\"modal-title\"><h3>{{titleModal}}</h3></div><div class=\"modal-body\"><div><p>Mira con atención las desconexiones que Helo realizará automaticamente durante la oferta del comercializador</p></div><div class=\"centrar centrar-align-start padding-4\"><div class=\"centrar centrar-columna centrar-align-start\"><div><p class=\"margin-0\">Fecha de desconexion</p><h4>{{desconexion.fecha_limite}}</h4></div><div><p class=\"margin-0\">Hora de desconexion</p><h4>{{desconexion.hora_in}} - {{desconexion.hora_fin}}</h4></div></div><div class=\"centrar centrar-columna centrar-align-start\"><div><p class=\"margin-0\">Valo KWh</p><h4>{{desconexion.valor_oferta}}</h4></div><div><p class=\"margin-0\">Pago por desconexion</p><h4>{{desconexion.total_oferta}}</h4></div><div><p class=\"margin-0\">Carga total a desconectar</p><h4>{{desconexion.carga_progressbar}}</h4></div></div></div><div><p>Zonas a desconectar</p></div><table class=\"table-bordered table-condensed width-100\"><thead><th class=\"bold\">Nombre Zona</th><th class=\"bold\">Dispositivos</th><th class=\"bold\">Carga</th></thead><tbody><tr ng-repeat=\"zona in desconexion.zonas\"><td>{{zona.nombre}}</td><td><p ng-if=\"dispositivo.estado==true\" ng-repeat=\"dispositivo in zona.dispositivos\">{{dispositivo.nombre}}</p></td><td>{{zona.carga_zona}}</td></tr></tbody><tfoot><tr class=\"bold\"><td colspan=\"2\" class=\"text-align-right\">TOTAL</td><td>{{desconexion.carga_progressbar}}</td></tr></tfoot></table><div class=\"margin-top-10\"><button type=\"button\" class=\"btn btn-default color-1\" ng-click=\"editar()\">Editar</button> <button type=\"button\" class=\"btn btn-default color-4\" ng-click=\"enviar_des()\">Enviar</button></div></div></div>");
$templateCache.put("app/cliente/mantenimiento/components/filterMaintenance/filterMaintenance.html","<div class=\"centrar cont-filtros\"><div class=\"filtro cursor\" ng-init=\"todo = true\" ng-class=\"{\'filtro-activo\':todo == true}\" ng-click=\"filtrar(\'\') ; todo = true; red = false; green = false\"><p>Todo</p></div><div class=\"filtro cursor\" ng-init=\"red = false\" ng-class=\"{\'filtro-activo\':red == true}\" ng-click=\"filtrar(\'red\') ; red = true; todo = false; green = false\"><p>Rojo</p></div><div class=\"filtro cursor\" ng-init=\"green = false\" ng-class=\"{\'filtro-activo\':green == true}\" ng-click=\"filtrar(\'green\') ; green = true; red = false; todo = false\"><p>Verde</p></div></div>");
$templateCache.put("app/cliente/mantenimiento/components/maintenanceCard/maintenanceCard.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 maintenance-card\"><p class=\"title\">Dispositivos en mantenimiento</p><div class=\"panel panel-primary bootstrap-panel zoomIn panel-smart-bar\"><div class=\"panel-heading holder_header centrar centrar-columna\"><div class=\"centrar centrar-flex-flow width-100p\"><div class=\"h_titulo\"><select class=\"select-maintenance-zone\" ng-model=\"id\" ng-change=\"get_maintenances(id)\" ng-options=\"zona.id as zona.nombre for zona in zones\" id=\"zonas\" name=\"zonas\"></select><div class=\"has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar por nombre\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"text\"> <i class=\"ion-search form-control-feedback\"></i></div></div><div class=\"centrar item-right\"><selected-filter nombre=\"\'Ordenar por\'\" lista=\"listaOrden\" selected=\"filterOrderBy\"></selected-filter><div class=\"centrar centrar-c cont-btn-printer\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><span class=\"ion-printer btn-printer\"></span></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><i class=\"dropdown-arr\"></i></li><li><a ng-click=\"imprimirTodos()\" class=\"btn-printer-option cursor\">Imprimir todos</a></li><li><a ng-click=\"imprimirM()\" class=\"btn-printer-option cursor\">Imprimir solo mantenimiento</a></li></ul></div></div></div><div class=\"centrar centrar-align-self-start\"><p class=\"ind-filter\" ng-repeat=\"filter in filters\">{{filter | limitTo: 15}}{{filter.length > 15 ? \'...\': \' \'}}</p></div></div><div class=\"panel-body cont-sm-card-with-scroll\"><div class=\"cont-sm-card-list\" ng-class=\"{\'toPrint\': print}\"><div class=\"centrar sm-card-list-item cursor\" ng-repeat=\"device in devicesFiltered\" ng-click=\"goMantenimientoLog(device)\"><div class=\"centrar centrar-columna centrar-align-start sm-card-list-item-ind\"><p>{{device.nombre}}</p><p class=\"sub-ind\">Zona: {{device.nombre_zona}}</p></div><div class=\"centrar centrar-columna sm-card-list-item-comp\"><p ng-class=\"{\'warning-item\': device.filter === \'red\'}\">{{device.horas_uso === null ? \'Sin datos\' : device.horas_uso}}</p><p class=\"itm-unit\">horas de uso</p></div></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div></div></div></div>");
$templateCache.put("app/cliente/mantenimiento/components/maintenanceTabs/maintenanceTabs.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"panel animated zoomIn maintenance-tab\"><div class=\"form-group has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"filtrar3(buscar)\" type=\"text\"> <i class=\"ion-search form-control-feedback\"></i></div><div class=\"centrar\"><div class=\"tab cursor\" ng-repeat=\"tab in tabs\" ng-click=\"selectTab(tab)\"><h3 ng-class=\"{\'tab-active-h3\': tab.status}\">{{tab.name}}</h3><div ng-class=\"{\'tab-active\': tab.status}\" class=\"tab-ind\"></div></div></div><div><div ng-if=\"tabActive === 0\"><maintenance-tables zone=\"zone\" ng-repeat=\"zone in filtered = zones | filter:buscar | filter:categoryFilter | startFrom:(currentPage-1)*itemsPerPage | limitTo:itemsPerPage\"></maintenance-tables><div class=\"centrar centrar-c\"><uib-pagination total-items=\"zones.length\" boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-model=\"currentPage\" boundary-link-numbers=\"true\" rotate=\"false\" class=\"pagination-sm\" items-per-page=\"itemsPerPage\" max-size=\"5\"></uib-pagination></div></div><div ng-if=\"tabActive === 1\"><div ng-repeat=\"client in clients\"><p ng-click=\"selectClient(client, $event)\" class=\"cont-client cursor\">{{client.nombre}}</p></div><maintenance-tables zone=\"zone\" ng-repeat=\"zone in filteredZones\"></maintenance-tables><div class=\"centrar centrar-c\" ng-hide=\"filterActivo\"><uib-pagination total-items=\"filteredZones.length\" boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-model=\"currentPage\" boundary-link-numbers=\"true\" rotate=\"false\" class=\"pagination-sm\" items-per-page=\"itemsPerPage\" max-size=\"5\"></uib-pagination></div><div class=\"centrar centrar-c\" ng-show=\"filterActivo\"><uib-pagination total-items=\"totalItems\" boundary-links=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-model=\"currentPage\" boundary-link-numbers=\"true\" rotate=\"false\" class=\"pagination-sm\" items-per-page=\"itemsPerPage\" max-size=\"5\"></uib-pagination></div></div></div></div></div>");
$templateCache.put("app/cliente/mantenimiento/components/solicitarMantenimiento/solicitarMantenimiento.html","<div><button class=\"btn-add-activo width-100p centrar centrar-c\" ng-click=\"solicitarMantenimiento()\" title=\"Solicitar Mantenimiento\">Solicitar Mantenimiento</button></div>");
$templateCache.put("app/cliente/mantenimiento/directives/maintenance_limit/maintenance_limit.html","<div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Límite de mantenimiento\" ba-panel-class=\"\"><div class=\"centrar centrar-c\"><div class=\"centrar centrar-align-start\"><p class=\"margin-0 consolidado-dato consolidado-dato-limite\" ng-if=\"editar_limite==false\">{{limite}}</p><input type=\"number\" ng-model=\"nuevo_limite.valor\" value=\"\" ng-if=\"editar_limite\" class=\"editar-limite-mantenimiento\" autofocus=\"\"><p class=\"margin-0 consolidado-unidad\">horas</p></div><div class=\"centrar\" ng-if=\"control\"><span class=\"ion-edit icon-editar cursor\" ng-click=\"abrirEditar()\"></span></div></div><div class=\"centrar centrar-c\" ng-if=\"editar_limite\"><div class=\"centrar centrar-c btn-editar btn-guardar cursor\" ng-click=\"guardarNuevoLimite()\"><p class=\"margin-0\">Guardar</p></div><div class=\"centrar centrar-c btn-editar btn-cerrar cursor\" ng-click=\"cerrarEditar()\"><p class=\"margin-0\">Cerrar</p></div></div></div>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/apparatus_profile.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"row\"><div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\"><bread-crumbs></bread-crumbs></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><div class=\"centrar width-100p centrar-justificar-final margin-10-20\"><div ng-if=\"control_d\" ng-click=\"goEdit(apparatusProfile)\" class=\"centrar centrar-c cont-btn-printer\"><span class=\"ion-edit cursor\"></span></div><div ng-if=\"(type === \'2\' || type === \'3\' || type === \'4\' || type === \'5\' || type === \'6\' || type === \'14\' || type === \'15\' || type === \'16\' || type === \'21\' || type === \'22\' || type === \'23\' || type === \'27\' || type === \'28\' || type === \'29\' || type === \'30\' || type === \'31\' || type === \'32\') && control_d\" ng-click=\"goSettings(apparatusProfile)\" class=\"centrar centrar-c cont-btn-printer\"><span class=\"ion-gear-b cursor\"></span></div><div ng-if=\"type === \'31\' && control_d\" ng-click=\"goAddDevicesHub(apparatusProfile)\" class=\"centrar centrar-c cont-btn-printer\"><span style=\"font-size: 25px;\" class=\"ion-grid cursor\"></span></div><div ng-if=\"rol_ind === \'6\' || rol_ind === \'8\' || rol_ind === \'12\'\" title=\"Liberar Dispositivo\" ng-click=\"liberarEquipo(apparatusProfile)\" class=\"centrar centrar-c cont-btn-printer\"><span style=\"font-size: 25px;\" class=\"ion-log-out cursor\"></span></div></div></div></div><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-3 col-md-4 col-sm-4 col-xs-12\"><div class=\"animated zoomIn centrar centrar-columna device-profile\"><div class=\"cont-img\"><img ng-src=\"{{images.length > 0 ? images[0].url : \'../../../../../assets/img/device_default.png\'}}\" alt=\"\"></div><div class=\"centrar centrar-columna title\"><h1>{{apparatusProfile.nombre}}</h1><h6>{{apparatusProfile.nombre_zona ? apparatusProfile.nombre_zona : \'--\'}}</h6><p>Zona</p></div></div></div><div class=\"col-lg-9 col-md-8 col-sm-8 col-xs-12\"><div class=\"animated zoomIn device-profile device-profile-info\"><div class=\"centrar centrar-justificar-inicio centrar-flex-flow\"><div class=\"tabs\" ng-repeat=\"tab in tabs\" ng-class=\"{\'selected\' : tab.selected}\"><p class=\"cursor\" ng-click=\"selectTab(tab.index)\">{{tab.name}}</p></div></div><div style=\"margin: 30px 0 10px 20px;\"><div ng-show=\"indtab === 0\"><div ng-if=\"apparatusProfile.registro == false && device.tipo !== \'23\'\" class=\"cont-code\"><div class=\"centrar code\"><h4 id=\"textToCopy\">{{apparatusProfile.code_device}}</h4><span ng-click=\"copy()\" class=\"cursor\">COPIAR</span></div><p>Código de dispositivo</p></div><div class=\"general\"><p>Tipo</p><h3>{{apparatusProfile.tipo_.nombre ? apparatusProfile.tipo_.nombre : \'--\'}}</h3><p>Marca</p><h3>{{apparatusProfile.marca ? apparatusProfile.marca : \'--\'}}</h3><p>Serie</p><h3>{{apparatusProfile.serie ? apparatusProfile.serie : \'--\'}}</h3><p>Referencia</p><h3>{{apparatusProfile.referencia ? apparatusProfile.referencia : \'--\'}}</h3></div></div><div class=\"caracteristicas\" ng-show=\"indtab === 1\"><div class=\"general\" ng-if=\"!apparatusProfile.caracteristicas\"><p>Potencia nominal</p><h3>{{apparatusProfile.potencia_nominal ? apparatusProfile.potencia_nominal : \'--\'}}</h3><p>Corriente nominal</p><h3>{{apparatusProfile.corriente_nominal ? apparatusProfile.corriente_nominal : \'--\'}}</h3><p>Corriente de arranque</p><h3>{{apparatusProfile.corriente_arranque ? apparatusProfile.corriente_arranque : \'--\'}}</h3><p>Eficiencia</p><h3>{{apparatusProfile.eficiencia ? apparatusProfile.eficiencia : \'--\'}}</h3><p>Seguridad</p><h3>{{apparatusProfile.seguridad ? apparatusProfile.seguridad : \'--\'}}</h3><p>Voltaje</p><h3>{{apparatusProfile.voltaje ? apparatusProfile.voltaje : \'--\'}}</h3><p>Frecuencia</p><h3>{{apparatusProfile.frecuencia ? apparatusProfile.frecuencia : \'--\'}}</h3><p>Hp</p><h3>{{apparatusProfile.hp ? apparatusProfile.hp : \'--\'}}</h3><p>Factor de potencia</p><h3>{{apparatusProfile.factor_potencia ? apparatusProfile.factor_potencia : \'--\'}}</h3><p>Peso</p><h3>{{apparatusProfile.peso ? apparatusProfile.peso : \'--\'}}</h3><p>Frío BTU</p><h3>{{apparatusProfile.frio_btu ? apparatusProfile.frio_btu : \'--\'}}</h3><p>IP</p><h3>{{apparatusProfile.ip ? apparatusProfile.ip : \'--\'}}</h3><p>Capacidad de carga</p><h3>{{apparatusProfile.capacidad_carga ? apparatusProfile.capacidad_carga : \'--\'}}</h3><p>Dimensiones en m3</p><h3>{{apparatusProfile.dimensiones_m3 ? apparatusProfile.dimensiones_m3 : \'--\'}}</h3><p>Refrigerante</p><h3>{{apparatusProfile.refrigerante ? apparatusProfile.refrigerante : \'--\'}}</h3><p>Calor BTU</p><h3>{{apparatusProfile.calor_btu ? apparatusProfile.calor_btu : \'--\'}}</h3><p>Velocidad</p><h3>{{apparatusProfile.velocidad ? apparatusProfile.velocidad : \'--\'}}</h3></div><div ng-if=\"apparatusProfile.caracteristicas\"><div class=\"general margin-bottom-20\" ng-repeat=\"characteristic in deviceCaracteristicas\"><p>{{characteristic.titulo}}</p><h3>{{characteristic.valor}}</h3></div></div></div><div class=\"general\" ng-show=\"indtab === 2\"><p>Nombre</p><h3>{{apparatusProfile.nombre_encargado ? apparatusProfile.nombre_encargado : \'--\'}}</h3><p>Correo</p><h3 ng-repeat=\"email in apparatusProfile.email_encargado\">{{email}}</h3><p>Tel</p><h3>{{apparatusProfile.tel_encargado ? apparatusProfile.tel_encargado : \'--\'}}</h3></div><div class=\"galeria\" ng-show=\"indtab === 3\"><div ng-if=\"images.length > 0\" class=\"centrar centrar-justificar-inicio centrar-flex-flow\"><div class=\"item cursor\" ng-click=\"showImage($index)\" ng-repeat=\"imagen in images\"><img ng-src=\"{{imagen.url}}\" alt=\"\"></div></div><p style=\"font-size: 20px; font-weight: 300; font-style: italic;\" ng-if=\"images.length === 0\">No hay imágenes para mostrar</p></div></div></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/maintenance_detail/maintenance_detail.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"row\"><div class=\"col-lg-11 col-md-11 col-sm-12 col-xs-12\"><bread-crumbs></bread-crumbs></div><div class=\"col-lg-1 col-md-1 col-sm-12 col-xs-12\"><div class=\"centrar centrar-justificar-final\"><div class=\"centrar centrar-c cont-btn-printer cursor\" ng-click=\"imprimir()\" ng-if=\"printerView\"><span class=\"ion-printer btn-printer\"></span></div></div></div></div><div class=\"dinamic_content\"><div class=\"row margin-top\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"animated zoomIn cont-maintenance\"><div class=\"maintenance-general-info\"><div class=\"cont-logo\"><img ng-src=\"{{profile.image === \'\' ? \'../../../../../assets/img/helo_logo_bg_a.jpg\' : profile.image}}\" alt=\"\"></div><div style=\"border-right: 1px solid #ccc;\" class=\"centrar centrar-columna centrar-align-start padding\"><div class=\"ind-consecutivo-mobile centrar centrar-columna centrar-align-end centrar-align-self-end margin-bottom-20\"><h2>{{maintenance.consecutivo}}</h2><p class=\"ind\">Consecutivo</p></div><h3>General</h3><p class=\"ind\">Activo</p><h4>{{device.nombre}}</h4><p class=\"ind\">Zona</p><h4>{{device.nombre_zona}}</h4><p class=\"ind\">Tipo de mantenimiento</p><h4>{{maintenance.tipo == \'0\' ? \'Preventivo\' : \'Correctivo\'}}</h4><p class=\"ind\">Fecha de mantenimiento</p><h4>{{maintenance.fecha | date:\'MMMM d, y\'}}</h4><p class=\"ind\">Hora de mantenimiento</p><h4>{{maintenance.fecha | date:\'mediumTime\'}}</h4><h3 class=\"margin-top\">Encargado</h3><p class=\"ind\">Técnico</p><h4>{{maintenance.responsable}}</h4><p class=\"ind\">Tel</p><h4>{{maintenance.telefono}}</h4><p class=\"ind\">Creación de registro</p><h4>{{ maintenance.fecha_actualizacion | date:\'MMMM d, y\'}}</h4><h3 class=\"margin-top\">Próximo mantenimiento</h3><p class=\"ind\">Fecha</p><h4>{{maintenance.fecha_proximo | date:\'MMMM d, y\'}}</h4></div></div><div class=\"maintenance-description\"><div class=\"ind-consecutivo-desktop centrar centrar-columna centrar-align-end\"><h2>{{maintenance.consecutivo}}</h2><p class=\"ind\">Consecutivo</p></div><div class=\"centrar centrar-columna centrar-align-start\"><h3 class=\"margin-top\">Procedimiento</h3><h5>Estado en el que se encontró el equipo:</h5><p style=\"margin-bottom: 35px;\">{{maintenance.estado_actual}}</p><h5>Estado en el que se dejó el equipo:</h5><p style=\"margin-bottom: 35px;\">{{maintenance.estado_final}}</p><h5>Descripción del procedimiento:</h5><p style=\"margin-bottom: 35px;\">{{maintenance.descripcion}}</p><h5>Repuestos usados:</h5><p style=\"margin-bottom: 35px;\" ng-if=\"maintenance.repuestos !== \'\'\"><span ng-repeat=\"repuesto in maintenance.repuestos track by $index\">{{repuesto}}{{ $index < (maintenance.repuestos.length - 1) ? \',\': \'\'}}</span></p><p style=\"margin-bottom: 35px;\" ng-if=\"maintenance.repuestos === \'\'\">ninguno</p></div><div class=\"centrar centrar-columna centrar-align-start\" ng-if=\"maintenance.lista_chequeo\"><h3 class=\"margin-top\">Listas de Chequeo</h3><div ng-repeat=\"lista in listasDeChequeo\" class=\"width-100p\"><h5>{{lista.nombre}}</h5><div class=\"item\"><div class=\"grid-container grid-container-header\"><p class=\"centrar\">Descripción</p><p class=\"centrar centrar-c\">Estado</p><p class=\"centrar centrar-c\">Valor</p></div><div class=\"grid-container grid-container-body\" ng-repeat=\"item in lista.lista\"><p>{{item.description}}</p><p class=\"centrar centrar-c\">{{item.chequeo}}</p><div class=\"centrar centrar-c valores\"><p ng-if=\"item.valores[0]\">{{item.valores[0] === \'\' ? \'NA\': item.valores[0]}}</p><p ng-if=\"item.valores[1]\">{{item.valores[1]}}</p><p ng-if=\"item.valores[2]\">{{item.valores[2]}}</p></div></div></div></div></div><div class=\"centrar centrar-columna centrar-align-start galeria\"><h3 class=\"margin-top\">Imágenes adjuntas</h3><div ng-if=\"maintenance.imagenes\" class=\"centrar centrar-justificar-inicio centrar-flex-flow\"><div class=\"item cursor\" ng-click=\"showImage($index)\" ng-repeat=\"imagen in maintenance.imagenes\"><img ng-src=\"{{imagen.url}}\" alt=\"\"></div></div><p style=\"font-size: 20px; font-weight: 300; font-style: italic;\" ng-if=\"!maintenance.imagenes\">No hay imágenes para mostrar</p></div></div></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/new_maintenance/actionList/actionList.html","<div class=\"check-list-item\"><div><h2>{{list.name}}</h2></div><div class=\"grid-container check-list-ind\"><p class=\"grid-item\"></p><p class=\"grid-item centrar centrar-c\"><strong>SÍ</strong></p><p class=\"grid-item centrar centrar-c\"><strong>NO</strong></p><p class=\"grid-item centrar centrar-c\"><strong>NA</strong></p><p class=\"grid-item centrar centrar-c\"><strong>VALOR</strong></p></div><check-list class=\"check-list-body\" item=\"item\" ng-repeat=\"item in list.items\" par=\"($index % 2 === 0) ? true : false\"></check-list></div>");
$templateCache.put("app/cliente/mantenimiento/new_maintenance/checkList/checkList.html","<div class=\"grid-container check-list-body\" ng-class=\"{par : par}\"><p class=\"grid-item centrar\">{{item.descripcion}}</p><div class=\"centrar centrar-c grid-item\"><input type=\"radio\" name=\"{{item.name}}\" value=\"1\" ng-model=\"check_value\" ng-change=\"setCheck(check_value, item.id, item.id_lista_mantenimiento)\"></div><div class=\"centrar centrar-c grid-item\"><input type=\"radio\" name=\"{{item.name}}\" value=\"0\" ng-model=\"check_value\" ng-change=\"setCheck(check_value, item.id, item.id_lista_mantenimiento)\"></div><div class=\"centrar centrar-c grid-item\"><input type=\"radio\" name=\"{{item.name}}\" value=\"2\" ng-model=\"check_value\" ng-change=\"setCheck(check_value, item.id, item.id_lista_mantenimiento)\"></div><div class=\"value-container\"><div class=\"centrar centrar-c grid-item\" ng-if=\"item.valor>0\"><input type=\"text\" name=\"\" value=\"item.valor_\" ng-model=\"value1\" ng-change=\"setValue(value1, item.id, 1, item.id_lista_mantenimiento)\"></div><div class=\"centrar centrar-c grid-item\" ng-if=\"item.valor>1\"><input type=\"text\" name=\"\" value=\"item.valor_\" ng-model=\"value2\" ng-change=\"setValue(value2, item.id, 2, item.id_lista_mantenimiento)\"></div><div class=\"centrar centrar-c grid-item\" ng-if=\"item.valor>2\"><input type=\"text\" name=\"\" value=\"item.valor_\" ng-model=\"value3\" ng-change=\"setValue(value3, item.id, 3, item.id_lista_mantenimiento)\"></div></div></div>");
$templateCache.put("app/cliente/monitoreo/components/advanced-filters/advanced-filters.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top-10\"><div ba-panel=\"\" ba-panel-title=\"Filtros Avanzados\"><div class=\"centrar centrar-columna advanced-filters centrar-align-start form-mantenimiento\"><div class=\"centrar width-100p cont-filters\"><div class=\"width-100p\" style=\"padding: 0 10px;\"><label for=\"\">Estado</label><select ng-model=\"params.estado\" ng-options=\"i.value as i.text for i in statusOptions\" id=\"status\" name=\"status\"></select></div><div class=\"width-100p\" style=\"padding: 0 10px;\"><label for=\"\">Prioridad</label><select ng-model=\"params.prioridad\" ng-options=\"i.value as i.text for i in priority\" id=\"priority\" name=\"priority\"></select></div></div><div class=\"centrar width-100p cont-filters\"><div class=\"width-100p\" style=\"padding: 0 10px;\"><label class=\"centrar centrar-justificar-inicio\" for=\"\">Zona <span class=\"ion-load-c load-rotate padding-0-10\" ng-if=\"loading\"></span></label><select ng-model=\"params.id_zona\" ng-options=\"zona.id as zona.nombre for zona in zonas\" id=\"zonas\" name=\"zonas\"></select></div><div class=\"width-100p\" style=\"padding: 0 10px;\"><label class=\"centrar centrar-justificar-inicio\" for=\"\">Técnico <span class=\"ion-load-c load-rotate padding-0-10\" ng-if=\"loading_t\"></span></label><select ng-model=\"params.id_tecnico\" ng-options=\"tecnico.id as tecnico.email for tecnico in tecnicos\" id=\"zonas\" name=\"zonas\"></select></div></div><div class=\"centrar width-100p cont-filters\"><div class=\"width-100p\" style=\"padding: 0 10px;\"><label for=\"\">Fecha inicial <span style=\"font-weight: 300;\">(fecha de creación)</span></label><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_ini\" is-open=\"popup.opened_1\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_1\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"width-100p\" style=\"padding: 0 10px;\"><label for=\"\">Fecha final <span style=\"font-weight: 300;\">(fecha de creación)</span></label><p class=\"input-group margin-0\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{DateFormat}}\" datepicker-mode=\"options.minMode\" datepicker-options=\"options\" ng-model=\"date.fecha_fin\" is-open=\"popup.opened_2\" close-text=\"cerrar\" current-text=\"Hoy\" clear-text=\"Limpiar\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default button-datepicker\" ng-click=\"open(\'opened_2\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><p class=\"margin-top-10\" style=\"padding: 0 10px;\" ng-if=\"error_fecha_2\">La fecha inicial debe ser menor a la final</p><p class=\"margin-top-10\" style=\"padding: 0 10px;\" ng-if=\"error_fecha_1\">Debes agregar las dos fechas</p><div class=\"centrar centrar-align-start\"><button class=\"btn-cancelar\" style=\"margin: 20px 0 20px 10px;\" ng-click=\"resetFilters()\">Reiniciar</button> <button class=\"btn-add-active\" style=\"margin: 20px 0 20px 10px;\" ng-click=\"setFilters()\">Buscar</button></div></div></div></div>");
$templateCache.put("app/cliente/monitoreo/components/table-tecnicos/table-tecnicos.html","<div class=\"padding-col\"><div style=\"font-weight: bold;\" class=\"width-100p margin-top tabla-tickets tabla-tickets-header\"><p class=\"centrar centrar-c tabla-tickets-header-item\">Nombre</p><p class=\"centrar centrar-c tabla-tickets-header-item\">Correo</p><p class=\"centrar centrar-c tabla-tickets-header-item\">Zonas asignadas</p></div><div class=\"tabla-tickets\" ng-repeat=\"tecnico in tecnicos\"><p data-label=\"Nombre:\"><span></span>{{tecnico.nombre}} {{tecnico.apellido}}</p><p data-label=\"Correo:\"><span></span>{{tecnico.email}}</p><p data-label=\"Zonas:\" class=\"cursor\" ng-click=\"showZonas(tecnico)\"><span></span>ver</p><div class=\"dropdown centrar-align-self-end\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-justificar-final\"></span></div><ul class=\"dropdown-menu\"><li class=\"cursor\" ng-click=\"editarTecnico(tecnico)\">Editar</li><li class=\"cursor\" ng-click=\"borrarTecnico(tecnico)\">Borrar</li></ul></div></div></div>");
$templateCache.put("app/cliente/monitoreo/components/table-tickets/table-tickets.html","<div class=\"padding-col\"><div style=\"font-weight: bold;\" class=\"width-100p margin-top tabla-tickets tabla-tickets-header\"><p class=\"centrar centrar-c tabla-tickets-header-item\">Asunto</p><p class=\"centrar centrar-c tabla-tickets-header-item\">Creado por</p><p class=\"centrar centrar-c tabla-tickets-header-item\">Técnico asignado</p><p class=\"centrar centrar-c tabla-tickets-header-item\">Estado</p></div><div class=\"tabla-tickets\" ng-repeat=\"ticket in tickets\"><div class=\"centrar centrar-columna centrar-align-start cursor\" ng-click=\"gotoTicket(ticket)\"><h4>{{ticket.texto}}</h4><p ng-if=\"ticket.visto === \'0\'\" class=\"mobile-view centrar centrar-c tag\">Novedad</p><p>Número de servicio: {{ticket.id}}</p><p>Zona: {{ticket.zona}}</p><p>Fecha de creación: {{changeToLocal(ticket.fecha_creacion)}}</p><p ng-if=\"ticket.visto === \'0\'\" class=\"desktop-view tag\">Novedad</p></div><p data-label=\"Creado por:\"><span></span>{{ticket.nombre_creador}}</p><p ng-if=\"ticket.id_tecnico === \'0\'\" data-label=\"Técnico:\"><span style=\"margin-left: 7px; font-size: 16px;\" class=\"ion-eye cursor\" ng-click=\"get_tecnicos(ticket.id)\"></span></p><p ng-if=\"ticket.id_tecnico !== \'0\'\" data-label=\"Técnico:\"><span></span>{{ticket.nombre_tecnico}}</p><div class=\"ind-status centrar centrar-columna centrar-align-end centrar-align-self-center\"><div class=\"centrar margin-bottom-10\"><div class=\"ind-prioridad\" ng-class=\"setPriority(ticket.prioridad)\"></div><p style=\"font-weight: 700; color: #666666;\">{{setPriority(ticket.prioridad)}}</p></div><select ng-model=\"ticket.estado\" ng-options=\"i.value as i.text for i in statusOptions\" id=\"status\" name=\"status\" ng-change=\"setStatus(ticket.estado, ticket)\"></select></div></div></div>");
$templateCache.put("app/cliente/monitoreo-plano/components/configuracion-plano/configuracion-plano.html","<div class=\"configuracion-plano\"><div class=\"centrar\"><div class=\"panel width-100p\"><div class=\"centrar step-1\" ng-if=\"step === 1\"><div class=\"centrar centrar-columna centrar-align-start padding\"><h2 class=\"margin-top\">Configuración de Monitoreo en Plano</h2><p class=\"margin-top\">Este módulo te permite ver la zona como un plano esquemático en el cual puedes agregar los sensores y variables que quieres visualizar en tiempo real.</p><div class=\"centrar margin-top\"><button class=\"centrar\" ng-click=\"next(2)\">Comenzar</button></div></div><div class=\"centrar\"><div class=\"cont-img padding\"><img src=\"../../../../../../assets/img/monitoreo_plano.svg\" alt=\"\"></div></div></div><div class=\"step-2 centrar centrar-columna form-mantenimiento padding ticket\" ng-if=\"step === 2\"><div class=\"centrar centrar-columna centrar-align-start centrar-justificar-inicio width-100p\"><h2>Configuracion inicial</h2><h3>Zona: {{zona.nombre}}</h3><label for=\"\">Nombre del plano</label> <input type=\"text\" ng-model=\"plano.nombre\" name=\"\" id=\"\"> <label for=\"\">Imagen del plano</label><div ng-if=\"file\" class=\"centrar cont-file\"><p>{{file.name | limitTo: 25}}{{file.name.length > 25 ? \'...\': \'\'}}</p><span ng-click=\"removeFile()\" class=\"ion-close-round cursor\"></span></div><div class=\"centrar centrar-columna cont-upload\"><label class=\"cursor centrar\" for=\"file\"><span class=\"ion-android-upload\"></span><p>Subir imagen</p></label> <input ng-model=\"file\" type=\"file\" id=\"file\" name=\"file\" ng-change=\"getFile()\" onchange=\"angular.element(this).scope().getFile()\" accept=\".jpg, .jpeg, .png\"></div></div><div class=\"centrar centrar-align-self-end\"><button style=\"margin-right: 10px;\" class=\"centrar centrar-c btn-volver\" title=\"Cancelar\" ng-click=\"next(1)\">Volver</button> <button class=\"centrar\" ng-disabled=\"plano.nombre == \'\' || file == undefined\" ng-click=\"next(3)\">Continuar</button></div></div><div class=\"centrar centrar-columna centrar-align-start step-3 padding\" ng-if=\"step === 3\"><div class=\"centrar centrar-columna\" ng-if=\"!edit_mode\"><h2>Agregar hotspot para {{plano.nombre}}</h2><p>Haz clic en la parte del plano donde quieres agregar un hotspot y luego selecciona las varibles del dispositivo a monitorear</p></div><div class=\"centrar centrar-columna form-mantenimiento centrar-align-start\" ng-if=\"edit_mode\"><label for=\"\">Nombre del plano</label> <input type=\"text\" ng-model=\"plano.nombre\" name=\"\" id=\"\"></div><div style=\"position: relative;\" class=\"cont-img margin-top\"><img class=\"cursor\" ng-click=\"createPin($event)\" ng-src=\"{{plano.url_img}}\" alt=\"\"><div id=\"menu-variables\" style=\"position: absolute; display: none; padding: 20px;\" class=\"panel variables animated zoomIn\"><div class=\"centrar centrar-align-self-end\"><span style=\"font-size: 25px; color:#e85656;\" class=\"ion-close-circled cursor\" ng-click=\"openPin(pin)\"></span></div><label for=\"\">Nombre del pin</label> <input ng-model=\"pin.nombre\" name=\"\" type=\"text\"> <label for=\"\">Agregar variables</label><div class=\"\" style=\"max-height: 300px; overflow: scroll;\"><div ng-if=\"selectedDevices.length === 0\"><p class=\"centrar-texto margin-top\">No tienes dispositivos para agregar</p></div><div ng-repeat=\"device in selectedDevices\"><div class=\"cont-device-variables centrar\" ng-click=\"device.open = !device.open\"><p>{{device.nombre}}</p><span ng-class=\"{\'ion-chevron-up\': device.open, \'ion-chevron-down\': !device.open}\"></span></div><div ng-if=\"device.open\"><div class=\"centrar padding-2\" ng-repeat=\"variable in device.variables\"><p class=\"margin-0\">{{variable.name}}</p><input type=\"checkbox\" name=\"\" ng-model=\"variable.status\" id=\"\" ng-change=\"setVariables(variable.id, variable.status, device)\"></div></div></div></div><div class=\"centrar form-mantenimiento\"><button style=\"margin-left: 0;\" class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar(pin)\">Borrar</button> <button class=\"centrar centrar-c margin-top\" ng-disabled=\"!pinValido || pin.nombre === \'\'\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Agregar\" ng-click=\"addPin(pin)\">{{edit_mode ? \'Editar\' : \'Agregar\'}}</button></div></div><div id=\"{{\'pin-\'+ $index}}\" ng-click=\"openPin(pin)\" class=\"pin animated zoomIn\" ng-repeat=\"pin in pines\"></div></div><div class=\"centrar centrar-justificar-final form-mantenimiento margin-top\"><button style=\"margin-right: 10px;\" class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelarPlano()\">Cancelar</button> <button class=\"centrar centrar-c margin-top\" ng-disabled=\"pines.length === 0\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Agregar\" ng-click=\"addPlane(false)\">Guardar</button></div></div><div class=\"centrar step-1\" ng-if=\"step === 4\"><div class=\"centrar centrar-columna centrar-align-start padding\"><h2 class=\"margin-top\">Módulo de Monitoreo en Plano</h2><p class=\"margin-top\">Parece que no tienes ninguna zona asignada para realizar esta visualización. Comunicate con la Central de Monitoreo Helo para comenzar el proceso.</p></div><div class=\"centrar\"><div class=\"cont-img padding\"><img src=\"../../../../../../assets/img/monitoreo_plano.svg\" alt=\"\"></div></div></div></div></div></div>");
$templateCache.put("app/cliente/monitoreo-plano/components/plano/plano.html","<div class=\"plano configuracion-plano\"><div class=\"centrar\"><div class=\"panel width-100p\"><div class=\"centrar\" style=\"padding: 20px;\"><h2>{{plano.nombre}}</h2><div class=\"centrar\"><div ng-if=\"planos.length > 1\" class=\"centrar centrar-justificar-final form-mantenimiento\"><button style=\"margin-right: 10px;\" class=\"centrar centrar-c\" title=\"Agregar\" ng-click=\"prev()\"><span class=\"ion-chevron-left\"></span></button> <button class=\"centrar centrar-c\" title=\"Agregar\" ng-click=\"next()\"><span class=\"ion-chevron-right\"></span></button></div><div ng-if=\"rol === \'6\' || rol === \'7\' || rol === \'8\'\" class=\"centrar centrar-justificar-final dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-justificar-final\"></span></div><ul class=\"dropdown-menu\"><li class=\"cursor\" ng-click=\"editarPlano(plano)\">Editar plano</li><li class=\"cursor\" ng-click=\"borrarPlano(plano, false)\">Borrar este plano</li><li class=\"cursor\" ng-if=\"planos.length > 1\" ng-click=\"borrarPlano(plano, true)\">Borrar todos los planos</li></ul></div></div></div><div style=\"width: 850px;\" class=\"centrar slider center-block\"><img style=\"width: 100%;\" ng-src=\"{{plano.url}}\"><div ng-repeat=\"pin in pines track by pin.id\"><div class=\"pin animated zoomIn\" ng-style=\"{top: pin.y + \'%\', left: pin.x + \'%\'}\" ng-click=\"openPin(pin)\"></div><div ng-if=\"pin.close\" ng-style=\"{top: pin.y + \'%\', left: pin.x + \'%\'}\" style=\"animation-delay: 100ms;\" class=\"cont-pin centrar centrar-columna panel animated fadeIn\"><h4>{{pin.nombre}}</h4><div class=\"cont-variables\"><div class=\"variable\" ng-repeat=\"variable in pin.variables track by $index\"><h5>{{variable.valor.nombre}} {{variable.unidad}}</h5><p>{{variable.nombre}}</p></div></div><loading-content loading=\"loading\"></loading-content></div></div></div><h4 ng-if=\"rol === \'11\' || rol === \'6\' || rol === \'7\' || rol === \'8\'\" style=\"margin: 10px 20px 10px; font-weight: 300;\">Filtrar dispositivos:</h4><div ng-if=\"rol === \'11\' || rol === \'6\' || rol === \'7\' || rol === \'8\'\" class=\"centrar cont-filtros margin-top centrar-justificar-inicio\" style=\"margin: 10px 20px 20px;\"><div ng-click=\"changeFilter(filter.id)\" class=\"filtro cursor\" ng-repeat=\"filter in deviceFilter\" ng-class=\"{\'filtro-activo\':filter.status == true}\"><p>{{filter.name}}</p></div></div></div></div></div>");
$templateCache.put("app/cliente/smartbar/directives/consumption/consumption.html","<div id=\"\" class=\"panel panel-primary bootstrap-panel animated zoomIn panel-smart-bar\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Consumo</p></div><div><select ng-model=\"selectedIntervalConsump\" ng-options=\"i for i in intervalsConsump\" ng-init=\"selectedIntervalConsump = intervalsConsump[0]\"></select></div></div><div class=\"panel-body\"><div class=\"centrar cont-sm-card\"><div class=\"sm-card-ind\"><p>{{consumption.value}}<span>kwh</span></p></div><div class=\"centrar sm-card-comp\" ng-class=\"{\'ind-comp-up\': consumption.comparative.state === \'up\', \'ind-comp-down\': consumption.comparative.state === \'down\', \'ind-comp-stable\': consumption.comparative.state === \'stable\'}\"><span ng-class=\"{\'ion-arrow-up-b\': consumption.comparative.state === \'up\', \'ion-arrow-down-b\': consumption.comparative.state === \'down\', \'ion-minus-round\': consumption.comparative.state === \'stable\' }\"></span><p>{{consumption.comparative.state === \'stable\' ? \'\' : consumption.comparative.value}}</p></div></div></div></div>");
$templateCache.put("app/cliente/smartbar/directives/graficTempVsDist/graficTempVsDist.html","<div id=\"\" class=\"panel panel-primary bootstrap-panel animated zoomIn panel-smart-bar\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Relación Temp Vs Dist</p></div><div><select ng-model=\"selectedIntervalGrafTemDis\" ng-options=\"i for i in intervalsGrafTemDis\" ng-init=\"selectedIntervalGrafTemDis = intervalsGrafTemDis[0]\"></select></div></div><div class=\"panel-body\"><div><div class=\"centrar width-100p\"><p class=\"margin-0\">Temp C</p></div><div id=\"grafica_tempVsDist\" style=\"width:100%; height:318px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Distancia - M</p></div></div></div></div>");
$templateCache.put("app/cliente/smartbar/directives/losses/losses.html","<div id=\"\" class=\"panel panel-primary bootstrap-panel animated zoomIn panel-smart-bar\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Pérdidas</p></div><div><select ng-model=\"selectedIntervalLosses\" ng-options=\"i for i in intervalsLosses\" ng-init=\"selectedIntervalLosses = intervalsLosses[0]\"></select></div></div><div class=\"panel-body\"><div class=\"centrar cont-sm-card\"><div class=\"sm-card-ind\"><p>{{loss.value}}<span>%</span></p></div><div class=\"centrar sm-card-comp\" ng-class=\"{\'ind-comp-up\': loss.comparative.state === \'up\', \'ind-comp-down\': loss.comparative.state === \'down\', \'ind-comp-stable\': loss.comparative.state === \'stable\'}\"><span ng-class=\"{\'ion-arrow-up-b\': loss.comparative.state === \'up\', \'ion-arrow-down-b\': loss.comparative.state === \'down\', \'ion-minus-round\': loss.comparative.state === \'stable\' }\"></span><p>{{loss.comparative.state === \'stable\' ? \'\' : loss.comparative.value}}</p></div></div></div></div>");
$templateCache.put("app/cliente/smartbar/directives/meters/meters.html","<div id=\"\" class=\"panel panel-primary bootstrap-panel animated zoomIn panel-smart-bar\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Medidores</p></div><div><select ng-model=\"selectedIntervalMeters\" ng-options=\"i for i in intervalsMeters\" ng-init=\"selectedIntervalMeters = intervalsMeters[0]\"></select></div></div><div class=\"panel-body cont-sm-card-with-scroll\"><div class=\"cont-sm-card-list\"><div class=\"centrar sm-card-list-item\" ng-repeat=\"meter in meters\"><div class=\"centrar sm-card-list-item-ind\"><p>{{meter.name}}</p><div class=\"centrar sm-card-comp\" ng-class=\"{\'ind-comp-up\': meter.comparative.state === \'up\', \'ind-comp-down\': meter.comparative.state === \'down\', \'ind-comp-stable\': meter.comparative.state === \'stable\'}\"><span ng-class=\"{\'ion-arrow-up-b\': meter.comparative.state === \'up\', \'ion-arrow-down-b\': meter.comparative.state === \'down\', \'ion-minus-round\': meter.comparative.state === \'stable\' }\"></span><p>{{meter.comparative.state === \'stable\' ? \'\' : meter.comparative.value}}</p></div></div><div class=\"sm-card-list-item-comp\"><p>{{meter.consumption}}<span>KWH</span></p></div></div></div></div></div>");
$templateCache.put("app/cliente/smartbar/directives/rateLosses/rateLosses.html","<div id=\"\" class=\"panel panel-primary bootstrap-panel animated zoomIn panel-smart-bar\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Relación Pérdidas</p></div><div><select ng-model=\"selectedIntervalRateLosses\" ng-options=\"i for i in intervalsRateLosses\" ng-init=\"selectedIntervalRateLosses = intervalsRateLosses[0]\"></select></div></div><div class=\"panel-body\"><div><div class=\"centrar width-100p\"><p class=\"margin-0\">KWH</p></div><div id=\"grafica_rateLosses\" style=\"width:100%; height:400px;\"></div><div class=\"centrar centrar-c cont-load-rotate\" ng-if=\"loading\" style=\"position:absolute; top:200px;\"><span class=\"ion-load-c load-rotate padding-0-10\"></span><p class=\"margin-0\">Cargando</p></div><div class=\"centrar centrar-c cont-noInfo\" ng-if=\"noInfo\" style=\"position:absolute; top:200px;\"><h2 class=\"centrar-texto\">No hay información para mostrar</h2></div><div class=\"centrar centrar-c\"><p class=\"margin-0\">Tiempo</p></div></div></div></div>");
$templateCache.put("app/cliente/smartbar/directives/tempPoints/tempPoints.html","<div id=\"\" class=\"panel panel-primary bootstrap-panel animated zoomIn panel-smart-bar\" zoom-in=\"\"><div class=\"panel-heading holder_header\"><div class=\"h_titulo\"><p>Puntos Smart Bar</p></div><div></div></div><div class=\"panel-body cont-sm-card-with-scroll\"><div class=\"cont-sm-card-list\"><div class=\"centrar sm-card-list-item\" ng-repeat=\"point in points\"><div class=\"centrar sm-card-list-item-ind\"><p>{{point.name}}</p><div class=\"centrar sm-card-comp\" ng-class=\"{\'ind-comp-up\': point.comparative.state === \'up\', \'ind-comp-down\': point.comparative.state === \'down\', \'ind-comp-stable\': point.comparative.state === \'stable\'}\"><span ng-class=\"{\'ion-arrow-up-b\': point.comparative.state === \'up\', \'ion-arrow-down-b\': point.comparative.state === \'down\', \'ion-minus-round\': point.comparative.state === \'stable\' }\"></span><p>{{point.comparative.state === \'stable\' ? \'\' : point.comparative.value}}</p></div></div><div class=\"sm-card-list-item-comp\"><p>{{point.temperature}}<span>C</span></p></div></div></div></div></div>");
$templateCache.put("app/consumo/dashboard-consumo/estadisticas_zona/grafica_consumo/grafica_consumo_c.html","<div ng-controller=\"grafica_consumo_cCtrl\" class=\"centrar centrar-columna\"><div id=\"grafica_consumo_c\" style=\"width: 100%; height: 500px;\"></div><div class=\"centrar cont-filtros margin-top\"><div ng-click=\"filtrar(\'m\')\" class=\"filtro cursor\" ng-class=\"{\'filtro-activo\':filtro_mes == true}\"><p>Mes</p></div><div ng-click=\"filtrar(\'a\')\" class=\"filtro cursor\" ng-class=\"{\'filtro-activo\':filtro_year == true}\"><p>Año</p></div></div></div>");
$templateCache.put("app/instalador/projects/directives/project/project.html","<div class=\"cont-project-card animated zoomIn centrar centrar-columna panel centrar-align-start padding\"><div class=\"centrar width-100p margin-bottom\"><div class=\"title\" ng-hide=\"edit\">{{project.name}}</div><input type=\"text\" ng-model=\"newName\" value=\"\" ng-show=\"edit\" class=\"\" autofocus=\"\"><div uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><i class=\"ion-more\"></i></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><i class=\"dropdown-arr\"></i></li><li class=\"cursor\"><a ng-click=\"edit = !edit; newName = project.name\">Editar nombre</a></li><li class=\"cursor\"><a ng-click=\"\">Borrar</a></li></ul></div></div><div class=\"centrar margin-bottom\"><i class=\"ion-location\"></i><p>{{project.zones.length != 0 ? project.zones.length + \' zonas\' : \'No hay zonas disponibles\'}}</p></div><div class=\"centrar centrar-columna\"><h3>Helos</h3><div class=\"centrar\"><div ng-repeat=\"device in devices track by $index\"><span class=\"{{device.class}}\"></span></div></div></div></div>");
$templateCache.put("app/cliente/alerts/components/alert-card/alert-card.html","<div class=\"alert-card centrar centrar-columna animated zoomIn\"><div class=\"centrar centrar-espaciado-entre width-100p alert-card-header\"><div class=\"centrar\"><h3>{{alert.name | limitTo: 35}}{{alert.name.length > 35 ? \'...\' : \'\'}}</h3></div><div class=\"centrar\"><div class=\"centrar centrar-c toogle-alert cursor\" ng-class=\"{\'alert-card-status-on\': alert.status, \'alert-card-status-off\': !alert.status }\" ng-click=\"activeAlert(alert)\"><p>{{alert.status ? \'ON\' : \'OFF\'}}</p></div><div ng-click=\"showNotifications(alert)\" class=\"ind-alerts cursor\"><i class=\"fa icon-bell\" ng-class=\"{\'ion-android-notifications\': alert.notification, \'ion-android-notifications-none\': !alert.notification}\"></i><p ng-if=\"alert.notification\" class=\"centrar centrar-c animated tada\"></p></div><div><div class=\"dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-justificar-final\"></span></div><ul class=\"dropdown-menu\"><li class=\"cursor\" ng-click=\"editAlert(alert)\">Editar</li><li class=\"cursor\" ng-click=\"deleteAlert(alert)\">Borrar</li></ul></div></div></div></div><div class=\"alert-card-body centrar centrar-justificar-inicio width-100p\"><div class=\"icon-type centrar centrar-c\"><img ng-style=\"{\'width\': alert.type.type == \'10\' ? \'70%\' : \'100%\'}\" ng-src=\"{{alert.type.icon}}\" alt=\"\"></div><div class=\"centrar centrar-columna centrar-align-start\"><p>Tipo: {{alert.type.name}}</p><p>Dispositivo asociado:</p><div class=\"centrar centrar-align-self-start\"><p class=\"ind-filter\">{{alert.selectedDevices.nombre | limitTo: 30}}{{alert.selectedDevices.nombre.length > 30 ? \'...\': \' \'}}</p></div></div></div><div class=\"alert-card-footer centrar centrar-espaciado-entre width-100p\"><h5 ng-click=\"showNotifications(alert)\" class=\"cursor\">Alertas generadas</h5><p ng-click=\"showNotifications(alert)\" class=\"cursor\"><span ng-class=\"{\'ion-chevron-up\': status.open, \'ion-chevron-down\': !status.open}\"></span></p></div><div class=\"alert-card-notifications width-100p\" ng-if=\"status.open\"><div class=\"cont-notificacion cursor\" ng-repeat=\"notification in alert.notifications.slice(((currentPage-1)*itemsPerPage), ((currentPage)*itemsPerPage))\" ui-sref=\"estadisticas_zona({nombre: notification.device.nombre_zona, id_zona:notification.device.id_zona, id_device:notification.device.id, date: notification.date, time: notification.time})\"><div data-label=\"Dispositivo\">{{notification.device.nombre}} fuera de rango</div><div data-label=\"Fecha\" class=\"centrar\">{{notification.date | date : format : timezone}}</div><div data-label=\"Hora\" class=\"centrar centrar-justificar-final\">{{notification.time}}</div></div><div class=\"centrar centrar-c\" ng-show=\"alert.notifications.length > 0\"><ul uib-pagination=\"\" total-items=\"alert.notifications.length\" ng-model=\"currentPage\" max-size=\"5\" class=\"pagination-sm\" boundary-link-numbers=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" items-per-page=\"itemsPerPage\"></ul></div><div class=\"centrar\" ng-if=\"alert.notifications.length == 0\"><p class=\"\">No hay notificaciones para mostrar</p></div></div></div>");
$templateCache.put("app/cliente/alerts/components/offline-devices/offline-devices.html","<div class=\"offline-devices margin-top margin-bottom-10\"><div class=\"title centrar centrar-justificar-inicio\"><div class=\"cont-logo\"><img src=\"../../../../../assets/icons/icon_cloud_slash.svg\" alt=\"\"></div><h3>Dispositivos Offline</h3></div><div class=\"grid-offline-devices grid-offline-devices-header\"><p>Dispositivo</p><p class=\"aling-end\">Última conexión</p></div><div class=\"grid-offline-devices-body\"><div class=\"cont-offline-device grid-offline-devices\" ng-repeat=\"device in offlineDevices\"><p>{{device.nombre}}</p><p class=\"aling-end\" tooltip-placement=\"top\" uib-tooltip=\"{{device.date}}\">{{device.ultima_conexion | number: 1}} {{device.ind}}</p></div></div><loading-content loading=\"loading\"></loading-content><div ng-if=\"offlineDevices.length === 0 && loading === false\"><p style=\"padding: 10px; text-align: center;\">No hay dispositivos fuera de línea</p></div></div>");
$templateCache.put("app/cliente/alerts/components/table-alerts/table-alerts.html","<div><div style=\"font-weight: bold;\" class=\"width-100p cont-table-alert margin-top table-alerts table-alerts-header\"><div></div><div></div><p class=\"centrar centrar-c table-alerts-header-item\">Nombre</p><p class=\"centrar centrar-c table-alerts-header-item\">Tipo</p><p class=\"centrar centrar-c table-alerts-header-item\">Dispositivo</p><p class=\"centrar centrar-c table-alerts-header-item\">Observación</p><p class=\"centrar centrar-c table-alerts-header-item\">Tiempo</p><div></div></div><div class=\"centrar centrar-columna\" ng-repeat=\"alert in alerts\"><div class=\"centrar cont-table-alert centrar-columna width-100p\"><div class=\"centrar width-100p cont-alert\"><div class=\"ind-control\" ng-class=\"{\'has_control\': alert.control, \'has_offline\': alert.type.type == \'15\'}\"></div><div class=\"width-100p table-alerts\"><div class=\"only-responsive centrar\"><div class=\"centrar\"><p class=\"centrar cursor\" ng-click=\"activeAlert(alert, $index)\"><i class=\"ind-status\" ng-class=\"alert.status ? \'ion-toggle-filled ind-status-on\': \'ion-toggle\'\"></i></p><div class=\"centrar ind-alerts\"><i class=\"fa icon-bell ind-bell\" ng-class=\"{\'ion-android-notifications ind-notification\': alert.notification, \'ion-android-notifications-none\': !alert.notification}\"></i><p ng-if=\"alert.active\" class=\"animated tada\"></p></div></div><div class=\"centrar centrar-justificar-final dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-justificar-final\"></span></div><ul class=\"dropdown-menu\"><li class=\"cursor\" ng-click=\"editAlert(alert)\">Editar</li><li class=\"cursor\" ng-click=\"deleteAlert(alert)\">Borrar</li></ul></div></div><p class=\"only-desktop centrar cursor\" ng-click=\"activeAlert(alert, $index)\"><i class=\"ind-status\" ng-class=\"alert.status ? \'ion-toggle-filled ind-status-on\': \'ion-toggle\'\"></i></p><div class=\"only-desktop centrar ind-alerts\"><i class=\"fa icon-bell ind-bell\" ng-class=\"{\'ion-android-notifications ind-notification\': alert.notification, \'ion-android-notifications-none\': !alert.notification}\"></i><p ng-if=\"alert.active\" class=\"ind-alert-active animated tada\"></p></div><div class=\"centrar centrar-justificar-inicio cursor alert-name\" ng-click=\"open(alert, $index)\"><p><i class=\"ind-arrow\" ng-class=\"{\'ion-arrow-up-b\': alert.info, \'ion-arrow-down-b\': !alert.info}\"></i></p><div class=\"centrar centrar-align-start centrar-columna\"><p class=\"table-alerts-item\">{{alert.name}}</p><p ng-if=\"alert.type.type !== \'15\'\" class=\"only-desktop zone-name\">Zona: {{alert.selectedDevices.nombre_zona | limitTo: 20}}{{alert.selectedDevices.nombre_zona > 20 ? \'...\' : \'\'}}</p><p ng-if=\"alert.type.type == \'15\'\" class=\"only-desktop zone-name\">Zona: {{alert.selectedDevices[0].nombre_zona | limitTo: 20}}{{alert.selectedDevices[0].nombre_zona > 20 ? \'...\' : \'\'}}</p></div></div><p data-label=\"Zona\" ng-if=\"alert.type.type !== \'3\' && alert.type.type !== \'15\' && alert.type.type !== \'7\'\" class=\"only-responsive table-alerts-item\">{{alert.selectedDevices.nombre_zona | limitTo: 20}}{{alert.selectedDevices.nombre_zona > 20 ? \'...\' : \'\'}}</p><p data-label=\"Zona\" ng-if=\"alert.type.type == \'15\'\" class=\"only-responsive table-alerts-item\">{{alert.selectedDevices[0].nombre_zona | limitTo: 20}}{{alert.selectedDevices[0].nombre_zona > 20 ? \'...\' : \'\'}}</p><p data-label=\"Tipo\" class=\"table-alerts-item\">{{alert.type.min_name}}</p><p style=\"text-align: center;\" ng-if=\"alert.type.type !== \'15\'\" data-label=\"Dispositivo\" class=\"table-alerts-item\">{{alert.selectedDevices.nombre | limitTo: 50}}{{alert.selectedDevices.nombre.length > 50 ? \'...\': \' \'}}</p><p style=\"text-align: center;\" ng-if=\"alert.type.type == \'15\'\" data-label=\"Dispositivo\" class=\"table-alerts-item\">Dispositivos agrupados</p><p data-label=\"Observación\" ng-if=\"alert.type.type !== \'3\' && alert.type.type !== \'15\' && alert.type.type !== \'7\' && alert.type.type !== \'58\' && alert.type.type !== \'59\'\" class=\"table-alerts-item\"><span class=\"ind-obs\"><i ng-class=\"alert.interval.type === 0 ? \'\' : alert.interval.type === 1 ? \'ion-arrow-up-c ind-up\': \'ion-arrow-down-c ind-down\'\"></i> {{alert.interval.min_with_offset}}{{alert.interval.min_with_offset !== null ? alert.type.unit : \'\'}} {{alert.interval.type === 0 ? \'-\':\'\'}} {{alert.interval.max_with_offset}}{{alert.interval.max_with_offset !== null ? alert.type.unit : \'\'}}</span></p><p data-label=\"Observación\" ng-if=\"alert.type.type == \'3\'\" class=\"table-alerts-item\"><span class=\"ind-obs\">{{alert.interval.min == \'1\' && alert.interval.max == null ? \'Abierto\' : (alert.interval.max == \'0\' && alert.interval.min == null) ? \'Cerrado\' : \'\'}}</span></p><p data-label=\"Observación\" ng-if=\"alert.type.type == \'7\'\" class=\"table-alerts-item\"><span class=\"ind-obs\">{{alert.interval.min == \'1\' && alert.interval.max == null ? \'No Presencia\' : (alert.interval.max == \'0\' && alert.interval.min == null) ? \'Presencia\' : \'\'}}</span></p><p data-label=\"Observación\" ng-if=\"alert.type.type == \'15\'\" class=\"table-alerts-item\"><span class=\"ind-obs\">Desconexión</span></p><p data-label=\"Observación\" ng-if=\"alert.type.type == \'58\'\" class=\"table-alerts-item\"><span class=\"ind-obs\">{{alert.interval.min == \'1\' ? \'Sin comunicación\' : alert.interval.min == \'2\' ? \'Error\' : alert.interval.min == \'3\' ? \'Con comunicación\' : \'\'}}</span></p><p data-label=\"Observación\" ng-if=\"alert.type.type == \'59\'\" class=\"table-alerts-item\"><span class=\"ind-obs\">Error</span></p><p data-label=\"Tiempo\" class=\"table-alerts-item\">{{alert.standBy}} min</p><div class=\"centrar only-desktop centrar-justificar-final dropdown\"><div class=\"dropdown-toggle cursor\" data-toggle=\"dropdown\"><span class=\"ion-android-more-vertical centrar centrar-justificar-final\"></span></div><ul class=\"dropdown-menu\"><li class=\"cursor\" ng-click=\"editAlert(alert)\">Editar</li><li class=\"cursor\" ng-click=\"deleteAlert(alert)\">Borrar</li></ul></div></div></div><div class=\"centrar cont-info-alert width-100p\" ng-if=\"alert.info\"><uib-tabset class=\"width-100p\"><uib-tab index=\"2\" heading=\"Control\"><div class=\"info-alert\" ng-if=\"alert.control\"><p><b>{{alert.control.device_name}}</b></p><small>Dispositivo</small></div><div class=\"info-alert\" ng-if=\"alert.control\"><p><b>{{alert.control.set_point_name}}</b></p><small>Control</small></div><div class=\"info-alert\" ng-if=\"alert.control\"><p><b>{{alert.control_en_off === \"1\" ? \'Activado\' : \'Desactivado\'}}</b></p><small>Control cuando el equipo está apagado</small></div><div class=\"info-alert\" ng-if=\"alert.control === null\"><p>No hay dispositivos de control</p></div></uib-tab><uib-tab index=\"1\" heading=\"Dispositivos agrupados\" ng-if=\"alert.nestedAlerts\"><div ng-repeat=\"device in alert.selectedDevices\" class=\"info-alert\"><p>{{device.nombre}}</p></div></uib-tab><uib-tab ng-click=\"showNotifications(alert, $index)\" index=\"3\" heading=\"Notificaciones\"><div class=\"padding-2 centrar cursor\" ng-repeat=\"notification in alert.notifications.slice(((currentPage-1)*itemsPerPage), ((currentPage)*itemsPerPage))\" ui-sref=\"estadisticas_zona({nombre: notification.device.nombre_zona, id_zona:notification.device.id_zona, id_device:notification.device.id, date: notification.date, time: notification.time})\"><div data-label=\"Dispositivo\">{{notification.device.nombre}} fuera de rango</div><div data-label=\"Fecha\" class=\"centrar\">{{notification.date | date : format : timezone}}</div><div data-label=\"Hora\" class=\"centrar centrar-justificar-final\">{{notification.time}}</div></div><div class=\"padding-2 centrar centrar-c\" ng-show=\"alert.notifications.length > 0\"><ul uib-pagination=\"\" total-items=\"alert.notifications.length\" ng-model=\"currentPage\" max-size=\"5\" class=\"pagination-sm\" boundary-link-numbers=\"true\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" items-per-page=\"itemsPerPage\"></ul></div><div class=\"info-alert centrar\" ng-if=\"alert.notifications.length == 0\"><p class=\"\">No hay notificaciones para mostrar</p></div></uib-tab><uib-tab index=\"4\" heading=\"Observación\"><div class=\"info-alert\" ng-if=\"alert.comparador\"><p><b>{{alert.comparador.device_name}}</b></p><small>Comparador</small></div><div class=\"info-alert\"><div class=\"\"><p ng-repeat=\"user in alert.interestedUsers track by $index\" class=\"ind-highlight\">{{user}}</p></div><small>Correos a notificar</small></div><div class=\"info-alert\"><p><b>{{alert.email === \"1\" ? \'Activado\' : \'Desactivado\'}}</b></p><small>Envio de correos</small></div><div class=\"info-alert\"><p><b>{{setRepeat(alert.repeatAlert)}}</b></p><small>Repetición de notificación</small></div></uib-tab><uib-tab index=\"5\" heading=\"Intermitencia\"><div class=\"info-alert\"><div class=\"centrar centrar-flex-flow centrar-justificar-inicio\" ng-if=\"alert.feriado === \'1\'\"><p style=\"margin-right: 10px;\" ng-repeat=\"holiday in alert.holidays\"><b>{{holiday.day | date : \'dd/MM/yyyy\'}}</b></p></div><div ng-if=\"alert.feriado !== \'1\'\" style=\"display: flex;\"><p ng-repeat=\"day in alert.observation.days\"><b>{{setDay(day)}}</b></p></div><small>{{alert.control ? \'Días de ejecución\' : \'Días de observación\'}}</small></div><div class=\"info-alert\"><p><b>{{alert.observation.h_ini}} - {{alert.observation.h_fin}}</b></p><small>Intervalo de tiempo</small></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/components/content-graph/content-graph.html","<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"graph\"><div class=\"panel\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">{{graph.title}}</h3></div><div class=\"panel-body\"><div ng-include=\"graph.url\"></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/components/device-info/device-info.html","<div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Informacion de {{device.nombre}}\" ba-panel-class=\"with-scroll\" ng-if=\"info\"><div class=\"centrar dispositivo-consolidado\"><div class=\"cont-icon-dispositivo-consolidado\"><img ng-src=\"{{device.image}}\" alt=\"\"></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/components/ind-variable/ind-variable.html","<div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-12\" ng-if=\"flow\"><div class=\"panel animated zoomIn flujo-totalizador\"><div class=\"panel-heading clearfix centrar\"><h3 class=\"panel-title\">{{indTitle}}</h3></div><div class=\"panel-body\"><div class=\"centrar centrar-align-start centrar-columna\"><div class=\"centrar centrar-align-self-center\"><h2>{{variable.estado}} <sup>{{unit}}</sup></h2></div><div class=\"centrar width-100p\"><div><p class=\"margin-0\"><strong>Fecha:</strong></p><p class=\"margin-0\">{{variable.fecha | date : \'mediumDate\'}}</p></div><div><p class=\"margin-0\"><strong>Hora:</strong></p><p class=\"margin-0\">{{variable.fecha | date : \'mediumTime\'}}</p></div></div></div></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/components/tabs/tabs.html","<div class=\"centrar panel cont-tab-graficas animated zoomIn\" ng-if=\"tabs\"><div class=\"centrar centrar-c tab-grafica cursor\" ng-repeat=\"tab in tabs\" ng-class=\"{\'tab-grafica-activo\':tab.status == true}\" ng-click=\"tabGrafica(tab.type)\"><p>{{tab.name}}</p></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/components/tabs-energy/tabs-energy.html","<div ng-if=\"energy\"><div style=\"justify-content: space-between !important;\" class=\"centrar panel cont-tab-graficas animated zoomIn padding-2\"><div class=\"centrar\"><p>Selecciona un variable eléctrica</p><select ng-options=\"itm as itm.name for itm in optionEnergy\" ng-model=\"optionTab.value\" ng-change=\"tabEnergy_(optionTab.value)\" ng-init=\"optionTab.value = optionEnergy[0]\"></select></div><div class=\"centrar\" ng-if=\"energyType === \'power\' || energyType === \'current\'\"><p>Relación CT\'s</p><select ng-options=\"itm.factor as itm.name for itm in factors\" ng-model=\"factor.ind\" ng-change=\"setFactor(factor.ind)\"></select></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/components/tabs-helo-s-plus/tabs-helo-s-plus.html","<div ng-if=\"helo_s_plus\"><div style=\"justify-content: space-between !important;\" class=\"centrar panel cont-tab-graficas animated zoomIn padding-2\"><div class=\"centrar\"><p>Selecciona un variable eléctrica</p><select ng-options=\"itm as itm.name for itm in optionEnergy\" ng-model=\"optionTab.value\" ng-change=\"tabEnergy(optionTab.value)\" ng-init=\"optionTab.value = optionEnergy[0]\"></select></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/components/tabs-saeg/tabs-saeg.html","<div ng-if=\"saeg\"><div style=\"justify-content: space-between !important;\" class=\"centrar panel cont-tab-graficas animated zoomIn padding-2\"><div class=\"centrar\"><p>{{optionSaeg.length > 0 ? \'Selecciona una variable\' : \'No hay variables disponibles\'}}</p><select ng-if=\"optionSaeg.length > 0\" ng-options=\"itm as itm.navName for itm in optionSaeg\" ng-model=\"optionTab.value\" ng-change=\"tabSaeg(optionTab.value)\" ng-init=\"optionTab.value = optionSaeg[0]\"></select></div></div></div>");
$templateCache.put("app/cliente/dashboard-cliente/directives/zoneTable/deviceControl/deviceControl.html","<div class=\"grid-container\" ng-if=\"device.tipo !== \'23\' && device.tipo !== \'26\'\"><div class=\"grid-item cursor\" ng-click=\"goApparatusProfile(device, control)\"><p style=\"text-align: start;\" class=\"name\">{{device.nombre}}</p></div><div class=\"grid-item\"><p class=\"ind\">Conexión Plataforma</p><p ng-if=\"device.tipo != \'11\'\"><span class=\"ion-ios-circle-filled\" ng-class=\"{\'dis_on\': device.online == 1, \'dis_off\': device.online == 0}\"></span></p><p ng-if=\"device.tipo == \'11\'\">--</p></div><div ng-if=\"integracion === \'0\'\" class=\"grid-item\"><p class=\"ind\">Última conexión</p><p tooltip-placement=\"top\" uib-tooltip=\"{{fecha_conexion}}\">{{last_conexion | number: 1}} {{ind}}</p></div><div ng-if=\"integracion === \'1\'\" class=\"grid-item\"><p class=\"ind\">Variables</p><select ng-if=\"device.variables.length > 0\" ng-model=\"variable_name.name\" name=\"\" id=\"\" ng-change=\"showStatus(variable_name.name)\"><option ng-repeat=\"variable in device.variables\" value=\"{{variable.navName}}\">{{variable.navName}}</option></select></div><div class=\"grid-item\" ng-if=\"device.online == \'1\'\"><p class=\"ind\">Estado</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'0\' || device.tipo == \'1\')\">{{device.estado == \'0\' ? \'Apagado\' : \'Encendido\'}}</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'5\' || device.tipo == \'7\' || device.tipo == \'9\')\">{{device.estado | number : 2 }} {{device.tipo == \'5\' ? \'W\': \'\'}}</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'2\' || device.tipo == \'3\' || device.tipo == \'8\')\">{{device.estado.nombre ?(device.estado.nombre != \'Apagar\' ? device.estado.nombre : \'Apagado\') : \'--\'}} {{device.tipo == \'2\' || device.tipo == \'3\' ? (device.estado.nombre != \'Apagar\' ? \'&#8451\' : \'\'): \'\'}}</p><p data-label=\"Estado\" ng-if=\"device.tipo == \'6\' || device.tipo == \'13\' || device.tipo == \'15\' || device.tipo == \'4\' || device.tipo == \'33\'\">{{device.estado ? (device.tipo == \'14\' || device.tipo == \'15\' ? device.estado/10 : device.estado): \'--\'}} &#8451</p><p data-label=\"Estado\" ng-if=\"device.tipo == \'14\'\">{{device.estado ? device.estado/10 : \'--\'}} Bar</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'10\' || device.tipo == \'11\')\">--</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'12\')\">{{device.estado ? (device.estado / 100) : \'--\'}} m3n</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'16\')\">{{device.estado ? device.estado : \'--\'}} Wh</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'18\')\">{{device.estado ? device.estado : \'--\'}} PSI</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'19\')\">{{device.estado ? device.estado : \'--\'}} Gpm</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'21\')\">{{device.estado == \'0\' ? \'No Presen\' : \'Presencia\'}}</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'22\')\">--</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'27\')\">{{device.estado ? device.estado : \'--\'}} Hz</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'28\' || device.tipo == \'30\' || device.tipo == \'32\')\">{{device.estado ? device.estado / 100 : \'--\'}} C°</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'29\')\">{{device.estado ? (device.estado === \'0\' ? \'Apagado\' : \'Encendido\') : \'--\'}}</p></div><div class=\"grid-item\" ng-if=\"device.online == \'0\'\"><p class=\"ind\">Estado</p><p data-label=\"Estado\">--</p></div><div class=\"grid-item\" ng-if=\"device.tag\"><p class=\"ind\">Estado</p><p data-label=\"Estado\">{{device.estado}}</p></div><div class=\"grid-item\" ng-if=\"control\"><p class=\"ind\">Control</p><select ng-if=\"setpoints && device.online == \'1\'\" ng-change=\"setAir(temp, device)\" ng-model=\"temp\"><option ng-if=\"setpoint.status\" ng-repeat=\"setpoint in setpoints\" value=\"{{setpoint}}\">{{setpoint.nombre}}</option></select><div ng-if=\"(device.tipo == \'14\') && device.online == \'1\'\"><input type=\"number\" min=\"0\" ng-model=\"comandoRack\" max=\"10\" step=\"0.1\" ng-value=\"{{parseInt(device.estado)/10}}\" ng-change=\"setAir(comandoRack, device)\"></div><div ng-if=\"(device.tipo == \'0\' || device.tipo == \'1\') && device.online == \'1\'\"><span ng-class=\"{\'ion-toggle-filled btn_on\': (device.relay? device.relay : device.estado) ==\'1\', \'ion-toggle btn_off\': (device.relay? device.relay : device.estado) ==\'0\'}\" ng-click=\"turnDevice(device)\"></span></div><div ng-if=\"device.tag && control_saeg\"><input type=\"number\" min=\"0\" ng-model=\"comand_saeg\" ng-model-options=\"{ debounce: 800 }\" max=\"100\" step=\"1\" ng-change=\"controlSaeg(comand_saeg)\"></div><div ng-if=\"device.tipo == \'17\' && device.online == \'1\'\"><select ng-model=\"comandoDimmer\" ng-options=\"i.id as i.nombre for i in intervalDimmer\" id=\"intervalDimmer\" name=\"intervalDimmer\" ng-change=\"setControlByPercent(comandoDimmer, device)\"></select></div><div ng-if=\"device.tipo == \'27\' && device.online == \'1\'\"><select ng-model=\"comandoVariador\" ng-options=\"i.id as i.nombre for i in intervalEngine\" id=\"intervalEngine\" name=\"intervalEngine\" ng-change=\"setControlByPercent(comandoVariador, device)\"></select></div><div ng-if=\"device.online == \'0\'\"><p>--</p></div></div><div class=\"grid-item\" ng-if=\"!control\"><p class=\"ind\">Control</p><p>--</p></div></div><div class=\"width-100p\" ng-if=\"device.tipo == \'23\' || device.tipo == \'26\'\"><div class=\"centrar width-100p\"><p style=\"text-align: start;\" ng-click=\"goApparatusProfile(device, control)\" class=\"name cursor\">{{device.nombre}}</p><span class=\"cursor\" ng-click=\"device.open = !device.open\" ng-class=\"{\'ion-chevron-up\': device.open, \'ion-chevron-down\': !device.open}\"></span></div><div class=\"cont-channels\" ng-show=\"device.open\"><div class=\"grid-container\" ng-repeat=\"canal in device.canales\"><div class=\"grid-item cursor\" ng-click=\"goApparatusProfile(canal, control)\"><p style=\"text-align: start;\" class=\"name\">{{canal.nombre}}</p></div><div class=\"grid-item\"><p class=\"ind\">Conexión Plataforma</p><p ng-if=\"canal.tipo != \'11\'\"><span class=\"ion-ios-circle-filled\" ng-class=\"{\'dis_on\': device.online == 1, \'dis_off\': device.online == 0}\"></span></p><p ng-if=\"canal.tipo == \'11\'\">--</p></div><div class=\"grid-item\"><p class=\"ind\">Última conexión</p><p tooltip-placement=\"top\" uib-tooltip=\"{{fecha_conexion}}\">{{last_conexion | number: 1}} {{ind}}</p></div><div class=\"grid-item\" ng-if=\"canal.online == \'1\'\"><p class=\"ind\">Estado</p><p data-label=\"Estado\" ng-if=\"(device.tipo == \'24\')\">{{canal.estado}}</p></div><div class=\"grid-item\" ng-if=\"canal.online == \'0\'\"><p class=\"ind\">Estado</p><p data-label=\"Estado\">--</p></div><div class=\"grid-item\" ng-if=\"control\"><p class=\"ind\">Control</p><p>--</p></div></div></div></div>");
$templateCache.put("app/cliente/mantenimiento/components/maintenanceTabs/maintenanceTables/maintenanceTables.html","<div class=\"centrar centrar-columna centrar-align-start maintenance-table\"><div class=\"table-header\"><p><strong>Zona:</strong> {{zone.nombre}}</p></div><div class=\"centrar centrar-columna width-100p table-body\"><div class=\"table-body-inds width-100p grid-container\"><p class=\"grid-item\">Dispositivo</p><p class=\"grid-item centrar-texto\">Próximo mantenimiento</p><p class=\"grid-item centrar-texto\">Horas de uso</p></div><div class=\"table-body-items width-100p grid-container\" ng-repeat=\"device in zone.dispositivos\"><p class=\"grid-item cursor link\" ng-click=\"goMaintenanceLog(device)\">{{device.nombre}}</p><p class=\"grid-item centrar-texto\">{{device.dateMaintenance}}</p><div class=\"grid-item centrar centrar-c\"><p class=\"ind-horas-uso centrar-texto\" ng-class=\"{\'mantenimiento\':device.filter == \'red\', \'no-mantenimiento\': device.filter == \'green\' }\">{{device.horas_uso === null ? \'Sin datos\' : device.horas_uso}}</p></div></div></div></div>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/new_apparatus_profile/new_apparatus_profile.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nuevo dispositivo\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start\"><form name=\"nuevoAparatoForm\" class=\"centrar centrar-columna centrar-align-start ticket form-mantenimiento\"><p>Todos los campos marcado con * son obligatorios</p><label>Nombre*</label> <input type=\"text\" ng-model=\"nuevoAparato.nombre\" name=\"nombre\" required=\"\"> <label>Tipo*</label><select ng-model=\"nuevoAparato.tipo_\" name=\"Tipo\" ng-change=\"selectForm(nuevoAparato.tipo_)\" required=\"\"><option value=\"{{device.value}}\" ng-repeat=\"device in deviceType\">{{device.nombre}}</option></select><div class=\"width-100p\" ng-if=\"nuevoAparato.tipo_ == \'32\'\"><label>¿Cuál?</label> <input type=\"text\" ng-model=\"nuevoAparato.otro_\" name=\"tipo otro\" required=\"\"></div><div class=\"width-100p\" ng-if=\"is_saeg\"><label>Tag Integración</label><div class=\"centrar\"><input type=\"text\" disabled=\"\" name=\"tag_saeg\" ng-model=\"tag\" ng-change=\"setcharacteristics(tag, 63)\" required=\"\"> <span ngclipboard=\"\" data-clipboard-text=\"{{tag}}\" ng-click=\"copy()\" class=\"centrar centrar-c cursor btn-new\">COPIAR</span></div></div><div class=\"width-100p\" ng-if=\"nuevoAparato.tipo_ == \'40\'\"><label for=\"dimmer_min\">Mínimo dimerizable*</label> <input type=\"number\" min=\"0\" max=\"100\" step=\"10\" ng-model=\"nuevoAparato.dimmer_min\" name=\"dimmer_min\" required=\"\" ng-change=\"setcharacteristics(nuevoAparato.dimmer_min, 75)\"> <small ng-if=\"nuevoAparatoForm.dimmer_min.$dirty && !nuevoAparatoForm.dimmer_min.$valid\">Este valor no es válido. Deber se un número entre 0 y 100</small></div><label>Marca*</label> <input type=\"text\" ng-model=\"nuevoAparato.marca\" name=\"marca\" required=\"\" ng-change=\"setcharacteristics(nuevoAparato.marca, 1)\"> <label>Zona a la cual va a quedar asociado el dispositivo*</label><div class=\"centrar\"><select ng-model=\"nuevoAparato.id_zona\" name=\"zona\" required=\"\" ng-change=\"getUsersAvailables(nuevoAparato.id_zona)\" ng-disabled=\"is_control === false\"><option value=\"{{zone.id}}\" ng-repeat=\"zone in zones\">{{zone.nombre}}</option></select><div class=\"btn-new centrar centrar-c cursor\" ng-click=\"addZone()\">Nueva zona</div></div><label>Número de serie</label> <input type=\"text\" ng-model=\"nuevoAparato.serie\" name=\"serie\" ng-change=\"setcharacteristics(nuevoAparato.serie, 3)\"> <label>Ref. Inventario</label> <input type=\"text\" ng-model=\"nuevoAparato.referencia\" name=\"inventario\" ng-change=\"setcharacteristics(nuevoAparato.referencia, 4)\"> <label>Nombre de encargado</label> <input type=\"text\" ng-model=\"nuevoAparato.nombre_encargado\" name=\"nombre encargado\" ng-change=\"setcharacteristics(nuevoAparato.nombre_encargado, 5)\"> <label>Correo encargado(s)</label><selected-field ng-model=\"nuevoAparato.email_encargado\" lista=\"emailsDisponibles\" class=\"width-100p\"></selected-field><label>Teléfono encargado</label> <input type=\"tel\" ng-model=\"nuevoAparato.tel_encargado\" name=\"teléfono\" ng-change=\"setcharacteristics(nuevoAparato.tel_encargado, 7)\"><div class=\"centrar centrar-columna centrar-align-start\" ng-if=\"nuevoAparato.tipo_ !== \'41\'\"><label class=\"margin-top\">Imágenes adjuntas</label><div class=\"centrar centrar-c centrar-flex-flow centrar-justificar-inicio new-zone\"><div ng-click=\"showImage($index)\" class=\"centrar cursor user-zone\" ng-repeat=\"image in images track by $index\"><div class=\"info-user\"><h3>{{image.name | limitTo : 20}}</h3></div><div class=\"button-close cursor\" ng-click=\"deteleImage(image)\"><span class=\"ion-close-round\"></span></div></div></div><div class=\"centrar centrar-columna cont-upload\"><label class=\"cursor centrar\" for=\"file\"><span class=\"ion-android-upload\"></span><p>Subir imagen</p></label> <input ng-model=\"file\" type=\"file\" id=\"file\" name=\"file\" ng-change=\"addImage()\" onchange=\"angular.element(this).scope().addImage()\" multiple=\"\" accept=\".jpg, .jpeg, .png\"></div></div><uib-accordion ng-if=\"apparatusCharacteristics || deviceCaracteristicas\"><uib-accordion-group class=\"panel-default\"><uib-accordion-heading>Caraterísticas<i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}\"></i></uib-accordion-heading><div><div ng-if=\"!editMode\" class=\"centrar centrar-columna margin-10\" ng-repeat=\"characteristic in apparatusCharacteristics\"><h3>{{characteristic.tipoDato}}</h3><div class=\"width-100p\" ng-repeat=\"caracteristica in characteristic.caracteristicas\"><label>{{caracteristica.titulo}} {{caracteristica.unidad !== \'NA\' ? \'[\' + caracteristica.unidad + \']\' : \'\' }}</label> <input ng-if=\"!caracteristica.options\" type=\"text\" ng-model=\"nuevoAparato.caracteristica[caracteristica.nombre]\" name=\"caracteristica.nombre\" ng-change=\"setcharacteristics(nuevoAparato.caracteristica[caracteristica.nombre], caracteristica.id)\"><select ng-if=\"caracteristica.options\" ng-model=\"nuevoAparato.caracteristica[caracteristica.nombre]\" name=\"caracteristica.nombre\" ng-change=\"setcharacteristics(nuevoAparato.caracteristica[caracteristica.nombre], caracteristica.id)\"><option value=\"{{option.value !== undefined ? option.value : option}}\" ng-repeat=\"option in caracteristica.options\">{{option.text !== undefined ? option.text : option}}</option></select></div></div><div ng-if=\"editMode\" class=\"centrar centrar-columna margin-10\" ng-repeat=\"characteristic in deviceCaracteristicas\"><h3>{{characteristic.tipoDato}}</h3><div class=\"width-100p\" ng-repeat=\"caracteristica in characteristic.caracteristicas\"><label>{{caracteristica.titulo}} {{caracteristica.unidad !== \'NA\' ? \'[\' + caracteristica.unidad + \']\' : \'\' }}</label> <input ng-if=\"!caracteristica.options\" type=\"text\" ng-model=\"caracteristica.valor\" ng-disabled=\"nuevoAparato.tipo === \'39\'\" name=\"caracteristica.nombre\" ng-change=\"setcharacteristics(caracteristica.valor, caracteristica.id)\"><select ng-if=\"caracteristica.options\" ng-model=\"caracteristica.valor\" name=\"caracteristica.nombre\" ng-change=\"setcharacteristics(caracteristica.valor, caracteristica.id)\"><option value=\"{{option.value !== undefined ? option.value : option}}\" ng-repeat=\"option in caracteristica.options\">{{option.text !== undefined ? option.text : option}}</option></select></div></div></div></uib-accordion-group></uib-accordion><div class=\"centrar centrar-c new-alert-form\"><button type=\"button\" class=\"margin-10 button-cancel\" ng-click=\"cancelar()\">Cancelar</button> <button type=\"button\" class=\"margin-10\" ng-disabled=\"!nuevoAparatoForm.$valid || flag_disabled\" ng-click=\"addNewApparatus(nuevoAparato)\">{{editMode ? \'Editar\' : \'Crear\'}}</button></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings/settings.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Configuración dispositivo\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><form name=\"settingsForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><div ng-if=\"device.tipo === \'2\' || device.tipo === \'3\'\" class=\"centrar\"><label class=\"margin-0\" for=\"\">Activar modo Ahorro</label> <input style=\"margin: 0 0 0 10px;\" type=\"checkbox\" ng-model=\"settings.ahorro\" name=\"\" id=\"\" ng-change=\"setcharacteristics(settings.ahorro, 67)\"></div><div ng-if=\"device.id_device > 6245 && (device.tipo === \'2\' || device.tipo === \'3\')\" class=\"width-100p margin-top\"><label for=\"commands_bd\" class=\"margin-0\">Base de datos de comandos de control</label><div class=\"centrar width-100p\"><input ng-model=\"commands_bd.referencia\" style=\"height: 40px; border-radius: 5px 0 0 5px; width: 95%; color: #666666;font-size: 16px;\" disabled=\"true\" class=\"input-sm form-control search-input\" type=\"text\"> <button style=\"margin-top: 0; width: 5%; border-radius: 0 5px 5px 0;\" class=\"centrar centrar-c\" type=\"button\" ng-click=\"goToChangeBD()\"><i class=\"ion-archive\"></i></button></div></div><div class=\"centrar\"><label for=\"\">Activar sensor de presencia</label> <input style=\"margin: 20px 0 0 10px;\" type=\"checkbox\" ng-model=\"settings.sensor\" name=\"\" id=\"\" ng-change=\"setcharacteristics(settings.sensor, 64)\"></div><div><h5 style=\"font-size: 18px;\" class=\"margin-top\">RANGO DE DETECCIÓN PRESENCIA</h5></div><div class=\"centrar width-100p\"><div class=\"centrar centrar-columna centrar-align-start width-45p\"><label for=\"h_ini\" class=\"margin-0\">Hora inicial</label> <input type=\"time\" step=\"3600\" name=\"h_ini\" ng-model=\"settings.h_ini\" ng-class=\"\" ng-change=\"setcharacteristics(settings.h_ini, 66, true)\"> <small class=\"ind-requerido\" ng-show=\"\">Debes ingresar una hora menor al ingresado en hora final</small></div><div class=\"centrar centrar-columna centrar-align-start width-45p\"><label for=\"h_fin\" class=\"margin-0\">Hora final</label> <input type=\"time\" step=\"3600\" name=\"h_fin\" ng-model=\"settings.h_fin\" ng-class=\"\" ng-change=\"setcharacteristics(settings.h_fin, 65, true)\"> <small ng-show=\"\" class=\"ind-requerido\">La hora final debe ser mayor al inicial</small></div></div><label ng-if=\"device.tipo !== \'21\'\" for=\"repeatAlert\">Comando cuando no detecta presencia</label><select ng-if=\"device.tipo !== \'21\'\" ng-model=\"settings.comando\" id=\"commandControl\" name=\"commandControl\" ng-class=\"{\'input-invalid\': settingsForm.commandControl.$touched && settingsForm.commandControl.$invalid}\" ng-change=\"setcharacteristics(settings.comando, 68)\"><option ng-if=\"command.status\" ng-repeat=\"command in commandControl\" value=\"{{command.id}}\">{{command.nombre}}</option></select><label for=\"repeatAlert\">Tiempo de espera para definir ausencia</label><select ng-model=\"settings.ausencia\" ng-options=\"i.value as i.text for i in lackRanges\" id=\"ausencia\" name=\"ausencia\" ng-class=\"{\'input-invalid\': settingsForm.ausencia.$touched && settingsForm.ausencia.$invalid}\" ng-change=\"setcharacteristics(settings.ausencia, 70)\"></select><div ng-if=\"device.tipo === \'29\'\" class=\"width-100p\"><div><h5 style=\"font-size: 18px;\" class=\"margin-top\">CONFIGURAR CORRIENTE DE OPERACIÓN</h5></div><label for=\"repeatAlert\">Umbral Corriente Mínima (mA)</label> <input type=\"number\" min=\"0\" max=\"\" step=\"1\" name=\"umbral_corriente_low\" id=\"umbral_corriente_low\" ng-model=\"settings.umbral_corriente_low\" ng-class=\"{\'input-invalid\': settings_helo_th_Form.umbral_corriente_low.$touched && settings_helo_th_Form.umbral_corriente_low.$invalid}\" ng-change=\"setcharacteristics(settings.umbral_corriente_low, 87)\" required=\"\"> <label for=\"repeatAlert\">Umbral Corriente Máxima (mA)</label> <input type=\"number\" min=\"0\" max=\"\" step=\"1\" name=\"umbral_corriente_high\" id=\"umbral_corriente_high\" ng-model=\"settings.umbral_corriente_high\" ng-class=\"{\'input-invalid\': settings_helo_th_Form.umbral_corriente_high.$touched && settings_helo_th_Form.umbral_corriente_high.$invalid}\" ng-change=\"setcharacteristics(settings.umbral_corriente_high, 88)\" required=\"\"></div><div ng-if=\"device.tipo === \'2\' || device.tipo === \'3\'\" class=\"width-100p\"><div><h5 style=\"font-size: 18px;\" class=\"margin-top\">CONFIGURAR PROGRAMACIÓN</h5></div><label class=\"margin-0\" for=\"repeatAlert\">Número de grados a subir</label><select ng-model=\"settings.grados\" ng-options=\"i.value as i.text for i in degreesRanges\" id=\"grados\" name=\"grados\" ng-class=\"{\'input-invalid\': settingsForm.grados.$touched && settingsForm.grados.$invalid}\" ng-change=\"setcharacteristics(settings.grados, 69)\"></select><label for=\"repeatAlert\">Tiempo de espera para cambiar temperatura</label><select ng-model=\"settings.tiempo\" ng-options=\"i.value as i.text for i in timeRanges\" id=\"tiempo\" name=\"tiempo\" ng-class=\"{\'input-invalid\': settingsForm.tiempo.$touched && settingsForm.tiempo.$invalid}\" ng-change=\"setcharacteristics(settings.tiempo, 71)\"></select></div><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"disabled\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"editarConfiguracion()\">Guardar</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings-virtual-device/settings-virtual-device.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Configuración dispositivo\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><form name=\"settings_virtual_helo_Form\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><label for=\"repeatAlert\">Origen de Datos</label><select ng-model=\"settings.id_origen\" ng-options=\"i.id_origen as i.nombre for i in apis\" id=\"id_origen\" name=\"id_origen\" ng-class=\"{\'input-invalid\': settings_virtual_helo_Form.id_origen.$touched && settings_virtual_helo_Form.id_origen.$invalid}\" ng-change=\"setcharacteristics(settings_virtual_helo_Form.id_origen, 71)\"></select><div class=\"margin-top\"><h5 style=\"font-size: 18px;\" class=\"margin-top\">Coordenadas</h5></div><div class=\"centrar centrar-columna centrar-align-start width-100p\"><label for=\"latitud\">Latitud</label> <input type=\"number\" min=\"\" max=\"\" step=\"0.00001\" name=\"latitud\" id=\"latitud\" ng-model=\"settings.latitud\" ng-class=\"{\'input-invalid\': settings_virtual_helo_Form.latitud.$touched && settings_virtual_helo_Form.latitud.$invalid}\" ng-change=\"setcharacteristics(settings.latitud, 84)\" required=\"\"> <small ng-if=\"settings_virtual_helo_Form.latitud.$invalid && settings_virtual_helo_Form.latitud.$dirty\">El valor puede tener hasta 5 decimales</small> <label for=\"repeatAlert\">Longitud</label> <input type=\"number\" min=\"\" max=\"\" step=\"0.00001\" name=\"longitud\" id=\"longitud\" ng-model=\"settings.longitud\" ng-class=\"{\'input-invalid\': settings_virtual_helo_Form.longitud.$touched && settings_virtual_helo_Form.longitud.$invalid}\" ng-change=\"setcharacteristics(settings.longitud, 85)\" required=\"\"> <small ng-if=\"settings_virtual_helo_Form.longitud.$invalid && settings_virtual_helo_Form.longitud.$dirty\">El valor puede tener hasta 5 decimales</small></div><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"settings_virtual_helo_Form.$invalid\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"editarConfiguracion(settings)\">Guardar</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_helo_s/settings_helo_s.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Configuración dispositivo\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><form name=\"settings_helo_s_Form\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><div ng-if=\"device.tipo === \'23\'\"><h3>Canales</h3><div class=\"centrar\"><label class=\"margin-0\" for=\"\">{{device.canales[0].nombre}}</label> <input style=\"margin: 0 0 0 10px;\" type=\"checkbox\" ng-model=\"settings.channel_1\" name=\"\" id=\"\" ng-change=\"setcharacteristics(settings.channel_1, 76)\"></div><div class=\"centrar\"><label class=\"margin-0\" for=\"\">{{device.canales[1].nombre}}</label> <input style=\"margin: 0 0 0 10px;\" type=\"checkbox\" ng-model=\"settings.channel_2\" name=\"\" id=\"\" ng-change=\"setcharacteristics(settings.channel_2, 77)\"></div><div class=\"centrar\"><label class=\"margin-0\" for=\"\">{{device.canales[2].nombre}}</label> <input style=\"margin: 0 0 0 10px;\" type=\"checkbox\" ng-model=\"settings.channel_3\" name=\"\" id=\"\" ng-change=\"setcharacteristics(settings.channel_3, 78)\"></div></div><div ng-if=\"settings.ct_type\" class=\"width-100p\"><label for=\"ct_type\">Número de CTs usandos en el dispositivo</label><select ng-model=\"settings.ct_type\" ng-options=\"i.value as i.text for i in ct_type\" id=\"ct_type\" name=\"ct_type\" ng-class=\"{\'input-invalid\': settings_helo_s_Form.ct_type.$touched && settings_helo_s_Form.ct_type.$invalid}\" ng-change=\"setcharacteristics(settings.ct_type, 72)\" required=\"\"></select></div><div ng-if=\"settings.current_ct\" class=\"width-100p\"><label for=\"current_ct\">Corriente máxima del CT</label><select ng-model=\"settings.current_ct\" ng-options=\"i.value as i.text for i in current_ct\" id=\"current_ct\" name=\"current_ct\" ng-class=\"{\'input-invalid\': settings_helo_s_Form.current_ct.$touched && settings_helo_s_Form.current_ct.$invalid}\" ng-change=\"setcharacteristics(settings.current_ct, 73)\" required=\"\"></select></div><div ng-if=\"settings.sampling_time\" class=\"width-100p\"><label for=\"current_ct\">Tiempo de muestreo</label><select ng-model=\"settings.sampling_time\" ng-options=\"i.value as i.text for i in sampling_time\" id=\"sampling_time\" name=\"sampling_time\" ng-class=\"{\'input-invalid\': settings_helo_s_Form.sampling_time.$touched && settings_helo_s_Form.sampling_time.$invalid}\" ng-change=\"setcharacteristics(settings.sampling_time, 74)\" required=\"\"></select></div><div ng-if=\"settings.offset !== null\" class=\"width-100p\"><label for=\"current_ct\">Offset</label> <input type=\"number\" min=\"0\" max=\"999\" step=\"1\" ng-model=\"settings.offset\" id=\"offset\" name=\"offset\" ng-class=\"{\'input-invalid\': settings_helo_s_Form.offset.$touched && settings_helo_s_Form.offset.$invalid}\" ng-change=\"setcharacteristics(settings.offset, 75)\" required=\"\"> <small ng-if=\"settings_helo_s_Form.offset.$invalid && settings_helo_s_Form.offset.$dirty\">El valor debe ser un número entre 0 y 999</small></div><div ng-if=\"settings.frequency && device.tipo === \'22\'\" class=\"width-100p\"><label for=\"current_ct\">Frecuencua</label><select ng-model=\"settings.frequency\" ng-options=\"i.value as i.text for i in frequency\" id=\"frequency\" name=\"frequency\" ng-class=\"{\'input-invalid\': settings_helo_s_Form.frequency.$touched && settings_helo_s_Form.frequency.$invalid}\" ng-change=\"setcharacteristics(settings.frequency, 15)\" required=\"\"></select></div><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"disabled || settings_helo_s_Form.offset.$invalid\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled || settings_helo_s_Form.offset.$invalid}\" title=\"Ajustar\" ng-click=\"editarConfiguracion()\">Guardar</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_helo_t/settings_helo_t.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Configuración dispositivo\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><form name=\"settingsForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><div><h5 style=\"font-size: 18px;\" class=\"margin-top\">Operación primaria</h5></div><label for=\"velocidad_fan\">Velocidad del Ventilador</label><select ng-model=\"settings.velocidad_fan\" id=\"velocidad_fan\" name=\"velocidad_fan\" ng-class=\"{\'input-invalid\': settingsForm.velocidad_fan.$touched && settingsForm.velocidad_fan.$invalid}\" ng-change=\"setcharacteristics(settings.velocidad_fan, 91)\"><option ng-repeat=\"item in velocidad_ventilador\" value=\"{{item.value}}\">{{item.text}}</option></select><label for=\"modo_operacion\">Modo de Operación del termostato</label><select ng-model=\"settings.modo_operacion\" id=\"modo_operacion\" name=\"modo_operacion\" ng-class=\"{\'input-invalid\': settingsForm.modo_operacion.$touched && settingsForm.modo_operacion.$invalid}\" ng-change=\"setcharacteristics(settings.modo_operacion, 93)\"><option ng-repeat=\"item in modos_termostato\" value=\"{{item.value}}\">{{item.text}}</option></select><label for=\"bloqueo\">Pantalla</label><select ng-model=\"settings.bloqueo\" id=\"bloqueo\" name=\"bloqueo\" ng-class=\"{\'input-invalid\': settingsForm.bloqueo.$touched && settingsForm.bloqueo.$invalid}\" ng-change=\"setcharacteristics(settings.bloqueo, 92)\"><option ng-repeat=\"item in block_termostato\" value=\"{{item.value}}\">{{item.text}}</option></select><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"disabled\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"editarConfiguracion()\">Guardar</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_helo_th/settings_helo_th.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Configuración dispositivo\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><form name=\"settings_helo_th_Form\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><div><h5 style=\"font-size: 18px;\" class=\"margin-top\">Calibración</h5></div><label for=\"repeatAlert\">Offset en grados centígrados (°C)</label> <input type=\"number\" min=\"-9\" max=\"9\" step=\"1\" name=\"offset_t\" id=\"offset_t\" ng-model=\"settings.offset_t\" ng-class=\"{\'input-invalid\': settings_helo_th_Form.offset_t.$touched && settings_helo_th_Form.offset_t.$invalid}\" ng-change=\"setcharacteristics(settings.offset_t, 80)\" required=\"\"> <small ng-if=\"settings_helo_th_Form.offset_t.$invalid && settings_helo_th_Form.offset_t.$dirty\">El valor debe ser un número entre -9 y 9</small><div class=\"centrar\"><label for=\"activar_umbral_t\">Activar umbrales de temperatura</label> <input style=\"margin: 20px 0 0 10px;\" type=\"checkbox\" ng-model=\"settings.activar_umbral_t\" name=\"\" id=\"\" ng-change=\"setcharacteristics(settings.activar_umbral_t, 86)\"></div><div class=\"centrar centrar-columna centrar-align-start width-100p\" ng-if=\"settings.activar_umbral_t\"><label for=\"repeatAlert\">Umbral temp Max</label> <input type=\"number\" min=\"-40\" max=\"40\" step=\"1\" name=\"umbral_t_max\" id=\"umbral_t_max\" ng-model=\"settings.umbral_t_max\" ng-class=\"{\'input-invalid\': settings_helo_th_Form.umbral_t_max.$touched && settings_helo_th_Form.umbral_t_max.$invalid}\" ng-change=\"setcharacteristics(settings.umbral_t_max, 84)\" required=\"\"> <small ng-if=\"settings_helo_th_Form.umbral_t_max.$invalid && settings_helo_th_Form.umbral_t_max.$dirty\">El valor debe ser un número entre -40 y 40</small> <label for=\"repeatAlert\">Umbral temp Min</label> <input type=\"number\" min=\"-40\" max=\"40\" step=\"1\" name=\"umbral_t_min\" id=\"umbral_t_min\" ng-model=\"settings.umbral_t_min\" ng-class=\"{\'input-invalid\': settings_helo_th_Form.umbral_t_min.$touched && settings_helo_th_Form.umbral_t_min.$invalid}\" ng-change=\"setcharacteristics(settings.umbral_t_min, 85)\" required=\"\"> <small ng-if=\"settings_helo_th_Form.umbral_t_min.$invalid && settings_helo_th_Form.umbral_t_min.$dirty\">El valor debe ser un número entre -40 y 40</small></div><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"settings_helo_th_Form.$invalid\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"editarConfiguracion()\">Guardar</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_hub/settings_hub.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Configuración dispositivo\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><form name=\"settings_hub_Form\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><div class=\"width-100p\" ng-if=\"device.tipo === \'27\'\"><div><h5 style=\"font-size: 18px;\" class=\"margin-top\">Sentido de Giro</h5></div><div class=\"centrar centrar-justificar-inicio centrar-flex-flow\"><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Derecha</label> <input type=\"radio\" name=\"giro\" ng-model=\"settings.turning_sense\" value=\"0\" ng-change=\"setcharacteristics(settings.turning_sense, 82)\"></div><div class=\"centrar\"><label class=\"without-margin\" for=\"interval\">Izquierda</label> <input type=\"radio\" ng-model=\"settings.turning_sense\" value=\"1\" name=\"giro\" ng-change=\"setcharacteristics(settings.turning_sense, 82)\"></div></div><label for=\"giro\">Frecuencia máxima</label> <input type=\"number\" min=\"0\" max=\"400\" step=\"1\" name=\"frequency\" id=\"frequency\" ng-model=\"settings.frequency\" ng-class=\"{\'input-invalid\': settings_hub_Form.frequency.$touched && settings_hub_Form.frequency.$invalid}\" ng-change=\"setcharacteristics(settings.frequency, 83)\" required=\"\"> <small ng-if=\"settings_hub_Form.frequency.$touched && settings_hub_Form.frequency.$invalid\">El valor debe ser un número entre 0 y 400</small></div><label for=\"giro\">Dirección Modbus</label> <input type=\"number\" min=\"1\" max=\"100\" step=\"1\" name=\"direction\" id=\"direction\" ng-model=\"settings.direction\" ng-class=\"{\'input-invalid\': settings_hub_Form.direction.$touched && settings_hub_Form.direction.$invalid}\" ng-change=\"setcharacteristics(settings.direction, 81)\" required=\"\"> <small ng-if=\"settings_hub_Form.direction.$touched && settings_hub_Form.direction.$invalid\">El valor debe ser un número entre 1 y 100</small><div class=\"width-100p\" ng-if=\"device.tipo === \'31\'\"><label for=\"baudios_rate\">Tasa de Baudios</label><select ng-model=\"settings.baudios_rate\" ng-options=\"i.value as i.text for i in baudios_rate\" id=\"baudios_rate\" name=\"baudios_rate\" ng-class=\"{\'input-invalid\': settings_hub_Form.baudios_rate.$touched && settings_hub_Form.baudios_rate.$invalid}\" ng-change=\"setcharacteristics(settings.baudios_rate, 89)\" required=\"\"></select><label for=\"paridad\">Paridad</label><select ng-model=\"settings.paridad\" ng-options=\"i.value as i.text for i in paridad\" id=\"paridad\" name=\"paridad\" ng-class=\"{\'input-invalid\': settings_hub_Form.paridad.$touched && settings_hub_Form.paridad.$invalid}\" ng-change=\"setcharacteristics(settings.paridad, 90)\" required=\"\"></select></div><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"settings_hub_Form.$invalid\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"editarConfiguracion()\">Guardar</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_hub_master/settings_hub_master.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Configuración dispositivo\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><form name=\"settings_hub_Form\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><div class=\"width-100p\"><label for=\"\">Agregar equipos</label><div class=\"centrar centrar-columna width-100p\"><div class=\"centrar centrar-justificar-inicio width-100p panel-selected\"><div class=\"has-feedback cont-buscar\"><input ng-model=\"buscar\" placeholder=\"Buscar\" class=\"input-sm form-control search-input\" ng-keyup=\"search(buscar)\" type=\"search\"> <i class=\"ion-search form-control-feedback\"></i></div><div class=\"centrar\" style=\"margin-left: 20px;\"><p class=\"margin-0\">Seleccionar todo</p><input style=\"margin: 0 0 0 20px;\" type=\"checkbox\" ng-model=\"select_all\" ng-change=\"selectAll(select_all)\"></div></div><div class=\"centrar width-100p margin-20\"><p class=\"margin-0\">Nombre</p><p class=\"margin-0\">Dirección</p></div><div class=\"centrar centrar-columna centrar-justificar-inicio width-100p cont-select\" style=\"max-height: 400px;\"><div ng-if=\"loading === false || devices.length > 0\" ng-repeat=\"itm in devices track by $index\" class=\"centrar width-100p itm-select\"><div class=\"centrar\"><input style=\"margin: 0 10px 0 0;\" ng-model=\"itm.status\" ng-change=\"addToList(itm, itm.status)\" type=\"checkbox\"><p>{{itm.nombre}}</p></div><input disabled=\"true\" style=\"width: 10%; text-align: center;\" ng-model=\"itm.direccion\" type=\"number\" min=\"1\" max=\"50\" step=\"1\"></div><loading-content loading=\"loading\" no-info=\"noInfo\"></loading-content></div></div></div><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"!validation\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"editarConfiguracion()\">Guardar</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/settings_tipo_dispositivo/settings_tipo_dispositivo.html","<div id=\"preloader_c\" ng-if=\"flag_loading\"><div></div></div><ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Configuración dispositivo\" ba-panel-class=\"\"><div class=\"centrar centrar-align-start new-alert-form\"><form name=\"settingsForm\" class=\"centrar centrar-columna centrar-align-start form-mantenimiento\"><div><h5 style=\"font-size: 18px;\" class=\"margin-top\">CONFIGURAR TEMPERATURA</h5></div><label for=\"umbral_t_min\">Límite Mínimo Temperatura (°C)</label> <input type=\"number\" min=\"16\" max=\"30\" step=\"1\" name=\"umbral_t_min\" id=\"umbral_t_min\" ng-model=\"settings.umbral_t_min\" ng-class=\"{\'input-invalid\': settingsForm.umbral_t_min.$touched && settingsForm.umbral_t_min.$invalid}\" ng-change=\"setcharacteristics(settings.umbral_t_min, 85)\" required=\"\"> <small class=\"ind-requerido\" ng-if=\"settingsForm.umbral_t_min.$dirty && !settingsForm.umbral_t_min.$valid\">Debes ingresar un valor entre 16 y 30°C</small> <label for=\"umbral_t_max\">Límite Máximo Temperatura (°C)</label> <input type=\"number\" min=\"16\" max=\"30\" step=\"1\" name=\"umbral_t_max\" id=\"umbral_t_max\" ng-model=\"settings.umbral_t_max\" ng-class=\"{\'input-invalid\': settingsForm.umbral_t_max.$touched && (settingsForm.umbral_t_max.$invalid || invalidTempRange())}\" ng-change=\"setcharacteristics(settings.umbral_t_max, 84)\" required=\"\"> <small class=\"ind-requerido\" ng-if=\"settingsForm.umbral_t_max.$dirty && !settingsForm.umbral_t_max.$valid\">Debes ingresar un valor entre 16 y 30°C</small> <small class=\"ind-requerido\" ng-if=\"settingsForm.umbral_t_max.$valid && settingsForm.umbral_t_min.$valid && invalidTempRange()\">La temperatura máxima no puede ser menor a la mínima</small><div><h5 style=\"font-size: 18px;\" class=\"margin-top\">OPERACIÓN</h5></div><label for=\"modo_operacion\">Modo de Operación</label><select ng-model=\"settings.modo_operacion\" id=\"modo_operacion\" name=\"modo_operacion\" ng-class=\"{\'input-invalid\': settingsForm.modo_operacion.$touched && settingsForm.modo_operacion.$invalid}\" ng-change=\"setcharacteristics(settings.modo_operacion, 93)\"><option ng-repeat=\"item in modos_operacion\" value=\"{{item.value}}\">{{item.text}}</option></select><label for=\"velocidad_fan\">Velocidad Ventilador</label><select ng-model=\"settings.velocidad_fan\" id=\"velocidad_fan\" name=\"velocidad_fan\" ng-class=\"{\'input-invalid\': settingsForm.velocidad_fan.$touched && settingsForm.velocidad_fan.$invalid}\" ng-change=\"setcharacteristics(settings.velocidad_fan, 91)\"><option ng-repeat=\"item in velocidades_fan\" value=\"{{item.value}}\">{{item.text}}</option></select><label for=\"swing\">Swing</label><select ng-model=\"settings.swing\" id=\"swing\" name=\"swing\" ng-class=\"{\'input-invalid\': settingsForm.swing.$touched && settingsForm.swing.$invalid}\" ng-change=\"setcharacteristics(settings.swing, 94)\"><option ng-repeat=\"item in swing_options\" value=\"{{item.value}}\">{{item.text}}</option></select><div class=\"centrar form-mantenimiento\"><button class=\"centrar centrar-c margin-top\" ng-disabled=\"disabled || invalidTempRange()\" ng-class=\"{\'btn-add-active\': !disabled, \'btn-add-active-disabled\': disabled}\" title=\"Ajustar\" ng-click=\"editarConfiguracion()\">Guardar</button> <button class=\"centrar centrar-c margin-top btn-cancelar\" title=\"Cancelar\" ng-click=\"cancelar()\">Cancelar</button></div></form></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/components/airInfo/airInfo.html","<div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Nombre del equipo\" ba-panel-class=\"\"><div class=\"centrar centrar-c\"><div class=\"centrar centrar-c\"><div class=\"centrar centrar-align-start\"><p class=\"margin-0 consolidado-dato\">{{dispositivo.nombre}}</p></div></div><div class=\"centrar centrar-c cont-btn-printer cursor\"><a ui-sref=\"mantenimiento_apparatusProfile({device:dispositivo, control: control})\"><span class=\"ion-clipboard\"></span></a></div></div></div>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/components/indMaintenance/indMaintenance.html","<div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Estado: {{dispositivo.filter == \'unknown\' ? \'Horas de uso no disponibles\' : dispositivo.filter == \'red\' ? \'Necesita mantenimiento\':\'No necesita mantenimiento\'}}\" ba-panel-class=\"\"><div class=\"centrar centrar-c\"><div class=\"centrar\"><p class=\"ind-mantenimiento-2\" ng-class=\"{\'mantenimiento\':dispositivo.filter == \'red\', \'no-mantenimiento\': dispositivo.filter == \'green\' }\"></p></div><div class=\"centrar centrar-align-start\"><p class=\"margin-0 consolidado-dato\">{{dispositivo.horas_uso === null ? \'Sin datos\' : dispositivo.horas_uso}}</p><p class=\"margin-0 consolidado-unidad\">horas</p></div></div></div>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/components/indicador-uso-pie-chart/indicador-uso-pie-chart.html","<div class=\"panel panel-primary bootstrap-panel animated zoomIn panel-smart-bar\"><div class=\"panel-body\"><div class=\"centrar centrar-align-start\"><h4>Gráfica comparativa horas de uso</h4><div ng-click=\"editarLimite(dispositivo.limite_horas_uso)\" class=\"centrar centrar-c cont-btn-printer\"><span class=\"ion-edit cursor\"></span></div></div><div class=\"cont-sm-card-list\"><div id=\"chartdiv\" class=\"cont-pie-chart\"></div><loading-content loading=\"loading_\" no-info=\"noInfo_\"></loading-content></div><div class=\"margin-top\"><p style=\"font-weight: bold;\">Horas de Uso: {{dispositivo.horas_uso === null ? \'Sin datos\' : dispositivo.horas_uso}}</p><p style=\"font-weight: bold;\">Límite mantenimiento: {{dispositivo.limite_horas_uso}}</p></div></div></div>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/change_DB/change_DB.html","<ba-sidebar></ba-sidebar><page-top class=\"barra\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div class=\"dinamic_content\"><div class=\"row centrar\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"\" ba-panel-class=\"\"><div class=\"centrar change-db new-alert-form\" ng-if=\"step === \'select\'\"><div><div class=\"cont-img\"><img src=\"../../../../../../assets/img/test_info.svg\" alt=\"\"></div></div><div class=\"centrar centrar-columna centrar-align-start form-mantenimiento padding\"><h2 class=\"text-center margin-top\">Configuración de Base de datos de comandos de control</h2><p>Este proceso descargará en el Helo Air una nueva base de datos con los comandos de control seleccionados. Debes asegurar que el dispositivo está en linea y conectado a la plataforma.</p><label>Selecciona una nueva base de datos</label><select ng-model=\"aire_db\" ng-options=\"i as i.referencia for i in aires_db\" id=\"aire_db\" name=\"aire_db\"></select><div class=\"centrar centrar-align-self-end\"><button class=\"button-cancel\" style=\"margin-right: 10px;\" ng-click=\"goToSettings()\">Cancelar</button> <button class=\"centrar\" ng-disabled=\"aire_db === undefined\" ng-click=\"stepConfiguration(aire_db, 6)\">Continuar <i style=\"margin-left: 5px;\" class=\"ion-arrow-right-c\"></i></button></div></div></div><div ng-if=\"step === \'loading\'\"><div class=\"centrar centrar-c centrar-columna cont-load-rotate\"><span style=\"font-size: 40px;\" class=\"ion-load-c load-rotate padding-0-10\"></span><p style=\"font-size: 18px;\" class=\"margin-top\">Descargando Datos en el dispositivo</p></div></div><div class=\"centrar change-db new-alert-form\" ng-if=\"step === \'test_info\'\"><div><div class=\"cont-img\"><img src=\"../../../../../../assets/img/test.svg\" alt=\"\"></div></div><div class=\"centrar centrar-c centrar-columna form-mantenimiento padding\"><h2 class=\"text-center margin-top\">{{aire_db.referencia}}</h2><p>Hemos descargado unos comandos para garantizar el funcionamiento correcto del dispositvo, vamos a probar que sean los correctos para tu aire acondicionado</p><div class=\"centrar\"><button class=\"centrar\" ng-click=\"next(\'test_1\')\">Probar</button></div></div></div><div class=\"centrar change-db new-alert-form\" ng-if=\"step === \'test_1\'\"><div><div class=\"cont-img\"><img src=\"../../../../../../assets/img/test_2.svg\" alt=\"\"></div></div><div class=\"centrar centrar-c centrar-columna form-mantenimiento padding\"><h2 class=\"text-center margin-top\">Prueba de encendido</h2><p>Vamos a probar que el aire acondicionado encienda correctamente</p><h3 class=\"text-center\">Enviar comando de encendido</h3><div class=\"centrar\"><button class=\"centrar\" ng-click=\"stepConfiguration(undefined, 7)\">Enviar</button></div></div></div><div class=\"centrar change-db new-alert-form\" ng-if=\"step === \'test_1_2\'\"><div><div class=\"cont-img\"><img src=\"../../../../../../assets/img/test_2.svg\" alt=\"\"></div></div><div class=\"centrar centrar-c centrar-columna form-mantenimiento padding\"><h2 class=\"text-center margin-top\">¿El aire acondicionando encendió correctamente?</h2><p class=\"text-center\">El Helo puede tardar hasta un minuto para enviar el comando</p><div class=\"centrar centrar-columna\"><button class=\"centrar button-cancel\" ng-click=\"next(\'test_2\')\">Sí, se envió el comando</button> <button class=\"centrar button-cancel\" ng-click=\"stepConfiguration(undefined,7)\">No, volver a enviar</button> <button class=\"centrar button-cancel\" ng-click=\"next(\'select\')\">Volver al inicio</button></div></div></div><div class=\"centrar change-db new-alert-form\" ng-if=\"step === \'test_2\'\"><div><div class=\"cont-img\"><img src=\"../../../../../../assets/img/test_2.svg\" alt=\"\"></div></div><div class=\"centrar centrar-c centrar-columna form-mantenimiento padding\"><h2 class=\"text-center margin-top\">Prueba de cambio de temperatura</h2><p>Vamos a probar que el Helo asigne una tempertuara al aire acondicionado de manera correcta</p><h3 class=\"text-center\">Enviar comando de 22°</h3><div class=\"centrar\"><button class=\"centrar\" ng-click=\"stepConfiguration(undefined, 8)\">Enviar</button></div></div></div><div class=\"centrar change-db new-alert-form\" ng-if=\"step === \'test_2_2\'\"><div><div class=\"cont-img\"><img src=\"../../../../../../assets/img/test_2.svg\" alt=\"\"></div></div><div class=\"centrar centrar-c centrar-columna form-mantenimiento padding\"><h2 class=\"text-center margin-top\">¿Cambió el set point del aire acondicionado?</h2><p class=\"text-center\">El Helo puede tardar hasta un minuto para enviar el comando</p><div class=\"centrar centrar-columna\"><button class=\"centrar button-cancel\" ng-click=\"next(\'confirm\')\">Sí, se envió el comando</button> <button class=\"centrar button-cancel\" ng-click=\"stepConfiguration(undefined, 8)\">No, volver a enviar</button> <button class=\"centrar button-cancel\" ng-click=\"next(\'select\')\">Volver al inicio</button></div></div></div><div class=\"centrar change-db new-alert-form\" ng-if=\"step === \'confirm\'\"><div><div class=\"cont-img\"><img src=\"../../../../../../assets/img/test_2.svg\" alt=\"\"></div></div><div class=\"centrar centrar-c centrar-columna form-mantenimiento padding\"><h2 class=\"text-center margin-top\">Se ha validado el funcionamiento del control del aire. ¿Confirmas la actualización del Helo Air?</h2><div class=\"centrar\"><button style=\"margin-right: 20px;\" class=\"centrar\" ng-click=\"stepConfiguration(undefined, 9)\">Actualizar</button> <button class=\"centrar button-cancel\" ng-click=\"goToSettings()\">Cancelar</button></div></div></div><div class=\"centrar change-db new-alert-form\" ng-if=\"step === \'success\'\"><div><div class=\"cont-img\"><img src=\"../../../../../../assets/img/success.svg\" alt=\"\"></div></div><div class=\"centrar centrar-c centrar-columna form-mantenimiento padding\"><h2 class=\"text-center margin-top\">Bien hecho</h2><p style=\"font-size: 20px;\" class=\"text-center\">Se ha actualizado el Helo Air correctamente</p><div class=\"centrar\"><button class=\"centrar\" ng-click=\"goToSettings()\">Aceptar</button></div></div></div><div class=\"centrar change-db new-alert-form\" ng-if=\"step === \'error\'\"><div><div class=\"cont-img\"><img src=\"../../../../../../assets/img/error.svg\" alt=\"\"></div></div><div class=\"centrar centrar-c centrar-columna form-mantenimiento padding\"><h2 class=\"text-center margin-top\">Algo ha salido mal</h2><p style=\"font-size: 20px;\" class=\"text-center\">Algo ha fallado en la actualización. Intenta de nuevo más tarde</p><div class=\"centrar\"><button class=\"centrar\" ng-click=\"goToSettings()\">Volver</button></div></div></div></div></div></div></div></div><page-footer></page-footer>");
$templateCache.put("app/cliente/dashboard-cliente/estadisticas_zona/grafica_scfm_kw/components/settingScfmKw/settingScfmKw.html","<div class=\"centrar centrar-c centrar-columna settings-scfm-kw\"><h3>CONFIGURACIÓN</h3><p>Antes de mostrar la gráfica <strong>SCFM/KW</strong> es necesario agregar los medidores de consumo asociados con el medidor de flujo.</p><label>Seleccionar medidores</label><selected-list ng-model=\"medidores\" lista=\"lista\" class=\"width-100p\"></selected-list><button ng-click=\"addMeasurer(medidores)\" ng-disabled=\"medidores.length === 0\">Confirmar</button></div>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/components/editableField/editableField.html","<div class=\"edit-directive\" ng-switch=\"editMode\"><div ng-switch-when=\"true\" class=\"centrar\"><input type=\"{{fieldType}}\" ng-model=\"edit.value\" ng-keydown=\"$event.keyCode === 13 ? update() : null\"> <button type=\"submit\" class=\"btn-guardar\" ng-click=\"update()\">Guardar</button></div><p ng-switch-default=\"\" ng-click=\"handleModeChange()\">{{edit.value}}</p></div>");
$templateCache.put("app/cliente/mantenimiento/maintenance_log/apparatus_profile/components/defaultForm/defaultForm.html","<uib-accordion><uib-accordion-group class=\"panel-default\"><uib-accordion-heading>Caraterísticas Eléctricas<i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}\"></i></uib-accordion-heading><div><div class=\"centrar centrar-espaciado centrar-flex-flow\"><div class=\"centrar centrar-columna margin-10\"><label>Potencia nominal [kW]</label> <input type=\"text\" ng-model=\"nuevoAparato.potencia_nominal\" name=\"Potencia nominal\"></div><div class=\"centrar centrar-columna margin-10\"><label>Voltaje [VAC]</label> <input type=\"text\" ng-model=\"nuevoAparato.voltaje\" name=\"voltaje\"></div></div><div class=\"centrar centrar-espaciado centrar-flex-flow\"><div class=\"centrar centrar-columna margin-10\"><label>Corriente nominal [A]</label> <input type=\"text\" ng-model=\"nuevoAparato.corriente_nominal\" name=\"corriente nominal\"></div><div class=\"centrar centrar-columna margin-10\"><label>Frecuencia [Hz]</label> <input type=\"text\" ng-model=\"nuevoAparato.frecuencia\" name=\"Frecuencia\"></div></div><div class=\"centrar centrar-espaciado centrar-flex-flow\"><div class=\"centrar centrar-columna margin-10\"><label>Corriente de Arranque [A]</label> <input type=\"text\" ng-model=\"nuevoAparato.corriente_arranque\" name=\"Corriente de arranque\"></div><div class=\"centrar centrar-columna margin-10\"><label>HP</label> <input type=\"text\" ng-model=\"nuevoAparato.hp\" name=\"hp\"></div></div><div class=\"centrar centrar-espaciado centrar-flex-flow\"><div class=\"centrar centrar-columna margin-10\"><label>Eficiencia</label> <input type=\"text\" ng-model=\"nuevoAparato.eficiencia\" name=\"Eficiencia\"></div><div class=\"centrar centrar-columna margin-10\"><label>Factor de Potencia</label> <input type=\"text\" ng-model=\"nuevoAparato.factor_potencia\" name=\"Factor de Potencia\"></div></div><div class=\"centrar centrar-espaciado centrar-flex-flow\"><div class=\"centrar centrar-columna margin-10\"><label>Seguridad</label> <input type=\"text\" ng-model=\"nuevoAparato.seguridad\" name=\"Seguridad\"></div></div></div></uib-accordion-group></uib-accordion><uib-accordion><uib-accordion-group class=\"panel-default\"><uib-accordion-heading>Caraterísticas Mecánicas<i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}\"></i></uib-accordion-heading><div><div class=\"centrar centrar-espaciado centrar-flex-flow\"><div class=\"centrar centrar-columna margin-10\"><label>Peso [kg]</label> <input type=\"text\" ng-model=\"nuevoAparato.peso\" name=\"Peso\"></div><div class=\"centrar centrar-columna margin-10\"><label>Dimensiones [LxAxa]</label> <input type=\"text\" ng-model=\"nuevoAparato.dimensiones_m3\" name=\"dimensiones\"></div></div><div class=\"centrar centrar-espaciado centrar-flex-flow\"><div class=\"centrar centrar-columna margin-10\"><label>Capacidad frio [BTus]</label> <input type=\"text\" ng-model=\"nuevoAparato.frio_btu\" name=\"capacidad frio\"></div><div class=\"centrar centrar-columna margin-10\"><label>Refrigerante</label> <input type=\"text\" ng-model=\"nuevoAparato.refrigerante\" name=\"Refrigerante\"></div></div><div class=\"centrar centrar-espaciado centrar-flex-flow\"><div class=\"centrar centrar-columna margin-10\"><label>IP</label> <input type=\"text\" ng-model=\"nuevoAparato.ip\" name=\"IP\"></div><div class=\"centrar centrar-columna margin-10\"><label>Capacidad de Calefacción [BTus]</label> <input type=\"text\" ng-model=\"nuevoAparato.calor_btu\" name=\"Capacidad Calefacción\"></div></div><div class=\"centrar centrar-espaciado centrar-flex-flow\"><div class=\"centrar centrar-columna margin-10\"><label>Capacidad de Carga</label> <input type=\"text\" ng-model=\"nuevoAparato.capacidad_carga\" name=\"Capacidad Carga\"></div><div class=\"centrar centrar-columna margin-10\"><label>Velocidad de Trabajo</label> <input type=\"text\" ng-model=\"nuevoAparato.velocidad\" name=\"Velocidad de trabajo\"></div></div></div></uib-accordion-group></uib-accordion>");}]);